'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name conducaoEconomica
   * @description
   *
   */

  angular.module('conducaoEconomica', ['ngCookies', 'ui.router', 'ui.bootstrap', 'blockUI', 'flash', 'angular-growl', 'ngAnimate', 'ui.select', 'ngSanitize', 'angularMoment', 'daterangepicker', 'smart-table', 'ngImgCrop', 'restangular', 'tmh.dynamicLocale', 'enumModule', 'v3gWebComponents', 'newsModule', 'ngStomp', 'home', 'relatorios', 'mapas', 'mapasGrid', 'ui.slimscroll', 'historicoTimeline', 'angulartics', 'angulartics.google.analytics', 'indicadores', 'duo-routes', 'productivity-report', 'productivity-indicators', 'cadastros', 'ui.toggle', 'configEventos', 'configVdrivers', 'biReport', 'vehicleSettings', 'historicoAlerta', 'alert-message', 'xeditable', 'ui.utils.masks', 'ModuleMapasUtil', 'ModuleConvertersUtil', 'ModuleEventos', 'mapControlModule', 'resumoPeriodoModule', 'mapaCalor', 'onePageModule', 'ranking.Infracoes', 'ranking.Pontos', 'CentralNotificacoesModule', 'ObjetosVfiltroModule', 'VfiltroModule', 'VtabelaModule', 'VTabelaCellFilter', 'ProntuarioModule', 'ngMessages', 'reprodRotasModule', 'idf.br-filters', 'quadroOcorrencias', 'gestaoOcorrencia', 'pascalprecht.translate', 'FeatureFlagModule', 'urlConfigModule', 'httpServiceV3gModule', 'v3gCustomPopupModule', 'uoSelectInputModule', 'vUiSelectModule', 'informativoModule', 'planosSolucoesModule', 'middlewareModule', 'v3gServicosModule', 'v3gLinhasModule', 'v3gVeiculoModule', 'motoristaModule', 'documentoModule', 'filtroAlertaModule', 'diagnosticoModule', 'sidebarMenuToggleModule', 'uoModule', 'uoArvoreNivelModule', 'linkOnboardingModule', 'v3gValidatorModule', 'modalInfoConfirmModule', 'v3gTrimbleFilters', 'v3gAuthenticatorModule', 'ConstantModule', 'v3gHeaderModule', 'AlertasModule', 'AuditingEventsModule', 'SolucoesModule', 'usuarioModule', 'headerModule', 'stateUrlModule', 'vflashModule', 'insightsModule', 'planosSolucoesNovoUsuarioModule', 'errorPageModule', 'ModuleMeasurementUnitConverter', 'FeatureOuModule', 'UoHelperModule', 'motoristaLinkModule', 'safetyModule', 'ProntuarioV2Module']).run(configureRestAngular).run(function () {
    L.Control.Attribution.prototype.options.prefix = 'Leaflet';
  }).run(['$rootScope', '$state', '$interval', 'editableOptions', '$uibModalStack', '$timeout', 'StateUrlService', 'Authenticator', '$translate', 'FeatureOuService', 'safetyService', function ($rootScope, $state, $interval, editableOptions, $uibModalStack, $timeout, StateUrlService, Authenticator, $translate, FeatureOuService, safetyService) {
    function updateFavicon(productName) {
      if (productName === 'Visual Intelligence') {
        $rootScope.faviconUrl = 'images/ps_logo.png';
      } else {
        $rootScope.faviconUrl = 'images/favicon.ico';
      }
    }

    Authenticator.getUser().then(function (user) {
      $translate.use(user.idioma.toLowerCase());
      $translate.fallbackLanguage('pt_br');
      FeatureOuService.getProductName(user.uo.id).then(function (productName) {
        var finalProductName = productName ? 'Visual Intelligence' : 'Vfleets';
        $rootScope.$productName = finalProductName;
        updateFavicon(finalProductName);
        safetyService.initializeUserpilot();
      });
    });
    $rootScope.$state = $state;
    $rootScope.$productName = 'Platform Science';
    StateUrlService.initInterceptInformativo();

    function paraTimerDoMapaQuandoMudarARota() {
      if (angular.isDefined($rootScope.timerMapa)) {
        $interval.cancel($rootScope.timerMapa);
        $rootScope.timerMapa = undefined;
      }
    }

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, to, toParams, from) {
      $state.previous = from;
      paraTimerDoMapaQuandoMudarARota();
    }),
        locationChangeStart = $rootScope.$on('$locationChangeStart', function () {
      return $uibModalStack.dismissAll();
    }),
        locationChangeSuccess = $rootScope.$on('$stateChangeSuccess', function () {
      StateUrlService.onPageLoad();
      StateUrlService.onProductValidationSnackbarLoad();
    });

    editableOptions.theme = 'bs3';

    $rootScope.$on('$destroy', locationChangeStart);
    $rootScope.$on('$destroy', stateChangeStart);
    $rootScope.$on('$destroy', locationChangeSuccess);

    StateUrlService.onPageChange();
  }]).config(tooltipConfig).config(configI18n).config(configMomentRelativeTime);

  function configureRestAngular(Restangular, UrlConfigService, Authenticator) {
    Restangular.setBaseUrl(UrlConfigService.getApiGatewayUrl());
    Restangular.setDefaultHttpFields({
      withCredentials: true
    });
    Restangular.setFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
      headers.Authorization = 'Bearer ' + Authenticator.keycloak.token;
      return {
        element: element,
        params: params,
        headers: headers,
        httpConfig: httpConfig
      };
    });
  }

  function tooltipConfig($uibTooltipProvider) {
    $uibTooltipProvider.options({ appendToBody: true });
  }

  function configI18n($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: 'https://vfleets-i18n.s3.sa-east-1.amazonaws.com/latest/',
      suffix: '.json'
    });
    $translateProvider.useSanitizeValueStrategy('sceParameters');
    $translateProvider.forceAsyncReload(true);
  }

  function configMomentRelativeTime(moment) {
    moment.updateLocale('pt-br', {
      relativeTime: {
        past: 'há %s',
        w: 'uma semana',
        ww: '%d semanas',
        ss: '%d segundos'
      }
    });
    /* eslint-disable no-inline-comments */
    moment.relativeTimeThreshold('s', 60); // seconds to minute
    moment.relativeTimeThreshold('m', 60); // minutes to hour
    moment.relativeTimeThreshold('h', 24); // hours to day
    moment.relativeTimeThreshold('d', 7); // days to week
    moment.relativeTimeThreshold('w', 4); // weeks to month
    moment.relativeTimeThreshold('M', 12); // months to year
    /* eslint-enable no-inline-comments */
  }
})();
angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/pesquisa-ponto-referencia/filtros-ponto-referencia/input-ponto-referencia/input-ponto-referencia.tpl.html',
    '<div class="form-group input-group"><input name="pesquisa" type="text" placeholder="{{ \'ce.mapa.common.modal.inputPontoReferencia.placeholder\' | translate }}" autocomplete="off" ng-minlength="3" ng-model="ctrl.pesquisa" ng-change="ctrl.validaPontos = false" class="form-control input-busca"/><span class="input-group-btn"><button name="filterAdd" ng-click="ctrl.adicionarItem()" class="btn btn-flat"><i class="fa fa-plus"></i></button></span></div><p ng-show="formFiltro.pesquisa.$valid &amp;&amp; ctrl.validaPontos" class="text-center">{{ \'ce.mapa.common.modal.inputPontoReferencia.validaPontos\' | translate }}</p><p ng-show="formFiltro.pesquisa.$dirty &amp;&amp; formFiltro.pesquisa.$error.required" class="text-center">{{ \'ce.mapa.common.modal.inputPontoReferencia.required\' | translate }}</p><p ng-show="formFiltro.pesquisa.$dirty &amp;&amp; formFiltro.pesquisa.$error.minlength" class="text-center">{{ \'ce.mapa.common.modal.minlength3\' | translate }}</p><div><span ng-repeat="item in ctrl.listaItem" class="badge bg-yellow badge-lista"><i ng-click="ctrl.removeItem($index)" class="fa fa-times"></i>{{item}}</span></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/pesquisa-ponto-referencia/filtros-ponto-referencia/checkbox-ponto-referencia/checkbox-ponto-referencia.tpl.html',
    '<div class="checkbox"><label><input type="checkbox" ng-click="ctrl.selecionarTodosChecks()" ng-checked="ctrl.checkboxSelecionarTodos()"/>{{ \'ce.mapa.common.modal.checkBoxPontoReferencia.selecionarTodos\' | translate }}</label></div><div ng-repeat="item in ctrl.pontosReferenciaFiltroService.filtroSelecionado.lista | orderBy: &quot;nome&quot;" class="checkbox"><label><input type="checkbox" ng-model="item.check"/>{{item.nome}}</label></div><button type="submit" ng-click="ctrl.aplicarFiltro()" class="btn btn-primary btn-block btn-flat btn-submit">{{ \'ce.mapa.common.modal.checkBoxPontoReferencia.aplicarFiltro\' | translate }}</button>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/ocorrencias/modal-simulador/modal-simulador.tpl.html',
    '<div id="modal-simulador"><div class="modal-header bg-light-blue"><h3 id="modal-title" class="modal-title">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle close-modal"></i></h3></div><section class="conteudo"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.descricao\' | translate }}</span><div ng-init="isOpen = false" class="como-funciona"><div class="btn-como-funciona"><i ng-class="{&quot;open-como-funciona&quot;: isOpen}" class="fa fa-caret-down"></i><span ng-click="isOpen = !isOpen">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.titulo\' | translate }}</span></div><span ng-if="isOpen" translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.descricao" class="explicacao"></span></div><div class="data-simulador"><form name="dateForm" class="form-group"><div ng-class="{\'has-error\': !!$ctrl.getMsgError(dateForm.data)}" class="form-group"><label>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.selecioneUmaData\' | translate }}</label><datepicker name="data" model="$ctrl.model.data" required="true" options="$ctrl.dateOptions"></datepicker><div ng-if="dateForm.$invalid" class="help-block">{{ $ctrl.getMsgError(dateForm.data) }}</div></div></form></div></section><div class="modal-footer"><button type="button" ng-click="$ctrl.simular()" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.simular\' | translate }}</button></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/ocorrencias/modal-ocorrencias-info/modal-ocorrencias-info.tpl.html',
    '<div id="modal-ocorrencias-info"><div class="modal-header bg-green"><h3 id="modal-title" class="modal-title">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.titulo\' | translate }}<i ng-click="$ctrl.modalInstance.dismiss()" class="pull-right fa fa-times-circle close-modal"></i></h3></div><div class="conteudo-info"><spam translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.descricao1"></spam><section><div class="title"><spam translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.destaqueOcorrencias.titulo"></spam></div><div class="conteudo"><div class="sequencia-ocorrencia row"><div class="item-sequencia col-sm-3"><div class="icon-ocorrencia"><i class="fa fa-binoculars"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.destaqueOcorrencias.analisamosAlertasGerados\' | translate }}</spam></div><div class="next-sequencia col-sm-1"><i class="fa fa-long-arrow-right"></i></div><div class="item-sequencia col-sm-3"><div class="icon-ocorrencia"><i class="fa fa-list"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.destaqueOcorrencias.classificamosDeAcordoGravidade\' | translate }}</spam></div><div class="next-sequencia col-sm-1"><i class="fa fa-long-arrow-right"></i></div><div class="item-sequencia col-sm-3"><div class="icon-ocorrencia"><i class="fa fa-user-times"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.destaqueOcorrencias.pontuamosCondutor\' | translate }}</spam></div></div><div class="row"><div translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.descricao2" class="col-sm-12"></div><div class="col-sm-12">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.descricao1\' | translate }}</div></div><div class="row"><div class="lista-classes col-sm-6"><div class="gravissimo"><spam class="fa fa-circle classe-gravissima"></spam><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.pontosGravissima\' | translate }}</spam></div><div class="grave"><spam class="fa fa-circle classe-grave"></spam><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.pontosGrave\' | translate }}</spam></div><div class="moderado"><spam class="fa fa-circle classe-media"></spam><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.pontosModerada\' | translate }}</spam></div><div class="leve"><spam class="fa fa-circle classe-leve"></spam><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.pontosLeve\' | translate }}</spam></div></div></div><spam translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.classeInfo.descricao2"></spam></div></section><section><div translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueQuantoTempo.titulo" class="title"></div><div class="conteudo row"><div class="col-sm-2"><div class="icon-ocorrencia icon tempo-tratar-icon"><i class="fa fa-clock-o"></i></div></div><div translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueQuantoTempo.descricao" class="col-sm-10"></div></div></section><section><div translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueComoConfigurar.titulo" class="title"></div><div class="conteudo list-how-config"><ol><li translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueComoConfigurar.comoConfigurarInfo.selecioneOsEventos">&nbsp;</li><li translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueComoConfigurar.comoConfigurarInfo.selecioneAClasse">&nbsp;</li><li translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueComoConfigurar.comoConfigurarInfo.definaOsParâmetros">&nbsp;</li></ol></div></section><section><div translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueComoConfigurar.comoConfigurarInfo.vejaUmMsg" class="title"></div><div class="conteudo"><spam translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.descricao1"></spam><div class="row exemplo-items"><div class="exemplo-item col-sm-4"><div class="icon-exemplo center-block"><i class="fa fa-clock-o"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.itensExemplos.item1\' | translate }}</spam><br/><strong>30 min</strong></div><div class="exemplo-item col-sm-4"><div class="icon-exemplo center-block"><i class="fa fa-tachometer"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.itensExemplos.item2\' | translate }}</spam><br/><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.itensExemplos.item2-1\' | translate }}</strong></div><div class="exemplo-item col-sm-4"><div class="icon-exemplo center-block"><i class="fa fa-list-ol"></i></div><spam>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.itensExemplos.item3\' | translate }}</spam><br/><strong>3</strong></div></div><spam translate="ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.textoDestaqueExemploConfiguracao.descricao2"></spam></div></section></div><div class="modal-footer"><button type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-success">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.modal.entendi\' | translate }}</button></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/alerta-dia/grafico/alerta-dia-one-page-grafico.tpl.html',
    '<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.tituloDia\' | translate }}</h3></div><div class="box-body"><highchart config="ctrl.alertas" ng-if="ctrl.alertas" style="width: 100%; height: 300px"></highchart><p ng-if="ctrl.alertas.erroSemData" translate="{{ ctrl.mensagemDeErro }}" translate-values="{linkConfigAlertas: ctrl.linkConfigAlertas}" class="highchart-error"></p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/alerta-dia/card/alerta-dia-one-page-card.tpl.html',
    '<div ng-if="!ctrl.erroSemData" ng-repeat="item in ctrl.alertas.data" class="col-md-2"><div style="border-top-color: {{item.color}}" class="box box-height-140"><div class="box-header with-border"><h3 class="box-title">{{item.name}}</h3></div><div class="box-body"><a ng-if="ctrl.visualizarHistoricoAlerta" ng-href="{{ctrl.goToHistoricoAlerta(item)}}" class="text-center box-texto-custom"><strong>{{item.data}}</strong><span ng-if="item.data &gt; 1">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.totalVeiculos\' | translate }}</span><span ng-if="item.data &lt;= 1">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.totalVeiculos\' | translate }}</span></a><div ng-if="!ctrl.visualizarHistoricoAlerta" class="text-center box-texto-custom"><strong>{{item.data}}</strong><span ng-if="item.data &gt; 1">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.totalVeiculos\' | translate }}</span><span ng-if="item.data &lt;= 1">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.totalVeiculos\' | translate }}</span></div></div></div></div><p ng-if="ctrl.erroSemData" translate="{{ ctrl.mensagemDeErro }}" translate-values="{linkConfigAlertas: ctrl.linkConfigAlertas}" class="col-md-12 text-center"></p>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/sem-sinal/modal/sem-sinal-one-page-modal.tpl.html',
    '<div class="modal-header bg-orange"><h3 class="modal-title">{{ \'ce.tempoReal.statusFrota.charts.semSinal.numeroVeiculosExcedido\' | translate }}</h3></div><div class="modal-body"><p>{{ \'ce.tempoReal.statusFrota.charts.semSinal.muitosVeiculosParaSeremMostrado\' | translate }}</p></div><div class="modal-footer"><button type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-warning">Ok</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/sem-sinal/grafico/sem-sinal-one-page-grafico.tpl.html',
    '<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.semSinal.titulo\' | translate }}</h3></div><div class="box-body"><highchart config="ctrl.semSinal" ng-if="ctrl.semSinal" style="width: 100%; height: 300px"></highchart><p ng-if="ctrl.semSinal.erroSemData" class="highchart-error">{{ \'ce.tempoReal.statusFrota.charts.common.erroSemData\' | translate }}</p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/sem-sinal/card/sem-sinal-one-page-card.tpl.html',
    '<div class="box box-primary box-alerta-turno"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.semSinal.titulo\' | translate }}</h3></div><div class="box-body no-padding"><div ng-if="!ctrl.semSinal.erroSemData" class="box-total-evento text-center"><div><a ng-if="ctrl.semSinal.data[0].url" ng-href="{{ctrl.semSinal.data[0].url}}"><span><strong>{{ctrl.semSinal.data[0].total}}  </strong><small> ({{ctrl.semSinal.data[0].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.semSinal.veiculosComSinal\' | translate }}</span></a><div ng-if="!ctrl.semSinal.data[0].url" ng-click="ctrl.openModal(ctrl.excedidoQuantidadeMaximaVeiculos.comSinal)"><span><strong>{{ctrl.semSinal.data[0].total}}  </strong><small> ({{ctrl.semSinal.data[0].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.semSinal.veiculosComSinal\' | translate }}</span></div></div><div><a ng-if="ctrl.semSinal.data[1].url" ng-href="{{ctrl.semSinal.data[1].url}}"><span><strong>{{ctrl.semSinal.data[1].total}}  </strong><small> ({{ctrl.semSinal.data[1].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.semSinal.veiculosSemSinal\' | translate }}</span></a><div ng-if="!ctrl.semSinal.data[1].url" ng-click="ctrl.openModal(ctrl.excedidoQuantidadeMaximaVeiculos.semSinal)"><span><strong>{{ctrl.semSinal.data[1].total}}  </strong><small> ({{ctrl.semSinal.data[1].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.semSinal.veiculosSemSinal\' | translate }}</span></div></div></div><p ng-if="ctrl.semSinal.erroSemData" class="highchart-error">{{ \'ce.tempoReal.statusFrota.charts.common.erroSemData\' | translate }}</p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/parado-movimento/grafico/parado-movimento-one-page-grafico.tpl.html',
    '<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.paradoMovimento.titulo\' | translate }}</h3></div><div class="box-body"><highchart config="ctrl.paradoMovimento" ng-if="ctrl.paradoMovimento" style="width: 100%; height: 300px"></highchart><p ng-if="ctrl.paradoMovimento.erroSemData" class="highchart-error">{{ \'ce.tempoReal.statusFrota.charts.common.erroSemData\' | translate }}</p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/parado-movimento/card/parado-movimento-one-page-card.tpl.html',
    '<div class="box box-primary box-alerta-turno"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.paradoMovimento.titulo\' | translate }}</h3></div><div class="box-body no-padding"><div ng-if="!ctrl.paradoMovimento.erroSemData" class="box-total-evento text-center"><div><span><strong>{{ctrl.paradoMovimento.data[0].total}}  </strong><small> ({{ctrl.paradoMovimento.data[0].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.paradoMovimento.veiculosEmMovimento\' | translate }}</span></div><div><span><strong>{{ctrl.paradoMovimento.data[1].total}}  </strong><small> ({{ctrl.paradoMovimento.data[1].porcentagem}}%)</small></span><span>{{ \'ce.tempoReal.statusFrota.charts.paradoMovimento.veiculosParados\' | translate }}</span></div></div><p ng-if="ctrl.paradoMovimento.erroSemData" class="highchart-error">{{ \'ce.tempoReal.statusFrota.charts.common.erroSemData\' | translate }}</p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/alerta-turno/grafico/alerta-turno-one-page-grafico.tpl.html',
    '<div class="box box-primary box-alerta-turno"><div class="box-header with-border"><h3 class="box-title">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.tituloTurno\' | translate }}</h3></div><div class="box-body"><highchart config="ctrl.alertaTurno" ng-if="ctrl.alertaTurno" id="highcharts-alertaturno" style="width: 100%; height: 100%"></highchart><p ng-if="ctrl.alertaTurno.erroSemData" translate="{{ ctrl.mensagemDeErro }}" translate-values="{linkConfigAlertas: ctrl.linkConfigAlertas}" class="highchart-error"></p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/directives/alerta-turno/card/alerta-turno-one-page-card.tpl.html',
    '<div ng-class="{\'collapse-alerta-turno\': ctrl.collapseAlertasControle}" gridster="ctrl.gridsterAlertaTurno" ng-if="ctrl.gridsterAlertaTurno &amp;&amp; ctrl.turnos.length &gt; 0 &amp;&amp; ctrl.alertaTurno.length &gt; 0" class="gridster-alerta-turno gridster-no-margin"><ul><li id="gridster-item-{{item.tipo}}" gridster-item="item" ng-repeat="item in ctrl.posicoesGridster" ng-if="ctrl.posicoesGridster" ng-class="{\'turno-disabled\': ctrl.getAlertaTurno(item.tipo).totalEventos === 0}"><div style="border-top-color: {{ctrl.getAlertaTurno(item.tipo).color}}" class="box box-alerta-turno"><div class="box-header with-border"><h3 class="box-title">{{ctrl.getAlertaTurno(item.tipo).texto}}</h3></div><div class="box-body no-padding"><div class="box-detalhe-evento"><table st-table="lista" st-safe-src="ctrl.getAlertaTurno(item.tipo).uoContagensTurno" one-page-sort-directive="{{item.tipo}}" name-localstorage="c-alertaTurno-{{ctrl.user.id}}-{{ctrl.uoFiltro}}" orderby="{{item.sort}}" class="table no-margin"><thead><tr><th id="th-uo-{{item.tipo}}" rowspan="2" st-sort="uo.nome" class="st-sort turno-uo text-center middle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.uo\' | translate }}</th><th colspan="{{ctrl.turnos.length}}" class="text-center middle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.turno\' | translate }}</th><th id="th-resolvidos-{{item.tipo}}" rowspan="2" width="23%" st-sort="porcentagem" class="st-sort text-center middle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.resolvidos\' | translate }}</th><th id="th-total-{{item.tipo}}" rowspan="2" width="13%" st-sort="ocorridos" class="st-sort text-center middle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.totalEvento\' | translate }}</th></tr><tr><th id="th-turno-{{$index + 1}}-{{item.tipo}}" ng-repeat="turno in ctrl.turnos" uib-tooltip="{{ \'Início: \' + turno.inicio +  \' / Fim: \' + turno.fim }}" tooltip-placement="bottom" ng-class="{\'ativo\': turno.ativo}" st-sort="contagensTurno[{{$index}}].resolvidos" class="st-sort text-center middle">{{$index + 1}}</th></tr></thead><tbody><tr ng-repeat="i in lista"><td uib-tooltip="{{i.uo.nome}}" tooltip-placement="bottom" class="turno-uo truncate">{{i.uo.nome}}</td><td ng-repeat="turno in i.contagensTurno" ng-class="{\'ativo\': turno.ativo}" class="text-center"><a ng-href="{{turno.url}}" ng-if="turno.ocorridos &gt; 0 &amp;&amp; turno.url !== \'\'"><strong ng-class="turno.resolvidos === 0 ? \'text-danger\' : \'text-success\'">{{turno.resolvidos}}</strong><strong class="text-primary">/{{turno.ocorridos}}</strong></a><div ng-if="turno.ocorridos &gt; 0 &amp;&amp; turno.url === \'\'"><strong ng-class="turno.resolvidos === 0 ? \'text-danger\' : \'text-success\'">{{turno.resolvidos}}</strong><strong class="text-primary">/{{turno.ocorridos}}</strong></div><div ng-if="turno.ocorridos === 0"><strong class="text-primary">0/0</strong></div></td><td width="23%" class="text-center"><strong class="text-primary">{{i.porcentagem}} %</strong></td><td width="13%" class="text-center"><strong class="text-primary">{{i.ocorridos}}</strong></td></tr></tbody><tfoot><tr><td class="turno-uo"><strong>{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.total\' | translate }}</strong></td><td ng-repeat="turno in ctrl.turnos track by $index" class="text-center"><a ng-href="{{ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalUrl[$index]}}" ng-if="ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalOcorridos[$index] &gt; 0 &amp;&amp; ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalUrl[$index] !== \'\'"><strong ng-class="ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalResolvidos[$index] === 0 ? \'text-danger\' : \'text-success\'">{{ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalResolvidos[$index]}}</strong><strong class="text-primary">/{{ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalOcorridos[$index]}}</strong></a><div ng-if="ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalOcorridos[$index] &gt; 0 &amp;&amp; ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalUrl[$index] === \'\'"><strong ng-class="ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalResolvidos[$index] === 0 ? \'text-danger\' : \'text-success\'">{{ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalResolvidos[$index]}}</strong><strong class="text-primary">/{{ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalOcorridos[$index]}}</strong></div><div ng-if="ctrl.getAlertaTurno(item.tipo).uoContagensTurnoTotal.totalOcorridos[$index] === 0"><strong class="text-primary">0/0</strong></div></td><td width="23%" one-page-highlight-directive="{{item.tipo}}" tipo-alerta="\'totalResolvidos\'" new-value="ctrl.getAlertaTurno(item.tipo).totalResolvidos" old-value="ctrl.onePageService.getAlertaTurno(item.tipo).totalResolvidos" class="text-center"><a ng-if="ctrl.getAlertaTurno(item.tipo).totalResolvidos !== 0" ng-href="{{ctrl.getAlertaTurno(item.tipo).urlTotalResolvidos}}"><strong>{{ctrl.getAlertaTurno(item.tipo).totalResolvidos}} %</strong></a><span ng-if="ctrl.getAlertaTurno(item.tipo).totalResolvidos === 0"><strong>{{ctrl.getAlertaTurno(item.tipo).totalResolvidos}} %</strong></span></td><td width="13%" one-page-highlight-directive="{{item.tipo}}" tipo-alerta="\'totalEventos\'" new-value="ctrl.getAlertaTurno(item.tipo).totalEventos" old-value="ctrl.onePageService.getAlertaTurno(item.tipo).totalEventos" class="text-center"><a ng-if="ctrl.getAlertaTurno(item.tipo).totalEventos !== 0" ng-href="{{ctrl.getAlertaTurno(item.tipo).urlTotalEventos}}"><strong>{{ctrl.getAlertaTurno(item.tipo).totalEventos}}</strong></a><span ng-if="ctrl.getAlertaTurno(item.tipo).totalEventos === 0"><strong>{{ctrl.getAlertaTurno(item.tipo).totalEventos}}</strong></span></td></tr></tfoot></table></div></div></div></li></ul></div><div ng-click="ctrl.collapseAlertas()" class="collapse-alertas text-center"><span ng-if="ctrl.collapseAlertasControle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.mostrarTodos\' | translate }}<i class="fa fa-angle-double-down"></i></span><span ng-if="!ctrl.collapseAlertasControle">{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.mostrarMenos\' | translate }}<i class="fa fa-angle-double-up"></i></span></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/cerca-eletronica/cadastro-cerca-eletronica-modal/cadastro-cerca-eletronica-modal.tpl.html',
    '<div class="modal-cerca-eletronica modal-header bg-white"><div class="header-modal-cerca-eletronica"><h3 id="modal-title" class="modal-title">{{ \'ce.mapa.common.modal.cadastroCercaEletronica.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle close-modal"></i></h3></div><div class="row"><div class="col-md-3 container-form"><section class="form"><form name="cercaEletronicaForm" id="form-edicao-cerca-eletronica"><div class="inputs-container"><div class="row"><div class="col-md-12 col-xs-12"><div ng-if="$ctrl.errorCarregar" class="alert alert-danger">{{ \'ce.mapa.common.modal.cadastroCercaEletronica.errorCarregar\' | translate }}</div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="uo">{{ \'ce.mapa.common.modal.cadastroCercaEletronica.labelUo\' | translate }}</label><ui-select ng-model="$ctrl.model.uo" ng-disabled="disabled" close-on-select="true" name="uo" id="uo" ng-required="true" on-select="$ctrl.loadCategorias($select.selected.id)"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'ce.mapa.common.modal.placeholderUo\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in $ctrl.uos | filter: $select.search track by uo.id"><span ng-style="{&quot;padding-left&quot;: uo.arvoreNivel * 15}"></span><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome | highlight: $select.search"></span></ui-select-choices></ui-select><strong ng-if="$ctrl.uo.$error.required &amp;&amp; $ctrl.uo.$dirty" class="help-block">{{ \'ce.mapa.common.modal.cadastroCercaEletronica.errorSelecioneUo\' | translate }}</strong></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div ng-class="{\'has-error\': cercaEletronicaForm.nome.$touched &amp;&amp; cercaEletronicaForm.nome.$invalid}" class="form-group"><label for="nome">{{ \'ce.mapa.common.modal.labelNome\' | translate }}</label><input type="text" id="nome" name="nome" ng-model="$ctrl.model.nome" placeholder="{{ \'ce.mapa.common.modal.cadastroCercaEletronica.placeholderNome\' | translate }}" ng-required="true" ng-minlength="3" autofocus="autofocus" class="form-control"/><div ng-messages="cercaEletronicaForm.nome.$touched &amp;&amp; cercaEletronicaForm.nome.$error" class="help-block"><strong ng-message="required">{{ \'ce.mapa.common.modal.campoObrigatorio\' | translate }}</strong><strong ng-message="minlength">{{ \'ce.mapa.common.modal.nomeMinimoCaracteres\' | translate }}</strong></div></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><label for="categoria">{{ \'ce.mapa.common.modal.labelCategoria\' | translate }}</label><div class="opcional-msg">&nbsp;- {{ \'ce.mapa.common.modal.opcional\' | translate }}</div><div class="row"><div class="col-md-3"><div style="background-color: {{$ctrl.model.categoria.cor || &quot;#000&quot;}}" class="cor-cerca-eletronica-categoria"></div></div><div class="col-md-9"><select id="categoria" name="categoria" ng-change="$ctrl.onChangeCategoria()" ng-options="categoria.nome for categoria in $ctrl.categorias track by categoria.id" ng-model="$ctrl.model.categoria" placeholder="{{ \'ce.mapa.common.modal.placeholderCategoria\' | translate }}" class="form-control"><option></option></select></div></div></div></div></div><div ng-if="$ctrl.isPermanenciaVisivel" class="row"><div class="col-md-12 col-xs-12"><div ng-class="{\'has-error\': cercaEletronicaForm.tempoPermanencia.$invalid &amp;&amp; cercaEletronicaForm.tempoPermanencia.$touched}" class="form-group"><label for="observacao">{{ \'ce.mapa.common.modal.labelTempoPermanencia\' | translate }}</label><div class="opcional-msg">&nbsp;- {{ \'ce.mapa.common.modal.opcional\' | translate }}</div><tempo-permanencia-input name="tempoPermanencia" info="{{ \'ce.mapa.common.modal.cadastroCercaEletronica.infoTempoPermanencia\' | translate }}" configurar-tempo="$ctrl.model.configurarTempo" model="$ctrl.model.tempoPermanenciaMinimo"></tempo-permanencia-input><div class="help-block"><strong ng-if="cercaEletronicaForm.tempoPermanencia.$invalid &amp;&amp; cercaEletronicaForm.tempoPermanencia.$touched">{{ \'ce.mapa.common.modal.tempoPermanenciaInput.less3Minutes\' | translate }}</strong></div></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div ng-class="{\'has-error\': cercaEletronicaForm.observacao.$invalid}" class="form-group"><label for="observacao">{{ \'ce.mapa.common.modal.labelObservacao\' | translate }}</label><div class="opcional-msg">&nbsp;- {{ \'ce.mapa.common.modal.opcional\' | translate }}</div><textarea name="observacao" id="observacao" rows="2" ng-model="$ctrl.model.observacao" class="form-control observacao-text-area"></textarea></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="alerta-aqui-modal-area"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.mapa.common.tituloBtCancelar\' | translate }}</button><button type="button" ng-disabled="cercaEletronicaForm.$invalid || $ctrl.errorCarregar" ng-click="$ctrl.salvar()" class="btn btn-success">{{ \'ce.mapa.common.tituloBtSalvar\' | translate }}</button></div></form></section></div><div class="col-md-9"><section class="map-container-modal"><leaflet id="mapaModalCercaEletronica" tiles="$ctrl.tiles" lf-center="$ctrl.center" defaults="$ctrl.defaults" watch-markers="no" width="100%" class="leaflet-mobile cerca-eletronica-map-container"><map-layer-switcher on-layer-switch="$ctrl.onLayerSwitch(layerWrapper)" should-set-url-param="false"></map-layer-switcher></leaflet></section></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/subpaginas/vigencia/vigencia-vdrivers.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>Configuração de Vigência</strong></h3></header><article class="box-body"><form name="vigenciaVdrivers" ng-submit="ctrl.service.salvar()"><p>Configure as opções de vigência que serão refletidas no aplicativo <i>Vdrivers.</i></p><div class="row"><span class="col-xs-4 col-xs-offset-8 text-center">Permitir</span></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.habilitarVigencia.titulo"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.habilitarVigencia.value" disabled="!ctrl.service.roleCadastrar" name="habilitarVigencia"></input-checkbox></div></div><div uib-collapse="!ctrl.service.model.configuracoes.habilitarVigencia.value"><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.fecharVigenciaPorIgnicaoOff.titulo" class="margin-left-30"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.fecharVigenciaPorIgnicaoOff.value" disabled="!ctrl.service.roleCadastrar" name="fecharVigenciaPorIgnicaoOff"></input-checkbox></div></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.titulo" class="margin-left-30"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" disabled="!ctrl.service.roleCadastrar" name="habilitarVigenciaAutomatica"></input-checkbox></div></div><div uib-collapse="!ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value"><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="tempoVerificacao" ng-bind-html="ctrl.service.model.configuracoes.tempoVerificacao.titulo" class="margin-left-60"></span></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.tempoVerificacao.value" mask="ctrl.service.model.configuracoes.tempoVerificacao.mask" disabled="!ctrl.service.roleCadastrar" enable="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" name="tempoVerificacao"></input-number></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="velocidadeMinima" ng-bind-html="ctrl.service.model.configuracoes.velocidadeMinima.titulo" class="margin-left-60"></span><small class="text-muted margin-left-60"><i ng-bind-html="ctrl.service.model.configuracoes.velocidadeMinima.subtitulo"></i></small></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.velocidadeMinima.value" mask="ctrl.service.model.configuracoes.velocidadeMinima.mask" disabled="!ctrl.service.roleCadastrar" enable="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" name="velocidadeMinima"></input-number></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="distanciaMinima" ng-bind-html="ctrl.service.model.configuracoes.distanciaMinima.titulo" class="margin-left-60"></span><small class="text-muted margin-left-60"><i ng-bind-html="ctrl.service.model.configuracoes.distanciaMinima.subtitulo"></i></small></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.distanciaMinima.value" mask="ctrl.service.model.configuracoes.distanciaMinima.mask" disabled="!ctrl.service.roleCadastrar" enable="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" name="distanciaMinima"></input-number></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="tempoMaximoIgnicao" ng-bind-html="ctrl.service.model.configuracoes.tempoMaximoIgnicao.titulo" class="margin-left-60"></span></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.tempoMaximoIgnicao.value" mask="ctrl.service.model.configuracoes.tempoMaximoIgnicao.mask" disabled="!ctrl.service.roleCadastrar" enable="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" name="tempoMaximoIgnicao"></input-number></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="tempoVeiculoParado" ng-bind-html="ctrl.service.model.configuracoes.tempoVeiculoParado.titulo" class="margin-left-60"></span></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.tempoVeiculoParado.value" mask="ctrl.service.model.configuracoes.tempoVeiculoParado.mask" disabled="!ctrl.service.roleCadastrar" enable="ctrl.service.model.configuracoes.habilitarVigenciaAutomatica.value" name="tempoVeiculoParado"></input-number></div></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="tempoMaximoEntreVigencias" ng-bind-html="ctrl.service.model.configuracoes.tempoMaximoEntreVigencias.titulo" class="margin-left-30"></span></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.tempoMaximoEntreVigencias.value" mask="ctrl.service.model.configuracoes.tempoMaximoEntreVigencias.mask" disabled="!ctrl.service.roleCadastrar" enable="true" name="tempoMaximoEntreVigencias"></input-number></div></div></div></form><div class="alerta-aqui"></div></article><footer ng-if="ctrl.service.roleCadastrar" class="box-footer"><button id="btnSalvarVdriversVigencia" type="button" ng-disabled="!vigenciaVdrivers.$dirty || vigenciaVdrivers.$invalid" ng-click="ctrl.service.salvar(vigenciaVdrivers)" class="btn btn-primary">Salvar</button><span class="fa-icon-left">ou </span><a href="#" ng-click="ctrl.service.descartarAlteracoes()" id="btnDescartarVdriversVigencia">Descartar Alterações</a><button ng-click="ctrl.service.abrirModal()" id="btnRestaurarVdriversVigencia" class="btn btn-default pull-right">Restaurar Configurações</button></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/subpaginas/safedrive/safedrive-vdrivers.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>SafeDrive</strong></h3></header><article class="box-body"><form name="safedriveVdrivers" ng-submit="ctrl.service.salvar()"><p>Configura visualização de alertas no <i>SafeDrive.</i></p><div class="row"><span class="col-xs-4 col-xs-offset-8 text-center">Permitir</span></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.habilitarResumo.titulo"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.habilitarResumo.value" disabled="!ctrl.service.roleCadastrar" name="habilitarResumo"></input-checkbox></div></div><div class="row row-custom row-highlight"><div class="col-sm-8"><span for="atualizarEventosVigencia" ng-bind-html="ctrl.service.model.configuracoes.atualizarEventosVigencia.titulo"></span></div><div class="col-sm-4 text-center"><input-number type="number" model="ctrl.service.model.configuracoes.atualizarEventosVigencia.value" mask="ctrl.service.model.configuracoes.atualizarEventosVigencia.mask" disabled="!ctrl.service.roleCadastrar" enable="true" name="atualizarEventosVigencia"></input-number></div></div></form><div class="alerta-aqui"></div></article><footer ng-if="ctrl.service.roleCadastrar" class="box-footer"><button id="btnSalvarVdriversSafedrive" type="button" ng-disabled="!safedriveVdrivers.$dirty || safedriveVdrivers.$invalid" ng-click="ctrl.service.salvar(safedriveVdrivers)" class="btn btn-primary">Salvar</button><span class="fa-icon-left">ou </span><a href="#" ng-click="ctrl.service.descartarAlteracoes()" id="btnDescartarVdriversSafedrive">Descartar Alterações</a><button ng-click="ctrl.service.abrirModal()" id="btnRestaurarVdriversSafedrive" class="btn btn-default pull-right">Restaurar Configurações</button></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/subpaginas/checklist/checklist-vdrivers.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>Checklist do Veículo</strong></h3></header><article class="box-body"><p>Essas configurações serão refletidas no <strong>Checklist do Veículo</strong> no aplicativo Vdrivers. </p><div class="row"><span class="col-xs-4 col-xs-offset-8 text-center">Permitir</span></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.habilitarChecklist.titulo"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.habilitarChecklist.value" disabled="!ctrl.service.roleCadastrar" name="habilitarChecklist"></input-checkbox></div></div><div uib-collapse="!ctrl.service.model.configuracoes.habilitarChecklist.value"><div ng-if="ctrl.service.roleCadastrar" class="row row-custom"><div class="col-xs-12 col-md-5"><form name="checklistVdrivers" ng-submit="ctrl.service.inserirChecklist()" class="form-group"><div class="input-group"><input type="text" name="inserirChecklist" placeholder="Digite um novo item e pressione “Enter”" autocomplete="off" required="required" ng-maxlength="80" ng-model="ctrl.service.model.textChecklist" ng-change="ctrl.service.erroForm = false" class="form-control input-busca"/><span class="input-group-btn"><button name="filterAdd" type="button" ng-click="ctrl.service.inserirChecklist()" class="btn btn-flat"><i class="fa fa-plus"></i></button></span></div><p ng-show="checklistVdrivers.inserirChecklist.$dirty &amp;&amp;checklistVdrivers.inserirChecklist.$valid &amp;&amp;ctrl.service.erroForm" class="text-center text-danger">Item já inserido no checklist</p><p ng-show="checklistVdrivers.inserirChecklist.$dirty &amp;&amp;checklistVdrivers.inserirChecklist.$error.maxlength" class="text-center text-danger">São permitidos até 80 caracteres.</p></form></div></div><div ng-if="ctrl.service.model.checklistAtivos.length &gt; 0" class="row"><span class="col-xs-4 col-xs-offset-8 text-center">Ativar</span></div><ul dnd-list="ctrl.service.model.checklistAtivos" dnd-disable-if="!ctrl.service.roleCadastrar" class="list-unstyled"><li ng-repeat="item in ctrl.service.model.checklistAtivos" dnd-draggable="item" dnd-moved="ctrl.service.model.checklistAtivos.splice($index, 1)" dnd-effect-allowed="move" dnd-selected="models.selected = item" id="checklist-item-ativo-{{$index}}" ng-class="{\'selected\': models.selected === item}" class="no-animate row row-custom row-highlight"><dnd-nodrag><div class="col-xs-8"><span ng-if="ctrl.service.roleCadastrar" dnd-handle="dnd-handle" class="handle"><i class="fa fa-ellipsis-v text-muted"></i><i style="margin-left: 2px;" class="fa fa-ellipsis-v text-muted"></i></span><span ng-class="{&quot;fa-icon-left&quot;: ctrl.service.roleCadastrar}" class="fa-icon-right">{{$index + 1}} -</span><span ng-if="item.id">{{item.nome}}</span><span ng-if="!item.id" id="checklist-item-edit-{{$index}}" editable-text="item.nome" onbeforesave="ctrl.service.validateChecklistInput($data, item.nome)" e-required="e-required">{{item.nome || \'Não é possível salvar itens vazio\'}}</span></div><div class="col-xs-4 text-center"><input-checkbox ng-if="item.id" ng-click="ctrl.service.changeStatus(item, true)" model="item.status" disabled="!ctrl.service.roleCadastrar" name="checklist-ativo-{{$index}}"></input-checkbox><i id="checklist-deletar-{{$index}}" ng-if="!item.id" ng-click="ctrl.service.removeItem(item)" class="fa fa-trash text-danger cursor-pointer"></i></div></dnd-nodrag></li></ul><hr ng-if="ctrl.service.model.checklistAtivos.length &gt; 0 &amp;&amp; ctrl.service.model.checklistInativos.length &gt; 0"/><ul class="list-unstyled"><li ng-repeat="item in ctrl.service.model.checklistInativos" id="checklist-item-inativo-{{$index}}" class="no-animate row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="item.nome"></span></div><div class="col-xs-4 text-center"><input-checkbox ng-click="ctrl.service.changeStatus(item, false)" model="item.status" disabled="!ctrl.service.roleCadastrar" name="checklist-inativo-{{$index}}"></input-checkbox></div></li></ul></div><div class="alerta-aqui"></div></article><footer ng-if="ctrl.service.roleCadastrar" class="box-footer"><button ng-disabled="ctrl.service.invalidChecklist()" id="btnSalvarVdriversChecklist" type="button" ng-click="ctrl.service.salvar()" class="btn btn-primary">Salvar</button><span class="fa-icon-left">ou </span><a href="#" ng-click="ctrl.service.descartarAlteracoes()" id="btnDescartarVdriversChecklist">Descartar Alterações</a></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/subpaginas/aplicativo/aplicativo-vdrivers.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>Aplicativo</strong></h3></header><article class="box-body"><form name="aplicativoVdrivers" ng-submit="ctrl.service.salvar()"><p>Habilite as configurações mais adequadas para o aplicativo em sua operação.</p><div class="row"><span class="col-xs-4 col-xs-offset-8 text-center">Permitir</span></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.manterTelaAtiva.titulo"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.manterTelaAtiva.value" disabled="!ctrl.service.roleCadastrar" name="manterTelaAtiva"></input-checkbox></div></div><div class="row row-custom row-highlight"><div class="col-xs-8"><span ng-bind-html="ctrl.service.model.configuracoes.evitarFechamentoApp.titulo"></span></div><div class="col-xs-4 text-center"><input-checkbox model="ctrl.service.model.configuracoes.evitarFechamentoApp.value" disabled="!ctrl.service.roleCadastrar" name="evitarFechamentoApp"></input-checkbox></div></div></form><div class="alerta-aqui"></div></article><footer ng-if="ctrl.service.roleCadastrar" class="box-footer"><button id="btnSalvarVdriversAplicativo" type="button" ng-disabled="!aplicativoVdrivers.$dirty || aplicativoVdrivers.$invalid" ng-click="ctrl.service.salvar(aplicativoVdrivers)" class="btn btn-primary">Salvar</button><span class="fa-icon-left">ou </span><a href="#" ng-click="ctrl.service.descartarAlteracoes()" id="btnDescartarVdriversAplicativo">Descartar Alterações</a><button ng-click="ctrl.service.abrirModal()" id="btnRestaurarVdriversAplicativo" class="btn btn-default pull-right">Restaurar Configurações</button></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/modal/reset/reset-vdrivers.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">Restaurar configurações do Vdrivers<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><div class="row"><div class="col-md-12"><p style="margin-bottom: 15px;">Deseja realmente restaurar as configurações do Vdrivers? Essa ação não poderá ser desfeita.</p></div></div></div><div class="modal-footer"><button ng-click="$ctrl.close()" class="btn btn-default">Cancelar</button><button ng-click="$ctrl.ok()" class="btn btn-success">Sim, prosseguir</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/uso-indevido-veiculo-configuration/uso-indevido-veiculo-configuration.tpl.html',
    '<div id="safety-app-uso-indevido-veiculo-configuration" ng-controller="UsoIndevidoVeiculoConfigurationCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/turnos/turnos-eventos.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.titulo\' | translate }}</strong></h3></header><article class="box-body"><form name="formTurnos"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.infoRefleccaoConfig\' | translate }}<strong> {{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.alertasSeguranca\' | translate }}</strong> {{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.noMenu\' | translate }}<a ng-href="{{ctrl.goToIndicadoresTempoReal()}}"> {{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.infoIndicadoresTempoReal\' | translate }}</a></p><div class="row row-custom row-highlight"><div class="col-xs-12"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.habilitarConfiguracaoTurno\' | translate }}</span><div class="row row-custom"><div class="col-xs-12"><span class="label-selecionar-entidades">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.entidadesTurnos\' | translate }}<div class="input-checkbox checkbox-selecionar-entidades"><input type="checkbox" name="habilitarTurnosAlertas" id="habilitarTurnosAlertas" ng-disabled="!ctrl.roleCadastrar" ng-model="ctrl.modelTurnos.habilitarTurnosAlertas" ng-change="ctrl.desabilitarTurnos(\'alertas\')"/><label for="habilitarTurnosAlertas"><i ng-class="{\'fa-square-o\': !ctrl.modelTurnos.habilitarTurnosAlertas, \'text-muted\': !ctrl.roleCadastrar}" class="fa fa-check-square-o"></i></label><span class="span-entidades">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.entidadeAlertas\' | translate }}</span></div><div ng-if="ctrl.hasPermissaoConfigOcorrenciaSolucao" class="input-checkbox checkbox-selecionar-entidades"><input type="checkbox" name="habilitarTurnosOcorrencias" id="habilitarTurnosOcorrencias" ng-disabled="!ctrl.roleCadastrar" ng-model="ctrl.modelTurnos.habilitarTurnosOcorrencias" ng-change="ctrl.desabilitarTurnos(\'ocorrencias\')"/><label for="habilitarTurnosOcorrencias"><i ng-class="{\'fa-square-o\': !ctrl.modelTurnos.habilitarTurnosOcorrencias, \'text-muted\': !ctrl.roleCadastrar}" class="fa fa-check-square-o"></i></label><span class="span-entidades">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.entidadeOcorrencias\' | translate }}</span></div></span></div></div></div></div><div ng-if="ctrl.modelTurnos.habilitarTurnosAlertas || ctrl.modelTurnos.habilitarTurnosOcorrencias" class="row"><div class="col-md-6"><div class="form-group"><label for="modelTurnos">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.selecionarQuantidadeTotal\' | translate }}</label><select name="modelTurnos" id="modelTurnos" ng-required="true" ng-disabled="!ctrl.roleCadastrar" ng-model="ctrl.modelTurnos.qntTurnos" ng-change="ctrl.resetarTurnos()" class="form-control"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></div></div><div ng-if="ctrl.modelTurnos.habilitarTurnosAlertas || ctrl.modelTurnos.habilitarTurnosOcorrencias" ng-repeat="turno in ctrl.modelTurnos.turnos" class="row"><div class="col-md-12"><p> <strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.titulo\' | translate }} {{$index + 1}}</strong></p></div><div ng-class="{\'has-error\': formTurnos[\'txtTurnoInicio\' + $index].$invalid}" class="col-md-3 form-group"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.comeca\' | translate }}</span><input type="text" name="txtTurnoInicio{{$index}}" id="txtTurnoInicio{{$index}}" ng-disabled="!ctrl.roleCadastrar" ng-required="true" ng-model="turno.inicio" ng-change="ctrl.modificaFim($index)" value="{{turno.inicio}}" ui-time-mask="short" placeholder="__:__" class="form-control"/><div ng-if="formTurnos[\'txtTurnoInicio\' + $index].$invalid" class="help-block"><div ng-if="formTurnos[\'txtTurnoInicio\' + $index].$error.required">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.campoRequerido\' | translate }}</div><div ng-if="formTurnos[\'txtTurnoInicio\' + $index].$error.turnoRepetido">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.turnoRepetido\' | translate }}</div><div ng-if="formTurnos[\'txtTurnoInicio\' + $index].$error.time">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.horarioInvalido\' | translate }}</div><div ng-if="formTurnos[\'txtTurnoInicio\' + $index].$error.cargaHorariaExcedida">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.cargaHorariaExcedida\' | translate }}</div></div></div><div class="col-md-3 form-group"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.termina\' | translate }}</span><input type="text" name="txtTurnoFim{{$index}}" id="txtTurnoFim{{$index}}" ng-model="turno.fim" value="{{turno.fim}}" disabled="disabled" placeholder="__:__" class="form-control"/></div><div class="col-md-3"><p id="txtCargaHoraria{{$index}}" class="carga-horaria">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.cargaHoraria\' | translate }} {{turno.carga}}</p></div></div><div class="alerta-aqui-turnos"></div></form></article><footer ng-if="ctrl.roleCadastrar" class="box-footer"><button type="submit" id="btnSalvarTurnos" ng-click="ctrl.salvarTurnos()" ng-disabled="!formTurnos.$dirty || formTurnos.$invalid || ctrl.validaBotaoSalvar()" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.salvar\' | translate }}</button></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/tipos/tipos-eventos.tpl.html',
    '<form name="formAlertas"><div ng-if="ctrl.flagCollapseTables"><header class="box-header with-border alerts-tag"><h3 class="box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.titulo\' | translate }}</strong></h3><div id="safety-alerts-tag"></div></header><article class="box-body"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.descricao\' | translate }}</p><div class="row"><span class="col-xs-2 text-right col-xs-offset-4">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarAlerta\' | translate }}</span><span class="col-xs-2 text-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarEvento\' | translate }}</span><span class="col-xs-2 text-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarVideo.tituloV2\' | translate }}<div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarVideo.infoExtraV2\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div></span><span class="col-xs-2 text-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.automatedCoaching.titulo\' | translate }}<div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.automatedCoaching.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div></span></div><div class="row row-highlight row-eventos"><div class="col-xs-4"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.selecionarTodos\' | translate }}</strong></div><div class="col-xs-2 text-center"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" name="check-alertas" ng-model="ctrl.model.checkAllAlertas" ng-click="ctrl.checkAllAlertas()"/></div></div><div class="col-xs-2 col-xs-offset-2 text-center"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" name="check-videos" ng-model="ctrl.model.checkAllVideos" ng-disabled="!ctrl.model.checkAllAlertas" ng-click="ctrl.checkAllVideos()"/></div></div><div class="col-xs-2 text-center"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" name="check-automated-coaching" ng-model="ctrl.model.checkAllAutomatedCoaching" ng-disabled="!ctrl.model.checkAllAlertas" ng-click="ctrl.checkAllAutomatedCoaching()"/></div></div></div><div class="row row-tipos"><div class="col-xs-8 padding-tipos"><strong class="padding-coluna-tipos">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.category.inCab\' | translate }}</strong></div><div class="col-xs-3 text-right eventos-up">{{ ctrl.model.configuracoesInCab.length }} {{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.eventsSetUp\' | translate }}</div><div class="col-xs-1 text-right"><a href="" ng-click="ctrl.collapse(\'inCab\')" class="collapse-table-tipos-eventos"><i ng-class="{\'fa-chevron-circle-up\': !ctrl.inCabIsCollapsed, \'fa-chevron-circle-down\': ctrl.inCabIsCollapsed}" class="icon icon-icon-hover fa"></i></a></div></div><article uib-collapse="ctrl.inCabIsCollapsed"><div ng-repeat="config in ctrl.model.configuracoesInCab" ng-if="config.item.tipo !== &quot;quaseColisao&quot;"><div class="row row-highlight row-eventos"><div class="col-xs-4"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-alerts"><span ng-if="config.item.tipo === \'carona\'">{{ config.item.titulo }}<div uib-tooltip="{{ ctrl.getCaronaTooltip(1) }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div></span><span ng-if="config.item.tipo !== \'carona\'">{{ config.item.titulo }}</span><div uib-tooltip="{{ ctrl.getEventTooltip(config.item) | translate }}" tooltip-placement="top" ng-if="ctrl.isEventTooltip(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.infoExtra\' | translate }}" tooltip-placement="top" ng-if="ctrl.isPossivelColisao(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.funcExperimental\' | translate }}" tooltip-placement="top" ng-if="ctrl.isEPIEvent(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)"><small><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div><a ng-if="ctrl.isSpeedLimitVia(config.item) &amp;&amp; !ctrl.removeReadMore" ng-click="ctrl.abrirModal()"><i class="text-primary"> {{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.titulo\' | translate }}</i></a><div ng-if="config.item.subtitulo" style="margin-top: -5px"><small><i>{{config.item.subtitulo}}</i></small></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-alerts"><div class="fa fa-circle fa-icon-left sub-item-marker"></div><span ng-class="{&quot;label-disabled&quot;: config.isDisabled}">{{ config.item.titulo }}</span><div ng-if="ctrl.isIlegalOvertaking(config.item)" uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.ultrapassagemIlegal.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)" class="experimental-label"><small ng-class="{&quot;label-disabled&quot;: config.isDisabled}"><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkAlerta(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || ctrl.isDashcamNecessaria(config.item)" name="{{config.item.tipo + &quot;-alerta&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkSubItemConfig(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || config.isDisabled" name="{{config.item.tipo + &quot;-sub-item-alerta&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="" ng-model="config.eventoAtivo" ng-disabled="!ctrl.roleCadastrar || config.alertaAtivo" name="{{config.item.tipo + &quot;-evento&quot;}}" ng-if="config.eventoAtivo !== undefined"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo || ctrl.disableVideo(config.item.tipo)" name="{{config.item.tipo + &quot;-video&quot;}}" ng-if="!ctrl.isManualEventHardware(config.item)"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-video&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-automated-coaching&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-automated-coaching&quot;}}"/></div></div></div></div><div ng-if="config.item.tipo === &quot;carona&quot; &amp;&amp; config.alertaAtivo" class="row row-custom row-specific-data-config"><div class="col-xs-12 col-specific-data-config"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.generateWhen\' | translate }}</span><div ng-repeat="option in ctrl.rideSpecificData track by option.value" class="radio-button-ride-alert-config"><input type="radio" id="ride-option-{{ option.value }}" name="ride-option" ng-model="config.specificData" ng-value="option.value" ng-checked="ctrl.checkFirst($first, config, option.value)"/><label for="ride-option-{{ option.value }}" class="ride-radio-button-label"><span>{{ option.label | translate }}</span></label></div></div></div></div></article><div class="row row-empty"></div><div class="row row-tipos"><div class="col-xs-8 padding-tipos"><strong class="padding-coluna-tipos">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.category.safety\' | translate }}</strong></div><div class="col-xs-3 text-right eventos-up">{{ ctrl.flagFixUiBehavior ? ctrl.safetyConfigsLength : ctrl.model.configuracoesSafety.length }} {{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.eventsSetUp\' | translate }}</div><div class="col-xs-1 text-right"><a href="" ng-click="ctrl.collapse(\'safety\')" class="collapse-table-tipos-eventos"><i ng-class="{\'fa-chevron-circle-up\': !ctrl.safetyIsCollapsed, \'fa-chevron-circle-down\': ctrl.safetyIsCollapsed}" class="icon icon-icon-hover fa"></i></a></div></div><article uib-collapse="ctrl.safetyIsCollapsed"><div ng-repeat="config in ctrl.model.configuracoesSafety" ng-if="config.item.tipo !== &quot;quaseColisao&quot;"><div ng-if="ctrl.flagSeparateStabilityControl"><div ng-if="config.item.tipo === &quot;stabilityControl&quot;" class="row row-highlight row-eventos no-hover-tipos-eventos"><div class="col-xs-6"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-alerts"><span>{{ config.item.titulo }}</span><div uib-tooltip="{{ ctrl.getEventTooltip(config.item) | translate }}" tooltip-placement="top" ng-if="ctrl.isEventTooltip(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="config.item.subtitulo" style="margin-top: -5px"><small><i>{{config.item.subtitulo}}</i></small></div></div></div></div><div ng-if="config.item.tipo !== &quot;stabilityControl&quot;" class="row row-highlight row-eventos"><div class="col-xs-4"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-alerts"><span>{{ config.item.titulo }}</span><div uib-tooltip="{{ ctrl.getEventTooltip(config.item) | translate }}" tooltip-placement="top" ng-if="ctrl.isEventTooltip(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.infoExtra\' | translate }}" tooltip-placement="top" ng-if="ctrl.isPossivelColisao(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.funcExperimental\' | translate }}" tooltip-placement="top" ng-if="ctrl.isEPIEvent(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)"><small><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div><a ng-if="ctrl.isSpeedLimitVia(config.item) &amp;&amp; !ctrl.removeReadMore" ng-click="ctrl.abrirModal()"><i class="text-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.titulo\' | translate }}</i></a><div ng-if="config.item.subtitulo" style="margin-top: -5px"><small><i>{{config.item.subtitulo}}</i></small></div><span ng-if="(ctrl.isSpeedLimitVia(config.item) || ctrl.isSpeedLimit(config.item)) &amp;&amp; ctrl.showSpeedDescription" class="description-speed"><div ng-repeat="description in (ctrl.isSpeedLimitVia(config.item) ? ctrl.speedDescriptionsVia : ctrl.speedDescriptions)"><i ng-class="\'color-\' + description.color" class="fa fa-circle"></i><span ng-bind-html="description.text"></span></div></span></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-alerts"><div class="fa fa-circle fa-icon-left sub-item-marker"></div><span ng-class="{&quot;label-disabled&quot;: config.isDisabled}">{{ config.item.titulo }}</span><div ng-if="ctrl.isIlegalOvertaking(config.item)" uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.ultrapassagemIlegal.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)" class="experimental-label"><small ng-class="{&quot;label-disabled&quot;: config.isDisabled}"><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkAlerta(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || ctrl.isDashcamNecessaria(config.item)" name="{{config.item.tipo + &quot;-alerta&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkSubItemConfig(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || config.isDisabled" name="{{config.item.tipo + &quot;-sub-item-alerta&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="" ng-model="config.eventoAtivo" ng-disabled="!ctrl.roleCadastrar || config.alertaAtivo" name="{{config.item.tipo + &quot;-evento&quot;}}" ng-if="config.eventoAtivo !== undefined"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo || ctrl.disableVideo(config.item.tipo)" name="{{config.item.tipo + &quot;-video&quot;}}" ng-if="!ctrl.isManualEventHardware(config.item)"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-video&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-automated-coaching&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-automated-coaching&quot;}}"/></div></div></div></div><div ng-if="ctrl.isManualEventHardware(config.item) &amp;&amp; (ctrl.isDashcamNecessaria(config.item) || ctrl.isFrotaMista(config.item) || config.alertaAtivo)" class="row row-custom row-specific-data-config"><div class="col-xs-12 col-specific-data-config"><div ng-if="ctrl.isDashcamNecessaria(config.item)"><i class="fa fa-exclamation-triangle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.dashcamNecessaria\' | translate }}</span></div><div ng-if="ctrl.isFrotaMista(config.item)"><i class="fa fa-info-circle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.frotaMista\' | translate }}</span></div><div ng-if="config.alertaAtivo &amp;&amp; !ctrl.isDashcamNecessaria(config.item)"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.midiaGerada\' | translate }}</span><div ng-repeat="option in ctrl.mediaTypes track by option.value" class="radio-button-ride-alert-config"><input type="radio" id="media-type-{{ option.value }}" name="media-type" ng-model="config.mediaType" ng-value="option.value" ng-change="ctrl.changeMediaType(config)" ng-disabled="!ctrl.roleCadastrar"/><label for="media-type-{{ option.value }}" class="ride-radio-button-label"><span>{{ option.label | translate }}</span></label></div></div></div></div></div><div ng-if="!ctrl.flagSeparateStabilityControl"><div class="row row-highlight row-eventos"><div class="col-xs-4"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-alerts"><span>{{ config.item.titulo }}</span><div uib-tooltip="{{ ctrl.getEventTooltip(config.item) | translate }}" tooltip-placement="top" ng-if="ctrl.isEventTooltip(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.infoExtra\' | translate }}" tooltip-placement="top" ng-if="ctrl.isPossivelColisao(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.funcExperimental\' | translate }}" tooltip-placement="top" ng-if="ctrl.isEPIEvent(config.item)" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)"><small><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div><a ng-if="ctrl.isSpeedLimitVia(config.item) &amp;&amp; !ctrl.removeReadMore" ng-click="ctrl.abrirModal()"><i class="text-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.titulo\' | translate }}</i></a><div ng-if="config.item.subtitulo" style="margin-top: -5px"><small><i>{{config.item.subtitulo}}</i></small></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-alerts"><div class="fa fa-circle fa-icon-left sub-item-marker"></div><span ng-class="{&quot;label-disabled&quot;: config.isDisabled}">{{ config.item.titulo }}</span><div ng-if="ctrl.isIlegalOvertaking(config.item)" uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.ultrapassagemIlegal.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-black"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)" class="experimental-label"><small ng-class="{&quot;label-disabled&quot;: config.isDisabled}"><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkAlerta(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || ctrl.isDashcamNecessaria(config.item)" name="{{config.item.tipo + &quot;-alerta&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.checkSubItemConfig(config)" ng-model="config.alertaAtivo" ng-disabled="!ctrl.roleCadastrar || config.isDisabled" name="{{config.item.tipo + &quot;-sub-item-alerta&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="" ng-model="config.eventoAtivo" ng-disabled="!ctrl.roleCadastrar || config.alertaAtivo" name="{{config.item.tipo + &quot;-evento&quot;}}" ng-if="config.eventoAtivo !== undefined"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo || ctrl.disableVideo(config.item.tipo)" name="{{config.item.tipo + &quot;-video&quot;}}" ng-if="!ctrl.isManualEventHardware(config.item)"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllVideos()" ng-model="config.videoAtivo" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-video&quot;}}"/></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-automated-coaching&quot;}}"/></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><div class="checkbox pull-right checkbox-tipos-eventos"><input type="checkbox" ng-change="ctrl.updateCheckAllAutomatedCoaching()" ng-model="config.automatedCoaching" ng-disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-automated-coaching&quot;}}"/></div></div></div></div><div ng-if="ctrl.isManualEventHardware(config.item) &amp;&amp; (ctrl.isDashcamNecessaria(config.item) || ctrl.isFrotaMista(config.item) || config.alertaAtivo)" class="row row-custom row-specific-data-config"><div class="col-xs-12 col-specific-data-config"><div ng-if="ctrl.isDashcamNecessaria(config.item)"><i class="fa fa-exclamation-triangle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.dashcamNecessaria\' | translate }}</span></div><div ng-if="ctrl.isFrotaMista(config.item)"><i class="fa fa-info-circle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.frotaMista\' | translate }}</span></div><div ng-if="config.alertaAtivo &amp;&amp; !ctrl.isDashcamNecessaria(config.item)"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.midiaGerada\' | translate }}</span><div ng-repeat="option in ctrl.mediaTypes track by option.value" class="radio-button-ride-alert-config"><input type="radio" id="media-type-{{ option.value }}" name="media-type" ng-model="config.mediaType" ng-value="option.value" ng-change="ctrl.changeMediaType(config)" ng-disabled="!ctrl.roleCadastrar"/><label for="media-type-{{ option.value }}" class="ride-radio-button-label"><span>{{ option.label | translate }}</span></label></div></div></div></div></div></div></article><div class="alerta-aqui"></div></article><footer ng-if="ctrl.roleCadastrar" class="box-footer"><button id="btnSalvarAlertas" type="button" ng-click="ctrl.salvar()" ng-disabled="!formAlertas.$dirty" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.salvar\' | translate }}</button></footer></div><div ng-if="!ctrl.flagCollapseTables"><header class="box-header with-border alerts-tag"><h3 class="box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.titulo\' | translate }}</strong></h3><div id="safety-alerts-tag"></div></header><article class="box-body"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.descricao\' | translate }}</p><div class="row"><span class="col-xs-2 text-center col-xs-offset-4">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarAlerta\' | translate }}</span><span class="col-xs-2 text-center">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarEvento\' | translate }}</span><span class="col-xs-2 text-center">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarVideo.tituloV2\' | translate }}<div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.gerarVideo.infoExtraV2\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div></span><span class="col-xs-2 text-center">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.automatedCoaching.titulo\' | translate }}<div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.automatedCoaching.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div></span></div><div class="row row-custom row-highlight"><div class="col-xs-4"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.selecionarTodos\' | translate }}</strong></div><div class="col-xs-2 text-center"><input-checkbox name="check-alertas" model="ctrl.model.checkAllAlertas" ng-click="ctrl.checkAllAlertas()"></input-checkbox></div><div class="col-xs-2 col-xs-offset-2 text-center"><input-checkbox name="check-videos" model="ctrl.model.checkAllVideos" ng-click="ctrl.checkAllVideos()"></input-checkbox></div><div class="col-xs-2 text-center"><input-checkbox name="check-automated-coaching" model="ctrl.model.checkAllAutomatedCoaching" ng-click="ctrl.checkAllAutomatedCoaching()"></input-checkbox></div></div><div ng-repeat="config in ctrl.model.configuracoes" ng-if="config.item.tipo !== &quot;quaseColisao&quot;"><div class="row row-custom row-highlight"><div class="col-xs-4"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-alerts"><span>{{ config.item.titulo }} aaaaaaaaaaaaaaa</span><div uib-tooltip="{{ ctrl.getEventTooltip(config.item) | translate }}" tooltip-placement="top" ng-if="ctrl.isEventTooltip(config.item)" class="fa fa-info-circle fa-icon-left text-blue"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.infoExtra\' | translate }}" tooltip-placement="top" ng-if="ctrl.isPossivelColisao(config.item)" class="fa fa-info-circle fa-icon-left text-blue"></div><div uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.funcExperimental\' | translate }}" tooltip-placement="top" ng-if="ctrl.isEPIEvent(config.item)" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)"><small><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div><a ng-if="ctrl.isSpeedLimitVia(config.item) &amp;&amp; !ctrl.removeReadMore " ng-click="ctrl.abrirModal()"><i class="text-primary"> {{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.titulo\' | translate }}</i></a><div ng-if="config.item.subtitulo" style="margin-top: -5px"><small><i>{{config.item.subtitulo}} + TTTTTTTTTTTTTTTTTTTT</i></small></div></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-alerts"><div class="fa fa-circle fa-icon-left sub-item-marker"></div><span ng-class="{&quot;label-disabled&quot;: config.isDisabled}">{{ config.item.titulo }}</span><div ng-if="ctrl.isIlegalOvertaking(config.item)" uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.ultrapassagemIlegal.infoExtra\' | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="ctrl.isFuncionalidadeExperimental(config.item)" class="experimental-label"><small ng-class="{&quot;label-disabled&quot;: config.isDisabled}"><i>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.possivelColisao.funcionalidadeExperimental\' | translate }}</i></small></div></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><input-checkbox change="ctrl.checkAlerta(config)" model="config.alertaAtivo" disabled="!ctrl.roleCadastrar || ctrl.isDashcamNecessaria(config.item)" name="{{config.item.tipo + &quot;-alerta&quot;}}"></input-checkbox></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><input-checkbox change="ctrl.checkSubItemConfig(config)" model="config.alertaAtivo" disabled="!ctrl.roleCadastrar || config.isDisabled" name="{{config.item.tipo + &quot;-sub-item-alerta&quot;}}"></input-checkbox></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><input-checkbox change="" model="config.eventoAtivo" disabled="!ctrl.roleCadastrar || config.alertaAtivo" name="{{config.item.tipo + &quot;-evento&quot;}}" ng-if="config.eventoAtivo !== undefined"></input-checkbox></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><input-checkbox change="" model="config.videoAtivo" disabled="!ctrl.roleCadastrar || !config.alertaAtivo || ctrl.disableVideo(config.item.tipo)" name="{{config.item.tipo + &quot;-video&quot;}}" ng-if="!ctrl.isManualEventHardware(config.item)"></input-checkbox></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><input-checkbox change="" model="config.videoAtivo" disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-video&quot;}}"></input-checkbox></div></div><div class="col-xs-2 text-center"><div ng-if="!ctrl.isSubItem(config.item)" class="main-items-input-checkbox"><input-checkbox change="" model="config.automatedCoaching" disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-automated-coaching&quot;}}"></input-checkbox></div><div ng-if="ctrl.isSubItem(config.item)" class="sub-items-input-checkbox"><input-checkbox change="" model="config.automatedCoaching" disabled="!ctrl.roleCadastrar || !config.alertaAtivo" name="{{config.item.tipo + &quot;-sub-item-automated-coaching&quot;}}"></input-checkbox></div></div></div><div ng-if="ctrl.isManualEventHardware(config.item) &amp;&amp; (ctrl.isDashcamNecessaria(config.item) || ctrl.isFrotaMista(config.item) || config.alertaAtivo)" class="row row-custom row-specific-data-config"><div class="col-xs-12 col-specific-data-config"><div ng-if="ctrl.isDashcamNecessaria(config.item)"><i class="fa fa-exclamation-triangle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.dashcamNecessaria\' | translate }}</span></div><div ng-if="ctrl.isFrotaMista(config.item)"><i class="fa fa-info-circle fa-icon-left"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.frotaMista\' | translate }}</span></div><div ng-if="config.alertaAtivo &amp;&amp; !ctrl.isDashcamNecessaria(config.item)"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware.midiaGerada\' | translate }}</span><div ng-repeat="option in ctrl.mediaTypes track by option.value" class="radio-button-ride-alert-config"><input type="radio" id="media-type-{{ option.value }}" name="media-type" ng-model="config.mediaType" ng-value="option.value" ng-change="ctrl.changeMediaType(config)" ng-disabled="!ctrl.roleCadastrar"/><label for="media-type-{{ option.value }}" class="ride-radio-button-label"><span>{{ option.label | translate }}</span></label></div></div></div></div><div ng-if="config.item.tipo === &quot;carona&quot; &amp;&amp; config.alertaAtivo" class="row row-custom row-specific-data-config"><div class="col-xs-12 col-specific-data-config"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.generateWhen\' | translate }}</span><div ng-repeat="option in ctrl.rideSpecificData track by option.value" class="radio-button-ride-alert-config"><input type="radio" id="ride-option-{{ option.value }}" name="ride-option" ng-model="config.specificData" ng-value="option.value" ng-checked="ctrl.checkFirst($first, config, option.value)"/><label for="ride-option-{{ option.value }}" class="ride-radio-button-label"><span>{{ option.label | translate }}</span></label></div></div></div></div><div class="alerta-aqui"></div></article><footer ng-if="ctrl.roleCadastrar" class="box-footer"><button id="btnSalvarAlertas" type="button" ng-click="ctrl.salvar()" ng-disabled="!formAlertas.$dirty" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.salvar\' | translate }}</button></footer></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/pesos/pesos-eventos.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.titulo\' | translate }}</strong></h3></header><article class="box-body"><form name="formPesos" ng-submit="ctrl.salvar()" novalidate="novalidate"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.descricao\' | translate }}</p><uib-accordion class="config-pesos"><div ng-class="{&quot;panel-danger&quot;: ctrl.checkError(formPesos.$error, alerta.alertaEnum, alerta.lista)}" uib-accordion-group="uib-accordion-group" heading="{{ alerta.alertaEnum.descricao | translate }}" is-open="$first" ng-repeat="alerta in (ctrl.model.configuracoes | orderBy: \'alertaEnum.ordem\') track by $index" class="panel-default"><div ng-if="alerta.backupMultiplicadorUnitario !== null" class="row row-custom row-highlight"><div class="col-sm-8"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.pesoBase\' | translate }}</span></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="2" model="alerta.multiplicadorUnitario" mask="&quot;pts&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="multiplicador-unitario.{{ alerta.alertaEnum.id }}"></input-number></div></div><div ng-if="alerta.backupMultiplicadorTempo !== null" class="row row-custom row-highlight"><div class="col-sm-8"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.pesoSomado\' | translate }}</span></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="2" model="alerta.multiplicadorTempo" mask="&quot;pts&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="multiplicador-tempo.{{ alerta.alertaEnum.id }}"></input-number></div></div><div ng-if="alerta.backupLista.length &gt; 0" ng-repeat="subAlerta in (alerta.lista | orderBy: \'alertaEnum.ordem\') track by $index"><div class="row"><strong class="col-sm-7">{{ ctrl.getSpeedingLevelTitle(subAlerta) }}</strong></div><div ng-if="subAlerta.backupMultiplicadorUnitario !== null" class="row row-custom row-highlight"><div class="col-sm-8"><span class="margin-left-30">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.pesoBase\' | translate }}</span></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="2" model="subAlerta.multiplicadorUnitario" mask="&quot;pts&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="sub-multiplicador-unitario.{{ subAlerta.alertaEnum.id }}"></input-number></div></div><div ng-if="subAlerta.backupMultiplicadorTempo !== null" class="row row-custom row-highlight"><div class="col-sm-8"><span class="margin-left-30">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.pesoSomado\' | translate }}</span></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="2" model="subAlerta.multiplicadorTempo" mask="&quot;pts&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="sub-multiplicador-tempo.{{ subAlerta.alertaEnum.id }}"></input-number></div></div></div></div></uib-accordion><div class="alerta-aqui"></div></form></article><footer ng-if="ctrl.roleCadastrar" class="box-footer"><button id="btnSalvarPesos" type="button" ng-click="ctrl.salvar(false)" ng-disabled="!formPesos.$dirty || formPesos.$invalid" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.salvar\' | translate }}</button><span class="fa-icon-left fa-icon-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.ou\' | translate }}</span><a href="#" ng-click="ctrl.descartarAlteracoes()" id="btnDescartarEventosPesos">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.descartarAlteracoes\' | translate }}  </a><button ng-click="ctrl.abrirModal()" id="btnRestaurarEventosPesos" class="btn btn-default pull-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.titulo\' | translate }}</button></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/ocorrencias/ocorrencias.tpl.html',
    '<div ng-show="ctrl.hasPermission === false" class="msg-role-permissao"><div class="alert alert-danger">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.msgVoceNaoPossuiPermissao\' | translate }}</div></div><div id="config-ocorrencias" ng-show="ctrl.hasPermission"><header class="flex box-header with-border"><h3 class="flex-1 box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.titulo\' | translate }}</strong></h3><a ui-sref="root.configNotificacao" ng-if="ctrl.featureFlag.CONFIG_NOTIFICACAO_OCORRENCIA" class="gerenciar-notificacoes"><i class="fa fa-bell"></i><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.btnGerenciarNotificacoes.titulo\' | translate }} </span></a></header><article class="box-body"><div class="alerta-permissao"></div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.descricao\' | translate }}</p><form name="ocorrenciasForm"><uib-accordion ng-if="ctrl.showRetentionPeriod" class="config-ocorrencias safety-focus-board-configuration-panel"><div uib-accordion-group="uib-accordion-group" is-open="true" is-disabled="true" class="panel-default"><uib-accordion-heading><strong><span class="title-evento">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.title\' | translate }}</span></strong></uib-accordion-heading><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.description\' | translate }}</p><ng-form name="retentionPeriodForm"><div class="form-group"><label for="retentionPeriod">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.retentionPeriod.title\' | translate }}</label><select ng-disabled="ctrl.isReadOnly()" ng-model="ctrl.retentionPeriod" id="retentionPeriod" name="retentionPeriod" ng-options="period.value as period.label for period in ctrl.retentionPeriods" required="required" class="form-control select-retention-period"></select></div></ng-form></div></uib-accordion><uib-accordion class="config-ocorrencias event-configuration-panel"><div uib-accordion-group="uib-accordion-group" is-open="true" is-disabled="true" class="panel-default"><uib-accordion-heading><strong><span class="title-evento">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventConfiguration.title\' | translate }}      </span></strong></uib-accordion-heading><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventConfiguration.description\' | translate }}<div class="form-group"><div class="selecao-eventos"><label>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.titulo\' | translate }}</label><ui-select ng-model="ctrl.model.eventoSelected" name="evento-ocorrencia" id="config-evento-ocorrencia" on-select="ctrl.adicionarConfig()" ng-disabled="ctrl.isReadOnly()" close-on-select="true" class="select-eventos"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.titulo\' | translate }}"></ui-select-match><ui-select-choices repeat="evento in (ctrl.selectOptions | filter: $select.search) track by evento.id"><span ng-bind-html="ctrl.getEventTitle(evento) | highlight: $select.search"></span></ui-select-choices></ui-select><button ng-click="ctrl.abrirModalInfo()" class="saiba-mais"><span>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.btnEntendaComoFunciona.titulo\' | translate }}</span></button><div id="openDialogEventPriority" tooltip-enable="ctrl.disableButton" uib-tooltip="{{ ctrl.tooltipErrorMessage | translate }}"></div></div></div></p><div class="alerta-top"><uib-accordion class="config-ocorrencias config-ocorrencias-panel"><div uib-accordion-group="uib-accordion-group" ng-repeat="evento in ctrl.configsOcorrencia track by $index" ng-class="{&quot;accordio-group-error&quot;: ocorrenciasForm[evento.tipo].$invalid &amp;&amp; ocorrenciasForm[evento.tipo].$dirty}" class="panel-default"><uib-accordion-heading><span class="title-evento">{{ ctrl.getEventTitle(evento) }}</span><span class="icon-classes"><span ng-if="evento.classe" class="fa fa-circle classe-{{evento.classe | lowercase}}"></span></span><span href="" ng-if="ctrl.isReadWrite()" ng-click="ctrl.removerEvento($index, $event)" class="remove-evento">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.remover\' | translate }}</span></uib-accordion-heading><div class="label-classicacao">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.descricao\' | translate }}</div><ng-form name="{{evento.tipo}}"><div ng-class="{\'has-error\': ctrl.hasErrorClassificacao(ocorrenciasForm[evento.tipo][\'classificacao_\' + evento.tipo])}" class="form-group"><label>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.titulo\' | translate }}</label><select ng-disabled="ctrl.isReadOnly()" id="classificacao_{{evento.tipo}}" name="classificacao_{{evento.tipo}}" required="required" ng-model="evento.classe" class="form-control select-classificacao"><option value="">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.nenhum\' | translate }}</option><option ng-repeat="classe in ctrl.classes.todas track by $index" value="{{classe}}">{{ctrl.classes[classe].label}}</option></select><div ng-if="ctrl.hasErrorClassificacao(ocorrenciasForm[evento.tipo][\'classificacao_\' + evento.tipo])" class="help-block">{{ctrl.msgError(ocorrenciasForm[evento.tipo][\'classificacao_\'+evento.tipo].$error)}}</div></div><div ng-if="evento.classe" class="config-classe-ocorrencia"><div ng-class="{\'has-error\': ocorrenciasForm[evento.tipo][\'vel_\'+evento.tipo].$invalid}" class="form-group velocidade-minima"><label>{{ ctrl.velocidadeMinimaTitulo | translate }}<em>&nbsp;- {{ ctrl.velocidadeMinimaOpcional | translate }}</em><i uib-tooltip="{{ ctrl.velocidadeMinimaExtraInfo | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><input id="vel_{{evento.tipo}}" name="vel_{{evento.tipo}}" ng-model="evento.velocidadeMinima" ng-disabled="ctrl.isReadOnly()" type="number" min="0" max="999"/><div ng-if="ocorrenciasForm[evento.tipo][\'vel_\'+evento.tipo].$invalid" class="help-block">{{ctrl.msgError(ocorrenciasForm[evento.tipo][\'vel_\'+evento.tipo].$error, \'velocidade\')}}</div><div ng-if="ocorrenciasForm[evento.tipo][\'vel_\'+evento.tipo].$error.max" class="help-block">{{ ctrl.velocidadeMaximaPermitida | translate }}</div></div><div ng-class="{\'has-error\': ctrl.hasErrorQtd(ocorrenciasForm[evento.tipo][\'qtd_\'+evento.tipo])}" class="form-group quantidade"><label>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.quantidade.titulo\' | translate }}<i uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.quantidade.extraInfo\' | translate }} " class="fa-icon-left fa fa-info-circle"></i></label><input name="qtd_{{evento.tipo}}" ng-model="evento.quantidade" ng-model-options="{allowInvalid: true}" ui-validate="{qtdInteger: ctrl.isInteger(ocorrenciasForm[evento.tipo][&quot;qtd_&quot;+evento.tipo]), qtdValidate: ctrl.isQtdValid(evento.quantidade)}" type="number" min="1" max="999" step="1" ng-disabled="ctrl.isReadOnly()" required="required"/><div ng-if="ocorrenciasForm[evento.tipo][\'qtd_\'+evento.tipo].$invalid" class="help-block">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.quantidade.quantidadeMinimaPermitida\' | translate }}</div><div ng-if="ocorrenciasForm[evento.tipo][\'qtd_\'+evento.tipo].$error.max" class="help-block">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.quantidade.quantidadeMaximaPermitida\' | translate }}</div></div><div ng-class="{\'has-error\': ctrl.hasErrorQtd(ocorrenciasForm[evento.tipo][\'intervalo_\'+evento.tipo])}" class="form-group intervalo-tempo"><label>{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.titulo\' | translate }}<em>&nbsp;- {{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.opcional\' | translate }}</em><i uib-tooltip="{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.extraInfo\' | translate }} " class="fa-icon-left fa fa-info-circle"></i></label><input id="intervalo_{{evento.tipo}}" name="intervalo_{{evento.tipo}}" type="number" ng-model="evento.intervaloTempo" max="720" ng-disabled="ctrl.isReadOnly()" min="1" ui-validate="{intervaloInteger: ctrl.isInteger(ocorrenciasForm[evento.tipo][&quot;intervalo_&quot;+evento.tipo])}"/><div ng-if="ocorrenciasForm[evento.tipo][\'intervalo_\'+evento.tipo].$error.intervaloInteger" class="help-block">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.valorDeveSerInteiro\' | translate }}</div><div ng-if="ocorrenciasForm[evento.tipo][\'intervalo_\'+evento.tipo].$error.min" class="help-block">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.valorMinimo1Minuto\' | translate }}</div><div ng-if="ocorrenciasForm[evento.tipo][\'intervalo_\'+evento.tipo].$error.max" class="help-block">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.intervaloDeTempoMIN.valorMaximo720Minutos\' | translate }}</div></div></div></ng-form></div></uib-accordion></div><div class="alerta-aqui"></div></div></uib-accordion></form></article><footer class="box-footer"><button id="btnSalvarPesos" type="button" ng-disabled="ctrl.isReadOnly()" ng-click="ctrl.salvar()" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.titulo\' | translate }}</button><span ng-if="ctrl.isReadWrite()"><span class="fa-icon-left fa-icon-right">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.ou\' | translate }}</span><a href="#" ng-click="ctrl.descartarAlteracoes()" id="btnDescartarEventosPesos">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.modalDescartarAlteracoes.titulo\' | translate }}</a></span></footer></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/driver-privacy/driver-privacy.tpl.html',
    '<div id="safety-app-driver-privacy" ng-controller="DriverPrivacyCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/device-health-configuration/device-health-configuration.tpl.html',
    '<div id="safety-app-device-health-configuration" ng-controller="DeviceHealthConfigurationCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/subpaginas/descarte/descarte-eventos.tpl.html',
    '<header class="box-header with-border"><h3 class="box-title text-primary"><strong>{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.titulo\' | translate }}</strong></h3></header><article class="box-body"><form name="formDescarte" ng-submit="ctrl.salvar()" novalidate="novalidate"><p class="descricao-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.descricao\' | translate }}</p><span>{{ \'ce.enum.common.excessoVelocidade\' | translate }}</span><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-tempo-velocidade" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarSpeedLimitDuracaoDescarte"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.tempo\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoTempoTexto\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.speedLimitDuracaoDescarte" mask="ctrl.ptsMask" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-tempo-excesso-velocidade" ng-if="ctrl.model.habilitarSpeedLimitDuracaoDescarte"></input-number></div></div><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-porcentagem-velocidade" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarSpeedLimitPorcentagem"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.porcentagemDescarte\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessosSeraoDescartados\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.speedLimitPorcentagemDescarte" mask="&quot;%&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-duracao-excesso-velocidade" ng-if="ctrl.model.habilitarSpeedLimitPorcentagem"></input-number></div></div><span>{{ \'ce.enum.common.excessoVelocidadePorVia\' | translate }}</span><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-tempo-velocidade-via" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarSpeedLimitViaDuracaoDescarte"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.tempo\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoViaTempoTexto\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.speedLimitViaDuracaoDescarte" mask="ctrl.ptsMask" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-tempo-excesso-velocidade-via" ng-if="ctrl.model.habilitarSpeedLimitViaDuracaoDescarte"></input-number></div></div><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-porcentagem-velocidade-via" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarSpeedLimitViaPorcentagem"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.porcentagemDescarte\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessosViaSeraoDescartados\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.speedLimitViaPorcentagemDescarte" mask="&quot;%&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-duracao-excesso-velocidade-via" ng-if="ctrl.model.habilitarSpeedLimitViaPorcentagem"></input-number></div></div><div ng-if="ctrl.isNAFeatureEnabled"><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-velocidade-absoluta-posted" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarVelAbsolutaDescarteExcessoVelocidadeVia"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoVelocidadeAbsoluto.titulo\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoVelocidadeAbsoluto.speedingPosted\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.velAbsolutaDescarteExcessoVelocidadeVia" mask="\'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoVelocidadeAbsoluto.unidade\' | translate" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-velocidade-absoluta-posted" ng-if="ctrl.model.habilitarVelAbsolutaDescarteExcessoVelocidadeVia" on-change="ctrl.validateVelAbsolutaDescarteExcessoVelocidadeVia()"></input-number><span ng-if="formDescarte[\'input-velocidade-absoluta-posted\'].$error.velocidadeMinima" translate=" {{\'ce.configuracao.eventos.itensConfiguraveis.descarte.excessoVelocidadeAbsoluto.erros.velocidadeMinima\'}}" translate-values="{minSpeedingBucket: ctrl.getMinVelAbsolutaDescarteExcessoVelocidadeVia()}" class="help-block custom-error"></span></div></div></div><span>{{ \'ce.enum.common.curvaBrusca\' | translate }}</span><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-velocidade-curva" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarVelDescarteCurva"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.velocidadeDescarte\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.curvasBruscasVelDescartadas\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.velDescarteCurva" mask="&quot;Km/h&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-velocidade-curva" ng-if="ctrl.model.habilitarVelDescarteCurva"></input-number></div></div><span>{{ \'ce.enum.common.cameraObstruida\' | translate }}</span><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-velocidade-camera" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarVelDescarteCameraObstruida"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.velocidadeDescarte\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.cameraObstruidaVelDescartados\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.velDescarteCameraObstruida" mask="&quot;km/h&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-velocidade-camera" ng-if="ctrl.model.habilitarVelDescarteCameraObstruida"></input-number></div></div><span>{{ \'ce.enum.common.freioDescida\' | translate }}</span><div class="row row-custom"><div class="col-sm-8"><div class="col-sm-1 checkbox-descarte"><input-checkbox name="check-distancia-freio-descida" disabled="!ctrl.roleCadastrar" model="ctrl.model.habilitarDistanciaMinimaFreioDescida"></input-checkbox></div><div class="col-sm-10"><p class="tipo-descarte">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.distanciaDescarte\' | translate }}</p><p class="descricao-tipo">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.freioDescidaDistanciaDescartados\' | translate }}</p></div></div><div class="col-sm-4 text-center"><input-number type="text" number-mask="0" model="ctrl.model.distanciaMinimaFreioDescida" mask="&quot;m&quot;" disabled="!ctrl.roleCadastrar" enable="true" min="0" name="input-distancia-freio-descida" ng-if="ctrl.model.habilitarDistanciaMinimaFreioDescida"></input-number></div></div><div class="alerta-aqui">    </div></form></article><footer ng-if="ctrl.roleCadastrar" class="box-footer"><button id="btnSalvarDescarte" type="button" ng-click="ctrl.salvar()" ng-disabled="!formDescarte.$dirty || formDescarte.$invalid" class="btn btn-primary">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.salvar\' | translate }}</button><span class="fa-icon-left">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.ou\' | translate }} </span><a href="#" ng-click="ctrl.descartarAlteracoes()" id="btnDescartar">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.descartarAlteracoes\' | translate }}</a></footer>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/modal/turnos/turnos-eventos.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title">{{$ctrl.titulo}}</h3></div><div class="modal-body"><div class="alerta-aqui-categoria-ponto"></div><p>{{$ctrl.texto}}<a href="/configuracao-notificacao" class="clicando-aqui">{{$ctrl.clique}}</a> {{$ctrl.texto2}}</p></div><div class="modal-footer"><button type="button" ng-click="$ctrl.modalInstance.dismiss()" class="btn btn-default">Não</button><button type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-danger">Sim</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/modal/reset/reset-eventos.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.titulo\' | translate }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><div class="row"><div class="col-md-12"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.descricao\' | translate }}</p></div></div></div><div class="modal-footer"><button ng-click="$ctrl.close()" class="btn btn-default">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.cancelar\' | translate }}</button><button ng-click="$ctrl.ok()" class="btn btn-success">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.simProsseguir\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/modal/info/info-eventos.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.titulo\' | translate }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><div class="row"><div class="col-md-12"><p class="col-md-12">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.descricao1\' | translate }}</p><div class="col-md-6 col-md-offset-6"><img src="images/mapa-velocidade-maxima.png"/></div><p class="col-md-12">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.descricao2\' | translate }}</p></div></div><div class="row"><div class="col-md-6"><div class="col-md-12"><table class="table table-bordered table-striped"><thead><tr><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.titulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.titulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.leveTitulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.pesadoTitulo\' | translate }}</th></tr></thead><tbody><tr><td class="text-center"><div class="retangulo vermelho-motorway"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.viaRapida\' | translate }}</p><img src="images/urb-via-rapida.png"/></div></div><div class="retangulo laranja-trunk"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.viaRapida\' | translate }}</p><img src="images/urb-via-rapida-2.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.viaRapida\' | translate }}</td><td>100 km/h</td><td>90 km/h</td></tr><tr><td class="text-center"><div class="retangulo amarelo-primary"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.avenida\' | translate }}</p><img src="images/urb-avenida.png"/></div></div><div class="retangulo bege-secondary"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.avenida\' | translate }}</p><img src="images/urb-avenida-2.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.avenida\' | translate }}</td><td>80 km/h</td><td>70 km/h</td></tr><tr><td class="text-center"><div class="retangulo branco-others"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.rua\' | translate }}</p><img src="images/urb-rua.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaUrbano.tipoVia.linha.rua\' | translate }}</td><td>60 km/h</td><td>50 km/h</td></tr></tbody></table></div><div class="col-md-12"><table class="table table-bordered table-striped"><thead><tr><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.titulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.titulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.leveTitulo\' | translate }}</th><th>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.pesadoTitulo\' | translate }}</th></tr></thead><tbody><tr><td class="text-center"><div class="retangulo vermelho-motorway"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.pistaDuplicada\' | translate }}</p><img src="images/rod-pista-duplicada.png"/></div></div><div class="retangulo laranja-trunk"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.pistaDuplicada\' | translate }}</p><img src="images/rod-pista-duplicada-2.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.pistaDuplicada\' | translate }}</td><td>120 km/h</td><td>100 km/h</td></tr><tr><td class="text-center"><div class="retangulo amarelo-primary"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.pistaSimples\' | translate }}</p><img src="images/rod-pista-simples.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.pistaSimples\' | translate }}</td><td>110 km/h</td><td>90 km/h</td></tr><tr><td class="text-center"><div class="retangulo bege-secondary"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.vicinal\' | translate }}</p><img src="images/rod-vicinal.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.vicinal\' | translate }}</td><td>80 km/h</td><td>80 km/h</td></tr><tr><td class="text-center"><div class="retangulo icone-rural"><div><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.ruralOutras\' | translate }}</p><img src="images/rod-rural.png"/></div></div></td><td>{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.colunasTabelaRodoviario.tipoVia.linha.ruralOutras\' | translate }}</td><td>80 km/h</td><td>60 km/h</td></tr></tbody></table></div></div><div class="col-md-6"><leaflet id="mapaPrincipal" lf-center="$ctrl.center" tiles="$ctrl.tiles.veltec" geojson="$ctrl.geoJson" defaults="$ctrl.defaults" width="100%" height="350px"></leaflet></div></div><div class="row"><div class="col-md-12"><p translate="ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.leiaMais.modal.osEventosGerados">| translate }}</p></div></div></div><div class="modal-footer"><button ng-click="$ctrl.close()" class="btn btn-success">OK</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/video-library/solicitacao-videos/solicitacao-videos.tpl.html',
    '<div id="table-solicitacao-videos"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/video-library/playback/playback.tpl.html',
    '<div id="safety-app-VideoPlayback"></div><div id="playback-page-content"><div id="playback-page-pendo-content"></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/historico-solicitacao/cancelar/cancelar-solicitacao.tpl.html',
    '<div class="modal-header bg-red"><h3 id="modal-title" class="modal-title">{{ \'ce.analise.solicitacoesAgendadas.modal.titulo.cancelarSolicitacaoDeRelatorio\' | translate }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><p>{{ \'ce.analise.solicitacoesAgendadas.modal.mensagem.naoSeraPossivelReverterAcao\' | translate }}</p></div><div class="modal-footer"><button id="historicoSolicitacao-voltar" type="button" ng-click="$ctrl.close()" class="btn btn-default">{{ \'ce.analise.solicitacoesAgendadas.modal.botao.voltar\' | translate }}</button><button id="historicoSolicitacao-sim" type="submit" ng-click="$ctrl.ok()" class="btn btn-danger">{{ \'ce.analise.solicitacoesAgendadas.modal.botao.simQueroCancelar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/historico-solicitacao/cadastrar/cadastrar-solicitacao.tpl.html',
    '<div class="modal-header bg-green"><h3 id="modal-title" class="modal-title">{{ $ctrl.getTitle() }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><form name="formVfiltroModal" class="form"><div class="modal-body"><div ng-if="$ctrl.exibirForm" class="form-solicitacao"><div class="row"><div class="form-group col-md-6"><label for="relatorio-select">{{ \'ce.analise.solicitacoesAgendadas.modal.label.relatorio\' | translate }}</label><ui-select ng-model="$ctrl.relatorioSelecionado" close-on-select="true" on-select="$ctrl.onRelatorioSelecionado()" ng-disabled="$ctrl.somenteVisualizacao"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'ce.analise.solicitacoesAgendadas.modal.label.placeholderSelecionar\' | translate }}">{{ $select.selected.label }}</ui-select-match><ui-select-choices repeat="option in $ctrl.opcoesRelatorios track by option.label"><span>{{ option.label }}</span></ui-select-choices></ui-select></div></div><div ng-class="{ \'expandido\': !!$ctrl.filtro, \'expandindo\': $ctrl.expandindo }" class="vfiltro"><div class="row"><div ng-repeat="item in ($ctrl.filtro.filtroCompleto | orderBy : &quot;order&quot;) track by item.order" ng-switch="item.type" ng-class="&quot;col-md-{{item.size}}&quot;"><select-simple ng-switch-when="select-simple" model="item"></select-simple><select-multiple ng-switch-when="select-multiple" model="item"></select-multiple><date-time-picker ng-switch-when="date-time-picker" model="item"></date-time-picker></div></div><div class="alerta-aqui-cadastro-solicitacao"></div><div ng-if="$ctrl.isUoSemVeiculos" class="alert alert-error text-left"><span>{{ \'ce.analise.solicitacoesAgendadas.modal.mensagem.erroSemVeiculos\' | translate }}</span></div></div></div><div ng-if="!$ctrl.exibirForm" class="confirmacao-solicitacao"><p>{{ \'ce.analise.solicitacoesAgendadas.modal.mensagem.processoPodeDemorar\' | translate }}</p><p>{{ \'ce.analise.solicitacoesAgendadas.modal.mensagem.desejaCriarNovaSolicitacao\' | translate }}</p><div class="alerta-aqui-cadastro-solicitacao"></div></div></div><div ng-if="!$ctrl.somenteVisualizacao" class="modal-footer"><button id="historicoSolicitacao-cancelar" type="button" ng-click="$ctrl.cancelar()" class="btn btn-default">{{ $ctrl.getLabelBtnCancelar() }}</button><button id="historicoSolicitacao-salvar" type="submit" ng-click="$ctrl.save()" ng-disabled="$ctrl.isSaveInvalid()" class="btn btn-success">{{ $ctrl.getLabelBtnSalvar() }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bdv/bdv-checklist/bdv-checklist.tpl.html',
    '<div class="alerta-aqui"></div><div class="box box-primary box-checklist"><header class="box-header"><h3 class="box-title">{{bdvChecklist.veiculo.placa}} - {{bdvChecklist.veiculo.prefixo}}</h3></header><nav class="nav-tabs-custom"><ul class="nav nav-tabs"><li ng-class="{active: bdvChecklist.isSelected(item)}" ng-repeat="item in bdvChecklist.data"><a href="#" ng-click="bdvChecklist.changeTab(item)" uib-tooltip="{{item.motorista.nome}}" class="truncate">{{item.motorista.nome}}</a></li></ul></nav><article class="box-body"><div class="row form-group"><div class="col-md-6"><strong>{{ \'ce.boletim.diarioVeiculoChecklist.dataHora\' | translate }}:</strong><span> {{bdvChecklist.itemSelected.dataPreenchimento | date: \'dd/MM/yyyy HH:mm\'}}</span></div><div class="col-md-2"><i class="fa fa-check-square fa-icon-right text-success"></i><span>{{ bdvChecklist.checklistEnum.CONFORME.label | translate }}:\n' +
    '{{bdvChecklist.getCount(bdvChecklist.checklistEnum.CONFORME.id)}}</span></div><div class="col-md-2"><i class="fa fa-window-close fa-icon-right text-danger"></i><span>{{ bdvChecklist.checklistEnum.NAO_CONFORME.label | translate }}:\n' +
    '{{bdvChecklist.getCount(bdvChecklist.checklistEnum.NAO_CONFORME.id)}}</span></div><div class="col-md-2"><i class="fa fa-check-square fa-icon-right text-muted"></i><span>{{ bdvChecklist.checklistEnum.NAO_APLICA.label | translate }}:\n' +
    '{{bdvChecklist.getCount(bdvChecklist.checklistEnum.NAO_APLICA.id)}}</span></div></div><table id="bdv-table-checklist" st-table="bdvChecklist.itemSelected.itens" st-safe-src="bdvChecklist.itemSelectedCopy" class="table table-hover table-striped"><thead><tr><th id="bdv-checklist-th-item" st-sort="item.nome" class="col-md-4 middle st-sort">{{ \'ce.boletim.diarioVeiculoChecklist.item\' | translate }}</th><th id="bdv-checklist-th-status" st-sort="opcao" class="col-md-2 middle st-sort">{{ \'ce.boletim.diarioVeiculoChecklist.status\' | translate }}</th><th id="bdv-checklist-th-observacao" st-sort="observacao" class="col-md-6 middle st-sort">{{ \'ce.boletim.diarioVeiculoChecklist.observacao\' | translate }}</th></tr></thead><tbody><tr ng-repeat="i in bdvChecklist.itemSelected.itens"><td>{{i.item.nome}}</td><td ng-class="bdvChecklist.checklistEnum.getTipoChecklist(i.opcao).class">{{ bdvChecklist.checklistEnum.getTipoChecklist(i.opcao).label | translate }}</td><td>{{i.observacao}}</td></tr></tbody></table></article></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bdv/bdv-detalhes/bdv-detalhes.tpl.html',
    '<div id="bdv-detalhes" class="row"><div class="col-md-9"><div class="box box-primary"><div class="box-body"><div class="col-md-9 no-padding"><leaflet id="bdv-map" tiles="bdvDetalhes.tiles" geojson="bdvDetalhes.geoJson" lf-center="bdvDetalhes.mapCenter" defaults="bdvDetalhes.defaults" event-broadcast="events" watch-markers="no" width="100%" height="500px"><map-control id-mapa="&quot;bdv-map&quot;" ng-if="!bdvDetalhes.isDemo" on-init="bdvDetalhes.onMapControlInit()"></map-control><map-layer-switcher on-layer-switch="bdvDetalhes.onLayerSwitch(layerWrapper)"></map-layer-switcher><toggle-layer-markers></toggle-layer-markers></leaflet><div ng-if="bdvDetalhes.conducaoSelecionada == null &amp;&amp; !bdvDetalhes.todasConducoes" class="panel"><div id="bdv-panel-erro" class="panel-body text-muted">{{ \'ce.boletim.diarioVeiculoDetalhes.erroPanel\' | translate }}</div></div></div><div class="col-md-3 no-padding"><resumo-periodo titulo="bdvDetalhes.veiculo" subtitulo="bdvDetalhes.motoristas" duracao="bdvDetalhes.duracao" distancia="bdvDetalhes.distancia" logradouro-inicio="bdvDetalhes.logradouroInicio" logradouro-fim="bdvDetalhes.logradouroFim" conducoes="bdvDetalhes.resumoPeriodo" consumo-combustivel="bdvDetalhes.consumoCombustivel" media-consumo="bdvDetalhes.mediaConsumo" consumo-eletrico="bdvDetalhes.consumoEletrico" media-consumo-eletrico="bdvDetalhes.mediaConsumoEletrico" on-click-evento="bdvDetalhes.onClickTipoEvento" on-click-posicao="bdvDetalhes.onClickPosicao" tempo-por-faixa-rpm="bdvDetalhes.tempoPorFaixaRpm" faixas-descida="bdvDetalhes.faixasDescida" diferenca-altitude="bdvDetalhes.diferencaAltitude"></resumo-periodo></div></div></div></div><div id="decoratedVideoPlayerModalContainer" class="bdv-decorated-video-player"></div><div class="col-md-3"><div id="box-lateral-bdx" class="box box-primary"><div ng-class="{\'bg-cinza\' : bdvDetalhes.todasConducoes}" class="box-header with-border"><a href="" ng-click="bdvDetalhes.selecionarTodasConducoes()"><h3 id="conducoes-title" class="box-title">{{ \'ce.boletim.diarioVeiculoDetalhes.painelConducoes.titulo\' | translate }}</h3></a><small class="clearfix"><i class="fa fa-calendar margin-r-5"></i>{{bdvDetalhes.inicio | date:bdvDetalhes.dateTimeFormat}}\n' +
    '- {{bdvDetalhes.duracaoTotal | humanizedDuration}}</small><div class="box-tools"><button data-widget="collapse" class="btn btn-box-tool btn-box-bd"><i class="fa fa-minus"></i></button></div></div><div class="box-body no-padding box-bdv-conducoes"><div slimscroll="{railVisible: true, height: \'460px\'}" class="conducoes"><ul class="nav nav-stacked"><li ng-repeat="row in bdvDetalhes.detalhes" ng-class="row == bdvDetalhes.conducaoSelecionada || bdvDetalhes.todasConducoes ? [\'active\'] : \'\'"><a href="" ng-click="bdvDetalhes.selecionarConducao(row)" id="conducao-{{$index}}"><span class="text-primary">{{ row.nomesMotoristas }}</span><p>{{row.inicio | date:"HH:mm:ss"}}\n' +
    '- {{ row.fim ? (row.fim | date:\'HH:mm:ss\') : \'ce.boletim.diarioVeiculoDetalhes.painelConducoes.vigente\' | translate }}<i ng-if="row.vigenciaManual" uib-tooltip="{{ \'ce.boletim.diarioVeiculoDetalhes.painelConducoes.tooltipVigenciaManual\' | translate }}" tooltip-placement="top-right" class="fa-lg trimble-history pull-right"></i></p></a></li></ul><vfwc-btn-adicionar-conducao ng-if="bdvDetalhes.roleVigenciaEditar" ng-init="bdvDetalhes.configurarCadastroConducao()"></vfwc-btn-adicionar-conducao></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('quadro-ocorrencias/ocorrencia-modal/hist-item/hist-item.tpl.html',
    '<div class="row user-title"><div class="col-md-8"><div class="icon-obs pull-left"><i class="fa fa-user"></i></div><div class="user-email pull-left"><span>{{ $ctrl.usuario }}</span></div></div><div class="col-md-4 text-right"><span class="data-hora">{{ $ctrl.dataHora }}</span></div></div><div class="detalhes"><div ng-if="$ctrl.item.statusAnterior" class="row"><div class="col-md-12"><span ng-bind-html="$ctrl.statusI18N"></span><span>{{ $ctrl.statusAnterior | translate }}</span><i class="fa fa-arrow-right"></i><span>{{ $ctrl.statusNovo | translate }}</span></div></div><div ng-if="$ctrl.item.usuarioAtribuidoAnterior || $ctrl.item.usuarioAtribuidoNovo" class="row"><div class="col-md-12"><span ng-bind-html="$ctrl.responsavelI18N"></span><span>{{ $ctrl.resAnterior }}</span><i class="fa fa-arrow-right"></i><span>{{ $ctrl.resNovo }}</span></div></div><div ng-if="$ctrl.comentario" class="row"><div class="col-md-12"><span ng-bind-html="$ctrl.observacaoI18N"></span><span>{{$ctrl.comentario}}</span></div></div><div ng-if="$ctrl.item.anexos.length" class="row"><div class="col-md-12 anexos"><span ng-bind-html="$ctrl.anexoI18N"></span><div ng-repeat="anexo in $ctrl.item.anexos" ng-click="$ctrl.downloadAnexo(anexo.uuid, anexo.nome)" class="anexo-nome-block"><span>{{ anexo.nome }}</span><span class="clique-para-ver">{{ \'ce.tempoReal.quadroDeOcorrencias.historicoItem.cliqueParaDownload\' | translate }}</span><a></a></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('prontuario/modal/upload/upload-prontuario.tpl.html',
    '<div class="modal-header bg-light-blue"><h3 class="modal-title"><strong>{{\'ce.ranking.motoristas.prontuario.modal.upload.importarInfracoes\' | translate}}</strong><i ng-click="$ctrl.dismiss()" class="pull-right fa fa-times-circle cursor-pointer"></i></h3></div><form id="form-upload" name="formUpload" ng-submit="$ctrl.salvar()"><div class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group"><label for="upload">{{ \'ce.ranking.motoristas.prontuario.modal.upload.selecioneArquivo\' | translate }}<br/><small class="subtitle-label text-muted">{{ \'ce.ranking.motoristas.prontuario.modal.upload.extensaoArquivo\' | translate }}</small></label><div><input id="upload" ng-required="!$ctrl.infracao" onchange="angular.element(this).scope().$ctrl.setUploadFile(this)" type="file" accept=".pdf,.rar,.zip,image/*" ng-hide="true" name="upload" class="form-control input-vfiltro"/><button type="button" botao-upload="#upload" class="btn btn-sm btn-outline-blue">{{ \'ce.common.escolherArquivo\' | translate }}</button><label for="upload" style="padding-left:15px; font-weight: normal" class="text-muted">{{ $ctrl.getFileName() }}</label></div></div><div class="alert-file"></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><strong class="text-primary">{{ \'ce.ranking.motoristas.prontuario.modal.upload.tipoInfracao\' | translate }}</strong><div class="radio"><label for="tipo-multa"><input id="tipo-multa" ng-model="$ctrl.model.tipo" required="required" type="radio" name="tipo" value="INFRACAO"/>{{ \'ce.ranking.motoristas.prontuario.modal.upload.multa\' | translate }}<i uib-tooltip-html="&quot;{{ \'ce.ranking.motoristas.prontuario.modal.upload.pontosAplicados\' | translate }}&quot;" class="fa-icon-left fa fa-info-circle"></i></label></div><div class="radio"><label for="tipo-outros"><input id="tipo-outros" ng-model="$ctrl.model.tipo" required="required" type="radio" name="tipo" value="OUTRO"/>{{ \'ce.ranking.motoristas.prontuario.modal.upload.outros\' | translate }}<br/><small class="subtitle-label">({{ \'ce.ranking.motoristas.prontuario.modal.upload.reclamacao\' | translate }})</small></label></div></div></div><div class="col-sm-12 vfiltro"><div class="form-group"><strong class="text-primary">{{ \'ce.ranking.motoristas.prontuario.modal.upload.maisInformacoes\' | translate }}</strong></div><div class="row"><div ng-repeat="item in ($ctrl.filtro | orderBy : &quot;order&quot;) track by item.order" class="col-md-6"><select-simple model="item"></select-simple></div></div></div><div ng-class="{\'has-error\': !!descricaoError()}" class="col-sm-12 form-group"><label for="descricao">{{ \'ce.ranking.motoristas.prontuario.modal.upload.descricao\' | translate }}</label><input id="descricao" v3g-validator="descricaoError" ng-model="$ctrl.model.descricao" placeholder="{{ \'ce.ranking.motoristas.prontuario.modal.upload.descricaoPlaceholder\' | translate }}" required="required" type="text" name="descricao" class="form-control input-vfiltro"/><span ng-if="!!descricaoError()" class="help-block">{{ descricaoError() | translate }}</span></div><div ng-class="[{\'has-error\': !!dataError()}, $ctrl.isRadioButtonMulta() ? \'col-sm-4\' : \'col-sm-6\']" class="form-group"><label for="data">{{ \'ce.ranking.motoristas.prontuario.modal.upload.dataOcorrencia\' | translate }}</label><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-calendar"></i></span><input id="data" v3g-validator="dataError" v3g-mensagem-expression="$error.isDataFutura ? &quot;{{ \'ce.ranking.motoristas.prontuario.modal.upload.dataNaoPodeSerFutura\' | translate }}&quot; : &quot;{{ \'ce.ranking.motoristas.prontuario.modal.upload.dataInvalida\' | translate }}&quot;" ui-validate="{isDataFutura: $ctrl.isNotDataFutura()}" ng-model="$ctrl.model.data" ui-date-mask="DD-MM-YYYY" placeholder="DD/MM/YYYY" required="required" type="text" name="data" class="form-control"/></div><span ng-if="!!dataError()" class="help-block">{{ dataError() }}</span></div><div ng-class="[{\'has-error\': !!horaError()}, $ctrl.isRadioButtonMulta() ? \'col-sm-4\' : \'col-sm-6\']" class="form-group"><label for="hora">{{ \'ce.ranking.motoristas.prontuario.modal.upload.horaOcorrencia\' | translate }}</label><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-clock-o"></i></span><input id="hora" v3g-validator="horaError" v3g-mensagem-expression="$error.isHoraFutura ? &quot;{{ \'ce.ranking.motoristas.prontuario.modal.upload.horarioNaoPodeSerFuturo\' | translate }}&quot; : &quot;{{ \'ce.ranking.motoristas.prontuario.modal.upload.horarioInvalido\' | translate }}&quot;" ui-validate="{isHoraFutura: $ctrl.isNotHoraFutura()}" ng-model="$ctrl.model.hora" ui-time-mask="short" placeholder="HH:MM" required="required" type="text" name="hora" class="form-control"/></div><span ng-if="!!horaError()" class="help-block">{{ horaError() }}</span></div><div ng-if="$ctrl.isRadioButtonMulta()" ng-class="{\'has-error\': !!multaError()}" class="col-sm-4 form-group"><label for="multa">{{ \'ce.ranking.motoristas.prontuario.modal.upload.valorMulta\' | translate }}</label><div class="input-group left input-group-vfiltro"><span class="input-group-addon">R$</span><input id="multa" v3g-validator="multaError" v3g-mensagem="{{ \'ce.ranking.motoristas.prontuario.modal.upload.valorMultaInvalido\' | translate }}" ng-model="$ctrl.model.multa" ui-number-mask="2" placeholder="0.000,00" required="required" type="text" name="multa" class="form-control"/></div><span ng-if="!!multaError()" class="help-block">{{ multaError() }}</span></div><div ng-if="$ctrl.isRadioButtonMulta()" class="col-sm-12"><div class="form-group"><strong class="text-primary">{{ \'ce.ranking.motoristas.prontuario.modal.upload.quantosPontosSomar\' | translate }}</strong></div></div><div ng-if="$ctrl.isRadioButtonMulta()" ng-class="{\'has-error\': !!pontosError()}" class="col-sm-4 form-group"><label for="pontos">{{ \'ce.ranking.motoristas.prontuario.modal.upload.pontos\' | translate }}</label><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-vcard-o"></i></span><input id="pontos" v3g-validator="pontosError" ng-model="$ctrl.model.pontos" ng-min="1" ng-max="99" placeholder="0" required="required" type="number" name="pontos" class="form-control"/></div><span ng-if="!!pontosError()" class="help-block">{{ pontosError() | translate : \'{valorMinimo: 1, valorMaximo: 99}\' }}</span></div></div><div class="alerta-aqui"></div></div><div class="modal-footer text-right"><button ng-disabled="formUpload.$invalid || !formUpload.$dirty || (!$ctrl.model.file &amp;&amp; !$ctrl.infracao)" class="btn btn-primary">{{ \'ce.ranking.motoristas.prontuario.modal.upload.botaoSalvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('prontuario/modal/foto/foto-motorista.tpl.html',
    '<div class="modal-header bg-light-blue"><h3 class="modal-title"><strong>Editar Foto<i ng-click="$ctrl.dismiss()" class="pull-right fa fa-times-circle cursor-pointer"></i></strong></h3></div><form name="formFotoMotorista" ng-submit="$ctrl.salvar()"><div class="modal-body"><v3g-image-crop on-crop="$ctrl.onCrop" on-change-file="$ctrl.onChangeFile"></v3g-image-crop><div class="alerta-aqui"></div></div><div class="modal-footer text-right"><button type="button" ng-click="$ctrl.dismiss()" class="btn btn-default">Cancelar</button><button type="submit" ng-disabled="!formFotoMotorista.$dirty" class="btn btn-primary">Importar</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('prontuario/modal/excluir-upload/excluir-upload-prontuario.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title"><strong>{{ \'ce.ranking.motoristas.prontuario.modal.excluir.titulo\' | translate }}\n' +
    '{{ \'ce.ranking.motoristas.prontuario.modal.excluir.infracao\' | translate }}</strong><i ng-click="$ctrl.dismiss()" class="pull-right fa fa-times-circle cursor-pointer"></i></h3></div><div class="modal-body"><p ng-if="$ctrl.isMulta()">{{ \'ce.ranking.motoristas.prontuario.modal.excluir.excluirMulta\' | translate }}</p><p ng-if="!$ctrl.isMulta()">{{ \'ce.ranking.motoristas.prontuario.modal.excluir.confirmaInfracao\' | translate }}</p><div class="alerta-aqui"></div></div><div class="modal-footer text-right"><button type="button" ng-click="$ctrl.dismiss()" class="btn btn-default">{{ \'ce.ranking.motoristas.prontuario.modal.excluir.cancelar\' | translate }}</button><button type="button" ng-click="$ctrl.excluir()" class="btn btn-danger">{{ \'ce.ranking.motoristas.prontuario.modal.excluir.botaoExcluir\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/view/grafico/grafico-one-page.tpl.html',
    '<div ng-if="ctrl.exibeAlertaTurnos() || ctrl.exibeAlertaDia()" class="row"><div class="col-md-12"><h4 class="titulo-one-page"><strong>{{ \'ce.tempoReal.statusFrota.common.alertasSeguranca\' | translate }}</strong></h4></div><div ng-if="ctrl.exibeAlertaTurnos()" class="col-md-12"><div gridster="ctrl.gridster" ng-if="ctrl.gridster" class="gridster-no-margin"><ul><li gridster-item="ctrl.posicoesGridster.alertaTurnos" ng-if="ctrl.posicoesGridster.alertaTurnos"><alerta-turno-one-page-grafico-directive ng-controller="GraficoOnePageCtrl"></alerta-turno-one-page-grafico-directive></li></ul></div></div><div ng-if="ctrl.exibeAlertaDia()" class="col-md-12"><div gridster="ctrl.gridster" ng-if="ctrl.gridster" class="gridster-no-margin"><ul><li gridster-item="ctrl.posicoesGridster.alertas" ng-if="ctrl.posicoesGridster.alertas"><alerta-dia-one-page-grafico-directive ng-controller="GraficoOnePageCtrl"></alerta-dia-one-page-grafico-directive></li></ul></div></div></div><div ng-if="ctrl.visualizarLocalizao || ctrl.visualizarHistoricoAlerta" class="row"><div class="col-md-12"><h4 class="titulo-one-page"><strong>{{ \'ce.tempoReal.statusFrota.common.statusFrota\' | translate }}</strong></h4></div><div class="col-md-12"><div gridster="ctrl.gridster" ng-if="ctrl.gridster" class="gridster-no-margin"><ul><li gridster-item="ctrl.posicoesGridster.semSinal" ng-if="ctrl.exibeSemSinal()"><sem-sinal-one-page-grafico-directive ng-controller="GraficoOnePageCtrl"></sem-sinal-one-page-grafico-directive></li><li gridster-item="ctrl.posicoesGridster.paradoMovimento" ng-if="ctrl.exibeParadoMovimento()"><parado-movimento-one-page-grafico-directive ng-controller="GraficoOnePageCtrl"></parado-movimento-one-page-grafico-directive></li></ul></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/view/card/card-one-page.tpl.html',
    '<div ng-if="ctrl.visualizarHistoricoAlerta &amp;&amp; ctrl.onePageService.exibirAlertaTurnos" class="row"><div class="col-md-12"><h4 class="titulo-one-page"><strong>{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.tituloTurno\' | translate }}</strong></h4></div><div class="col-md-12"><alerta-turno-one-page-card-directive></alerta-turno-one-page-card-directive></div></div><div ng-if="ctrl.visualizarNotificacoes &amp;&amp; !ctrl.onePageService.exibirAlertaTurnos" class="row"><div class="col-md-12"><h4 class="titulo-one-page"><strong>{{ \'ce.tempoReal.statusFrota.charts.alertaSeguranca.tituloDia\' | translate }}</strong></h4></div><alerta-dia-one-page-card-directive></alerta-dia-one-page-card-directive></div><div ng-if="ctrl.visualizarLocalizao || ctrl.visualizarHistoricoAlerta" class="row"><div class="col-md-12"><h4 class="titulo-one-page"><strong>{{ \'ce.tempoReal.statusFrota.common.statusFrota\' | translate }}</strong></h4></div><div class="col-md-12"><div gridster="ctrl.gridster" ng-if="ctrl.gridster" class="gridster-no-margin"><ul><li gridster-item="ctrl.posicoesGridster.semSinal" ng-if="ctrl.visualizarHistoricoAlerta &amp;&amp; ctrl.posicoesGridster.semSinal"><sem-sinal-one-page-card-directive ng-controller="CardOnePageCtrl"></sem-sinal-one-page-card-directive></li><li gridster-item="ctrl.posicoesGridster.paradoMovimento" ng-if="ctrl.visualizarLocalizao &amp;&amp; ctrl.posicoesGridster.paradoMovimento"><parado-movimento-one-page-card-directive ng-controller="CardOnePageCtrl"></parado-movimento-one-page-card-directive></li></ul></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/visao-cameras/cameras-paginacao/cameras-paginacao.tpl.html',
    '<nav class="cameras-pagination"><ul><li><i ng-class="{disabled: $ctrl.isFirst}" ng-click="!$ctrl.isFirst ? $ctrl.handlePreviousPage() : null" class="action-button fa fa-chevron-left"></i></li><li class="page"><span>{{ \'vfwc.shared.veltecPaginator.paginaAtual\' | translate }}</span><select id="select-page" name="page" ng-change="$ctrl.handleChangeSelectPage()" ng-options="page + 1 for page in $ctrl.pageArray" ng-model="$ctrl.page" class="form-control"></select><span>{{ \'vfwc.shared.veltecPaginator.de\' | translate }} {{ $ctrl.totalPages }}</span></li><li><i ng-class="{disabled: $ctrl.isLast}" ng-click="!$ctrl.isLast ? $ctrl.handleNextPage() : null" class="action-button fa fa-chevron-right"></i></li></ul></nav>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/visao-cameras/controle-cameras/controle-cameras.tpl.html',
    '<div class="controle-cameras"><i ng-click="$ctrl.previous()" ng-class="{\'disabled\': $ctrl.isPreviousDisable()}" uib-tooltip="{{$ctrl.getPreviousEvidenceTooltip()}}" class="action-button fa fa-chevron-left"></i><div class="cameras flex-1"><div class="label-camera"><p>{{ \'ce.mapa.common.visaoCameras.camera\' | translate }} {{ $ctrl.cameraSelected + 1 }}</p></div><div class="circles"><i ng-repeat="index in $ctrl.indiceDisponiveis" ng-class="$ctrl.classCamera(index)" ng-click="$ctrl.setIndex(index)" class="fa circle-camera"></i></div></div><i ng-click="$ctrl.next()" ng-class="{\'disabled\': $ctrl.isNextDisable()}" uib-tooltip="{{$ctrl.getNextEvidenceTooltip()}}" class="action-button fa fa-chevron-right"></i></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/visao-cameras/carousel-snapshot/carousel-snapshot.tpl.html',
    '<div uib-carousel="" active="$ctrl.indiceCard" interval="myInterval" no-wrap="noWrapSlides" class="carousel-snapshot"><div uib-slide="" ng-repeat="camera in $ctrl.snapshot.cameras track by $index" index="$index" class="snapshot-image-container"><img ng-src="{{ $ctrl.getUrl(camera.indice) }}" style="margin:auto;"/><div class="carousel-caption"><h4>{{ $ctrl.getCaption(camera.indice) }}</h4><h4>{{ $ctrl.getLabels(camera.indice) }}</h4></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/visao-cameras/card-snapshot/card-snapshot.tpl.html',
    '<div class="card-snapshot"><div class="card-header"><div class="header-content flex"><a href="#" ng-click="$ctrl.visualizarPonto()" ng-if="$ctrl.snapshot.latitude &amp;&amp; $ctrl.snapshot.longitude" class="ver-no-mapa flex-1">{{ \'ce.mapa.common.visaoCameras.verNoMapa\' | translate }}</a><div class="datahora flex"><i class="fa fa-clock-o"></i>&nbsp; {{ $ctrl.getTime() }}</div></div></div><img ng-src="{{$ctrl.getUrl()}}" ng-click="$ctrl.visualizarFoto()"/><div ng-if="$ctrl.getLabels()" class="card-footer"><span>{{ $ctrl.getLabels() }}</span></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/tempo-permanencia-input/tempo-permanencia-input-component.tpl.html',
    '<div id="tempo-permanencia" class="tempo-permanencia-container"><div class="configurar-tempo-minimo"><div class="checkbox"><div class="checkbox-container"><label for="tempo-minimo-permanencia">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelConfigurarTempo\' | translate }}</label><i uib-tooltip="{{$ctrl.info}}" class="fa fa-info-circle fa-icon-top"></i><input type="checkbox" id="tempo-minimo-permanencia" ng-change="$ctrl.onChangeConfigTempoMinimo()" ng-model="$ctrl.configurarTempo"/><span ng-click="$ctrl.configurarTempo = !$ctrl.configurarTempo; $ctrl.onChangeConfigTempoMinimo()" class="checkmark"></span></div></div></div><div ng-class="{\'error-tempo-permanencia\': tempoPermanenciaError() !== \'\'}" class="form-group"><div ng-show="$ctrl.configurarTempo" class="input-group"><input id="tempo-permanencia-minimo" name="{{$ctrl.name}}" type="number" ng-model="$ctrl.model" ng-model-options="{allowInvalid: true}" ng-min="3" maxlength="6" v3g-validator="tempoPermanenciaError" v3g-mensagem-expression="{{ $error.less3Minutes ? \'ce.mapa.common.modal.tempoPermanenciaInput.less3Minutes\' : \'ce.mapa.common.modal.valorInvalido\' | translate }}" ui-validate="{less3Minutes: $ctrl.tempoPermanenciaValid()}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderTempoPermanencia\' | translate }}" class="form-control hide-spin"/><div class="input-group-addon">min</div></div><span ng-if="tempoPermanenciaError() !== \'\'" class="help-block">{{tempoPermanenciaError() | translate : \'{valorMinimo: 3, valorMaximo: 6}\'}}</span></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/tabela-pontos-proximos/tabela-pontos-proximos.tpl.html',
    '<div class="box box-primary no-margin"><header class="box-header with-border"><h3 class="box-title text-primary"><strong>{{ \'ce.mapa.common.modal.tabelaPontosProximos.titulo\' | translate }}</strong><small class="text-muted"> {{ \'ce.mapa.common.modal.tabelaPontosProximos.ate500m\' | translate }}</small></h3><i ng-if="ctrl.showBtn" ng-class="ctrl.pontosReferenciaMenuService.tabelaPontosProximos ? &quot;fa-caret-down&quot;: &quot;fa-caret-up&quot;" ng-click="ctrl.toggleTable()" class="fa toggle-table-pontos-proximos"></i><button type="button" ng-click="ctrl.removeAllPontosProximos()" class="btn btn-primary btn-xs pull-right">{{ \'ce.mapa.common.modal.tabelaPontosProximos.tituloBtLimpar\' | translate }}</button></header><article slimscroll="{railVisible: true, height: \'150px\', size: \'5px\', alwaysVisible: \'true\'}" class="box-body no-padding"><table ng-if="ctrl.pontosProximosService.listaPontosProximos.length &gt; 0" class="table table-hover table-striped"><thead><tr><th class="col-md-2">{{ \'ce.mapa.common.modal.tabelaPontosProximos.headerPin\' | translate }}</th><th class="col-md-4">{{ \'ce.mapa.common.modal.tabelaPontosProximos.headerDataHora\' | translate }}</th><th class="col-md-2">{{ \'ce.mapa.common.modal.tabelaPontosProximos.headerDistancia\' | translate }}</th><th class="col-md-2">{{ \'ce.mapa.common.modal.tabelaPontosProximos.headerVelocidade\' | translate }}</th><th class="col-md-2"></th></tr></thead><tbody><tr ng-repeat="item in ctrl.pontosProximosService.listaPontosProximos" ng-click="ctrl.focusItem(item)" ng-class="{active: ctrl.idLayer === item.idLayer}" class="cursor-pointer"><td>{{ item.index }}</td><td ng-if="item.evento">{{ ctrl.formatDate(item.evento.data) }}</td><td ng-if="item.raio">{{ item.raio }} m</td><td ng-if="item.evento">{{ item.evento.velocidade }} Km/h</td><td ng-if="!item.evento" colspan="3" class="text-center"><strong>{{ \'ce.mapa.common.modal.tabelaPontosProximos.pontoMais500m\' | translate }}</strong></td><td class="text-center"><i ng-click="ctrl.removeItem(item.idLayer)" class="btn text-danger fa fa-times"></i></td></tr></tbody></table><div ng-if="ctrl.pontosProximosService.listaPontosProximos.length === 0" class="panel-body text-muted">{{ \'ce.mapa.common.modal.tabelaPontosProximos.nenhumPinMapa\' | translate }}</div></article></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/rotograma-ponto-referencia/modal-detalhes-rotograma.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ $ctrl.getTitle() | translate }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body modal-body-custom-ponto"><div class="alerta-aqui-rotograma-ponto"></div><div class="row"><div class="col-md-12"><p ng-bind-html="$ctrl.getDescricao()"></p></div></div><div ng-if="$ctrl.model.length &gt; 0" class="row"><div class="col-md-12"><table class="table table-hover table-bordered"><tr><th class="col-md-4">{{ \'ce.mapa.common.modal.modalDetalhesRotograma.headerGrupoVeiculo\' | translate }}</th><th class="col-md-4">{{ \'ce.mapa.common.modal.modalDetalhesRotograma.headerTipoVeiculo\' | translate }}</th><th class="col-md-4">{{ \'ce.mapa.common.modal.modalDetalhesRotograma.headerVelocidade\' | translate }}</th></tr><tr ng-repeat="configuracao in $ctrl.model"><td>{{ configuracao.grupoVeiculo }}</td><td>{{ configuracao.tipoVeiculo }}</td><td>{{ configuracao.grupoVelocidade.velocidade + \' km/h\'}}</td></tr></table></div></div></div><div class="modal-footer"><button type="submit" ng-click="$ctrl.close()" class="btn btn-success">{{ \'ce.mapa.common.modal.tituloBtOk\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/rotograma/editor-rotogramas.tpl.html',
    '<div class="editor-rotogramas"><leaflet id="{{$ctrl.MAPA_ID}}" lf-center="$ctrl.center" tiles="$ctrl.tiles" defaults="$ctrl.defaults" watch-markers="no" class="map-container"><map-layer-switcher on-layer-switch="$ctrl.onLayerSwitch(layerWrapper)" should-set-url-param="false"></map-layer-switcher></leaflet><div ng-if="$ctrl.cadastroRotogramaService.getRotogramas().length === 1" role="alert" class="has-error"><span class="help-block">{{ \'ce.mapa.common.modal.cadastroRotograma.minimoRotogramasConcluirCadastro\' | translate }}</span></div><div class="agrupamentos-rotogramas-list-container"><agrupamentos-rotogramas-list></agrupamentos-rotogramas-list></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/rotograma/agrupamentos-rotogramas-list.tpl.html',
    '<div ng-repeat="agrupamento in $ctrl.cadastroRotogramaService.agrupamentos" ng-class="{\'separador\': !$last}" class="container-agrupamento-rotogramas"><i ng-if="$first &amp;&amp; $ctrl.cadastroRotogramaService.getRotogramas().length &gt; 0" uib-tooltip-html="$ctrl.getTooltipApoioCadastro()" tooltip-class="tooltip-apoio-cadastro-rotogramas" tooltip-append-to-body="true" tooltip-is-open="$ctrl.tooltipApoioCadastro" on-mousewheel="$ctrl.tooltipApoioCadastro = false" class="fa fa-icon-left fa-info-circle icon-tooltip-apoio-cadastro-rotogramas"></i><agrupamento-rotogramas agrupamento="agrupamento"></agrupamento-rotogramas></div><div class="row-adicionar-agrupamento"><span ng-click="$ctrl.cadastroRotogramaService.adicionarAgrupamento()" ng-if="$ctrl.devePermitirCriacaoGrupos()" class="badge btn-adicionar-agrupamento">+</span></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/rotograma/agrupamento-rotogramas.tpl.html',
    '<span ng-if="$ctrl.agrupamento.rotogramas.length === 0 &amp;&amp; $ctrl.cadastroRotogramaService.getRotogramas().length &lt; 5" class="info-selecionar-rotogramas"><div ng-if="$ctrl.cadastroRotogramaService.getRotogramas().length &gt; 0"><p>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.selecioneNoMapa\' | translate }}</p></div><div ng-if="$ctrl.cadastroRotogramaService.getRotogramas().length === 0"><strong>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.configurarVelocidades\' | translate }}</strong><p>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.selecioneNoMapa\' | translate }}<br/><strong>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.atencao\' | translate }}</strong>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.salvar2Selecionados\' | translate }}</p></div></span><div ng-if="$ctrl.agrupamento.rotogramas.length &gt; 0" class="agrupamento-rotogramas"><div class="row-rotogramas"><span ng-repeat="rotograma in $ctrl.agrupamento.rotogramas track by rotograma.idInterno" ng-class="rotograma.state" ng-click="$ctrl.cadastroRotogramaService.removerRotograma(rotograma.idInterno)" ng-mouseover="rotograma.state = $ctrl.rotogramaComponentStates.EXCLUSAO" ng-mouseleave="rotograma.state = $ctrl.rotogramaComponentStates.ATIVO" uib-tooltip="{{ \'ce.mapa.common.modal.agrupamentoRotogramas.tooltipExcluir\' | translate }}" tooltip-is-open="$ctrl[\'tooltipExcluirRotograma\' + rotograma.idInterno]" on-mousewheel="$ctrl[\'tooltipExcluirRotograma\' + rotograma.idInterno] = false" class="badge badge-rotograma rotograma-animated">{{ $ctrl.getIconContent(rotograma) }}</span><span ng-click="$ctrl.habilitarAdicaoProGrupo()" ng-if="$ctrl.cadastroRotogramaService.getRotogramas().length &lt; 5" class="badge badge-rotograma btn-adicionar-rotograma">+</span><div class="indicador-controle-velocidade"><div ng-if="$ctrl.agrupamento.controleVelocidade !== $ctrl.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR &amp;&amp;             $ctrl.agrupamento.grupoVelocidade"><span><i class="fa fa-arrow-right"></i></span><span class="badge-rotograma controle-velocidade-icon limite-velocidade-icon"><strong>{{ $ctrl.agrupamento.grupoVelocidade.velocidade }}</strong><small>km/h</small></span></div><div ng-if="$ctrl.agrupamento.controleVelocidade === $ctrl.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR"><span><i class="fa fa-arrow-right"></i></span><span class="badge-rotograma controle-velocidade-icon manter-velocidade-icon"></span></div></div></div><div class="row"><div ng-class="{\'has-error\': !$ctrl.isControleVelocidadeValido()}" class="form-group col-md-7"><label>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.labelControleVelocidade\' | translate }}</label><div class="controle-velocidade"><ui-select ng-model="$ctrl.agrupamento.controleVelocidade"><ui-select-match placeholder="{{ \'ce.mapa.common.modal.agrupamentoRotogramas.placeholderSelecione\' | translate }}">{{ $select.selected.label | translate }}</ui-select-match><ui-select-choices repeat="controleVelocidade in $ctrl.getControlesVelocidadeRotograma() | filter: $select.search"><span ng-bind-html="$ctrl.translate.instant(controleVelocidade.label) | highlight: $select.search"></span></ui-select-choices></ui-select><i ng-if="$ctrl.deveExibirTooltipUtilizaVelocidadeAnterior()" uib-tooltip-html="$ctrl.getTooltipUtilizaVelocidadeAnterior()" tooltip-class="tooltip-utiliza-velocidade-anterior" tooltip-append-to-body="true" tooltip-is-open="$ctrl.tooltipUtilizaVelocidadeAnterior" on-mousewheel="$ctrl.tooltipUtilizaVelocidadeAnterior = false" class="fa fa-icon-left fa-info-circle"></i></div><div ng-if="!$ctrl.isControleVelocidadeValido()" role="alert" class="help-block"><span>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.rotogramaInterno\' | translate }}</span></div></div><div ng-if="$ctrl.deveExibirVelocidade()" ng-class="{\'has-error\': !$ctrl.agrupamento.grupoVelocidade}" class="form-group col-md-5"><label>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.labelVelocidadePadrao\' | translate }}</label><ui-select ng-model="$ctrl.agrupamento.grupoVelocidade"><ui-select-match placeholder="{{ \'ce.mapa.common.modal.agrupamentoRotogramas.placeholderSelecione\' | translate }}">{{ $select.selected.velocidade + \' Km/h\' }}</ui-select-match><ui-select-choices repeat="grupo in $ctrl.getGruposVelocidade() | filter: $select.search track by grupo.id"><span ng-bind-html="grupo.velocidade + \' Km/h\' | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-if="!$ctrl.agrupamento.grupoVelocidade" role="alert" class="help-block"><span>{{ \'ce.mapa.common.modal.campoObrigatorio\' | translate }}</span></div></div></div><div class="checkbox"><label><input type="checkbox" name="veiculosEspecificos" ng-model="$ctrl.agrupamento.usarRegrasEspecificas" ng-change="$ctrl.adicionarRegraSeNaoExistir()"/>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.checkboxVeiculosEspecificos\' | translate }}</label></div><div ng-if="$ctrl.agrupamento.usarRegrasEspecificas" class="table-responsive"><table class="table table-bordered"><thead class="thead-config-rotograma"><tr><th>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.grupoVeiculo\' | translate }}</th><th>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.tipoVeiculo\' | translate }}</th><th>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.velocidade\' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat="regra in $ctrl.agrupamento.regras" ng-class="{\'has-error\': $ctrl.cadastroRotogramaService.isRegraDuplicada(regra, $ctrl.agrupamento.regras)}"><td class="col-md-4"><div ng-class="{\'has-error\': !regra.grupoVeiculo}" class="form-group"><select ng-model="regra.grupoVeiculo" ng-options="grupo.nome for grupo in $ctrl.getGruposVeiculo() track by grupo.id" class="form-control"><option value="" disabled="disabled" selected="selected" hidden="hidden">{{ \'ce.mapa.common.modal.agrupamentoRotogramas.placeholderSelecione\' | translate }}</option></select><div ng-if="!regra.grupoVeiculo" role="alert" class="help-block"><span>{{ \'ce.mapa.common.modal.campoObrigatorio\' | translate }}</span></div><div ng-if="$ctrl.cadastroRotogramaService.isRegraDuplicada(regra, $ctrl.agrupamento.regras)" role="alert" class="help-block"><span>{{ \'ce.mapa.common.modal.agrupamentoRotogramas.jaExisteRegra\' | translate }}</span></div></div></td><td class="col-md-4"><div class="form-group"><select ng-model="regra.tipoVeiculo" ng-options="tipo.nome for tipo in $ctrl.getTiposVeiculo() track by tipo.id" class="form-control"><option value="" disabled="disabled" selected="selected" hidden="hidden">{{ \'ce.mapa.common.modal.agrupamentoRotogramas.placeholderSelecione\' | translate }}</option></select></div></td><td class="col-md-3"><div ng-class="{\'has-error\': !regra.grupoVelocidade}" class="form-group"><select ng-model="regra.grupoVelocidade" ng-options="grupo.velocidade + \' Km/h\' for grupo in $ctrl.getGruposVelocidade() track by grupo.id" class="form-control"><option value="" disabled="disabled" selected="selected" hidden="hidden">{{ \'ce.mapa.common.modal.agrupamentoRotogramas.placeholderSelecione\' | translate }}</option></select><div ng-if="!regra.grupoVelocidade" role="alert" class="help-block"><span>{{ \'ce.mapa.common.modal.campoObrigatorio\' | translate }}</span></div></div></td><td class="col-md-1"><button ng-click="$ctrl.removerRegra(regra)" class="btn btn-remover-regra"><i class="fa fa-times"></i></button></td></tr></tbody></table><div class="controle-regras"><span ng-click="$ctrl.cadastroRotogramaService.adicionarRegra($ctrl.agrupamento)" class="adicionar-regra">+ {{ \'ce.mapa.common.modal.agrupamentoRotogramas.adicionarRegra\' | translate }}</span></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/pesquisa-ponto-referencia/pesquisa-ponto-referencia.tpl.html',
    '<div ng-mouseover="ctrl.pontosReferenciaMapService.map.dragging.disable()" ng-mouseleave="ctrl.pontosReferenciaMapService.map.dragging.enable()" class="pesquisa-filtro"><div ng-class="{\'hide-lista\': ctrl.pontosReferenciaFiltroService.selecionarFiltro || ctrl.mostrarResultado}" class="pesquisa"><div slimscroll="{railVisible: true, height: \'100%\', size: \'5px\'}"><div class="nav-tabs-custom"><ul ng-class="{\'two-tabs\': !ctrl.showBuscaPorRegiao()}" class="nav nav-tabs"><li ng-class="{\'active\': ctrl.pesquisaService.tabPontoReferencia}"><a href="#" ng-click="ctrl.setTabPontoReferencia()"><small>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.tabSeusLocais\' | translate }}</small><span ng-if="ctrl.pesquisaService.buscaPontoCerca.length &gt; 0" class="badget">{{\' (\' + ctrl.pesquisaService.buscaPontoCerca.length + \')\'}}</span></a></li><li ng-class="{\'active\': ctrl.pesquisaService.tabLogradouro}"><a href="#" ng-click="ctrl.setTabLogradouro()"><small>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.tabLogradouro\' | translate }}</small><span ng-if="ctrl.tabOnlyLogradouroEnabled() &amp;&amp; ctrl.pesquisaService.logradouros.length &gt; 0" class="badget">{{\' (\' + ctrl.pesquisaService.logradouros.length + \')\'}}</span></a></li><li ng-class="{\'active\': ctrl.pesquisaService.tabBuscaPorRegiao}" id="tab-busca-por-regiao" ng-if="ctrl.showBuscaPorRegiao()"><a href="#" ng-click="ctrl.setTabBuscaPorRegiao()"><small>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.tabPorRegiao\' | translate }}</small></a></li></ul></div><form name="formPesquisa" ng-if="!ctrl.pesquisaService.tabBuscaPorRegiao"><div class="form-box"><div ng-show="!ctrl.pesquisaService.tabBuscaPorRegiao" ng-class="{&quot;has-error&quot; : formPesquisa.pesquisa.$dirty &amp;&amp; formPesquisa.pesquisa.$error.minlength}" class="busca form-group input-group"><label ng-if="!ctrl.tabOnlyPontoReferencia()">{{ ctrl.getLabelMainInput() | translate }}</label><input name="pesquisa" type="text" placeholder="{{ ctrl.getPlaceHolderInput1() | translate }}" autocomplete="off" ng-required="true" ng-minlength="3" ng-model="ctrl.pesquisaService.pesquisa" ng-change="ctrl.validaPontos = true" class="form-control input-busca"/><p ng-show="(formPesquisa.pesquisa.$dirty &amp;&amp; formPesquisa.pesquisa.$error.minlength)" class="tabLogradouro-msg-form-box text-left help-block">{{ \'ce.mapa.common.modal.minlength3\' | translate }}</p></div><span ng-if="situacaoVeiculo.$invalid" class="help-block">{{ $ctrl.getMsgError(situacaoVeiculo.dataRetorno) }}</span></div><div ng-if="ctrl.pesquisaService.tabPontoReferencia" class="text-center mais-opcoes-padding"><a ng-click="ctrl.isCollapsed = !ctrl.isCollapsed" href="#">{{ ctrl.isCollapsed ? \'ce.mapa.common.modal.pesquisaPontoReferencia.ocultarFiltros\' : \'ce.mapa.common.modal.pesquisaPontoReferencia.verFiltros\' | translate }}</a></div><div uib-collapse="!ctrl.isCollapsed" ng-if="ctrl.pesquisaService.tabPontoReferencia" class="lista-filtros"><ul class="btn-group-vertical"><li ng-repeat="filtro in ctrl.pontosReferenciaFiltroService.filtrosDisponiveis" ng-click="ctrl.exibirFiltro(filtro)" class="btn btn-default">{{filtro.titulo}}<span><span ng-if="filtro.selecionado &amp;&amp; filtro.selecionado &gt; 0" class="badge bg-yellow">{{filtro.total - filtro.selecionado}} / {{filtro.total}}</span><span ng-if="!filtro.selecionado &amp;&amp; filtro.total &amp;&amp; filtro.total &gt; 0" class="badge bg-yellow">{{filtro.total}}</span><i class="fa fa-angle-right"></i></span></li></ul></div><span class="search-button"><button ng-click="ctrl.busca()" ng-disabled="!ctrl.formValido(formPesquisa)" class="btn btn-success search-label">{{ \'ce.mapa.common.tituloBtPesquisar\' | translate }}</button></span><p ng-show="ctrl.tabOnlyLogradouroEnabled()&amp;&amp; formPesquisa.pesquisa.$valid &amp;&amp; ctrl.pesquisaService.tabLogradouro &amp;&amp; !ctrl.validaPontos &amp;&amp; ctrl.pesquisaService.logradouros.length == 0" class="tabLogradouro-msg-form-box text-center">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.nenhumLogradouroEncontrado\' | translate }}</p><p ng-show="formPesquisa.pesquisa.$valid &amp;&amp; ctrl.pesquisaService.tabPontoReferencia &amp;&amp; !ctrl.validaPontoArea" class="tabLogradouro-msg-form-box text-center">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.nenhumLocalEncontrado\' | translate }}</p></form><form name="formBuscaPorRegiao" ng-if="ctrl.pesquisaService.tabBuscaPorRegiao &amp;&amp; ctrl.showBuscaPorRegiao()"><div class="form-box"><div ng-if="!ctrl.isAreaBuscaRegiaoCriada" class="busca text-center"><p ng-show="ctrl.buscaPorRegiaoMapService.isZoomInadequate">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.zoomRequerido\' | translate }}</p><button id="btn-desenha-area" ng-disabled="ctrl.buscaPorRegiaoMapService.isZoomInadequate" ng-click="ctrl.desenhaArea()">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.botaoDesenheArea\' | translate }}</button><p ng-show="!ctrl.buscaPorRegiaoMapService.isZoomInadequate">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.msgDesenheArea\' | translate }}</p></div><div ng-if="ctrl.isAreaBuscaRegiaoCriada" class="busca"><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.titulo\' | translate }}</strong><p>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.selecioneData\' | translate }}</p><div id="busca-regiao-dia" class="form-group"><label>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.inputData\' | translate }}<datepicker name="buscaRegiaoDia" model="ctrl.buscaRegiaoDia" required="true" options="ctrl.dateOptions"></datepicker></label></div><div class="text-center"><button type="button" ng-click="ctrl.buscaPorRegiaoCancel()" class="btn btn-default btn-cancelar">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.cancelar\' | translate }}</button><button type="button" ng-click="ctrl.buscaPorRegiao()" ng-disabled="!ctrl.formBuscaPorRegiaoValido(formBuscaPorRegiao)" class="btn btn-success search-label">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.botaoBuscar\' | translate }}</button></div></div></div></form><div ng-class="{&quot;resultado-com-filtro&quot; : ctrl.isCollapsed}" ng-show="ctrl.pesquisaService.buscaPontoCerca.length &gt; 0" ng-if="ctrl.pesquisaService.tabPontoReferencia" class="resultado"><div slimscroll="{railVisible: true, height: \'100%\', size: \'5px\'}"><ul class="list-group"><li ng-repeat="item in ctrl.pesquisaService.buscaPontoCerca | orderBy: &quot;!disabled&quot;" id="{{\'lista-area-ponto-pesquisa-\' + $index}}" ng-class="{\'disabled\': item.disabled}" uib-tooltip="{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.tooltipDesabilitadoViaFiltro\' | translate }}" tooltip-placement="left" tooltip-enable="{{item.disabled}}" class="list-group-item lista-resultado-pesquisa"><div ng-class="{\'busca-resultado-pesquisa-clicavel\': !item.disabled}" ng-click="!item.disabled &amp;&amp; ctrl.focusLocal(item)"><div><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoNome\' | translate }}</strong><span>{{item.entidade.nome}}</span></div><div><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoForma\' | translate }}</strong><i ng-class="item.type.id === ctrl.typePonto.id ? &quot;fa fa-map-marker&quot; : &quot;trimble-control-area&quot;"></i><span>&nbsp;{{item.type.label}}</span></div><div><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoCategoria\' | translate }}</strong><span>{{ctrl.getNomeCategoria(item)}}</span></div><div ng-if="item.type.id === ctrl.typePonto.id"><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoRaio\' | translate }}</strong><span>{{item.entidade.raio}} m</span></div><div ng-if="item.entidade.limiteVelocidade !== undefined"><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoLimiteVelocidade\' | translate }}</strong><span>{{item.entidade.limiteVelocidade}} km/h</span><div class="tipo-filtro"></div></div></div></li></ul></div></div><div ng-if="ctrl.pesquisaService.tabLogradouro" class="resultado"><div slimscroll="{railVisible: true, height: \'100%\', size: \'5px\'}"><ul class="list-group"><li ng-repeat="logradouro in ctrl.pesquisaService.logradouros" id="{{\'lista-logradouro-pesquisa-\' + $index}}" ng-class="{\'active\': $index == ctrl.logradouroIndex}" class="list-group-item lista-resultado-pesquisa"><div ng-click="ctrl.pontosReferenciaMapService.focusLogradouro(logradouro, $index)"><div><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoLogradouro\' | translate }}</strong><span>{{logradouro.logradouro}}</span></div><div><strong>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.resultadoCidade\' | translate }}</strong><span>{{logradouro.cidade}}, {{logradouro.uf}}</span></div></div></li></ul></div></div></div></div><div ng-show="ctrl.pontosReferenciaFiltroService.selecionarFiltro" ng-class="{\'show-filtro\': ctrl.pontosReferenciaFiltroService.selecionarFiltro}" class="filtro-selecionado"><h2 ng-click="ctrl.voltarLista()"><i class="fa fa-angle-left"></i>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.tituloFiltrar\' | translate }} {{ctrl.pontosReferenciaFiltroService.filtroSelecionado.titulo}}</h2><div class="resultado-filtro"><div slimscroll="{railVisible: true, height: \'100%\', size: \'5px\'}"><form name="formFiltro" ng-switch="ctrl.pontosReferenciaFiltroService.filtroSelecionado.tipo"><checkbox-ponto-referencia-directive ng-switch-when="checkbox"></checkbox-ponto-referencia-directive><input-ponto-referencia-directive ng-switch-when="input"></input-ponto-referencia-directive></form></div></div></div><div ng-show="ctrl.mostrarResultado" ng-class="{\'show-resultado\': ctrl.mostrarResultado}" class="busca-por-regiao container-fluid"><h2 ng-click="ctrl.voltarLista()"><i class="fa fa-angle-left"></i>{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.buscarTitulo\' | translate }}</h2><div class="input-search"><i class="fa fa-search"></i><input type="text" name="filtro" ng-model="ctrl.filtro" ng-minlength="2" placeholder="{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.placeholderBuscarVeiculo\' | translate }}" class="form-control regiao-filtro"/></div><div class="resultado-box"><div slimscroll="{railVisible: true, height: \'100%\', size: \'5px\'}" id="busca-por-regiao-resultado"><p ng-if="ctrl.pesquisaService.buscaPorRegiao.length === 0">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.nenhumResultado\' | translate }}</p><div ng-repeat="resultado in ctrl.pesquisaService.buscaPorRegiao | filter: ctrl.filtro track by $index" class="resultado-card"><div class="row"><div class="col-md-6">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.veiculo\' | translate }}</div><div class="col-md-6 text-right">{{ \'ce.mapa.common.modal.pesquisaPontoReferencia.buscaPorRegiao.dataPrimeiroReporte\' | translate }}</div></div><div class="row text-big"><div class="col-md-6"><a ng-href="{{ctrl.getLinkHistoricoDetalhado(resultado)}}" target="_blank">{{ resultado.prefixo + \'-\' +  resultado.placa }}</a></div><div class="col-md-6 text-right">{{ resultado.datahora | date: \'dd/MM/yyyy HH:mm\' }}</div></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/menu-map-control/menu-map-control.tpl.html',
    '<nav ng-class="[ctrl.pontosReferenciaMenuService.isDrawerOpen() ? \'pesquisa-ativo\' : \'pesquisa-inativo\', {\'sem-efeito\': ctrl.pontosReferenciaMenuService.menustate === \'open\' || ctrl.pontosReferenciaMenuService.menu === \'open\'}]" ng-if="ctrl.pontosReferenciaService.roleVisualizar || ctrl.cercaEletronicaService.roleVisualizar" mfb-menu="mfb-menu" menu-state="ctrl.pontosReferenciaMenuService.menustate" position="br" effect="slidein-spring" active-icon="{{ctrl.pontosReferenciaMenuService.buttonsPrincipal.active}}" resting-icon="{{ctrl.pontosReferenciaMenuService.buttonsPrincipal.resting}}" toggling-method="hover" class="map-overlay mfb-custom"><button ng-repeat="button in ctrl.pontosReferenciaMenuService.buttons track by button.titulo" mfb-button="mfb-button" icon="{{button.icon}}" label="{{ button.titulo | translate }}" ng-click="button.funcao() || ctrl.pontosReferenciaMenuService.setFABActive(button.tipo)" class="mfb-item-custom mfb-item-custom-{{button.color}}"></button></nav><div id="dialog-create-ponto"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/focus-ponto-referencia/focus-ponto-referencia-modal.tpl.html',
    '<div class="modal-header bg-yellow"><h3 class="modal-title">{{ \'ce.mapa.common.modal.focusPontoReferencia.titulo\' | translate }}</h3></div><div class="modal-body"><div class="alerta-aqui-categoria-ponto"></div><p><strong>{{ \'ce.mapa.common.modal.focusPontoReferencia.mensagem\' | translate }}</strong></p></div><div class="modal-footer"><button type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-default"> </button>{{ \'ce.mapa.common.modal.tituloBtOk\' | translate }}</div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/categoria-ponto-referencia/excluir-categoria-ponto-referencia.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title">{{ \'ce.mapa.common.modal.excluirCategoriaPonto.titulo\' | translate }}</h3></div><div class="modal-body"><div class="alerta-aqui-categoria-ponto-excluir"></div><p><strong>{{ \'ce.mapa.common.modal.excluirCategoriaPonto.mensagemConfirmacao\' | translate }}</strong></p><p>{{ $ctrl.model.nome }}</p></div><div class="modal-footer"><button type="button" ng-click="$ctrl.ok()" class="btn btn-danger">{{ \'ce.mapa.common.modal.excluirCategoriaPonto.tituloBtExcluir\' | translate }}</button><button type="button" ng-click="$ctrl.close()" class="btn btn-default">{{ \'ce.mapa.common.tituloBtCancelar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/categoria-ponto-referencia/cadastrar-categoria-ponto-referencia.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.titulo\' | translate }}<i ng-click="$ctrl.close()" class="pull-right fa fa-times-circle"></i></h3></div><form name="cadastroCategoriaPontoReferencia"><div class="modal-body modal-body-custom-ponto"><div class="alerta-aqui-categoria-ponto"><div class="row"><div class="col-md-12"><div class="form-group"><label for="uoSelecionadaPonto">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.labelUoSelecionada\' | translate }}</label><input type="text" id="uoSelecionadaPonto" name="uoSelecionadaPonto" value="{{$ctrl.uoSelecionada.nome}}" disabled="disabled" class="form-control"/></div></div></div><div class="row"><div class="col-md-12"><div ng-class="{\'has-error\':nomeCategoriaError()!==\'\'}" class="form-group"><label for="nome">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.labelNome\' | translate }}</label><input type="text" id="nome" name="nome" ng-required="true" ng-minlength="3" ng-model="$ctrl.model.nome" v3g-validator="nomeCategoriaError" placeholder="{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.placeholderNome\' | translate }}" autofocus="autofocus" class="form-control"/><span ng-if="nomeCategoriaError()!==\'\'" class="help-block">{{ nomeCategoriaError() | translate : \'{minCaracteres: 3}\' }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="tipo">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.labelTipo\' | translate }}</label><span class="opcional-field"></span><select id="tipo" name="tipo" ng-options="tipo.descricao for tipo in $ctrl.TIPOS_CATEGORIA track by tipo.id" ng-model="$ctrl.model.tipo" placeholder="{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.placeholderTipo\' | translate }}" class="form-control"><option value="">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.placeholderTipo\' | translate }}</option></select></div></div></div><div ng-if="$ctrl.hasVtalks &amp;&amp; $ctrl.temRegra" class="row"><div class="col-md-12"><div class="form-group"><label for="audio">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.labelAudiosAviso\' | translate }}</label><div class="flex"><input-checkbox name="check-audio" model="$ctrl.model.audioHabilitado" ng-click="$ctrl.changeAudioHabilitado()" class="inline"> </input-checkbox><span class="label-habilitar">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.spanHabilitar\' | translate }}<i uib-tooltip="{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.audioTooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></span></div><div ng-if="$ctrl.model.audioHabilitado" class="select-audio"><ui-select ng-model="$ctrl.model.audio" name="audio" id="audio" close-on-select="true"><ui-select-match placeholder="Buscar por áudio a ser falado">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="audio in ($ctrl.audios | filter: $select.search) track by audio.id"><span ng-bind-html="audio.nome | highlight: $select.search" uib-tooltip="{{audio.nome}}"></span></ui-select-choices></ui-select><span class="small-info">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.spanAudio\' | translate }}</span></div></div></div></div><div ng-class="{\'has-error\':corError()!==\'\'}" class="form-group"><div class="row"><div class="col-md-12">{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.labelCor\' | translate }}</div></div><div class="row"><div class="col-md-2"><div colorpicker="hex" ng-model="$ctrl.model.cor" style="background-color: {{$ctrl.model.cor}}" class="cor-ponto-categoria"></div></div><div class="col-md-10"><p>{{ \'ce.mapa.common.modal.cadastrarCategoriaPonto.alterarSelecionarCor\' | translate }}</p></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.close()" class="btn btn-default">{{ \'ce.mapa.common.tituloBtCancelar\' | translate }}</button><button type="submit" ng-click="$ctrl.ok()" ng-disabled="cadastroCategoriaPontoReferencia.$invalid" class="btn btn-success">{{ \'ce.mapa.common.tituloBtSalvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/cadastrar-ponto-referencia/editar-ponto-referencia.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.mapa.common.modal.editarPontoReferencia.titulo\' | translate }}<i ng-click="$ctrl.dismiss()" class="pull-right fa fa-times-circle"></i></h3></div><form name="formPontoReferencia"><div class="modal-body modal-body-custom-ponto"><div class="alerta-aqui-cadastro-ponto"><div class="row"><div ng-class="{\'col-md-6\': $ctrl.checkboxCadastrarRotograma, \'col-md-12\': !$ctrl.checkboxCadastrarRotograma}"><div class="row"><div ng-if="$ctrl.podeEditarUoDona" class="col-md-12"><div class="form-group"><label for="uo">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelUo\' | translate }}</label><ui-select style="width: 100%; height: 34px;" ng-model="$ctrl.uoSelecionada" close-on-select="true" name="uo" id="uo" ng-required="true" on-select="$ctrl.carregarCategorias($ctrl.uoSelecionada.id)"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'ce.mapa.common.modal.placeholderUo\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in $ctrl.uosFiltradas | filter: $select.search track by uo.id"><div style="padding-left: {{15 * uo.arvoreNivel}}px" ng-bind-html="uo.nome | highlight: $select.search"></div></ui-select-choices></ui-select><span ng-if="$ctrl.uo.$error.required &amp;&amp; $ctrl.uo.$dirty" class="help-block">{{ \'ce.mapa.common.modal.editarPontoReferencia.requiredUo\' | translate }}</span></div></div></div><div class="row"><div ng-class="$ctrl.temRoleEdicaoRotogramas ? \'col-md-6\' : \'col-md-12\'"><div ng-class="{\'has-error\': formPontoReferencia.nome.$touched &amp;&amp; formPontoReferencia.nome.$invalid}" class="form-group"><label for="nome">{{ \'ce.mapa.common.modal.labelNome\' | translate }}</label><input type="text" id="nome" name="nome" ng-required="true" ng-minlength="3" ng-model="$ctrl.model.nome" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderNome\' | translate }}" autofocus="autofocus" class="form-control"/><div ng-messages="formPontoReferencia.nome.$touched &amp;&amp; formPontoReferencia.nome.$error" role="alert" class="help-block"><span ng-message="required">{{ \'ce.mapa.common.modal.campoObrigatorio\' | translate }}</span><span ng-message="minlength">{{ \'ce.mapa.common.modal.nomeMinimoCaracteres\' | translate }}</span></div></div></div><div ng-if="$ctrl.temRoleEdicaoRotogramas" class="col-md-6"><div ng-class="{\'checked\': $ctrl.checkboxCadastrarRotograma}" class="checkbox-cadastro-rotograma form-group"><div class="checkbox"><label for="rotograma">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelRotograma\' | translate }}<input type="checkbox" id="rotograma" ng-model="$ctrl.checkboxCadastrarRotograma"/><span class="checkmark"></span></label></div></div></div></div><div ng-if="$ctrl.podeEditarUoDona" class="form-group"><div class="row"><div class="col-md-12"><label for="categoria">{{ \'ce.mapa.common.modal.labelCategoria\' | translate }}</label><span class="opcional-field"></span></div></div><div class="row"><div class="col-md-2"><div style="background-color: {{$ctrl.model.categoria.cor || &quot;#000&quot;}}" class="cor-ponto-categoria"></div></div><div class="col-md-8"><select id="categoria" name="categoria" ng-options="categoria.nome for categoria in $ctrl.model.categorias track by categoria.id" ng-model="$ctrl.model.categoria" placeholder="{{ \'ce.mapa.common.modal.placeholderCategoria\' | translate }}" class="form-control"><option></option></select></div><div class="col-md-2"><button type="button" ng-click="$ctrl.adicionarCategoria()" uib-tooltip="{{ \'ce.mapa.common.modal.editarPontoReferencia.tooltipCategoria\' | translate }}" tooltip-placement="top" class="btn btn-block btn-success"><i class="fa fa-plus"></i></button></div></div><div class="row"><div class="col-md-12"><a href="#" ng-click="$ctrl.mostrarCategorias()">{{ $ctrl.textoCategorias | translate }}</a></div></div></div><div ng-show="$ctrl.exibirCategorias" class="row"><div class="col-md-12 table-responsive"><div slimscroll="{railVisible: true, height: \'200px\'}"><table class="table table-hover table-bordered"><tr><th class="col-md-9">{{ \'ce.mapa.common.modal.editarPontoReferencia.headerNomeCategoria\' | translate }}</th><th class="col-md-3 text-center">{{ \'ce.mapa.common.modal.editarPontoReferencia.headerAcao\' | translate }}</th></tr><tr ng-repeat="categoria in $ctrl.model.categorias"><td>{{categoria.nome}}</td><td class="text-right"><button ng-click="$ctrl.editarCategoria(categoria.id)" type="button" uib-tooltip="{{ \'ce.mapa.common.modal.editarPontoReferencia.tooltipEditarCategoria\' | translate }} {{categoria.nome}}" tooltip-placement="top" style="margin-right: 10px;" class="btn btn-warning"><i class="fa fa-pencil-square-o"></i></button><button ng-click="$ctrl.excluirCategorias(categoria.id)" type="button" uib-tooltip="{{ \'ce.mapa.common.modal.editarPontoReferencia.tooltipExcluirCategoria\' | translate }} {{categoria.nome}}" tooltip-placement="top" class="btn btn-danger"><i class="fa fa-times"></i></button></td></tr></table></div></div></div><div class="row"><div class="col-md-4"><div ng-class="{\'has-error\':raioError()!==\'\'}" class="form-group"><label for="raio">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelRaio\' | translate }}</label><input type="number" id="raio" name="raio" ng-required="true" ng-minlength="2" min="10" max="2000" ng-min="10" ng-max="2000" pattern="^[0-9]{2,4}$" ng-model="$ctrl.model.raio" v3g-validator="raioError" v3g-mensagem="{{ \'ce.mapa.common.modal.editarPontoReferencia.raioInvalido\' | translate }}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderRaio\' | translate }}" class="form-control"/><span ng-if="raioError()!==\'\'" class="help-block">{{raioError() | translate : \'{valorMinimo: 10, valorMaximo: 2000}\'}}</span></div></div><div class="col-md-4"><div ng-class="{\'has-error\':latitudeError()!==\'\'}" class="form-group"><label for="latitude">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelLatitude\' | translate }}</label><input type="text" id="latitude" name="latitude" ng-required="true" pattern="^(\\+|-)?(?:89(?:(?:,0{1,15})?)|(?:[0-9]|[1-8][0-9])(?:(?:,[0-9]{1,15})?))$" ng-model="$ctrl.model.latitude" v3g-validator="latitudeError" v3g-mensagem="{{ \'ce.mapa.common.modal.editarPontoReferencia.latitudeInvalida\' | translate }}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderLatitude\' | translate }}" class="form-control"/><span ng-if="latitudeError()!==\'\'" class="help-block">{{latitudeError()}}</span></div></div><div class="col-md-4"><div ng-class="{\'has-error\':longitudeError()!==\'\'}" class="form-group"><label for="longitude">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelLongitude\' | translate }}</label><input type="text" id="longitude" name="longitude" ng-required="true" pattern="^(\\+|-)?(?:179(?:(?:,0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:,[0-9]{1,15})?))$" ng-model="$ctrl.model.longitude" v3g-validator="longitudeError" v3g-mensagem="{{ \'ce.mapa.common.modal.editarPontoReferencia.longitudeInvalida\' | translate }}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderLongitude\' | translate }}" class="form-control"/><span ng-if="longitudeError()!==\'\'" class="help-block">{{longitudeError()}}</span></div></div></div><div ng-if="$ctrl.config.habilitarSpeedLimit" class="row"><div class="col-md-12"><div ng-class="{\'has-error\':limiteVelocidadeError()!==\'\'}" class="form-group"><label for="limite-velocidade">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelLimiteVelocidade\' | translate }}</label><input type="number" id="limite-velocidade" name="limiteVelocidade" ng-required="false" ng-minlength="0" min="1" max="250" ng-min="1" ng-max="250" pattern="^[0-9]{0,3}$" ng-model="$ctrl.model.limiteVelocidade" v3g-validator="limiteVelocidadeError" v3g-mensagem="{{ \'ce.mapa.common.modal.editarPontoReferencia.limiteVelociadeInvalido\' | translate }}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderLimiteVelocidade\' | translate }}" class="form-control"/><span ng-if="limiteVelocidadeError()!==\'\'" class="help-block">{{limiteVelocidadeError() | translate : \'{valorMinimo: 1, valorMaximo: 250}\'}}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="observacao">{{ \'ce.mapa.common.modal.labelObservacao\' | translate }}</label><span class="opcional-field"></span><input type="text" id="observacao" name="observacao" ng-model="$ctrl.model.observacao" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderObservacao\' | translate }}" class="form-control"/></div></div></div><div ng-if="$ctrl.temRoleEditarPermanenciaPontoReferencia" class="row"><div class="col-xs-12"><div ng-class="{\'has-error\':tempoPermanenciaError()!==\'\'}" class="form-group tempo-permanencia-container"><div class="configurar-tempo-minimo"><label for="configurar-tempo-permanencia-minimo">{{ \'ce.mapa.common.modal.labelTempoPermanencia\' | translate }}</label><span class="opcional-field"></span><div class="checkbox"><label for="tempo-minimo-permanencia">{{ \'ce.mapa.common.modal.editarPontoReferencia.labelConfigurarTempo\' | translate }}<i uib-tooltip="{{ \'ce.mapa.common.modal.editarPontoReferencia.tooltipTempoPermanencia\' | translate }}" class="fa fa-info-circle fa-icon-top"></i><input type="checkbox" id="tempo-minimo-permanencia" ng-change="$ctrl.onChangeConfigTempoMinimo()" ng-model="$ctrl.configurarTempoMinimo"/><span class="checkmark"></span></label></div></div><div ng-class="{\'has-error\':tempoPermanenciaError()!==\'\'}" class="form-group"><div ng-show="$ctrl.configurarTempoMinimo" class="input-group"><input id="tempoPermanenciaMinimo" name="tempoPermanenciaMinimo" type="number" ng-model="$ctrl.model.tempoPermanenciaMinimo" ng-model-options="{allowInvalid: true}" ng-required="false" ng-min="3" min="3" ng-maxlength="6" maxlength="6" v3g-validator="tempoPermanenciaError" v3g-mensagem-expression="{{ $error.less3Minutes ? \'ce.mapa.common.modal.editarPontoReferencia.tempoAcima3Minutos\' : \'ce.mapa.common.modal.valorInvalido\' }}" ui-validate="{less3Minutes: $ctrl.tempoPermanenciaValid()}" placeholder="{{ \'ce.mapa.common.modal.editarPontoReferencia.placeholderTempoPermanencia\' | translate }}" class="form-control hide-spin"/><div class="input-group-addon">min</div></div><div ng-messages="formPontoReferencia.tempoPermanenciaMinimo.$touched &amp;&amp; formPontoReferencia.tempoPermanenciaMinimo.$error" role="alert" class="help-block"><span ng-message="min">{{ \'ce.mapa.common.modal.editarPontoReferencia.tempoAcima3Minutos\' | translate }}</span><span ng-message="maxlength">{{ \'ce.mapa.common.modal.valorInvalido\' | translate }}</span></div></div></div></div></div></div><div ng-if="$ctrl.checkboxCadastrarRotograma" class="col-md-6"><editor-rotogramas ponto-referencia="$ctrl.pontoReferencia" rotogramas="$ctrl.rotogramas" categoria="$ctrl.model.categoria" advisor-suggestion="$ctrl.suggestion"></editor-rotogramas></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.dismiss()" class="btn btn-default">{{ \'ce.mapa.common.tituloBtCancelar\' | translate }}</button><button type="submit" ng-disabled="formPontoReferencia.$invalid ||         ($ctrl.checkboxCadastrarRotograma &amp;&amp; !$ctrl.cadastroRotogramaService.isCadastroValido())" ng-click="$ctrl.ok()" class="btn btn-success">{{ \'ce.mapa.common.tituloBtSalvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/advisor-rotogramas/suggestion-card-component.tpl.html',
    '<div ng-class="{\'card-active\': $ctrl.suggestion.active}" class="suggestion-card-container advisor-list-suggestion-card row"><div class="col-md-12"><div class="title"> <span>{{ \'ce.mapa.common.modal.advisorRotogramas.suggestionDrawer.cardTitle\' | translate }} {{ $ctrl.index + 1}}</span></div></div><div class="col-md-12 dots-overflow info-card"><i class="fa fa-map-marker"></i><span>{{ $ctrl.getLogradouro() }}</span></div><div class="col-md-8 dots-overflow info-card"><i class="fa fa-exclamation-triangle"></i><span>{{ \'ce.mapa.common.modal.advisorRotogramas.suggestionDrawer.eventosBruscosLabel\' | translate | uppercase }}: </span><span>{{ $ctrl.getTotalEventosBruscos() }}</span></div><div class="col-md-4 dots-overflow info-card"><i class="trimble-speeding"></i><span>{{ $ctrl.getMinSpeed() | formatSpeedMeasure: $ctrl.userSpeedMeasurement }}</span></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/advisor-rotogramas/list-advisor-rotogramas-component.tpl.html',
    '<div class="list-advisor-rotogramas-container"><div class="label-advisor title">{{ \'ce.mapa.common.modal.advisorRotogramas.suggestionDrawer.title\' | translate }}</div><div class="horizontal-line"></div><div class="label-advisor sub-title">{{ \'ce.mapa.common.modal.advisorRotogramas.suggestionDrawer.subTitle\' | translate }}</div><div id="advisor-container"><div scroll-detector="$ctrl.loadMore()" class="cards-container"><div ng-repeat="suggestion in ($ctrl.suggestions | limitTo: $ctrl.limit) track by $index" class="suggestion-card-list-container"><suggestion-card id="{{\'advisor-list-suggestion-card-\' + $index}}" suggestion="suggestion" index="$index" ng-click="$ctrl.activeItem(suggestion)"></suggestion-card></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/advisor-rotogramas/btn-advisor-rotogramas-component.tpl.html',
    '<div id="advisor-button" class="aside-button-ui"><span ng-if="!$ctrl.active" class="qtd-sugestoes badge">{{ $ctrl.qtdSugestoesExibicao() }}</span><i ng-class="$ctrl.getIcon()" class="fa"></i></div><div ng-if="!$ctrl.active &amp;&amp; $ctrl.qtdSugestoes" class="featured-advisor"><img id="featured-advisor" src="https://vfleets-imagens.s3-sa-east-1.amazonaws.com/mapa/circle_pulse.gif"/></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/components/number/input-number.tpl.html',
    '<div ng-class="{&quot;has-error&quot;: form[name].$invalid}" class="input-number"><div class="input-group"><input ng-if="numberMask !== undefined" type="{{type}}" id="{{name}}" name="{{name}}" ng-model="$parent.model" ng-disabled="disabled" ng-required="enable" ui-number-mask="{{numberMask}}" maxlength="{{maxlength}}" max="{{max}}" min="{{min}}" ng-change="onChange()" class="form-control"/><input ng-if="numberMask === undefined" type="{{type}}" id="{{name}}" name="{{name}}" ng-model="$parent.model" ng-disabled="disabled" ng-required="enable" maxlength="{{maxlength}}" max="{{max}}" min="{{min}}" ng-change="onChange()" class="form-control"/><div class="input-group-addon">{{mask}}</div></div><span ng-if="enable &amp;&amp; form[name].$invalid &amp;&amp; form[name].$error.number" translate=" {{\'v3gwc.validacao.numeroInvalido\'}}" class="help-block"></span><span ng-if="enable &amp;&amp; form[name].$invalid &amp;&amp; form[name].$error.required" translate=" {{\'v3gwc.validacao.campoObrigatorio\'}}" class="help-block"></span><span ng-if="enable &amp;&amp; form[name].$invalid &amp;&amp; form[name].$error.max" translate=" {{\'component.inputNumber.valorMaximo\'}}" translate-values="{max: max}" class="help-block"></span><span ng-if="enable &amp;&amp; form[name].$invalid &amp;&amp; form[name].$error.min" translate=" {{\'v3gwc.validacao.valorMinimo\'}}" translate-values="{min: min}" class="help-block"></span><span ng-if="enable &amp;&amp; form[name].$invalid &amp;&amp; form[name].$error.maxlength &amp;&amp; maxlength" translate=" {{\'component.inputNumber.maximoCaracteres\'}}" translate-values="{maxlength: maxlength}" class="help-block"></span></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/components/checkbox/input-checkbox.tpl.html',
    '<div class="input-checkbox"><input id="{{name}}" type="checkbox" name="{{name}}" ng-change="change" ng-model="model" ng-disabled="disabled"/><label for="{{name}}"><i ng-class="{\'fa-square-o\': !model, \'text-muted\': disabled}" class="fa fa-check-square-o"></i></label></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/situacao/situacao-veiculo.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.cadastro.veiculos.modalSituacao.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form name="situacaoVeiculo"><div class="modal-body"><div class="row"><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: situacaoVeiculo.situacao.$dirty &amp;&amp; situacaoVeiculo.situacao.$invalid}" class="form-group"><select id="situacao" name="situacao" required="true" ng-options="situacao.nome for situacao in $ctrl.situacoesOption track by situacao.id" ng-model="$ctrl.situacaoSelected" class="form-control"><option value="">{{ \'ce.cadastro.veiculos.modalSituacao.optPadrao\' | translate }}</option></select><span ng-if="situacaoVeiculo.situacao.$dirty &amp;&amp; situacaoVeiculo.situacao.$invalid" class="help-block">{{ \'ce.cadastro.veiculos.modalSituacao.selecionarSituacao\' | translate }}</span></div><div ng-class="{\'has-error\': $ctrl.getMsgError(situacaoVeiculo.dataRetorno)}" ng-if="$ctrl.isSituacaoWithDataRetorno()" class="form-group"><label>{{ \'ce.cadastro.veiculos.modalSituacao.dataRetorno\' | translate }}</label><datepicker name="dataRetorno" model="$ctrl.dataRetorno" required="true" options="$ctrl.dateOptions"></datepicker><span ng-if="situacaoVeiculo.$invalid" class="help-block">{{ $ctrl.getMsgError(situacaoVeiculo.dataRetorno) }}</span></div></div></div><div ng-if="$ctrl.isSituacaoWithDataRetorno()" class="warning-message"> \n' +
    '{{ \'ce.cadastro.veiculos.modalSituacao.warningMessage\' | translate }}</div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.veiculos.modalSituacao.cancelar\' | translate }}</button><button ng-disabled="situacaoVeiculo.$invalid" ng-click="$ctrl.registrar()" class="btn btn-success">{{ \'ce.cadastro.veiculos.modalSituacao.confirmar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/qrcode/qrcode-veiculo.tpl.html',
    '<div id="qrcode-container"><div class="quadro-qrcode"><div ng-repeat="qrcode in ctrl.veiculosQrCode"><div class="qr-individual"><img ng-src="data:image/png;base64,{{qrcode.qrCodeBase64}}" width="120" height="120"/><p class="placa">PLACA: {{ qrcode.placa }}</p></div></div></div><div class="footer"><img ng-src="https://vfleets-imagens.s3.sa-east-1.amazonaws.com/logos/vfleets.png" width="85" height="20"/></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/editar-grupo/editar-grupo.tpl.html',
    '<div class="modal-header bg-green"><h3 id="modal-title" class="modal-title">{{ \'ce.cadastro.veiculos.modalAlterarGrupo.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><article class="box-body"><form name="editarGrupoForm" ng-class="{&quot;form-edicao-grupo&quot;: $ctrl.grupos.length &gt; 4 }"><div class="form-edicao-grupo-inner"><div ng-class="{&quot;has-error&quot;: editarGrupoForm.grupoDestino.$touched &amp;&amp; editarGrupoForm.grupoDestino.$invalid}" class="form-group"><label for="grupoDestino">{{ \'ce.cadastro.veiculos.modalAlterarGrupo.grupoDestino\' | translate }}</label><ui-select ng-model="$ctrl.grupoDestinoSelected" ng-disabled="$ctrl.selectInput.disable" name="grupoDestino" required="required" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{$ctrl.selectInput.text}}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="grupoDestino in ($ctrl.gruposDestino| filter: $select.search | limitTo: $ctrl.limitItensSelect) track by grupoDestino.id" scroll-detector="$ctrl.loadMoreItensSelect()"><span ng-bind-html="grupoDestino.nome | highlight: $select.search"></span><span ng-bind-html="grupoDestino.uo.nome | highlight: $select.search" class="id-grupo-select"></span></ui-select-choices></ui-select><span ng-if="editarGrupoForm.grupoDestino.$touched &amp;&amp; editarGrupoForm.grupoDestino.$invalid" class="help-block"> \n' +
    '{{ \'ce.cadastro.veiculos.modalAlterarGrupo.campoObrigatorio\' | translate }}</span><div class="aviso-operacao">{{ \'ce.cadastro.veiculos.modalAlterarGrupo.msgConfirmacao\' | translate }}</div></div></div></form></article><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.veiculos.modalAlterarGrupo.cancelar\' | translate }}</button><button type="button" ng-click="$ctrl.confirmaEdicao()" class="btn btn-success"> \n' +
    '{{ \'ce.cadastro.veiculos.modalAlterarGrupo.confirmar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/alerta-manutencao/alerta-manutencao.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.cadastro.veiculos.modalManutencao.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form name="alertaManutencao"><div class="modal-body"><section class="manutencao-km"><h4>{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.titulo\' | translate }}<span class="optional">&nbsp;- {{ \'ce.cadastro.veiculos.modalManutencao.opcional\' | translate }}</span></h4><div class="row"><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: alertaManutencao.intervalo.$dirty &amp;&amp; alertaManutencao.intervalo.$invalid}" class="form-group"><label for="intervalo"> \n' +
    '{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.intervaloManutencoes\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.intervaloTooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><div class="input-group"><input type="text" id="intervalo" name="intervalo" ui-number-mask="0" min="100" maxlength="11" placeholder="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.placeholder\' | translate }}" ng-model="$ctrl.intervalo" class="form-control"/><div class="input-group-addon">km</div></div><span ng-if="alertaManutencao.intervalo.$dirty &amp;&amp; alertaManutencao.intervalo.$invalid" class="help-block">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.margemIntervalo\' | translate }}</span></div></div><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: alertaManutencao.margem.$invalid}" class="form-group"><label for="margem">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.antecedenciaAlerta\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.antecedenciaTooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><div class="input-group"><input type="text" id="margem" name="margem" ui-number-mask="0" max="$ctrl.intervalo" maxlength="11" placeholder="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.placeholder\' | translate }}" ng-model="$ctrl.margem" class="form-control"/><div class="input-group-addon">km</div></div><span ng-if="alertaManutencao.margem.$invalid" class="help-block">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoKm.margemAntecedencia\' | translate }}</span></div></div><div class="col-md-12"><div class="alerta-aqui-manutencao"></div></div></div></section><section><header class="horimetro"><h4>{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.titulo\' | translate }}<span class="optional">&nbsp;- {{ \'ce.cadastro.veiculos.modalManutencao.opcional\' | translate }}</span></h4><span>{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.saoContabilizadas\' | translate }}</span></header><div class="row"><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: alertaManutencao.intervaloHorimetro.$dirty &amp;&amp; alertaManutencao.intervaloHorimetro.$invalid}" class="form-group"><label for="intervalo-horimetro"> \n' +
    '{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.intervaloManutencoes\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.intervaloTooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><div class="input-group"> <input type="text" id="intervalo-horimetro" name="intervaloHorimetro" ui-number-mask="0" min="10" maxlength="11" placeholder="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.placeholder\' | translate }}" ng-model="$ctrl.intervaloHorimetro" class="form-control"/><div class="input-group-addon">h</div></div><span ng-if="alertaManutencao.intervaloHorimetro.$dirty &amp;&amp; alertaManutencao.intervaloHorimetro.$invalid" class="help-block">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.margemIntervalo\' | translate }}</span></div></div><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: alertaManutencao.margemHorimetro.$invalid}" class="form-group"><label for="margem-horimetro">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.antecedenciaAlerta\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.antecedenciaTooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><div class="input-group"><input type="text" id="margem-horimetro" name="margemHorimetro" ui-number-mask="0" max="$ctrl.intervaloHorimetro" maxlength="11" placeholder="{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.placeholder\' | translate }}" ng-model="$ctrl.margemHorimetro" class="form-control"/><div class="input-group-addon">h</div></div><span ng-if="alertaManutencao.margemHorimetro.$invalid" class="help-block">{{ \'ce.cadastro.veiculos.modalManutencao.manutencaoHorimetro.margemAntecedencia\' | translate }}</span></div></div></div></section><div class="alerta-erro"></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.veiculos.modalManutencao.cancelar\' | translate }}</button><button ng-disabled="!$ctrl.podeSalvar()" ng-click="$ctrl.ok()" class="btn btn-success">{{ \'ce.cadastro.veiculos.modalManutencao.salvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/alerta-manutencao/alerta-manutencao-remove.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title">{{ \'ce.cadastro.veiculos.modalManutencao.remove.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><p ng-if="$ctrl.tipoRemocao === &quot;horimetro&quot;">{{ \'ce.cadastro.veiculos.modalManutencao.remove.descreveVeiculoHorimetro\' | translate }}<strong> {{$ctrl.veiculos.placa}} - {{$ctrl.veiculos.prefixo}}.</strong> {{ \'ce.cadastro.veiculos.modalManutencao.remove.confirmacao\' | translate }}</p><p ng-if="$ctrl.tipoRemocao === &quot;hodometro&quot;">{{ \'ce.cadastro.veiculos.modalManutencao.remove.descreveVeiculoHodometro\' | translate }}<strong> {{$ctrl.veiculos.placa}} - {{$ctrl.veiculos.prefixo}}.</strong> {{ \'ce.cadastro.veiculos.modalManutencao.remove.confirmacao\' | translate }}</p></div><div class="modal-footer"><button ng-click="$ctrl.delete()" class="btn btn-danger">{{ \'ce.cadastro.veiculos.modalManutencao.remove.sim\' | translate }}</button><button ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.veiculos.modalManutencao.remove.nao\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/ponto-referencia/tempo-permanencia/tempo-permanencia.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.title\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form name="tempoPermanencia" novalidate="novalidate" class="tempo-permanencia-relatorio-ponto"><div class="modal-body"><div class="row"><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: tempoPermanencia.tempo.$dirty &amp;&amp; tempoPermanencia.intervalo.$invalid}" class="form-group"><label for="tempo"> \n' +
    '{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.label\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.tooltip\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><input type="text" id="tempo" name="tempo" ui-number-mask="0" min="3" maxlength="7" required="required" placeholder="{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.placeholder\' | translate }}" ng-model="$ctrl.tempo" class="form-control"/><span ng-if="tempoPermanencia.tempo.$dirty &amp;&amp; tempoPermanencia.tempo.$invalid" class="help-block">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.invalid\' | translate }}</span></div></div><div class="col-md-12"><div class="alerta-aqui-manutencao"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.botaoCancelar\' | translate }}</button><button ng-disabled="tempoPermanencia.$invalid" ng-click="$ctrl.ok()" class="btn btn-success">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaModal.botaoSalvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/ponto-referencia/tempo-permanencia/tempo-permanencia-remove.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaRemoveModal.title\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><p>{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaRemoveModal.message\' | translate }}</p></div><div class="modal-footer"><button ng-click="$ctrl.ok(true)" class="btn btn-danger">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaRemoveModal.botaoSim\' | translate }}</button><button ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.pontosReferencia.tempoPermanenciaRemoveModal.botaoNao\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/ponto-referencia/codigo-integracao/codigo-integracao.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.label\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form name="codigoIntegracao" novalidate="novalidate" class="codigo-integracao-relatorio-ponto"><div class="modal-body"><div class="row"><div class="col-md-6"><div ng-class="{&quot;has-error&quot;: codigoIntegracao.codigo.$dirty &amp;&amp; codigoIntegracao.codigo.$invalid}" class="form-group"><label for="codigo"> \n' +
    '{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.label\' | translate }}<i uib-tooltip="{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.invalid\' | translate }}" class="fa-icon-left fa fa-info-circle"></i></label><input type="text" id="codigo" name="codigo" min="0" maxlength="200" required="required" placeholder="{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.placeholder\' | translate }}" ng-model="$ctrl.codigo" class="form-control"/><span ng-if="codigoIntegracao.codigo.$dirty &amp;&amp; codigoIntegracao.codigo.$invalid" class="help-block">{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.invalid\' | translate }}</span></div></div><div class="col-md-12"><div class="alerta-aqui-manutencao"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.common.botoesAcao.cancelar\' | translate }}</button><button ng-disabled="codigoIntegracao.$invalid" ng-click="$ctrl.updatePoints()" class="btn btn-success">{{ \'ce.common.botoesAcao.salvar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/ponto-referencia/codigo-integracao/codigo-integracao-remove.tpl.html',
    '<div class="modal-header bg-red"><h3 class="modal-title">{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.remover\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div class="modal-body"><p>{{ \'ce.cadastro.pontosReferencia.codigoIntegracaoModal.messageRemocao\' | translate }}</p></div><div class="modal-footer"><button ng-click="$ctrl.updatePoints(true)" class="btn btn-danger">{{ \'common.sim\' | translate }}</button><button ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'common.nao\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/grupo-veic/grupo-veic-formmodal/grupo-veic-formmodal.tpl.html',
    '<div class="modal-header bg-green"><h3 id="modal-title" class="modal-title">{{$ctrl.title}}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form name="grupoVeicForm" class="cadastro-grupo"><div ng-init="editarVeiculos = false" class="row"><div class="col-md-12"><div class="form-group"><div class="col-md-12 col-xs-12"><div ng-class="{\'has-error\': grupoVeicForm.uo.$invalid &amp;&amp; grupoVeicForm.uo.$touched}" class="form-group"><label for="uo" class="control-labfel">{{ \'ce.cadastro.grupoDeVeiculos.modal.uoLabel\' | translate }}</label><select-uo model="$ctrl.model" select-required="true" select-name="uo" select-disabled="$ctrl.grupo"></select-uo><div ng-if="grupoVeicForm.uo.$touched &amp;&amp; grupoVeicForm.uo.$error" class="help-block"><span ng-if="grupoVeicForm.uo.$error.required">{{ \'ce.cadastro.grupoDeVeiculos.modal.campoObrigatorio\' | translate }}</span></div></div><div ng-class="{\'has-error\': grupoVeicForm.nome.$invalid &amp;&amp; grupoVeicForm.nome.$touched}" class="form-group"><label for="nome">{{ \'ce.cadastro.grupoDeVeiculos.modal.nomeLabel\' | translate }}</label><input type="text" id="nome" name="nome" ng-model="$ctrl.model.nome" minlength="3" maxlength="40" required="required" class="form-control"/><div ng-if="grupoVeicForm.nome.$touched &amp;&amp; grupoVeicForm.nome.$error" class="help-block"><span ng-if="grupoVeicForm.nome.$error.required">{{ \'ce.cadastro.grupoDeVeiculos.modal.campoObrigatorio\' | translate }}</span><span ng-if="grupoVeicForm.nome.$error.minlength">{{ \'ce.cadastro.grupoDeVeiculos.modal.min3Caracteres\' | translate }}</span><span ng-if="grupoVeicForm.nome.$error.maxlength">{{ \'ce.cadastro.grupoDeVeiculos.modal.min40Caracteres\' | translate }}</span></div></div><div ng-class="{\'has-error\': grupoVeicForm.descricao.$invalid}" class="form-group"><label for="descricao">{{ \'ce.cadastro.grupoDeVeiculos.modal.descricaoLabel\' | translate }}</label><span>&nbsp;- {{ \'ce.cadastro.grupoDeVeiculos.modal.opcional\' | translate }}</span><input type="text" id="descricao" maxlength="150" name="descricao" ng-model="$ctrl.model.observacoes" class="form-control"/><div ng-if="grupoVeicForm.descricao.$error" class="help-block"><span ng-if="grupoVeicForm.descricao.$error.maxlength">{{ \'ce.cadastro.grupoDeVeiculos.modal.max150Caracteres\' | translate }}</span></div></div></div></div></div></div></form><div class="alerta-aqui-modal"></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.grupoDeVeiculos.modal.btnCancelar\' | translate }}</button><button type="button" ng-click="$ctrl.confirmar()" class="btn btn-success">{{ \'ce.cadastro.grupoDeVeiculos.modal.btnConfirmar\' | translate }}</button><a href="#" tooltip-enable="$ctrl.grupo.quantidadeVeiculosTotal" uib-tooltip="{{ \'ce.cadastro.grupoDeVeiculos.modal.tooltipExcluirGrupo\' | translate }}" ng-if="$ctrl.isGrupoCarregado" ng-click="$ctrl.removerGrupo()" ng-class="{&quot;excluir-grupo-desabilitado&quot;: $ctrl.grupo.quantidadeVeiculosTotal}" class="excluir-grupo">{{ \'ce.cadastro.grupoDeVeiculos.modal.excluirGrupo\' | translate }}</a></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/documentos/documentos.tpl.html',
    '<div id="table-documentos"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('video/video-player/multi-video-player.tpl.html',
    '<div id="video-player-container"></div><div id="decoratedVideoPage"> <div id="decoratedVideoPlayerModalContainer"></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/video-library/video-library.tpl.html',
    '<ui-view></ui-view>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/velocidade-rpm/velocidade-rpm.tpl.html',
    '<div class="alerta-absolute-tl"><div class="alerta-aqui"></div></div><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-body"><div class="row"><div id="grafico-velocidade-rpm" style="height: 78vh;" class="container"></div></div></div></div></div></div><nav mfb-menu="mfb-menu" position="br" effect="slidein-spring" active-icon="fa fa-cog" resting-icon="fa fa-cog" toggling-method="hover" class="mfb-custom mfb-custom-fixed"><button mfb-button="mfb-button" icon="fv trimble-speeding" label="{{ \'ce.analise.velocidadeXrpm.option.configurarLimitesVelocidade\' | translate }}" ng-click="velocidadeRpm.modalConfigurar()" id="speeding-icon" class="mfb-item-custom mfb-item-custom-default"></button></nav>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/velocidade-rpm/velocidade-rpm-config.tpl.html',
    '<div class="modal-header bg-light-blue"><h3 id="modal-title" class="modal-title">{{ \'ce.analise.velocidadeXrpm.option.modal.titulo\' | translate }}</h3></div><form ng-submit="$ctrl.validar()" class="form"><div class="modal-body"><p>{{ \'ce.analise.velocidadeXrpm.option.modal.informacao\' | translate }}</p><div class="form-group row"><label class="col-sm-6 col-form-label col-form-label-lg">{{ \'ce.analise.velocidadeXrpm.option.modal.limiarSuperior\' | translate }}</label><div class="col-sm-6"><input type="number" ng-model="$ctrl.limiarSuperior" required="required" max="200" min="{{$ctrl.limiarInferior}}" class="form-control"/></div></div><div class="form-group row"><label class="col-sm-6 col-form-label col-form-label-lg">{{ \'ce.analise.velocidadeXrpm.option.modal.limiarInferior\' | translate }} </label><div class="col-sm-6"><input type="number" ng-model="$ctrl.limiarInferior" required="required" max="200" min="0" class="form-control"/></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary">{{ \'ce.analise.velocidadeXrpm.option.modal.botaoAplicar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/saude-frota/saude-frota.tpl.html',
    '<div id="table-diagnosticos"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/risk-intelligence/risk-intelligence.tpl.html',
    '<div id="safety-app-risk-intelligence" ng-controller="RiskIntelligenceCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/risk-intelligence/risk-intelligence-detail.tpl.html',
    '<div id="safety-app-risk-intelligence-detail"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/ranking-safety/ranking-safety.tpl.html',
    '<vtabela ng-if="!!rankingSafety.vtabela" id="ranking-table" grid-options="rankingSafety.vtabela" analytics-category="Relatorios" analytics-label="Ranking Segurança"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/ranking-economy/ranking-economy.tpl.html',
    '<vtabela ng-if="!!rankingEconomy.vtabela" id="ranking-economico-table" grid-options="rankingEconomy.vtabela" analytics-category="Relatorios" analytics-label="Ranking Condução Econômica"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/permanencia-ponto/permanencia-ponto.tpl.html',
    '<vtabela ng-if="!!permanencia.vtabela" id="relatorio-permanencia" grid-options="permanencia.vtabela" analytics-category="Relatorios" analytics-label="Permanencia"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/ocorrencia-detalhes/ocorrencia-detalhes.tpl.html',
    '<div id="ocorrencia-detalhe"><div class="ocorrencia-detalhes row"><div class="lista col-sm-12 col-md-8"> <div scroll-detector="ctrl.loadMore()" class="cards">      <div ng-show="ctrl.requestError" class="request-error"> \n' +
    '{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDetalhes.erroBuscar\' | translate }}</div><div ng-show="!ctrl.requestError" class="ocorrencia-modal-content"><section>          <ocorrencia-dados item="ctrl.ocorrencia" ng-if="ctrl.ocorrencia"></ocorrencia-dados></section><div class="horizontal-line"></div><section class="sec-eventos"><div class="title">{{ \'ce.tempoReal.quadroDeOcorrencias.common.eventos\' | translate }}<br/></div><ocorrencia-eventos item="ctrl.ocorrencia" ng-if="ctrl.ocorrencia"></ocorrencia-eventos></section></div></div></div><div ng-class="{active: ctrl.isDrawerActive}" ng-click="ctrl.toggleDrawer()" class="detalhes-overlay"></div><div ng-class="{active: ctrl.isDrawerActive, reloaded: ctrl.isDetailsReloaded}" class="oc_detalhes"><div class="informacoes"><section class="historico"><h3>{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDetalhes.historico\' | translate }}</h3><ocorrencia-historico item="ctrl.ocorrencia" ng-if="ctrl.ocorrencia.hist"></ocorrencia-historico></section></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/movimento-veiculo/movimento-veiculo.tpl.html',
    '<vtabela ng-if="analiseOp.vtabela" id="analiseOp-table" grid-options="analiseOp.vtabela" analytics-category="Relatorios" analytics-label="Movimento do Veículo"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/identificacoes/identificacoes.tpl.html',
    '<div id="table-identificacoes"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/historico-solicitacao/historico-solicitacao.tpl.html',
    '<div class="alerta-aqui"></div><div class="alert alert-warning-opaco">{{ historicoSolicitacao.getWarningMessage() }}</div><v3g-table-limit-directive></v3g-table-limit-directive><div class="clearfix"></div><div ng-show="historicoSolicitacao.relatorioTable.length &gt; 0" class="box table-responsive"><table id="historico-solicitacao-table" st-table="historicoSolicitacao.relatorioTable" st-safe-src="historicoSolicitacao.relatorio" v3g-table-state="historicoSolicitacao.setTableState" class="table-historico-solicitacao table table-hover table-striped"><thead><tr><th id="historicoSolicitacao-dataHora-th" st-sort="dataHora" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.abertoEm\' | translate }}</th><th id="historicoSolicitacao-id-th" st-sort="id" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.pedidoNumero\' | translate }}</th><th id="historicoSolicitacao-uo-nome-th" st-sort="uo.nome" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.uoUpperCase\' | translate }}</th><th id="historicoSolicitacao-relatorio-th" st-sort="nomeRelatorio" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.relatorio\' | translate }}</th><th id="historicoSolicitacao-periodo-th" st-sort="periodoInicio" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.periodo\' | translate }}</th><th id="historicoSolicitacao-filtro-aplicado-th">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.filtroAplicado\' | translate }}</th><th id="historicoSolicitacao-status-th" st-sort="status.label" class="st-sort">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.status\' | translate }}</th><th id="historicoSolicitacao-progresso-th" ng-if="historicoSolicitacao.roleAdminVeltec">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.progresso\' | translate }}</th><th id="historicoSolicitacao-link-download-th">{{ \'ce.analise.solicitacoesAgendadas.tabela.header.linkParaDownload\' | translate }}</th><th id="historicoSolicitacao-acoes-th" ng-if="historicoSolicitacao.exibirColunaAcoes()"></th></tr></thead><tbody><tr ng-repeat="solicitacao in historicoSolicitacao.relatorioTable"><td>{{ solicitacao.dataCadastro | date: historicoSolicitacao.formatoData }}</td><td>{{ solicitacao.id }}</td><td>{{ solicitacao.uo.nome }}</td><td>{{ solicitacao.nomeRelatorio }}</td><td>{{ historicoSolicitacao.getPeriodo(solicitacao) }}</td><td><a id="historicoSolicitacao-ver-filtro" ng-click="historicoSolicitacao.modalFiltro(solicitacao.filtro, true, solicitacao.filtro.type)">{{ \'ce.analise.solicitacoesAgendadas.tabela.body.verFiltro\' | translate }}</a></td><td ng-class="solicitacao.status.class">{{ solicitacao.status.label | translate }}</td><td ng-class="solicitacao.progresso.class" ng-if="historicoSolicitacao.roleAdminVeltec">{{ solicitacao.progresso }}</td><td><span ng-if="!historicoSolicitacao.isExpirado(solicitacao)"><a id="historicoSolicitacao-fazer-download" ng-if="solicitacao.link" ng-click="historicoSolicitacao.download(solicitacao)"><i class="fa-icon-right fa fa-download"></i>{{ \'ce.analise.solicitacoesAgendadas.tabela.body.fazerDownload\' | translate }}</a><span ng-if="!solicitacao.link">-</span></span><span ng-if="historicoSolicitacao.isExpirado(solicitacao)">{{ \'ce.analise.solicitacoesAgendadas.tabela.body.expirado\' | translate }}</span></td><td ng-if="historicoSolicitacao.exibirColunaAcoes()"><a id="historicoSolicitacao-reportar-problema" ng-href="{{ solicitacao.miscInfo.linkPortal }}" target="_blank" ng-if="!historicoSolicitacao.isNa             &amp;&amp; !historicoSolicitacao.isExpirado(solicitacao)             &amp;&amp; solicitacao.status.id === historicoSolicitacao.status.CONCLUIDO.id"><i class="text-red fa-icon-right fa fa-exclamation"></i><span class="text-red">{{ \'ce.analise.solicitacoesAgendadas.tabela.body.reportarProblema\' | translate }}</span></a><a id="historicoSolicitacao-cancelar-pedido" ng-if="historicoSolicitacao.isCancelavel(solicitacao)" ng-click="historicoSolicitacao.modalCancelar(solicitacao)"><span class="text-red fa-icon-right fa fa-close"></span><span class="text-red">{{ \'ce.analise.solicitacoesAgendadas.tabela.body.cancelarPedido\' | translate }}</span></a></td></tr></tbody><tfoot><tr><td v3g-pagination="" st-select-page="historicoSolicitacao.currentPage" st-items-by-page="stItemsByPage" colspan="14" class="text-center"></td></tr></tfoot></table></div><nav id="historicoSolicitacao-fab" mfb-menu="mfb-menu" position="br" effect="slidein-spring" active-icon="fa fa-plus" resting-icon="fa fa-plus" toggling-method="hover" class="mfb-custom mfb-custom-fixed"><button id="historicoSolicitacao-nova-solicitacao" mfb-button="mfb-button" icon="fa fa-inbox" label="{{ \'ce.analise.solicitacoesAgendadas.botao.novaSolicitacao\' | translate }}" ng-if="historicoSolicitacao.hasSolucaoRequestReport" ng-click="historicoSolicitacao.modalFiltro()" class="mfb-item-custom mfb-item-custom-default"></button></nav>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/historico-ocorrencia/historico-ocorrencia.tpl.html',
    '<vtabela ng-if="!!historicoOcorrencia.vtabela" id="relatorio-ocorrencia" grid-options="historicoOcorrencia.vtabela" analytics-category="Relatorios" analytics-label="Histórico de Ocorrências"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/historico-comando/historico-comando.tpl.html',
    '<vtabela ng-if="ctrl.vtabela" id="historico-comando" grid-options="ctrl.vtabela" analytics-category="Relatorios" analytics-label="HistoricoComando"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/device-health/device-health.tpl.html',
    '<div id="safety-app-device-health" ng-controller="DeviceHealthCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/coaching/coaching.tpl.html',
    '<div id="safety-app-coaching" ng-controller="CoachingCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bdv/bdv.tpl.html',
    '<vtabela ng-if="!!bdv.vtabela" id="relatorio-bdv" grid-options="bdv.vtabela" analytics-category="Relatorios" analytics-label="BDV"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bds/bds.tpl.html',
    '<vtabela ng-if="!!bds.vtabela" id="relatorio-bdv" grid-options="bds.vtabela" analytics-category="Relatorios" analytics-label="BDS"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bds/bds-detalhes.tpl.html',
    '<div class="row"><div class="col-md-9"><div class="box box-primary"><div class="box-body"><div class="col-md-9 no-padding"><leaflet id="bds-map" tiles="bdsDetalhes.tiles" geojson="bdsDetalhes.geoJson" lf-center="bdsDetalhes.mapCenter" defaults="bdsDetalhes.defaults" event-broadcast="events" watch-markers="no" width="100%" height="500px"><map-control></map-control><map-layer-switcher on-layer-switch="bdsDetalhes.onLayerSwitch(layerWrapper)"></map-layer-switcher><toggle-layer-markers></toggle-layer-markers></leaflet><div ng-if="bdsDetalhes.segmentoSelecionado == null &amp;&amp; !bdsDetalhes.todosSegmentos" class="panel"><div id="bds-panel-erro" class="panel-body text-muted">{{ \'ce.boletim.servicos.servicosDetalhes.erroCarregarDetalhes\' | translate }}</div></div></div><div class="col-md-3 no-padding"><resumo-periodo titulo="bdsDetalhes.veiculos" subtitulo="bdsDetalhes.motoristas" duracao="bdsDetalhes.duracao" distancia="bdsDetalhes.distancia" logradouro-inicio="bdsDetalhes.logradouroInicio" logradouro-fim="bdsDetalhes.logradouroFim" conducoes="bdsDetalhes.resumoPeriodo" on-click-evento="bdsDetalhes.onClickTipoEvento" on-click-posicao="bdsDetalhes.onClickPosicao"></resumo-periodo></div></div></div></div><div class="col-md-3"><div class="box box-primary"><div ng-class="{\'bg-cinza\' : bdsDetalhes.todosSegmentos}" class="box-header with-border"><a href="" ng-click="bdsDetalhes.selecionarTodosSegmentos()"><h5 class="text-title box-title">{{ bdsDetalhes.titulo }}</h5></a></div><div class="box-body no-padding box-bds-segmentos"><div slimscroll="{railVisible: true, height: \'460px\'}"><ul class="nav nav-stacked"><li ng-repeat="row in bdsDetalhes.segmentos"><a href="" ng-click="bdsDetalhes.selecionarSegmento(row, $index)" id="segmento-{{$index}}"><span class="text-primary">{{ row.motorista }}</span><i ng-click="collapsed = !collapsed" ng-class="row.ativo ? \'fa fa-angle-up\' : \'fa fa-angle-down\'" class="pull-right"></i><small class="clearfix">{{ row.horario }}</small></a><div collapse="!row.ativo"><div class="row no-margin"><div class="col-md-6"><h5>{{ \'ce.boletim.servicos.servicosDetalhes.saiu\' | translate }}<i class="fa fa-arrow-up fa-rotate-45 red"></i></h5></div><div class="col-md-6"><h5>{{ \'ce.boletim.servicos.servicosDetalhes.entrou\' | translate }}<i class="fa fa-arrow-down fa-rotate-45 green"></i></h5></div></div><ul class="nav nav-stacked"><li ng-repeat="intervalo in row.intervalos" id="intervalos-{{$index}}" ng-class="intervalo.ativo ? [\'active\'] : \'\'" class="barra-lateral borda-branca"><a href="" ng-click="bdsDetalhes.selecionarIntervalo(row, intervalo)" class="pontos-executados-conteudo"><div class="row"><div class="col-md-6 col-xs-6"><small class="text clearfix">{{ intervalo.pontos[0].horario | date: \'HH:mm:ss\' }}</small><span class="text-primary">{{ intervalo.pontos[0].nome }}</span></div><div class="col-md-6 col-xs-6"><small class="text clearfix">{{ intervalo.pontos[1].horario | date: \'HH:mm:ss\' }}</small><span class="text-primary">{{ intervalo.pontos[1].nome }}</span></div></div></a></li></ul></div></li></ul></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bdm/bdm.tpl.html',
    '<vtabela ng-if="!!bdm.vtabela" id="relatorio-bdm" grid-options="bdm.vtabela" analytics-category="Relatorios" analytics-label="BDM"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/bdm/bdm-detalhes.tpl.html',
    '<div class="row"><div class="col-md-12"><div class="pdf-row"><a ng-click="bdmDetalhes.downloadPdf()" class="btn btn-primary btn-xs"><i class="fa fa-file-pdf-o fa-icon-right"></i>PDF</a></div></div><div id="bdm-detalhes"><div class="col-md-9"><div class="box box-primary"><div class="box-body"><div class="col-md-9 no-padding"><leaflet id="bdm-map" tiles="bdmDetalhes.tiles" geojson="bdmDetalhes.geoJson" lf-center="bdmDetalhes.mapCenter" defaults="bdmDetalhes.defaults" event-broadcast="events" watch-markers="no" width="100%" height="500px"><map-control id-mapa="&quot;bdm-map&quot;" ng-if="!bdmDetalhes.isDemo" on-init="bdmDetalhes.onMapControlInit()"></map-control><map-layer-switcher on-layer-switch="bdmDetalhes.onLayerSwitch(layerWrapper)"></map-layer-switcher><toggle-layer-markers></toggle-layer-markers></leaflet><div ng-if="bdmDetalhes.vigenciaSelecionada == null &amp;&amp; !bdmDetalhes.todasVigencias" class="panel"><div id="bdm-panel-erro" class="panel-body text-muted">{{ \'ce.boletim.diarioMotoristaDetalhes.msgErro\' | translate }}.</div></div></div><div class="col-md-3 no-padding"><resumo-periodo titulo="bdmDetalhes.motorista" subtitulo="bdmDetalhes.veiculos" duracao="bdmDetalhes.duracao" distancia="bdmDetalhes.distancia" logradouro-inicio="bdmDetalhes.logradouroInicio" logradouro-fim="bdmDetalhes.logradouroFim" conducoes="bdmDetalhes.resumoPeriodo" consumo-combustivel="bdmDetalhes.consumoCombustivel" media-consumo="bdmDetalhes.mediaConsumo" consumo-eletrico="bdmDetalhes.consumoEletrico" media-consumo-eletrico="bdmDetalhes.mediaConsumoEletrico" on-click-evento="bdmDetalhes.onClickTipoEvento" on-click-posicao="bdmDetalhes.onClickPosicao" faixas-descida="bdmDetalhes.faixasDescida" diferenca-altitude="bdmDetalhes.diferencaAltitude"></resumo-periodo></div></div></div></div><div id="decoratedVideoPlayerModalContainer" class="bdm-decorated-video-player"></div><div class="col-md-3"><div id="box-lateral-bdx" class="box box-primary"><div ng-class="{\'bg-cinza\' : bdmDetalhes.todasVigencias}" class="box-header with-border"><a href="" ng-click="bdmDetalhes.selecionarTodasVigencias()"><h3 id="vigencias-title" class="box-title">{{ \'ce.boletim.diarioMotoristaDetalhes.vigencias\' | translate }}</h3></a><small class="clearfix"><i class="fa fa-calendar margin-r-5"></i>{{ bdmDetalhes.inicio | date:bdmDetalhes.dateTimeFormat }}\n' +
    '- {{ bdmDetalhes.duracaoTotal | humanizedDuration }}</small><div class="box-tools"><button data-widget="collapse" class="btn btn-box-tool btn-box-bd"><i class="fa fa-minus"></i></button></div></div><div class="box-body no-padding box-bdm-vigencias"><div slimscroll="{railVisible: true, height: \'460px\'}"><ul class="nav nav-stacked"><li ng-repeat="row in bdmDetalhes.detalhes" ng-class="row.vigencia == bdmDetalhes.vigenciaSelecionada || bdmDetalhes.todasVigencias ? [\'active\'] : \'\'"><a href="" ng-click="bdmDetalhes.selecionarVigencia(row.vigencia)" id="vigencia-{{$index}}"><span class="text-primary">{{ row.vigencia.veiculo }}</span><p>{{ row.vigencia.inicio | date:\'HH:mm:ss\' }}\n' +
    '- {{ row.vigencia.fim ? (row.vigencia.fim | date:\'HH:mm:ss\') : \'vigente\' }}</p></a></li></ul></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/abastecimento/abastecimento.tpl.html',
    '<vtabela ng-if="!!abastecimento.vtabela" id="relatorio-abastecimento" grid-options="abastecimento.vtabela" analytics-category="Relatorios" analytics-label="Abastecimento"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ranking/pontos/pontos.tpl.html',
    '<vtabela ng-if="rankingPontos.vtabela" id="ranking-pontos" grid-options="rankingPontos.vtabela" analytics-category="Relatorios" analytics-label="Ranking Pontos"></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ranking/infracoes/infracoes.tpl.html',
    '<div class="ranking-infracoes row"><div class="lista col-sm-12 col-md-8"><div class="settings"><label for="ordenacao">{{ \'ce.tempoReal.infracoes.common.classificarPor\' | translate }}</label><select name="ordenacao" ng-model="rankingInfracoes.orderBy" ng-options="value for (key, value) in rankingInfracoes.orders" ng-change="rankingInfracoes.infracoes = rankingInfracoes.ranquear(rankingInfracoes.infracoes)"></select></div><div class="ranking-header row hidden-xs"><div class="header-line"><div class="col-sm-9 col-sm-offset-1"><div class="col-sm-4 text-bold">{{ \'ce.tempoReal.infracoes.common.motorista\' | translate }}</div><div class="col-sm-4 text-bold">{{ \'ce.tempoReal.infracoes.common.veiculo\' | translate }}</div><div class="col-sm-4 text-bold">{{ \'ce.tempoReal.infracoes.common.uoUpperCase\' | translate }}</div></div><div ng-if="rankingInfracoes.orderBy !== rankingInfracoes.orders.PONTUACAO" class="col-sm-2 text-bold header-pontos">{{ \'ce.tempoReal.infracoes.common.naoTratadosTotal\' | translate }}</div><div ng-if="rankingInfracoes.orderBy === rankingInfracoes.orders.PONTUACAO" class="col-sm-2 text-bold">{{ \'ce.tempoReal.infracoes.common.totalPontos\' | translate }}</div></div></div><div scroll-detector="rankingInfracoes.loadMore()" class="cards"><div ng-repeat="item in rankingInfracoes.infracoes | orderBy:\'-ranking\' | limitTo: rankingInfracoes.limit track by item.id" ng-click="rankingInfracoes.loadDetails(item.id) || rankingInfracoes.toggleDrawer()" ng-class="{active: item.id === rankingInfracoes.details.id, reloaded: rankingInfracoes.isItemReloaded(item.id)}" ng-init="$first &amp;&amp; rankingInfracoes.details === null &amp;&amp; rankingInfracoes.loadDetails(item.id)" class="item clearfix"><div class="col-sm-1 col-xs-6 ranking">{{ item.ranking }}º</div><div class="visible-xs col-xs-6"><div class="pull-right"><span class="pontos-badge"><span ng-if="rankingInfracoes.orderBy !== rankingInfracoes.orders.PONTUACAO">{{ rankingInfracoes.formatar(item.totalPontuacao - item.totalResolvido) }} / </span><span ng-class="{opacidade: rankingInfracoes.orderBy !== rankingInfracoes.orders.PONTUACAO}">{{ rankingInfracoes.formatar(item.totalPontuacao) }}</span></span></div></div><div class="col-sm-9 col-xs-12"><div class="col-sm-4 col-xs-12">{{ item.hasOwnProperty("motorista") ? item.motorista.nome : rankingInfracoes.naoIdentificado }}</div><div class="col-sm-4 col-xs-12">{{ item.veiculo.prefixo }} - {{ item.veiculo.placa }}</div><div class="col-sm-4 col-xs-12">{{ item.veiculo.uo.nome }}</div></div><div class="col-sm-2 hidden-xs text-center"><span class="pontos-badge"><span ng-if="rankingInfracoes.orderBy !== rankingInfracoes.orders.PONTUACAO">{{ rankingInfracoes.formatar(item.totalPontuacao - item.totalResolvido) }} / </span><span ng-class="{opacidade: rankingInfracoes.orderBy !== rankingInfracoes.orders.PONTUACAO}">{{ rankingInfracoes.formatar(item.totalPontuacao) }}</span></span></div></div></div></div><div ng-class="{active: rankingInfracoes.isDrawerActive}" ng-click="rankingInfracoes.toggleDrawer()" class="detalhes-overlay"></div><div ng-class="{active: rankingInfracoes.isDrawerActive, reloaded: rankingInfracoes.isDetailsReloaded}" class="detalhes"><div class="motorista"><div class="informacoes"><h5 class="text-bold">{{ rankingInfracoes.details.hasOwnProperty("motorista") ? rankingInfracoes.details.motorista.nome : rankingInfracoes.motoristaNaoIdentificado }}</h5><p>{{ rankingInfracoes.details.veiculo.placa }} - {{ rankingInfracoes.details.veiculo.uo.nome }}</p></div><div uib-dropdown="uib-dropdown" dropdown-append-to-body="dropdown-append-to-body" class="opcoes dropdown-motorista"><a href="href" uib-dropdown-toggle="uib-dropdown-toggle"><i class="fa fa-ellipsis-v"></i></a><ul uib-dropdown-menu="uib-dropdown-menu" class="dropdown-menu-right dropdown-menu dropdown-motorista"><li><a href="#" ng-click="rankingInfracoes.openAcoesModal(\'resolver\')">{{ \'ce.tempoReal.infracoes.botoes.resolverTodos\' | translate }}</a></li><li><a href="#" ng-click="rankingInfracoes.openAcoesModal(\'atribuir\')">{{ \'ce.tempoReal.infracoes.botoes.atribuirTodos\' | translate }}</a></li><li><a ng-href="{{rankingInfracoes.getLinkHistoricoDetalhado()}}">{{ \'ce.tempoReal.infracoes.botoes.irParaHistoricoDetalhado\' | translate }}</a></li></ul></div></div><div class="infracoes"><div ng-repeat="item in rankingInfracoes.details.pontuacoes"><div ng-click="rankingInfracoes.collapseAlerta = rankingInfracoes.collapseAlerta !== item.tipoAlerta ? item.tipoAlerta : null" class="infracao"><div ng-class="{active: item.total === item.resolvido}" class="overlay">{{ \'ce.tempoReal.infracoes.common.tratado\' | translate }}</div><div class="evento"> <span class="icone-badge"><i ng-class="rankingInfracoes.getClasseIcone(item.tipoAlerta)" class="icon"></i></span>{{ rankingInfracoes.getAlertaDescricao(item.tipoAlerta) }}</div><div class="pontos"><span class="pontos-badge">{{ rankingInfracoes.formatar(item.total) }}</span></div><div uib-dropdown="uib-dropdown" dropdown-append-to-body="dropdown-append-to-body" is-open="rankingInfracoes.dropdownMenuAcoes === item.tipoAlerta" class="opcoes dropdown-motorista"><a href="href" ng-click="rankingInfracoes.toggleDropdownMenuAcoes(item.tipoAlerta, $event)"><i class="fa fa-ellipsis-v"></i></a><ul uib-dropdown-menu="uib-dropdown-menu" class="dropdown-menu-right dropdown-menu dropdown-motorista"><li><a href="#" ng-click="rankingInfracoes.openAcoesModal(\'resolver\', item.tipoAlerta)">{{ \'ce.tempoReal.infracoes.botoes.resolverTodos\' | translate }}</a></li><li><a href="#" ng-click="rankingInfracoes.openAcoesModal(\'atribuir\', item.tipoAlerta)">{{ \'ce.tempoReal.infracoes.botoes.atribuirTodos\' | translate }}</a></li><li><a ng-href="{{rankingInfracoes.getLinkHistoricoDetalhado(item.tipoAlerta)}}">{{ \'ce.tempoReal.infracoes.botoes.irParaHistoricoDetalhado\' | translate }}</a></li></ul></div></div><div uib-collapse="rankingInfracoes.collapseAlerta !== item.tipoAlerta" class="collapse alertas-detalhes"><div ng-repeat="alerta in rankingInfracoes.alertasDetalhados[item.tipoAlerta] | orderBy:\'datahora\'" ng-class="{ \'alerta-sem-intensidade\': !rankingInfracoes.isIntensidadeValida(alerta.intensidade) }" class="alerta-detalhes"><div ng-class="{active: alerta.resolvido}" class="overlay"><div class="col-xs-3">{{ \'ce.tempoReal.infracoes.common.tratado\' | translate }}</div></div><div ng-class="{\'alerta-resolvido\': alerta.resolvido &amp;&amp; rankingInfracoes.isIntensidadeValida(alerta.intensidade)}" class="intensidade-alerta-container"><span class="intensidade-alerta">{{ alerta.intensidade ? rankingInfracoes.formatar(alerta.intensidade, 2) : \'-\' }} </span>{{ alerta.unidadeExcesso }}</div><div ng-class="{\'alerta-resolvido\': alerta.resolvido &amp;&amp; !rankingInfracoes.isIntensidadeValida(alerta.intensidade)}" class="dados-alerta"><span><i class="fa fa-map-marker"></i>{{ alerta.logradouro || \'-\' }}</span><div><span class="icone-inline"><i class="fa fa-exclamation"></i>{{ \'ce.tempoReal.infracoes.common.limite\' | translate }}: {{ alerta.limiar ? (rankingInfracoes.formataLimiar(alerta) + \' \' + (alerta.unidadeExcesso || \'\')) : \'-\' }}</span><span><i class="fa fa-clock-o"></i>{{ (alerta.datahora | date: \'HH:mm\') || \'-\' }}</span></div><span ng-if="rankingInfracoes.hasVideo(alerta) || rankingInfracoes.hasSnapshot(alerta)"><event-viewer-link id-video="{{alerta.videoId}}" snapshot-id="{{alerta.snapshotId}}" datahora="{{alerta.datahora}}" latitude="{{alerta.latitude}}" longitude="{{alerta.longitude}}" vehicle-id="{{rankingInfracoes.details.veiculo.id}}" vehicle-prefix="{{rankingInfracoes.details.veiculo.prefixo}}" vehicle-plate="{{rankingInfracoes.details.veiculo.placa}}" driver-name="rankingInfracoes.details.hasOwnProperty(\'motorista\') ? rankingInfracoes.details.motorista.nome : rankingInfracoes.motoristaNaoIdentificado" tipo-evento="{{alerta.tipo}}" status-video="alerta.statusVideo" ng-click="rankingInfracoes.onVideoClick()" class="infracoes-video-play-button"></event-viewer-link></span></div><div class="pontos"><tag-ignore alert="alerta.tagIgnoreAlert" size="medium" position="left"></tag-ignore><span class="pontos-badge">{{ rankingInfracoes.formatar(alerta.pontuacao.total) }}</span></div></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ranking/infracoes/acoes-alerta.html',
    '<div class="modal-acoes-ranking-infracoes"><div class="modal-header"><h4 class="modal-title">{{ acoesAlertaModal.getTitulo() }}</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.motorista\' | translate }}</label><div class="col-sm-10"><p class="form-control-static">{{ acoesAlertaModal.details.hasOwnProperty("motorista") ? acoesAlertaModal.details.motorista.nome : acoesAlertaModal.motoristaNaoIdentificado }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.veiculo\' | translate }}</label><div class="col-sm-10"><p class="form-control-static">{{ acoesAlertaModal.details.veiculo.placa }} - {{ acoesAlertaModal.details.veiculo.prefixo }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.uoUpperCase\' | translate }}</label><div class="col-sm-10"><p class="form-control-static">{{ acoesAlertaModal.details.veiculo.uo.nome }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.alerta\' | translate }}</label><div class="col-sm-10"><p class="form-control-static">{{ acoesAlertaModal.getAlertaDescricao() }}</p></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.acao\' | translate }}</label><div class="col-sm-7"><select ng-model="acoesAlertaModal.status" ng-options="key as value for (key, value) in acoesAlertaModal.statusType" class="form-control"></select></div></div><div ng-show="acoesAlertaModal.status === \'atribuir\'" class="form-group"><label class="col-sm-2 control-label">{{ \'ce.tempoReal.infracoes.common.usuario\' | translate }}</label><div class="col-sm-7"><select ng-model="acoesAlertaModal.usuario" ng-options="usuario.login for usuario in acoesAlertaModal.usuarios" class="form-control"></select></div></div></form></div><div class="modal-footer"><div ng-show="acoesAlertaModal.alerta.length &gt; 0" class="alert alert-danger text-left">{{ acoesAlertaModal.alerta }}</div><button type="button" id="cancelar" ng-click="acoesAlertaModal.fechar()" class="btn btn-default">{{ \'ce.tempoReal.infracoes.botoes.cancelar\' | translate }}</button><button type="button" id="salvar" ng-click="acoesAlertaModal.salvar()" class="btn btn-primary">{{ \'ce.tempoReal.infracoes.botoes.salvar\' | translate }}</button></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('quadro-ocorrencias/ocorrencia-modal/ocorrencia-modal.tpl.html',
    '<div id="ocorrencia-modal"><div ng-class="$ctrl.requestError ? &quot;bg-red&quot; : &quot;bg-green&quot;" class="modal-header"><h3 id="modal-title" class="modal-title">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.titulo" | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle close-modal"></i></h3></div><div ng-show="$ctrl.requestError" class="request-error">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.erroBuscarOcorrencia" | translate }}</div><div ng-show="!$ctrl.requestError" class="ocorrencia-modal-content"><section><ocorrencia-dados item="$ctrl.ocorrencia" ng-if="$ctrl.ocorrencia">     </ocorrencia-dados></section><div class="horizontal-line info-line"></div><section class="sec-eventos"><div class="title">{{ "ce.tempoReal.quadroDeOcorrencias.common.eventos" | translate }}<br/></div><ocorrencia-eventos item="$ctrl.ocorrencia" ng-if="$ctrl.ocorrencia"></ocorrencia-eventos><div class="horizontal-line"></div></section><section class="tratativa"><div class="title">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.tratativa" | translate }}</div><form name="formTratativa" class="form"><div class="row"><div class="col-sm-4"><div class="form-group"><span>{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.statusDaOcorrencia" | translate }}&nbsp;</span><i uib-tooltip="{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.statusDaOcorrenciaTooltip\' | translate }}" class="fa fa-info-circle"></i><ui-select ng-model="$ctrl.model.status" ng-change="formTratativa.responsavel.$validate()" name="status" ng-disabled="$ctrl.isDisabled()" close-on-select="true" class="ui-select-white"><ui-select-match>{{$select.selected.descricao | translate }}</ui-select-match><ui-select-choices repeat="status in ($ctrl.selectStatus | filter: $select.search) track by status.id"><span ng-bind-html="status.descricao | translate | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-sm-8"><div ng-class="{\'has-error\': formTratativa.responsavel.$invalid}" class="form-group"><label for="responsavel">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.responsavel" | translate }}</label><ui-select ng-model="$ctrl.model.responsavel" name="responsavel" ng-disabled="$ctrl.isDisabled()" ui-validate="{responsavelValido: $ctrl.responsavelValidate(formTratativa.responsavel)}" close-on-select="true" class="ui-select-white"><ui-select-match>{{$select.selected.login}}</ui-select-match><ui-select-choices repeat="usuario in ($ctrl.usuarios | filter: $select.search | limitTo: $ctrl.limitScroll) track by usuario.id" scroll-detector="$ctrl.loadMore()"><span ng-bind-html="usuario.login | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-if="formTratativa.responsavel.$invalid" class="help-block">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.responsavelObrigatorio" | translate }}</div></div></div><div class="col-sm-12"><div class="form-group"><span>{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.observacao" | translate }}</span><textarea ng-disabled="$ctrl.isDisabled()" rows="2" name="obs" id="obs" ng-model="$ctrl.model.obs" class="form-control"></textarea></div></div></div></form><div ng-if="$ctrl.showHistorico()" class="horizontal-line"></div></section><section ng-if="$ctrl.showHistorico()" class="historico"><div class="title">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.historico" | translate }}</div><ocorrencia-historico item="$ctrl.ocorrencia" ng-if="$ctrl.ocorrencia.hist"></ocorrencia-historico><div ng-if="$ctrl.ocorrenciasAnexo.length" class="anexos"><div class="row"><div class="col-sm-6"><div class="icon-anexo pull-left"><i class="v-veltec-simbolo"></i></div><div class="pull-left"><strong>{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.anexos" | translate }}</strong></div></div><div class="col-sm-6 text-right"><span class="data-hora">{{ $ctrl.ocorrencia.dataHora | date:\'dd/MM/yyyy\' }} \n' +
    '{{ "ce.tempoReal.quadroDeOcorrencias.common.as" | translate }}\n' +
    '{{ $ctrl.ocorrencia.dataHora | date:\'HH:mm\' }}</span></div></div><div class="row"><div ng-repeat="ocorrAnexo in $ctrl.ocorrenciasAnexo" class="col-sm-12"><span ng-click="$ctrl.abreOcorrenciaAnexo(ocorrAnexo)" class="ocorr-hist">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.ocorrenciaAnterior" | translate }}\n' +
    '({{ ocorrAnexo.dataHora | date:\'dd/MM/yyyy\' }} \n' +
    '{{ "ce.tempoReal.quadroDeOcorrencias.common.as" | translate }} \n' +
    '{{ ocorrAnexo.dataHora | date:\'HH:mm\' }})</span></div></div></div></section></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.botaoCancelar" | translate }}</button><button type="button" ng-disabled="!$ctrl.formChanged()" ng-click="$ctrl.salvar()" ng-show="!$ctrl.requestError" class="btn btn-success">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.botaoSalvar" | translate }}</button><button type="button" ng-click="$ctrl.cancel()" ng-show="$ctrl.requestError" class="btn btn-danger">{{ "ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.botaoOK" | translate }}</button></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('quadro-ocorrencias/ocorrencia-card/ocorrencia-card.tpl.html',
    '<div id="ocorrencia-card" data-testid="quadro-ocorrencia-card-{{ $ctrl.ocorrencia.veiculo | prefixoPlaca}}"><div class="row header-card-occ"><div class="col-md-5 col-sm-12 pull-right col-xs-12 text-right"><span data-testid="quadro-ocorrencia-card-datahora" class="data-gerada">{{ \'ce.tempoReal.quadroDeOcorrencias.common.gerada\' | translate }}\n' +
    '{{ $ctrl.ocorrencia.dataHora | date: $ctrl.getDateFormat() }}\n' +
    '{{ \'ce.tempoReal.quadroDeOcorrencias.common.as\' | translate }}\n' +
    '{{ $ctrl.ocorrencia.dataHora | date:\'HH:mm\' }}</span></div><div class="col-md-7 col-sm-12 col-xs-12 dots-overflow"><span uib-tooltip="{{$ctrl.ocorrencia.veiculo | prefixoPlaca}}" data-testid="quadro-ocorrencia-card-placa-{{$ctrl.ocorrencia.veiculo | prefixoPlaca}}-value" class="veiculo">{{ $ctrl.ocorrencia.veiculo | prefixoPlaca }}</span></div><div class="col-md-7 col-sm-12 col-xs-12 uo dots-overflow"><span class="trimble-ou"></span><span data-testid="quadro-ocorrencia-card-uo-value" class="uo-nome">{{ $ctrl.ocorrencia.veiculo.uo.nome | uppercase }}</span></div><div class="linha-card"></div></div><div ng-if="$ctrl.ocorrencia.usuarioAtribuido" class="row"><div class="col-sm-12 col-md-8 dots-overflow"><info-item item="$ctrl.infoItemUsuarioAtribuido"></info-item></div><div class="linha-card"></div></div><div class="row"><div class="col-sm-12 col-md-8 dots-overflow"><info-item item="$ctrl.infoItemMotorista"></info-item></div><div ng-if="$ctrl.ocorrencia.isRecorrente" class="col-sm-12 col-md-4 col-xs-5 pull-right text-right"><div class="recorrente dots-overflow">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaCard.recorrente\' | translate }}</div></div><div class="linha-card"></div></div><div class="row eventos"><div ng-class="{\'no-events\': !$ctrl.alerts.length}" class="col-sm-12"><div data-testid="quadro-ocorrencia-card-total-eventos-value" class="text-uppercase text-bold">{{ $ctrl.totalAlertas }} {{ $ctrl.totalAlertas > 1 ? \'ce.tempoReal.quadroDeOcorrencias.common.eventos\' : \'ce.tempoReal.quadroDeOcorrencias.common.evento\' | translate }}</div><div class="event-content"><div ng-if="$ctrl.alerts.length"><strong ng-if="$ctrl.alerts[0]" data-testid="quadro-ocorrencia-card-grupo-evento1-value" class="badge-custom">{{ $ctrl.alerts[0].quantidade }} {{ $ctrl.handleDescription($ctrl.alerts[0].tipo) | translate }}</strong><strong ng-if="$ctrl.alerts[1]" data-testid="quadro-ocorrencia-card-grupo-evento2-value" class="badge-custom">{{ $ctrl.alerts[1].quantidade }} {{ $ctrl.handleDescription($ctrl.alerts[1].tipo) | translate }}</strong><strong ng-if="$ctrl.alerts[2]" data-testid="quadro-ocorrencia-card-grupo-evento3-value" class="badge-custom without-bg">+{{ $ctrl.handleEventsQuantity() }} {{ $ctrl.alerts[3] ? \'ce.tempoReal.quadroDeOcorrencias.common.eventos\' : \'ce.tempoReal.quadroDeOcorrencias.common.evento\' | translate }}</strong></div><div ng-if="$ctrl.roleVisualizarVideo &amp;&amp; $ctrl.showIconVideo" class="possui-video"><span class="label-card">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaCard.possuiVideo\' | translate }}</span><br/><i class="fa fa-video-camera icon-camera"></i></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('quadro-ocorrencias/info-item/info-item.tpl.html',
    '<div id="info-item-component"><div class="icon-infos pull-left"><span ng-class="$ctrl.item.icon">{{ $ctrl.item.iconText }}</span></div><div class="info-text"><div data-testid="quadro-ocorrencia-card-{{$ctrl.item.title}}-title" class="item-title text-uppercase">{{ $ctrl.item.title }}</div><div ng-class="{\'text-uppercase\': $ctrl.item.upperCase}" data-testid="quadro-ocorrencia-card-{{$ctrl.item.description()}}-description">{{ $ctrl.item.description() }}</div><a ng-if="$ctrl.item.link" ng-href="{{$ctrl.item.link}}" target="_blank">{{ $ctrl.item.linkText }}</a><a ng-if="$ctrl.item.linkHistorico" ng-href="{{$ctrl.item.linkHistorico}}" target="_blank">{{ $ctrl.item.textHistorico }}</a></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('onboarding/tutorial-busca-regiao/tutorial-busca-regiao-directive.tpl.html',
    '<div id="container-busca-regiao"><p class="title"><img src="https://vfleets-imagens.s3-sa-east-1.amazonaws.com/tutoriais/blue-warning.png" width="30px" height="28px"/><strong>Você sabia?</strong></p><div>A funcionalidade de <strong>Busca por região </strong>permite verificar se seus veículos  fizeram determinadas rotas, ou estiveram em determinados lugares em um dia e horário especifíco. Vamos conhecê-la?</div><div class="div-btns"><button type="button" ng-click="ctrl.closeContainer()" class="btn mais-tarde">MAIS TARDE</button><button type="button" ng-click="ctrl.start()" class="btn experimentar">CONHECER AGORA</button></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ocorrencia/ocorrencia-historico/ocorrencia-historico.tpl.html',
    '<div ng-repeat="itemHist in $ctrl.ocorrencia.hist" class="user-obs"><hist-item item="itemHist" veiculo-id="$ctrl.veiculoId"></hist-item></div><div class="alerta-aqui-anexo"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ocorrencia/ocorrencia-eventos/ocorrencia-eventos.tpl.html',
    '<a ng-href="{{$ctrl.linkHistoricoDetalhado}}" target="_blank"> \n' +
    '{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaEventos.linkVerHistoricoDetalhado\' | translate }}</a><div class="row"><div class="col-sm-2 col-xs-2 col-sm-offset-7 col-xs-offset-10 text-center"><span class="item-title">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaEventos.quantidade\' | translate }}</span></div></div><div ng-repeat="alerta in $ctrl.alertasAgrupados" class="row eventos"><div class="col-sm-7 col-xs-10"><div class="icon-eventos pull-left"><i ng-class="$ctrl.alertasEnum.getAlerta(alerta.tipo).icone"></i></div><div class="evento-desc pull-left"><span>{{ $ctrl.alertasEnum.getAlerta(alerta.tipo).descricao | translate}}</span><span ng-if="$ctrl.showLabelVideo" class="tem-video">&nbsp; ({{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaEventos.possuiVideo\' | translate }})</span></div></div><div class="col-sm-2 col-xs-2 text-center">{{ alerta.quantidade }}</div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('ocorrencia/ocorrencia-dados/ocorrencia-dados.tpl.html',
    '<div id="ocorrencia-dados"><div class="infos"><div class="row data-hora"><div class="col-sm-12 text-right"><span class="data-hora">{{ \'ce.tempoReal.quadroDeOcorrencias.common.gerada\' | translate }}\n' +
    '{{ $ctrl.ocorrencia.dataHora | date:$ctrl.dateFormat }} {{ \'ce.tempoReal.quadroDeOcorrencias.common.as\' | translate }}\n' +
    '{{ $ctrl.ocorrencia.dataHora | date:\'HH:mm\' }}</span></div></div><div class="row veiculo"><div class="col-sm-6"><div class="info-content veiculo"><div class="icon-infos pull-left"><i class="fa fa-car"></i></div><div class="info-text pull-left"><span class="item-title">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.veiculo\' | translate }}<br/></span><span>{{$ctrl.ocorrencia.veiculo | prefixoPlaca}}<br/></span><a ng-href="{{$ctrl.linkMapaVeiculo}}" target="_blank">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.verVeiculoMapa\' | translate }}</a></div></div></div><div class="col-sm-6"><div class="info-content veiculo"><div class="icon-infos pull-left"><i class="fa fa-user"></i></div><div class="info-text pull-left"><span class="item-title">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.motorista\' | translate }}<br/></span><span>{{$ctrl.ocorrencia.motorista.nome || \'ce.tempoReal.quadroDeOcorrencias.common.semIdentificacao\' | translate }}<br/></span><a ng-if="$ctrl.ocorrencia.motorista" ng-href="{{$ctrl.linkProntuario}}" target="_blank">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.linkProntuario\' | translate }}<br/></a><a ng-if="$ctrl.ocorrencia.motorista" ng-href="{{$ctrl.linkHistoricoOcorrencias}}" target="_blank">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.linkHistoricoOcorrencia\' | translate }}</a></div></div></div></div><div class="row"><div class="col-sm-6 col-xs-12"><div class="row"><div ng-repeat="info in $ctrl.veiculoInfos" class="pull-left info-col col-xs-12"><info-item item="info"></info-item></div></div></div><div class="col-sm-6 col-xs-12"><div class="row"><div ng-repeat="info in $ctrl.motoristaInfos" class="pull-left info-col col-xs-12"><info-item item="info"></info-item></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas-grid/modal-select/modal-select.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">Número de veículos selecionados excedido</h3></div><div class="modal-body"><p>Limite de 100 veículos selecionados excedidos. Gostaria de prosseguir ao histórico com os primeiros 100 veículos selecionados?</p></div><div class="modal-footer"><button type="button" ng-click="$ctrl.modalInstance.dismiss()" class="btn btn-default">Cancelar</button><button type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-success">Ok</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas-grid/envio-comando/envio-comando.tpl.html',
    '<div class="modal-header bg-green"><h3 id="modal-title" class="modal-title">{{ \'ce.mapa.localizacaoDaFrota.enviarComando.titulo\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><form ng-submit="$ctrl.efetuaEnvioComando()" name="importarForm" class="form"><div id="modal-body" class="modal-body modal-body-custom-ponto"><div class="row"><div class="col-md-12"><div class="form-group"><label for="selectUo" class="control-label">{{ \'ce.mapa.localizacaoDaFrota.enviarComando.selecioneComandoASerEnviado\' | translate }}</label><div class="row"><div class="col-md-6"><div class="form-group"><select type="text" name="comando" id="comando" ng-options="comando as $ctrl.tiposComando[comando.tipo] | translate for comando in $ctrl.comandos track by comando.tipo" ng-model="$ctrl.model.comandoSelected" ng-disabled="!$ctrl.hasVeiculosAfetados()" class="form-control select-comando"><option value="" disabled="disabled" selected="selected" hidden="hidden">{{$ctrl.defaultOption}}</option></select></div></div><div class="col-md-6"><div class="label-afetados"><span ng-if="$ctrl.model">({{$ctrl.model.comandoSelected.veiculos.length}}\n' +
    '{{ \'ce.mapa.localizacaoDaFrota.enviarComando.veículosAfetados\' | translate }})</span></div></div></div></div></div></div></div><div class="modal-footer"><div ng-if="$ctrl.erro" class="alerta alert alert-error alert-dismissible alertIn alertOut text-left"><span>{{$ctrl.msgErro}}</span><button type="button" ng-click="$ctrl.limpaErro()" class="close">×</button></div></div><div class="modal-footer"><button type="button" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.mapa.localizacaoDaFrota.enviarComando.cancelar\' | translate }}</button><button type="submit" ng-disabled="!$ctrl.model.comandoSelected" class="btn btn-success">{{ \'ce.mapa.localizacaoDaFrota.enviarComando.enviar\' | translate }}</button></div></form>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas/toggle-layer-markers/toggle-layer-markers-component.tpl.html',
    '<ul ng-class="{ \'expanded\': $ctrl.expanded }" ng-mouseenter="$ctrl.expanded = true" ng-mouseleave="$ctrl.expanded = false" ng-click="$ctrl.expanded = true" outside-click="$ctrl.expanded = false" class="toggle-markers-options list-group"><li class="selected-option list-group-item"><i class="trimble-icon trimble-layers"></i></li><li ng-repeat="option in $ctrl.options track by option.name" ng-class="{ \'selected\': $ctrl.options.name === option.name }" class="toggle-markers-option list-group-item visible-when-expanded"><input type="checkbox" id="opcao-{{ option.name }}" name="opcao-{{ option.name }}" ng-model="option.shouldShow" ng-change="$ctrl.onSelectOption(option.name, option.shouldShow)"/><label for="opcao-{{ option.name }}"><span>{{ option.label | translate }}</span></label></li></ul>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas/map-layer-switcher/map-layer-switcher-component.tpl.html',
    '<ul ng-class="{ \'expanded\': $ctrl.expanded }" ng-mouseenter="$ctrl.expanded = true" ng-mouseleave="$ctrl.expanded = false" ng-click="$ctrl.expanded = true" outside-click="$ctrl.expanded = false" class="layer-switcher-options list-group"><li class="selected-option list-group-item"><i ng-class="$ctrl.selectedOption.iconClass"></i></li><li ng-repeat="option in $ctrl.availableOptions track by option.value" ng-class="{ \'selected\': $ctrl.selectedOption.value === option.value }" class="layer-switcher-option list-group-item visible-when-expanded"><input type="radio" id="opcao-{{ option.value }}" name="camada" ng-model="$ctrl.selectedOption" ng-value="option" ng-change="$ctrl.onSelectOption()"/><label for="opcao-{{ option.value }}"><i ng-class="option.iconClass"></i><span>{{ option.label | translate }}</span></label></li></ul>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('insights/seguranca/seguranca.tpl.html',
    '<div id="vfwc-predicao-acidentes-view"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('indicadores/utilizacao-veiculo/utilizacao-veiculo.tpl.html',
    '<div class="div"><div class="row"><div class="col-md-9"><div class="box box-primary"><div class="box-body"><highchart config="utilizacaoVeiculo.columnChart" style="height: 272px"></highchart></div></div></div><div class="col-md-3"><div class="box box-primary"><div class="box-body"><highchart config="utilizacaoVeiculo.pieChart" style="height: 272px"></highchart></div></div></div></div><div class="row"><div class="col-md-4"><div class="box box-widget widget-default"><div class="box-header v3g-bg-red"><h4 class="box-title">{{ \'ce.indicadores.ociosidadeFrota.charts.veiculosDesligados\' | translate }}</h4><span class="fa-stack fa-stack-1-2x box-tools"><i class="fa fa-circle-thin fa-stack-2x fa-inverse"></i><i class="fa fa-circle fa-stack-1x fa-stack-1-7x v3g-text-red"></i><i class="fa fa-power-off fa-stack-1x fa-inverse"></i></span></div><ul class="list-inline"><li ng-repeat="item in utilizacaoVeiculo.desligadosCard" class="widget-veiculo-utilizacao-item"><div class="row"><div class="col-xs-7"><h4>{{ item.uo.nome }}</h4><small>{{ item.uoCompartilhada.nome }}</small></div><div class="col-xs-2"><h4 class="pull-right total-veiculo">{{ item.quantidade + \'/\' + item.total }}</h4><small class="pull-right">{{ \'ce.indicadores.ociosidadeFrota.charts.veiculos\' | translate }}</small></div><div class="col-xs-3 percentual"><span class="pull-right"><strong>{{ item.percentual }}</strong><span>%</span></span></div></div></li></ul></div></div><div class="col-md-4"><div class="box box-widget widget-default"><div class="box-header v3g-bg-yellow"><h4 class="box-title">{{ \'ce.indicadores.ociosidadeFrota.charts.ate10kmPercorridos\' | translate }}</h4><span class="fa-stack fa-stack-1-2x box-tools"><i class="fa fa-circle-thin fa-stack-2x fa-inverse"></i><i class="fa fa-circle fa-stack-1x fa-stack-1-7x v3g-text-yellow"></i><i class="fa icon trimble-vehicle fa-stack-1x fa-inverse indicador-trimble-icon"></i></span></div><ul class="list-inline"><li ng-repeat="item in utilizacaoVeiculo.ate10KmCard" class="widget-veiculo-utilizacao-item"><div class="row"><div class="col-xs-7"><h4>{{ item.uo.nome }}</h4><small>{{ item.uoCompartilhada.nome }}</small></div><div class="col-xs-2"><h4 class="pull-right total-veiculo">{{ item.quantidade + \'/\' + item.total }}</h4><small class="pull-right">{{ \'ce.indicadores.ociosidadeFrota.charts.veiculos\' | translate }}</small></div><div class="col-xs-3 percentual"><span class="pull-right"><strong>{{ item.percentual }}</strong><span>%</span></span></div></div></li></ul></div></div><div class="col-md-4"><div class="box box-widget widget-default"><div class="box-header v3g-bg-green"><h4 class="box-title">{{ \'ce.indicadores.ociosidadeFrota.charts.mais10kmPercorridos\' | translate }}</h4><span class="fa-stack fa-stack-1-2x box-tools"><i class="fa fa-circle-thin fa-stack-2x fa-inverse"></i><i class="fa fa-circle fa-stack-1x fa-stack-1-7x v3g-text-green"></i><i class="fa icon trimble-vehicle fa-stack-1x fa-inverse indicador-trimble-icon"></i></span></div><ul class="list-inline"><li ng-repeat="item in utilizacaoVeiculo.maisDe10KmCard" class="widget-veiculo-utilizacao-item"><div class="row"><div class="col-xs-7"><h4>{{ item.uo.nome }}</h4><small>{{ item.uoCompartilhada.nome }}</small></div><div class="col-xs-2"><h4 class="pull-right total-veiculo">{{ item.quantidade + \'/\' + item.total }}</h4><small class="pull-right">{{ \'ce.indicadores.ociosidadeFrota.charts.veiculos\' | translate }}</small></div><div class="col-xs-3 percentual"><span class="pull-right"><strong>{{ item.percentual }}</strong><span>%</span></span></div></div></li></ul></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('indicadores/power-bi/power-bi.tpl.html',
    '<powerbi-component id="embed-container" options="powerBi.response"></powerbi-component>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('indicadores/direcao-segura/direcao-segura.tpl.html',
    '<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-body"><div class="row"><div id="comparativo-chart" class="col-md-4"><highchart config="direcaoSegura.comparativoChart" style="height: 272px"></highchart></div><div id="periodo-chart" class="col-md-8"><highchart config="direcaoSegura.periodoChart" style="height: 272px"></highchart></div></div></div><div class="box-footer footer-evento"><div class="row footer-evento-content text-center"><div ng-repeat="item in direcaoSegura.footer" class="footer-evento-item"><div class="footer-evento-description-block"><span ng-class="{&quot;v3g-text-red&quot;: item.percentualEntrePeriodos &gt; 0, &quot;v3g-text-green&quot;: item.percentualEntrePeriodos &lt; 0}" class="description-percentage"><i ng-class="{&quot;fa-caret-up&quot;: item.percentualEntrePeriodos &gt; 0, &quot;fa-caret-down&quot;: item.percentualEntrePeriodos &lt;= 0, &quot;fa-caret-left&quot;: item.percentualEntrePeriodos === 0}" class="fa"></i> {{item.percentualEntrePeriodos >= 0 ? (item.percentualEntrePeriodos | number) : ((item.percentualEntrePeriodos * -1) | number)}}%</span><h5 class="footer-evento-description-header">{{ item.mediaVeiculoPeriodoAnterior | number}} / {{ \'ce.indicadores.common.label.veiculo\' | translate }} | {{ item.mediaVeiculoPeriodoAtual | number}} / {{ \'ce.indicadores.common.label.veiculo\' | translate }}</h5><span>{{ item.descricao }}</span></div></div></div></div></div></div><div class="col-md-12"><div class="box box-primary"><div class="box-body"><div class="row"><div id="uo-chart" class="col-md-12"><highchart config="direcaoSegura.uoChart" style="height: 272px"></highchart></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('indicadores/conducao-economica/conducao-economica.tpl.html',
    '<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-body"><div class="row"><div id="comparativo-chart" class="col-md-4"><highchart config="conducaoEconomica.comparativoChart" style="height: 272px"></highchart></div><div id="periodo-chart" class="col-md-8"><highchart config="conducaoEconomica.periodoChart" style="height: 272px"></highchart></div></div></div><div class="box-footer footer-evento"><div class="row footer-evento-content text-center"><div ng-repeat="item in conducaoEconomica.footer" class="footer-evento-item"><div class="footer-evento-description-block"><span ng-class="{&quot;v3g-text-red&quot;: item.percentualEntrePeriodos &gt; 0, &quot;v3g-text-green&quot;: item.percentualEntrePeriodos &lt; 0}" class="description-percentage"><i ng-class="{&quot;fa-caret-up&quot;: item.percentualEntrePeriodos &gt; 0, &quot;fa-caret-down&quot;: item.percentualEntrePeriodos &lt;= 0, &quot;fa-caret-left&quot;: item.percentualEntrePeriodos === 0}" class="fa"></i> {{item.percentualEntrePeriodos >= 0 ? (item.percentualEntrePeriodos | number) : ((item.percentualEntrePeriodos * -1) | number)}}%</span><h5 class="footer-evento-description-header">{{ item.mediaVeiculoPeriodoAnterior | ceilAndRemoveDecimals | humanizedDuration: true}} / {{ \'ce.indicadores.common.label.veiculo\' | translate }} | {{ item.mediaVeiculoPeriodoAtual | ceilAndRemoveDecimals | humanizedDuration: true}} / {{ \'ce.indicadores.common.label.veiculo\' | translate }}</h5><span>{{ item.descricao }}</span></div></div></div></div></div></div><div class="col-md-12"><div class="box box-primary"><div class="box-body"><div class="row"><div id="uo-chart" class="col-md-12"><highchart config="conducaoEconomica.uoChart" style="height: 272px"></highchart></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/visao-cameras/visao-cameras.tpl.html',
    '<div id="visao-cameras"><div ng-if="$ctrl.snapshots === null" class="loading"><div class="fa fa-spinner fa-spin"></div></div><div ng-if="$ctrl.snapshots.length === 0" class="alerta-sem-snaps alert alert-warning">{{ $ctrl.getAlertNoSnapshots() }}</div><div class="label-filter"><div class="timeline-filtros"><div ng-if="$ctrl.indicesDisponiveis.length" historico-timeline-dropdown-multiselect="{}" options="$ctrl.labels" selected-model="$ctrl.labelsActived" events="$ctrl.labelsEvents" button-text="ce.mapa.historicoDetalhado.dropdownMultiselectDirective.auditingEventsText"></div></div></div><controle-cameras ng-if="$ctrl.indicesDisponiveis.length &amp;&amp; $ctrl.snapshots.length &gt; 0" on-to-index="$ctrl.changeIndiceCamera(indice, cameraSelected)" indice-disponiveis="$ctrl.indicesDisponiveis" cameras-evidence="$ctrl.camerasEvidence"></controle-cameras><div id="snapshots" class="container-snapshots"><div ng-repeat="snapshot in $ctrl.snapshots track by snapshot.id+$ctrl.camera" class="snapshot-item"><card-snapshot snapshot="snapshot" qtd-cameras="$ctrl.indicesDisponiveis.length" indice="$ctrl.indice" camera-selected="$ctrl.cameraSelected" indice-disponiveis="$ctrl.indicesDisponiveis" ver-no-mapa="$ctrl.verNoMapa(posicao)"></card-snapshot></div></div><cameras-paginacao ng-if="$ctrl.indicesDisponiveis.length &amp;&amp; $ctrl.snapshots.length &gt; 0" navigation-setting="$ctrl.navigationSetting" handle-change-page="$ctrl.changePage(page)"></cameras-paginacao></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/devices/devices.tpl.html',
    '<div id="safety-app" ng-controller="DevicesCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('duo-routes/cadastro/form-duo-routes.tpl.html',
    '<div id="safety-duo-route-form"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('duo-routes/cadastro/cadastro-duo-routes.tpl.html',
    '<div id="safety-duo-route-list"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('duo-routes/atribuicao/form-assignment-duo-routes.tpl.html',
    '<div id="safety-duo-route-assignment-form"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('duo-routes/atribuicao/details-assignment-duo-routes.tpl.html',
    '<div id="safety-duo-route-assignment-details"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('duo-routes/atribuicao/atribuicao-duo-routes.tpl.html',
    '<div id="safety-duo-route-assignment-list"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/v3g-table-limit/v3g-table-limit.tpl.html',
    '<select id="stItemsByPage" ng-model="stItemsByPage" type="number" ng-options="value*1 as label for (value, label) in options" ng-change="changeValue()" class="select-table-limit form-control"></select><span class="span-table-limit">{{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.itensPorPagina\' | translate }}</span>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/v3g-image-crop/v3g-image-crop.tpl.html',
    '<div class="row"><div class="col-sm-12"><div class="form-group"><label for="imagem">Selecione uma imagem:<br/><small class="subtitle-label text-muted">O tamanho máximo é de {{ v3gImageCropCtrl.maxSizeLabel() }}</small></label><input id="imagem" type="file" onchange="angular.element(this).scope().v3gImageCropCtrl.handleChangeImage(this)" accept="image/*" required="{{ v3gImageCropCtrl.required }}"/></div><div class="alert-file"></div></div></div><div class="row"><div class="col-sm-12"><div ng-class="{\'crop-area\': v3gImageCropCtrl.fotoOriginal}" ng-show="v3gImageCropCtrl.fotoOriginal"><img-crop image="v3gImageCropCtrl.fotoOriginal" result-image="v3gImageCropCtrl.fotoFinal" area-type="square" change-on-fly="true" on-change="v3gImageCropCtrl.onCrop()" class="image-area"></img-crop></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/v-ui-select/v-ui-select.tpl.html',
    '<div class="v-ui-select"><ui-select ng-model="$ctrl.model" close-on-select="true" name="$ctrl.name" id="$ctrl.name" reset-search-input="false" on-select="$ctrl.onSelectedElement($select.selected)" ng-keyup="$ctrl.checkEscapeKey($event)" class="diretiva-ui-select"><ui-select-match placeholder="{{$ctrl.placeholder}}"> \n' +
    '{{$select.selected.nome || $select.search}}</ui-select-match><ui-select-choices repeat="element in $ctrl.elements | filter: $select.search track by element.id" refresh="$ctrl.refreshResults($select)" refresh-delay="0"><div ng-if="!$ctrl.itemCadastrado(element)" class="cadastro-novo"><i class="fa fa-plus-circle fa-icon-right"> </i><span class="small">{{$ctrl.info}}</span></div><span ng-if="$ctrl.itemCadastrado(element)" ng-bind-html="element.nome | highlight: $select.search"></span></ui-select-choices></ui-select></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/uo-select-input/uo-select-input-component.tpl.html',
    '<ui-select id="uo-select-input" style="width: 100%" ng-model="$ctrl.model" ng-disabled="$ctrl.disabled" ng-required="$ctrl.required" name="{{$ctrl.name}}" on-select="$ctrl.onSelect($ctrl.model)" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'uo.selecione\' | translate }}"> \n' +
    '{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="uo as uo in ($ctrl.uos | filter: $select.search | limitTo: $ctrl.limitOrigem ) track by uo.id" refresh="$ctrl.bindModelSelect()" refresh-delay="0"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/tag-ignore/tag-ignore.tpl.html',
    '<span ng-if="$ctrl.featureFlagLAINT42 &amp;&amp; ($ctrl.alert || $ctrl.event)" class="tag-ignore"><span ng-class="$ctrl.size" uib-tooltip="{{ $ctrl.handleTooltipMessage() }}" tooltip-placement="{{$ctrl.position}}" class="material-icons">label_off</span></span>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/select-uo/select-uo.tpl.html',
    '<ui-select id="select-uo" style="width: 100%" ng-model="$ctrl.model.uoSelected" ng-disabled="$ctrl.selectDisabled" ng-required="$ctrl.selectRequired" name="{{$ctrl.selectName}}" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'uo.selecione\' | translate }}"> \n' +
    '{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="uo as uo in ($ctrl.uos | filter: $select.search | limitTo: $ctrl.limitOrigem ) track by uo.id"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/reprod-rotas/reprod-rotas.tpl.html',
    '<div id="reprod-rotas" ng-class="$ctrl.reprodRotasService.showReprodRotas ? &quot;reprod-rota-open&quot; : &quot;reprod-rota-close&quot;"><i ng-class="$ctrl.reprodRotasService.showReprodRotas ? &quot;fa-caret-down icon-up&quot; : &quot;fa-caret-up icon-down&quot;" ng-click="$ctrl.reprodRotasService.toggleReprodRotas(); $ctrl.showSpeed = false" class="fa toggle-reprod-rotas"></i><div class="controls"><div class="play-pause"><button type="button" ng-click="$ctrl.playPause()" class="btn btn-default"><span ng-class="$ctrl.isPlaying ? &quot;fa-pause&quot; : &quot;fa-play&quot;" class="fa"></span></button></div><div class="speed"><div ng-click="$ctrl.toggleSpeed()" class="speed-button">{{$ctrl.model.speed + \'x\'}}</div><div ng-if="$ctrl.showSpeed" class="speed-range"><input type="range" outside-click="$ctrl.closeSpeed()" min="{{$ctrl.speedInput.min}}" max="{{$ctrl.speedInput.max}}" step="{{$ctrl.speedInput.step}}" ng-model="$ctrl.model.speed" ng-change="$ctrl.setSpeed()"/></div></div><div class="dateTime"><div class="data"><span>{{$ctrl.dataTimeReproduction | date:\'dd/MM/yyyy\' }}</span></div><div class="time"><span>{{$ctrl.dataTimeReproduction | date:\'HH:mm:ss\' }}</span></div></div><div class="toggle-parado"><toggle ng-model="$ctrl.model.pulaParada" off="" on="" onstyle="btn-primary" offstyle="btn-default" style="tipo-ios" size="btn-xs"> </toggle><span class="pular-paradas">{{ \'ce.mapa.common.modal.reprodRotas.pularParadas\' | translate }}</span></div><div ng-if="$ctrl.playbackRoute" class="slider"><span class="start-time">{{$ctrl.sliderInput.min | date:\'HH:mm:ss\'}}</span><span class="end-time">{{$ctrl.sliderInput.max | date:\'HH:mm:ss\'}}</span><input type="range" min="{{$ctrl.sliderInput.min}}" max="{{$ctrl.sliderInput.max}}" step="{{$ctrl.sliderInput.step}}" ng-model="$ctrl.model.slider" ng-change="$ctrl.setSlider()"/></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/motorista-link/motorista-link.tpl.html',
    '<a ng-if="$ctrl.motorista &amp;&amp; $ctrl.enableHiperlink &amp;&amp; $ctrl.hasPermission" id="driver-name-{{$ctrl.index}}" ng-href="{{$ctrl.getLinkProntuarioMotorista()}}" target="_blank" title="{{\'ce.ranking.pontos.stringProntuario\' | translate}}\n' +
    '{{$ctrl.motorista}}" class="driver-record-link">{{$ctrl.motorista}}</a><span ng-if="$ctrl.motorista &amp;&amp; (!$ctrl.enableHiperlink || !$ctrl.hasPermission)">{{$ctrl.motorista}}</span><span ng-if="!$ctrl.motorista">{{\'ce.tempoReal.quadroDeOcorrencias.common.semIdentificacao\' | translate}}</span>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/map-control/map-control-directive.tpl.html',
    '<div id="map-control" ng-class="ctrl.pontosReferenciaMenuService.tabelaPontosProximos ? \'tabela-ativo\' : \'tabela-inativo\'"><menu-default-directive ng-if="ctrl.pontosReferenciaMenuService.verificaMenuDefaultOuPesquisa()"></menu-default-directive><menu-adicionar-cerca-eletronica ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;adicionar-cerca-eletronica&quot;"></menu-adicionar-cerca-eletronica><menu-editar-cerca-eletronica ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;editar-cerca-eletronica&quot;"></menu-editar-cerca-eletronica><menu-excluir-cerca-eletronica ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;excluir-cerca-eletronica&quot;"></menu-excluir-cerca-eletronica><menu-adicionar-ponto-referencia-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;adicionar&quot;"></menu-adicionar-ponto-referencia-directive><menu-editar-ponto-referencia-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;editar&quot;"></menu-editar-ponto-referencia-directive><menu-excluir-ponto-referencia-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;excluir&quot;"></menu-excluir-ponto-referencia-directive><menu-ajustar-ponto-referencia-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;ajustar&quot;"></menu-ajustar-ponto-referencia-directive><menu-adicionar-pontos-proximos-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;adicionar-pontos-proximos&quot;"></menu-adicionar-pontos-proximos-directive><div ng-class="{\'alerta-pesquisa\': ctrl.pontosReferenciaMenuService.tipoFAB === \'pesquisar\'}" class="alerta-aqui-ponto"></div><div ng-if="ctrl.pontosReferenciaMapService.alertaZoom" class="alerta-zoom alert alert-warning text-center">{{ ctrl.alertaZoomPontoReferencia | translate }}</div><div ng-if="ctrl.cercaEletronicaMapService.alertaZoom" class="alerta-zoom alert alert-warning text-center">{{ ctrl.alertaZoomCercaEletronica | translate }}</div><tabela-pontos-proximos-directive ng-if="ctrl.scope.pontosProximos" ng-class="{&quot;active&quot;: ctrl.pontosReferenciaMenuService.tabelaPontosProximos, &quot;drawer-pesquisa-open&quot;: ctrl.pontosReferenciaMenuService.drawerBusca}"></tabela-pontos-proximos-directive><aside id="drawer-pesquisar" ng-class="{\'control-sidebar-open\' : ctrl.pontosReferenciaMenuService.drawerBusca}" class="drawer-action drawer-ponto-referencia control-sidebar control-sidebar-light"><pesquisa-ponto-referencia-directive ng-if="ctrl.pontosReferenciaMenuService.tipoFAB === &quot;pesquisar&quot; || ctrl.pontosReferenciaMenuService.tipoFAB === &quot;adicionar-pontos-proximos&quot;"></pesquisa-ponto-referencia-directive></aside><aside id="drawer-pesquisar" ng-class="{\'control-sidebar-open\' : ctrl.pontosReferenciaMenuService.drawerAdvisor}" class="drawer-action control-sidebar control-sidebar-light"><list-advisor-rotogramas suggestions="ctrl.suggestions"></list-advisor-rotogramas></aside><button type="button" ng-if="ctrl.pontosReferenciaFiltroService.verificaLocalStorage()" ng-click="ctrl.limparFiltro()" class="btn btn-primary btn-limpar-filtro">{{ \'ce.mapa.common.mapControlDirective.limparFiltro\' | translate }}</button><div id="fechar-drawer" ng-class="ctrl.activeDrawerStyle()" uib-tooltip="{{ \'ce.mapa.common.tooltipModoEdicao\' | translate }}" tooltip-placement="left" tooltip-enable="{{!ctrl.pontosReferenciaMenuService.verificaMenuDefaultOuPesquisaOuAdicionarPontoProximo()}}" ng-click="ctrl.pontosReferenciaMenuService.toggleDrawer()" class="fechar-drawer aside-button aside-button-ui"><i ng-class="ctrl.pontosReferenciaMenuService.drawerBusca ? \'fa-caret-right\' : \'fa-search\'" class="fa"></i></div><btn-advisor-rotogramas id="btn-advisor-rotograma" ng-if="ctrl.hasRoleUpdateAdvisorSuggestion" ng-class="ctrl.activeDrawerStyle()" ng-click="ctrl.pontosReferenciaMenuService.clickAdvisorButton()" uib-tooltip="{{ \'ce.mapa.common.tooltipModoEdicaoSugestaoRotograma\' | translate }}" tooltip-placement="left" tooltip-enable="{{ctrl.pontosReferenciaMenuService.isEditModeOn()}}" active="ctrl.pontosReferenciaMenuService.drawerAdvisor" qtd-sugestoes="ctrl.suggestions.length" class="aside-button advisor-button"></btn-advisor-rotogramas><div id="sugestion-rotograma-snackbar"></div><div id="toast-advisor" ng-class="ctrl.activeDrawerStyle()"></div><div id="dialog-create-ponto"></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/datepicker/datepicker.tpl.html',
    '<div class="datepicket-component"><div id="data-input" class="input-group left datepicker vfiltro-calendar"><span ng-class="{disabled: $ctrl.disabled}" ng-click="isDataOpen = true" class="input-group-addon"><i class="fa fa-calendar"></i></span><input name="{{$ctrl.name}}" autocomplete="off" type="tel" model-view-value="true" ui-mask="99/99/9999" popover-trigger="\'focus\'" popover-placement="top-right" popover-append-to-body="false" ng-model="$ctrl.model" ng-required="$ctrl.required" ng-focus="isDataOpen = true" ng-disabled="$ctrl.disabled" datepicker-template-url="components/directives/vfiltro/components/date-time/template/vfiltro-datepicker.tpl.html" on-open-focus="false" uib-datepicker-popup="dd/MM/yyyy" is-open="isDataOpen" show-button-bar="false" datepicker-options="$ctrl.options" class="form-control"/></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/custom-popup/custom-popup.tpl.html',
    '<div id="vpopup-component"><div class="header-vpopup"><div class="row"><div class="col-xs-11 col-sm-10 col-sm-offset-1 text-uppercase"><div class="title">{{$ctrl.infos.title.text}}</div><a ng-href="{{$ctrl.infos.title.linkRedirecionar}}" target="_blank" class="icone-redirecionar"><i class="trimble-icon trimble-open-new"></i></a><div class="trimble-ou subtitle">{{$ctrl.infos.subTitle}}</div><div ng-if="$ctrl.infos.alerta" class="borda"></div></div></div></div><div class="content-vpopup"><div ng-if="!$ctrl.infos.alerta" class="row alerta-row"><div class="icon-col col-sm-1"><span class="icon-infos fa fa-exclamation-triangle"></span></div><div class="alerta-box"><div class="alerta-info"><span class="alerta-title">{{ \'ce.mapa.common.customPopup.atencao\' | translate }}</span><br/><span translate="{{ $ctrl.getGpsText() }}"> </span></div></div></div><div ng-repeat="row in $ctrl.infos.rows" ng-if="$ctrl.isValid(row)" ng-class="{\'route-progress-alert\': row.type === \'route-progress\' &amp;&amp; row.routeProgress.late}" class="row"><div class="icon-col col-sm-1"><span class="icon-infos"><span ng-class="row.icon" class="fa"></span></span></div><div class="col-xs-11 col-sm-10"><div class="row"><div ng-repeat="item in row.infos" ng-class="[\'col-sm-\' + item.size, + \'col-xs-\' + $ctrl.getMobileSize(item.size), { \'bottom-spacing\': row.noBorder }]" ng-if="item.value" data-testid="custom-popup-info_{{item.label}}"><span class="info-title">{{item.label}}</span><br/><span ng-if="!item.veiculoHasOcorrenciaNova" ng-class="item.class" ng-click="$ctrl.onItemClick(item)" title="{{item.value}}" class="info-value"><span ng-if="!item.onClick">{{item.value}}</span><a ng-if="item.onClick">{{item.value}}</a></span><span ng-if="item.veiculoHasOcorrenciaNova" ng-class="item.class" class="info-value"><span class="highlighted-number">{{item.qtdNovasOcorrencias}}</span><span class="custom-text"> {{item.value}}</span></span><a ng-if="item.linkRedirecionar &amp;&amp; !item.veiculoHasOcorrenciaNova" ng-href="{{item.linkRedirecionar}}" target="_blank" class="icone-redirecionar"><i class="trimble-icon trimble-open-new"></i></a><a ng-if="item.linkRedirecionar &amp;&amp; item.veiculoHasOcorrenciaNova" ng-href="{{item.linkRedirecionar}}" target="_blank" ng-click="$ctrl.onClickTratarOcorrencia(item.ocorrenciaId)" class="texto-redirecionar">{{ \'ce.mapa.localizacaoDaFrota.ocorrencia.tratar\' | translate | uppercase }}</a></div></div><div ng-if="row.type === \'route-progress\'" data-testid="custom-popup-route-progress" class="route-progress"><span class="info-title">{{ \'ce.mapa.common.vpopupService.progressoDaRota\' | translate }}</span><div title="{{row.routeProgress.name}}" class="info-value route-name">{{row.routeProgress.name}}</div><div ng-if="row.routeProgress.late || row.routeProgress.onDeviation" class="route-badges"><span ng-if="row.routeProgress.late" data-testid="custom-popup-route-late" class="label label-danger">{{ \'ce.mapa.common.vpopupService.atrasado\' | translate | uppercase }}</span><span ng-if="row.routeProgress.onDeviation" data-testid="custom-popup-route-deviation" class="label label-danger">{{ \'ce.mapa.common.vpopupService.desvioDeRota\' | translate | uppercase }}</span></div><div ng-class="{late: row.routeProgress.late}" data-testid="custom-popup-route-bar" class="route-bar"><uib-progressbar value="row.routeProgress.progress" max="100"></uib-progressbar></div><a ng-click="$ctrl.toggleRouteDetails()" data-testid="custom-popup-route-toggle" class="route-toggle">{{ ($ctrl.routeDetailsCollapsed ? \'ce.mapa.common.vpopupService.verDetalhes\' : \'ce.mapa.common.vpopupService.ocultarDetalhes\') | translate }}\n' +
    ' <i ng-class="$ctrl.routeDetailsCollapsed ? \'fa-angle-down\' : \'fa-angle-up\'" class="fa"></i></a><div uib-collapse="$ctrl.routeDetailsCollapsed" class="route-details"><div class="row"><div class="col-xs-7"><span class="info-title">{{ \'ce.mapa.common.vpopupService.horaEstimadaConclusao\' | translate }}</span><br/><span data-testid="custom-popup-route-eta" class="info-value">{{row.routeProgress.eta}}</span></div><div class="col-xs-5"><span class="info-title">{{ \'ce.mapa.common.vpopupService.tempoEmExecucao\' | translate }}</span><br/><span data-testid="custom-popup-route-execution" class="info-value">{{row.routeProgress.executionTime}}</span><span ng-if="row.routeProgress.exceededMinutes" data-testid="custom-popup-route-exceeded" class="info-value route-exceeded"> (+{{row.routeProgress.exceededMinutes}} {{ \'ce.mapa.common.vpopupService.min\' | translate | uppercase }})</span></div></div><div class="row route-details-second"><div class="col-xs-7"><span class="info-title">{{ \'ce.mapa.common.vpopupService.tempoEstimadoConclusao\' | translate }}</span><br/><span data-testid="custom-popup-route-estimated" class="info-value">{{row.routeProgress.estimatedTime}}</span></div><div class="col-xs-5"><span class="info-title">{{ \'ce.mapa.common.vpopupService.ultimaAtualizacao\' | translate }}</span><br/><span data-testid="custom-popup-route-last-update" class="info-value">{{row.routeProgress.lastUpdate}}</span></div></div></div></div><div ng-if="$index !== ($ctrl.infos.rows.length - 1) &amp;&amp; !row.noBorder" class="borda"></div></div></div></div><div class="footer-vpopup"><div class="row"><div class="col-xs-5 col-sm-5 col-sm-offset-1"><a ng-attr-href="{{$ctrl.infos.linkTimeline}}" uib-tooltip="{{ \'ce.mapa.common.customPopup.tooltip\' | translate }}" tooltip-enable="{{!$ctrl.infos.permissaoTimeline}}" ng-class="{&quot;no-role&quot;: !$ctrl.infos.permissaoTimeline}" class="fa fa-flag-checkered footer-row"><span>{{ \'ce.mapa.common.customPopup.comoChegouAqui\' | translate }}</span></a><a ng-href="{{$ctrl.infos.linkMaps}}" target="_blank" class="fa trimble-traffic"> <span>{{ \'ce.mapa.common.customPopup.trafegoTempoReal\' | translate }}</span></a><a ng-href="{{$ctrl.infos.linkStreetView}}" target="_blank" class="fa fa-street-view footer-row"><span>{{ \'ce.mapa.common.customPopup.explorarVisaoLocal\' | translate }}</span></a></div><div class="col-xs-6 col-sm-6 atualizacao"><span>{{ \'ce.mapa.common.customPopup.ultimaAtualizacao\' | translate }}</span><br/><span>{{$ctrl.infos.data}}</span></div></div></div></div><div id="dialog-vehicle-health"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vehicle-settings/vehicle-settings.tpl.html',
    '<div id="safety-app-vehicle-settings" ng-controller="VehicleSettingsCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vehicle-settings/vehicle-settings-profile.tpl.html',
    '<div id="safety-app-vehicle-settings-profile" ng-controller="VehicleSettingsProfileCtrl"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/vdrivers/configuracoes-vdrivers.tpl.html',
    '<div class="box box-primary box-menu"><div class="box-body no-padding"><aside class="col-xs-12 col-sm-5 col-md-3 bg-gray"><p>Selecione o item que deseja configurar:</p><ul class="list-unstyled"><li ng-class="{ativo: configVdriversCtrl.tipo === configVdriversCtrl.service.tipoSubpagina.APLICATIVO}"><a href="/configuracoes-vdrivers/aplicativo" title="Aplicativo" id="config-{{configVdriversCtrl.service.tipoSubpagina.APLICATIVO}}">Aplicativo</a></li><li ng-class="{ativo: configVdriversCtrl.tipo === configVdriversCtrl.service.tipoSubpagina.VIGENCIA}"><a href="/configuracoes-vdrivers/vigencia" title="Configuração de vigência" id="config-{{configVdriversCtrl.service.tipoSubpagina.VIGENCIA}}">Configuração de Vigência</a></li><li ng-class="{ativo: configVdriversCtrl.tipo === configVdriversCtrl.service.tipoSubpagina.SAFEDRIVE}"><a href="/configuracoes-vdrivers/safedrive" title="Safedrive" id="config-{{configVdriversCtrl.service.tipoSubpagina.SAFEDRIVE}}">SafeDrive</a></li><li ng-class="{ativo: configVdriversCtrl.tipo === configVdriversCtrl.service.tipoSubpagina.CHECKLIST}"><a href="/configuracoes-vdrivers/checklist" title="Checklist" id="config-{{configVdriversCtrl.service.tipoSubpagina.CHECKLIST}}">Checklist do Veículo</a></li></ul></aside><section ng-switch="configVdriversCtrl.tipo" class="col-xs-12 col-sm-7 col-md-9 no-padding"><safedrive-vdrivers ng-switch-when="safedrive"></safedrive-vdrivers><vigencia-vdrivers ng-switch-when="vigencia"></vigencia-vdrivers><checklist-vdrivers ng-switch-when="checklist"></checklist-vdrivers><aplicativo-vdrivers ng-switch-default="ng-switch-default"></aplicativo-vdrivers></section></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/eventos/configuracoes-eventos.tpl.html',
    '<div class="box box-primary box-menu"><div class="box-body no-padding"><aside ng-if="!configEventosCtrl.isLoading" class="col-xs-12 col-sm-5 col-md-3 bg-gray"><p>{{ \'ce.configuracao.eventos.itensConfiguraveis.descricao\' | translate }}</p><ul class="list-unstyled"><li ng-if="configEventosCtrl.hasPermissionConfigAlerta" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.TIPOS}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.TIPOS, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.TIPOS}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoConfigTurno &amp;&amp; !configEventosCtrl.shouldDisplayWorkShift" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.TURNOS}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.TURNOS, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.menuLabel\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.TURNOS}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.turnos.menuLabel\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissionOcorrencia &amp;&amp; configEventosCtrl.hasPermissionOcorrenciaSolucao" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.OCORRENCIAS}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.OCORRENCIAS, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.OCORRENCIAS}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoConfigPesoEventosSolucao" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.PESOS}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.PESOS, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.PESOS}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.pesoEventos.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoConfigDescarteEventosSolucao" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.DESCARTE}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.DESCARTE, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.DESCARTE}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.descarte.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoConfigDeviceHealthConfiguration" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.devicehealthConfiguration.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.devicehealthConfiguration.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoDriverPrivacy" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.DRIVER_PRIVACY}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.DRIVER_PRIVACY, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.driverPrivacy.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.DRIVER_PRIVACY}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.driverPrivacy.titulo\' | translate }}</a></li><li ng-if="configEventosCtrl.hasPermissaoConfigAlertaUsoIndevidoVeiculo" ng-class="{ativo: configEventosCtrl.tipo === configEventosCtrl.tipoSubpagina.USO_INDEVIDO_VEICULO}"><a ui-sref="root.configEventos({ tipoSubpagina: configEventosCtrl.tipoSubpagina.USO_INDEVIDO_VEICULO, hideTitle: configEventosCtrl.hideTitle })" title="{{ \'ce.configuracao.eventos.itensConfiguraveis.usoIndevidoVeiculoConfiguration.titulo\' | translate }}" id="config-{{configEventosCtrl.tipoSubpagina.USO_INDEVIDO_VEICULO}}">{{ \'ce.configuracao.eventos.itensConfiguraveis.usoIndevidoVeiculoConfiguration.titulo\' | translate }}</a></li></ul></aside><section ng-switch="configEventosCtrl.tipo" class="col-xs-12 col-sm-7 col-md-9 no-padding"><turnos-eventos ng-switch-when="turnos" ng-if="configEventosCtrl.hasPermissaoConfigTurno"></turnos-eventos><pesos-eventos ng-switch-when="pesos" ng-if="configEventosCtrl.hasPermissaoConfigPesoEventosSolucao"></pesos-eventos><descarte-eventos ng-switch-when="descarte" ng-if="configEventosCtrl.hasPermissaoConfigDescarteEventosSolucao"></descarte-eventos><ocorrencias-eventos ng-switch-when="ocorrencias" ng-if="configEventosCtrl.hasPermissionOcorrencia &amp;&amp; configEventosCtrl.hasPermissionOcorrenciaSolucao"></ocorrencias-eventos><device-health-configuration-eventos ng-switch-when="device-health-configuration" ng-if="configEventosCtrl.hasPermissaoConfigDeviceHealthConfiguration"></device-health-configuration-eventos><driver-privacy-configuration-eventos ng-switch-when="driver-privacy" ng-if="configEventosCtrl.hasPermissaoDriverPrivacy"></driver-privacy-configuration-eventos><uso-indevido-veiculo-configuration-eventos ng-switch-when="uso-indevido-veiculo" ng-if="configEventosCtrl.hasPermissaoConfigAlertaUsoIndevidoVeiculo"></uso-indevido-veiculo-configuration-eventos><tipos-eventos ng-switch-default="ng-switch-default" ng-if="configEventosCtrl.hasPermissionConfigAlerta"></tipos-eventos></section></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/config-notificacao/config-notificacao.tpl.html',
    '<div id="container-notificacao"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('configuracoes/bi-report/bi-report.tpl.html',
    '<div id="safety-bi-report"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/veiculo.tpl.html',
    '<div class="alerta-aqui"></div><div id="vehicleRegistrationModal"></div><div id="editVehicleDiv"></div><vtabela id="cadastro-veiculo" grid-options="veiculoCtrl.vtabela" analytics-category="Cadastros" analytics-label="Cadastro de Motoristas"><div ng-if="veiculoCtrl.roleCadastrar &amp;&amp; veiculoCtrl.vtabela.grid.data.length &gt; 0"></div><div id="registerVehicleButtonContainer" ng-controller="VehicleRegistrationCtrl as VehicleRegistrationCtrl" uib-tooltip="You need permission to register a vehicle." tooltip-placement="left" tooltip-class="custom-tooltip custom-tooltip-right-arrow" tooltip-enable="!VehicleRegistrationCtrl.isAdministrator" ng-show="VehicleRegistrationCtrl.shouldDisplayRegisterVehicleButton()" ng-class="{\'button-shift-left-on-selection\': veiculoCtrl.vtabela.rowsSelected.length &gt; 0}"><button ng-click="VehicleRegistrationCtrl.handleRegisterVehicleButtonClick()" ng-class="{\'disabled-button\': !VehicleRegistrationCtrl.isAdministrator}" data-testid="register-vehicle-button" class="btn btn-primary btn-sm">{{ \'ce.cadastro.veiculos.registrarNovoVeiculo\' | translate }}</button></div><div id="dialogConfigConducao"><span class="fa-icon-left fa-icon-right text-muted">  </span><span ng-show="veiculoCtrl.shouldDisplayMoreOptions" uib-dropdown="uib-dropdown" uib-tooltip="{{veiculoCtrl.getMaisOpcoesMsg()}}" tooltip-placement="right" class="dropdown no-space"><strong ng-disabled="veiculoCtrl.getEditableRowsSelected().length === 0 || (!veiculoCtrl.roleCadastrar &amp;&amp; !veiculoCtrl.roleVigenciaProgramadaVisualizar)" uib-dropdown-toggle="uib-dropdown-toggle" class="dropdown-toggle btn btn-sm btn-outline-blue">{{ \'ce.cadastro.veiculos.menuOpcoes.title\' | translate }}<i class="fa fa-caret-down fa-icon-left"></i></strong><ul ui-dropdown-menu="ui-dropdown-menu" class="dropdown-menu"><li><a ng-if="veiculoCtrl.roleCadastrar" ng-click="veiculoCtrl.abrirQrCode(veiculoCtrl.vDataToVeiculo(veiculoCtrl.vtabela.rowsSelected))"><i class="fa fa-qrcode"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.gerarQRCode\' | translate }}<br/>({{veiculoCtrl.vtabela.rowsSelected.length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}</a></li><li><a ng-if="veiculoCtrl.getEditableRowsSelected().length &gt; 0 &amp;&amp; veiculoCtrl.roleCadastrar" ng-click="veiculoCtrl.abrirModalDefinirSituacao(veiculoCtrl.vDataToVeiculo(veiculoCtrl.getEditableRowsSelected()))"><i class="fa fa-exclamation-circle"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.definirSituacao\' | translate }}<br/>({{veiculoCtrl.getEditableRowsSelected().length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}</a></li><li><a ng-if="!veiculoCtrl.isTTCUser &amp;&amp; veiculoCtrl.getEditableRowsSelected().length &gt; 0 &amp;&amp; veiculoCtrl.roleCadastrar" ng-click="veiculoCtrl.alertaManutencao(veiculoCtrl.vDataToVeiculo(veiculoCtrl.getEditableRowsSelected()))"><i class="fv trimble-icon trimble-maintenance"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.configurarManutencao\' | translate }}<br/>({{veiculoCtrl.getEditableRowsSelected().length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}</a></li><li ng-if="veiculoCtrl.isVeiculoEditavelComIntervaloDeManutencao()"><a ng-click="veiculoCtrl.alertaManutencao(veiculoCtrl.vDataToVeiculo(veiculoCtrl.getEditableRowsSelected()[0]), &quot;hodometro&quot;)"><i class="fv trimble-icon trimble-maintenance"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.removerIntervaloHodometro\' | translate }}</a></li><li ng-if="veiculoCtrl.isVeiculoEditavelComIntervaloDeManutencaoHorimetro()"><a ng-click="veiculoCtrl.alertaManutencao(veiculoCtrl.vDataToVeiculo(veiculoCtrl.getEditableRowsSelected()[0]), &quot;horimetro&quot;)"><i class="fv trimble-icon trimble-maintenance"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.removerIntervaloHorimetro\' | translate }}</a></li><li ng-if="veiculoCtrl.getEditableRowsSelected().length &gt; 0 &amp;&amp; veiculoCtrl.roleCadastrar"><a ng-click="veiculoCtrl.editarGrupoVeiculosModal(veiculoCtrl.getEditableRowsSelected())"><i class="fv trimble-icon trimble-group"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.alterarGrupo\' | translate }}<br/>({{veiculoCtrl.getEditableRowsSelected().length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}  </a></li><li ng-if="veiculoCtrl.getSelecionadosComGrupo().length &gt; 0 &amp;&amp; veiculoCtrl.roleCadastrar"><a ng-click="veiculoCtrl.desvincularGrupoVeic(veiculoCtrl.getSelecionadosComGrupo())"><i class="fv trimble-icon trimble-group"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.desvincularGrupo\' | translate }}<br/>({{veiculoCtrl.getSelecionadosComGrupo().length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}</a></li><li ng-if="!veiculoCtrl.isTTCUser &amp;&amp; veiculoCtrl.featureFlag.VIGENCIA_PROGRAMADA &amp;&amp; veiculoCtrl.getEditableRowsSelected().length &gt; 0 &amp;&amp; veiculoCtrl.roleVigenciaProgramadaVisualizar"><a ng-class="{\'option-disable\': veiculoCtrl.getEditableRowsSelected().length &gt; 1}" ng-click="veiculoCtrl.openConfigConducao(veiculoCtrl.getEditableRowsSelected())" uib-tooltip="{{ veiculoCtrl.getEditableRowsSelected().length &gt; 1 ? veiculoCtrl.tooltipDisabledMenu : \'\' }}"><i class="fv trimble-icon trimble-group"></i>{{ \'ce.cadastro.veiculos.menuOpcoes.programarConducao\' | translate }}<br/>({{veiculoCtrl.getEditableRowsSelected().length}}) {{ \'ce.cadastro.veiculos.menuOpcoes.selecionados\' | translate }}</a></li></ul></span></div></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/veiculo/hodometro-confirmacao.tpl.html',
    '<div class="modal-header bg-light-blue"><h3 class="modal-title">{{ \'ce.cadastro.veiculos.alteracaoHodometro.title\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div id="modal-body" class="modal-body"><div> \n' +
    '{{ \'ce.cadastro.veiculos.alteracaoHodometro.conteudoPt1\' | translate }} {{$ctrl.placa}} {{ \'ce.cadastro.veiculos.alteracaoHodometro.conteudoPt2\' | translate }} <strong>{{$ctrl.hodometro}} Km </strong>?</div></div><div class="modal-footer"><button ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.veiculos.alteracaoHodometro.btnSecundario\' | translate }}</button><button ng-click="$ctrl.ok()" class="btn btn-primary">{{ \'ce.cadastro.veiculos.alteracaoHodometro.btnPrimario\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/ponto-referencia/ponto-referencia.tpl.html',
    '<div class="alerta-aqui"></div><vtabela ng-if="!!pontoReferenciaCtrl.vtabela" id="cadastro-ponto" grid-options="pontoReferenciaCtrl.vtabela" analytics-category="Cadastros" analytics-label="Cadastro de Ponto de Referência"><div ng-if="pontoReferenciaCtrl.hasRoleVisualizar"></div><span class="fa-icon-left fa-icon-right text-muted">  </span><span uib-dropdown="uib-dropdown" uib-tooltip="{{pontoReferenciaCtrl.getMaisOpcoesMsg()}}" tooltip-placement="right" class="dropdown no-space"><strong uib-dropdown-toggle="uib-dropdown-toggle" ng-disabled="!pontoReferenciaCtrl.podeExibirOpcoes()" class="dropdown-toggle btn btn-sm btn-outline-blue">{{ \'ce.cadastro.pontosReferencia.maisOpcoes\' | translate }}<i class="fa fa-caret-down fa-icon-left"></i></strong><ul ui-dropdown-menu="ui-dropdown-menu" ng-if="true" class="dropdown-menu"><li><a href="#" ng-click="pontoReferenciaCtrl.abrirTempoPermanenciaConfig(pontoReferenciaCtrl.getEditableRowsSelected())"><i class="fa trimble-icon trimble-duration-stay"></i>{{ \'ce.cadastro.pontosReferencia.configurarTempo\' | translate }}<br/>{{ \'ce.cadastro.pontosReferencia.permanencia\' | translate }} ({{pontoReferenciaCtrl.getEditableRowsSelected().length}})</a></li><li><a href="#" ng-click="pontoReferenciaCtrl.abrirTempoPermanenciaConfig(pontoReferenciaCtrl.getEditableRowsSelected(), true)"><i class="fa trimble-icon trimble-duration-stay"></i>{{ \'ce.cadastro.pontosReferencia.removerTempo\' | translate }}<br/>{{ \'ce.cadastro.pontosReferencia.permanencia\' | translate }} ({{pontoReferenciaCtrl.getEditableRowsSelected().length}})</a></li><li ng-if="pontoReferenciaCtrl.podeExibirOpcoesImportacao()"><a href="#" ng-click="pontoReferenciaCtrl.abrirModalImportacao(pontoReferenciaCtrl.getEditableRowsSelected())" id="abrirModal"><i class="fa trimble-icon trimble-duration-stay"></i>{{ \'ce.cadastro.pontosReferencia.importar\' | translate }} ({{pontoReferenciaCtrl.getEditableRowsSelected().length}})</a></li><li ng-if="pontoReferenciaCtrl.isIntegrationCodeLandmarkEnabled &amp;&amp; pontoReferenciaCtrl.vtabela.rowsSelected.length === 1"><a href="#" ng-click="pontoReferenciaCtrl.abrirCodigoIntegracaoCadastro(pontoReferenciaCtrl.getEditableRowsSelected())"><i class="fa fa-pencil-square-o"></i>{{ \'ce.cadastro.pontosReferencia.configurarCodigo\' | translate }} ({{pontoReferenciaCtrl.getEditableRowsSelected().length}})</a></li><li ng-if="pontoReferenciaCtrl.isIntegrationCodeLandmarkEnabled &amp;&amp; pontoReferenciaCtrl.vtabela.rowsSelected.length &gt; 1"><a><i class="fa fa-pencil-square-o"></i>{{ \'ce.cadastro.pontosReferencia.selecionarApenasUmPonto\' | translate }}</a></li><li ng-if="pontoReferenciaCtrl.isIntegrationCodeLandmarkEnabled &amp;&amp; pontoReferenciaCtrl.vtabela.rowsSelected.length &gt; 0"><a ng-click="pontoReferenciaCtrl.abrirCodigoIntegracaoCadastro(pontoReferenciaCtrl.getEditableRowsSelected(), true)"><i class="fa fa-pencil-square-o"></i>{{ \'ce.cadastro.pontosReferencia.removerCodigo\' | translate }} ({{pontoReferenciaCtrl.getEditableRowsSelected().length}})</a></li></ul></span></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/motorista.tpl.html',
    '<div class="alerta-aqui-motorista"></div><vtabela ng-if="!!motoristaCtrl.vtabela" id="cadastro-motoristas" grid-options="motoristaCtrl.vtabela" analytics-category="Cadastros" analytics-label="Cadastro de Motoristas"><div id="botaoCadastrarMotorista"></div><div ng-if="motoristaCtrl.roleCadastrar &amp;&amp; motoristaCtrl.vtabela.grid.data.length &gt; 0 &amp;&amp; !motoristaCtrl.removeMoreOptions"><span class="fa-icon-left fa-icon-right text-muted"></span><span uib-dropdown="uib-dropdown" class="dropdown"><strong uib-dropdown-toggle="uib-dropdown-toggle" class="dropdown-toggle btn btn-sm btn-outline-blue">{{ \'ce.cadastro.motoristas.botao.maisOpcoes.label\' | translate }}<i class="fa fa-caret-down fa-icon-left"></i></strong><ul ui-dropdown-menu="ui-dropdown-menu" ng-if="motoristaCtrl.rowsAreValid()" class="dropdown-menu"><li ng-if="motoristaCtrl.vtabela.rowsSelected.length === 1 &amp;&amp; motoristaCtrl.vtabela.rowsSelected[0].ativo"><a ng-click="motoristaCtrl.abrirQrCode(motoristaCtrl.vtabela.rowsSelected[0])" class="button-link"><i class="fa fa-qrcode"></i>{{ \'ce.cadastro.motoristas.botao.maisOpcoes.qrCode\' | translate }}</a></li><li ng-if="motoristaCtrl.vtabela.rowsSelected.length &gt; 1"><a><i class="fa fa-qrcode"></i><span translate="ce.cadastro.motoristas.botao.maisOpcoes.qrCodeSelecioneApenas1Motorista"></span></a></li><li ng-if="motoristaCtrl.selecionouMotoristaInativo()"><a><i class="fa fa-qrcode"></i><span translate="ce.cadastro.motoristas.botao.maisOpcoes.qrCodeSelecione1MotoristaAtivo"></span></a></li><li ng-if="motoristaCtrl.motoristasEditaveis(false).length &gt; 0"><a ng-class="{\'option-disable\': motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length)}" uib-tooltip="{{ motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length) ? motoristaCtrl.tooltipApenas1Motorista : \'\' }}" ng-click="!motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length) &amp;&amp; motoristaCtrl.confirmacaoAtivar(motoristaCtrl.motoristasEditaveis(false))" class="button-link"><i class="fa fa-toggle-on text-success"></i><span ng-if="motoristaCtrl.vtabela.rowsSelected.length &gt; 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.ativarSelecionados" translate-values="{qtdeMotoristasEditaveis: motoristaCtrl.motoristasEditaveis(false).length}"></span><span ng-if="motoristaCtrl.vtabela.rowsSelected.length === 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.ativarTodos" translate-values="{qtdeMotoristasEditaveis: motoristaCtrl.motoristasEditaveis(false).length}"></span></a></li><li ng-if="motoristaCtrl.motoristasEditaveis(true).length &gt; 0"><a ng-class="{\'option-disable\': motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length)}" uib-tooltip="{{ motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length) ? motoristaCtrl.tooltipApenas1Motorista : \'\' }}" ng-click="!motoristaCtrl.disableAtivarInativar(motoristaCtrl.vtabela.rowsSelected.length) &amp;&amp; motoristaCtrl.confirmacaoInativar(motoristaCtrl.motoristasEditaveis(true))" class="button-link"><i class="fa fa-toggle-off"></i><span ng-if="motoristaCtrl.vtabela.rowsSelected.length &gt; 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.inativarSelecionados" translate-values="{qtdeMotoristasEditaveis: motoristaCtrl.motoristasEditaveis(true).length}"></span><span ng-if="motoristaCtrl.vtabela.rowsSelected.length === 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.inativarTodos" translate-values="{qtdeMotoristasEditaveis: motoristaCtrl.motoristasEditaveis(true).length}"></span></a></li><li ng-if="motoristaCtrl.hasMotoristasComEmail()"><a ng-click="motoristaCtrl.enviarEmails(motoristaCtrl.motoristasComEmail())" class="button-link"><i class="fa fa-share"></i><span ng-if="motoristaCtrl.vtabela.rowsSelected.length &gt; 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.enviarEmailParaSelecionados" translate-values="{qtdeMotoristasComEmail: motoristaCtrl.motoristasComEmail().length}"></span><span ng-if="motoristaCtrl.vtabela.rowsSelected.length === 0" translate="ce.cadastro.motoristas.botao.maisOpcoes.enviarEmailParaTodos" translate-values="{qtdeMotoristasComEmail: motoristaCtrl.motoristasComEmail().length}"></span></a></li><li ng-if="!motoristaCtrl.isNaUser &amp;&amp; motoristaCtrl.isGenerateCsvPhotosLinkEnabled"><a ng-if="!motoristaCtrl.handleCanGenerateLink()" class="button-link button-link-disabled"><i class="fa fa-file-excel-o"></i><span translate="ce.cadastro.motoristas.botao.maisOpcoes.selectOneDriverToSendLink"></span></a><a ng-if="motoristaCtrl.handleCanGenerateLink()" ng-click="motoristaCtrl.handleGenerateLink(motoristaCtrl.activeDrivers())" class="button-link"><i class="fa fa-file-excel-o"></i><span translate="ce.cadastro.motoristas.botao.maisOpcoes.sendLinkToSelectedDrivers" translate-values="{driversSelected: motoristaCtrl.activeDrivers().length}"></span></a></li></ul></span></div></vtabela>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/motorista-qrmodal.tpl.html',
    '<div class="modal-header modal-sucesso"><h3 id="modal-title" class="modal-title"><i class="fa fa-qrcode"></i>{{ \'ce.cadastro.motoristas.modal.qrCode.qeradoComSucesso\' | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div id="modal-body" class="modal-body"><a ng-click="$ctrl.download()" href="#"><!-- TODO: pesquisar como fazer mock de arquivos para ng src--><!-- img(src=\'/images/qrcode_sample.png\')--><img ng-src="{{$ctrl.qrCodeImage}}"/>{{ \'ce.cadastro.motoristas.modal.qrCode.fazerDownload\' | translate }}</a></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/motorista-link.tpl.html',
    '<div class="modal-header modal-sucesso"><h3 class="modal-title"><span translate="{{ \'ce.cadastro.motoristas.modal.link.title\' }}" translate-values="{driversSelected: $ctrl.motoristas.length}"></span><i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle cursor-pointer"></i></h3></div><div id="modal-body" class="modal-body"><div><span translate="{{ \'ce.cadastro.motoristas.modal.link.text\' }}" translate-values="{driversSelected: $ctrl.motoristas.length}"></span></div></div><div class="modal-footer"><button ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isLoading" class="btn btn-default">{{ \'ce.cadastro.motoristas.modal.email.botao.cancelar\' | translate }}</button><button ng-click="$ctrl.generateLink()" ng-disabled="$ctrl.isLoading" class="btn btn-success">{{ \'ce.cadastro.motoristas.modal.link.button\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/motorista-emailmultiplomodal.tpl.html',
    '<div class="modal-header modal-sucesso"><h3 class="modal-title"><i class="fa fa-envelope"></i><span translate="ce.cadastro.motoristas.modal.email.enviarLinkParaXusuarios" translate-values="{qtdeMotoristas: $ctrl.motoristas.length}"></span><i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div id="modal-body" class="modal-body"><div ng-show="$ctrl.enviando"><span>{{ \'ce.cadastro.motoristas.modal.email.aguarde\' | translate }}</span><i class="fa fa-spinner fa-spin"></i></div><div ng-if="!$ctrl.result" ng-hide="$ctrl.enviando"><span translate="ce.cadastro.motoristas.modal.email.desejaEnviarLinkParaXusuariosSelecionados" translate-values="{qtdeMotoristas: $ctrl.motoristas.length}"></span></div><div ng-if="$ctrl.result">{{ $ctrl.result.message | translate }}</div></div><div class="modal-footer"><button ng-if="$ctrl.result" ng-disabled="$ctrl.enviando" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.motoristas.modal.email.botao.fechar\' | translate }}</button><button ng-if="!$ctrl.result" ng-disabled="$ctrl.enviando" ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.motoristas.modal.email.botao.cancelar\' | translate }}</button><button ng-if="!$ctrl.result" ng-disabled="$ctrl.enviando" ng-click="$ctrl.enviarEmails()" class="btn btn-success">{{ \'ce.cadastro.motoristas.modal.email.botao.enviar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/motorista/motorista-confirmacao.tpl.html',
    '<div ng-if="$ctrl.ativando" class="modal-header modal-sucesso"><h3 class="modal-title">{{ $ctrl.getTitle() | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div ng-if="!$ctrl.ativando" class="modal-header bg-red"><h3 class="modal-title">{{ $ctrl.getTitle() | translate }}<i ng-click="$ctrl.cancel()" class="pull-right fa fa-times-circle"></i></h3></div><div id="modal-body" class="modal-body"><div><span translate="{{ $ctrl.mostrarTexto() }}" translate-values="{qtdeMotoristas: $ctrl.motoristas.length}"></span></div></div><div class="modal-footer"><button ng-click="$ctrl.cancel()" class="btn btn-default">{{ \'ce.cadastro.motoristas.modal.confirmacao.botao.cancelar\' | translate }}</button><button ng-if="$ctrl.ativando" ng-click="$ctrl.confirmacaoAtivar()" class="btn btn-success">{{ \'ce.cadastro.motoristas.modal.confirmacao.botao.ativar\' | translate }}</button><button ng-if="!$ctrl.ativando" ng-click="$ctrl.confirmacaoInativar()" class="btn btn-danger">{{ \'ce.cadastro.motoristas.modal.confirmacao.botao.inativar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/macro/macro.tpl.html',
    '<div id="safety-macro-page"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/macro/form-macro.tpl.html',
    '<div id="safety-macro-group-form"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('cadastros/grupo-veic/grupo-veic.tpl.html',
    '<div id="grupo-veic"><div class="alerta-aqui"></div><vtabela ng-if="!!ctrl.vtabela" id="grupo-veic" grid-options="ctrl.vtabela" analytics-category="Cadastros" analytics-label="GrupoVeiculo"><button type="button" ng-if="ctrl.hasRoleEditarGrupo" ng-click="ctrl.modalForm()" class="btn btn-success btn-sm"><i class="fa fa-plus fa-icon-right"></i>{{ \'ce.cadastro.grupoDeVeiculos.botaoCadastrar\' | translate }}</button></vtabela></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('unauthorized-na-user/unauthorized-na-user.tpl.html',
    '<div class="unauthorized-page"><div class="content"> <h1>Oops, something is missing! </h1><p>You don\'t have permision to view this page at this time.</p></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('template/pagination-template.html',
    '<small id="pagination-total" class="pagination-total">{{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.exibindo\' | translate }} {{((currentPage * stItemsByPage) - stItemsByPage) + 1}} -\n' +
    '{{(currentPage==numPages) ? totalItemCount : currentPage * stItemsByPage}}\n' +
    '{{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.doTotalDe\' | translate }} {{totalItemCount}} {{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.registros\' | translate }}</small><div class="clearfix"></div><nav id="pagination-footer" ng-if="numPages &amp;&amp; pages.length &gt;= 2" class="pagination-footer"><ul class="pagination"><li ng-class="{disabled: currentPage==1}"><a id="pag-anterior" href="" aria-label="Anterior" ng-click="selectPage(currentPage-1)"><span aria-hidden="true">« {{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.anterior\' | translate }}</span></a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="" ng-click="selectPage(page)">{{page}}</a></li><li ng-class="{disabled: currentPage==numPages}"><a id="pag-proxima" href="" aria-label="Próxima" ng-click="selectPage(currentPage+1)"><span aria-hidden="true">{{ \'ce.analise.solicitacoesAgendadas.tabela.pagination.proxima\' | translate }} »</span></a></li></ul></nav>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('relatorios/resumo-periodo.tpl.html',
    '<div class="resumo-periodo"><div class="box-header"><h5 uib-tooltip="{{ctrl.tituloCustomizado(false)}}" tooltip-placement="right" tooltip-enable="{{ctrl.enableTooltipTitulo}}" class="text-title box-title">{{ctrl.tituloCustomizado(true)}}</h5></div><div class="box-body"><div class="dados-conducao"><ul class="list-unstyled list-group list-group-unbordered"><li id="resumo-periodo"><h4 class="text-primary"><i class="fa fa-truck margin-r-5"></i><strong uib-tooltip="{{ \'ce.resumoPeriodo.outros\' | translate }} {{ctrl.subtituloCustomizado(false)}}" tooltip-placement="right" tooltip-enable="{{ctrl.scope.subtitulo.length &gt; 1}}">{{ctrl.subtituloCustomizado(true)}}</strong></h4></li><li ng-if="duracao"><i class="fa fa-clock-o margin-r-5"></i>{{ duracao ? (duracao | humanizedDuration) : \'ce.resumoPeriodo.vigente\' | translate }}</li><li><i class="fa fa-tachometer margin-r-5"></i><span ng-if="distancia &gt;= 0 &amp;&amp; ctrl.distanceUnit === &quot;Km&quot;">{{ distancia | decimalWithLabel: ctrl.distanceUnit }} {{ \'ce.resumoPeriodo.percorridos\' | translate }}</span><span ng-if="distancia &gt;= 0 &amp;&amp; ctrl.distanceUnit !== &quot;Km&quot;">{{ distancia | decimalPointWithLabel: ctrl.distanceUnit }} {{ \'ce.resumoPeriodo.percorridos\' | translate }}</span><span ng-if="distancia &lt; 0">-</span></li><li ng-if="consumoCombustivel" class="consumo-combustivel"><i class="fa trimble icon trimble-gas-pump margin-r-5"></i><span ng-if="ctrl.fuelUnit === \'L\'">{{ consumoCombustivel | decimalWithLabel: ctrl.fuelUnit }}</span><span ng-if="ctrl.fuelUnit !== \'L\'">{{ consumoCombustivel | decimalPointWithLabel: ctrl.fuelUnit }}</span></li><li ng-if="mediaConsumo" title="{{ \'ce.resumoPeriodo.mediaConsumo\' | translate }}" class="media-consumo-combustivel"><i class="fa trimble icon trimble-average-consuption margin-r-5"></i><span ng-if="ctrl.fuelUnit === \'L\'">{{ mediaConsumo | number: 2 | withLabel: ctrl.fuelEfficiency }}</span><span ng-if="ctrl.fuelUnit !== \'L\'">{{ mediaConsumo | numberWithPoint: 2 | withLabel: ctrl.fuelEfficiency }}</span></li><li ng-if="consumoEletrico" class="consumo-eletrico"><i class="fa trimble icon trimble-gas-pump margin-r-5"></i><span ng-if="ctrl.distanceUnit === &quot;Km&quot;">{{ consumoEletrico | decimalWithLabel: ctrl.energyUnit }}</span><span ng-if="ctrl.distanceUnit !== &quot;Km&quot;">{{ consumoEletrico | decimalPointWithLabel: ctrl.energyUnit }}</span></li><li ng-if="mediaConsumoEletrico" title="{{ \'ce.resumoPeriodo.mediaConsumoEletrico\' | translate }}" class="media-consumo-eletrico"><i class="fa trimble icon trimble-average-consuption margin-r-5"></i><span ng-if="ctrl.distanceUnit === &quot;Km&quot;">{{ mediaConsumoEletrico | number: 2 | withLabel: ctrl.energyEfficiency }}</span><span ng-if="ctrl.distanceUnit !== &quot;Km&quot;">{{ mediaConsumoEletrico | numberWithPoint: 2 | withLabel: ctrl.energyEfficiency }}</span></li><li ng-if="logradouroInicio !== \'\'"><i class="fa fa-flag-o margin-r-5"></i>{{ logradouroInicio }}</li><li ng-if="logradouroFim !== \'\'"><i class="fa fa-flag-checkered margin-r-5"></i>{{ logradouroFim }}</li><li ng-if="diferencaAltitude"><div class="flex centralizado"><span uib-tooltip="{{ \'ce.resumoPeriodo.tooltipAltitude\' | translate }}" tooltip-placement="rigth" class="material-symbols-filled icone-elevation margin-r-5">elevation</span>{{ diferencaAltitude }}m</div></li></ul></div><div ng-repeat="tipo in [\'posicoes\', \'posicoesIgnoradas\']" ng-attr-id="{{tipo === \'posicoes\' ? \'lista-eventos\' : \'lista-eventos-ignorados\'}}" ng-if="ctrl.eventosAgrupados.length &gt; 0 &amp;&amp; (tipo === \'posicoesIgnoradas\' ? ctrl.hasIgnoredEvents &amp;&amp; ctrl.feature462 : true)" class="lista-eventos"><h4 ng-if="tipo === \'posicoes\' &amp;&amp; ctrl.handleCheckEventsPosicoes(\'posicoes\')">{{ \'ce.resumoPeriodo.eventos\' | translate }}</h4><div ng-if="tipo === \'posicoesIgnoradas\' &amp;&amp; ctrl.handleCheckEventsPosicoes(\'posicoesIgnoradas\')" class="posicoes-ignoradas"><h4><i class="material-icons">label_off</i>{{ \'ce.resumoPeriodo.eventosDesconsiderados\' | translate }}</h4><p>{{ \'ce.resumoPeriodo.eventosDesconsideradosSubtitle\' | translate }}</p></div><ul class="list-group"><li ng-repeat="agrupamento in ctrl.eventosAgrupados" ng-if="ctrl.getEventByName(agrupamento.nome) &amp;&amp; agrupamento[tipo].length &gt; 0" class="list-group-item"><a href="#" ng-click="ctrl.onClick(agrupamento, tipo)" class="small agrupador-eventos"><i ng-class="ctrl.getEventByName(agrupamento.nome).icon" class="icone-esquerda"></i><span>{{ agrupamento.nome }}</span><span ng-class="{\'bg-green\' : rpmExcessivo === 0}" class="pull-right badge bg-red"><span ng-if="rpmExcessivo !== 0 &amp;&amp; todosSegmentos">~</span>{{ ctrl.getEventByName(agrupamento.nome).valueType == \'duration\' ? ((tipo == \'posicoesIgnoradas\' ? agrupamento.duracaoIgnorada : agrupamento.duracao) | humanizedDuration) : agrupamento[tipo].length }}</span></a><ul uib-collapse="ctrl.eventoSelecionado !== agrupamento.nome || ctrl.eventoTipoSelecionado !== tipo" class="lista-posicoes collapse list-group"><li ng-repeat="posicao in agrupamento[tipo]" class="item-lista-posicoes list-group-item"><div class="dados-posicao"><a href="#" ng-click="onClickPosicao(posicao)" ng-if="posicao.valida"><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.PARADO_LIGADO])"><i class="fa fa-clock-o"></i>{{ posicao.intensidade || \'-\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.RPM_EXCESSIVO])"><i class="fa fa-dashboard"></i>{{ posicao.intensidade || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + \' s\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, ctrl.eventsWithDatePosition)"><i class="fa fa-clock-o"></i>{{ (posicao.data | date:"HH:mm:ss" ) }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.BANGUELA])"><i class="fa fa-dashboard"></i>{{ ctrl.formatarVelocidadeMaximaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-arrow-right"></i>{{ ctrl.formatarVelocidadeMinimaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + " s"}}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.EXCESSO_VELOCIDADE_VIA, ctrl.eventosEnum.EXCESSO_VELOCIDADE])"><i class="fa fa-dashboard"></i>{{ posicao.velocidade + " " + ctrl.speedUnit + " " || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.SENSOR_ACIONADO])"><i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(descidaFaixa.nome, [ctrl.eventosEnum.DESCIDA_FAIXA1,     ctrl.eventosEnum.DESCIDA_FAIXA2, ctrl.eventosEnum.DESCIDA_FAIXA3])" class="texto-posicao-descida"><span class="texto-descido-data">{{ \'ce.resumoPeriodo.inicio\' | translate }}</span><span>{{ posicao.data | date:"HH:mm:ss" }}</span><span class="texto-descido-data">{{ \'ce.resumoPeriodo.fim\' | translate }}</span><span>{{ posicao.fim.data | date:"HH:mm:ss" }}<i uib-tooltip="{{ \'ce.resumoPeriodo.tooltipTempoDescida\' | translate }}" tooltip-placement="above" class="fa fa-clock-o icon-relogio-tempo-descida"></i>{{ posicao.miscInfo.segundosFreioPressionado }}s</span></small></a><span ng-if="!posicao.valida"><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.PARADO_LIGADO])"><i class="fa fa-clock-o"></i>{{ posicao.intensidade || \'-\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.RPM_EXCESSIVO])"><i class="fa fa-dashboard"></i>{{ posicao.intensidade || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + \' s\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, ctrl.eventsWithDatePosition)"><i class="fa fa-clock-o"></i>{{ (posicao.data | date:"HH:mm:ss" ) }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.BANGUELA])"><i class="fa fa-dashboard"></i>{{ ctrl.formatarVelocidadeMaximaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-arrow-right"></i>{{ ctrl.formatarVelocidadeMinimaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + " s"}}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.EXCESSO_VELOCIDADE_VIA, ctrl.eventosEnum.EXCESSO_VELOCIDADE])"><i class="fa fa-dashboard"></i>{{ posicao.velocidade + " " + ctrl.speedUnit + " " || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.SENSOR_ACIONADO])"><i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(descidaFaixa.nome, [ctrl.eventosEnum.DESCIDA_FAIXA1,     ctrl.eventosEnum.DESCIDA_FAIXA2, ctrl.eventosEnum.DESCIDA_FAIXA3])" class="texto-posicao-descida"><span class="texto-descido-data">{{ \'ce.resumoPeriodo.inicio\' | translate }}</span><span>{{ posicao.data | date:"HH:mm:ss" }}</span><span class="texto-descido-data">{{ \'ce.resumoPeriodo.fim\' | translate }}</span><span>{{ posicao.fim.data | date:"HH:mm:ss" }}<i uib-tooltip="{{ \'ce.resumoPeriodo.tooltipTempoDescida\' | translate }}" tooltip-placement="above" class="fa fa-clock-o icon-relogio-tempo-descida"></i>{{ posicao.miscInfo.segundosFreioPressionado }}s</span></small></span><span ng-if="posicao.gps !== &quot;Precisão alta&quot;" class="text-center"><i uib-popover-html="ctrl.getPopoverContent()" popover-title="{{ \'ce.resumoPeriodo.popOverTitulo\' | translate }}" popover-trigger="&quot;outsideClick&quot;" popover-class="popover-gps-invalido" popover-placement="top" class="fv trimble-help v3g-text-alt-red circulo-precisao-red"></i></span></div><small ng-if="posicao.videoId || posicao.snapshotId"><event-viewer-link id-video="{{posicao.videoId}}" snapshot-id="{{posicao.snapshotId}}" datahora="{{posicao.data}}" tipo-evento="{{ ctrl.getTipoAlerta(posicao.evento) }}" vehicle-id="{{posicao.veiculo.id}}" vehicle-prefix="{{posicao.veiculo.prefixo}}" vehicle-plate="{{posicao.veiculo.placa}}" latitude="{{posicao.latitude}}" longitude="{{posicao.longitude}}" status-video="\'CONCLUIDO\'" ng-click="ctrl.onVideoClick()" class="bdx-detalhes-video-play-button"></event-viewer-link></small></li></ul></li></ul></div><div id="lista-freio-descidas" ng-if="ctrl.descidasAgrupadas.length &gt; 0" class="lista-eventos"><h4>{{ \'ce.resumoPeriodo.pedalAcionadoDescidas\' | translate }}</h4><ul class="list-group"><li ng-repeat="descidaFaixa in ctrl.descidasAgrupadas" ng-if="descidaFaixa.posicoes.length &gt; 0" class="list-group-item"><a href="#" ng-click="ctrl.onClick(descidaFaixa)" class="small agrupador-eventos"><div class="linha-faixa"><span class="texto-faixa-descida">{{ ctrl.getTextoFaixaDescida(descidaFaixa.nome) | translate }}:</span><i class="fa fa-clock-o icon-relogio-descida"></i><span class="texto-tempo-faixa-descida">{{ ctrl.getTextoTempoFaixaDescida(descidaFaixa.nome) | translate }}</span><span uib-tooltip="{{ \'ce.resumoPeriodo.tooltipIconDescida\' | translate }}" tooltip-placement="right" class="material-symbols-outlined descida-icon-rotate">local_shipping<span class="descida-underline-icon"></span></span><span class="texto-qtd-descidas">{{ descidaFaixa.posicoes.length }}x</span><span class="pull-right badge bg-red duracao-freio-descidas">{{ (descidaFaixa.duracao | humanizedDuration) }}</span></div></a><ul uib-collapse="ctrl.eventoSelecionado !== descidaFaixa.nome" class="lista-posicoes collapse list-group"><li ng-repeat="posicao in descidaFaixa.posicoes" class="item-lista-posicoes list-group-item"><div class="dados-posicao"><a href="#" ng-click="onClickPosicao(posicao, true)" ng-if="posicao.valida"><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.PARADO_LIGADO])"><i class="fa fa-clock-o"></i>{{ posicao.intensidade || \'-\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.RPM_EXCESSIVO])"><i class="fa fa-dashboard"></i>{{ posicao.intensidade || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + \' s\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, ctrl.eventsWithDatePosition)"><i class="fa fa-clock-o"></i>{{ (posicao.data | date:"HH:mm:ss" ) }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.BANGUELA])"><i class="fa fa-dashboard"></i>{{ ctrl.formatarVelocidadeMaximaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-arrow-right"></i>{{ ctrl.formatarVelocidadeMinimaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + " s"}}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.EXCESSO_VELOCIDADE_VIA, ctrl.eventosEnum.EXCESSO_VELOCIDADE])"><i class="fa fa-dashboard"></i>{{ posicao.velocidade + " " + ctrl.speedUnit + " " || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.SENSOR_ACIONADO])"><i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(descidaFaixa.nome, [ctrl.eventosEnum.DESCIDA_FAIXA1,     ctrl.eventosEnum.DESCIDA_FAIXA2, ctrl.eventosEnum.DESCIDA_FAIXA3])" class="texto-posicao-descida"><span class="texto-descido-data">{{ \'ce.resumoPeriodo.inicio\' | translate }}</span><span>{{ posicao.data | date:"HH:mm:ss" }}</span><span class="texto-descido-data">{{ \'ce.resumoPeriodo.fim\' | translate }}</span><span>{{ posicao.fim.data | date:"HH:mm:ss" }}<i uib-tooltip="{{ \'ce.resumoPeriodo.tooltipTempoDescida\' | translate }}" tooltip-placement="above" class="fa fa-clock-o icon-relogio-tempo-descida"></i>{{ posicao.miscInfo.segundosFreioPressionado }}s</span></small></a><span ng-if="!posicao.valida"><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.PARADO_LIGADO])"><i class="fa fa-clock-o"></i>{{ posicao.intensidade || \'-\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.RPM_EXCESSIVO])"><i class="fa fa-dashboard"></i>{{ posicao.intensidade || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + \' s\' }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, ctrl.eventsWithDatePosition)"><i class="fa fa-clock-o"></i>{{ (posicao.data | date:"HH:mm:ss" ) }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.BANGUELA])"><i class="fa fa-dashboard"></i>{{ ctrl.formatarVelocidadeMaximaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-arrow-right"></i>{{ ctrl.formatarVelocidadeMinimaBanguela(posicao.intensidade) + " " + ctrl.speedUnit + " " }}<i class="fa fa-clock-o"></i>{{ posicao.duracao + " s"}}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.EXCESSO_VELOCIDADE_VIA, ctrl.eventosEnum.EXCESSO_VELOCIDADE])"><i class="fa fa-dashboard"></i>{{ posicao.velocidade + " " + ctrl.speedUnit + " " || \'-\' }}<i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(agrupamento.nome, [ctrl.eventosEnum.SENSOR_ACIONADO])"><i class="fa fa-clock-o"></i>{{ posicao.duracao | humanizedDuration }}</small><small ng-if="ctrl.isAnyOfTheseEvents(descidaFaixa.nome, [ctrl.eventosEnum.DESCIDA_FAIXA1,     ctrl.eventosEnum.DESCIDA_FAIXA2, ctrl.eventosEnum.DESCIDA_FAIXA3])" class="texto-posicao-descida"><span class="texto-descido-data">{{ \'ce.resumoPeriodo.inicio\' | translate }}</span><span>{{ posicao.data | date:"HH:mm:ss" }}</span><span class="texto-descido-data">{{ \'ce.resumoPeriodo.fim\' | translate }}</span><span>{{ posicao.fim.data | date:"HH:mm:ss" }}<i uib-tooltip="{{ \'ce.resumoPeriodo.tooltipTempoDescida\' | translate }}" tooltip-placement="above" class="fa fa-clock-o icon-relogio-tempo-descida"></i>{{ posicao.miscInfo.segundosFreioPressionado }}s</span></small></span><span ng-if="posicao.gps !== &quot;Precisão alta&quot;" class="text-center"><i uib-popover-html="ctrl.getPopoverContent()" popover-title="{{ \'ce.resumoPeriodo.popOverTitulo\' | translate }}" popover-trigger="&quot;outsideClick&quot;" popover-class="popover-gps-invalido" popover-placement="top" class="fv trimble-help v3g-text-alt-red circulo-precisao-red"></i></span></div></li></ul></li></ul></div><div ng-if="ctrl.deveExibirFaixasRpm()" class="faixas-rpm"><h4>{{ \'ce.resumoPeriodo.faixasDeRPM.titulo\' | translate }}</h4><ul class="list-group"><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.marchaLenta\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmMarchaLentaTempo | humanizedDuration }}</span></li><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.abaixoDaVerde\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmAbaixoVerdeTempo | humanizedDuration }}</span></li><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.verdeEconomico\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmVerdeEconomicaTempo | humanizedDuration }}</span></li><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.verdePotencia\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmVerdePotenciaTempo | humanizedDuration }}</span></li><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.amarela\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmAmareloTempo | humanizedDuration }}</span></li><li class="list-group-item small">{{ \'ce.resumoPeriodo.faixasDeRPM.vermelha\' | translate }}<span class="badge bg-red">{{ tempoPorFaixaRpm.rpmVermelhoTempo | humanizedDuration }}</span></li></ul></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('quadro-ocorrencias/quadro-ocorrencias.tpl.html',
    '<div class="toolbar-ocorrencias"><div class="select-container"><label for="select-cards-order" class="select-label">{{ \'ce.tempoReal.quadroDeOcorrencias.order\' | translate }}</label><select id="select-cards-order" name="select-cards-order" ng-model="ctrl.cardsOrder" ng-change="ctrl.onChangeCardsOrder()" class="select-box"><option ng-repeat="option in ctrl.cardsOrderOptions" value="{{option.key}}" class="select-option">{{ option.label | translate }}</option><div class="select-arrow"></div></select></div><div id="openDialogEventPriority"></div><a id="occurrences-board-detailed-history-btn" href="/relatorios/historico-ocorrencia" target="_blank" class="btn btn-sm btn-outline-blue"><i class="trimble-history fa-icon-right"></i>{{ "ce.tempoReal.quadroDeOcorrencias.linkVerHistorico" | translate }}</a></div><div id="abrirModal"></div><div id="openAlert"></div><div id="quadro-ocorrencias"><div class="row quadro-row"><div ng-if="ctrl.loaded" class="col-md-12"><div role="alert" class="alert alert-warning">{{ "ce.tempoReal.quadroDeOcorrencias.nenhumaOcorrenciaGerada" | translate }}</div></div><div ng-if="!ctrl.hasConfigs" class="col-md-12"><div role="alert" ng-bind-html="ctrl.entreEmContatoI18N" class="alert alert-no-configs"></div></div><div ng-if="ctrl.errorRequest" class="col-md-12"><div role="alert" class="alert alert-danger">{{ "ce.tempoReal.quadroDeOcorrencias.erroBuscarOcorrencia" | translate }}</div></div><div ng-if="ctrl.ocorrencias.length &amp;&amp; !ctrl.errorRequest" class="quadro-container"><div ng-repeat="col in ctrl.ocorrenciasEnum.getKeys()" class="col-md-4 col-xs-4"><div class="coluna novas"><div class="header row"><div class="col-xs-12"><div class="title col-xs-8"><span data-testid="quadro-ocorrencias-status-{{ctrl.ocorrenciasEnum.getStatusById(col).id}}">{{ ctrl.ocorrenciasEnum.getStatusById(col).title | translate }}</span></div><div class="qtd-ocorrencias col-xs-4 text-right"><span data-testid="quadro-ocorrencias-status-{{ctrl.ocorrenciasEnum.getStatusById(col).id}}-quantidade" class="pull-right badge bg-qtd">{{ ctrl.ocorrenciasByStatus[col].length }}</span></div><div class="col-xs-12 borda-title"></div></div></div><div id="{{col}}" class="cards"><div ng-repeat="ocorrencia in (ctrl.ocorrenciasByStatus[col] | orderBy:&quot;+&quot;)                 track by ctrl.generateIdTrackBy(ocorrencia)" ng-click="ctrl.openDetalhes(ocorrencia)" class="ocorrencia"><ocorrencia-card ocorrencia="ocorrencia" events-order="ctrl.eventsOrder"></ocorrencia-card></div></div></div></div></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('prontuario-v2/prontuario.tpl.html',
    '<div ng-if="!prontuario.featurehubJsSdk.isFeatureEnabled(\'LAINT36_remove_prontuario_button\')" class="custom-prontuario-button"><a ng-href="{{prontuario.handleGoToOldProntuario()}}" class="btn btn-default"><i class="material-symbols-outlined">sync_alt</i>{{ \'ce.ranking.motoristas.prontuario.alterarVersao\' | translate }}</a></div><div id="safety-driver-record"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('prontuario/prontuario.tpl.html',
    '<div class="custom-prontuario-button"><a ng-href="{{prontuario.handleGoToNewProntuario()}}" class="btn btn-default"><i class="material-symbols-outlined">sync_alt</i>{{ \'ce.ranking.motoristas.prontuario.alterarVersao\' | translate }}</a></div><div id="prontuario-tassi"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('productivity-report/productivity-report.tpl.html',
    '<div id="safety-productivity-report"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('productivity-indicators/productivity-indicators.tpl.html',
    '<div id="safety-productivity-indicators"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('planos-solucoes-usuario-novo/planos-solucoes.tpl.html',
    '<div ng-controller="PlanosSolucoesNovoUsuarioCtrl as ctrl" class="planos-solucoes"><vfwc-contratacao-planos bg-image="images/bg-planos-solucoes.png" ng-if="!ctrl.shouldDisplayUnauthorizedPage" class="page-component"></vfwc-contratacao-planos><div ng-if="ctrl.shouldDisplayUnauthorizedPage" class="unauthorized-page"><div class="content"><h1>Oops, something is missing!</h1><p>You don\'t have permission to view this page at this time.</p></div></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('planos-solucoes/planos-solucoes.tpl.html',
    '<div class="planos-solucoes"><vfwc-contratacao-planos bg-image="images/bg-planos-solucoes.png" class="page-component"></vfwc-contratacao-planos></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/one-page.tpl.html',
    '<div class="toggle-titulo"><div class="text-right"><span>{{ \'ce.tempoReal.statusFrota.common.verEmGrafico\' | translate }} </span><toggle ng-model="onePage.grafico" ng-change="onePage.graficoCard(onePage.grafico)" off="" on="" onstyle="btn-success" offstyle="btn-default" style="tipo-ios" size="btn-xs"></toggle><div uib-dropdown="uib-dropdown" class="config-one-page"><span id="config-onepage" ng-class="{\'text-danger\': onePage.edicaoGridster, \'text-primary\': !onePage.edicaoGridster}" uib-dropdown-toggle="uib-dropdown-toggle"><i class="fa fa-cog"></i></span><ul uib-dropdown-menu="uib-dropdown-menu" class="dropdown-menu-right"><li><a id="habilitar-edicao" href="#" ng-click="onePage.statusGridster()"> <i ng-if="onePage.edicaoGridster" class="fa fa-lock"></i><i ng-if="!onePage.edicaoGridster" class="fa fa-unlock"></i>{{ onePage.isEdicaoGridster() }}</a></li><li><a id="abrir-modal" href="#" ng-click="onePage.voltarPadrao()"><i class="fa fa-reply"></i>{{ \'ce.tempoReal.statusFrota.common.voltarPadraoVfleets\' | translate }}</a></li></ul></div></div></div><grafico-one-page-directive ng-if="onePage.grafico === true"></grafico-one-page-directive><card-one-page-directive ng-if="onePage.grafico === false"></card-one-page-directive>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('one-page/one-page-padrao.tpl.html',
    '<div class="modal-header bg-blue"><h3 class="modal-title">{{ \'ce.tempoReal.statusFrota.common.voltarLayoutPadrao\' | translate }}</h3></div><div class="modal-body"><p>{{ \'ce.tempoReal.statusFrota.common.infoSobreVoltarLayout\' | translate }}</p><p>{{ \'ce.tempoReal.statusFrota.common.infoSobreMudarPosicionamentoCard\' | translate }} <i class="fa fa-cog"></i><strong> > {{ \'ce.tempoReal.statusFrota.common.habilitarEdicao\' | translate }}.</strong></p></div><div class="modal-footer"><button id="modal-nao" type="button" ng-click="$ctrl.modalInstance.dismiss()" class="btn btn-default">{{ \'ce.tempoReal.statusFrota.common.nao\' | translate }}</button><button id="modal-sim" type="button" ng-click="$ctrl.modalInstance.close()" class="btn btn-primary">{{ \'ce.tempoReal.statusFrota.common.msgConfirmacao\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas-grid/mapas-grid.tpl.html',
    '<div class="alerta-absolute-tl"><div class="alerta-aqui"></div></div><leaflet id="mapaPrincipal" lf-center="mapasGrid.center" tiles="mapasGrid.tiles" geojson="mapasGrid.geoJson" defaults="mapasGrid.defaults" event-broadcast="events" watch-markers="no" width="100%" class="leaflet-mobile"><map-control id-ponto="mapasGrid.filtroPontoReferencia" id-mapa="&quot;mapaPrincipal&quot;"></map-control><map-layer-switcher on-layer-switch="mapasGrid.onLayerSwitch(layerWrapper)"></map-layer-switcher><toggle-layer-markers></toggle-layer-markers></leaflet><div growl="growl"></div><div ng-init="mapasGrid.exibicao; mapasGrid.showMenu" ng-class="mapasGrid.showMenu ? &quot;mapas-grid-sidebar-enabled&quot; : &quot;mapas-grid-sidebar-disabled&quot;" class="mapas-grid"><i ng-class="mapasGrid.exibicao ? &quot;fa-caret-down icon-up&quot; : &quot;fa-caret-up icon-down&quot;" ng-click="mapasGrid.toggleShowGrid()" class="fa toggle-table-mapas-grid"></i><div ng-class="mapasGrid.exibicao ? &quot;tabela-mapas-grid-enable&quot; : &quot;tabela-mapas-grid-disable&quot;" class="vtabela-box"><vtabela ng-if="!!mapasGrid.vtabela" id="mapas-grid" grid-options="mapasGrid.vtabela" analytics-category="Mapas" analytics-label="Mapas Grid" class="vtabela"><div ng-if="!mapasGrid.vtabela.error"><span uib-dropdown="uib-dropdown" tooltip-enable="!mapasGrid.isMenuHabilitado()" uib-tooltip="{{mapasGrid.tooltipMsg()}}" tooltip-placement="right" class="dropdown"><strong uib-dropdown-toggle="uib-dropdown-toggle" ng-disabled="!mapasGrid.isMenuHabilitado()" class="dropdown-toggle btn btn-sm btn-outline-blue">{{ \'ce.mapa.localizacaoDaFrota.maisOpcoesBotao\' | translate }}<i class="fa fa-caret-down fa-icon-left"></i></strong><ul ui-dropdown-menu="ui-dropdown-menu" class="dropdown-menu"><li ng-if="mapasGrid.permissaoComandoEditar"><a href="#" ng-class="{\'option-disable\': !mapasGrid.podeEnviarComando()}" uib-tooltip="{{ mapasGrid.podeEnviarComando() ? \'\' : mapasGrid.tooltipDisabledMenuComando }}" ng-click="mapasGrid.modalEnviarComando()"><i class="fa fa-bullhorn"></i><span>{{ \'ce.mapa.localizacaoDaFrota.enviarComandoLink\' | translate }} ({{mapasGrid.vtabela.rowsSelected.length}})</span></a></li><li ng-if="mapasGrid.permissaoComandoVisualizar"><a ng-click="mapasGrid.goHistComandos()"><i class="fa fa-bullhorn"></i><span>{{ \'ce.mapa.localizacaoDaFrota.historicoDeComandos\' | translate }} ({{mapasGrid.vtabela.rowsSelected.length}})</span></a></li></ul></span></div></vtabela></div></div><div id="dialog-vehicle-health"></div><div id="container-delete-confirm"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapas/mapa.tpl.html',
    '<leaflet lf-center="mapas.center" tiles="mapas.tiles.veltec" markers="mapas.markers" defaults="defaults" width="900px" height="480px"></leaflet><div class="box box-success coordenadas"><div class="box-header with-border">{{ mapas.posicao.logradouro }}</div><div class="box-body"><span>{{ mapas.posicao.cidade }} - {{ mapas.posicao.uf }}</span><br/><span>{{ mapas.posicao.latitude}}, {{ mapas.posicao.longitude }}</span></div></div><div class="close-button"><button type="button" data-widget="remove" ng-click="mapas.closeModal()" class="btn btn-primary btn-sm"><i class="fa fa-close"></i></button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('mapa-calor/mapa-calor.tpl.html',
    '<div class="alerta-absolute-tl"><div class="alerta-aqui"></div></div><div class="map-container"><leaflet id="leafletCalor" lf-center="mapaCalor.center" tiles="" defaults="mapaCalor.defaults" class="leaflet-mobile"></leaflet><div class="controle-camadas"><map-layer-switcher on-layer-switch="mapaCalor.onLayerSwitch(layerWrapper)" use-night-and-day-options="true"></map-layer-switcher></div><div class="right-info-container"><div class="toggle-sort-container"><div id="heat-map-absolute-tab" ng-class="mapaCalor.whichClicked === &quot;ABSOLUTO&quot; ? &quot;clicked&quot; : &quot;&quot;" ng-click="mapaCalor.toggleValueFlag(&quot;ABSOLUTO&quot;)" class="sort-by-absoluto">{{ \'ce.mapa.mapaDeCalor.absoluto\' | translate }}</div><div id="heat-map-percent-tab" ng-class="mapaCalor.whichClicked === &quot;PERCENTUAL&quot; ? &quot;clicked&quot; : &quot;&quot;" ng-click="mapaCalor.toggleValueFlag(&quot;PERCENTUAL&quot;)" class="sort-by-percentual">{{ \'ce.mapa.mapaDeCalor.percentual\' | translate }}</div></div><div class="card-container"><div ng-repeat="item in mapaCalor.ranking" ng-dblclick="mapaCalor.zoom()" ng-click="mapaCalor.pan(item)" id="heat-map-card-item-{{$index}}" class="cards heat-map-card-item"><div class="card-full card"><div class="card-principal"><div class="card-principal-identificacao"><div class="card-datetime"><a href="{{ mapaCalor.getLinkHistoricoDetalhado(item) }}">{{ item.dtt | date: \'dd/MM/yyyy HH:mm:ss\' }}</a></div>{{ item.pfx ? item.pfx  : "-" }}<br/>{{ item.plc }}</div><div class="card-principal-infracao"><div ng-if="mapaCalor.whichClicked === &quot;ABSOLUTO&quot;" ng-style="mapaCalor.getStyleCardContainer(item, &quot;ABSOLUTO&quot;)" class="card-principal-infracao-valor">{{ item.mainValue.ABSOLUTO }}{{ mapaCalor.getUnidadeMedida() }}</div><div ng-if="mapaCalor.whichClicked === &quot;PERCENTUAL&quot;" ng-style="mapaCalor.getStyleCardContainer(item, &quot;PERCENTUAL&quot;)" class="card-principal-infracao-valor">{{ item.mainValue.PERCENTUAL }}%</div><div class="card-principal-infracao-limites"><div>{{ \'ce.mapa.mapaDeCalor.maxima\' | translate }}<br/>{{ item.mainValue.ABSOLUTO }}<span>{{ mapaCalor.getUnidadeMedida() }}</span></div><div>{{ \'ce.mapa.mapaDeCalor.limite\' | translate }}<br/>{{ item.lim }}<span>{{ mapaCalor.getUnidadeMedida() }}</span></div></div></div></div><div ng-style="mapaCalor.getStyleLine(item)" class="card-line"></div></div></div></div></div></div><div class="mapa-calor-botoes"><div class="btn-group"><a ng-repeat="item in mapaCalor.listaMes" ng-click="mapaCalor.refresh(item)" href="#" ng-class="{&quot;active&quot; : mapaCalor.mesFocus === item}" id="heat-map-month-btn-{{$index}}" class="btn heat-map-month-btn">{{ mapaCalor.getMesExtenso(item) }}</a></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('informativo/informativo.tpl.html',
    '<div ng-show="!InformativoCtrl.isLoadingDependencies"><vfwc-informativo id="informativo-box"></vfwc-informativo></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/home.tpl.html',
    '');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/historico-timeline.tpl.html',
    '<div class="alerta-absolute-tl"><div class="alerta-aqui"></div></div><div class="historico-timeline-container"><div id="decoratedVideoPlayerModalContainer" class="detailed-history-video-player"></div><div ng-show="historicoTimeline.historicoCompleto.length &gt; 0 || historicoTimeline.filtroEventos.length &gt; 0" class="timeline-container"><div ng-if="!historicoTimeline.mostraVisaoCameras"><div id="historico"><div class="timeline-filtros"><div historico-timeline-dropdown-multiselect="{}" options="historicoTimeline.filtroEventos" selected-model="historicoTimeline.eventosAtivos" events="historicoTimeline.filtroEventosEvents" data-testid="historico-detalhado-filtro-eventos"></div><div class="checkbox-alert-tag"><input-checkbox name="check-alert-tag" ng-click="historicoTimeline.insertMarkers()" model="historicoTimeline.alertTagCheckbox"></input-checkbox><label for="check-alert-tag">{{ \'ce.mapa.historicoDetalhado.alertTagLabel\' | translate }}</label></div></div><div class="box-buttons"><a id="excel-btn" href="#" ng-click="historicoTimeline.downloadCsv()" data-testid="historico-detalhado-csv-button" class="btn btn-primary btn-xs"><span class="fa fa-download margin-r-5"></span>CSV</a><a href="#" ng-click="historicoTimeline.registerRoute()" ng-if="historicoTimeline.roleRotaEditar" class="btn btn-outline-blue btn-xs">{{ \'ce.mapa.historicoDetalhado.registerRoute\' | translate }}</a></div><ul id="timeline" class="timeline timeline-eventos"><li ng-repeat="evento in historicoTimeline.historicoCompleto" ng-if="historicoTimeline.handleCheckAlertTag(evento.historicos[0]) || evento.historicos.length &gt; 1" ng-class="{\'has-alert-tag\': !!evento.historicos[0].tagIgnoreEvent}"><i ng-class="collapseEventos ? \'evento-collapse-show\' : \'evento-collapse-hide\'" ng-click="collapseEventos = !collapseEventos" class="{{historicoTimeline.getIcon(evento)}}"></i><span ng-if="collapseEventos &amp;&amp; !historicoTimeline.verificaEventoDefault(evento) &amp;&amp; historicoTimeline.verificaSeTemEventos(evento.historicos)" class="label label-danger">{{historicoTimeline.retornaEventosFiltrados(evento.historicos)}}</span><div ng-if="historicoTimeline.verificaEventoDefault(evento)" class="timeline-item timeline-item-custom"><span id="timeline-data-{{evento.historicos[0].index}}" class="time"><i class="fa fa-clock-o margin-r-5"></i>{{evento.historicos[0].data | date:\'HH:mm:ss\'}}</span><h3 ng-if="evento.historicos[0].temCoordenada &amp;&amp; evento.historicos[0].exibirEvento" ng-class="{ \'tag-ignore-title\': evento.historicos[0].tagIgnoreEvent }"><tag-ignore event="evento.historicos[0].tagIgnoreEvent" size="small" position="left"></tag-ignore><a href="" ng-click="historicoTimeline.setFocusMap(evento.historicos[0])" data-testid="historico-timeline-event-card-event-name-{{evento.historicos[0].descricao}}" class="text-primary">{{evento.historicos[0].descricao}}</a><span>{{ historicoTimeline.mostrarDuracao(evento.historicos[0]) }}</span></h3><h3 ng-if="!evento.historicos[0].temCoordenada" ng-class="{ \'tag-ignore-title\': evento.historicos[0].tagIgnoreEvent }" class="text-muted"><tag-ignore event="evento.historicos[0].tagIgnoreEvent" size="small" position="left"></tag-ignore><div>{{evento.historicos[0].descricao}}<span>{{ historicoTimeline.mostrarDuracao(evento.historicos[0]) }}</span></div></h3><div ng-if="evento.historicos[0].meio === &quot;GTP&quot;" class="evento-tic card-tic"><div class="icon-tic"><span class="material-icons">hub</span></div><div class="texto-tic"><small>{{ \'ce.mapa.historicoDetalhado.eventoTic\' | translate }}</small></div></div><historico-timeline-directive item="evento.historicos[0]" historico-timeline="historicoTimeline"></historico-timeline-directive></div><div ng-if="!historicoTimeline.verificaEventoDefault(evento)" ng-class="{&quot;timeline-item-custom&quot;: !historicoTimeline.verificaSeTemEventos(evento.historicos) || collapseEventos}" data-testid="historico-timeline-event-card-event-time-{{evento.inicio}}" class="timeline-item"><span class="time"><i class="fa fa-clock-o margin-r-5"></i>{{evento.inicio | date:\'HH:mm:ss\'}}</span><h3 class="text-muted"><div><a href="" ng-if="historicoTimeline.temLocalizacao(evento)" ng-click="historicoTimeline.setMarkerAgrupamento(evento, evento.index)">{{evento.evento}}</a><span ng-if="!historicoTimeline.temLocalizacao(evento)" uib-tooltip-html="historicoTimeline.invalidPositionTooltip" tooltip-placement="top">{{evento.evento}}</span><span>{{ historicoTimeline.mostrarDuracao(evento) }}</span></div></h3><div ng-if="evento.movimentos.length &gt; 0 &amp;&amp; evento.movimentos[0].exibirEvento"><a ng-show="evento.movimentos.length &gt; 1" ng-click="isCollapsed = !isCollapsed" class="btn btn-primary btn-xs"><strong>{{evento.movimentos.length}}</strong> {{ \'ce.mapa.historicoDetalhado.eventos\' | translate }}</a><ul ng-show="evento.movimentos.length &gt; 1" uib-collapse="!isCollapsed" class="timeline-posicoes-list"><li ng-repeat="posicaoAgrupada in evento.movimentos"><a href="" ng-if="historicoTimeline.temLocalizacao(posicaoAgrupada)" ng-click="historicoTimeline.setMarker(posicaoAgrupada, evento.movimentos[0].index)"><small><i class="fa fa-clock-o"></i>{{posicaoAgrupada.data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{posicaoAgrupada.velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small ng-if="posicaoAgrupada.posicaoFoiAjustada" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><i class="fa fa-exclamation-triangle"></i></small></a><span ng-if="!historicoTimeline.temLocalizacao(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><small><i class="fa fa-clock-o"></i>{{posicaoAgrupada.data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{posicaoAgrupada.velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small> <i class="fa fa-exclamation-triangle"></i></small></span></li></ul><ul ng-show="evento.movimentos.length === 1" class="timeline-posicoes-list"><li><a href="" ng-if="historicoTimeline.temLocalizacao(evento.movimentos[0])" ng-click="historicoTimeline.setMarker(evento.movimentos[0], evento.movimentos[0].index)"><small><i class="fa fa-clock-o"></i>{{evento.movimentos[0].data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{evento.movimentos[0].velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small></a><span ng-if="!historicoTimeline.temLocalizacao(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><small><i class="fa fa-clock-o"></i>{{evento.movimentos[0].data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{evento.movimentos[0].velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small> <i class="fa fa-exclamation-triangle"></i></small></span></li></ul></div></div><ul ng-if="!historicoTimeline.verificaEventoDefault(evento)" uib-collapse="collapseEventos" class="timeline timeline-itens"><li ng-repeat="item in evento.historicos" ng-if="historicoTimeline.handleShowEventWithAlertTag(item) &amp;&amp; historicoTimeline.verificaEventoDiferenteDefault(item.descricao)" id="historico-{{item.index}}" ng-class="{active: evento.ativo, \'has-alert-tag\': !!item.tagIgnoreEvent}"><i ng-class="historicoTimeline.getIcon(item)" class="event-icon"></i><div id="timeline-item-{{item.index}}" class="timeline-item"><span id="timeline-data-{{item.index}}" class="time"><i class="fa fa-clock-o margin-r-5"></i>{{item.data | date:\'HH:mm:ss\'}}</span><h3 ng-if="item.temCoordenada" ng-class="{ \'tag-ignore-title\': item.tagIgnoreEvent }"><tag-ignore event="item.tagIgnoreEvent" size="small" position="left"></tag-ignore><a href="" ng-click="historicoTimeline.setFocusMap(item)" class="text-primary">{{ item.descricao }}</a><div ng-if="historicoTimeline.isEventTooltip(item)" uib-tooltip="{{ historicoTimeline.getEventTooltip(item) | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="historicoTimeline.isFrenagemBruscaInformacaoPedal(item) &amp;&amp; !item.acionamentoFreioServico" uib-tooltip-html="historicoTimeline.fraseAcionamentoSemPedalFreio" tooltip-placement="bottom" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="historicoTimeline.isPossivelColisao(item)" uib-tooltip-html="historicoTimeline.frasePossivelColisaoTooltip" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><span>{{ historicoTimeline.mostrarDuracao(item) }}</span></h3><h3 ng-if="!item.temCoordenada" ng-class="{ \'tag-ignore-title\': item.tagIgnoreEvent }" class="text-muted"><tag-ignore event="item.tagIgnoreEvent" size="small" position="left"></tag-ignore><div uib-tooltip-html="historicoTimeline.invalidPositionTooltip">{{ item.descricao }}<div ng-if="historicoTimeline.isEventTooltip(item)" uib-tooltip="{{ historicoTimeline.getEventTooltip(item) | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><span>{{ historicoTimeline.mostrarDuracao(item) }}</span></div></h3><div ng-if="item.meio === &quot;GTP&quot;" class="evento-tic card-tic"><div class="icon-tic"><span class="material-icons">hub</span></div><div class="texto-tic"><small>{{ \'ce.mapa.historicoDetalhado.eventoTic\' | translate }}</small></div></div><historico-timeline-directive item="item" historico-timeline="historicoTimeline"></historico-timeline-directive></div></li></ul></li></ul></div></div><div ng-if="historicoTimeline.mostraVisaoCameras"><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" heading="{{ \'ce.mapa.historicoDetalhado.tabHistorico\' | translate }}" select="historicoTimeline.resizeDropdown()" ng-click="historicoTimeline.showHistorico()"><div id="historico"><div class="timeline-filtros"><div historico-timeline-dropdown-multiselect="{}" options="historicoTimeline.filtroEventos" selected-model="historicoTimeline.eventosAtivos" events="historicoTimeline.filtroEventosEvents" data-testid="historico-detalhado-filtro-eventos"></div><div class="checkbox-alert-tag"><input-checkbox name="check-alert-tag" ng-click="historicoTimeline.insertMarkers()" model="historicoTimeline.alertTagCheckbox"></input-checkbox><label for="check-alert-tag">{{ \'ce.mapa.historicoDetalhado.alertTagLabel\' | translate }}</label></div></div><div class="box-buttons"><a id="excel-btn" href="#" ng-click="historicoTimeline.downloadCsv()" data-testid="historico-detalhado-csv-button" class="btn btn-primary btn-xs"><span class="fa fa-download margin-r-5"></span>CSV</a><a href="#" ng-click="historicoTimeline.registerRoute()" ng-if="historicoTimeline.roleRotaEditar" class="btn btn-outline-blue btn-xs">{{ \'ce.mapa.historicoDetalhado.registerRoute\' | translate }}</a></div><ul id="timeline" class="timeline timeline-eventos"><li ng-repeat="evento in historicoTimeline.historicoCompleto" ng-if="historicoTimeline.handleCheckAlertTag(evento.historicos[0]) || evento.historicos.length &gt; 1" ng-class="{\'has-alert-tag\': !!evento.historicos[0].tagIgnoreEvent}"><i ng-class="collapseEventos ? \'evento-collapse-show\' : \'evento-collapse-hide\'" ng-click="collapseEventos = !collapseEventos" class="{{historicoTimeline.getIcon(evento)}}"></i><span ng-if="collapseEventos &amp;&amp; !historicoTimeline.verificaEventoDefault(evento) &amp;&amp; historicoTimeline.verificaSeTemEventos(evento.historicos)" class="label label-danger">{{historicoTimeline.retornaEventosFiltrados(evento.historicos)}}</span><div ng-if="historicoTimeline.verificaEventoDefault(evento)" class="timeline-item timeline-item-custom"><span id="timeline-data-{{evento.historicos[0].index}}" class="time"><i class="fa fa-clock-o margin-r-5"></i>{{evento.historicos[0].data | date:\'HH:mm:ss\'}}</span><h3 ng-if="evento.historicos[0].temCoordenada &amp;&amp; evento.historicos[0].exibirEvento" ng-class="{ \'tag-ignore-title\': evento.historicos[0].tagIgnoreEvent }"><tag-ignore event="evento.historicos[0].tagIgnoreEvent" size="small" position="left"></tag-ignore><a href="" ng-click="historicoTimeline.setFocusMap(evento.historicos[0])" data-testid="historico-timeline-event-card-event-name-{{evento.historicos[0].descricao}}" class="text-primary">{{evento.historicos[0].descricao}}</a><span>{{ historicoTimeline.mostrarDuracao(evento.historicos[0]) }}</span></h3><h3 ng-if="!evento.historicos[0].temCoordenada" ng-class="{ \'tag-ignore-title\': evento.historicos[0].tagIgnoreEvent }" class="text-muted"><tag-ignore event="evento.historicos[0].tagIgnoreEvent" size="small" position="left"></tag-ignore><div>{{evento.historicos[0].descricao}}<span>{{ historicoTimeline.mostrarDuracao(evento.historicos[0]) }}</span></div></h3><div ng-if="evento.historicos[0].meio === &quot;GTP&quot;" class="evento-tic card-tic"><div class="icon-tic"><span class="material-icons">hub</span></div><div class="texto-tic"><small>{{ \'ce.mapa.historicoDetalhado.eventoTic\' | translate }}</small></div></div><historico-timeline-directive item="evento.historicos[0]" historico-timeline="historicoTimeline"></historico-timeline-directive></div><div ng-if="!historicoTimeline.verificaEventoDefault(evento)" ng-class="{&quot;timeline-item-custom&quot;: !historicoTimeline.verificaSeTemEventos(evento.historicos) || collapseEventos}" data-testid="historico-timeline-event-card-event-time-{{evento.inicio}}" class="timeline-item"><span class="time"><i class="fa fa-clock-o margin-r-5"></i>{{evento.inicio | date:\'HH:mm:ss\'}}</span><h3 class="text-muted"><div><a href="" ng-if="historicoTimeline.temLocalizacao(evento)" ng-click="historicoTimeline.setMarkerAgrupamento(evento, evento.index)">{{evento.evento}}</a><span ng-if="!historicoTimeline.temLocalizacao(evento)" uib-tooltip-html="historicoTimeline.invalidPositionTooltip" tooltip-placement="top">{{evento.evento}}</span><span>{{ historicoTimeline.mostrarDuracao(evento) }}</span></div></h3><div ng-if="evento.movimentos.length &gt; 0 &amp;&amp; evento.movimentos[0].exibirEvento"><a ng-show="evento.movimentos.length &gt; 1" ng-click="isCollapsed = !isCollapsed" class="btn btn-primary btn-xs"><strong>{{evento.movimentos.length}}</strong> {{ \'ce.mapa.historicoDetalhado.eventos\' | translate }}</a><ul ng-show="evento.movimentos.length &gt; 1" uib-collapse="!isCollapsed" class="timeline-posicoes-list"><li ng-repeat="posicaoAgrupada in evento.movimentos"><a href="" ng-if="historicoTimeline.temLocalizacao(posicaoAgrupada)" ng-click="historicoTimeline.setMarker(posicaoAgrupada, evento.movimentos[0].index)"><small><i class="fa fa-clock-o"></i>{{posicaoAgrupada.data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{posicaoAgrupada.velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small ng-if="posicaoAgrupada.posicaoFoiAjustada" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><i class="fa fa-exclamation-triangle"></i></small></a><span ng-if="!historicoTimeline.temLocalizacao(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><small><i class="fa fa-clock-o"></i>{{posicaoAgrupada.data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{posicaoAgrupada.velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(posicaoAgrupada)" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small> <i class="fa fa-exclamation-triangle"></i></small></span></li></ul><ul ng-show="evento.movimentos.length === 1" class="timeline-posicoes-list"><li><a href="" ng-if="historicoTimeline.temLocalizacao(evento.movimentos[0])" ng-click="historicoTimeline.setMarker(evento.movimentos[0], evento.movimentos[0].index)"><small><i class="fa fa-clock-o"></i>{{evento.movimentos[0].data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{evento.movimentos[0].velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small></a><span ng-if="!historicoTimeline.temLocalizacao(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.invalidPositionTooltip"><small><i class="fa fa-clock-o"></i>{{evento.movimentos[0].data | date:\'HH:mm:ss\'}}</small><small><i class="fa fa-tachometer"></i>{{evento.movimentos[0].velocidade }} {{historicoTimeline.speedUnit}}</small><small><i ng-if="historicoTimeline.verificaMovimentoVelocidadeZero(evento.movimentos[0])" uib-tooltip-html="historicoTimeline.fraseTooltip" tooltip-placement="top" class="fa fa-info-circle"></i></small><small> <i class="fa fa-exclamation-triangle"></i></small></span></li></ul></div></div><ul ng-if="!historicoTimeline.verificaEventoDefault(evento)" uib-collapse="collapseEventos" class="timeline timeline-itens"><li ng-repeat="item in evento.historicos" ng-if="historicoTimeline.handleShowEventWithAlertTag(item) &amp;&amp; historicoTimeline.verificaEventoDiferenteDefault(item.descricao)" id="historico-{{item.index}}" ng-class="{active: evento.ativo, \'has-alert-tag\': !!item.tagIgnoreEvent}"><i ng-class="historicoTimeline.getIcon(item)" class="event-icon"></i><div id="timeline-item-{{item.index}}" class="timeline-item"><span id="timeline-data-{{item.index}}" class="time"><i class="fa fa-clock-o margin-r-5"></i>{{item.data | date:\'HH:mm:ss\'}}</span><h3 ng-if="item.temCoordenada" ng-class="{ \'tag-ignore-title\': item.tagIgnoreEvent }"><tag-ignore event="item.tagIgnoreEvent" size="small" position="left"></tag-ignore><a href="" ng-click="historicoTimeline.setFocusMap(item)" class="text-primary">{{ item.descricao }}</a><div ng-if="historicoTimeline.isEventTooltip(item)" uib-tooltip="{{ historicoTimeline.getEventTooltip(item) | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="historicoTimeline.isFrenagemBruscaInformacaoPedal(item) &amp;&amp; !item.acionamentoFreioServico" uib-tooltip-html="historicoTimeline.fraseAcionamentoSemPedalFreio" tooltip-placement="bottom" class="fa fa-info-circle fa-icon-left text-blue"></div><div ng-if="historicoTimeline.isPossivelColisao(item)" uib-tooltip-html="historicoTimeline.frasePossivelColisaoTooltip" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><span>{{ historicoTimeline.mostrarDuracao(item) }}</span></h3><h3 ng-if="!item.temCoordenada" ng-class="{ \'tag-ignore-title\': item.tagIgnoreEvent }" class="text-muted"><tag-ignore event="item.tagIgnoreEvent" size="small" position="left"></tag-ignore><div uib-tooltip-html="historicoTimeline.invalidPositionTooltip">{{ item.descricao }}<div ng-if="historicoTimeline.isEventTooltip(item)" uib-tooltip="{{ historicoTimeline.getEventTooltip(item) | translate }}" tooltip-placement="top" class="fa fa-info-circle fa-icon-left text-blue"></div><span>{{ historicoTimeline.mostrarDuracao(item) }}</span></div></h3><div ng-if="item.meio === &quot;GTP&quot;" class="evento-tic card-tic"><div class="icon-tic"><span class="material-icons">hub</span></div><div class="texto-tic"><small>{{ \'ce.mapa.historicoDetalhado.eventoTic\' | translate }}</small></div></div><historico-timeline-directive item="item" historico-timeline="historicoTimeline"></historico-timeline-directive></div></li></ul></li></ul></div></uib-tab><uib-tab index="1" heading="{{ \'ce.mapa.historicoDetalhado.tabCameras\' | translate }}" analytics-on="click" analytics-event="selecao" analytics-category="historico_detalhado" analytics-label="foto_historico_detalhado" ng-click="historicoTimeline.onClickCameras()"><visao-cameras snapshots="historicoTimeline.snapshots" labels="historicoTimeline.labels" labels-actived="historicoTimeline.labelsActived" label-events="historicoTimeline.filterLabelsEvent()" on-ver-no-mapa="historicoTimeline.onVerNoMapaSnapshot(posicao)" handle-change-page="historicoTimeline.handleChangePage(page)" navigation-setting="historicoTimeline.navigationSetting"></visao-cameras></uib-tab></uib-tabset></div></div><div ng-class="{&quot;playback-active&quot;: historicoTimeline.reprodRotasService.showReprodRotas}" class="mapa-container"><leaflet id="historico-map" tiles="historicoTimeline.tiles" geojson="historicoTimeline.geoJson" lf-center="historicoTimeline.mapCenter" defaults="historicoTimeline.defaults" event-broadcast="events" watch-markers="no" width="100%" class="leaflet-mobile"><map-control id-mapa="&quot;historico-map&quot;" id-ponto="historicoTimeline.idPonto" pontos-proximos="true"></map-control><map-layer-switcher on-layer-switch="historicoTimeline.onLayerSwitch(layerWrapper)"></map-layer-switcher><toggle-layer-markers></toggle-layer-markers><div ng-if="historicoTimeline.exibeReproducaoRotas()"><reprod-rotas posicoes="historicoTimeline.posicoesReprodRotas" agrupamentos="historicoTimeline.historicoCompleto" map="historicoTimeline.map"></reprod-rotas></div></leaflet></div></div><div id="container-delete-confirm"></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-timeline/historico-timeline-directive.tpl.html',
    '<div><style>body {\n' +
    '  overflow: hidden;\n' +
    '}</style><span class="timeline-speed"><div ng-if="historicoTimeline.eventos.isExcessoVelocidade(item.evento)" class="v3g-text-red div-vel-max">{{\'ce.mapa.common.modal.popupService.velMaxima\' | translate}}</div><strong id="timeline-velocidade-{{item.index}}">{{item.velocidade}}</strong><small>{{historicoTimeline.speedUnit}}</small></span><div class="timeline-info"><small id="timeline-invalido-{{item.index}}" ng-if="item.gps === \'Inválido\'" class="v3g-text-alt-red"><i class="fa fa-exclamation-triangle"></i>{{ \'ce.mapa.historicoDetalhado.localizacaoBaixaPrecisao\' | translate }}</small><small id="timeline-log-{{item.index}}"><i class="fa fa-map-marker"></i><span ng-bind-html="historicoTimeline.setPontoReferencia(item)"></span></small><small id="timeline-intensidade-{{item.index}}" ng-if="historicoTimeline.deveMostrar(item)"><i class="fa fa-exclamation"></i>{{historicoTimeline.getInfoEvento(item)}}</small><small id="timeline-motorista-{{item.index}}" ng-if="item.motorista"><i class="fa fa-user"></i>{{item.motorista.nome}}</small><small id="timeline-identificacao-motorista-{{item.index}}" ng-if="item.identificacaoMotorista"><i class="trimble-icon trimble-rfid"></i><span uib-tooltip="Identificação do motorista">{{item.identificacaoMotorista}}</span></small><small id="timeline-veiculo-{{item.veiculo}}"><i class="trimble-icon trimble-vehicle-plate"></i>{{item | prefixoPlaca}}</small><small id="timeline-pedal-com-freio-{{item.veiculo}}" ng-if="historicoTimeline.isFrenagemBruscaInformacaoPedal(item)"><i class="trimble-icon trimble-harsh-braking"></i>{{ historicoTimeline.verificarPedalFreio(item.acionamentoFreioServico) | translate }}</small><a id="timeline-alerta-rfid-nao-cadastrado-{{item.index}}" ng-if="item.codigoRfid" ng-href="/motorista" target="_blank"><i class="trimble-icon trimble-rfid-alert"></i><span uib-tooltip="Código do RFID">{{item.codigoRfid}}</span></a><small id="timeline-video-{{item.index}}" ng-if="item.videoId || historicoTimeline.hasSnapshotNotIgnition(item) &amp;&amp; historicoTimeline.hasSnapshotNotVigencia(item) || item.eventSnapshotId"><div class="detailed-history-video-play-btn"><event-viewer-link id-video="{{item.videoId}}" snapshot-id="{{historicoTimeline.getSnapshotId(item)}}" datahora="{{item.data}}" latitude="{{item.latitude}}" longitude="{{item.longitude}}" vehicle-id="{{item.veiculo.id}}" vehicle-prefix="{{item.veiculo.prefixo}}" vehicle-plate="{{item.veiculo.placa}}" driver-name="item.motorista ? item.motorista.nome : historicoTimeline.unknownDriver" tipo-evento="{{historicoTimeline.getTipoAlerta(item.evento)}}" status-video="\'CONCLUIDO\'" ng-click="historicoTimeline.onVideoClick()"></event-viewer-link></div></small><small id="timeline-snapshot" ng-if="historicoTimeline.hasSnapshotIgnition(item) &amp;&amp; (!item.vigencia || item.vigencia.origem === \'RFID\')"><div class="detailed-history-view-photo-btn"><snapshot-link id-snapshot="{{item.snapshotId}}" s3key="{{item.s3Key}}" bucket="{{item.snapshotBucket}}" bucket-region="{{item.snapshotBucketRegion}}" date-ignition-on="{{item.data}}" date-ignition-off="{{item.snapshotDataIgnicaoOff}}" pode-abrir-vigencia-manual="item.podeAbrirVigenciaManual" vigencia-atual="item.vigencia" id-veiculo="{{item.veiculo.id}}" uo-veiculo="{{item.veiculo.uo.id}}" prefix-container="historico-timeline-container" uo-with-rec-facial="historicoTimeline.uoWithRecFacial" is-na="historicoTimeline.isNa" ng-click="historicoTimeline.sendClickGTM(\'historico_detalhado_ver_foto\')"></snapshot-link></div></small><small id="timeline-snapshot" ng-if="!item.podeAbrirVigenciaManual &amp;&amp; historicoTimeline.isAberturaVigencia(item)"><div class="detailed-history-edit-vehicle-usage-btn"><snapshot-link id-snapshot="{{item.snapshotId}}" s3key="{{item.s3Key}}" bucket="{{item.snapshotBucket}}" bucket-region="{{item.snapshotBucketRegion}}" date-ignition-on="{{item.data}}" date-ignition-off="{{item.snapshotDataIgnicaoOff}}" pode-abrir-vigencia-manual="item.podeAbrirVigenciaManual" vigencia-atual="item.vigencia" id-veiculo="{{item.veiculo.id}}" uo-veiculo="{{item.veiculo.uo.id}}" prefix-container="historico-timeline-container" uo-with-rec-facial="historicoTimeline.uoWithRecFacial" is-na="historicoTimeline.isNa" ng-click="historicoTimeline.sendClickGTM(\'historico_detalhado_editar_vigencia\')"></snapshot-link></div></small><a id="timeline-ponto-referencia-{{item.index}}" ng-if="item.pontoReferencia &amp;&amp; item.evento !== &quot;Ponto de Referência&quot;" focus-ponto-referencia-directive="{{item.pontoReferencia.id}}" href=""><i class="fa fa-map-marker"></i>{{ \'ce.mapa.historicoDetalhado.rotograma\' | translate }}</a><small id="chuva-veiculo-{{item.veiculo}}" ng-if="historicoTimeline.deveMostrarChovendo(item)"><i class="fa fa-cloud"></i>{{ \'ce.mapa.historicoDetalhado.chovendo\' | translate }}</small></div></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-alerta/modal-requisicao-video.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ $ctrl.isSnapshotRequest ? \'ce.analise.alertas.requisicaoVideo.tituloSnapshot\' : \'ce.analise.alertas.requisicaoVideo.titulo\' | translate}}<i ng-click="$ctrl.dismiss()" class="pull-right fa fa-times-circle close-icon"></i></h3></div><div class="modal-body requisicao-video"><div class="identificacao-alerta"><span ng-class="$ctrl.getIconBackgroundColor()" class="badge badge-alerta"><i ng-class="$ctrl.tipoAlerta.icone" class="fa"></i></span><span class="h4 alerta-descricao">{{ $ctrl.tipoAlerta.descricao | translate }}</span></div><p class="text-muted"><i>{{ $ctrl.isSnapshotRequest ? \'ce.analise.alertas.requisicaoVideo.descricaoSnapshot\' : \'ce.analise.alertas.requisicaoVideo.descricao\' | translate }}</i></p><div class="row"><div class="col-xs-5 col-sm-6"><strong>{{ \'ce.analise.alertas.requisicaoVideo.horario\' | translate }}</strong><br/>{{ $ctrl.alerta.datahora | date: $ctrl.dateTimeFormat }} <br/>{{ $ctrl.alerta.datahora | date: \'HH:mm:ss\' }}</div><div ng-if="!$ctrl.isSnapshotRequest" class="col-xs-7 col-sm-6"><strong>{{ \'ce.analise.alertas.requisicaoVideo.duracao\' | translate }}</strong><div class="row"><div class="col-sm-3 col-xs-6">{{ $ctrl.inicioVideo | date: $ctrl.dateTimeFormat }} <br/>{{ $ctrl.inicioVideo | date: \'HH:mm:ss\' }}</div><div class="col-sm-2 hidden-xs"><svg viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="seta"><path d="M22.265 6.68519L16.1135 12.7963L14.6576 11.35L18.3383 7.7037H6.88619H0.222046V5.66667H6.88619H18.3383L14.6576 2.02037L16.1135 0.574074L22.265 6.68519Z" fill="black" fill-opacity="0.85"></path></svg></div><div class="col-sm-3 col-xs-6">{{ $ctrl.fimVideo | date: $ctrl.dateTimeFormat }}<br/>{{ $ctrl.fimVideo | date: \'HH:mm:ss\' }}</div></div></div></div><div class="alerta-aqui-requisicao-video"></div></div><div class="modal-footer"><button type="submit" ng-click="$ctrl.dismiss()" class="btn btn-default">{{ \'ce.analise.alertas.requisicaoVideo.cancelar\' | translate }}</button><button type="submit" ng-click="$ctrl.request()" class="btn btn-success">{{ \'ce.analise.alertas.requisicaoVideo.solicitar\' | translate }}</button></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-alerta/historico-paginacao-directive.tpl.html',
    '<small>Exibindo {{navigationSetting.start+1}}-{{lastRegistroPagina()}} do total de {{navigationSetting.total}} registros<nav id="pagination-footer" class="pagination-footer ng-scope"><ul class="pagination"><li ng-class="{disabled: isFirst()}"><a href="" ng-click="!isFirst() ? setpage(navigationSetting.currentPage-1) : null"><< Anterior</a></li><li ng-repeat="i in [0,1,2,3,4]" ng-if="i &lt; navigationSetting.numberOfPages" ng-class="{active: pagina(i) == navigationSetting.currentPage}"><a href="" ng-click="setpage(pagina(i))">{{pagina(i)}}</a></li><li ng-class="{disabled: isLast()}"><a href="" ng-click="!isLast() ? setpage(navigationSetting.currentPage+1) : null">Próximo >></a></li></ul></nav></small>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-alerta/historico-alerta.tpl.html',
    '<div class="parent-container"><div id="decoratedVideoPlayerModalContainer"></div><div id="thumbnailGrid"></div><div ng-if="!!historicoAlerta.vtabela &amp;&amp; historicoAlerta.isThumbnailsViewButtonEnabled" class="alert-container"><button ng-click="historicoAlerta.toggleView(\'table\')" ng-class="{\'active\': historicoAlerta.currentView === \'table\'}" class="btn btn-primary btn-table"><i class="fa fa-list-ul"></i></button><button ng-click="historicoAlerta.toggleView(\'grid\')" ng-class="{\'active\': historicoAlerta.currentView === \'grid\'}" class="btn btn-primary btn-grid"><i class="fa fa-th-large"></i></button></div><vtabela ng-if="!!historicoAlerta.vtabela" id="historico-alerta" grid-options="historicoAlerta.vtabela" analytics-category="Relatorios" analytics-label="HistoricoAlerta" ng-class="{\'view-table\': historicoAlerta.currentView === \'table\', \'view-grid\': historicoAlerta.currentView === \'grid\'}"><div ng-if="historicoAlerta.roleCadastrar &amp;&amp; historicoAlerta.vtabela.grid.data.length &gt; 0"><span class="fa-icon-left fa-icon-right text-muted"></span><span uib-tooltip="{{historicoAlerta.getMaisOpcoesMsg()}}" tooltip-placement="right" class="no-space"><strong ng-disabled="historicoAlerta.vtabela.rowsSelected.length === 0" ng-click="historicoAlerta.openDetalhesModal(historicoAlerta.vtabela.rowsSelected)" class="btn btn-sm btn-outline-blue">{{ \'ce.insights.seguranca.predicaoAcidente.operacao.regioesRisco.modalConfirmacaoAdvisor.btnAceitar\' | translate }}</strong></span></div></vtabela></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('historico-alerta/detalhes-alerta.html',
    '<div class="modal-detalhes"><div id="modalConfirmProntuario"></div><form><div class="modal-header modal-detalhes-header"><h4 class="modal-title">{{ \'ce.analise.alertas.detalhes.titulo\' | translate }}</h4><div ng-show="detalhesAlertaModal.alertas.length == 1" class="detalhes-header"><h5 class="modal-title">{{ \'ce.analise.alertas.detalhes.veiculo\' | translate }}<strong class="text-primary"> {{detalhesAlertaModal.alertas[0].prefixo ? detalhesAlertaModal.alertas[0].prefixo + \' - \' : \'\'}} {{ detalhesAlertaModal.alertas[0].placa }}</strong></h5><h5 class="modal-title">{{ \'ce.analise.alertas.detalhes.status\' | translate }}<strong class="text-primary"> {{ detalhesAlertaModal.descricaoStatus[detalhesAlertaModal.alertas[0].status].label }}</strong></h5><h5 class="modal-title">{{ \'ce.analise.alertas.detalhes.usuarioAtribuido\' | translate }}<strong class="text-primary"> {{ detalhesAlertaModal.alertas[0].usuarioAtribuido.login }}</strong></h5></div><div ng-show="detalhesAlertaModal.alertas.length &gt; 1" class="detalhes-header"><span class="modal-title pull-left">{{ \'ce.analise.alertas.detalhes.alertasSelecionados\' | translate }}<strong class="text-primary"> {{ detalhesAlertaModal.alertas.length }}</strong></span></div></div><div class="modal-body"><div ng-show="detalhesAlertaModal.alertas.length == 1"><div><h4 class="box-title"><i class="fa fa-comments-o"></i> {{ \'ce.analise.alertas.detalhes.acoesComentarios\' | translate }}</h4></div><div ng-show="detalhesAlertaModal.historico.length == 0">{{ \'ce.analise.alertas.detalhes.nenhumComentario\' | translate }}</div><div ng-repeat="item in detalhesAlertaModal.historico"><div class="box-body"><div class="user-block"><div class="detalhes-user"><div class="content-info"><img src="images/default_user.png" class="img-circle img-sm"/><div class="user-info"><div class="user-name"><a ng-click="item.isCollapsed = !item.isCollapsed" href="#">{{ item.isOpen }}\n' +
    '{{ item.usuario.login }}</a><small class="text-muted pull-right"><i class="fa fa-clock-o"></i> {{ item.dataHora | date: \'dd/MM/yyyy HH:mm:ss\' }}</small></div><div class="user-tags"><span ng-class="detalhesAlertaModal.descricaoStatus[item.status].cor" class="badge">{{ detalhesAlertaModal.descricaoStatus[item.status].label }}\n' +
    '{{ item.usuarioAtribuido.login ? detalhesAlertaModal.stringPara + \' \' + item.usuarioAtribuido.login : \'\' }}</span><span ng-show="item.tag &amp;&amp; item.tag.name" class="badge bg-blue">{{ item.tag.name }}</span></div></div></div><div class="text-ellipsis"><span ng-click="item.isCollapsed = !item.isCollapsed">{{ item.comentario }}</span></div></div><div ng-if="item.anexos.length &gt; 0"><div ng-repeat="anexo in item.anexos" class="detalhes-anexo-div"><span class="material-icons icon-anexo pull-left">attach_file</span><span>{{ anexo.nome }}</span></div></div></div></div><div id="collapseOne" uib-collapse="!item.isCollapsed" class="panel-collapse"><div class="box-body">{{ item.comentario }}</div></div></div></div><div class="form-group"><h4>{{ \'ce.analise.alertas.detalhes.comentar\' | translate }}</h4><textarea rows="2" ng-model="detalhesAlertaModal.comentario" id="comentarios-textarea" class="form-control"></textarea><div><div class="detalhes-anexo-div"><span class="material-icons icon-anexo pull-left">attach_file</span><h4 class="box-title">{{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.adicionarAnexos\' | translate }}</h4></div><span ng-show="!detalhesAlertaModal.isDisabled()">{{ \'ce.analise.alertas.detalhes.cliqueAbaixoAdicionar\' | translate }}</span><span ng-if="detalhesAlertaModal.isDisabled()">{{ \'ce.analise.alertas.detalhes.avisoVeiculosDiferentes\' | translate }}</span><div id="attachmentSquare" class="alerts-detail-attachments"></div></div></div><div class="form-horizontal form-altera-status"><h4 class="box-title tratativa-title"><i class="fa fa-file-text"></i> {{ \'ce.tempoReal.quadroDeOcorrencias.ocorrenciaModal.tratativa\' | translate | lowercase }}</h4><div class="form-group-fields"><div class="form-field"><label for="status-select" class="control-label">{{ \'ce.analise.alertas.detalhes.alterarStatus\' | translate }}</label><select id="status-select" ng-model="detalhesAlertaModal.status" ng-change="detalhesAlertaModal.usuario = null" ng-options="s for s in detalhesAlertaModal.statusLista" placeholder="{{ \'ce.mapa.common.modal.placeholderCategoria\' | translate }}" class="form-control"><option value=""></option></select></div><div class="form-field"><label class="control-label">{{ \'ce.analise.alertas.detalhes.tag\' | translate }}</label><select id="alerts-tag-select" ng-model="detalhesAlertaModal.alertTag" ng-options="u.name for u in detalhesAlertaModal.alertsTag" class="select-status form-control"><option value=""></option></select><span>{{ \'ce.analise.alertas.detalhes.tagObservation.isOuOwner\' | translate }}</span></div><div ng-if="detalhesAlertaModal.alertTag.ignoreIndicator" tooltip-enable="detalhesAlertaModal.alertTag.ignoreIndicator" uib-tooltip="{{ \'ce.analise.alertas.detalhes.tagObservation.ignoreIndicator\' | translate }}" class="fa fa-info-circle"></div></div><div class="form-group-fields"><div ng-show="detalhesAlertaModal.status === detalhesAlertaModal.statusLista[0]" class="form-field"><label class="control-label">{{ \'ce.analise.alertas.detalhes.usuario\' | translate }}</label><select id="usuarios-select" ng-model="detalhesAlertaModal.usuario" ng-options="u.login for u in detalhesAlertaModal.usuarios" class="select-status form-control"><option value=""></option></select></div></div><div ng-show="detalhesAlertaModal.alerta.show"><div class="alert alert-warning">{{ detalhesAlertaModal.alerta.msg }}</div></div></div></div><div class="modal-footer"><button type="button" id="alerts-detail-cancel-btn" ng-click="detalhesAlertaModal.fechar()" class="btn btn-default">{{ \'ce.analise.alertas.detalhes.cancelar\' | translate }}</button><button type="button" id="alerts-detail-save-btn" ng-click="detalhesAlertaModal.salvar()" class="btn btn-primary">{{ \'ce.analise.alertas.detalhes.salvar\' | translate }}</button></div></form></div>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('gestao-ocorrencia/gestao-ocorrencia.tpl.html',
    '<powerbi-component id="embed-container" options="ctrl.response"></powerbi-component>');
}]);

angular.module('conducaoEconomica').run(['$templateCache', function($templateCache) {
  $templateCache.put('header.tpl.html',
    '<v3g-header uo="headerCtrl.uo" mostrar-menu-vfleets="false" gerenciar-permissoes="true" mostrar-versao="headerCtrl.showVersion"></v3g-header><tutorial-busca-regiao ng-if="headerCtrl.showModalTutorialBuscaRegiao"></tutorial-busca-regiao><div id="notification-video-download"></div>');
}]);

'use strict';

(function () {
  'use strict';

  angular.module('mapControlModule', ['enumModule', 'relatorios', 'ui.bootstrap', 'colorpicker.module', 'ng-mfb', 'configuracoesEvento', 'mapas', 'ModuleEventos', 'InputCheckboxModule', 'rotogramaModule', 'alert-message', 'reprodRotasModule', 'pascalprecht.translate', 'httpServiceV3gModule', 'urlConfigModule', 'ModuleMapasUtil', 'FeatureFlagModule', 'uoModule', 'ServiceVfiltroModule', 'reportwrongspeedviaModule', 'ModuleConvertersUtil', 'ngSanitize']).constant('TIPOS_CATEGORIA', {
    AREA_RISCO: { id: 'AREA_RISCO', descricao: 'Área de Risco' },
    GARAGEM: { id: 'GARAGEM', descricao: 'Garagem' }
  }).constant('LayerTypeEnum', {
    MARKER: 'marker',
    POLYGON: 'polygon',
    RECTANGLE: 'rectangle'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function inputPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/pesquisa-ponto-referencia/filtros-ponto-referencia/input-ponto-referencia/input-ponto-referencia.tpl.html',
      controller: 'InputPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var InputPontoReferenciaCtrl = function () {
    function InputPontoReferenciaCtrl($scope, PontosReferenciaFiltro, PontosReferenciaMap, CercaEletronicaMapService) {
      _classCallCheck(this, InputPontoReferenciaCtrl);

      this.scope = $scope;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.cercaEletronicaMapService = CercaEletronicaMapService;

      this.pesquisa = '';
      this.listaItem = this.pontosReferenciaFiltroService.getFiltroByKeyOrDefault('palavra', { itensEscondidos: [] }).itensEscondidos;
      this.validaPontos = false;
    }

    _createClass(InputPontoReferenciaCtrl, [{
      key: 'adicionarItem',
      value: function adicionarItem() {
        var pesquisa = this.pesquisa ? this.pesquisa.toLowerCase() : '';
        if (pesquisa && this.verificaLista(pesquisa)) {
          this.listaItem.push(pesquisa);
          this.pesquisa = '';
          this.validaPontos = false;
          this.aplicarFiltro();
        } else {
          this.validaPontos = true;
        }
      }
    }, {
      key: 'removeItem',
      value: function removeItem(i) {
        this.listaItem = this.listaItem.filter(function (item, index) {
          return index !== i;
        });
        this.aplicarFiltro();
      }
    }, {
      key: 'verificaLista',
      value: function verificaLista(pesquisa) {
        return angular.isUndefined(this.listaItem.find(function (x) {
          return x === pesquisa;
        }));
      }
    }, {
      key: 'aplicarFiltro',
      value: function aplicarFiltro() {
        this.pontosReferenciaFiltroService.salvarFiltroItensEscondidos(this.pontosReferenciaFiltroService.filtroSelecionado.key, this.listaItem);
        this.pontosReferenciaMapService.recarregaPontos();
        this.cercaEletronicaMapService.mostrarCercasBoundsAtual();
      }
    }]);

    return InputPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('InputPontoReferenciaCtrl', InputPontoReferenciaCtrl).directive('inputPontoReferenciaDirective', inputPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function checkboxPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/pesquisa-ponto-referencia/filtros-ponto-referencia/checkbox-ponto-referencia/checkbox-ponto-referencia.tpl.html',
      controller: 'CheckboxPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var CheckboxPontoReferenciaCtrl = function () {
    function CheckboxPontoReferenciaCtrl($scope, PontosReferenciaFiltro, PontosReferenciaMap, CercaEletronicaMapService) {
      _classCallCheck(this, CheckboxPontoReferenciaCtrl);

      this.scope = $scope;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.cercaEletronicaMapService = CercaEletronicaMapService;

      this.pontosReferenciaFiltroService.verificaFiltroLocalstorage();
    }

    _createClass(CheckboxPontoReferenciaCtrl, [{
      key: 'checkboxSelecionarTodos',
      value: function checkboxSelecionarTodos() {
        return this.pontosReferenciaFiltroService.filtroSelecionado.lista.filter(function (x) {
          return !x.check;
        }).length === 0;
      }
    }, {
      key: 'selecionarTodosChecks',
      value: function selecionarTodosChecks() {
        var todos = this.checkboxSelecionarTodos();

        this.pontosReferenciaFiltroService.filtroSelecionado.lista.forEach(function (x) {
          return x.check = !todos;
        });
      }
    }, {
      key: 'aplicarFiltro',
      value: function aplicarFiltro() {
        this.pontosReferenciaFiltroService.salvarFiltroItensEscondidos(this.pontosReferenciaFiltroService.filtroSelecionado.key, this.pontosReferenciaFiltroService.filtroSelecionado.lista.filter(function (x) {
          return !x.check;
        }).map(function (x) {
          return x.id;
        }));
        this.pontosReferenciaMapService.recarregaPontos();
        this.cercaEletronicaMapService.mostrarCercasBoundsAtual();
        this.pontosReferenciaFiltroService.filtroSelecionado = null;
        this.pontosReferenciaFiltroService.selecionarFiltro = false;
      }
    }]);

    return CheckboxPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('CheckboxPontoReferenciaCtrl', CheckboxPontoReferenciaCtrl).directive('checkboxPontoReferenciaDirective', checkboxPontoReferenciaDirective);
})();
'use strict';

(function () {
  'use strict';

  angular.module('SubpaginasEventos', ['InputCheckboxModule', 'InputNumberModule', 'ui.router', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'pascalprecht.translate', 'alert-message', 'restangular', 'modalInfoConfirmModule', 'angularMoment', 'AlertasModule', 'FeatureFlagModule', 'httpServiceV3gModule', 'validateUtilModule', 'v3gAuthenticatorModule', 'SolucoesModule', 'ConfigEventosModule', 'safetyModule', 'UoHelperModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalSimuladorCtrl = function () {
    function ModalSimuladorCtrl($uibModalInstance, ValidateUtil, ModalInfoConfirmService, HttpServiceV3g, $scope, moment, configsOcorrencia, AlertMessage, $translate) {
      _classCallCheck(this, ModalSimuladorCtrl);

      this.modalInstance = $uibModalInstance;
      this.validadeService = ValidateUtil;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.scope = $scope;
      this.moment = moment;
      this.model = {};
      this.httpService = HttpServiceV3g;
      this.configsOcorrencia = configsOcorrencia;
      this.alertMessage = AlertMessage;
      this.translate = $translate;
      this.dateOptions = {
        formatYear: 'yy',
        maxDate: this.moment().startOf('day').subtract(1, 'days'),
        minDate: this.moment().startOf('day').subtract(7, 'days'),
        startingDay: 0,
        showWeeks: false
      };

      this.simularClicked = false;
    }

    _createClass(ModalSimuladorCtrl, [{
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'simular',
      value: function simular() {
        var _this = this;

        if (this.scope.dateForm.data.$valid && this.dateInRange(this.model.data)) {
          var simuladorData = this.moment(this.model.data).format('YYYY-MM-DD');
          this.httpService.post('/alerta/ocorrencias/simular/' + simuladorData, this.configsOcorrencia).then(function (res) {
            _this.modalInstance.close({ ocorrencias: res.data.mediaOcorrencias, data: _this.model.data });
          }).catch(function () {
            _this.modalInstance.dismiss('ERRO_SIMULADOR');
          });
        } else {
          this.simularClicked = true;
        }
      }
    }, {
      key: 'getMsgError',
      value: function getMsgError(inputScope) {
        if (angular.isDefined(inputScope)) {
          if (inputScope.$invalid && (inputScope.$touched || this.simularClicked)) {
            return this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.dataObrigatoria');
          }
          if (this.model.data && !this.dateInRange(this.model.data)) {
            return this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modalSimuladorDeOcorrencias.comoFunciona.dataPeriodoPermitido');
          }
        }
        return null;
      }
    }, {
      key: 'dateInRange',
      value: function dateInRange(inputDate) {
        var maxDate = this.moment().startOf('day').subtract(1, 'days'),
            minDate = this.moment().startOf('day').subtract(7, 'days');
        return this.moment(inputDate).isBetween(minDate, maxDate, null, []);
      }
    }]);

    return ModalSimuladorCtrl;
  }();

  angular.module('SubpaginasEventos').controller('ModalSimuladorCtrl', ModalSimuladorCtrl);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalOcorrenciasInfoCtrl = function ModalOcorrenciasInfoCtrl($uibModalInstance) {
    _classCallCheck(this, ModalOcorrenciasInfoCtrl);

    this.modalInstance = $uibModalInstance;
  };

  angular.module('SubpaginasEventos').controller('ModalOcorrenciasInfoCtrl', ModalOcorrenciasInfoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
  * @name onepage
  * @description
  *
  */

  angular.module('onePageModule', ['ui.router', 'chartModule', 'customGridsterModule', 'mapasGrid', 'restangular', 'httpServiceV3gModule', 'angularMoment', 'AlertasModule', 'pascalprecht.translate', 'customGridsterModule', 'v3gAuthenticatorModule', 'ui.bootstrap.modal', 'enumModule', 'filtroAlertaModule', 'uoModule', 'uoArvoreNivelModule', 'UrlModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  function alertaDiaOnePageCardDirective() {
    return {
      templateUrl: 'one-page/directives/alerta-dia/card/alerta-dia-one-page-card.tpl.html',
      controller: 'AlertaDiaOnePageCardCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var AlertaDiaOnePageCardCtrl = function () {
    function AlertaDiaOnePageCardCtrl($scope, $window, AlertaVeiculoService, Authenticator, FiltroAlertaService, Keys, Restangular, $translate, ServiceVfiltro, FactoryVfiltro) {
      var _this = this;

      _classCallCheck(this, AlertaDiaOnePageCardCtrl);

      this.scope = $scope;
      this.window = $window;
      this.alertaVeiculoService = AlertaVeiculoService;
      this.authenticator = Authenticator;
      this.filtroAlertaService = FiltroAlertaService;
      this.keys = Keys;
      this.restangular = Restangular;
      this.translate = $translate;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;

      this.alertas = { data: null, erroSemData: false };
      this.onePageCtrl = this.scope.$parent.$parent.onePage;
      this.visualizarHistoricoAlerta = false;

      this.scope.$on('$destroy', function () {
        _this.alertaVeiculoService.removeCallbackPorTipo('onepage');
        _this.alertaVeiculoService.stop();
      });

      if (this.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
        this.visualizarHistoricoAlerta = true;
      }

      this.loadFiltro();

      this.alertasDesativados = ['VEICULO_SEM_SINAL'];
    }

    _createClass(AlertaDiaOnePageCardCtrl, [{
      key: 'loadFiltro',
      value: function loadFiltro() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          key: this.keys.uo.name
        }])).then(function (filtro) {
          _this2.uoId = filtro.find(function (x) {
            return x.key === _this2.keys.uo.name;
          }).value.id;
          _this2.alertaVeiculoService.setUoId(_this2.uoId);
          _this2.alertaVeiculoService.checkAlertaPorTipo();
          _this2.init();
        });
      }
    }, {
      key: 'init',
      value: function init() {
        var _this3 = this;

        if (this.alertaVeiculoService.listaCacheada) {
          this.alertas.data = this.buildCardAlerta(this.alertaVeiculoService.listaCacheada);
        } else {
          this.verificarAlertasInativos();
        }

        this.alertaVeiculoService.onUpdateAlertaPorTipo(function (data) {
          return _this3.alertas.data = _this3.buildCardAlerta(data);
        }, 'onepage');
        this.alertaVeiculoService.onUpdateAlertaPorTipoError(function (error) {
          if (error) {
            _this3.mensagemDeErro = _this3.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
          }
        }, 'onepageError');
      }
    }, {
      key: 'verificarAlertasInativos',
      value: function verificarAlertasInativos() {
        var _this4 = this;

        this.restangular.one('configuracao/configuracoes/' + this.uoId + '/alerta').get().then(function (alertas) {
          _this4.erroAlertasInativos = _.values(alertas.configuracoes).filter(function (item) {
            return item.ativo;
          }).length === 0;
          if (_this4.erroAlertasInativos) {
            _this4.mensagemDeErro = 'ce.tempoReal.statusFrota.charts.alertaSeguranca.nenhumAlertaAtivo';
            _this4.linkConfigAlertas = _this4.getUrlConfigAlertas();
          } else if (!_this4.erroAlertasInativos) {
            _this4.mensagemDeErro = _this4.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.mensagemSucesso');
          }
        }, function () {
          _this4.mensagemDeErro = _this4.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
        });
      }
    }, {
      key: 'buildCardAlerta',
      value: function buildCardAlerta(data) {
        var _this5 = this;

        var retorno = [];
        this.erroSemData = true;

        if (data && data.length > 0 && data.filter(function (x) {
          return x.quantidade;
        }).length > 0) {
          data.filter(function (x) {
            return x.quantidade > 0 && _this5.alertasDesativados.indexOf(x.key) === -1;
          }).forEach(function (item) {
            if (_this5.erroSemData) {
              _this5.erroSemData = false;
            }

            retorno.push({
              name: item.texto,
              data: item.quantidade,
              color: item.chartColor,
              key: item.key
            });
          });
        } else {
          this.verificarAlertasInativos();
        }

        return retorno;
      }
    }, {
      key: 'goToHistoricoAlerta',
      value: function goToHistoricoAlerta(item) {
        return this.filtroAlertaService.filtroLink(this.onePageCtrl.getParamValue(this.keys.uo.name), item);
      }
    }, {
      key: 'getUrlConfigAlertas',
      value: function getUrlConfigAlertas() {
        return '/configuracoes-alertas?vfiltro=uo:' + this.uoId;
      }
    }]);

    return AlertaDiaOnePageCardCtrl;
  }();

  angular.module('onePageModule').controller('AlertaDiaOnePageCardCtrl', AlertaDiaOnePageCardCtrl).directive('alertaDiaOnePageCardDirective', alertaDiaOnePageCardDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  function alertaDiaOnePageGraficoDirective() {
    return {
      templateUrl: 'one-page/directives/alerta-dia/grafico/alerta-dia-one-page-grafico.tpl.html',
      controller: 'AlertaDiaOnePageGraficoCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var AlertaDiaOnePageGraficoCtrl = function () {
    function AlertaDiaOnePageGraficoCtrl($scope, $window, FiltroAlertaService, AlertaVeiculoService, UrlService, OnePageService, SingleColumnChart, Keys, ServiceVfiltro, Restangular, FactoryVfiltro, $translate) {
      var _this = this;

      _classCallCheck(this, AlertaDiaOnePageGraficoCtrl);

      this.scope = $scope;
      this.window = $window;
      this.filtroAlertaService = FiltroAlertaService;
      this.alertaVeiculoService = AlertaVeiculoService;
      this.onePageService = OnePageService;
      this.keys = Keys;
      this.urlService = UrlService;
      this.serviceVfiltro = ServiceVfiltro;
      this.restangular = Restangular;
      this.factoryVfiltro = FactoryVfiltro;
      this.translate = $translate;

      this.alertas = SingleColumnChart.get();
      this.alertas.removeTitleCategories();
      this.alertas.setCustomTooltip();

      this.scope.$on('$destroy', function () {
        _this.alertaVeiculoService.removeCallbackPorTipo('onepage');
        _this.alertaVeiculoService.stop();
      });

      this.loadFiltro();

      this.alertasDesativados = ['VEICULO_SEM_SINAL'];
    }

    _createClass(AlertaDiaOnePageGraficoCtrl, [{
      key: 'loadFiltro',
      value: function loadFiltro() {
        var _this2 = this;

        this.serviceVfiltro.init(this.factoryVfiltro.get([{
          key: this.keys.uo.name
        }])).then(function (filtro) {
          _this2.uoId = filtro.find(function (x) {
            return x.key === _this2.keys.uo.name;
          }).value.id;
          if (_this2.serviceVfiltro.factoryVfiltro.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
            _this2.alertas.setClickEvent(_this2.clickBinding().onClickColumn);
            _this2.alertas.setLegendItemClickEvent(_this2.clickBinding().onLegendItemClick);
          }
          _this2.alertaVeiculoService.setUoId(_this2.uoId);
          _this2.alertaVeiculoService.checkAlertaPorTipo();
          _this2.init();
        });
      }
    }, {
      key: 'init',
      value: function init() {
        var _this3 = this;

        this.alertaVeiculoService.checkAlertaPorTipo().then(function () {
          if (_this3.alertaVeiculoService.listaCacheada) {
            _this3.alertas.setData(_this3.buildGraficoAlerta(_this3.alertaVeiculoService.listaCacheada));
          } else if (angular.isUndefined(_this3.alertaVeiculoService.listaCacheada)) {
            _this3.verificarAlertasInativos();
          }

          _this3.alertaVeiculoService.onUpdateAlertaPorTipo(function (data) {
            return _this3.alertas.setData(_this3.buildGraficoAlerta(data));
          }, 'onepage');

          _this3.alertaVeiculoService.onUpdateAlertaPorTipoError(function (error) {
            if (error) {
              _this3.mensagemDeErro = _this3.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
            }
          }, 'onepageError');
        });
      }
    }, {
      key: 'verificarAlertasInativos',
      value: function verificarAlertasInativos() {
        var _this4 = this;

        this.restangular.one('configuracao/configuracoes/' + this.uoId + '/alerta').get().then(function (alertas) {
          _this4.erroAlertasInativos = _.values(alertas.configuracoes).filter(function (item) {
            return item.ativo;
          }).length === 0;
          if (_this4.erroAlertasInativos) {
            _this4.mensagemDeErro = 'ce.tempoReal.statusFrota.charts.alertaSeguranca.nenhumAlertaAtivo';
            _this4.linkConfigAlertas = _this4.receberUrlConfigAlertas();
          } else if (!_this4.erroAlertasInativos) {
            _this4.mensagemDeErro = _this4.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.mensagemSucesso');
          }
        }, function () {
          _this4.mensagemDeErro = _this4.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
        });
      }
    }, {
      key: 'buildGraficoAlerta',
      value: function buildGraficoAlerta(data) {
        var _this5 = this;

        var retorno = { categorias: [], series: [] };
        if (data && data.length > 0 && data.filter(function (x) {
          return x.quantidade;
        }).length > 0) {
          data.filter(function (x) {
            return x.quantidade > 0 && _this5.alertasDesativados.indexOf(x.key) === -1;
          }).forEach(function (item) {
            if (_this5.alertas.erroSemData) {
              _this5.alertas.erroSemData = false;
            }

            var visibility = true;
            if (_this5.alertas.series) {
              var serieAlerta = _this5.alertas.series.find(function (sa) {
                return sa.key === item.key;
              });
              if (angular.isDefined(serieAlerta)) {
                visibility = serieAlerta.visible;
              }
            }

            retorno.series.push({
              name: item.texto,
              data: item.quantidade,
              visible: visibility,
              color: item.chartColor,
              key: item.key
            });
          });
        } else {
          this.verificarAlertasInativos();
        }

        return retorno;
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this;

        return {
          onClickColumn: function onClickColumn() {
            var _this6 = this;

            var info = self.alertas.series.filter(function (i) {
              return i.name === _this6.series.name;
            })[0];
            self.window.location.href = self.filtroAlertaService.filtroLink(self.scope.onePage.getParamValue(self.keys.uo.name), info);
          },
          onLegendItemClick: function onLegendItemClick() {
            self.alertas.commonChartService.filterAllSeries.call(this);

            this.chart.series.forEach(function (serieChart) {
              self.alertas.series.filter(function (sa) {
                return sa.name === serieChart.name;
              }).forEach(function (sa) {
                sa.visible = serieChart.visible;
              });
            });
            return false;
          }
        };
      }
    }, {
      key: 'receberUrlConfigAlertas',
      value: function receberUrlConfigAlertas() {
        if (this.erroAlertasInativos) {
          return '/configuracoes-eventos?vfiltro=' + this.urlService.getObjectVfiltro(this.serviceVfiltro.filtroTopbar);
        }
      }
    }]);

    return AlertaDiaOnePageGraficoCtrl;
  }();

  angular.module('onePageModule').controller('AlertaDiaOnePageGraficoCtrl', AlertaDiaOnePageGraficoCtrl).directive('alertaDiaOnePageGraficoDirective', alertaDiaOnePageGraficoDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function alertaTurnoOnePageCardDirective() {
    return {
      templateUrl: 'one-page/directives/alerta-turno/card/alerta-turno-one-page-card.tpl.html',
      controller: 'AlertaTurnoOnePageCardCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var AlertaTurnoOnePageCardCtrl = function () {
    function AlertaTurnoOnePageCardCtrl($scope, $window, $q, $httpParamSerializer, moment, FiltroAlertaService, AlertaVeiculoService, OnePageService, CustomGridster, Uos, UoArvoreNivel, Authenticator, Keys, UrlService) {
      var _this = this;

      _classCallCheck(this, AlertaTurnoOnePageCardCtrl);

      this.scope = $scope;
      this.window = $window;
      this.q = $q;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.filtroAlertaService = FiltroAlertaService;
      this.alertaVeiculoService = AlertaVeiculoService;
      this.onePageService = OnePageService;
      this.customGridster = CustomGridster;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.urlService = UrlService;

      this.onePageCtrl = this.scope.$parent.$parent.onePage;

      this.gridsterAlertaTurno = this.customGridster.getOptions(150);

      this.alertaTurno = {};
      this.turnos = [];
      this.tableState = null;

      this.listaAlertaWatch = [];
      this.alertaTipo = '';
      this.alertaSelecionado = {};
      this.uoFiltro = null;
      this.posicoesGridster = {};
      this.visualizarHistoricoAlerta = false;
      this.collapseAlertasControle = true;

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateAlertaTurno();
        _this.removeTimer();
        _this.alertaVeiculoService.stop();
      });

      this.authenticator.getUser().then(function (user) {
        var retornoCollapse = angular.fromJson(_this.window.localStorage.getItem('collapse-alertas-' + user.id));
        if (retornoCollapse !== null) {
          _this.collapseAlertasControle = retornoCollapse;
        }
        if (_this.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
          _this.visualizarHistoricoAlerta = true;
        }
        _this.loadUos().then(function (x) {
          _this.uos = x;
          _this.init(user);
        });
      });
    }

    _createClass(AlertaTurnoOnePageCardCtrl, [{
      key: 'init',
      value: function init(user) {
        var _this2 = this;

        this.user = user;
        this.alertaVeiculoService.setUoId(user.uo.id);
        this.alertaVeiculoService.checkAlertaPorTipo();
        if (this.onePageService.listaCacheadaAlertaTurno) {
          this.buildCardAlertaTurno(this.onePageService.listaCacheadaAlertaTurno);
        }
        this.onePageService.onUpdateAlertaTurno(function (data) {
          if (data.turnos && data.turnos.length > 0) {
            _this2.buildCardAlertaTurno(data);
          }
        }, 'onepage');
      }
    }, {
      key: 'loadUos',
      value: function loadUos() {
        var _this3 = this;

        return this.q(function (resolve) {
          _this3.uoService.getFilhas().then(function (uos) {
            uos = _this3.uoArvoreNivel.converterEmLista(uos);
            resolve(uos.map(function (u) {
              return { id: u.id, label: u.nome, arvoreNivel: u.arvoreNivel };
            }));
          }, function () {});
        });
      }
    }, {
      key: 'buildCardAlertaTurno',
      value: function buildCardAlertaTurno(data) {
        var _this4 = this;

        var tipoAlertas = angular.copy(this.alertaVeiculoService.alertaMapPtBr),
            indexTurno = 0,
            listaAlerta = [],
            trocarLista = false,
            fimTurno = void 0;

        var uoId = data.turnos[0].uoId;
        if (this.uoFiltro !== uoId) {
          this.uoFiltro = uoId;
          trocarLista = true;
        }

        this.turnos = data.turnos.map(function (x, y) {
          var atual = _this4.moment(),
              inicio = _this4.moment(x.inicio),
              fim = _this4.moment(x.fim),
              ativo = atual.isBetween(inicio, fim);

          if (ativo) {
            indexTurno = y;
            fimTurno = fim;
          }

          return {
            ativo: ativo,
            inicioCompleto: inicio.format(),
            fimCompleto: fim.format(),
            inicio: inicio.format('HH:mm'),
            fim: fim.format('HH:mm')
          };
        });

        Object.keys(tipoAlertas).forEach(function (alerta) {
          tipoAlertas[alerta].color = tipoAlertas[alerta].chartColor;
          tipoAlertas[alerta].totalEventos = 0;
          tipoAlertas[alerta].urlTotalEventos = '';
          tipoAlertas[alerta].totalResolvidos = 0;
          tipoAlertas[alerta].urlTotalResolvidos = '';
          tipoAlertas[alerta].uoContagensTurno = [];
          tipoAlertas[alerta].uoContagensTurnoTotal = [];
          tipoAlertas[alerta].sort = {};

          var itemData = data.paineis.filter(function (painel) {
            return painel.label === tipoAlertas[alerta].key;
          })[0];
          if (itemData) {
            var totalOcorridos = [0, 0, 0, 0],
                totalResolvidos = [0, 0, 0, 0],
                totalUrl = ['', '', '', ''];

            tipoAlertas[alerta].uoContagensTurno = itemData.uoContagensTurno.map(function (y) {
              var ocorridos = _this4.somatorioArray(y.contagensTurno.map(function (z) {
                return z.ocorridos;
              })),
                  resolvidos = _this4.somatorioArray(y.contagensTurno.map(function (z) {
                return z.resolvidos;
              }));
              return {
                uo: y.uo,
                contagensTurno: y.contagensTurno.map(function (t, index) {
                  totalOcorridos[index] += t.ocorridos;
                  totalResolvidos[index] += t.resolvidos;
                  if (totalUrl[index] === '' && _this4.visualizarHistoricoAlerta) {
                    totalUrl[index] = _this4.buildObjectTurnoFiltro(_this4.uoFiltro, index, itemData.label);
                  }
                  return {
                    ocorridos: t.ocorridos,
                    resolvidos: t.resolvidos,
                    ativo: indexTurno === index,
                    url: _this4.visualizarHistoricoAlerta ? _this4.buildObjectTurnoFiltro(y.uo.id, index, itemData.label) : ''
                  };
                }),
                ocorridos: ocorridos,
                resolvidos: resolvidos,
                porcentagem: ocorridos === 0 ? 100 : Math.round(resolvidos / ocorridos * 100 * 1e2) / 1e2
              };
            });

            tipoAlertas[alerta].uoContagensTurnoTotal = {
              totalOcorridos: totalOcorridos,
              totalResolvidos: totalResolvidos,
              totalUrl: totalUrl
            };

            tipoAlertas[alerta].totalEventos = _this4.somatorioArray(tipoAlertas[alerta].uoContagensTurno.map(function (x) {
              return x.ocorridos;
            }));
            tipoAlertas[alerta].urlTotalEventos = _this4.buildObjectTotalFiltro(fimTurno, alerta, false);
            tipoAlertas[alerta].totalResolvidos = tipoAlertas[alerta].totalEventos !== 0 ? Math.round(_this4.somatorioArray(tipoAlertas[alerta].uoContagensTurno.map(function (x) {
              return x.resolvidos;
            })) / tipoAlertas[alerta].totalEventos * 100 * 1e2) / 1e2 : 100;
            tipoAlertas[alerta].urlTotalResolvidos = _this4.buildObjectTotalFiltro(fimTurno, alerta, true);
            listaAlerta.push(tipoAlertas[alerta]);
          }
        });

        this.alertaTurno = listaAlerta;
        if (trocarLista) {
          this.onePageService.alertaTurno = listaAlerta;
        }
        this.setPosicaoGraficoAlertaTurno();
      }
    }, {
      key: 'getAlertaTurno',
      value: function getAlertaTurno(tipo) {
        if (this.alertaTipo !== tipo || this.alertaTurno.length === 1) {
          var alerta = this.alertaTurno.filter(function (x) {
            return x.key === tipo;
          })[0];

          this.alertaTipo = tipo;
          this.alertaSelecionado = alerta;
        }

        return this.alertaSelecionado;
      }
    }, {
      key: 'somatorioArray',
      value: function somatorioArray(itens) {
        if (itens.length > 0) {
          return itens.reduce(function (anterior, atual) {
            return anterior + atual;
          });
        }
        return 0;
      }
    }, {
      key: 'goToHistoricoAlerta',
      value: function goToHistoricoAlerta(item) {
        if (this.visualizarHistoricoAlerta) {
          this.window.location.href = this.filtroAlertaService.filtroLink(this.onePageCtrl.getParamValue(this.keys.uo.name), item);
        }
      }
    }, {
      key: 'objectFiltro',
      value: function objectFiltro() {
        return {
          filtros: [],
          tableState: {
            sort: {},
            search: {},
            pagination: {
              start: 0,
              totalItemCount: 0,
              number: 10,
              numberOfPages: 1
            }
          }
        };
      }
    }, {
      key: 'buildObjectTotalFiltro',
      value: function buildObjectTotalFiltro(fim, tipo, resolvidos) {
        var dataHojeFim = this.moment().endOf('day'),
            endDate = fim.isBefore(dataHojeFim) ? fim : dataHojeFim,
            startDate = angular.copy(fim),
            filtro = [{
          key: this.keys.dateTime.name,
          value: {
            tipo: 'personalizado',
            endDate: endDate.format(),
            startDate: startDate.subtract(1, 'day').format()
          }
        }, {
          key: this.keys.uo.name,
          value: {
            id: this.uoFiltro
          }
        }, {
          key: this.keys.tipos.name,
          value: {
            id: tipo === 'EXCESSO_VELOCIDADE_20' || tipo === 'EXCESSO_VELOCIDADE_30' || tipo === 'EXCESSO_VELOCIDADE_ACIMA_30' ? 'EXCESSO_VELOCIDADE' : tipo
          }
        }];

        if (tipo === 'EXCESSO_VELOCIDADE_20') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'BAIXO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'MEDIO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_ACIMA_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'ALTO' } });
        }

        if (resolvidos) {
          filtro.push({ key: this.keys.status.name, value: { id: 'RESOLVIDO' } });
        }

        return '/historico-alerta?vfiltro=' + this.urlService.getObjectVfiltro(filtro);
      }
    }, {
      key: 'buildObjectTurnoFiltro',
      value: function buildObjectTurnoFiltro(uo, index, tipo) {
        var dataHojeFim = this.moment().endOf('day'),
            fim = this.moment(this.turnos[index].fimCompleto),
            endDate = fim.isBefore(dataHojeFim) ? fim : dataHojeFim,
            filtro = [{
          key: this.keys.dateTime.name,
          value: {
            startDate: this.turnos[index].inicioCompleto,
            endDate: endDate.format(),
            tipo: 'personalizado'
          }
        }, {
          key: this.keys.tipos.name,
          value: {
            id: tipo === 'EXCESSO_VELOCIDADE_20' || tipo === 'EXCESSO_VELOCIDADE_30' || tipo === 'EXCESSO_VELOCIDADE_ACIMA_30' ? 'EXCESSO_VELOCIDADE' : tipo
          }
        }];

        if (this.uos.filter(function (x) {
          return x.id === uo;
        }).length > 0) {
          filtro.push({ key: this.keys.uo.name, value: { id: uo } });
        } else {
          filtro.push({ key: this.keys.uo.name, value: { id: this.uoFiltro } }, { key: this.keys.uoParceira.name, value: { id: uo } });
        }

        if (tipo === 'EXCESSO_VELOCIDADE_20') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'BAIXO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'MEDIO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_ACIMA_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'ALTO' } });
        }

        return '/historico-alerta?vfiltro=' + this.urlService.getObjectVfiltro(filtro);
      }
    }, {
      key: 'unbindScopeWatch',
      value: function unbindScopeWatch() {
        if (this.listaAlertaWatch.length > 0) {
          this.listaAlertaWatch.forEach(function (e) {
            return e();
          });
          this.listaAlertaWatch = [];
        }
      }
    }, {
      key: 'buildObjectGridster',
      value: function buildObjectGridster(name) {
        var listaPosicoes = [],
            listaGridster = [],
            listaLocalstorage = {},
            criarNovaLista = false;

        this.alertaTurno.map(function (alerta, index) {
          listaPosicoes[index] = { row: Math.floor(index / 3) * 2, col: index % 3 * 4, sizeX: 4, sizeY: 2, minSizeY: 1, maxSizeY: 6, minSizeX: 4, maxSizeX: 12, sort: {}, tipo: alerta.key };
        });

        listaGridster = listaPosicoes.filter(function (i) {
          return i.tipo !== '';
        });
        listaLocalstorage = this.customGridster.getLocalStorage(name);

        if (listaLocalstorage && listaLocalstorage.versao && listaLocalstorage.versao === this.onePageCtrl.versaoLocalstorage) {
          var copyListaGridster = angular.copy(listaGridster),
              copylistaLocalstorage = angular.copy(listaLocalstorage.alertas);

          copyListaGridster = copyListaGridster.map(function (x) {
            return x.tipo;
          }).sort().toString();
          copylistaLocalstorage = copylistaLocalstorage.map(function (x) {
            return x.tipo;
          }).sort().toString();
          if (copyListaGridster !== copylistaLocalstorage) {
            criarNovaLista = true;
          }
        } else {
          criarNovaLista = true;
          this.customGridster.setLocalStorage(name, { name: name, alertas: listaGridster, versao: this.onePageCtrl.versaoLocalstorage });
        }

        if (criarNovaLista) {
          this.posicoesGridster = listaGridster;
          this.customGridster.setLocalStorage(name, { name: name, alertas: listaGridster, versao: this.onePageCtrl.versaoLocalstorage });
        } else {
          this.posicoesGridster = listaLocalstorage.alertas;
        }
      }
    }, {
      key: 'setPosicaoGraficoAlertaTurno',
      value: function setPosicaoGraficoAlertaTurno() {
        var name = 'c-alertaTurno-' + this.user.id + '-' + this.uoFiltro;

        this.unbindScopeWatch();
        this.buildObjectGridster(name);

        for (var i = 0; i < this.posicoesGridster.length; i++) {
          this.listaAlertaWatch.push(this.onePageCtrl.setPosicaoLocalStorageAlertas(this.posicoesGridster[i], name));
        }
      }
    }, {
      key: 'collapseAlertas',
      value: function collapseAlertas() {
        this.collapseAlertasControle = !this.collapseAlertasControle;
        this.window.localStorage.setItem('collapse-alertas-' + this.user.id, angular.toJson(this.collapseAlertasControle));
      }
    }]);

    return AlertaTurnoOnePageCardCtrl;
  }();

  angular.module('onePageModule').controller('AlertaTurnoOnePageCardCtrl', AlertaTurnoOnePageCardCtrl).directive('alertaTurnoOnePageCardDirective', alertaTurnoOnePageCardDirective);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var SemSinalModalCtrl = function SemSinalModalCtrl($uibModalInstance) {
    _classCallCheck(this, SemSinalModalCtrl);

    this.modalInstance = $uibModalInstance;
  };

  angular.module('onePageModule').controller('SemSinalModalCtrl', SemSinalModalCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function semSinalOnePageGraficoDirective() {
    return {
      templateUrl: 'one-page/directives/sem-sinal/grafico/sem-sinal-one-page-grafico.tpl.html',
      controller: 'SemSinalOnePageGraficoCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var SemSinalOnePageGraficoCtrl = function () {
    function SemSinalOnePageGraficoCtrl($scope, $window, $httpParamSerializer, HalfPieChart, moment, OnePageService, $uibModal, Keys, UrlService, $translate, GoogleTagManagerUtils, ServiceVfiltro) {
      var _this = this;

      _classCallCheck(this, SemSinalOnePageGraficoCtrl);

      this.scope = $scope;
      this.window = $window;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.onePageService = OnePageService;
      this.modalService = $uibModal;
      this.keys = Keys;
      this.urlService = UrlService;
      this.translate = $translate;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.serviceVfiltro = ServiceVfiltro;

      this.semSinal = HalfPieChart.get();
      this.semSinal.removeTitleCategories();
      this.semSinal.setClickEvent(this.clickBinding().onClickColumn);
      this.comSinalEnum = this.translate.instant('ce.enum.common.comSinal');
      this.semSinalEnum = this.translate.instant('ce.enum.common.semSinal');

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateStatusVeiculoPassivelManutencao();
      });

      this.init();
    }

    _createClass(SemSinalOnePageGraficoCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.onePageService.checkStatusVeiculoPassivelManutencao({ uoId: this.scope.onePage.getParamValue(this.keys.uo.name) }).then(function () {
          if (_this2.onePageService.listaCacheadaPassivelManutencao) {
            _this2.semSinal.setData(_this2.buildGraficoSemSinal(_this2.onePageService.listaCacheadaPassivelManutencao));
          }
        });
        this.onePageService.onUpdateStatusVeiculoPassivelManutencao(function (data) {
          return _this2.semSinal.setData(_this2.buildGraficoSemSinal(data));
        }, this.semSinalEnum);
      }
    }, {
      key: 'buildGraficoSemSinal',
      value: function buildGraficoSemSinal(data) {
        var retorno = { categorias: [this.comSinalEnum, this.semSinalEnum], series: [] };
        if (data && data.length > 0) {
          this.semSinal.erroSemData = false;
          var comSinal = data.filter(function (x) {
            return x.diasSemSinal === 0;
          }),
              semSinal = data.filter(function (x) {
            return x.diasSemSinal > 0;
          }),
              qntComSinal = comSinal.length,
              qntSemSinal = data.length - qntComSinal;
          retorno.series.push({ name: this.comSinalEnum, y: qntComSinal > 0 ? qntComSinal : null, ids: comSinal.map(function (x) {
              return x.veiculoId;
            }) });
          retorno.series.push({ name: this.semSinalEnum, y: qntSemSinal > 0 ? qntSemSinal : null, ids: semSinal.map(function (x) {
              return x.veiculoId;
            }) });
        } else {
          this.semSinal.erroSemData = true;
        }
        return retorno;
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this;

        return {
          onClickColumn: function onClickColumn(e) {
            var qntMaxVeiculosId = 300;
            self.googleTagManagerUtils.sendEventClickGTM('status_frota_drill_down', self.serviceVfiltro.factoryVfiltro.user);
            var info = self.semSinal.series[0].data.filter(function (i) {
              return i[0] === e.point.name;
            })[0][2];
            if (info.length <= qntMaxVeiculosId) {
              var urlRedirect = self.filtroLinkMapGrid(self.scope.onePage.getParamValue(self.keys.uo.name), info);
              if (e.point.name === self.semSinalEnum) {
                urlRedirect = self.filtroLinkHistoricoAlerta(self.scope.onePage.getParamValue(self.keys.uo.name), 'VEICULO_SEM_SINAL');
              }
              self.redirectTo(urlRedirect);
            } else {
              self.modalService.open({
                animation: true,
                templateUrl: 'one-page/directives/sem-sinal/modal/sem-sinal-one-page-modal.tpl.html',
                controller: 'SemSinalModalCtrl',
                controllerAs: '$ctrl'
              });
            }
          }
        };
      }
    }, {
      key: 'redirectTo',
      value: function redirectTo(url) {
        this.window.location.href = url;
      }
    }, {
      key: 'filtroLinkMapGrid',
      value: function filtroLinkMapGrid(uoId, veiculos) {
        return '/mapas-grid?forceRenderLayer=true&vfiltro=' + this.urlService.getObjectVfiltro([{ key: this.keys.uo.name, value: { id: uoId } }, { key: this.keys.veiculos.name, values: veiculos.map(function (x) {
            return { id: x };
          }) }]);
      }
    }, {
      key: 'filtroLinkHistoricoAlerta',
      value: function filtroLinkHistoricoAlerta(uoId, tipo) {
        var filtro = [{
          key: this.keys.dateTime.name,
          value: {
            startDate: this.moment().startOf('day'),
            endDate: this.moment().endOf('day'),
            tipo: 'personalizado'
          }
        }, { key: this.keys.uo.name, value: { id: uoId } }, { key: this.keys.tipos.name, value: { id: tipo } }];
        return '/historico-alerta?vfiltro=' + this.urlService.getObjectVfiltro(filtro);
      }
    }]);

    return SemSinalOnePageGraficoCtrl;
  }();

  angular.module('onePageModule').controller('SemSinalOnePageGraficoCtrl', SemSinalOnePageGraficoCtrl).directive('semSinalOnePageGraficoDirective', semSinalOnePageGraficoDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function semSinalOnePageCardDirective() {
    return {
      templateUrl: 'one-page/directives/sem-sinal/card/sem-sinal-one-page-card.tpl.html',
      controller: 'SemSinalOnePageCardCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var SemSinalOnePageCardCtrl = function () {
    function SemSinalOnePageCardCtrl($scope, $window, moment, $httpParamSerializer, OnePageService, $uibModal, Keys, UrlService, $translate) {
      var _this = this;

      _classCallCheck(this, SemSinalOnePageCardCtrl);

      this.scope = $scope;
      this.window = $window;
      this.moment = moment;
      this.httpParamSerializer = $httpParamSerializer;
      this.onePageService = OnePageService;
      this.modalService = $uibModal;
      this.keys = Keys;
      this.urlService = UrlService;
      this.translate = $translate;

      this.excedidoQuantidadeMaximaVeiculos = { comSinal: false, semSinal: false };

      this.semSinal = { data: [], erroSemData: false };
      this.onePageCtrl = this.scope.$parent.$parent.onePage;
      this.comSinalEnum = this.translate.instant('ce.enum.common.comSinal');
      this.semSinalEnum = this.translate.instant('ce.enum.common.semSinal');

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateStatusVeiculoPassivelManutencao();
      });

      this.init();
    }

    _createClass(SemSinalOnePageCardCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        if (this.onePageService.listaCacheadaPassivelManutencao) {
          this.buildGraficoSemSinal(this.onePageService.listaCacheadaPassivelManutencao);
        }
        this.onePageService.onUpdateStatusVeiculoPassivelManutencao(function (data) {
          return _this2.buildGraficoSemSinal(data);
        }, 'semSinal');
      }
    }, {
      key: 'buildGraficoSemSinal',
      value: function buildGraficoSemSinal(data) {
        this.semSinal.data = [];
        this.semSinal.erroSemData = false;

        if (data && data.length > 0) {
          this.semSinal.erroSemData = false;
          var comSinal = data.filter(function (x) {
            return x.diasSemSinal === 0;
          }),
              semSinal = data.filter(function (x) {
            return x.diasSemSinal > 0;
          }),
              qntComSinal = comSinal.length,
              qntSemSinal = data.length - qntComSinal;
          var idsComSinal = comSinal.map(function (x) {
            return x.veiculoId;
          }),
              idsSemSinal = semSinal.map(function (x) {
            return x.veiculoId;
          }),
              qntMaxVeiculosId = 300;
          this.excedidoQuantidadeMaximaVeiculos.comSinal = idsComSinal.length > qntMaxVeiculosId;
          this.excedidoQuantidadeMaximaVeiculos.semSinal = idsSemSinal.length > qntMaxVeiculosId;

          this.semSinal.data.push({
            name: this.comSinalEnum,
            total: qntComSinal,
            porcentagem: qntComSinal > 0 ? Math.round(qntComSinal / data.length * 100 * 1e2) / 1e2 : 0,
            ids: idsComSinal,
            url: idsComSinal.length > 0 && idsComSinal.length <= qntMaxVeiculosId ? this.getUrlLocalizacaoFrota(idsComSinal) : null
          });
          this.semSinal.data.push({
            name: this.semSinalEnum,
            total: qntSemSinal,
            porcentagem: qntSemSinal > 0 ? Math.round(qntSemSinal / data.length * 100 * 1e2) / 1e2 : 0,
            ids: idsSemSinal,
            url: idsSemSinal.length > 0 && idsSemSinal.length <= qntMaxVeiculosId ? this.getUrlHistoricoAlerta() : null
          });
        } else {
          this.semSinal.erroSemData = true;
        }
      }
    }, {
      key: 'getUrlLocalizacaoFrota',
      value: function getUrlLocalizacaoFrota(ids) {
        return this.filtroLinkMapGrid(this.onePageCtrl.getParams(this.keys.uo.name), ids);
      }
    }, {
      key: 'getUrlHistoricoAlerta',
      value: function getUrlHistoricoAlerta() {
        return this.filtroLinkHistoricoAlerta(this.onePageCtrl.getParams(this.keys.uo.name), 'VEICULO_SEM_SINAL');
      }
    }, {
      key: 'openModal',
      value: function openModal(excedidoQuantidadeVeiculos) {
        if (excedidoQuantidadeVeiculos) {
          this.modalService.open({
            animation: true,
            templateUrl: 'one-page/directives/sem-sinal/modal/sem-sinal-one-page-modal.tpl.html',
            controller: 'SemSinalModalCtrl',
            controllerAs: '$ctrl'
          });
        }
      }
    }, {
      key: 'filtroLinkMapGrid',
      value: function filtroLinkMapGrid(uoId, veiculos) {
        return '/mapas-grid?forceRenderLayer=true&vfiltro=' + this.urlService.getObjectVfiltro([{ key: this.keys.uo.name, value: { id: uoId.uoId } }, { key: this.keys.veiculos.name, values: veiculos.map(function (x) {
            return { id: x };
          }) }]);
      }
    }, {
      key: 'filtroLinkHistoricoAlerta',
      value: function filtroLinkHistoricoAlerta(uoId, tipo) {
        var filtro = [{
          key: this.keys.dateTime.name,
          value: {
            startDate: this.moment().startOf('day'),
            endDate: this.moment().endOf('day'),
            tipo: 'personalizado'
          }
        }, { key: this.keys.uo.name, value: { id: uoId.uoId } }, { key: this.keys.tipos.name, value: { id: tipo } }];
        return '/historico-alerta?vfiltro=' + this.urlService.getObjectVfiltro(filtro);
      }
    }]);

    return SemSinalOnePageCardCtrl;
  }();

  angular.module('onePageModule').controller('SemSinalOnePageCardCtrl', SemSinalOnePageCardCtrl).directive('semSinalOnePageCardDirective', semSinalOnePageCardDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function paradoMovimentoOnePageGraficoDirective() {
    return {
      templateUrl: 'one-page/directives/parado-movimento/grafico/parado-movimento-one-page-grafico.tpl.html',
      controller: 'ParadoMovimentoOnePageGraficoCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var ParadoMovimentoOnePageGraficoCtrl = function () {
    function ParadoMovimentoOnePageGraficoCtrl($scope, $timeout, HalfPieChart, OnePageService, Keys, $translate) {
      var _this = this;

      _classCallCheck(this, ParadoMovimentoOnePageGraficoCtrl);

      this.scope = $scope;
      this.onePageService = OnePageService;
      this.translate = $translate;
      this.paradoMovimento = HalfPieChart.get();
      this.paradoMovimento.removeTitleCategories();
      this.keys = Keys;
      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateStatusVeiculo();
      });

      this.paradoEnum = this.translate.instant('ce.enum.eventos.parado');
      this.movimentoEnum = this.translate.instant('ce.enum.eventos.movimento');
      this.init();
    }

    _createClass(ParadoMovimentoOnePageGraficoCtrl, [{
      key: 'init',
      value: function init() {
        this.buildWithListaCacheada();
        this.setOnUpdateStatus();
      }
    }, {
      key: 'buildWithListaCacheada',
      value: function buildWithListaCacheada() {
        var _this2 = this;

        this.onePageService.checkStatusVeiculo({ uoId: this.scope.onePage.getParamValue(this.keys.uo.name) }).then(function () {
          if (_this2.onePageService.listaCacheada) {
            _this2.paradoMovimento.setData(_this2.buildGraficoParadoMovimento(_this2.onePageService.listaCacheada));
          }
        });
      }
    }, {
      key: 'setOnUpdateStatus',
      value: function setOnUpdateStatus() {
        var _this3 = this;

        this.onePageService.onUpdateStatusVeiculo(function (data) {
          return _this3.paradoMovimento.setData(_this3.buildGraficoParadoMovimento(data));
        }, 'paradoMovimento');
      }
    }, {
      key: 'buildGraficoParadoMovimento',
      value: function buildGraficoParadoMovimento(data) {
        var _this4 = this;

        var retorno = { categorias: [this.movimentoEnum, this.paradoEnum], series: [] };
        if (data && data.length > 0) {
          this.paradoMovimento.erroSemData = false;
          var qntMovimento = data.filter(function (x) {
            return x.status === _this4.movimentoEnum;
          }).length,
              qntParado = data.length - qntMovimento;
          retorno.series.push({ name: this.movimentoEnum, y: qntMovimento > 0 ? qntMovimento : null });
          retorno.series.push({ name: this.paradoEnum, y: qntParado > 0 ? qntParado : null });
        } else {
          this.paradoMovimento.erroSemData = true;
        }
        return retorno;
      }
    }]);

    return ParadoMovimentoOnePageGraficoCtrl;
  }();

  angular.module('onePageModule').controller('ParadoMovimentoOnePageGraficoCtrl', ParadoMovimentoOnePageGraficoCtrl).directive('paradoMovimentoOnePageGraficoDirective', paradoMovimentoOnePageGraficoDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function paradoMovimentoOnePageCardDirective() {
    return {
      templateUrl: 'one-page/directives/parado-movimento/card/parado-movimento-one-page-card.tpl.html',
      controller: 'ParadoMovimentoOnePageCardCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var ParadoMovimentoOnePageCardCtrl = function () {
    function ParadoMovimentoOnePageCardCtrl($scope, OnePageService, $translate) {
      var _this = this;

      _classCallCheck(this, ParadoMovimentoOnePageCardCtrl);

      this.scope = $scope;
      this.onePageService = OnePageService;
      this.translate = $translate;

      this.paradoMovimento = { data: [], erroSemData: false };
      this.paradoEnum = this.translate.instant('ce.enum.eventos.parado');
      this.movimentoEnum = this.translate.instant('ce.enum.eventos.movimento');

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateStatusVeiculo();
      });

      this.init();
    }

    _createClass(ParadoMovimentoOnePageCardCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        if (this.onePageService.listaCacheada) {
          this.buildGraficoParadoMovimento(this.onePageService.listaCacheada);
        }
        this.onePageService.onUpdateStatusVeiculo(function (data) {
          return _this2.buildGraficoParadoMovimento(data);
        }, 'paradoMovimento');
      }
    }, {
      key: 'buildGraficoParadoMovimento',
      value: function buildGraficoParadoMovimento(data) {
        var _this3 = this;

        this.paradoMovimento.data = [];
        this.paradoMovimento.erroSemData = false;

        if (data && data.length > 0) {
          this.paradoMovimento.erroSemData = false;
          var qntMovimento = data.filter(function (x) {
            return x.status === _this3.movimentoEnum;
          }).length,
              qntParado = data.length - qntMovimento;
          this.paradoMovimento.data.push({
            name: this.movimentoEnum,
            total: qntMovimento,
            porcentagem: qntMovimento > 0 ? Math.round(qntMovimento / data.length * 100 * 1e2) / 1e2 : 0
          });
          this.paradoMovimento.data.push({
            name: this.paradoEnum,
            total: qntParado,
            porcentagem: qntParado > 0 ? Math.round(qntParado / data.length * 100 * 1e2) / 1e2 : 0
          });
        } else {
          this.paradoMovimento.erroSemData = true;
        }
      }
    }]);

    return ParadoMovimentoOnePageCardCtrl;
  }();

  angular.module('onePageModule').controller('ParadoMovimentoOnePageCardCtrl', ParadoMovimentoOnePageCardCtrl).directive('paradoMovimentoOnePageCardDirective', paradoMovimentoOnePageCardDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  function alertaTurnoOnePageGraficoDirective() {
    return {
      templateUrl: 'one-page/directives/alerta-turno/grafico/alerta-turno-one-page-grafico.tpl.html',
      controller: 'AlertaTurnoOnePageGraficoCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var AlertaTurnoOnePageGraficoCtrl = function () {
    function AlertaTurnoOnePageGraficoCtrl($scope, $window, $q, $httpParamSerializer, $timeout, DrilldownChart, moment, Authenticator, OnePageService, Uos, UoArvoreNivel, Keys, UrlService, ServiceVfiltro, Restangular, FactoryVfiltro, AlertaVeiculoService, $translate, GoogleTagManagerUtils) {
      var _this = this;

      _classCallCheck(this, AlertaTurnoOnePageGraficoCtrl);

      this.scope = $scope;
      this.restangular = Restangular;
      this.window = $window;
      this.q = $q;
      this.httpParamSerializer = $httpParamSerializer;
      this.timeout = $timeout;
      this.moment = moment;
      this.authenticator = Authenticator;
      this.alertaVeiculoService = AlertaVeiculoService;
      this.onePageService = OnePageService;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.keys = Keys;
      this.urlService = UrlService;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.onePageCtrl = this.scope.$parent.$parent.onePage;
      this.translate = $translate;
      this.googleTagManagerUtils = GoogleTagManagerUtils;

      this.alertaTurno = DrilldownChart.get();
      this.alertaTurno.setClickEvent(this.clickBinding().onClickColumn);

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeUpdateAlertaTurno();
        _this.onePageService.removeTimer();
        _this.alertaVeiculoService.stop();
      });

      this.loadFiltro();
    }

    _createClass(AlertaTurnoOnePageGraficoCtrl, [{
      key: 'loadFiltro',
      value: function loadFiltro() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          _this2.alertaVeiculoService.setUoId(user.uo.id);
          _this2.alertaVeiculoService.checkAlertaPorTipo();
          if (_this2.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
            _this2.visualizarHistoricoAlerta = true;
          }
          _this2.loadUos().then(function (x) {
            _this2.uos = x;
            _this2.serviceVfiltro.init(_this2.factoryVfiltro.get([{ key: _this2.keys.uo.name }])).then(function (filtro) {
              _this2.uoId = filtro.find(function (k) {
                return k.key === _this2.keys.uo.name;
              }).value.id;
              _this2.init(user);
            });
          });
        });
      }
    }, {
      key: 'verificarAlertasInativos',
      value: function verificarAlertasInativos() {
        var _this3 = this;

        this.restangular.one('configuracao/configuracoes/' + this.uoId + '/alerta').get().then(function (alertas) {
          _this3.erroAlertasInativos = _.values(alertas.configuracoes).filter(function (item) {
            return item.ativo;
          }).length === 0;
          if (_this3.erroAlertasInativos) {
            _this3.mensagemDeErro = 'ce.tempoReal.statusFrota.charts.alertaSeguranca.nenhumAlertaAtivo';
            _this3.linkConfigAlertas = _this3.receberUrlConfigAlertas();
          } else if (!_this3.erroAlertasInativos) {
            _this3.mensagemDeErro = _this3.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.mensagemSucesso');
          }
        }, function () {
          _this3.mensagemDeErro = _this3.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
        });
      }
    }, {
      key: 'loadUos',
      value: function loadUos() {
        var _this4 = this;

        return this.q(function (resolve) {
          _this4.uoService.getFilhas().then(function (uos) {
            uos = _this4.uoArvoreNivel.converterEmLista(uos);
            resolve(uos.map(function (u) {
              return { id: u.id, label: u.nome, arvoreNivel: u.arvoreNivel };
            }));
          }, function () {});
        });
      }
    }, {
      key: 'init',
      value: function init(user) {
        var _this5 = this;

        this.user = user;
        this.onePageService.checkAlertaTurno({ uoId: this.scope.onePage.getParamValue(this.keys.uo.name) }).then(function () {
          if (_this5.onePageService.listaCacheadaAlertaTurno) {
            var chart = angular.element('#highcharts-alertaturno').highcharts();
            if (chart) {
              if (_this5.alertaTurno.isDrillDown) {
                chart.drillUp();
              }
              _this5.alertaTurno.setData(_this5.buildCardAlertaTurno(_this5.onePageService.listaCacheadaAlertaTurno));
              if (_this5.alertaTurno.erroSemData) {
                _this5.verificarAlertasInativos();
              }
              chart.reflow();
            }
          }
          _this5.onePageService.onUpdateAlertaTurno(function (data) {
            var chart = angular.element('#highcharts-alertaturno').highcharts();
            if (chart) {
              if (_this5.alertaTurno.isDrillDown) {
                chart.drillUp();
              }
              _this5.alertaTurno.setData(_this5.buildCardAlertaTurno(data));
              if (_this5.alertaTurno.erroSemData) {
                _this5.verificarAlertasInativos();
              }
              chart.reflow();
            }
          }, 'onepage');

          _this5.onePageService.onUpdateAlertaTurnoError(function (error) {
            if (error) {
              _this5.mensagemDeErro = _this5.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.falhaComunicacaoServidor');
            }
          }, 'onepageError');
        });
      }
    }, {
      key: 'buildCardAlertaTurno',
      value: function buildCardAlertaTurno(data) {
        var _this6 = this;

        var tipoAlertas = angular.copy(this.alertaVeiculoService.alertaMapPtBr),
            retorno = { series: [], turnoAtual: 1, drilldown: [] },
            turnos = [];

        turnos = data.turnos.map(function (x, y) {
          var atual = _this6.moment(),
              inicio = _this6.moment(x.inicio),
              fim = _this6.moment(x.fim),
              ativo = atual.isBetween(inicio, fim);

          if (ativo) {
            retorno.turnoAtual = y + 1;
          }

          return inicio.format('HH:mm') + ' - ' + fim.format('HH:mm');
        });

        Object.keys(tipoAlertas).forEach(function (alerta) {
          tipoAlertas[alerta].uoContagensTurno = [];

          var itemData = data.paineis.filter(function (painel) {
            return painel.label === tipoAlertas[alerta].key;
          })[0];
          if (itemData) {
            var eventosResolvidos = [],
                eventosOcorridos = [];
            var color = tipoAlertas[alerta].chartColor;

            for (var i = 0; i < turnos.length; i++) {
              eventosResolvidos.push({
                name: turnos[i],
                y: _this6.countTurno(itemData, i, 'resolvidos'),
                color: color,
                drilldown: tipoAlertas[alerta].key + '_RESOLVIDO_' + i
              });
              eventosOcorridos.push({
                name: turnos[i],
                y: _this6.countTurno(itemData, i, 'ocorridos'),
                color: color,
                drilldown: tipoAlertas[alerta].key + '_OCORRIDO_' + i
              });

              var evento = tipoAlertas[alerta].key,
                  turno = data.turnos[i];

              retorno.drilldown.push({
                id: tipoAlertas[alerta].key + '_RESOLVIDO_' + i,
                name: tipoAlertas[alerta].texto,
                data: _this6.itemDrillDown(itemData, i, 'resolvidos', evento, turno)
              });
              retorno.drilldown.push({
                id: tipoAlertas[alerta].key + '_OCORRIDO_' + i,
                name: tipoAlertas[alerta].texto,
                data: _this6.itemDrillDown(itemData, i, 'ocorridos', evento, turno)
              });
            }

            retorno.series.push({ name: tipoAlertas[alerta].texto, stack: 'male', data: eventosResolvidos, color: color, id: tipoAlertas[alerta].key });
            retorno.series.push({ name: tipoAlertas[alerta].texto, stack: 'female', data: eventosOcorridos, color: color, id: tipoAlertas[alerta].key + '_2', linkedTo: tipoAlertas[alerta].key });
          }
        });
        return retorno;
      }
    }, {
      key: 'countTurno',
      value: function countTurno(itemData, i, tipo) {
        return itemData.uoContagensTurno.map(function (e) {
          return e.contagensTurno[i][tipo];
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      }
    }, {
      key: 'itemDrillDown',
      value: function itemDrillDown(itemData, i, tipo, evento, turno) {
        return itemData.uoContagensTurno.map(function (e) {
          return {
            name: e.uo.nome,
            uo: e.uo.id,
            evento: evento,
            turno: turno,
            y: e.contagensTurno[i][tipo]
          };
        });
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this;

        return {
          onClickColumn: function onClickColumn() {
            self.googleTagManagerUtils.sendEventClickGTM('status_frota_drill_down', self.serviceVfiltro.factoryVfiltro.user);
            if (this.category) {
              self.redirectTo(self.buildObjectTurnoFiltro(this.options.uo, this.options.turno.inicio, this.options.turno.fim, this.options.evento));
            }
          }
        };
      }
    }, {
      key: 'redirectTo',
      value: function redirectTo(url) {
        this.window.location.href = url;
      }
    }, {
      key: 'buildObjectTurnoFiltro',
      value: function buildObjectTurnoFiltro(uo, inicio, fim, tipo) {
        var dataHojeFim = this.moment().endOf('day'),
            fimMoment = this.moment(fim),
            endDate = fimMoment.isBefore(dataHojeFim) ? fimMoment : dataHojeFim,
            filtro = [{
          key: this.keys.dateTime.name,
          value: {
            startDate: this.moment(inicio).format(),
            endDate: endDate.format(),
            tipo: 'personalizado'
          }
        }, {
          key: this.keys.tipos.name,
          value: {
            id: tipo === 'EXCESSO_VELOCIDADE_20' || tipo === 'EXCESSO_VELOCIDADE_30' || tipo === 'EXCESSO_VELOCIDADE_ACIMA_30' ? 'EXCESSO_VELOCIDADE' : tipo
          }
        }];

        if (this.uos.filter(function (x) {
          return x.id === uo;
        }).length > 0) {
          filtro.push({ key: this.keys.uo.name, value: { id: uo } });
        } else {
          filtro.push({ key: this.keys.uo.name, value: { id: this.onePageCtrl.getParamValue(this.keys.uo.name) } }, { key: this.keys.uoParceira.name, value: { id: uo } });
        }

        if (tipo === 'EXCESSO_VELOCIDADE_20') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'BAIXO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'MEDIO' } });
        } else if (tipo === 'EXCESSO_VELOCIDADE_ACIMA_30') {
          filtro.push({ key: this.keys.nivel.name, value: { id: 'ALTO' } });
        }

        return '/historico-alerta?vfiltro=' + this.urlService.getObjectVfiltro(filtro);
      }
    }, {
      key: 'receberUrlConfigAlertas',
      value: function receberUrlConfigAlertas() {
        if (this.erroAlertasInativos) {
          return '/configuracoes-eventos?vfiltro=' + this.urlService.getObjectVfiltro(this.serviceVfiltro.filtroTopbar);
        }
      }
    }]);

    return AlertaTurnoOnePageGraficoCtrl;
  }();

  angular.module('onePageModule').controller('AlertaTurnoOnePageGraficoCtrl', AlertaTurnoOnePageGraficoCtrl).directive('alertaTurnoOnePageGraficoDirective', alertaTurnoOnePageGraficoDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function menuDefaultDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuDefaultCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuDefaultCtrl = function () {
    function MenuDefaultCtrl($scope, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, CercaEletronicaService, $rootScope, $translate, ServiceVfiltro, GoogleTagManagerUtils, MapasUtil, Authenticator) {
      var _this = this;

      _classCallCheck(this, MenuDefaultCtrl);

      this.scope = $scope;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.cercaEletronicaService = CercaEletronicaService;
      this.rootScope = $rootScope;
      this.translate = $translate;
      this.serviceVfiltro = ServiceVfiltro;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.mapasUtilService = MapasUtil;
      this.authenticator = Authenticator;

      this.user = null;
      this.rootScope.$on('init-menu-map', function () {
        _this.setup();
      });
      this.setup();
    }

    _createClass(MenuDefaultCtrl, [{
      key: 'setup',
      value: function setup() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          _this2.user = user;
          _this2.init();
        });
      }
    }, {
      key: 'init',
      value: function init() {
        var _this3 = this;

        var buttons = [{
          titulo: this.translate.instant('ce.mapa.common.tituloBtPesquisar'),
          icon: 'fa fa-search',
          color: 'default',
          tipo: 'pesquisar',
          funcao: function funcao() {
            return _this3.mapasUtilService.activateAllMapLayers(_this3.user.id);
          }
        }],
            cadastroConfig = this.pontosReferenciaMapService.cadastroPontoConfig;

        if (this.cercaEletronicaService.roleCadastrar) {
          buttons.unshift({
            titulo: this.translate.instant('ce.mapa.common.menuDefaultDirective.tituloBtAdicionarCerca'),
            icon: 'trimble-control-area',
            color: 'default',
            tipo: 'adicionar-cerca-eletronica',
            funcao: function funcao() {
              return _this3.mapasUtilService.activateAllMapLayers(_this3.user.id);
            }
          });
        }

        if (this.pontosReferenciaService.roleCadastrar && cadastroConfig !== null && angular.isDefined(cadastroConfig.permissaoDeEdicao) && this.pontosReferenciaMapService.cadastroPontoConfig.permissaoDeEdicao) {
          buttons.unshift({
            titulo: this.translate.instant('ce.mapa.common.menuDefaultDirective.tituloBtAdicionarPontoReferencia'),
            icon: 'fa fa-map-marker',
            color: 'default',
            tipo: 'adicionar',
            funcao: function funcao() {
              return _this3.mapasUtilService.activateAllMapLayers(_this3.user.id);
            }
          });
        }

        if (this.scope.$parent.pontosProximos) {
          buttons.push({
            titulo: this.translate.instant('ce.mapa.common.menuDefaultDirective.tituloBtAdicionarPontosProx'),
            icon: 'fa fa-thumb-tack',
            color: 'default',
            tipo: 'adicionar-pontos-proximos',
            funcao: function funcao() {
              _this3.googleTagManagerUtils.sendEventClickGTM('add_ponto_proximo', _this3.serviceVfiltro.factoryVfiltro.user);
              _this3.pontosReferenciaMenuService.setFABActive('adicionar-pontos-proximos');
              _this3.mapasUtilService.activateAllMapLayers(_this3.user.id);
            }
          });
        }

        if (this.pontosReferenciaMenuService.idMapa === 'historico-map') {
          buttons.push({
            titulo: this.translate.instant('ce.mapa.common.menuDefaultDirective.tituloBtReproducaoRotas'),
            icon: 'fa fa-play',
            color: 'default',
            tipo: 'reproducao-rotas',
            funcao: function funcao() {
              _this3.googleTagManagerUtils.sendEventClickGTM('reproducao_rota_visualizar', _this3.serviceVfiltro.factoryVfiltro.user);
              _this3.pontosReferenciaMenuService.setFABActive('reproducao-rotas');
              _this3.mapasUtilService.activateAllMapLayers(_this3.user.id);
            }
          });
        }
        this.pontosReferenciaMenuService.setMenu(buttons);
      }
    }]);

    return MenuDefaultCtrl;
  }();

  angular.module('mapControlModule').controller('MenuDefaultCtrl', MenuDefaultCtrl).directive('menuDefaultDirective', menuDefaultDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  function menuExcluirPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuExcluirPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuExcluirPontoReferenciaCtrl = function () {
    function MenuExcluirPontoReferenciaCtrl($scope, $rootScope, $uibModal, AlertMessage, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, $translate, CadastroRotogramaService) {
      _classCallCheck(this, MenuExcluirPontoReferenciaCtrl);

      this.rootScope = $rootScope;
      this.scope = $scope;
      this.modalService = $uibModal;
      this.alertMessage = AlertMessage;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.translate = $translate;
      this.cadastroRotogramaService = CadastroRotogramaService;
      this.init();
    }

    _createClass(MenuExcluirPontoReferenciaCtrl, [{
      key: 'init',
      value: function init() {
        var buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtExcluirPonto',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'default',
          funcao: this.excluirPontoBanco.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'editar'
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMenuService.drawerClose();
        this.pontosReferenciaMenuService.menuOpen();
      }
    }, {
      key: 'excluirPontoBanco',
      value: function excluirPontoBanco() {
        var pontoReferencia = this.pontosReferenciaMapService.layer.entidadePermissao.entidade;
        if (angular.isDefined(pontoReferencia.rotogramas) && pontoReferencia.rotogramas.length > 0) {
          this.openConfirmationDeleteRotogramasPonto(pontoReferencia.id);
        } else {
          this.deletePonto(pontoReferencia.id);
        }
      }
    }, {
      key: 'openConfirmationDeleteRotogramasPonto',
      value: function openConfirmationDeleteRotogramasPonto(pontoId) {
        if (this.pontosReferenciaService.roleCadastrarRotograma) {
          this.deleteRotogramasAfterConfirmation(pontoId);
        } else {
          this.showErrorSnackbar('ce.mapa.common.menuExcluirPonto.erroRotograma');
          this.pontosReferenciaMapService.setLayerDefault();
        }
      }
    }, {
      key: 'deleteRotogramasAfterConfirmation',
      value: function deleteRotogramasAfterConfirmation(pontoId) {
        var _this = this;

        /* eslint-disable */
        var container = document.querySelector('#container-delete-confirm'),
            dialog = document.createElement('vfwc-element-delete-confirm-dialog');
        /* eslint-enable */
        container.innerHTML = '';
        dialog.title = 'ce.mapa.common.menuExcluirPonto.deleteComRotogramaTitle';
        dialog.content = ['ce.mapa.common.menuExcluirPonto.deleteRotogramaConfirm'];
        dialog.cancelText = 'dialog.common.cancelar';
        dialog.confirmText = 'ce.mapa.common.modal.excluirCategoriaPonto.tituloBtExcluir';
        container.appendChild(dialog);
        dialog.addEventListener('isConfirmed', function (e) {
          if (e.detail && e.detail.isConfirmed) {
            _this.deletePontoAndAllRotogramas(pontoId);
          } else {
            _this.pontosReferenciaMapService.setLayerDefault();
          }
        });
      }
    }, {
      key: 'deletePontoAndAllRotogramas',
      value: function deletePontoAndAllRotogramas(pontoId) {
        var _this2 = this;

        this.cadastroRotogramaService.deleteAllByPontoId(pontoId).then(function () {
          _this2.deletePonto(pontoId);
        }).catch(function () {
          _this2.showErrorSnackbar('ce.mapa.common.modal.cadastroRotograma.errorExcluir');
          _this2.pontosReferenciaMapService.setLayerDefault();
        });
      }
    }, {
      key: 'showErrorSnackbar',
      value: function showErrorSnackbar(messageI18n) {
        this.alertMessage.create({
          type: 'error',
          message: this.translate.instant(messageI18n),
          appendTo: '.alerta-aqui-ponto'
        });
      }
    }, {
      key: 'deletePonto',
      value: function deletePonto(pontoId) {
        var _this3 = this;

        this.pontosReferenciaService.deletePontoReferencia(pontoId).then(function () {
          _this3.alertMessage.create({
            type: 'success',
            message: _this3.translate.instant('ce.mapa.common.menuExcluirPonto.excluirSucesso'),
            appendTo: '.alerta-aqui-ponto'
          });
          _this3.pontosReferenciaMapService.removePontoAndAllMarkers(pontoId);
        }).catch(function () {
          _this3.showErrorSnackbar('ce.mapa.common.menuExcluirPonto.excluirErro');
        });
        this.pontosReferenciaMenuService.setFABDefault();
      }
    }]);

    return MenuExcluirPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('MenuExcluirPontoReferenciaCtrl', MenuExcluirPontoReferenciaCtrl).directive('menuExcluirPontoReferenciaDirective', menuExcluirPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  function menuEditarPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuEditarPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuEditarPontoReferenciaCtrl = function () {
    function MenuEditarPontoReferenciaCtrl($scope, $uibModal, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, FeatureFlag, Authenticator, $rootScope, ServiceVfiltro) {
      var _this = this;

      _classCallCheck(this, MenuEditarPontoReferenciaCtrl);

      this.scope = $scope;
      this.modalService = $uibModal;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.featureFlag = FeatureFlag;
      this.authenticator = Authenticator;
      this.authenticator.getUser().then(function (user) {
        _this.user = user;
      });
      this.rootScope = $rootScope;
      this.serviceVfiltro = ServiceVfiltro;
      this.init();
    }

    _createClass(MenuEditarPontoReferenciaCtrl, [{
      key: 'init',
      value: function init() {
        this.pontosReferenciaMapService.layer.editing.disable();
        var buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.menuEditarPonto.tituloBtAjustarNoMapa',
          icon: 'fa fa-arrows-alt',
          color: 'default',
          tipo: 'ajustar'
        }, {
          titulo: 'ce.mapa.common.tituloBtEditarCadastro',
          icon: 'fa fa-pencil',
          color: 'default',
          tipo: 'editar',
          funcao: this.editarPonto.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtExcluirPonto',
          icon: 'fa fa-trash-o',
          color: 'default',
          tipo: 'excluir'
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cancelarPonto.bind(this)
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMenuService.menuOpen();
      }
    }, {
      key: 'editarPonto',
      value: function editarPonto() {
        var _this2 = this;

        this.pontosReferenciaMenuService.drawerClose();
        if (this.featureFlag.DIALOG_PONTO_REESTRUTURADO) {
          /* eslint-disable */
          var abrirModal = document.querySelector('#dialog-create-ponto'),
              modal = document.createElement('vfwc-open-dialog-create-ponto-referencia'); /* eslint-enable */
          modal.pontoReferencia = {
            id: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.id,
            latitude: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.latitude,
            longitude: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.longitude,
            raio: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.raio,
            uo: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.uo,
            rotogramas: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas || [],
            categoria: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.categoria,
            hasDeprecatedCategoriaAudio: this.pontosReferenciaMapService.layer.entidadePermissao.entidade.hasDeprecatedCategoriaAudio
          };
          modal.uoFiltro = this.uoSelecionadaParaEdicao();
          modal.usuario = this.user;
          abrirModal.appendChild(modal);
          this.onPontoEdited(modal);
        } else {
          this.modalService.open({
            animation: true,
            component: 'modalEdicaoPontoReferencia',
            backdrop: 'static',
            size: 'lg',
            openedClass: 'modal-edicao-ponto-referencia',
            resolve: {
              pontoReferencia: function pontoReferencia() {
                return {
                  id: _this2.pontosReferenciaMapService.layer.entidadePermissao.entidade.id,
                  latitude: _this2.pontosReferenciaMapService.layer.entidadePermissao.entidade.latitude,
                  longitude: _this2.pontosReferenciaMapService.layer.entidadePermissao.entidade.longitude,
                  raio: _this2.pontosReferenciaMapService.layer.entidadePermissao.entidade.raio
                };
              },
              rotogramas: function rotogramas() {
                return _this2.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas || [];
              },
              uoSelecionada: function uoSelecionada() {
                return _this2.uoSelecionadaParaEditarPonto();
              }
            }
          }).result.then(function (data) {
            return _this2.atualizarPonto(data);
          });
        }
      }
    }, {
      key: 'onPontoEdited',
      value: function onPontoEdited(element) {
        var _this3 = this;

        element.addEventListener('pontoReferenciaEventEmitter', function (event) {
          if (event.detail && event.detail.result) {
            var data = event.detail.result,
                rotogramaIds = _this3.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas ? _this3.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas.map(function (rotograma) {
              return rotograma.id;
            }) : [];
            _this3.atualizarPonto(data);
            if (data.rotogramas.length) {
              _this3.rootScope.$broadcast('rotogramasCadastrados', {
                rotogramas: data.rotogramas,
                pontoReferenciaId: data.entidade.id
              });
            } else if (rotogramaIds.length) {
              _this3.rootScope.$broadcast('rotogramasDeletados', {
                rotogramaIds: rotogramaIds,
                pontoReferenciaId: data.entidade.id
              });
            }
          }
        });
      }
    }, {
      key: 'uoSelecionadaParaEdicao',
      value: function uoSelecionadaParaEdicao() {
        if (this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === 'uo';
        })) {
          return this.serviceVfiltro.filtroTopbar.find(function (x) {
            return x.key === 'uo';
          }).value.id;
        }
        return this.user.uo.id;
      }
    }, {
      key: 'uoSelecionadaParaEditarPonto',
      value: function uoSelecionadaParaEditarPonto() {
        var config = this.pontosReferenciaMapService.cadastroPontoConfig;
        if (config !== null && config.uoDaRegra) {
          return config.uoDaRegra.id;
        }
        return this.pontosReferenciaMapService.layer.entidadePermissao.entidade.uo;
      }
    }, {
      key: 'atualizarPonto',
      value: function atualizarPonto(data) {
        this.pontosReferenciaMapService.pesquisa = '';
        this.pontosReferenciaMapService.pontos = [];
        this.pontosReferenciaMapService.atualizarLayer(data);
        if (angular.isDefined(data.entidade.limiteVelocidade)) {
          this.pontosReferenciaMapService.markerIn(this.pontosReferenciaMapService.getIdLayer(this.pontosReferenciaMapService.layer), [data.entidade.latitude, data.entidade.longitude], data.entidade.limiteVelocidade);
        } else {
          var layer = this.pontosReferenciaMapService.getMarkerLimite(this.pontosReferenciaMapService.getIdLayer(this.pontosReferenciaMapService.layer));
          if (layer !== null) {
            this.pontosReferenciaMapService.removeLayer(layer);
            this.pontosReferenciaMapService.removeLayerMap(layer);
          }
        }
      }
    }, {
      key: 'cancelarPonto',
      value: function cancelarPonto() {
        this.pontosReferenciaMenuService.setFABDefault();
        this.pontosReferenciaMapService.setLayerDefault();
      }
    }]);

    return MenuEditarPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('MenuEditarPontoReferenciaCtrl', MenuEditarPontoReferenciaCtrl).directive('menuEditarPontoReferenciaDirective', menuEditarPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  function menuAjustarPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuAjustarPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuAjustarPontoReferenciaCtrl = function () {
    function MenuAjustarPontoReferenciaCtrl($scope, $uibModal, AlertMessage, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, MapControlService, $translate) {
      _classCallCheck(this, MenuAjustarPontoReferenciaCtrl);

      this.scope = $scope;
      this.modalService = $uibModal;
      this.alertMessage = AlertMessage;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.mapControlService = MapControlService;
      this.translate = $translate;
      this.init();
    }

    _createClass(MenuAjustarPontoReferenciaCtrl, [{
      key: 'init',
      value: function init() {
        if (this.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas && this.pontosReferenciaMapService.layer.entidadePermissao.entidade.rotogramas.length > 0) {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.mapa.common.menuAjustarPonto.erroRotograma'),
            appendTo: '.alerta-aqui-ponto'
          });
          this.pontosReferenciaMenuService.setFABDefault();
          this.pontosReferenciaMapService.setLayerDefault();
          return;
        }
        this.pontosReferenciaMapService.layer.options.editing = true;
        this.mapControlService.isDrawingPontoRef = true;
        this.pontosReferenciaMapService.layer.editing.enable();
        var buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtConfirmar',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'default',
          funcao: this.salvarPosicao.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'editar',
          funcao: this.pontosReferenciaMapService.cancelarAjuste.bind(this.pontosReferenciaMapService)
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMenuService.drawerClose();
        this.pontosReferenciaMenuService.menuOpen();
        this.pontosReferenciaMapService.markerOut(this.pontosReferenciaMapService.getIdLayer(this.pontosReferenciaMapService.layer));
      }
    }, {
      key: 'salvarPosicao',
      value: function salvarPosicao() {
        var _this = this;

        var latlngs = this.pontosReferenciaMapService.layer.getLatLngs()[0],
            latlngCentro = this.pontosReferenciaToolsService.geraLatLngCentro(latlngs),
            raio = this.pontosReferenciaToolsService.geraDiametro(latlngs) / 2,
            entidade = angular.copy(this.pontosReferenciaMapService.layer.entidadePermissao.entidade);

        entidade.latitude = latlngCentro.latitude;
        entidade.longitude = latlngCentro.longitude;
        entidade.raio = raio;

        this.pontosReferenciaService.putPontoReferencia(entidade).then(function (data) {
          var ponto = _.find(_this.pontosReferenciaMapService.pontosReferencia, function (p) {
            return p.entidade.id === entidade.id;
          }),
              copia = angular.copy(ponto);
          if (copia) {
            copia.entidade = data.plain();
            copia.oldId = entidade.id;
            copia.entidade.texto = _this.translate.instant('ce.mapa.common.menuAjustarPonto.editarSucesso');
            _this.pontosReferenciaMapService.atualizaPonto(copia);
          }
        }).catch(function (err) {
          _this.pontosReferenciaMapService.cancelarAjuste();
          if (err && err.status === 409) {
            _this.alertMessage.create({
              type: 'error',
              message: _this.translate.instant('ce.mapa.common.menuAjustarPonto.editarSobreposto'),
              appendTo: '.alerta-aqui-ponto'
            });
          } else {
            _this.alertMessage.create({
              type: 'error',
              message: _this.translate.instant('ce.mapa.common.menuAjustarPonto.editarErro'),
              appendTo: '.alerta-aqui-ponto'
            });
          }
        });

        this.pontosReferenciaMapService.layer.options.editing = false;
        this.pontosReferenciaMapService.layer.editing.disable();
        this.pontosReferenciaMenuService.setFABDefault();
        this.pontosReferenciaMapService.setLayerDefault();
        this.pontosReferenciaMapService.markerIn(this.pontosReferenciaMapService.getIdLayer(this.pontosReferenciaMapService.layer), [latlngCentro.latitude, latlngCentro.longitude]);
      }
    }]);

    return MenuAjustarPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('MenuAjustarPontoReferenciaCtrl', MenuAjustarPontoReferenciaCtrl).directive('menuAjustarPontoReferenciaDirective', menuAjustarPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function menuAdicionarPontosProximosDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuAdicionarPontosProximosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuAdicionarPontosProximosCtrl = function () {
    function MenuAdicionarPontosProximosCtrl($timeout, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, PontosProximos) {
      _classCallCheck(this, MenuAdicionarPontosProximosCtrl);

      this.timeout = $timeout;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.pontosProximosService = PontosProximos;
      this.adicionarNovoPonto();
    }

    _createClass(MenuAdicionarPontosProximosCtrl, [{
      key: 'adicionarNovoPonto',
      value: function adicionarNovoPonto() {
        var buttonsPrincipal = {
          active: 'fa fa-thumb-tack',
          resting: 'fa fa-thumb-tack'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.pontosReferenciaMapService.cancelarPonto.bind(this.pontosReferenciaMapService)
        }];
        this.pontosReferenciaMenuService.menuOpen();
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMapService.setPontoProximo();
      }
    }]);

    return MenuAdicionarPontosProximosCtrl;
  }();

  angular.module('mapControlModule').controller('MenuAdicionarPontosProximosCtrl', MenuAdicionarPontosProximosCtrl).directive('menuAdicionarPontosProximosDirective', menuAdicionarPontosProximosDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L*/
(function () {
  'use strict';

  function menuAdicionarPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuAdicionarPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var MenuAdicionarPontoReferenciaCtrl = function () {
    function MenuAdicionarPontoReferenciaCtrl(PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia) {
      _classCallCheck(this, MenuAdicionarPontoReferenciaCtrl);

      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.adicionarNovoPonto();
    }

    _createClass(MenuAdicionarPontoReferenciaCtrl, [{
      key: 'adicionarNovoPonto',
      value: function adicionarNovoPonto() {
        this.pontosReferenciaMenuService.drawerClose();
        this.pontosReferenciaMapService.retangulo = new L.Draw.Rectangle(this.pontosReferenciaMapService.map, { shapeOptions: { color: '#000000', weight: 4, fillOpacity: 0.75 } });
        var buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.pontosReferenciaMapService.cancelarPonto.bind(this.pontosReferenciaMapService)
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMenuService.menuOpen();
        this.pontosReferenciaMapService.setVerificaZoom();
      }
    }]);

    return MenuAdicionarPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('MenuAdicionarPontoReferenciaCtrl', MenuAdicionarPontoReferenciaCtrl).directive('menuAdicionarPontoReferenciaDirective', menuAdicionarPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BuscaRegiaoService = function () {
    function BuscaRegiaoService(HttpServiceV3g, MockGetListBuscaRegiao, $q) {
      _classCallCheck(this, BuscaRegiaoService);

      this.httpService = HttpServiceV3g;
      this.mockGetListBuscaRegiao = MockGetListBuscaRegiao;
      this.q = $q;
      this.isDemo = false;
    }

    _createClass(BuscaRegiaoService, [{
      key: 'getList',
      value: function getList(latlngCentro, params) {
        var _this = this;

        if (this.isDemo) {
          return this.q(function (resolve) {
            return resolve(_this.mockGetListBuscaRegiao);
          });
        }
        var url = this.getUrlRegiao(latlngCentro, params);

        return this.httpService.get(url);
      }
    }, {
      key: 'getUrlRegiao',
      value: function getUrlRegiao(latlngCentro, params) {
        return '/sensor/regiao/' + Number.parseFloat(latlngCentro.lat) + '/' + Number.parseFloat(latlngCentro.lng) + '?' + params;
      }
    }]);

    return BuscaRegiaoService;
  }();

  angular.module('mapControlModule').service('BuscaRegiaoService', BuscaRegiaoService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L*/
(function () {
  'use strict';

  var BuscaRegiaoShape = L.Rectangle.extend({});

  var BuscaPorRegiaoMapService = function () {
    function BuscaPorRegiaoMapService(PontosReferenciaTools) {
      _classCallCheck(this, BuscaPorRegiaoMapService);

      this.pontosReferenciaToolsService = PontosReferenciaTools;

      this.map = null;
      this.layer = null;
      this.isZoomInadequate = true;
      this.raioLimite = 200;
      this.zoomMinimoBuscaRegiao = 15;
      // A API cadastra tilenumbers com zoom 17 como default
      this.zoomBuscaDefault = 17;

      this.init();
    }

    _createClass(BuscaPorRegiaoMapService, [{
      key: 'init',
      value: function init() {
        this.declareCustomShape();
      }
    }, {
      key: 'setMap',
      value: function setMap(map) {
        var _this = this;

        this.map = map;
        this.map.on(L.Draw.Event.CREATED, function () {
          return _this.fitsInTileArea();
        });
        this.map.on(L.Draw.Event.EDITED, function () {
          return _this.fitsInTileArea();
        });
        this.setVerifyZoom();
      }
    }, {
      key: 'declareCustomShape',
      value: function declareCustomShape() {
        /* eslint-disable */
        var BuscaRegiaoShapeEdit = L.Edit.SimpleShape.extend({
          _createMoveMarker: function _createMoveMarker() {
            var bounds = this._shape.getBounds(),
                center = bounds.getCenter();
            this.options.moveIcon.options.iconSize = [100, 100];
            this._moveMarker = this._createMarker(center, this.options.moveIcon);
          },

          _createResizeMarker: function _createResizeMarker() {
            // Empty: Since this rectangle doesn't allow resize, it doesn't need icons.
            this._resizeMarkers = [];
          },

          _move: function _move(newCenter) {
            var latlngs = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(),
                bounds = this._shape.getBounds(),
                center = bounds.getCenter(),
                offset = void 0,
                newLatLngs = [];

            // Offset the latlngs to the new center
            for (var i = 0, l = latlngs.length; i < l; i++) {
              offset = [latlngs[i].lat - center.lat, latlngs[i].lng - center.lng];
              newLatLngs.push([newCenter.lat + offset[0], newCenter.lng + offset[1]]);
            }

            this._shape.setLatLngs(newLatLngs);

            this._map.fire(L.Draw.Event.EDITMOVE, {
              layer: this._shape
            });
          },

          _onMarkerDragEnd: function _onMarkerDragEnd(e) {
            this._map.fire(L.Draw.Event.EDITED);
            L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, e);
          },

          setPositionMoveMarker: function setPositionMoveMarker(position) {
            this._moveMarker.setLatLng(position);
          }
        });

        BuscaRegiaoShape.addInitHook(function () {
          this.editing = new BuscaRegiaoShapeEdit(this);

          if (this.options.editable) {
            this.editing.enable();
          }

          this.on('add', function () {
            this._map.fire(L.Draw.Event.CREATED);
          });
        });
        /* eslint-enable */
      }
    }, {
      key: 'render',
      value: function render() {
        if (this.map) {
          this.layer = this.drawArea();
          this.map.addLayer(this.layer);
        }
      }
    }, {
      key: 'drawArea',
      value: function drawArea() {
        var posicao = this.getLatLongFromCenter();

        return new BuscaRegiaoShape([[posicao.latlngLeftBottom.latitude, posicao.latlngLeftBottom.longitude], [posicao.latlngRightTop.latitude, posicao.latlngRightTop.longitude]], { color: '#000', fillOpacity: 0.5, weight: 1, editable: true });
      }
    }, {
      key: 'getLatLongFromCenter',
      value: function getLatLongFromCenter() {
        var center = this.map.getCenter();
        return this.pontosReferenciaToolsService.geraLatLngsExternos(center.lat, center.lng, this.raioLimite);
      }
    }, {
      key: 'setVerifyZoom',
      value: function setVerifyZoom() {
        this.verifyZoom();
        this.map.on('zoomend', this.verifyZoom, this);
      }
    }, {
      key: 'verifyZoom',
      value: function verifyZoom() {
        this.isZoomInadequate = this.map.getZoom() < this.zoomMinimoBuscaRegiao;
      }
    }, {
      key: 'removeLayerMap',
      value: function removeLayerMap() {
        if (this.map && this.layer) {
          this.map.removeLayer(this.layer);
        }
        this.layer = null;
      }
    }, {
      key: 'fitsInTileArea',
      value: function fitsInTileArea() {
        if (this.layer) {
          var tileBoundBox = L.latLngBounds(this.tileToBoundBox());

          this.layer.setBounds(tileBoundBox);
          this.centralizaMarker(tileBoundBox.getCenter());
        }
      }
    }, {
      key: 'tileToBoundBox',
      value: function tileToBoundBox() {
        var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.zoomBuscaDefault;

        var tile = this.toTileNumber(zoom),
            swLon = this.tileToLon(tile.x, zoom),
            swLat = this.tileToLat(tile.y + 1, zoom),
            neLon = this.tileToLon(tile.x + 1, zoom),
            netLat = this.tileToLat(tile.y, zoom);

        return [[swLat, swLon], [netLat, neLon]];
      }
    }, {
      key: 'toTileNumber',
      value: function toTileNumber(zoom) {
        var center = this.layer.getCenter();
        /* jslint bitwise: true */
        return {
          x: parseInt(Math.floor((center.lng + 180) / 360 * (1 << zoom)), 10),
          y: parseInt(Math.floor((1 - Math.log(Math.tan(center.lat.toRad()) + 1 / Math.cos(center.lat.toRad())) / Math.PI) / 2 * (1 << zoom)), 10)
        };
      }
    }, {
      key: 'tileToLon',
      value: function tileToLon(x, z) {
        return x / Math.pow(2, z) * 360 - 180;
      }
    }, {
      key: 'tileToLat',
      value: function tileToLat(y, z) {
        var toDegrees = function toDegrees(radians) {
          return radians * 180 / Math.PI;
        },
            n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
        return toDegrees(Math.atan(Math.sinh(n)));
      }
    }, {
      key: 'centralizaMarker',
      value: function centralizaMarker(center) {
        this.layer.editing.setPositionMoveMarker({ lat: center.lat, lng: center.lng });
      }
    }]);

    return BuscaPorRegiaoMapService;
  }();

  angular.module('mapControlModule').service('BuscaPorRegiaoMapService', BuscaPorRegiaoMapService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MenuExcluirCercaEletronicaCtrl = function () {
    function MenuExcluirCercaEletronicaCtrl(CercaEletronicaMapService, PontosReferenciaMenu, CercaEletronicaService, AlertMessage, $translate) {
      _classCallCheck(this, MenuExcluirCercaEletronicaCtrl);

      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.cercaEletronicaService = CercaEletronicaService;
      this.alertMessage = AlertMessage;
      this.translate = $translate;
      this.init();
    }

    _createClass(MenuExcluirCercaEletronicaCtrl, [{
      key: 'init',
      value: function init() {
        var buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtExcluirCerca',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'default',
          funcao: this.excluirCercaEletronica.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'editar-cerca-eletronica'
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.pontosReferenciaMenuService.drawerClose();
        this.pontosReferenciaMenuService.menuOpen();
      }
    }, {
      key: 'excluirCercaEletronica',
      value: function excluirCercaEletronica() {
        var _this = this;

        var idCercaEletronica = this.cercaEletronicaMapService.cercaEletronicaSelecionadaLayer.cercaEletronica.id;
        this.cercaEletronicaService.deleteCercaEletronica(idCercaEletronica).then(function () {
          _this.alertMessage.create({
            type: 'success',
            message: _this.translate.instant('ce.mapa.common.menuExcluirCerca.excluirCercaEletronicaSucess'),
            appendTo: '.alerta-aqui-ponto'
          });
          _this.cercaEletronicaMapService.excluirCercaEletronica(idCercaEletronica);
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: _this.translate.instant('ce.mapa.common.menuExcluirCerca.excluirCercaEletronicaError'),
            appendTo: '.alerta-aqui-ponto'
          });
        });

        this.pontosReferenciaMenuService.setFABDefault();
        this.pontosReferenciaMenuService.menuClose();
        this.cercaEletronicaMapService.setCercaEletronicaSelecionada(null);
      }
    }]);

    return MenuExcluirCercaEletronicaCtrl;
  }();

  angular.module('mapControlModule').component('menuExcluirCercaEletronica', {
    controller: MenuExcluirCercaEletronicaCtrl,
    templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
    controllerAs: 'ctrl'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MenuEditarCercaEletronicaCtrl = function () {
    function MenuEditarCercaEletronicaCtrl(CercaEletronicaMapService, PontosReferenciaMenu, CercaEletronicaService) {
      _classCallCheck(this, MenuEditarCercaEletronicaCtrl);

      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.cercaEletronicaService = CercaEletronicaService;
      this.init();
    }

    _createClass(MenuEditarCercaEletronicaCtrl, [{
      key: 'init',
      value: function init() {
        var buttonsPrincipal = {
          active: 'trimble-control-area',
          resting: 'trimble-control-area'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtEditarCadastro',
          icon: 'fa fa-pencil',
          color: 'default',
          tipo: 'editar-cerca-eletronica',
          funcao: this.editarCercaEletronica.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtExcluirCerca',
          icon: 'fa fa-trash-o',
          color: 'default',
          tipo: 'excluir-cerca-eletronica'
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cancelarAreaControle.bind(this)
        }];
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
      }
    }, {
      key: 'editarCercaEletronica',
      value: function editarCercaEletronica() {
        this.pontosReferenciaMenuService.drawerClose();
        this.cercaEletronicaMapService.editarCadastroCercaEletronica();
      }
    }, {
      key: 'cancelarAreaControle',
      value: function cancelarAreaControle() {
        this.cercaEletronicaMapService.setCercaEletronicaSelecionada(null);
        this.pontosReferenciaMenuService.setFABDefault();
      }
    }]);

    return MenuEditarCercaEletronicaCtrl;
  }();

  angular.module('mapControlModule').component('menuEditarCercaEletronica', {
    controller: MenuEditarCercaEletronicaCtrl,
    templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
    controllerAs: 'ctrl'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MenuAdicionarCercaEletronicaCtrl = function () {
    function MenuAdicionarCercaEletronicaCtrl($timeout, PontosReferenciaMenu, PontosReferencia, CercaEletronicaService, CercaEletronicaMapService) {
      _classCallCheck(this, MenuAdicionarCercaEletronicaCtrl);

      this.timeout = $timeout;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.cercaEletronicaService = CercaEletronicaService;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.adicionarNovaCercaEletronica();
    }

    _createClass(MenuAdicionarCercaEletronicaCtrl, [{
      key: 'adicionarNovaCercaEletronica',
      value: function adicionarNovaCercaEletronica() {
        var buttonsPrincipal = {
          active: 'trimble-control-area',
          resting: 'trimble-control-area'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cercaEletronicaMapService.cancelarDesenhoCerca.bind(this.cercaEletronicaMapService)
        }];
        this.pontosReferenciaMenuService.menuOpen();
        this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        this.cercaEletronicaMapService.iniciaDesenhoCercaEletronica();
      }
    }]);

    return MenuAdicionarCercaEletronicaCtrl;
  }();

  angular.module('mapControlModule').component('menuAdicionarCercaEletronica', {
    controller: MenuAdicionarCercaEletronicaCtrl,
    templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
    controllerAs: 'ctrl'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PROPORCAO_MAPA_BOUNDS_AUMENTO = 0.5,
      MINUTO_EM_SEGUNDOS = 60;
  /* global L, _ */

  var CadastroCercaEletronicaCtrl = function () {
    function CadastroCercaEletronicaCtrl(CercaEletronicaService, CercaEletronicaMapService, PontosReferenciaMap, PontosReferenciaTools, MapasUtil, leafletData, $scope, CategoriaPontosReferencia, Authenticator, AlertMessage, Uos, UoArvoreNivel, $rootScope, $translate) {
      _classCallCheck(this, CadastroCercaEletronicaCtrl);

      this.cercaEletronicaService = CercaEletronicaService;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.pontoReferenciaMapService = PontosReferenciaMap;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.alertMessage = AlertMessage;
      this.categoriaPontosReferenciaService = CategoriaPontosReferencia;
      this.mapasUtil = MapasUtil;
      this.map = null;
      this.rootScope = $rootScope;
      this.leafletData = leafletData;
      this.authenticatorService = Authenticator;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.model = {
        uo: null,
        nome: null,
        tempoPermanenciaMinimo: null,
        observacao: null,
        categoria: null
      };
      this.uos = [];
      this.scope = $scope;
      this.maxBounds = null;
      this.rotogramas = new L.FeatureGroup();
      this.pontosRefencia = new L.FeatureGroup();
      this.isEdicao = false;
      this.cercaEletronica = null;
      this.errorCarregar = false;
      this.categorias = null;
      this.isPermanenciaVisivel = true;
      this.translate = $translate;
    }

    _createClass(CadastroCercaEletronicaCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        // remove referencia para não precisar clonar layer
        this.resolve.cercaEletronica.layer = null;
        this.cercaEletronica = _.cloneDeep(this.resolve.cercaEletronica);
        var idCercaEletronica = this.cercaEletronica.id;

        this.loadUos();
        this.loadCategorias(this.cercaEletronica.uoId);
        if (!idCercaEletronica) {
          this.initMap();
        } else {
          this.loadFields(idCercaEletronica);
        }
        this.isEdicao = !!this.cercaEletronica.id;
        this.setMapConfig();
      }
    }, {
      key: 'toMinutes',
      value: function toMinutes(seconds) {
        return seconds ? seconds / MINUTO_EM_SEGUNDOS : null;
      }
    }, {
      key: 'toSeconds',
      value: function toSeconds(minutes) {
        return minutes ? minutes * MINUTO_EM_SEGUNDOS : null;
      }
    }, {
      key: 'loadFields',
      value: function loadFields(idCercaEletronica) {
        var _this = this;

        this.cercaEletronicaService.getCercaEletronica(idCercaEletronica).then(function (cercaEletronica) {
          _this.model.nome = cercaEletronica.nome;
          _this.model.tempoPermanenciaMinimo = _this.toMinutes(cercaEletronica.tempoPermanenciaMinimo);
          _this.model.configurarTempo = !!cercaEletronica.tempoPermanenciaMinimo;
          _this.model.observacao = cercaEletronica.observacao;

          _this.cercaEletronica = cercaEletronica;
          _this.setCategoria();
          _this.initMap();
        }).catch(function () {
          _this.errorCarregar = true;
        });
      }
    }, {
      key: 'loadUos',
      value: function loadUos() {
        var _this2 = this;

        this.uoService.getFilhas().then(function (data) {
          var uoId = _this2.cercaEletronica.id ? _this2.cercaEletronica.uoId : _this2.rootScope.usuario.uo.id;

          _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
          _this2.model.uo = _this2.uos.find(function (uo) {
            return uo.id === uoId;
          });
        });
      }
    }, {
      key: 'setCategoria',
      value: function setCategoria() {
        var _this3 = this;

        if (this.categorias && this.cercaEletronica.categoriaId) {
          this.model.categoria = this.categorias.find(function (categoria) {
            return categoria.id === _this3.cercaEletronica.categoriaId;
          });
        } else {
          this.model.categoria = null;
        }
        this.onChangeCategoria();
      }
    }, {
      key: 'loadCategorias',
      value: function loadCategorias(uoId) {
        var _this4 = this;

        this.categoriaPontosReferenciaService.getListCategoriasPontoReferencia().then(function (categorias) {
          if (uoId) {
            _this4.categorias = categorias.filter(function (categoria) {
              return categoria.uo === uoId;
            });
          } else {
            _this4.categorias = categorias;
          }
          _this4.categorias = _this4.categorias.sort(function (a, b) {
            return a.nome.localeCompare(b.nome);
          });
          _this4.setCategoria();
        }).catch(function () {
          _this4.errorCarregar = true;
        });
      }
    }, {
      key: 'setMapConfig',
      value: function setMapConfig() {
        var center = this.getCenterCercaEletronica();
        this.tiles = this.mapasUtil.tiles.veltec;
        this.defaults = this.mapasUtil.defaults;
        this.center = {
          zoom: 15,
          lat: center.lat,
          lng: center.lng
        };
      }
    }, {
      key: 'getCenterCercaEletronica',
      value: function getCenterCercaEletronica() {
        return this.cercaEletronicaMapService.getLatLngsBoundsCercaEletronica(this.cercaEletronica).getCenter();
      }
    }, {
      key: 'initMap',
      value: function initMap() {
        var _this5 = this;

        this.leafletData.getMap('mapaModalCercaEletronica').then(function (map) {
          _this5.map = map;
          _this5.addCercaEletronicaLayer();
        });
      }
    }, {
      key: 'addCercaEletronicaLayer',
      value: function addCercaEletronicaLayer() {
        this.cercaEletronicaLayer = this.cercaEletronicaMapService.getMarkerFromCercaEletronica(this.cercaEletronica);

        var boundsCercaEletronica = this.cercaEletronicaLayer.getBounds();

        this.cercaEletronicaLayer.setStyle(this.cercaEletronicaMapService.getStyleSelecionada(this.cercaEletronica.categoria ? this.cercaEletronica.categoria.cor : null));
        this.map.addLayer(this.cercaEletronicaLayer);
        this.map.fitBounds(boundsCercaEletronica);

        // faz com o mapa possua um limite de navegação proporcional ao tamanho da area em edição
        this.maxBounds = boundsCercaEletronica.pad(PROPORCAO_MAPA_BOUNDS_AUMENTO);
        this.map.setMaxBounds(this.maxBounds);
        this.map.setMinZoom(this.map.getBoundsZoom(boundsCercaEletronica));

        this.cercaEletronicaMapService.getCustomEditablePolygon(this.cercaEletronicaLayer).enable();

        this.importCercasEletronicas();
        this.importPontosRef();
      }
    }, {
      key: 'importCercasEletronicas',
      value: function importCercasEletronicas() {
        var _this6 = this;

        this.getCercasFiltradas().forEach(function (cercaEletronica) {
          _this6.map.addLayer(_this6.cercaEletronicaMapService.getMarkerFromCercaEletronica(cercaEletronica));
        });
      }

      /**
       * Filtra somente cercas na região de visualizacao do mapa
       *
       * @return {Array} Cercas que se encontram nas delimitações do mapa visualizado pelo usuário
       */

    }, {
      key: 'getCercasFiltradas',
      value: function getCercasFiltradas() {
        var _this7 = this;

        return this.cercaEletronicaMapService.cercasEletronicas.filter(function (cercaEletronica) {
          return cercaEletronica.id !== _this7.cercaEletronica.id && _this7.maxBounds.intersects(_this7.cercaEletronicaMapService.getLatLngsBoundsCercaEletronica(cercaEletronica));
        });
      }
    }, {
      key: 'importPontosRef',
      value: function importPontosRef() {
        var _this8 = this;

        this.getPontosFiltrados().forEach(function (ponto) {
          _this8.pontoReferenciaMapService.getLayersPontoReferencia(ponto).forEach(function (layer, index) {
            if (index !== 0) {
              layer.setOpacity(1);
              _this8.rotogramas.addLayer(layer);
            } else {
              _this8.pontosRefencia.addLayer(layer);
            }
          });
        });

        this.map.addLayer(this.pontosRefencia);
        this.controlRotogramas();
      }

      /**
       * Filtra somente pontos na região de visualizacao do mapa
       *
       * @return {Array} Pontos que se encontram nas delimitações do mapa visualizado pelo usuário
       */

    }, {
      key: 'getPontosFiltrados',
      value: function getPontosFiltrados() {
        var _this9 = this;

        return this.pontoReferenciaMapService.pontosReferencia.filter(function (pontoRef) {
          return _this9.maxBounds.contains(L.latLng(pontoRef.entidade.latitude, pontoRef.entidade.longitude));
        });
      }
    }, {
      key: 'controlRotogramas',
      value: function controlRotogramas() {
        var _this10 = this;

        this.map.on('zoomend', function () {
          if (_this10.map.getZoom() >= 15) {
            _this10.rotogramas.addTo(_this10.map);
          } else {
            _this10.rotogramas.removeFrom(_this10.map);
          }
        });
      }
    }, {
      key: 'onChangeCategoria',
      value: function onChangeCategoria() {
        if (this.cercaEletronicaLayer) {
          this.cercaEletronicaLayer.setStyle(this.cercaEletronicaMapService.getStyleSelecionada(this.model.categoria ? this.model.categoria.cor : null));
        }
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this11 = this;

        this.cercaEletronica = {
          id: this.cercaEletronica.id,
          geometria: this.cercaEletronicaLayer.toGeoJSON().geometry,
          nome: this.model.nome,
          uoId: this.model.uo.id,
          observacao: this.model.observacao,
          tempoPermanenciaMinimo: this.toSeconds(this.model.tempoPermanenciaMinimo),
          categoriaId: this.model.categoria ? this.model.categoria.id : null
        };

        if (this.cercaEletronica.id) {
          this.cercaEletronicaService.updateCercaEletronica(this.cercaEletronica).then(function (res) {
            var cercaEletronicaEditada = Object.assign({}, res.data, {
              categoria: _this11.model.categoria,
              tipoPermissao: 'E'
            });
            _this11.alertMessage.create({
              type: 'success',
              message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.sucessoEditarCerca'),
              appendTo: '.alerta-aqui-ponto'
            });
            _this11.closeModal(cercaEletronicaEditada);
          }).catch(function (err) {
            if (err && err.status === 409) {
              _this11.alertMessage.create({
                type: 'error',
                message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.errorEditarCercaSobreposta'),
                appendTo: '.alerta-aqui-modal-area'
              });
            } else {
              _this11.alertMessage.create({
                type: 'error',
                message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.errorEditarCerca'),
                appendTo: '.alerta-aqui-modal-area'
              });
            }
          });
        } else {
          this.cercaEletronicaService.createCercaEletronica(this.cercaEletronica).then(function (res) {
            var cercaEletronicaNova = Object.assign({}, res.data, {
              categoria: _this11.model.categoria,
              tipoPermissao: 'E'
            });
            _this11.alertMessage.create({
              type: 'success',
              message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.sucessoCadastrarCerca'),
              appendTo: '.alerta-aqui-ponto'
            });
            _this11.closeModal(cercaEletronicaNova);
          }).catch(function (err) {
            if (err && err.status === 409) {
              _this11.alertMessage.create({
                type: 'error',
                message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.errorCadastrarCercaSobreposta'),
                appendTo: '.alerta-aqui-modal-area'
              });
            } else {
              _this11.alertMessage.create({
                type: 'error',
                message: _this11.translate.instant('ce.mapa.common.modal.cadastroCercaEletronica.errorCadastrarCerca'),
                appendTo: '.alerta-aqui-modal-area'
              });
            }
          });
        }
      }
    }, {
      key: 'closeModal',
      value: function closeModal(cercaEletronica) {
        this.close({
          $value: {
            isEdicao: this.isEdicao,
            cercaEletronica: cercaEletronica
          }
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.dismiss();
      }
    }, {
      key: '$onDestroy',
      value: function $onDestroy() {
        this.leafletData.unresolveMap('mapaModalCercaEletronica');
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }]);

    return CadastroCercaEletronicaCtrl;
  }();

  angular.module('mapControlModule').component('modalCercaEletronica', {
    controller: CadastroCercaEletronicaCtrl,
    templateUrl: 'directives/map-control/cerca-eletronica/cadastro-cerca-eletronica-modal/cadastro-cerca-eletronica-modal.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('SubpaginasVdrivers', ['InputCheckboxModule', 'InputNumberModule', 'dndLists']);
})();
'use strict';

(function () {
  'use strict';

  function VigenciaVdrivers() {
    return {
      templateUrl: 'configuracoes/vdrivers/subpaginas/vigencia/vigencia-vdrivers.tpl.html',
      controller: function controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },

      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasVdrivers').directive('vigenciaVdrivers', VigenciaVdrivers);
})();
'use strict';

(function () {
  'use strict';

  function SafedriveVdrivers() {
    return {
      templateUrl: 'configuracoes/vdrivers/subpaginas/safedrive/safedrive-vdrivers.tpl.html',
      controller: function controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },

      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasVdrivers').directive('safedriveVdrivers', SafedriveVdrivers);
})();
'use strict';

(function () {
  'use strict';

  function ChecklistVdrivers() {
    return {
      templateUrl: 'configuracoes/vdrivers/subpaginas/checklist/checklist-vdrivers.tpl.html',
      controller: function controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },

      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasVdrivers').directive('checklistVdrivers', ChecklistVdrivers);
})();
'use strict';

(function () {
  'use strict';

  function AplicativoVdrivers() {
    return {
      templateUrl: 'configuracoes/vdrivers/subpaginas/aplicativo/aplicativo-vdrivers.tpl.html',
      controller: function controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },

      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasVdrivers').directive('aplicativoVdrivers', AplicativoVdrivers);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ModalVdrivers', []);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalResetVdrivers = function () {
    function ModalResetVdrivers($uibModalInstance) {
      _classCallCheck(this, ModalResetVdrivers);

      this.modalInstance = $uibModalInstance;
    }

    _createClass(ModalResetVdrivers, [{
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return ModalResetVdrivers;
  }();

  angular.module('ModalVdrivers').controller('ModalResetVdriversCtrl', ModalResetVdrivers);
})();
'use strict';

(function () {
  'use strict';

  function UsoIndevidoVeiculoConfiguration() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/uso-indevido-veiculo-configuration/uso-indevido-veiculo-configuration.tpl.html',
      controller: 'UsoIndevidoVeiculoConfigurationCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('usoIndevidoVeiculoConfigurationEventos', UsoIndevidoVeiculoConfiguration);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase */
(function () {
  'use strict';

  var UsoIndevidoVeiculoConfigurationCtrl = function () {
    function UsoIndevidoVeiculoConfigurationCtrl($scope, $document, $log, $window, Authenticator, safetyService, Keys, ServiceVfiltro, FactoryVfiltro, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, UsoIndevidoVeiculoConfigurationCtrl);

      this.log = $log;
      this.scope = $scope;
      this.window = $window;
      this.document = $document[0];
      this.safetyService = safetyService;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.isFeatureFlagUsoIndevidoVeiculoConfigurationPageEnabled = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.CONFIG_ALERTA_USO_INDEVIDO_VEICULO);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      var filterFromService = null;
      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (result) {
        filterFromService = result.filtro;
      }).catch(function (error) {
        _this.log.error('Error initializing filter:', error);
      }).finally(function () {
        _this.safetyService.initialize().then(function () {
          _this.authenticator.getUser().then(function (user) {
            var finalFilter = null;
            if (filterFromService) {
              finalFilter = filterFromService;
            } else {
              finalFilter = _this.getStoredOUFilter(user.id);
            }
            _this.loadPage(finalFilter, user);
          }).catch(function (error) {
            _this.log.error('Critical Error: Failed to fetch user in finally block:', error);
            _this.loadPage(null, null);
          });
        });
      });
    }

    _createClass(UsoIndevidoVeiculoConfigurationCtrl, [{
      key: 'getStoredOUFilter',
      value: function getStoredOUFilter(userId) {
        if (!userId) {
          return null;
        }
        var storedVFilter = this.window.localStorage.getItem('vfiltro-' + userId);
        return storedVFilter ? { uo_permissao: angular.fromJson(storedVFilter).uo } : null;
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter, user) {
        if (!this.isFeatureFlagUsoIndevidoVeiculoConfigurationPageEnabled || !user || !user.id) {
          return;
        }

        var finalFilter = filter || this.getStoredOUFilter(user.id),
            props = {
          user: user,
          filter: finalFilter
        },
            appName = 'safetyApp',
            componentPath = './UsoIndevidoVeiculoConfigurationPageRoute',
            componentId = 'safety-app-uso-indevido-veiculo-configuration',
            containerElement = this.document.getElementById(componentId);

        if (!containerElement) {
          this.log.error('Container element with ID \'' + componentId + '\' not found in DOM when calling loadReactComponent.');
          return;
        }
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }]);

    return UsoIndevidoVeiculoConfigurationCtrl;
  }();

  angular.module('SubpaginasEventos').controller('UsoIndevidoVeiculoConfigurationCtrl', UsoIndevidoVeiculoConfigurationCtrl);
})();
'use strict';

(function () {
  'use strict';

  function TurnosEventos() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/turnos/turnos-eventos.tpl.html',
      controller: 'TurnosEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('turnosEventos', TurnosEventos);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var TurnosEventosCtrl = function () {
    function TurnosEventosCtrl($scope, $uibModal, moment, Restangular, AlertMessage, Keys, UrlService, ServiceVfiltro, FactoryVfiltro, $translate, Authenticator, FeatureFlag, SolucoesEnum) {
      var _this = this;

      _classCallCheck(this, TurnosEventosCtrl);

      this.scope = $scope;
      this.modalService = $uibModal;
      this.moment = moment;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.keys = Keys;
      this.urlService = UrlService;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.solucoesEnum = SolucoesEnum;
      this.featureFlag = FeatureFlag;

      this.uoId = 0;
      this.roleCadastrar = true;
      this.modelTurnosOriginal = null;
      this.modelTurnos = { habilitarTurnosAlertas: false, habilitarTurnosOcorrencias: false, qntTurnos: '1', turnos: [{ inicio: '', fim: '', carga: '' }] };
      this.hasPermissaoConfigOcorrenciaSolucao = false;

      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (filtro) {
        _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIGURACAO_ALERTA_EDITAR');
        _this.authenticator.getUser().then(function (user) {
          _this.usuario = user;
          _this.hasPermissaoConfigOcorrenciaSolucao = user.permissoesSolucao.indexOf('CONFIG_OCORRENCIA_VISUALIZAR') !== -1;
          _this.init(filtro.find(function (x) {
            return x.key === _this.keys.uo.name;
          }).value.id);
        });
      });
    }

    _createClass(TurnosEventosCtrl, [{
      key: 'init',
      value: function init(uoId) {
        var _this2 = this;

        this.uoId = uoId;
        this.restangular.one('configuracao/configuracoes/' + uoId + '/turnos').get().then(function (turnos) {
          _this2.buildModelTurnos(turnos);
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.msgErroCarregarConfigs'),
            appendTo: '.alerta-aqui-geral'
          });
        });
      }
    }, {
      key: 'buildModelTurnos',
      value: function buildModelTurnos(item) {
        var _this3 = this;

        this.modelTurnos.habilitarTurnosAlertas = item.turnos.length && item.turnos[0].alertas;
        this.modelTurnos.habilitarTurnosOcorrencias = item.turnos.length && item.turnos[0].ocorrencias;
        this.modelTurnos.qntTurnos = item.turnos.length.toString();
        this.modelTurnos.uoId = item.uoId;
        this.modelTurnos.turnos = item.turnos.map(function (x) {
          return {
            inicio: _this3.moment('2012-12-12 ' + x.inicio).format('HH:mm')
          };
        });
        for (var i = 0; i < this.modelTurnos.turnos.length; i++) {
          if (this.modelTurnos.turnos[i].inicio) {
            this.buildTurnos(i);
            this.modelTurnos.turnos[i].carga = this.modelTurnos.turnos.length === 1 ? '24:00' : this.buildCargaHoraria(i);
          }
        }
        this.modelTurnosOriginal = angular.copy(this.modelTurnos);
      }
    }, {
      key: 'buildCargaHoraria',
      value: function buildCargaHoraria(i) {
        var inicioAtual = this.modelTurnos.turnos[i].inicio,
            proximoInicio = this.modelTurnos.turnos[(i + 1) % this.modelTurnos.turnos.length].inicio;
        if (inicioAtual && proximoInicio) {
          var hrInicio = this.moment(inicioAtual, 'HH:mm'),
              hrFim = this.moment(proximoInicio, 'HH:mm'),
              dia = hrInicio.isAfter(hrFim) ? '13' : '12',
              dtInicio = this.moment('2012-12-12 ' + inicioAtual),
              dtFim = this.moment('2012-12-' + dia + ' ' + proximoInicio),
              duration = this.moment.duration(dtFim.diff(dtInicio, 'minutes'), 'minutes').format('HH:mm');
          return duration.includes(':') ? duration : '00:' + duration;
        }
        return '';
      }
    }, {
      key: 'buildTurnos',
      value: function buildTurnos(i) {
        var turnoAnterior = this.modelTurnos.turnos[i - 1],
            turnoAtual = this.modelTurnos.turnos[i],
            ultimoTurno = this.modelTurnos.turnos[this.modelTurnos.turnos.length - 1];
        if (turnoAnterior) {
          turnoAnterior.fim = turnoAtual.inicio;
        } else {
          ultimoTurno.fim = turnoAtual.inicio;
        }
      }
    }, {
      key: 'resetarTurnos',
      value: function resetarTurnos() {
        var _this4 = this;

        if (this.modelTurnos.turnos.filter(function (x) {
          return x.inicio !== '';
        }).length > 0) {
          this.modalService.open({
            animation: true,
            templateUrl: 'configuracoes/eventos/modal/turnos/turnos-eventos.tpl.html',
            controller: 'ModalTurnoEventosCtrl',
            controllerAs: '$ctrl',
            resolve: {
              titulo: function titulo() {
                return _this4.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.titulo');
              },
              texto: function texto() {
                return _this4.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricaoOcorrencias');
              },
              texto2: function texto2() {
                return _this4.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricao2');
              },
              clique: function clique() {
                return _this4.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.clicandoAqui');
              }
            }
          }).result.then(function () {
            _this4.limpaCamposTurnos();
            _this4.limparConfiguracoesAtribuicao();
          }, function () {
            _this4.modelTurnos.qntTurnos = _this4.modelTurnos.turnos.length.toString();
          });
        } else {
          this.limpaCamposTurnos();
        }
      }
    }, {
      key: 'desabilitarTurnos',
      value: function desabilitarTurnos(changed) {
        var _this5 = this;

        var desabilitouAlertas = changed === 'alertas' && !this.modelTurnos.habilitarTurnosAlertas && this.verificaSeTemTurnoOriginal(),
            desabilitouOcorrencias = changed === 'ocorrencias' && !this.modelTurnos.habilitarTurnosOcorrencias && this.verificaSeTemTurnoOriginal(),
            desabilitouAmbos = !this.modelTurnos.habilitarTurnosAlertas && !this.modelTurnos.habilitarTurnosOcorrencias && this.verificaSeTemTurnoOriginal();
        if (desabilitouAlertas) {
          this.modalService.open({
            animation: true,
            templateUrl: 'configuracoes/eventos/modal/turnos/turnos-eventos.tpl.html',
            controller: 'ModalTurnoEventosCtrl',
            controllerAs: '$ctrl',
            resolve: {
              titulo: function titulo() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalTurnoDesabilitado.titulo');
              },
              texto: function texto() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalTurnoDesabilitado.descricaoAlertas');
              },
              texto2: function texto2() {},
              clique: function clique() {}
            }
          }).result.then(function () {
            if (desabilitouAmbos) {
              _this5.limparTurnos();
            } else {
              _this5.enviarTurnos(_this5.buildSalvarTurnos());
            }
          }, function () {
            _this5.modelTurnos.habilitarTurnosAlertas = !_this5.modelTurnos.habilitarTurnosAlertas;
          });
        }

        if (desabilitouOcorrencias) {
          this.modalService.open({
            animation: true,
            templateUrl: 'configuracoes/eventos/modal/turnos/turnos-eventos.tpl.html',
            controller: 'ModalTurnoEventosCtrl',
            controllerAs: '$ctrl',
            resolve: {
              titulo: function titulo() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalTurnoDesabilitado.titulo');
              },
              texto: function texto() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricaoOcorrencias');
              },
              texto2: function texto2() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricao2');
              },
              clique: function clique() {
                return _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.clicandoAqui');
              }
            }
          }).result.then(function () {
            if (desabilitouAmbos) {
              _this5.limparTurnos();
            } else {
              _this5.enviarTurnos(_this5.buildSalvarTurnos());
              _this5.limparConfiguracoesAtribuicao();
            }
          }, function () {
            _this5.modelTurnos.habilitarTurnosOcorrencias = !_this5.modelTurnos.habilitarTurnosOcorrencias;
          });
        }
      }
    }, {
      key: 'limpaCamposTurnos',
      value: function limpaCamposTurnos() {
        this.modelTurnos.turnos = [];
        for (var i = 0; i < Number(this.modelTurnos.qntTurnos); i++) {
          this.modelTurnos.turnos[i] = { inicio: '', fim: '', carga: '' };
        }
      }
    }, {
      key: 'modificaFim',
      value: function modificaFim(index) {
        this.buildTurnos(index);
        if (this.modelTurnos.turnos.length > 1) {
          for (var i = 0; i < this.modelTurnos.turnos.length; i++) {
            if (this.modelTurnos.turnos[i].inicio) {
              this.modelTurnos.turnos[i].carga = this.buildCargaHoraria(i);
            }
            this.verificaTurnosRepetidos(i);
          }
          this.verificaCargaHoraria();
        } else {
          this.modelTurnos.turnos[0].carga = '24:00';
        }
      }
    }, {
      key: 'validaBotaoSalvar',
      value: function validaBotaoSalvar() {
        var nennhumTurno = this.modelTurnos.qntTurnos === '0',
            opcoesHabilitadas = !this.modelTurnos.habilitarTurnosAlertas && !this.modelTurnos.habilitarTurnosOcorrencias,
            naoPreencheuTurnos = !this.verificaSeTemTurnoOriginal();
        return nennhumTurno || opcoesHabilitadas && naoPreencheuTurnos;
      }
    }, {
      key: 'verificaSeTemTurnoOriginal',
      value: function verificaSeTemTurnoOriginal() {
        return this.modelTurnosOriginal.turnos.filter(function (x) {
          return x.inicio !== '';
        }).length > 0;
      }
    }, {
      key: 'verificaTurnosRepetidos',
      value: function verificaTurnosRepetidos(i) {
        var turnoAtual = this.modelTurnos.turnos[i],
            inputTurno = this.scope.formTurnos['txtTurnoInicio' + i];

        if (turnoAtual && inputTurno.$modelValue) {
          if (this.modelTurnos.turnos.filter(function (x) {
            return x.inicio === turnoAtual.inicio;
          }).length > 1) {
            inputTurno.$setValidity('turnoRepetido', false);
          } else {
            inputTurno.$setValidity('turnoRepetido', true);
          }
        }
      }
    }, {
      key: 'verificaCargaHoraria',
      value: function verificaCargaHoraria() {
        var _this6 = this;

        var umDiaEmMinutos = 1440;
        var cargaTotal = _.reduce(this.modelTurnos.turnos.map(function (x) {
          return _this6.moment.duration(x.carga).asMinutes();
        }), function (sum, num) {
          return sum + num;
        });
        if (cargaTotal > umDiaEmMinutos) {
          this.setErroCargaHoraria(false);
        } else {
          this.setErroCargaHoraria(true);
        }
      }
    }, {
      key: 'setErroCargaHoraria',
      value: function setErroCargaHoraria(erro) {
        for (var i = 0; i < this.modelTurnos.turnos.length; i++) {
          this.scope.formTurnos['txtTurnoInicio' + i].$setValidity('cargaHorariaExcedida', erro);
        }
      }
    }, {
      key: 'goToIndicadoresTempoReal',
      value: function goToIndicadoresTempoReal() {
        return '/tempo-real?vfiltro=' + this.urlService.getObjectVfiltro(this.serviceVfiltro.filtroTopbar);
      }
    }, {
      key: 'salvarTurnos',
      value: function salvarTurnos() {
        var _this7 = this;

        if (!this.modelTurnos.habilitarTurnosAlertas && !this.modelTurnos.habilitarTurnosOcorrencias) {
          this.modalService.open({
            animation: true,
            templateUrl: 'configuracoes/eventos/modal/turnos/turnos-eventos.tpl.html',
            controller: 'ModalTurnoEventosCtrl',
            controllerAs: '$ctrl',
            resolve: {
              titulo: function titulo() {
                return _this7.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalTurnoDesabilitado.titulo');
              },
              texto: function texto() {
                return _this7.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalTurnoDesabilitado.descricaoAlertas') + '\n' + _this7.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricaoOcorrencias');
              },
              texto2: function texto2() {
                return _this7.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.descricao2');
              },
              clique: function clique() {
                return _this7.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.modalDadosSeraoZerados.clicandoAqui');
              }
            }
          }).result.then(function () {
            var configTurnos = {
              uoId: _this7.uoId,
              turnos: []
            };
            _this7.limparConfiguracoesAtribuicao();
            _this7.enviarTurnos(configTurnos);
            _this7.modelTurnos.qntTurnos = '1';
            _this7.modelTurnos.turnos = [{ inicio: '', fim: '', carga: '' }];
          });
        } else {
          var ordem = 0;
          var configTurnos = {
            uoId: this.uoId,
            turnos: this.modelTurnos.turnos.map(function (x) {
              ordem++;
              return {
                inicio: x.inicio,
                fim: x.fim,
                ordem: ordem,
                alertas: _this7.modelTurnos.habilitarTurnosAlertas,
                ocorrencias: _this7.modelTurnos.habilitarTurnosOcorrencias
              };
            })
          };
          this.enviarTurnos(configTurnos);
        }
      }
    }, {
      key: 'enviarTurnos',
      value: function enviarTurnos(configTurnos) {
        var _this8 = this;

        this.restangular.all('configuracao/configuracoes/' + configTurnos.uoId + '/turnos').post(configTurnos).then(function () {
          _this8.modelTurnosOriginal = angular.copy(_this8.modelTurnos);
          _this8.scope.formTurnos.$setPristine();
          _this8.alertMessage.create({
            type: 'success',
            message: _this8.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.msgSalvoComSucesso'),
            appendTo: '.alerta-aqui-turnos'
          });
        }).catch(function () {
          _this8.alertMessage.create({
            type: 'error',
            message: _this8.translate.instant('ce.configuracao.eventos.itensConfiguraveis.turnos.configuracoes.turno.msgErroSalvarTurnos'),
            appendTo: '.alerta-aqui-turnos'
          });
        });
      }
    }, {
      key: 'buildSalvarTurnos',
      value: function buildSalvarTurnos() {
        var _this9 = this;

        var configTurnos = {
          uoId: this.uoId,
          turnos: this.modelTurnos.turnos.map(function (x, index) {
            index++;
            return {
              inicio: x.inicio,
              fim: x.fim,
              ordem: index,
              alertas: _this9.modelTurnos.habilitarTurnosAlertas,
              ocorrencias: _this9.modelTurnos.habilitarTurnosOcorrencias
            };
          })
        };
        return configTurnos;
      }
    }, {
      key: 'limparConfiguracoesAtribuicao',
      value: function limparConfiguracoesAtribuicao() {
        this.restangular.one('configuracao/configuracoes/' + this.uoId + '/notificacao-ocorrencia/delete-config-atribuicao').remove();
      }
    }, {
      key: 'limparTurnos',
      value: function limparTurnos() {
        var configTurnos = {
          uoId: this.uoId,
          turnos: []
        };
        this.enviarTurnos(configTurnos);
        this.limparConfiguracoesAtribuicao();
        this.modelTurnos.qntTurnos = '1';
        this.modelTurnos.turnos = [{ inicio: '', fim: '', carga: '' }];
        this.modelTurnosOriginal = angular.copy(this.modelTurnos);
      }
    }]);

    return TurnosEventosCtrl;
  }();

  angular.module('SubpaginasEventos').controller('TurnosEventosCtrl', TurnosEventosCtrl);
})();
'use strict';

(function () {
  'use strict';

  function TiposEventos() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/tipos/tipos-eventos.tpl.html',
      controller: 'TiposEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('tiposEventos', TiposEventos);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var SAFETY = 'safety',
      IN_CAB = 'in-cab',
      STABILITY_CONTROL = 'stabilityControl',
      STABILITY_CONTROL_SUB_ITEMS = ['ropBrake', 'ropEngine', 'ycBrake', 'ycEngine'],
      ALERT_CONFIG_KEYS = { rollingStop: 'stopSignViolation', noStop: 'stopSignViolation' },
      ROW_TITLES = { rollingStop: 'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.stopSignViolation.titulo' },
      MANUAL_EVENT_HARDWARE = 'manualEventHardware',
      MEDIA_TYPE = { VIDEO: 'VIDEO', IMAGE: 'IMAGE', NO_MEDIA: 'NO_MEDIA' },
      COMPOSICOES_SEM_DASHCAM = ['NO_DASHCAM', 'NO_VIDEO_DEVICE'],
      MANUAL_EVENT_HARDWARE_I18N = 'ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.manualEventHardware';

  var TiposEventosCtrl = function () {
    function TiposEventosCtrl($scope, $uibModal, $log, $window, Authenticator, safetyService, Restangular, AlertMessage, AlertasEnum, FeatureFlag, Keys, ServiceVfiltro, FactoryVfiltro, $translate, ConfigEventosService, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, SpeedingBucketService, ConvertersService, EventsToAlerts) {
      var _this = this;

      _classCallCheck(this, TiposEventosCtrl);

      this.scope = $scope;
      this.safetyIsCollapsed = false;
      this.inCabIsCollapsed = false;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.featureFlag = FeatureFlag;
      this.configEventosService = ConfigEventosService;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.removeReadMore = false;
      this.log = $log;
      this.window = $window;
      this.safetyService = safetyService;
      this.speedingBucketService = SpeedingBucketService;
      this.uoId = 0;
      this.roleCadastrar = true;
      this.model = { configuracoes: [], configuracoesSafety: [], configuracoesInCab: [], checkAllAlertas: false, checkAllVideos: false, checkAllAutomatedCoaching: false };
      this.safetyConfigsLength = 0;
      this.speedDescriptionsVia = [];
      this.speedDescriptions = [];
      this.convertersService = ConvertersService;
      this.mapLabel = EventsToAlerts.map(function (item) {
        return Object.assign({}, item, {
          enum: _this.alertasEnum[item.enum],
          titulo: _this.translate.instant(ROW_TITLES[item.tipo] || item.titulo)
        });
      });
      this.subItems = ['ultrapassagemIlegal'];
      this.tituloItemsSafety = ['stabilityControl'];
      this.alertsWithSubItem = [{ name: 'distanciaPerigosa', subItem: 'ultrapassagemIlegal' }];
      this.alertsDisableVideo = ['carona'];
      this.rideSpecificData = [{
        label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.xOrMore', { x: 2 }),
        value: 2
      }, {
        label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.ride.xOrMore', { x: 3 }),
        value: 3
      }];
      this.alertsWithSpecificData = ['carona'];
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (filtro) {
        _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIGURACAO_ALERTA_EDITAR');
        _this.init(filtro.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id);
      });
      this.flagCollapseTables = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.COLLAPSIBLE_TABLES);
      this.flagFixUiBehavior = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FIX_UI_BEHAVIOR);
      this.flagSeparateStabilityControl = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.SEPARATE_STABILITY_CONTROL);
      this.flagRollingStop = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROLLING_STOP);
      this.flagManualEventHardware = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MANUAL_EVENT_HARDWARE);
      this.composicaoVideo = null;
      this.mediaTypes = [{ value: MEDIA_TYPE.VIDEO, label: MANUAL_EVENT_HARDWARE_I18N + '.tipoMidia.video' }, { value: MEDIA_TYPE.IMAGE, label: MANUAL_EVENT_HARDWARE_I18N + '.tipoMidia.imagem' }, { value: MEDIA_TYPE.NO_MEDIA, label: MANUAL_EVENT_HARDWARE_I18N + '.tipoMidia.semMidia' }];
    }

    _createClass(TiposEventosCtrl, [{
      key: 'init',
      value: function init(uoId) {
        var _this2 = this;

        this.uoId = uoId;

        if (this.featurehubJsSdk.isFeatureEnabled('TTLAINT1548_save_and_read_alerts_tag')) {
          this.authenticator.getUser().then(function (user) {
            _this2.getEventsConfig(user);
          });
        }

        Promise.all([this.restangular.one('configuracao/configuracoes/' + this.uoId + '/alerta').get(), this.restangular.one('sensor/uos/' + this.uoId + '/configuracoes/eventos').get(), this.configEventosService.getConfigEventos()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              alertas = _ref2[0],
              eventos = _ref2[1],
              configEventos = _ref2[2];

          _this2.setConfiguracoesView(alertas, eventos, configEventos);
          _this2.updateCheckAllAlertas();
          _this2.updateCheckAllVideos();
          _this2.updateCheckAllAutomatedCoaching();
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: 'Ocorreu um erro ao carregar as configurações',
            appendTo: '.alerta-aqui-geral'
          });
        });
        this.authenticator.getUser().then(function (user) {
          _this2.distanceUnitFormat = user.measurementUnits.distanceMeasurement;
        });
        if (this.flagManualEventHardware) {
          this.getComposicaoVideo();
        }
      }
    }, {
      key: 'getComposicaoVideo',
      value: function getComposicaoVideo() {
        var _this3 = this;

        return this.restangular.one('veiculo/module/video-composition').get({ uoId: this.uoId }).then(function (response) {
          _this3.composicaoVideo = response.composition;
        }).catch(function () {
          _this3.composicaoVideo = null;
        });
      }
    }, {
      key: 'setConfiguracoesView',
      value: function setConfiguracoesView(alertas, eventos, configEventos) {
        var _this4 = this;

        return this.scope.$apply(function () {
          _this4.model.configuracoesSafety = _this4.setConfiguracoes(alertas, eventos, configEventos, SAFETY);
          _this4.model.configuracoesInCab = _this4.setConfiguracoes(alertas, eventos, configEventos, IN_CAB);
          _this4.model.configuracoes = [].concat(_toConsumableArray(_this4.model.configuracoesInCab), _toConsumableArray(_this4.model.configuracoesSafety));
          if (_this4.flagFixUiBehavior) {
            _this4.safetyConfigsLength = _this4.model.configuracoesSafety.length - _this4.tituloItemsSafety.length;
          }
        });
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(user) {
        var _this5 = this;

        this.featureOuService.getEventsConfig(user.uo.id).then(function (eventNaConfig) {
          _this5.removeReadMore = eventNaConfig;
          _this5.showSpeedDescription = eventNaConfig;
          _this5.getSpeedingLevels(user.uo.id).then(function () {
            _this5.speedDescriptionsVia = _this5.getSpeedLevelDescription(null, true);
            _this5.speedDescriptions = _this5.getSpeedLevelDescription(null, false);
          });
          if (!eventNaConfig) {
            _this5.safetyService.initialize().then(function () {
              return _this5.loadReact(user);
            });
          }
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact(user) {
        var appName = 'safetyApp',
            componentPath = './AlertsTag',
            componentId = 'safety-alerts-tag',
            props = {
          user: user,
          ouId: this.uoId
        };
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }, {
      key: 'setConfiguracoes',
      value: function setConfiguracoes(alertas, eventos, configEventos, category) {
        var _this6 = this;

        this.sortMapLabel();
        if (this.flagSeparateStabilityControl && category === SAFETY) {
          this.separateStabilityControl();
        }
        return this.mapLabel.filter(function (alertaMapeado) {
          return _this6.flagRollingStop || alertaMapeado.enum.id !== _this6.alertasEnum.ROLLING_STOP.id && alertaMapeado.enum.id !== _this6.alertasEnum.NO_STOP.id;
        }).filter(function (alertaMapeado) {
          return alertaMapeado.enum.id !== _this6.alertasEnum.NO_STOP.id;
        }).filter(function (alertaMapeado) {
          return _this6.flagManualEventHardware || alertaMapeado.enum.id !== _this6.alertasEnum.MANUAL_EVENT_HARDWARE.id;
        }).filter(function (alertaMapeado) {
          return !configEventos[alertaMapeado.tipo] || configEventos[alertaMapeado.tipo].enabled !== false;
        }).filter(function (alertaMapeado) {
          return alertaMapeado.enum.isEnabled(configEventos);
        }).filter(function (alertaMapeado) {
          return alertas.configuracoes[_this6.alertConfigKey(alertaMapeado.tipo)] ? alertas.configuracoes[_this6.alertConfigKey(alertaMapeado.tipo)].configuracaoVisivel : null;
        }).filter(function (alertaMapeado) {
          return alertaMapeado.enum.category === category;
        }).map(function (item) {
          if (item) {
            var alerta = alertas.configuracoes[_this6.alertConfigKey(item.tipo)] || {},
                evento = eventos.configuracoes[item.tipo] || {};

            return {
              item: item,
              alertaAtivo: !!alerta.ativo,
              eventoAtivo: evento.ativo,
              videoAtivo: !!alerta.videoAtivo,
              automatedCoaching: !!alerta.automatedCoaching,
              specificData: _this6.getSpecificData(alerta.specificDataHashMap, item.tipo, !!alerta.ativo),
              mediaType: _this6.getMediaType(alerta, item)
            };
          }
        });
      }
    }, {
      key: 'getMediaType',
      value: function getMediaType(alerta, item) {
        if (!this.isManualEventHardware(item)) {
          return undefined;
        }
        if (alerta.mediaType) {
          return alerta.mediaType;
        }
        return alerta.videoAtivo ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.NO_MEDIA;
      }
    }, {
      key: 'isManualEventHardware',
      value: function isManualEventHardware(item) {
        return item.tipo === MANUAL_EVENT_HARDWARE;
      }
    }, {
      key: 'isDashcamNecessaria',
      value: function isDashcamNecessaria(item) {
        return this.isManualEventHardware(item) && COMPOSICOES_SEM_DASHCAM.includes(this.composicaoVideo);
      }
    }, {
      key: 'isFrotaMista',
      value: function isFrotaMista(item) {
        return this.isManualEventHardware(item) && this.composicaoVideo === 'MIXED';
      }
    }, {
      key: 'changeMediaType',
      value: function changeMediaType(config) {
        config.videoAtivo = config.mediaType === MEDIA_TYPE.VIDEO;
        this.updateCheckAllVideos();
      }
    }, {
      key: 'getSpecificData',
      value: function getSpecificData(specificDataHashMap, eventType, active) {
        switch (eventType) {
          case 'carona':
            var value = specificDataHashMap && specificDataHashMap.peopleCount;
            return angular.isDefined(value) && active ? value : null;
          default:
            return null;
        }
      }
    }, {
      key: 'sortMapLabel',
      value: function sortMapLabel() {
        var _this7 = this;

        this.mapLabel.sort(function (a, b) {
          return a.titulo.localeCompare(b.titulo);
        });
        this.alertsWithSubItem.forEach(function (item) {
          var indexItem = void 0,
              indexSubItem = void 0;
          indexItem = _this7.mapLabel.findIndex(function (alerta) {
            return alerta.tipo === item.name;
          });
          indexSubItem = _this7.mapLabel.findIndex(function (alerta) {
            return alerta.tipo === item.subItem;
          });

          if (indexItem !== -1 && indexSubItem !== -1) {
            var _mapLabel$splice = _this7.mapLabel.splice(indexSubItem, 1),
                _mapLabel$splice2 = _slicedToArray(_mapLabel$splice, 1),
                subItem = _mapLabel$splice2[0];

            _this7.mapLabel.splice(indexItem + 1, 0, subItem);
          }
        });
        return this.mapLabel;
      }
    }, {
      key: 'separateStabilityControl',
      value: function separateStabilityControl() {
        var _subItems;

        var indexStabilityControl = void 0;
        indexStabilityControl = this.mapLabel.findIndex(function (label) {
          return label.tipo === STABILITY_CONTROL;
        });
        if (indexStabilityControl === -1) {
          return;
        }

        (_subItems = this.subItems).push.apply(_subItems, STABILITY_CONTROL_SUB_ITEMS);
        this.groupStabilityControlSubItems();
      }
    }, {
      key: 'groupStabilityControlSubItems',
      value: function groupStabilityControlSubItems() {
        var _this8 = this,
            _mapLabel;

        var subItems = STABILITY_CONTROL_SUB_ITEMS.map(function (tipo) {
          return _this8.mapLabel.find(function (label) {
            return label.tipo === tipo;
          });
        }).filter(function (subItem) {
          return !!subItem;
        });

        subItems.forEach(function (subItem) {
          return _this8.mapLabel.splice(_this8.mapLabel.indexOf(subItem), 1);
        });

        // o indice do pai precisa ser lido depois da remocao dos sub itens, senao fica defasado
        (_mapLabel = this.mapLabel).splice.apply(_mapLabel, [this.mapLabel.findIndex(function (label) {
          return label.tipo === STABILITY_CONTROL;
        }) + 1, 0].concat(_toConsumableArray(subItems)));
      }
    }, {
      key: 'alertConfigKey',
      value: function alertConfigKey(tipo) {
        return ALERT_CONFIG_KEYS[tipo] || tipo;
      }
    }, {
      key: 'configuracoesToObject',
      value: function configuracoesToObject() {
        var _this9 = this;

        if (this.flagSeparateStabilityControl) {
          var indexStabilityControl = this.model.configuracoes.findIndex(function (config) {
            return config.item.tipo === STABILITY_CONTROL;
          });
          if (indexStabilityControl !== -1) {
            this.model.configuracoes.splice(indexStabilityControl, 1);
          }
        }
        return this.model.configuracoes.reduce(function (_ref3, config) {
          var accAlertas = _ref3.accAlertas,
              accEventos = _ref3.accEventos;

          var specificData = null;
          if (_this9.alertsWithSpecificData.includes(config.item.tipo)) {
            specificData = _this9.handleSpecificData(config.item.tipo, config.specificData);
          }
          accAlertas[_this9.alertConfigKey(config.item.tipo)] = {
            ativo: !!config.alertaAtivo,
            videoAtivo: !!config.videoAtivo,
            automatedCoaching: !!config.alertaAtivo && !!config.automatedCoaching,
            specificDataHashMap: config.alertaAtivo ? specificData : null
          };
          if (config.mediaType) {
            accAlertas[_this9.alertConfigKey(config.item.tipo)].mediaType = config.mediaType;
          }
          if (angular.isDefined(config.eventoAtivo)) {
            accEventos[config.item.tipo] = { ativo: !!config.eventoAtivo };
          }
          return { accAlertas: accAlertas, accEventos: accEventos };
        }, { accAlertas: {}, accEventos: {} });
      }
    }, {
      key: 'handleSpecificData',
      value: function handleSpecificData(eventType, value) {
        switch (eventType) {
          case 'carona':
            return { peopleCount: value };
          default:
            return null;
        }
      }
    }, {
      key: 'getEventTooltip',
      value: function getEventTooltip(item) {
        return item.enum && item.enum.tooltip ? this.translate.instant(item.enum.tooltip) : null;
      }
    }, {
      key: 'isEventTooltip',
      value: function isEventTooltip(item) {
        return !!item.enum.tooltip;
      }
    }, {
      key: 'isSpeedLimitVia',
      value: function isSpeedLimitVia(item) {
        return item.tipo === 'speedlimitVia';
      }
    }, {
      key: 'isSpeedLimit',
      value: function isSpeedLimit(item) {
        return item.tipo === 'speedlimit';
      }
    }, {
      key: 'isPossivelColisao',
      value: function isPossivelColisao(item) {
        return item.tipo === 'possivelColisao';
      }
    }, {
      key: 'isEPIEvent',
      value: function isEPIEvent(item) {
        return item.tipo === 'semCone' || item.tipo === 'semOculos' || item.tipo === 'semLuvas';
      }
    }, {
      key: 'isIlegalOvertaking',
      value: function isIlegalOvertaking(item) {
        return item.tipo === 'ultrapassagemIlegal';
      }
    }, {
      key: 'isRideEvent',
      value: function isRideEvent(item) {
        return item.tipo === 'carona';
      }
    }, {
      key: 'isFuncionalidadeExperimental',
      value: function isFuncionalidadeExperimental(item) {
        return this.isEPIEvent(item) || this.isPossivelColisao(item) || this.isIlegalOvertaking(item) || this.isRideEvent(item);
      }
    }, {
      key: 'isSubItem',
      value: function isSubItem(item) {
        return this.subItems.indexOf(item.tipo) > -1;
      }
    }, {
      key: 'checkAlerta',
      value: function checkAlerta(alertConfig) {
        this.updateCheckAllAlertas();
        this.updateCheckAllVideos();

        var matchedItem = this.alertsWithSubItem.find(function (alert) {
          return alert.name === alertConfig.item.tipo;
        });

        if (angular.isDefined(alertConfig.eventoAtivo) && alertConfig.alertaAtivo) {
          alertConfig.eventoAtivo = true;
        }

        if (!alertConfig.alertaAtivo) {
          alertConfig.videoAtivo = false;
          alertConfig.automatedCoaching = false;
        } else if (alertConfig.mediaType) {
          alertConfig.videoAtivo = alertConfig.mediaType === MEDIA_TYPE.VIDEO;
        }

        if (matchedItem) {
          var subItem = this.model.configuracoes.find(function (config) {
            return config.item.tipo === matchedItem.subItem;
          });
          this.handleSubItemConfig(subItem, alertConfig.alertaAtivo);
        }

        this.updateCheckAllAutomatedCoaching();
      }
    }, {
      key: 'updateCheckAllAlertas',
      value: function updateCheckAllAlertas() {
        var _this10 = this;

        if (!this.flagFixUiBehavior) {
          return;
        }
        this.model.checkAllAlertas = this.model.configuracoes.length > 0 && this.model.configuracoes.every(function (config) {
          return config.alertaAtivo || _this10.tituloItemsSafety.includes(config.item.tipo) || _this10.isDashcamNecessaria(config.item);
        });
      }
    }, {
      key: 'updateCheckAllVideos',
      value: function updateCheckAllVideos() {
        var _this11 = this;

        if (!this.flagFixUiBehavior) {
          return;
        }
        this.model.checkAllVideos = this.model.checkAllAlertas && this.model.configuracoes.length > 0 && this.model.configuracoes.every(function (config) {
          return config.videoAtivo || _this11.tituloItemsSafety.includes(config.item.tipo) || _this11.isManualEventHardware(config.item);
        });
      }
    }, {
      key: 'handleSubItemConfig',
      value: function handleSubItemConfig(subItem, isAlertaAtivo) {
        if (!subItem) {
          return;
        }

        if (!isAlertaAtivo) {
          Object.assign(subItem, { alertaAtivo: false, isDisabled: true });
          subItem.automatedCoaching = false;
        } else {
          subItem.isDisabled = false;
        }
      }
    }, {
      key: 'checkSubItemConfig',
      value: function checkSubItemConfig(configSubItem) {
        this.updateCheckAllAlertas();
        if (!configSubItem.alertaAtivo) {
          configSubItem.videoAtivo = false;
          configSubItem.automatedCoaching = false;
        }
        this.updateCheckAllAutomatedCoaching();
      }
    }, {
      key: 'checkFirst',
      value: function checkFirst(isFirst, config, value) {
        if (isFirst && config.specificData === null) {
          config.specificData = value;
        }
        return angular.isDefined(config.specificData) && config.specificData === value;
      }
    }, {
      key: 'checkAllAlertas',
      value: function checkAllAlertas() {
        var _this12 = this;

        this.model.configuracoes.filter(function (config) {
          return !_this12.isDashcamNecessaria(config.item);
        }).forEach(function (config) {
          return config.alertaAtivo = _this12.model.checkAllAlertas;
        });
        if (!this.model.checkAllAlertas) {
          this.model.checkAllVideos = false;
          this.model.configuracoes.forEach(function (config) {
            config.videoAtivo = _this12.model.checkAllVideos;
            config.automatedCoaching = false;
          });
          this.model.checkAllAutomatedCoaching = false;
        }
      }
    }, {
      key: 'checkAllVideos',
      value: function checkAllVideos() {
        var _this13 = this;

        this.model.configuracoes.forEach(function (config) {
          if (config.alertaAtivo && !_this13.disableVideo(config.item.tipo) && !_this13.isManualEventHardware(config.item)) {
            config.videoAtivo = _this13.model.checkAllVideos;
          }
        });
      }
    }, {
      key: 'checkAllAutomatedCoaching',
      value: function checkAllAutomatedCoaching() {
        var _this14 = this;

        this.model.configuracoes.forEach(function (config) {
          if (config.alertaAtivo) {
            config.automatedCoaching = _this14.model.checkAllAutomatedCoaching;
          }
        });
      }
    }, {
      key: 'updateCheckAllAutomatedCoaching',
      value: function updateCheckAllAutomatedCoaching() {
        var _this15 = this;

        if (!this.flagFixUiBehavior) {
          return;
        }
        this.model.checkAllAutomatedCoaching = this.model.configuracoes.length > 0 && this.model.configuracoes.every(function (config) {
          return config.alertaAtivo && config.automatedCoaching || _this15.tituloItemsSafety.includes(config.item.tipo);
        });
      }
    }, {
      key: 'disableVideo',
      value: function disableVideo(type) {
        return this.alertsDisableVideo.includes(type);
      }
    }, {
      key: 'abrirModal',
      value: function abrirModal() {
        this.modalService.open({
          animation: true,
          templateUrl: 'configuracoes/eventos/modal/info/info-eventos.tpl.html',
          controller: 'ModalInfoEventosCtrl',
          controllerAs: '$ctrl',
          size: 'lg'
        });
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this16 = this;

        var configs = this.configuracoesToObject(),
            configAlertas = {
          uoId: this.uoId,
          configuracoes: configs.accAlertas
        },
            configEventos = {
          uo: { id: this.uoId },
          configuracoes: configs.accEventos
        };

        this.mapLabel.forEach(function (label) {
          if (_this16.flagSeparateStabilityControl && _this16.tituloItemsSafety.includes(label.tipo)) {
            return;
          }
          if (!configAlertas.configuracoes[_this16.alertConfigKey(label.tipo)]) {
            configAlertas.configuracoes[_this16.alertConfigKey(label.tipo)] = {
              ativo: false,
              videoAtivo: false,
              automatedCoaching: false
            };
          }
        });

        this.mapLabel.forEach(function (label) {
          if (_this16.flagSeparateStabilityControl && _this16.tituloItemsSafety.includes(label.tipo)) {
            return;
          }
          if (!configAlertas.configuracoes[_this16.alertConfigKey(label.tipo)]) {
            configAlertas.configuracoes[_this16.alertConfigKey(label.tipo)] = {
              ativo: false,
              videoAtivo: false,
              automatedCoaching: false
            };
          }
        });

        Promise.all([this.restangular.all('configuracao/configuracoes/' + this.uoId + '/alerta').customPUT(configAlertas), this.restangular.all('sensor/uos/' + this.uoId + '/configuracoes/eventos').post(configEventos)]).then(function () {
          _this16.scope.formAlertas.$setPristine();
          _this16.scope.$apply(function () {
            _this16.alertMessage.create({
              type: 'success',
              message: _this16.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.sucessoMsg'),
              appendTo: '.alerta-aqui'
            });
          });
        }).catch(function () {
          _this16.scope.$apply(function () {
            _this16.alertMessage.create({
              type: 'error',
              message: _this16.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.erro'),
              appendTo: '.alerta-aqui'
            });
          });
        });
      }
    }, {
      key: 'unmountReactComponent',
      value: function unmountReactComponent() {
        if (this.window.ReactDOM && this.container) {
          if (this.window.ReactDOM.unmountComponentAtNode(this.container)) {
            this.log.log('React component unmounted');
          } else {
            this.log.log('React component was not mounted.');
          }
        } else {
          this.log.log('Container not found or React component was not mounted.');
        }
      }
    }, {
      key: 'collapse',
      value: function collapse(category) {
        if (category === SAFETY) {
          this.safetyIsCollapsed = !this.safetyIsCollapsed;
        } else if (category === 'inCab') {
          this.inCabIsCollapsed = !this.inCabIsCollapsed;
        }
      }
    }, {
      key: 'getCaronaTooltip',
      value: function getCaronaTooltip(x) {
        return this.translate.instant('ce.enum.eventosTooltips.carona', { x: x });
      }
    }, {
      key: 'getSpeedLevelDescription',
      value: function getSpeedLevelDescription(level) {
        var isSpeedLimitVia = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!this.speedingLevels) {
          return [];
        }
        var descriptions = [],
            shouldConvert = isSpeedLimitVia && this.distanceUnitFormat === 'MILES',
            level1Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh1min) : this.speedingLevels.speedingBucketKmh1min) || 6,
            level1Max = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh1max) : this.speedingLevels.speedingBucketKmh1max) || 17,
            level2Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh2min) : this.speedingLevels.speedingBucketKmh2min) || 19,
            level2Max = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh2max) : this.speedingLevels.speedingBucketKmh2max) || 24,
            level3Min = (shouldConvert ? this.convertersService.handleKmToMiles(this.speedingLevels.speedingBucketKmh3min) : this.speedingLevels.speedingBucketKmh3min) || 25;

        if (isSpeedLimitVia) {
          descriptions.push({
            color: 'blue',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level1', {
              kmh1Min: level1Min,
              kmh1Max: level1Max
            })
          });

          descriptions.push({
            color: 'yellow',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level2', {
              kmh2Min: level2Min,
              kmh2Max: level2Max
            })
          });

          descriptions.push({
            color: 'red',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidadePorVia.level3', {
              kmh3Min: level3Min
            })
          });
        } else {
          descriptions.push({
            color: 'blue',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level1', {})
          });

          descriptions.push({
            color: 'yellow',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level2', {})
          });

          descriptions.push({
            color: 'red',
            text: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.visualizarAlertas.colunas.alertas.excessoVelocidade.level3', {})
          });
        }

        if (level && level >= 1 && level <= 3) {
          return [descriptions[level - 1]];
        }

        return descriptions;
      }
    }, {
      key: 'getSpeedingLevels',
      value: function getSpeedingLevels(uoId) {
        var _this17 = this;

        return this.speedingBucketService.getSpeedingBucketsPorUo(uoId).then(function (speedingLevels) {
          _this17.speedingLevels = speedingLevels;
        });
      }
    }, {
      key: 'getSpeedLimitViaDescriptions',
      value: function getSpeedLimitViaDescriptions() {
        return this.getSpeedLevelDescription(null, true);
      }
    }, {
      key: 'getSpeedLimitDescriptions',
      value: function getSpeedLimitDescriptions() {
        return this.getSpeedLevelDescription(null, false);
      }
    }]);

    return TiposEventosCtrl;
  }();

  angular.module('SubpaginasEventos').controller('TiposEventosCtrl', TiposEventosCtrl);
})();
'use strict';

(function () {
  'use strict';

  function PesosEventos() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/pesos/pesos-eventos.tpl.html',
      controller: 'PesosEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('pesosEventos', PesosEventos);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PesosEventosCtrl = function () {
    function PesosEventosCtrl($scope, $uibModal, Restangular, AlertMessage, AlertasEnum, Keys, ServiceVfiltro, FactoryVfiltro, $translate, ConfigEventosService, $q, SpeedingBucketService, FeatureOuService, UoHelperService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, PesosEventosCtrl);

      this.scope = $scope;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.configEventosService = ConfigEventosService;
      this.q = $q;
      this.speedingBucketService = SpeedingBucketService;
      this.featureOuService = FeatureOuService;
      this.uoHelperService = UoHelperService;
      this.featRollingStop = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROLLING_STOP);

      this.uoId = 0;
      this.roleCadastrar = true;
      this.model = { configuracoes: [] };
      this.speedingLevels = null;
      this.eventNaConfig = false;

      this.NaFeatureExcludedEvents = ['CURVA_BRUSCA', 'VEICULO_SEM_VIGENCIA'];

      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (filtro) {
        _this.uoId = filtro.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id;
        _this.roleCadastrar = _this.temPermissaoParaConfigurar();
        _this.init();
      });
    }

    _createClass(PesosEventosCtrl, [{
      key: 'temPermissaoParaConfigurar',
      value: function temPermissaoParaConfigurar() {
        return this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_PESO_EVENTO_EDITAR') && this.uoHelperService.isDirectChildOfRoot(this.serviceVfiltro.factoryVfiltro.user.uo) && this.serviceVfiltro.factoryVfiltro.user.uo.id === this.uoId;
      }
    }, {
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.q.all([this.restangular.one('configuracao/configuracoes/' + this.uoId + '/pontuacao').get(), this.configEventosService.getConfigEventos(), this.speedingBucketService.getFormattedSpeedingLevels(this.uoId), this.getEventNaConfig(this.uoId)]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 4),
              alertas = _ref2[0],
              configEventos = _ref2[1],
              speedingLevels = _ref2[2],
              eventNaConfig = _ref2[3];

          _this2.speedingLevels = speedingLevels;
          _this2.setConfiguracoes(alertas, configEventos);
          _this2.eventNaConfig = eventNaConfig;
        }).catch(function () {
          return _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.msgErroCarregarConfiguracoes'),
            appendTo: '.alerta-aqui-geral'
          });
        });
      }
    }, {
      key: 'getSpeedingLevelTitle',
      value: function getSpeedingLevelTitle(subAlerta) {
        if (!this.speedingLevels) {
          return this.translate.instant(subAlerta.alertaEnum.descricaoCurta);
        }

        var nivel = this.getSpeedingNivel(subAlerta.tipoOcorrencia);

        if (nivel && this.speedingLevels.useBuckets && this.speedingLevels[nivel] && this.speedingLevels[nivel].levelLabel) {
          return this.speedingLevels[nivel].levelLabel;
        }

        return this.translate.instant(subAlerta.alertaEnum.descricaoCurta);
      }
    }, {
      key: 'getSpeedingNivel',
      value: function getSpeedingNivel(tipoEvento) {
        if (tipoEvento.includes('ALTO') || tipoEvento.includes('ACIMA_30')) return 'ALTO';
        if (tipoEvento.includes('MEDIO') || tipoEvento.includes('30')) return 'MEDIO';
        if (tipoEvento.includes('BAIXO') || tipoEvento.includes('20')) return 'BAIXO';
        return null;
      }
    }, {
      key: 'setConfiguracoes',
      value: function setConfiguracoes(alertas, configEventos) {
        var _this3 = this;

        var excVel = [],
            excVelVia = [],
            curvaBrusca = [],
            cameraObstruida = [];

        this.model.uoId = alertas.uoId;
        this.model.heranca = alertas.heranca;

        var filteredConfiguracoes = alertas.configuracoes.filter(function (alerta) {
          var excludeConditions = [_this3.alertasEnum.DIAGNOSTICO_OBD.id, _this3.alertasEnum.MANUTENCAO_PROGRAMADA.id, 'TREPIDACAO', _this3.alertasEnum.VEICULO_SEM_SINAL.id, _this3.alertasEnum.PREVISAO_COLISAO.id, _this3.alertasEnum.RFID_NAO_CADASTRADO.id, _this3.alertasEnum.MANUTENCAO_PROGRAMADA_HORIMETRO.id, _this3.alertasEnum.PANICO.id];

          if (_this3.eventNaConfig) {
            excludeConditions.push.apply(excludeConditions, _toConsumableArray(_this3.NaFeatureExcludedEvents));
          }

          if (!_this3.featRollingStop) {
            excludeConditions.push(_this3.alertasEnum.ROLLING_STOP.id, _this3.alertasEnum.NO_STOP.id);
          }

          return !excludeConditions.includes(alerta.tipoOcorrencia);
        });

        this.model.configuracoes = filteredConfiguracoes.map(function (alerta) {
          var alertaEnum = _this3.alertasEnum.getAlerta(alerta.tipoOcorrencia);
          if (alertaEnum) {
            if (_this3.alertasEnum.isExcessoVelocidade(alertaEnum.id)) {
              excVel.push(alerta);
              return null;
            } else if (_this3.alertasEnum.isExcessoVelocidadeVia(alertaEnum.id)) {
              excVelVia.push(alerta);
              return null;
            } else if (alertaEnum && _this3.alertasEnum.CURVA_BRUSCA.id === alertaEnum.id) {
              curvaBrusca.push(alerta);
              return null;
            } else if (alertaEnum && _this3.alertasEnum.CAMERA_OBSTRUIDA.id === alertaEnum.id) {
              cameraObstruida.push(alerta);
              return null;
            }
            return angular.extend(alerta, _this3.extendDefault(alerta, alertaEnum, null, []));
          }
          return null;
        }).filter(function (x) {
          return !!x && x.alertaEnum.isEnabled(configEventos);
        });

        this.buildExcessoVelocidade(excVel, this.alertasEnum.EXCESSO_VELOCIDADE);
        this.buildExcessoVelocidade(excVelVia, this.alertasEnum.EXCESSO_VELOCIDADE_POR_VIA);
        this.buildExcessoVelocidade(curvaBrusca, this.alertasEnum.CURVA_BRUSCA);
        this.buildExcessoVelocidade(cameraObstruida, this.alertasEnum.CAMERA_OBSTRUIDA);
      }
    }, {
      key: 'getEventNaConfig',
      value: function getEventNaConfig(uoId) {
        var _this4 = this;

        return this.featureOuService.getEventsConfig(uoId).then(function (eventNaConfig) {
          _this4.eventNaConfig = eventNaConfig;
        });
      }
    }, {
      key: 'buildExcessoVelocidade',
      value: function buildExcessoVelocidade(lista, alertaEnum) {
        var _this5 = this;

        if (lista.length > 0) {
          lista = lista.map(function (alerta) {
            return angular.extend(alerta, _this5.extendDefault(alerta, _this5.alertasEnum.getAlerta(alerta.tipoOcorrencia), null, []));
          });
          this.model.configuracoes.push(angular.extend({
            lista: lista
          }, this.extendDefault({}, alertaEnum, lista)));
        }
      }
    }, {
      key: 'extendDefault',
      value: function extendDefault(alerta, alertaEnum, lista) {
        return {
          alertaEnum: alertaEnum,
          backupMultiplicadorUnitario: alerta.multiplicadorUnitario >= 0 ? angular.copy(alerta.multiplicadorUnitario) : null,
          backupMultiplicadorTempo: alerta.multiplicadorTempo >= 0 ? angular.copy(alerta.multiplicadorTempo) : null,
          backupLista: angular.copy(lista) || []
        };
      }
    }, {
      key: 'checkError',
      value: function checkError(error, alertaEnum, alertaLista) {
        return error && !!Object.keys(error).find(function (tipo) {
          return !!error[tipo].find(function (item) {
            if (alertaLista && alertaLista.length > 0) {
              return !!alertaLista.find(function (alerta) {
                return alerta.alertaEnum.id === item.$name.split('.')[1];
              });
            }
            return item.$name.split('.')[1] === alertaEnum.id;
          });
        });
      }
    }, {
      key: 'descartarAlteracoes',
      value: function descartarAlteracoes() {
        this.model.configuracoes = this.model.configuracoes.map(function (item) {
          if (item.backupMultiplicadorUnitario >= 0) {
            item.multiplicadorUnitario = angular.copy(item.backupMultiplicadorUnitario);
          }
          if (item.backupMultiplicadorTempo >= 0) {
            item.multiplicadorTempo = angular.copy(item.backupMultiplicadorTempo);
          }
          if (item.backupLista.length > 0) {
            item.lista = angular.copy(item.backupLista);
          }
          return item;
        });
      }
    }, {
      key: 'abrirModal',
      value: function abrirModal() {
        var _this6 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'configuracoes/eventos/modal/reset/reset-eventos.tpl.html',
          controller: 'ModalResetEventosCtrl',
          controllerAs: '$ctrl'
        }).result.then(function () {
          _this6.salvar(true);
        });
      }
    }, {
      key: 'buildConfiguracoes',
      value: function buildConfiguracoes(item) {
        var itemFinal = { tipoOcorrencia: item.tipoOcorrencia };

        if (item.multiplicadorUnitario >= 0) {
          itemFinal.multiplicadorUnitario = item.multiplicadorUnitario;
        }
        if (item.multiplicadorTempo >= 0) {
          itemFinal.multiplicadorTempo = item.multiplicadorTempo;
        }

        return itemFinal;
      }
    }, {
      key: 'getConfiguracoes',
      value: function getConfiguracoes() {
        var _this7 = this;

        var lista = [];

        this.model.configuracoes.forEach(function (item) {
          if (item.backupLista.length > 0) {
            item.lista.forEach(function (alerta) {
              return lista.push(_this7.buildConfiguracoes(alerta));
            });
          } else {
            lista.push(_this7.buildConfiguracoes(item));
          }
        });

        return lista;
      }
    }, {
      key: 'salvar',
      value: function salvar(heranca) {
        var _this8 = this;

        var config = this.getConfiguracoes(),
            pontuacao = {
          uoId: this.uoId,
          heranca: heranca,
          configuracoes: config
        };

        Promise.all([this.restangular.all('configuracao/configuracoes/' + this.uoId + '/pontuacao').post(pontuacao)]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              pesos = _ref4[0];

          if (pesos) {
            _this8.rebuildPesos(pesos);
          }
        }).catch(function () {
          _this8.alertMessage.create({
            type: 'error',
            message: _this8.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.erroSalvarConfiguracoes'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'rebuildPesos',
      value: function rebuildPesos(pesos) {
        this.scope.formPesos.$setPristine();
        this.setConfiguracoes(pesos);
        this.alertMessage.create({
          type: 'success',
          message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.salvoComSucesso'),
          appendTo: '.alerta-aqui'
        });
        this.scope.$apply();
      }
    }]);

    return PesosEventosCtrl;
  }();

  angular.module('SubpaginasEventos').controller('PesosEventosCtrl', PesosEventosCtrl);
})();
'use strict';

(function () {
  'use strict';

  function Ocorrencias() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/ocorrencias/ocorrencias.tpl.html',
      controller: 'OcorrenciasCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('ocorrenciasEventos', Ocorrencias);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/log */
(function () {
  'use strict';
  /* global _*/

  var UM_MINUTO_EM_SEGUNDOS = 60;

  var OcorrenciasCtrl = function () {
    function OcorrenciasCtrl($q, $scope, $uibModal, HttpServiceV3g, AlertMessage, AlertasEnum, FeatureFlag, Keys, ServiceVfiltro, FactoryVfiltro, ModalInfoConfirmService, moment, $translate, Authenticator, ConvertersService, ConfigEventosService, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, SpeedingBucketService, MeasurementUnitConverterService) {
      var _this = this;

      _classCallCheck(this, OcorrenciasCtrl);

      this.q = $q;
      this.scope = $scope;
      this.modalService = $uibModal;
      this.httpService = HttpServiceV3g;
      this.speedingBucketService = SpeedingBucketService;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.featureFlag = FeatureFlag;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.selectOptions = [];
      this.configEventosService = ConfigEventosService;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.isOwnConfigs = false;
      this.speedingLevels = {};
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.hasRoleConfigOcorrenciaEditar = false;
      this.moment = moment;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.model = {};
      this.hasPermission = null;
      this.convertersService = ConvertersService;
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.disableButton = false;
      this.occurrenceSimulator = false;
      this.tooltipErrorMessage = '';
      this.classes = {
        todas: ['GRAVISSIMA', 'GRAVE', 'MEDIA', 'LEVE'],
        GRAVISSIMA: { label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.gravissima') },
        GRAVE: { label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.grave') },
        MEDIA: { label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.moderada') },
        LEVE: { label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.classe.leve') }
      };

      this.NaFeatureExcludedEvents = ['FREADA_BRUSCA_COM_ACIONAMENTO_PEDAL', 'FREADA_BRUSCA_SEM_ACIONAMENTO_PEDAL', 'VEICULO_SEM_VIGENCIA', 'PREVISAO_COLISAO'];

      this.retentionPeriods = [{ value: 12, label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.retentionPeriod.periodValues.12hrs') }, { value: 24, label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.retentionPeriod.periodValues.24hrs') }, { value: 48, label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.retentionPeriod.periodValues.48hrs') }, { value: 72, label: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.safetyFocusBoardConfiguration.retentionPeriod.periodValues.72hrs') }];

      this.configsOcorrencia = [];
      this.configsBkp = [];
      this.configsSalvar = null;
      this.configEventos = null;

      this.authenticator.getUser().then(function (user) {
        _this.usuario = user;
        _this.measurementUnits = user.measurementUnits;
        var isKm = _this.measurementUnits.distanceMeasurement === 'KM',
            translationKeyPrefix = 'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.',
            measurementKey = isKm ? 'velocidadeMinimaKMH' : 'velocidadeMinimaMPH',
            translateMeasurement = function translateMeasurement(suffix) {
          return _this.translate.instant('' + translationKeyPrefix + measurementKey + '.' + suffix);
        };

        _this.userLanguage = user.idioma;
        _this.velocidadeMinimaTitulo = translateMeasurement('titulo');
        _this.velocidadeMinimaOpcional = translateMeasurement('opcional');
        _this.velocidadeMinimaExtraInfo = translateMeasurement('extraInfo');
        _this.velocidadeMaximaPermitida = translateMeasurement('velocidadeMaximaPermitida');
        _this.getEventsConfig(user.uo.id);
      });

      this.q.all([this.configEventosService.getConfigEventos(), this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }]))]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            configEventos = _ref2[0],
            filtro = _ref2[1];

        _this.selectOptions = _this.getAlertasFiltrados(configEventos);
        _this.configEventos = configEventos;
        _this.uoId = filtro.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id;
        _this.hasPermission = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_OCORRENCIA_VISUALIZAR');
        _this.hasRoleConfigOcorrenciaEditar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_OCORRENCIA_EDITAR');
        if (_this.featureFlag.SHOW_EVENT_DIALOG) {
          _this.showOpenDialogEventPriority();
        }

        _this.enabledRetentionPeriod(_this.uoId).then(function () {
          _this.speedingBucketService.getFormattedSpeedingLevels(_this.uoId).then(function (speedingLevels) {
            _this.speedingLevels = speedingLevels;
            if (_this.showRetentionPeriod) {
              _this.getConfigPeriodRetentionHours();
            }
          });
        });

        _this.consultar();
      });
    }

    _createClass(OcorrenciasCtrl, [{
      key: 'enabledRetentionPeriod',
      value: function enabledRetentionPeriod(uoId) {
        var _this2 = this;

        return this.featureOuService.getProductName(uoId).then(function (naFeature) {
          if (naFeature) {
            _this2.showRetentionPeriod = _this2.featurehubJsSdk.isFeatureEnabled(_this2.featureHubConfigKeys.ENABLE_RETENTION_PERIOD_NA);
          } else {
            _this2.showRetentionPeriod = _this2.featurehubJsSdk.isFeatureEnabled(_this2.featureHubConfigKeys.ENABLE_RETENTION_PERIOD_LATAM);
          }
        });
      }
    }, {
      key: 'getEventTitle',
      value: function getEventTitle(event) {
        var eventType = event.tipo || event.id;
        if (!event || !eventType) {
          return '';
        }

        var hasCustomLevels = this.speedingLevels && Object.keys(this.speedingLevels).length > 0;
        var isSpeedingEvent = eventType.includes('EXCESSO_VELOCIDADE');

        if (isSpeedingEvent && hasCustomLevels) {
          var _getSpeedingLevelInfo = this.getSpeedingLevelInfo(eventType),
              nivel = _getSpeedingLevelInfo.nivel,
              baseType = _getSpeedingLevelInfo.baseType;

          if (nivel && this.speedingLevels.useBuckets && this.speedingLevels[nivel] && this.speedingLevels[nivel].levelLabel) {
            var baseTitle = this.translate.instant(this.alertasEnum.getAlerta(baseType).descricao);
            var bucketRange = this.speedingLevels[nivel].levelLabel;
            return baseTitle + ' - ' + bucketRange;
          }
        }

        var alertInfo = this.alertasEnum.getAlerta(eventType);
        return this.translate.instant(alertInfo.descricao);
      }
    }, {
      key: 'getSpeedingLevelInfo',
      value: function getSpeedingLevelInfo(eventType) {
        if (eventType.includes('_ALTO')) {
          return { nivel: 'ALTO', baseType: eventType.replace('_ALTO', '') };
        }
        if (eventType.includes('_MEDIO')) {
          return { nivel: 'MEDIO', baseType: eventType.replace('_MEDIO', '') };
        }
        if (eventType.includes('_BAIXO')) {
          return { nivel: 'BAIXO', baseType: eventType.replace('_BAIXO', '') };
        }
        return { nivel: null, baseType: eventType };
      }
    }, {
      key: 'getAlertasFiltrados',
      value: function getAlertasFiltrados(configEventos) {
        var _this3 = this;

        return this.alertasEnum.getTiposFiltered(configEventos).filter(function (alerta) {
          return alerta.id !== 'EXCESSO_VELOCIDADE' && alerta.id !== 'EXCESSO_VELOCIDADE_20' && alerta.id !== 'EXCESSO_VELOCIDADE_30' && alerta.id !== 'EXCESSO_VELOCIDADE_ACIMA_30' && alerta.id !== 'EXCESSO_VELOCIDADE_POR_VIA' && alerta.id !== 'DIAGNOSTICO_OBD' && alerta.id !== 'VEICULO_SEM_SINAL' && alerta.id !== 'RFID_NAO_CADASTRADO' && alerta.id !== 'SEM_IDENTIFICACAO_DE_MOTORISTA' && alerta.id !== 'GENERIC' && alerta.id !== 'BOTAO_PANE' && alerta.id !== 'SEM_EPI' && alerta.id !== 'STABILITY_CONTROL';
        }).filter(function (alerta) {
          return alerta.id !== 'MANUAL_EVENT_HARDWARE' || _this3.featurehubJsSdk.isFeatureEnabled(_this3.featureHubConfigKeys.MANUAL_EVENT_HARDWARE);
        });
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this4 = this;

        this.httpService.get('/configuracao/configuracoes/' + this.uoId + '/ocorrencia').then(function (consult) {
          consult.data.sort(_this4.handleSortEvents).forEach(function (ocorr) {
            if (ocorr.intervaloTempo) {
              ocorr.intervaloTempo /= UM_MINUTO_EM_SEGUNDOS;
            } else {
              ocorr.intervaloTempo = null;
            }
            if (ocorr.velocidadeMinima && ocorr.velocidadeMinima !== 0) {
              ocorr.velocidadeMinima = _this4.measurementUnits.distanceMeasurement === 'KM' ? ocorr.velocidadeMinima : Number(_this4.convertersService.handleKmToMiles(ocorr.velocidadeMinima));
            }
          });
          _this4.configsOcorrencia = consult.data.filter(function (ocorr) {
            var alert = _this4.alertasEnum[ocorr.tipo];
            return alert && alert.isEnabled(_this4.configEventos);
          });
          _this4.configsOcorrencia.forEach(function (config) {
            return config.backend = true;
          });
          _this4.configsBkp = _.cloneDeep(_this4.configsOcorrencia);
          _this4.isOwnConfigs = !_this4.hasConfigsUoPai(consult.data);
          _this4.filterSelectOptions(_this4.configsOcorrencia.map(function (ocorr) {
            return ocorr.tipo;
          }));
          _this4.handleTooltip();
          if (!_this4.isOwnConfigs) {
            _this4.emiteAlertaConfigUoPai();
          }
        }).catch(function () {
          _this4.isOwnConfigs = true;
          _this4.alertMessage.create({
            type: 'error',
            message: _this4.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.erroAoCarregarConfiguracoes'),
            appendTo: '.alerta-top'
          });
        });
      }
    }, {
      key: 'getConfigPeriodRetentionHours',
      value: function getConfigPeriodRetentionHours() {
        var _this5 = this;

        this.httpService.get('/configuracao/configurations/' + this.uoId + '/safety-focus-board').success(function (data) {
          _this5.retentionPeriod = data.periodRetentionHours;
          _this5.retentionPeriodBkp = data.periodRetentionHours;
        });
      }
    }, {
      key: 'hasConfigsUoPai',
      value: function hasConfigsUoPai(configs) {
        var hasConfigsUoPai = configs.length > 0 && configs[0].uoId !== this.uoId;
        return hasConfigsUoPai;
      }
    }, {
      key: 'emiteAlertaConfigUoPai',
      value: function emiteAlertaConfigUoPai() {
        this.alertMessage.create({
          type: 'warning',
          message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.erroUOPermissao.uoNaoPossuiPermissao') + '\n        <strong> ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.erroUOPermissao.configDeOcorrencias') + '</strong>.\n        ',
          appendTo: '.alerta-permissao',
          timeout: 15000
        });
      }
    }, {
      key: 'filterSelectOptions',
      value: function filterSelectOptions(eventosId) {
        var _this6 = this;

        var filteredOptions = this.selectOptions;

        if (this.occurrenceSimulator) {
          filteredOptions = filteredOptions.filter(function (evento) {
            return !_this6.NaFeatureExcludedEvents.includes(evento.id);
          });
        }

        eventosId.forEach(function (eventoId) {
          filteredOptions = filteredOptions.filter(function (evento) {
            return evento.id !== eventoId;
          });
        });

        this.selectOptions = filteredOptions;
      }
    }, {
      key: 'adicionarConfig',
      value: function adicionarConfig() {
        this.configsOcorrencia.push({
          tipo: this.model.eventoSelected.id,
          intervaloTempo: null,
          uoId: this.uoId,
          classe: null,
          velocidadeMinima: null,
          quantidade: 1,
          backend: false
        });

        this.filterSelectOptions([this.model.eventoSelected.id]);
        this.model.eventoSelected = null;
        this.handleChangeButton(true);
      }
    }, {
      key: 'removerEvento',
      value: function removerEvento(index, $event) {
        var _this7 = this;

        $event.stopPropagation();
        $event.preventDefault();

        var eventoKey = this.configsOcorrencia[index].tipo,
            descricao = this.translate.instant(this.alertasEnum.getAlerta(eventoKey).descricao);

        this.modalInfoConfirmService.confirmModal({
          title: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.titulo'),
          btnSecundario: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.voltar'),
          btnPrimario: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.remover'),
          conteudo: '\n                  ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.prefixMsgRemoverConfiguracao') + '\n                  ' + descricao + '\n                  ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.sufixMsgRemoverConfiguracao') + '\n                  ',
          headerColor: 'bg-red',
          typeButton: 'btn-danger'
        }).then(function () {
          _this7.removerConfig(index, eventoKey);
        });
      }
    }, {
      key: 'removerConfig',
      value: function removerConfig(index) {
        if (this.configsOcorrencia[index].backend) {
          this.removerConfigBackend(index);
        } else {
          this.removerConfigFrontend(index);
        }
      }
    }, {
      key: 'removerConfigBackend',
      value: function removerConfigBackend(index) {
        var _this8 = this;

        var tipo = this.configsOcorrencia[index].tipo,
            classe = this.configsOcorrencia[index].classe;
        this.httpService.delete('/configuracao/configuracoes/' + this.uoId + '/ocorrencia/' + tipo + '/classe/' + classe).then(function () {
          _this8.removerConfigFrontend(index);
          var indexBkp = _this8.configsBkp.findIndex(function (config) {
            return config.tipo === tipo;
          });
          _this8.configsBkp.splice(indexBkp, 1);
        }).catch(function () {
          _this8.alertMessage.create({
            type: 'danger',
            message: _this8.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.removerConfiguracaoModal.msgErro'),
            appendTo: '.alerta-aqui',
            timeout: 5000
          });
        });
      }
    }, {
      key: 'removerConfigFrontend',
      value: function removerConfigFrontend(index) {
        this.adicionaEventosSelect(this.configsOcorrencia[index].tipo);
        this.configsOcorrencia.splice(index, 1);
        if (!this.disableButton) {
          this.handleTooltip();
        }
      }
    }, {
      key: 'descartarAlteracoes',
      value: function descartarAlteracoes() {
        var _this9 = this;

        this.modalInfoConfirmService.confirmModal({
          title: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.modalDescartarAlteracoes.titulo'),
          conteudo: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.modalDescartarAlteracoes.descricao'),
          btnSecundario: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.modalDescartarAlteracoes.cancelar'),
          btnPrimario: 'OK',
          headerColor: 'bg-red',
          typeButton: 'btn-danger'
        }).then(function () {
          _this9.configsOcorrencia.forEach(function (config) {
            if (!config.backend) {
              _this9.adicionaEventosSelect(config.tipo);
            }
          });
          _this9.configsOcorrencia = _.cloneDeep(_this9.configsBkp);
          _this9.retentionPeriod = _.cloneDeep(_this9.retentionPeriodBkp);
          _this9.handleChangeButton(false);
        });
      }
    }, {
      key: 'adicionaEventosSelect',
      value: function adicionaEventosSelect(eventoKey) {
        this.selectOptions.push(this.alertasEnum.getAlerta(eventoKey));
      }
    }, {
      key: 'geraConfigsParaBackend',
      value: function geraConfigsParaBackend() {
        var _this10 = this;

        this.configsSalvar = _.cloneDeep(this.configsOcorrencia);
        this.configsSalvar.forEach(function (config) {
          if (config.intervaloTempo) {
            config.intervaloTempo *= UM_MINUTO_EM_SEGUNDOS;
          }
          if (config.velocidadeMinima && config.velocidadeMinima !== 0) {
            config.velocidadeMinima = _this10.measurementUnits.distanceMeasurement === 'KM' ? config.velocidadeMinima : Number(_this10.convertersService.handleMilesToKm(config.velocidadeMinima));
          }
          return config;
        });
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(uoId) {
        var _this11 = this;

        return this.featureOuService.getEventsConfig(uoId).then(function (eventNaConfig) {
          _this11.occurrenceSimulator = eventNaConfig;
        }).catch(function (error) {
          console.error('Error loading featureOu config: ', error);
        });
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this12 = this;

        if (!this.scope.ocorrenciasForm.$valid) {
          this.configsOcorrencia.forEach(function (ocorr) {
            _this12.scope.ocorrenciasForm[ocorr.tipo].$setDirty();
            _this12.scope.ocorrenciasForm[ocorr.tipo]['classificacao_' + ocorr.tipo].$setDirty();
          });
          return;
        }

        this.geraConfigsParaBackend();

        if (this.configsOcorrencia.length >= 1 && !this.occurrenceSimulator) {
          this.modalService.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'configuracoes/eventos/subpaginas/ocorrencias/modal-simulador/modal-simulador.tpl.html',
            controller: 'ModalSimuladorCtrl',
            controllerAs: '$ctrl',
            resolve: {
              configsOcorrencia: function configsOcorrencia() {
                return _this12.configsSalvar;
              }
            }
          }).result.then(function (res) {
            _this12.modalConfirmacaoSalvar(res);
          }).catch(function (error) {
            if (error === 'ERRO_SIMULADOR') {
              _this12.emiteAlertaErroSalvar();
            }
          });
        } else {
          this.salvarConfigsBackend();
        }
      }
    }, {
      key: 'emiteAlertaErroSalvar',
      value: function emiteAlertaErroSalvar() {
        this.alertMessage.create({
          type: 'error',
          message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.erro'),
          appendTo: '.alerta-aqui'
        });
      }
    }, {
      key: 'modalConfirmacaoSalvar',
      value: function modalConfirmacaoSalvar(res) {
        var _this13 = this;

        var data = this.moment(res.data).format('DD/MM/YYYY');
        this.modalInfoConfirmService.confirmModal({
          title: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.titulo'),
          conteudo: '<div>\n                    ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.divConfirmarSalvar.noDiaSelecionadoMsg') + '\n                    <em>(' + data + ')</em>,\n                    ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.divConfirmarSalvar.seriaGeradosAproximadamenteMsg') + '\n                    <strong> ' + res.ocorrencias + ' ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.divConfirmarSalvar.ocorrenciasMsg') + '</strong>\n                    ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.divConfirmarSalvar.noTotal') + '\n                  </div>\n                  <div>\n                    ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.divConfirmarSalvar.desejaProsseguirMsg') + '\n                  </div>',
          btnSecundario: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.voltar'),
          btnPrimario: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.modal.salvar')
        }).then(function () {
          _this13.salvarConfigsBackend();
        });
      }
    }, {
      key: 'salvarConfigsBackend',
      value: function salvarConfigsBackend() {
        var _this14 = this;

        var promises = [];

        promises.push(this.httpService.post('/configuracao/configuracoes/' + this.uoId + '/ocorrencia', this.configsSalvar).then(function () {
          _this14.configsOcorrencia.forEach(function (config) {
            return config.backend = true;
          });
        }));

        if (this.showRetentionPeriod) {
          promises.push(this.httpService.put('/configuracao/configurations/' + this.uoId + '/safety-focus-board', { periodRetentionHours: this.retentionPeriod }));
        }

        this.q.all(promises).then(function () {
          _this14.alertMessage.create({
            type: 'success',
            message: _this14.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.salvar.sucessoMsg'),
            appendTo: '.alerta-aqui',
            timeout: 5000
          });
          _this14.retentionPeriodBkp = _this14.retentionPeriod;
          _this14.handleChangeButton(false);
        }).catch(function () {
          _this14.emiteAlertaErroSalvar();
        });
      }
    }, {
      key: 'showOpenDialogEventPriority',
      value: function showOpenDialogEventPriority() {
        var _this15 = this;

        /* eslint-disable */
        var abrirModal = document.querySelector('#openDialogEventPriority'),
            modal = document.createElement('vfwc-open-dialog-event-priority'); /* eslint-enable */
        modal.uoId = this.uoId;
        modal.enableOptions = false;
        modal.userLanguage = this.userLanguage;
        abrirModal && abrirModal.appendChild(modal);
        this.onEventPriority(modal);
        this.scope.$watch(function () {
          return _this15.scope.ocorrenciasForm.$dirty;
        }, function (isDirty) {
          return _this15.handleChangeButton(isDirty);
        });
      }
    }, {
      key: 'onEventPriority',
      value: function onEventPriority(element) {
        var _this16 = this;

        element.addEventListener('eventPriorityEmitter', function () {
          _this16.consultar();
        });
      }
    }, {
      key: 'handleChangeButton',
      value: function handleChangeButton(disableButton, tooltipErrorMessage) {
        /* eslint-disable */
        var element = document.getElementById('event-priority-button'); /* eslint-enable */
        this.disableButton = disableButton;
        if (element) {
          element.disabled = disableButton;
          if (disableButton) {
            element.classList.add('mat-button-disabled');
          } else {
            element.classList.remove('mat-button-disabled');
          }
        }
        this.tooltipErrorMessage = tooltipErrorMessage || 'ce.tempoReal.quadroDeOcorrencias.dialogEventPriority.radio.tooltipDisabled';
      }
    }, {
      key: 'handleTooltip',
      value: function handleTooltip() {
        var _this17 = this;

        if (!this.configsOcorrencia.length) {
          this.handleChangeButton(true, 'ce.tempoReal.quadroDeOcorrencias.dialogEventPriority.radio.tooltipDisabledEmpty');
        } else if (this.configsOcorrencia.some(function (config) {
          return config.uoId !== _this17.uoId;
        })) {
          this.handleChangeButton(true, 'ce.tempoReal.quadroDeOcorrencias.dialogEventPriority.radio.tooltipDisabledUO');
        } else {
          this.handleChangeButton(false);
        }
      }
    }, {
      key: 'handleSortEvents',
      value: function handleSortEvents(a, b) {
        if (a.presentationPriority === b.presentationPriority) {
          return 0;
        } else if (!a.presentationPriority) {
          return 1;
        } else if (!b.presentationPriority) {
          return -1;
        }
        return a.presentationPriority - b.presentationPriority;
      }
    }, {
      key: 'msgError',
      value: function msgError(error, campo) {
        return error.required && '' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.erro.campoObrigatorio') || error.min && this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.erro.prefixMsgValorDe') + ' ' + campo + ' ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.erro.sufixMsgNaoPodeSerNegativo') || error.qtdInteger && this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.erro.prefixMsgValorDe') + ' ' + campo + ' ' + this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.ocorrencias.eventosConfiguraveis.adicioneEventos.eventoInfo.erro.sufixMsgDeveSerInteiro');
      }
    }, {
      key: 'isQtdValid',
      value: function isQtdValid(quantidade) {
        return function () {
          return quantidade > 0;
        };
      }
    }, {
      key: 'isInteger',
      value: function isInteger(inputScope) {
        return function () {
          return Number.isInteger(Number(inputScope.$viewValue));
        };
      }
    }, {
      key: 'hasErrorQtd',
      value: function hasErrorQtd(inputScope) {
        return inputScope.$invalid && (inputScope.$dirty || inputScope.$error.required);
      }
    }, {
      key: 'hasErrorClassificacao',
      value: function hasErrorClassificacao(inputScope) {
        var returno = inputScope.$invalid && inputScope.$dirty;
        return returno;
      }
    }, {
      key: 'abrirModalInfo',
      value: function abrirModalInfo() {
        this.modalService.open({
          animation: true,
          backdrop: 'static',
          templateUrl: 'configuracoes/eventos/subpaginas/ocorrencias/modal-ocorrencias-info/modal-ocorrencias-info.tpl.html',
          controller: 'ModalOcorrenciasInfoCtrl',
          controllerAs: '$ctrl'
        });
      }
    }, {
      key: 'isReadOnly',
      value: function isReadOnly() {
        return !this.isOwnConfigs || !this.hasRoleConfigOcorrenciaEditar;
      }
    }, {
      key: 'isReadWrite',
      value: function isReadWrite() {
        return this.isOwnConfigs && this.hasRoleConfigOcorrenciaEditar;
      }
    }]);

    return OcorrenciasCtrl;
  }();

  angular.module('SubpaginasEventos').controller('OcorrenciasCtrl', OcorrenciasCtrl);
})();
'use strict';

(function () {
  'use strict';

  function DriverPrivacyConfiguration() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/driver-privacy/driver-privacy.tpl.html',
      controller: 'DriverPrivacyCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('driverPrivacyConfigurationEventos', DriverPrivacyConfiguration);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/log */
/* eslint-disable camelcase */
(function () {
  'use strict';

  var DriverPrivacyCtrl = function () {
    function DriverPrivacyCtrl($scope, $document, $log, $window, Authenticator, safetyService, Keys, ServiceVfiltro, FactoryVfiltro, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, DriverPrivacyCtrl);

      this.log = $log;
      this.scope = $scope;
      this.window = $window;
      this.document = $document[0];
      this.safetyService = safetyService;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.isFeatureFlagDeviceHealthConfigurationPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_DRIVER_PRIVACY);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      var filterFromService = null;
      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (result) {
        filterFromService = result.filtro;
      }).catch(function (error) {
        _this.log.error('Error initializing filter:', error);
      }).finally(function () {
        _this.safetyService.initialize().then(function () {
          _this.authenticator.getUser().then(function (user) {
            var finalFilter = null;
            if (filterFromService) {
              finalFilter = filterFromService;
            } else {
              finalFilter = _this.getStoredOUFilter(user.id);
            }
            _this.loadPage(finalFilter, user);
          }).catch(function (error) {
            _this.log.error('Critical Error: Failed to fetch user in finally block:', error);
            _this.loadPage(null, null);
          });
        });
      });
    }

    _createClass(DriverPrivacyCtrl, [{
      key: 'getStoredOUFilter',
      value: function getStoredOUFilter(userId) {
        if (!userId) {
          return null;
        }
        var storedVFilter = this.window.localStorage.getItem('vfiltro-' + userId);
        return storedVFilter ? { uo_permissao: angular.fromJson(storedVFilter).uo } : null;
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter, user) {
        if (!this.isFeatureFlagDeviceHealthConfigurationPageEnabled || !user || !user.id) {
          return;
        }

        var finalFilter = filter || this.getStoredOUFilter(user.id),
            props = {
          filter: finalFilter,
          user: user
        },
            appName = 'safetyApp',
            componentPath = './SettingsPageRoute',
            componentId = 'safety-app-driver-privacy',
            containerElement = this.document.getElementById(componentId);

        if (!containerElement) {
          this.log.error('Container element with ID \'' + componentId + '\' not found in DOM when calling loadReactComponent.');
          return;
        }
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }]);

    return DriverPrivacyCtrl;
  }();

  angular.module('SubpaginasEventos').controller('DriverPrivacyCtrl', DriverPrivacyCtrl);
})();
'use strict';

(function () {
  'use strict';

  function DeviceHealthConfiguration() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/device-health-configuration/device-health-configuration.tpl.html',
      controller: 'DeviceHealthConfigurationCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('deviceHealthConfigurationEventos', DeviceHealthConfiguration);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase */
(function () {
  'use strict';

  var DeviceHealthConfigurationCtrl = function () {
    function DeviceHealthConfigurationCtrl($scope, $document, $log, $window, Authenticator, safetyService, Keys, ServiceVfiltro, FactoryVfiltro, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, DeviceHealthConfigurationCtrl);

      this.log = $log;
      this.scope = $scope;
      this.window = $window;
      this.document = $document[0];
      this.safetyService = safetyService;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.isFeatureFlagDeviceHealthConfigurationPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      var filterFromService = null;
      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (result) {
        filterFromService = result.filtro;
      }).catch(function (error) {
        _this.log.error('Error initializing filter:', error);
      }).finally(function () {
        _this.safetyService.initialize().then(function () {
          _this.authenticator.getUser().then(function (user) {
            var finalFilter = null;
            if (filterFromService) {
              finalFilter = filterFromService;
            } else {
              finalFilter = _this.getStoredOUFilter(user.id);
            }
            _this.loadPage(finalFilter, user);
          }).catch(function (error) {
            _this.log.error('Critical Error: Failed to fetch user in finally block:', error);
            _this.loadPage(null, null);
          });
        });
      });
    }

    _createClass(DeviceHealthConfigurationCtrl, [{
      key: 'getStoredOUFilter',
      value: function getStoredOUFilter(userId) {
        if (!userId) {
          return null;
        }
        var storedVFilter = this.window.localStorage.getItem('vfiltro-' + userId);
        return storedVFilter ? { uo_permissao: angular.fromJson(storedVFilter).uo } : null;
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter, user) {
        if (!this.isFeatureFlagDeviceHealthConfigurationPageEnabled || !user || !user.id) {
          return;
        }

        var finalFilter = filter || this.getStoredOUFilter(user.id),
            props = {
          filter: finalFilter,
          user: user
        },
            appName = 'safetyApp',
            componentPath = './DeviceHealthConfigurationPageRoute',
            componentId = 'safety-app-device-health-configuration',
            containerElement = this.document.getElementById(componentId);

        if (!containerElement) {
          this.log.error('Container element with ID \'' + componentId + '\' not found in DOM when calling loadReactComponent.');
          return;
        }
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }]);

    return DeviceHealthConfigurationCtrl;
  }();

  angular.module('SubpaginasEventos').controller('DeviceHealthConfigurationCtrl', DeviceHealthConfigurationCtrl);
})();
'use strict';

(function () {
  'use strict';

  function DescarteEventos() {
    return {
      templateUrl: 'configuracoes/eventos/subpaginas/descarte/descarte-eventos.tpl.html',
      controller: 'DescarteEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular.module('SubpaginasEventos').directive('descarteEventos', DescarteEventos);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DescarteEventosCtrl = function () {
    function DescarteEventosCtrl($scope, $uibModal, Restangular, AlertMessage, Keys, ServiceVfiltro, FactoryVfiltro, $translate, $q, $timeout, Authenticator, FeatureOuService, MeasurementUnitConverterService, SpeedingBucketService, UoHelperService) {
      var _this = this;

      _classCallCheck(this, DescarteEventosCtrl);

      this.scope = $scope;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.q = $q;
      this.$timeout = $timeout;
      this.authenticator = Authenticator;
      this.featureOuService = FeatureOuService;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.speedingBucketService = SpeedingBucketService;
      this.uoHelperService = UoHelperService;

      this.uoId = 0;
      this.roleCadastrar = true;
      this.model = { configuracoes: [] };
      this.ptsMask = this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.descarte.segMask');

      this.speedingLevels = {};

      this.q.all([this.serviceVfiltro.init(FactoryVfiltro.get([{ key: this.keys.uo.name }])), this.authenticator.getUser()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            filtro = _ref2[0],
            user = _ref2[1];

        _this.user = user;
        _this.isUserSpeedMeasurementUnitMiles = _this.user.measurementUnits.speedMeasurement === 'MILES';
        _this.userUoId = _this.user.uo.id;
        _this.uoId = filtro.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id;
        _this.roleCadastrar = _this.temPermissaoParaConfigurar();
        _this.getSpeedingLevels().then(function () {
          _this.isNAFeatureEnabled(_this.uoId).then(function (isNAFeatureEnabled) {
            _this.isNAFeatureEnabled = isNAFeatureEnabled;
            _this.init();
          });
        });
      });
    }

    _createClass(DescarteEventosCtrl, [{
      key: 'temPermissaoParaConfigurar',
      value: function temPermissaoParaConfigurar() {
        return this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_DESCARTE_EDITAR') && this.uoHelperService.isDirectChildOfRoot(this.serviceVfiltro.factoryVfiltro.user.uo) && this.serviceVfiltro.factoryVfiltro.user.uo.id === this.uoId;
      }
    }, {
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.restangular.one('configuracao/configuracoes/' + this.uoId + '/speed-limit-ativo').get().then(function (speedLimit) {
          return _this2.setConfiguracoes(speedLimit);
        }).catch(function () {
          return _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.msgErroCarregarConfiguracoes'),
            appendTo: '.alerta-aqui-geral'
          });
        });
      }
    }, {
      key: 'isNAFeatureEnabled',
      value: function isNAFeatureEnabled(uoId) {
        return this.featureOuService.getEventsConfig(uoId).then(function (naFeature) {
          return naFeature;
        });
      }
    }, {
      key: 'setConfiguracoes',
      value: function setConfiguracoes(speedLimit) {
        this.model.speedLimitEmbarcado = speedLimit.speedLimitEmbarcado;
        this.model.speedLimitVia = speedLimit.speedLimitVia;

        this.model.habilitarSpeedLimitPorcentagem = speedLimit.speedLimitPorcentagemDescarte > 0;
        this.model.speedLimitPorcentagemDescarte = speedLimit.speedLimitPorcentagemDescarte;

        this.model.habilitarSpeedLimitDuracaoDescarte = speedLimit.speedLimitDuracaoDescarte > 0;
        this.model.speedLimitDuracaoDescarte = speedLimit.speedLimitDuracaoDescarte;

        this.model.habilitarSpeedLimitViaPorcentagem = speedLimit.speedLimitViaPorcentagemDescarte > 0;
        this.model.speedLimitViaPorcentagemDescarte = speedLimit.speedLimitViaPorcentagemDescarte;

        this.model.habilitarSpeedLimitViaDuracaoDescarte = speedLimit.speedLimitViaDuracaoDescarte > 0;
        this.model.speedLimitViaDuracaoDescarte = speedLimit.speedLimitViaDuracaoDescarte;

        this.model.habilitarVelDescarteCurva = speedLimit.velDescarteCurva > 0;
        this.model.velDescarteCurva = speedLimit.velDescarteCurva;

        this.model.habilitarVelDescarteCameraObstruida = speedLimit.velDescarteCameraObstruida > 0;
        this.model.velDescarteCameraObstruida = speedLimit.velDescarteCameraObstruida;

        this.model.habilitarDistanciaMinimaFreioDescida = speedLimit.distanciaMinimaFreioDescida > 0;
        this.model.distanciaMinimaFreioDescida = speedLimit.distanciaMinimaFreioDescida;

        this.model.habilitarVelAbsolutaDescarteExcessoVelocidadeVia = speedLimit.velAbsolutaDescarteExcessoVelocidadeVia > 0;
        this.model.velAbsolutaDescarteExcessoVelocidadeVia = this.isUserSpeedMeasurementUnitMiles ? this.measurementUnitConverterService.convertSpeedFromKmhToMph(Number(speedLimit.velAbsolutaDescarteExcessoVelocidadeVia)) : speedLimit.velAbsolutaDescarteExcessoVelocidadeVia;

        this.model.backupConfiguracoes = speedLimit;
      }
    }, {
      key: 'descartarAlteracoes',
      value: function descartarAlteracoes() {
        this.setConfiguracoes(this.model.backupConfiguracoes);
      }
    }, {
      key: 'getSpeedingLevels',
      value: function getSpeedingLevels() {
        var _this3 = this;

        return this.speedingBucketService.getSpeedingBucketsPorUo(this.userUoId).then(function (speedingLevels) {
          _this3.speedingLevels = speedingLevels;
        });
      }
    }, {
      key: 'validateVelAbsolutaDescarteExcessoVelocidadeVia',
      value: function validateVelAbsolutaDescarteExcessoVelocidadeVia() {
        var _this4 = this;

        this.$timeout(function () {
          var inputController = _this4.scope.formDescarte['input-velocidade-absoluta-posted'];

          if (!inputController || !_this4.model.habilitarVelAbsolutaDescarteExcessoVelocidadeVia) {
            return;
          }

          if (!_this4.speedingLevels.speedingBucketKmh1min) {
            inputController.$setValidity('velocidadeMinima', true);
            return;
          }

          var inputValue = Number(_this4.model.velAbsolutaDescarteExcessoVelocidadeVia),
              minimumLimit = Number(_this4.getMinVelAbsolutaDescarteExcessoVelocidadeVia()),
              isExceededSpeedPostedValid = inputValue && inputValue >= minimumLimit;

          inputController.$setValidity('velocidadeMinima', isExceededSpeedPostedValid);
        }, 0);
      }
    }, {
      key: 'getMinVelAbsolutaDescarteExcessoVelocidadeVia',
      value: function getMinVelAbsolutaDescarteExcessoVelocidadeVia() {
        if (!this.speedingLevels.speedingBucketKmh1min) return 0;

        return !this.isUserSpeedMeasurementUnitMiles ? this.measurementUnitConverterService.convertSpeedFromMphToKmh(this.speedingLevels.speedingBucketKmh1min) : this.speedingLevels.speedingBucketKmh1min;
      }
    }, {
      key: 'getConfiguracoes',
      value: function getConfiguracoes() {
        var velAbsolutaDescarteExcessoVelocidadeVia = 0;

        if (this.model.habilitarVelAbsolutaDescarteExcessoVelocidadeVia) {
          if (this.isUserSpeedMeasurementUnitMiles) {
            velAbsolutaDescarteExcessoVelocidadeVia = this.measurementUnitConverterService.convertSpeedFromMphToKmh(Number(this.model.velAbsolutaDescarteExcessoVelocidadeVia));
          } else {
            velAbsolutaDescarteExcessoVelocidadeVia = this.model.velAbsolutaDescarteExcessoVelocidadeVia;
          }
        }

        return {
          uoId: this.uoId,
          speedLimitEmbarcado: this.model.speedLimitEmbarcado,
          speedLimitVia: this.model.speedLimitVia,
          speedLimitPorcentagemDescarte: this.model.habilitarSpeedLimitPorcentagem ? this.model.speedLimitPorcentagemDescarte : 0,
          speedLimitDuracaoDescarte: this.model.habilitarSpeedLimitDuracaoDescarte ? this.model.speedLimitDuracaoDescarte : 0,
          speedLimitViaPorcentagemDescarte: this.model.habilitarSpeedLimitViaPorcentagem ? this.model.speedLimitViaPorcentagemDescarte : 0,
          speedLimitViaDuracaoDescarte: this.model.habilitarSpeedLimitViaDuracaoDescarte ? this.model.speedLimitViaDuracaoDescarte : 0,
          velDescarteCurva: this.model.habilitarVelDescarteCurva ? this.model.velDescarteCurva : 0,
          velDescarteCameraObstruida: this.model.habilitarVelDescarteCameraObstruida ? this.model.velDescarteCameraObstruida : 0,
          distanciaMinimaFreioDescida: this.model.habilitarDistanciaMinimaFreioDescida ? this.model.distanciaMinimaFreioDescida : 0,
          velAbsolutaDescarteExcessoVelocidadeVia: velAbsolutaDescarteExcessoVelocidadeVia
        };
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this5 = this;

        var configDescarte = this.getConfiguracoes();

        this.restangular.all('configuracao/configuracoes/' + this.uoId + '/speed-limit-ativo').post(configDescarte).then(function (speedLimit) {
          _this5.rebuildSpeedLimitAtivo(speedLimit);
        }).catch(function () {
          _this5.alertMessage.create({
            type: 'error',
            message: _this5.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.erroSalvarConfiguracoes'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'rebuildSpeedLimitAtivo',
      value: function rebuildSpeedLimitAtivo(speedLimit) {
        this.scope.formDescarte.$setPristine();
        this.setConfiguracoes(speedLimit);
        this.alertMessage.create({
          type: 'success',
          message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.salvoComSucesso'),
          appendTo: '.alerta-aqui'
        });
      }
    }]);

    return DescarteEventosCtrl;
  }();

  angular.module('SubpaginasEventos').controller('DescarteEventosCtrl', DescarteEventosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ModalEventos', ['ModuleMapasUtil', 'ui.bootstrap']);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalTurnoEventos = function ModalTurnoEventos($uibModalInstance, titulo, texto, texto2, clique) {
    _classCallCheck(this, ModalTurnoEventos);

    this.modalInstance = $uibModalInstance;
    this.titulo = titulo;
    this.texto = texto;
    this.texto2 = texto2;
    this.clique = clique;
  };

  angular.module('ModalEventos').controller('ModalTurnoEventosCtrl', ModalTurnoEventos);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalResetEventos = function () {
    function ModalResetEventos($uibModalInstance) {
      _classCallCheck(this, ModalResetEventos);

      this.modalInstance = $uibModalInstance;
    }

    _createClass(ModalResetEventos, [{
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return ModalResetEventos;
  }();

  angular.module('ModalEventos').controller('ModalResetEventosCtrl', ModalResetEventos);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalInfoEventos = function () {
    function ModalInfoEventos($uibModalInstance, MapasUtil) {
      _classCallCheck(this, ModalInfoEventos);

      this.modalInstance = $uibModalInstance;
      this.tiles = MapasUtil.tiles;
      this.defaults = MapasUtil.defaults;
      this.center = {
        lat: -23.310229,
        lng: -51.170495,
        zoom: 12
      };
      this.markers = {};
      this.geoJson = {};
    }

    _createClass(ModalInfoEventos, [{
      key: 'close',
      value: function close() {
        this.modalInstance.close();
      }
    }]);

    return ModalInfoEventos;
  }();

  angular.module('ModalEventos').controller('ModalInfoEventosCtrl', ModalInfoEventos);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.videoLibrary.solicitacaoVideos', ['ui.router', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ProntuarioLinkModule', 'angularMoment', 'v3gAuthenticatorModule', 'pascalprecht.translate']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/relatorios/solicitacao-videos', ['$state', function ($state) {
      $state.go('root.videoLibrary.solicitacaoVideos');
    }]);

    return $stateProvider.state('root.videoLibrary.solicitacaoVideos', {
      url: 'solicitacao-videos?vfiltro=',
      views: {
        '': {
          templateUrl: 'relatorios/video-library/solicitacao-videos/solicitacao-videos.tpl.html',
          controller: 'SolicitacaoVideosCtrl',
          controllerAs: 'solicitacaoVideos'
        }
      },
      data: {
        roles: [['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']],
        accessByBundle: ['ROAD_GOLD', 'PATH_BLUE', 'PATH_GOLD', 'EDGE_BLUE', 'EDGE_GOLD'],
        accessByPremiumTelemetry: true
      }
    });
  }
  angular.module('relatorios.videoLibrary.solicitacaoVideos').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var SolicitacaoVideosCtrl = function () {
    function SolicitacaoVideosCtrl(ServiceVfiltro, Authenticator, FactoryVfiltro, ProntuarioLinkService, Keys, moment, $translate) {
      var _this = this;

      _classCallCheck(this, SolicitacaoVideosCtrl);

      this.authenticator = Authenticator;
      this.keys = Keys;
      this.moment = moment;
      this.translate = $translate;
      this.prontuarioLinkService = ProntuarioLinkService;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        defaultValues: {
          hoje: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        key: this.keys.uo.name
      }, {
        key: this.keys.veiculos.name
      }, {
        key: this.keys.statusVideosSolicitacao.name
      }, {
        label: this.translate.instant('ce.configuracao.eventos.menuLabel'),
        key: this.keys.tipos.name,
        hasNivel: false,
        showEpiUnified: true,
        includeManualRequest: true
      }])).then(function (filtro) {
        _this.init(filtro);
      });
      this.authenticator.getUser().then(function (user) {
        _this.validShowLinkDriverRecord = _this.prontuarioLinkService.hasRoleToViewProntuario(user);
      });
    }

    _createClass(SolicitacaoVideosCtrl, [{
      key: 'init',
      value: function init(filtro) {
        var _this2 = this;

        /*eslint-disable */
        this.authenticator.getUser().then(function (user) {
          var tableSolicitacaoVideosElement = document.querySelector('#table-solicitacao-videos'),
              vfwcTableSolicitacaoVideosElement = document.createElement('vfwc-solicitacao-videos'),
              vehiclesFiltered = filtro.find(function (f) {
            return f.key === 'veiculos';
          }),
              eventsFiltered = filtro.find(function (f) {
            return f.key === 'tipos';
          }),
              statusVideoFiltered = filtro.find(function (f) {
            return f.key === 'statusVideosSolicitacao';
          }),
              vehiclesId = vehiclesFiltered ? vehiclesFiltered.values.map(function (vehicle) {
            return vehicle.id;
          }) : vehiclesFiltered,
              eventsId = eventsFiltered ? eventsFiltered.values.map(function (event) {
            return event.id;
          }) : eventsFiltered,
              statusVideoId = statusVideoFiltered ? statusVideoFiltered.values.map(function (status) {
            return status.id;
          }) : statusVideoFiltered;
          vfwcTableSolicitacaoVideosElement.uoId = Number(filtro.find(function (f) {
            return f.key === 'uo';
          }).value.id);
          vfwcTableSolicitacaoVideosElement.vehiclesIds = vehiclesId;
          vfwcTableSolicitacaoVideosElement.events = eventsId;
          vfwcTableSolicitacaoVideosElement.status = statusVideoId;
          vfwcTableSolicitacaoVideosElement.startDate = filtro.find(function (f) {
            return f.key === 'dateTime';
          }).value.startDate;
          vfwcTableSolicitacaoVideosElement.endDate = filtro.find(function (f) {
            return f.key === 'dateTime';
          }).value.endDate;
          vfwcTableSolicitacaoVideosElement.user = user;
          vfwcTableSolicitacaoVideosElement.hideHeaderTopLine = false;
          vfwcTableSolicitacaoVideosElement.enableHiperlink = _this2.validShowLinkDriverRecord;

          if (tableSolicitacaoVideosElement) {
            tableSolicitacaoVideosElement.appendChild(vfwcTableSolicitacaoVideosElement);
          }
        });
        /*eslint-enable */
      }
    }]);

    return SolicitacaoVideosCtrl;
  }();

  angular.module('relatorios.videoLibrary.solicitacaoVideos').controller('SolicitacaoVideosCtrl', SolicitacaoVideosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.videoLibrary.playback', ['ui.router', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'angularMoment', 'v3gAuthenticatorModule', 'pascalprecht.translate']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.playback', {
      url: '/relatorios/playback?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/video-library/playback/playback.tpl.html',
          controller: 'PlaybackCtrl'
        }
      },
      data: {
        titulo: 'ce.analise.videoPlayback.menuLabel',
        roles: [['VIDEO_PLAYBACK', 'DADOS_SENSIVEIS_VISUALIZAR'], ['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }
  angular.module('relatorios.videoLibrary.playback').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PlaybackTab = Object.freeze({ VIDEO_HISTORY: 0, VIDEO_PLAYBACK: 1 }),
      TAB_CHANGE_EVENT = 'vfleets:playback:tabChange',
      ACTIVE_TAB_SESSION_KEY = 'playback:activeTab',
      VIDEO_HISTORY_ROLE = 'VPLAYER_REQMANUAL_VISUALIZAR',
      VIDEO_PLAYBACK_ROLE = 'VIDEO_PLAYBACK',
      VEHICLE_ONLINE_EVENT = 'safety:vehicle:online';

  var PlaybackCtrl = function () {
    function PlaybackCtrl($scope, $rootScope, $window, $location, safetyService, ServiceVfiltro, FactoryVfiltro, Keys, moment, Authenticator, FeatureHubConfigKeys, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, PlaybackCtrl);

      this.authenticator = Authenticator;
      this.keys = Keys;
      this.moment = moment;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.safetyService = safetyService;
      this.isVideoPlaybackRequest = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.VIDEO_PLAYBACK_REQUEST);
      this.window = $window;
      this.location = $location;
      this.rootScope = $rootScope;
      this.scope = $scope;
      this.activeTab = Number($window.sessionStorage.getItem(ACTIVE_TAB_SESSION_KEY)) || PlaybackTab.VIDEO_HISTORY;

      if (!this.isVideoPlaybackRequest) {
        this.serviceVfiltro.init(this.factoryVfiltro.get(this.getVideoPlaybackFilterConfig())).then(function (filtro) {
          _this.filterInitializing = false;
          _this.serviceVfiltro.openFiltroDetalhado = true;
          _this.init(filtro);
        });
      } else {
        this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.activeTab = _this.resolveInitialTab(user, _this.activeTab);
          _this.window.sessionStorage.setItem(ACTIVE_TAB_SESSION_KEY, _this.activeTab);
          _this.initFilterForTab(_this.activeTab, user);
        });

        this.onTabChange = function (_ref) {
          var detail = _ref.detail;

          _this.activeTab = detail.tab;
          _this.window.sessionStorage.setItem(ACTIVE_TAB_SESSION_KEY, detail.tab);
          _this.initFilterForTab(_this.activeTab, _this.user);
        };

        this.window.addEventListener(TAB_CHANGE_EVENT, this.onTabChange);

        this.onVehicleOnline = function () {
          var vehicleFilter = _this.serviceVfiltro.filtroTopbar.find(function (f) {
            return f.key === _this.keys.veiculo.name;
          });
          if (vehicleFilter) {
            vehicleFilter.value.vmovOnline = true;
          }
          _this.callVideoPlaybackPage(_this.serviceVfiltro.filtroTopbar, _this.user);
        };

        this.window.addEventListener(VEHICLE_ONLINE_EVENT, this.onVehicleOnline);

        var unregisterLocationChange = this.rootScope.$on('$locationChangeSuccess', function () {
          if (_this.location.path() === '/relatorios/playback' && !_this.filterInitializing) {
            if (_this.isVideoPlaybackRequest) {
              _this.callVideoPlaybackPage(_this.serviceVfiltro.filtroTopbar, _this.user);
            } else {
              _this.initFilterForTab(_this.activeTab, _this.user);
            }
          }
        });

        this.scope.$on('$destroy', function () {
          _this.window.removeEventListener(TAB_CHANGE_EVENT, _this.onTabChange);
          _this.window.removeEventListener(VEHICLE_ONLINE_EVENT, _this.onVehicleOnline);
          unregisterLocationChange();
        });

        this.rootScope.$on('$stateChangeStart', function (event, toState) {
          if (toState.name !== 'root.playback') {
            _this.window.sessionStorage.removeItem(ACTIVE_TAB_SESSION_KEY);
          }
        });
      }
    }

    _createClass(PlaybackCtrl, [{
      key: 'resolveInitialTab',
      value: function resolveInitialTab(user, requestedTab) {
        var roles = user && user.permissoesSolucao || [],
            canShowVideoHistory = roles.indexOf(VIDEO_HISTORY_ROLE) !== -1,
            canShowVideoPlayback = roles.indexOf(VIDEO_PLAYBACK_ROLE) !== -1;

        if (requestedTab === PlaybackTab.VIDEO_HISTORY && !canShowVideoHistory && canShowVideoPlayback) {
          return PlaybackTab.VIDEO_PLAYBACK;
        }
        if (requestedTab === PlaybackTab.VIDEO_PLAYBACK && !canShowVideoPlayback && canShowVideoHistory) {
          return PlaybackTab.VIDEO_HISTORY;
        }
        return requestedTab;
      }
    }, {
      key: 'initFilterForTab',
      value: function initFilterForTab(tab, user) {
        var _this2 = this;

        var config = tab === PlaybackTab.VIDEO_HISTORY ? this.getVideoHistoryFilterConfig() : this.getVideoPlaybackFilterConfig();

        this.filterInitializing = true;
        this.serviceVfiltro.init(this.factoryVfiltro.get(config)).then(function (filtro) {
          _this2.filterInitializing = false;
          if (_this2.isVideoPlaybackRequest) {
            _this2.callVideoPlaybackPage(filtro, user);
          } else {
            _this2.init(filtro);
          }
        }).catch(function () {
          _this2.filterInitializing = false;
          _this2.serviceVfiltro.openFiltroDetalhado = tab === PlaybackTab.VIDEO_PLAYBACK;
        });
      }
    }, {
      key: 'getVideoPlaybackFilterConfig',
      value: function getVideoPlaybackFilterConfig() {
        return [{
          key: this.keys.uo.name,
          required: true,
          order: 1
        }, {
          key: this.keys.veiculo.name,
          required: true,
          checkVehiclesOnline: true,
          reloadCalendar: true,
          order: 2
        }, {
          key: this.keys.dateTime.name,
          format: 'YYYY-MM-DD',
          maxDate: this.moment().endOf('day').format(),
          customAvailableDates: true,
          required: true,
          order: 3
        }];
      }
    }, {
      key: 'getVideoHistoryFilterConfig',
      value: function getVideoHistoryFilterConfig() {
        return [{
          key: this.keys.dateTime.name,
          time: true,
          maxDate: this.moment().endOf('day').format(),
          defaultValues: {
            hoje: { active: true },
            ultimos7dias: { active: true },
            ontem: { active: true }
          }
        }, {
          key: this.keys.uo.name,
          required: true,
          order: 4
        }, {
          key: this.keys.veiculos.name,
          required: false,
          order: 5
        }, {
          key: this.keys.tipos.name,
          hasNivel: false,
          showEpiUnified: true,
          includeManualRequest: true
        }, {
          key: this.keys.statusVideos.name
        }];
      }
    }, {
      key: 'init',
      value: function init(filtro) {
        var _this3 = this;

        this.authenticator.getUser().then(function (user) {
          /*eslint-disable */
          var playbackPageContentElement = document.querySelector('#playback-page-content');

          var vfwcPlaybackElement = document.createElement('vfwc-playback'),
              vehicleFilter = filtro.find(function (f) {
            return f.key === _this3.keys.veiculo.name;
          }),
              dateTimeFilter = filtro.find(function (f) {
            return f.key === _this3.keys.dateTime.name;
          });

          vfwcPlaybackElement.vehicleId = vehicleFilter && Number(vehicleFilter.value.id);
          vfwcPlaybackElement.startDate = dateTimeFilter && dateTimeFilter.value.startDate;
          vfwcPlaybackElement.endDate = dateTimeFilter && dateTimeFilter.value.endDate;
          vfwcPlaybackElement.user = user;

          playbackPageContentElement.innerHTML = '';
          playbackPageContentElement.appendChild(vfwcPlaybackElement);
          /*eslint-enable */
        });
      }
    }, {
      key: 'callVideoPlaybackPage',
      value: function callVideoPlaybackPage(filtro, user) {
        var _this4 = this;

        var isHistory = this.activeTab === PlaybackTab.VIDEO_HISTORY,
            vehicleFilter = isHistory ? filtro.find(function (f) {
          return f.key === _this4.keys.veiculos.name;
        }) : filtro.find(function (f) {
          return f.key === _this4.keys.veiculo.name;
        }),
            dateTimeFilter = filtro.find(function (f) {
          return f.key === _this4.keys.dateTime.name;
        }),
            type = filtro.find(function (f) {
          return f.key === _this4.keys.tipos.name;
        }),
            state = filtro.find(function (f) {
          return f.key === _this4.keys.statusVideos.name;
        }),
            vehicleIds = isHistory ? vehicleFilter && vehicleFilter.values.length > 0 && vehicleFilter.values.map(function (v) {
          return v.id;
        }) || null : vehicleFilter && [Number(vehicleFilter.value.id)],
            vehicleLabels = isHistory ? vehicleFilter && vehicleFilter.values.length > 0 && vehicleFilter.values.map(function (v) {
          return v.label;
        }) || null : vehicleFilter && [String(vehicleFilter.value.label)],
            appName = 'safetyApp',
            componentPath = './VideoPlaybackPage',
            componentId = 'safety-app-VideoPlayback',
            props = {
          activeTab: this.activeTab,
          vehicleIds: vehicleIds,
          vehicleLabels: vehicleLabels,
          startDate: dateTimeFilter && dateTimeFilter.value.startDate,
          endDate: dateTimeFilter && dateTimeFilter.value.endDate,
          events: type && type.values.map(function (v) {
            return v.id;
          }),
          status: state && state.values.map(function (v) {
            return v.id;
          }),
          user: user,
          isVehicleOnline: !isHistory && vehicleFilter ? !!vehicleFilter.value.vmovOnline : undefined
        };
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }]);

    return PlaybackCtrl;
  }();

  angular.module('relatorios.videoLibrary.playback').controller('PlaybackCtrl', PlaybackCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.historicoSolicitacao', ['ui.router', 'ui.bootstrap.modal', 'restangular', 'urlConfigModule', 'alert-message', 'pascalprecht.translate', 'angularMoment', 'smart-table', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'v3gAuthenticatorModule', 'httpServiceV3gModule', 'FeatureFlagModule', 'FeatureOuModule', 'ModuleMeasurementUnitConverter']).constant('StatusSolicitacao', {
    AGUARDANDO: { id: 'AGUARDANDO', label: 'ce.analise.solicitacoesAgendadas.statusSolicitacao.aguardando', class: 'text-light-blue', ordem: 0 },
    FINALIZANDO: { id: 'FINALIZANDO', label: 'ce.analise.solicitacoesAgendadas.statusSolicitacao.finalizando', class: 'text-light-blue', ordem: 1 },
    PROCESSANDO: { id: 'PROCESSANDO', label: 'ce.analise.solicitacoesAgendadas.statusSolicitacao.processando', class: 'text-light-blue', ordem: 2 },
    CONCLUIDO: { id: 'CONCLUIDO', label: 'ce.analise.solicitacoesAgendadas.statusSolicitacao.concluido', class: 'text-green', ordem: 3 },
    CANCELADO: { id: 'CANCELADO', label: 'ce.analise.solicitacoesAgendadas.statusSolicitacao.cancelado', class: 'text-red', ordem: 4 }
  }).constant('TipoPermissao', {
    HISTORICO_DETALHADO_VISUALIZAR: 'HISTORICO_DETALHADO',
    HISTORICO_ALERTA_VISUALIZAR: 'HISTORICO_ALERTA',
    HISTORICO_CONSOLIDADO_VISUALIZAR: 'MOVIMENTO_VEICULO'
  }).factory('HistoricoSolicitacao', function (Restangular) {
    return Restangular.service('relatorios-agendado/historico-requisicoes');
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CancelarSolicitacaoCtrl = function () {
    function CancelarSolicitacaoCtrl(solicitacao, $uibModalInstance, Restangular) {
      _classCallCheck(this, CancelarSolicitacaoCtrl);

      this.modalInstance = $uibModalInstance;
      this.restangular = Restangular;

      this.solicitacao = solicitacao;
    }

    _createClass(CancelarSolicitacaoCtrl, [{
      key: 'ok',
      value: function ok() {
        var _this = this;

        this.restangular.all('/relatorios-agendado/historico-requisicoes/cancelar/' + this.solicitacao.id).post().then(function (cancelado) {
          _this.modalInstance.close(cancelado);
        }).catch(function (cancelado) {
          _this.modalInstance.close(cancelado);
        });
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return CancelarSolicitacaoCtrl;
  }();

  angular.module('relatorios.historicoSolicitacao').controller('CancelarSolicitacaoCtrl', CancelarSolicitacaoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global Intl */

  var ModalCadastrarSolicitacaoCtrl = function () {
    function ModalCadastrarSolicitacaoCtrl(Restangular, AlertMessage, ServiceVfiltro, RelatorioAgendadoService, $timeout, Authenticator, $translate, $httpParamSerializer, $scope, Keys, FeatureOuService) {
      _classCallCheck(this, ModalCadastrarSolicitacaoCtrl);

      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.serviceVfiltro = ServiceVfiltro;
      this.relatorioAgendadoService = RelatorioAgendadoService;
      this.timeout = $timeout;
      this.authenticator = Authenticator;
      this.translate = $translate;
      this.httpParamSerializer = $httpParamSerializer;
      this.scope = $scope;
      this.keys = Keys;
      this.featureOuService = FeatureOuService;

      this.filtro = null;
      this.exibirForm = true;
      this.isUoSemVeiculos = false;
      this.isNa = false;
    }

    _createClass(ModalCadastrarSolicitacaoCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          return _this.resolveIsNa(user.uo.id).then(function () {
            _this.opcoesRelatorios = Object.values(_this.relatorioAgendadoService.getTiposRelatoriosAgendaveis()).filter(function (opcao) {
              return user.permissoesSolucao.includes(opcao.permissao);
            });

            _this.somenteVisualizacao = _this.resolve.somenteVisualizacao;
            _this.filtroValues = _this.resolve.filtroValues;
            _this.tipoRelatorio = _this.opcoesRelatorios.length === 1 ? _this.opcoesRelatorios[0].tipo : _this.resolve.tipoRelatorio;

            if (_this.tipoRelatorio) {
              _this.relatorioSelecionado = _this.opcoesRelatorios.find(function (opcao) {
                return opcao.tipo === _this.tipoRelatorio;
              });
              _this.onRelatorioSelecionado();
            }
          });
        });
      }
    }, {
      key: 'resolveIsNa',
      value: function resolveIsNa(ouId) {
        var _this2 = this;

        return this.featureOuService.getEventsConfig(ouId).then(function (eventNAConfig) {
          _this2.isNa = !!eventNAConfig;
        }).catch(function () {
          _this2.isNa = false;
        });
      }
    }, {
      key: 'onRelatorioSelecionado',
      value: function onRelatorioSelecionado() {
        var _this3 = this;

        this.expandindo = true;
        this.relatorioSelecionado.getFiltros(this.somenteVisualizacao, this.filtroValues, this.isNa).then(function (filtro) {
          _this3.filtro = filtro;
          _this3.removeStatusVideoErro();
          _this3.bindChangeVeiculos();
        }).catch(function () {
          _this3.alertMessage.create({
            type: 'error',
            message: _this3.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.naoFoiPossivelCarregarFiltro'),
            appendTo: '.alerta-aqui-cadastro-solicitacao'
          });
        }).finally(function () {
          _this3.timeout(function () {
            return _this3.expandindo = false;
          }, 1000);
        });
      }
    }, {
      key: 'save',
      value: function save() {
        var _this4 = this;

        if (this.exibirForm) {
          this.exibirForm = false;
        } else {
          var payload = Object.assign({ type: this.relatorioSelecionado.tipo }, this.serviceVfiltro.getFiltroBackendNovo(this.filtro.getFiltroTopbar(), false)),
              zoneId = this.httpParamSerializer({ zoneId: new Intl.DateTimeFormat().resolvedOptions().timeZone });
          this.restangular.all('/relatorios-agendado/historico-requisicoes?' + zoneId).post(payload).then(function (response) {
            _this4.close({ $value: response.plain() });
          }).catch(function (error) {
            if (error && error.data && error.data.message === 'Nada para ser exportado') {
              _this4.alertMessage.create({
                type: 'error',
                message: _this4.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.naoExisteRegistroParaExportacao'),
                appendTo: '.alerta-aqui-cadastro-solicitacao'
              });
            } else {
              _this4.alertMessage.create({
                type: 'error',
                message: _this4.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.naoFoiPossivelConcluirSolicitacao'),
                appendTo: '.alerta-aqui-cadastro-solicitacao'
              });
            }
          });
        }
      }
    }, {
      key: 'cancelar',
      value: function cancelar() {
        if (!this.exibirForm) {
          this.exibirForm = true;
        } else {
          this.dismiss();
        }
      }
    }, {
      key: 'getTitle',
      value: function getTitle() {
        return this.somenteVisualizacao ? this.translate.instant('ce.analise.solicitacoesAgendadas.modal.titulo.dadosDaSolicitacao') : this.translate.instant('ce.analise.solicitacoesAgendadas.modal.titulo.novaSolicitacao');
      }
    }, {
      key: 'getLabelBtnCancelar',
      value: function getLabelBtnCancelar() {
        return this.exibirForm ? this.translate.instant('ce.analise.solicitacoesAgendadas.modal.botao.cancelar') : this.translate.instant('ce.analise.solicitacoesAgendadas.modal.botao.voltar');
      }
    }, {
      key: 'getLabelBtnSalvar',
      value: function getLabelBtnSalvar() {
        return this.exibirForm ? this.translate.instant('ce.analise.solicitacoesAgendadas.modal.botao.salvar') : this.translate.instant('ce.analise.solicitacoesAgendadas.modal.botao.simCriarSolicitacao');
      }

      // ERRO nao e um agrupador de status de video; a tela de eventos tambem remove essa opcao

    }, {
      key: 'removeStatusVideoErro',
      value: function removeStatusVideoErro() {
        var _this5 = this;

        var filtroStatusVideos = this.filtro.filtroCompleto.find(function (item) {
          return item.key === _this5.keys.statusVideos.name;
        });
        if (filtroStatusVideos) {
          filtroStatusVideos.defaultValues = filtroStatusVideos.defaultValues.filter(function (v) {
            return v.id !== 'ERRO';
          });
        }
      }
    }, {
      key: 'bindChangeVeiculos',
      value: function bindChangeVeiculos() {
        var _this6 = this;

        var filtroVeiculos = this.filtro.filtroCompleto.find(function (item) {
          return item.key === _this6.keys.veiculos.name;
        });
        if (!filtroVeiculos) {
          this.isUoSemVeiculos = false;
          return;
        }
        this.scope.$watch(function () {
          return _this6.getQuantidadeVeiculos(filtroVeiculos);
        }, function (newValue) {
          return _this6.verifyHasVeiculos(newValue);
        });
      }
    }, {
      key: 'getQuantidadeVeiculos',
      value: function getQuantidadeVeiculos(filtroVeiculos) {
        return filtroVeiculos.totalCount === null || angular.isUndefined(filtroVeiculos.totalCount) ? filtroVeiculos.defaultValues.length : filtroVeiculos.totalCount;
      }
    }, {
      key: 'verifyHasVeiculos',
      value: function verifyHasVeiculos(veiculosSize) {
        this.isUoSemVeiculos = veiculosSize === 0;
      }
    }, {
      key: 'isSaveInvalid',
      value: function isSaveInvalid() {
        return !this.filtro || this.loading || this.scope.formVfiltroModal.$invalid || this.isUoSemVeiculos;
      }
    }]);

    return ModalCadastrarSolicitacaoCtrl;
  }();

  angular.module('relatorios.historicoSolicitacao').component('modalCadastrarSolicitacao', {
    controller: ModalCadastrarSolicitacaoCtrl,
    templateUrl: 'relatorios/historico-solicitacao/cadastrar/cadastrar-solicitacao.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.bdv', ['ui.router', 'restangular', 'angularMoment', 'uoModule', 'v3gVeiculoModule', 'onboarding', 'ChecklistEnum', 'VtabelaModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'pascalprecht.translate', 'v3gAuthenticatorModule', 'cadastros.veiculo', 'urlConfigModule', 'mapas', 'ModuleEventos', 'vflashModule', 'alert-message', 'ConfigEventosModule']).factory('Bdv', function (Restangular) {
    var url = 'boletim/bv',
        fieldsChecklist = ['itemPreenchido.opcao', 'itemPreenchido.observacao', 'item.titulo', 'checklist.id', 'motorista.nome', 'veiculo.placa', 'veiculo.prefixo', 'dataPreenchimento'];

    var service = Restangular.service(url);

    service.getDetalhes = function (veiculoId, dia) {
      return Restangular.one(url + '/detalhes?veiculoId=' + veiculoId + '&dia=' + dia).get();
    };

    service.getChecklist = function (veiculoId, inicio, fim) {
      return Restangular.one('/veiculo/checklist/preenchimentos?preenchimentoInicio=' + inicio + '&preenchimentoFim=' + fim + '&veiculoId=' + veiculoId + '&fields=' + fieldsChecklist.toString()).get();
    };

    return service;
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, L */

  var BdvDetalhesCtrl = function () {
    function BdvDetalhesCtrl($window, $stateParams, Bdv, MapasUtil, $filter, $scope, $compile, leafletData, Eventos, VFlash, $location, SpiderfierService, MarkerService, moment, Onboarding, MockBDVDetalhes, IDBDVDetalhes, ServiceVfiltro, FactoryVfiltro, $translate, Authenticator, MeasurementUnitConverterService, ConvertersService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, BdvDetalhesCtrl);

      this.window = $window;
      this.stateParams = $stateParams;
      this.bdvService = Bdv;
      this.convertersService = ConvertersService;
      this.mapasUtilService = MapasUtil;
      this.spiderfierService = SpiderfierService;
      this.markerService = MarkerService;
      this.location = $location;
      this.onboarding = Onboarding;
      this.mockBDVDetalhes = MockBDVDetalhes;
      this.idConfluence = IDBDVDetalhes;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.filter = $filter;
      this.scope = $scope;
      this.compile = $compile;
      this.moment = moment;
      this.todasConducoes = false;
      this.veiculo = null;
      this.inicio = null;
      this.duracaoTotal = 0;
      this.duracao = null;
      this.consumoCombustivelTotal = 0;
      this.consumoCombustivel = 0;
      this.consumoEletricoTotal = 0;
      this.consumoEletrico = 0;
      this.distancia = 0;
      this.motoristas = [];
      this.detalhes = [];
      this.conducaoSelecionada = null;
      this.leafletData = leafletData;
      this.eventos = Eventos;
      this.flash = VFlash;
      this.tooltipMotoristas = false;
      this.logradouroInicio = null;
      this.logradouroFim = null;

      this.tiles = MapasUtil.tiles.veltec;
      this.defaults = MapasUtil.defaults;
      this.geoJson = {};
      this.mapCenter = MapasUtil.getCenter();
      this.markersGroup = new L.FeatureGroup();
      this.pathGroup = new L.FeatureGroup();
      this.eventoSelecionado = '';

      this.onClickTipoEvento = this.filtraEvento();
      this.onClickPosicao = this.destacarMarcador();
      this.markersPorPosicao = new Map();
      this.eventoDescida = this.translate.instant(this.eventos.DESCIDA.tipo);
      this.eventoDescidaFaixa1 = this.translate.instant(this.eventos.DESCIDA_FAIXA1.tipo);
      this.eventoDescidaFaixa2 = this.translate.instant(this.eventos.DESCIDA_FAIXA2.tipo);
      this.eventoDescidaFaixa3 = this.translate.instant(this.eventos.DESCIDA_FAIXA3.tipo);
      this.faixasDescida = {
        segundosFaixa1: 5,
        segundosFaixa2: 30
      };

      this.setMapEvents();
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.roleVigenciaEditar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIGENCIA_EDITAR');
        _this.updateFiltrosLocalStorage();
        _this.loadServerData();
      }).catch(function () {
        _this.leafletData.unresolveMap('bdv-map');
      });

      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator.getUser().then(function (user) {
        _this.measurementUnits = user.measurementUnits;
        _this.fuelUnit = _this.measurementUnitConverterService.getFuelUnit(_this.measurementUnits.fuelMeasurement);
        _this.distanceUnit = _this.measurementUnitConverterService.getDistanceUnit(_this.measurementUnits.distanceMeasurement);
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateFormat(_this.measurementUnits.dateTimeFormat);
        _this.fuelEfficiency = _this.measurementUnitConverterService.getFuelEfficiencyUnit(_this.measurementUnits.fuelMeasurement);
        _this.energyEfficiency = _this.measurementUnitConverterService.getEnergyEfficiencyUnit(_this.measurementUnits.fuelMeasurement);
      });
      this.invalidGpsFilterEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_INVALID_GPS_MAPS);
      this.INVALID_GPS = 'Inválido';
    }

    _createClass(BdvDetalhesCtrl, [{
      key: 'updateFiltrosLocalStorage',
      value: function updateFiltrosLocalStorage() {
        var filtroLocalstorage = angular.fromJson(this.window.localStorage.getItem('vfiltro-' + this.serviceVfiltro.factoryVfiltro.user.id)) || {};
        filtroLocalstorage.dateTime = [this.moment(this.stateParams.dia, 'YYYY-MM-DD').startOf('day').format('YYYY.MM.DD.HH.mm.ss.ZZ'), this.moment(this.stateParams.dia, 'YYYY-MM-DD').endOf('day').format('YYYY.MM.DD.HH.mm.ss.ZZ')];
        filtroLocalstorage.veiculo = this.stateParams.veiculoId;
        this.window.localStorage.setItem('vfiltro-' + this.serviceVfiltro.factoryVfiltro.user.id, angular.toJson(filtroLocalstorage));
      }
    }, {
      key: 'filtraEvento',
      value: function filtraEvento() {
        var _this2 = this;

        return function (index) {
          _this2.eventoSelecionado = index;
          if (_this2.detalhes.length === 0) {
            _this2.flash.filterWarn();
          } else if (_this2.todasConducoes) {
            _this2.selecionarTodasConducoes();
          } else {
            _this2.limparVariaveisLayers();
            _this2.popularDadosDaConducao(_this2.conducaoSelecionada);
            _this2.inserirConducaoNoMapa(_this2.conducaoSelecionada);
          }
        };
      }
    }, {
      key: 'destacarMarcador',
      value: function destacarMarcador() {
        var _this3 = this;

        return function (posicao, centralizarFim) {
          return _this3.leafletData.getMap('bdv-map').then(function (map) {
            if (posicao.miscInfo && posicao.miscInfo.diferencaAltitude !== -1) {
              _this3.diferencaAltitude = posicao.miscInfo.diferencaAltitude;
            }
            var marker = _this3.markersPorPosicao.get(posicao);
            if (centralizarFim && angular.isDefined(posicao.fim)) {
              var markerFim = _this3.markersPorPosicao.get(posicao.fim);
              map.fitBounds([marker.getLatLng(), markerFim.getLatLng()]);
            } else {
              map.panTo(marker.getLatLng());
            }
            marker.openPopup(marker.getLatLng());
          });
        };
      }
    }, {
      key: 'loadServerData',
      value: function loadServerData() {
        var _this4 = this;

        this.isDemo = this.onboarding.startOnboarding(this.idConfluence);

        if (angular.isUndefined(this.stateParams.dia) || angular.isUndefined(this.stateParams.veiculoId)) {
          return;
        }

        if (this.isDemo) {
          var retorno = angular.copy(this.mockBDVDetalhes);
          retorno.data = retorno.data.map(function (x) {
            if (_this4.stateParams.veiculoId === 1) {
              x.veiculo = 'VW81502 - AOI7238';
            } else if (_this4.stateParams.veiculoId === 2) {
              x.veiculo = 'FSADF45 - VXZ9045';
            } else if (_this4.stateParams.veiculoId === 3) {
              x.veiculo = 'VCBZ45 - UKT3556';
            } else {
              x.veiculo = 'ANGA01 - ANR1131';
            }

            x.motoristas = _this4.location.search().motorista;

            return x;
          });
          this.setInfo(retorno);
        } else {
          this.bdvService.getDetalhes(this.stateParams.veiculoId, this.stateParams.dia).then(function (data) {
            return _this4.setInfo(data);
          });
        }
      }
    }, {
      key: 'onMapControlInit',
      value: function onMapControlInit() {
        var _this5 = this;

        this.leafletData.getMap('bdv-map').then(function (map) {
          _this5.scope.$broadcast('initPontoReferencia', map);
        });
      }
    }, {
      key: 'setInfo',
      value: function setInfo(data) {
        var _this6 = this;

        this.detalhes = data.data.map(function (c) {
          // Icone parado 1 esta sobrecarregando. Removido até proximo sprint.
          c.posicoes.forEach(function (p) {
            if (p.evento === _this6.translate.instant(_this6.eventos.PARADO.tipo) && p.duracao <= 300) {
              p.evento = _this6.translate.instant('ce.enum.eventos.movimento');
            }
            if (p.evento === _this6.translate.instant('ce.enum.eventos.pontoDeReferencia')) {
              p.evento = _this6.translate.instant('ce.enum.eventos.movimento');
            }
          });
          _this6.faixasDescida = c.faixasDescida;
          c.posicoes = _this6.mapasUtilService.ajustarEventos(c.posicoes, c.faixasDescida);
          _this6.mapasUtilService.marcarPosicoesInvalidasNoInicio(c.posicoes);

          if (c.fim) {
            _this6.duracaoTotal += _this6.moment(c.fim, 'YYYY/MM/DD HH:mm:ssZ').diff(_this6.moment(c.inicio, 'YYYY/MM/DD HH:mm:ssZ'), 'seconds');
          }
          _this6.consumoCombustivelTotal += c.consumoCombustivelParado + c.consumoCombustivelMovimento + c.consumoCombustivelGpsInvalido;
          _this6.consumoEletricoTotal += c.consumoEletricoParado + c.consumoEletricoMovimento + c.consumoEletricoGpsInvalido;

          return c;
        });

        if (this.detalhes.length === 0) {
          this.flash.filterWarn();
        } else {
          this.inicio = this.detalhes[0].inicio;
          this.selecionarTodasConducoes();
          this.detalhes = this.convertMeasurements(this.detalhes);
        }
      }
    }, {
      key: 'selecionarTodasConducoes',
      value: function selecionarTodasConducoes() {
        var _this7 = this;

        this.limparVariaveisLayers();
        this.resumoPeriodo = this.detalhes;
        this.tempoPorFaixaRpm = {
          rpmMarchaLentaTempo: 0,
          rpmAbaixoVerdeTempo: 0,
          rpmVerdeEconomicaTempo: 0,
          rpmVerdePotenciaTempo: 0,
          rpmAmareloTempo: 0,
          rpmVermelhoTempo: 0
        };

        this.detalhes.forEach(function (element) {
          _this7.veiculo = element.veiculo;
          _this7.distancia += element.distanciaPercorrida;

          var nomesMotoristas = _this7.getNomesMotoristas(element);
          _this7.motoristas.push(nomesMotoristas);
          element.nomesMotoristas = nomesMotoristas;
          element.vigenciaManual = element.vigencias && element.vigencias.some(function (v) {
            return v.origem === 'MANUAL';
          });

          var posicoes = _.sortBy(_this7.mapasUtilService.flatPosicoes(element.posicoes), 'data'),
              posicoesValidas = posicoes.filter(function (p) {
            return p.valida && p.latitude !== 0 && p.longitude !== 0;
          });

          _this7.tempoPorFaixaRpm.rpmMarchaLentaTempo += element.rpmMarchaLentaTempo || 0;
          _this7.tempoPorFaixaRpm.rpmAbaixoVerdeTempo += element.rpmAbaixoVerdeTempo || 0;
          _this7.tempoPorFaixaRpm.rpmVerdeEconomicaTempo += element.rpmVerdeEconomicaTempo || 0;
          _this7.tempoPorFaixaRpm.rpmVerdePotenciaTempo += element.rpmVerdePotenciaTempo || 0;
          _this7.tempoPorFaixaRpm.rpmAmareloTempo += element.rpmAmareloTempo || 0;
          _this7.tempoPorFaixaRpm.rpmVermelhoTempo += element.rpmVermelhoTempo || 0;

          _this7.setPath(posicoesValidas);
          _this7.setPathEventos(posicoesValidas, _this7.eventoSelecionado);
        });

        this.todasConducoes = true;
        this.logradouroInicio = '';
        this.logradouroFim = '';
        this.duracao = this.duracaoTotal;
        this.consumoCombustivel = this.consumoCombustivelTotal;
        this.consumoEletrico = this.consumoEletricoTotal;
        if (this.consumoCombustivelTotal > 0) {
          this.mediaConsumo = this.distancia / this.consumoCombustivelTotal;
        } else {
          this.mediaConsumo = undefined;
        }
        if (this.consumoEletricoTotal > 0) {
          this.mediaConsumoEletrico = this.distancia / this.consumoEletricoTotal;
        } else {
          this.mediaConsumoEletrico = undefined;
        }
        this.insertMarkers(this.detalhes.map(function (d) {
          return _this7.mapasUtilService.posicoesFiltradas(d.posicoes);
        }));
      }
    }, {
      key: 'convertMeasurements',
      value: function convertMeasurements(data) {
        var _this8 = this;

        if (this.measurementUnits.fuelMeasurement !== 'LITERS') {
          this.mediaConsumo = this.mediaConsumo * 2.352;
          this.consumoCombustivel = this.consumoCombustivel * 0.264172;
        }
        if (this.measurementUnits.distanceMeasurement !== 'KM') {
          this.convertersService.handleKmToMiles(data);
        }

        return data.map(function (record) {
          var recordCopy = Object.assign({}, record);

          var conversionFactors = {
            distanciaPercorrida: _this8.convertersService.handleKmToMiles(),
            consumoCombustivel: 0.264172,
            mediaConsumo: 2.352,
            distanciaPercorridaConvertida: _this8.convertersService.handleKmToMiles(),
            mediaConsumoEletrico: 0.621371
          };

          for (var field in conversionFactors) {
            if (field in recordCopy) {
              var isDistanceField = ['distanciaPercorrida', 'distanciaPercorridaConvertida', 'mediaConsumoEletrico'].includes(field),
                  isFuelField = ['consumoCombustivel', 'mediaConsumo'].includes(field);
              if (isDistanceField && _this8.measurementUnits.distanceMeasurement !== 'KM' || isFuelField && _this8.measurementUnits.fuelMeasurement !== 'LITERS') {
                recordCopy[field] *= conversionFactors[field];
              }
            }
          }
          return recordCopy;
        });
      }
    }, {
      key: 'limparVariaveisLayers',
      value: function limparVariaveisLayers() {
        this.pathGroup.clearLayers();
        this.markersGroup.clearLayers();
        this.duracao = null;
        this.consumoCombustivel = 0;
        this.consumoEletrico = 0;
        this.motoristas = [];
        this.distancia = 0;
        this.diferencaAltitude = null;
        this.markersPorPosicao.clear();
      }
    }, {
      key: 'selecionarConducao',
      value: function selecionarConducao(conducao) {
        this.limparVariaveisLayers();
        this.resumoPeriodo = [conducao];
        this.popularDadosDaConducao(conducao);
        this.inserirConducaoNoMapa(conducao);
      }
    }, {
      key: 'popularDadosDaConducao',
      value: function popularDadosDaConducao(conducao) {
        this.conducaoSelecionada = conducao;
        this.logradouroInicio = this.conducaoSelecionada.logradouroInicio;
        this.logradouroFim = this.conducaoSelecionada.logradouroFim;
        this.todasConducoes = false;
        this.motoristas.push(this.getNomesMotoristas(conducao));
        this.veiculo = conducao.veiculo;
        this.distancia += conducao.distanciaPercorrida;
        this.consumoCombustivel = conducao.consumoCombustivelParado + conducao.consumoCombustivelMovimento + conducao.consumoCombustivelGpsInvalido;
        this.mediaConsumo = conducao.mediaConsumo;
        this.consumoEletrico = conducao.consumoEletricoParado + conducao.consumoEletricoMovimento + conducao.consumoEletricoGpsInvalido;
        this.mediaConsumoEletrico = conducao.mediaConsumoEletrico;
        this.tempoPorFaixaRpm = {
          rpmMarchaLentaTempo: conducao.rpmMarchaLentaTempo || 0,
          rpmAbaixoVerdeTempo: conducao.rpmAbaixoVerdeTempo || 0,
          rpmVerdeEconomicaTempo: conducao.rpmVerdeEconomicaTempo || 0,
          rpmVerdePotenciaTempo: conducao.rpmVerdePotenciaTempo || 0,
          rpmAmareloTempo: conducao.rpmAmareloTempo || 0,
          rpmVermelhoTempo: conducao.rpmVermelhoTempo || 0
        };
        this.duracao = conducao.fim ? this.moment(conducao.fim, 'YYYY/MM/DD HH:mm:ssZ').diff(this.moment(conducao.inicio, 'YYYY/MM/DD HH:mm:ssZ'), 'seconds') : null;
      }
    }, {
      key: 'inserirConducaoNoMapa',
      value: function inserirConducaoNoMapa(conducao) {
        var _this9 = this;

        var posicoes = _.sortBy(this.mapasUtilService.flatPosicoes(conducao.posicoes), 'data').filter(function (p) {
          return _this9.isValidPosition(p);
        });
        this.setPath(posicoes);
        this.setPathEventos(posicoes, this.eventoSelecionado);
        this.insertMarkers([this.mapasUtilService.posicoesFiltradas(conducao.posicoes)]);
      }
    }, {
      key: 'setMapEvents',
      value: function setMapEvents() {
        angular.extend(this.scope, {
          events: {
            map: {
              enable: ['click'],
              logic: 'emit'
            },
            markers: {
              enable: ['click'],
              logic: 'emit'
            }
          }
        });
      }
    }, {
      key: 'insertMarkers',
      value: function insertMarkers(trechos) {
        var _this10 = this;

        this.leafletData.getMap('bdv-map').then(function (map) {
          var oms = _this10.spiderfierService.createSpiderfier(map),
              posicoes = _this10.addPosicaoDescidaFimDescidas(trechos);
          _this10.markersGroup.clearLayers();

          _this10.markersPorPosicao = _this10.markerService.buildMarkersAssociadosAsPosicoes(posicoes, _this10.eventoSelecionado, 'bdv-');

          _this10.markersPorPosicao.forEach(function (marker) {
            marker.setPopupContent(_this10.compile('<div>' + marker.getPopup().getContent() + '</div>')(_this10.scope)[0]);
            _this10.markersGroup.addLayer(marker);
            if (!_this10.eventos.isLocalizacao(marker.options.evento)) {
              oms.addMarker(marker);
            }
          });

          if (!map.hasLayer(_this10.markersGroup)) {
            map.addLayer(_this10.markersGroup);
          }
          if (_this10.markersGroup.getLayers().length > 0) {
            map.fitBounds(_this10.markersGroup.getBounds(), { padding: [100, 100] });
          }
        });
      }
    }, {
      key: 'addPosicaoDescidaFimDescidas',
      value: function addPosicaoDescidaFimDescidas(trechos) {
        var _this11 = this;

        return _.flatten(trechos).reduce(function (acc, posicao) {
          acc.push(posicao);
          if (posicao.evento && posicao.evento.includes(_this11.eventoDescida) && angular.isDefined(posicao.fim)) {
            switch (posicao.evento) {
              case _this11.eventoDescidaFaixa1:
                posicao.fim.evento = _this11.translate.instant(_this11.eventos.DESCIDA_FAIXA1_FIM.tipo);
                break;
              case _this11.eventoDescidaFaixa2:
                posicao.fim.evento = _this11.translate.instant(_this11.eventos.DESCIDA_FAIXA2_FIM.tipo);
                break;
              default:
                posicao.fim.evento = _this11.translate.instant(_this11.eventos.DESCIDA_FAIXA3_FIM.tipo);
                break;
            }
            posicao.fim.temCoordenada = true;
            posicao.fim.descricao = _this11.translate.instant(_this11.eventos.DESCIDA_FAIXA1_FIM.descricao);
            acc.push(posicao.fim);
          }
          return acc;
        }, []);
      }
    }, {
      key: 'setPath',
      value: function setPath(posicoes) {
        var _this12 = this;

        this.leafletData.getMap('bdv-map').then(function (map) {
          var routeLines = L.polyline(posicoes.map(function (p) {
            return [p.latitude, p.longitude];
          }), {
            color: '#3388FF',
            opacity: 0.75,
            weight: 3
          });
          L.polylineDecorator(routeLines, {
            patterns: [{
              offset: 0,
              repeat: 300,
              symbol: L.Symbol.arrowHead({
                pixelSize: 12,
                pathOptions: { fillOpacity: 0.75, color: '#0033FF', weight: 0 }
              })
            }]
          }).addTo(_this12.pathGroup);
          _this12.pathGroup.addLayer(routeLines);

          if (!map.hasLayer(_this12.pathGroup)) {
            map.addLayer(_this12.pathGroup);
          }
        });
      }
    }, {
      key: 'setPathEventos',
      value: function setPathEventos(posicoes, e) {
        var _this13 = this;

        this.leafletData.getMap('bdv-map').then(function (map) {
          posicoes.filter(function (p) {
            return _this13.isEvento(p, e);
          }).map(function (p) {
            var coord = [[p.latitude, p.longitude]],
                routeEventsLines = null;
            if (angular.isDefined(p.fim)) {
              coord = coord.concat(_this13.getPosicoesDentroDoPeriodoDoEvento(p, posicoes));
              coord.push([p.fim.latitude, p.fim.longitude]);
            }
            routeEventsLines = L.polyline(coord, {
              color: 'red',
              weight: 3
            });
            _this13.pathGroup.addLayer(routeEventsLines);
          });

          if (!map.hasLayer(_this13.pathGroup)) {
            map.addLayer(_this13.pathGroup);
          }
        });
      }
    }, {
      key: 'getPosicoesDentroDoPeriodoDoEvento',
      value: function getPosicoesDentroDoPeriodoDoEvento(posicao, posicoes) {
        var _this14 = this;

        return posicoes.filter(function (p) {
          return _this14.isDentroDoPeriodo(p, posicao);
        }).map(function (p) {
          return [p.latitude, p.longitude];
        });
      }
    }, {
      key: 'isDentroDoPeriodo',
      value: function isDentroDoPeriodo(posicao, posicaoPeriodo) {
        return new Date(posicaoPeriodo.data) < new Date(posicao.data) && new Date(posicaoPeriodo.fim.data) > new Date(posicao.data);
      }
    }, {
      key: 'isEvento',
      value: function isEvento(p, e) {
        if (e === this.translate.instant(this.eventos.EXCESSO_VELOCIDADE.tipo)) {
          return this.eventos.isExcessoVelocidade(p.evento);
        } else if (e === this.translate.instant(this.eventos.CURVA_BRUSCA.tipo)) {
          return this.eventos.isCurvaBrusca(p.evento);
        }
        return e === '' || p.evento === e;
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }, {
      key: 'getNomesMotoristas',
      value: function getNomesMotoristas(conducao) {
        var _this15 = this;

        if (conducao.vigencias && conducao.vigencias.length > 0) {
          var todasAsPosicoesTemVigencia = conducao.posicoes.every(function (posicao) {
            return conducao.vigencias.some(function (v) {
              return _this15.moment(posicao.data).isBetween(v.inicio, v.fim);
            });
          });
          var nomesMotoristas = conducao.vigencias.map(function (vigencia) {
            return vigencia.motoristaNome;
          });
          return todasAsPosicoesTemVigencia ? nomesMotoristas.join(', ') : [].concat(_toConsumableArray(nomesMotoristas), [this.translate.instant('ce.common.motorista.semIdentificacao')]).join(', ');
        }
        return this.translate.instant('ce.common.motorista.semIdentificacao');
      }
    }, {
      key: 'configurarCadastroConducao',
      value: function configurarCadastroConducao() {
        var btnAdicionarConducao = angular.element('vfwc-btn-adicionar-conducao')[0];
        if (btnAdicionarConducao) {
          btnAdicionarConducao.veiculoId = Number(this.stateParams.veiculoId);
          btnAdicionarConducao.dia = this.stateParams.dia;
        }
      }
    }, {
      key: 'isValidPosition',
      value: function isValidPosition(position) {
        return !this.invalidGpsFilterEnabled || position.gps !== this.INVALID_GPS && position.latitude !== 0 && position.longitude !== 0;
      }
    }]);

    return BdvDetalhesCtrl;
  }();

  angular.module('relatorios.bdv').controller('BdvDetalhesCtrl', BdvDetalhesCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BdvChecklistCtrl = function () {
    function BdvChecklistCtrl($stateParams, Bdv, AlertMessage, ChecklistEnum, moment, ServiceVfiltro, FactoryVfiltro, $translate) {
      var _this = this;

      _classCallCheck(this, BdvChecklistCtrl);

      this.stateParams = $stateParams;
      this.bdvService = Bdv;
      this.alertMessage = AlertMessage;
      this.checklistEnum = ChecklistEnum;
      this.moment = moment;
      this.translate = $translate;

      this.data = [];
      this.veiculo = {};
      this.itemSelected = {};
      this.itemSelectedCopy = {};

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.init();
      });
    }

    _createClass(BdvChecklistCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        if (!this.stateParams.veiculoId || !this.stateParams.dia) {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.boletim.diarioVeiculoChecklist.errorMessage'),
            appendTo: '.alerta-aqui'
          });
        } else {
          var dia = this.moment(this.stateParams.dia, 'YYYY-MM-DD');
          this.bdvService.getChecklist(this.stateParams.veiculoId, dia.startOf('day').format(), dia.endOf('day').format()).then(function (data) {
            return _this2.setInfo(data);
          });
        }
      }
    }, {
      key: 'setInfo',
      value: function setInfo(data) {
        this.data = data.content;
        var item = this.data[0];
        this.veiculo = item && item.veiculo || { placa: '', prefixo: '' };
        this.changeTab(item || { itens: [] });
      }
    }, {
      key: 'changeTab',
      value: function changeTab(item) {
        this.itemSelected = item;
        this.itemSelectedCopy = this.itemSelected.itens;
      }
    }, {
      key: 'isSelected',
      value: function isSelected(item) {
        return this.itemSelected.id === item.id;
      }
    }, {
      key: 'getCount',
      value: function getCount(tipo) {
        return this.itemSelected.itens && this.itemSelected.itens.reduce(function (acc, atual) {
          return atual.opcao === tipo ? acc + 1 : acc;
        }, 0);
      }
    }]);

    return BdvChecklistCtrl;
  }();

  angular.module('relatorios.bdv').controller('BdvChecklistCtrl', BdvChecklistCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('quadroOcorrencias', ['ui.router', 'ocorrencia.component', 'httpServiceV3gModule', 'angularMoment', 'enumModule', 'ConstantVfiltroModule', 'v3gAuthenticatorModule', 'ui.bootstrap.modal', 'ServiceVfiltroModule', 'alert-message', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'pascalprecht.translate', 'modalInfoConfirmModule', 'AlertasModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var HistItemCtrl = function () {
    function HistItemCtrl(OcorrenciasEnum, $filter, $translate, HttpServiceV3g, AlertMessage, Authenticator, MeasurementUnitConverterService) {
      _classCallCheck(this, HistItemCtrl);

      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.ocorrenciasEnum = OcorrenciasEnum;
      this.filter = $filter;
      this.teste = null;
      this.translate = $translate;
      this.statusI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.status') + ' </strong>';
      this.responsavelI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.responsavel') + ' </strong>';
      this.observacaoI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.observacao') + ' </strong>';
      this.anexoI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.anexo') + ' </strong>';
      this.asI18N = this.translate.instant('ce.tempoReal.quadroDeOcorrencias.common.as');
      this.usuarioAtribuidoNenhumI18N = this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.usuarioAtribuidoNenhum');
      this.httpService = HttpServiceV3g;
      this.alertMessage = AlertMessage;
      this.mapUuidUrl = new Map();
    }

    _createClass(HistItemCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        if (this.item.statusAnterior) {
          this.statusAnterior = this.ocorrenciasEnum.getStatusById(this.item.statusAnterior).descricao;
          this.statusNovo = this.ocorrenciasEnum.getStatusById(this.item.statusNovo).descricao;
        }
        var isComentarioKey = this.isTranslationKey(this.item.comentario),
            isUsarioKey = this.isTranslationKey(this.item.usuario.login);

        this.comentario = isComentarioKey ? this.translate.instant(this.item.comentario) : this.item.comentario;
        this.usuario = isUsarioKey ? this.translate.instant(this.item.usuario.login) : this.item.usuario.login;
        this.dateFormat = 'dd/MM/yyyy';
        this.dataHora = this.filter('date')(this.item.dataHora, this.dateFormat) + ' ' + this.asI18N + ' ' + this.filter('date')(this.item.dataHora, 'HH:mm');
        this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.userPreferredDateFormat = user.measurementUnits && user.measurementUnits.dateTimeFormat || 'BRITISH';
          _this.dateFormat = _this.measurementUnitConverterService.getDateFormat(_this.userPreferredDateFormat);
          _this.updateDataHora();
        });

        if (this.item.usuarioAtribuidoAnterior || this.item.usuarioAtribuidoNovo) {
          var isUsuarioAtribuidoAnteriorKey = this.item.usuarioAtribuidoAnterior ? this.isTranslationKey(this.item.usuarioAtribuidoAnterior.login) : false;
          this.resNovo = this.item.usuarioAtribuidoNovo ? this.item.usuarioAtribuidoNovo.login : this.usuarioAtribuidoNenhumI18N;
          this.resAnterior = this.item.usuarioAtribuidoAnterior ? this.getUsuarioAtribuidoAnteriorLogin(isUsuarioAtribuidoAnteriorKey) : this.usuarioAtribuidoNenhumI18N;
        }
      }
    }, {
      key: 'updateDataHora',
      value: function updateDataHora() {
        this.dataHora = this.filter('date')(this.item.dataHora, this.dateFormat) + ' ' + this.asI18N + ' ' + this.filter('date')(this.item.dataHora, 'HH:mm');
      }
    }, {
      key: 'getUsuarioAtribuidoAnteriorLogin',
      value: function getUsuarioAtribuidoAnteriorLogin(isKey) {
        return isKey ? this.translate.instant(this.item.usuarioAtribuidoAnterior.login) : this.item.usuarioAtribuidoAnterior.login;
      }
    }, {
      key: 'isTranslationKey',
      value: function isTranslationKey(key) {
        return this.translate.instant(key) !== key;
      }
    }, {
      key: 'downloadAnexo',
      value: function downloadAnexo(uuid, nome) {
        var _this2 = this;

        var url = this.mapUuidUrl.get(uuid);
        if (angular.isDefined(url)) {
          this.createAnchorElementAndClick(url, nome);
        } else {
          this.httpService.get('/anexo/anexos/' + uuid + '/download?entidadeId=' + this.veiculoId).then(function (fileDownloadUrl) {
            if (fileDownloadUrl && fileDownloadUrl.data.url) {
              var urlDownload = fileDownloadUrl.data.url;
              _this2.mapUuidUrl.set(uuid, urlDownload);
              _this2.createAnchorElementAndClick(urlDownload, nome);
            }
          }).catch(function () {
            _this2.alertMessage.create({
              type: 'error',
              message: _this2.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.erroUrlAnexo'),
              appendTo: '.alerta-aqui-anexo'
            });
          });
        }
      }
    }, {
      key: 'createAnchorElementAndClick',
      value: function createAnchorElementAndClick(url, nome) {
        var anchor = angular.element('<a/>');
        anchor.attr({
          href: url,
          download: nome
        })[0].click();
      }
    }]);

    return HistItemCtrl;
  }();

  angular.module('quadroOcorrencias').component('histItem', {
    controller: HistItemCtrl,
    templateUrl: 'quadro-ocorrencias/ocorrencia-modal/hist-item/hist-item.tpl.html',
    bindings: {
      item: '=',
      veiculoId: '='
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('ProntuarioModule', ['VImageCrop', 'ui.bootstrap.modal', 'restangular', 'AlertasModule', 'angularMoment', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'FeatureFlagModule', 'v3gAuthenticatorModule', 'enumModule', 'middlewareModule', 'pascalprecht.translate', 'ConstantModule', 'urlConfigModule', 'alert-message']).factory('Prontuario', function (Restangular) {
    return Restangular.service('boletim/ranking/pontuacao-motoristas/mensal');
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FormData */

  var UploadProntuarioCtrl = function () {
    function UploadProntuarioCtrl($uibModalInstance, $scope, AlertMessage, Restangular, moment, FactoryVfiltro, Keys, motoristaId, arquivo, user, $translate) {
      var _this = this;

      _classCallCheck(this, UploadProntuarioCtrl);

      this.modalInstance = $uibModalInstance;
      this.scope = $scope;
      this.alertMessage = AlertMessage;
      this.restangular = Restangular;
      this.moment = moment;
      this.keys = Keys;
      this.translate = $translate;

      this.motoristaId = motoristaId;
      this.arquivo = arquivo;
      this.user = user;
      this.model = {};
      this.infracao = null;
      this.anexo = null;
      this.TAMANHO_MAX_UPLOAD = 5000000;
      this.TIPOS_EXTENSAO_FILE = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'rar', 'zip'];

      FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name,
        disabled: true,
        id: 'filtro-modal-uo',
        size: 12
      }, {
        name: 'uoDonaId',
        key: this.keys.uoParceira.name,
        disabled: true,
        id: 'filtro-modal-uo-parceira',
        size: 6
      }, {
        name: 'idEntidade',
        required: true,
        key: this.keys.veiculo.name,
        ignoreValidation: true,
        id: 'filtro-modal-veiculo',
        size: 6
      }], false, {
        uoId: this.user.uo.id,
        idEntidade: this.arquivo && this.arquivo.infracao ? this.arquivo.infracao.veiculoId : null
      }).then(function (e) {
        _this.filtro = e.filtroCompleto.filter(function (x) {
          return x.key === _this.keys.veiculo.name;
        });
        _this.init();
      }).catch(function () {
        _this.alertMessage.create({
          type: 'error',
          message: _this.translate.instant('ce.ranking.motoristas.prontuario.modal.upload.naofoiPossivelCarregarFiltro'),
          appendTo: '.alerta-aqui'
        });
      });
    }

    _createClass(UploadProntuarioCtrl, [{
      key: 'init',
      value: function init() {
        this.infracao = this.arquivo && this.arquivo.infracao;
        this.anexo = this.arquivo && this.arquivo.anexo;
        this.model = this.buildModelInfracoes();
      }
    }, {
      key: 'buildModelInfracoes',
      value: function buildModelInfracoes() {
        var editar = !!this.infracao;
        return {
          file: null,
          tipo: editar ? this.anexo.tipo : 'INFRACAO',
          descricao: editar ? this.anexo.descricao : null,
          data: editar ? this.moment(this.infracao.dataHoraInfracao).format('DD-MM-YYYY') : null,
          hora: editar ? this.moment(this.infracao.dataHoraInfracao).format('HH:mm') : null,
          multa: editar ? this.infracao.valorMulta : null,
          pontos: editar ? this.infracao.pontosCnh : null
        };
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this2 = this;

        this.restangular.all(this.getURLPost()).withHttpConfig({ transformRequest: angular.identity }).customPOST(this.getModelInfracoes(), undefined, undefined, { 'Content-Type': undefined }).then(function () {
          _this2.modalInstance.close();
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.ranking.motoristas.prontuario.modal.erroSalvar'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'getURLPost',
      value: function getURLPost() {
        return '/motorista/motoristas/' + this.motoristaId + '/infracoes-transito' + ('' + (!this.infracao ? '' : '/' + this.infracao.id + '/update'));
      }
    }, {
      key: 'getModelInfracoes',
      value: function getModelInfracoes() {
        var _this3 = this;

        var date = this.moment(this.model.data, 'DD-MM-YYYY').format('YYYY-MM-DD'),
            formData = new FormData();
        if (this.model.file) {
          formData.append('file', this.model.file[0]);
        }
        formData.append('content', angular.toJson({
          motoristaId: this.motoristaId,
          veiculoId: this.filtro.find(function (x) {
            return x.key === _this3.keys.veiculo.name;
          }).value.id,
          pontosCnh: this.model.pontos,
          dataHoraInfracao: this.moment(date + ' ' + this.model.hora + ':00').format(),
          valorMulta: this.model.multa,
          anexoDocumento: {
            uoId: this.user.uo.id,
            motoristaId: this.motoristaId,
            descricao: this.model.descricao,
            tipo: this.model.tipo
          }
        }));
        return formData;
      }
    }, {
      key: 'setUploadFile',
      value: function setUploadFile(element) {
        var _this4 = this;

        this.scope.$apply(function () {
          if (element.files && element.files.length > 0) {
            _this4.model.file = null;
            if (element.files[0].size > _this4.TAMANHO_MAX_UPLOAD) {
              _this4.alertMessage.create({
                type: 'error',
                message: _this4.translate.instant('ce.ranking.motoristas.prontuario.modal.upload.arquivoExcedeuLimite'),
                appendTo: '.alert-file'
              });
              angular.element('#upload').val('');
            } else if (_this4.isInvalidFile(element.files[0].name.split('.').slice(-1)[0])) {
              _this4.alertMessage.create({
                type: 'error',
                message: _this4.translate.instant('ce.ranking.motoristas.prontuario.modal.upload.extensaoInvalida'),
                appendTo: '.alert-file'
              });
              angular.element('#upload').val('');
            } else {
              _this4.model.file = element.files;
              _this4.scope.formUpload.$setDirty();
            }
          }
        });
      }
    }, {
      key: 'isInvalidFile',
      value: function isInvalidFile(type) {
        return this.TIPOS_EXTENSAO_FILE.filter(function (t) {
          return t === String(type).toLowerCase();
        }).length === 0;
      }
    }, {
      key: 'isRadioButtonMulta',
      value: function isRadioButtonMulta() {
        return this.model.tipo === 'INFRACAO';
      }
    }, {
      key: 'dismiss',
      value: function dismiss() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'isNotDataFutura',
      value: function isNotDataFutura() {
        var _this5 = this;

        return function () {
          var dataInput = _this5.moment(_this5.scope.formUpload.data.$viewValue, 'DD/MM/YYYY', true);
          if (dataInput.isValid()) {
            _this5.scope.formUpload.hora.$setValidity('isHoraFutura', _this5.isNotHoraFutura()());
            return dataInput.isBefore(_this5.moment());
          }
          return true;
        };
      }
    }, {
      key: 'isNotHoraFutura',
      value: function isNotHoraFutura() {
        var _this6 = this;

        return function () {
          var dataInput = _this6.moment(_this6.scope.formUpload.data.$viewValue, 'DD/MM/YYYY', true),
              horainput = _this6.moment(_this6.scope.formUpload.hora.$viewValue, 'HH:mm', true);
          if (dataInput.isValid() && horainput.isValid() && dataInput.isSame(_this6.moment().startOf('day'))) {
            return horainput.isSameOrBefore(_this6.moment());
          }
          return true;
        };
      }
    }, {
      key: 'getFileName',
      value: function getFileName() {
        return !this.model.file ? this.translate.instant('ce.common.nenhumArquivoSelecionado') : this.model.file[0].name;
      }
    }]);

    return UploadProntuarioCtrl;
  }();

  angular.module('ProntuarioModule').controller('UploadProntuarioCtrl', UploadProntuarioCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FormData */

  var FotoMotoristaCtrl = function () {
    function FotoMotoristaCtrl($uibModalInstance, $scope, AlertMessage, Restangular, motorista) {
      _classCallCheck(this, FotoMotoristaCtrl);

      this.scope = $scope;
      this.alertMessage = AlertMessage;
      this.modal = $uibModalInstance;
      this.restangular = Restangular;
      this.motorista = motorista;
      this.MAX_SIZE_UPLOAD = 5000000;

      this.fotoFinal = null;
      this.fileName = null;
    }

    _createClass(FotoMotoristaCtrl, [{
      key: 'onChangeFile',
      value: function onChangeFile(file) {
        this.$parent.$ctrl.fileName = file.name;
        this.$parent.formFotoMotorista.$setDirty();
      }
    }, {
      key: 'onCrop',
      value: function onCrop(fotoFinal) {
        this.$parent.$ctrl.fotoFinal = fotoFinal;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this = this;

        var formData = new FormData();
        formData.append('file', this.fotoFinal, this.fileName);

        if (this.isValidUpload(this.fotoFinal)) {
          this.restangular.all(this.getUrlFotoMotorista()).withHttpConfig({ transformRequest: angular.identity }).customPOST(formData, undefined, undefined, { 'Content-Type': undefined }).then(function (motoristaSalvo) {
            _this.modal.close(motoristaSalvo);
          }).catch(function () {
            _this.alertMessage.create({
              type: 'error',
              message: 'Ocorreu um erro ao importar a foto, por favor, tente novamente',
              appendTo: '.alerta-aqui'
            });
          });
        }
      }
    }, {
      key: 'isValidUpload',
      value: function isValidUpload(file) {
        if (file.size > this.MAX_SIZE_UPLOAD) {
          this.alertMessage.create({
            type: 'error',
            message: 'Arquivo excedeu o limite m\xE1ximo de 5MB.',
            appendTo: '.alerta-aqui'
          });
          angular.element('#fileFotoMotorista').val('');
          return false;
        }
        return true;
      }
    }, {
      key: 'getUrlFotoMotorista',
      value: function getUrlFotoMotorista() {
        return '/motorista/v2/motoristas/' + this.motorista.id + '/foto';
      }
    }, {
      key: 'dismiss',
      value: function dismiss() {
        this.modal.dismiss();
      }
    }]);

    return FotoMotoristaCtrl;
  }();

  angular.module('ProntuarioModule').controller('FotoMotoristaCtrl', FotoMotoristaCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ExcluirUploadProntuarioCtrl = function () {
    function ExcluirUploadProntuarioCtrl($uibModalInstance, Restangular, AlertMessage, motoristaId, arquivo, $translate) {
      _classCallCheck(this, ExcluirUploadProntuarioCtrl);

      this.modalInstance = $uibModalInstance;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.translate = $translate;

      this.motoristaId = motoristaId;
      this.arquivo = arquivo;
    }

    _createClass(ExcluirUploadProntuarioCtrl, [{
      key: 'excluir',
      value: function excluir() {
        var _this = this;

        this.restangular.all(this.getURLDelete()).remove().then(function () {
          _this.modalInstance.close();
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: _this.translate.instant('ce.ranking.motoristas.prontuario.modal.erroSalvar'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'getURLDelete',
      value: function getURLDelete() {
        return '/motorista/motoristas/' + this.motoristaId + '/infracoes-transito/' + this.arquivo.id;
      }
    }, {
      key: 'isMulta',
      value: function isMulta() {
        return this.arquivo && this.arquivo.anexoDocumento && this.arquivo.anexoDocumento.tipo === 'INFRACAO';
      }
    }, {
      key: 'dismiss',
      value: function dismiss() {
        this.modalInstance.dismiss();
      }
    }]);

    return ExcluirUploadProntuarioCtrl;
  }();

  angular.module('ProntuarioModule').controller('ExcluirUploadProntuarioCtrl', ExcluirUploadProntuarioCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function graficoOnePageDirective() {
    return {
      templateUrl: 'one-page/view/grafico/grafico-one-page.tpl.html',
      controller: 'GraficoOnePageCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var GraficoOnePageCtrl = function () {
    function GraficoOnePageCtrl($scope, CustomGridster, Authenticator, OnePageService) {
      var _this = this;

      _classCallCheck(this, GraficoOnePageCtrl);

      this.scope = $scope;
      this.customGridster = CustomGridster;
      this.authenticator = Authenticator;
      this.onePageService = OnePageService;

      this.gridster = this.customGridster.getOptions(125);

      this.scope.$on('gridster-item-resized', function () {
        return _this.scope.$broadcast('highchartsng.reflow');
      });
      this.scope.$on('gridster-item-transition-end', function () {
        return _this.scope.$broadcast('highchartsng.reflow');
      });

      this.posicoesGridster = { alertaTurnos: {}, alertas: {}, semSinal: {}, paradoMovimento: {} };
      this.visualizarHistoricoAlerta = false;
      this.visualizarLocalizao = false;
      this.visualizarNotificacoes = false;

      this.scope.$on('$destroy', function () {
        _this.gridster.resizable.resize = null;
        _this.gridster.draggable.drag = null;
      });

      this.authenticator.getUser().then(function (user) {
        if (_this.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
          _this.visualizarHistoricoAlerta = true;
        }
        if (_this.authenticator.hasRole('LOCALIZACAO_ATUAL_VISUALIZAR')) {
          _this.visualizarLocalizao = true;
        }
        if (_this.authenticator.hasRole('NOTIFICACOES_VISUALIZAR')) {
          _this.visualizarNotificacoes = true;
        }
        _this.init(user);
      });
    }

    _createClass(GraficoOnePageCtrl, [{
      key: 'init',
      value: function init(user) {
        var _this2 = this;

        this.gridster.resizable.resize = function () {
          return _this2.scope.$broadcast('highchartsng.reflow');
        };
        this.gridster.draggable.drag = function () {
          return _this2.scope.$broadcast('highchartsng.reflow');
        };
        this.user = user;
        this.setPosicaoGrafico();
      }
    }, {
      key: 'setPosicaoGrafico',
      value: function setPosicaoGrafico() {
        this.setPosicaoAlertaTurno();
        this.setPosicaoAlerta();
        this.setPosicaoSemSinal();
        this.setPosicaoParadoMovimento();
      }
    }, {
      key: 'setPosicaoAlertaTurno',
      value: function setPosicaoAlertaTurno() {
        this.posicoesGridster.alertaTurnos = this.scope.onePage.getPosicaoGrafico('g-alertaTurno-' + this.user.id, {
          row: 0,
          col: 0,
          sizeX: 12,
          sizeY: 3,
          minSizeY: 3,
          maxSizeY: 7,
          minSizeX: 8,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'g-alertaTurno-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.alertaTurnos);
      }
    }, {
      key: 'setPosicaoAlerta',
      value: function setPosicaoAlerta() {
        this.posicoesGridster.alertas = this.scope.onePage.getPosicaoGrafico('g-alerta-' + this.user.id, {
          row: 0,
          col: 0,
          sizeX: 12,
          sizeY: 3,
          minSizeY: 3,
          maxSizeY: 3,
          minSizeX: 8,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'g-alerta-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.alertas);
      }
    }, {
      key: 'setPosicaoSemSinal',
      value: function setPosicaoSemSinal() {
        this.posicoesGridster.semSinal = this.scope.onePage.getPosicaoGrafico('g-semsinal-' + this.user.id, {
          row: 0,
          col: 0,
          sizeX: 6,
          sizeY: 3,
          minSizeY: 3,
          maxSizeY: 3,
          minSizeX: 4,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'g-semsinal-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.semSinal);
      }
    }, {
      key: 'setPosicaoParadoMovimento',
      value: function setPosicaoParadoMovimento() {
        this.posicoesGridster.paradoMovimento = this.scope.onePage.getPosicaoGrafico('g-paradoMovimento-' + this.user.id, {
          row: 0,
          col: this.visualizarHistoricoAlerta ? 6 : 0,
          sizeX: 6,
          sizeY: 3,
          minSizeY: 3,
          maxSizeY: 3,
          minSizeX: 4,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'g-paradoMovimento-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.paradoMovimento);
      }
    }, {
      key: 'exibeAlertaTurnos',
      value: function exibeAlertaTurnos() {
        return this.visualizarHistoricoAlerta && this.onePageService.exibirAlertaTurnos;
      }
    }, {
      key: 'exibeAlertaDia',
      value: function exibeAlertaDia() {
        return this.visualizarNotificacoes && !this.onePageService.exibirAlertaTurnos;
      }
    }, {
      key: 'exibeSemSinal',
      value: function exibeSemSinal() {
        return this.visualizarHistoricoAlerta && this.posicoesGridster.semSinal;
      }
    }, {
      key: 'exibeParadoMovimento',
      value: function exibeParadoMovimento() {
        return this.visualizarLocalizao && this.posicoesGridster.paradoMovimento;
      }
    }]);

    return GraficoOnePageCtrl;
  }();

  angular.module('onePageModule').controller('GraficoOnePageCtrl', GraficoOnePageCtrl).directive('graficoOnePageDirective', graficoOnePageDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function cardOnePageDirective() {
    return {
      templateUrl: 'one-page/view/card/card-one-page.tpl.html',
      controller: 'CardOnePageCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var CardOnePageCtrl = function () {
    function CardOnePageCtrl($scope, $window, CustomGridster, Authenticator, OnePageService) {
      var _this = this;

      _classCallCheck(this, CardOnePageCtrl);

      this.scope = $scope;
      this.window = $window;
      this.customGridster = CustomGridster;
      this.authenticator = Authenticator;
      this.onePageService = OnePageService;

      this.gridster = this.customGridster.getOptions(115);

      this.posicoesGridster = { semSinal: {}, paradoMovimento: {} };
      this.visualizarHistoricoAlerta = false;
      this.visualizarLocalizao = false;
      this.visualizarNotificacoes = false;

      this.authenticator.getUser().then(function () {
        if (_this.authenticator.hasRole('HISTORICO_ALERTA_VISUALIZAR')) {
          _this.visualizarHistoricoAlerta = true;
        }
        if (_this.authenticator.hasRole('LOCALIZACAO_ATUAL_VISUALIZAR')) {
          _this.visualizarLocalizao = true;
        }
        if (_this.authenticator.hasRole('NOTIFICACOES_VISUALIZAR')) {
          _this.visualizarNotificacoes = true;
        }

        // this.init(user);
      });
    }

    _createClass(CardOnePageCtrl, [{
      key: 'init',
      value: function init(user) {
        this.user = user;
        this.setPosicaoGrafico();
      }
    }, {
      key: 'setPosicaoGrafico',
      value: function setPosicaoGrafico() {
        this.setPosicaoSemSinal();
        this.setPosicaoParadoMovimento();
      }
    }, {
      key: 'setPosicaoSemSinal',
      value: function setPosicaoSemSinal() {
        this.posicoesGridster.semSinal = this.scope.onePage.getPosicaoGrafico('c-semsinal-' + this.user.id, {
          row: 0,
          col: 0,
          sizeX: 6,
          sizeY: 1,
          minSizeY: 1,
          maxSizeY: 1,
          minSizeX: 4,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'c-semsinal-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.semSinal);
      }
    }, {
      key: 'setPosicaoParadoMovimento',
      value: function setPosicaoParadoMovimento() {
        this.posicoesGridster.paradoMovimento = this.scope.onePage.getPosicaoGrafico('c-paradoMovimento-' + this.user.id, {
          row: 0,
          col: this.visualizarHistoricoAlerta ? 6 : 0,
          sizeX: 6,
          sizeY: 1,
          minSizeY: 1,
          maxSizeY: 1,
          minSizeX: 4,
          maxSizeX: 12,
          versao: this.scope.onePage.versaoLocalstorage,
          name: 'c-paradoMovimento-' + this.user.id
        });
        this.scope.onePage.setPosicaoLocalStorage(this.posicoesGridster.paradoMovimento);
      }
    }]);

    return CardOnePageCtrl;
  }();

  angular.module('onePageModule').controller('CardOnePageCtrl', CardOnePageCtrl).directive('cardOnePageDirective', cardOnePageDirective);
})();
'use strict';

(function () {
  'use strict';

  angular.module('historicoTimeline', ['ui.router', 'restangular', 'historico-timeline-dropdown-multiselect', 'FeatureFlagModule', 'ConstantModule', 'ModuleEventos', 'ModuleMapasUtil', 'angularMoment', 'alert-message', 'leaflet-directive', 'mapas', 'enumModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'reprodRotasModule', 'pascalprecht.translate', 'urlConfigModule', 'v3gAuthenticatorModule', 'v3gTrimbleFilters', 'httpServiceV3gModule', 'AuditingEventsModule']).factory('HistoricoVeiculo', function (Restangular) {
    return Restangular.service('sensor/relatorio/historico-veiculo');
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CardSnapshotCtrl = function () {
    function CardSnapshotCtrl($uibModal, UrlConfigService, $translate, AuditingEventsEnum) {
      _classCallCheck(this, CardSnapshotCtrl);

      this.uibModal = $uibModal;
      this.urlConfigService = UrlConfigService;
      this.translate = $translate;
      this.auditingEventsEnum = AuditingEventsEnum;
    }

    _createClass(CardSnapshotCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.qtdCameras = this.indiceDisponiveis.length;
        this.cameraLabels = this.snapshot.cameraLabels;
      }
    }, {
      key: 'getUrl',
      value: function getUrl() {
        var _this = this;

        var currentCamera = this.snapshot.camerasPhotoUrl.find(function (camera) {
          return camera.indice === _this.indiceDisponiveis[_this.indice];
        });
        if (currentCamera) {
          return currentCamera.urlDriverPhoto;
        }
        return 'https://vfleets-imagens.s3.sa-east-1.amazonaws.com/logos/ps-background.png';
      }
    }, {
      key: 'visualizarPonto',
      value: function visualizarPonto() {
        this.verNoMapa({ posicao: {
            latitude: this.snapshot.latitude,
            longitude: this.snapshot.longitude,
            horario: this.getTime()
          } });
      }
    }, {
      key: 'visualizarFoto',
      value: function visualizarFoto() {
        var _this2 = this;

        var snapshotSlide = {
          id: this.snapshot.id,
          dateTime: this.snapshot.dateTime,
          cameras: this.indiceDisponiveis.map(function (indice) {
            var currentCamera = _this2.snapshot.camerasPhotoUrl.find(function (camera) {
              return camera.indice === indice;
            });
            return {
              indice: indice,
              possuiImagem: !!currentCamera,
              s3Url: currentCamera ? currentCamera.urlDriverPhoto : undefined
            };
          })
        };

        this.uibModal.open({
          component: 'carouselSnapshot',
          size: 'carousel',
          resolve: {
            snapshot: function snapshot() {
              return snapshotSlide;
            },
            indice: function indice() {
              return _this2.indice;
            },
            cameraLabels: function cameraLabels() {
              return _this2.cameraLabels;
            }
          }
        });
      }
    }, {
      key: 'getTime',
      value: function getTime() {
        return new Date(this.snapshot.dateTime).toLocaleTimeString();
      }
    }, {
      key: 'getLabels',
      value: function getLabels() {
        var _this3 = this;

        if (!this.cameraLabels) {
          return this.translate.instant(this.auditingEventsEnum.getDescriptionById('NO_LABEL'));
        }

        var labelsShow = this.cameraLabels.filter(function (cameraLabel) {
          return cameraLabel.index === _this3.cameraSelected;
        }).map(function (cameraLabel) {
          var translatedLabels = cameraLabel.labels.map(function (label) {
            return _this3.translate.instant(_this3.auditingEventsEnum.getDescriptionById(label));
          });

          if (translatedLabels.length > 2) {
            var firstTwoLabels = translatedLabels.slice(0, 2).join(', '),
                remainingCount = translatedLabels.length - 2,
                remainingText = remainingCount > 1 ? ' + ' + remainingCount + ' ' + _this3.translate.instant('ce.ranking.motoristas.prontuarioTassi.score.eventos') : ' + ' + remainingCount + ' ' + _this3.translate.instant('ce.ranking.motoristas.prontuarioTassi.score.evento');
            return '' + firstTwoLabels + remainingText;
          }

          return translatedLabels.join(', ');
        }).join(', ');

        return labelsShow || this.translate.instant(this.auditingEventsEnum.getDescriptionById('NO_LABEL'));
      }
    }]);

    return CardSnapshotCtrl;
  }();

  angular.module('historicoTimeline').component('cardSnapshot', {
    controller: CardSnapshotCtrl,
    templateUrl: 'historico-timeline/visao-cameras/card-snapshot/card-snapshot.tpl.html',
    bindings: {
      snapshot: '<',
      indice: '<',
      cameraSelected: '<',
      indiceDisponiveis: '<',
      verNoMapa: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CarouselSnapshotCtrl = function () {
    function CarouselSnapshotCtrl($translate, UrlConfigService, AuditingEventsEnum) {
      _classCallCheck(this, CarouselSnapshotCtrl);

      this.translate = $translate;
      this.urlConfigService = UrlConfigService;
      this.auditingEventsEnum = AuditingEventsEnum;
    }

    _createClass(CarouselSnapshotCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.snapshot = this.resolve.snapshot;
        this.indiceCard = this.resolve.indice;
        this.cameraLabels = this.resolve.cameraLabels;
      }
    }, {
      key: 'getUrl',
      value: function getUrl(indice) {
        var currentCamera = this.snapshot.cameras.find(function (cam) {
          return cam.indice === indice;
        });
        return currentCamera.possuiImagem ? currentCamera.s3Url : 'https://vfleets-imagens.s3.sa-east-1.amazonaws.com/logos/ps-background.png';
      }
    }, {
      key: 'getCaption',
      value: function getCaption(indice) {
        return this.translate.instant('ce.mapa.common.visaoCameras.camera') + ' ' + (indice + 1);
      }
    }, {
      key: 'getLabels',
      value: function getLabels(indice) {
        var _this = this;

        var noLabelTranslation = this.translate.instant(this.auditingEventsEnum.getDescriptionById('NO_LABEL'));
        var cameraLabel = null;

        if (!this.cameraLabels) {
          return noLabelTranslation;
        }

        cameraLabel = this.cameraLabels.find(function (cam) {
          return cam.index === indice;
        });

        if (!cameraLabel) {
          return noLabelTranslation;
        }

        return cameraLabel.labels.map(function (label) {
          return _this.translate.instant(_this.auditingEventsEnum.getDescriptionById(label));
        }).join(', ');
      }
    }]);

    return CarouselSnapshotCtrl;
  }();

  angular.module('historicoTimeline').component('carouselSnapshot', {
    controller: CarouselSnapshotCtrl,
    controllerAs: '$ctrl',
    templateUrl: 'historico-timeline/visao-cameras/carousel-snapshot/carousel-snapshot.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ControleCamerasCtrl = function () {
    function ControleCamerasCtrl($translate, AuditingEventsEnum) {
      _classCallCheck(this, ControleCamerasCtrl);

      this.translate = $translate;
      this.auditingEventsEnum = AuditingEventsEnum;
      this.qtdCameras = 0;
      this.viewIndex = 0;
      this.cameraSelected = null;
    }

    _createClass(ControleCamerasCtrl, [{
      key: '$onChanges',
      value: function $onChanges() {
        this.updateControls();
      }
    }, {
      key: 'classCamera',
      value: function classCamera(value) {
        return value === this.indiceDisponiveis[this.viewIndex] ? 'fa-circle' : 'fa-circle-o';
      }
    }, {
      key: 'setIndex',
      value: function setIndex(value) {
        this.cameraSelected = value;
        this.viewIndex = this.indiceDisponiveis.indexOf(value);
        this.emitToIndex(this.viewIndex);
      }
    }, {
      key: 'updateControls',
      value: function updateControls() {
        if (this.indiceDisponiveis.length !== this.qtdCameras) {
          this.qtdCameras = this.indiceDisponiveis.length;

          var firstCamera = this.indiceDisponiveis[0];
          this.setIndex(firstCamera);
        }
      }
    }, {
      key: 'next',
      value: function next() {
        if (this.viewIndex !== this.qtdCameras - 1) {
          this.viewIndex++;
          this.cameraSelected = this.indiceDisponiveis[this.viewIndex];
          this.emitToIndex(this.viewIndex);
        }
      }
    }, {
      key: 'previous',
      value: function previous() {
        if (this.viewIndex !== 0) {
          this.viewIndex--;
          this.cameraSelected = this.indiceDisponiveis[this.viewIndex];
          this.emitToIndex(this.viewIndex);
        }
      }
    }, {
      key: 'isNextDisable',
      value: function isNextDisable() {
        return this.viewIndex === this.qtdCameras - 1;
      }
    }, {
      key: 'isPreviousDisable',
      value: function isPreviousDisable() {
        return this.viewIndex === 0;
      }
    }, {
      key: 'emitToIndex',
      value: function emitToIndex(value) {
        this.onToIndex({ indice: value, cameraSelected: this.cameraSelected });
      }
    }, {
      key: 'getNextEvidenceTooltip',
      value: function getNextEvidenceTooltip() {
        return this.getEvidenceTooltip(true);
      }
    }, {
      key: 'getPreviousEvidenceTooltip',
      value: function getPreviousEvidenceTooltip() {
        return this.getEvidenceTooltip(false);
      }
    }, {
      key: 'getEvidenceTooltip',
      value: function getEvidenceTooltip(isNext) {
        if (!this.camerasEvidence || this.camerasEvidence.length === 0) {
          return '';
        }

        var _getLabelAndCameraSet = this.getLabelAndCameraSets(isNext),
            labelSet = _getLabelAndCameraSet.labelSet,
            cameraSet = _getLabelAndCameraSet.cameraSet,
            evento = labelSet[0],
            eventos = labelSet.slice(1).join(', '),
            camera = cameraSet[0],
            cameras = cameraSet.slice(1).join(', ');

        if (labelSet.length === 0) {
          return '';
        }

        return this.buildTooltipText(labelSet.length, cameraSet.length, { evento: evento, eventos: eventos, camera: camera, cameras: cameras });
      }
    }, {
      key: 'getLabelAndCameraSets',
      value: function getLabelAndCameraSets(isNext) {
        var _this = this;

        var labelSet = [],
            cameraSet = [];

        this.camerasEvidence.forEach(function (evidence) {
          var relevantIndexes = evidence.indexes.filter(function (index) {
            return isNext ? index > _this.cameraSelected : index < _this.cameraSelected;
          });
          if (relevantIndexes.length > 0) {
            var translatedLabel = _this.translate.instant(_this.auditingEventsEnum.getDescriptionById(evidence.label));
            if (!labelSet.includes(translatedLabel)) {
              labelSet.push(translatedLabel);
            }
            relevantIndexes.forEach(function (index) {
              if (!cameraSet.includes(index + 1)) {
                cameraSet.push(index + 1);
              }
            });
          }
        });

        return { labelSet: labelSet, cameraSet: cameraSet };
      }
    }, {
      key: 'buildTooltipText',
      value: function buildTooltipText(labelCount, cameraCount, params) {
        var evento = params.evento,
            eventos = params.eventos,
            camera = params.camera,
            cameras = params.cameras,
            baseText = this.translate.instant('ce.mapa.historicoDetalhado.camerasTooltip.moreCameraEvidence.moreEvidenceOf', { evento: evento });

        var specificText = '';

        switch (true) {
          case labelCount === 1 && cameraCount === 1:
            specificText = this.translate.instant('ce.mapa.historicoDetalhado.camerasTooltip.moreCameraEvidence.singleCamera', { camera: camera });
            break;
          case labelCount > 1 && cameraCount === 1:
            specificText = this.translate.instant('ce.mapa.historicoDetalhado.camerasTooltip.moreCameraEvidence.multiEventsSingleCamera', { eventos: eventos, camera: camera });
            break;
          case labelCount === 1 && cameraCount > 1:
            specificText = this.translate.instant('ce.mapa.historicoDetalhado.camerasTooltip.moreCameraEvidence.singleEventMultiCameras', { camera: camera, cameras: cameras });
            break;
          case labelCount > 1 && cameraCount > 1:
            specificText = this.translate.instant('ce.mapa.historicoDetalhado.camerasTooltip.moreCameraEvidence.multiEventsMultiCameras', { eventos: eventos, camera: camera, cameras: cameras });
            break;
          default:
            return '';
        }

        return '' + baseText + specificText;
      }
    }]);

    return ControleCamerasCtrl;
  }();

  angular.module('historicoTimeline').component('controleCameras', {
    controller: ControleCamerasCtrl,
    templateUrl: 'historico-timeline/visao-cameras/controle-cameras/controle-cameras.tpl.html',
    bindings: {
      indiceDisponiveis: '<',
      camerasEvidence: '<',
      onToIndex: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CamerasPaginacaoCtrl = function () {
    function CamerasPaginacaoCtrl() {
      _classCallCheck(this, CamerasPaginacaoCtrl);

      this.totalPages = 0;
      this.pageArray = [];
      this.page = 0;
      this.isFirst = true;
      this.isLast = false;
    }

    _createClass(CamerasPaginacaoCtrl, [{
      key: '$onChanges',
      value: function $onChanges() {
        if (this.navigationSetting) {
          this.updateState();
        }
      }
    }, {
      key: 'updateState',
      value: function updateState() {
        this.totalPages = this.navigationSetting.totalPages;
        this.pageArray = Array.from(Array(this.totalPages).keys());
        this.page = this.navigationSetting.page;
        this.isFirst = this.navigationSetting.first;
        this.isLast = this.navigationSetting.last;
      }
    }, {
      key: 'handleChangeSelectPage',
      value: function handleChangeSelectPage() {
        this.handleChangePage({ page: this.page });
      }
    }, {
      key: 'handlePreviousPage',
      value: function handlePreviousPage() {
        this.handleChangePage({ page: this.isFirst ? 0 : this.page - 1 });
      }
    }, {
      key: 'handleNextPage',
      value: function handleNextPage() {
        this.handleChangePage({ page: this.isLast ? this.page : this.page + 1 });
      }
    }]);

    return CamerasPaginacaoCtrl;
  }();

  angular.module('historicoTimeline').component('camerasPaginacao', {
    controller: CamerasPaginacaoCtrl,
    templateUrl: 'historico-timeline/visao-cameras/cameras-paginacao/cameras-paginacao.tpl.html',
    bindings: {
      navigationSetting: '<',
      handleChangePage: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var TempoPermanenciaInputCtrl = function () {
    function TempoPermanenciaInputCtrl() {
      _classCallCheck(this, TempoPermanenciaInputCtrl);
    }

    _createClass(TempoPermanenciaInputCtrl, [{
      key: 'onChangeConfigTempoMinimo',
      value: function onChangeConfigTempoMinimo() {
        if (!this.configurarTempo) {
          this.model = null;
        }
      }
    }, {
      key: 'tempoPermanenciaValid',
      value: function tempoPermanenciaValid() {
        var _this = this;

        return function () {
          return !(_this.model && _this.model < 3);
        };
      }
    }]);

    return TempoPermanenciaInputCtrl;
  }();

  angular.module('mapControlModule').component('tempoPermanenciaInput', {
    controller: TempoPermanenciaInputCtrl,
    templateUrl: 'directives/map-control/tempo-permanencia-input/tempo-permanencia-input-component.tpl.html',
    bindings: {
      model: '=',
      configurarTempo: '=',
      name: '@',
      info: '@'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function tabelaPontosProximosDirective() {
    return {
      templateUrl: 'directives/map-control/tabela-pontos-proximos/tabela-pontos-proximos.tpl.html',
      controller: 'TabelaPontosProximosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var TabelaPontosProximosCtrl = function () {
    function TabelaPontosProximosCtrl($scope, moment, PontosReferenciaMap, PontosReferenciaMenu, PontosProximos) {
      var _this = this;

      _classCallCheck(this, TabelaPontosProximosCtrl);

      this.moment = moment;
      this.historicoTimelineCtrl = $scope.$parent.$parent.$parent.$parent.historicoTimeline;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosProximosService = PontosProximos;

      this.idLayer = 0;
      this.layerEvento = null;
      this.showBtn = false;

      $scope.$watch(function () {
        return _this.pontosProximosService.listaPontosProximos.length;
      }, function (qnt) {
        if (qnt === 0) {
          _this.showBtn = false;
          _this.pontosReferenciaMenuService.tabelaPontosProximosClose();
        } else {
          _this.showBtn = true;
        }
      });
    }

    _createClass(TabelaPontosProximosCtrl, [{
      key: 'formatDate',
      value: function formatDate(date) {
        return date ? this.moment(date).format('DD/MM/YYYY HH:mm:ss') : '-';
      }
    }, {
      key: 'removeItem',
      value: function removeItem(idLayer) {
        this.pontosProximosService.removePontoProximo(idLayer);
        this.pontosReferenciaMapService.removeLayerPontoProximo(this.pontosReferenciaMapService.pontosProximosLayersBackup.getLayer(idLayer));
        this.pontosReferenciaMapService.removeDemoPontoProximo();
      }
    }, {
      key: 'focusItem',
      value: function focusItem(item) {
        var _this2 = this;

        this.idLayer = item.idLayer;
        this.closePopup();

        if (item.evento) {
          var layerHistorico = this.historicoTimelineCtrl.historico.find(function (i) {
            return i.data === item.evento.data && i.descricao === item.evento.evento;
          });

          this.historicoTimelineCtrl.markersGroup.eachLayer(function (layer) {
            if (layerHistorico && layerHistorico.index === layer.options.index) {
              layer.openPopup();
              _this2.layerEvento = layer;
            }
          });

          this.pontosReferenciaMapService.focusPontoProximo(item, !!this.layerEvento);
        } else {
          this.pontosReferenciaMapService.removeDemoPontoProximo();
          this.pontosReferenciaMapService.focusMarker(item);
        }
      }
    }, {
      key: 'closePopup',
      value: function closePopup() {
        if (this.layerEvento) {
          this.layerEvento.closePopup();
          this.layerEvento = null;
        }
      }
    }, {
      key: 'toggleTable',
      value: function toggleTable() {
        if (this.pontosReferenciaMenuService.tabelaPontosProximos) {
          this.pontosReferenciaMenuService.tabelaPontosProximosClose();
          this.pontosReferenciaMapService.removeDemoPontoProximo();
          this.closePopup();
        } else {
          this.pontosReferenciaMenuService.tabelaPontosProximosOpen();
        }
      }
    }, {
      key: 'removeAllPontosProximos',
      value: function removeAllPontosProximos() {
        this.pontosReferenciaMapService.removeAllPontosProximos();
        this.pontosProximosService.listaPontosProximos = [];
      }
    }]);

    return TabelaPontosProximosCtrl;
  }();

  angular.module('mapControlModule').controller('TabelaPontosProximosCtrl', TabelaPontosProximosCtrl).directive('tabelaPontosProximosDirective', tabelaPontosProximosDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PontosReferencia = function () {
    function PontosReferencia(Restangular, HttpServiceV3g) {
      _classCallCheck(this, PontosReferencia);

      this.http = HttpServiceV3g;
      this.restangular = Restangular;
      this.roleCadastrar = false;
      this.roleVisualizar = false;
      this.roleVisualizarRotograma = false;
      this.roleCadastrarRotograma = false;
      this.user = null;
      this.categorias = [];
      this.uos = null;
      this.rotograma = false;
    }

    _createClass(PontosReferencia, [{
      key: 'getListPontoReferencia',
      value: function getListPontoReferencia() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { rotograma: true, geocoding: false };

        return this.http.get('/ponto-referencia/pontos-referencia/permissao', {
          params: params
        });
      }
    }, {
      key: 'getListPontoReferenciaRelatorio',
      value: function getListPontoReferenciaRelatorio() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { rotograma: true, geocoding: false };

        return this.restangular.all('ponto-referencia/pontos-referencia/permissao/relatorio').getList(params);
      }
    }, {
      key: 'getPontoReferencia',
      value: function getPontoReferencia(idPonto) {
        return this.restangular.one('ponto-referencia/pontos-referencia/permissao/' + idPonto).get();
      }
    }, {
      key: 'postPontoReferencia',
      value: function postPontoReferencia(item) {
        return this.restangular.all('ponto-referencia/pontos-referencia').post(item);
      }
    }, {
      key: 'putPontoReferencia',
      value: function putPontoReferencia(item) {
        return this.restangular.all('ponto-referencia/pontos-referencia/' + item.id).customPUT(item);
      }
    }, {
      key: 'deletePontoReferencia',
      value: function deletePontoReferencia(idPonto) {
        return this.restangular.all('ponto-referencia/pontos-referencia/' + idPonto).remove();
      }
    }, {
      key: 'getInfoGeocode',
      value: function getInfoGeocode(lat, lon) {
        return this.restangular.one('/geocode/localizacao/', 'getByLatLong').get({ lat: lat, lon: lon });
      }
    }, {
      key: 'getRotograma',
      value: function getRotograma(id) {
        return this.restangular.all('/ponto-referencia/config-rotograma?rotograma=' + id).getList();
      }
    }, {
      key: 'getPontosReferenciaV2',
      value: function getPontosReferenciaV2(params) {
        return this.restangular.all('/ponto-referencia/v2/pontos-referencia').getList(params);
      }
    }, {
      key: 'getCadastroPontoConfig',
      value: function getCadastroPontoConfig() {
        return this.restangular.one('ponto-referencia/regra').get();
      }
    }]);

    return PontosReferencia;
  }();

  angular.module('mapControlModule').service('PontosReferencia', PontosReferencia);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global L, geolib, _ */

  var PontosProximos = function () {
    function PontosProximos($filter, PontosReferenciaMenu) {
      _classCallCheck(this, PontosProximos);

      this.filter = $filter;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;

      this.historicos = [];
      this.listaPontosProximos = [];

      this.RAIO_EM_METROS = 500;
    }

    _createClass(PontosProximos, [{
      key: 'init',
      value: function init(historicos) {
        this.historicos = historicos;
      }
    }, {
      key: 'setPontosProximos',
      value: function setPontosProximos(pontos) {
        var _this = this;

        this.listaPontosProximos = pontos.map(function (layer) {
          var latlng = layer.getLatLng(),
              idLayer = L.stamp(layer),
              index = layer.options.icon.options.index,
              obj = _this.findHistorico(latlng, idLayer, index);

          if (obj.length > 0) {
            return _.sortBy(obj, 'raio')[0];
          }
          return {
            index: index,
            idLayer: idLayer,
            latitude: latlng.lat,
            longitude: latlng.lng
          };
        });

        if (this.listaPontosProximos.length > 0) {
          this.pontosReferenciaMenuService.tabelaPontosProximosOpen();
        }
      }
    }, {
      key: 'removePontoProximo',
      value: function removePontoProximo(idLayer) {
        this.listaPontosProximos = this.listaPontosProximos.filter(function (item) {
          return item.idLayer !== idLayer;
        });
      }
    }, {
      key: 'findHistorico',
      value: function findHistorico(latlng, idLayer, index) {
        var _this2 = this;

        var listaEvento = [];
        this.historicos.forEach(function (item) {
          listaEvento.push(_this2.getPontosProximos(item.historicos, latlng, idLayer, index));
        });
        return _.flatten(listaEvento).filter(function (x) {
          return x && !!x.raio;
        });
      }
    }, {
      key: 'getPontosProximos',
      value: function getPontosProximos(item, latlng, idLayer, index) {
        var _this3 = this;

        return _.flatten(item.map(function (i) {
          return _this3.getPontoProximo(i, latlng, idLayer, index);
        }));
      }
    }, {
      key: 'getPontoProximo',
      value: function getPontoProximo(item, latlng, idLayer, index) {
        var lista = [];
        if (this.hasHistoricoInicio(item, latlng)) {
          lista.push(this.buildObjPontoProximo(item, item.latitude, item.longitude, latlng, idLayer, index));
        }
        if (this.hasHistoricoFim(item, latlng)) {
          lista.push(this.buildObjPontoProximo(item.fim, item.fim.latitude, item.fim.longitude, latlng, idLayer, index));
        }
        return lista;
      }
    }, {
      key: 'buildObjPontoProximo',
      value: function buildObjPontoProximo(item, latitude, longitude, latlng, idLayer, index) {
        return {
          evento: item,
          raio: geolib.getDistanceSimple({ latitude: latlng.lat, longitude: latlng.lng }, { latitude: latitude, longitude: longitude }),
          latitudeMarker: latlng.lat,
          longitudeMarker: latlng.lng,
          latitude: latitude,
          longitude: longitude,
          idLayer: idLayer,
          index: index
        };
      }
    }, {
      key: 'hasHistoricoInicio',
      value: function hasHistoricoInicio(item, latlng) {
        return item.gps !== 'Inválido' && item.latitude && item.longitude && geolib.isPointInCircle({ latitude: item.latitude, longitude: item.longitude }, { latitude: latlng.lat, longitude: latlng.lng }, this.RAIO_EM_METROS);
      }
    }, {
      key: 'hasHistoricoFim',
      value: function hasHistoricoFim(item, latlng) {
        return item.fim && item.fim.gps !== 'Inválido' && item.fim.latitude && item.fim.longitude && geolib.isPointInCircle({ latitude: item.fim.latitude, longitude: item.fim.longitude }, { latitude: latlng.lat, longitude: latlng.lng }, this.RAIO_EM_METROS);
      }
    }]);

    return PontosProximos;
  }();

  angular.module('mapControlModule').service('PontosProximos', PontosProximos);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global geolib*/
(function () {
  'use strict';

  var PontosReferenciaTools = function () {
    function PontosReferenciaTools() {
      _classCallCheck(this, PontosReferenciaTools);
    }

    _createClass(PontosReferenciaTools, [{
      key: 'retornaPontosComDistancia',
      value: function retornaPontosComDistancia(latlngs, metros) {
        var p2 = geolib.computeDestinationPoint({ lat: latlngs[0].lat, lon: latlngs[0].lng }, metros, 0),
            p3 = geolib.computeDestinationPoint({ lat: p2.latitude, lon: p2.longitude }, metros, 90),
            novaLatLng = [{
          lat: latlngs[0].lat,
          lng: latlngs[0].lng
        }, {
          lat: p3.latitude,
          lng: latlngs[0].lng
        }, {
          lat: p2.latitude,
          lng: p3.longitude
        }, {
          lat: latlngs[0].lat,
          lng: p3.longitude
        }];

        return novaLatLng;
      }
    }, {
      key: 'geraDiametro',
      value: function geraDiametro(latlngs) {
        return Math.ceil(geolib.getDistance({ latitude: latlngs[0].lat, longitude: latlngs[0].lng }, { latitude: latlngs[1].lat, longitude: latlngs[1].lng }, 1, 3));
      }
    }, {
      key: 'geraLatLngCentro',
      value: function geraLatLngCentro(latlngs) {
        return geolib.getCenter(latlngs.map(function (item) {
          return angular.extend({ latitude: item.lat, longitude: item.lng });
        }));
      }
    }, {
      key: 'geraLatLngsExternos',
      value: function geraLatLngsExternos(latCenter, lngCenter, raio) {
        return {
          latlngLeftBottom: geolib.computeDestinationPoint({ lat: latCenter, lon: lngCenter }, raio * 1.414213562, 225),
          latlngRightTop: geolib.computeDestinationPoint({ lat: latCenter, lon: lngCenter }, raio * 1.414213562, 45)
        };
      }
    }, {
      key: 'geraLatlngs',
      value: function geraLatlngs(latlngs, latCenter, lngCenter, raio) {
        var pontos = this.geraLatLngsExternos(latCenter, lngCenter, raio);

        latlngs[0].lat = pontos.latlngLeftBottom.latitude;
        latlngs[0].lng = pontos.latlngLeftBottom.longitude;

        latlngs[1].lat = pontos.latlngRightTop.latitude;
        latlngs[1].lng = pontos.latlngLeftBottom.longitude;

        latlngs[2].lat = pontos.latlngRightTop.latitude;
        latlngs[2].lng = pontos.latlngRightTop.longitude;

        latlngs[3].lat = pontos.latlngLeftBottom.latitude;
        latlngs[3].lng = pontos.latlngRightTop.longitude;

        return latlngs;
      }
    }, {
      key: 'geraLatLngsRotograma',
      value: function geraLatLngsRotograma(angulo, raio, latitude, longitude) {
        var i = void 0,
            sentido = void 0;
        if (angulo >= 0 && angulo <= 45) {
          sentido = 360;
          i = Math.cos(angulo * Math.PI / 180);
        } else if (angulo > 45 && angulo <= 90) {
          sentido = 90;
          i = Math.sin(angulo * Math.PI / 180);
        } else if (angulo > 90 && angulo <= 135) {
          sentido = 90;
          i = Math.cos((angulo - 90) * Math.PI / 180);
        } else if (angulo > 135 && angulo <= 180) {
          sentido = 180;
          i = Math.sin((angulo - 90) * Math.PI / 180);
        } else if (angulo > 180 && angulo <= 225) {
          sentido = 180;
          i = Math.cos((angulo - 180) * Math.PI / 180);
        } else if (angulo > 225 && angulo <= 270) {
          sentido = 270;
          i = Math.sin((angulo - 180) * Math.PI / 180);
        } else if (angulo > 270 && angulo <= 315) {
          sentido = 270;
          i = Math.cos((angulo - 270) * Math.PI / 180);
        } else {
          sentido = 360;
          i = Math.sin((angulo - 270) * Math.PI / 180);
        }

        var hip = raio / i,
            latlng = geolib.computeDestinationPoint({ lat: latitude, lon: longitude }, hip, angulo);
        return { latlng: latlng, sentido: sentido };
      }
    }, {
      key: 'geraLatLngsLabel',
      value: function geraLatLngsLabel(raio, latitude, longitude) {
        var ajusteAlturaLabel = 1.75,
            hip = raio / ajusteAlturaLabel,
            latlng = geolib.computeDestinationPoint({ lat: latitude, lon: longitude }, hip, 360);
        return latlng;
      }
    }, {
      key: 'geraLatLngsPontoLargura',
      value: function geraLatLngsPontoLargura(raio, latitude, longitude) {
        var latlngDireta = geolib.computeDestinationPoint({ lat: latitude, lon: longitude }, raio, 90),
            latlngEsquerda = geolib.computeDestinationPoint({ lat: latitude, lon: longitude }, raio, 270);
        return { latlngDireta: latlngDireta, latlngEsquerda: latlngEsquerda };
      }
    }, {
      key: 'geraWidth',
      value: function geraWidth(map, pontoA, pontoB) {
        return map.latLngToLayerPoint({ lat: pontoA.latitude, lng: pontoA.longitude }).distanceTo(map.latLngToLayerPoint({ lat: pontoB.latitude, lng: pontoB.longitude }));
      }
    }, {
      key: 'geraLatlngsResize',
      value: function geraLatlngsResize(latlngs, latlngsOriginal) {
        var latlngsOriginalCentro = geolib.getCenter(latlngsOriginal),
            latlngsCentro = geolib.getCenter(latlngs),
            countAngulo = 45,
            dif = geolib.getDistance(latlngs[0], latlngsCentro, 1, 3) / 1.414213562;

        dif = Math.max(10, Math.min(2000, dif)) * 1.414213562;

        for (var i = 0; i < 4; i++) {
          var ponto = geolib.computeDestinationPoint({ lat: latlngsOriginalCentro.latitude, lon: latlngsOriginalCentro.longitude }, dif, countAngulo);
          countAngulo += 90;
          latlngs[i].lat = ponto.latitude;
          latlngs[i].lng = ponto.longitude;
        }

        return latlngs;
      }
    }]);

    return PontosReferenciaTools;
  }();

  angular.module('mapControlModule').service('PontosReferenciaTools', PontosReferenciaTools);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document, _, geolib, L*/
(function () {
  'use strict';

  var ZOOM_MINIMO_RENDER_MARKER = 13;

  var PontosReferenciaMap = function () {
    function PontosReferenciaMap($timeout, $rootScope, $uibModal, AlertMessage, PopupService, PontosReferencia, PontosReferenciaTools, PontosReferenciaMenu, PontosReferenciaFiltro, PontosProximos, RotogramaMapService, PosicoesRotogramas, CadastroRotogramaService, CategoriaPontosReferencia, ControleVelocidadeRotograma, $compile, LayerTypeEnum, MapControlService, $translate, Authenticator, FeatureFlag, ReportWrongSpeedViaService, $sanitize) {
      var _this = this;

      _classCallCheck(this, PontosReferenciaMap);

      this.timeout = $timeout;
      this.rootScope = $rootScope;
      this.modalService = $uibModal;
      this.$sanitize = $sanitize;
      this.alertMessage = AlertMessage;
      this.popupService = PopupService;
      this.pontosReferenciaService = PontosReferencia;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.pontosProximosService = PontosProximos;
      this.rotogramaMapService = RotogramaMapService;
      this.posicoesRotogramas = PosicoesRotogramas;
      this.cadastroRotogramaService = CadastroRotogramaService;
      this.pontosCategoriaReferenciaService = CategoriaPontosReferencia;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.compile = $compile;
      this.layerTypeEnum = LayerTypeEnum;
      this.mapControlService = MapControlService;
      this.translate = $translate;
      this.lastLayerSuggestionClicked = null;
      this.viaRapida = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.viaRapida');
      this.avenida = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.avenida');
      this.rua = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.rua');
      this.pistaDuplicada = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.pistaDuplicada');
      this.pistaSimples = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.pistaSimples');
      this.vicinal = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.vicinal');
      this.ruralOutras = this.translate.instant('ce.mapa.common.modal.popupService.tipoVia.ruralOutras');
      this.featureFlag = FeatureFlag;
      this.authenticator = Authenticator;
      this.reportWrongSpeedViaService = ReportWrongSpeedViaService;
      this.authenticator.getUser().then(function (user) {
        _this.user = user;
      });

      this.retornaTipoVia = {
        MOTORWAY: function MOTORWAY(urbano) {
          return urbano ? { veiculoLeve: 100, veiculoPesado: 90, tipoVia: _this.viaRapida } : { veiculoLeve: 120, veiculoPesado: 100, tipoVia: _this.pistaDuplicada };
        },
        TRUNK: function TRUNK(urbano) {
          return urbano ? { veiculoLeve: 100, veiculoPesado: 90, tipoVia: _this.viaRapida } : { veiculoLeve: 120, veiculoPesado: 100, tipoVia: _this.pistaDuplicada };
        },
        PRIMARY: function PRIMARY(urbano) {
          return urbano ? { veiculoLeve: 80, veiculoPesado: 70, tipoVia: _this.avenida } : { veiculoLeve: 110, veiculoPesado: 90, tipoVia: _this.pistaSimples };
        },
        SECONDARY: function SECONDARY(urbano) {
          return urbano ? { veiculoLeve: 80, veiculoPesado: 70, tipoVia: _this.rua } : { veiculoLeve: 80, veiculoPesado: 80, tipoVia: _this.vicinal };
        },
        default: function _default(urbano) {
          return urbano ? { veiculoLeve: 60, veiculoPesado: 50, tipoVia: _this.rua } : { veiculoLeve: 80, veiculoPesado: 60, tipoVia: _this.ruralOutras };
        }
      };

      this.logradouroLayers = new L.FeatureGroup();

      this.setVariaveis();

      this.rootScope.$on('rotogramasCadastrados', function (evt, data) {
        var ponto = _.find(_this.pontosReferencia, function (p) {
          return p.entidade.id === data.pontoReferenciaId;
        });
        if (ponto.rendered) {
          _this.unRender(ponto);
        }
        ponto.layers = null;
        ponto.entidade.rotogramas = [];
        data.rotogramas.forEach(function (rotogramaCadastrado) {
          var grupoVelocidade = rotogramaCadastrado.rotograma.grupoVelocidadePadrao,
              rotograma = Object.assign({}, rotogramaCadastrado.rotograma, { grupoVelocidadePadrao: grupoVelocidade });
          ponto.entidade.rotogramas.push(rotograma);
        });
        _this.render(ponto);
        _this.map.invalidateSize();
        _this.map.panTo([ponto.entidade.latitude, ponto.entidade.longitude]);
      });

      this.rootScope.$on('rotogramasDeletados', function (evt, data) {
        var ponto = _.find(_this.pontosReferencia, function (p) {
          return p.entidade.id === data.pontoReferenciaId;
        });
        if (ponto.rendered) {
          _this.unRender(ponto);
        }
        ponto.layers = null;
        ponto.entidade.rotogramas = [];
        _this.render(ponto);
        _this.map.invalidateSize();
      });

      this.rootScope.$on('limpaSelecaoPontoReferencia', function () {
        return _this.cancelarPonto();
      });
    }

    _createClass(PontosReferenciaMap, [{
      key: 'setVariaveis',
      value: function setVariaveis() {
        var _this2 = this;

        this.map = null;
        this.countPontosProximos = 0;
        this.countPontosProximosBackup = 1;
        this.latlngsOriginal = [];
        this.alertaZoom = false;
        this.retangulo = null;
        this.markerPontoProximo = null;
        this.pontosProximosLayers = new L.FeatureGroup();
        this.pontosProximosLayersBackup = new L.FeatureGroup();
        this.pontosProximosPolyline = new L.FeatureGroup();
        this.logradouroLayers = new L.FeatureGroup();
        this.layer = null;
        this.editableLayers = new L.FeatureGroup();
        this.pontoHover = null;
        this.pontosReferencia = [];
        this.pontosRendered = [];

        if (this.pontosReferenciaService.roleVisualizar) {
          this.pontosReferenciaService.getCadastroPontoConfig().then(function (data) {
            _this2.cadastroPontoConfig = data;
            _this2.rootScope.$emit('init-menu-map');
          }).catch(function () {
            _this2.cadastroPontoConfig = { permissaoEdicao: true };
          });
        } else {
          this.cadastroPontoConfig = { permissaoEdicao: true };
        }
      }
    }, {
      key: 'desabilitarZoom',
      value: function desabilitarZoom() {
        this.alertaZoom = false;
        this.map.off('zoomend', this.verificaZoom, this);
      }
    }, {
      key: 'verificaZoom',
      value: function verificaZoom() {
        if (this.map.getZoom() >= 14) {
          this.alertaZoom = false;
          this.retangulo.enable();
        } else {
          this.alertaZoom = true;
          this.retangulo.disable();
        }
      }
    }, {
      key: 'setVerificaZoom',
      value: function setVerificaZoom() {
        this.verificaZoom();
        this.map.on('zoomend', this.verificaZoom, this);
      }
    }, {
      key: 'setLayerDefault',
      value: function setLayerDefault() {
        var _this3 = this;

        this.latlngsOriginal = [];
        this.editableLayers.eachLayer(function (layer) {
          return _this3.setDefaultStyle(layer);
        });
      }
    }, {
      key: 'setDefaultStyle',
      value: function setDefaultStyle(layer) {
        if (angular.isUndefined(layer.options.id) && angular.isUndefined(layer.options.label)) {
          return layer.setStyle({ weight: 0, fillOpacity: 0.4 });
        }
      }
    }, {
      key: 'setMap',
      value: function setMap(map) {
        this.map = map;
        this.drawControl = new L.Control.Draw({
          draw: false,
          edit: {
            moveMarkers: true,
            featureGroup: this.editableLayers
          }
        });
        L.drawLocal.draw.handlers.simpleshape.tooltip.end = this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.simpleshapeTooltipEnd');
        L.drawLocal.draw.handlers.rectangle.tooltip.start = this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.rectangleTooltipStart');
        L.drawLocal.draw.handlers.marker.tooltip.start = this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.markerTooltipStart');
        var element = L.DomUtil.get('map-control');
        L.DomEvent.on(element, 'mousewheel', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'dblclick', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'mousedown', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'contextmenu', L.DomEvent.stopPropagation);
        angular.element('tabela-pontos-proximos-directive').on('click', L.DomEvent.stopPropagation);
        angular.element('pesquisa-ponto-referencia-directive').on('click', L.DomEvent.stopPropagation);
        angular.element('#fechar-drawer').on('click', L.DomEvent.stopPropagation);
        this.moveMap();
        this.map.invalidateSize(true);
      }
    }, {
      key: 'moveMap',
      value: function moveMap() {
        var _this4 = this;

        this.map.on('moveend', function () {
          _this4.mostrarPontosBoundsAtual();
          _this4.editableLayers.eachLayer(function (layer) {
            _this4.renderLabels(layer);
          });
        });
      }
    }, {
      key: 'addLayer',
      value: function addLayer(layer) {
        this.editableLayers.addLayer(layer);
      }
    }, {
      key: 'removeLayer',
      value: function removeLayer(layer) {
        if (layer) {
          this.editableLayers.removeLayer(layer);
        }
      }
    }, {
      key: 'addLayerMap',
      value: function addLayerMap(layer) {
        this.map.addLayer(layer);
      }
    }, {
      key: 'removeLayerMap',
      value: function removeLayerMap(layer) {
        if (layer) {
          this.map.removeLayer(layer);
        }
      }
    }, {
      key: 'removeAllLayerMap',
      value: function removeAllLayerMap() {
        var _this5 = this;

        this.editableLayers.eachLayer(function (layer) {
          return _this5.removeLayerMap(layer);
        });
      }
    }, {
      key: 'getIdLayer',
      value: function getIdLayer(layer) {
        return L.stamp(layer);
      }
    }, {
      key: 'markerEditing',
      value: function markerEditing(layer) {
        return !!layer.options.editing;
      }
    }, {
      key: 'removeLogradouroMarker',
      value: function removeLogradouroMarker() {
        this.logradouroLayers.removeLayer(this.logradouroMarker);
      }
    }, {
      key: 'focusLogradouro',
      value: function focusLogradouro(logradouro, index) {
        if (this.logradouroMarker) {
          this.removeLogradouroMarker();
        }

        var zoom = this.map.getZoom();
        this.map.setView(new L.LatLng(logradouro.lat, logradouro.lon), zoom <= 15 ? 15 : zoom);
        if (index !== null && angular.isDefined(index)) {
          this.logradouroIndex = index;
        }
        this.logradouroMarker = L.marker([logradouro.lat, logradouro.lon], {
          icon: L.divIcon({
            iconSize: [0, 0],
            html: '<img src="images/icons-map/marker-pin-blue.png" class="img-icon"/>',
            iconAnchor: [15, 40],
            popupAnchor: [1, -35]
          })
        });
        this.logradouroLayers.addLayer(this.logradouroMarker);
        this.map.addLayer(this.logradouroLayers);
      }
    }, {
      key: 'focusLayer',
      value: function focusLayer(layer, zoomMap) {
        if (!this.hasEditableLayers()) {
          if (!this.markerEditing(layer)) {
            this.setLayerDefault();
            layer.setStyle({ weight: 4, fillOpacity: 0.75 });
            this.latlngsOriginal = layer.getLatLngs()[0];
            var latlngCenter = geolib.getCenter(this.latlngsOriginal);
            if (zoomMap) {
              var zoom = this.map.getZoom();
              this.map.setView(new L.LatLng(latlngCenter.latitude, latlngCenter.longitude), zoom <= 15 ? 15 : zoom);
            } else {
              this.map.panTo(new L.LatLng(latlngCenter.latitude, latlngCenter.longitude));
            }
            if (this.pontosReferenciaFiltroService.verificaLayer(layer, this.getIdLayer(layer))) {
              this.layer = layer;
              return true;
            }

            this.alertMessage.create({
              type: 'warning',
              message: this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.messagePontoOculto'),
              appendTo: '.alerta-aqui-ponto',
              timeout: 10000
            });
          }
        }
        return false;
      }
    }, {
      key: 'hasRotogramas',
      value: function hasRotogramas(layer) {
        return layer.entidade.rotogramas && layer.entidade.rotogramas.length > 0;
      }
    }, {
      key: 'hasEditableLayers',
      value: function hasEditableLayers() {
        return _.some(this.editableLayers.getLayers(), function (item) {
          if (item instanceof L.Rectangle) {
            return item.options.editing;
          }
        });
      }
    }, {
      key: 'markerOut',
      value: function markerOut(id) {
        var layer = this.getMarkerLimite(id, true);
        if (layer) {
          layer.setOpacity(0);
        }
      }
    }, {
      key: 'markerIn',
      value: function markerIn(id, latlng, value) {
        var layer = this.getMarkerLimite(id, false, latlng, value);
        if (layer && this.map.getZoom() >= 15) {
          layer.setOpacity(1);
        }
      }
    }, {
      key: 'getMarkerLimite',
      value: function getMarkerLimite(id, editing, latlng, value) {
        var _this6 = this;

        var retorno = null;
        this.editableLayers.eachLayer(function (layer) {
          if (angular.isDefined(layer.options.id) && layer.options.id === id) {
            retorno = layer;
            if (angular.isDefined(editing)) {
              layer.options.editing = editing;
            }
            if (angular.isDefined(latlng)) {
              if (angular.isDefined(value)) {
                _this6.removeLayer(layer);
                _this6.removeLayerMap(layer);

                var marker = _this6.buildMarkerLimite(latlng[0], latlng[1], value, id);
                _this6.addLayer(marker);
                _this6.addLayerMap(marker);
                retorno = marker;
              } else {
                layer.setLatLng(latlng);
              }
            }
          }
        });

        if (retorno === null && angular.isDefined(latlng) && angular.isDefined(value)) {
          var marker = this.buildMarkerLimite(latlng[0], latlng[1], value, id);
          this.addLayer(marker);
          this.addLayerMap(marker);
          retorno = marker;
        }

        return retorno;
      }
    }, {
      key: 'getPontoReferencia',
      value: function getPontoReferencia(entidadePermissao) {
        var _this7 = this;

        var achouPonto = false;
        this.editableLayers.eachLayer(function (layer) {
          if (layer instanceof L.Rectangle && layer.entidadePermissao.entidade.id === entidadePermissao.entidade.id) {
            if (_this7.focusLayer(layer, true) && _this7.deveExibirIconeDeEdicao(layer)) {
              _this7.pontosReferenciaMenuService.setFABActive('editar');
            } else {
              _this7.pontosReferenciaMenuService.setFABDefault();
            }
            _this7.map.dragging.enable();
            achouPonto = true;
          }
        });
        if (!achouPonto) {
          if (!this.pontosReferenciaFiltroService.isPontoVisible(entidadePermissao)) {
            this.alertMessage.create({
              type: 'warning',
              message: this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.messagePontoOculto'),
              appendTo: '.alerta-aqui-ponto',
              timeout: 10000
            });
          } else {
            this.modalService.open({
              animation: true,
              controller: 'FocusPontoReferenciaModalCtrl',
              controllerAs: '$ctrl',
              templateUrl: 'directives/map-control/focus-ponto-referencia/focus-ponto-referencia-modal.tpl.html'
            });
          }
        }
      }
    }, {
      key: 'deveExibirIconeDeEdicao',
      value: function deveExibirIconeDeEdicao(layer) {
        return layer.entidadePermissao.permissao.edicao && this.pontosReferenciaService.roleCadastrar && this.cadastroPontoConfig && this.cadastroPontoConfig.permissaoDeEdicao;
      }
    }, {
      key: 'buildMarkerLimite',
      value: function buildMarkerLimite(latitude, longitude) {
        var velocidade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var status = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.controleVelocidadeRotograma.CONFIGURADO.value;
        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
        var idRotograma = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        var audio = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        var html = this.getMarkerInnerHtml(velocidade, status),
            opacity = this.map.getZoom() >= 15 ? 1 : 0;

        return L.marker([latitude, longitude], {
          icon: L.divIcon({
            className: 'degree-' + rotation + ' ' + this.controleVelocidadeRotograma[status].classe,
            html: html
          }),
          opacity: opacity,
          id: id,
          idRotograma: idRotograma,
          velocidade: velocidade,
          status: status,
          audio: audio
        });
      }
    }, {
      key: 'getMarkerInnerHtml',
      value: function getMarkerInnerHtml(velocidade, status) {
        var html = '';
        var iconAudio = '<span class="material-icons">volume_up</span>',
            showSpeed = typeof velocidade !== 'undefined' && velocidade !== null,
            statusRotogram = this.controleVelocidadeRotograma.getStatusRotogram(status),
            hasAudioIcon = statusRotogram && statusRotogram.hasAudioIcon,
            hasSpeedIcon = statusRotogram && statusRotogram.hasSpeedIcon;

        if (hasSpeedIcon && showSpeed) {
          html = '<strong>' + velocidade + '</strong><small>km/h</small>';
        }
        if (hasAudioIcon) {
          html += iconAudio;
        }
        return html;
      }
    }, {
      key: 'buildMarkerLabel',
      value: function buildMarkerLabel(infosPonto) {
        var larguraRotograma = 30;
        var html = void 0,
            label = true,
            width = void 0,
            pontosLargura = this.pontosReferenciaToolsService.geraLatLngsPontoLargura(infosPonto.raio, infosPonto.latitude, infosPonto.longitude);

        width = this.pontosReferenciaToolsService.geraWidth(this.map, pontosLargura.latlngEsquerda, pontosLargura.latlngDireta) - larguraRotograma;

        html = '<div class="label-box" style="width: ' + width + 'px; margin-left: -' + Math.round(width / 2 - 6) + 'px;">                <div style="max-width: ' + width + 'px" class="label-text">                  <i class=\'fa fa-map-marker icon-label-ponto\'></i>' + infosPonto.nome + '                </div>              </div>';
        return L.marker([infosPonto.latitude, infosPonto.longitude], {
          icon: L.divIcon({
            html: html
          }),
          label: label,
          nome: infosPonto.nome,
          idPonto: infosPonto.id
        });
      }
    }, {
      key: 'getMarkerRotograma',
      value: function getMarkerRotograma(idLayer, rotograma, ponto) {
        var marker = void 0;
        var speed = rotograma.grupoVelocidadePadrao && rotograma.grupoVelocidadePadrao.velocidade;
        if (angular.isDefined(rotograma.grau) && rotograma.grau !== null) {
          var retorno = this.pontosReferenciaToolsService.geraLatLngsRotograma(rotograma.grau, ponto.raio, ponto.latitude, ponto.longitude);
          marker = this.buildMarkerLimite(retorno.latlng.latitude, retorno.latlng.longitude, speed, idLayer, rotograma.status, retorno.sentido, rotograma.id, rotograma.audio);
        } else {
          marker = this.buildMarkerLimite(ponto.latitude, ponto.longitude, speed, idLayer, rotograma.status, -1, rotograma.id, rotograma.audio);
        }
        return marker;
      }
    }, {
      key: 'getIconPontoProximo',
      value: function getIconPontoProximo(html, className) {
        return L.divIcon({
          html: html,
          iconSize: [30, 35],
          iconAnchor: [15, 32],
          index: this.countPontosProximosBackup,
          className: 'icon-pontos-proximos ' + className
        });
      }
    }, {
      key: 'setPontoProximo',
      value: function setPontoProximo() {
        var icon = this.getIconPontoProximo('<i class="fv trimble-push-pin"></i><span class="label label-danger">x</span>', 'icon-pontos-proximos-' + this.countPontosProximos);
        this.markerPontoProximo = new L.Draw.Marker(this.map, { icon: icon });
        this.enablePontoProximo();
      }
    }, {
      key: 'enablePontoProximo',
      value: function enablePontoProximo() {
        var _this8 = this;

        this.timeout(function () {
          if (_this8.markerPontoProximo) {
            _this8.markerPontoProximo.enable();
          }
          _this8.pontosReferenciaMenuService.menuOpen();
          _this8.countPontosProximos++;
        }, 100);
      }
    }, {
      key: 'exibirVelocidadeVia',
      value: function exibirVelocidadeVia(lat, lon) {
        var _this9 = this;

        if (this.map.getZoom() >= 15) {
          this.pontosReferenciaService.getInfoGeocode(lat, lon).then(function (item) {
            var logradouroLabel = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.logradouro'),
                reportarVelocidadeIncorretaVia = _this9.reportWrongSpeedViaService.getLinkToFormHtml(_this9.user, lat, lon);
            var html = item.logradouro ? '<div><strong>' + logradouroLabel + '</strong> ' + item.logradouro + '</div>' : '',
                urbano = item.urbano;
            if (item.roadInfo && item.roadInfo.highwayType) {
              var fonteLabel = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.fonte');
              if (item.roadInfo.speedLimit) {
                var limiteLabel = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.limite');
                html += '<div><strong>' + limiteLabel + '</strong> ' + item.roadInfo.speedLimit + ' km/h <i>(' + fonteLabel + ' <a href="https://www.openstreetmap.org/way/' + item.osmId + '" target="_blank">OSM</a>)</i></div>';
              } else {
                var i = _this9.retornaTipoVia.hasOwnProperty(item.roadInfo.highwayType) ? _this9.retornaTipoVia[item.roadInfo.highwayType](urbano) : _this9.retornaTipoVia.default(urbano),
                    limiteVeiculoLeveLabel = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.limiteVeiculoLeve'),
                    limiteVeiculoPesadoLabel = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.limiteVeiculoPesado'),
                    padraoPorTipoDe = _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.padraoPorTipoDe');
                html += '<div><strong>' + limiteVeiculoLeveLabel + '</strong> ' + i.veiculoLeve + ' km/h <i>(' + fonteLabel + ' ' + padraoPorTipoDe + ' ' + i.tipoVia + ')</i></div>';
                html += '<div><strong>' + limiteVeiculoPesadoLabel + '</strong> ' + i.veiculoPesado + ' km/h <i>(' + fonteLabel + ' ' + padraoPorTipoDe + ' ' + i.tipoVia + ')</i></div>';
              }
            } else {
              html = '<strong>' + _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.naoFoiPossivelCarregar') + '</strong>';
            }
            html += '<div>' + _this9.popupService.getGoogleMapsLink(lat, lon) + '</div>';
            html += '<div>' + _this9.popupService.getStreetViewLink(lat, lon) + '</div>';
            if (reportarVelocidadeIncorretaVia) {
              html += '<div>' + reportarVelocidadeIncorretaVia + '</div>';
            }

            L.popup().setLatLng(new L.LatLng(lat, lon)).setContent(html).openOn(_this9.map);
          }).catch(function () {
            _this9.alertMessage.create({
              type: 'error',
              message: _this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorCarregarLimiteVia'),
              appendTo: '.alerta-aqui-ponto'
            });
          });
        }
      }
    }, {
      key: 'getTextoPopUp',
      value: function getTextoPopUp(textoPopup, data) {
        if (!data.permissao.edicao) {
          var textoSemPermissao = this.translate.instant('ce.mapa.common.modal.editarPontoReferencia.popupNaoTemPermissao');
          return textoPopup + ('<br/><strong style="color: #f39c12;">' + textoSemPermissao + '</strong>');
        }
        return textoPopup;
      }
    }, {
      key: 'selecionarPonto',
      value: function selecionarPonto(e) {
        if (this.layer && this.getIdLayer(this.layer) !== this.getIdLayer(e.layer)) {
          this.map.closePopup();
          if (this.map.getZoom() < 17) {
            e.layer.openPopup(e.latlng);
          }
        }
        var focus = this.focusLayer(e.layer, false);
        if (focus) {
          this.atualizaScopeMenuEditar();
        }
      }
    }, {
      key: 'atualizaScopeMenuEditar',
      value: function atualizaScopeMenuEditar() {
        var _this10 = this;

        angular.element('#map-control').scope().$apply(function () {
          if (_this10.cadastroPontoConfig.permissaoDeEdicao) {
            _this10.pontosReferenciaMenuService.setFABActive('editar');
          }
        });
      }
    }, {
      key: 'atualizarLayer',
      value: function atualizarLayer(data) {
        var item = data.entidade;
        if (item) {
          this.alertMessage.create({
            type: 'success',
            message: item.texto,
            appendTo: '.alerta-aqui-ponto'
          });
          this.map.fire('click');
          this.removeLayer(this.layer);
          this.removeLayerMap(this.layer);
          if (!data.isNew) {
            var ponto = _.find(this.pontosReferencia, function (p) {
              return p.entidade.id === data.oldId;
            });
            this.unRender(ponto);
            ponto.layers = null;
            ponto.entidade = data.entidade;
            ponto.permissao = data.permissao;
            ponto.objCategoria = data.objCategoria;
          } else {
            data.isNew = false;
            this.pontosReferencia.push(data);
          }
          this.map.panTo(new L.LatLng(item.latitude, item.longitude));
        }

        if (this.layer) {
          this.latlngsOriginal = this.layer.getLatLngs()[0];
          this.layer.editing.disable();
        }
        this.mapControlService.isDrawingPontoRef = false;
        this.retangulo = null;

        this.pontosReferenciaMenuService.setFABDefault();
        this.setLayerDefault();
        this.setCategorias();
        this.setUos();
      }
    }, {
      key: 'cancelarPonto',
      value: function cancelarPonto() {
        this.pontosReferenciaMenuService.setFABDefault();
        this.setLayerDefault();
        this.removePontosProximos();
        if (this.layer && angular.isUndefined(this.layer.entidadePermissao)) {
          this.removeLayer(this.layer);
          this.removeLayerMap(this.layer);
        }
        if (this.retangulo) {
          this.drawCanceled = true;
          this.retangulo.disable();
          this.retangulo = null;
          this.desabilitarZoom();
        }
        this.mapControlService.isDrawingPontoRef = false;
      }
    }, {
      key: 'cancelarAjuste',
      value: function cancelarAjuste() {
        var item = this.layer.entidadePermissao.entidade,
            pontos = this.pontosReferenciaToolsService.geraLatLngsExternos(item.latitude, item.longitude, item.raio);

        this.layer.setLatLngs([[pontos.latlngLeftBottom.latitude, pontos.latlngLeftBottom.longitude], [pontos.latlngRightTop.latitude, pontos.latlngLeftBottom.longitude], [pontos.latlngRightTop.latitude, pontos.latlngRightTop.longitude], [pontos.latlngLeftBottom.latitude, pontos.latlngRightTop.longitude]]);
        this.layer.options.editing = false;
        this.mapControlService.isDrawingPontoRef = false;
        this.markerIn(this.getIdLayer(this.layer), [item.latitude, item.longitude]);
      }
    }, {
      key: 'eventoDrawStart',
      value: function eventoDrawStart() {
        var _this11 = this;

        this.map.on(L.Draw.Event.DRAWSTART, function () {
          _this11.layer = null;
          _this11.drawCanceled = false;
        });
      }
    }, {
      key: 'eventoDrawCanceled',
      value: function eventoDrawCanceled() {
        var _this12 = this;

        this.map.on('draw:canceled', function () {
          _this12.desabilitarZoom();
          _this12.pontosReferenciaMenuService.setFABDefault();
          _this12.setLayerDefault();
          _this12.drawCanceled = true;
          _this12.retangulo = null;
          _this12.removePontosProximos();
        });
      }
    }, {
      key: 'eventoDrawStop',
      value: function eventoDrawStop() {
        var _this13 = this;

        this.map.on(L.Draw.Event.DRAWSTOP, function () {
          if (_this13.map.hasLayer(_this13.layer)) {
            _this13.desabilitarZoom();
          } else if (_this13.map.getZoom() >= 14 && !_this13.drawCanceled && _this13.retangulo !== null) {
            _this13.retangulo.enable();
          }
        });
      }
    }, {
      key: 'eventoDrawMove',
      value: function eventoDrawMove() {
        var _this14 = this;

        this.map.on(L.Draw.Event.EDITMOVE, function (e) {
          _this14.unRenderLabels(e.layer);
          _this14.latlngsOriginal = e.layer.getLatLngs()[0];
        });
      }
    }, {
      key: 'eventoDrawResize',
      value: function eventoDrawResize() {
        var _this15 = this;

        this.map.on(L.Draw.Event.EDITRESIZE, function (e) {
          _this15.unRenderLabels(e.layer);
          var layer = e.layer,
              latlngs = _this15.pontosReferenciaToolsService.geraLatlngsResize(layer.getLatLngs()[0], _this15.latlngsOriginal),
              latlngsOriginalCentro = _this15.pontosReferenciaToolsService.geraLatLngCentro(_this15.latlngsOriginal);

          layer.setLatLngs(latlngs);
          /*eslint-disable */
          layer.editing._moveMarker.setLatLng({ lat: latlngsOriginalCentro.latitude, lng: latlngsOriginalCentro.longitude });
          /*eslint-enable */
          _this15.layer = layer;
        });
      }
    }, {
      key: 'eventoDrawCreated',
      value: function eventoDrawCreated() {
        var _this16 = this;

        this.map.on(L.Draw.Event.CREATED, function (e) {
          if (e.layerType === _this16.layerTypeEnum.RECTANGLE) {
            _this16.drawCreatedPontoReferencia(e);
          }

          if (e.layerType === _this16.layerTypeEnum.MARKER) {
            _this16.drawCreatedPontoProximo(e);
          }
        });
      }
    }, {
      key: 'drawCreatedPontoProximo',
      value: function drawCreatedPontoProximo(e) {
        var _this17 = this;

        var layer = e.layer,
            buttonsPrincipal = {
          active: 'fa fa-thumb-tack',
          resting: 'fa fa-thumb-tack'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtConfirmar',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'default',
          funcao: this.confirmarPontosProximos.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cancelarPonto.bind(this)
        }];
        this.rootScope.$apply(function () {
          return _this17.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        });
        this.pontosProximosLayers.addLayer(layer);
        this.addLayerMap(layer);

        layer.dragging.enable();

        layer.on('mouseover', function () {
          return _this17.markerPontoProximo && _this17.markerPontoProximo.disable();
        });
        layer.on('mouseout', function () {
          return _this17.markerPontoProximo && _this17.markerPontoProximo.enable();
        });

        angular.element('.' + layer.options.icon.options.className.split(' ')[1] + ' > span.label').on('click', function () {
          return _this17.removePontoProximo(layer);
        });

        this.setPontoProximo();
      }
    }, {
      key: 'excluiPontoReferencia',
      value: function excluiPontoReferencia(idPontoReferenciaDeletar) {
        this.pontosReferencia = this.pontosReferencia.filter(function (pontoRerefencia) {
          return pontoRerefencia.entidade.id !== idPontoReferenciaDeletar;
        });
      }
    }, {
      key: 'confirmarPontosProximos',
      value: function confirmarPontosProximos() {
        var _this18 = this;

        this.pontosReferenciaMenuService.setFABDefault();
        this.pontosProximosLayers.eachLayer(function (e) {
          _this18.pontosProximosLayersBackup.addLayer(e);
          e.dragging.disable();
          e.setIcon(_this18.getIconPontoProximo('<i class="fv trimble-push-pin"></i><span class="label">' + _this18.countPontosProximosBackup + '</span>', 'fix'));
          _this18.countPontosProximosBackup++;
        });
        this.pontosProximosLayers = new L.FeatureGroup();
        this.markerPontoProximo.disable();
        this.markerPontoProximo = null;

        this.pontosProximosService.setPontosProximos(this.pontosProximosLayersBackup.getLayers());
      }
    }, {
      key: 'removePontoProximo',
      value: function removePontoProximo(layer) {
        var _this19 = this;

        layer.dragging.disable();
        this.pontosReferenciaMenuService.menuOpen();
        this.timeout(function () {
          return _this19.removeLayerPontoProximo(layer);
        }, 100);
        this.setPontoProximo();

        if (this.pontosProximosLayers.getLayers().length === 0) {
          this.pontosReferenciaMenuService.menuClose();
          this.cancelarPonto();
        }
      }
    }, {
      key: 'removeLayerPontoProximo',
      value: function removeLayerPontoProximo(layer) {
        this.pontosProximosLayers.removeLayer(layer);
        this.pontosProximosLayersBackup.removeLayer(layer);
        this.removeLayerMap(layer);
      }
    }, {
      key: 'removePontosProximos',
      value: function removePontosProximos() {
        var _this20 = this;

        if (this.markerPontoProximo) {
          this.pontosProximosLayers.eachLayer(function (layer) {
            _this20.removeLayerMap(layer);
          });
          this.pontosProximosLayers = new L.FeatureGroup();
          this.markerPontoProximo.disable();
          this.markerPontoProximo = null;
        }
      }
    }, {
      key: 'removeAllPontosProximos',
      value: function removeAllPontosProximos() {
        var _this21 = this;

        this.removeDemoPontoProximo();
        this.removePontosProximos();
        this.pontosProximosLayersBackup.eachLayer(function (layer) {
          _this21.removeLayerMap(layer);
        });
        this.pontosProximosLayersBackup = new L.FeatureGroup();
        this.pontosReferenciaMenuService.setFABDefault();
        this.countPontosProximosBackup = 1;
      }
    }, {
      key: 'removeDemoPontoProximo',
      value: function removeDemoPontoProximo() {
        var _this22 = this;

        this.pontosProximosPolyline.eachLayer(function (layer) {
          return _this22.removeLayerMap(layer);
        });
        this.pontosProximosPolyline = new L.FeatureGroup();
      }
    }, {
      key: 'focusPontoProximo',
      value: function focusPontoProximo(item, layerEvento) {
        var _this23 = this;

        var linha = new L.Polyline([[item.latitude, item.longitude], [item.latitudeMarker, item.longitudeMarker]], {
          dashArray: '7, 7',
          opacity: 1,
          color: '#9775FB'
        }),
            marker = new L.Marker(new L.LatLng(item.latitude, item.longitude), {
          icon: L.divIcon({
            html: '<img src="images/icons-map/marker-pin-blue.png" class="img-icon"/>',
            iconSize: [0, 0],
            iconAnchor: [12, 37],
            popupAnchor: [0, -35]
          })
        }).bindPopup(this.popupService.build(item.evento));

        if (!layerEvento) {
          this.timeout(function () {
            return marker.openPopup();
          }, 100);
        }
        this.focusMarker(item);
        this.removeDemoPontoProximo();

        this.pontosProximosPolyline.addLayer(linha);
        this.pontosProximosPolyline.addLayer(marker);
        this.pontosProximosPolyline.eachLayer(function (layer) {
          return _this23.addLayerMap(layer);
        });
      }
    }, {
      key: 'focusMarker',
      value: function focusMarker(item) {
        var zoom = this.map.getZoom();
        this.map.setView(new L.LatLng(item.latitude, item.longitude), zoom <= 16 ? 16 : zoom);
      }
    }, {
      key: 'drawCreatedPontoReferencia',
      value: function drawCreatedPontoReferencia(e) {
        var _this24 = this;

        var DIAMETRO_MIN_EM_METROS = 20,
            DIAMETRO_MAX_EM_METROS = 400;
        this.desabilitarZoom();
        this.pontosReferenciaMenuService.menuOpen();

        var layer = e.layer,
            latlngs = layer.getLatLngs()[0],
            difLatMetros = geolib.getDistance({ latitude: latlngs[0].lat, longitude: latlngs[0].lng }, { latitude: latlngs[1].lat, longitude: latlngs[1].lng }, 1, 3),
            buttonsPrincipal = {
          active: 'fa fa-pencil-square-o',
          resting: 'fa fa-pencil-square-o'
        },
            buttons = [{
          titulo: 'ce.mapa.common.tituloBtConfirmar',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'adicionar',
          funcao: this.confirmarNovoPonto.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cancelarPonto.bind(this)
        }];

        this.rootScope.$apply(function () {
          return _this24.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
        });
        layer.setLatLngs(this.pontosReferenciaToolsService.retornaPontosComDistancia(latlngs, Math.max(DIAMETRO_MIN_EM_METROS, Math.min(DIAMETRO_MAX_EM_METROS, difLatMetros))));

        layer.options.editing = true;
        this.mapControlService.isDrawingPontoRef = true;
        this.latlngsOriginal = latlngs;

        this.addLayer(layer);
        this.addLayerMap(layer);
        layer.editing.enable();

        this.layer = layer;
      }
    }, {
      key: 'confirmarNovoPonto',
      value: function confirmarNovoPonto() {
        this.pontosReferenciaMenuService.drawerClose();
        var latlngCentro = this.pontosReferenciaToolsService.geraLatLngCentro(this.layer.getLatLngs()[0]),
            raio = this.pontosReferenciaToolsService.geraDiametro(this.layer.getLatLngs()[0]) / 2,
            posicao = { lat: latlngCentro.latitude, lng: latlngCentro.longitude, raio: raio };

        this.openModalCreatePontoReferencia(posicao);
      }
    }, {
      key: 'openModalCreatePontoReferencia',
      value: function openModalCreatePontoReferencia(posicao) {
        var _this25 = this;

        if (this.featureFlag.DIALOG_PONTO_REESTRUTURADO) {
          /* eslint-disable */
          var abrirModal = document.querySelector('#dialog-create-ponto'),
              modal = document.createElement('vfwc-open-dialog-create-ponto-referencia'),
              advisorSuggestion = posicao.advisorSuggestion;
          /* eslint-enable */
          modal.pontoReferencia = {
            latitude: Number.parseFloat(posicao.lat),
            longitude: Number.parseFloat(posicao.lng),
            raio: Math.round(posicao.raio),
            rotogramas: []
          };
          modal.uoFiltro = this.uoSelecionadaParaNovoPonto();
          modal.usuario = this.user;
          modal.advisorSuggestion = advisorSuggestion;
          abrirModal.appendChild(modal);
          this.onPontoCreated(modal, advisorSuggestion);
        } else {
          this.modalService.open({
            animation: true,
            component: 'modalEdicaoPontoReferencia',
            backdrop: 'static',
            openedClass: 'modal-edicao-ponto-referencia',
            resolve: {
              pontoReferencia: function pontoReferencia() {
                return {
                  latitude: Number.parseFloat(posicao.lat),
                  longitude: Number.parseFloat(posicao.lng),
                  raio: Math.round(posicao.raio)
                };
              },
              rotogramas: function rotogramas() {
                return [];
              },
              uoSelecionada: function uoSelecionada() {
                return _this25.uoSelecionadaParaNovoPonto();
              },
              advisorSuggestion: function advisorSuggestion() {
                return posicao.advisorSuggestion;
              }
            }
          }).result.then(function (data) {
            return _this25.atualizaPonto(data);
          });
        }
      }
    }, {
      key: 'onPontoCreated',
      value: function onPontoCreated(element, advisorSuggestion) {
        var _this26 = this;

        element.addEventListener('pontoReferenciaEventEmitter', function (event) {
          if (event.detail && event.detail.result) {
            var data = event.detail.result;
            _this26.atualizaPonto(data);
            if (data.rotogramas && data.rotogramas.length) {
              _this26.rootScope.$broadcast('rotogramasCadastrados', {
                rotogramas: data.rotogramas,
                pontoReferenciaId: data.entidade.id
              });
              if (advisorSuggestion) {
                _this26.rootScope.$broadcast('advisorAtualizado');
              }
            }
          }
        });
      }
    }, {
      key: 'focusLocal',
      value: function focusLocal(item) {
        this.map.setView(new L.LatLng(item.lat, item.lng), 18);
      }
    }, {
      key: 'renderAdvisorSuggestion',
      value: function renderAdvisorSuggestion(posicao, advisorSuggestion) {
        var _this27 = this;

        var slowerSpeed = this.getSlowestSpeed(advisorSuggestion),
            latLngsExternos = this.pontosReferenciaToolsService.geraLatLngsExternos(posicao.lat, posicao.lng, posicao.raio),
            advisorArea = L.rectangle([[latLngsExternos.latlngLeftBottom.latitude, latLngsExternos.latlngLeftBottom.longitude], [latLngsExternos.latlngRightTop.latitude, latLngsExternos.latlngRightTop.longitude]], {
          color: '#000000',
          weight: 0,
          fillOpacity: 0.4,
          editing: false
        });

        this.lastLayerSuggestionClicked = L.layerGroup([advisorArea], { id: 'advisor-selected-group' });
        if (slowerSpeed) {
          var markerVelocidade = this.buildMarkerLimite(posicao.lat, posicao.lng, slowerSpeed, 'advisor-vel-selected', this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value);
          markerVelocidade.setOpacity(1);
          this.lastLayerSuggestionClicked.addLayer(markerVelocidade);
        }

        this.addLayerMap(this.lastLayerSuggestionClicked);
        this.map.on('zoomend', function () {
          var opacity = _this27.map.getZoom() >= 15 ? 1 : 0;
          _this27.lastLayerSuggestionClicked.getLayers().filter(function (layer) {
            return layer instanceof L.Marker;
          }).forEach(function (layer) {
            return layer.setOpacity(opacity);
          });
        });
      }
    }, {
      key: 'getSlowestSpeed',
      value: function getSlowestSpeed(advisorSuggestion) {
        return advisorSuggestion.velocidadeInterna ? _.min(Object.values(advisorSuggestion.velocidadeInterna)) : null;
      }
    }, {
      key: 'unrenderAdvisorSuggestion',
      value: function unrenderAdvisorSuggestion() {
        if (this.lastLayerSuggestionClicked) {
          this.removeLayerMap(this.lastLayerSuggestionClicked);
        }
      }
    }, {
      key: 'uoSelecionadaParaNovoPonto',
      value: function uoSelecionadaParaNovoPonto() {
        var config = this.cadastroPontoConfig;
        if (config && config.uoDaRegra && config.permissaoDeEdicao) {
          return config.uoDaRegra.id;
        }
        return this.pontosReferenciaService.user.uo.id;
      }
    }, {
      key: 'atualizaPonto',
      value: function atualizaPonto(data) {
        this.removeLayer(this.layer);
        this.removeLayerMap(this.layer);
        this.atualizarLayer(data);
        if (data.entidade.limiteVelocidade) {
          var marker = this.buildMarkerLimite(data.entidade.latitude, data.entidade.longitude, data.entidade.limiteVelocidade, this.getIdLayer(this.layer));
          this.addLayer(marker);
          this.addLayerMap(marker);
          if (this.map.getZoom() >= 15) {
            marker.setOpacity(1);
          }
        }
      }
    }, {
      key: 'mapearMarcador',
      value: function mapearMarcador(posicao, pontoReferencia) {
        if (posicao.key === this.posicoesRotogramas.CENTRO.key) {
          return L.marker([pontoReferencia.latitude, pontoReferencia.longitude], {
            icon: L.divIcon({ className: 'icon-rotograma' }),
            posicao: posicao
          });
        }
        var latLngRotograma = this.pontosReferenciaToolsService.geraLatLngsRotograma(posicao.anguloInicial, pontoReferencia.raio, pontoReferencia.latitude, pontoReferencia.longitude);
        return L.marker([latLngRotograma.latlng.latitude, latLngRotograma.latlng.longitude], {
          icon: L.divIcon({ className: 'icon-rotograma' }),
          draggable: true,
          posicao: posicao
        });
      }
    }, {
      key: 'iniciaEventos',
      value: function iniciaEventos() {
        this.eventoDrawStart();
        this.eventoDrawCanceled();
        this.eventoDrawStop();
        this.eventoDrawMove();
        this.eventoDrawResize();
        this.eventoDrawCreated();
      }
    }, {
      key: 'geraLabelPorZoom',
      value: function geraLabelPorZoom(layer) {
        var latLngLabel = this.pontosReferenciaToolsService.geraLatLngsLabel(layer.ponto.raio, layer.ponto.latitude, layer.ponto.longitude),
            label = void 0,
            labels = [],
            infosPonto = {
          latitude: latLngLabel.latitude,
          longitude: latLngLabel.longitude,
          nome: layer.ponto.nome,
          raio: layer.ponto.raio,
          id: layer.ponto.id
        };

        label = this.buildMarkerLabel(infosPonto);
        this.addLayer(label);
        this.addLayerMap(label);
        label.setZIndexOffset(-1001);

        if (angular.isDefined(layer.labels)) {
          layer.labels[this.map.getZoom()] = label;
        } else {
          labels[this.map.getZoom()] = label;
          layer.labels = labels;
        }
        label.bindPopup(this.getTextoPopUp(layer.ponto.nome, layer.entidadePermissao));
        return label;
      }
    }, {
      key: 'renderLabels',
      value: function renderLabels(layer) {
        var _this28 = this;

        if (this.map.getZoom() >= 17 && angular.isDefined(layer.ponto)) {
          if (this.shouldRenderLabel(layer.entidadePermissao) && angular.isDefined(layer.ponto.nome)) {
            if (angular.isUndefined(layer.labels) || angular.isUndefined(layer.labels[this.map.getZoom()])) {
              this.geraLabelPorZoom(layer).setOpacity(1);
            }
            if (angular.isDefined(layer.labels)) {
              layer.labels.forEach(function (label, index) {
                if (index !== _this28.map.getZoom()) {
                  label.setOpacity(0);
                  _this28.removeLayer(label);
                  _this28.removeLayerMap(label);
                } else {
                  _this28.addLayer(label);
                  _this28.addLayerMap(label);
                  label.setOpacity(1);
                }
              });
            }
          }
        } else if (angular.isDefined(layer.labels)) {
          this.unRenderLabels(layer);
        }
      }
    }, {
      key: 'eventoZoomEnd',
      value: function eventoZoomEnd() {
        var _this29 = this;

        this.map.on('zoomend', function () {
          _this29.editableLayers.eachLayer(function (layer) {
            _this29.renderLabels(layer);
            _this29.popUpControl(layer);
            if (angular.isDefined(layer.options.id) && !_this29.markerEditing(layer)) {
              if (_this29.map.getZoom() >= 15) {
                layer.setOpacity(1);
              } else {
                layer.setOpacity(0);
              }
            }
          });
        });
      }
    }, {
      key: 'eventoGeral',
      value: function eventoGeral() {
        var _this30 = this;

        this.eventoZoomEnd();

        this.editableLayers.on('contextmenu', function (e) {
          return _this30.exibirVelocidadeVia(e.latlng.lat, e.latlng.lng);
        });
        this.map.on('contextmenu', function (e) {
          return _this30.exibirVelocidadeVia(e.latlng.lat, e.latlng.lng);
        });

        this.eventoClickLayer();
      }
    }, {
      key: 'popUpControl',
      value: function popUpControl(layerPonto) {
        if (angular.isDefined(layerPonto.entidadePermissao)) {
          if (layerPonto.entidadePermissao.permissao.edicao && this.map.getZoom() >= 17) {
            layerPonto.closePopup();
          }
        }
      }
    }, {
      key: 'eventoClickLayer',
      value: function eventoClickLayer() {
        var _this31 = this;

        this.editableLayers.on('click', function (e) {
          _this31.popUpControl(e.layer);

          if (_this31.pontosReferenciaService.roleVisualizarRotograma && e.layer instanceof L.Marker) {
            _this31.exibirRotograma(e);
          }
          if (_this31.pontosReferenciaService.roleCadastrar && e.layer instanceof L.Rectangle) {
            _this31.exibirPontoReferencia(e);
          }
          if (e.layer.options.label) {
            _this31.getPontoReferencia({ entidade: { id: e.layer.options.idPonto } });
          }
        });
      }
    }, {
      key: 'exibirRotograma',
      value: function exibirRotograma(e) {
        if (e.layer.options.id && e.layer.options.idRotograma) {
          this.modalService.open({
            component: 'modalDetalhesRotograma',
            backdrop: 'static',
            resolve: {
              id: function id() {
                return e.layer.options.idRotograma;
              },
              velocidade: function velocidade() {
                return e.layer.options.velocidade;
              },
              audio: function audio() {
                return e.layer.options.audio;
              },
              status: function status() {
                return e.layer.options.status;
              }
            }
          });
        }
      }
    }, {
      key: 'exibirPontoReferencia',
      value: function exibirPontoReferencia(e) {
        if (angular.isUndefined(e.layer.options.id) && e.layer.entidadePermissao.permissao.edicao && !this.hasEditableLayers() && !this.mapControlService.isDrawingCercaEletronica) {
          this.rootScope.$broadcast('limpaSelecaoCercaEletronica');
          this.selecionarPonto(e);
        }
      }
    }, {
      key: 'centerPontoId',
      value: function centerPontoId(pontoId) {
        this.pontosReferenciaMenuService.limpaClassePesquisa();
        this.removeDemoPontoProximo();
        this.removePontosProximos();

        var ponto = _.find(this.pontosReferencia, function (p) {
          return p.entidade.id === pontoId;
        });

        if (angular.isDefined(ponto)) {
          this.map.setView(new L.LatLng(ponto.entidade.latitude, ponto.entidade.longitude), 14, { animate: false });
          this.mostrarPontosBoundsAtual();
          this.getPontoReferencia(ponto);
        } else {
          this.modalService.open({
            animation: true,
            controller: 'FocusPontoReferenciaModalCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'directives/map-control/focus-ponto-referencia/focus-ponto-referencia-modal.tpl.html'
          });
        }
      }
    }, {
      key: 'focusPonto',
      value: function focusPonto(item) {
        this.rootScope.$broadcast('limpaSelecaoCercaEletronica');
        this.pontosReferenciaMenuService.limpaClassePesquisa();
        this.removeDemoPontoProximo();
        this.removePontosProximos();

        var zoom = this.map.getZoom();
        this.map.setView(new L.LatLng(item.entidade.latitude, item.entidade.longitude), zoom <= 15 ? 15 : zoom);
        this.mostrarPontosBoundsAtual();

        this.getPontoReferencia(item);
      }
    }, {
      key: 'getEntidadePermissao',
      value: function getEntidadePermissao() {
        return this.editableLayers.getLayers().filter(function (x) {
          return x.entidadePermissao;
        });
      }
    }, {
      key: 'setUos',
      value: function setUos() {
        this.pontosReferenciaService.uos = this.getEntidadePermissao().filter(function (item) {
          return item.entidadePermissao.permissao.uo;
        }).filter(function (item, index, self) {
          return index === self.findIndex(function (t) {
            return t.entidadePermissao.permissao.uo.id === item.entidadePermissao.permissao.uo.id;
          });
        }).map(function (x) {
          return x.entidadePermissao.permissao.uo;
        });
      }
    }, {
      key: 'setCategorias',
      value: function setCategorias() {
        this.pontosReferenciaService.categorias = this.getEntidadePermissao().filter(function (item, index, self) {
          return index === self.findIndex(function (t) {
            return t.entidadePermissao.objCategoria.id === item.entidadePermissao.objCategoria.id;
          });
        }).map(function (x) {
          return x.entidadePermissao.objCategoria;
        });
      }
    }, {
      key: 'setPontosReferencia',
      value: function setPontosReferencia(pontosReferencia, categorias, pontoId) {
        this.pontosReferenciaService.uos = _.uniq(pontosReferencia, function (t) {
          return t.permissao.uo.id;
        }).map(function (x) {
          return x.permissao.uo;
        });
        this.pontosReferenciaFiltroService.loadFiltroFromLocalStorage();

        this.responseCategorias(categorias);
        this.responsePontos(pontosReferencia, pontoId);
      }
    }, {
      key: 'recarregaPontos',
      value: function recarregaPontos() {
        this.mostrarPontosBoundsAtual();
        this.pesquisa = '';
        this.pontos = [];
      }
    }, {
      key: 'removerLayersRotogramas',
      value: function removerLayersRotogramas(rotogramaIds) {
        var _this32 = this;

        var ids = new Set(rotogramaIds);
        this.editableLayers.getLayers().filter(function (layer) {
          return layer instanceof L.Marker && ids.has(layer.options.idRotograma);
        }).forEach(function (layer) {
          _this32.editableLayers.removeLayer(layer);
          _this32.map.removeLayer(layer);
        });
      }
    }, {
      key: 'responsePontos',
      value: function responsePontos(pontosReferencia, idPonto) {
        this.pontosReferencia = pontosReferencia;
        this.mostrarPontosBoundsAtual();
        if (idPonto) {
          this.centerPontoId(parseInt(idPonto, 10));
        }
      }
    }, {
      key: 'getLayersPontoReferencia',
      value: function getLayersPontoReferencia(item) {
        var _this33 = this;

        var ponto = item.entidade,
            objCategoria = this.categoriasById[ponto.categoria] && this.categoriasById[ponto.categoria][0] ? this.categoriasById[ponto.categoria][0] : this.pontosCategoriaReferenciaService.categoriaDefault,
            retangulo = void 0,
            pontos = this.pontosReferenciaToolsService.geraLatLngsExternos(ponto.latitude, ponto.longitude, ponto.raio),
            layers = [];

        retangulo = new L.Rectangle([[pontos.latlngLeftBottom.latitude, pontos.latlngLeftBottom.longitude], [pontos.latlngRightTop.latitude, pontos.latlngRightTop.longitude]], { color: objCategoria.cor, weight: 0, fillOpacity: 0.4, editing: false });

        item.objCategoria = objCategoria;

        retangulo.ponto = ponto;
        retangulo.entidadePermissao = item;
        retangulo.bindPopup(this.getTextoPopUp(ponto.nome, retangulo.entidadePermissao));
        layers.push(retangulo);

        if (ponto.limiteVelocidade) {
          layers.push(this.buildMarkerLimite(ponto.latitude, ponto.longitude, ponto.limiteVelocidade, this.getIdLayer(retangulo)));
        }

        if (this.pontosReferenciaService.roleVisualizarRotograma && this.hasRotogramas(retangulo.entidadePermissao)) {
          this.pontosReferenciaService.rotograma = true;
          var pontosComAudioOuVelocidade = ponto.rotogramas.filter(function (r) {
            return !(!r.audio && r.isVelocidadeExcluida);
          });
          pontosComAudioOuVelocidade.forEach(function (rotograma) {
            layers.push(_this33.getMarkerRotograma(_this33.getIdLayer(retangulo), rotograma, ponto));
          });
        }
        return layers;
      }
    }, {
      key: 'shouldRender',
      value: function shouldRender(item) {
        return this.map.getBounds().contains(L.latLng(item.entidade.latitude, item.entidade.longitude)) && this.pontosReferenciaFiltroService.isPontoVisible(item) && !item.rendered;
      }
    }, {
      key: 'shouldRenderLabel',
      value: function shouldRenderLabel(item) {
        return this.map.getBounds().contains(L.latLng(item.entidade.latitude, item.entidade.longitude)) && this.pontosReferenciaFiltroService.isPontoVisible(item);
      }
    }, {
      key: 'shouldUnrender',
      value: function shouldUnrender(item) {
        return (!this.map.getBounds().contains(L.latLng(item.entidade.latitude, item.entidade.longitude)) || !this.pontosReferenciaFiltroService.isPontoVisible(item)) && item.rendered;
      }
    }, {
      key: 'render',
      value: function render(item) {
        var _this34 = this;

        if (!item.layers) {
          item.layers = this.getLayersPontoReferencia(item);
        }
        item.layers.forEach(function (layer) {
          if (angular.isDefined(layer.options.id) && !_this34.markerEditing(layer)) {
            if (_this34.map.getZoom() >= 15) {
              layer.setOpacity(1);
            } else {
              layer.setOpacity(0);
            }
          }
          _this34.addLayer(layer);
          _this34.addLayerMap(layer);
          _this34.renderLabels(layer);
        });
        item.rendered = true;
      }
    }, {
      key: 'unRender',
      value: function unRender(item) {
        var _this35 = this;

        if (item && item.layers) {
          item.layers.forEach(function (layer) {
            _this35.unRenderLabels(layer);
            _this35.removeLayer(layer);
            _this35.removeLayerMap(layer);
          });
          item.rendered = false;
        }
      }
    }, {
      key: 'unRenderLabels',
      value: function unRenderLabels(layer) {
        var _this36 = this;

        if (angular.isDefined(layer.labels)) {
          layer.labels.map(function (label) {
            label.setOpacity(0);
            _this36.removeLayer(label);
            _this36.removeLayerMap(label);
          });
        }
      }
    }, {
      key: 'mostrarPontosBoundsAtual',
      value: function mostrarPontosBoundsAtual() {
        var _this37 = this;

        if (this.map.getZoom() >= ZOOM_MINIMO_RENDER_MARKER) {
          this.pontosReferencia.forEach(function (item) {
            if (_this37.shouldRender(item)) {
              var rawName = item.entidade.nome,
                  sanitizedName = _this37.$sanitize(rawName);
              item.entidade.nome = sanitizedName;
              _this37.render(item);
              _this37.pontosRendered.push(item);
            } else if (_this37.shouldUnrender(item)) {
              _this37.unRender(item);
              _this37.pontosRendered = _this37.pontosRendered.filter(function (i) {
                return item.entidade.id !== i.entidade.id;
              });
            }
          });
        } else {
          this.pontosRendered.forEach(function (item) {
            return _this37.unRender(item);
          });
          this.pontosRendered = [];
        }
      }
    }, {
      key: 'responseCategorias',
      value: function responseCategorias(categorias) {
        this.pontosReferenciaService.categorias = [this.pontosCategoriaReferenciaService.categoriaDefault].concat(categorias);
        this.categoriasById = _.groupBy(categorias.plain(), function (cat) {
          return cat.id;
        });
      }
    }, {
      key: 'clearMarkers',
      value: function clearMarkers() {
        var _this38 = this;

        this.pontosRendered.forEach(function (item) {
          return _this38.unRender(item);
        });
        this.pontosRendered = [];
        this.pontosReferencia = [];
      }
    }, {
      key: 'removePontoAndAllMarkers',
      value: function removePontoAndAllMarkers(pontoId) {
        var ponto = this.pontosReferencia.find(function (p) {
          return p.entidade.id === pontoId;
        });
        if (ponto.rendered) {
          this.unRender(ponto);
        }
        this.excluiPontoReferencia(pontoId);
        this.recarregaPontos();
      }
    }]);

    return PontosReferenciaMap;
  }();

  angular.module('mapControlModule').service('PontosReferenciaMap', PontosReferenciaMap);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PontosReferenciaFiltro = function () {
    function PontosReferenciaFiltro($window, PontosReferencia, CategoriaPontosReferencia, AlertMessage, PesquisaPontoReferenciaService, $translate) {
      _classCallCheck(this, PontosReferenciaFiltro);

      this.window = $window;
      this.pontosReferenciaService = PontosReferencia;
      this.pontosCategoriaReferenciaService = CategoriaPontosReferencia;
      this.alertMessage = AlertMessage;
      this.translate = $translate;

      this.filtroSelecionado = null;
      this.filtroSelecionadoLocalstorage = null;
      this.filtrosDisponiveis = [];
      this.filterObject = [];
      this.idLayers = [];
      this.pontos = [];
      this.selecionarFiltro = false;
      this.pesquisaService = PesquisaPontoReferenciaService;
    }

    _createClass(PontosReferenciaFiltro, [{
      key: 'init',
      value: function init() {
        this.filtroSelecionado = null;
        this.filtroSelecionadoLocalstorage = null;
        this.filtrosDisponiveis = this.getFiltrosDisponiveis();
      }
    }, {
      key: 'getFiltrosDisponiveis',
      value: function getFiltrosDisponiveis() {
        return [{
          titulo: this.translate.instant('ce.mapa.common.modal.checkBoxPontoReferencia.filtroUO'),
          lista: this.pontosReferenciaService.uos,
          key: 'uo',
          tipo: 'checkbox',
          total: this.pontosReferenciaService.uos && this.pontosReferenciaService.uos.length || 0,
          selecionado: this.getFiltroByKeyOrDefault('uo', { key: 'uo', itensEscondidos: [] }).itensEscondidos.length
        }, {
          titulo: this.translate.instant('ce.mapa.common.modal.checkBoxPontoReferencia.filtroCategorias'),
          lista: this.pontosReferenciaService.categorias,
          key: 'categoria',
          tipo: 'checkbox',
          total: this.pontosReferenciaService.categorias && this.pontosReferenciaService.categorias.length || 0,
          selecionado: this.getFiltroByKeyOrDefault('categoria', { key: 'categoria', itensEscondidos: [] }).itensEscondidos.length
        }, {
          titulo: this.translate.instant('ce.mapa.common.modal.checkBoxPontoReferencia.filtroPalavrasChave'),
          key: 'palavra',
          tipo: 'input',
          total: this.getFiltroByKeyOrDefault('palavra', { key: 'palavra', itensEscondidos: [] }).itensEscondidos.length
        }];
      }
    }, {
      key: 'salvarFiltroLocalstorage',
      value: function salvarFiltroLocalstorage(message) {
        if (this.filterObject.length > 0) {
          this.window.localStorage.setItem('filtro-ponto-referencia-' + this.pontosReferenciaService.user.id, angular.toJson(this.filterObject));
        } else {
          this.window.localStorage.removeItem('filtro-ponto-referencia-' + this.pontosReferenciaService.user.id);
        }

        this.alertMessage.create({
          type: 'success',
          message: message,
          appendTo: '.alerta-aqui-ponto'
        });

        this.setValueItensLocalstorage();
      }
    }, {
      key: 'setValueItensLocalstorage',
      value: function setValueItensLocalstorage() {
        this.filtrosDisponiveis = this.getFiltrosDisponiveis();
      }
    }, {
      key: 'loadFiltroFromLocalStorage',
      value: function loadFiltroFromLocalStorage() {
        this.filterObject = angular.fromJson(this.window.localStorage.getItem('filtro-ponto-referencia-' + this.pontosReferenciaService.user.id)) || [];
        this.setValueItensLocalstorage();
      }
    }, {
      key: 'verificaLocalStorage',
      value: function verificaLocalStorage() {
        return this.filterObject.find(function (x) {
          return angular.isDefined(x.itensEscondidos) && x.itensEscondidos.length > 0;
        });
      }
    }, {
      key: 'verificaFiltroLocalstorage',
      value: function verificaFiltroLocalstorage() {
        var tipoFiltroSelecionado = this.getFiltroByKeyOrDefault(this.filtroSelecionado.key);

        if (angular.isUndefined(tipoFiltroSelecionado) || tipoFiltroSelecionado.itensEscondidos.length === 0) {
          this.filtroSelecionado.lista.forEach(function (x) {
            return x.check = true;
          });
        } else if (tipoFiltroSelecionado.itensEscondidos.length > 0) {
          this.filtroSelecionado.lista.forEach(function (x) {
            x.check = angular.isUndefined(tipoFiltroSelecionado.itensEscondidos.find(function (y) {
              return y === x.id;
            }));
          });
        }
      }

      /**
       * Verifica se o atributo da entidade é filtrado
       * @param  {string | number} categoria atributo da entidade
       * @param  {string | number} item item do filtro
       * @param  {boolean} contains utiliza o filtro escondido como contain(inverte verificação)
       * @return {boolean}      deve exibir a entidade ou não baseado no filtro
       */

    }, {
      key: 'isVisible',
      value: function isVisible(categoria, item) {
        var contains = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (categoria && categoria.itensEscondidos.length > 0) {
          return contains ? angular.isDefined(categoria.itensEscondidos.find(function (x) {
            return item.toLowerCase().includes(x);
          })) : angular.isUndefined(categoria.itensEscondidos.find(function (x) {
            return x === item;
          }));
        }
        return true;
      }
    }, {
      key: 'isPontoVisible',
      value: function isPontoVisible(ponto) {
        if (ponto && this.isVisible(this.getFiltroByKeyOrDefault('uo'), ponto.permissao.uo.id) && this.isVisible(this.getFiltroByKeyOrDefault('categoria'), ponto.entidade.categoria || 0) && this.isVisible(this.getFiltroByKeyOrDefault('palavra'), ponto.entidade.nome, true)) {
          return true;
        }

        return false;
      }
    }, {
      key: 'isCercaVisible',
      value: function isCercaVisible(area) {
        if (area && this.isVisible(this.getFiltroByKeyOrDefault('uo'), area.uoId) && this.isVisible(this.getFiltroByKeyOrDefault('categoria'), area.categoriaId || 0) && this.isVisible(this.getFiltroByKeyOrDefault('palavra'), area.nome, true)) {
          return true;
        }

        return false;
      }
    }, {
      key: 'verificaLayer',
      value: function verificaLayer(layer) {
        if (layer.entidadePermissao && layer.entidadePermissao.permissao.uo && this.isVisible(this.getFiltroByKeyOrDefault('uo'), layer.entidadePermissao.permissao.uo.id, false) && this.isVisible(this.getFiltroByKeyOrDefault('categoria'), layer.entidadePermissao.objCategoria.id, false) && this.isVisible(this.getFiltroByKeyOrDefault('palavra'), layer.entidadePermissao.entidade.nome, true)) {
          return true;
        }
        return false;
      }

      /**
       * Monta filtro baseado na categoria(escolha de atributo da entidade)
       * @param  {string} key parametro do filtro relacionado ao atributo de filtro[nome, categoria, palavra chave]
       * @param  {object} defaultWhenNotFound retorno default caso não encontre filtro
       * @return {object}      retorna objeto de filtro {key: string, itensEscondidos: string[] | number[]}
       */

    }, {
      key: 'getFiltroByKeyOrDefault',
      value: function getFiltroByKeyOrDefault(key, defaultWhenNotFound) {
        var filter = this.filterObject.find(function (x) {
          return x.key === key;
        });
        if (angular.isUndefined(filter)) {
          return defaultWhenNotFound;
        }
        if (angular.isUndefined(filter.itensEscondidos)) {
          filter.itensEscondidos = [];
        }
        return filter;
      }
    }, {
      key: 'salvarFiltroItensEscondidos',
      value: function salvarFiltroItensEscondidos(key, lista) {
        var filtro = this.getFiltroByKeyOrDefault(key);

        if (filtro) {
          filtro.itensEscondidos = lista;
        } else {
          this.filterObject.push({
            key: key,
            itensEscondidos: lista
          });
        }

        this.idLayers = [];
        this.pontos = [];
        this.pesquisaService.pontos = [];

        this.salvarFiltroLocalstorage(this.translate.instant('ce.mapa.common.modal.checkBoxPontoReferencia.filtroSucesso'));
      }
    }, {
      key: 'limparFiltro',
      value: function limparFiltro() {
        this.pontos = [];
        this.idLayers = [];
        this.filterObject = [];
        this.filtroSelecionado = null;
        this.selecionarFiltro = false;
        this.salvarFiltroLocalstorage(this.translate.instant('ce.mapa.common.modal.checkBoxPontoReferencia.filtroFalha'));
      }
    }]);

    return PontosReferenciaFiltro;
  }();

  angular.module('mapControlModule').service('PontosReferenciaFiltro', PontosReferenciaFiltro);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CategoriaPontosReferencia = function () {
    function CategoriaPontosReferencia(Restangular, HttpServiceV3g, AGRUPAMENTO_EQUIPAMENTO) {
      _classCallCheck(this, CategoriaPontosReferencia);

      this.restangular = Restangular;
      this.httpService = HttpServiceV3g;
      this.agrupamentoDeEquipamentos = AGRUPAMENTO_EQUIPAMENTO;
      this.categoriaDefault = { id: 0, nome: 'Sem categoria', cor: '#000000' };
    }

    _createClass(CategoriaPontosReferencia, [{
      key: 'getListCategoriasPontoReferencia',
      value: function getListCategoriasPontoReferencia() {
        return this.restangular.all('ponto-referencia/categorias-ponto-referencia').getList();
      }
    }, {
      key: 'getCategoriaPontoReferencia',
      value: function getCategoriaPontoReferencia(categoriaId) {
        return this.restangular.one('ponto-referencia/categorias-ponto-referencia/' + categoriaId).get();
      }
    }, {
      key: 'postCategoriaPontoReferencia',
      value: function postCategoriaPontoReferencia(item) {
        return this.restangular.all('ponto-referencia/categorias-ponto-referencia').post(item);
      }
    }, {
      key: 'putCategoriaPontoReferencia',
      value: function putCategoriaPontoReferencia(item) {
        return this.restangular.all('ponto-referencia/categorias-ponto-referencia/' + item.id).customPUT(item);
      }
    }, {
      key: 'deleteCategoriaPontoReferencia',
      value: function deleteCategoriaPontoReferencia(categoriaId) {
        return this.restangular.all('ponto-referencia/categorias-ponto-referencia/' + categoriaId).remove();
      }
    }, {
      key: 'getCategoriaAudios',
      value: function getCategoriaAudios(uoId) {
        return this.restangular.all('ponto-referencia/v2/categoria-audio').getList({ uoId: uoId });
      }
    }, {
      key: 'hasVtalks',
      value: function hasVtalks() {
        return this.restangular.one('veiculo/v2/veiculos').get({
          agrupamentosEquipamentos: this.agrupamentoDeEquipamentos.VTALKS,
          size: 1
        }).then(function (responseVeiculos) {
          return Boolean(responseVeiculos.numberOfElements);
        });
      }
    }]);

    return CategoriaPontosReferencia;
  }();

  angular.module('mapControlModule').service('CategoriaPontosReferencia', CategoriaPontosReferencia);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalDetalhesRotogramaCtrl = function () {
    function ModalDetalhesRotogramaCtrl(PontosReferencia, AlertMessage, ControleVelocidadeRotograma, $translate) {
      _classCallCheck(this, ModalDetalhesRotogramaCtrl);

      this.pontoReferenciaService = PontosReferencia;
      this.alertMessage = AlertMessage;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.translate = $translate;

      this.KEEP_SPEED_STATUS = [this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR.value, this.controleVelocidadeRotograma.KEEP_SPEED_AND_AUDIO.value];
    }

    _createClass(ModalDetalhesRotogramaCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.velocidadePadrao = this.resolve.velocidade;
        this.audio = this.resolve.audio ? this.resolve.audio.nome : null;
        this.status = this.resolve.status;
        this.pontoReferenciaService.getRotograma(this.resolve.id).then(function (data) {
          _this.model = data.plain();
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: _this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.errorCarregarRotograma'),
            appendTo: '.alerta-aqui-rotograma-ponto'
          });
        });
      }
    }, {
      key: 'getTitle',
      value: function getTitle() {
        if (this.audio && this.velocidadePadrao || this.controleVelocidadeRotograma.KEEP_SPEED_AND_AUDIO.value === this.status) {
          return 'ce.mapa.common.modal.modalDetalhesRotograma.tituloVelocidadeEAudio';
        }
        if (this.audio) {
          return 'ce.mapa.common.modal.modalDetalhesRotograma.tituloAudio';
        }
        return 'ce.mapa.common.modal.modalDetalhesRotograma.titulo';
      }
    }, {
      key: 'getDescricao',
      value: function getDescricao() {
        var speedDescription = this.velocidadePadrao ? '<p>' + this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoPadrao') + ': <strong>' + this.velocidadePadrao + ' km/h</strong></p>' : '',
            audioDescription = this.audio ? '<p>' + this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoAudio') + ': <strong>' + this.audio + '</strong></p>' : '';

        if (this.KEEP_SPEED_STATUS.includes(this.status)) {
          var keepSpeedDescription = '<p>' + this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoVelocidadeAnterior') + '</p>';
          if (this.audio) {
            return keepSpeedDescription + '<br>' + audioDescription;
          }
          return keepSpeedDescription;
        }

        return speedDescription + audioDescription;
      }
    }]);

    return ModalDetalhesRotogramaCtrl;
  }();

  angular.module('mapControlModule').component('modalDetalhesRotograma', {
    controller: ModalDetalhesRotogramaCtrl,
    templateUrl: 'directives/map-control/rotograma-ponto-referencia/modal-detalhes-rotograma.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('rotogramaModule', ['mousewheelDirectiveModule', 'pascalprecht.translate', 'restangular', 'alert-message']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ANGULO_MINIMO_RADIANOS = 0.610865,
      PRECISAO_UNITARIA = 1,
      PRECISAO_CENTIMETROS = 3;

  /* global geolib, _, L */

  var RotogramaMapService = function () {
    function RotogramaMapService(PosicoesRotogramas, ControleVelocidadeRotograma, $timeout) {
      _classCallCheck(this, RotogramaMapService);

      this.posicoesRotogramas = PosicoesRotogramas;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.timeout = $timeout;
      this.rotogramaMarkers = [];
    }

    _createClass(RotogramaMapService, [{
      key: 'setLatLngPontoReferencia',
      value: function setLatLngPontoReferencia(latLngBaseEsquerda, latLngTopoDireita) {
        this.pontoReferenciaLatLngs = {
          latLngBaseEsquerda: { lat: latLngBaseEsquerda[0], lng: latLngBaseEsquerda[1] },
          latLngTopoDireita: { lat: latLngTopoDireita[0], lng: latLngTopoDireita[1] }
        };
      }
    }, {
      key: 'adicionarMarker',
      value: function adicionarMarker(marker, posicao) {
        if (posicao.key === this.posicoesRotogramas.CENTRO.key) {
          this.centro = marker;
        } else {
          this.rotogramaMarkers.push({ marker: marker, posicao: posicao, posicaoAnterior: marker.getLatLng() });
        }
      }
    }, {
      key: 'encerrarCadastro',
      value: function encerrarCadastro() {
        this.rotogramaMarkers = [];
        this.pontoReferenciaLatLngs = null;
      }
    }, {
      key: 'forcarLatLngValida',
      value: function forcarLatLngValida(dragEvent, posicaoRotograma) {
        var markerRotograma = _.find(this.rotogramaMarkers, function (r) {
          return r.posicao.key === posicaoRotograma.key;
        });
        if (this.isTopoOuBase(posicaoRotograma) && this.isLongitudeValida(markerRotograma.marker.getLatLng().lng)) {
          markerRotograma.marker.setLatLng([dragEvent.oldLatLng.lat, markerRotograma.marker.getLatLng().lng]);
          markerRotograma.posicaoAnterior = markerRotograma.marker.getLatLng();
        } else if (!this.isTopoOuBase(posicaoRotograma) && this.isLatitudeValida(markerRotograma.marker.getLatLng().lat)) {
          markerRotograma.marker.setLatLng([markerRotograma.marker.getLatLng().lat, dragEvent.oldLatLng.lng]);
          markerRotograma.posicaoAnterior = markerRotograma.marker.getLatLng();
        } else {
          markerRotograma.marker.setLatLng(markerRotograma.posicaoAnterior);
        }
      }
    }, {
      key: 'isTopoOuBase',
      value: function isTopoOuBase(posicaoRotograma) {
        return posicaoRotograma === this.posicoesRotogramas.TOPO || posicaoRotograma === this.posicoesRotogramas.BASE;
      }
    }, {
      key: 'isLongitudeValida',
      value: function isLongitudeValida(longitude) {
        return Math.abs(this.pontoReferenciaLatLngs.latLngBaseEsquerda.lng) >= Math.abs(longitude) && Math.abs(this.pontoReferenciaLatLngs.latLngTopoDireita.lng) <= Math.abs(longitude);
      }
    }, {
      key: 'isLatitudeValida',
      value: function isLatitudeValida(latitude) {
        return Math.abs(this.pontoReferenciaLatLngs.latLngBaseEsquerda.lat) >= Math.abs(latitude) && Math.abs(this.pontoReferenciaLatLngs.latLngTopoDireita.lat) <= Math.abs(latitude);
      }
    }, {
      key: 'forcarAnguloValido',
      value: function forcarAnguloValido(posicaoRotograma, latLngInicial) {
        var _this = this;

        var markerRotograma = _.find(this.rotogramaMarkers, function (r) {
          return r.posicao.key === posicaoRotograma.key;
        }),
            markersAdjacentes = this.getMarkersAdjacentes(posicaoRotograma),
            markerComAnguloInvalido = _.find(markersAdjacentes, function (markerAdjacente) {
          return !_this.isAnguloValido(markerRotograma.marker, markerAdjacente.marker);
        });
        if (angular.isDefined(markerComAnguloInvalido)) {
          markerRotograma.marker.setLatLng(latLngInicial);
          this.exibirPopupAnguloInvalido(markerRotograma.marker);
        }
      }
    }, {
      key: 'exibirPopupAnguloInvalido',
      value: function exibirPopupAnguloInvalido(marker) {
        var _this2 = this;

        marker.bindPopup(L.popup({ closeOnClick: false, offset: L.point(0, -5) }).setContent('<p>Os rotogramas estão muito próximos!</p>')).openPopup();
        marker.off('click');
        if (this.timeoutPopupClose) {
          this.timeout.cancel(this.timeoutPopupClose);
        }
        this.timeoutPopupClose = this.timeout(function () {
          marker.closePopup();
          _this2.timeoutPopupClose = null;
        }, 2500);
      }

      /**
       * Retorna o ângulo em graus de um dado rotograma em relação ao centro do ponto de referência e um ponto de ângulo 0
       *
       * Na verificação é utilizada a Lei dos Cossenos, cuja forma mais conhecida é c² = a² + b² − 2ab cos(C),
       * aqui rearranjada na forma cos(C) = (a² + b² − c²) / (2ab).
       *
       * @param {Rotograma} rotograma rotograma com marker cujo ângulo será calculado
       * @return {Number} ângulo do rotograma a partir do centro do ponto de referência, em graus. Null caso o rotograma
       * passado seja falsy, não tenha marker ou seja o rotograma interno.
       */

    }, {
      key: 'getAngulo',
      value: function getAngulo(rotograma) {
        if (rotograma && rotograma.marker && !angular.equals(rotograma.marker.getLatLng(), this.centro.getLatLng())) {
          var latLngAnguloZero = L.latLng(this.centro.getLatLng().lat + 1, this.centro.getLatLng().lng),
              a = this.getDistance(latLngAnguloZero, this.centro.getLatLng()),
              b = this.getDistance(rotograma.marker.getLatLng(), this.centro.getLatLng()),
              c = this.getDistance(rotograma.marker.getLatLng(), latLngAnguloZero);
          var cos = (Math.pow(a, 2) + Math.pow(b, 2) - Math.pow(c, 2)) / (2 * a * b);
          if (cos > 1 || cos < -1) {
            cos = Math.round(cos);
          }
          return Math.abs(rotograma.marker.getLatLng().lng) < Math.abs(this.centro.getLatLng().lng) ? Math.acos(cos) * 180 / Math.PI : 360 - Math.acos(cos) * 180 / Math.PI;
        }
        return null;
      }

      /**
       * Verifica se o ângulo entre dois markers em relação ao centro do ponto de referência é maior que 35°.
       *
       * Na verificação é utilizada a Lei dos Cossenos, cuja forma mais conhecida é c² = a² + b² − 2ab cos(C),
       * aqui rearranjada na forma cos(C) = (a² + b² − c²) / (2ab).
       *
       * @param {L.Marker} markerAlvo Marker cujo ângulo em relação ao centro e ao marker adjacente será analisado.
       * @param {L.Marker} markerAdjacente Marker adjacente ao marker alvo.
       * @return {boolean} true se o ângulo entre o marker e seu marker adjacente for maior que 35°, do contrário false.
       */

    }, {
      key: 'isAnguloValido',
      value: function isAnguloValido(markerAlvo, markerAdjacente) {
        var a = this.getDistance(markerAdjacente.getLatLng(), this.centro.getLatLng()),
            b = this.getDistance(markerAlvo.getLatLng(), this.centro.getLatLng()),
            c = this.getDistance(markerAlvo.getLatLng(), markerAdjacente.getLatLng()),
            cos = (Math.pow(a, 2) + Math.pow(b, 2) - Math.pow(c, 2)) / (2 * a * b);
        return Math.acos(cos) > ANGULO_MINIMO_RADIANOS;
      }
    }, {
      key: 'getMarkersAdjacentes',
      value: function getMarkersAdjacentes(posicao) {
        return this.rotogramaMarkers.filter(function (m) {
          return posicao.ladosAdjacentes.indexOf(m.posicao) !== -1;
        });
      }
    }, {
      key: 'getDistance',
      value: function getDistance(pontoA, pontoB) {
        return geolib.getDistance({ latitude: pontoA.lat, longitude: pontoA.lng }, { latitude: pontoB.lat, longitude: pontoB.lng }, PRECISAO_UNITARIA, PRECISAO_CENTIMETROS);
      }
    }, {
      key: 'getRotacaoRotograma',
      value: function getRotacaoRotograma(tipoRotograma, angulo) {
        if (tipoRotograma === this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value) {
          return -1;
        } else if (angulo > 45 && angulo <= 135) {
          return 90;
        } else if (angulo > 135 && angulo <= 225) {
          return 180;
        } else if (angulo > 225 && angulo <= 315) {
          return 270;
        }
        return 360;
      }
    }, {
      key: 'renderizarPontoReferencia',
      value: function renderizarPontoReferencia(map, latLngsExternos, cor) {
        map.addLayer(L.rectangle([[latLngsExternos.latlngLeftBottom.latitude, latLngsExternos.latlngLeftBottom.longitude], [latLngsExternos.latlngRightTop.latitude, latLngsExternos.latlngRightTop.longitude]], {
          color: cor,
          weight: 0,
          fillOpacity: 0.4,
          editing: false
        }));
      }
    }]);

    return RotogramaMapService;
  }();

  angular.module('rotogramaModule').service('RotogramaMapService', RotogramaMapService);
})();
'use strict';

(function () {
  'use strict';

  var statusRotogram = {
    CONFIGURADO: {
      label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoControlarVelocidade',
      classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
      value: 'CONFIGURADO',
      visible: true,
      hasSpeedIcon: true,
      hasAudioIcon: false
    },
    UTILIZA_VELOCIDADE_ANTERIOR: {
      label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoUtilizarVelAnterior',
      classe: 'limite-velocidade-icone placa-ponto-referencia manter-velocidade-placa',
      value: 'UTILIZA_VELOCIDADE_ANTERIOR',
      visible: true,
      hasSpeedIcon: false,
      hasAudioIcon: false
    },
    CONTROLA_VELOCIDADE_INTERNA: {
      label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoRotogramaInterno',
      classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
      value: 'CONTROLA_VELOCIDADE_INTERNA',
      visible: false,
      hasSpeedIcon: true,
      hasAudioIcon: false
    },
    NAO_CONTROLA_VELOCIDADE: {
      label: 'ce.mapa.common.modal.modalDetalhesRotograma.descricaoNaoControlarVelocidade',
      classe: 'limite-velocidade-icone placa-ponto-referencia nao-controlar-velocidade-placa',
      value: 'NAO_CONTROLA_VELOCIDADE',
      visible: false,
      hasSpeedIcon: false,
      hasAudioIcon: false
    },
    ONLY_AUDIO: {
      label: 'NA',
      classe: 'audio-rotogram',
      value: 'ONLY_AUDIO',
      visible: false,
      hasSpeedIcon: false,
      hasAudioIcon: true
    },
    ONLY_AUDIO_INTERN: {
      label: 'NA',
      classe: 'audio-rotogram',
      value: 'ONLY_AUDIO_INTERN',
      visible: false,
      hasSpeedIcon: false,
      hasAudioIcon: true
    },
    SPEED_AND_AUDIO: {
      label: 'NA',
      classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa rotogram-and-audio',
      value: 'SPEED_AND_AUDIO',
      visible: false,
      hasSpeedIcon: true,
      hasAudioIcon: true
    },
    KEEP_SPEED_AND_AUDIO: {
      label: 'NA',
      classe: 'limite-velocidade-icone placa-ponto-referencia manter-velocidade-placa',
      value: 'KEEP_SPEED_AND_AUDIO',
      visible: false,
      hasSpeedIcon: false,
      hasAudioIcon: true
    },
    INTERN_SPEED_AND_AUDIO: {
      label: 'NA',
      classe: 'limite-velocidade-icone placa-ponto-referencia limite-velocidade-placa',
      value: 'INTERN_SPEED_AND_AUDIO',
      visible: false,
      hasSpeedIcon: true,
      hasAudioIcon: true
    }
  },
      functions = {
    getStatusRotogram: function getStatusRotogram(key) {
      return statusRotogram[key];
    }
  };

  angular.module('rotogramaModule').constant('RotogramaComponentStates', {
    INICIAL: 'rotograma-inicial',
    DESTAQUE: 'rotograma-inicial rotograma-destaque',
    ATIVO: 'rotograma-ativo',
    EXCLUSAO: 'rotograma-exclusao'
  }).constant('ControleVelocidadeRotograma', Object.assign({}, statusRotogram, functions)).constant('PosicoesRotogramas', function () {
    var TOPO = {
      key: 'TOPO',
      anguloInicial: 0,
      contemAngulo: function contemAngulo(angulo) {
        return angulo >= 315 && angulo <= 360 || angulo >= 0 && angulo < 45;
      }
    },
        DIREITA = {
      key: 'DIREITA',
      anguloInicial: 90,
      contemAngulo: function contemAngulo(angulo) {
        return angulo >= 45 && angulo < 135;
      }
    },
        BASE = {
      key: 'BASE',
      anguloInicial: 180,
      contemAngulo: function contemAngulo(angulo) {
        return angulo >= 135 && angulo < 225;
      }
    },
        ESQUERDA = {
      key: 'ESQUERDA',
      anguloInicial: 270,
      contemAngulo: function contemAngulo(angulo) {
        return angulo >= 225 && angulo < 325;
      }
    },
        CENTRO = {
      key: 'CENTRO'
    };

    TOPO.ladosAdjacentes = [DIREITA, ESQUERDA];
    DIREITA.ladosAdjacentes = [TOPO, BASE];
    BASE.ladosAdjacentes = [DIREITA, ESQUERDA];
    ESQUERDA.ladosAdjacentes = [TOPO, BASE];

    return { TOPO: TOPO, DIREITA: DIREITA, BASE: BASE, ESQUERDA: ESQUERDA, CENTRO: CENTRO };
  }());
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RotogramaController = function () {
    function RotogramaController(CadastroRotogramaService, RotogramaMapService, RotogramaComponentStates, $scope) {
      _classCallCheck(this, RotogramaController);

      this.cadastroRotogramaService = CadastroRotogramaService;
      this.rotogramaMapService = RotogramaMapService;
      this.componentStates = RotogramaComponentStates;
      this.scope = $scope;
    }

    _createClass(RotogramaController, [{
      key: '$onInit',
      value: function $onInit() {
        this.configurarInteracoesMarker();
        this.rotogramaMapService.adicionarMarker(this.marker, this.posicao);
        if (this.marker.options.rotogramaCadastrado) {
          this.rotogramaId = this.cadastroRotogramaService.adicionarRotograma(this.marker, this.marker.options.rotogramaCadastrado);
        }
      }
    }, {
      key: 'configurarInteracoesMarker',
      value: function configurarInteracoesMarker() {
        var _this = this;

        var latLngInicial = void 0;
        this.marker.on('dragstart', function () {
          latLngInicial = _this.handleDragStart();
        });
        this.marker.on('drag', function (e) {
          return _this.handleDrag(e);
        });
        this.marker.on('dragend', function () {
          return _this.handleDragEnd(latLngInicial);
        });
      }
    }, {
      key: 'handleDragStart',
      value: function handleDragStart() {
        this.dragging = true;
        return this.marker.getLatLng();
      }
    }, {
      key: 'handleDrag',
      value: function handleDrag(dragEvent) {
        this.rotogramaMapService.forcarLatLngValida(dragEvent, this.posicao);
      }
    }, {
      key: 'handleDragEnd',
      value: function handleDragEnd(latLngInicial) {
        var _this2 = this;

        this.rotogramaMapService.forcarAnguloValido(this.posicao, latLngInicial);
        this.scope.$applyAsync(function () {
          _this2.dragging = false;
        });
      }
    }, {
      key: 'click',
      value: function click() {
        if (this.dragging) {
          return;
        }
        if (this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.INICIAL || this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.DESTAQUE) {
          this.rotogramaId = this.cadastroRotogramaService.adicionarRotograma(this.marker);
        } else if (this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.EXCLUSAO) {
          this.cadastroRotogramaService.removerRotograma(this.rotogramaId);
          this.rotogramaId = null;
        }
      }
    }, {
      key: 'mouseEnter',
      value: function mouseEnter() {
        if (this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.ATIVO) {
          this.cadastroRotogramaService.getRotograma(this.rotogramaId).state = this.componentStates.EXCLUSAO;
        }
      }
    }, {
      key: 'mouseLeave',
      value: function mouseLeave() {
        if (this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.EXCLUSAO) {
          this.cadastroRotogramaService.getRotograma(this.rotogramaId).state = this.componentStates.ATIVO;
        }
      }
    }, {
      key: 'getContent',
      value: function getContent() {
        return this.cadastroRotogramaService.getState(this.rotogramaId) === this.componentStates.ATIVO ? this.cadastroRotogramaService.getRotograma(this.rotogramaId).indice : '+';
      }
    }]);

    return RotogramaController;
  }();

  angular.module('rotogramaModule').component('rotograma', {
    template: '\n        <span class="botao-rotograma rotograma-animated"\n          ng-class="rotogramaCtrl.cadastroRotogramaService.getState(rotogramaCtrl.rotogramaId)"\n          ng-click="rotogramaCtrl.click()"\n          ng-mouseover="rotogramaCtrl.mouseEnter()"\n          ng-mouseleave="rotogramaCtrl.mouseLeave()">\n          {{ rotogramaCtrl.getContent() }}\n        </span>\n      ',
    controller: RotogramaController,
    controllerAs: 'rotogramaCtrl',
    bindings: {
      marker: '<',
      posicao: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, L */

  var EditorRotogramasCtrl = function () {
    function EditorRotogramasCtrl(MapasUtil, leafletData, PontosReferenciaTools, CadastroRotogramaService, CategoriaPontosReferencia, PosicoesRotogramas, ControleVelocidadeRotograma, RotogramaMapService, PontosReferenciaMap, $scope, $compile) {
      _classCallCheck(this, EditorRotogramasCtrl);

      this.mapasUtil = MapasUtil;
      this.leafletData = leafletData;
      this.pontosReferenciaTools = PontosReferenciaTools;
      this.cadastroRotogramaService = CadastroRotogramaService;
      this.categoriaPontosReferenciaService = CategoriaPontosReferencia;
      this.posicoesRotogramas = PosicoesRotogramas;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.rotogramaMapService = RotogramaMapService;
      this.pontoReferenciaMapService = PontosReferenciaMap;
      this.scope = $scope;
      this.compile = $compile;
      this.MAPA_ID = 'mapa-rotograma';
    }

    _createClass(EditorRotogramasCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.inicializarMapa();
      }
    }, {
      key: '$onDestroy',
      value: function $onDestroy() {
        this.cadastroRotogramaService.encerrarCadastro(this.map);
      }
    }, {
      key: 'inicializarMapa',
      value: function inicializarMapa() {
        var _this = this;

        this.tiles = this.mapasUtil.tiles.veltec;
        this.defaults = this.mapasUtil.defaults;
        this.center = {
          zoom: 17,
          lat: this.pontoReferencia.latitude,
          lng: this.pontoReferencia.longitude
        };

        this.leafletData.getMap(this.MAPA_ID).then(function (map) {
          var latlngsExternos = _this.pontosReferenciaTools.geraLatLngsExternos(_this.pontoReferencia.latitude, _this.pontoReferencia.longitude, _this.pontoReferencia.raio),
              rotogramasPorPosicao = _this.associarRotogramasAsPosicoes(),
              markersRotogramas = _.values(_this.posicoesRotogramas).map(function (p) {
            return _this.mapearMarcador(p, rotogramasPorPosicao);
          });

          _this.rotogramaMapService.setLatLngPontoReferencia([latlngsExternos.latlngLeftBottom.latitude, latlngsExternos.latlngLeftBottom.longitude], [latlngsExternos.latlngRightTop.latitude, latlngsExternos.latlngRightTop.longitude]);
          _this.rotogramaMapService.renderizarPontoReferencia(map, latlngsExternos, _this.categoria && _this.categoria.cor || _this.categoriaPontosReferenciaService.categoriaDefault.cor);

          _this.cadastroRotogramaService.iniciarCadastro(_this.rotogramas).then(function () {
            if (_this.advisorSuggestion) {
              _this.handleAdvisorSuggestion(markersRotogramas);
            }

            markersRotogramas.forEach(function (marker) {
              map.addLayer(marker);
              var scope = _this.scope.$new(true);
              scope.marker = marker;
              scope.posicao = marker.options.posicao;
              marker.getElement().appendChild(_this.compile('<rotograma marker="marker" posicao="posicao"></rotograma>')(scope)[0]);
            });
          });
        });
      }
    }, {
      key: 'handleAdvisorSuggestion',
      value: function handleAdvisorSuggestion(markersRotogramas) {
        var _this2 = this;

        var slowestSpeed = this.pontoReferenciaMapService.getSlowestSpeed(this.advisorSuggestion),
            grupoVelocidade = _.values(this.cadastroRotogramaService.gruposVelocidadePorId).find(function (grupoVel) {
          return grupoVel.velocidade === slowestSpeed;
        });
        if (slowestSpeed && grupoVelocidade) {
          var centro = markersRotogramas.find(function (marker) {
            return marker.options.posicao === _this2.posicoesRotogramas.CENTRO;
          });
          centro.options.rotogramaCadastrado = {
            grupoVelocidadePadrao: Object.assign({}, grupoVelocidade),
            status: this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value
          };
        }
      }
    }, {
      key: 'associarRotogramasAsPosicoes',
      value: function associarRotogramasAsPosicoes() {
        var _this3 = this;

        return this.rotogramas.reduce(function (acc, atual) {
          var posicao = _.find(_.values(_this3.posicoesRotogramas), function (p) {
            return p.contemAngulo && p.contemAngulo(atual.grau);
          });
          acc[posicao && posicao.key || _this3.posicoesRotogramas.CENTRO.key] = atual;
          return acc;
        }, {});
      }
    }, {
      key: 'mapearMarcador',
      value: function mapearMarcador(posicao, rotogramasPorPosicao) {
        if (rotogramasPorPosicao[posicao.key]) {
          var rotograma = rotogramasPorPosicao[posicao.key];
          return L.marker([rotograma.latitude, rotograma.longitude], {
            icon: L.divIcon({ className: 'icon-rotograma' }),
            draggable: posicao !== this.posicoesRotogramas.CENTRO,
            posicao: posicao,
            rotogramaCadastrado: rotograma
          });
        } else if (posicao === this.posicoesRotogramas.CENTRO) {
          return L.marker([this.pontoReferencia.latitude, this.pontoReferencia.longitude], {
            icon: L.divIcon({ className: 'icon-rotograma' }),
            posicao: posicao
          });
        }
        var latLngRotograma = this.pontosReferenciaTools.geraLatLngsRotograma(posicao.anguloInicial, this.pontoReferencia.raio, this.pontoReferencia.latitude, this.pontoReferencia.longitude);
        return L.marker([latLngRotograma.latlng.latitude, latLngRotograma.latlng.longitude], {
          icon: L.divIcon({ className: 'icon-rotograma' }),
          draggable: true,
          posicao: posicao
        });
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }]);

    return EditorRotogramasCtrl;
  }();

  angular.module('rotogramaModule').component('editorRotogramas', {
    controller: EditorRotogramasCtrl,
    bindings: {
      pontoReferencia: '<',
      categoria: '<',
      rotogramas: '<',
      advisorSuggestion: '<'
    },
    templateUrl: 'directives/map-control/rotograma/editor-rotogramas.tpl.html'
  });
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RegraEspecificaRotograma = function () {
    function RegraEspecificaRotograma() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var grupoVeiculo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var tipoVeiculo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var grupoVelocidade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var rotogramaId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      _classCallCheck(this, RegraEspecificaRotograma);

      this.id = id;
      this.grupoVeiculo = grupoVeiculo;
      this.tipoVeiculo = tipoVeiculo;
      this.grupoVelocidade = grupoVelocidade;
      this.rotogramaId = rotogramaId;
    }

    _createClass(RegraEspecificaRotograma, [{
      key: 'equals',
      value: function equals(regra) {
        return this.grupoVeiculo && regra.grupoVeiculo && this.grupoVeiculo.id === regra.grupoVeiculo.id && (this.tipoVeiculo === regra.tipoVeiculo || this.tipoVeiculo && regra.tipoVeiculo && this.tipoVeiculo.id === regra.tipoVeiculo.id) && this.grupoVelocidade && regra.grupoVelocidade && this.grupoVelocidade.id === regra.grupoVelocidade.id;
      }
    }, {
      key: 'toBackendFormat',
      value: function toBackendFormat() {
        return {
          id: this.id,
          grupoVelocidade: this.grupoVelocidade,
          grupoVeiculo: this.grupoVeiculo.nome,
          grupoVeiculoId: this.grupoVeiculo.id,
          tipoVeiculo: this.tipoVeiculo && this.tipoVeiculo.nome
        };
      }
    }, {
      key: 'isValid',
      value: function isValid() {
        return !!(this.grupoVeiculo && this.grupoVelocidade);
      }
    }]);

    return RegraEspecificaRotograma;
  }();

  /* global _ */


  var CadastroRotogramaService = function () {
    function CadastroRotogramaService(RotogramaComponentStates, RotogramaMapService, ControleVelocidadeRotograma, Restangular, $uibModal, $rootScope, $q, AlertMessage, PosicoesRotogramas, $translate) {
      _classCallCheck(this, CadastroRotogramaService);

      this.rotogramaComponentStates = RotogramaComponentStates;
      this.rotogramaMapService = RotogramaMapService;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.rootScope = $rootScope;
      this.q = $q;
      this.alertMessage = AlertMessage;
      this.posicoesRotogramas = PosicoesRotogramas;
      this.translate = $translate;

      this.geradorId = 0;
      this.rotogramaDefaultState = this.rotogramaComponentStates.INICIAL;
    }

    _createClass(CadastroRotogramaService, [{
      key: 'iniciarCadastro',
      value: function iniciarCadastro() {
        var _this = this;

        var rotogramasCadastrados = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        this.agrupamentoAtivo = { rotogramas: [], controleVelocidade: this.controleVelocidadeRotograma.CONFIGURADO };
        this.agrupamentos = [this.agrupamentoAtivo];
        return this.q.all([this.restangular.one('/ponto-referencia/grupos-velocidade').get(), this.restangular.one('/veiculo/veiculos/grupos').get(), this.restangular.one('/veiculo/veiculos/permitidos/tipos').get(), this.q.all(rotogramasCadastrados.map(function (r) {
          return _this.restangular.one('/ponto-referencia/config-rotograma?rotograma=' + r.id).get();
        }))]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 4),
              gruposVelocidade = _ref2[0],
              gruposVeiculo = _ref2[1],
              tiposVeiculo = _ref2[2],
              configsRotogramasData = _ref2[3];

          var associateBy = function associateBy(objetos, propriedade) {
            return objetos.reduce(function (map, obj) {
              map[obj[propriedade]] = obj;
              return map;
            }, {});
          };
          _this.gruposVelocidadePorId = associateBy(gruposVelocidade.plain(), 'id');
          _this.gruposVeiculoPorId = associateBy(gruposVeiculo.plain(), 'id');
          _this.tiposVeiculoPorNome = associateBy(tiposVeiculo.plain(), 'nome');
          _this.configsPorRotograma = _.chain(configsRotogramasData).map(function (data) {
            return data.plain();
          }).flatten().map(function (config) {
            return new RegraEspecificaRotograma(config.id, _this.gruposVeiculoPorId[config.grupoVeiculoId], _this.tiposVeiculoPorNome[config.tipoVeiculo], config.grupoVelocidade, config.rotograma);
          }).groupBy(function (regra) {
            return regra.rotogramaId;
          }).value();
        });
      }
    }, {
      key: 'adicionarRegra',
      value: function adicionarRegra(agrupamento) {
        if (!agrupamento.regras) {
          agrupamento.regras = [];
        }
        agrupamento.regras.push(new RegraEspecificaRotograma());
      }
    }, {
      key: 'getGruposVelocidade',
      value: function getGruposVelocidade() {
        return _.values(this.gruposVelocidadePorId).sort(function (a, b) {
          return a.velocidade.toString().localeCompare(b.velocidade.toString(), undefined, { numeric: true });
        });
      }
    }, {
      key: 'getGruposVeiculo',
      value: function getGruposVeiculo() {
        return _.values(this.gruposVeiculoPorId);
      }
    }, {
      key: 'getTiposVeiculo',
      value: function getTiposVeiculo() {
        return _.values(this.tiposVeiculoPorNome);
      }
    }, {
      key: 'salvar',
      value: function salvar(pontoReferenciaId) {
        var _this2 = this;

        var rotogramas = _.chain(this.agrupamentos).map(function (agrupamento) {
          return _this2.mapearRotogramas(agrupamento, pontoReferenciaId);
        }).flatten().value();

        return this.restangular.all('/ponto-referencia/rotogramas/' + pontoReferenciaId + '/batch').post(rotogramas).then(function (rotogramasResponse) {
          _this2.rootScope.$broadcast('rotogramasCadastrados', {
            rotogramas: rotogramasResponse.plain(),
            pontoReferenciaId: pontoReferenciaId
          });
          _this2.encerrarCadastro();
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.mapa.common.modal.cadastroRotograma.errorCadastrar'),
            appendTo: '.alerta-aqui-cadastro-ponto'
          });
        });
      }
    }, {
      key: 'excluir',
      value: function excluir(pontoReferenciaId) {
        var _this3 = this;

        this.restangular.all('/ponto-referencia/rotogramas/' + pontoReferenciaId + '/batch').post([]).then(function () {
          _this3.rootScope.$broadcast('rotogramasDeletados', {
            rotogramaIds: _this3.getRotogramas().map(function (rotograma) {
              return rotograma.id;
            }),
            pontoReferenciaId: pontoReferenciaId
          });
        }).catch(function () {
          _this3.alertMessage.create({
            type: 'error',
            message: _this3.translate.instant('ce.mapa.common.modal.cadastroRotograma.errorExcluir'),
            appendTo: '.alerta-aqui-cadastro-ponto'
          });
        });
      }
    }, {
      key: 'deleteAllByPontoId',
      value: function deleteAllByPontoId(pontoId) {
        return this.restangular.all('/ponto-referencia/rotogramas/' + pontoId + '/batch').post([]);
      }
    }, {
      key: 'encerrarCadastro',
      value: function encerrarCadastro() {
        this.rotogramaMapService.encerrarCadastro();
      }
    }, {
      key: 'mapearRotogramas',
      value: function mapearRotogramas(agrupamento, pontoReferenciaId) {
        var _this4 = this;

        var configsAgrupamento = agrupamento.usarRegrasEspecificas ? agrupamento.regras.map(function (regra) {
          return regra.toBackendFormat();
        }) : [];

        return agrupamento.rotogramas.map(function (rotograma) {
          var angulo = _this4.rotogramaMapService.getAngulo(rotograma),
              rotogramaInterno = angulo === null;
          var grupoVelocidade = void 0;
          if (agrupamento.controleVelocidade.value !== _this4.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR.value) {
            grupoVelocidade = agrupamento.grupoVelocidade;
          }
          return {
            rotograma: {
              id: rotograma.id,
              pontoReferencia: pontoReferenciaId,
              latitude: rotograma.marker.getLatLng().lat,
              longitude: rotograma.marker.getLatLng().lng,
              grau: angulo === 360 ? 0 : angulo,
              status: rotogramaInterno ? _this4.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value : agrupamento.controleVelocidade.value,
              grupoVelocidadePadrao: grupoVelocidade
            },
            configs: configsAgrupamento
          };
        });
      }
    }, {
      key: 'adicionarAgrupamento',
      value: function adicionarAgrupamento() {
        this.agrupamentoAtivo = { rotogramas: [], controleVelocidade: this.controleVelocidadeRotograma.CONFIGURADO };
        this.agrupamentos.push(this.agrupamentoAtivo);
        this.destacarRotogramasDisponiveis();
      }
    }, {
      key: 'setAgrupamentoAtivo',
      value: function setAgrupamentoAtivo(agrupamento) {
        var _this5 = this;

        if (this.agrupamentoAtivo.rotogramas.length === 0) {
          this.agrupamentos = this.agrupamentos.filter(function (a) {
            return a !== _this5.agrupamentoAtivo;
          });
        }
        this.agrupamentoAtivo = agrupamento;
      }
    }, {
      key: 'destacarRotogramasDisponiveis',
      value: function destacarRotogramasDisponiveis() {
        this.rotogramaDefaultState = this.rotogramaComponentStates.DESTAQUE;
      }
    }, {
      key: 'getRotograma',
      value: function getRotograma(idInterno) {
        return _.chain(this.agrupamentos).map(function (agrupamento) {
          return agrupamento.rotogramas;
        }).flatten().find(function (r) {
          return r.idInterno === idInterno;
        });
      }
    }, {
      key: 'getRotogramas',
      value: function getRotogramas() {
        return _.flatten(_.map(this.agrupamentos, function (agrupamento) {
          return agrupamento.rotogramas;
        }));
      }
    }, {
      key: 'adicionarRotograma',
      value: function adicionarRotograma(marker, rotogramaCadastrado) {
        var rotograma = {
          id: rotogramaCadastrado && rotogramaCadastrado.id,
          idInterno: ++this.geradorId,
          state: this.rotogramaComponentStates.ATIVO,
          marker: marker
        };

        if (rotogramaCadastrado) {
          if (rotogramaCadastrado.status === this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value) {
            rotogramaCadastrado.status = this.controleVelocidadeRotograma.CONFIGURADO.value;
          }
          this.agrupar(rotograma, rotogramaCadastrado);
          return rotograma.idInterno;
        }
        this.agrupamentoAtivo.rotogramas.push(rotograma);
        this.indexarRotogramas();
        return rotograma.idInterno;
      }
    }, {
      key: 'agrupar',
      value: function agrupar(rotograma, rotogramaCadastrado) {
        var regrasEspecificasRotograma = this.configsPorRotograma[rotogramaCadastrado.id],
            indice = this.getIndiceAgrupamento(rotogramaCadastrado, regrasEspecificasRotograma);
        if (this.agrupamentos[indice].rotogramas.length === 0) {
          this.setPropriedadesAgrupamento(this.agrupamentos[indice], rotogramaCadastrado, regrasEspecificasRotograma);
          if (this.getRotogramas().length < 4) {
            this.adicionarAgrupamento();
          }
        }
        this.agrupamentos[indice].rotogramas.push(rotograma);
        this.indexarRotogramas();
      }
    }, {
      key: 'getIndiceAgrupamento',
      value: function getIndiceAgrupamento(rotogramaCadastrado, regrasEspecificasRotograma) {
        var _this6 = this;

        var indice = _.findIndex(this.agrupamentos, function (agrupamento) {
          if (agrupamento.rotogramas.length === 0) {
            return false;
          }
          return _this6.gruposVelocidadeIguais(agrupamento.grupoVelocidade, rotogramaCadastrado.grupoVelocidadePadrao) && _this6.controlesVelocidadeIguais(agrupamento.controleVelocidade.value, rotogramaCadastrado.status) && _this6.regrasEspecificasIguais(agrupamento, regrasEspecificasRotograma);
        });
        return indice !== -1 ? indice : this.agrupamentos.length - 1;
      }
    }, {
      key: 'setPropriedadesAgrupamento',
      value: function setPropriedadesAgrupamento(agrupamento, rotogramaCadastrado, regrasEspecificasRotograma) {
        var controleVelocidade = rotogramaCadastrado.status === this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value ? this.controleVelocidadeRotograma.CONFIGURADO : this.controleVelocidadeRotograma[rotogramaCadastrado.status];
        agrupamento.grupoVelocidade = rotogramaCadastrado.grupoVelocidadePadrao;
        agrupamento.controleVelocidade = controleVelocidade;

        if (regrasEspecificasRotograma && regrasEspecificasRotograma.length > 0) {
          agrupamento.usarRegrasEspecificas = true;
          agrupamento.regras = regrasEspecificasRotograma;
        }
      }
    }, {
      key: 'controlesVelocidadeIguais',
      value: function controlesVelocidadeIguais(controleVelocidade1, controleVelocidade2) {
        if (controleVelocidade1 === controleVelocidade2) {
          return true;
        }
        var controlesVelocidade = new Set([controleVelocidade1, controleVelocidade2]);
        return controlesVelocidade.has(this.controleVelocidadeRotograma.CONFIGURADO.value) && controlesVelocidade.has(this.controleVelocidadeRotograma.CONTROLA_VELOCIDADE_INTERNA.value);
      }
    }, {
      key: 'gruposVelocidadeIguais',
      value: function gruposVelocidadeIguais(grupo1, grupo2) {
        return _.isEqual(grupo1, grupo2) || grupo1 && grupo2 && grupo1.id === grupo2.id;
      }
    }, {
      key: 'regrasEspecificasIguais',
      value: function regrasEspecificasIguais(agrupamento, regrasEspecificasRotograma) {
        if (angular.isUndefined(agrupamento.regras) && (angular.isUndefined(regrasEspecificasRotograma) || regrasEspecificasRotograma.length === 0)) {
          return true;
        }
        return angular.isDefined(agrupamento.regras) && angular.isDefined(regrasEspecificasRotograma) && agrupamento.regras.length === regrasEspecificasRotograma.length && agrupamento.regras.every(function (regraAgrupamento) {
          return regrasEspecificasRotograma.some(function (regra) {
            return regra.equals(regraAgrupamento);
          });
        });
      }
    }, {
      key: 'removerRotograma',
      value: function removerRotograma(idInterno) {
        var agrupamentoRotograma = _.find(this.agrupamentos, function (agrupamento) {
          return _.some(agrupamento.rotogramas, function (rotograma) {
            return rotograma.idInterno === idInterno;
          });
        });
        agrupamentoRotograma.rotogramas = agrupamentoRotograma.rotogramas.filter(function (rotograma) {
          return rotograma.idInterno !== idInterno;
        });
        if (agrupamentoRotograma.rotogramas.length === 0 && this.agrupamentos.length > 1) {
          this.agrupamentos = this.agrupamentos.filter(function (agrupamento) {
            return agrupamento !== agrupamentoRotograma;
          });
          if (agrupamentoRotograma === this.agrupamentoAtivo) {
            this.agrupamentoAtivo = this.agrupamentos[this.agrupamentos.length - 1];
          }
        }
        this.indexarRotogramas();
      }
    }, {
      key: 'getState',
      value: function getState(idInterno) {
        var rotograma = this.getRotograma(idInterno);
        return rotograma && rotograma.state || this.rotogramaDefaultState;
      }
    }, {
      key: 'indexarRotogramas',
      value: function indexarRotogramas() {
        _.chain(this.agrupamentos).map(function (agrupamento) {
          return agrupamento.rotogramas;
        }).flatten().forEach(function (rotograma, i) {
          rotograma.indice = i + 1;
        });
        this.rotogramaDefaultState = this.rotogramaComponentStates.INICIAL;
      }
    }, {
      key: 'isCadastroValido',
      value: function isCadastroValido() {
        var _this7 = this;

        var temQuantidadeMinimaRotogramas = this.getRotogramas().length >= 2,
            agrupamentosValidos = this.agrupamentos && this.agrupamentos.every(function (agrupamento) {
          return _this7.isAgrupamentoValido(agrupamento);
        });
        return temQuantidadeMinimaRotogramas && agrupamentosValidos;
      }
    }, {
      key: 'isAgrupamentoValido',
      value: function isAgrupamentoValido(agrupamento) {
        var _this8 = this;

        var agrupamentoVazio = agrupamento.rotogramas.length === 0,
            grupoVelocidadeValido = agrupamento.grupoVelocidade && agrupamento.controleVelocidade !== this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR || agrupamento.controleVelocidade === this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR && agrupamento.rotogramas.every(function (rotograma) {
          return rotograma.marker.options.posicao !== _this8.posicoesRotogramas.CENTRO;
        }),
            regrasValidas = !agrupamento.regras || agrupamento.regras.every(function (regra) {
          return regra.isValid() && !_this8.isRegraDuplicada(regra, agrupamento.regras);
        });
        return agrupamentoVazio || grupoVelocidadeValido && regrasValidas;
      }
    }, {
      key: 'isRegraDuplicada',
      value: function isRegraDuplicada(regra, regras) {
        return regras.slice(0, regras.indexOf(regra)).some(function (outraRegra) {
          return outraRegra.equals(regra);
        });
      }
    }]);

    return CadastroRotogramaService;
  }();

  angular.module('rotogramaModule').service('CadastroRotogramaService', CadastroRotogramaService).service('RegraEspecificaRotogramaFactory', function () {
    return {
      new: function _new(id, grupoVeiculo, tipoVeiculo, grupoVelocidade, rotogramaId) {
        return new RegraEspecificaRotograma(id, grupoVeiculo, tipoVeiculo, grupoVelocidade, rotogramaId);
      }
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var AgrupamentosRotogramasList = function () {
    function AgrupamentosRotogramasList(CadastroRotogramaService, $translate) {
      _classCallCheck(this, AgrupamentosRotogramasList);

      this.cadastroRotogramaService = CadastroRotogramaService;
      this.translate = $translate;
    }

    _createClass(AgrupamentosRotogramasList, [{
      key: 'devePermitirCriacaoGrupos',
      value: function devePermitirCriacaoGrupos() {
        return angular.isDefined(this.cadastroRotogramaService.agrupamentos) && this.cadastroRotogramaService.agrupamentos.length < 5 && this.cadastroRotogramaService.getRotogramas().length < 5 && this.cadastroRotogramaService.agrupamentoAtivo.rotogramas.length > 0;
      }
    }, {
      key: 'getTooltipApoioCadastro',
      value: function getTooltipApoioCadastro() {
        return this.translate.instant('ce.mapa.common.modal.agrupamentoRotogramas.tooltipApoioCadastro');
      }
    }]);

    return AgrupamentosRotogramasList;
  }();

  angular.module('rotogramaModule').component('agrupamentosRotogramasList', {
    controller: AgrupamentosRotogramasList,
    bindings: {},
    templateUrl: 'directives/map-control/rotograma/agrupamentos-rotogramas-list.tpl.html'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var AgrupamentoRotogramasCtrl = function () {
    function AgrupamentoRotogramasCtrl(CadastroRotogramaService, RotogramaComponentStates, ControleVelocidadeRotograma, PosicoesRotogramas, $translate) {
      _classCallCheck(this, AgrupamentoRotogramasCtrl);

      this.cadastroRotogramaService = CadastroRotogramaService;
      this.rotogramaComponentStates = RotogramaComponentStates;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.posicoesRotogramas = PosicoesRotogramas;
      this.translate = $translate;
    }

    _createClass(AgrupamentoRotogramasCtrl, [{
      key: 'getIconContent',
      value: function getIconContent(rotograma) {
        return rotograma.state === this.rotogramaComponentStates.EXCLUSAO ? '+' : rotograma.indice;
      }
    }, {
      key: 'getControlesVelocidadeRotograma',
      value: function getControlesVelocidadeRotograma() {
        return _.values(this.controleVelocidadeRotograma).filter(function (opcao) {
          return opcao.visible;
        });
      }
    }, {
      key: 'getGruposVelocidade',
      value: function getGruposVelocidade() {
        return this.cadastroRotogramaService.getGruposVelocidade();
      }
    }, {
      key: 'getGruposVeiculo',
      value: function getGruposVeiculo() {
        return this.cadastroRotogramaService.getGruposVeiculo();
      }
    }, {
      key: 'getTiposVeiculo',
      value: function getTiposVeiculo() {
        return this.cadastroRotogramaService.getTiposVeiculo();
      }
    }, {
      key: 'getTooltipUtilizaVelocidadeAnterior',
      value: function getTooltipUtilizaVelocidadeAnterior() {
        return this.translate.instant('ce.mapa.common.modal.agrupamentoRotogramas.tooltipUtilizaVelocidadeAnterior');
      }
    }, {
      key: 'habilitarAdicaoProGrupo',
      value: function habilitarAdicaoProGrupo() {
        this.cadastroRotogramaService.setAgrupamentoAtivo(this.agrupamento);
        this.cadastroRotogramaService.destacarRotogramasDisponiveis();
      }
    }, {
      key: 'adicionarRegraSeNaoExistir',
      value: function adicionarRegraSeNaoExistir() {
        if (this.agrupamento.usarRegrasEspecificas && (!this.agrupamento.regras || this.agrupamento.regras.length === 0)) {
          this.cadastroRotogramaService.adicionarRegra(this.agrupamento);
        }
      }
    }, {
      key: 'removerRegra',
      value: function removerRegra(regra) {
        this.agrupamento.regras.splice(this.agrupamento.regras.indexOf(regra), 1);
      }
    }, {
      key: 'deveExibirVelocidade',
      value: function deveExibirVelocidade() {
        return this.agrupamento.controleVelocidade !== this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR;
      }
    }, {
      key: 'deveExibirTooltipUtilizaVelocidadeAnterior',
      value: function deveExibirTooltipUtilizaVelocidadeAnterior() {
        return this.agrupamento.controleVelocidade === this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR && (!this.contemRotogramaInterno() || this.agrupamento.rotogramas.length > 1);
      }
    }, {
      key: 'isControleVelocidadeValido',
      value: function isControleVelocidadeValido() {
        return !this.contemRotogramaInterno() || this.agrupamento.controleVelocidade !== this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR;
      }
    }, {
      key: 'contemRotogramaInterno',
      value: function contemRotogramaInterno() {
        var _this = this;

        return this.agrupamento.rotogramas.some(function (rotograma) {
          return rotograma.marker.options.posicao === _this.posicoesRotogramas.CENTRO;
        });
      }
    }]);

    return AgrupamentoRotogramasCtrl;
  }();

  angular.module('rotogramaModule').component('agrupamentoRotogramas', {
    templateUrl: 'directives/map-control/rotograma/agrupamento-rotogramas.tpl.html',
    controller: AgrupamentoRotogramasCtrl,
    bindings: {
      agrupamento: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PesquisaPontoReferenciaService = function PesquisaPontoReferenciaService() {
    _classCallCheck(this, PesquisaPontoReferenciaService);

    this.pontos = [];
    this.cercasEletronicas = [];
    this.buscaPontoArea = [];
    this.pesquisa = '';
    this.logradouroIndex = null;
    this.logradouros = null;
    this.pesquisaCruzamento = '';
    this.pesquisaCidadeCruzamento = '';
    this.coordenadaCruzamento = {};
    this.encontrouCruzamento = null;
    this.tabLogradouro = false;
    this.tabPontoReferencia = true;
    this.tabBuscaPorRegiao = false;
    this.logradouroMarker = null;
    this.enableFieldCruzamento = false;
  };

  angular.module('mapControlModule').service('PesquisaPontoReferenciaService', PesquisaPontoReferenciaService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  function pesquisaPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/pesquisa-ponto-referencia/pesquisa-ponto-referencia.tpl.html',
      controller: 'PesquisaPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  var PesquisaPontoReferenciaCtrl = function () {
    function PesquisaPontoReferenciaCtrl($scope, $window, HttpServiceV3g, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, PontosReferenciaFiltro, PesquisaPontoReferenciaService, CercaEletronicaMapService, BuscaPorRegiaoMapService, BuscaRegiaoService, moment, ServiceVfiltro, $httpParamSerializer, Keys, $state, $rootScope, $location, GoogleTagManagerUtils) {
      _classCallCheck(this, PesquisaPontoReferenciaCtrl);

      this.scope = $scope;
      this.window = $window;
      this.httpService = HttpServiceV3g;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.pesquisaService = PesquisaPontoReferenciaService;
      this.validaPontos = true;
      this.validaPontoArea = true;
      this.validaPesquisaLogradouro = true;
      this.tabLogradouro = false;
      this.tabPontoReferencia = true;
      this.tabBuscaPorRegiao = false;
      this.isAreaBuscaRegiaoCriada = false;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.buscaPorRegiaoMapService = BuscaPorRegiaoMapService;
      this.buscaRegiaoService = BuscaRegiaoService;
      this.moment = moment;
      this.serviceVfiltro = ServiceVfiltro;
      this.httpParamSerializer = $httpParamSerializer;
      this.keys = Keys;
      this.state = $state;
      this.rootScope = $rootScope;
      this.location = $location;
      this.isDemo = this.location.search().demo;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.typePonto = {
        id: 'PONTO_REFERENCIA',
        label: 'Ponto de Referência'
      };
      this.typeCerca = {
        id: 'CERCAS_ELETRONICAS',
        label: 'Cerca Eletrônica'
      };
      this.dateOptions = {
        maxDate: this.moment().startOf('day'),
        startingDay: 0,
        showWeeks: false
      };
      this.paginasPermiteBuscaRegiao = ['root.mapasGrid'];
      this.init();
    }

    _createClass(PesquisaPontoReferenciaCtrl, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this.pontosReferenciaFiltroService.selecionarFiltro = false;
        this.pontosReferenciaFiltroService.init();
        this.scope.$on('$destroy', function () {
          _this.buscaPorRegiaoMapService.removeLayerMap();
          _this.setTabPontoReferencia();
        });
        this.rootScope.$on('clica-busca-regiao', function () {
          return _this.setTabBuscaPorRegiao();
        });
        this.rootScope.$on('desenha-area', function () {
          return _this.desenhaArea();
        });
        this.rootScope.$on('busca-por-regiao', function () {
          return _this.buscaPorRegiao();
        });
        this.rootScope.$on('data-busca-regiao', function () {
          return _this.buscaRegiaoDia = new Date();
        });
        this.rootScope.$on('buscar-veiculo', function () {
          return _this.filtro = 'ABC';
        });
      }
    }, {
      key: 'setTabPontoReferencia',
      value: function setTabPontoReferencia() {
        this.pesquisaService.tabLogradouro = false;
        this.pesquisaService.tabPontoReferencia = true;
        this.pesquisaService.tabBuscaPorRegiao = false;
        this.validaPontos = true;
      }
    }, {
      key: 'tabOnlyLogradouroEnabled',
      value: function tabOnlyLogradouroEnabled() {
        return this.pesquisaService.tabLogradouro && !this.pesquisaService.tabPontoReferencia && !this.pesquisaService.tabBuscaPorRegiao;
      }
    }, {
      key: 'tabOnlyPontoReferencia',
      value: function tabOnlyPontoReferencia() {
        return this.pesquisaService.tabPontoReferencia && !this.pesquisaService.tabLogradouro && !this.pesquisaService.tabBuscaPorRegiao;
      }
    }, {
      key: 'tabOnlyBuscaPorRegiao',
      value: function tabOnlyBuscaPorRegiao() {
        return this.pesquisaService.tabBuscaPorRegiao && !this.pesquisaService.tabLogradouro && !this.pesquisaService.tabPontoReferencia;
      }
    }, {
      key: 'getPlaceHolderInput1',
      value: function getPlaceHolderInput1() {
        if (this.tabOnlyPontoReferencia()) {
          return 'ce.mapa.common.modal.pesquisaPontoReferencia.placeholderBuscarPontoCerca';
        }
        return 'ce.mapa.common.modal.pesquisaPontoReferencia.placeholderNomeLogradouro';
      }
    }, {
      key: 'getLabelMainInput',
      value: function getLabelMainInput() {
        if (this.tabOnlyPontoReferencia()) {
          return 'ce.mapa.common.modal.pesquisaPontoReferencia.labelPontoReferencia';
        } else if (this.tabOnlyLogradouroEnabled()) {
          return 'ce.mapa.common.modal.pesquisaPontoReferencia.labelLogradouro';
        }
        return '';
      }
    }, {
      key: 'setTabLogradouro',
      value: function setTabLogradouro() {
        this.pesquisaService.tabLogradouro = true;
        this.pesquisaService.tabPontoReferencia = false;
        this.pesquisaService.tabBuscaPorRegiao = false;
        this.validaPontos = true;
      }
    }, {
      key: 'setTabBuscaPorRegiao',
      value: function setTabBuscaPorRegiao() {
        this.pesquisaService.tabLogradouro = false;
        this.pesquisaService.tabPontoReferencia = false;
        this.pesquisaService.tabBuscaPorRegiao = true;
      }
    }, {
      key: 'busca',
      value: function busca() {
        var isUserInLocalizacaoDaFrotaPage = this.window.location.href.includes('mapas-grid'),
            isUserInHistoricoDetalhadoPage = this.window.location.href.includes('historico-timeline');
        var gtmEventName = void 0;

        if (this.tabOnlyPontoReferencia()) {
          if (isUserInLocalizacaoDaFrotaPage) {
            gtmEventName = 'localizacao_frota_busca_local';
          } else if (isUserInHistoricoDetalhadoPage) {
            gtmEventName = 'historico_detalhado_busca_local';
          }

          var result = this.pesquisaService.pesquisa ? this.pesquisaService.pesquisa.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
          this.pesquisaService.pontos = [];
          this.pesquisaService.cercasEletronicas = [];
          this.pesquisaService.buscaPontoCerca = [];

          this.pontosReferenciaMapService.removeLogradouroMarker();

          if (result.length > 2) {
            this.realizaBuscaPontos(result);
            this.realizaBuscaCercasEletronicas(result);
            this.montaResultadoBusca();
          }
          this.validaPontos = this.pesquisaService.pontos.length > 0;
          this.validaPontoArea = this.pesquisaService.buscaPontoCerca.length > 0;
        } else {
          if (isUserInLocalizacaoDaFrotaPage) {
            gtmEventName = 'localizacao_frota_busca_logradouro';
          } else if (isUserInHistoricoDetalhadoPage) {
            gtmEventName = 'historico_detalhado_busca_logradouro';
          }
          this.buscaRuas();
        }

        if (gtmEventName) {
          this.googleTagManagerUtils.sendEventClickGTM(gtmEventName, this.serviceVfiltro.factoryVfiltro.user);
        }
      }
    }, {
      key: 'realizaBuscaPontos',
      value: function realizaBuscaPontos(searchString) {
        var _this2 = this;

        this.pontosReferenciaMapService.pontosReferencia.forEach(function (item) {
          if (item && _this2.isBuscaNomeCorrespondente(item.entidade.nome, searchString)) {
            item.type = _this2.typePonto;
            item.disabled = !_this2.pontosReferenciaFiltroService.isPontoVisible(item);
            _this2.pesquisaService.pontos.push(item);
          }
        });
      }
    }, {
      key: 'realizaBuscaCercasEletronicas',
      value: function realizaBuscaCercasEletronicas(searchString) {
        var _this3 = this;

        this.cercaEletronicaMapService.cercasEletronicas.forEach(function (cercaEletronica) {
          var cercaParaPesquisa = { entidade: _this3.getCerca(cercaEletronica) };
          if (cercaParaPesquisa && _this3.isBuscaNomeCorrespondente(cercaParaPesquisa.entidade.nome, searchString)) {
            cercaParaPesquisa.type = _this3.typeCerca;
            cercaParaPesquisa.disabled = !_this3.pontosReferenciaFiltroService.isCercaVisible(cercaEletronica);
            cercaParaPesquisa.disabled = !_this3.pontosReferenciaFiltroService.isCercaVisible(cercaEletronica);
            _this3.pesquisaService.cercasEletronicas.push(cercaParaPesquisa);
          }
        });
      }
    }, {
      key: 'isBuscaNomeCorrespondente',
      value: function isBuscaNomeCorrespondente(nomeEntidade, searchString) {
        return nomeEntidade.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(searchString) !== -1;
      }
    }, {
      key: 'montaResultadoBusca',
      value: function montaResultadoBusca() {
        this.pesquisaService.buscaPontoCerca = [].concat(_toConsumableArray(this.pesquisaService.pontos), _toConsumableArray(this.pesquisaService.cercasEletronicas)).sort(function (a, b) {
          return a.entidade.nome.localeCompare(b.entidade.nome);
        });
      }
    }, {
      key: 'focusLocal',
      value: function focusLocal(item) {
        if (item.type.id === this.typePonto.id) {
          this.pontosReferenciaMapService.focusPonto(item);
        }
        if (item.type.id === this.typeCerca.id) {
          this.cercaEletronicaMapService.focusCercaEletronica(item.entidade.id);
        }
      }
    }, {
      key: 'formValido',
      value: function formValido(form) {
        if (this.tabOnlyPontoReferencia()) {
          return form.pesquisa.$valid;
        } else if (this.tabOnlyLogradouroEnabled()) {
          return form.pesquisa.$valid;
        }
        return false;
      }
    }, {
      key: 'formBuscaPorRegiaoValido',
      value: function formBuscaPorRegiaoValido(form) {
        if (this.tabOnlyBuscaPorRegiao() && form.buscaRegiaoDia) {
          return form.buscaRegiaoDia.$valid;
        }
        return false;
      }
    }, {
      key: 'buscaRuas',
      value: function buscaRuas() {
        this.buscaLogradouro();
      }
    }, {
      key: 'buscaLogradouro',
      value: function buscaLogradouro() {
        var _this4 = this;

        this.pesquisaService.logradouroIndex = null;
        this.httpService.get('/geocode/localizacao/search?query=' + encodeURIComponent(this.pesquisaService.pesquisa.toLowerCase())).then(function (data) {
          _this4.pesquisaService.logradouros = data.data;
          _this4.validaPontos = _this4.pesquisaService.logradouros.length !== 0;
        });
      }
    }, {
      key: 'buscaPorRegiao',
      value: function buscaPorRegiao() {
        var _this5 = this;

        this.googleTagManagerUtils.sendEventClickGTM('busca_regiao', this.serviceVfiltro.factoryVfiltro.user);

        this.mostrarResultado = true;
        var params = this.getParams(this.buscaRegiaoDia);

        if (this.isDemo) {
          this.buscaRegiaoService.isDemo = true;
        }

        this.buscaRegiaoService.getList(this.buscaPorRegiaoMapService.layer.getCenter(), params).then(function (data) {
          _this5.pesquisaService.buscaPorRegiao = data.data;
        }).catch(function () {
          _this5.pesquisaService.buscaPorRegiao = [];
        });
      }
    }, {
      key: 'exibirFiltro',
      value: function exibirFiltro(filtro) {
        this.pontosReferenciaFiltroService.filtroSelecionado = filtro;
        this.pontosReferenciaFiltroService.selecionarFiltro = true;
      }
    }, {
      key: 'voltarLista',
      value: function voltarLista() {
        this.pontosReferenciaFiltroService.filtroSelecionado = null;
        this.pontosReferenciaFiltroService.selecionarFiltro = false;
        this.mostrarResultado = false;
      }
    }, {
      key: 'getNomeCategoria',
      value: function getNomeCategoria(item) {
        if (item.objCategoria) {
          return item.objCategoria.nome;
        }
        if (item.entidade.categoria) {
          return item.entidade.categoria.nome;
        }
        return null;
      }
    }, {
      key: 'getCerca',
      value: function getCerca(cercaEletronica) {
        return {
          id: cercaEletronica.id,
          nome: cercaEletronica.nome,
          categoriaId: cercaEletronica.categoriaId,
          categoria: cercaEletronica.categoria
        };
      }
    }, {
      key: 'desenhaArea',
      value: function desenhaArea() {
        this.buscaPorRegiaoMapService.render();
        this.isAreaBuscaRegiaoCriada = true;
      }
    }, {
      key: 'getParams',
      value: function getParams(dia) {
        return this.httpParamSerializer(angular.extend(this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar), { dia: this.moment(dia).format('YYYY-MM-DD') }));
      }
    }, {
      key: 'getLinkHistoricoDetalhado',
      value: function getLinkHistoricoDetalhado(buscaRegiao) {
        var _this6 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this6.keys.uo.name;
        }).value.id,
            dataInicio = this.moment(buscaRegiao.datahora).format('YYYY.MM.DD.HH.mm.ss.ZZ'),
            dataFim = this.moment(buscaRegiao.datahora).format('YYYY.MM.DD.23.59.59.ZZ');

        return '/historico-timeline?vfiltro=dateTime:' + dataInicio + ',' + dataFim + ';uo:' + uoId + ';veiculo:' + buscaRegiao.veiculoId;
      }
    }, {
      key: 'buscaPorRegiaoCancel',
      value: function buscaPorRegiaoCancel() {
        this.buscaRegiaoDia = {};
        this.buscaPorRegiaoMapService.removeLayerMap();
        this.isAreaBuscaRegiaoCriada = false;
      }
    }, {
      key: 'showBuscaPorRegiao',
      value: function showBuscaPorRegiao() {
        return this.paginasPermiteBuscaRegiao.includes(this.state.current.name);
      }
    }]);

    return PesquisaPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').controller('PesquisaPontoReferenciaCtrl', PesquisaPontoReferenciaCtrl).directive('pesquisaPontoReferenciaDirective', pesquisaPontoReferenciaDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalEdicaoPontoReferenciaCtrl = function () {
    function ModalEdicaoPontoReferenciaCtrl($uibModal, PontosReferencia, CategoriaPontosReferencia, AlertMessage, Uos, UoArvoreNivel, ConfiguracoesEvento, CadastroRotogramaService, Authenticator, PontosReferenciaMap, $translate, AdvisorRotogramasService, $rootScope, GoogleTagManagerUtils) {
      _classCallCheck(this, ModalEdicaoPontoReferenciaCtrl);

      this.rootScope = $rootScope;
      this.pontoReferenciaMapService = PontosReferenciaMap;
      this.modalService = $uibModal;
      this.model = {};
      this.permissao = {};
      this.exibirCategorias = false;
      this.textoCategorias = 'ce.mapa.common.modal.editarPontoReferencia.textoCategoriasMostrar';
      this.alertMessage = AlertMessage;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.uosFiltradas = [];
      this.uoSelecionada = {};
      this.pontosReferenciaService = PontosReferencia;
      this.pontosCategoriaReferenciaService = CategoriaPontosReferencia;
      this.podeEditarUoDona = false;
      this.configuracoesEvento = ConfiguracoesEvento;
      this.cadastroRotogramaService = CadastroRotogramaService;
      this.configurarTempoMinimo = false;
      this.checkboxCadastrarRotograma = false;
      this.MINUTO_EM_SEGUNDOS = 60;
      this.config = {
        habilitarSpeedLimit: false
      };
      this.carregarUos();
      this.configuracoesEvento = ConfiguracoesEvento;
      this.authenticator = Authenticator;
      this.translate = $translate;
      this.advisorRotogramasService = AdvisorRotogramasService;
    }

    _createClass(ModalEdicaoPontoReferenciaCtrl, [{
      key: 'onChangeConfigTempoMinimo',
      value: function onChangeConfigTempoMinimo() {
        if (!this.configurarTempoMinimo) {
          this.model.tempoPermanenciaMinimo = null;
        }
      }
    }, {
      key: '$onInit',
      value: function $onInit() {
        this.pontoReferencia = this.resolve.pontoReferencia;
        this.rotogramas = this.resolve.rotogramas;
        this.suggestion = this.resolve.advisorSuggestion;
        this.idUoDona = this.resolve.uoSelecionada;
        this.temRoleEdicaoRotogramas = this.authenticator.hasRole('ROTOGRAMA_EDITAR');
        this.temRoleEditarPermanenciaPontoReferencia = this.authenticator.hasRole('PERMANENCIA_PONTO_REFERENCIA_EDITAR');
        this.checkboxCadastrarRotograma = this.temRoleEdicaoRotogramas && this.rotogramas && this.rotogramas.length > 0 || angular.isDefined(this.suggestion);

        if (this.pontoReferencia.id) {
          this.carregarPonto();
        } else {
          this.model = {
            latitude: ('' + this.pontoReferencia.latitude).replace('.', ','),
            longitude: ('' + this.pontoReferencia.longitude).replace('.', ','),
            raio: this.pontoReferencia.raio,
            tempoPermanenciaMinimo: this.toMinutes(this.pontoReferencia.tempoPermanenciaMinimo),
            categorias: [],
            advisorSuggestion: this.suggestion
          };
          this.configurarTempoMinimo = !!this.model.tempoPermanenciaMinimo;
        }
      }
    }, {
      key: 'toMinutes',
      value: function toMinutes(time) {
        return time ? time / this.MINUTO_EM_SEGUNDOS : null;
      }
    }, {
      key: 'tempoPermanenciaValid',
      value: function tempoPermanenciaValid() {
        var _this = this;

        return function () {
          return !(_this.model.tempoPermanenciaMinimo && _this.model.tempoPermanenciaMinimo < 3);
        };
      }
    }, {
      key: 'carregarPonto',
      value: function carregarPonto() {
        var _this2 = this;

        this.pontosReferenciaService.getPontoReferencia(this.pontoReferencia.id).then(function (data) {
          var item = data.plain();
          _this2.permissao = item.permissao;
          _this2.model = item.entidade;
          _this2.model.latitude = item.entidade.latitude.toString().replace('.', ',');
          _this2.model.longitude = item.entidade.longitude.toString().replace('.', ',');
          _this2.model.tempoPermanenciaMinimo = _this2.toMinutes(item.entidade.tempoPermanenciaMinimo);
          _this2.configurarTempoMinimo = !!_this2.model.tempoPermanenciaMinimo;
          _this2.carregarCategorias(item.entidade.uo, item.entidade.categoria);
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorCarregarPonto'),
            appendTo: '.alerta-aqui-cadastro-ponto'
          });
        });
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this3 = this;

        this.uoService.getFilhas().then(function (data) {
          _this3.uosFiltradas = _this3.uoArvoreNivel.converterEmLista(data.plain());
          _this3.uoSelecionada = _this3.uosFiltradas.filter(function (uo) {
            return uo.id === _this3.idUoDona;
          })[0];
          _this3.podeEditarUoDona = _this3.podeEditarUoDoPonto();
          if (!_this3.pontoReferencia.id && _this3.uoSelecionada) {
            _this3.carregarCategorias(_this3.uoSelecionada.id);
          }
        });
      }
    }, {
      key: 'podeEditarUoDoPonto',
      value: function podeEditarUoDoPonto() {
        var _this4 = this;

        return angular.isDefined(this.uosFiltradas.find(function (uo) {
          return uo.id === _this4.idUoDona;
        }));
      }
    }, {
      key: 'carregarConfiguracoes',
      value: function carregarConfiguracoes(uoId) {
        var _this5 = this;

        this.configuracoesEvento.getConfiguracoes(uoId).then(function (data) {
          _this5.config.habilitarSpeedLimit = data.speedlimitPontoHabilitar;
        }).catch(function () {
          _this5.config = {
            habilitarSpeedLimit: false
          };
        });
      }
    }, {
      key: 'carregarCategorias',
      value: function carregarCategorias(uoId, categoriaId) {
        var _this6 = this;

        this.pontosCategoriaReferenciaService.getListCategoriasPontoReferencia().then(function (data) {
          _this6.model.categorias = data.filter(function (f) {
            return f.uo === uoId;
          }).sort(function (a, b) {
            return a.nome.localeCompare(b.nome);
          });
          _this6.model.categoria = _this6.model.categorias.filter(function (f) {
            return f.id === categoriaId;
          })[0];
        }).catch(function () {
          _this6.alertMessage.create({
            type: 'error',
            message: _this6.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorCarregarCategorias'),
            appendTo: '.alerta-aqui-cadastro-ponto'
          });
        });
        this.carregarConfiguracoes(uoId);
      }
    }, {
      key: 'mostrarCategorias',
      value: function mostrarCategorias() {
        if (this.exibirCategorias) {
          this.exibirCategorias = false;
          this.textoCategorias = 'ce.mapa.common.modal.editarPontoReferencia.textoCategoriasMostrar';
        } else {
          this.exibirCategorias = true;
          this.textoCategorias = 'ce.mapa.common.modal.editarPontoReferencia.textoCategoriasOcultar';
        }
      }
    }, {
      key: 'reloadCategorias',
      value: function reloadCategorias(msg, categoriaId) {
        this.alertMessage.create({
          type: 'success',
          message: msg,
          appendTo: '.alerta-aqui-cadastro-ponto'
        });
        this.carregarCategorias(this.uoSelecionada.id, categoriaId);
      }
    }, {
      key: 'adicionarCategoria',
      value: function adicionarCategoria() {
        var _this7 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'directives/map-control/categoria-ponto-referencia/cadastrar-categoria-ponto-referencia.tpl.html',
          controller: 'CadastrarCategoriaPontoReferenciaCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            uoSelecionada: function uoSelecionada() {
              return _this7.uoSelecionada;
            }
          }
        }).result.then(function (data) {
          _this7.reloadCategorias(_this7.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoAdicionarCategoria'), data.id);
        });
      }
    }, {
      key: 'editarCategoria',
      value: function editarCategoria(categoriaId) {
        var _this8 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'directives/map-control/categoria-ponto-referencia/cadastrar-categoria-ponto-referencia.tpl.html',
          controller: 'EditarCategoriaPontoReferenciaCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            categoriaId: categoriaId,
            uoSelecionada: function uoSelecionada() {
              return _this8.uoSelecionada;
            }
          }
        }).result.then(function (data) {
          _this8.reloadCategorias(_this8.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoEditarCategoria'), data.id);
        });
      }
    }, {
      key: 'excluirCategorias',
      value: function excluirCategorias(categoriaId) {
        var _this9 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'directives/map-control/categoria-ponto-referencia/excluir-categoria-ponto-referencia.tpl.html',
          controller: 'ExcluirCategoriaPontoReferenciaCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            categoriaId: categoriaId
          }
        }).result.then(function () {
          _this9.reloadCategorias(_this9.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoExcluirCategoria'));
        });
      }
    }, {
      key: 'ok',
      value: function ok() {
        var ponto = {
          id: this.model.id,
          uo: angular.isDefined(this.uoSelecionada) ? this.uoSelecionada.id : this.idUoDona,
          nome: this.model.nome,
          latitude: this.model.latitude.replace(',', '.'),
          longitude: this.model.longitude.replace(',', '.'),
          raio: this.model.raio,
          limiteVelocidade: this.model.limiteVelocidade,
          tempoPermanenciaMinimo: this.model.tempoPermanenciaMinimo ? this.model.tempoPermanenciaMinimo * this.MINUTO_EM_SEGUNDOS : null
        };
        if (angular.isDefined(this.model.observacao) && this.model.observacao !== null) {
          ponto.observacao = this.model.observacao;
        }
        if (angular.isDefined(this.model.categoria) && this.model.categoria !== null) {
          ponto.categoria = this.model.categoria.id;
        }
        this.salvar(ponto);
      }
    }, {
      key: 'salvar',
      value: function salvar(pontoReferencia) {
        var _this10 = this;

        if (!pontoReferencia.id) {
          this.pontosReferenciaService.postPontoReferencia(pontoReferencia).then(function (data) {
            if (_this10.suggestion) {
              _this10.updateSugestaoRotograma('APROVADO');
              _this10.sendAcceptedAdvisorToGTM();
            }
            var categoria = !_this10.model.categoria ? _this10.pontosCategoriaReferenciaService.categoriaDefault : _this10.model.categoria;
            if (_this10.checkboxCadastrarRotograma && _this10.temRoleEdicaoRotogramas) {
              _this10.cadastroRotogramaService.pontoReferenciaId = data.id;
              _this10.cadastroRotogramaService.salvar(data.id);
              data.texto = _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoCadastrarPontoRotograma');
            } else {
              data.texto = _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoCadastrarPonto');
            }
            _this10.close({
              $value: {
                isNew: true,
                entidade: data.plain(),
                permissao: {
                  uo: _this10.uoSelecionada && _this10.podeEditarUoDoPonto() ? _this10.uoSelecionada : _this10.idUoDona,
                  edicao: true
                },
                objCategoria: categoria
              }
            });
          }).catch(function (err) {
            if (err && err.status === 409) {
              _this10.updateSugestaoRotograma('PONTO_SOBREPOSTO');
              _this10.alertMessage.create({
                type: 'error',
                message: _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorCadastrarSobreposto'),
                appendTo: '.alerta-aqui-cadastro-ponto'
              });
            } else if (err && err.status === 403) {
              _this10.alertMessage.create({
                type: 'error',
                message: _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorRegraEmbarque'),
                appendTo: '.alerta-aqui-cadastro-ponto'
              });
            } else {
              _this10.alertMessage.create({
                type: 'error',
                message: _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorCadastroPonto'),
                appendTo: '.alerta-aqui-cadastro-ponto'
              });
            }
          });
        } else {
          this.pontosReferenciaService.putPontoReferencia(pontoReferencia).then(function (pontoReferenciaResponse) {
            var categoria = angular.isDefined(_this10.model.categoria) && _this10.model.categoria !== null ? _this10.model.categoria : _this10.pontosCategoriaReferenciaService.categoriaDefault;
            if (angular.isDefined(_this10.uoSelecionada)) {
              _this10.permissao.uo = _this10.uoSelecionada;
            }
            if (_this10.temRoleEdicaoRotogramas) {
              if (_this10.checkboxCadastrarRotograma) {
                pontoReferenciaResponse.texto = _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoEditarPontoRotograma');
                _this10.cadastroRotogramaService.pontoReferenciaId = pontoReferenciaResponse.id;
                _this10.cadastroRotogramaService.salvar(pontoReferenciaResponse.id);
              } else {
                pontoReferenciaResponse.texto = _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoEditarPonto');
                _this10.cadastroRotogramaService.excluir(pontoReferenciaResponse.id);
              }
            } else {
              pontoReferenciaResponse.texto = _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.sucessoEditarPonto');
            }
            _this10.close({
              $value: {
                entidade: pontoReferenciaResponse,
                permissao: _this10.permissao,
                objCategoria: categoria,
                oldId: pontoReferencia.id
              }
            });
          }).catch(function (pontoReferenciaError) {
            if (pontoReferenciaError && pontoReferenciaError.status === 409) {
              _this10.alertMessage.create({
                type: 'error',
                message: _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorEditarSobreposto'),
                appendTo: '.alerta-aqui-cadastro-ponto'
              });
            } else {
              _this10.alertMessage.create({
                type: 'error',
                message: _this10.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorEditarPonto'),
                appendTo: '.alerta-aqui-cadastro-ponto'
              });
            }
          });
        }
      }
    }, {
      key: 'updateSugestaoRotograma',
      value: function updateSugestaoRotograma(status) {
        var _this11 = this;

        this.advisorRotogramasService.updateStatus(this.uoSelecionada.id, this.suggestion.uuid, status).then(function () {
          return _this11.rootScope.$broadcast('advisorAtualizado');
        });
      }
    }, {
      key: 'sendAcceptedAdvisorToGTM',
      value: function sendAcceptedAdvisorToGTM() {
        var _this12 = this;

        this.authenticator.getUser().then(function (user) {
          _this12.googleTagManagerUtils.sendEventClickGTM('advisor_aceito', user);
        });
      }
    }]);

    return ModalEdicaoPontoReferenciaCtrl;
  }();

  angular.module('mapControlModule').component('modalEdicaoPontoReferencia', {
    controller: ModalEdicaoPontoReferenciaCtrl,
    templateUrl: 'directives/map-control/cadastrar-ponto-referencia/editar-ponto-referencia.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var SuggestionCardCtrl = function () {
    function SuggestionCardCtrl($translate, Authenticator, ConvertersService) {
      var _this = this;

      _classCallCheck(this, SuggestionCardCtrl);

      this.translate = $translate;
      this.authenticator = Authenticator;
      this.converter = ConvertersService;
      this.authenticator.getUser().then(function (user) {
        _this.userSpeedMeasurement = user.measurementUnits.speedMeasurement;
      });
    }

    _createClass(SuggestionCardCtrl, [{
      key: 'getTotalEventosBruscos',
      value: function getTotalEventosBruscos() {
        var _this2 = this;

        var keyEvents = Object.keys(this.suggestion.eventos);

        return keyEvents.reduce(function (acc, keyEvent) {
          return acc + _this2.suggestion.eventos[keyEvent];
        }, 0);
      }
    }, {
      key: 'getMinSpeed',
      value: function getMinSpeed() {
        var _this3 = this;

        var speedUnit = this.userSpeedMeasurement,
            speedValues = Object.keys(this.suggestion.velocidadeInterna).map(function (key) {
          return _this3.suggestion.velocidadeInterna[key];
        }),
            speed = Math.min.apply(Math, _toConsumableArray(speedValues));

        if (speedUnit === 'MILES') {
          return this.converter.handleKmToMiles(speed);
        }

        return speed;
      }
    }, {
      key: 'getLogradouro',
      value: function getLogradouro() {
        return this.suggestion.logradouro ? this.suggestion.logradouro : this.translate.instant('ce.common.logradouroNaoEncontrado');
      }
    }]);

    return SuggestionCardCtrl;
  }();

  angular.module('mapControlModule').component('suggestionCard', {
    controller: SuggestionCardCtrl,
    templateUrl: 'directives/map-control/advisor-rotogramas/suggestion-card-component.tpl.html',
    bindings: {
      suggestion: '<',
      index: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var BtnAdvisorRotogramasCtrl = function () {
    function BtnAdvisorRotogramasCtrl(PontosReferenciaMap, Authenticator, $rootScope) {
      _classCallCheck(this, BtnAdvisorRotogramasCtrl);

      this.rootScope = $rootScope;
      this.pontosReferenciaMap = PontosReferenciaMap;
      this.lastActive = null;
      this.clickOtherSuggestion = false;
      this.user = null;
      this.authenticator = Authenticator;
      this.suggestionCardHeight = 80;
      this.limit = 10;
    }

    _createClass(BtnAdvisorRotogramasCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.rootScope.$on('advisorAtualizado', function () {
          _this.removeSuggestionList();
        });
        this.authenticator.getUser().then(function (user) {
          _this.user = user;
        });
        this.limit = this.getSuggestionLimit();
      }
    }, {
      key: 'activeItem',
      value: function activeItem(item) {
        if (this.hasSuggestionClicked() && this.lastActive.uuid === item.uuid) {
          this.lastActive = Object.assign(this.lastActive, { active: false });
          this.clickOtherSuggestion = false;
        } else {
          if (this.hasSuggestionClicked()) {
            this.lastActive = Object.assign(this.lastActive, { active: false });
            this.clickOtherSuggestion = true;
          }
          item = Object.assign(item, { active: true });
          this.lastActive = item;
        }

        this.toggleSnackbarSuggestion();
      }
    }, {
      key: 'hasSuggestionClicked',
      value: function hasSuggestionClicked() {
        return this.lastActive && this.lastActive.active;
      }
    }, {
      key: 'toggleSnackbarSuggestion',
      value: function toggleSnackbarSuggestion() {
        /* eslint-disable */
        var snackbarElement = document.querySelector('vfwc-snackbar-sugestao-rotograma'); /* eslint-enable */
        if (this.clickOtherSuggestion) {
          this.closeSnackbarSuggestion(snackbarElement);
          this.openSnackbarSuggestion();
          this.focusAndRenderAdvisor();
        } else if (snackbarElement) {
          this.closeSnackbarSuggestion(snackbarElement);
        } else {
          this.openSnackbarSuggestion();
          this.focusAndRenderAdvisor();
        }
      }
    }, {
      key: 'openSnackbarSuggestion',
      value: function openSnackbarSuggestion() {
        /* eslint-disable */
        var snackbarContainer = document.querySelector('#sugestion-rotograma-snackbar'),
            snackbarElement = document.createElement('vfwc-snackbar-sugestao-rotograma'); /* eslint-enable */
        snackbarElement.suggestion = this.lastActive;
        snackbarElement.usuario = this.user;
        snackbarContainer.appendChild(snackbarElement);
        this.onListenerEvents(snackbarElement);
      }
    }, {
      key: 'focusAndRenderAdvisor',
      value: function focusAndRenderAdvisor() {
        var posicao = { lat: this.lastActive.lat, lng: this.lastActive.lng, raio: this.lastActive.raio };
        this.pontosReferenciaMap.renderAdvisorSuggestion(posicao, this.lastActive);
        this.pontosReferenciaMap.focusLocal(posicao);
      }
    }, {
      key: 'closeSnackbarSuggestion',
      value: function closeSnackbarSuggestion(element) {
        if (element) {
          element.remove();
        }
        this.pontosReferenciaMap.unrenderAdvisorSuggestion();
      }
    }, {
      key: 'removeSuggestionList',
      value: function removeSuggestionList() {
        this.clickOtherSuggestion = false;
        this.suggestions = this.suggestions.filter(function (suggestion) {
          return suggestion.active !== true;
        });
        this.toggleSnackbarSuggestion();
      }
    }, {
      key: 'onListenerEvents',
      value: function onListenerEvents(element) {
        var _this2 = this;

        var posicao = { lat: this.lastActive.lat, lng: this.lastActive.lng, raio: this.lastActive.raio, advisorSuggestion: this.lastActive };

        element.addEventListener('reject', function (event) {
          if (event.detail && event.detail.wasRejected) {
            _this2.removeSuggestionList();
          }
        });

        element.addEventListener('openRotogramaModal', function () {
          _this2.pontosReferenciaMap.openModalCreatePontoReferencia(posicao);
        });

        element.addEventListener('verLocal', function () {
          _this2.pontosReferenciaMap.focusLocal(posicao);
        });
      }
    }, {
      key: 'getSuggestionLimit',
      value: function getSuggestionLimit() {
        var container = angular.element('#advisor-container')[0];
        return container.offsetHeight / this.suggestionCardHeight;
      }
    }, {
      key: 'loadMore',
      value: function loadMore() {
        this.limit += this.getSuggestionLimit();
      }
    }]);

    return BtnAdvisorRotogramasCtrl;
  }();

  angular.module('mapControlModule').component('listAdvisorRotogramas', {
    controller: BtnAdvisorRotogramasCtrl,
    templateUrl: 'directives/map-control/advisor-rotogramas/list-advisor-rotogramas-component.tpl.html',
    bindings: {
      suggestions: '='
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BtnAdvisorRotogramasCtrl = function () {
    function BtnAdvisorRotogramasCtrl() {
      _classCallCheck(this, BtnAdvisorRotogramasCtrl);
    }

    _createClass(BtnAdvisorRotogramasCtrl, [{
      key: 'qtdSugestoesExibicao',
      value: function qtdSugestoesExibicao() {
        return this.qtdSugestoes > 9 ? '9+' : this.qtdSugestoes;
      }
    }, {
      key: 'getIcon',
      value: function getIcon() {
        return this.active ? 'fa-caret-right' : 'fa-map-marker';
      }
    }]);

    return BtnAdvisorRotogramasCtrl;
  }();

  angular.module('mapControlModule').component('btnAdvisorRotogramas', {
    controller: BtnAdvisorRotogramasCtrl,
    templateUrl: 'directives/map-control/advisor-rotogramas/btn-advisor-rotogramas-component.tpl.html',
    bindings: {
      qtdSugestoes: '<',
      active: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ADVISOR_ENDPOINT = '/advisor/reducao_velocidade';

  var AdvisorRotogramasService = function () {
    function AdvisorRotogramasService(HttpServiceV3g, ServiceVfiltro, $window, MockGetManyAdvisors, $q) {
      _classCallCheck(this, AdvisorRotogramasService);

      this.httpService = HttpServiceV3g;
      this.serviceVfiltro = ServiceVfiltro;
      this.window = $window;
      this.mockGetManyAdvisors = MockGetManyAdvisors;
      this.q = $q;
      this.isDemo = false;
    }

    _createClass(AdvisorRotogramasService, [{
      key: 'getMany',
      value: function getMany() {
        var _this = this;

        if (this.isDemo) {
          return this.q(function (resolve) {
            return resolve(_this.mockGetManyAdvisors);
          });
        }
        return this.httpService.get(ADVISOR_ENDPOINT + '/' + this.getVfiltroUo());
      }
    }, {
      key: 'updateStatus',
      value: function updateStatus(uoId, uuid, status) {
        return this.httpService.put(ADVISOR_ENDPOINT + '/' + uoId + '/status', null, { params: { uuid: uuid, status: status } });
      }
    }, {
      key: 'getVfiltroUo',
      value: function getVfiltroUo() {
        return angular.fromJson(this.window.localStorage.getItem('vfiltro-' + this.serviceVfiltro.factoryVfiltro.user.id)).uo;
      }
    }]);

    return AdvisorRotogramasService;
  }();

  angular.module('mapControlModule').service('AdvisorRotogramasService', AdvisorRotogramasService);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FocusPontoReferenciaModal = function FocusPontoReferenciaModal($uibModalInstance) {
    _classCallCheck(this, FocusPontoReferenciaModal);

    this.modalInstance = $uibModalInstance;
  };

  angular.module('mapControlModule').controller('FocusPontoReferenciaModalCtrl', FocusPontoReferenciaModal);
})();
'use strict';

(function () {
  'use strict';

  angular.module('mapControlModule').directive('focusPontoReferenciaDirective', function (PontosReferenciaMap) {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        element.on('click', function () {
          return PontosReferenciaMap.centerPontoId(Number(attr.focusPontoReferenciaDirective));
        });
      }
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CERCAS_ELETRONICAS_URL = 'ponto-referencia/cercas-eletronicas',
      fields = ['id', 'nome', 'originalId', 'uoId', 'categoriaId', 'observacao', 'geometria', 'localizacao', 'logradouro', 'tempoPermanenciaMinimo', 'categoria.id', 'categoria.nome', 'categoria.cor', 'categoria.uoId', 'categoria.garagem', 'categoria.areaRisco', 'categoria.ativaSensorPonto', 'tipoPermissao'];

  var CercaEletronicaService = function () {
    function CercaEletronicaService(HttpServiceV3g) {
      _classCallCheck(this, CercaEletronicaService);

      this.http = HttpServiceV3g;
      this.roleCadastrar = false;
      this.roleVisualizar = false;
    }

    _createClass(CercaEletronicaService, [{
      key: 'getListCercaEletronica',
      value: function getListCercaEletronica() {
        return this.http.get('/' + CERCAS_ELETRONICAS_URL + '?fields=' + fields.join());
      }
    }, {
      key: 'getCercaEletronica',
      value: function getCercaEletronica(idCercaEletronica) {
        return this.http.get('/' + CERCAS_ELETRONICAS_URL + '?ids=' + idCercaEletronica + '&fields=' + fields.join()).then(function (cercas) {
          return cercas.data.length ? cercas.data[0] : null;
        });
      }
    }, {
      key: 'createCercaEletronica',
      value: function createCercaEletronica(cercaEletronica) {
        return this.http.post('/' + CERCAS_ELETRONICAS_URL, cercaEletronica);
      }
    }, {
      key: 'updateCercaEletronica',
      value: function updateCercaEletronica(cercaEletronica) {
        return this.http.patch('/' + CERCAS_ELETRONICAS_URL + '/' + cercaEletronica.id, cercaEletronica);
      }
    }, {
      key: 'deleteCercaEletronica',
      value: function deleteCercaEletronica(id) {
        return this.http.delete('/' + CERCAS_ELETRONICAS_URL + '/' + id);
      }
    }]);

    return CercaEletronicaService;
  }();

  angular.module('mapControlModule').service('CercaEletronicaService', CercaEletronicaService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L*/
(function () {
  'use strict';

  var OPACIDADE_NOME_AREA_CONTROLE = 0.75,
      ZOOM_MINIMO_RENDER_MARKER = 13;

  var CercaEletronicaMapService = function () {
    function CercaEletronicaMapService($rootScope, PontosReferenciaMenu, $uibModal, LayerTypeEnum, CercaEletronicaService, MapControlService, PontosReferenciaFiltro, TipoPermissaoEnum, $translate, $sanitize) {
      var _this = this;

      _classCallCheck(this, CercaEletronicaMapService);

      this.cercaEletronicaDrawer = null;
      this.mapControlService = MapControlService;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.tipoPermissao = TipoPermissaoEnum;
      this.map = null;
      this.cercaEletronicaService = CercaEletronicaService;
      this.drawControl = null;
      this.todasCercasEletronicasFeatureGroup = new L.FeatureGroup();
      this.rootScope = $rootScope;
      this.$sanitize = $sanitize;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.modalService = $uibModal;
      this.layerTypeEnum = LayerTypeEnum;
      this.cercasEletronicas = [];
      this.cercaEletronicaSelecionadaLayer = null;
      this.polygonEditable = null;
      this.cercaEletronicaCriandoEditable = null;
      this.translate = $translate;
      this.cercasRendered = [];

      this.rootScope.$on('limpaSelecaoCercaEletronica', function () {
        return _this.setCercaEletronicaSelecionada(null);
      });
    }

    _createClass(CercaEletronicaMapService, [{
      key: 'setCercasEletronicas',
      value: function setCercasEletronicas(cercasEletronicas) {
        this.cercasEletronicas = cercasEletronicas;
        this.mostrarCercasBoundsAtual();
      }
    }, {
      key: 'mostrarCercasBoundsAtual',
      value: function mostrarCercasBoundsAtual() {
        var _this2 = this;

        if (this.map.getZoom() >= ZOOM_MINIMO_RENDER_MARKER) {
          this.cercasEletronicas.forEach(function (cercaEletronica) {
            if (_this2.shouldRender(cercaEletronica)) {
              _this2.render(cercaEletronica);
              _this2.cercasRendered.push(cercaEletronica);
            } else if (cercaEletronica.rendered) {
              _this2.unRender(cercaEletronica);
              _this2.cercasRendered = _this2.cercasRendered.filter(function (i) {
                return cercaEletronica.id !== i.id;
              });
            }
          });
        } else {
          this.cercasRendered.forEach(function (item) {
            return _this2.unRender(item);
          });
          this.cercasRendered = [];
        }
      }
    }, {
      key: 'render',
      value: function render(cercaEletronica) {
        if (!cercaEletronica.layer) {
          cercaEletronica.layer = this.getMarkerFromCercaEletronica(cercaEletronica);
        }
        this.addToMap(cercaEletronica.layer);
        this.addToFeatureGroup(cercaEletronica.layer);
        this.renderTooltip(cercaEletronica.layer);
        cercaEletronica.rendered = true;
      }
    }, {
      key: 'renderTooltip',
      value: function renderTooltip(layer) {
        layer.getTooltip().setOpacity(this.map.getZoom() >= 17 ? OPACIDADE_NOME_AREA_CONTROLE : 0);
      }
    }, {
      key: 'unRender',
      value: function unRender(cercaEletronica) {
        if (cercaEletronica.layer) {
          this.removeFromMap(cercaEletronica.layer);
          this.removeFromFeatureGroup(cercaEletronica.layer);
          cercaEletronica.rendered = false;
        }
      }

      /* Renderiza somente areas de controle que possuem ao menos um ponto em comum com view do mapa */

    }, {
      key: 'shouldRender',
      value: function shouldRender(cercaEletronica) {
        return this.pontosReferenciaFiltroService.isCercaVisible(cercaEletronica) && this.map.getBounds().intersects(this.getLatLngsBoundsCercaEletronica(cercaEletronica));
      }
    }, {
      key: 'getLatLngsBoundsCercaEletronica',
      value: function getLatLngsBoundsCercaEletronica(cercaEletronica) {
        return L.latLngBounds(L.GeoJSON.coordsToLatLngs(cercaEletronica.geometria.coordinates[0]));
      }
    }, {
      key: 'getHtmlLabel',
      value: function getHtmlLabel(nome) {
        var showMsgPermissao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var msgPermissao = this.translate.instant('ce.mapa.common.cercaMapService.msgPermissao');
        if (showMsgPermissao) {
          return '\n          <div class=\'label-nome-area\'>\n            <div>\n              <i class=\'trimble-control-area\'></i>\n              ' + nome + '\n            </div>\n            <div class=\'label-msg-permissao\'>\n              ' + msgPermissao + '\n            </div>\n          </div>';
        }
        return '\n        <div class=\'label-nome-area\'>\n          <i class=\'trimble-control-area\'></i>\n          ' + nome + '\n        </div>';
      }
    }, {
      key: 'getMarkerFromCercaEletronica',
      value: function getMarkerFromCercaEletronica(cercaEletronica) {
        cercaEletronica.nome = this.$sanitize(cercaEletronica.nome);
        var layerCercaEletronica = L.GeoJSON.geometryToLayer({
          type: 'Feature',
          properties: {},
          geometry: cercaEletronica.geometria
        });

        layerCercaEletronica.bindPopup(this.getHtmlLabel(cercaEletronica.nome, !this.podeEditarCerca(cercaEletronica)), { className: 'popup-nome-cerca-eletronica' });

        layerCercaEletronica.bindTooltip(this.getHtmlLabel(cercaEletronica.nome), {
          permanent: true,
          className: 'label-nome-cerca-eletronica',
          direction: 'center',
          opacity: 0
        });

        layerCercaEletronica.setStyle(this.getStyleDefault(cercaEletronica.categoria ? cercaEletronica.categoria.cor : null));
        layerCercaEletronica.cercaEletronica = cercaEletronica;

        return layerCercaEletronica;
      }
    }, {
      key: 'getOptionsPolygon',
      value: function getOptionsPolygon() {
        return {
          showArea: false,
          showLength: false,
          shapeOptions: this.getStyleSelecionada(),
          icon: new L.DivIcon({
            iconSize: new L.Point(15, 15),
            className: 'cerca-eletronica-icon-draw'
          }),
          touchIcon: new L.DivIcon({
            iconSize: new L.Point(15, 15),
            className: 'cerca-eletronica-touch-icon-draw'
          })
        };
      }
    }, {
      key: 'iniciaDesenhoCercaEletronica',
      value: function iniciaDesenhoCercaEletronica() {
        this.cercaEletronicaDrawer = new L.Draw.Polygon(this.map, this.getOptionsPolygon());
        this.onZoomEndMap();
        this.mapControlService.isDrawingCercaEletronica = true;
      }
    }, {
      key: 'onZoomEndMap',
      value: function onZoomEndMap() {
        this.verificaZoom();
        this.map.on('zoomend', this.verificaZoom, this);
      }
    }, {
      key: 'offZoomEndMap',
      value: function offZoomEndMap() {
        this.map.off('zoomend', this.verificaZoom, this);
      }
    }, {
      key: 'verificaZoom',
      value: function verificaZoom() {
        if (this.map.getZoom() >= ZOOM_MINIMO_RENDER_MARKER) {
          this.alertaZoom = false;
          this.cercaEletronicaDrawer.enable();
        } else {
          this.alertaZoom = true;
          this.cercaEletronicaDrawer.disable();
        }
      }
    }, {
      key: 'setMap',
      value: function setMap(map) {
        this.map = map;
        this.drawControl = new L.Control.Draw({
          draw: false,
          edit: {
            moveMarkers: true,
            featureGroup: this.todasCercasEletronicasFeatureGroup
          }
        });

        L.drawLocal.draw.handlers.polygon.tooltip = {
          start: this.translate.instant('ce.mapa.common.cercaMapService.tooltipStart'),
          cont: this.translate.instant('ce.mapa.common.cercaMapService.tooltipCont'),
          end: this.translate.instant('ce.mapa.common.cercaMapService.tooltipEnd')
        };

        var element = L.DomUtil.get('map-control');
        L.DomEvent.on(element, 'mousewheel', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'dblclick', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'mousedown', L.DomEvent.stopPropagation);
        L.DomEvent.on(element, 'contextmenu', L.DomEvent.stopPropagation);
        this.map.invalidateSize(true);
      }

      // Exibe layer no mapa

    }, {
      key: 'addToMap',
      value: function addToMap(layer) {
        this.map.addLayer(layer);
      }
    }, {
      key: 'removeFromMap',
      value: function removeFromMap(layer) {
        this.map.removeLayer(layer);
      }
    }, {
      key: 'addToFeatureGroup',
      value: function addToFeatureGroup(cercaEletronicaLayer) {
        this.todasCercasEletronicasFeatureGroup.addLayer(cercaEletronicaLayer);
      }
    }, {
      key: 'removeFromFeatureGroup',
      value: function removeFromFeatureGroup(layer) {
        this.todasCercasEletronicasFeatureGroup.removeLayer(layer);
      }
    }, {
      key: 'excluirCercaEletronica',
      value: function excluirCercaEletronica(idCercaEletronica) {
        var _this3 = this;

        this.cercasEletronicas = this.cercasEletronicas.filter(function (cercaEletronica) {
          if (cercaEletronica.id === idCercaEletronica) {
            _this3.unRender(cercaEletronica);
            return false;
          }
          return true;
        });
      }
    }, {
      key: 'getCustomEditablePolygon',
      value: function getCustomEditablePolygon(polygonLayer) {
        /**
         * Adiciona options em modo de edição dos polygons do Leaflet.draw
        **/
        return new L.Edit.PolyVerticesEdit(polygonLayer, polygonLayer.getLatLngs(), this.getOptionsPolygon());
      }
    }, {
      key: 'setCercaEletronicaLayerEditable',
      value: function setCercaEletronicaLayerEditable() {
        this.editablePolygon = this.getCustomEditablePolygon(this.cercaEletronicaSelecionadaLayer);
        this.editablePolygon.enable();
        this.mapControlService.isDrawingCercaEletronica = true;
      }
    }, {
      key: 'iniciaEventosEdicao',
      value: function iniciaEventosEdicao() {
        this.eventoDrawStart();
        this.eventoDrawCreated();
      }
    }, {
      key: 'iniciaEventosVisualizacao',
      value: function iniciaEventosVisualizacao() {
        this.onMoveEndMap();
        this.onClickAreaControle();
      }
    }, {
      key: 'onMoveEndMap',
      value: function onMoveEndMap() {
        var _this4 = this;

        this.map.on('moveend', function () {
          return _this4.mostrarCercasBoundsAtual();
        });
      }
    }, {
      key: 'onClickAreaControle',
      value: function onClickAreaControle() {
        var _this5 = this;

        this.todasCercasEletronicasFeatureGroup.on('click', function (e) {
          if (_this5.map.getZoom() >= 17 && _this5.podeEditarCerca(e.layer.cercaEletronica)) {
            e.layer.closePopup();
          }

          if (!_this5.mapControlService.isDrawingCercaEletronica && !_this5.mapControlService.isDrawingPontoRef && _this5.podeEditarCerca(e.layer.cercaEletronica)) {
            _this5.rootScope.$broadcast('limpaSelecaoPontoReferencia');
            _this5.setCercaEletronicaSelecionada(e.layer, e.latlng);
            _this5.setMenuEditar();
          }
        });
      }
    }, {
      key: 'podeEditarCerca',
      value: function podeEditarCerca(cercaEletronica) {
        return this.tipoPermissao.podeEditar(cercaEletronica.tipoPermissao) && this.cercaEletronicaService.roleCadastrar;
      }
    }, {
      key: 'focusCercaEletronica',
      value: function focusCercaEletronica(cercaEletronicaId) {
        var cercaEletronica = this.cercasEletronicas.find(function (cerca) {
          return cerca.id === cercaEletronicaId;
        });
        if (!cercaEletronica.layer) {
          cercaEletronica.layer = this.getMarkerFromCercaEletronica(cercaEletronica);
        }
        this.map.fitBounds(cercaEletronica.layer.getBounds());
        this.setCercaEletronicaSelecionada(cercaEletronica.layer);
        if (this.podeEditarCerca(cercaEletronica)) {
          this.pontosReferenciaMenuService.setFABActive('editar-cerca-eletronica');
          this.pontosReferenciaMenuService.menuOpen();
        }
      }
    }, {
      key: 'setCercaEletronicaSelecionada',
      value: function setCercaEletronicaSelecionada(cercaEletronicaLayer) {
        var latLngClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (this.cercaEletronicaSelecionadaLayer) {
          this.setStyleDefault(this.cercaEletronicaSelecionadaLayer);
        }

        if (cercaEletronicaLayer) {
          this.setStyleSelecionada(cercaEletronicaLayer);
          if (latLngClick && !this.map.getBounds().contains(cercaEletronicaLayer.getBounds())) {
            this.map.panTo(latLngClick);
          } else {
            this.map.panTo(cercaEletronicaLayer.getBounds().getCenter());
          }
        }
        this.cercaEletronicaSelecionadaLayer = cercaEletronicaLayer;
      }
    }, {
      key: 'setStyleDefault',
      value: function setStyleDefault(layer) {
        layer.setStyle(this.getStyleDefault(layer.cercaEletronica.categoria ? layer.cercaEletronica.categoria.cor : null));
      }
    }, {
      key: 'setStyleSelecionada',
      value: function setStyleSelecionada(layer) {
        layer.setStyle(this.getStyleSelecionada(layer.cercaEletronica.categoria ? layer.cercaEletronica.categoria.cor : null));
      }
    }, {
      key: 'getStyleDefault',
      value: function getStyleDefault() {
        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000';

        return {
          stroke: true,
          color: color,
          opacity: 0.5,
          weight: 2,
          fill: true,
          fillColor: color,
          fillOpacity: 0.38,
          clickable: true
        };
      }
    }, {
      key: 'getStyleSelecionada',
      value: function getStyleSelecionada() {
        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000';

        return {
          stroke: true,
          color: color,
          opacity: 0.5,
          weight: 4,
          fill: true,
          fillColor: color,
          fillOpacity: 0.75,
          clickable: true
        };
      }
    }, {
      key: 'eventoDrawStart',
      value: function eventoDrawStart() {
        var _this6 = this;

        this.map.on(L.Draw.Event.DRAWSTART, function () {
          _this6.setCercaEletronicaSelecionada(null);
        });
      }
    }, {
      key: 'setMenuEditar',
      value: function setMenuEditar() {
        var _this7 = this;

        angular.element('#map-control').scope().$apply(function () {
          _this7.pontosReferenciaMenuService.setFABActive('editar-cerca-eletronica');
          _this7.pontosReferenciaMenuService.menuOpen();
        });
      }
    }, {
      key: 'eventoDrawCreated',
      value: function eventoDrawCreated() {
        var _this8 = this;

        this.map.on(L.Draw.Event.CREATED, function (e) {
          if (e.layerType === _this8.layerTypeEnum.POLYGON) {
            _this8.offZoomEndMap();
            _this8.cercaEletronicaCriandoLayer = e.layer;
            _this8.drawCreatedAreaControle();
          }
        });
      }
    }, {
      key: 'drawCreatedAreaControle',
      value: function drawCreatedAreaControle() {
        var _this9 = this;

        var buttonsPrincipal = {
          active: 'trimble-control-area',
          resting: 'trimble-control-area'
        },
            buttonsCercaEletronica = [{
          titulo: 'ce.mapa.common.tituloBtConfirmar',
          icon: 'fa fa-check',
          color: 'success',
          tipo: 'adicionar-cerca-eletronica',
          funcao: this.confirmaCercaEletronica.bind(this)
        }, {
          titulo: 'ce.mapa.common.tituloBtCancelar',
          icon: 'fa fa-times',
          color: 'danger',
          tipo: 'default',
          funcao: this.cancelarDesenhoCerca.bind(this)
        }];

        this.addToMap(this.cercaEletronicaCriandoLayer);
        this.cercaEletronicaCriandoEditable = this.getCustomEditablePolygon(this.cercaEletronicaCriandoLayer);
        this.cercaEletronicaCriandoEditable.enable();

        this.mapControlService.isDrawingCercaEletronica = true;

        this.rootScope.$apply(function () {
          _this9.pontosReferenciaMenuService.setMenu(buttonsCercaEletronica, buttonsPrincipal);
          _this9.pontosReferenciaMenuService.menuOpen();
        });
      }
    }, {
      key: 'cancelarDesenhoCerca',
      value: function cancelarDesenhoCerca() {
        if (this.cercaEletronicaDrawer) {
          this.offZoomEndMap();
          this.cercaEletronicaDrawer.disable();
        }

        if (this.cercaEletronicaCriandoLayer) {
          this.cercaEletronicaCriandoEditable.disable();
          this.map.removeLayer(this.cercaEletronicaCriandoLayer);
          this.cercaEletronicaCriandoLayer = null;
        }

        this.cercaEletronicaDrawer = null;
        this.alertaZoom = false;
        this.mapControlService.isDrawingCercaEletronica = false;
        this.pontosReferenciaMenuService.setFABDefault();
      }
    }, {
      key: 'confirmaCercaEletronica',
      value: function confirmaCercaEletronica() {
        var cercaEletronica = {
          geometria: this.cercaEletronicaCriandoLayer.toGeoJSON().geometry
        };
        this.openModalCadastro(cercaEletronica);
      }
    }, {
      key: 'openModalCadastro',
      value: function openModalCadastro(_cercaEletronica) {
        var _this10 = this;

        if (_cercaEletronica) {
          this.unRender(_cercaEletronica);
        }
        this.modalService.open({
          animation: true,
          component: 'modalCercaEletronica',
          backdrop: 'static',
          openedClass: 'modal-cerca-eletronica',
          size: 'cerca-eletronica-dimension',
          resolve: {
            cercaEletronica: function cercaEletronica() {
              return _cercaEletronica;
            }
          }
        }).result.then(function (result) {
          if (result.isEdicao) {
            _this10.confirmaEdicaoCercaEletronica(result.cercaEletronica);
          } else {
            _this10.confirmaCadastroCercaEletronica(result.cercaEletronica);
          }
          _this10.pontosReferenciaMenuService.setFABDefault();
          _this10.pontosReferenciaMenuService.menuClose();
          _this10.mostrarCercasBoundsAtual();
        }).catch(function () {
          _this10.mostrarCercasBoundsAtual();
          _this10.setCercaEletronicaSelecionada(_cercaEletronica.layer);
        });
      }
    }, {
      key: 'confirmaCadastroCercaEletronica',
      value: function confirmaCadastroCercaEletronica(cercaEletronica) {
        this.cercaEletronicaCriandoEditable.disable();
        this.removeFromMap(this.cercaEletronicaCriandoLayer);
        this.cercasEletronicas.push(cercaEletronica);
        this.mapControlService.isDrawingCercaEletronica = false;
      }
    }, {
      key: 'editarCadastroCercaEletronica',
      value: function editarCadastroCercaEletronica() {
        var cercaEletronica = this.cercaEletronicaSelecionadaLayer.cercaEletronica;
        this.openModalCadastro(cercaEletronica);
      }
    }, {
      key: 'confirmaEdicaoCercaEletronica',
      value: function confirmaEdicaoCercaEletronica(cercaEletronicaAtualizada) {
        this.excluirCercaEletronica(this.cercaEletronicaSelecionadaLayer.cercaEletronica.id);
        cercaEletronicaAtualizada.layer = null;
        this.cercasEletronicas.push(cercaEletronicaAtualizada);
        this.setCercaEletronicaSelecionada(null);
      }
    }, {
      key: 'clearMarkers',
      value: function clearMarkers() {
        var _this11 = this;

        this.cercasRendered.forEach(function (cercaEletronica) {
          return _this11.unRender(cercaEletronica);
        });
        this.cercasRendered = [];
        this.cercasEletronicas = [];
      }
    }]);

    return CercaEletronicaMapService;
  }();

  angular.module('mapControlModule').service('CercaEletronicaMapService', CercaEletronicaMapService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ExcluirCategoriaPontoReferencia = function () {
    function ExcluirCategoriaPontoReferencia($uibModalInstance, categoriaId, CategoriaPontosReferencia, AlertMessage, Restangular, $translate) {
      _classCallCheck(this, ExcluirCategoriaPontoReferencia);

      this.modalInstance = $uibModalInstance;
      this.model = {};
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.categoriaPontoReferenciaService = CategoriaPontosReferencia;
      this.categoriaId = categoriaId;
      this.translate = $translate;

      this.carregarCategoria();
    }

    _createClass(ExcluirCategoriaPontoReferencia, [{
      key: 'carregarCategoria',
      value: function carregarCategoria() {
        var _this = this;

        this.categoriaPontoReferenciaService.getCategoriaPontoReferencia(this.categoriaId).then(function (data) {
          _this.model = data.plain();
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: _this.translate.instant('ce.mapa.common.modal.errorCarregarCategoria'),
            appendTo: '.alerta-aqui-categoria-ponto-excluir'
          });
        });
      }
    }, {
      key: 'ok',
      value: function ok() {
        var _this2 = this;

        this.categoriaPontoReferenciaService.deleteCategoriaPontoReferencia(this.model.id).then(function () {
          _this2.modalInstance.close();
        }).catch(function (e) {
          _this2.alertMessage.create({
            type: 'error',
            message: angular.isDefined(e) && e.status === 409 ? _this2.translate.instant('ce.mapa.common.modal.excluirCategoriaPonto.errorCategoriaEmUso') : _this2.translate.instant('ce.mapa.common.modal.excluirCategoriaPonto.errorExcluirCategoria'),
            appendTo: '.alerta-aqui-categoria-ponto-excluir'
          });
        });
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return ExcluirCategoriaPontoReferencia;
  }();

  angular.module('mapControlModule').controller('ExcluirCategoriaPontoReferenciaCtrl', ExcluirCategoriaPontoReferencia);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var EditarCategoriaPontoReferencia = function () {
    function EditarCategoriaPontoReferencia($uibModalInstance, $q, categoriaId, CategoriaPontosReferencia, AlertMessage, uoSelecionada, TIPOS_CATEGORIA, $translate) {
      _classCallCheck(this, EditarCategoriaPontoReferencia);

      this.modalInstance = $uibModalInstance;
      this.model = { audioHabilitado: false };
      this.hasVtalks = false;
      this.q = $q;
      this.alertMessage = AlertMessage;
      this.uoSelecionada = uoSelecionada;
      this.categoriaPontoReferenciaService = CategoriaPontosReferencia;
      this.categoriaId = categoriaId;
      this.AREA_RISCO = 'AREA_RISCO';
      this.GARAGEM = 'GARAGEM';
      this.TIPOS_CATEGORIA = TIPOS_CATEGORIA;
      this.temRegra = false;
      this.translate = $translate;

      this.carregarCategoria();
    }

    _createClass(EditarCategoriaPontoReferencia, [{
      key: 'carregarCategoria',
      value: function carregarCategoria() {
        var _this = this;

        this.q.all([this.categoriaPontoReferenciaService.getCategoriaPontoReferencia(this.categoriaId), this.categoriaPontoReferenciaService.getCategoriaAudios(this.uoSelecionada.id), this.categoriaPontoReferenciaService.hasVtalks()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              data = _ref2[0],
              audios = _ref2[1],
              hasVtalks = _ref2[2];

          _this.hasVtalks = hasVtalks;
          _this.audios = _this.ordenarAudios(audios.plain());
          // API retorna uma lista vazia quando a uo não possui regra cadastrada
          _this.temRegra = _this.audios.length > 0;
          _this.model = data.plain();
          if (_this.audios) {
            _this.model.audio = _this.audios.find(function (audio) {
              return audio.id === _this.model.audioId;
            });
          }

          _this.model.audioHabilitado = Boolean(_this.model.audioId);

          if (_this.model.areaRisco || _this.model.garagem) {
            _this.model.tipo = _this.model.areaRisco ? _this.TIPOS_CATEGORIA[_this.AREA_RISCO] : _this.TIPOS_CATEGORIA[_this.GARAGEM];
          }
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: _this.translate.instant('ce.mapa.common.modal.errorCarregarCategoria'),
            appendTo: '.alerta-aqui-categoria-ponto'
          });
        });
      }
    }, {
      key: 'ordenarAudios',
      value: function ordenarAudios(audios) {
        return audios.sort(function (a, b) {
          return a.nome.localeCompare(b.nome);
        });
      }
    }, {
      key: 'changeAudioHabilitado',
      value: function changeAudioHabilitado() {
        this.model.audioHabilitado = !this.model.audioHabilitado;
      }
    }, {
      key: 'ok',
      value: function ok() {
        var _this2 = this;

        var categoria = {
          id: this.model.id,
          uo: this.uoSelecionada.id,
          nome: this.model.nome,
          cor: this.model.cor,
          areaRisco: angular.isDefined(this.model.tipo) && this.model.tipo !== null && this.model.tipo.id === this.AREA_RISCO,
          garagem: angular.isDefined(this.model.tipo) && this.model.tipo !== null && this.model.tipo.id === this.GARAGEM,
          audioId: this.model.audioHabilitado && angular.isDefined(this.model.audio) ? this.model.audio.id : null
        };
        this.categoriaPontoReferenciaService.putCategoriaPontoReferencia(categoria).then(function (data) {
          _this2.modalInstance.close(data.plain());
        }).catch(function (e) {
          _this2.alertMessage.create({
            type: 'error',
            message: angular.isDefined(e) && e.status === 409 ? _this2.translate.instant('ce.mapa.common.modal.editarPontoReferencia.categoriaJaCadastrada') + ' "' + e.data.nome + '"' : _this2.translate.instant('ce.mapa.common.modal.editarPontoReferencia.errorEditarCategoria'),
            appendTo: '.alerta-aqui-categoria-ponto'
          });
        });
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return EditarCategoriaPontoReferencia;
  }();

  angular.module('mapControlModule').controller('EditarCategoriaPontoReferenciaCtrl', EditarCategoriaPontoReferencia);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CadastrarCategoriaPontoReferencia = function () {
    function CadastrarCategoriaPontoReferencia($uibModalInstance, CategoriaPontosReferencia, AlertMessage, Restangular, uoSelecionada, TIPOS_CATEGORIA, $q, $translate) {
      _classCallCheck(this, CadastrarCategoriaPontoReferencia);

      this.q = $q;
      this.modalInstance = $uibModalInstance;
      this.model = {
        cor: '#000000',
        audioHabilitado: false
      };
      this.hasVtalks = false;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.uoSelecionada = uoSelecionada;
      this.categoriaPontoReferenciaService = CategoriaPontosReferencia;
      this.AREA_RISCO = 'AREA_RISCO';
      this.GARAGEM = 'GARAGEM';
      this.TIPOS_CATEGORIA = TIPOS_CATEGORIA;
      this.audios = null;
      this.temRegra = false;
      this.translate = $translate;
      this.init();
    }

    _createClass(CadastrarCategoriaPontoReferencia, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this.q.all([this.categoriaPontoReferenciaService.getCategoriaAudios(this.uoSelecionada.id), this.categoriaPontoReferenciaService.hasVtalks()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              audios = _ref2[0],
              hasVtalks = _ref2[1];

          _this.hasVtalks = hasVtalks;
          _this.audios = _this.ordenarAudios(audios.plain());
          // API retorna uma lista vazia quando a uo não possui regra cadastrada
          _this.temRegra = _this.audios.length > 0;
        });
      }
    }, {
      key: 'ordenarAudios',
      value: function ordenarAudios(audios) {
        return audios.sort(function (a, b) {
          return a.nome.localeCompare(b.nome);
        });
      }
    }, {
      key: 'changeAudioHabilitado',
      value: function changeAudioHabilitado() {
        this.model.audioHabilitado = !this.model.audioHabilitado;
      }
    }, {
      key: 'ok',
      value: function ok() {
        var _this2 = this;

        var categoria = {
          uo: this.uoSelecionada.id,
          nome: this.model.nome,
          cor: this.model.cor,
          areaRisco: angular.isDefined(this.model.tipo) && this.model.tipo !== null && this.model.tipo.id === this.AREA_RISCO,
          garagem: angular.isDefined(this.model.tipo) && this.model.tipo !== null && this.model.tipo.id === this.GARAGEM,
          audioId: this.model.audioHabilitado && angular.isDefined(this.model.audio) ? this.model.audio.id : null
        };
        this.categoriaPontoReferenciaService.postCategoriaPontoReferencia(categoria).then(function (data) {
          _this2.modalInstance.close(data.plain());
        }).catch(function (e) {
          _this2.alertMessage.create({
            type: 'error',
            message: angular.isDefined(e) && e.status === 409 ? _this2.translate.instant('ce.mapa.common.modal.cadastrarCategoriaPonto.categoriaJaCadastrada') + ' "' + e.data.nome + '"' : _this2.translate.instant('ce.mapa.common.modal.cadastrarCategoriaPonto.errorCadastrarCategoria'),
            appendTo: '.alerta-aqui-categoria-ponto'
          });
        });
      }
    }, {
      key: 'close',
      value: function close() {
        this.modalInstance.dismiss();
      }
    }]);

    return CadastrarCategoriaPontoReferencia;
  }();

  angular.module('mapControlModule').controller('CadastrarCategoriaPontoReferenciaCtrl', CadastrarCategoriaPontoReferencia);
})();
'use strict';

(function () {
  'use strict';

  function InputCheckbox() {
    return {
      templateUrl: 'configuracoes/components/checkbox/input-checkbox.tpl.html',
      controllerAs: 'ctrl',
      restrict: 'E',
      replace: true,
      scope: {
        model: '=',
        disabled: '=',
        name: '@',
        change: '='
      }
    };
  }

  angular.module('InputCheckboxModule', []).directive('inputCheckbox', InputCheckbox);
})();
'use strict';

(function () {
  'use strict';

  function InputNumber() {
    return {
      templateUrl: 'configuracoes/components/number/input-number.tpl.html',
      controllerAs: 'ctrl',
      restrict: 'E',
      require: '^form',
      replace: true,
      scope: {
        type: '@',
        numberMask: '=?',
        model: '=',
        disabled: '=',
        name: '@',
        enable: '=',
        mask: '=',
        min: '=?',
        max: '=?',
        maxlength: '=?',
        onChange: '&?'
      },
      link: function link(scope, element, attrs, formCtrl) {
        scope.form = formCtrl;
        if (angular.isUndefined(scope.min)) {
          scope.min = 1;
        }
        if (angular.isUndefined(scope.max)) {
          scope.max = 999;
        }
        if (angular.isUndefined(scope.maxlength)) {
          scope.maxlength = 7;
        }
      }
    };
  }

  angular.module('InputNumberModule', ['pascalprecht.translate']).directive('inputNumber', InputNumber);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.veiculo
   * @description
   *
   */

  angular.module('cadastros.veiculo', ['ui.router', 'restangular', 'angularMoment', 'alert-message', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'enumModule', 'pascalprecht.translate', 'modalInfoConfirmModule', 'FeatureFlagModule', 'relatorios', 'FeatureOuModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var SituacaoVeiculoCtrl = function () {
    function SituacaoVeiculoCtrl($uibModalInstance, Restangular, veiculos, moment, $translate) {
      _classCallCheck(this, SituacaoVeiculoCtrl);

      this.modalInstance = $uibModalInstance;
      this.restangular = Restangular;
      this.veiculos = veiculos;
      this.moment = moment;

      this.tomorrow = this.moment().startOf('day').add(1, 'days');
      this.situacoesComDataRetorno = ['Em manutenção', 'Fora de operação', 'Manutenção mecânica', 'En manutención', 'Fuera de operación', 'Mantenimiento mecánico', 'Under maintenance', 'Out of service', 'Mechanical maintenance'];
      this.situacoesOption = [];
      this.situacaoSelected = null;
      this.translate = $translate;
      this.dataRetorno = null;
      this.dateOptions = {
        formatYear: 'yy',
        minDate: this.tomorrow,
        startingDay: 0,
        showWeeks: false
      };
      this.translate = $translate;

      this.init();
    }

    _createClass(SituacaoVeiculoCtrl, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this.restangular.all('veiculo/veiculos/situacoes').getList().then(function (situacoes) {
          return _this.situacoesOption = situacoes.plain();
        }).catch(function () {
          return _this.modalInstance.dismiss({ msg: _this.translate.instant('ce.cadastro.veiculos.modalSituacao.falha') });
        });
      }
    }, {
      key: 'registrar',
      value: function registrar() {
        var _this2 = this;

        this.restangular.all('veiculo/veiculos/permitidos/situacao').post(this.buildSituacoes()).then(function () {
          return _this2.modalInstance.close({ situacao: _this2.situacaoSelected, dataRetorno: _this2.dataRetorno });
        }).catch(function (err) {
          return _this2.modalInstance.dismiss({ msg: err.msg });
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'buildSituacoes',
      value: function buildSituacoes() {
        var _this3 = this;

        return this.veiculos.map(function (veiculo) {
          return {
            veiculoId: veiculo.id,
            situacaoId: _this3.situacaoSelected.id,
            dataRetorno: _this3.dataRetorno ? _this3.moment(_this3.dataRetorno).format('YYYY-MM-DD').toString() : _this3.dataRetorno
          };
        });
      }
    }, {
      key: 'getMsgError',
      value: function getMsgError(inputScope) {
        if (angular.isDefined(inputScope)) {
          if (inputScope.$invalid && inputScope.$touched) {
            return this.translate.instant('ce.cadastro.veiculos.modalSituacao.dataObrigatoria');
          }
          if (this.dataRetorno && this.moment(this.dataRetorno).isBefore(this.tomorrow)) {
            return this.translate.instant('ce.cadastro.veiculos.modalSituacao.dataPeriodoPermitido');
          }
        }
        return null;
      }
    }, {
      key: 'isSituacaoWithDataRetorno',
      value: function isSituacaoWithDataRetorno() {
        return this.situacaoSelected && this.situacaoSelected.nome ? this.situacoesComDataRetorno.includes(this.situacaoSelected.nome) : false;
      }
    }]);

    return SituacaoVeiculoCtrl;
  }();

  angular.module('cadastros.veiculo').controller('SituacaoVeiculoCtrl', SituacaoVeiculoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SafetyService = function () {
  function SafetyService($document, $window, $log, $timeout, $rootScope, UrlConfigService, Authenticator) {
    _classCallCheck(this, SafetyService);

    this.$log = $log;
    this.$document = $document[0];
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.urlConfigService = UrlConfigService;
    this.authenticator = Authenticator;
    this.isLocalhost = this.urlConfigService.location.host() === 'ce-local.ttl.dev.br';
    this.remoteEntryUrl = this.isLocalhost ? 'https://localhost:3002/remoteEntry.js?v=' + Date.now() : this.urlConfigService.getSafetyComponentsUrl() + '/remoteEntry.js?v=' + Date.now();
    this.reactLoaded = false;
    this.reactDOMLoaded = false;
    this.remoteEntryLoaded = false;
    this.initializationPromise = null;
    this.userpilotService = null;
    this.initialize();
    this.roots = {};
  }

  _createClass(SafetyService, [{
    key: 'initialize',
    value: function initialize() {
      var _this = this;

      if (!this.initializationPromise) {
        this.initializationPromise = Promise.all([this.loadReactAndReactDOM(), this.loadRemoteEntry()]).then(function () {
          _this.reactLoaded = true;
          _this.remoteEntryLoaded = true;
          _this.initializeLeafletService('safetyApp').then(function (leafletService) {
            return leafletService();
          }).then(function (leafletModule) {
            var initLeaflet = leafletModule.initLeaflet;

            initLeaflet();
          });
        }).catch(function (error) {
          _this.$log.error('Error loading React or RemoteEntry:', error);
        });
      }
      return this.initializationPromise;
    }
  }, {
    key: 'loadReactAndReactDOM',
    value: function loadReactAndReactDOM() {
      var _this2 = this;

      if (this.reactLoaded && this.reactDOMLoaded) {
        return Promise.resolve();
      }

      // Create a module script that imports React and exposes it to window
      var moduleScript = this.$document.createElement('script');
      moduleScript.type = 'module';
      moduleScript.textContent = '\n      import { React, ReactDOM, ReactDOMClient } from \'' + this.urlConfigService.getSafetyReactBundleUrl() + '/react.bundle.js\';\n\n      window.React = React;\n      window.ReactDOM = { ...ReactDOM, createRoot: ReactDOMClient.createRoot };\n\n      window.dispatchEvent(new CustomEvent(\'reactLoaded\'));\n    ';

      return new Promise(function (resolve, reject) {
        var handleReactLoaded = function handleReactLoaded() {
          _this2.reactLoaded = true;
          _this2.reactDOMLoaded = true;
          _this2.$window.removeEventListener('reactLoaded', handleReactLoaded);
          resolve();
        };

        _this2.$window.addEventListener('reactLoaded', handleReactLoaded);

        // Handle script errors
        moduleScript.onerror = function () {
          _this2.$window.removeEventListener('reactLoaded', handleReactLoaded);
          reject(new Error('An error occurred while loading React modules'));
        };

        _this2.$document.head.appendChild(moduleScript);
      });
    }
  }, {
    key: 'loadRemoteEntry',
    value: function loadRemoteEntry() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var script = _this3.$document.createElement('script');
        script.src = _this3.remoteEntryUrl;
        script.onload = resolve;
        if (_this3.isLocalhost) {
          script.crossOrigin = 'anonymous';
        }
        script.onerror = function () {
          return reject(new Error('An error occurred while loading remoteEntry.js'));
        };
        _this3.$document.head.appendChild(script);
      });
    }
  }, {
    key: 'loadReactComponent',
    value: function loadReactComponent(appName, componentPath, componentId, props) {
      var _this4 = this;

      this.unmountReactComponent(componentId);
      return this.getComponentWithRetry(appName, componentPath).then(function (component) {
        var container = _this4.$document.getElementById(componentId);
        if (container) {
          var root = _this4.roots[componentId];
          if (!root) {
            root = _this4.$window.ReactDOM.createRoot(container);
            _this4.roots[componentId] = root;
          }
          root.render(_this4.$window.React.createElement(component().default, props));
        }
      }).catch(function (error) {
        _this4.$log.error('Error loading component at ' + componentPath + ': ', error);
      });
    }
  }, {
    key: 'unmountReactComponent',
    value: function unmountReactComponent(componentId) {
      var container = this.$document.getElementById(componentId),
          root = this.roots[componentId];
      if (container && root) {
        root.unmount();
        delete this.roots[componentId];
      }
    }
  }, {
    key: 'getComponentWithRetry',
    value: function getComponentWithRetry(appName, componentName) {
      var _this5 = this;

      var retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

      return new Promise(function (resolve, reject) {
        var attempt = function attempt() {
          _this5.getComponent(appName, componentName).then(resolve).catch(function (error) {
            if (retries === 0) {
              reject(error);
            } else {
              _this5.$timeout(function () {
                retries--;
                attempt();
              }, delay);
            }
          });
        };
        attempt();
      });
    }
  }, {
    key: 'getComponent',
    value: function getComponent(appName, componentName) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (!_this6.$window || !_this6.$window[appName]) {
          reject(new Error(appName + ' is not loaded or does not exist'));
        } else {
          var checkAppLoaded = function checkAppLoaded() {
            if (!_this6.$window[appName] || Object.keys(_this6.$window[appName]).length === 0) {
              reject(new Error(appName + ' is empty or not exporting anything'));
            } else {
              resolve(_this6.$window[appName].get(componentName));
            }
          };

          if (!_this6.$window[appName]) {
            _this6.$window.addEventListener('appLoaded', checkAppLoaded);
          } else {
            checkAppLoaded();
          }
        }
      });
    }
  }, {
    key: 'initializeLeafletService',
    value: function initializeLeafletService(appName) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        if (!_this7.$window || !_this7.$window[appName]) {
          reject(new Error(appName + ' is not loaded or does not exist'));
        } else {
          var checkAppLoaded = function checkAppLoaded() {
            if (!_this7.$window[appName] || Object.keys(_this7.$window[appName]).length === 0) {
              reject(new Error(appName + ' is empty or not exporting anything'));
            } else {
              resolve(_this7.$window[appName].get('./LeafletService'));
            }
          };

          if (!_this7.$window[appName]) {
            _this7.$window.addEventListener('appLoaded', checkAppLoaded);
          } else {
            checkAppLoaded();
          }
        }
      });
    }
  }, {
    key: 'initializeUserpilot',
    value: function initializeUserpilot() {
      var _this8 = this;

      this.getComponentWithRetry('safetyApp', './UserpilotService').then(function (userpilotModule) {
        return userpilotModule();
      }).then(function (service) {
        _this8.userpilotService = service;
        _this8.authenticator.getUser().then(function (user) {
          service.identifyUser(user);
        });
        _this8.$rootScope.$on('$stateChangeSuccess', function () {
          service.reloadUserpilot();
        });
      }).catch(function (error) {
        _this8.$log.error('Error loading UserpilotService:', error);
      });
    }
  }]);

  return SafetyService;
}();

SafetyService.$inject = ['$document', '$window', '$log', '$timeout', '$rootScope', 'UrlConfigService', 'Authenticator'];

angular.module('safetyModule', []).service('safetyService', SafetyService);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var VehicleRegistrationController = function () {
    function VehicleRegistrationController($scope, $log, Authenticator, safetyService, FeatureOuService) {
      var _this = this;

      _classCallCheck(this, VehicleRegistrationController);

      this.authenticator = Authenticator;
      this.log = $log;
      this.scope = $scope;
      this.safetyService = safetyService;
      this.FeatureOuService = FeatureOuService;
      this.initUserConfig();
      this.scope.$watch(function () {
        return _this.shouldDisableRegisterVehicleButton();
      }, function (newVal) {
        _this.disableRegisterVehicleButton = newVal;
      });
    }

    _createClass(VehicleRegistrationController, [{
      key: 'loadReactComponent',
      value: function loadReactComponent() {
        var _this2 = this;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var appName = 'safetyApp',
            componentPath = './VehicleRegistrationModal',
            componentId = 'vehicleRegistrationModal';
        return this.safetyService.initialize().then(function () {
          return _this2.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        });
      }
    }, {
      key: 'initUserConfig',
      value: function initUserConfig() {
        var _this3 = this;

        this.authenticator.getUser().then(function (user) {
          _this3.isAdministrator = _this3.isUserAdministrator(user.permissoes);
          _this3.language = user.idioma;
          _this3.getVehicleRegistrationConfig(user.uo.id);
        });
      }
    }, {
      key: 'isUserAdministrator',
      value: function isUserAdministrator(permissoes) {
        var AdminProfiles = {
          NA_ADMIN: 'VEICULO_EDITAR'
        };
        return permissoes.includes(AdminProfiles.NA_ADMIN);
      }
    }, {
      key: 'shouldDisableRegisterVehicleButton',
      value: function shouldDisableRegisterVehicleButton() {
        return !this.isAdministrator;
      }
    }, {
      key: 'shouldDisplayRegisterVehicleButton',
      value: function shouldDisplayRegisterVehicleButton() {
        return this.displayRegisterVehicleButton;
      }
    }, {
      key: 'handleRegisterVehicleButtonClick',
      value: function handleRegisterVehicleButtonClick() {
        var _this4 = this;

        if (this.isAdministrator) {
          this.loadReactComponent({
            onRegistrationSuccess: function onRegistrationSuccess() {
              _this4.scope.$apply(function () {
                return _this4.scope.$emit('vehicleRegistered');
              });
            },
            language: this.language
          });
        }
      }
    }, {
      key: 'getVehicleRegistrationConfig',
      value: function getVehicleRegistrationConfig(userUoId) {
        var _this5 = this;

        this.FeatureOuService.getVehicleRegistrationConfig(userUoId).then(function (vehicleRegistration) {
          _this5.displayRegisterVehicleButton = vehicleRegistration;
        }).catch(function (error) {
          _this5.log.error('Error loading featureOu config: ', error);
        });
      }
    }]);

    return VehicleRegistrationController;
  }();

  VehicleRegistrationController.$inject = ['$scope', '$log', 'Authenticator', 'safetyService', 'FeatureOuService'];
  angular.module('safetyModule').controller('VehicleRegistrationCtrl', VehicleRegistrationController);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var QrcodeVeiculoCtrl = function () {
    function QrcodeVeiculoCtrl(CadastroVeiculoService, $window) {
      _classCallCheck(this, QrcodeVeiculoCtrl);

      this.veiculoService = CadastroVeiculoService;
      this.window = $window;

      this.localStorageQrCode = 'qrcode-veiculos-params';
      this.veiculosQrCode = null;
      this.consultarQrCode();
    }

    _createClass(QrcodeVeiculoCtrl, [{
      key: 'consultarQrCode',
      value: function consultarQrCode() {
        var _this = this;

        var params = angular.fromJson(this.window.localStorage.getItem(this.localStorageQrCode));
        this.veiculoService.getQrCode(params).then(function (response) {
          _this.veiculosQrCode = response;
          _this.window.localStorage.removeItem(_this.localStorageQrCode);
        });
      }
    }]);

    return QrcodeVeiculoCtrl;
  }();

  angular.module('cadastros.veiculo').controller('QrcodeVeiculoCtrl', QrcodeVeiculoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var EditarGrupoCtrl = function () {
    function EditarGrupoCtrl($uibModalInstance, veiculos, HttpServiceV3g, $scope, $translate) {
      _classCallCheck(this, EditarGrupoCtrl);

      this.modalInstance = $uibModalInstance;
      this.translate = $translate;
      this.selectInput = { text: this.translate.instant('ce.cadastro.veiculos.modalAlterarGrupo.optPadrao'), disable: false };
      this.veiculos = veiculos;
      this.httpService = HttpServiceV3g;
      this.scope = $scope;
      this.limitItensSelect = 10;
      this.fields = ['id', 'nome', 'uo.nome'];

      this.getGrupos();
    }

    _createClass(EditarGrupoCtrl, [{
      key: 'getGrupos',
      value: function getGrupos() {
        var _this = this;

        this.httpService.get('/veiculo/veiculos/grupos?fields=' + this.fields.join()).success(function (data) {
          _this.gruposDestino = data;
        }).error(function () {
          _this.selectInput = {
            text: _this.translate.instant('ce.cadastro.veiculos.modalAlterarGrupo.msgErro'),
            disable: true
          };
        });
      }
    }, {
      key: 'loadMoreItensSelect',
      value: function loadMoreItensSelect() {
        this.limitItensSelect += 10;
      }
    }, {
      key: 'confirmaEdicao',
      value: function confirmaEdicao() {
        var _this2 = this;

        if (this.scope.editarGrupoForm.grupoDestino.$valid) {
          var veiculosIds = this.veiculos.map(function (veic) {
            return veic.id;
          }),
              edicao = {
            veiculoIds: veiculosIds,
            patch: {
              grupoId: this.grupoDestinoSelected.id
            }
          };
          this.httpService.post('/veiculo/v2/veiculos/batch', edicao).success(function () {
            _this2.modalInstance.close({
              message: _this2.translate.instant('ce.cadastro.veiculos.modalAlterarGrupo.msgSucesso'),
              edition: { grupo: _this2.grupoDestinoSelected, veiculosIds: veiculosIds }
            });
          }).error(function () {
            _this2.modalInstance.dismiss({ message: _this2.translate.instant('ce.cadastro.veiculos.modalAlterarGrupo.falha') });
          });
        } else {
          this.scope.editarGrupoForm.grupoDestino.$setTouched();
        }
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return EditarGrupoCtrl;
  }();

  angular.module('cadastros.veiculo').controller('EditarGrupoCtrl', EditarGrupoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var VehicleEditCtrl = function () {
    function VehicleEditCtrl($scope, Authenticator, safetyService) {
      _classCallCheck(this, VehicleEditCtrl);

      this.scope = $scope;
      this.safetyService = safetyService;
      this.authenticator = Authenticator;
    }

    _createClass(VehicleEditCtrl, [{
      key: 'handleEditVehicleButtonClick',
      value: function handleEditVehicleButtonClick(veiculo, idioma) {
        var _this = this;

        this.loadReactComponent({
          onEditSuccess: function onEditSuccess() {
            _this.scope.$apply(function () {
              return _this.scope.$emit('vehicleEdited');
            });
            _this.safetyService.unmountReactComponent('editVehicleDiv');
          },
          onClose: function onClose() {
            _this.safetyService.unmountReactComponent('editVehicleDiv');
          },
          vehicle: veiculo,
          idioma: idioma
        });
      }
    }, {
      key: 'loadReactComponent',
      value: function loadReactComponent() {
        var _this2 = this;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var appName = 'safetyApp',
            componentPath = './VehicleEditModal',
            componentId = 'editVehicleDiv';
        return this.safetyService.initialize().then(function () {
          return _this2.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        });
      }
    }]);

    return VehicleEditCtrl;
  }();

  angular.module('safetyModule').controller('VehicleEditCtrl', VehicleEditCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var HORA_EM_SEGUNDOS = 3600,
      KM_EM_METROS = 1000;

  var AlertaManutencaoCtrl = function () {
    function AlertaManutencaoCtrl($uibModalInstance, $timeout, Restangular, AlertMessage, veiculos, permissaoManutencaoProgramada, tipoRemocao, HttpServiceV3g, $translate) {
      _classCallCheck(this, AlertaManutencaoCtrl);

      this.modalInstance = $uibModalInstance;
      this.timeout = $timeout;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.veiculos = veiculos;
      this.permissaoManutencaoProgramada = permissaoManutencaoProgramada;
      this.httpService = HttpServiceV3g;
      this.tipoRemocao = tipoRemocao;

      this.intervalo = null;
      this.margem = null;
      this.intervaloBackend = null;
      this.margemBackend = null;
      this.intervaloHorimetro = null;
      this.margemHorimetro = null;
      this.intervaloHorimetroBackend = null;
      this.margemHorimetroBackend = null;
      this.translate = $translate;

      this.init();
    }

    _createClass(AlertaManutencaoCtrl, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this.veiculos = this.veiculos.length === 1 ? this.veiculos[0] : this.veiculos;

        if (!angular.isArray(this.veiculos) && this.veiculos && this.veiculos.manutencaoProgramada) {
          this.intervalo = this.veiculos.manutencaoProgramada.intervaloManutencao || null;
          this.margem = this.veiculos.manutencaoProgramada.margemAlertaManutencao || null;
          this.intervaloHorimetro = this.veiculos.manutencaoProgramada.intervaloManutencaoHorimetro || null;
          this.margemHorimetro = this.veiculos.manutencaoProgramada.margemAlertaManutencaoHorimetro || null;
        }

        if (!this.permissaoManutencaoProgramada) {
          this.timeout(function () {
            _this.alertMessage.create({
              type: 'warning',
              message: _this.translate.instant('ce.cadastro.veiculos.modalManutencao.aviso'),
              appendTo: '.alerta-aqui-manutencao',
              timeout: 1000000
            });
          }, 100);
        }
      }
    }, {
      key: 'buildProximoAlertaManutencao',
      value: function buildProximoAlertaManutencao(hodometroOuHorimetro, intervalo, margem) {
        if (hodometroOuHorimetro > 0) {
          return Math.ceil(hodometroOuHorimetro / intervalo) * intervalo - (margem || 0);
        }

        return intervalo - (margem || 0);
      }
    }, {
      key: 'buildVeiculo',
      value: function buildVeiculo(id, hodometro, horimetro) {
        var veiculo = {
          veiculoId: id
        };

        if (this.intervaloBackend || this.intervaloBackend === 0) {
          veiculo.intervaloManutencao = this.intervaloBackend;
          veiculo.margemAlertaManutencao = this.margemBackend;
          veiculo.hodometroProximoAlertaManutencao = veiculo.intervaloManutencao === 0 ? 0 : this.buildProximoAlertaManutencao(Number(hodometro *= KM_EM_METROS), this.intervaloBackend, this.margemBackend);
        }

        if (this.intervaloHorimetroBackend || this.intervaloHorimetroBackend === 0) {
          veiculo.intervaloManutencaoHorimetro = this.intervaloHorimetroBackend;
          veiculo.margemAlertaManutencaoHorimetro = this.margemHorimetroBackend || 0;
          veiculo.horimetroProximoAlertaManutencao = veiculo.intervaloManutencaoHorimetro === 0 ? 0 : this.buildProximoAlertaManutencao(Number(horimetro *= HORA_EM_SEGUNDOS), this.intervaloHorimetroBackend, this.margemHorimetroBackend);
        }

        return veiculo;
      }
    }, {
      key: 'buildListaVeiculos',
      value: function buildListaVeiculos() {
        var _this2 = this;

        this.intervaloBackend = angular.copy(this.intervalo) * KM_EM_METROS;
        this.margemBackend = angular.copy(this.margem) * KM_EM_METROS;
        this.intervaloHorimetroBackend = angular.copy(this.intervaloHorimetro) * HORA_EM_SEGUNDOS;
        this.margemHorimetroBackend = angular.copy(this.margemHorimetro) * HORA_EM_SEGUNDOS;

        if (angular.isArray(this.veiculos)) {
          return this.veiculos.map(function (x) {
            return _this2.buildVeiculo(x.id, x.hodometro, x.horimetro);
          });
        }
        return [this.buildVeiculo(this.veiculos.id, this.veiculos.hodometro, this.veiculos.horimetro)];
      }
    }, {
      key: 'ok',
      value: function ok() {
        var _this3 = this;

        this.restangular.all('veiculo/manutencoes-programadas/batch').post(this.buildListaVeiculos()).then(function (newValue) {
          _this3.modalInstance.close(newValue.plain().map(function (v) {
            v.intervaloManutencao /= KM_EM_METROS;
            v.margemAlertaManutencao = v.margemAlertaManutencao ? v.margemAlertaManutencao / KM_EM_METROS : null;

            v.intervaloManutencaoHorimetro /= HORA_EM_SEGUNDOS;
            v.margemAlertaManutencaoHorimetro = v.margemAlertaManutencaoHorimetro ? v.margemAlertaManutencaoHorimetro / HORA_EM_SEGUNDOS : null;
            return v;
          }));
        }).catch(function (e) {
          if (e.status === 406) {
            _this3.alertMessage.create({
              type: 'error',
              message: e.data.erro,
              appendTo: '.alerta-erro'
            });
          } else {
            _this3.modalInstance.dismiss({ msg: _this3.translate.instant('ce.cadastro.veiculos.modalManutencao.erroConfigurar') });
          }
        });
      }
    }, {
      key: 'delete',
      value: function _delete() {
        var _this4 = this;

        this.restangular.all('veiculo/manutencoes-programadas/batch').post(this.buildListaVeiculos()).then(function () {
          var value = { veiculoId: _this4.veiculos.id },
              manutencaoProgramadaDoVeiculo = _this4.veiculos.manutencaoProgramada;

          if (_this4.tipoRemocao === 'horimetro') {
            value.intervaloManutencao = manutencaoProgramadaDoVeiculo.intervaloManutencao;
            value.margemAlertaManutencao = manutencaoProgramadaDoVeiculo.margemAlertaManutencao;
            value.hodometroProximoAlertaManutencao = manutencaoProgramadaDoVeiculo.hodometroProximoAlertaManutencao;
          } else {
            value.intervaloManutencaoHorimetro = manutencaoProgramadaDoVeiculo.intervaloManutencaoHorimetro;
            value.margemAlertaManutencaoHorimetro = manutencaoProgramadaDoVeiculo.margemAlertaManutencaoHorimetro;
            value.horimetroProximoAlertaManutencao = manutencaoProgramadaDoVeiculo.horimetroProximoAlertaManutencao;
          }

          _this4.modalInstance.close([value]);
        }).catch(function () {
          _this4.modalInstance.dismiss({ msg: _this4.translate.instant('ce.cadastro.veiculos.modalManutencao.erroRemover') });
        });
      }
    }, {
      key: 'podeSalvar',
      value: function podeSalvar() {
        return Boolean(this.intervalo || this.intervaloHorimetro);
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return AlertaManutencaoCtrl;
  }();

  angular.module('cadastros.veiculo').controller('AlertaManutencaoCtrl', AlertaManutencaoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.pontoReferencia
   * @description
   *
   */

  angular.module('cadastros.pontoReferencia', ['ui.router', 'mapControlModule', 'alert-message', 'smart-table', 'validateUtilModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'enumModule', 'pascalprecht.translate', 'v3gAuthenticatorModule', 'validateUtilModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var TempoPermanenciaCtrl = function () {
    function TempoPermanenciaCtrl($uibModalInstance, HttpServiceV3g, AlertMessage, pontos, $translate) {
      _classCallCheck(this, TempoPermanenciaCtrl);

      this.modalInstance = $uibModalInstance;
      this.alertMessage = AlertMessage;
      this.httpService = HttpServiceV3g;
      this.pontos = pontos;
      this.translate = $translate;

      this.tempo = null;
    }

    _createClass(TempoPermanenciaCtrl, [{
      key: 'ok',
      value: function ok() {
        var _this = this;

        var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var patchObject = {
          ids: this.pontos.map(function (i) {
            return i.id;
          }),
          patch: {
            tempoPermanenciaMinimo: this.tempo ? this.tempo * 60 : null
          }
        };

        this.httpService.post('/ponto-referencia/v2/pontos-referencia/batch/update', patchObject).then(function (pontosAtualizados) {
          _this.modalInstance.close(pontosAtualizados, remove);
        }).catch(function () {
          _this.modalInstance.dismiss({ msg: _this.translate.instant('ce.cadastro.pontosReferencia.tempoPermanenciaModal.errorMessage') });
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return TempoPermanenciaCtrl;
  }();

  angular.module('cadastros.pontoReferencia').controller('TempoPermanenciaCtrl', TempoPermanenciaCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CodigoIntegracaoCtrl = function () {
    function CodigoIntegracaoCtrl($uibModalInstance, HttpServiceV3g, AlertMessage, pontos, $translate) {
      _classCallCheck(this, CodigoIntegracaoCtrl);

      this.modalInstance = $uibModalInstance;
      this.alertMessage = AlertMessage;
      this.httpService = HttpServiceV3g;
      this.pontos = pontos;
      this.translate = $translate;

      this.codigo = null;
    }

    _createClass(CodigoIntegracaoCtrl, [{
      key: 'updatePoints',
      value: function updatePoints() {
        var _this = this;

        var remover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var patchObject = {
          ids: this.pontos.map(function (i) {
            return i.id;
          }),
          patch: {
            codigoIntegracao: this.codigo ? this.codigo : null
          }
        };

        this.httpService.post('/ponto-referencia/v2/pontos-referencia/batch/update', patchObject).then(function (pontosAtualizados) {
          _this.modalInstance.close(pontosAtualizados, remover);
        }).catch(function () {
          _this.modalInstance.dismiss({ msg: _this.translate.instant('ce.cadastro.pontosReferencia.codigoIntegracaoModal.errorMessage') });
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return CodigoIntegracaoCtrl;
  }();

  angular.module('cadastros.pontoReferencia').controller('CodigoIntegracaoCtrl', CodigoIntegracaoCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.motorista.documentos', ['ui.router', 'FeatureFlagModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider, FeatureFlag) {
    return FeatureFlag.DOCUMENTOS_MOTORISTA && $stateProvider.state('root.documentos', {
      url: '/documentos?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'cadastros/motorista/documentos/documentos.tpl.html',
          controller: 'DocumentosCtrl',
          controllerAs: 'documentos'
        }
      },
      data: {
        titulo: 'ce.cadastro.motoristas.documentos.titulo',
        role: 'MOTORISTA_EDITAR'
      },
      params: {
        podeEditar: 'podeEditar'
      }
    });
  }

  angular.module('cadastros.motorista.documentos').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable angular/log */
(function () {
  'use strict';

  var DocumentosCtrl = function () {
    function DocumentosCtrl(ServiceVfiltro, FactoryVfiltro, Keys, moment, $stateParams) {
      var _this = this;

      _classCallCheck(this, DocumentosCtrl);

      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.moment = moment;
      this.podeEditar = $stateParams.podeEditar;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name
      }, {
        name: 'motorista_id',
        key: this.keys.motoristas.name,
        size: 6
      }, {
        name: 'documentos',
        key: this.keys.documentos.name,
        size: 6
      }])).then(function (filtro) {
        return _this.init(filtro);
      });
    }

    _createClass(DocumentosCtrl, [{
      key: 'init',
      value: function init(filtro) {
        /*eslint-disable */
        var tableDocumentosElement = document.querySelector('#table-documentos'),
            documentosListElement = document.createElement('vfwc-documentos-list'),
            motoristasFiltered = filtro.find(function (f) {
          return f.key === 'motoristas';
        }),
            motoristaIds = motoristasFiltered ? motoristasFiltered.values.map(function (motorista) {
          return motorista.id;
        }) : motoristasFiltered,
            tipoFiltered = filtro.find(function (f) {
          return f.key === 'documentos';
        }),
            tipoDocumento = tipoFiltered ? tipoFiltered.value.id : tipoFiltered;

        documentosListElement.uoId = Number(filtro.find(function (f) {
          return f.key === 'uo';
        }).value.id);
        documentosListElement.tipoDocumento = tipoDocumento;
        documentosListElement.motoristasIds = motoristaIds;
        documentosListElement.temPermissaoEditar = this.podeEditar;

        tableDocumentosElement.appendChild(documentosListElement);
      }
    }]);

    return DocumentosCtrl;
  }();

  angular.module('cadastros.motorista.documentos').controller('DocumentosCtrl', DocumentosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.grupoVeic', ['ui.router', 'ui.bootstrap', 'restangular', 'ServiceVfiltroModule', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'modalInfoConfirmModule', 'VtabelaModule', 'alert-message', 'enumModule', 'pascalprecht.translate', 'httpServiceV3gModule', 'ngSanitize']).factory('GrupoVeic', function (Restangular) {
    return Restangular.service('/veiculo/veiculos/grupos');
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var VEICULO_URL = '/veiculo/veiculos/grupos';

  var GrupoVeicFormCtrl = function () {
    function GrupoVeicFormCtrl($uibModalInstance, HttpServiceV3g, grupoRow, TipoPermissaoEnum, $scope, AlertMessage, ModalInfoConfirmService, $translate, $sanitize) {
      _classCallCheck(this, GrupoVeicFormCtrl);

      this.tipoPermissaoEnum = TipoPermissaoEnum;
      this.modalInstance = $uibModalInstance;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.grupo = grupoRow;
      this.alertMessage = AlertMessage;
      this.isGrupoCarregado = Boolean(this.grupo);
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.translate = $translate;
      this.$sanitize = $sanitize;

      this.initModal();
    }

    _createClass(GrupoVeicFormCtrl, [{
      key: 'initModal',
      value: function initModal() {
        if (this.isGrupoCarregado) {
          this.title = this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.edicao.titulo');
          this.carregaGrupo();
        } else {
          this.title = this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.cadastro.titulo');
        }
      }
    }, {
      key: 'carregaGrupo',
      value: function carregaGrupo() {
        this.model = {
          nome: this.grupo.nome,
          observacoes: this.grupo.observacoes,
          uoSelected: this.grupo.uo
        };
      }
    }, {
      key: 'confirmar',
      value: function confirmar() {
        if (this.scope.grupoVeicForm.$valid) {
          this.salvar();
        } else {
          this.scope.grupoVeicForm.nome.$setTouched();
          this.scope.grupoVeicForm.uo.$setTouched();
        }
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this = this;

        var grupoSubmit = {
          nome: this.model.nome,
          observacoes: this.model.observacoes || null
        };
        if (this.isGrupoCarregado) {
          this.httpService.patch(VEICULO_URL + '/' + this.grupo.id, grupoSubmit).then(function () {
            _this.modalInstance.close({ message: _this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.edicao.sucesso'), grupoSubmit: grupoSubmit });
          }).catch(function (data) {
            _this.appendAlert('editar', data);
          });
        } else {
          grupoSubmit.uo = { id: this.model.uoSelected.id };

          this.httpService.post(VEICULO_URL, grupoSubmit).then(function () {
            _this.modalInstance.close({ message: _this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.cadastro.sucesso') });
          }).catch(function (response) {
            _this.appendAlert('cadastrar', response);
          });
        }
      }
    }, {
      key: 'removerGrupo',
      value: function removerGrupo() {
        var _this2 = this;

        if (!this.grupo.quantidadeVeiculosTotal) {
          var sanitizedMessage = this.$sanitize(this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.confirmacao') + (this.grupo.nome + '?'));
          this.modalInfoConfirmService.confirmModal({
            title: this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.titulo'),
            conteudo: sanitizedMessage,
            btnSecundario: this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.cancelar'),
            btnPrimario: this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.excluir'),
            headerColor: 'bg-light-blue',
            typeButton: 'btn-primary'
          }).then(function () {
            return _this2.removerBackend();
          });
        }
      }
    }, {
      key: 'removerBackend',
      value: function removerBackend() {
        var _this3 = this;

        this.httpService.delete('/veiculo/veiculos/grupos/' + this.grupo.id).then(function () {
          _this3.modalInstance.close({ message: _this3.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.sucesso'), idDeleted: _this3.grupo.id });
        }).catch(function () {
          _this3.alertMessage.create({
            type: 'error',
            message: _this3.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluir.error'),
            appendTo: '.alerta-aqui-modal'
          });
        });
      }
    }, {
      key: 'appendAlert',
      value: function appendAlert(type, response) {
        var typeString = void 0;
        if (type === 'editar') {
          typeString = this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.editar');
        } else if (type === 'excluir') {
          typeString = this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.excluirString');
        } else if (type === 'cadastrar') {
          typeString = this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.cadastrar');
        }
        if (response.status === 409 && response.data.statusCode === 'PERMISSAO_VEICULOS_GRUPO' && type === 'editar') {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.permissaoNecessaria'),
            appendTo: '.alerta-aqui-modal'
          });
        } else {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.erroPt1') + typeString + this.translate.instant('ce.cadastro.grupoDeVeiculos.modal.erroPt2'),
            appendTo: '.alerta-aqui-modal'
          });
        }
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return GrupoVeicFormCtrl;
  }();

  angular.module('cadastros.grupoVeic').controller('GrupoVeicFormCtrl', GrupoVeicFormCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('videoPlayer', ['ui.router', 'cadastros.veiculo', 'FeatureOuModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MultiVideoService = function () {
    function MultiVideoService($rootScope, Restangular) {
      _classCallCheck(this, MultiVideoService);

      this.restangular = Restangular;
      this.sharedScope = $rootScope.$new();
    }

    _createClass(MultiVideoService, [{
      key: 'updateVideo',
      value: function updateVideo(video) {
        this.sharedScope.$emit('update-video', video);
      }
    }, {
      key: 'getAlertaById',
      value: function getAlertaById(alertaId) {
        return this.restangular.one('/alerta/alertas/ids').get({ ids: alertaId }).then(function (response) {
          return response.plain();
        }).catch(function (error) {
          console.error('Erro ao buscar alerta pelo ID:', error);
          return null;
        });
      }
    }, {
      key: 'getVeiculoById',
      value: function getVeiculoById(veiculoId) {
        return this.restangular.one('/veiculo/v2/veiculos').get({
          veiculoId: veiculoId,
          fields: 'placa,prefixo'
        }).then(function (response) {
          var data = response.plain();
          return data && data.content && data.content.length > 0 ? data.content[0] : null;
        }).catch(function (error) {
          console.error('Erro ao buscar veículo:', error);
          return null;
        });
      }
    }]);

    return MultiVideoService;
  }();

  MultiVideoService.$inject = ['$rootScope', 'Restangular'];

  angular.module('videoPlayer').service('MultiVideoService', MultiVideoService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('videoPlayer').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.video', {
      url: '/video/:idVideo/:datahora',
      views: {
        'content@': {
          templateUrl: 'video/video-player/multi-video-player.tpl.html',
          controller: 'MultiVideoPlayerCtrl',
          controllerAs: 'MultiVideoPlayerCtrl'
        }
      },
      data: {
        hideTitulo: true,
        roles: [['VIDEO_VISUALIZAR']]
      }
    }).state('root.snapshot', {
      url: '/video/:snapshotId/:datahora/:latitude/:longitude/:tipoEvento/:vehicleId/:vehiclePrefix/:vehiclePlate/:driverName/:threshold/:eventDuration/:actualValue/:eventLevel',
      views: {
        'content@': {
          templateUrl: 'video/video-player/multi-video-player.tpl.html',
          controller: 'MultiVideoPlayerCtrl',
          controllerAs: 'MultiVideoPlayerCtrl'
        }
      },
      data: {
        hideTitulo: true,
        roles: [['VIDEO_VISUALIZAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  function MultiVideoPlayer() {
    return {
      templateUrl: 'video/video-player/multi-video-player.tpl.html',
      controller: 'MultiVideoPlayerCtrl',
      controllerAs: 'multiVideoPlayer',
      restrict: 'E',
      scope: {
        idVideo: '@',
        alertaId: '@',
        snapshotId: '@',
        latitude: '@',
        longitude: '@',
        vehicleId: '@',
        vehiclePrefix: '@',
        vehiclePlate: '@',
        driverName: '@',
        datahora: '@',
        tipoEvento: '@',
        threshold: '@',
        eventDuration: '@',
        eventLevel: '@',
        actualValue: '@',
        resolve: '='
      }
    };
  }

  var MultiVideoPlayerCtrl = function () {
    function MultiVideoPlayerCtrl($scope, moment, Authenticator, MultiVideoService, $stateParams, DecoratedVideoPlayerService, FeaturehubJsSdk, FeatureOuService, FeatureHubConfigKeys, $uibModal, StatusVideo) {
      _classCallCheck(this, MultiVideoPlayerCtrl);

      this.moment = moment;
      this.authenticator = Authenticator;
      this.multiVideoService = MultiVideoService;
      this.decoratedVideoPlayerService = DecoratedVideoPlayerService;
      this.FeatureOuService = FeatureOuService;
      this.isDecoratedVideoPlayerEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DECORATED_VIDEO_PLAYER);
      this.isDecoratedVideoPlayerNAFlagActivated = false;
      this.modalElement = null;
      this.uibModal = $uibModal;
      this.statusVideoEnum = StatusVideo;
      this.alertData = null;
      this.statusVideo = null;
      this.buildVideoParams($scope, $stateParams);
      this.initUserConfig();
    }

    _createClass(MultiVideoPlayerCtrl, [{
      key: 'buildVideoParams',
      value: function buildVideoParams(scope, stateParams) {
        this.idVideo = scope.resolve ? scope.resolve.idVideo : stateParams.idVideo;
        this.snapshotId = scope.resolve ? scope.resolve.snapshotId : stateParams.snapshotId;
        this.tipoEvento = scope.resolve ? scope.resolve.tipoEvento : stateParams.tipoEvento;
        this.latitude = scope.resolve ? scope.resolve.latitude : stateParams.latitude;
        this.longitude = scope.resolve ? scope.resolve.longitude : stateParams.longitude;
        this.vehicleId = scope.resolve ? scope.resolve.vehicleId : stateParams.vehicleId;
        this.vehiclePrefix = scope.resolve ? scope.resolve.vehiclePrefix : stateParams.vehiclePrefix;
        this.vehiclePlate = scope.resolve ? scope.resolve.vehiclePlate : stateParams.vehiclePlate;
        this.driverName = scope.resolve ? scope.resolve.driverName : stateParams.driverName;
        this.datahora = this.moment(scope.resolve ? scope.resolve.datahora : stateParams.datahora).toISOString();
        this.isDialog = angular.isDefined(scope.resolve);
        this.threshold = scope.resolve ? scope.resolve.threshold : stateParams.threshold;
        this.actualValue = scope.resolve ? scope.resolve.actualValue : stateParams.actualValue;
        this.eventDuration = scope.resolve ? scope.resolve.eventDuration : stateParams.eventDuration;
        this.eventLevel = scope.resolve ? scope.resolve.eventLevel : stateParams.eventLevel;
        this.statusVideo = scope.resolve ? scope.resolve.statusVideo : stateParams.statusVideo;

        this.coordinates = {
          latitude: this.latitude,
          longitude: this.longitude
        };
        this.vehicle = {
          id: this.vehicleId,
          prefixo: this.vehiclePrefix,
          placa: this.vehiclePlate
        };
      }
    }, {
      key: 'initUserConfig',
      value: function initUserConfig() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.getDecoratedVideoPlayerConfig(user.uo.id);
          _this.roleSolicitarVideo = user.permissoes.includes('VIDEO_EDITAR');
        });
      }
    }, {
      key: 'getDecoratedVideoPlayerConfig',
      value: function getDecoratedVideoPlayerConfig(userUoId) {
        var _this2 = this;

        this.FeatureOuService.getDecoratedVideoPlayerConfig(userUoId).then(function (decoratedVideoPlayer) {
          _this2.isDecoratedVideoPlayerNAFlagActivated = decoratedVideoPlayer;
          _this2.loadInitialData();
        }).catch(function (error) {
          _this2.log.error('Error loading featureOu config: ', error);
        });
      }
    }, {
      key: 'loadInitialData',
      value: function loadInitialData() {
        var _this3 = this;

        var isAlertId = this.idVideo && !this.idVideo.includes('-');

        if (isAlertId) {
          this.multiVideoService.getAlertaById(this.idVideo).then(function (alertData) {
            var data = alertData[0] || alertData;
            if (data && data.veiculoId) {
              _this3.multiVideoService.getVeiculoById(data.veiculoId).then(function (veiculo) {
                _this3.alertData = _this3.buildAlertDataFromResponse(data, veiculo);
                _this3.statusVideo = data.statusVideo;
                _this3.configurarPlayerMultiVideo();
              }).catch(function () {
                _this3.alertData = _this3.buildAlertDataFromResponse(data, null);
                _this3.statusVideo = data.statusVideo;
                _this3.configurarPlayerMultiVideo();
              });
            } else {
              if (data) {
                _this3.alertData = _this3.buildAlertDataFromResponse(data, null);
                _this3.statusVideo = data.statusVideo;
              }
              _this3.configurarPlayerMultiVideo();
            }
          }).catch(function () {
            _this3.configurarPlayerMultiVideo();
          });
        } else {
          this.configurarPlayerMultiVideo();
        }
      }
    }, {
      key: 'buildAlertDataFromResponse',
      value: function buildAlertDataFromResponse(data, veiculo) {
        var veiculoObj = data.veiculo || veiculo || { id: data.veiculoId };
        return {
          id: data.id,
          videoId: data.videoId,
          snapshotId: data.snapshotId,
          datahora: data.datahora,
          idVeiculo: data.veiculoId,
          tipoEvento: data.tipoAlerta,
          threshold: data.limiar,
          eventDuration: data.duracao,
          actualValue: data.excesso,
          eventLevel: data.nivel,
          statusVideo: data.statusVideo,
          veiculo: veiculoObj,
          tipo: data.tipoAlerta,
          latitude: data.latitude,
          longitude: data.longitude,
          prefixo: data.prefixo || veiculo && veiculo.prefixo,
          placa: data.placa || veiculo && veiculo.placa || veiculoObj.placa,
          motorista: data.motorista,
          coordinates: data.coordinates || { latitude: data.latitude, longitude: data.longitude }
        };
      }
    }, {
      key: 'shouldDisplayDecoratedVideoPlayer',
      value: function shouldDisplayDecoratedVideoPlayer() {
        return this.isDecoratedVideoPlayerEnabled && this.isDecoratedVideoPlayerNAFlagActivated;
      }
    }, {
      key: 'configurarPlayerMultiVideo',
      value: function configurarPlayerMultiVideo() {
        var _this4 = this;

        /*eslint-disable */
        this.modalElement = document.querySelector('.modal');
        var modalDialogElement = document.querySelector('.modal-dialog'),
            playerContainer = document.querySelector('#video-player-container');

        if (modalDialogElement) {
          modalDialogElement.style.width = '95vw';
          modalDialogElement.style.margin = '0px auto';
        }

        if (playerContainer) {
          this.authenticator.getUser().then(function (user) {
            if (user) {
              if (_this4.shouldDisplayDecoratedVideoPlayer()) {
                _this4.loadDecoratedVideoPlayer(user);
              } else {
                var playerMultiVideo = document.createElement('vfwc-dialog-event-viewer'); /*eslint-enable */

                if (_this4.snapshotId) {
                  playerMultiVideo.snapshotId = _this4.snapshotId;
                } else {
                  playerMultiVideo.idVideo = _this4.idVideo;
                }
                playerMultiVideo.dataHora = _this4.datahora;
                playerMultiVideo.user = user;
                playerMultiVideo.tipoEvento = _this4.tipoEvento;
                playerMultiVideo.coordinates = _this4.coordinates;
                playerMultiVideo.vehicle = _this4.vehicle;
                playerMultiVideo.driverName = _this4.driverName;
                playerMultiVideo.isDialog = _this4.isDialog;
                playerMultiVideo.threshold = _this4.threshold;
                playerMultiVideo.actualValue = _this4.actualValue;
                playerMultiVideo.eventDuration = _this4.eventDuration;
                playerMultiVideo.eventLevel = _this4.eventLevel;
                playerContainer.appendChild(playerMultiVideo);
                _this4.onWatchedVideo(playerMultiVideo);
                _this4.onModalClosed(playerMultiVideo);
              }
            }
          });
        }
      }
    }, {
      key: 'loadDecoratedVideoPlayer',
      value: function loadDecoratedVideoPlayer(user) {
        var _this5 = this;

        var isSeparatedVideoScreen = true,
            hasVideo = this.idVideo && this.idVideo.includes('-');
        var props = void 0;

        if (hasVideo) {
          props = {
            idVideo: this.idVideo,
            snapshotId: this.snapshotId,
            datahora: this.datahora,
            tipoEvento: this.tipoEvento,
            latitude: this.latitude,
            longitude: this.longitude,
            vehicleId: this.vehicleId,
            vehiclePrefix: this.vehiclePrefix,
            vehiclePlate: this.vehiclePlate,
            driverName: this.driverName,
            threshold: this.threshold,
            eventDuration: this.eventDuration,
            actualValue: this.actualValue,
            eventLevel: this.eventLevel,
            user: user,
            statusVideo: 'CONCLUIDO'
          };
        } else if (this.alertData) {
          props = {
            alertaId: this.alertData.id,
            snapshotId: this.alertData.snapshotId,
            datahora: this.alertData.datahora,
            tipoEvento: this.alertData.tipoEvento,
            latitude: this.alertData.latitude,
            longitude: this.alertData.longitude,
            vehicleId: this.alertData.veiculo.id,
            vehiclePrefix: this.alertData.prefixo,
            vehiclePlate: this.alertData.placa,
            driverName: this.alertData.motorista,
            threshold: this.alertData.threshold,
            eventDuration: this.alertData.eventDuration,
            actualValue: this.alertData.actualValue,
            eventLevel: this.alertData.eventLevel,
            user: user,
            statusVideo: this.alertData.statusVideo,
            coordinates: this.alertData.coordinates,
            requestVideo: function requestVideo(onRequestCompleted) {
              return _this5.abrirModalRequisicaoVideo(_this5.alertData, onRequestCompleted);
            },
            requestVideoPermission: this.roleSolicitarVideo
          };

          if (this.alertData.videoId) {
            props.idVideo = this.alertData.videoId;
          }
        } else {
          props = {
            snapshotId: this.snapshotId,
            datahora: this.datahora,
            tipoEvento: this.tipoEvento,
            latitude: this.latitude,
            longitude: this.longitude,
            vehicleId: this.vehicleId,
            vehiclePrefix: this.vehiclePrefix,
            vehiclePlate: this.vehiclePlate,
            driverName: this.driverName,
            threshold: this.threshold,
            eventDuration: this.eventDuration,
            actualValue: this.actualValue,
            eventLevel: this.eventLevel,
            user: user,
            statusVideo: this.statusVideo
          };
        }

        this.decoratedVideoPlayerService.loadDecoratedVideoPlayer(props, isSeparatedVideoScreen);
      }
    }, {
      key: 'onWatchedVideo',
      value: function onWatchedVideo(element) {
        var _this6 = this;

        element.addEventListener('markWatched', function (event) {
          var video = event.detail;
          _this6.multiVideoService.updateVideo(video);
        });
      }
    }, {
      key: 'onModalClosed',
      value: function onModalClosed(element) {
        var _this7 = this;

        element.addEventListener('modalClosedEvent', function (event) {
          if (_this7.modalElement && event.detail.isModalClosed) {
            _this7.modalElement.remove();
          }
        });
      }
    }, {
      key: 'abrirModalRequisicaoVideo',
      value: function abrirModalRequisicaoVideo(_alerta, _onRequestCompleted) {
        if (_alerta && !_alerta.user) {
          _alerta.user = this.user;
        }

        this.uibModal.open({
          component: 'modalRequisicaoVideo',
          backdrop: 'static',
          resolve: {
            alerta: function alerta() {
              return _alerta;
            },
            onRequestCompleted: function onRequestCompleted() {
              return _onRequestCompleted;
            }
          }
        }).result.then(function (videoId) {
          if (_alerta) {
            _alerta.statusVideo = 'CADASTRADO';
            _alerta.videoId = videoId;
          }
        });
      }
    }]);

    return MultiVideoPlayerCtrl;
  }();

  MultiVideoPlayerCtrl.$inject = ['$scope', 'moment', 'Authenticator', 'MultiVideoService', '$stateParams', 'DecoratedVideoPlayerService', 'FeaturehubJsSdk', 'FeatureOuService', 'FeatureHubConfigKeys', '$uibModal', 'StatusVideo'];

  angular.module('videoPlayer').controller('MultiVideoPlayerCtrl', MultiVideoPlayerCtrl).directive('multiVideoPlayer', MultiVideoPlayer);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var LEFT_CLICK = 0,
      MIDDLE_CLICK = 1;

  var EventViewerLinkCtrl = function () {
    function EventViewerLinkCtrl($uibModal, Authenticator, $translate, $window, safetyService, $document, $scope, FeaturehubJsSdk, FeatureOuService, FeatureHubConfigKeys, DecoratedVideoPlayerService) {
      _classCallCheck(this, EventViewerLinkCtrl);

      this.uibModal = $uibModal;
      this.authenticator = Authenticator;
      this.translate = $translate;
      this.window = $window;
      this.safetyService = safetyService;
      this.document = $document[0];
      this.scope = $scope;
      this.user = null;
      this.FeatureOuService = FeatureOuService;
      this.decoratedVideoPlayerService = DecoratedVideoPlayerService;

      this.visualizar = this.translate.instant('ce.common.visualizar');
      this.tooltip = this.snapshotId ? this.visualizar : this.translate.instant('ce.common.visualizarVideo');
      this.verVideo = this.translate.instant('ce.common.verVideo');
      this.temPermissaoVisualizacaoVideo = this.authenticator.hasRole('VIDEO_VISUALIZAR');
      this.text = this.snapshotId ? this.visualizar : this.verVideo;
      this.isDecoratedVideoPlayerEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DECORATED_VIDEO_PLAYER);
      this.driverNotIdentified = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.motoristaNaoIdentificado');

      this.initUserConfig();
    }

    _createClass(EventViewerLinkCtrl, [{
      key: 'initUserConfig',
      value: function initUserConfig() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.getDecoratedVideoPlayerConfig(user.uo.id);
        });
      }
    }, {
      key: 'getDecoratedVideoPlayerConfig',
      value: function getDecoratedVideoPlayerConfig(userUoId) {
        var _this2 = this;

        this.FeatureOuService.getDecoratedVideoPlayerConfig(userUoId).then(function (decoratedVideoPlayer) {
          _this2.isDecoratedVideoPlayerNAFlagActivated = decoratedVideoPlayer;
        }).catch(function (error) {
          _this2.log.error('Error loading featureOu config: ', error);
        });
      }
    }, {
      key: 'shouldDisplayDecoratedVideoPlayer',
      value: function shouldDisplayDecoratedVideoPlayer() {
        return this.isDecoratedVideoPlayerEnabled && this.isDecoratedVideoPlayerNAFlagActivated;
      }
    }, {
      key: 'linkText',
      value: function linkText() {
        return this.hideText ? '' : ' ' + this.text;
      }
    }, {
      key: 'exibirPlayer',
      value: function exibirPlayer(event) {
        var _this3 = this;

        var isClickOpenInNewTab = event.ctrlKey && event.button === LEFT_CLICK || event.button === MIDDLE_CLICK;
        if (isClickOpenInNewTab && this.idVideo) {
          this.window.open('/video/' + this.idVideo + '/' + this.datahora, '_blank');
        } else if (isClickOpenInNewTab && this.snapshotId) {
          this.window.open('/video/' + this.snapshotId + '/' + this.datahora + '/' + this.latitude + '/' + this.longitude + ('/' + this.tipoEvento + '/' + this.vehicleId + '/' + this.vehiclePrefix + '/' + this.vehiclePlate + '/' + (this.driverName ? this.driverName : this.driverNotIdentified)) + ('/' + this.threshold + '/' + this.eventDuration + '/' + this.actualValue + '/' + this.eventLevel), '_blank');
        } else if (event.button === LEFT_CLICK) {
          if (this.shouldDisplayDecoratedVideoPlayer()) {
            this.loadDecoratedVideoPlayer();
          } else {
            this.uibModal.open({
              component: 'multiVideoPlayer',
              windowTopClass: 'player-container',
              backdrop: false,
              resolve: {
                idVideo: function idVideo() {
                  return _this3.idVideo;
                },
                snapshotId: function snapshotId() {
                  return _this3.snapshotId;
                },
                datahora: function datahora() {
                  return _this3.datahora;
                },
                tipoEvento: function tipoEvento() {
                  return _this3.tipoEvento;
                },
                latitude: function latitude() {
                  return _this3.latitude;
                },
                longitude: function longitude() {
                  return _this3.longitude;
                },
                vehicleId: function vehicleId() {
                  return _this3.vehicleId;
                },
                vehiclePrefix: function vehiclePrefix() {
                  return _this3.vehiclePrefix;
                },
                vehiclePlate: function vehiclePlate() {
                  return _this3.vehiclePlate;
                },
                driverName: function driverName() {
                  return _this3.driverName;
                },
                threshold: function threshold() {
                  return _this3.threshold;
                },
                eventDuration: function eventDuration() {
                  return _this3.eventDuration;
                },
                actualValue: function actualValue() {
                  return _this3.actualValue;
                },
                eventLevel: function eventLevel() {
                  return _this3.eventLevel;
                },
                statusVideo: function statusVideo() {
                  return _this3.statusVideo;
                }
              }
            });
          }
        }
      }
    }, {
      key: 'loadDecoratedVideoPlayer',
      value: function loadDecoratedVideoPlayer() {
        var _this4 = this;

        console.log(this);
        var props = {
          idVideo: this.idVideo,
          snapshotId: this.snapshotId,
          datahora: this.datahora,
          tipoEvento: this.tipoEvento,
          latitude: this.latitude || this.coordinates && this.coordinates.latitude,
          longitude: this.longitude || this.coordinates && this.coordinates.longitude,
          vehicleId: this.vehicleId,
          vehiclePrefix: this.vehiclePrefix,
          vehiclePlate: this.vehiclePlate,
          driverName: this.driverName,
          threshold: this.threshold,
          eventDuration: this.eventDuration,
          actualValue: this.actualValue,
          eventLevel: this.eventLevel,
          user: this.user,
          coordinates: this.coordinates,
          statusVideo: this.statusVideo,
          handleVideoExport: function handleVideoExport(isBlur, videoType) {
            return _this4.handleVideoExport(isBlur, videoType);
          }
        };
        this.decoratedVideoPlayerService.loadDecoratedVideoPlayer(props);
      }
    }, {
      key: 'handleVideoExport',
      value: function handleVideoExport(isBlurButton, videoType) {
        this.window.videoService.initializeList();
        var videoExport = { id: this.idVideo, type: videoType, status: 'PENDING' };
        switch (videoType) {
          case 'STANDARD':
            this.window.videoService.standardVideoExport = videoExport;
            break;
          case 'BLUR':
            this.window.videoService.blurVideoExport = videoExport;
            break;
          case 'INDIVIDUAL_STANDARD':
            this.window.videoService.indivStandardVideoExport = videoExport;
            break;
          case 'INDIVIDUAL_BLUR':
            this.window.videoService.indivBlurVideoExport = videoExport;
            break;
          default:
            throw new Error('Unknown export type: ' + videoType);
        }
        this.window.videoService.setVideoId(this.idVideo);
        this.window.videoService.setVehicleId(this.vehicleId);
        this.window.videoService.handleVideoExport(isBlurButton, videoType);
      }
    }, {
      key: 'shouldShowLink',
      value: function shouldShowLink() {
        return this.idVideo || this.snapshotId;
      }
    }]);

    return EventViewerLinkCtrl;
  }();

  EventViewerLinkCtrl.$inject = ['$uibModal', 'Authenticator', '$translate', '$window', 'safetyService', '$document', '$scope', 'FeaturehubJsSdk', 'FeatureOuService', 'FeatureHubConfigKeys', 'DecoratedVideoPlayerService'];

  angular.module('videoPlayer').controller('EventViewerLinkCtrl', EventViewerLinkCtrl).component('eventViewerLink', {
    template: '\n      <a ng-if="$ctrl.temPermissaoVisualizacaoVideo && $ctrl.shouldShowLink()"\n        ng-class="{\'video-link-assistido\': $ctrl.isAssistido && !$ctrl.snapshotId}"\n        ng-mouseup="$ctrl.exibirPlayer($event)"\n        uib-tooltip="{{ $ctrl.tooltip }}"\n        tooltip-enable="$ctrl.showTooltip"\n      >\n        <span ng-if="$ctrl.snapshotId" class=\'material-symbols-filled\'>imagesmode</span>\n        <i ng-if="$ctrl.idVideo && !$ctrl.snapshotId" class=\'fa fa-play-circle video-button\'/>\n        {{ $ctrl.linkText() }}\n      </a>\n      ',
    controller: 'EventViewerLinkCtrl',
    bindings: {
      idVideo: '@',
      snapshotId: '@',
      datahora: '@',
      latitude: '@',
      longitude: '@',
      vehicleId: '@',
      vehiclePrefix: '@',
      vehiclePlate: '@',
      driverName: '<',
      tipoEvento: '@',
      threshold: '@',
      eventDuration: '@',
      actualValue: '@',
      coordinates: '@',
      eventLevel: '@',
      hideText: '@',
      showTooltip: '@',
      isAssistido: '<',
      statusVideo: '<'
    }
  });
})();
'use strict';

/* eslint-disable angular/di */
(function () {
  'use strict';

  angular.module('VTabelaCellFilter', []).filter('splitComposedLabels', function () {
    return function (value, isFirst) {
      if (!value) {
        return '-';
      }
      var arrayValues = void 0,
          finalArrayValues = void 0,
          label = void 0;

      finalArrayValues = [];
      arrayValues = value.split(',');

      arrayValues.forEach(function (val) {
        label = val.split('-');

        if (label.length === 1) {
          finalArrayValues.push(val.trim());
        } else if (isFirst) {
          finalArrayValues.push(label[0].trim());
        } else {
          finalArrayValues.push(label[1].trim());
        }
      });

      if (finalArrayValues.length === 0) {
        return '';
      }

      if (finalArrayValues.length === 1) {
        return finalArrayValues.join('');
      }

      return finalArrayValues.join(', ');
    };
  }).filter('secondsToHHmm', function () {
    return function (seconds) {
      var emptyLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

      if (!Number.isFinite(seconds) || seconds < 0) {
        return emptyLabel;
      }
      var pad = function pad(value) {
        return String(value).padStart(2, '0');
      };
      return pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor(seconds % 3600 / 60));
    };
  }).filter('humanizedOrUndefinedWithLabel', function ($filter) {
    return function (value, defaultLabel) {
      if (value === null || angular.isUndefined(value) || value < 0) {
        return defaultLabel;
      }
      return $filter('humanizedDuration')(value);
    };
  }).filter('decimalWithLabel', ['ConvertersService', function (ConvertersService) {
    return function (value, label) {
      if (value === null || angular.isUndefined(value)) {
        return '-';
      }
      var val = value / 1000;
      if (val < 0) {
        return '-';
      }
      if (label === 'mi') {
        var valMiles = ConvertersService.handleKmToMiles(val);
        return parseFloat(valMiles.toFixed(2)) + ' ' + label;
      }
      return (parseFloat(val.toFixed(2)) + ' ' + label).replace('.', ',');
    };
  }]).filter('decimalPointWithLabel', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value)) {
        return '-';
      }
      var val = value / 1000;
      if (val < 0) {
        return '-';
      }
      return parseFloat(val.toFixed(2)) + ' ' + label;
    };
  }).filter('numberWithPoint', function () {
    return function (value, fractionDigits) {
      if (value === null || angular.isUndefined(value)) {
        return '-';
      }
      return value.toFixed(fractionDigits);
    };
  }).filter('decimal', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value) || value < 0) {
        return '-';
      }
      if (label === 'mi') {
        return value.toFixed(2);
      }
      return parseFloat(value.toFixed(2)).toString().replace('.', ',');
    };
  }).filter('withLabel', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value) || value < 0) {
        return '-';
      }

      return value + ' ' + label;
    };
  }).filter('withNumberLabel', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value) || value === '-') {
        return value;
      }

      return value + ' ' + label;
    };
  }).filter('withLabelToUndefined', function () {
    return function (value, defaultLabel) {
      return value === null || angular.isUndefined(value) || value === '' ? defaultLabel : value;
    };
  }).filter('decimalForPoints', ['ConvertersService', function (ConvertersService) {
    return function (value, label) {
      if (value === null || angular.isUndefined(value) || value < 0) {
        return '-';
      }
      if (label === 'mi') {
        var valMiles = ConvertersService.handleMilesToKm(value);
        return valMiles.toFixed(2);
      }
      return parseFloat(value.toFixed(2)).toString().replace('.', ',');
    };
  }]).filter('decimalWithLabelWithoutConversion', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value)) {
        return '-';
      }
      var val = value / 1000;
      if (val < 0) {
        return '-';
      }
      val = parseFloat(val.toFixed(2));
      if (label === 'mi' || label === 'gal' || label === 'mpg' || label === 'mi/kWh') {
        return val + ' ' + label;
      }
      return val.toString().replace('.', ',') + ' ' + label;
    };
  }).filter('decimalFormatterWithLabel', function () {
    return function (value, label) {
      if (value === null || angular.isUndefined(value) || value < 0) {
        return '-';
      }

      value = parseFloat(value.toFixed(2));
      if (label === 'mi' || label === 'gal' || label === 'mpg' || label === 'mi/kWh') {
        return value + ' ' + label;
      }

      return value.toString().replace('.', ',') + ' ' + label;
    };
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.videoLibrary', ['ui.router', 'angularMoment', 'v3gAuthenticatorModule', 'pascalprecht.translate']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.videoLibrary', {
      url: '/relatorios/biblioteca-videos/',
      views: {
        'content@': {
          templateUrl: 'relatorios/video-library/video-library.tpl.html',
          controller: 'VideoLibraryCtrl'
        }
      },
      data: {
        titulo: 'ce.analise.videoLibrary.menuLabel',
        roles: [['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }

  angular.module('relatorios.videoLibrary').config(pageConfig);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var VideoLibraryCtrl = function VideoLibraryCtrl($state) {
    _classCallCheck(this, VideoLibraryCtrl);

    if ($state.current.name === 'root.videoLibrary') {
      $state.go('root.videoLibrary.solicitacaoVideos');
      return;
    }

    /*eslint-disable */
    var elementContainer = document.querySelector('#video-library-tabs');
    if (elementContainer) {
      var vfwcVideoLibraryTabsElement = document.createElement('vfwc-video-library-tabs');
      vfwcVideoLibraryTabsElement.tabs = [{
        name: 'playlist',
        label: 'ce.analise.videoLibrary.tabs.playlist'
      }];

      switch ($state.current.name) {
        default:
          {
            vfwcVideoLibraryTabsElement.initialTabIndex = 0;
          }
      }

      vfwcVideoLibraryTabsElement.addEventListener('tabChanged', function (event) {
        switch (event.detail) {
          default:
            $state.go('root.videoLibrary.solicitacaoVideos');
        }
      });

      elementContainer.appendChild(vfwcVideoLibraryTabsElement);
      $rootScope.$on('$translateChangeSuccess', function () {
        console.log('[VideoLibrary] idioma mudou — recarregando abas');

        elementContainer.innerHTML = '';
        var newTabs = document.createElement('vfwc-video-library-tabs');
        newTabs.tabs = [{
          name: 'playlist',
          label: 'ce.analise.videoLibrary.tabs.playlist'
        }];
        newTabs.initialTabIndex = vfwcVideoLibraryTabsElement.initialTabIndex != null ? vfwcVideoLibraryTabsElement.initialTabIndex : 0;
        elementContainer.appendChild(newTabs);
      });
    }
  };

  angular.module('relatorios.videoLibrary').controller('VideoLibraryCtrl', VideoLibraryCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.velocidadeRpm', ['ui.router', 'restangular', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'alert-message', 'ui.bootstrap.modal', 'pascalprecht.translate', 'ConstantModule', 'angularMoment']).constant('LIMIAR', { INFERIOR: 60, SUPERIOR: 80 }).factory('VelocidadeRpm', function (Restangular) {
    return Restangular.service('boletim/velocidade-rpm-limpador-parabrisa');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.velocidadeRpm', {
      url: '/relatorios/velocidade-rpm?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/velocidade-rpm/velocidade-rpm.tpl.html',
          controller: 'VelocidadeRpmCtrl',
          controllerAs: 'velocidadeRpm'
        }
      },
      data: {
        titulo: 'ce.analise.velocidadeXrpm.titulo',
        role: 'ANALISE_VELOCIDADE_RPM_PARABRISA_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.velocidadeRpm').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global Highcharts */

  var VelocidadeRpmCtrl = function () {
    function VelocidadeRpmCtrl(Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, $timeout, $scope, VelocidadeRpm, moment, AlertMessage, $uibModal, $window, $filter, LIMIAR, $translate, GoogleTagManagerUtils) {
      var _this = this;

      _classCallCheck(this, VelocidadeRpmCtrl);

      this.velocidadeRpmService = VelocidadeRpm;
      this.moment = moment;
      this.alertMessage = AlertMessage;
      this.dadosDoGrafico = {};
      this.modalService = $uibModal;
      this.window = $window;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.timeout = $timeout;
      this.scope = $scope;
      this.filter = $filter;
      this.translate = $translate;
      this.googleTagManagerUtils = GoogleTagManagerUtils;

      this.limiares = angular.fromJson(this.window.localStorage.getItem('limiar-rpm-velocidade'));
      this.limiarInferior = this.limiares === null ? LIMIAR.INFERIOR : this.limiares.limiarInferior;
      this.limiarSuperior = this.limiares === null ? LIMIAR.SUPERIOR : this.limiares.limiarSuperior;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        dateLimit: 1,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        name: 'uo_id',
        key: this.keys.uo.name,
        size: 6
      }, {
        name: 'uo_parceira_id',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'veiculo_id',
        key: this.keys.veiculo.name,
        required: true,
        size: 6
      }])).then(function (filtro) {
        _this.consultar(ServiceVfiltro.getFiltroBackendAntigo(filtro));
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = true;
      });
    }

    _createClass(VelocidadeRpmCtrl, [{
      key: 'consultar',
      value: function consultar(filtro) {
        var _this2 = this;

        this.velocidadeRpmService.one().get({ filtros: filtro }).then(function (data) {
          var dadosDoGrafico = data.plain();
          if (!Object.keys(dadosDoGrafico).some(function (chave) {
            return dadosDoGrafico[chave].length > 0;
          })) {
            _this2.alertMessage.create({
              type: 'warning',
              message: _this2.translate.instant('ce.analise.velocidadeXrpm.common.nenhumResultadoEncontrado'),
              appendTo: '.alerta-aqui'
            });
          }
          _this2.dadosDoGrafico = dadosDoGrafico;
          _this2.renderizarGrafico(dadosDoGrafico);
        }).catch(function () {
          _this2.serviceVfiltro.openFiltroDetalhado = true;
        });
      }
    }, {
      key: 'getPlotLines',
      value: function getPlotLines() {
        return [{
          color: '#333333',
          value: this.limiarInferior,
          width: 1,
          zIndex: 3,
          label: {
            text: this.limiarInferior,
            x: -28,
            y: 5,
            style: {
              color: '#333333',
              fontWeight: ''
            }
          }
        }, {
          color: '#333333',
          value: this.limiarSuperior,
          width: 1,
          zIndex: 3,
          label: {
            text: this.limiarSuperior,
            x: -28,
            y: 5,
            style: {
              color: '#333333',
              fontWeight: ''
            }
          }
        }];
      }
    }, {
      key: 'redrawPlotLines',
      value: function redrawPlotLines() {
        this.chart.yAxis[0].update({
          plotLines: this.getPlotLines()
        });
      }
    }, {
      key: 'renderizarGrafico',
      value: function renderizarGrafico(data) {
        this.chart = new Highcharts.Chart(this.getChartOptions(data));
        this.chart.yAxis[0].setExtremes(this.chart.axes[2].min, this.chart.axes[2].max);
        this.chart.yAxis[1].setExtremes(this.chart.axes[3].min, this.chart.axes[3].max);
      }
    }, {
      key: 'getChartOptions',
      value: function getChartOptions(data) {
        var _this4 = this;

        var chartSeries = this.mapChartSeries(data);
        return {
          title: {
            text: this.filter('prefixoPlaca')(data.veiculo),
            style: {
              fontSize: '16px'
            }
          },
          chart: {
            renderTo: 'grafico-velocidade-rpm'
          },
          credits: false,
          plotOptions: {
            series: {
              events: {
                legendItemClick: function legendItemClick() {
                  var _this3 = this;

                  if (this.visible) {
                    this.chart.series.filter(function (s) {
                      return s.name !== 'Navigator' && s.name !== _this3.name;
                    }).forEach(function (s) {
                      return s.visible ? s.hide() : s.show();
                    });
                  } else {
                    this.chart.series.filter(function (s) {
                      return s.name !== 'Navigator' && s.name !== _this3.name;
                    }).forEach(function (s) {
                      return s.hide();
                    });
                    this.show();
                  }
                  return false;
                }
              }
            }
          },
          exporting: {
            enabled: false
          },
          legend: {
            padding: 15
          },
          navigator: {
            enabled: true,
            xAxis: {
              labels: {
                y: 15
              }
            }
          },
          tooltip: {
            crosshairs: true,
            formatter: function () {
              var ctrl = _this4;
              return function () {
                return ctrl.moment.utc(this.x).format('DD/MM/YYYY HH:mm:ss') + '<br/><b>' + this.series.name + '</b>: ' + this.y;
              };
            }()
          },
          xAxis: [{
            type: 'datetime',
            minTickInterval: 1000,
            minRange: 10 * 1000
          }],
          yAxis: [{
            title: {
              text: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.velocidade') + ' (Km/h)',
              offset: 40
            },
            height: '75%',
            gridLineWidth: 0,
            gridLineColor: 'transparent',
            labels: {
              formatter: function formatter() {
                return this.value;
              }
            },
            plotLines: this.gerarPlotLinesVelocidade(data)
          }, {
            title: {
              text: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.rpmUpperCase')
            },
            labels: {
              formatter: function formatter() {
                return this.value;
              }
            },
            opposite: true,
            height: '75%'
          }, {
            title: {
              text: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.sensorDeChuva'),
              margin: 0,
              offset: -14
            },
            top: '75%',
            height: '25%',
            min: 0,
            max: 1000,
            gridLineWidth: 0,
            labels: {
              enabled: false
            }
          }],
          series: [{
            name: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.velocidade'),
            color: '#5BC0DE',
            data: chartSeries.velocidade,
            marker: { enabled: true, radius: 0 },
            yAxis: 0
          }, {
            name: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.rpmUpperCase'),
            color: '#367fa9',
            data: chartSeries.rpm,
            marker: { enabled: true, radius: 0 },
            yAxis: 1
          }, {
            name: this.translate.instant('ce.analise.velocidadeXrpm.common.chart.sensorDeChuva'),
            type: 'polygon',
            color: 'rgba(124, 181, 236, 0.6)',
            data: chartSeries.sensorDeChuva,
            yAxis: 2,
            enableMouseTracking: false
          }]
        };
      }
    }, {
      key: 'mapChartSeries',
      value: function mapChartSeries(data) {
        var _this5 = this;

        return {
          velocidade: data.historicoVelocidade.map(function (v) {
            return [_this5.getMillisWithOffset(v.dataHora), v.velocidade];
          }),
          rpm: data.historicoRpm.map(function (r) {
            return [_this5.getMillisWithOffset(r.dataHora), r.rpm];
          }),
          sensorDeChuva: function () {
            var yBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
            var altura = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
            return data.historicoLimpadorParabrisa.map(function (periodo) {
              var inicio = _this5.getMillisWithOffset(periodo.inicio),
                  fim = _this5.getMillisWithOffset(periodo.fim);
              return [[inicio, yBase], [fim, yBase], [fim, yBase + altura], [inicio, yBase + altura], [fim, null]];
            }).reduce(function (ant, atual) {
              return ant.concat(atual);
            }, []);
          }()
        };
      }
    }, {
      key: 'getMillisWithOffset',
      value: function getMillisWithOffset(dateTimeStr) {
        var instante = this.moment(dateTimeStr);
        return this.moment(instante.valueOf() + instante.utcOffset() * 60 * 1000).valueOf();
      }
    }, {
      key: 'gerarPlotLinesVelocidade',
      value: function gerarPlotLinesVelocidade(data) {
        if (!data.historicoVelocidade || data.historicoVelocidade.length === 0) {
          return [];
        }
        return this.getPlotLines();
      }
    }, {
      key: 'modalConfigurar',
      value: function modalConfigurar() {
        var _this6 = this;

        this.sendEventToGTM();
        this.modalService.open({
          animation: true,
          templateUrl: 'relatorios/velocidade-rpm/velocidade-rpm-config.tpl.html',
          controller: 'VelocidadeRpmConfigCtrl',
          controllerAs: '$ctrl',
          size: 'sm',
          resolve: {
            limiarInferior: function limiarInferior() {
              return _this6.limiarInferior;
            },
            limiarSuperior: function limiarSuperior() {
              return _this6.limiarSuperior;
            }
          }
        }).result.then(function (data) {
          _this6.limiarInferior = data.limiarInferior;
          _this6.limiarSuperior = data.limiarSuperior;
          _this6.window.localStorage.setItem('limiar-rpm-velocidade', angular.toJson(data));
          _this6.redrawPlotLines();
        });
      }
    }, {
      key: 'sendEventToGTM',
      value: function sendEventToGTM() {
        this.googleTagManagerUtils.sendEventClickGTM('velocidade_x_rpm_configurar_velocidades', this.serviceVfiltro.factoryVfiltro.user);
      }
    }]);

    return VelocidadeRpmCtrl;
  }();

  var VelocidadeRpmConfigCtrl = function () {
    function VelocidadeRpmConfigCtrl(limiarInferior, limiarSuperior, $uibModalInstance, LIMIAR) {
      _classCallCheck(this, VelocidadeRpmConfigCtrl);

      this.limiarInferior = limiarInferior;
      this.limiarSuperior = limiarSuperior;
      this.modalInstance = $uibModalInstance;
      this.LIMIAR = LIMIAR;
    }

    _createClass(VelocidadeRpmConfigCtrl, [{
      key: 'validar',
      value: function validar() {
        if (this.limiarInferior < 0) {
          this.limiarInferior = this.limiarInferior * -1;
        }
        if (this.limiarSuperior < 0) {
          this.limiarSuperior = this.limiarSuperior * -1;
        }
        if (this.limiarInferior > 200 || this.limiarInferior <= 0) {
          this.limiarInferior = this.LIMIAR.INFERIOR;
        }
        if (this.limiarSuperior > 200 || this.limiarSuperior <= 0) {
          this.limiarSuperior = this.LIMIAR.SUPERIOR;
        }
        if (this.limiarInferior >= this.limiarSuperior) {
          this.limiarInferior = this.limiarSuperior;
        }
        this.modalInstance.close({
          limiarInferior: this.limiarInferior,
          limiarSuperior: this.limiarSuperior
        });
      }
    }]);

    return VelocidadeRpmConfigCtrl;
  }();

  /**
   * @ngdoc object
   * @name relatorios.velocidadeRpm.controller:VelocidadeRpmCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.velocidadeRpm').constant('LIMIAR', { INFERIOR: 60, SUPERIOR: 80 }).controller('VelocidadeRpmConfigCtrl', VelocidadeRpmConfigCtrl).controller('VelocidadeRpmCtrl', VelocidadeRpmCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.saudeFrota', ['ui.router', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.saudeFrota', {
      url: '/relatorios/saude-frota?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/saude-frota/saude-frota.tpl.html',
          controller: 'SaudeFrotaCtrl',
          controllerAs: 'saudeFrota'
        }
      },
      data: {
        titulo: 'ce.analise.saudeDaFrota.titulo',
        role: 'SAUDE_FROTA_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.saudeFrota').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable angular/log */
(function () {
  'use strict';

  var SaudeFrotaCtrl = function () {
    function SaudeFrotaCtrl(ServiceVfiltro, FactoryVfiltro, Keys) {
      var _this = this;

      _classCallCheck(this, SaudeFrotaCtrl);

      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name
      }, {
        name: 'veiculosId',
        key: this.keys.veiculos.name,
        size: 6
      }, {
        name: 'diagnosticosId',
        key: this.keys.diagnosticos.name,
        size: 6
      }])).then(function (filtro) {
        return _this.init(filtro);
      });
    }

    _createClass(SaudeFrotaCtrl, [{
      key: 'init',
      value: function init(filtro) {
        /*eslint-disable */
        var tableDiagnosticosElement = document.querySelector('#table-diagnosticos'),
            saudeFrotaListElement = document.createElement('vfwc-saude-frota-list'),
            vehiclesFiltered = filtro.find(function (f) {
          return f.key === 'veiculos';
        }),
            diagnosticsFiltered = filtro.find(function (f) {
          return f.key === 'diagnosticos';
        }),
            vehiclesId = vehiclesFiltered ? vehiclesFiltered.values.map(function (vehicle) {
          return vehicle.id;
        }) : vehiclesFiltered,
            diagnosticsId = diagnosticsFiltered ? diagnosticsFiltered.values.map(function (diagnostic) {
          return diagnostic.id;
        }) : diagnosticsFiltered;

        saudeFrotaListElement.uoId = Number(filtro.find(function (f) {
          return f.key === 'uo';
        }).value.id);
        saudeFrotaListElement.vehiclesIds = vehiclesId;
        saudeFrotaListElement.diagnosticsTypes = diagnosticsId;

        tableDiagnosticosElement.appendChild(saudeFrotaListElement);
      }
    }]);

    return SaudeFrotaCtrl;
  }();

  angular.module('relatorios.saudeFrota').controller('SaudeFrotaCtrl', SaudeFrotaCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.riskIntelligence
   * @description
   *
   */

  angular.module('relatorios.riskIntelligence', ['ui.router', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.riskIntelligence').config(configRiskIntelligence);

  function configRiskIntelligence($stateProvider) {
    $stateProvider.state('root.riskIntelligence', {
      url: '/qi?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/risk-intelligence/risk-intelligence.tpl.html',
          controller: 'RiskIntelligenceCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.quadroDeOcorrencias.quadroInteligente',
        hideTitulo: true,
        roles: ['OCORRENCIA_VISUALIZAR']
      }
    });

    // Opened from the "copy link" buttons of the board's detail drawer; the occurrence may no
    // longer be on the board, so the page loads it by id.
    $stateProvider.state('root.riskIntelligence.detail', {
      url: '/detail?id&dataHoraReferencia&alertaId',
      views: {
        'content@': {
          templateUrl: 'relatorios/risk-intelligence/risk-intelligence-detail.tpl.html',
          controller: 'RiskIntelligenceDetailCtrl',
          controllerAs: 'RiskIntelligenceDetailCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.quadroDeOcorrencias.quadroInteligente',
        hideTitulo: true,
        roles: ['OCORRENCIA_VISUALIZAR']
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RiskIntelligenceDetailCtrl = function () {
    function RiskIntelligenceDetailCtrl(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $state, $stateParams) {
      _classCallCheck(this, RiskIntelligenceDetailCtrl);

      this.safetyService = safetyService;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.authenticator = Authenticator;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.user = null;

      this.initialize();
    }

    _createClass(RiskIntelligenceDetailCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }

      // The detail has no filters: an empty init hides the filter bar left by the board.

    }, {
      key: 'initFilter',
      value: function initFilter() {
        return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this2 = this;

        return this.authenticator.getUser().then(function (user) {
          _this2.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this3 = this;

        var appName = 'safetyApp',
            componentName = './RiskIntelligenceDetailPageRoute',
            componentId = 'safety-app-risk-intelligence-detail',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this3.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goBackToBoard',
      value: function goBackToBoard() {
        this.state.go('root.riskIntelligence');
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        return {
          user: this.user,
          ocorrenciaId: this.stateParams.id,
          dataHoraReferencia: this.stateParams.dataHoraReferencia,
          alertaId: this.stateParams.alertaId,
          goBackToBoard: function goBackToBoard() {
            return _this4.goBackToBoard();
          }
        };
      }
    }]);

    return RiskIntelligenceDetailCtrl;
  }();

  RiskIntelligenceDetailCtrl.$inject = ['safetyService', 'ServiceVfiltro', 'FactoryVfiltro', 'Authenticator', 'blockUI', '$state', '$stateParams'];
  angular.module('relatorios.riskIntelligence').controller('RiskIntelligenceDetailCtrl', RiskIntelligenceDetailCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-var */
(function () {
  'use strict';

  var RiskIntelligenceCtrl = function () {
    function RiskIntelligenceCtrl($safetyService, $window, Authenticator, Keys, ServiceVfiltro, FactoryVfiltro) {
      var _this = this;

      _classCallCheck(this, RiskIntelligenceCtrl);

      this.window = $window;
      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.user = {};
      this.filtro = null;
      this.authenticator.getUser().then(function (user) {
        _this.user = user;
        _this.initializePage();
      });
    }

    _createClass(RiskIntelligenceCtrl, [{
      key: 'initializePage',
      value: function initializePage() {
        var _this2 = this;

        return this.initFilter().then(function () {
          return _this2.safetyService.initialize();
        }).then(function () {
          return _this2.loadPage();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this3 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name,
          size: 12
        }, {
          name: 'veiculos',
          key: this.keys.veiculos.name,
          ignoreValidation: true,
          size: 12
        }, {
          key: this.keys.usuario.name,
          size: 6
        }, {
          key: this.keys.nivel.name,
          size: 6
        }, {
          key: this.keys.tipos.name,
          size: 12
        }, {
          key: this.keys.videoContext.name,
          size: 12
        }])).then(function (filtro) {
          _this3.filtro = filtro;
        });
      }
    }, {
      key: 'loadPage',
      value: function loadPage() {
        var appName = 'safetyApp',
            componentPath = './RiskIntelligencePageRoute',
            componentId = 'safety-app-risk-intelligence',
            props = this.getReactProps();

        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        var uo = this.filtro.find(function (f) {
          return f.key === _this4.keys.uo.name;
        }),
            veiculos = this.filtro.find(function (f) {
          return f.key === _this4.keys.veiculos.name;
        }),
            usuario = this.filtro.find(function (f) {
          return f.key === _this4.keys.usuario.name;
        }),
            nivel = this.filtro.find(function (f) {
          return f.key === _this4.keys.nivel.name;
        }),
            tipos = this.filtro.find(function (f) {
          return f.key === _this4.keys.tipos.name;
        }),
            videoContext = this.filtro.find(function (f) {
          return f.key === _this4.keys.videoContext.name;
        });

        return {
          user: this.user,
          filter: {
            uoId: uo.value.id,
            veiculos: veiculos ? veiculos.values.map(function (v) {
              return v.id;
            }) : [],
            usuario: usuario ? usuario.value.id : null,
            nivel: nivel ? nivel.value.id : null,
            tipos: tipos ? tipos.values.map(function (t) {
              return t.id;
            }) : [],
            videoContextLabels: videoContext ? videoContext.values.map(function (v) {
              return v.label;
            }) : []
          }
        };
      }
    }]);

    return RiskIntelligenceCtrl;
  }();

  RiskIntelligenceCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro'];
  angular.module('relatorios.riskIntelligence').controller('RiskIntelligenceCtrl', RiskIntelligenceCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.rankingSafety', ['ui.router', 'uoModule', 'motoristaModule', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'pascalprecht.translate', 'VtabelaModule', 'smart-table', 'onboarding', 'urlConfigModule']).factory('RankingSafety', function (Restangular) {
    return Restangular.service('boletim/ranking/safety');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.rankingSafety', {
      url: '/relatorios/ranking/safety?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/ranking-safety/ranking-safety.tpl.html',
          controller: 'RankingSafetyCtrl',
          controllerAs: 'rankingSafety'
        }
      },
      data: {
        titulo: 'ce.ranking.direcaoSegura.titulo',
        role: 'RANKING_SEGURANCA_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.rankingSafety').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.rankingSafety').constant('MockRankingSafety', [{
    motorista: 'André Castanheira',
    motoristaId: 1,
    departamento: 'Coletas',
    totalEventos: 35,
    eventosPorTempo: 12,
    tempoEmDirecao: 3600,
    eventosPorEspaco: 21,
    distanciaPercorrida: 5035,
    aceleracoesBruscas: 8,
    frenagensBruscas: 2,
    curvasBruscas: 10,
    banguelas: 0,
    exVelocidadeFaixa1: 2,
    exVelocidadeFaixa2: 8,
    exVelocidadeFaixa3: 5,
    veiculos: 'VW81502 - AOI7238',
    veiculosIds: [1]
  }, {
    motorista: 'Gil Larangeira',
    motoristaId: 2,
    departamento: 'Coletas',
    totalEventos: 22,
    eventosPorTempo: 10,
    tempoEmDirecao: 2043,
    eventosPorEspaco: 4,
    distanciaPercorrida: 5840,
    aceleracoesBruscas: 0,
    frenagensBruscas: 0,
    curvasBruscas: 0,
    banguelas: 0,
    exVelocidadeFaixa1: 0,
    exVelocidadeFaixa2: 8,
    exVelocidadeFaixa3: 14,
    veiculos: 'FSADF45 - VXZ9045',
    veiculosIds: [2]
  }, {
    motorista: 'Iberê Lages',
    motoristaId: 3,
    departamento: 'Entregas',
    totalEventos: 18,
    eventosPorTempo: 6,
    tempoEmDirecao: 1068,
    eventosPorEspaco: 10,
    distanciaPercorrida: 7345,
    aceleracoesBruscas: 0,
    frenagensBruscas: 2,
    curvasBruscas: 9,
    banguelas: 1,
    exVelocidadeFaixa1: 2,
    exVelocidadeFaixa2: 4,
    exVelocidadeFaixa3: 0,
    veiculos: 'VCBZ45 - UKT3556',
    veiculosIds: [3]
  }, {
    motorista: 'Silvério Mansilla',
    motoristaId: 4,
    departamento: 'Coletas',
    totalEventos: 11,
    eventosPorTempo: 2,
    tempoEmDirecao: 3024,
    eventosPorEspaco: 0,
    distanciaPercorrida: 15040,
    aceleracoesBruscas: 0,
    frenagensBruscas: 0,
    curvasBruscas: 1,
    banguelas: 3,
    exVelocidadeFaixa1: 2,
    exVelocidadeFaixa2: 4,
    exVelocidadeFaixa3: 1,
    veiculos: 'ANGA01 - ANR1131',
    veiculosIds: [4]
  }]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RankingSafetyCtrl = function () {
    function RankingSafetyCtrl($httpParamSerializer, $window, $filter, Uos, Motoristas, IDRankingSafety, Keys, ServiceVfiltro, FactoryVfiltro, $translate, VtabelaFactory, uiGridConstants, ObjetosVfiltroService, RankingSafety, v3gTableLimitService, Onboarding, MockRankingSafety, UrlConfigService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, RankingSafetyCtrl);

      this.httpParamSerializer = $httpParamSerializer;
      this.window = $window;
      this.filter = $filter;
      this.uoService = Uos;
      this.motoristasService = Motoristas;
      this.rankingSafetyService = RankingSafety;
      this.v3gTableLimitService = v3gTableLimitService;
      this.onboarding = Onboarding;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.mockRankingSafety = MockRankingSafety;
      this.isDemo = this.onboarding.startOnboarding(IDRankingSafety);
      this.uoService.isDemo = this.isDemo;
      this.motoristasService.isDemo = this.isDemo;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.translate = $translate;
      this.labelSemMotorista = this.translate.instant('ce.ranking.direcaoSegura.labelSemMotorista');
      this.urlConfigService = UrlConfigService;

      this.featVsafeBoletim = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_VSAFE_BOLETIM);
      this.featRollingStop = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROLLING_STOP);
      this.featRouteDeviation = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROUTE_DEVIATION);
      this.vtabela = null;
      this.exportsPdf = false;
      this.uoSelecionada = null;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo_id',
        key: this.keys.uo.name
      }, {
        name: 'uo_parceira_id',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'motorista_id',
        key: this.keys.motoristas.name,
        size: 6
      }])).then(function (filtro) {
        _this.roleVisualizarBdm = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_MOTORISTA_VISUALIZAR');
        _this.roleVisualizarBdv = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_VEICULO_VISUALIZAR');
        _this.consultar(ServiceVfiltro.getFiltroBackendAntigo(filtro));
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'rankingTable', 'v2');
      });
    }

    _createClass(RankingSafetyCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        var drilDownSorting = void 0,
            drilDownCol = void 0,
            objVtabela = {
          exporterPdfFilename: 'Ranking Direção Segura PDF.pdf',
          exporterCsvFilename: 'Ranking Direção Segura CSV.csv',
          exporterExcelFilename: 'Ranking Direção Segura XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'motorista',
            displayName: 'ce.ranking.direcaoSegura.colunas.motorista',
            pinnedLeft: true,
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            width: 150,
            aggregationTotalTitle: 'Total',
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\' title="{{row.entity.ic}}">\n                    <a\n                    ng-href=\'{{(row.entity.linkBdm)}}\'\n                    target=\'_blank\'\n                    ng-if=\'grid.appScope.roleVisualizarBdm && row.entity.motorista !== grid.appScope.labelSemMotorista && row.entity.linkBdm\'>\n                      {{row.entity.motorista }}\n                    </a>\n                    <span ng-if=\'!grid.appScope.roleVisualizarBdm || row.entity.motorista === grid.appScope.labelSemMotorista\'> {{row.entity.motorista | splitComposedLabels:true}} </span>\n                  </div>\n                  '
          }, {
            name: 'departamento',
            displayName: 'ce.ranking.direcaoSegura.colunas.departamento',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'veiculos',
            displayName: 'ce.ranking.direcaoSegura.colunas.veiculos',
            enableHiding: false,
            filterCellFiltered: true,
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\' title="{{row.entity.ic}}">\n                    <a ng-href=\'{{(row.entity.linkBdv)}}\'\n                    target=\'_blank\'\n                    ng-if=\'grid.appScope.roleVisualizarBdv && row.entity.veiculos && row.entity.linkBdv\'\n                    title="{{row.entity.veiculos}}">\n                      {{row.entity.veiculos }}\n                    </a>\n                    <span ng-if=\'!grid.appScope.roleVisualizarBdv || !row.entity.veiculos || !row.entity.linkBdv\'\n                    title="{{row.entity.veiculos}}">\n                      {{row.entity.veiculos}}\n                    </span>\n                  </div>\n                  '
          }, { name: 'totalEventos', displayName: 'ce.ranking.direcaoSegura.colunas.totalEventos', type: 'number', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, { name: 'eventosPorTempo', displayName: 'ce.ranking.direcaoSegura.colunas.eventosPorTempo', type: 'number', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'decimal', cellClass: 'text-center', enableFiltering: false }, { name: 'tempoIgnicaoLigada', displayName: 'ce.ranking.direcaoSegura.colunas.tempoIgnicaoLigada', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }, { name: 'eventosPorEspaco', displayName: 'ce.ranking.direcaoSegura.colunas.eventosPorEspaco', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellFilter: 'decimal', cellClass: 'text-center', enableFiltering: false }, { name: 'distanciaPercorrida', displayName: 'ce.ranking.direcaoSegura.colunas.distanciaPercorrida', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellFilter: 'decimalWithLabel:\'Km\'', cellClass: 'text-center', enableFiltering: false }, { name: 'aceleracoesBruscas', displayName: 'ce.ranking.direcaoSegura.colunas.aceleracoesBruscas', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, { name: 'frenagensBruscas', displayName: 'ce.ranking.direcaoSegura.colunas.frenagensBruscas', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, { name: 'curvasBruscas', displayName: 'ce.ranking.direcaoSegura.colunas.curvasBruscas', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, { name: 'banguelas', displayName: 'ce.ranking.direcaoSegura.colunas.banguelas', type: 'number', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, { name: 'exVelocidadeFaixa1', displayName: 'ce.ranking.direcaoSegura.colunas.exVelocidadeFaixa1', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, { name: 'exVelocidadeFaixa2', displayName: 'ce.ranking.direcaoSegura.colunas.exVelocidadeFaixa2', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, { name: 'exVelocidadeFaixa3', displayName: 'ce.ranking.direcaoSegura.colunas.exVelocidadeFaixa3', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number', cellClass: 'text-center', enableFiltering: false }, {
            name: 'noSeatbelt',
            displayName: 'ce.enum.common.semCinto',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'yawning',
            displayName: 'ce.enum.eventos.bocejo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'absentDriver',
            displayName: 'ce.enum.common.semMotorista',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'smoking',
            displayName: 'ce.enum.common.usoDeCigarro',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'distraction',
            displayName: 'ce.enum.common.distracao',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'fatique',
            displayName: 'ce.enum.common.fadiga',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'cellphoneUsage',
            displayName: 'ce.enum.common.usoDeCelular',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'unsafeDistance',
            displayName: 'ce.enum.common.distanciaPerigosa',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'obstructedCamera',
            displayName: 'ce.enum.common.cameraObstruida',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'illegalOvertaking',
            displayName: 'ce.enum.eventos.ultrapassagemIlegal',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'noSafetyCone',
            displayName: 'ce.enum.eventos.semCone',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'noSafetyGlasses',
            displayName: 'ce.enum.eventos.SemOculos',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'noGloves',
            displayName: 'ce.enum.eventos.SemLuvas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'semCasquete',
            displayName: 'ce.enum.eventos.semCasquete',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'ride',
            displayName: 'ce.enum.eventos.carona',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim
          }, {
            name: 'rollingStop',
            displayName: 'ce.enum.eventos.rollingStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim || !this.featRollingStop
          }, {
            name: 'noStop',
            displayName: 'ce.enum.eventos.noStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim || !this.featRollingStop
          }, {
            name: 'routeDeviation',
            displayName: 'ce.enum.eventos.routeDeviation',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featVsafeBoletim || !this.featRouteDeviation
          }].filter(function (x) {
            return x.isDisabled !== true;
          })
        };
        drilDownSorting = this.getDrilDownSortingDirection(this.tableState);
        drilDownCol = objVtabela.columnDefs.find(function (column) {
          return column.name === _this2.tableState.sort.predicate;
        });

        if (drilDownSorting && drilDownCol) {
          angular.merge(drilDownCol, drilDownSorting);
        }
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.motoristaId,
          motorista: this.filter('withLabelToUndefined')(item.nomeMotorista, this.labelSemMotorista),
          departamento: item.departamento,
          veiculos: item.veiculos,
          totalEventos: item.totalEventos,
          eventosPorTempo: item.eventosPorTempo,
          tempoIgnicaoLigada: item.tempoEmDirecao,
          eventosPorEspaco: item.eventosPorEspaco,
          distanciaPercorrida: item.distanciaPercorrida,
          aceleracoesBruscas: item.aceleracoesBruscas,
          frenagensBruscas: item.frenagensBruscas,
          curvasBruscas: item.curvasBruscas,
          banguelas: item.banguelas,
          exVelocidadeFaixa1: item.exVelocidadeFaixa1,
          exVelocidadeFaixa2: item.exVelocidadeFaixa2,
          exVelocidadeFaixa3: item.exVelocidadeFaixa3,
          linkBdv: this.getLinkBdv(item.veiculosIds),
          linkBdm: this.getLinkBdm(item.motoristaId),
          noSeatbelt: item.noSeatbelt,
          yawning: item.yawning,
          absentDriver: item.absentDriver,
          smoking: item.smoking,
          distraction: item.distraction,
          fatique: item.fatique,
          cellphoneUsage: item.cellphoneUsage,
          unsafeDistance: item.unsafeDistance,
          obstructedCamera: item.obstructedCamera,
          illegalOvertaking: item.illegalOvertaking,
          noSafetyCone: item.noSafetyCone,
          noSafetyGlasses: item.noSafetyGlasses,
          noGloves: item.noGloves,
          semCasquete: item.semCasquete,
          ride: item.ride,
          rollingStop: item.rollingStop,
          noStop: item.noStop,
          routeDeviation: item.routeDeviation
        };
      }
    }, {
      key: 'consultar',
      value: function consultar(filtro) {
        var _this3 = this;

        if (this.isDemo) {
          this.setInfoTable(this.mockRankingSafety);
        } else {
          this.rankingSafetyService.one().get({ filtros: filtro }).then(function (data) {
            return _this3.setInfoTable(data);
          }).catch(function () {
            return _this3.vtabela.setError();
          });
        }
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this4 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this4.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getDrilDownSortingDirection',
      value: function getDrilDownSortingDirection(tableState) {
        if (tableState && tableState.sort.reverse) {
          return {
            sort: {
              direction: this.uiGridConstants.DESC
            }
          };
        }

        return {
          sort: {
            direction: this.uiGridConstants.ASC
          }
        };
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return {
          filtros: this.serviceVfiltro.getFiltroBackendAntigo(this.serviceVfiltro.filtroTopbar)
        };
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/boletim/ranking/safety/csv?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getUrlPdf',
      value: function getUrlPdf() {
        return '/boletim/ranking/safety/pdf?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getLinkBdv',
      value: function getLinkBdv(veiculosIds) {
        if (veiculosIds.length === 1) {
          return '/relatorios/bdv?' + this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.veiculos.name) + ';veiculos:' + veiculosIds.toString();
        }
        return null;
      }
    }, {
      key: 'getLinkBdm',
      value: function getLinkBdm(motoristaId) {
        return '/relatorios/bdm?' + this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.motoristas.name) + ';motoristas:' + motoristaId.toString();
      }
    }, {
      key: 'goToBDXDemo',
      value: function goToBDXDemo(tipo, id) {
        var filtro = tipo === 'bdv' ? this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.veiculos.name) + ';veiculos:' + id.toString() : this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.motoristas.name) + ';motoristas:' + id.toString();
        this.window.location.href = '/relatorios/' + tipo + '?demo&' + filtro;
      }
    }]);

    return RankingSafetyCtrl;
  }();
  /**
   * @ngdoc object
   * @name relatorios.rankingSafety.controller:RankingSafetyCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.rankingSafety').controller('RankingSafetyCtrl', RankingSafetyCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.rankingEconomy', ['ui.router', 'restangular', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'pascalprecht.translate', 'v3gAuthenticatorModule', 'cadastros.veiculo', 'urlConfigModule']).factory('RankingEconomy', function (Restangular) {
    return Restangular.service('boletim/ranking/economy');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.rankingEconomy', {
      url: '/relatorios/ranking/economy?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/ranking-economy/ranking-economy.tpl.html',
          controller: 'RankingEconomyCtrl',
          controllerAs: 'rankingEconomy'
        }
      },
      data: {
        titulo: 'ce.ranking.conducaoEconomica.titulo',
        role: 'RANKING_ECONOMIA_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.rankingEconomy').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RankingEconomyCtrl = function () {
    function RankingEconomyCtrl(Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, VtabelaFactory, uiGridConstants, RankingEconomy, $q, $httpParamSerializer, Restangular, $filter, $translate, Authenticator, CadastroVeiculoService, UrlConfigService) {
      var _this = this;

      _classCallCheck(this, RankingEconomyCtrl);

      this.authenticator = Authenticator;
      this.veiculoService = CadastroVeiculoService;
      this.q = $q;
      this.hasSensorAcionado = false;
      this.rankingEconomyService = RankingEconomy;
      this.restangular = Restangular;
      this.filter = $filter;
      this.httpParamSerializer = $httpParamSerializer;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.translate = $translate;
      this.urlConfigService = UrlConfigService;
      this.labelSemMotorista = this.translate.instant('ce.ranking.conducaoEconomica.labelSemMotorista');

      this.vtabela = null;
      this.exportsPdf = false;
      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo_id',
        key: this.keys.uo.name
      }, {
        name: 'uo_parceira_id',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'motorista_id',
        key: this.keys.motoristas.name,
        size: 6
      }])).then(function (filtro) {
        _this.roleVisualizarBdm = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_MOTORISTA_VISUALIZAR');
        _this.roleVisualizarBdv = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_VEICULO_VISUALIZAR');
        _this.consultar(ServiceVfiltro.getFiltroBackendAntigo(filtro));
      });
    }

    _createClass(RankingEconomyCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        var drilDownSorting = void 0,
            drilDownCol = void 0,
            objVtabela = {
          exporterPdfFilename: 'Ranking Condução Econômica PDF.pdf',
          exporterCsvFilename: 'Ranking Condução Econômica CSV.csv',
          exporterExcelFilename: 'Ranking Condução Econômica XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'motorista',
            displayName: 'ce.ranking.conducaoEconomica.colunas.motorista',
            type: 'string',
            pinnedLeft: true,
            width: 150,
            filterCellFiltered: true,
            enableHiding: false,
            aggregationTotalTitle: 'Total',
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\' title="{{row.entity.ic}}">\n                    <a\n                    ng-href=\'{{(row.entity.linkBdm)}}\'\n                    target=\'_blank\'\n                    ng-if=\'grid.appScope.roleVisualizarBdm && row.entity.motorista !== grid.appScope.labelSemMotorista && row.entity.linkBdm\'\n                    title="{{row.entity.motorista}}">\n                      {{row.entity.motorista}}\n                    </a>\n                    <span\n                    ng-if=\'!grid.appScope.roleVisualizarBdm || row.entity.motorista === grid.appScope.labelSemMotorista\'\'\n                    title="{{row.entity.motorista}}">\n                      {{row.entity.motorista | withLabelToUndefined:\'Sem identifica\xE7\xE3o\' | splitComposedLabels:true}}\n                    </span>\n                  </div> '
          }, {
            name: 'departamento',
            displayName: 'ce.ranking.conducaoEconomica.colunas.departamento',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'veiculos',
            displayName: 'ce.ranking.conducaoEconomica.colunas.veiculos',
            enableHiding: false,
            filterCellFiltered: true,
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\' title="{{row.entity.veiculos}}">\n                    <a ng-href=\'{{(row.entity.linkBdv)}}\' target=\'_blank\' ng-if=\'grid.appScope.roleVisualizarBdv && row.entity.veiculos && row.entity.linkBdv\'>\n                      {{row.entity.veiculos }}\n                    </a>\n                    <span ng-if=\'!grid.appScope.roleVisualizarBdv || !row.entity.veiculos || !row.entity.linkBdv\'> {{row.entity.veiculos}} </span>\n                  </div>\n                  '
          }, { name: 'totalEventos', displayName: 'ce.ranking.conducaoEconomica.colunas.totalEventos', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }, { name: 'tempoIgnicaoLigada', displayName: 'ce.ranking.conducaoEconomica.colunas.tempoIgnicaoLigada', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }, { name: 'distanciaPercorrida', displayName: 'ce.ranking.conducaoEconomica.colunas.distanciaPercorrida', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'decimalWithLabel:\'Km\'', cellClass: 'text-center', enableFiltering: false }, { name: 'banguelas', displayName: 'ce.ranking.conducaoEconomica.colunas.banguelas', cellFilter: 'humanizedDuration', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, { name: 'rpmExcessivo', displayName: 'ce.ranking.conducaoEconomica.colunas.rpmExcessivo', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }, { name: 'motorOcioso', displayName: 'ce.ranking.conducaoEconomica.colunas.motorOcioso', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }]
        };

        if (this.hasSensorAcionado) {
          objVtabela.columnDefs.push({
            name: 'tempoSensorDesengate',
            displayName: 'ce.ranking.conducaoEconomica.colunas.sensorAcionado',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            sortWithUndefinedValues: true,
            footerCellClass: 'text-center',
            cellTemplate: '\n            <div class="ui-grid-cell-contents text-center">\n              <span title="{{row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'N\xE3o se aplica.\'}}">\n                {{row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'N/A\'}}\n              </span>\n            </div>',
            cellFilter: 'humanizedOrUndefinedWithLabel:\'N/A\'',
            enableFiltering: false
          });
        }

        drilDownSorting = this.getDrilDownSortingDirection(this.tableState);
        drilDownCol = objVtabela.columnDefs.find(function (column) {
          return column.name === _this2.tableState.sort.predicate;
        });

        if (drilDownSorting && drilDownCol) {
          angular.merge(drilDownCol, drilDownSorting);
        }
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.motoristaId,
          motorista: this.filter('withLabelToUndefined')(item.nomeMotorista, this.labelSemMotorista),
          departamento: item.departamento,
          veiculos: item.veiculos,
          totalEventos: item.totalEventos,
          tempoIgnicaoLigada: item.tempoEmDirecao,
          distanciaPercorrida: item.distanciaPercorrida,
          banguelas: item.banguelas,
          rpmExcessivo: item.rpmExcessivo,
          motorOcioso: item.motorOcioso,
          tempoSensorDesengate: item.tempoSensorDesengate,
          linkBdv: this.getLinkBdv(item.veiculosIds),
          linkBdm: this.getLinkBdm(item.motoristaId)
        };
      }
    }, {
      key: 'loadGridRankingEconomy',
      value: function loadGridRankingEconomy(data) {
        var _this3 = this;

        this.authenticator.getUser().then(function (user) {
          var usuarioUoId = user.plain().uo.id;

          _this3.veiculoService.hasSensor(usuarioUoId).then(function (hasSensor) {
            _this3.hasSensorAcionado = hasSensor;
            _this3.vtabela = _this3.vtabelaFactory.get(_this3.initVtabela(), _this3.serviceVfiltro.factoryVfiltro.user, 'rankingEconomicoTable', 'v1');
            _this3.setInfoTable(data);
          });
        });
      }
    }, {
      key: 'consultar',
      value: function consultar(filtro) {
        var _this4 = this;

        this.rankingEconomyService.one().get({ filtros: filtro }).then(function (data) {
          _this4.loadGridRankingEconomy(data);
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this5 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this5.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getLinkBdv',
      value: function getLinkBdv(veiculosIds) {
        if (veiculosIds.length === 1) {
          return '/relatorios/bdv?' + this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.veiculos.name) + ';veiculos:' + veiculosIds.toString();
        }
        return null;
      }
    }, {
      key: 'getLinkBdm',
      value: function getLinkBdm(motoristaId) {
        return '/relatorios/bdm?' + this.objetosVfiltroService.getVfiltroTableState(this.tableState, this.keys.motoristas.name) + ';motoristas:' + motoristaId.toString();
      }
    }, {
      key: 'getDrilDownSortingDirection',
      value: function getDrilDownSortingDirection(tableState) {
        if (tableState && tableState.sort.reverse) {
          return {
            sort: {
              direction: this.uiGridConstants.DESC
            }
          };
        }

        return {
          sort: {
            direction: this.uiGridConstants.ASC
          }
        };
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return {
          filtros: this.serviceVfiltro.getFiltroBackendAntigo(this.serviceVfiltro.filtroTopbar)
        };
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/boletim/ranking/economy/csv?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getUrlPdf',
      value: function getUrlPdf() {
        return '/boletim/ranking/economy/pdf?' + this.httpParamSerializer(this.getParams());
      }
    }]);

    return RankingEconomyCtrl;
  }();

  /**
   * @ngdoc object
   * @name relatorios.rankingEconomy.controller:RankingEconomyCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.rankingEconomy').controller('RankingEconomyCtrl', RankingEconomyCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.permanencia', ['ui.router', 'restangular', 'angularMoment', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'pascalprecht.translate', 'ModuleEventos', 'urlConfigModule', 'VtabelaModule']).factory('Permanencia', function (Restangular) {
    return Restangular.service('/ponto-referencia/permanencias');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.permanencia', {
      url: '/relatorios/permanencia?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/permanencia-ponto/permanencia-ponto.tpl.html',
          controller: 'PermanenciaCtrl',
          controllerAs: 'permanencia'
        }
      },
      data: {
        titulo: 'ce.analise.permanencia.titulo',
        role: ['PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR', 'PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR']
      }
    });
  }

  angular.module('relatorios.permanencia').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PermanenciaCtrl = function () {
    function PermanenciaCtrl(Permanencia, $httpParamSerializer, moment, ServiceVfiltro, ObjetosVfiltroService, FactoryVfiltro, Keys, VtabelaFactory, uiGridConstants, FormatVfiltro, $filter, $translate, Eventos, UrlConfigService) {
      var _this = this;

      _classCallCheck(this, PermanenciaCtrl);

      this.permanenciaService = Permanencia;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.formatVfiltro = FormatVfiltro;
      this.filter = $filter;
      this.translate = $translate;
      this.eventos = Eventos;
      this.urlConfigService = UrlConfigService;

      this.vtabela = null;
      this.exportsPdf = false;
      this.uoSelecionada = null;
      this.labelCercaEletronica = this.translate.instant('ce.common.permanencia.cercaEletronica');
      this.labelPontoReferencia = this.translate.instant('ce.common.permanencia.pontoReferencia');
      this.mapTipoPermanenciaToTipoEvento = new Map([['PONTO_REFERENCIA', this.eventos.PERMANENCIA_PONTO.alerta], ['CERCA_ELETRONICA', this.eventos.PERMANENCIA_CERCA.alerta]]);

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        dateLimit: 1,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        name: 'uoId',
        key: this.keys.uo.name
      }, {
        name: 'veiculoIds',
        key: this.keys.veiculos.name,
        ignoreValidation: true
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.user = _this.serviceVfiltro.factoryVfiltro.user;
        _this.selectOptions = _this.getTiposPermanenciaPermissao();
        _this.roleHistoricoDetalhado = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('HISTORICO_DETALHADO_VISUALIZAR');
        _this.consultar();
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'relatorioPermanencia', 'v1');
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = true;
      });
    }

    _createClass(PermanenciaCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var exporterBaseName = this.translate.instant('ce.analise.permanencia.exporter');
        var objVtabela = {
          exporterPdfFilename: exporterBaseName + ' PDF.pdf',
          exporterCsvFilename: exporterBaseName + ' CSV.csv',
          exporterExcelFilename: exporterBaseName + ' XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'veiculo',
            displayName: 'ce.analise.permanencia.colunas.veiculo',
            pinnedLeft: true,
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'isPermanenciaPontoReferencia',
            displayName: 'ce.common.permanencia.tipoPermanencia',
            pinnedLeft: true,
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: this.selectOptions
            },
            type: 'boolean',
            cellTemplate: '\n              <div\n                class="ui-grid-cell-contents text-center">\n                {{ grid.appScope.getLabelPermanenciaTipo(row.entity.isPermanenciaPontoReferencia) }}\n              </div>'
          }, {
            name: 'nomeRegiao',
            displayName: 'ce.common.nome',
            filterCellFiltered: true,
            pinnedLeft: true,
            enableHiding: false,
            cellClass: 'text-center'
          }, {
            name: 'tempoPermanencia',
            displayName: 'ce.analise.permanencia.colunas.tempoPermanencia',
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'uo',
            displayName: 'ce.analise.permanencia.colunas.uo',
            filterCellFiltered: true
          }, {
            name: 'motorista',
            displayName: 'ce.analise.permanencia.colunas.motoristas',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'dataHoraInicial',
            displayName: 'ce.analise.permanencia.colunas.dataHoraInicial',
            cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'dataHoraFinal',
            displayName: 'ce.analise.permanencia.colunas.dataHoraFinal',
            cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'grupoVeiculo',
            displayName: 'ce.analise.permanencia.colunas.grupoVeiculo',
            filterCellFiltered: true
          }, {
            name: 'logradouro',
            displayName: 'ce.analise.permanencia.colunas.logradouro',
            filterCellFiltered: true,
            type: 'string',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{row.entity.logradouro}}">\n                <a ng-href=\'{{row.entity.link}}\' target=\'_blank\' ng-if=\'grid.appScope.roleHistoricoDetalhado\'>\n                  {{ row.entity.logradouro }}\n                </a>\n                <span ng-if=\'!grid.appScope.roleHistoricoDetalhado\'> {{row.entity.logradouro}} </span>\n              </div>\n              '
          }, {
            name: 'localizacao',
            displayName: 'ce.analise.permanencia.colunas.localizacao',
            filterCellFiltered: true
          }, {
            name: 'categoria',
            displayName: 'ce.analise.permanencia.colunas.categoria',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'hodometroInicial',
            displayName: 'ce.analise.permanencia.colunas.hodometroInicial',
            cellFilter: 'decimalWithLabel:\'Km\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'hodometroFinal',
            displayName: 'ce.analise.permanencia.colunas.hodometroFinal',
            cellFilter: 'decimalWithLabel:\'Km\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'distancia',
            displayName: 'ce.analise.permanencia.colunas.distanciaPercorrida',
            cellClass: 'text-center',
            filterCellFiltered: true
          }]
        };

        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        var permanencia = this.getPermanenciaByTipo(item);
        return {
          veiculo: this.geraVeiculo(item.veiculo),
          grupoVeiculo: item.veiculo.grupo && item.veiculo.grupo.nome,
          motorista: angular.isDefined(item.motoristas) ? this.geraMotoristas(item.motoristas) : null,
          uo: item.veiculo.uo && item.veiculo.uo.nome,
          nomeRegiao: permanencia.nome,
          categoria: permanencia.categoriaNome,
          tempoPermanencia: this.geraTempoPermanenciaSegundos(item),
          dataHoraInicial: item.inicio,
          dataHoraFinal: item.fim,
          localizacao: permanencia.localizacao,
          logradouro: permanencia.logradouro,
          hodometroInicial: item.hodometroInicial,
          hodometroFinal: item.hodometroFinal,
          distancia: this.geraDistancia(item),
          link: this.getLinkHistoricoDetalhado(item),
          isPermanenciaPontoReferencia: item.permanenciaTipo === 'PONTO_REFERENCIA'
        };
      }
    }, {
      key: 'getPermanenciaByTipo',
      value: function getPermanenciaByTipo(item) {
        var isPontoReferencia = item.permanenciaTipo === 'PONTO_REFERENCIA';
        var categoriaCercaNome = '';
        if (!isPontoReferencia && item.cercaEletronica.categoria) {
          categoriaCercaNome = item.cercaEletronica.categoria.nome;
        }

        return {
          nome: isPontoReferencia ? item.pontoReferencia.nome : item.cercaEletronica.nome,
          categoriaNome: isPontoReferencia ? item.pontoReferencia.categoriaNome : categoriaCercaNome,
          logradouro: isPontoReferencia ? item.pontoReferencia.logradouro : item.cercaEletronica.logradouro,
          localizacao: isPontoReferencia ? item.pontoReferencia.localizacao : item.cercaEletronica.localizacao
        };
      }
    }, {
      key: 'getLabelPermanenciaTipo',
      value: function getLabelPermanenciaTipo(isPermanenciaPontoReferencia) {
        return isPermanenciaPontoReferencia ? this.labelPontoReferencia : this.labelCercaEletronica;
      }
    }, {
      key: 'getTiposPermanenciaPermissao',
      value: function getTiposPermanenciaPermissao() {
        var permissionPonto = this.user.permissoes.includes('PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR'),
            permissionCerca = this.user.permissoes.includes('PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR');

        var options = [{ value: true, label: this.labelPontoReferencia }, { value: false, label: this.labelCercaEletronica }];

        if (!permissionPonto && permissionCerca) {
          options = [{ value: false, label: this.labelCercaEletronica }];
        } else if (permissionPonto && !permissionCerca) {
          options = [{ value: true, label: this.labelPontoReferencia }];
        }

        return options;
      }
    }, {
      key: 'getLinkHistoricoDetalhado',
      value: function getLinkHistoricoDetalhado(row) {
        var momentEvento = this.moment(row.inicio),
            eventoTipo = this.mapTipoPermanenciaToTipoEvento.get(row.permanenciaTipo),
            eventoIsoDate = new Date(row.inicio).toISOString(),
            inicioEvento = momentEvento.format(this.formatVfiltro),
            inicioDia = momentEvento.startOf('day').format(this.formatVfiltro);

        return '/historico-timeline?vfiltro=veiculo:' + row.veiculoId + ';uo:' + row.veiculo.uo.id + ';dateTime:' + inicioDia + ',' + inicioEvento + '&evento=' + eventoTipo + '&date=' + eventoIsoDate + '&ultimo=true&forceRenderLayer=true';
      }
    }, {
      key: 'geraVeiculo',
      value: function geraVeiculo(veiculo) {
        return '' + (veiculo.prefixo ? veiculo.prefixo + ' - ' : '') + veiculo.placa;
      }
    }, {
      key: 'geraMotoristas',
      value: function geraMotoristas(motoristas) {
        return motoristas.map(function (motorista) {
          return motorista.nome;
        }).join(', ');
      }
    }, {
      key: 'geraDistancia',
      value: function geraDistancia(item) {
        if (item.hodometroFinal && item.hodometroInicial) {
          return this.filter('decimalWithLabel')(item.hodometroFinal - item.hodometroInicial, 'Km');
        }
        return '-';
      }
    }, {
      key: 'geraTempoPermanenciaSegundos',
      value: function geraTempoPermanenciaSegundos(item) {
        return (new Date(item.fim) - new Date(item.inicio)) / 1000;
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this2 = this;

        this.permanenciaService.one().get(this.serviceVfiltro.getFiltroBackendNovo(this.filtro)).then(function (data) {
          return _this2.setInfoTable(data);
        }).catch(function () {
          return _this2.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this3 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this3.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/ponto-referencia/permanencias/csv?' + this.httpParamSerializer(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
      }
    }, {
      key: 'getUrlPdf',
      value: function getUrlPdf() {
        return '/ponto-referencia/historico-permanencia/pdf?' + this.httpParamSerializer(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
      }
    }]);

    return PermanenciaCtrl;
  }();

  angular.module('relatorios.permanencia').controller('PermanenciaCtrl', PermanenciaCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.ocorrenciaDetalhes', ['ui.router', 'ocorrencia.component', 'quadroOcorrencias', 'httpServiceV3gModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FIELDS_OCORR = ['id', 'uoId', 'dataHora', 'status', 'alertasGerados', 'veiculoId', 'veiculo.id', 'veiculo.placa', 'veiculo.prefixo', 'veiculo.grupo.id', 'veiculo.grupo.nome', 'veiculo.uo.nome', 'veiculo.uo.id', 'motorista.id', 'motorista.nome', 'motorista.uo.id', 'motorista.uoId', 'motorista.uo.nome', 'motorista.departamentoId', 'motorista.departamento.id', 'motorista.departamento.nome', 'usuarioIdAtribuido'];

  var OcorrenciasDetalhes = function () {
    function OcorrenciasDetalhes(HttpServiceV3g, $httpParamSerializer) {
      _classCallCheck(this, OcorrenciasDetalhes);

      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
    }

    _createClass(OcorrenciasDetalhes, [{
      key: 'getOcorrenciaById',
      value: function getOcorrenciaById(idOcorrencia, datahora) {
        var params = this.httpParamSerializer({
          fields: FIELDS_OCORR.join(),
          inicio: datahora,
          id: idOcorrencia
        });

        return this.httpService.get('/alerta/ocorrencias?' + params);
      }
    }]);

    return OcorrenciasDetalhes;
  }();

  angular.module('relatorios.ocorrenciaDetalhes').service('OcorrenciasDetalhes', OcorrenciasDetalhes);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.ocorrenciaDetalhes', {
      url: '/relatorios/ocorrencia-detalhes/:ocorrenciaId/:dataHora',
      views: {
        'content@': {
          templateUrl: 'relatorios/ocorrencia-detalhes/ocorrencia-detalhes.tpl.html',
          controller: 'OcorrenciaDetalhesCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.quadroDeOcorrencias.ocorrenciaDetalhes.titulo',
        backButton: true,
        role: 'OCORRENCIA_VISUALIZAR',
        backState: 'root.ocorrencia'
      }
    });
  }

  angular.module('relatorios.ocorrenciaDetalhes').config(pageConfig);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  /* global Intl, _ */
  'use strict';

  var OcorrenciaDetalhesCtrl = function () {
    function OcorrenciaDetalhesCtrl(Ocorrencias, OcorrenciasDetalhes, $q, $scope, $stateParams) {
      _classCallCheck(this, OcorrenciaDetalhesCtrl);

      this.serviceQuadroOcorr = Ocorrencias;
      this.serviceOcorrDetalhes = OcorrenciasDetalhes;
      this.q = $q;
      this.stateParams = $stateParams;
      this.scope = $scope;
      this.timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.nenhumUsuario = { id: null, login: 'Nenhum' };
      this.requestError = false;
      this.model = {
        responsavel: null,
        status: null,
        obs: null
      };
      this.limitScroll = 10;
      this.ocorrencia = null;

      this.initRequests();

      this.isDrawerActive = false;
      this.isDetailsReloaded = false;
      this.itemsReloaded = new Set();
      this.limit = 100;
    }

    _createClass(OcorrenciaDetalhesCtrl, [{
      key: 'toggleDrawer',
      value: function toggleDrawer() {
        this.isDrawerActive = !this.isDrawerActive;
      }
    }, {
      key: 'loadMore',
      value: function loadMore() {
        this.limitScroll += 10;
      }
    }, {
      key: 'initRequests',
      value: function initRequests() {
        var _this = this;

        this.serviceOcorrDetalhes.getOcorrenciaById(this.stateParams.ocorrenciaId, this.stateParams.dataHora).then(function (data) {
          _this.ocorrencia = data.data[0];
          _this.lateRequest();
        }).catch(function () {
          _this.requestError = true;
        });
      }
    }, {
      key: 'lateRequest',
      value: function lateRequest() {
        var _this2 = this;

        var requests = [this.serviceQuadroOcorr.getUsers(this.ocorrencia.veiculoId), this.serviceQuadroOcorr.getHistorico(this.ocorrencia, this.timezone)];
        this.q.all(requests).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              userRes = _ref2[0],
              histRes = _ref2[1];

          _this2.usuarios = userRes.data;
          _this2.model.responsavel = _this2.usuarios.find(function (user) {
            return user.id === _this2.ocorrencia.usuarioIdAtribuido;
          }) || _this2.nenhumUsuario;
          _this2.usuarios.unshift(_this2.nenhumUsuario);
          if (histRes) {
            _this2.ocorrencia.hist = histRes.data;
          }
        }).catch(function () {
          _this2.requestError = true;
        });
      }
    }]);

    return OcorrenciaDetalhesCtrl;
  }();

  angular.module('relatorios.ocorrenciaDetalhes').controller('OcorrenciaDetalhesCtrl', OcorrenciaDetalhesCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.analiseOp', ['ui.router', 'restangular', 'uoModule', 'v3gVeiculoModule', 'motoristaModule', 'angularMoment', 'vflashModule', 'sidebarMenuToggleModule', 'smart-table', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'urlConfigModule']).factory('AnaliseOperacional', function (Restangular) {
    return Restangular.service('/analiseoperacional/relatorio/analise-operacional');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.analiseOp', {
      url: '/relatorios/movimento-veiculo?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/movimento-veiculo/movimento-veiculo.tpl.html',
          controller: 'AnaliseOpCtrl',
          controllerAs: 'analiseOp'
        }
      },
      data: {
        titulo: 'ce.analise.movimentoVeiculo.titulo',
        role: 'HISTORICO_CONSOLIDADO_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.analiseOp').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global Blob*/

  var AnaliseOpCtrl = function () {
    function AnaliseOpCtrl(AnaliseOperacional, $httpParamSerializer, Uos, Veiculos, Motoristas, $q, moment, VFlash, SidebarToggleService, v3gTableLimitService, ServiceVfiltro, FactoryVfiltro, Keys, VtabelaFactory, uiGridConstants, UrlConfigService, $translate, HttpServiceV3g, FeaturehubJsSdk, FeatureHubConfigKeys, $window) {
      var _this = this;

      _classCallCheck(this, AnaliseOpCtrl);

      this.httpParamSerializer = $httpParamSerializer;
      this.q = $q;
      this.uoService = Uos;
      this.moment = moment;
      this.sidebarToggle = SidebarToggleService;
      this.veiculoService = Veiculos;
      this.motoristaService = Motoristas;
      this.analiseOperacional = AnaliseOperacional;
      this.v3gTableLimitService = v3gTableLimitService;
      this.flash = VFlash;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.urlConfigService = UrlConfigService;
      this.translate = $translate;
      this.isConsumoEletrico = false;
      this.httpService = HttpServiceV3g;
      this.window = $window;
      this.isFeatureFlagDownloadPdfEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_FEAT_DOWNLOAD_PDF_ANALISE_MOVIMENTO_VEICULO);
      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        dateLimit: 1,
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        name: 'uoId',
        key: this.keys.uo.name,
        size: 6
      }, {
        name: 'uoParceiraId',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'veiculoId',
        key: this.keys.veiculo.name,
        ignoreValidation: true,
        size: 6,
        required: true
      }, {
        name: 'motoristaId',
        key: this.keys.motoristas.name,
        ignoreValidation: true,
        size: 6
      }])).then(function (filtro) {
        _this.user = _this.serviceVfiltro.factoryVfiltro.user;
        _this.roleVisualizarMapa = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('LOCALIZACAO_ATUAL_VISUALIZAR');
        _this.roleVisualizarPonto = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PONTO_REFERENCIA_VISUALIZAR');
        _this.consultar(filtro);
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = true;
      });
    }

    _createClass(AnaliseOpCtrl, [{
      key: 'consultar',
      value: function consultar(filtro) {
        var _this2 = this;

        this.analiseOperacional.one().get(this.serviceVfiltro.getFiltroBackendNovo(filtro)).then(function (data) {
          _this2.isConsumoEletrico = data.list.some(function (item) {
            return item.consumoEletrico > 0;
          });
          _this2.vtabela = _this2.vtabelaFactory.get(_this2.initVtabela(), _this2.user, 'analiseOp', 'v1');
          _this2.setInfoTable(data);
        }).catch(function () {
          return _this2.vtabela.setError();
        });
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var _this3 = this;

        var objVtabela = {
          exporterPdfFilename: 'Ranking Direção Segura PDF.pdf',
          exporterCsvFilename: 'Ranking Direção Segura CSV.csv',
          exporterExcelFilename: 'Ranking Direção Segura XLSX.xlsx',
          exportsPdf: this.isFeatureFlagDownloadPdfEnabled,
          exportsPdfClickFn: function exportsPdfClickFn() {
            return _this3.handlClickExportPdf(_this3.httpParamSerializer(_this3.serviceVfiltro.getFiltroBackendNovo(_this3.serviceVfiltro.filtroTopbar)));
          },
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'nomeVeiculo',
            displayName: 'ce.analise.movimentoVeiculo.colunas.veiculo',
            pinnedLeft: true,
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            width: 150,
            aggregationTotalTitle: 'Total'
          }, {
            name: 'statusRelatorio',
            displayName: 'ce.analise.movimentoVeiculo.colunas.ocorrencia',
            type: 'string',
            width: 150,
            filterCellFiltered: true,
            enableHiding: false,
            cellTemplate: '\n                <div class=\'ui-grid-cell-contents text-center centered-label-analise-mov\'\n                title="{{ row.entity.statusRelatorio }}">\n                  <span class=\'label {{row.entity.statusRelatorioLabel}}\'>\n                    {{ row.entity.statusRelatorio }}\n                  </span>\n                </div>\n              '
          }, {
            name: 'inicio',
            displayName: 'ce.analise.movimentoVeiculo.colunas.dataHoraInicial',
            filterCellFiltered: true,
            cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
            cellClass: 'text-center',
            width: 130
          }, {
            name: 'fim',
            displayName: 'ce.analise.movimentoVeiculo.colunas.dataHoraFinal',
            filterCellFiltered: true,
            cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
            cellClass: 'text-center',
            width: 130
          }, {
            name: 'duracao',
            displayName: 'ce.analise.movimentoVeiculo.colunas.duracao',
            cellClass: 'text-center',
            cellFilter: 'humanizedDuration',
            enableFiltering: false,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'motoristaNome',
            displayName: 'ce.analise.movimentoVeiculo.colunas.motorista',
            type: 'string',
            filterCellFiltered: true,
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\'>\n                    <motorista-link\n                      motorista="row.entity.motoristaNome"\n                      motorista-id="row.entity.motoristaId"\n                      has-permission="row.entity.hasPermissionDriver"\n                      index=\'$index\'>\n                    </motorista-link>\n                  </div>\n                '
          }, {
            name: 'distanciaPercorrida',
            displayName: 'ce.analise.movimentoVeiculo.colunas.distanciaPercorrida',
            cellFilter: 'decimalWithLabel:\'Km\'',
            cellClass: 'text-center',
            enableFiltering: false,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'consumo',
            displayName: 'ce.analise.movimentoVeiculo.colunas.consumo',
            type: 'number',
            cellFilter: this.getConsumoCellFilter(),
            cellClass: 'text-center',
            enableFiltering: false,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'logradouro',
            displayName: 'ce.analise.movimentoVeiculo.colunas.logradouro',
            type: 'string',
            filterCellFiltered: true }, {
            name: 'pontoReferencia',
            displayName: 'ce.analise.movimentoVeiculo.colunas.pontoReferencia',
            type: 'string',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{ row.entity.pontoReferencia }}">\n                <a ng-href=\'{{ row.entity.linkLocalizacaoFrota }}\'\n                   target=\'_blank\'\n                   ng-if=\'grid.appScope.roleVisualizarMapa && grid.appScope.roleVisualizarPonto\'>\n                  {{ row.entity.pontoReferencia }}\n                </a>\n                <span ng-if=\'!grid.appScope.roleVisualizarMapa || !grid.appScope.roleVisualizarPonto\'>\n                  {{ row.entity.pontoReferencia }}\n                </span>\n              </div>\n              '
          }, {
            name: 'cidade',
            displayName: 'ce.analise.movimentoVeiculo.colunas.cidade',
            type: 'string',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'uf',
            displayName: 'ce.analise.movimentoVeiculo.colunas.uf',
            width: 75,
            type: 'string',
            filterCellFiltered: true
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'handlClickExportPdf',
      value: function handlClickExportPdf(httpParams) {
        this.downloadPdf(httpParams);
      }
    }, {
      key: 'downloadPdf',
      value: function downloadPdf(httpParams) {
        var _this4 = this;

        this.httpService.get('/analiseoperacional/relatorio/analise-operacional/pdf?' + httpParams, { responseType: 'blob' }).then(function (result) {
          var contentDispositionHeader = result.headers('content-disposition'),
              fileName = contentDispositionHeader ? contentDispositionHeader.split('filename=')[1] : undefined,
              anchor = angular.element('<a/>'),
              file = new Blob([result.data], { type: 'application/pdf' }),
              pdfBrowserUrl = _this4.window.URL.createObjectURL(file);
          anchor.attr({
            href: pdfBrowserUrl,
            target: '_blank',
            download: fileName ? fileName : 'export.pdf'
          })[0].click();
          _this4.window.URL.revokeObjectURL(pdfBrowserUrl);
        });
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          distanciaPercorrida: item.distanciaPercorrida,
          motoristaNome: item.motoristaNome,
          motoristaId: item.motoristaId,
          hasPermissionDriver: item.hasPermissionDriver,
          logradouro: item.logradouro,
          cidade: item.cidade,
          uf: item.uf,
          duracao: item.duracao,
          inicio: item.inicio,
          fim: item.fim,
          nomeVeiculo: item.nomeVeiculo,
          consumo: item.consumo ? item.consumo : item.consumoEletrico,
          statusRelatorio: this.statusText(item.statusRelatorio),
          statusRelatorioLabel: this.statusLabel(item.statusRelatorio),
          pontoReferencia: item.pontoReferencia && item.pontoReferencia.nome,
          linkLocalizacaoFrota: item.pontoReferencia && '/mapas-grid?ponto=' + item.pontoReferencia.id + '&forceRenderLayer=true'
        };
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this5 = this;

        this.vtabela.setData(data.list.map(function (i) {
          return _this5.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/analiseoperacional/relatorio/analise-operacional/csv?' + this.httpParamSerializer(this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar));
      }
    }, {
      key: 'statusLabel',
      value: function statusLabel(status) {
        switch (status) {
          case 'GPS_INVALIDO':
            return 'label-important ign-desligada';
          case 'PARADO':
            return 'label-parado-anal-op';
          case 'PARADO_COM_MOTOR':
            return 'label-warning';
          case 'MOVIMENTO':
            return 'label-primary';
          default:
            return 'Indefinido';
        }
      }
    }, {
      key: 'statusText',
      value: function statusText(status) {
        switch (status) {
          case 'GPS_INVALIDO':
            return this.translate.instant('ce.enum.movimentoVeiculo.gpsInvalido');
          case 'PARADO':
            return this.translate.instant('ce.enum.movimentoVeiculo.parado');
          case 'PARADO_COM_MOTOR':
            return this.translate.instant('ce.enum.movimentoVeiculo.paradoMotorLigado');
          case 'MOVIMENTO':
            return this.translate.instant('ce.enum.movimentoVeiculo.movimento');
          default:
            return this.translate.instant('ce.enum.movimentoVeiculo.indefinido');
        }
      }
    }, {
      key: 'getConsumoCellFilter',
      value: function getConsumoCellFilter() {
        return this.isConsumoEletrico ? 'decimalWithLabel:\'kWh\'' : 'decimalWithLabel:\'L\'';
      }
    }]);

    return AnaliseOpCtrl;
  }();

  angular.module('relatorios.analiseOp').controller('AnaliseOpCtrl', AnaliseOpCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.identificacoes', ['ui.router', 'angularMoment', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ProntuarioLinkModule', 'ConstantVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.identificacoes', {
      url: '/relatorios/identificacoes?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/identificacoes/identificacoes.tpl.html',
          controller: 'IdentificacoesCtrl',
          controllerAs: 'identificacoes'
        }
      },
      data: {
        titulo: 'ce.analise.identificacoes.titulo',
        roles: ['IDENTIFICACOES_VISUALIZAR']
      }
    });
  }

  angular.module('relatorios.identificacoes').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable angular/log */
(function () {
  'use strict';

  var IdentificacoesCtrl = function () {
    function IdentificacoesCtrl(ServiceVfiltro, FactoryVfiltro, Keys, moment, Authenticator, ProntuarioLinkService) {
      var _this = this;

      _classCallCheck(this, IdentificacoesCtrl);

      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.moment = moment;
      this.prontuarioLinkService = ProntuarioLinkService;
      this.authenticator = Authenticator;
      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name
      }, {
        key: this.keys.dateTime.name,
        dateLimit: 1,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        name: 'veiculosId',
        key: this.keys.veiculos.name,
        size: 6
      }, {
        name: 'motorista_id',
        key: this.keys.motoristas.name,
        size: 6
      }, {
        name: 'identificacao',
        key: this.keys.identificacao.name,
        size: 6
      }])).then(function (filtro) {
        _this.roleMotoristaEditar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('MOTORISTA_EDITAR');
        _this.roleVideoVisualizar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIDEO_VISUALIZAR');
        _this.init(filtro);
      });
      this.authenticator.getUser().then(function (user) {
        _this.validShowLinkDriverRecord = _this.prontuarioLinkService.hasRoleToViewProntuario(user);
      });
    }

    _createClass(IdentificacoesCtrl, [{
      key: 'init',
      value: function init(filtro) {
        /*eslint-disable */
        var tableIdentificacoesElement = document.querySelector('#table-identificacoes'),
            identificacaoesListElement = document.createElement('vfwc-identificacoes-list'),
            dataFiltered = filtro.find(function (f) {
          return f.key === 'dateTime';
        }),
            veiculosFiltered = filtro.find(function (f) {
          return f.key === 'veiculos';
        }),
            motoristasFiltered = filtro.find(function (f) {
          return f.key === 'motoristas';
        }),
            identificacaoFiltered = filtro.find(function (f) {
          return f.key === 'identificacao';
        }),
            veiculoIds = veiculosFiltered ? veiculosFiltered.values.map(function (veiculo) {
          return veiculo.id;
        }) : veiculosFiltered,
            motoristaIds = motoristasFiltered ? motoristasFiltered.values.map(function (motorista) {
          return motorista.id;
        }) : motoristasFiltered,
            isIdentificacao = identificacaoFiltered ? identificacaoFiltered.value.isIdentificado : null;

        identificacaoesListElement.uoId = Number(filtro.find(function (f) {
          return f.key === 'uo';
        }).value.id);
        identificacaoesListElement.dataInicio = dataFiltered.value.startDate;
        identificacaoesListElement.dataFim = dataFiltered.value.endDate;
        identificacaoesListElement.veiculoIds = veiculoIds;
        identificacaoesListElement.motoristaIds = motoristaIds;
        identificacaoesListElement.isIdentificacao = isIdentificacao;
        identificacaoesListElement.hasPermissionEditMotorista = this.roleMotoristaEditar;
        identificacaoesListElement.hasPermissionViewVideo = this.roleVideoVisualizar;
        identificacaoesListElement.enableHiperlink = this.validShowLinkDriverRecord;
        identificacaoesListElement.user = this.serviceVfiltro.factoryVfiltro.user;

        tableIdentificacoesElement.appendChild(identificacaoesListElement);
      }
    }]);

    return IdentificacoesCtrl;
  }();

  angular.module('relatorios.identificacoes').controller('IdentificacoesCtrl', IdentificacoesCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* globals moment */

  var RelatorioAgendadoService = function () {
    function RelatorioAgendadoService(FactoryVfiltro, Keys, $translate, FeaturehubJsSdk, FeatureHubConfigKeys) {
      _classCallCheck(this, RelatorioAgendadoService);

      this.factoryVfiltro = FactoryVfiltro;
      this.vfiltroKeys = Keys;
      this.translate = $translate;
      this.isTagFilterFeatureEnabled = FeaturehubJsSdk.isFeatureEnabled('LAINT49_tag_filter');
      this.isFilterEventByDriverEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FILTER_EVENT_BY_DRIVER);
      this.isBdmFeatureEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.BOLETIM_MOTORISTA_RELATORIO_AGENDADO);
    }

    _createClass(RelatorioAgendadoService, [{
      key: 'getTiposRelatoriosAgendaveis',
      value: function getTiposRelatoriosAgendaveis() {
        return Object.assign(this.getTiposRelatoriosBase(), this.isBdmFeatureEnabled ? { BOLETIM_MOTORISTA: this.getTipoBoletimMotorista() } : {});
      }
    }, {
      key: 'getTiposRelatoriosBase',
      value: function getTiposRelatoriosBase() {
        var _this = this;

        return {
          HISTORICO_ALERTA: {
            label: this.translate.instant('ce.analise.solicitacoesAgendadas.relatoriosAgendaveis.analiseDeAlertas'),
            tipo: 'HISTORICO_ALERTA',
            permissao: 'HISTORICO_ALERTA_VISUALIZAR',
            getFiltros: function getFiltros(disabled, filtroValues) {
              var isNa = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

              return _this.factoryVfiltro.get([{
                key: _this.vfiltroKeys.dateTime.name,
                maxDate: moment().endOf('day').format(),
                dateLimit: 30,
                segment: false,
                disabled: disabled,
                id: 'filtro-modal-datetime',
                defaultValues: {
                  hoje: { active: true },
                  ontem: { active: true }
                }
              }, {
                name: 'uoId',
                disabled: disabled,
                key: _this.vfiltroKeys.uo.name,
                id: 'filtro-modal-uo',
                size: 12
              }, {
                name: 'uoDonaId',
                disabled: disabled,
                key: _this.vfiltroKeys.uoParceira.name,
                id: 'filtro-modal-uo-parceira',
                size: 6
              }, {
                name: 'idEntidade',
                disabled: disabled,
                key: _this.vfiltroKeys.veiculos.name,
                ignoreValidation: true,
                checkEmpty: true,
                id: 'filtro-modal-veiculo',
                size: 6
              }].concat(_toConsumableArray(!isNa ? [{
                disabled: disabled,
                key: _this.vfiltroKeys.status.name,
                id: 'filtro-modal-status',
                size: 6
              }, {
                disabled: disabled,
                key: _this.vfiltroKeys.eventoTic.name,
                id: 'filtro-modal-eventoTic',
                size: 6
              }] : []), [{
                disabled: disabled,
                key: _this.vfiltroKeys.nivel.name,
                id: 'filtro-modal-nivel',
                size: 6
              }, {
                disabled: disabled,
                key: _this.vfiltroKeys.tipos.name,
                id: 'filtro-modal-tipos',
                size: 12
              }], _toConsumableArray(!isNa ? [{
                name: 'idUsuario',
                disabled: disabled,
                key: _this.vfiltroKeys.usuario.name,
                id: 'filtro-modal-usuario',
                size: 6
              }] : []), _toConsumableArray(_this.isTagFilterFeatureEnabled ? [{
                disabled: disabled,
                key: _this.vfiltroKeys.tags.name,
                id: 'filtro-modal-tags',
                size: 12
              }] : []), _toConsumableArray(isNa ? [{
                disabled: disabled,
                key: _this.vfiltroKeys.feedbackVideo.name,
                id: 'filtro-modal-feedbackVideo',
                size: 6
              }, {
                disabled: disabled,
                key: _this.vfiltroKeys.statusVideos.name,
                id: 'filtro-modal-statusVideos',
                size: 12
              }, {
                disabled: disabled,
                key: _this.vfiltroKeys.coaching.name,
                id: 'filtro-modal-coaching',
                size: 12
              }] : []), _toConsumableArray(isNa && _this.isFilterEventByDriverEnabled ? [{
                name: 'motoristaId',
                disabled: disabled,
                key: _this.vfiltroKeys.motorista.name,
                onlyActive: false,
                order: _this.vfiltroKeys.feedbackVideo.order + 0.5,
                id: 'filtro-modal-motorista',
                size: 6
              }] : [])), false, filtroValues);
            }
          },
          MOVIMENTO_VEICULO: {
            label: this.translate.instant('ce.analise.solicitacoesAgendadas.relatoriosAgendaveis.analiseDeMovimentoDoVeiculo'),
            tipo: 'MOVIMENTO_VEICULO',
            permissao: 'HISTORICO_CONSOLIDADO_VISUALIZAR',
            getFiltros: function getFiltros(disabled, filtroValues) {
              return _this.factoryVfiltro.get([{
                key: _this.vfiltroKeys.dateTime.name,
                maxDate: moment().endOf('day').format(),
                dateLimit: 30,
                segment: false,
                disabled: disabled,
                id: 'filtro-modal-datetime',
                defaultValues: {
                  hoje: { active: true },
                  ontem: { active: true }
                }
              }, {
                name: 'uoId',
                disabled: disabled,
                key: _this.vfiltroKeys.uo.name,
                id: 'filtro-modal-uo',
                size: 12
              }, {
                name: 'uoDonaId',
                disabled: disabled,
                key: _this.vfiltroKeys.uoParceira.name,
                id: 'filtro-modal-uo-parceira',
                size: 6
              }, {
                name: 'idEntidade',
                disabled: disabled,
                key: _this.vfiltroKeys.veiculos.name,
                ignoreValidation: true,
                checkEmpty: true,
                id: 'filtro-modal-veiculo',
                size: 6
              }, {
                name: 'motoristaIds',
                disabled: disabled,
                key: _this.vfiltroKeys.motoristas.name,
                ignoreValidation: true,
                id: 'filtro-modal-motorista',
                size: 6
              }], false, filtroValues);
            }
          },
          HISTORICO_DETALHADO: {
            label: this.translate.instant('ce.mapa.historicoDetalhado.menuLabel'),
            tipo: 'HISTORICO_DETALHADO',
            permissao: 'HISTORICO_DETALHADO_VISUALIZAR',
            getFiltros: function getFiltros(disabled, filtroValues) {
              return _this.factoryVfiltro.get([{
                key: _this.vfiltroKeys.dateTime.name,
                maxDate: moment().endOf('day').format(),
                dateLimit: 30,
                segment: false,
                disabled: disabled,
                id: 'filtro-modal-datetime',
                defaultValues: {
                  hoje: { active: true },
                  ontem: { active: true }
                }
              }, {
                name: 'uoId',
                disabled: disabled,
                key: _this.vfiltroKeys.uo.name,
                id: 'filtro-modal-uo',
                size: 12
              }, {
                name: 'uoDonaId',
                disabled: disabled,
                key: _this.vfiltroKeys.uoParceira.name,
                id: 'filtro-modal-uo-parceira',
                size: 6
              }, {
                name: 'idEntidade',
                disabled: disabled,
                key: _this.vfiltroKeys.veiculos.name,
                ignoreValidation: true,
                checkEmpty: true,
                id: 'filtro-modal-veiculo',
                size: 6
              }], false, filtroValues);
            }
          }
        };
      }
    }, {
      key: 'getTipoBoletimMotorista',
      value: function getTipoBoletimMotorista() {
        var _this2 = this;

        return {
          label: this.translate.instant('ce.analise.solicitacoesAgendadas.relatoriosAgendaveis.boletimMotorista'),
          tipo: 'BOLETIM_MOTORISTA',
          permissao: 'BOLETIM_MOTORISTA_VISUALIZAR',
          getFiltros: function getFiltros(disabled, filtroValues) {
            return _this2.factoryVfiltro.get([{
              key: _this2.vfiltroKeys.dateTime.name,
              maxDate: moment().endOf('day').format(),
              dateLimit: 1826,
              segment: false,
              disabled: disabled,
              id: 'filtro-modal-datetime',
              defaultValues: {
                hoje: { active: true },
                ontem: { active: true }
              }
            }, {
              name: 'uoId',
              disabled: disabled,
              key: _this2.vfiltroKeys.uo.name,
              id: 'filtro-modal-uo',
              size: 12
            }, {
              name: 'uoDonaId',
              disabled: disabled,
              key: _this2.vfiltroKeys.uoParceira.name,
              id: 'filtro-modal-uo-parceira',
              size: 6
            }, {
              name: 'motoristaId',
              disabled: disabled,
              key: _this2.vfiltroKeys.motorista.name,
              required: true,
              id: 'filtro-modal-motorista',
              size: 6
            }], false, filtroValues);
          }
        };
      }
    }]);

    return RelatorioAgendadoService;
  }();

  angular.module('relatorios.historicoSolicitacao').service('RelatorioAgendadoService', RelatorioAgendadoService);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.historicoSolicitacao', {
      url: '/relatorios/historico-solicitacao?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/historico-solicitacao/historico-solicitacao.tpl.html',
          controller: 'HistoricoSolicitacaoCtrl',
          controllerAs: 'historicoSolicitacao'
        }
      },
      data: {
        titulo: 'ce.analise.solicitacoesAgendadas.titulo',
        roles: ['HISTORICO_ALERTA_VISUALIZAR', 'HISTORICO_CONSOLIDADO_VISUALIZAR', 'HISTORICO_DETALHADO_VISUALIZAR']
      }
    });
  }

  angular.module('relatorios.historicoSolicitacao').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global window */
(function () {
  'use strict';

  var HistoricoSolicitacaoCtrl = function () {
    function HistoricoSolicitacaoCtrl(ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, Keys, $filter, $uibModal, HistoricoSolicitacao, v3gTableLimitService, moment, AlertMessage, StatusSolicitacao, RelatorioAgendadoService, $translate, UrlConfigService, HttpServiceV3g, TipoPermissao, FeaturehubJsSdk, FeatureHubConfigKeys, MeasurementUnitConverterService) {
      var _this = this;

      _classCallCheck(this, HistoricoSolicitacaoCtrl);

      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.filter = $filter;
      this.modalService = $uibModal;
      this.historicoSolicitacao = HistoricoSolicitacao;
      this.v3gTableLimitService = v3gTableLimitService;
      this.moment = moment;
      this.alertMessage = AlertMessage;
      this.status = StatusSolicitacao;
      this.relatorioAgendadoService = RelatorioAgendadoService;
      this.translate = $translate;
      this.urlConfigService = UrlConfigService;
      this.httpServiceV3g = HttpServiceV3g;
      this.tipoPermissao = TipoPermissao;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.isBdmFeatureEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.BOLETIM_MOTORISTA_RELATORIO_AGENDADO);

      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.currentPage = 0;
      this.relatorio = null;
      this.relatorioSafe = null;
      this.hasSolucaoRequestReport = false;
      this.permissoesSolucao = null;
      this.isNa = false;
      this.aplicarFormatoData('BRITISH');
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.roleAdminVeltec = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ADMIN_VELTEC');
        _this.serviceVfiltro.factoryVfiltro.authenticator.getUser().then(function (user) {
          _this.permissoesSolucao = user.permissoesSolucao;
          _this.aplicarPreferenciasUsuario(user);
          _this.hasSolucaoRequestReport = user.permissoesSolucao.includes('HISTORICO_ALERTA_VISUALIZAR') || user.permissoesSolucao.includes('HISTORICO_CONSOLIDADO_VISUALIZAR') || user.permissoesSolucao.includes('HISTORICO_DETALHADO_VISUALIZAR') || _this.isBdmFeatureEnabled && user.permissoesSolucao.includes('BOLETIM_MOTORISTA_VISUALIZAR');
          _this.consultar(_this.getPage());
        });
      });
    }

    _createClass(HistoricoSolicitacaoCtrl, [{
      key: 'aplicarPreferenciasUsuario',
      value: function aplicarPreferenciasUsuario(user) {
        this.isNa = Boolean(user.isNa);
        this.aplicarFormatoData(user.measurementUnits && user.measurementUnits.dateTimeFormat || 'BRITISH');
      }
    }, {
      key: 'aplicarFormatoData',
      value: function aplicarFormatoData(dateTimeFormat) {
        this.formatoData = this.measurementUnitConverterService.getDateFormat(dateTimeFormat);
        this.formatoDiaMes = dateTimeFormat === 'AMERICAN' ? 'MM/DD' : 'DD/MM';
      }
    }, {
      key: 'getPage',
      value: function getPage() {
        if (angular.isDefined(this.tableState) && this.tableState !== null) {
          if (isNaN(this.tableState.pagination.number)) {
            this.tableState.pagination.number = 1;
          }
          return Math.floor(this.tableState.pagination.start / this.tableState.pagination.number) + 1;
        }
        return this.currentPage;
      }
    }, {
      key: 'consultar',
      value: function consultar(currentPage) {
        var _this2 = this;

        if (this.tableState && this.tableState.pagination) {
          angular.extend(this.tableState.pagination, this.v3gTableLimitService.init(this.serviceVfiltro.factoryVfiltro.user));
          this.objetosVfiltroService.setTableStateUrl(this.tableState, true);
        }

        var tipos = new Set();

        Object.keys(this.tipoPermissao).forEach(function (key) {
          if (_this2.permissoesSolucao.includes(key)) {
            tipos.add(_this2.tipoPermissao[key]);
          }
        });

        if (this.isBdmFeatureEnabled && this.permissoesSolucao.includes('BOLETIM_MOTORISTA_VISUALIZAR')) {
          tipos.add('BOLETIM_MOTORISTA');
        }

        this.historicoSolicitacao.one().get({
          inicio: this.moment().subtract(30, 'days').endOf('day').format(),
          fim: this.moment().endOf('day').format(),
          uoId: this.serviceVfiltro.factoryVfiltro.user.uo.id,
          tipos: Array.from(tipos)
        }).then(function (data) {
          return _this2.setInfoTable(data, currentPage);
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data, currentPage) {
        var _this3 = this;

        this.relatorioTable = this.filter('orderBy')(data.map(function (item) {
          var progresso = '-';
          switch (item.status) {
            case _this3.status.PROCESSANDO.id:
              if (item.quantidadePartes > 0 && item.currentPart !== null && angular.isDefined(item.currentPart)) {
                var quantidadePendente = item.quantidadePartes - item.currentPart;
                progresso = _this3.filter('number')(quantidadePendente / item.quantidadePartes * 100, 2) + '%';
              } else if (item.quantidadePartes > 0 && !item.currentPart) {
                progresso = '0,00%';
              }
              break;
            case _this3.status.CONCLUIDO.id:
              progresso = '100%';
              break;
            default:
              progresso = '-';
          }

          return Object.assign({}, item, _this3.setStatus(item), { nomeRelatorio: _this3.getRelatorioLabel(item.filtro.type), progresso: progresso });
        }), ['status.ordem', '-id']);
        this.relatorio = this.relatorioTable;
        if (angular.isDefined(currentPage)) {
          this.currentPage = currentPage;
        }
      }
    }, {
      key: 'setTableState',
      value: function setTableState(tableState) {
        if (this.$parent.historicoSolicitacao.tableState !== null) {
          tableState.sort = this.$parent.historicoSolicitacao.tableState.sort;
        }
        this.$parent.historicoSolicitacao.tableState = tableState;
      }
    }, {
      key: 'getPeriodo',
      value: function getPeriodo(solicitacao) {
        var inicio = this.moment(solicitacao.filtro.inicio),
            fim = this.moment(solicitacao.filtro.fim);
        var formato = this.formatoData.toUpperCase();
        return inicio.format(formato) + ' - ' + fim.format(formato);
      }
    }, {
      key: 'setStatus',
      value: function setStatus(solicitacao) {
        return { status: this.status[solicitacao.status] || { id: 'N/A', class: '', label: 'N/A', ordem: 5 } };
      }
    }, {
      key: 'getRelatorioLabel',
      value: function getRelatorioLabel(tipoRelatorio) {
        if (!this.labelsPorTipoRelatorio) {
          this.labelsPorTipoRelatorio = Object.values(this.relatorioAgendadoService.getTiposRelatoriosAgendaveis()).reduce(function (acc, atual) {
            return Object.assign(acc, _defineProperty({}, atual.tipo, atual.label));
          }, {});
        }
        return this.labelsPorTipoRelatorio[tipoRelatorio];
      }
    }, {
      key: 'download',
      value: function download(solicitacao) {
        if (solicitacao.link) {
          this.httpServiceV3g.get('/relatorios-agendado/historico-requisicoes/download/' + solicitacao.id).then(function (response) {
            window.open(response.data.url, '_blank'); // eslint-disable-line
          });
        }
      }
    }, {
      key: 'isExpirado',
      value: function isExpirado(solicitacao) {
        return solicitacao.status.id === this.status.CONCLUIDO.id && this.moment(solicitacao.dataExpiracao).isSameOrBefore(this.moment());
      }
    }, {
      key: 'isCancelavel',
      value: function isCancelavel(solicitacao) {
        return !this.isExpirado(solicitacao) && (solicitacao.status.id === this.status.PROCESSANDO.id || solicitacao.status.id === this.status.AGUARDANDO.id);
      }
    }, {
      key: 'exibirColunaAcoes',
      value: function exibirColunaAcoes() {
        var _this4 = this;

        return !this.isNa || (this.relatorioTable || []).some(function (solicitacao) {
          return _this4.isCancelavel(solicitacao);
        });
      }
    }, {
      key: 'atualizarStatus',
      value: function atualizarStatus(relatorio, solicitacao) {
        var _this5 = this;

        return relatorio.map(function (x) {
          if (x.id === solicitacao.id) {
            x.status = _this5.status.CANCELADO;
          }
          return x;
        });
      }
    }, {
      key: 'atualizarTable',
      value: function atualizarTable(solicitacao, remover) {
        var msg = this.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.cadastradaComSucesso');
        if (remover) {
          this.relatorioTable = this.atualizarStatus(this.relatorioTable, solicitacao);
          this.relatorio = this.atualizarStatus(this.relatorio, solicitacao);
          msg = this.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.canceladaComSucesso');
        } else {
          this.consultar(this.getPage());
        }
        this.alertMessage.create({
          type: 'success',
          message: msg,
          appendTo: '.alerta-aqui'
        });
      }
    }, {
      key: 'getWarningMessage',
      value: function getWarningMessage() {
        var msgPrefix = this.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.prefixWarning'),
            maxDate = this.getMaxDate(),
            msgSuffix = this.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.suffixWarning');
        return msgPrefix + ' ' + maxDate + ' ' + msgSuffix;
      }
    }, {
      key: 'modalFiltro',
      value: function modalFiltro() {
        var filtro = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var _this6 = this;

        var _somenteVisualizacao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _tipoRelatorio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        this.modalService.open({
          animation: true,
          component: 'modalCadastrarSolicitacao',
          size: 'custom-size',
          backdropClass: 'cadastro-solicitacao-modal-backdrop',
          resolve: {
            filtroValues: function filtroValues() {
              return filtro || { uoId: _this6.serviceVfiltro.factoryVfiltro.user.uo.id };
            },
            somenteVisualizacao: function somenteVisualizacao() {
              return _somenteVisualizacao;
            },
            tipoRelatorio: function tipoRelatorio() {
              return _tipoRelatorio;
            }
          }
        }).result.then(function (solicitacao) {
          return _this6.atualizarTable(solicitacao, false);
        });
      }
    }, {
      key: 'modalCancelar',
      value: function modalCancelar(_solicitacao) {
        var _this7 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'relatorios/historico-solicitacao/cancelar/cancelar-solicitacao.tpl.html',
          controller: 'CancelarSolicitacaoCtrl',
          controllerAs: '$ctrl',
          size: 'md',
          resolve: {
            solicitacao: function solicitacao() {
              return _solicitacao;
            }
          }
        }).result.then(function (cancelado) {
          if (cancelado) {
            _this7.atualizarTable(_solicitacao, true);
          } else {
            _this7.consultar(_this7.getPage());
            _this7.alertMessage.create({
              type: 'warning',
              message: _this7.translate.instant('ce.analise.solicitacoesAgendadas.mensagem.erroParaCancelarSolicitacao'),
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'getMaxDate',
      value: function getMaxDate() {
        return this.moment().subtract(30, 'days').endOf('day').format(this.formatoDiaMes);
      }
    }]);

    return HistoricoSolicitacaoCtrl;
  }();

  angular.module('relatorios.historicoSolicitacao').controller('HistoricoSolicitacaoCtrl', HistoricoSolicitacaoCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.ocorrencia', ['ui.router', 'httpServiceV3gModule', 'enumModule', 'ServiceVfiltroModule', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'pascalprecht.translate', 'FeatureFlagModule', 'urlConfigModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.ocorrencia', {
      url: '/relatorios/historico-ocorrencia?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/historico-ocorrencia/historico-ocorrencia.tpl.html',
          controller: 'HistoricoOcorrenciaCtrl',
          controllerAs: 'historicoOcorrencia'
        }
      },
      data: {
        titulo: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.titulo',
        role: 'OCORRENCIA_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.ocorrencia').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global Intl, _, Blob*/

  var HistoricoOcorrenciaCtrl = function () {
    function HistoricoOcorrenciaCtrl($window, $httpParamSerializer, $filter, Authenticator, HttpServiceV3g, ServiceVfiltro, ObjetosVfiltroService, FactoryVfiltro, Keys, VtabelaFactory, uiGridConstants, OcorrenciasEnum, $translate, UrlConfigService, AlertasEnum, FeatureFlag, MeasurementUnitConverterService, FeatureOuService) {
      var _this = this;

      _classCallCheck(this, HistoricoOcorrenciaCtrl);

      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.window = $window;
      this.httpService = HttpServiceV3g;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.httpParamSerializer = $httpParamSerializer;
      this.filter = $filter;
      this.STATUS_OCORRENCIA = OcorrenciasEnum;
      this.timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.translate = $translate;
      this.urlConfigService = UrlConfigService;
      this.alertasEnum = AlertasEnum;
      this.featureFlag = FeatureFlag;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.FeatureOuService = FeatureOuService;

      this.FIELDS = ['id', 'uoId', 'dataHora', 'status', 'veiculo.id', 'veiculo.placa', 'veiculo.prefixo', 'veiculo.uo.nome', 'veiculo.uoId', 'motorista.id', 'motorista.nome', 'motorista.apelido', 'motorista.documentoIdentificador', 'motorista.cpf', 'motorista.uoId', 'motorista.uo.nome', 'comentario', 'usuarioIdAtribuido', 'ultimoUsuarioAtribuiuTratativa', 'ultimoUsuarioRecebeuTratativa', 'ultimoUsuarioResolveu', 'usuario.login', 'usuario.id', 'dataHoraTratativa', 'dataHoraFinalizacao', 'alertasGerados', 'anexo'];

      this.vtabela = null;
      this.exportsPdf = false;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        required: true,
        dateLimit: 30,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uoId',
        required: true,
        key: this.keys.uo.name,
        size: 12
      }, {
        name: 'motoristaIds',
        key: this.keys.motoristas.name,
        size: 12
      }])).then(function (filtro) {
        _this.filtro = filtro;

        _this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.userPreferredDateFormat = user.measurementUnits && user.measurementUnits.dateTimeFormat || 'BRITISH';
          _this.dateFormat = _this.measurementUnitConverterService.getDateFormat(_this.userPreferredDateFormat);
          _this.FeatureOuService.getVehicleTableConfig(user.uo.id).then(function (isNaUser) {
            _this.isNaUser = isNaUser;
            var tableKey = _this.isNaUser ? 'relatorioOcorrencia_NA' : 'relatorioOcorrencia';
            _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, tableKey, 'v4');
            _this.consultar();
          });
        });
      });
    }

    _createClass(HistoricoOcorrenciaCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        var objVtabela = {
          appScopeProvider: this,
          exportsPdf: this.featureFlag.EXPORTAR_PDF_HISTORICO_OCORRENCIAS,
          enableRowSelection: this.featureFlag.EXPORTAR_PDF_HISTORICO_OCORRENCIAS,
          enableRowHeaderSelection: this.featureFlag.EXPORTAR_PDF_HISTORICO_OCORRENCIAS,
          multiSelect: this.featureFlag.EXPORTAR_PDF_HISTORICO_OCORRENCIAS,
          enableSelectAll: this.featureFlag.EXPORTAR_PDF_HISTORICO_OCORRENCIAS,
          exportsPdfDisabledFn: this.handleDisableExportPdf,
          exportsPdfDisabledTooltipFn: this.handleDisableTooltipExportPdf,
          exportsPdfClickFn: function exportsPdfClickFn(data) {
            return _this2.handlClickExportPdf(data, _this2.getParams());
          },
          isRowSelectable: function isRowSelectable(e) {
            return !!e.entity.motorista;
          },
          emptyMessage: this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.emptyMessage.mensagem') + ' <strong>' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.emptyMessage.dataFiltrada') + '</strong>',
          columnDefs: [{
            name: 'motorista',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.motorista',
            type: 'string',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'ce.tempoReal.quadroDeOcorrencias.common.semIdentificacao\' | translate | splitComposedLabels:true',
            headerCellFilter: 'translate',
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\'>\n                    <motorista-link\n                      motorista=\'row.entity.motorista\'\n                      motorista-id=\'row.entity.motoristaId\'\n                      has-permission=\'true\'\n                      index=\'$index\'>\n                    </motorista-link>\n                  </div>\n                '
          }, {
            name: 'apelido',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.apelido',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'documentoIdentificador',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.documentoIdentificador',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate',
            visible: !this.isNaUser
          }, {
            name: 'motoristaUo',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.uoMotorista',
            enableHiding: false,
            filterCellFiltered: true,
            headerCellFilter: 'translate'
          }, {
            name: 'veiculo',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.veiculo',
            enableHiding: false,
            filterCellFiltered: true,
            headerCellFilter: 'translate'
          }, {
            name: 'veiculoUo',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.uoVeiculo',
            enableHiding: false,
            filterCellFiltered: true,
            headerCellFilter: 'translate'
          }, {
            name: 'status',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.status',
            filterCellFiltered: true,
            headerCellFilter: 'translate'
          }, {
            name: 'dataHora',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.dataHora',
            type: 'date',
            filterCellFiltered: true,
            cellFilter: 'date:\'' + this.dateFormat + ' HH:mm\' | withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'atribuido',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.atribuido',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'comentario',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.comentario',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'dataHoraTratativa',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.datahoraTratativa',
            type: 'date',
            filterCellFiltered: true,
            cellFilter: 'date:\'' + this.dateFormat + ' HH:mm\' | withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'ultimoUsuarioAtribuiuTratativa',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.ultimoUsuarioAtribuiuTratativa',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'ultimoUsuarioRecebeuTratativa',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.ultimoUsuarioRecebeuTratativa',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'dataHoraResolvida',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.datahoraResolvida',
            type: 'date',
            filterCellFiltered: true,
            cellFilter: 'date:\'' + this.dateFormat + ' HH:mm\' | withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'ultimoUsuarioResolveu',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.ultimoUsuarioResolveu',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'alertasGerados',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.alertas',
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerCellFilter: 'translate'
          }, {
            name: 'anexos',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.anexos',
            filterCellFiltered: true,
            headerCellFilter: 'translate',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: true, label: this.translate.instant('common.sim') }, { value: false, label: this.translate.instant('common.nao') }]
            },
            cellTemplate: '\n                <div class="ui-grid-cell-contents">\n                  <div ng-if=\'row.entity.anexos\' class=\'anexo-div\'>\n                    <span class="material-icons icon-anexo">\n                      attach_file\n                    </span>\n                    <span>{{ \'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.possuiAnexos\' | translate }}</span>\n                  </div>\n                </div>'
          }, {
            name: 'detalhe',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            cellTemplate: '\n                <div class="ui-grid-cell-contents vtabela-icone-detalhado">\n                  <a\n                    id=\'occurrences-history-detail-btn-{{$index}}\'\n                    class=\'occurrences-history-detail-btn\'\n                    ng-href=\'{{grid.appScope.goToHistOcorrenciaDetalhe(row.entity.id, row.entity.dataHora)}}\'>\n                    <span class="glyphicon glyphicon-zoom-in" aria-hidden=\'true\'></span>\n                  </a>\n                </div>'
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.id,
          veiculo: this.filter('prefixoPlaca')(item.veiculo),
          veiculoUo: item.veiculo.uo.nome,
          veiculoId: item.veiculo.id,
          motorista: item.motorista ? item.motorista.nome : null,
          apelido: item.motorista ? item.motorista.apelido : null,
          documentoIdentificador: item.motorista ? item.motorista.cpf || item.motorista.documentoIdentificador : null,
          motoristaId: item.motorista ? item.motorista.id : null,
          motoristaUo: item.motorista ? item.motorista.uo.nome : null,
          status: this.translate.instant(this.STATUS_OCORRENCIA[item.status].descricao),
          dataHora: item.dataHora,
          atribuido: item.usuarioAtribuido ? item.usuarioAtribuido.login : null,
          comentario: item.comentario,
          dataHoraTratativa: item.dataHoraTratativa,
          ultimoUsuarioAtribuiuTratativa: item.ultimoUsuarioAtribuiuTratativa ? item.ultimoUsuarioAtribuiuTratativa.login : null,
          ultimoUsuarioRecebeuTratativa: item.ultimoUsuarioRecebeuTratativa ? item.ultimoUsuarioRecebeuTratativa.login : null,
          dataHoraResolvida: item.dataHoraFinalizacao,
          ultimoUsuarioResolveu: item.ultimoUsuarioResolveu ? item.ultimoUsuarioResolveu.login : null,
          alertasGerados: this.getItemTabelaAlertas(item.alertasGerados),
          anexos: item.qtdAnexos ? item.qtdAnexos > 0 : false
        };
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this3 = this;

        this.httpService.get('/alerta/ocorrencias?' + this.httpParamSerializer(angular.extend(this.getParams(), { fields: this.isNaUser ? this.FIELDS.filter(function (f) {
            return !['motorista.documentoIdentificador', 'motorista.cpf'].includes(f);
          }).join() : this.FIELDS.join() }))).then(function (response) {
          return _this3.setInfoTable(response.data);
        }).catch(function () {
          return _this3.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this4 = this;

        this.vtabela.setData(data.map(function (row) {
          return _this4.getItemVtabela(row);
        }));
      }
    }, {
      key: 'handleDisableTooltipExportPdf',
      value: function handleDisableTooltipExportPdf(data) {
        var pdfMessage = 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.pdfMessage.';

        if (data) {
          if (data.length > 10) {
            return pdfMessage + 'max10Ocorrencia';
          }

          if (!data.every(function (item) {
            return item.motorista === data[0].motorista;
          })) {
            return pdfMessage + 'differentMotorista';
          }
        }
        return pdfMessage + 'empty';
      }
    }, {
      key: 'handleDisableExportPdf',
      value: function handleDisableExportPdf(data) {
        if (data) {
          var noneSelected = !data.length,
              moreThan10 = data.length > 10,
              differentMotorista = !data.every(function (item) {
            return item.motorista === data[0].motorista;
          });

          return noneSelected || moreThan10 || differentMotorista;
        }
        return true;
      }
    }, {
      key: 'handlClickExportPdf',
      value: function handlClickExportPdf(data, params) {
        var extractUniqueIds = function extractUniqueIds(items, key) {
          return [].concat(_toConsumableArray(new Set(items.map(function (item) {
            return item[key];
          }))));
        },
            driverIds = extractUniqueIds(data, 'motoristaId'),
            vehiclesIds = extractUniqueIds(data, 'veiculoId'),
            occurrenceIds = extractUniqueIds(data, 'id'),
            timezone = this.timezone,
            paramsPdf = {
          start: params.inicio,
          end: params.fim,
          uoId: params.uoId,
          driverIds: driverIds,
          vehiclesIds: vehiclesIds,
          occurrenceIds: occurrenceIds,
          timezone: timezone
        },
            httpParams = this.httpParamSerializer(paramsPdf);

        this.downloadPdf(httpParams);
      }
    }, {
      key: 'downloadPdf',
      value: function downloadPdf(httpParams) {
        var _this5 = this;

        this.httpService.get('/alerta/ocorrencias/pdf?' + httpParams, { responseType: 'blob' }).then(function (result) {
          var contentDispositionHeader = result.headers('content-disposition'),
              fileName = contentDispositionHeader ? contentDispositionHeader.split('filename=')[1] : undefined,
              anchor = angular.element('<a/>'),
              file = new Blob([result.data], { type: 'application/pdf' }),
              pdfBrowserUrl = _this5.window.URL.createObjectURL(file);
          anchor.attr({
            href: pdfBrowserUrl,
            target: '_blank',
            download: fileName ? fileName : 'export.pdf'
          })[0].click();
          _this5.window.URL.revokeObjectURL(pdfBrowserUrl);
        });
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return this.serviceVfiltro.getFiltroBackendNovo(this.filtro);
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/alerta/ocorrencias/csv?' + this.httpParamSerializer(angular.extend(this.getParams(), { timezone: this.timezone }));
      }
    }, {
      key: 'goToHistOcorrenciaDetalhe',
      value: function goToHistOcorrenciaDetalhe(id, dia) {
        return '/relatorios/ocorrencia-detalhes/' + id + '/' + dia;
      }
    }, {
      key: 'getItemTabelaAlertas',
      value: function getItemTabelaAlertas(alertasOcorrencias) {
        var _this6 = this;

        if (alertasOcorrencias && alertasOcorrencias.length) {
          return _(alertasOcorrencias).map(function (alerta) {
            return {
              tipo: _this6.translate.instant(_this6.alertasEnum.getAlerta(alerta.tipo).descricao),
              quantidade: alerta.quantidade
            };
          }).sortBy('tipo').groupBy('tipo').map(function (alertas, tipo) {
            return tipo + ': ' + alertas.reduce(function (acc, alerta) {
              return acc + alerta.quantidade;
            }, 0);
          }).value().join(', ');
        }
        return undefined;
      }
    }]);

    return HistoricoOcorrenciaCtrl;
  }();

  angular.module('relatorios.ocorrencia').controller('HistoricoOcorrenciaCtrl', HistoricoOcorrenciaCtrl);
})();
'use strict';

(function () {
  'use strict';

  var fields = ['veiculo.placa', 'veiculo.prefixo', 'login', 'comando.nome', 'dataHoraCriacao', 'dataHoraConfirmacao', 'status'],
      HIST_COMANDO_URL = '/comando/historicos';

  angular.module('relatorios.historicoComando', ['ui.router', 'restangular', 'angularMoment', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'ConstantVfiltroModule', 'VtabelaModule', 'pascalprecht.translate', 'urlConfigModule']).factory('HistoricoComando', function (Restangular) {
    return Restangular.one(HIST_COMANDO_URL + ('?fields=' + fields.join()));
  }).constant('StatusComandoEnum', {
    AGUARDANDO_ENVIO: 'ce.enum.statusComando.aguardandoEnvio',
    AGUARDANDO_CONFIRMACAO: 'ce.enum.statusComando.aguardandoConfirmacao',
    CONFIRMADO: 'ce.enum.statusComando.confirmado',
    CANCELADO: 'ce.enum.statusComando.cancelado',
    DOWNLOAD_SOLICITADO: 'ce.enum.statusComando.downloadSolicitado',
    NAO_MAPEADO: 'ce.enum.statusComando.naoMapeado'
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.historicoComando', {
      url: '/relatorios/historico-comando?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/historico-comando/historico-comando.tpl.html',
          controller: 'HistoricoComandoCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.mapa.localizacaoDaFrota.historicoComando.titulo',
        role: 'COMANDO_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.historicoComando').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global Intl */

  var HistoricoComandoCtrl = function () {
    function HistoricoComandoCtrl(HistoricoComando, $httpParamSerializer, $filter, moment, ServiceVfiltro, ObjetosVfiltroService, FactoryVfiltro, Keys, VtabelaFactory, uiGridConstants, StatusComandoEnum, $translate, UrlConfigService) {
      var _this = this;

      _classCallCheck(this, HistoricoComandoCtrl);

      this.historicoComandoService = HistoricoComando;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.moment = moment;
      this.httpParamSerializer = $httpParamSerializer;
      this.filter = $filter;
      this.statusComando = StatusComandoEnum;
      this.timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.translate = $translate;
      this.urlConfigService = UrlConfigService;

      this.vtabela = null;
      this.exportsPdf = false;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        dateLimit: 1,
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          }
        }
      }, {
        name: 'uoId',
        key: this.keys.uo.name,
        size: 12
      }, {
        name: 'veiculoIds',
        required: true,
        key: this.keys.veiculos.name,
        size: 12
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.user = _this.serviceVfiltro.factoryVfiltro.user;
        _this.consultar();
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'historicoComando', 'v1');
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = true;
      });
    }

    _createClass(HistoricoComandoCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'veiculo',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.veiculo',
            type: 'string',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'usuario',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.usuario',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'Sem identificação\' | splitComposedLabels:true'
          }, {
            name: 'comando',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.comando',
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'dataEnvio',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.dataHoraEnvio',
            type: 'date',
            filterCellFiltered: true,
            cellFilter: 'date:\'dd/MM/yyyy HH:mm\''
          }, {
            name: 'dataConfirmacao',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.dataHoraConfirmacao',
            type: 'date',
            filterCellFiltered: true,
            cellFilter: 'date:\'dd/MM/yyyy HH:mm\' | withLabelToUndefined:\'-\''
          }, {
            name: 'status',
            displayName: 'ce.mapa.localizacaoDaFrota.historicoComando.colunas.status',
            type: 'date',
            filterCellFiltered: true
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          veiculo: this.filter('prefixoPlaca')(item.veiculo),
          usuario: item.login,
          comando: item.comando.nome,
          dataEnvio: item.dataHoraCriacao,
          dataConfirmacao: item.dataHoraConfirmacao,
          status: this.translate.instant(this.statusComando[item.statusDescricao])
        };
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this2 = this;

        this.historicoComandoService.get(this.serviceVfiltro.getFiltroBackendNovo(this.filtro)).then(function (data) {
          return _this2.setInfoTable(data);
        }).catch(function () {
          return _this2.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this3 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this3.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return this.serviceVfiltro.getFiltroBackendNovo(this.filtro);
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/comando/historicos/csv?timezone=' + this.timezone + '&' + this.httpParamSerializer(this.getParams());
      }
    }]);

    return HistoricoComandoCtrl;
  }();

  angular.module('relatorios.historicoComando').controller('HistoricoComandoCtrl', HistoricoComandoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.deviceHealth
   * @description
   *
   */

  angular.module('relatorios.deviceHealth', ['ui.router', 'restangular', 'angularMoment', 'FeatureFlagModule', 'FeatureOuModule', 'pascalprecht.translate', 'ServiceVfiltroModule', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'UrlModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.deviceHealth').config(configDeviceHealth).config(configVehicleHealth);

  function configDeviceHealth($stateProvider) {
    $stateProvider.state('root.device-health', {
      url: '/tempo-real/device-health?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/device-health/device-health.tpl.html',
          controller: 'DeviceHealthCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.deviceHealth.menuLabel',
        roles: [['SAUDE_DO_EQUIPAMENTO']],
        hideTitulo: true
      }
    });
  }

  function configVehicleHealth($stateProvider) {
    $stateProvider.state('root.vehicle-health', {
      url: '/tempo-real/vehicle-health?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/device-health/device-health.tpl.html',
          controller: 'DeviceHealthCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.vehicleHealth.menuLabel',
        roles: [['SAUDE_DO_EQUIPAMENTO']],
        hideTitulo: true
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DeviceHealthCtrl = function () {
    function DeviceHealthCtrl($safetyService, $window, Authenticator, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, $state, Keys, ServiceVfiltro, FactoryVfiltro, $translate, UrlService) {
      var _this = this;

      _classCallCheck(this, DeviceHealthCtrl);

      this.window = $window;
      this.safetyService = $safetyService;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.user = {};
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.state = $state;
      this.isFeatureFlagDeviceHealthPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_PAGE);
      this.isFeatureTelematicsTableEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_TELEMATICS_TABLE);
      this.isFeatureHideTitleEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ORION_HIDE_TITLE);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.urlService = UrlService;
      this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
      if (this.isFeatureHideTitleEnabled && this.queryParams.hideTitle === 'true') {
        this.hideTitle = true;
      } else {
        this.hideTitle = false;
      }
      this.authenticator.getUser().then(function (user) {
        _this.user = user;

        ServiceVfiltro.init(FactoryVfiltro.get(_this.handleGetVFiltro())).then(function (filtro) {
          _this.filtro = filtro;
          _this.initializePage(_this.serviceVfiltro.getFiltroBackendNovo(_this.filtro));
        });
      });
    }

    _createClass(DeviceHealthCtrl, [{
      key: 'handleGetVFiltro',
      value: function handleGetVFiltro() {
        if (!this.user.isNa && this.isFeatureTelematicsTableEnabled) {
          return [{
            name: 'uoId',
            required: true,
            key: this.keys.uo.name,
            size: 12
          }, {
            name: 'mainSemaphoreStatus',
            required: false,
            key: this.keys.vehicleHealthStatus.name,
            size: 6
          }];
        }
        return [{
          name: 'uoId',
          required: true,
          key: this.keys.uo.name,
          size: 12
        }, {
          name: 'vehiclesWithDevices',
          required: false,
          key: this.keys.vehiclesWithDevices.name,
          size: 6,
          order: 5
        }, {
          name: 'deviceHealthStatus',
          required: false,
          key: this.keys.deviceHealthStatus.name,
          size: 6
        }, {
          name: 'sdCardStatus',
          required: false,
          key: this.keys.sdCardStatus.name,
          size: 6
        }, {
          name: 'cameraDiagnostics',
          required: false,
          key: this.keys.cameraDiagnostics.name,
          size: 6
        }];
      }
    }, {
      key: 'initializePage',
      value: function initializePage(filter) {
        var _this2 = this;

        this.safetyService.initialize().then(function () {
          return _this2.loadPage(filter);
        });
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter) {
        var appName = 'safetyApp',
            componentPath = './DeviceHealthPageRoute',
            componentId = 'safety-app-device-health';

        this.safetyService.loadReactComponent(appName, componentPath, componentId, { user: this.user, filter: filter, hideTitle: this.hideTitle });
      }
    }]);

    return DeviceHealthCtrl;
  }();

  DeviceHealthCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', '$state', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$translate', 'UrlService'];
  angular.module('relatorios.deviceHealth').controller('DeviceHealthCtrl', DeviceHealthCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.coaching
   * @description
   *
   */

  angular.module('relatorios.coaching', ['ui.router', 'restangular', 'angularMoment', 'FeatureFlagModule', 'FeatureOuModule', 'pascalprecht.translate', 'ServiceVfiltroModule', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'UrlModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.coaching').config(configCoaching);

  function configCoaching($stateProvider) {
    $stateProvider.state('root.coaching', {
      url: '/tempo-real/coaching?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/coaching/coaching.tpl.html',
          controller: 'CoachingCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.coaching.menuLabel',
        roles: [['COACHING_PAGE_VISUALIZAR']],
        hideTitle: true
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-var */
(function () {
  'use strict';

  var CoachingCtrl = function () {
    function CoachingCtrl($safetyService, $window, Authenticator, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, $state, Keys, ServiceVfiltro, FactoryVfiltro, $translate, UrlService, ProntuarioLinkService) {
      var _this = this;

      _classCallCheck(this, CoachingCtrl);

      this.window = $window;
      this.safetyService = $safetyService;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.user = {};
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.state = $state;
      this.isFeatureFlagCoachingPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.COACHING_PAGE);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.urlService = UrlService;
      this.prontuarioLinkService = ProntuarioLinkService;
      this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
      this.authenticator.getUser().then(function (user) {
        _this.user = user;

        ServiceVfiltro.init(FactoryVfiltro.get([{
          key: _this.keys.uo.name
        }])).then(function (filtro) {
          _this.filtro = filtro;
          _this.initializePage(_this.serviceVfiltro.getFiltroBackendNovo(_this.filtro));
        });
      });
    }

    _createClass(CoachingCtrl, [{
      key: 'redirectToRankingMotoristas',
      value: function redirectToRankingMotoristas() {
        var url = this.state.href('root.rankingPontos', {
          vfiltro: 'dateTime:mesAtual;uo:' + this.user.uo.id,
          vtabela: 'currentPage:1;pageSize:150'
        });
        this.window.open(url, '_blank');
      }
    }, {
      key: 'redirectToVehicleRegistration',
      value: function redirectToVehicleRegistration() {
        var url = this.state.href('root.veiculo', {
          vfiltro: 'uo:' + this.user.uo.id,
          vtabela: 'currentPage:1;pageSize:150'
        });
        this.window.open(url, '_blank');
      }
    }, {
      key: 'formatDateWithTemplate',
      value: function formatDateWithTemplate(date) {
        var formatString = 'YYYY.MM.DD.hh.mm.ss.zz';
        var map = {
          YYYY: date.getFullYear(),
          MM: String(date.getMonth() + 1).padStart(2, '0'),
          DD: String(date.getDate()).padStart(2, '0'),
          hh: String(date.getHours()).padStart(2, '0'),
          mm: String(date.getMinutes()).padStart(2, '0'),
          ss: String(date.getSeconds()).padStart(2, '0')
        };
        formatString = formatString.replace(/YYYY|MM|DD|hh|mm|ss/g, function (match) {
          return map[match];
        });

        var tzOffset = date.getTimezoneOffset();
        var offsetSign = tzOffset > 0 ? '-' : '+';
        var offsetHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, '0');
        var offsetMinutes = String(Math.abs(tzOffset) % 60).padStart(2, '0');
        formatString = formatString.replace('zz', '' + offsetSign + offsetHours + offsetMinutes);
        return formatString;
      }
    }, {
      key: 'redirectToProntuario',
      value: function redirectToProntuario(motoristaId) {
        var now = new Date();
        var startRange = void 0;
        var endRange = void 0;

        if (now.getDate() === 1) {
          startRange = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          endRange = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        } else {
          startRange = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
          endRange = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
        }

        var dateTime = this.formatDateWithTemplate(startRange) + ',' + this.formatDateWithTemplate(endRange) + ',personalizado';
        var url = this.state.href('root.prontuarioV2', {
          vfiltro: this.keys.uo.name + ':' + this.user.uo.id + ';' + this.keys.dateTime.name + ':' + dateTime + ';' + this.keys.motorista.name + ':' + motoristaId
        });

        this.window.open(url, '_blank');
      }
    }, {
      key: 'initializePage',
      value: function initializePage(filter) {
        var _this2 = this;

        this.safetyService.initialize().then(function () {
          return _this2.loadPage(filter);
        });
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter) {
        var appName = 'safetyApp',
            componentPath = './CoachingPageRoute',
            componentId = 'safety-app-coaching',
            props = {
          user: this.user,
          filter: filter,
          hideTitle: this.hideTitle,
          onRedirectToRanking: this.redirectToRankingMotoristas.bind(this),
          onRedirectToProntuario: this.redirectToProntuario.bind(this),
          onRedirectToVehicleRegistration: this.redirectToVehicleRegistration.bind(this)
        };

        this.window.redirectToRankingMotoristas = this.redirectToRankingMotoristas.bind(this);
        this.window.redirectToProntuario = this.redirectToProntuario.bind(this);
        this.window.redirectToVehicleRegistration = this.redirectToVehicleRegistration.bind(this);

        if (this.isFeatureFlagCoachingPageEnabled) {
          this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        }
      }
    }]);

    return CoachingCtrl;
  }();

  CoachingCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', '$state', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$translate', 'UrlService'];
  angular.module('relatorios.coaching').controller('CoachingCtrl', CoachingCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.bdv', {
      url: '/relatorios/bdv?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/bdv/bdv.tpl.html',
          controller: 'BdvCtrl',
          controllerAs: 'bdv'
        }
      },
      data: {
        titulo: 'ce.boletim.diarioVeiculo.titulo',
        tituloDescricao: 'ce.boletim.diarioVeiculo.tituloDescricao',
        role: 'BOLETIM_VEICULO_VISUALIZAR'
      }
    }).state('root.bdvDetalhes', {
      url: '/relatorios/bdv/detalhes/:veiculoId/:dia',
      views: {
        'content@': {
          templateUrl: 'relatorios/bdv/bdv-detalhes/bdv-detalhes.tpl.html',
          controller: 'BdvDetalhesCtrl',
          controllerAs: 'bdvDetalhes'
        }
      },
      data: {
        titulo: 'ce.boletim.diarioVeiculoDetalhes.titulo',
        tituloDescricao: 'ce.boletim.diarioVeiculoDetalhes.tituloDescricao',
        backButton: true,
        backState: 'root.bdv',
        role: 'BOLETIM_VEICULO_VISUALIZAR'
      }
    }).state('root.bdvChecklist', {
      url: '/relatorios/bdv/checklist/:veiculoId/:dia',
      views: {
        'content@': {
          templateUrl: 'relatorios/bdv/bdv-checklist/bdv-checklist.tpl.html',
          controller: 'BdvChecklistCtrl',
          controllerAs: 'bdvChecklist'
        }
      },
      data: {
        titulo: 'ce.boletim.diarioVeiculoChecklist.titulo',
        tituloDescricao: 'ce.boletim.diarioVeiculoChecklist.tituloDescricao',
        backButton: true,
        backState: 'root.bdv',
        role: 'CONFIG_VDRIVERS_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.bdv').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.bdv').constant('MockBDV', [{
    id: 1,
    data: {
      total: 2,
      list: [{
        motoristas: 'André Castanheira',
        veiculo: { id: 1, prefixo: 'VW81502', placa: 'AOI7238' },
        dia: '2016-01-15',
        excessosVelocidade: 15,
        aceleracoes: 8,
        frenagens: 2,
        curvas: 10,
        trepidacoes: 0,
        banguelas: 0,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 5035,
        distanciaPercorridaConvertida: 5.04,
        tempoDirecao: 3600,
        hodometroFim: 5078102
      }, {
        motoristas: 'Silvério Mansilla',
        veiculo: { id: 1, prefixo: 'VW81502', placa: 'AOI7238' },
        dia: '2016-01-15',
        excessosVelocidade: 7,
        aceleracoes: 0,
        frenagens: 0,
        curvas: 1,
        trepidacoes: 0,
        banguelas: 3,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 15040,
        distanciaPercorridaConvertida: 15.04,
        tempoDirecao: 3024,
        hodometroFim: 9078101
      }]
    }
  }, {
    id: 2,
    data: {
      total: 2,
      list: [{
        motoristas: 'Gil Larangeira',
        veiculo: { id: 2, prefixo: 'FSADF45', placa: 'VXZ9045' },
        dia: '2016-01-15',
        excessosVelocidade: 22,
        aceleracoes: 0,
        frenagens: 0,
        curvas: 0,
        trepidacoes: 0,
        banguelas: 0,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 5840,
        distanciaPercorridaConvertida: 5.84,
        tempoDirecao: 2043,
        hodometroFim: 2372810
      }, {
        motoristas: 'Iberê Lages',
        veiculo: { id: 2, prefixo: 'FSADF45', placa: 'VXZ9045' },
        dia: '2016-01-15',
        excessosVelocidade: 6,
        aceleracoes: 0,
        frenagens: 2,
        curvas: 9,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 7345,
        distanciaPercorridaConvertida: 7.35,
        tempoDirecao: 1068,
        hodometroFim: 1273810
      }]
    }
  }, {
    id: 3,
    data: {
      total: 2,
      list: [{
        motoristas: 'André Castanheira',
        veiculo: { id: 3, prefixo: 'VCBZ45', placa: 'UKT3556' },
        dia: '2016-01-15',
        excessosVelocidade: 15,
        aceleracoes: 8,
        frenagens: 2,
        curvas: 10,
        trepidacoes: 0,
        banguelas: 0,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 5035,
        distanciaPercorridaConvertida: 5.04,
        tempoDirecao: 3600,
        hodometroFim: 5072810
      }, {
        motoristas: 'Iberê Lages',
        veiculo: { id: 3, prefixo: 'VCBZ45', placa: 'UKT3556' },
        dia: '2016-01-15',
        excessosVelocidade: 6,
        aceleracoes: 0,
        frenagens: 2,
        curvas: 9,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 7345,
        distanciaPercorridaConvertida: 7.35,
        tempoDirecao: 1068,
        hodometroFim: 1237810
      }]
    }
  }, {
    id: 4,
    data: {
      total: 2,
      list: [{
        motoristas: 'Iberê Lages',
        veiculo: { id: 4, prefixo: 'ANGA01', placa: 'ANR1131' },
        dia: '2016-01-15',
        excessosVelocidade: 6,
        aceleracoes: 0,
        frenagens: 2,
        curvas: 9,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorridaConvertida: 7.35,
        tempoDirecao: 1068,
        hodometroFim: 1271810
      }, {
        motoristas: 'Silvério Mansilla',
        veiculo: { id: 4, prefixo: 'ANGA01', placa: 'ANR1131' },
        dia: '2016-01-15',
        excessosVelocidade: 7,
        aceleracoes: 0,
        frenagens: 0,
        curvas: 1,
        trepidacoes: 0,
        banguelas: 3,
        rpmExcessivos: 0,
        motorOcioso: 0,
        logradouroInicio: 'Rua Paraná',
        logradouroFim: 'Av. Higienópolis',
        distanciaPercorrida: 15040,
        distanciaPercorridaConvertida: 15.04,
        tempoDirecao: 3024,
        hodometroFim: 9037810
      }]
    }
  }]).constant('MockBDVDetalhes', {
    success: true,
    message: 'Success',
    data: [{
      veiculo: 'ANGA01 - ANR1131',
      motoristas: 'Sem identificação',
      logradouroInicio: '-',
      logradouroFim: 'Avenida Santos Dumont',
      inicio: '2016-01-15T09:18:41Z',
      fim: '2016-01-15T09:59:24Z',
      posicoes: [{
        latitude: 0,
        longitude: 0,
        direcao: 0,
        hodometro: 3598000,
        hodometroAjustado: -655100,
        velocidade: 0,
        gsm: true,
        evento: 'Ignição ligada',
        limiar: '-',
        intensidade: '-',
        gps: 'Inválido',
        duracao: 0,
        data: '2016-01-15T09:18:41.000Z'
      }, {
        latitude: -23.412614822387695,
        longitude: -51.435218811035156,
        direcao: 36,
        hodometro: 0,
        hodometroAjustado: -4253100,
        velocidade: 39,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Inválido',
        duracao: 0,
        data: '2016-01-15T09:21:34.000Z'
      }, {
        latitude: -23.411392211914062,
        longitude: -51.434043884277344,
        direcao: 74,
        hodometro: 3598000,
        hodometroAjustado: -655100,
        velocidade: 27,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:21:52.000Z'
      }, {
        latitude: -23.410415649414062,
        longitude: -51.43329620361328,
        direcao: 38,
        hodometro: 3598000,
        hodometroAjustado: -655100,
        velocidade: 41,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:22:03.000Z'
      }, {
        latitude: -23.4052734375,
        longitude: -51.429561614990234,
        direcao: 37,
        hodometro: 3599000,
        hodometroAjustado: -654100,
        velocidade: 49,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:23:15.000Z'
      }, {
        latitude: -23.401506423950195,
        longitude: -51.427978515625,
        direcao: 79,
        hodometro: 3600000,
        hodometroAjustado: -653100,
        velocidade: 0,
        gsm: true,
        evento: 'Parado',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:24:26.000Z'
      }, {
        latitude: -23.401302337646484,
        longitude: -51.427650451660156,
        direcao: 42,
        hodometro: 3600000,
        hodometroAjustado: -653100,
        velocidade: 33,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:24:32.000Z'
      }, {
        latitude: -23.39692497253418,
        longitude: -51.425453186035156,
        direcao: 25,
        hodometro: 3600000,
        hodometroAjustado: -653100,
        velocidade: 77,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:25:00.000Z'
      }, {
        latitude: -23.381549835205078,
        longitude: -51.417694091796875,
        direcao: 25,
        hodometro: 3602000,
        hodometroAjustado: -651100,
        velocidade: 72,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:26:45.000Z'
      }, {
        latitude: -23.36176109313965,
        longitude: -51.39988327026367,
        direcao: 52,
        hodometro: 3605000,
        hodometroAjustado: -648100,
        velocidade: 74,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:28:32.000Z'
      }, {
        latitude: -23.349027633666992,
        longitude: -51.38587951660156,
        direcao: 64,
        hodometro: 3607000,
        hodometroAjustado: -646100,
        velocidade: 83,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:29:59.000Z'
      }, {
        latitude: -23.34894371032715,
        longitude: -51.384525299072266,
        direcao: 104,
        hodometro: 3607000,
        hodometroAjustado: -646100,
        velocidade: 86,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:30:05.000Z'
      }, {
        latitude: -23.34955596923828,
        longitude: -51.381622314453125,
        direcao: 81,
        hodometro: 3607000,
        hodometroAjustado: -646100,
        velocidade: 91,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:30:17.000Z'
      }, {
        latitude: -23.34955596923828,
        longitude: -51.381622314453125,
        direcao: 81,
        hodometro: 3607000,
        hodometroAjustado: -646100,
        velocidade: 91,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:30:17.000Z'
      }, {
        latitude: -23.34859848022461,
        longitude: -51.37976837158203,
        direcao: 43,
        hodometro: 3607000,
        hodometroAjustado: -646100,
        velocidade: 84,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:30:26.000Z'
      }, {
        latitude: -23.341352462768555,
        longitude: -51.372371673583984,
        direcao: 69,
        hodometro: 3608000,
        hodometroAjustado: -645100,
        velocidade: 101,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:31:17.000Z'
      }, {
        latitude: -23.33977508544922,
        longitude: -51.35969161987305,
        direcao: 99,
        hodometro: 3610000,
        hodometroAjustado: -643100,
        velocidade: 109,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:32:02.000Z'
      }, {
        latitude: -23.33977508544922,
        longitude: -51.35969161987305,
        direcao: 99,
        hodometro: 3610000,
        hodometroAjustado: -643100,
        velocidade: 109,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:32:02.000Z'
      }, {
        latitude: -23.34037208557129,
        longitude: -51.35377883911133,
        direcao: 68,
        hodometro: 3610000,
        hodometroAjustado: -643100,
        velocidade: 107,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:32:23.000Z'
      }, {
        latitude: -23.33758544921875,
        longitude: -51.34952163696289,
        direcao: 25,
        hodometro: 3611000,
        hodometroAjustado: -642100,
        velocidade: 104,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:32:41.000Z'
      }, {
        latitude: -23.334304809570312,
        longitude: -51.34843444824219,
        direcao: 15,
        hodometro: 3611000,
        hodometroAjustado: -642100,
        velocidade: 125,
        gsm: true,
        evento: 'Excesso de Velocidade',
        limiar: 'Limite: 110 Km/h',
        intensidade: 'ponto de interesse: 65535',
        fim: {
          latitude: -23.32306480407715,
          longitude: -51.34444046020508,
          direcao: 42,
          hodometro: 3613000,
          hodometroAjustado: -640100,
          velocidade: 104,
          gsm: true,
          evento: 'Movimento',
          gps: 'Precisão alta',
          duracao: 0,
          data: '2016-01-15T09:33:32.000Z'
        },
        gps: 'Precisão alta',
        miscInfo: {
          sensorChuva: 0
        },
        duracao: 39,
        data: '2016-01-15T09:32:53.000Z'
      }, {
        latitude: -23.32254981994629,
        longitude: -51.343753814697266,
        direcao: 56,
        hodometro: 3613000,
        hodometroAjustado: -640100,
        velocidade: 109,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:33:35.000Z'
      }, {
        latitude: -23.321361541748047,
        longitude: -51.34042739868164,
        direcao: 69,
        hodometro: 3613000,
        hodometroAjustado: -640100,
        velocidade: 109,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:33:47.000Z'
      }, {
        latitude: -23.318899154663086,
        longitude: -51.33598327636719,
        direcao: 32,
        hodometro: 3614000,
        hodometroAjustado: -639100,
        velocidade: 108,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:34:05.000Z'
      }, {
        latitude: -23.30337905883789,
        longitude: -51.328060150146484,
        direcao: 48,
        hodometro: 3616000,
        hodometroAjustado: -637100,
        velocidade: 122,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:35:06.000Z'
      }, {
        latitude: -23.29849624633789,
        longitude: -51.321048736572266,
        direcao: 58,
        hodometro: 3617000,
        hodometroAjustado: -636100,
        velocidade: 114,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:35:33.000Z'
      }, {
        latitude: -23.311674118041992,
        longitude: -51.331703186035156,
        direcao: 21,
        hodometro: 3615000,
        hodometroAjustado: -638100,
        velocidade: 117,
        gsm: true,
        evento: 'Excesso de Velocidade',
        limiar: 'Limite: 110 Km/h',
        intensidade: 'ponto de interesse: 65535',
        fim: {
          latitude: -23.297332763671875,
          longitude: -51.318851470947266,
          direcao: 65,
          hodometro: 3617000,
          hodometroAjustado: -636100,
          velocidade: 92,
          gsm: true,
          evento: 'Movimento',
          gps: 'Precisão alta',
          duracao: 0,
          data: '2016-01-15T09:35:42.000Z'
        },
        gps: 'Precisão alta',
        miscInfo: {
          sensorChuva: 0
        },
        duracao: 66,
        data: '2016-01-15T09:34:36.000Z'
      }, {
        latitude: -23.295419692993164,
        longitude: -51.311763763427734,
        direcao: 81,
        hodometro: 3617000,
        hodometroAjustado: -636100,
        velocidade: 91,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:36:12.000Z'
      }, {
        latitude: -23.295310974121094,
        longitude: -51.29420471191406,
        direcao: 89,
        hodometro: 3619000,
        hodometroAjustado: -634100,
        velocidade: 105,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:37:20.000Z'
      }, {
        latitude: -23.295787811279297,
        longitude: -51.27145767211914,
        direcao: 60,
        hodometro: 3621000,
        hodometroAjustado: -632100,
        velocidade: 82,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:38:57.000Z'
      }, {
        latitude: -23.29474449157715,
        longitude: -51.26995086669922,
        direcao: 50,
        hodometro: 3622000,
        hodometroAjustado: -631100,
        velocidade: 72,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:39:06.000Z'
      }, {
        latitude: -23.288820266723633,
        longitude: -51.2620849609375,
        direcao: 50,
        hodometro: 3623000,
        hodometroAjustado: -630100,
        velocidade: 32,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:41:00.000Z'
      }, {
        latitude: -23.286216735839844,
        longitude: -51.25962829589844,
        direcao: 29,
        hodometro: 3623000,
        hodometroAjustado: -630100,
        velocidade: 79,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:41:24.000Z'
      }, {
        latitude: -23.281957626342773,
        longitude: -51.25615692138672,
        direcao: 65,
        hodometro: 3624000,
        hodometroAjustado: -629100,
        velocidade: 64,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:41:50.000Z'
      }, {
        latitude: -23.281789779663086,
        longitude: -51.25402069091797,
        direcao: 102,
        hodometro: 3624000,
        hodometroAjustado: -629100,
        velocidade: 67,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:42:02.000Z'
      }, {
        latitude: -23.283645629882812,
        longitude: -51.24597930908203,
        direcao: 104,
        hodometro: 3625000,
        hodometroAjustado: -628100,
        velocidade: 57,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:42:47.000Z'
      }, {
        latitude: -23.286731719970703,
        longitude: -51.228233337402344,
        direcao: 115,
        hodometro: 3627000,
        hodometroAjustado: -626100,
        velocidade: 67,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:44:32.000Z'
      }, {
        latitude: -23.29473876953125,
        longitude: -51.21070098876953,
        direcao: 114,
        hodometro: 3629000,
        hodometroAjustado: -624100,
        velocidade: 0,
        gsm: true,
        evento: 'Parado',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:46:17.000Z'
      }, {
        latitude: -23.29727554321289,
        longitude: -51.20194625854492,
        direcao: 99,
        hodometro: 3630000,
        hodometroAjustado: -623100,
        velocidade: 25,
        gsm: true,
        evento: 'Aceleração Brusca',
        limiar: 'Limite: 18,5 Km/h/s',
        intensidade: '',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:48:14.000Z'
      }, {
        latitude: -23.297372817993164,
        longitude: -51.20128631591797,
        direcao: 97,
        hodometro: 3630000,
        hodometroAjustado: -623100,
        velocidade: 50,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:48:20.000Z'
      }, {
        latitude: -23.298067092895508,
        longitude: -51.19388961791992,
        direcao: 54,
        hodometro: 3631000,
        hodometroAjustado: -622100,
        velocidade: 57,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:49:08.000Z'
      }, {
        latitude: -23.297208786010742,
        longitude: -51.1922721862793,
        direcao: 88,
        hodometro: 3631000,
        hodometroAjustado: -622100,
        velocidade: 46,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:49:20.000Z'
      }, {
        latitude: -23.29731559753418,
        longitude: -51.18859100341797,
        direcao: 92,
        hodometro: 3631000,
        hodometroAjustado: -622100,
        velocidade: 58,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:50:05.000Z'
      }, {
        latitude: -23.298839569091797,
        longitude: -51.1772346496582,
        direcao: 98,
        hodometro: 3632000,
        hodometroAjustado: -621100,
        velocidade: 75,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:51:50.000Z'
      }, {
        latitude: -23.299352645874023,
        longitude: -51.173744201660156,
        direcao: 121,
        hodometro: 3633000,
        hodometroAjustado: -620100,
        velocidade: 26,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:52:42.000Z'
      }, {
        latitude: -23.299467086791992,
        longitude: -51.1733512878418,
        direcao: 73,
        hodometro: 3633000,
        hodometroAjustado: -620100,
        velocidade: 30,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:52:48.000Z'
      }, {
        latitude: -23.299457550048828,
        longitude: -51.173065185546875,
        direcao: 104,
        hodometro: 3633000,
        hodometroAjustado: -620100,
        velocidade: 39,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:52:51.000Z'
      }, {
        latitude: -23.30176544189453,
        longitude: -51.16803741455078,
        direcao: 108,
        hodometro: 3634000,
        hodometroAjustado: -619100,
        velocidade: 14,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:53:35.000Z'
      }, {
        latitude: -23.302995681762695,
        longitude: -51.165863037109375,
        direcao: 134,
        hodometro: 3634000,
        hodometroAjustado: -619100,
        velocidade: 44,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:54:02.000Z'
      }, {
        latitude: -23.30779457092285,
        longitude: -51.162593841552734,
        direcao: 100,
        hodometro: 3634000,
        hodometroAjustado: -619100,
        velocidade: 34,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:55:20.000Z'
      }, {
        latitude: -23.307819366455078,
        longitude: -51.1614875793457,
        direcao: 90,
        hodometro: 3635000,
        hodometroAjustado: -618100,
        velocidade: 36,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:55:36.000Z'
      }, {
        latitude: -23.30811882019043,
        longitude: -51.15535354614258,
        direcao: 120,
        hodometro: 3635000,
        hodometroAjustado: -618100,
        velocidade: 52,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:56:21.000Z'
      }, {
        latitude: -23.310178756713867,
        longitude: -51.15266799926758,
        direcao: 175,
        hodometro: 3636000,
        hodometroAjustado: -617100,
        velocidade: 38,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:56:57.000Z'
      }, {
        latitude: -23.31351661682129,
        longitude: -51.15262222290039,
        direcao: 179,
        hodometro: 3636000,
        hodometroAjustado: -617100,
        velocidade: 46,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:57:21.000Z'
      }, {
        latitude: -23.31540870666504,
        longitude: -51.152496337890625,
        direcao: 100,
        hodometro: 3636000,
        hodometroAjustado: -617100,
        velocidade: 24,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:58:09.000Z'
      }, {
        latitude: -23.315780639648438,
        longitude: -51.1511116027832,
        direcao: 126,
        hodometro: 3636000,
        hodometroAjustado: -617100,
        velocidade: 54,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:58:21.000Z'
      }, {
        latitude: -23.317087173461914,
        longitude: -51.14973831176758,
        direcao: 358,
        hodometro: 3637000,
        hodometroAjustado: -616100,
        velocidade: 0,
        gsm: true,
        evento: 'Ignição desligada',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T09:59:24.000Z'
      }],
      distanciaPercorrida: 39000,
      distanciaPercorridaConvertida: 39.0,
      curvasBruscas: 0,
      aceleracoesBruscas: 1,
      banguela: 0,
      freadasBruscas: 0,
      excessoVelocidade: 105,
      trepidacoes: 0,
      motorOcioso: 0,
      rpmExcessivo: 0
    }, {
      veiculo: 'ANGA01 - ANR1131',
      motoristas: 'Sem identificação',
      logradouroInicio: 'Avenida Santos Dumont',
      logradouroFim: 'Rua Aturia',
      inicio: '2016-01-15T21:08:14Z',
      fim: '2016-01-15T21:47:06Z',
      posicoes: [{
        latitude: -23.317005157470703,
        longitude: -51.14962387084961,
        direcao: 358,
        hodometro: 3638000,
        hodometroAjustado: -615100,
        velocidade: 0,
        gsm: true,
        evento: 'Ignição ligada',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:08:14.000Z'
      }, {
        latitude: -23.307958602905273,
        longitude: -51.151302337646484,
        direcao: 1,
        hodometro: 3639000,
        hodometroAjustado: -614100,
        velocidade: 60,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:10:18.000Z'
      }, {
        latitude: -23.300966262817383,
        longitude: -51.15116500854492,
        direcao: 348,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 16,
        gsm: true,
        evento: 'Curva brusca',
        limiar: 'Limite: 0.6097 G',
        intensidade: '',
        gps: 'Inválido',
        duracao: 0,
        data: '2016-01-15T21:11:24.000Z'
      }, {
        latitude: -23.300966262817383,
        longitude: -51.15116500854492,
        direcao: 348,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 16,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:11:24.000Z'
      }, {
        latitude: -23.300905227661133,
        longitude: -51.15131759643555,
        direcao: 293,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 23,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:11:27.000Z'
      }, {
        latitude: -23.29990577697754,
        longitude: -51.15290451049805,
        direcao: 299,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 35,
        gsm: true,
        evento: 'Aceleração Brusca',
        limiar: 'Limite: 18,5 Km/h/s',
        intensidade: '',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:12:00.000Z'
      }, {
        latitude: -23.299755096435547,
        longitude: -51.15317916870117,
        direcao: 302,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 40,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:12:03.000Z'
      }, {
        latitude: -23.299476623535156,
        longitude: -51.15353775024414,
        direcao: 344,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 20,
        gsm: true,
        evento: 'Curva brusca',
        limiar: 'Limite: 0.6097 G',
        intensidade: '',
        gps: 'Inválido',
        duracao: 0,
        data: '2016-01-15T21:12:09.000Z'
      }, {
        latitude: -23.299476623535156,
        longitude: -51.15353775024414,
        direcao: 344,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 20,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:12:09.000Z'
      }, {
        latitude: -23.29928207397461,
        longitude: -51.1534538269043,
        direcao: 32,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 35,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:12:12.000Z'
      }, {
        latitude: -23.297704696655273,
        longitude: -51.15262222290039,
        direcao: 342,
        hodometro: 3640000,
        hodometroAjustado: -613100,
        velocidade: 51,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:12:27.000Z'
      }, {
        latitude: -23.292884826660156,
        longitude: -51.15398025512695,
        direcao: 303,
        hodometro: 3641000,
        hodometroAjustado: -612100,
        velocidade: 16,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:13:36.000Z'
      }, {
        latitude: -23.29289436340332,
        longitude: -51.15409851074219,
        direcao: 267,
        hodometro: 3641000,
        hodometroAjustado: -612100,
        velocidade: 13,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:13:39.000Z'
      }, {
        latitude: -23.29292869567871,
        longitude: -51.15593719482422,
        direcao: 271,
        hodometro: 3641000,
        hodometroAjustado: -612100,
        velocidade: 54,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:14:27.000Z'
      }, {
        latitude: -23.292827606201172,
        longitude: -51.16886901855469,
        direcao: 270,
        hodometro: 3642000,
        hodometroAjustado: -611100,
        velocidade: 76,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:16:12.000Z'
      }, {
        latitude: -23.293333053588867,
        longitude: -51.18681716918945,
        direcao: 240,
        hodometro: 3644000,
        hodometroAjustado: -609100,
        velocidade: 34,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:17:37.000Z'
      }, {
        latitude: -23.29342269897461,
        longitude: -51.18700408935547,
        direcao: 236,
        hodometro: 3644000,
        hodometroAjustado: -609100,
        velocidade: 0,
        gsm: true,
        evento: 'Parado',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:17:58.000Z'
      }, {
        latitude: -23.293481826782227,
        longitude: -51.1871337890625,
        direcao: 235,
        hodometro: 3644000,
        hodometroAjustado: -609100,
        velocidade: 25,
        gsm: true,
        evento: 'Aceleração Brusca',
        limiar: 'Limite: 18,5 Km/h/s',
        intensidade: '',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:18:01.000Z'
      }, {
        latitude: -23.298179626464844,
        longitude: -51.194881439208984,
        direcao: 273,
        hodometro: 3645000,
        hodometroAjustado: -608100,
        velocidade: 67,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:18:55.000Z'
      }, {
        latitude: -23.296768188476562,
        longitude: -51.2044563293457,
        direcao: 281,
        hodometro: 3646000,
        hodometroAjustado: -607100,
        velocidade: 86,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:19:43.000Z'
      }, {
        latitude: -23.295597076416016,
        longitude: -51.208194732666016,
        direcao: 296,
        hodometro: 3647000,
        hodometroAjustado: -606100,
        velocidade: 27,
        gsm: true,
        evento: 'Aceleração Brusca',
        limiar: 'Limite: 18,5 Km/h/s',
        intensidade: '',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:20:21.000Z'
      }, {
        latitude: -23.29008674621582,
        longitude: -51.220359802246094,
        direcao: 295,
        hodometro: 3647000,
        hodometroAjustado: -606100,
        velocidade: 88,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:21:30.000Z'
      }, {
        latitude: -23.284664154052734,
        longitude: -51.24129104614258,
        direcao: 284,
        hodometro: 3650000,
        hodometroAjustado: -603100,
        velocidade: 84,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:23:15.000Z'
      }, {
        latitude: -23.281734466552734,
        longitude: -51.25582504272461,
        direcao: 252,
        hodometro: 3651000,
        hodometroAjustado: -602100,
        velocidade: 82,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:24:27.000Z'
      }, {
        latitude: -23.282827377319336,
        longitude: -51.257545471191406,
        direcao: 218,
        hodometro: 3651000,
        hodometroAjustado: -602100,
        velocidade: 90,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:24:36.000Z'
      }, {
        latitude: -23.28696632385254,
        longitude: -51.26018142700195,
        direcao: 211,
        hodometro: 3652000,
        hodometroAjustado: -601100,
        velocidade: 66,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:25:00.000Z'
      }, {
        latitude: -23.295740127563477,
        longitude: -51.271484375,
        direcao: 239,
        hodometro: 3653000,
        hodometroAjustado: -600100,
        velocidade: 96,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:26:36.000Z'
      }, {
        latitude: -23.29644775390625,
        longitude: -51.27361297607422,
        direcao: 259,
        hodometro: 3654000,
        hodometroAjustado: -599100,
        velocidade: 86,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:26:45.000Z'
      }, {
        latitude: -23.29705238342285,
        longitude: -51.27812576293945,
        direcao: 269,
        hodometro: 3654000,
        hodometroAjustado: -599100,
        velocidade: 78,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:27:06.000Z'
      }, {
        latitude: -23.295166015625,
        longitude: -51.29820251464844,
        direcao: 270,
        hodometro: 3656000,
        hodometroAjustado: -597100,
        velocidade: 85,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:28:31.000Z'
      }, {
        latitude: -23.295705795288086,
        longitude: -51.31336975097656,
        direcao: 253,
        hodometro: 3658000,
        hodometroAjustado: -595100,
        velocidade: 93,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:29:37.000Z'
      }, {
        latitude: -23.298912048339844,
        longitude: -51.32269287109375,
        direcao: 229,
        hodometro: 3659000,
        hodometroAjustado: -594100,
        velocidade: 101,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:30:16.000Z'
      }, {
        latitude: -23.300006866455078,
        longitude: -51.32387924194336,
        direcao: 223,
        hodometro: 3659000,
        hodometroAjustado: -594100,
        velocidade: 107,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:30:22.000Z'
      }, {
        latitude: -23.305410385131836,
        longitude: -51.32963180541992,
        direcao: 198,
        hodometro: 3660000,
        hodometroAjustado: -593100,
        velocidade: 100,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:30:51.000Z'
      }, {
        latitude: -23.319936752319336,
        longitude: -51.337135314941406,
        direcao: 231,
        hodometro: 3662000,
        hodometroAjustado: -591100,
        velocidade: 112,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:31:51.000Z'
      }, {
        latitude: -23.321327209472656,
        longitude: -51.340572357177734,
        direcao: 249,
        hodometro: 3662000,
        hodometroAjustado: -591100,
        velocidade: 116,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:32:03.000Z'
      }, {
        latitude: -23.32319450378418,
        longitude: -51.34458541870117,
        direcao: 219,
        hodometro: 3663000,
        hodometroAjustado: -590100,
        velocidade: 110,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:32:18.000Z'
      }, {
        latitude: -23.3389892578125,
        longitude: -51.35099411010742,
        direcao: 238,
        hodometro: 3665000,
        hodometroAjustado: -588100,
        velocidade: 112,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:33:15.000Z'
      }, {
        latitude: -23.34046745300293,
        longitude: -51.3558464050293,
        direcao: 278,
        hodometro: 3665000,
        hodometroAjustado: -588100,
        velocidade: 103,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:33:33.000Z'
      }, {
        latitude: -23.339582443237305,
        longitude: -51.36007308959961,
        direcao: 278,
        hodometro: 3666000,
        hodometroAjustado: -587100,
        velocidade: 106,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:33:48.000Z'
      }, {
        latitude: -23.339981079101562,
        longitude: -51.368377685546875,
        direcao: 251,
        hodometro: 3666000,
        hodometroAjustado: -587100,
        velocidade: 120,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:34:15.000Z'
      }, {
        latitude: -23.342458724975586,
        longitude: -51.37419128417969,
        direcao: 220,
        hodometro: 3666000,
        hodometroAjustado: -587100,
        velocidade: 111,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:34:36.000Z'
      }, {
        latitude: -23.3393611907959,
        longitude: -51.36459732055664,
        direcao: 271,
        hodometro: 3666000,
        hodometroAjustado: -587100,
        velocidade: 117,
        gsm: true,
        evento: 'Excesso de Velocidade',
        limiar: 'Limite: 110 Km/h',
        intensidade: 'ponto de interesse: 65535',
        fim: {
          latitude: -23.344873428344727,
          longitude: -51.376319885253906,
          direcao: 218,
          hodometro: 3667000,
          hodometroAjustado: -586100,
          velocidade: 88,
          gsm: true,
          evento: 'Movimento',
          gps: 'Precisão alta',
          duracao: 0,
          data: '2016-01-15T21:34:48.000Z'
        },
        gps: 'Precisão alta',
        miscInfo: {
          sensorChuva: 0
        },
        duracao: 45,
        data: '2016-01-15T21:34:03.000Z'
      }, {
        latitude: -23.349424362182617,
        longitude: -51.38144302368164,
        direcao: 255,
        hodometro: 3668000,
        hodometroAjustado: -585100,
        velocidade: 99,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:35:27.000Z'
      }, {
        latitude: -23.349340438842773,
        longitude: -51.38311004638672,
        direcao: 288,
        hodometro: 3668000,
        hodometroAjustado: -585100,
        velocidade: 107,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:35:33.000Z'
      }, {
        latitude: -23.349340438842773,
        longitude: -51.38311004638672,
        direcao: 288,
        hodometro: 3668000,
        hodometroAjustado: -585100,
        velocidade: 107,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:35:33.000Z'
      }, {
        latitude: -23.348913192749023,
        longitude: -51.3855094909668,
        direcao: 256,
        hodometro: 3669000,
        hodometroAjustado: -584100,
        velocidade: 92,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:35:43.000Z'
      }, {
        latitude: -23.349781036376953,
        longitude: -51.38667678833008,
        direcao: 210,
        hodometro: 3669000,
        hodometroAjustado: -584100,
        velocidade: 97,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:35:49.000Z'
      }, {
        latitude: -23.36110496520996,
        longitude: -51.39976501464844,
        direcao: 217,
        hodometro: 3671000,
        hodometroAjustado: -582100,
        velocidade: 52,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:37:19.000Z'
      }, {
        latitude: -23.368526458740234,
        longitude: -51.4073486328125,
        direcao: 224,
        hodometro: 3671000,
        hodometroAjustado: -582100,
        velocidade: 116,
        gsm: true,
        evento: 'Excesso de Velocidade',
        limiar: 'Limite: 110 Km/h',
        intensidade: 'ponto de interesse: 65535',
        fim: {
          latitude: -23.38232421875,
          longitude: -51.4181022644043,
          direcao: 205,
          hodometro: 3673000,
          hodometroAjustado: -580100,
          velocidade: 78,
          gsm: true,
          evento: 'Movimento',
          gps: 'Precisão alta',
          duracao: 0,
          data: '2016-01-15T21:39:03.000Z'
        },
        gps: 'Precisão alta',
        miscInfo: {
          sensorChuva: 0
        },
        duracao: 59,
        data: '2016-01-15T21:38:04.000Z'
      }, {
        latitude: -23.382720947265625,
        longitude: -51.418312072753906,
        direcao: 206,
        hodometro: 3673000,
        hodometroAjustado: -580100,
        velocidade: 42,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:39:06.000Z'
      }, {
        latitude: -23.400056838989258,
        longitude: -51.427024841308594,
        direcao: 204,
        hodometro: 3676000,
        hodometroAjustado: -577100,
        velocidade: 63,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:40:52.000Z'
      }, {
        latitude: -23.405380249023438,
        longitude: -51.42843246459961,
        direcao: 173,
        hodometro: 3676000,
        hodometroAjustado: -577100,
        velocidade: 76,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:41:28.000Z'
      }, {
        latitude: -23.407846450805664,
        longitude: -51.42839050292969,
        direcao: 209,
        hodometro: 3677000,
        hodometroAjustado: -576100,
        velocidade: 53,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:41:43.000Z'
      }, {
        latitude: -23.408794403076172,
        longitude: -51.42921829223633,
        direcao: 275,
        hodometro: 3677000,
        hodometroAjustado: -576100,
        velocidade: 28,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:41:55.000Z'
      }, {
        latitude: -23.408788681030273,
        longitude: -51.42984390258789,
        direcao: 203,
        hodometro: 3677000,
        hodometroAjustado: -576100,
        velocidade: 22,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:42:10.000Z'
      }, {
        latitude: -23.409847259521484,
        longitude: -51.4300422668457,
        direcao: 190,
        hodometro: 3677000,
        hodometroAjustado: -576100,
        velocidade: 30,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:42:37.000Z'
      }, {
        latitude: -23.41341781616211,
        longitude: -51.43244934082031,
        direcao: 138,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 25,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:43:54.000Z'
      }, {
        latitude: -23.413957595825195,
        longitude: -51.431488037109375,
        direcao: 57,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 24,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:44:06.000Z'
      }, {
        latitude: -23.413127899169922,
        longitude: -51.43092346191406,
        direcao: 338,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 20,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:44:18.000Z'
      }, {
        latitude: -23.41299057006836,
        longitude: -51.43111038208008,
        direcao: 305,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 35,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:44:21.000Z'
      }, {
        latitude: -23.41254234313965,
        longitude: -51.43180465698242,
        direcao: 265,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 17,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:44:42.000Z'
      }, {
        latitude: -23.41269874572754,
        longitude: -51.431968688964844,
        direcao: 221,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 35,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:44:45.000Z'
      }, {
        latitude: -23.413938522338867,
        longitude: -51.4329833984375,
        direcao: 213,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 25,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:45:09.000Z'
      }, {
        latitude: -23.415103912353516,
        longitude: -51.43407440185547,
        direcao: 254,
        hodometro: 3678000,
        hodometroAjustado: -575100,
        velocidade: 20,
        gsm: true,
        evento: 'Movimento',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:46:15.000Z'
      }, {
        latitude: -23.415443420410156,
        longitude: -51.43421936035156,
        direcao: 163,
        hodometro: 3679000,
        hodometroAjustado: -574100,
        velocidade: 0,
        gsm: true,
        evento: 'Parado',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:46:50.000Z'
      }, {
        latitude: -23.415517807006836,
        longitude: -51.43422317504883,
        direcao: 167,
        hodometro: 3679000,
        hodometroAjustado: -574100,
        velocidade: 0,
        gsm: true,
        evento: 'Ignição desligada',
        limiar: '-',
        intensidade: '-',
        gps: 'Precisão alta',
        duracao: 0,
        data: '2016-01-15T21:47:06.000Z'
      }],
      distanciaPercorrida: 41000,
      distanciaPercorridaConvertida: 41.0,
      curvasBruscas: 2,
      aceleracoesBruscas: 3,
      banguela: 0,
      freadasBruscas: 0,
      excessoVelocidade: 104,
      trepidacoes: 0,
      motorOcioso: 0,
      rpmExcessivo: 0
    }]
  });
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BdvCtrl = function () {
    function BdvCtrl($q, $window, $filter, $httpParamSerializer, Restangular, moment, IDBDV, MockBDV, Uos, Veiculos, Bdv, Onboarding, ChecklistEnum, VtabelaFactory, MeasurementUnitConverterService, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, uiGridConstants, $translate, Authenticator, CadastroVeiculoService, UrlConfigService, ConvertersService, ConfigEventosService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, BdvCtrl);

      this.q = $q;
      this.configEventosService = ConfigEventosService;
      this.httpParamSerializer = $httpParamSerializer;
      this.window = $window;
      this.filter = $filter;
      this.convertersService = ConvertersService;
      this.restangular = Restangular;
      this.moment = moment;
      this.mockBDV = MockBDV;
      this.uoService = Uos;
      this.veiculoService = Veiculos;
      this.bdvService = Bdv;
      this.onboarding = Onboarding;
      this.checklistEnum = ChecklistEnum;
      this.vtabelaFactory = VtabelaFactory;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.uiGridConstants = uiGridConstants;
      this.filtro = null;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.veiculoServiceV2 = CadastroVeiculoService;
      this.urlConfigService = UrlConfigService;
      this.featureHub = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;

      this.hasSensorAcionado = false;
      this.hasPermissaoChecklist = false;
      this.hasConsumoEletrico = false;
      this.vtabela = null;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();

      this.isDemo = this.onboarding.startOnboarding(IDBDV);
      this.uoService.isDemo = this.isDemo;
      this.veiculoService.isDemo = this.isDemo;

      this.colunaPedalAcionadoFaixa = this.translate.instant('ce.boletim.common.pedalAcionadoFaixa');

      this.tooltipUoNome = this.translate.instant('ce.boletim.diarioVeiculo.tooltipUoNome');
      this.tooltipFrenagemBrusca = this.translate.instant('ce.boletim.diarioVeiculo.tooltipFrenagemBrusca');
      this.tooltipPedalAcionadoFaixa1 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa1');
      this.tooltipPedalAcionadoFaixa2 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa2');
      this.tooltipPedalAcionadoFaixa3 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa3');
      this.tooltipFcwBrakeExtAccDem = this.translate.instant('ce.boletim.diarioVeiculo.colunasTooltips.fcwBrakeExtAccDem');

      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator.getUser().then(function (user) {
        _this.measurementUnits = user.measurementUnits;
        _this.fuelUnit = _this.measurementUnitConverterService.getFuelUnit(_this.measurementUnits.fuelMeasurement);
        _this.distanceUnit = _this.measurementUnitConverterService.getDistanceUnit(_this.measurementUnits.distanceMeasurement);
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateFormat(_this.measurementUnits.dateTimeFormat);
        _this.fuelEfficiency = _this.measurementUnitConverterService.getFuelEfficiencyUnit(_this.measurementUnits.fuelMeasurement);
        _this.energyEfficiency = _this.measurementUnitConverterService.getEnergyEfficiencyUnit(_this.measurementUnits.fuelMeasurement);
        var isEnUs = user.idioma === 'EN_US';
        _this.numberCellFilter = isEnUs ? 'numberWithPoint:2 | withNumberLabel:\'' : 'number:2 | withLabel:\'';
        _this.decimalWithLabelCellFilter = isEnUs ? 'decimalPointWithLabel:\'' : 'decimalWithLabel:\'';
      });

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        dateLimit: 30,
        format: 'YYYY-MM-DD',
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo',
        key: this.keys.uo.name
      }, {
        name: 'uoParceira',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'veiculos',
        key: this.keys.veiculos.name,
        ignoreValidation: true,
        size: 6
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.roleChecklist = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_VDRIVERS_VISUALIZAR');
        _this.consultar(ServiceVfiltro.getFiltroBackendNovo(filtro));
      });
    }

    _createClass(BdvCtrl, [{
      key: 'initVtabela',
      value: function initVtabela(configEventos) {
        var _this2 = this;

        var drilDownCol = void 0,
            drilDownSorting = void 0,
            objVtabela = {
          exporterPdfFilename: 'Boletim Diário do Veículo PDF.pdf',
          exporterCsvFilename: 'Boletim Diário do Veículo CSV.csv',
          exporterExcelFilename: 'Boletim Diário do Veículo XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          columnDefs: [{
            name: 'prefixo',
            displayName: 'ce.boletim.diarioVeiculo.colunas.prefixo',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'uoNome',
            displayName: 'ce.boletim.diarioVeiculo.colunas.uoNome',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipUoNome
          }, {
            name: 'placa',
            displayName: 'ce.boletim.diarioVeiculo.colunas.placa',
            type: 'string',
            pinnedLeft: true,
            filterCellFiltered: true,
            enableHiding: false,
            width: 150,
            aggregationTotalTitle: this.translate.instant('ce.boletim.common.total')
          }, {
            name: 'motorista',
            displayName: 'ce.boletim.diarioVeiculo.colunas.motoristas',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'ce.common.motorista.semIdentificacao\' | translate | splitComposedLabels:true'
          }, {
            name: 'dia',
            displayName: 'ce.boletim.diarioVeiculo.colunas.dia',
            type: 'date',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
            filterCellFiltered: true,
            enableHiding: false,
            cellClass: 'text-center'
          }, {
            name: 'distanciaConvertida',
            displayName: 'ce.boletim.diarioVeiculo.colunas.distanciaPercorrida',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellFilter: this.numberCellFilter + this.distanceUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'tempoIgnicaoLigada',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoIgnicaoLigada',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true
          }, {
            name: 'tempoVigente',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoEmVigencia',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true
          }, {
            name: 'velocidade',
            displayName: 'ce.boletim.diarioVeiculo.colunas.excessoVelocidade',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'aceleracoesBruscas',
            displayName: 'ce.boletim.diarioVeiculo.colunas.aceleracoesBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.aceleracao && !configEventos.aceleracao.enabled
          }, {
            name: 'frenagensBruscas',
            displayName: 'ce.boletim.diarioVeiculo.colunas.frenagensBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipFrenagemBrusca
          }, {
            name: 'frenagensComAcionamentoPedal',
            displayName: 'ce.enum.common.frenagemBruscaComPedal',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true
          }, {
            name: 'frenagensSemAcionamentoPedal',
            displayName: 'ce.enum.common.frenagemBruscaSemPedal',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true
          }, {
            name: 'curvasBruscas',
            displayName: 'ce.boletim.diarioVeiculo.colunas.curvasBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.curva && !configEventos.curva.enabled
          }, {
            name: 'noSeatbelt',
            displayName: 'ce.enum.common.semCinto',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'yawning',
            displayName: 'ce.enum.eventos.bocejo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'absentDriver',
            displayName: 'ce.enum.common.semMotorista',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.motoristaAusente && !configEventos.motoristaAusente.enabled
          }, {
            name: 'smoking',
            displayName: 'ce.enum.common.usoDeCigarro',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'distraction',
            displayName: 'ce.enum.common.distracao',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'fatique',
            displayName: 'ce.enum.common.fadiga',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'cellphoneUsage',
            displayName: 'ce.enum.common.usoDeCelular',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'unsafeDistance',
            displayName: 'ce.enum.common.distanciaPerigosa',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.distanciaPerigosa && !configEventos.distanciaPerigosa.enabled
          }, {
            name: 'obstructedCamera',
            displayName: 'ce.enum.common.cameraObstruida',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'cameraDisconnectionDriver',
            displayName: 'ce.enum.eventos.cameraDisconnectionDriver',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionDriver && !configEventos.cameraDisconnectionDriver.enabled
          }, {
            name: 'cameraDisconnectionRoad',
            displayName: 'ce.enum.eventos.cameraDisconnectionRoad',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionRoad && !configEventos.cameraDisconnectionRoad.enabled
          }, {
            name: 'cameraDisconnectionAudit',
            displayName: 'ce.enum.eventos.cameraDisconnectionAudit',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionAudit && !configEventos.cameraDisconnectionAudit.enabled
          }, {
            name: 'illegalOvertaking',
            displayName: 'ce.enum.eventos.ultrapassagemIlegal',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.ultrapassagemIlegal && !configEventos.ultrapassagemIlegal.enabled
          }, {
            name: 'noSafetyCone',
            displayName: 'ce.enum.eventos.semCone',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semCone && !configEventos.semCone.enabled
          }, {
            name: 'noSafetyGlasses',
            displayName: 'ce.enum.eventos.SemOculos',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semOculos && !configEventos.semOculos.enabled
          }, {
            name: 'noGloves',
            displayName: 'ce.enum.eventos.SemLuvas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semLuvas && !configEventos.semLuvas.enabled
          }, {
            name: 'ride',
            displayName: 'ce.enum.eventos.carona',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.carona && !configEventos.carona.enabled
          }, {
            name: 'followingDistance',
            displayName: 'ce.boletim.diarioVeiculo.colunas.followingDistance',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.followingDistance.enabled)
          }, {
            name: 'collisionMitigation',
            displayName: 'ce.boletim.diarioMotorista.colunas.collisionMitigation',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.collisionMitigation.enabled)
          }, {
            name: 'fcwBrakeExtAccDem',
            displayName: 'ce.boletim.diarioMotorista.colunas.fcwBrakeExtAccDem',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.fcwBrakeExtAccDem.enabled),
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipFcwBrakeExtAccDem
          }, {
            name: 'fcw',
            displayName: 'ce.boletim.diarioMotorista.colunas.fcw',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.fcw.enabled)
          }, {
            name: 'hapticWarning',
            displayName: 'ce.boletim.diarioMotorista.colunas.hapticWarning',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.hapticWarning.enabled)
          }, {
            name: 'ropBrake',
            displayName: 'ce.boletim.diarioVeiculo.colunas.ropBrake',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ropBrake.enabled)
          }, {
            name: 'ropEngine',
            displayName: 'ce.boletim.diarioVeiculo.colunas.ropEngine',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ropEngine.enabled)
          }, {
            name: 'ycBrake',
            displayName: 'ce.boletim.diarioVeiculo.colunas.ycBrake',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ycBrake.enabled)
          }, {
            name: 'ycEngine',
            displayName: 'ce.boletim.diarioVeiculo.colunas.ycEngine',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ycEngine.enabled)
          }, {
            name: 'banguelas',
            displayName: 'ce.boletim.diarioVeiculo.colunas.banguela',
            type: 'number',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.banguela && !configEventos.banguela.enabled
          }, {
            name: 'motorOcioso',
            displayName: 'ce.boletim.diarioVeiculo.colunas.paradoLigado',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.paradoLigado && !configEventos.paradoLigado.enabled
          }, {
            name: 'consumoCombustivel',
            displayName: 'ce.boletim.diarioVeiculo.colunas.consumoCombustivel',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: this.decimalWithLabelCellFilter + this.fuelUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'mediaConsumo',
            displayName: 'ce.boletim.diarioVeiculo.colunas.mediaConsumo',
            cellClass: 'text-center',
            cellFilter: this.numberCellFilter + this.fuelEfficiency + '\'',
            filterCellFiltered: true
          }, {
            name: 'consumoEletrico',
            displayName: 'ce.boletim.diarioVeiculo.colunas.consumoEletrico',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: this.decimalWithLabelCellFilter + 'kWh' + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: this.hasConsumoEletrico
          }, {
            name: 'mediaConsumoEletrico',
            displayName: 'ce.boletim.diarioVeiculo.colunas.mediaConsumoEletrico',
            cellClass: 'text-center',
            cellFilter: this.numberCellFilter + this.energyEfficiency + '\'',
            filterCellFiltered: true,
            visible: this.hasConsumoEletrico
          }, {
            name: 'rpmMarchaLenta',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmMarchaLenta',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmAbaixoVerde',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmAbaixoVerde',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmVerdeEconomico',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmVerdeEconomico',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmVerdePotencia',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmVerdePotencia',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmAmarelo',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmAmarelo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmVermelho',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmVermelho',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'rpmExcessivo',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rpmExcessivo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.rpmExcessivo && !configEventos.rpmExcessivo.enabled
          }, {
            name: 'pedalAcionadoFaixa1',
            displayName: this.colunaPedalAcionadoFaixa + ' 1',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa1
          }, {
            name: 'pedalAcionadoFaixa2',
            displayName: this.colunaPedalAcionadoFaixa + ' 2',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa2
          }, {
            name: 'pedalAcionadoFaixa3',
            displayName: this.colunaPedalAcionadoFaixa + ' 3',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa3
          }, {
            name: 'logradouroInicial',
            displayName: 'ce.boletim.diarioVeiculo.colunas.logradouroInicial',
            filterCellFiltered: true
          }, {
            name: 'logradouroFinal',
            displayName: 'ce.boletim.diarioVeiculo.colunas.logradouroFinal',
            filterCellFiltered: true
          }, {
            name: 'hodometroInicial',
            displayName: 'ce.boletim.diarioVeiculo.colunas.hodometroInicial',
            cellFilter: this.decimalWithLabelCellFilter + this.distanceUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'hodometroFinal',
            displayName: 'ce.boletim.diarioVeiculo.colunas.hodometroFinal',
            cellFilter: this.decimalWithLabelCellFilter + this.distanceUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'tempoMovimento',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoEmMovimento',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'tempoParado',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoParado',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'tempoGpsInvalido',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoGpsInvalido',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'tempoModuloDesligado',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoEquipDesligado',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'tempoBatendoTransmissao',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoBatendoTransmissao',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'tempoFreioMotor',
            displayName: 'ce.boletim.diarioVeiculo.colunas.tempoFreioMotor',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'detalhe',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            cellTemplate: '\n                    <div\n                      class="ui-grid-cell-contents vtabela-icone-detalhado"\n                      ng-if="row.entity.distancia > 0 || row.entity.tempoIgnicaoLigada > 0">\n                      <a\n                        id=\'btn-detalhes-{{$index}}\'\n                        ng-href=\'{{grid.appScope.getUrlBDVDetalhe(row.entity.id, row.entity.dia, row.entity.motorista)}}\'>\n                        <span class="glyphicon glyphicon-zoom-in" aria-hidden=\'true\'></span>\n                      </a>\n                    </div>'
          }, {
            name: 'unauthorizedVehicleUseQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.unauthorizedVehicleUse',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.unauthorizedVehicleUse.enabled)
          }, {
            name: 'unauthorizedVehicleUseTempo',
            displayName: 'ce.boletim.diarioVeiculo.colunas.unauthorizedVehicleUseTempo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.unauthorizedVehicleUse.enabled)
          }, {
            name: 'manuseioObjetoQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.manuseioObjeto',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.MANUSEIO_OBJETO_FRONTEND) || !(configEventos && configEventos.manuseioObjeto.enabled)
          }, {
            name: 'rollingStopQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.rollingStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROLLING_STOP) || configEventos && configEventos.rollingStop && !configEventos.rollingStop.enabled
          }, {
            name: 'noStopQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.noStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROLLING_STOP) || configEventos && configEventos.noStop && !configEventos.noStop.enabled
          }, {
            name: 'semCasqueteQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.semCasquete',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semCasquete && !configEventos.semCasquete.enabled
          }, {
            name: 'routeDeviationQtd',
            displayName: 'ce.boletim.diarioVeiculo.colunas.routeDeviation',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROUTE_DEVIATION) || configEventos && configEventos.routeDeviation && !configEventos.routeDeviation.enabled
          }].filter(function (x) {
            return x.isDisabled !== true;
          })
        };

        if (this.hasSensorAcionado) {
          objVtabela.columnDefs.push({
            name: 'tempoSensorDesengate',
            displayName: 'ce.boletim.diarioVeiculo.colunas.sensorAcionado',
            sortWithUndefinedValues: true,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellTemplate: '\n            <div class="ui-grid-cell-contents text-center">\n              <span title="{{ row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'ce.boletim.diarioVeiculo.sensorAcionado.naoSeAplica\' | translate }}">\n                {{ row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'N/A\' }}\n              </span>\n            </div>',
            cellFilter: 'humanizedOrUndefinedWithLabel:\'N/A\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          });
        }

        if (this.hasPermissaoChecklist && this.roleChecklist) {
          objVtabela.columnDefs.push({
            name: 'checklist',
            displayName: 'ce.boletim.diarioVeiculo.colunas.checklist',
            enableFiltering: false,
            enableHiding: false,
            customSort: true,
            exporterSuppressExport: true,
            cellTemplate: '\n            <div class="ui-grid-cell-contents text-center">\n              <a\n                ng-if=\'row.entity.checklist && row.entity.checklist !== grid.appScope.checklistEnum.NAO_APLICA.id\'\n                ng-href="{{grid.appScope.getUrlChecklist(row.entity)}}">\n                <i class="trimble-icon trimble-checklist" ng-class=\'grid.appScope.checklistEnum.getTipoChecklist(row.entity.checklist).class\'></i>\n              </a>\n              <span\n                uib-tooltip="{{ \'ce.boletim.common.checklist.naoPreenchido\' | translate }}"\n                ng-if=\'!row.entity.checklist || row.entity.checklist === grid.appScope.checklistEnum.NAO_APLICA.id\'> - </span>\n            </div>'
          });
        }

        drilDownSorting = this.getDrilDownSortingDirection(this.tableState);
        drilDownCol = objVtabela.columnDefs.find(function (x) {
          return _this2.isEventoVtabela(x.name, _this2.tableState.sort.predicate);
        });

        if (drilDownSorting && drilDownCol) {
          angular.merge(drilDownCol, drilDownSorting);
        }

        return objVtabela;
      }
    }, {
      key: 'getDrilDownSortingDirection',
      value: function getDrilDownSortingDirection(tableState) {
        if (tableState && tableState.sort.reverse) {
          return {
            sort: {
              direction: this.uiGridConstants.DESC
            }
          };
        }
        return {
          sort: {
            direction: this.uiGridConstants.ASC
          }
        };
      }
    }, {
      key: 'isEventoVtabela',
      value: function isEventoVtabela(eventName, urlEvent) {
        var isSpeedEvent = eventName === 'velocidade',
            isUrlExVelocidadeFaixa = urlEvent === 'exVelocidadeFaixa1' || urlEvent === 'exVelocidadeFaixa2' || urlEvent === 'exVelocidadeFaixa3';

        return eventName.toLowerCase() === urlEvent.toLowerCase() || isUrlExVelocidadeFaixa && isSpeedEvent;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.veiculo.id,
          prefixo: item.veiculo.prefixo,
          uoNome: item.uoNome,
          placa: item.veiculo.placa,
          motorista: item.motoristas,
          dia: item.dia,
          distancia: item.distanciaPercorrida,
          distanciaConvertida: item.distanciaPercorridaConvertida,
          tempoIgnicaoLigada: item.tempoDirecao,
          tempoVigente: item.tempoVigente,
          velocidade: item.excessosVelocidade,
          aceleracoesBruscas: item.aceleracoes,
          frenagensBruscas: item.frenagens,
          frenagensComAcionamentoPedal: item.frenagensComAcionamentoPedal,
          frenagensSemAcionamentoPedal: item.frenagensSemAcionamentoPedal,
          curvasBruscas: item.curvas,
          noSeatbelt: item.noSeatbelt,
          yawning: item.yawning,
          absentDriver: item.absentDriver,
          smoking: item.smoking,
          distraction: item.distraction,
          fatique: item.fatique,
          cellphoneUsage: item.cellphoneUsage,
          unsafeDistance: item.unsafeDistance,
          obstructedCamera: item.obstructedCamera,
          cameraDisconnectionDriver: item.cameraDisconnectionDriver,
          cameraDisconnectionRoad: item.cameraDisconnectionRoad,
          cameraDisconnectionAudit: item.cameraDisconnectionAudit,
          illegalOvertaking: item.illegalOvertaking,
          noSafetyCone: item.noSafetyCone,
          noSafetyGlasses: item.noSafetyGlasses,
          noGloves: item.noGloves,
          ride: item.ride,
          banguelas: item.banguelas,
          rpmExcessivo: item.rpmExcessivos,
          rpmMarchaLenta: item.tempoRpmMarchaLenta,
          rpmAbaixoVerde: item.tempoRpmAbaixoVerde,
          rpmVerdeEconomico: item.tempoRpmVerdeEconomica,
          rpmVerdePotencia: item.tempoRpmVerdePotencia,
          rpmAmarelo: item.tempoRpmAmarelo,
          rpmVermelho: item.tempoRpmVermelho,
          motorOcioso: item.motorOcioso,
          tempoSensorDesengate: item.tempoSensorDesengate,
          consumoCombustivel: item.consumoCombustivel,
          consumoEletrico: item.consumoEletrico,
          logradouroInicial: item.logradouroInicio,
          logradouroFinal: item.logradouroFim,
          hodometroInicial: item.hodometroInicio ? item.hodometroInicio : item.hodometroInicioCalculado,
          hodometroFinal: item.hodometroFimCalculado ? item.hodometroFimCalculado : item.hodometroFim,
          checklist: item.checklist,
          mediaConsumo: item.mediaConsumo,
          mediaConsumoEletrico: item.mediaConsumoEletrico,
          tempoMovimento: item.tempoMovimento,
          tempoParado: item.tempoParado,
          tempoGpsInvalido: item.tempoGpsInvalido,
          tempoModuloDesligado: item.tempoModuloDesligado,
          tempoBatendoTransmissao: item.tempoBatendoTransmissao,
          tempoFreioMotor: item.tempoFreioMotor,
          pedalAcionadoFaixa1: item.pedalFreioDescidaFaixa1Qtd,
          pedalAcionadoFaixa2: item.pedalFreioDescidaFaixa2Qtd,
          pedalAcionadoFaixa3: item.pedalFreioDescidaFaixa3Qtd,
          followingDistance: item.followingDistance,
          ropBrake: item.ropBrake,
          ropEngine: item.ropEngine,
          ycBrake: item.ycBrake,
          ycEngine: item.ycEngine,
          collisionMitigation: item.collisionMitigation,
          fcwBrakeExtAccDem: item.fcwBrakeExtAccDem,
          fcw: item.fcw,
          hapticWarning: item.hapticWarning,
          unauthorizedVehicleUseQtd: item.unauthorizedVehicleUseQtd,
          unauthorizedVehicleUseTempo: item.unauthorizedVehicleUseTempo,
          manuseioObjetoQtd: item.objectHandling,
          rollingStopQtd: item.rollingStopQtd,
          noStopQtd: item.noStopQtd,
          semCasqueteQtd: item.semCasqueteQtd,
          routeDeviationQtd: item.routeDeviationQtd
        };
      }
    }, {
      key: 'consultar',
      value: function consultar(filtro) {
        var _this3 = this;

        if (this.isDemo) {
          this.setInfoTable(this.mockBDV.filter(function (x) {
            return x.id === _this3.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === _this3.keys.veiculos.name;
            }).values[0].id;
          })[0].data.list);
        } else {
          this.q.all([this.bdvService.one().get(filtro), this.configEventosService.getConfigEventos(), this.consultarPermissaoChecklist(filtro), this.consultarSensorAcionado()]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                data = _ref2[0],
                configEventos = _ref2[1];

            _this3.hasConsumoEletrico = data.list.some(function (registro) {
              return angular.isDefined(registro.mediaConsumoEletrico);
            });
            var tabela = _this3.initVtabela(configEventos);
            _this3.vtabela = _this3.vtabelaFactory.get(tabela, _this3.serviceVfiltro.factoryVfiltro.user, 'relatorioBDV', 'v5|' + _this3.serviceVfiltro.factoryVfiltro.user.uo.id + '|' + _this3.disabledColumnsHash(tabela));
            _this3.setInfoTable(data.list);
          }).catch(function () {
            return _this3.vtabela.setError();
          });
        }
      }
    }, {
      key: 'disabledColumnsHash',
      value: function disabledColumnsHash(tabela) {
        return this.hashCode(tabela.columnDefs.filter(function (x) {
          return x.isDisabled !== true;
        }).map(function (x) {
          return x.name;
        }).join(','));
      }
    }, {
      key: 'hashCode',
      value: function hashCode(str) {
        var hash = 0;
        for (var i = 0, len = str.length; i < len; i++) {
          var chr = str.charCodeAt(i);
          hash = (hash << 5) - hash + chr;
          hash |= 0;
        }
        return hash;
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this4 = this;

        var convertedData = this.convertMeasurements(data);
        this.vtabela.setData(convertedData.map(function (i) {
          return _this4.getItemVtabela(i);
        }));
      }
    }, {
      key: 'convertMeasurements',
      value: function convertMeasurements(data) {
        var _this5 = this;

        return data.map(function (record) {
          var recordCopy = Object.assign({}, record);

          var conversionFactors = {
            distanciaPercorrida: 0.621371,
            consumoCombustivel: 0.264172,
            mediaConsumo: 2.352,
            distanciaPercorridaConvertida: 0.621371,
            mediaConsumoEletrico: 0.621371,
            hodometroFimCalculado: 0.621371,
            hodometroInicio: 0.621371
          };

          for (var field in conversionFactors) {
            if (field in recordCopy) {
              var isDistanceField = ['distanciaPercorrida', 'distanciaPercorridaConvertida', 'mediaConsumoEletrico', 'hodometroFimCalculado', 'hodometroInicio'].includes(field),
                  isFuelField = ['consumoCombustivel', 'mediaConsumo'].includes(field);
              if (isDistanceField && _this5.measurementUnits.distanceMeasurement !== 'KM' || isFuelField && _this5.measurementUnits.fuelMeasurement !== 'LITERS') {
                recordCopy[field] *= conversionFactors[field];
              }
            }
          }
          return recordCopy;
        });
      }
    }, {
      key: 'consultarPermissaoChecklist',
      value: function consultarPermissaoChecklist(filtro) {
        var _this6 = this;

        return this.q(function (resolve) {
          _this6.restangular.one('/mobile/config/uo/' + filtro.uo + '/vdrivers').get().then(function (item) {
            _this6.hasPermissaoChecklist = item.vdriverConfig.habilitarChecklist;
            resolve();
          }).catch(function () {
            _this6.hasPermissaoChecklist = false;
            resolve();
          });
        });
      }
    }, {
      key: 'consultarSensorAcionado',
      value: function consultarSensorAcionado() {
        var _this7 = this;

        return this.authenticator.getUser().then(function (user) {
          var usuarioUoId = user.plain().uo.id;

          _this7.veiculoServiceV2.hasSensor(usuarioUoId).then(function (hasSensor) {
            _this7.hasSensorAcionado = hasSensor;
          });
        });
      }
    }, {
      key: 'getUrlBDVDetalhe',
      value: function getUrlBDVDetalhe(id, dia, motorista) {
        return '/relatorios/bdv/detalhes/' + id + '/' + dia + '?' + (this.isDemo ? 'demo&motorista=' + motorista : '');
      }
    }, {
      key: 'getUrlChecklist',
      value: function getUrlChecklist(bdv) {
        return '/relatorios/bdv/checklist/' + bdv.id + '/' + bdv.dia;
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/boletim/bv/csv?' + this.httpParamSerializer(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
      }
    }]);

    return BdvCtrl;
  }();

  /**
   * @ngdoc object
   * @name bdv.controller:BdvCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.bdv').controller('BdvCtrl', BdvCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.bds', ['ui.router', 'restangular', 'pascalprecht.translate', 'ModuleMapasUtil', 'leaflet-directive', 'ModuleEventos', 'vflashModule', 'mapas', 'angularMoment', 'onboarding', 'confluenceID', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'urlConfigModule', 'smart-table', 'relatorios', 'cadastros.veiculo']).factory('Bds', function (Restangular) {
    var url = 'boletim/bs';

    var service = Restangular.service(url);

    service.getDetalhes = function (execucaoServico) {
      return Restangular.one(url + '/' + execucaoServico).get();
    };
    return service;
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.bds', {
      url: '/relatorios/bds?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/bds/bds.tpl.html',
          controller: 'BdsCtrl',
          controllerAs: 'bds'
        }
      },
      data: {
        titulo: 'ce.boletim.servicos.titulo',
        tituloDescricao: 'ce.boletim.servicos.tituloDescricao',
        role: 'BOLETIM_SERVICO_VISUALIZAR'
      }
    }).state('root.bdsDetalhes', {
      url: '/relatorios/bds/:execucaoServico',
      views: {
        'content@': {
          templateUrl: 'relatorios/bds/bds-detalhes.tpl.html',
          controller: 'BdsDetalhesCtrl',
          controllerAs: 'bdsDetalhes'
        }
      },
      data: {
        titulo: 'ce.boletim.servicos.servicosDetalhes.titulo',
        tituloDescricao: 'ce.boletim.servicos.servicosDetalhes.tituloDescricao',
        backButton: true,
        backState: 'root.bds',
        role: 'BOLETIM_SERVICO_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.bds').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, L */

  var BdsDetalhesCtrl = function () {
    function BdsDetalhesCtrl($stateParams, Bds, MapasUtil, $filter, $scope, leafletData, Eventos, VFlash, SpiderfierService, MarkerService, moment, ServiceVfiltro, FactoryVfiltro, $translate) {
      var _this = this;

      _classCallCheck(this, BdsDetalhesCtrl);

      this.stateParams = $stateParams;
      this.bsService = Bds;
      this.mapasUtilService = MapasUtil;
      this.spiderfierService = SpiderfierService;
      this.markerService = MarkerService;
      this.filter = $filter;
      this.scope = $scope;
      this.moment = moment;
      this.todosSegmentos = false;
      this.distancia = 0;
      this.motoristas = [];
      this.veiculos = [];
      this.segmentos = [];
      this.segmentoSelecionado = null;
      this.leafletData = leafletData;
      this.eventos = Eventos;
      this.flash = VFlash;
      this.titulo = null;
      this.logradouroInicio = null;
      this.logradouroFim = null;
      this.indexSegmento = 0;
      this.duracao = 0;
      this.translate = $translate;

      this.tiles = MapasUtil.tiles.veltec;
      this.defaults = MapasUtil.defaults;
      this.geoJson = {};
      this.mapCenter = MapasUtil.getCenter();
      this.markersGroup = new L.FeatureGroup();
      this.pathGroup = new L.FeatureGroup();
      this.eventoSelecionado = '';

      this.onClickTipoEvento = this.filtraEvento();
      this.onClickPosicao = this.destacarMarcador();
      this.markersPorPosicao = new Map();

      this.setMapEvents();
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.loadServerData();
      }).catch(function () {
        _this.leafletData.unresolveMap('bds-map');
      });

      this.leafletData.getMap('bds-map').then(function (map) {
        return _this.scope.$broadcast('initPontoReferencia', map);
      });
    }

    _createClass(BdsDetalhesCtrl, [{
      key: 'filtraEvento',
      value: function filtraEvento() {
        var _this2 = this;

        return function (index) {
          _this2.eventoSelecionado = index;
          if (_this2.segmentos.length === 0) {
            _this2.flash.filterWarn();
          } else if (_this2.todosSegmentos) {
            _this2.selecionarTodosSegmentos();
          } else {
            _this2.limparVariaveisLayers();
            _this2.popularDadosDoSegmento(_this2.segmentoSelecionado);
            _this2.inserirSegmentoNoMapa(_this2.segmentoSelecionado);
          }
        };
      }
    }, {
      key: 'destacarMarcador',
      value: function destacarMarcador() {
        var _this3 = this;

        return function (posicao) {
          return _this3.leafletData.getMap('bds-map').then(function (map) {
            var marker = _this3.markersPorPosicao.get(posicao);
            map.panTo(marker.getLatLng());
            marker.openPopup(marker.getLatLng());
          });
        };
      }
    }, {
      key: 'loadServerData',
      value: function loadServerData() {
        var _this4 = this;

        if (angular.isUndefined(this.stateParams.execucaoServico)) {
          return;
        }

        this.bsService.getDetalhes(this.stateParams.execucaoServico).then(function (data) {
          var movimento = _this4.translate.instant('ce.enum.eventos.movimento');
          _this4.segmentos = data.map(function (segmento) {
            // Icone parado 1 esta sobrecarregando. Removido até proximo sprint.
            segmento.posicoes.forEach(function (posicao) {
              if (posicao.evento === _this4.translate.instant(_this4.eventos.PARADO.tipo) && posicao.duracao <= 300) {
                posicao.evento = movimento;
              }
              if (posicao.evento === _this4.translate.instant('ce.enum.eventos.pontoDeReferencia')) {
                posicao.evento = movimento;
              }
            });

            segmento.posicoes = _this4.mapasUtilService.ajustarEventos(segmento.posicoes);
            _this4.mapasUtilService.marcarPosicoesInvalidasNoInicio(segmento.posicoes);

            segmento.inicio = _this4.moment(segmento.inicio);
            segmento.fim = _this4.moment(segmento.fim);
            segmento.duracao = segmento.fim.diff(segmento.inicio, 'seconds');
            segmento.horario = segmento.inicio.format('HH:mm:ss') + ' - ' + segmento.fim.format('HH:mm:ss');
            segmento.posicoes = segmento.posicoes;
            segmento.ativo = false;
            segmento.intervalos.forEach(function (intervalo) {
              return intervalo.ativo = false;
            });
            return segmento;
          });

          if (_this4.segmentos.length === 0) {
            _this4.flash.filterWarn();
          } else {
            _this4.selecionarTodosSegmentos();
          }
        });
      }
    }, {
      key: 'selecionarTodosSegmentos',
      value: function selecionarTodosSegmentos() {
        var _this5 = this;

        this.limparVariaveisLayers();
        this.resumoPeriodo = this.segmentos;
        var primeiroSegmento = this.segmentos[0],
            ultimoSegmento = this.segmentos[this.segmentos.length - 1];
        this.segmentos.forEach(function (segmento) {
          _this5.distancia += segmento.distancia;
          _this5.titulo = segmento.servico.nome + ' - ' + _this5.moment(segmento.inicioPrevisto).format('DD/MM/YYYY');
          _this5.motoristas.push(segmento.motorista);
          _this5.veiculos.push(segmento.veiculo);
          segmento.ativo = false;
          var posicoes = _.sortBy(_this5.mapasUtilService.flatPosicoes(segmento.posicoes), 'data'),
              posicoesValidas = posicoes.filter(function (p) {
            return p.valida;
          });
          _this5.setPath(posicoesValidas);
          _this5.setPathEventos(posicoesValidas, _this5.eventoSelecionado);
        });

        this.logradouroInicio = primeiroSegmento.logradouroInicio;
        this.logradouroFim = ultimoSegmento.logradouroFim;
        this.motoristas = _.uniq(this.motoristas);
        this.veiculos = _.uniq(this.veiculos);
        this.duracao = this.moment(ultimoSegmento.fim).diff(this.moment(primeiroSegmento.inicio), 'seconds');
        this.todosSegmentos = true;
        var posicoes = [];
        this.segmentos.map(function (segmento) {
          segmento.posicoes.map(function (posicao) {
            posicoes.push(posicao);
          });
        });
        this.insertMarkers(this.filtraMarkers(posicoes));
      }
    }, {
      key: 'limparVariaveisLayers',
      value: function limparVariaveisLayers() {
        this.pathGroup.clearLayers();
        this.markersGroup.clearLayers();
        this.veiculos = [];
        this.motoristas = [];
        this.distancia = 0;
        this.markersPorPosicao.clear();
      }
    }, {
      key: 'selecionarSegmento',
      value: function selecionarSegmento(segmento, index) {
        this.indexSegmento = index;
        this.limparVariaveisLayers();
        this.resumoPeriodo = [segmento];
        this.popularDadosDoSegmento(segmento, index);
        this.inserirSegmentoNoMapa(segmento);
        this.collapseSegmentos(index);
      }
    }, {
      key: 'popularDadosDoSegmento',
      value: function popularDadosDoSegmento(segmento, index) {
        this.titulo = segmento.servico.nome + ' - ' + this.moment(segmento.inicioPrevisto).format('DD/MM/YYYY');
        this.todosSegmentos = false;
        this.indexSegmento = index;
        this.segmentoSelecionado = segmento;
        this.logradouroInicio = this.segmentoSelecionado.logradouroInicio;
        this.logradouroFim = this.segmentoSelecionado.logradouroFim;
        this.motoristas = [segmento.motorista];
        this.veiculos = [segmento.veiculo];
        this.distancia = segmento.distancia;
        this.duracao = segmento.duracao;
      }
    }, {
      key: 'inserirSegmentoNoMapa',
      value: function inserirSegmentoNoMapa(segmento) {
        var posicoes = _.sortBy(this.mapasUtilService.flatPosicoes(segmento.posicoes), 'data');
        this.setPath(posicoes);
        this.setPathEventos(posicoes, this.eventoSelecionado);
        this.insertMarkers(this.filtraMarkers(segmento.posicoes));
      }
    }, {
      key: 'collapseSegmentos',
      value: function collapseSegmentos(indexSegmentoClicado) {
        this.segmentos.forEach(function (s, index) {
          if (index === indexSegmentoClicado) {
            s.ativo = !s.ativo;
            s.intervalos.forEach(function (i) {
              return i.ativo = true;
            });
          } else {
            s.ativo = false;
          }
        });
      }
    }, {
      key: 'setMapEvents',
      value: function setMapEvents() {
        angular.extend(this.scope, {
          events: {
            map: {
              enable: ['click'],
              logic: 'emit'
            },
            markers: {
              enable: ['click'],
              logic: 'emit'
            }
          }
        });
      }
    }, {
      key: 'insertMarkers',
      value: function insertMarkers(trechos) {
        var _this6 = this;

        var fit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        this.leafletData.getMap('bds-map').then(function (map) {
          var oms = _this6.spiderfierService.createSpiderfier(map);
          _this6.markersGroup.clearLayers();

          _this6.markersPorPosicao = _this6.markerService.buildMarkersAssociadosAsPosicoes(_.flatten(trechos), _this6.eventoSelecionado, 'bds-');

          _this6.markersPorPosicao.forEach(function (marker) {
            _this6.markersGroup.addLayer(marker);
            if (!_this6.eventos.isLocalizacao(marker.options.evento)) {
              oms.addMarker(marker);
            }
          });

          if (!map.hasLayer(_this6.markersGroup)) {
            map.addLayer(_this6.markersGroup);
          }
          if (fit) {
            map.fitBounds(_this6.markersGroup.getBounds(), { padding: [100, 100] });
          }
        });
      }
    }, {
      key: 'setPath',
      value: function setPath(posicoes) {
        var _this7 = this;

        this.leafletData.getMap('bds-map').then(function (map) {
          var routeLines = L.polyline(posicoes.map(function (p) {
            return [p.latitude, p.longitude];
          }), {
            color: '#3388FF',
            opacity: 0.75,
            weight: 3
          });
          L.polylineDecorator(routeLines, {
            patterns: [{
              offset: 0,
              repeat: 300,
              symbol: L.Symbol.arrowHead({
                pixelSize: 12,
                pathOptions: { fillOpacity: 0.75, color: '#0033FF', weight: 0 }
              })
            }]
          }).addTo(_this7.pathGroup);
          _this7.pathGroup.addLayer(routeLines);

          if (!map.hasLayer(_this7.pathGroup)) {
            map.addLayer(_this7.pathGroup);
          }
        });
      }
    }, {
      key: 'setPathEventos',
      value: function setPathEventos(posicoes, e) {
        var _this8 = this;

        this.leafletData.getMap('bds-map').then(function (map) {
          posicoes.filter(function (p) {
            return _this8.isEvento(p, e);
          }).map(function (p) {
            var coord = [[p.latitude, p.longitude]],
                routeEventsLines = null;
            if (angular.isDefined(p.fim)) {
              coord = coord.concat(_this8.getPosicoesDentroDoPeriodoDoEvento(p, posicoes));
              coord.push([p.fim.latitude, p.fim.longitude]);
            }
            routeEventsLines = L.polyline(coord, {
              color: 'red',
              weight: 3
            });
            _this8.pathGroup.addLayer(routeEventsLines);
          });

          if (!map.hasLayer(_this8.pathGroup)) {
            map.addLayer(_this8.pathGroup);
          }
        });
      }
    }, {
      key: 'getPosicoesDentroDoPeriodoDoEvento',
      value: function getPosicoesDentroDoPeriodoDoEvento(posicao, posicoes) {
        var _this9 = this;

        return posicoes.filter(function (p) {
          return _this9.isDentroDoPeriodo(p, posicao);
        }).map(function (p) {
          return [p.latitude, p.longitude];
        });
      }
    }, {
      key: 'isDentroDoPeriodo',
      value: function isDentroDoPeriodo(posicao, posicaoPeriodo) {
        return new Date(posicaoPeriodo.data) < new Date(posicao.data) && new Date(posicaoPeriodo.fim.data) > new Date(posicao.data);
      }
    }, {
      key: 'isEvento',
      value: function isEvento(p, e) {
        if (e === this.translate.instant(this.eventos.EXCESSO_VELOCIDADE.tipo)) {
          return this.eventos.isExcessoVelocidade(p.evento);
        } else if (e === this.translate.instant(this.eventos.CURVA_BRUSCA.tipo)) {
          return this.eventos.isCurvaBrusca(p.evento);
        }
        return e === '' || p.evento === e;
      }
    }, {
      key: 'selecionarIntervalo',
      value: function selecionarIntervalo(segmento, intervalo) {
        var _this10 = this;

        var posicoesNoPeriodo = segmento.posicoes.filter(function (p) {
          return _this10.moment(p.data).isBetween(intervalo.pontos[0].horario, intervalo.pontos[1].horario);
        });

        this.insertMarkers(this.filtraMarkers(posicoesNoPeriodo), false);

        this.logradouroInicio = intervalo.pontos[0].nome;
        this.logradouroFim = intervalo.pontos[1].nome;
        this.duracao = intervalo.duracao;
        this.distancia = intervalo.distancia;
        this.excessoVelocidade = intervalo.excessosVelocidade;
        this.aceleracoesBruscas = intervalo.aceleracoes;
        this.frenagensBruscas = intervalo.frenagens;
        this.curvasBruscas = intervalo.curvas;
        this.banguela = intervalo.banguelas;
        this.rpmExcessivo = intervalo.rpmExcessivos;
        this.motorOcioso = intervalo.motorOcioso;
        this.todosSegmentos = false;

        this.ativarIntervalo(segmento, intervalo);

        this.leafletData.getMap('bds-map').then(function (map) {
          var primeiroPonto = new L.LatLng(intervalo.pontos[0].latitude, intervalo.pontos[0].longitude),
              segundoPonto = new L.LatLng(intervalo.pontos[1].latitude, intervalo.pontos[1].longitude);

          map.fitBounds(L.latLngBounds(primeiroPonto, segundoPonto), { padding: [100, 100] });
        });
      }
    }, {
      key: 'ativarIntervalo',
      value: function ativarIntervalo(segmento, intervalo) {
        this.segmentos.forEach(function (s) {
          var isSelecionado = segmento === s;
          s.ativo = isSelecionado;
          if (isSelecionado) {
            s.intervalos.forEach(function (i) {
              return i.ativo = intervalo === i;
            });
          }
        });
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }, {
      key: 'filtraMarkers',
      value: function filtraMarkers(posicoes) {
        var _this11 = this;

        return posicoes.filter(function (p) {
          return p.valida && p.descricao !== _this11.translate.instant('ce.enum.eventos.analiseOperacional');
        });
      }
    }]);

    return BdsDetalhesCtrl;
  }();

  angular.module('relatorios.bds').controller('BdsDetalhesCtrl', BdsDetalhesCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BdsCtrl = function () {
    function BdsCtrl($httpParamSerializer, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, Bds, v3gTableLimitService, moment, sortAlertasIndicadores, VtabelaFactory, uiGridConstants, UrlConfigService) {
      var _this = this;

      _classCallCheck(this, BdsCtrl);

      this.httpParamSerializer = $httpParamSerializer;
      this.bsService = Bds;
      this.moment = moment;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.v3gTableLimitService = v3gTableLimitService;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.urlConfigService = UrlConfigService;

      this.vtabela = null;
      this.relatorio = null;
      this.uoSelecionada = null;
      this.currentPage = 0;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.tableState.sort.predicate = sortAlertasIndicadores[this.tableState.sort.predicate];

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        dateLimit: 30,
        maxDate: this.moment().endOf('day').format(),
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo',
        key: this.keys.uo.name
      }, {
        name: 'uoParceira',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'veiculo',
        key: this.keys.veiculo.name,
        size: 6
      }, {
        name: 'motorista',
        key: this.keys.motorista.name,
        size: 6
      }, {
        name: 'linha',
        key: this.keys.linha.name,
        size: 6
      }, {
        name: 'servico',
        key: this.keys.servico.name,
        size: 6
      }])).then(function (filtro) {
        _this.consultar(ServiceVfiltro.getFiltroBackendNovo(filtro));
      });
    }

    _createClass(BdsCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          exporterPdfFilename: 'Boletim Diário de Serviço PDF.pdf',
          exporterCsvFilename: 'Boletim Diário de Serviço CSV.csv',
          exporterExcelFilename: 'Boletim Diário de Serviço XLSX.xlsx',
          appScopeProvider: this,
          enableFiltering: false,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          showColumnFooter: true,
          columnDefs: [{
            name: 'servico',
            displayName: 'ce.boletim.servicos.colunas.servico',
            enableHiding: false,
            pinnedLeft: true,
            width: 150,
            aggregationTotalTitle: 'Total'
          }, {
            name: 'linha',
            displayName: 'ce.boletim.servicos.colunas.linha'
          }, {
            name: 'prefixoPlaca',
            displayName: 'ce.boletim.servicos.colunas.veiculos',
            enableHiding: false
          }, {
            name: 'motoristasNome',
            displayName: 'ce.boletim.servicos.colunas.motoristas',
            enableHiding: false
          }, {
            name: 'dia',
            displayName: 'ce.boletim.servicos.colunas.dia',
            type: 'date',
            cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\''
          }, {
            name: 'distancia',
            displayName: 'ce.boletim.servicos.colunas.distanciaPercorrida',
            cellClass: 'text-center',
            headerCellClass: 'text-center',
            cellFilter: 'decimalWithLabel:\'Km\'',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'tempoIgnicaoLigada',
            displayName: 'ce.boletim.servicos.colunas.tempoIgnicaoLigada',
            cellFilter: 'humanizedDuration',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'aceleracoesBruscas',
            displayName: 'ce.boletim.servicos.colunas.aceleracoesBruscas',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'frenagensBruscas',
            displayName: 'ce.boletim.servicos.colunas.frenagensBruscas',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'curvasBruscas',
            displayName: 'ce.boletim.servicos.colunas.curvasBruscas',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'banguelas',
            displayName: 'ce.boletim.servicos.colunas.banguela',
            cellFilter: 'humanizedDuration',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'rpmExcessivos',
            displayName: 'ce.boletim.servicos.colunas.rpmExcessivo',
            cellFilter: 'humanizedOrUndefinedWithLabel:\'-\'',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'excessosVelocidade',
            displayName: 'ce.boletim.servicos.colunas.excessoVelocidade',
            cellFilter: 'humanizedDuration',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'motorOcioso',
            displayName: 'ce.boletim.servicos.colunas.paradoLigado',
            cellFilter: 'humanizedOrUndefinedWithLabel:\'-\'',
            headerCellClass: 'text-center',
            cellClass: 'text-center',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'logradouroInicial',
            displayName: 'ce.boletim.servicos.colunas.logradouroInicial'
          }, {
            name: 'logradouroFinal',
            displayName: 'ce.boletim.servicos.colunas.logradouroFinal'
          }, {
            name: 'detalhe',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            cellTemplate: '\n                <div class="ui-grid-cell-contents vtabela-icone-detalhado">\n                  <a\n                    id=\'btn-detalhes-{{$index}}\'\n                    ui-sref="root.bdsDetalhes({execucaoServico: row.entity.execucaoServico})">\n                    <span class="glyphicon glyphicon-zoom-in" aria-hidden=\'true\'></span>\n                  </a>\n                </div>'
          }]
        };

        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          servico: item.servico,
          linha: item.linha,
          prefixoPlaca: item.prefixoPlaca,
          motoristasNome: item.motoristasNome,
          dia: item.inicioPrevisto,
          distancia: item.distancia >= 0 ? item.distancia : 0,
          tempoIgnicaoLigada: item.tempoDirecao,
          aceleracoesBruscas: item.aceleracoes,
          frenagensBruscas: item.frenagens,
          curvasBruscas: item.curvas,
          banguelas: item.banguelas,
          rpmExcessivos: item.rpmExcessivos,
          excessosVelocidade: item.excessosVelocidade,
          motorOcioso: item.motorOcioso,
          logradouroInicial: item.logradouroInicial,
          logradouroFinal: item.logradouroFinal,
          execucaoServico: item.execucaoServico
        };
      }
    }, {
      key: 'consultar',
      value: function consultar(filtro) {
        var _this2 = this;

        this.bsService.one().get(filtro).then(function (data) {
          _this2.vtabela = _this2.vtabelaFactory.get(_this2.initVtabela(), _this2.serviceVfiltro.factoryVfiltro.user, 'relatorioBDS', 'v1');
          _this2.vtabela.setData(data.list.map(function (i) {
            return _this2.getItemVtabela(i);
          }));
        });
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/boletim/bs/csv?' + this.httpParamSerializer(this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar));
      }
    }]);

    return BdsCtrl;
  }();

  /**
   * @ngdoc object
   * @name bds.controller:BdsCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.bds').controller('BdsCtrl', BdsCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.bdm', ['ui.router', 'restangular', 'pascalprecht.translate', 'ModuleMapasUtil', 'leaflet-directive', 'ModuleEventos', 'vflashModule', 'mapas', 'angularMoment', 'onboarding', 'confluenceID', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'urlConfigModule', 'smart-table', 'motoristaModule', 'uoModule', 'relatorios', 'cadastros.veiculo', 'httpServiceV3gModule', 'ModuleMeasurementUnitConverter', 'ConfigEventosModule']).factory('Bdm', function (Restangular) {
    var url = 'boletim/bdm';

    var service = Restangular.service(url);

    service.getDetalhes = function (motoristaId, dia) {
      return Restangular.one(url + '/detalhes?motoristaId=' + motoristaId + '&dia=' + dia).get();
    };

    return service;
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.bdm', {
      url: '/relatorios/bdm?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/bdm/bdm.tpl.html',
          controller: 'BdmCtrl',
          controllerAs: 'bdm'
        }
      },
      data: {
        titulo: 'ce.boletim.diarioMotorista.titulo',
        tituloDescricao: 'ce.boletim.diarioMotorista.tituloDescricao',
        roles: [['BOLETIM_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    }).state('root.bdmDetalhes', {
      url: '/relatorios/bdm/detalhes/:motoristaId/:dia',
      views: {
        'content@': {
          templateUrl: 'relatorios/bdm/bdm-detalhes.tpl.html',
          controller: 'BdmDetalhesCtrl',
          controllerAs: 'bdmDetalhes'
        }
      },
      data: {
        titulo: 'ce.boletim.diarioMotoristaDetalhes.titulo',
        tituloDescricao: 'ce.boletim.diarioMotoristaDetalhes.tituloDescricao',
        backButton: true,
        backState: 'root.bdm',
        roles: [['BOLETIM_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }

  angular.module('relatorios.bdm').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.bdm').constant('MockBDM', [{
    id: 1,
    data: {
      total: 2,
      list: [{
        motorista: { id: 1, nome: 'André Castanheira' },
        departamento: 'Coletas',
        veiculos: 'VW81502-AOI7238, FSADF45-VXZ9045',
        dia: '2016-01-15',
        excessosVelocidade: 900,
        distanciaPercorrida: 10000,
        aceleracoes: 5,
        frenagens: 2,
        curvas: 3,
        tempoDirecao: 3600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }, {
        motorista: { id: 1, nome: 'André Castanheira' },
        departamento: 'Coletas',
        veiculos: 'VW81502-AOI7238, FSADF45-VXZ9045',
        dia: '2016-01-15',
        excessosVelocidade: 90,
        distanciaPercorrida: 2341,
        aceleracoes: 1,
        frenagens: 0,
        curvas: 0,
        tempoDirecao: 1600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }]
    }
  }, {
    id: 2,
    data: {
      total: 2,
      list: [{
        motorista: { id: 2, nome: 'Gil Larangeira' },
        departamento: 'Coletas',
        veiculos: 'ANGA01-ANR1131',
        dia: '2016-01-15',
        excessosVelocidade: 0,
        distanciaPercorrida: 10000,
        aceleracoes: 0,
        frenagens: 1,
        curvas: 1,
        tempoDirecao: 3600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }, {
        motorista: { id: 2, nome: 'Gil Larangeira' },
        departamento: 'Coletas',
        veiculos: 'ANGA01-ANR1131',
        dia: '2016-01-15',
        excessosVelocidade: 50,
        distanciaPercorrida: 2536,
        aceleracoes: 1,
        frenagens: 1,
        curvas: 2,
        tempoDirecao: 1600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }]
    }
  }, {
    id: 3,
    data: {
      total: 2,
      list: [{
        motorista: { id: 3, nome: 'Iberê Lages' },
        departamento: 'Entregas',
        veiculos: 'VCBZ45-UKT3556',
        dia: '2016-01-15',
        excessosVelocidade: 100,
        distanciaPercorrida: 1000,
        aceleracoes: 5,
        frenagens: 1,
        curvas: 1,
        tempoDirecao: 3600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }, {
        motorista: { id: 3, nome: 'Iberê Lages' },
        departamento: 'Entregas',
        veiculos: 'VCBZ45-UKT3556',
        dia: '2016-01-15',
        excessosVelocidade: 50,
        distanciaPercorrida: 2536,
        aceleracoes: 1,
        frenagens: 1,
        curvas: 2,
        tempoDirecao: 1600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }]
    }
  }, {
    id: 4,
    data: {
      total: 2,
      list: [{
        motorista: { id: 4, nome: 'Silvério Mansilla' },
        departamento: 'Coletas',
        veiculos: 'VCBZ45-UKT3556',
        dia: '2016-01-15',
        excessosVelocidade: 100,
        distanciaPercorrida: 1000,
        aceleracoes: 5,
        frenagens: 1,
        curvas: 1,
        tempoDirecao: 3600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }, {
        motorista: { id: 4, nome: 'Silvério Mansilla' },
        departamento: 'Coletas',
        veiculos: 'VCBZ45-UKT3556',
        dia: '2016-01-15',
        excessosVelocidade: 50,
        distanciaPercorrida: 2536,
        aceleracoes: 1,
        frenagens: 1,
        curvas: 2,
        tempoDirecao: 1600,
        trepidacoes: 0,
        banguelas: 1,
        rpmExcessivos: 1,
        tempoMotorOcioso: 0,
        logradouroInicio: 'Avenida Santos Dumont',
        logradouroFim: 'Rua Fernando de Noronha'
      }]
    }
  }]).constant('MockBDMDetalhes', [{
    motoristaId: 28232,
    veiculoId: 14932,
    veiculo: 'MLY3551 - MLY3551',
    motorista: 'Daniel Cesar Romano Luvizotto',
    posicoes: [{
      latitude: -23.317081451416016,
      longitude: -51.14942932128906,
      direcao: 143,
      hodometro: 2472000,
      hodometroAjustado: -1781100,
      velocidade: 0,
      gsm: true,
      evento: 'Ignição ligada',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:30:06.000Z'
    }, {
      latitude: -23.31456184387207,
      longitude: -51.151676177978516,
      direcao: 282,
      hodometro: 2472000,
      hodometroAjustado: -1781100,
      velocidade: 38,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:30:26.000Z'
    }, {
      latitude: -23.314363479614258,
      longitude: -51.15803909301758,
      direcao: 267,
      hodometro: 2473000,
      hodometroAjustado: -1780100,
      velocidade: 19,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:32:23.000Z'
    }, {
      latitude: -23.314422607421875,
      longitude: -51.16783142089844,
      direcao: 275,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 40,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:37:01.000Z'
    }, {
      latitude: -23.314300537109375,
      longitude: -51.16800308227539,
      direcao: 310,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 27,
      gsm: true,
      evento: 'Curva brusca',
      limiar: 'Limite: 0.6097 G',
      intensidade: '',
      gps: 'Inválido',
      duracao: 0,
      data: '2017-12-11T19:37:04.000Z'
    }, {
      latitude: -23.314300537109375,
      longitude: -51.16800308227539,
      direcao: 310,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 27,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:37:04.000Z'
    }, {
      latitude: -23.314014434814453,
      longitude: -51.16798782348633,
      direcao: 354,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 36,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:37:07.000Z'
    }, {
      latitude: -23.31338119506836,
      longitude: -51.167945861816406,
      direcao: 44,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:37:19.000Z'
    }, {
      latitude: -23.313220977783203,
      longitude: -51.16796112060547,
      direcao: 2,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 25,
      gsm: true,
      evento: 'Aceleração Brusca',
      limiar: 'Limite: 18,5 Km/h/s',
      intensidade: '',
      gps: 'Inválido',
      duracao: 0,
      data: '2017-12-11T19:37:34.000Z'
    }, {
      latitude: -23.313220977783203,
      longitude: -51.16796112060547,
      direcao: 2,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 25,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:37:34.000Z'
    }, {
      latitude: -23.307857513427734,
      longitude: -51.16816329956055,
      direcao: 295,
      hodometro: 2474000,
      hodometroAjustado: -1779100,
      velocidade: 14,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:39:05.000Z'
    }, {
      latitude: -23.30779266357422,
      longitude: -51.17018508911133,
      direcao: 264,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 12,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:39:26.000Z'
    }, {
      latitude: -23.307714462280273,
      longitude: -51.1707763671875,
      direcao: 271,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 28,
      gsm: true,
      evento: 'Movimento',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:40:20.000Z'
    }, {
      latitude: -23.30774688720703,
      longitude: -51.17216873168945,
      direcao: 230,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 7,
      gsm: true,
      evento: 'Curva brusca',
      limiar: 'Limite: 0.6097 G',
      intensidade: '',
      gps: 'Inválido',
      duracao: 0,
      data: '2017-12-11T19:40:39.000Z'
    }, {
      latitude: -23.30774688720703,
      longitude: -51.17216873168945,
      direcao: 230,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:40:39.000Z'
    }, {
      latitude: -23.30780029296875,
      longitude: -51.17219161987305,
      direcao: 189,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:40:45.000Z'
    }, {
      latitude: -23.30794906616211,
      longitude: -51.1721305847168,
      direcao: 130,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:40:57.000Z'
    }, {
      latitude: -23.30797576904297,
      longitude: -51.17205810546875,
      direcao: 81,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:41:03.000Z'
    }, {
      latitude: -23.307994842529297,
      longitude: -51.171695709228516,
      direcao: 37,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Parado',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:41:24.000Z'
    }, {
      latitude: -23.3079833984375,
      longitude: -51.17171096801758,
      direcao: 37,
      hodometro: 2475000,
      hodometroAjustado: -1778100,
      velocidade: 0,
      gsm: true,
      evento: 'Ignição desligada',
      limiar: '-',
      intensidade: '-',
      gps: 'Precisão alta',
      duracao: 0,
      data: '2017-12-11T19:45:24.000Z'
    }],
    banguela: 0,
    excessoVelocidade: 0,
    rpmExcessivo: 0,
    curvasBruscas: 2,
    aceleracoesBruscas: 1,
    trepidacoes: 0,
    distanciaPercorrida: 3000,
    inicio: '2017-12-11T19:29:53Z',
    fim: '2017-12-11T19:45:24Z',
    departamento: 'PRODUTO',
    freadasBruscas: 0,
    motorOcioso: 0,
    localChegada: 'Rua Fernando de Noronha',
    localSaida: 'Avenida Santos Dumont'
  }]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, L, Intl, Blob */

  var BdmDetalhesCtrl = function () {
    function BdmDetalhesCtrl($window, $stateParams, Bdm, MapasUtil, $filter, $scope, $compile, leafletData, Eventos, VFlash, $location, SpiderfierService, MarkerService, moment, Onboarding, MockBDMDetalhes, IDBDMDetalhes, ServiceVfiltro, FactoryVfiltro, $translate, HttpServiceV3g, $rootScope, MeasurementUnitConverterService) {
      var _this = this;

      _classCallCheck(this, BdmDetalhesCtrl);

      this.translate = $translate;
      this.window = $window;
      this.stateParams = $stateParams;
      this.bdmService = Bdm;
      this.mapasUtilService = MapasUtil;
      this.spiderfierService = SpiderfierService;
      this.markerService = MarkerService;
      this.location = $location;
      this.onboarding = Onboarding;
      this.mockBDMDetalhes = MockBDMDetalhes;
      this.idConfluence = IDBDMDetalhes;
      this.httpService = HttpServiceV3g;
      this.filter = $filter;
      this.scope = $scope;
      this.compile = $compile;
      this.moment = moment;
      this.todasVigencias = false;
      this.motorista = null;
      this.inicio = null;
      this.duracaoTotal = 0;
      this.duracao = null;
      this.distancia = 0;
      this.distanciaRelativaConsumo = 0;
      this.distanciaRelativaConsumoEletrico = 0;
      this.veiculos = [];
      this.detalhes = [];
      this.vigenciaSelecionada = null;
      this.leafletData = leafletData;
      this.eventos = Eventos;
      this.translate = $translate;
      this.flash = VFlash;
      this.logradouroInicio = null;
      this.logradouroFim = null;

      this.tiles = MapasUtil.tiles.veltec;
      this.defaults = MapasUtil.defaults;
      this.geoJson = {};
      this.mapCenter = MapasUtil.getCenter();
      this.markersGroup = new L.FeatureGroup();
      this.pathGroup = new L.FeatureGroup();
      this.eventoSelecionado = '';

      this.onClickTipoEvento = this.filtraEvento();
      this.onClickPosicao = this.destacarMarcador();
      this.markersPorPosicao = new Map();
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.eventoDescida = this.translate.instant(this.eventos.DESCIDA.tipo);
      this.eventoDescidaFaixa1 = this.translate.instant(this.eventos.DESCIDA_FAIXA1.tipo);
      this.eventoDescidaFaixa2 = this.translate.instant(this.eventos.DESCIDA_FAIXA2.tipo);
      this.eventoDescidaFaixa3 = this.translate.instant(this.eventos.DESCIDA_FAIXA3.tipo);
      this.faixasDescida = {
        segundosFaixa1: 5,
        segundosFaixa2: 30
      };

      this.rootScope = $rootScope;
      this.measurementUnitConverterService = MeasurementUnitConverterService;

      this.dateTimeFormat = this.measurementUnitConverterService.getDateFormat(this.rootScope.usuario.measurementUnits.dateTimeFormat);
      this.distanceUnit = this.measurementUnitConverterService.getDistanceUnit(this.rootScope.usuario.measurementUnits.distanceMeasurement);
      this.fuelUnit = this.measurementUnitConverterService.getFuelUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.fuelEfficiency = this.measurementUnitConverterService.getFuelEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.energyEfficiency = this.measurementUnitConverterService.getEnergyEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);

      this.setMapEvents();
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        var filtroLocalstorage = angular.fromJson(_this.window.localStorage.getItem('vfiltro-' + ServiceVfiltro.factoryVfiltro.user.id));
        filtroLocalstorage.dateTime = [_this.moment(_this.stateParams.dia, 'YYYY-MM-DD').startOf('day').format('YYYY.MM.DD.HH.mm.ss.ZZ'), _this.moment(_this.stateParams.dia, 'YYYY-MM-DD').endOf('day').format('YYYY.MM.DD.HH.mm.ss.ZZ')];
        filtroLocalstorage.motorista = _this.stateParams.motoristaId;
        _this.window.localStorage.setItem('vfiltro-' + ServiceVfiltro.factoryVfiltro.user.id, angular.toJson(filtroLocalstorage));
        _this.loadServerData();
      }).catch(function () {
        _this.leafletData.unresolveMap('bdm-map');
      });
    }

    _createClass(BdmDetalhesCtrl, [{
      key: 'filtraEvento',
      value: function filtraEvento() {
        var _this2 = this;

        return function (index) {
          _this2.eventoSelecionado = index;
          if (_this2.detalhes.length === 0) {
            _this2.flash.filterWarn();
          } else if (_this2.todasVigencias) {
            _this2.selecionarTodasVigencias();
          } else {
            _this2.limparVariaveisLayers();
            _this2.popularDadosDaVigencia(_this2.vigenciaSelecionada);
            _this2.inserirVigenciaNoMapa(_this2.vigenciaSelecionada);
          }
        };
      }
    }, {
      key: 'destacarMarcador',
      value: function destacarMarcador() {
        var _this3 = this;

        return function (posicao, centralizarFim) {
          return _this3.leafletData.getMap('bdm-map').then(function (map) {
            if (posicao.miscInfo && posicao.miscInfo.diferencaAltitude !== -1) {
              _this3.diferencaAltitude = posicao.miscInfo.diferencaAltitude;
            }
            var marker = _this3.markersPorPosicao.get(posicao);
            if (centralizarFim && angular.isDefined(posicao.fim)) {
              var markerFim = _this3.markersPorPosicao.get(posicao.fim);
              map.fitBounds([marker.getLatLng(), markerFim.getLatLng()]);
            } else {
              map.panTo(marker.getLatLng());
            }
            marker.openPopup(marker.getLatLng());
          });
        };
      }
    }, {
      key: 'loadServerData',
      value: function loadServerData() {
        var _this4 = this;

        this.isDemo = this.onboarding.startOnboarding(this.idConfluence);

        if (angular.isUndefined(this.stateParams.dia) || angular.isUndefined(this.stateParams.motoristaId)) {
          return;
        }

        if (this.isDemo) {
          var retorno = angular.copy(this.mockBDMDetalhes);
          retorno = retorno.map(function (x) {
            if (_this4.stateParams.motoristaId === 1) {
              x.motorista = 'André Castanheira';
            } else if (_this4.stateParams.motoristaId === 2) {
              x.motorista = 'Gil Larangeira';
            } else if (_this4.stateParams.motoristaId === 3) {
              x.motorista = 'Iberê Lages';
            } else {
              x.motorista = 'Silvério Mansilla';
            }

            x.veiculo = _this4.location.search().veiculo;

            return x;
          });
          this.setInfo(retorno);
        } else {
          this.bdmService.getDetalhes(this.stateParams.motoristaId, this.stateParams.dia).then(function (data) {
            return _this4.setInfo(data);
          });
        }
      }
    }, {
      key: 'setInfo',
      value: function setInfo(data) {
        var _this5 = this;

        this.detalhes = data.map(function (v) {
          // Icone parado 1 esta sobrecarregando. Removido até proximo sprint.
          v.posicoes.forEach(function (p) {
            if (p.evento === _this5.translate.instant(_this5.eventos.PARADO.tipo) && p.duracao <= 300) {
              p.evento = _this5.translate.instant('ce.enum.eventos.movimento');
            }
            if (p.evento === _this5.translate.instant('ce.enum.eventos.pontoDeReferencia')) {
              p.evento = _this5.translate.instant('ce.enum.eventos.movimento');
            }
          });
          _this5.faixasDescida = v.faixasDescida;
          v.posicoes = _this5.mapasUtilService.ajustarEventos(v.posicoes, v.faixasDescida);
          _this5.mapasUtilService.marcarPosicoesInvalidasNoInicio(v.posicoes);

          if (v.fim) {
            _this5.duracaoTotal += _this5.moment(v.fim, 'YYYY/MM/DD HH:mm:ssZ').diff(_this5.moment(v.inicio, 'YYYY/MM/DD HH:mm:ssZ'), 'seconds');
          }

          return { vigencia: v };
        });

        if (this.detalhes.length === 0) {
          this.flash.filterWarn();
        } else {
          this.inicio = this.detalhes[0].vigencia.inicio;
          this.selecionarTodasVigencias();
        }
      }
    }, {
      key: 'selecionarTodasVigencias',
      value: function selecionarTodasVigencias() {
        var _this6 = this;

        this.limparVariaveisLayers();
        if (!this.todasVigencias) {
          this.resumoPeriodo = this.detalhes.map(function (detalhe) {
            return detalhe.vigencia;
          });
        }

        this.mediaConsumo = null;
        this.consumoCombustivel = 0;
        this.mediaConsumoEletrico = null;
        this.consumoEletrico = 0;
        this.detalhes.forEach(function (element) {
          _this6.motorista = element.vigencia.motorista;
          _this6.distancia += element.vigencia.distanciaPercorrida;
          _this6.veiculos.push(element.vigencia.veiculo);
          var posicoes = _.sortBy(_this6.mapasUtilService.flatPosicoes(element.vigencia.posicoes), 'data'),
              posicoesValidas = posicoes.filter(function (p) {
            return p.valida;
          }),
              consumoVigencia = (element.vigencia.consumoCombustivelParado || 0) + (element.vigencia.consumoCombustivelMovimento || 0) + (element.vigencia.consumoCombustivelGpsInvalido || 0),
              consumoVigenciaEletrico = (element.vigencia.consumoEletricoParado || 0) + (element.vigencia.consumoEletricoMovimento || 0) + (element.vigencia.consumoEletricoGpsInvalido || 0);

          _this6.consumoCombustivel += consumoVigencia > 0 ? consumoVigencia : 0;
          _this6.consumoEletrico += consumoVigenciaEletrico > 0 ? consumoVigenciaEletrico : 0;

          if (consumoVigencia > 0) {
            _this6.distanciaRelativaConsumo += element.vigencia.distanciaPercorrida;
          }

          if (consumoVigenciaEletrico > 0) {
            _this6.distanciaRelativaConsumoEletrico += element.vigencia.distanciaPercorrida;
          }

          _this6.setPath(posicoesValidas);
          _this6.setPathEventos(posicoesValidas, _this6.eventoSelecionado);
        });

        if (this.consumoCombustivel > 0) {
          this.mediaConsumo = this.distanciaRelativaConsumo / this.consumoCombustivel;
        }

        if (this.consumoEletrico > 0) {
          this.mediaConsumoEletrico = this.distanciaRelativaConsumoEletrico / this.consumoEletrico;
        }

        this.todasVigencias = true;
        this.logradouroInicio = '';
        this.logradouroFim = '';
        this.duracao = this.duracaoTotal;

        this.insertMarkers(this.detalhes.map(function (d) {
          return _this6.mapasUtilService.posicoesFiltradas(d.vigencia.posicoes);
        }));
      }
    }, {
      key: 'limparVariaveisLayers',
      value: function limparVariaveisLayers() {
        this.pathGroup.clearLayers();
        this.markersGroup.clearLayers();
        this.duracao = null;
        this.veiculos = [];
        this.distancia = 0;
        this.distanciaRelativaConsumo = 0;
        this.distanciaRelativaConsumoEletrico = 0;
        this.diferencaAltitude = null;
        this.markersPorPosicao.clear();
      }
    }, {
      key: 'selecionarVigencia',
      value: function selecionarVigencia(vigencia) {
        this.limparVariaveisLayers();
        this.resumoPeriodo = [vigencia];
        this.popularDadosDaVigencia(vigencia);
        this.inserirVigenciaNoMapa(vigencia);
      }
    }, {
      key: 'popularDadosDaVigencia',
      value: function popularDadosDaVigencia(vigencia) {
        this.motorista = vigencia.motorista;
        this.vigenciaSelecionada = vigencia;
        this.logradouroInicio = this.vigenciaSelecionada.localSaida;
        this.logradouroFim = this.vigenciaSelecionada.localChegada;
        this.todasVigencias = false;
        this.veiculos.push(vigencia.veiculo);
        this.distancia += vigencia.distanciaPercorrida;
        this.duracao = vigencia.fim ? this.moment(vigencia.fim, 'YYYY/MM/DD HH:mm:ssZ').diff(this.moment(vigencia.inicio, 'YYYY/MM/DD HH:mm:ssZ'), 'seconds') : null;
        this.consumoCombustivel = vigencia.consumoCombustivelParado + vigencia.consumoCombustivelMovimento + vigencia.consumoCombustivelGpsInvalido;
        this.mediaConsumo = vigencia.mediaConsumo;
        this.consumoEletrico = vigencia.consumoEletricoParado + vigencia.consumoEletricoMovimento + vigencia.consumoEletricoGpsInvalido;
        this.mediaConsumoEletrico = vigencia.mediaConsumoEletrico;
      }
    }, {
      key: 'inserirVigenciaNoMapa',
      value: function inserirVigenciaNoMapa(vigencia) {
        var posicoes = _.sortBy(this.mapasUtilService.flatPosicoes(vigencia.posicoes), 'data');
        this.setPath(posicoes);
        this.setPathEventos(posicoes, this.eventoSelecionado);
        this.insertMarkers([this.mapasUtilService.posicoesFiltradas(vigencia.posicoes)]);
      }
    }, {
      key: 'setMapEvents',
      value: function setMapEvents() {
        angular.extend(this.scope, {
          events: {
            map: {
              enable: ['click'],
              logic: 'emit'
            },
            markers: {
              enable: ['click'],
              logic: 'emit'
            }
          }
        });
      }
    }, {
      key: 'onMapControlInit',
      value: function onMapControlInit() {
        var _this7 = this;

        this.leafletData.getMap('bdm-map').then(function (map) {
          _this7.scope.$broadcast('initPontoReferencia', map);
        });
      }
    }, {
      key: 'insertMarkers',
      value: function insertMarkers(trechos) {
        var _this8 = this;

        this.leafletData.getMap('bdm-map').then(function (map) {
          var oms = _this8.spiderfierService.createSpiderfier(map),
              posicoes = _this8.addPosicaoDescidaFimDescidas(trechos);

          _this8.markersGroup.clearLayers();

          _this8.markersPorPosicao = _this8.markerService.buildMarkersAssociadosAsPosicoes(posicoes, _this8.eventoSelecionado, 'bdm-');

          _this8.markersPorPosicao.forEach(function (marker) {
            marker.setPopupContent(_this8.compile('<div>' + marker.getPopup().getContent() + '</div>')(_this8.scope)[0]);
            _this8.markersGroup.addLayer(marker);
            if (!_this8.eventos.isLocalizacao(marker.options.evento)) {
              oms.addMarker(marker);
            }
          });

          if (!map.hasLayer(_this8.markersGroup)) {
            map.addLayer(_this8.markersGroup);
          }
          if (_this8.markersGroup.getLayers().length > 0) {
            map.fitBounds(_this8.markersGroup.getBounds(), { padding: [100, 100] });
          }
        });
      }
    }, {
      key: 'addPosicaoDescidaFimDescidas',
      value: function addPosicaoDescidaFimDescidas(trechos) {
        var _this9 = this;

        return _.flatten(trechos).reduce(function (acc, posicao) {
          acc.push(posicao);
          if (posicao.evento && posicao.evento.includes(_this9.eventoDescida) && angular.isDefined(posicao.fim)) {
            switch (posicao.evento) {
              case _this9.eventoDescidaFaixa1:
                posicao.fim.evento = _this9.translate.instant(_this9.eventos.DESCIDA_FAIXA1_FIM.tipo);
                break;
              case _this9.eventoDescidaFaixa2:
                posicao.fim.evento = _this9.translate.instant(_this9.eventos.DESCIDA_FAIXA2_FIM.tipo);
                break;
              default:
                posicao.fim.evento = _this9.translate.instant(_this9.eventos.DESCIDA_FAIXA3_FIM.tipo);
                break;
            }
            posicao.fim.temCoordenada = true;
            posicao.fim.descricao = _this9.translate.instant(_this9.eventos.DESCIDA_FAIXA1_FIM.descricao);
            acc.push(posicao.fim);
          }
          return acc;
        }, []);
      }
    }, {
      key: 'setPath',
      value: function setPath(posicoes) {
        var _this10 = this;

        this.leafletData.getMap('bdm-map').then(function (map) {
          var routeLines = L.polyline(posicoes.map(function (p) {
            return [p.latitude, p.longitude];
          }), {
            color: '#3388FF',
            opacity: 0.75,
            weight: 3
          });
          L.polylineDecorator(routeLines, {
            patterns: [{
              offset: 0,
              repeat: 300,
              symbol: L.Symbol.arrowHead({
                pixelSize: 12,
                pathOptions: { fillOpacity: 0.75, color: '#0033FF', weight: 0 }
              })
            }]
          }).addTo(_this10.pathGroup);
          _this10.pathGroup.addLayer(routeLines);
          if (!map.hasLayer(_this10.pathGroup)) {
            map.addLayer(_this10.pathGroup);
          }
        });
      }
    }, {
      key: 'setPathEventos',
      value: function setPathEventos(posicoes, e) {
        var _this11 = this;

        this.leafletData.getMap('bdm-map').then(function (map) {
          posicoes.filter(function (p) {
            return _this11.isEvento(p, e);
          }).map(function (p) {
            var coord = [[p.latitude, p.longitude]],
                routeEventsLines = null;
            if (angular.isDefined(p.fim)) {
              coord = coord.concat(_this11.getPosicoesDentroDoPeriodoDoEvento(p, posicoes));
              coord.push([p.fim.latitude, p.fim.longitude]);
            }
            routeEventsLines = L.polyline(coord, {
              color: 'red',
              weight: 3
            });
            _this11.pathGroup.addLayer(routeEventsLines);
          });
          if (!map.hasLayer(_this11.pathGroup)) {
            map.addLayer(_this11.pathGroup);
          }
        });
      }
    }, {
      key: 'getPosicoesDentroDoPeriodoDoEvento',
      value: function getPosicoesDentroDoPeriodoDoEvento(posicao, posicoes) {
        var _this12 = this;

        return posicoes.filter(function (p) {
          return _this12.isDentroDoPeriodo(p, posicao);
        }).map(function (p) {
          return [p.latitude, p.longitude];
        });
      }
    }, {
      key: 'isDentroDoPeriodo',
      value: function isDentroDoPeriodo(posicao, posicaoPeriodo) {
        return new Date(posicaoPeriodo.data) < new Date(posicao.data) && new Date(posicaoPeriodo.fim.data) > new Date(posicao.data);
      }
    }, {
      key: 'isEvento',
      value: function isEvento(p, e) {
        if (e === this.translate.instant(this.eventos.EXCESSO_VELOCIDADE.tipo)) {
          return this.eventos.isExcessoVelocidade(p.evento);
        } else if (e === this.translate.instant(this.eventos.CURVA_BRUSCA.tipo)) {
          return this.eventos.isCurvaBrusca(p.evento);
        }
        return e === '' || p.evento === e;
      }
    }, {
      key: 'getLinkPdf',
      value: function getLinkPdf() {
        return '/boletim/bdm/detalhes/pdf?motoristaId=' + this.stateParams.motoristaId + '&dia=' + this.stateParams.dia + '&timezone=' + this.currentTimezone;
      }
    }, {
      key: 'downloadPdf',
      value: function downloadPdf() {
        var _this13 = this;

        this.httpService.get(this.getLinkPdf(), { responseType: 'blob' }).then(function (result) {
          var contentDispositionHeader = result.headers('content-disposition'),
              fileName = contentDispositionHeader ? contentDispositionHeader.split('filename=')[1] : undefined,
              anchor = angular.element('<a/>'),
              file = new Blob([result.data], { type: 'application/pdf' }),
              pdfBrowserUrl = _this13.window.URL.createObjectURL(file);
          anchor.attr({
            href: pdfBrowserUrl,
            target: '_blank',
            download: fileName ? fileName : 'export.pdf'
          })[0].click();
          _this13.window.URL.revokeObjectURL(pdfBrowserUrl);
        });
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }]);

    return BdmDetalhesCtrl;
  }();

  /**
   * @ngdoc object
   * @name relatorios.bdm.controller:BdmDetalhesCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.bdm').controller('BdmDetalhesCtrl', BdmDetalhesCtrl);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global Intl*/

  var BdmCtrl = function () {
    function BdmCtrl($q, $httpParamSerializer, $window, Onboarding, MockBDM, IDBDM, Uos, Motoristas, Bdm, v3gTableLimitService, Keys, ServiceVfiltro, FactoryVfiltro, VtabelaFactory, uiGridConstants, ObjetosVfiltroService, Restangular, $filter, sorters, CadastroVeiculoService, UrlConfigService, $translate, $rootScope, MeasurementUnitConverterService, ConfigEventosService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, BdmCtrl);

      this.q = $q;
      this.httpParamSerializer = $httpParamSerializer;
      this.veiculoService = CadastroVeiculoService;
      this.configEventosService = ConfigEventosService;
      this.sorters = sorters;
      this.bdmService = Bdm;
      this.v3gTableLimitService = v3gTableLimitService;
      this.onboarding = Onboarding;
      this.mockBDM = MockBDM;
      this.window = $window;
      this.uoService = Uos;
      this.motoristaService = Motoristas;
      this.keys = Keys;
      this.filter = $filter;
      this.restangular = Restangular;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.urlConfigService = UrlConfigService;
      this.translate = $translate;
      this.filtro = null;
      this.vtabela = null;
      this.relatorio = null;
      this.uoSelecionada = null;
      this.currentPage = 0;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.hasSensorAcionado = false;
      this.hasConsumoEletrico = false;
      this.featureHub = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;

      this.isDemo = this.onboarding.startOnboarding(IDBDM);
      this.uoService.isDemo = this.isDemo;
      this.motoristaService.isDemo = this.isDemo;
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.colunaPedalAcionadoFaixa = this.translate.instant('ce.boletim.common.pedalAcionadoFaixa');

      this.tooltipPedalAcionadoFaixa1 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa1');
      this.tooltipPedalAcionadoFaixa2 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa2');
      this.tooltipPedalAcionadoFaixa3 = this.translate.instant('ce.boletim.common.tooltipPedalAcionadoFaixa3');

      this.tooltipFcwBrakeExtAccDem = this.translate.instant('ce.boletim.diarioMotorista.colunasTooltips.fcwBrakeExtAccDem');

      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.rootScope = $rootScope;

      this.dateTimeFormat = this.measurementUnitConverterService.getDateFormat(this.rootScope.usuario.measurementUnits.dateTimeFormat);
      this.distanceUnit = this.measurementUnitConverterService.getDistanceUnit(this.rootScope.usuario.measurementUnits.distanceMeasurement);
      this.fuelUnit = this.measurementUnitConverterService.getFuelUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.fuelEfficiency = this.measurementUnitConverterService.getFuelEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.energyEfficiency = this.measurementUnitConverterService.getEnergyEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.decimalFilter = this.rootScope.usuario.idioma === 'EN_US' ? 'decimalPointWithLabel:\'' : 'decimalWithLabel:\'';
      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        dateLimit: 30,
        format: 'YYYY-MM-DD',
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo',
        key: this.keys.uo.name
      }, {
        name: 'uoParceira',
        key: this.keys.uoParceira.name,
        size: 6
      }, {
        name: 'motoristas',
        key: this.keys.motoristas.name,
        ignoreValidation: true,
        size: 6
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.consultar(ServiceVfiltro.getFiltroBackendNovo(filtro));
      });
    }

    _createClass(BdmCtrl, [{
      key: 'initVtabela',
      value: function initVtabela(configEventos) {
        var _this2 = this;

        var drilDownSorting = void 0,
            drilDownCol = void 0,
            objVtabela = {
          exporterPdfFilename: 'Boletim Diário do Motorista PDF.pdf',
          exporterCsvFilename: 'Boletim Diário do Motorista CSV.csv',
          exporterExcelFilename: 'Boletim Diário do Motorista XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'motorista',
            displayName: 'ce.boletim.diarioMotorista.colunas.motorista',
            type: 'string',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true,
            aggregationTotalTitle: 'Total',
            headerCellFilter: 'translate',
            cellTemplate: '\n                    <div class="ui-grid-cell-contents">\n                      <motorista-link\n                        motorista="row.entity.motorista"\n                        motorista-id="row.entity.id"\n                        has-permission="true"\n                        index="$index">\n                      </motorista-link>\n                    </div>\n                  '
          }, {
            name: 'departamento',
            displayName: 'ce.boletim.diarioMotorista.colunas.departamento',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'veiculos',
            displayName: 'ce.boletim.diarioMotorista.colunas.veiculos',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'Sem identificação\''
          }, {
            name: 'dia',
            displayName: 'ce.boletim.diarioMotorista.colunas.dia',
            type: 'date',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
            filterCellFiltered: true,
            enableHiding: false,
            cellClass: 'text-center'
          }, {
            name: 'inicio',
            displayName: 'ce.boletim.diarioMotorista.colunas.dataInicio',
            headerTooltip: 'ce.boletim.diarioMotorista.colunas.dataInicio',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\ HH:mm:ss\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'fim',
            displayName: 'ce.boletim.diarioMotorista.colunas.dataFim',
            headerTooltip: 'ce.boletim.diarioMotorista.colunas.dataFim',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\ HH:mm:ss\'',
            filterCellFiltered: true,
            cellClass: 'text-center'
          }, {
            name: 'distanciaPercorrida',
            displayName: 'ce.boletim.diarioMotorista.colunas.distanciaPercorrida',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellFilter: 'decimalWithLabelWithoutConversion:\'' + this.distanceUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'tempoIgnicaoLigada',
            displayName: 'ce.boletim.diarioMotorista.colunas.tempoIgnicaoLigada',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true
          }, {
            name: 'velocidade',
            displayName: 'ce.boletim.diarioMotorista.colunas.velocidadeExcessiva',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'aceleracoesBruscas',
            displayName: 'ce.boletim.diarioMotorista.colunas.aceleracoesBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.aceleracao && !configEventos.aceleracao.enabled
          }, {
            name: 'frenagensBruscas',
            displayName: 'ce.boletim.diarioMotorista.colunas.frenagensBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            enableFiltering: true,
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.freada && !configEventos.freada.enabled
          }, {
            name: 'curvasBruscas',
            displayName: 'ce.boletim.diarioMotorista.colunas.curvasBruscas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.curva && !configEventos.curva.enabled
          }, {
            name: 'noSeatbelt',
            displayName: 'ce.enum.common.semCinto',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'yawning',
            displayName: 'ce.enum.eventos.bocejo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'absentDriver',
            displayName: 'ce.enum.common.semMotorista',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.motoristaAusente && !configEventos.motoristaAusente.enabled
          }, {
            name: 'smoking',
            displayName: 'ce.enum.common.usoDeCigarro',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'distraction',
            displayName: 'ce.enum.common.distracao',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'fatique',
            displayName: 'ce.enum.common.fadiga',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'cellphoneUsage',
            displayName: 'ce.enum.common.usoDeCelular',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'unsafeDistance',
            displayName: 'ce.enum.common.distanciaPerigosa',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.distanciaPerigosa && !configEventos.distanciaPerigosa.enabled
          }, {
            name: 'obstructedCamera',
            displayName: 'ce.enum.common.cameraObstruida',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'cameraDisconnectionDriver',
            displayName: 'ce.enum.eventos.cameraDisconnectionDriver',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionDriver && !configEventos.cameraDisconnectionDriver.enabled
          }, {
            name: 'cameraDisconnectionRoad',
            displayName: 'ce.enum.eventos.cameraDisconnectionRoad',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionRoad && !configEventos.cameraDisconnectionRoad.enabled
          }, {
            name: 'cameraDisconnectionAudit',
            displayName: 'ce.enum.eventos.cameraDisconnectionAudit',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.cameraDisconnectionAudit && !configEventos.cameraDisconnectionAudit.enabled
          }, {
            name: 'illegalOvertaking',
            displayName: 'ce.enum.eventos.ultrapassagemIlegal',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.ultrapassagemIlegal && !configEventos.ultrapassagemIlegal.enabled
          }, {
            name: 'noSafetyCone',
            displayName: 'ce.enum.eventos.semCone',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semCone && !configEventos.semCone.enabled
          }, {
            name: 'noSafetyGlasses',
            displayName: 'ce.enum.eventos.SemOculos',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semOculos && !configEventos.semOculos.enabled
          }, {
            name: 'noGloves',
            displayName: 'ce.enum.eventos.SemLuvas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semLuvas && !configEventos.semLuvas.enabled
          }, {
            name: 'ride',
            displayName: 'ce.enum.eventos.carona',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.carona && !configEventos.carona.enabled
          }, {
            name: 'followingDistance',
            displayName: 'ce.boletim.diarioMotorista.colunas.followingDistance',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.followingDistance.enabled)
          }, {
            name: 'collisionMitigation',
            displayName: 'ce.boletim.diarioMotorista.colunas.collisionMitigation',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.collisionMitigation.enabled)
          }, {
            name: 'fcwBrakeExtAccDem',
            displayName: 'ce.boletim.diarioMotorista.colunas.fcwBrakeExtAccDem',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.fcwBrakeExtAccDem.enabled),
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipFcwBrakeExtAccDem
          }, {
            name: 'fcw',
            displayName: 'ce.boletim.diarioMotorista.colunas.fcw',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.fcw.enabled)
          }, {
            name: 'hapticWarning',
            displayName: 'ce.boletim.diarioMotorista.colunas.hapticWarning',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.hapticWarning.enabled)
          }, {
            name: 'ropBrake',
            displayName: 'ce.boletim.diarioMotorista.colunas.ropBrake',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ropBrake.enabled)
          }, {
            name: 'ropEngine',
            displayName: 'ce.boletim.diarioMotorista.colunas.ropEngine',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ropEngine.enabled)
          }, {
            name: 'ycBrake',
            displayName: 'ce.boletim.diarioMotorista.colunas.ycBrake',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ycBrake.enabled)
          }, {
            name: 'ycEngine',
            displayName: 'ce.boletim.diarioMotorista.colunas.ycEngine',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.ycEngine.enabled)
          }, {
            name: 'banguelas',
            displayName: 'ce.boletim.diarioMotorista.colunas.banguelas',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.banguela && !configEventos.banguela.enabled
          }, {
            name: 'rpmExcessivo',
            displayName: 'ce.boletim.diarioMotorista.colunas.rpmExcessivo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.rpmExcessivo && !configEventos.rpmExcessivo.enabled
          }, {
            name: 'pedalAcionadoFaixa1',
            displayName: this.colunaPedalAcionadoFaixa + ' 1',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa1
          }, {
            name: 'pedalAcionadoFaixa2',
            displayName: this.colunaPedalAcionadoFaixa + ' 2',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa2
          }, {
            name: 'pedalAcionadoFaixa3',
            displayName: this.colunaPedalAcionadoFaixa + ' 3',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.tooltipPedalAcionadoFaixa3
          }, {
            name: 'paradoLigado',
            displayName: 'ce.boletim.diarioMotorista.colunas.paradoLigado',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.paradoLigado && !configEventos.paradoLigado.enabled
          }, {
            name: 'consumoCombustivel',
            displayName: 'ce.boletim.diarioMotorista.colunas.consumoCombustivel',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'decimalWithLabelWithoutConversion:\'' + this.fuelUnit + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'mediaConsumo',
            displayName: 'ce.boletim.diarioMotorista.colunas.mediaConsumo',
            cellClass: 'text-center',
            cellFilter: 'decimalFormatterWithLabel:\'' + this.fuelEfficiency + '\'',
            filterCellFiltered: true
          }, {
            name: 'consumoEletrico',
            displayName: 'ce.boletim.diarioMotorista.colunas.consumoEletrico',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: this.decimalFilter + 'kWh\'',
            cellClass: 'text-center',
            visible: this.hasConsumoEletrico,
            filterCellFiltered: true
          }, {
            name: 'mediaConsumoEletrico',
            displayName: 'ce.boletim.diarioMotorista.colunas.mediaConsumoEletrico',
            cellClass: 'text-center',
            cellFilter: 'decimalFormatterWithLabel:\'' + this.energyEfficiency + '\'',
            visible: this.hasConsumoEletrico,
            filterCellFiltered: true
          }, {
            name: 'logradouroInicial',
            displayName: 'ce.boletim.diarioMotorista.colunas.logradouroInicial',
            filterCellFiltered: true
          }, {
            name: 'logradouroFinal',
            displayName: 'ce.boletim.diarioMotorista.colunas.logradouroFinal',
            filterCellFiltered: true
          }, {
            name: 'detalhe',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            cellTemplate: '\n                    <div class="ui-grid-cell-contents vtabela-icone-detalhado">\n                      <a\n                        id=\'btn-detalhes-{{$index}}\'\n                        ng-href=\'{{grid.appScope.goToBDMDetalhes(row.entity.id, row.entity.dia)}}\'>\n                        <span class="glyphicon glyphicon-zoom-in" aria-hidden=\'true\'></span>\n                      </a>\n                    </div>'
          }, {
            name: 'unauthorizedVehicleUseQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.unauthorizedVehicleUse',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.unauthorizedVehicleUse.enabled)
          }, {
            name: 'unauthorizedVehicleUseTempo',
            displayName: 'ce.boletim.diarioMotorista.colunas.unauthorizedVehicleUseTempo',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !(configEventos && configEventos.unauthorizedVehicleUse.enabled)
          }, {
            name: 'manuseioObjetoQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.manuseioObjeto',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.MANUSEIO_OBJETO_FRONTEND) || !(configEventos && configEventos.manuseioObjeto.enabled)
          }, {
            name: 'rollingStopQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.rollingStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROLLING_STOP) || configEventos && configEventos.rollingStop && !configEventos.rollingStop.enabled
          }, {
            name: 'noStopQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.noStop',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROLLING_STOP) || configEventos && configEventos.noStop && !configEventos.noStop.enabled
          }, {
            name: 'semCasqueteQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.semCasquete',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: configEventos && configEventos.semCasquete && !configEventos.semCasquete.enabled
          }, {
            name: 'routeDeviationQtd',
            displayName: 'ce.boletim.diarioMotorista.colunas.routeDeviation',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            isDisabled: !this.featureHub.isFeatureEnabled(this.featureHubConfigKeys.ROUTE_DEVIATION) || configEventos && configEventos.routeDeviation && !configEventos.routeDeviation.enabled
          }].filter(function (x) {
            return x.isDisabled !== true;
          })
        };

        if (this.hasSensorAcionado) {
          objVtabela.columnDefs.push({
            name: 'tempoSensorDesengate',
            displayName: 'ce.boletim.diarioMotorista.colunas.sensorAcionado',
            sortWithUndefinedValues: true,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center',
            cellTemplate: '\n            <div class="ui-grid-cell-contents text-center">\n              <span title="{{ row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'ce.boletim.diarioMotorista.sensorAcionado.naoSeAplica\' | translate }}">\n                {{row.entity.tempoSensorDesengate | humanizedOrUndefinedWithLabel:\'N/A\'}}\n              </span>\n            </div>',
            cellFilter: 'humanizedOrUndefinedWithLabel:\'N/A\'',
            filterCellFiltered: true
          });
        }

        drilDownSorting = this.getDrilDownSortingDirection(this.tableState);
        drilDownCol = objVtabela.columnDefs.find(function (x) {
          return _this2.isEventoVtabela(x.name, _this2.tableState.sort.predicate);
        });

        if (drilDownSorting && drilDownCol) {
          angular.merge(drilDownCol, drilDownSorting);
        }

        return objVtabela;
      }
    }, {
      key: 'isEventoVtabela',
      value: function isEventoVtabela(eventName, urlEvent) {
        var isSpeedEvent = eventName === 'velocidade',
            isUrlExVelocidadeFaixa = urlEvent === 'exVelocidadeFaixa1' || urlEvent === 'exVelocidadeFaixa2' || urlEvent === 'exVelocidadeFaixa3';

        return eventName.toLowerCase() === urlEvent.toLowerCase() || isUrlExVelocidadeFaixa && isSpeedEvent;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.motorista.id,
          motorista: item.motorista.nome,
          departamento: item.departamento,
          veiculos: item.veiculos.replace('-', ' - '),
          dia: item.dia,
          inicio: item.inicio,
          fim: item.fim,
          distanciaPercorrida: item.distanciaPercorrida,
          tempoIgnicaoLigada: item.tempoDirecao,
          velocidade: item.excessosVelocidade,
          aceleracoesBruscas: item.aceleracoes,
          frenagensBruscas: item.frenagens,
          curvasBruscas: item.curvas,
          banguelas: item.banguelas,
          noSeatbelt: item.noSeatbelt,
          yawning: item.yawning,
          absentDriver: item.absentDriver,
          smoking: item.smoking,
          distraction: item.distraction,
          fatique: item.fatique,
          cellphoneUsage: item.cellphoneUsage,
          unsafeDistance: item.unsafeDistance,
          obstructedCamera: item.obstructedCamera,
          cameraDisconnectionDriver: item.cameraDisconnectionDriver,
          cameraDisconnectionRoad: item.cameraDisconnectionRoad,
          cameraDisconnectionAudit: item.cameraDisconnectionAudit,
          illegalOvertaking: item.illegalOvertaking,
          noSafetyCone: item.noSafetyCone,
          noSafetyGlasses: item.noSafetyGlasses,
          noGloves: item.noGloves,
          ride: item.ride,
          rpmExcessivo: item.rpmExcessivos,
          paradoLigado: item.tempoMotorOcioso,
          consumoCombustivel: item.consumoCombustivel,
          consumoEletrico: item.consumoEletrico,
          tempoSensorDesengate: item.tempoSensorDesengate,
          logradouroInicial: item.logradouroInicio,
          logradouroFinal: item.logradouroFim,
          mediaConsumo: item.mediaConsumo,
          mediaConsumoEletrico: item.mediaConsumoEletrico,
          pedalAcionadoFaixa1: item.pedalFreioDescidaFaixa1Qtd,
          pedalAcionadoFaixa2: item.pedalFreioDescidaFaixa2Qtd,
          pedalAcionadoFaixa3: item.pedalFreioDescidaFaixa3Qtd,
          followingDistance: item.followingDistance,
          ropBrake: item.ropBrake,
          ropEngine: item.ropEngine,
          ycBrake: item.ycBrake,
          ycEngine: item.ycEngine,
          collisionMitigation: item.collisionMitigation,
          fcwBrakeExtAccDem: item.fcwBrakeExtAccDem,
          fcw: item.fcw,
          hapticWarning: item.hapticWarning,
          unauthorizedVehicleUseQtd: item.unauthorizedVehicleUseQtd,
          unauthorizedVehicleUseTempo: item.unauthorizedVehicleUseTempo,
          manuseioObjetoQtd: item.objectHandling,
          rollingStopQtd: item.rollingStopQtd,
          noStopQtd: item.noStopQtd,
          semCasqueteQtd: item.semCasqueteQtd,
          routeDeviationQtd: item.routeDeviationQtd
        };
      }
    }, {
      key: 'consultar',
      value: function consultar(filtro) {
        var _this3 = this;

        if (this.isDemo) {
          this.setInfoTable(this.mockBDM.filter(function (x) {
            return x.id === _this3.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === _this3.keys.motoristas.name;
            }).values[0].id;
          })[0].data);
        } else {
          this.bdmService.one().get(angular.extend(filtro, { timezone: this.currentTimezone })).then(function (data) {
            _this3.loadGridBdm(data);
          });
        }
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this4 = this;

        this.vtabela.setData(data.list.map(function (i) {
          return _this4.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getDrilDownSortingDirection',
      value: function getDrilDownSortingDirection(tableState) {
        if (tableState && tableState.sort.reverse) {
          return {
            sort: {
              direction: this.uiGridConstants.DESC
            }
          };
        }

        return {
          sort: {
            direction: this.uiGridConstants.ASC
          }
        };
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        var filtro = this.serviceVfiltro.getFiltroBackendNovo(this.filtro);
        return '/boletim/bdm/csv?' + this.httpParamSerializer(angular.extend(filtro, { timezone: this.currentTimezone }));
      }
    }, {
      key: 'goToBDMDetalheDemo',
      value: function goToBDMDetalheDemo(id, dia, veiculo) {
        this.window.location.href = '/relatorios/bdm/detalhes/' + id + '/' + dia + '?demo&veiculo=' + veiculo;
      }
    }, {
      key: 'goToBDMDetalhes',
      value: function goToBDMDetalhes(id, dia) {
        return '/relatorios/bdm/detalhes/' + id + '/' + dia;
      }
    }, {
      key: 'loadGridBdm',
      value: function loadGridBdm(data) {
        var _this5 = this;

        this.q.all([this.veiculoService.hasSensor(data.reqParams.uo), this.configEventosService.getConfigEventos()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              hasSensor = _ref2[0],
              configEventos = _ref2[1];

          _this5.hasSensorAcionado = hasSensor;
          _this5.hasConsumoEletrico = data.list.some(function (registro) {
            return angular.isDefined(registro.mediaConsumoEletrico);
          });
          var tabela = _this5.initVtabela(configEventos);
          _this5.vtabela = _this5.vtabelaFactory.get(tabela, _this5.serviceVfiltro.factoryVfiltro.user, 'relatorioBDM', 'v5|' + _this5.serviceVfiltro.factoryVfiltro.user.uo.id + '|' + _this5.disabledColumnsHash(tabela));
          _this5.setInfoTable(data);
        });
      }
    }, {
      key: 'disabledColumnsHash',
      value: function disabledColumnsHash(tabela) {
        return this.hashCode(tabela.columnDefs.filter(function (x) {
          return x.isDisabled !== true;
        }).map(function (x) {
          return x.name;
        }).join(','));
      }
    }, {
      key: 'hashCode',
      value: function hashCode(str) {
        var hash = 0;
        for (var i = 0, len = str.length; i < len; i++) {
          var chr = str.charCodeAt(i);
          hash = (hash << 5) - hash + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
      }
    }]);

    return BdmCtrl;
  }();

  /**
   * @ngdoc object
   * @name relatorios.bdm.controller:BdmCtrl
   *
   * @description
   *
   */


  angular.module('relatorios.bdm').controller('BdmCtrl', BdmCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('relatorios.abastecimento', ['ui.router', 'restangular', 'angularMoment', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'ConstantVfiltroModule', 'VtabelaModule']).factory('Abastecimento', function (Restangular) {
    return Restangular.service('/abastecimento/historico-abastecimento');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.abastecimento', {
      url: '/relatorios/abastecimento?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/abastecimento/abastecimento.tpl.html',
          controller: 'AbastecimentoCtrl',
          controllerAs: 'abastecimento'
        }
      },
      data: {
        titulo: 'ce.boletim.abastecimento.titulo',
        tituloDescricao: 'ce.boletim.abastecimento.tituloDescricao',
        role: 'HISTORICO_ABASTECIMENTO_VISUALIZAR'
      }
    });
  }

  angular.module('relatorios.abastecimento').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var AbastecimentoCtrl = function () {
    function AbastecimentoCtrl(Abastecimento, $httpParamSerializer, moment, ServiceVfiltro, ObjetosVfiltroService, FactoryVfiltro, Keys, VtabelaFactory, uiGridConstants, UrlConfigService) {
      var _this = this;

      _classCallCheck(this, AbastecimentoCtrl);

      this.abastecimentoService = Abastecimento;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.moment = moment;
      this.httpParamSerializer = $httpParamSerializer;
      this.urlConfigService = UrlConfigService;

      this.vtabela = null;
      this.exportsPdf = false;
      this.uoSelecionada = null;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        dateLimit: 180,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uo',
        key: this.keys.uo.name,
        size: 12
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.user = _this.serviceVfiltro.factoryVfiltro.user;
        _this.roleVisualizarMapa = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('LOCALIZACAO_ATUAL_VISUALIZAR');
        _this.roleVisualizarPonto = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PONTO_REFERENCIA_VISUALIZAR');
        _this.consultar();
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'relatorioAbastecimento', 'v1');
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = true;
      });
    }

    _createClass(AbastecimentoCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        var drilDownSorting = void 0,
            drilDownCol = void 0,
            objVtabela = {
          exporterPdfFilename: 'Relatório de Abastecimento PDF.pdf',
          exporterCsvFilename: 'Relatório de Abastecimento CSV.csv',
          exporterExcelFilename: 'Relatório de Abastecimento XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'placa',
            displayName: 'ce.boletim.abastecimento.colunas.placa',
            type: 'string',
            pinnedLeft: true,
            filterCellFiltered: true,
            enableHiding: false,
            aggregationTotalTitle: 'Total'
          }, {
            name: 'motorista',
            displayName: 'ce.boletim.abastecimento.colunas.motorista',
            enableHiding: false,
            pinnedLeft: true,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'ce.common.motorista.semIdentificacao\' | translate | splitComposedLabels:true'
          }, { name: 'dataAbastecimento', displayName: 'ce.boletim.abastecimento.colunas.dataHora', type: 'date', filterCellFiltered: true,
            cellFilter: 'date:\'dd/MM/yyyy HH:mm\'', cellClass: 'text-center', enableHiding: false }, { name: 'hodometroInformado', displayName: 'ce.boletim.abastecimento.colunas.hodometroInformado', filterCellFiltered: true,
            cellFilter: 'decimalWithLabel:\'Km\'', cellClass: 'text-center' }, { name: 'hodometroVeltec', displayName: 'ce.boletim.abastecimento.colunas.hodometroVeltec', filterCellFiltered: true,
            cellFilter: 'decimalWithLabel:\'Km\'', cellClass: 'text-center' }, { name: 'logradouro', displayName: 'ce.boletim.abastecimento.colunas.logradouro', filterCellFiltered: true }, {
            name: 'distancia',
            displayName: 'ce.boletim.abastecimento.colunas.distancia',
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: 'ce.boletim.abastecimento.colunas.distanciaTooltip',
            cellFilter: 'decimalWithLabel:\'Km\'',
            cellClass: 'text-center'
          }, { name: 'rendimento', displayName: 'ce.boletim.abastecimento.colunas.rendimento', type: 'number', cellClass: 'text-center',
            filterCellFiltered: true, cellFilter: 'withLabel:\'Km/L\'' }, { name: 'produto', displayName: 'ce.boletim.abastecimento.colunas.produto', filterCellFiltered: true }, {
            name: 'quantidade',
            displayName: 'ce.boletim.abastecimento.colunas.quantidade',
            filterCellFiltered: true,
            cellClass: 'text-center',
            cellFilter: 'decimalWithLabel:\'L\'',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'valorTotal',
            displayName: 'ce.boletim.abastecimento.colunas.valorTotal',
            filterCellFiltered: true,
            cellFilter: 'currency:\'R$ \'',
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'pontoReferencia',
            displayName: 'ce.boletim.abastecimento.colunas.pontoReferencia',
            type: 'string',
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\' title="{{ row.entity.pontoReferencia }}">\n                    <a ng-href=\'{{ row.entity.linkLocalizacaoFrota }}\'\n                      target=\'_blank\'\n                      ng-if=\'grid.appScope.roleVisualizarMapa && grid.appScope.roleVisualizarPonto\'>\n                      {{ row.entity.pontoReferencia }}\n                    </a>\n                    <span ng-if=\'!grid.appScope.roleVisualizarMapa || !grid.appScope.roleVisualizarPonto\'>\n                      {{ row.entity.pontoReferencia }}\n                    </span>\n                  </div>\n                  ',
            filterCellFiltered: true,
            enableHiding: true
          }]
        };
        drilDownSorting = this.getDrilDownSortingDirection(this.tableState);
        drilDownCol = objVtabela.columnDefs.find(function (column) {
          return column.name === _this2.tableState.sort.predicate;
        });

        if (drilDownSorting && drilDownCol) {
          angular.merge(drilDownCol, drilDownSorting);
        }
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          placa: item.placa,
          motorista: item.motorista,
          dataAbastecimento: item.dataAbastecimento,
          hodometroInformado: item.hodometroIntegracao,
          hodometroVeltec: item.hodometroV3g,
          logradouro: item.logradouro,
          distancia: item.distancia,
          rendimento: item.rendimento,
          produto: item.produto,
          quantidade: item.quantidade,
          valorTotal: item.valorTotal,
          pontoReferencia: item.pontoReferencia && item.pontoReferencia.nome,
          linkLocalizacaoFrota: item.pontoReferencia && '/mapas-grid?ponto=' + item.pontoReferencia.id + '&forceRenderLayer=true'
        };
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this3 = this;

        this.abastecimentoService.one().get(this.serviceVfiltro.getFiltroBackendNovo(this.filtro)).then(function (data) {
          return _this3.setInfoTable(data);
        }).catch(function () {
          return _this3.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this4 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this4.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getDrilDownSortingDirection',
      value: function getDrilDownSortingDirection(tableState) {
        if (tableState && tableState.sort.reverse) {
          return {
            sort: {
              direction: this.uiGridConstants.DESC
            }
          };
        }

        return {
          sort: {
            direction: this.uiGridConstants.ASC
          }
        };
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return this.serviceVfiltro.getFiltroBackendNovo(this.filtro);
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/abastecimento/historico-abastecimento/csv?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getUrlPdf',
      value: function getUrlPdf() {
        return '/abastecimento/historico-abastecimento/pdf?' + this.httpParamSerializer(this.getParams());
      }
    }]);

    return AbastecimentoCtrl;
  }();

  angular.module('relatorios.abastecimento').controller('AbastecimentoCtrl', AbastecimentoCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ranking.Pontos', ['ui.router', 'angularMoment', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'UrlModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'pascalprecht.translate', 'urlConfigModule', 'v3gTrimbleFilters']).factory('RankingPontos', function (Restangular) {
    return Restangular.service('boletim/ranking/pontuacao-motoristas/mensal');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.rankingPontos', {
      url: '/ranking/motoristas?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'ranking/pontos/pontos.tpl.html',
          controller: 'RankingPontosCtrl',
          controllerAs: 'rankingPontos'
        }
      },
      data: {
        titulo: 'ce.ranking.pontos.titulo',
        role: [['RANKING_GERAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }

  angular.module('ranking.Pontos').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var RankingPontosCtrl = function () {
    function RankingPontosCtrl($filter, $httpParamSerializer, moment, RankingPontos, Keys, ServiceVfiltro, FactoryVfiltro, UrlService, FormatVfiltro, ObjetosVfiltroService, VtabelaFactory, uiGridConstants, $translate, UrlConfigService, MeasurementUnitConverterService, Authenticator, ConvertersService, FeaturehubJsSdk, FeatureHubConfigKeys, ProntuarioLinkService, FeatureOuService) {
      var _this = this;

      _classCallCheck(this, RankingPontosCtrl);

      this.filter = $filter;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.rankingPontos = RankingPontos;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.urlService = UrlService;
      this.formatVfiltro = FormatVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.translate = $translate;
      this.urlConfigService = UrlConfigService;
      this.vtabela = null;
      this.featureOuService = FeatureOuService;
      this.exportsPdf = false;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.convertersService = ConvertersService;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.labelSemMotorista = this.translate.instant('ce.ranking.pontos.labelSemMotorista');
      this.labelNoPermissionVehicle = this.translate.instant('ce.ranking.pontos.labelNoPermissionVehicle');
      this.ativoVtabela = this.translate.instant('ce.ranking.pontos.colunas.ativoUpperCase');
      this.inativoVtabela = this.translate.instant('ce.ranking.pontos.colunas.inativoUpperCase');
      this.pontos100Km = this.translate.instant('ce.ranking.pontos.colunas.pontos100Km');
      this.stringProntuario = this.translate.instant('ce.ranking.pontos.stringProntuario');
      this.vfiltro = {};
      this.featureFlagRoleProntuario = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_FEAT_ROLE_PRONTUARIO_VISUALIZAR);
      this.prontuarioLinkService = ProntuarioLinkService;

      Authenticator.getUser().then(function (user) {
        _this.usuario = user;
      });

      ServiceVfiltro.init(FactoryVfiltro.get(this.getDefaultValuesFiltro())).then(function () {
        var uoId = _this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id;

        _this.getEventsConfig(uoId).then(function () {
          var _this$vfiltro;

          var dateTime = _this.serviceVfiltro.filtroTopbar.find(function (x) {
            return x.key === _this.keys.dateTime.name;
          }).value;
          _this.vfiltro = (_this$vfiltro = {}, _defineProperty(_this$vfiltro, _this.keys.dateTime.name, _this.moment(dateTime.endDate).subtract(30, 'days').format(_this.formatVfiltro) + ',' + _this.moment(dateTime.endDate).add(1, 'days').format(_this.formatVfiltro)), _defineProperty(_this$vfiltro, _this.keys.uo.name, _this.serviceVfiltro.filtroTopbar.find(function (x) {
            return x.key === _this.keys.uo.name;
          }).value.id), _this$vfiltro);
          _this.distanceUnit = _this.measurementUnitConverterService.getDistanceUnit(_this.usuario.measurementUnits.distanceMeasurement);
          _this.megNameColumn = _this.translate.instant('ce.ranking.pontos.colunas.meg', { distanceUnit: _this.distanceUnit });
          _this.roleVisualizarBdm = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_MOTORISTA_VISUALIZAR');
          _this.roleVisualizarBdv = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('BOLETIM_VEICULO_VISUALIZAR');
          _this.roleProntuarioVisualizar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PRONTUARIO_MOTORISTA_VISUALIZAR');

          _this.consultar(_this.serviceVfiltro.getFiltroBackendNovo(_this.serviceVfiltro.filtroTopbar));
          _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'rankingPontos', 'v2');
        });
      });
    }

    _createClass(RankingPontosCtrl, [{
      key: 'getDefaultValuesFiltro',
      value: function getDefaultValuesFiltro() {
        return [{
          key: this.keys.dateTime.name,
          showSegmentPersonalizado: false,
          format: 'YYYY-MM-DD',
          defaultValues: {
            mesAtual: {
              active: this.getCurrentDay() !== 1
            },
            ultimoMes: {
              active: true
            },
            ultimos3Meses: {
              active: true
            },
            ultimos6Meses: {
              active: true
            }
          }
        }, {
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          name: 'uoDonaId',
          key: this.keys.uoParceira.name,
          size: 6
        }, {
          name: 'motoristasId',
          key: this.keys.motoristas.name,
          size: 6
        }];
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          exporterPdfFilename: 'Ranking Motoristas PDF.pdf',
          exporterCsvFilename: 'Ranking Motoristas CSV.csv',
          exporterExcelFilename: 'Ranking Motoristas XLSX.xlsx',
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'classificacaoGeral',
            displayName: 'ce.ranking.pontos.colunas.posicao',
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            pinnedLeft: true,
            aggregationTotalTitle: 'Total'
          }, {
            name: 'motorista',
            displayName: 'ce.ranking.pontos.colunas.motorista',
            pinnedLeft: true,
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{row.entity.ic}}">\n                <a\n                ng-href=\'{{(row.entity.linkBdm)}}\'\n                target=\'_blank\'\n                ng-if=\'grid.appScope.roleVisualizarBdm && row.entity.motorista !== grid.appScope.labelSemMotorista && row.entity.linkBdm\'\n                title="{{row.entity.motorista}}">\n                  {{row.entity.motorista}}\n                </a>\n                <span\n                ng-if=\'!grid.appScope.roleVisualizarBdm || row.entity.motorista === grid.appScope.labelSemMotorista\'\'\n                title="{{row.entity.motorista}}">\n                  {{row.entity.motorista | splitComposedLabels:true}}\n                </span>\n              </div>\n              '
          }, {
            name: 'departamento',
            displayName: 'ce.ranking.pontos.colunas.departamento',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            visible: !this.eventNAConfig
          }, {
            name: 'veiculos',
            displayName: 'ce.ranking.pontos.colunas.veiculos',
            enableHiding: false,
            filterCellFiltered: true,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{row.entity.ic}}">\n                <a ng-href=\'{{(row.entity.linkBdv)}}\'\n                target=\'_blank\'\n                ng-if=\'grid.appScope.roleVisualizarBdv && row.entity.veiculos && grid.appScope.hasVehiclePermission(row.entity.veiculos)\'\n                title="{{row.entity.veiculos}}">\n                  {{row.entity.veiculos}}\n                </a>\n                <span\n                ng-if=\'!grid.appScope.roleVisualizarBdv || !row.entity.veiculos || !row.entity.linkBdv || !grid.appScope.hasVehiclePermission(row.entity.veiculos)\'\n                title="{{row.entity.veiculos}}">\n                  {{row.entity.veiculos}}\n                </span>\n              </div>\n              '
          }, { name: 'tempoIgnicaoLigada', displayName: 'ce.ranking.pontos.colunas.tempoIgnicaoLigada', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'humanizedDuration', cellClass: 'text-center', enableFiltering: false }, { name: 'distanciaPercorrida', displayName: 'ce.ranking.pontos.colunas.distanciaPercorrida', type: 'number', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellFilter: 'decimalWithLabel:\'' + this.distanceUnit + '\'', cellClass: 'text-center', enableFiltering: false }, { name: 'pontosPorHora', displayName: 'ce.ranking.pontos.colunas.pontosPorHora', cellFilter: 'decimal:\'' + this.distanceUnit + '\'', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, { name: 'pontos100Km', displayName: this.getPointsPerUnits(), cellFilter: 'decimalForPoints:\'' + this.distanceUnit + '\'', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, {
            name: 'meg',
            displayName: this.megNameColumn,
            type: 'number',
            cellFilter: 'decimal:\'' + this.distanceUnit + '\'',
            cellClass: 'text-center',
            enableFiltering: false,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, {
            name: 'megHoras',
            displayName: 'ce.ranking.pontos.colunas.megHoras',
            type: 'number',
            cellFilter: 'decimal:\'' + this.distanceUnit + '\'',
            cellClass: 'text-center',
            enableFiltering: false,
            aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum
          }, { name: 'pontosTotal', displayName: 'ce.ranking.pontos.colunas.pontosTotal', cellFilter: 'decimal:\'' + this.distanceUnit + '\'', aggregationTypeTotal: this.uiGridConstants.aggregationTypes.sum,
            cellClass: 'text-center', enableFiltering: false }, {
            name: 'ativo',
            displayName: 'ce.ranking.pontos.colunas.status.statusLabel',
            type: 'boolean',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: true, label: this.translate.instant('ce.ranking.pontos.colunas.status.ativos') }, { value: false, label: this.translate.instant('ce.ranking.pontos.colunas.status.inativos') }]
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center">{{row.entity.ativo ? grid.appScope.ativoVtabela : grid.appScope.inativoVtabela}}</div>'
          }, {
            name: 'prontuario',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            cellTemplate: '\n                <div class="ui-grid-cell-contents vtabela-icone-prontuario"\n                  ng-if="grid.appScope.shouldShowProntuarioBtn()"\n                >\n                  <a ng-href=\'{{(row.entity.linkProntuario)}}\' title=\'{{ grid.appScope.stringProntuario }}\'>\n                    <span class="trimble-driver-record" aria-hidden=\'true\'></span>\n                  </a>\n                </div>'
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.motoristas.id,
          motorista: this.filter('withLabelToUndefined')(item.motoristas.nome, this.labelSemMotorista),
          departamento: item.departamentos.nome,
          veiculos: item.veiculosExtenso ? item.veiculosExtenso : this.labelNoPermissionVehicle,
          tempoIgnicaoLigada: item.tempoEmDirecao,
          distanciaPercorrida: item.distanciaPercorrida,
          pontosPorHora: item.pontosPorHora,
          pontos100Km: item.pontos100Km,
          pontosTotal: item.pontosTotal,
          ativo: item.motoristas.ativo,
          linkBdv: this.getLinkBdv(item.veiculos),
          linkBdm: this.getLinkBdm(item.motoristas.id),
          linkProntuario: this.getLinkProntuario(item.motoristas.id),
          classificacaoGeral: item.classificacaoGeral,
          meg: this.handleDistanceUnitConversion(item.meg),
          megHoras: item.megHoras
        };
      }
    }, {
      key: 'shouldShowProntuarioBtn',
      value: function shouldShowProntuarioBtn() {
        if (!this.featureFlagRoleProntuario) {
          return true;
        }

        if (!angular.isArray(this.usuario.permissoesSolucao)) {
          return false;
        }

        var hasSolutions = this.usuario.permissoesSolucao.includes('PRONTUARIO_MOTORISTA_VISUALIZAR');
        return this.roleProntuarioVisualizar && hasSolutions;
      }
    }, {
      key: 'getCurrentDay',
      value: function getCurrentDay() {
        return this.moment().date();
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this2 = this;

        this.rankingPontos.one().get(this.getParams()).then(function (data) {
          return _this2.setInfoTable(data);
        }).catch(function () {
          return _this2.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this3 = this;

        var content = this.buildContent(data.content);
        this.vtabela.setData(content.map(function (i) {
          return _this3.getItemVtabela(i);
        }));
      }
    }, {
      key: 'buildContent',
      value: function buildContent(content) {
        return this.filter('orderBy')(content.map(function (item) {
          return angular.extend(item, {
            veiculosExtenso: item.veiculos.filter(function (vei) {
              return vei.prefixo || vei.placa;
            }).map(function (vei) {
              if (!vei.prefixo || vei.prefixo === vei.placa) {
                return vei.placa;
              } else if (!vei.placa) {
                return vei.prefixo;
              }
              return vei.prefixo + ' - ' + vei.placa;
            }).join(', '),
            motoristas: item.motoristas && item.motoristas[0] || {},
            departamentos: item.departamentos && item.departamentos[0] || {}
          });
        }), 'classificacaoGeral', true);
      }
    }, {
      key: 'setTableState',
      value: function setTableState(tableState) {
        if (this.$parent.rankingPontos.tableState !== null) {
          tableState.sort = this.$parent.rankingPontos.tableState.sort;
        }
        this.$parent.rankingPontos.tableState = tableState;
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        var fields = ['motorista.id', 'motorista.nome', 'motorista.ativo', 'departamento.id', 'departamento.nome', 'veiculo.id', 'veiculo.placa', 'veiculo.prefixo', 'tempoEmDirecao', 'distanciaPercorrida', 'pontosTotal', 'classificacaoGeral', 'meg', 'megHoras'];

        return Object.assign({ fields: fields.toString() }, this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar), { groupFields: 'motoristaId' });
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/boletim/ranking/pontuacao-motoristas/mensal/csv?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getUrlPdf',
      value: function getUrlPdf() {
        return '/boletim/ranking/pontuacao-motoristas/mensal/pdf?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'getLinkBdv',
      value: function getLinkBdv(veiculosIds) {
        var tablestate = this.objetosVfiltroService.getTableState(this.tableState),
            tablestateUrl = tablestate && 'tablestate=' + tablestate + '&' || '',
            vfiltro = angular.copy(this.vfiltro);
        vfiltro[this.keys.veiculos.name] = veiculosIds.map(function (vei) {
          return vei.id;
        }).join(',');

        return '/relatorios/bdv?' + tablestateUrl + 'vfiltro=' + this.urlService.getObjectVfiltroUrl(vfiltro);
      }
    }, {
      key: 'getLinkBdm',
      value: function getLinkBdm(motoristaId) {
        var tablestate = this.objetosVfiltroService.getTableState(this.tableState),
            tablestateUrl = tablestate && 'tablestate=' + tablestate + '&' || '',
            vfiltro = angular.copy(this.vfiltro);
        vfiltro[this.keys.motoristas.name] = motoristaId;
        return '/relatorios/bdm?' + tablestateUrl + 'vfiltro=' + this.urlService.getObjectVfiltroUrl(vfiltro);
      }
    }, {
      key: 'getLinkProntuario',
      value: function getLinkProntuario(motoristaId) {
        var _this4 = this;

        if (!this.shouldShowProntuarioBtn()) {
          return '';
        }

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this4.keys.uo.name;
        }).value.id,
            dateTime = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this4.keys.dateTime.name;
        }).value.tipo;
        return '/prontuario?vfiltro=' + this.keys.uo.name + ':' + uoId + ';' + this.keys.dateTime.name + ':' + this.prontuarioLinkService.handleProntuarioLink(dateTime) + ';' + this.keys.motorista.name + ':' + motoristaId;
      }
    }, {
      key: 'getPointsPerUnits',
      value: function getPointsPerUnits() {
        return this.pontos100Km + ' ' + this.distanceUnit;
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(uoId) {
        var _this5 = this;

        return this.featureOuService.getEventsConfig(uoId).then(function (eventNAConfig) {
          _this5.eventNAConfig = eventNAConfig;
        });
      }
    }, {
      key: 'hasVehiclePermission',
      value: function hasVehiclePermission(vehicle) {
        return vehicle !== this.labelNoPermissionVehicle;
      }
    }, {
      key: 'handleDistanceUnitConversion',
      value: function handleDistanceUnitConversion(value) {
        return this.usuario.measurementUnits.distanceMeasurement === 'MILES' ? this.convertersService.handleKmToMilesWithDecimal(value, 2) : value;
      }
    }]);

    return RankingPontosCtrl;
  }();

  angular.module('ranking.Pontos').controller('RankingPontosCtrl', RankingPontosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ranking.Infracoes', ['ui.router', 'videoPlayer', 'AlertasModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'uoModule', 'ui.bootstrap.modal', 'angularMoment', 'ConstantModule', 'pascalprecht.translate', 'usuarioModule', 'httpServiceV3gModule', 'v3gTrimbleFilters', 'historicoAlerta', 'TagIgnoreModule']).factory('RankingInfracoes', function (Restangular) {
    return Restangular.service('alerta/ranking-infracoes');
  }).factory('AlertasRanking', function (Restangular) {
    return Restangular.service('alerta/ranking-infracoes/alertas');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.rankingInfracoes', {
      url: '/ranking/infracoes?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'ranking/infracoes/infracoes.tpl.html',
          controller: 'RankingInfracoesCtrl',
          controllerAs: 'rankingInfracoes'
        }
      },
      data: {
        titulo: 'ce.tempoReal.infracoes.titulo',
        role: 'RANKING_INFRACOES_VISUALIZAR'
      }
    });
  }

  angular.module('ranking.Infracoes').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var RankingInfracoesCtrl = function () {
    function RankingInfracoesCtrl(RankingInfracoes, AlertasRanking, Keys, ServiceVfiltro, FactoryVfiltro, Uos, $scope, AlertasEnum, $uibModal, $interval, $timeout, moment, $filter, $translate, GoogleTagManagerUtils) {
      var _this = this;

      _classCallCheck(this, RankingInfracoesCtrl);

      this.rankingInfracoesService = RankingInfracoes;
      this.alertasRankingService = AlertasRanking;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.uoService = Uos;
      this.scope = $scope;
      this.alertasEnum = AlertasEnum;
      this.uibModal = $uibModal;
      this.interval = $interval;
      this.timeout = $timeout;
      this.moment = moment;
      this.filter = $filter;
      this.translate = $translate;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.STATUS_VIDEO_ASSISTIVEL = ['CONCLUIDO', 'ASSISTIDO'];

      this.orders = {
        PONTUACAO: this.translate.instant('ce.tempoReal.infracoes.common.pontos'),
        PONTOS_NAO_TRATADOS: this.translate.instant('ce.tempoReal.infracoes.common.pontosNaoTratados')
      };
      this.orderBy = this.orders.PONTUACAO;
      this.motoristaNaoIdentificado = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.motoristaNaoIdentificado');
      this.naoIdentificado = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.naoIdentificado');

      this.reloadDataInvertal = 60 * 1000;

      this.infracoes = [];
      this.details = null;
      this.isDrawerActive = false;
      this.isDetailsReloaded = false;
      this.itemsReloaded = new Set();
      this.limit = 100;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name
      }])).then(function () {
        _this.init(_this.serviceVfiltro.factoryVfiltro.user);
      });
    }

    _createClass(RankingInfracoesCtrl, [{
      key: 'init',
      value: function init(user) {
        var _this2 = this;

        this.user = user;

        this.interval(function () {
          _this2.loadData();
        }, this.reloadDataInvertal);
        this.loadData();
      }
    }, {
      key: 'loadData',
      value: function loadData() {
        var _this3 = this;

        var filtro = this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar);
        this.rankingInfracoesService.one().get(filtro).then(function (data) {
          _this3.loadInfracoes(_this3.parseData(data.plain()));
          _this3.updateDetails();
        });
      }
    }, {
      key: 'parseData',
      value: function parseData(data) {
        data.forEach(function (item) {
          item.id = angular.isDefined(item.motorista) ? item.veiculo.id + '-' + item.motorista.id : item.veiculo.id;

          item.totalPontuacao = item.pontuacoes.map(function (alerta) {
            return alerta.total;
          }).reduce(function (a, b) {
            return a + b;
          }, 0);

          item.totalResolvido = item.pontuacoes.map(function (alerta) {
            return alerta.resolvido;
          }).reduce(function (a, b) {
            return a + b;
          }, 0);
        });

        return this.ranquear(data);
      }
    }, {
      key: 'ranquear',
      value: function ranquear(data) {
        var _this4 = this;

        if (this.orderBy === this.orders.PONTUACAO) {
          data.sort(function (a, b) {
            return a.totalPontuacao - b.totalPontuacao;
          });
        } else {
          data.sort(function (a, b) {
            return a.totalPontuacao - a.totalResolvido - (b.totalPontuacao - b.totalResolvido);
          });
        }

        data.forEach(function (item, index) {
          item.ranking = index + 1;
          var infracao = _this4.getInfracao(item.id);
          if (angular.isDefined(infracao)) {
            if (item.totalPontuacao !== infracao.totalPontuacao || item.totalResolvido !== infracao.totalResolvido) {
              _this4.setItemReloaded(item.id);
            }
          }
        });

        return data;
      }
    }, {
      key: 'setItemReloaded',
      value: function setItemReloaded(id) {
        var _this5 = this;

        this.itemsReloaded.add(id);
        this.timeout(function () {
          _this5.itemsReloaded.delete(id);
          _this5.scope.$apply();
        }, 5000);
      }
    }, {
      key: 'isItemReloaded',
      value: function isItemReloaded(id) {
        return this.itemsReloaded.has(id);
      }
    }, {
      key: 'loadInfracoes',
      value: function loadInfracoes(data) {
        this.infracoes = data;
      }
    }, {
      key: 'updateDetails',
      value: function updateDetails() {
        if (this.details !== null) {
          var infracao = this.getInfracao(this.details.id);
          if (angular.isDefined(infracao)) {
            if (!angular.equals(this.details.pontuacoes, infracao.pontuacoes)) {
              this.loadDetails(infracao.id);
            }
          }
        }
      }
    }, {
      key: 'loadDetails',
      value: function loadDetails(id) {
        var _this6 = this;

        this.details = this.getInfracao(id);

        if (!this.isDetailsReloaded) {
          this.isDetailsReloaded = true;

          this.timeout(function () {
            _this6.isDetailsReloaded = false;
            _this6.scope.$apply();
          }, 500);
        }

        this.loadAlertas();
      }
    }, {
      key: 'loadAlertas',
      value: function loadAlertas() {
        var _this7 = this;

        var params = this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar);
        params.rankingCardIds = this.details.ids.join(',');
        this.alertasRankingService.one().get(params).then(function (data) {
          _this7.alertasDetalhados = _.groupBy(data.plain(), 'tipo');
        });
      }
    }, {
      key: 'getInfracao',
      value: function getInfracao(id) {
        return this.infracoes.find(function (item) {
          return item.id === id;
        });
      }
    }, {
      key: 'getAlertaDescricao',
      value: function getAlertaDescricao(tipo) {
        return this.translate.instant(this.alertasEnum[tipo].descricao);
      }
    }, {
      key: 'openAcoesModal',
      value: function openAcoesModal(_status, _tipo) {
        var _this8 = this;

        this.uibModal.open({
          templateUrl: 'ranking/infracoes/acoes-alerta.html',
          controller: 'AcoesAlertaCtrl as acoesAlertaModal',
          resolve: {
            details: function details() {
              return _this8.details;
            },
            status: function status() {
              return _status;
            },
            tipo: function tipo() {
              return _tipo;
            }
          }
        }).result.finally(function () {
          return _this8.loadData();
        });
      }
    }, {
      key: 'onVideoClick',
      value: function onVideoClick() {
        this.googleTagManagerUtils.sendEventClickGTM('infracoes_reproduzir_video_vfleets', this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'toggleDrawer',
      value: function toggleDrawer() {
        this.isDrawerActive = !this.isDrawerActive;
      }
    }, {
      key: 'formatar',
      value: function formatar(numero) {
        var casasDecimais = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        return numero.toFixed(casasDecimais).replace(/\.0+$/, '');
      }
    }, {
      key: 'formataLimiar',
      value: function formataLimiar(alerta) {
        switch (alerta.tipo) {
          case 'PERMANENCIA_PONTO':
          case 'PARADO_LIGADO':
            return this.filter('humanizedDuration')(alerta.limiar);

          default:
            if (angular.isNumber(alerta.limiar)) {
              return this.filter('number')(alerta.limiar, 2);
            }
            return '';
        }
      }
    }, {
      key: 'toggleDropdownMenuAcoes',
      value: function toggleDropdownMenuAcoes(tipoAlerta, event) {
        event.preventDefault();
        event.stopPropagation();
        this.dropdownMenuAcoes = this.dropdownMenuAcoes === tipoAlerta ? null : tipoAlerta;
      }
    }, {
      key: 'getLinkHistoricoDetalhado',
      value: function getLinkHistoricoDetalhado(tipoAlerta) {
        if (this.serviceVfiltro.filtroTopbar && this.details) {
          var dataInicio = this.moment().subtract(12, 'hours').format('YYYY.MM.DD.HH.mm.ss.ZZ'),
              dataFim = this.moment().format('YYYY.MM.DD.HH.mm.ss.ZZ'),
              filtro = this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar);
          if (tipoAlerta) {
            return '/historico-timeline?vfiltro=' + ('dateTime:' + dataInicio + ',' + dataFim + ';') + ('uo:' + filtro.uoId + ';') + ('veiculo:' + this.details.veiculo.id) + ('&tipoEvento=' + tipoAlerta);
          }
          return '/historico-timeline?vfiltro=' + ('dateTime:' + dataInicio + ',' + dataFim + ';') + ('uo:' + filtro.uoId + ';') + ('veiculo:' + this.details.veiculo.id);
        }
        return '';
      }
    }, {
      key: 'isIntensidadeValida',
      value: function isIntensidadeValida(intensidade) {
        return !!intensidade && intensidade !== '-';
      }
    }, {
      key: 'getClasseIcone',
      value: function getClasseIcone(tipoAlerta) {
        return this.alertasEnum[tipoAlerta].icone;
      }
    }, {
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 100;
      }
    }, {
      key: 'hasVideo',
      value: function hasVideo(alerta) {
        return alerta.videoId && _.contains(this.STATUS_VIDEO_ASSISTIVEL, alerta.videoStatus);
      }
    }, {
      key: 'hasSnapshot',
      value: function hasSnapshot(alerta) {
        return !!alerta.snapshotId;
      }
    }]);

    return RankingInfracoesCtrl;
  }();

  angular.module('ranking.Infracoes').controller('RankingInfracoesCtrl', RankingInfracoesCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var AcoesAlertaCtrl = function () {
    function AcoesAlertaCtrl($uibModalInstance, details, status, tipo, Alertas, Usuarios, AlertasEnum, HttpServiceV3g, $translate) {
      _classCallCheck(this, AcoesAlertaCtrl);

      this.modalInstance = $uibModalInstance;
      this.alertasService = Alertas;
      this.usuarioService = Usuarios;
      this.httpService = HttpServiceV3g;
      this.alertasEnum = AlertasEnum;
      this.translate = $translate;

      this.usuario = null;
      this.usuarios = [];
      this.alerta = null;

      this.motoristaNaoIdentificado = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.motoristaNaoIdentificado');

      this.statusType = {
        atribuir: this.translate.instant('ce.tempoReal.infracoes.statusType.atribuir'),
        resolver: this.translate.instant('ce.tempoReal.infracoes.statusType.resolver')
      };

      this.statusTypeMapBackend = {
        atribuir: 'ATRIBUIDO',
        resolver: 'RESOLVIDO'
      };

      this.status = status;
      this.details = details;
      this.tipo = tipo;

      this.init();
    }

    _createClass(AcoesAlertaCtrl, [{
      key: 'init',
      value: function init() {
        this.loadUsuarios();
      }
    }, {
      key: 'loadUsuarios',
      value: function loadUsuarios() {
        var _this = this;

        this.usuarioService.getUsuarios({ role: 'HISTORICO_ALERTA_VISUALIZAR' }).then(function (data) {
          _this.usuarios = data;
          if (_this.usuario !== null) {
            _this.usuario = data[0];
          }
        });
      }
    }, {
      key: 'fechar',
      value: function fechar() {
        this.modalInstance.dismiss('cancel');
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this2 = this;

        this.httpService.put('/alerta/ranking-infracoes/tratar/' + this.statusTypeMapBackend[this.status], this.details.ids, { params: { tipoAlerta: this.tipo, usuarioId: this.usuario !== null ? this.usuario.id : null } }).then(function () {
          _this2.fechar();
        }, function () {
          _this2.setAlerta(_this2.translate.instant('ce.tempoReal.infracoes.common.mensagem.erroAoSalvarAlteracao'));
        });
      }
    }, {
      key: 'getAlertaDescricao',
      value: function getAlertaDescricao() {
        if (angular.isUndefined(this.tipo)) {
          return this.translate.instant('ce.tempoReal.infracoes.common.todos');
        }
        return this.translate.instant(this.alertasEnum[this.tipo].descricao);
      }
    }, {
      key: 'getTitulo',
      value: function getTitulo() {
        if (this.tipo === null || angular.isUndefined(this.tipo)) {
          return this.translate.instant('ce.tempoReal.infracoes.common.mensagem.titulo.tratarTodosAlertas');
        }
        var stringTraduzida = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.titulo.tratarAlertasDe');
        return stringTraduzida + ' "' + this.translate.instant(this.alertasEnum[this.tipo].descricao) + '"';
      }
    }, {
      key: 'setAlerta',
      value: function setAlerta(message) {
        this.alerta = message;
      }
    }]);

    return AcoesAlertaCtrl;
  }();

  angular.module('ranking.Infracoes').controller('AcoesAlertaCtrl', AcoesAlertaCtrl);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  /* global Intl, _ */
  'use strict';

  var OcorrenciaModalCtrl = function () {
    function OcorrenciaModalCtrl($uibModalInstance, HttpServiceV3g, ModalInfoConfirmService, Ocorrencias, $q, ocorrencia, AlertasEnum, ocorrenciasMotorista, moment, OcorrenciasEnum, $scope, permissaoEditarOcorrencia, $translate) {
      _classCallCheck(this, OcorrenciaModalCtrl);

      this.modalInstance = $uibModalInstance;
      this.httpService = HttpServiceV3g;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.ocorrenciasService = Ocorrencias;
      this.ocorrenciasEnum = OcorrenciasEnum;
      this.alertasEnum = AlertasEnum;
      this.q = $q;
      this.permissaoEditarOcorrencia = permissaoEditarOcorrencia;
      this.ocorrenciasMotorista = ocorrenciasMotorista;
      this.ocorrencia = ocorrencia;
      this.moment = moment;
      this.scope = $scope;
      this.timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.nenhumUsuario = { id: null, login: $translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.usuarioAtribuidoNenhum') };
      this.requestError = false;
      this.model = {
        responsavel: null,
        status: null,
        obs: null
      };
      this.limitScroll = 10;
      this.init();
      // não mostrar label do video até preparar backend
      this.showLabelVideo = false;
    }

    _createClass(OcorrenciaModalCtrl, [{
      key: 'loadMore',
      value: function loadMore() {
        this.limitScroll += 10;
      }
    }, {
      key: 'init',
      value: function init() {
        this.initRequests();

        this.ocorrenciasAnexo = this.getAnexo();
        this.setForm();
        this.filterStatusSelect();
      }
    }, {
      key: 'filterStatusSelect',
      value: function filterStatusSelect() {
        var ocorrenciaStatus = this.ocorrenciasEnum.getStatusById(this.ocorrencia.status);
        this.selectStatus = this.ocorrenciasEnum.getStatus().filter(function (status) {
          return status.nivel >= ocorrenciaStatus.nivel;
        });
      }
    }, {
      key: 'initRequests',
      value: function initRequests() {
        var _this = this;

        var requests = [this.ocorrenciasService.getOcorrenciaById(this.ocorrencia.id, this.ocorrencia.dataHora), this.ocorrenciasService.getUsers(this.ocorrencia.veiculoId), this.ocorrenciasService.getHistorico(this.ocorrencia, this.timezone)];

        this.q.all(requests).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              ocorrencia = _ref2[0],
              userRes = _ref2[1],
              histRes = _ref2[2];

          _this.ocorrencia = ocorrencia.data[0];
          _this.usuarios = userRes.data;
          _this.model.responsavel = _this.usuarios.find(function (user) {
            return user.id === _this.ocorrencia.usuarioIdAtribuido;
          }) || _this.nenhumUsuario;
          _this.usuarios.unshift(_this.nenhumUsuario);
          if (histRes) {
            _this.ocorrencia.hist = histRes.data;
          }
        }).catch(function () {
          _this.requestError = true;
        });
      }
    }, {
      key: 'setForm',
      value: function setForm() {
        this.model.status = this.ocorrenciasEnum.getStatusById(this.ocorrencia.status);
      }
    }, {
      key: 'getAnexo',
      value: function getAnexo() {
        var _this2 = this;

        return this.ocorrenciasMotorista.filter(function (ocorr) {
          return new Date(ocorr.dataHora).getTime() < new Date(_this2.ocorrencia.dataHora).getTime();
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'abreOcorrenciaAnexo',
      value: function abreOcorrenciaAnexo(ocorrencia) {
        this.modalInstance.close({ isAnexo: true, ocorrenciaAnexo: ocorrencia });
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this3 = this;

        var form = this.scope.formTratativa;
        var objTrativa = {
          uoId: this.ocorrencia.uoId,
          ocorrenciaId: this.ocorrencia.id
        };

        objTrativa.comentario = form.obs.$dirty ? this.model.obs : null;
        objTrativa.statusNovo = form.status.$dirty ? this.model.status.id : null;
        objTrativa.usuarioIdAtribuidoNovo = this.model.responsavel.id;

        this.httpService.post('/alerta/ocorrencias/' + this.ocorrencia.id + '/historicos?dataHoraOcorrencia=' + this.ocorrencia.dataHora, objTrativa).then(function () {
          _this3.modalInstance.close({
            isAnexo: false,
            status: _this3.model.status.id,
            usuarioAtribuido: _this3.model.responsavel
          });
        }).catch(function () {
          _this3.modalInstance.dismiss(true);
        });
      }
    }, {
      key: 'isDisabled',
      value: function isDisabled() {
        return this.ocorrencia.status === this.ocorrenciasEnum.getStatusById('RESOLVIDA').id || !this.permissaoEditarOcorrencia;
      }
    }, {
      key: 'showHistorico',
      value: function showHistorico() {
        return this.ocorrenciasAnexo.length || this.ocorrencia.hist && this.ocorrencia.hist.length;
      }
    }, {
      key: 'responsavelValidate',
      value: function responsavelValidate(value) {
        var _this4 = this;

        return function () {
          if (_this4.model.status && _this4.model.status.id === 'EM_TRATATIVA') {
            return value.$viewValue && !!value.$viewValue.id;
          }
          return true;
        };
      }
    }, {
      key: 'formChanged',
      value: function formChanged() {
        if (!this.model.responsavel) {
          return false;
        }
        var usuarioIdAtribuido = angular.isUndefined(this.ocorrencia.usuarioIdAtribuido) ? null : this.ocorrencia.usuarioIdAtribuido,
            observacaoChanged = !!this.model.obs,
            statusChanged = this.model.status.id !== this.ocorrencia.status,
            responsavelChanged = this.model.responsavel.id !== usuarioIdAtribuido;
        return observacaoChanged || statusChanged || responsavelChanged;
      }
    }]);

    return OcorrenciaModalCtrl;
  }();

  angular.module('quadroOcorrencias').controller('OcorrenciaModalCtrl', OcorrenciaModalCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var OcorrenciaCardCtrl = function () {
    function OcorrenciaCardCtrl($filter, ServiceVfiltro, $translate, AlertasEnum) {
      _classCallCheck(this, OcorrenciaCardCtrl);

      this.filter = $filter;
      this.serviceVfiltro = ServiceVfiltro;
      this.alertasEnum = AlertasEnum;
      this.alerts = [];

      this.qtdTiposAlertas = 0;
      this.semIdentificacaoI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.common.semIdentificacao');
      this.motoristaI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.motorista');
      this.usuarioAtribuidoI18n = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaCard.usuarioAtribuido');
      this.semUsuarioAtribuidoI18n = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaCard.semUsuarioAtribuido');
      // não mostrar icone do video até preparar backend
      this.showIconVideo = false;
    }

    _createClass(OcorrenciaCardCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.serviceVfiltro.factoryVfiltro.authenticator.getUser().then(function (user) {
          _this.dateFormat = user.measurementUnits.dateTimeFormat;
        });
        this.roleVisualizarVideo = this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIDEO_VISUALIZAR');
        this.temVideo = this.ocorrencia.alertasGerados.some(function (alerta) {
          return alerta.videoIds && alerta.videoIds.length;
        });

        this.infoItemMotorista = {
          icon: 'fa fa-user',
          title: this.motoristaI18N,
          upperCase: true,
          description: function description() {
            return _this.ocorrencia.motorista ? _this.ocorrencia.motorista.nome : _this.semIdentificacaoI18N;
          }
        };

        this.infoItemUsuarioAtribuido = {
          icon: 'fa fa-check-circle-o',
          title: this.usuarioAtribuidoI18n,
          description: function description() {
            return _this.ocorrencia.usuarioAtribuido && _this.ocorrencia.usuarioAtribuido.login ? _this.ocorrencia.usuarioAtribuido.login : _this.semUsuarioAtribuidoI18n;
          }
        };

        this.totalAlertas = this.ocorrencia.alertasGerados.reduce(function (sum, alerta) {
          return sum + alerta.quantidade;
        }, 0);

        this.handleSortAlerts();
      }
    }, {
      key: 'getDateFormat',
      value: function getDateFormat() {
        if (this.dateFormat === 'AMERICAN') {
          return 'MM/dd/yyyy';
        }
        return 'dd/MM/yyyy';
      }
    }, {
      key: 'handleSortAlerts',
      value: function handleSortAlerts() {
        var _this2 = this;

        var alertWithQuantity = this.ocorrencia.alertasGerados.reduce(function (acc, alerta) {
          if (!acc[alerta.tipo]) {
            acc[alerta.tipo] = 0;
          }
          acc[alerta.tipo] += alerta.quantidade;
          return acc;
        }, {});

        this.alerts = Object.keys(alertWithQuantity).map(function (tipo) {
          return {
            tipo: tipo,
            quantidade: alertWithQuantity[tipo]
          };
        }).filter(function (alert) {
          return alert.quantidade > 0;
        });

        if (this.eventsOrder && this.eventsOrder.length) {
          this.alerts.sort(function (a, b) {
            var aIndex = _this2.eventsOrder.indexOf(a.tipo),
                bIndex = _this2.eventsOrder.indexOf(b.tipo);
            return aIndex - bIndex;
          });
        }
      }
    }, {
      key: 'handleDescription',
      value: function handleDescription(tipo) {
        var alertaTipo = this.alertasEnum.getAlerta(tipo) || {};
        return alertaTipo.descricaoIntermediaria || alertaTipo.descricaoCurta || alertaTipo.descricao;
      }
    }, {
      key: 'handleEventsQuantity',
      value: function handleEventsQuantity() {
        return this.totalAlertas - this.alerts[0].quantidade - this.alerts[1].quantidade;
      }
    }]);

    return OcorrenciaCardCtrl;
  }();

  angular.module('quadroOcorrencias').component('ocorrenciaCard', {
    controller: OcorrenciaCardCtrl,
    templateUrl: 'quadro-ocorrencias/ocorrencia-card/ocorrencia-card.tpl.html',
    bindings: {
      ocorrencia: '=',
      eventsOrder: '='
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var InfoItemCtrl = function InfoItemCtrl() {
    _classCallCheck(this, InfoItemCtrl);
  };

  angular.module('conducaoEconomica').component('infoItem', {
    controller: InfoItemCtrl,
    templateUrl: 'quadro-ocorrencias/info-item/info-item.tpl.html',
    bindings: {
      item: '='
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('BuscaRegiaoModule', []);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var TutorialBuscaRegiaoCtrl = function () {
    function TutorialBuscaRegiaoCtrl($window) {
      _classCallCheck(this, TutorialBuscaRegiaoCtrl);

      this.window = $window;
    }

    _createClass(TutorialBuscaRegiaoCtrl, [{
      key: 'start',
      value: function start() {
        this.window.open('mapas-grid?demo&vfiltro=dateTime:ontem;uo:1&vtabela=currentPage:1;pageSize:50&camada=ESTRADAS', '_blank');
        this.closeContainer();
      }
    }, {
      key: 'closeContainer',
      value: function closeContainer() {
        /*eslint-disable */
        var dataAtual = new Date();
        this.window.localStorage.setItem('tutorial-busca-regiao', dataAtual.setDate(dataAtual.getDate() + 3));
        document.getElementById('container-busca-regiao').style.display = 'none'; /*eslint-enable */
      }
    }]);

    return TutorialBuscaRegiaoCtrl;
  }();

  angular.module('conducaoEconomica').controller('TutorialBuscaRegiaoCtrl', TutorialBuscaRegiaoCtrl).directive('tutorialBuscaRegiao', function () {
    return {
      restrict: 'E',
      templateUrl: 'onboarding/tutorial-busca-regiao/tutorial-busca-regiao-directive.tpl.html',
      controller: TutorialBuscaRegiaoCtrl,
      controllerAs: 'ctrl'
    };
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('ocorrencia.component', ['AlertasModule', 'quadroOcorrencias', 'pascalprecht.translate', 'ProntuarioLinkModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global _ */
(function () {
  'use strict';

  var OcorrenciaHistoricoCtrl = function () {
    function OcorrenciaHistoricoCtrl() {
      _classCallCheck(this, OcorrenciaHistoricoCtrl);
    }

    _createClass(OcorrenciaHistoricoCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.ocorrencia = _.cloneDeep(this.item);
        this.veiculoId = this.ocorrencia.veiculoId;
      }
    }]);

    return OcorrenciaHistoricoCtrl;
  }();

  angular.module('ocorrencia.component').component('ocorrenciaHistorico', {
    controller: OcorrenciaHistoricoCtrl,
    templateUrl: 'ocorrencia/ocorrencia-historico/ocorrencia-historico.tpl.html',
    bindings: {
      item: '='
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global _ */
(function () {
  'use strict';

  var OcorrenciaEventosCtrl = function () {
    function OcorrenciaEventosCtrl(AlertasEnum, Ocorrencias) {
      _classCallCheck(this, OcorrenciaEventosCtrl);

      this.alertasEnum = AlertasEnum;
      this.ocorrenciasService = Ocorrencias;
      this.showLabelVideo = false;
    }

    _createClass(OcorrenciaEventosCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.ocorrencia = _.cloneDeep(this.item);
        this.linkHistoricoDetalhado = this.getLinkHistoricoDetalhado(this.ocorrencia);
        this.geraAlertasAgrupados();
      }
    }, {
      key: 'getLinkHistoricoDetalhado',
      value: function getLinkHistoricoDetalhado() {
        var paramVfiltro = this.ocorrenciasService.getParamsHistDetalhado(this.ocorrencia);
        return 'historico-timeline?' + paramVfiltro;
      }
    }, {
      key: 'geraAlertasAgrupados',
      value: function geraAlertasAgrupados() {
        this.alertasAgrupados = _(this.ocorrencia.alertasGerados).groupBy('tipo').map(function (alertas, tipo) {
          return {
            tipo: tipo,
            quantidade: alertas.reduce(function (acc, alerta) {
              return acc + alerta.quantidade;
            }, 0),
            videoIds: alertas.reduce(function (acc, alerta) {
              return alerta.videoIds ? [].concat(_toConsumableArray(acc), _toConsumableArray(alerta.videoIds)) : acc;
            }, [])
          };
        }).value();
      }
    }]);

    return OcorrenciaEventosCtrl;
  }();

  angular.module('ocorrencia.component').component('ocorrenciaEventos', {
    controller: OcorrenciaEventosCtrl,
    templateUrl: 'ocorrencia/ocorrencia-eventos/ocorrencia-eventos.tpl.html',
    bindings: {
      item: '='
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global _ */
(function () {
  'use strict';

  var OcorrenciaDadosCtrl = function () {
    function OcorrenciaDadosCtrl($translate, ProntuarioLinkService, Authenticator, MeasurementUnitConverterService) {
      _classCallCheck(this, OcorrenciaDadosCtrl);

      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.uoVeiculoI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.uoVeiculo');
      this.grupoVeiculoI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.grupoVeiculo');
      this.uoMotoristaI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.uoMotorista');
      this.departamentoI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.ocorrenciaDados.departamento');
      this.prontuarioLinkService = ProntuarioLinkService;
    }

    _createClass(OcorrenciaDadosCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.ocorrencia = _.cloneDeep(this.item);

        if (this.ocorrencia.veiculo) {
          this.linkMapaVeiculo = this.getLinkLocalizacaoFrota();
        }

        if (this.ocorrencia.motorista) {
          this.linkHistoricoOcorrencias = this.getLinkHistoricoOcorrencias();
          this.linkProntuario = this.getLinkProntuario();
        }

        this.dateFormat = 'dd/MM/yyyy';
        this.authenticator.getUser().then(function (user) {
          _this.user = user;
          _this.userPreferredDateFormat = user.measurementUnits && user.measurementUnits.dateTimeFormat || 'BRITISH';
          _this.dateFormat = _this.measurementUnitConverterService.getDateFormat(_this.userPreferredDateFormat);
        });

        this.buildConjInfos();
      }
    }, {
      key: 'getLinkLocalizacaoFrota',
      value: function getLinkLocalizacaoFrota() {
        return 'mapas-grid?vfiltro=uo:' + this.ocorrencia.veiculo.uo.id + ';veiculos:' + this.ocorrencia.veiculo.id;
      }
    }, {
      key: 'getLinkProntuario',
      value: function getLinkProntuario() {
        return 'prontuario?vfiltro=dateTime:' + this.prontuarioLinkService.handleProntuarioLink('ontem') + ';motorista:' + this.ocorrencia.motorista.id;
      }
    }, {
      key: 'getLinkHistoricoOcorrencias',
      value: function getLinkHistoricoOcorrencias() {
        return '/relatorios/historico-ocorrencia?vfiltro=dateTime:ontem;uo:' + this.ocorrencia.motorista.uo.id + ';motoristas:' + this.ocorrencia.motorista.id;
      }
    }, {
      key: 'buildConjInfos',
      value: function buildConjInfos() {
        this.veiculoInfos = [];
        this.motoristaInfos = [];

        this.veiculoInfos.push(this.buildInfo('trimble-icon trimble-ou', this.uoVeiculoI18N, this.ocorrencia.veiculo.uo.nome));
        if (this.ocorrencia.veiculo.grupo) {
          this.veiculoInfos.push(this.buildInfo('trimble-icon trimble-group', this.grupoVeiculoI18N, this.ocorrencia.veiculo.grupo.nome));
        }

        if (this.ocorrencia.motorista) {
          this.motoristaInfos.push(this.buildInfo('trimble-icon trimble-ou', this.uoMotoristaI18N, this.ocorrencia.motorista.uo.nome));
          if (this.ocorrencia.motorista.departamento) {
            this.motoristaInfos.push(this.buildInfo('fa fa-users', this.departamentoI18N, this.ocorrencia.motorista.departamento.nome));
          }
        }
      }
    }, {
      key: 'buildInfo',
      value: function buildInfo(icon, title, value, link, linkText) {
        return {
          icon: icon, title: title, description: function description() {
            return value;
          }, link: link, linkText: linkText
        };
      }
    }]);

    return OcorrenciaDadosCtrl;
  }();

  angular.module('ocorrencia.component').component('ocorrenciaDados', {
    controller: OcorrenciaDadosCtrl,
    templateUrl: 'ocorrencia/ocorrencia-dados/ocorrencia-dados.tpl.html',
    bindings: {
      item: '='
    }
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name mapasGrid
   * @description
   *
   */

  angular.module('mapasGrid', ['ui.router', 'leaflet-directive', 'ModuleMapasUtil', 'ModuleConvertersUtil', 'ConstantModule', 'angularMoment', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'mapas', 'leaflet-directive', 'ui.bootstrap.modal', 'alert-message', 'enumModule', 'urlConfigModule', 'v3gAuthenticatorModule', 'blockUI', 'httpServiceV3gModule', 'pascalprecht.translate', 'UrlModule', 'UoHelperModule']).factory('StatusVeiculo', function (Restangular) {
    return Restangular.service('sensor/status-veiculo');
  }).factory('StatusVeiculoPassivelManutencao', function (Restangular) {
    var url = 'alerta/passiveis-manutencao';
    var service = Restangular.service(url);

    service.getStatusVeiculos = function (uoId) {
      return Restangular.one(url + '/' + uoId + '/status-veiculos').get();
    };
    return service;
  }).factory('PermanenciaRealtime', function (Restangular) {
    return Restangular.service('ponto-referencia/permanencias/realtime-by-permission');
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalSelectCtrl = function ModalSelectCtrl($uibModalInstance) {
    _classCallCheck(this, ModalSelectCtrl);

    this.modalInstance = $uibModalInstance;
  };

  angular.module('mapasGrid').controller('ModalSelectCtrl', ModalSelectCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var EnviarComando = function () {
    function EnviarComando($uibModalInstance, veiculoIds, AlertMessage, HttpServiceV3g, $httpParamSerializer, TiposComando, $translate, ServiceVfiltro, GoogleTagManagerUtils) {
      _classCallCheck(this, EnviarComando);

      this.modalInstance = $uibModalInstance;
      this.alertMessage = AlertMessage;
      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
      this.veiculoIds = veiculoIds;
      this.tiposComando = TiposComando;
      this.translate = $translate;
      this.serviceVfiltro = ServiceVfiltro;
      this.googleTagManagerUtils = GoogleTagManagerUtils;

      this.comandos = [];
      this.getComandos();
    }

    _createClass(EnviarComando, [{
      key: 'getComandos',
      value: function getComandos() {
        var _this = this;

        this.httpService.get('/comando/tipos?veiculos=' + this.veiculoIds.join()).success(function (data) {
          _this.comandos = data;
          if (_this.hasVeiculosAfetados()) {
            _this.defaultOption = _this.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.selecionarComando');
          } else {
            _this.defaultOption = _this.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.nenhumComandoDisponivel');
          }
        }).error(function () {
          _this.erro = true;
          _this.defaultOption = _this.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.nenhumComandoDisponivel');
          _this.msgErro = _this.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.erroCarregarComando');
        });
      }
    }, {
      key: 'limpaErro',
      value: function limpaErro() {
        this.erro = false;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'hasVeiculosAfetados',
      value: function hasVeiculosAfetados() {
        return _.some(this.comandos, function (comando) {
          return comando.veiculos.length > 0;
        });
      }
    }, {
      key: 'efetuaEnvioComando',
      value: function efetuaEnvioComando() {
        var _this2 = this;

        if (angular.isDefined(this.model)) {
          this.sendCommandInfoToGTM(this.model.comandoSelected.tipo);
          this.httpService.post('/comando/comandos', this.model.comandoSelected).success(function () {
            if (_this2.model.comandoSelected.veiculos.length) {
              _this2.modalInstance.close({ hasAfetados: true, msg: _this2.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.requisicaoEnvioComando') });
            } else {
              _this2.modalInstance.close({ hasAfetados: false, msg: _this2.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.nenhumVeiculoAfetado') });
            }
          }).error(function () {
            _this2.erro = true;
            _this2.msgErro = _this2.translate.instant('ce.mapa.localizacaoDaFrota.enviarComando.ocorreuUmErro');
          });
        }
      }
    }, {
      key: 'sendCommandInfoToGTM',
      value: function sendCommandInfoToGTM(tipoComando) {
        switch (tipoComando) {
          case 'ACIONAR_BUZZER':
            this.googleTagManagerUtils.sendEventClickGTM('localizacao_frota_comando_acionar_buzzer', this.serviceVfiltro.factoryVfiltro.user);
            break;
          case 'DESACIONAR_BUZZER':
            this.googleTagManagerUtils.sendEventClickGTM('localizacao_frota_comando_desacionar_buzzer', this.serviceVfiltro.factoryVfiltro.user);
            break;
          case 'DESACIONAR_BLOQUEIO':
            this.googleTagManagerUtils.sendEventClickGTM('localizacao_frota_comando_desacionar_bloqueio', this.serviceVfiltro.factoryVfiltro.user);
            break;
          default:
            break;
        }
      }
    }]);

    return EnviarComando;
  }();

  angular.module('mapasGrid').controller('EnviarComandoCtrl', EnviarComando).constant('TiposComando', {
    ACIONAR_BUZZER: 'ce.mapa.localizacaoDaFrota.enviarComando.acionarBuzzer',
    DESACIONAR_BUZZER: 'ce.mapa.localizacaoDaFrota.enviarComando.desacionarBuzzer',
    DESACIONAR_BLOQUEIO: 'ce.mapa.localizacaoDaFrota.enviarComando.desacionarBloqueio'
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.historicoVeiculo
   * @description
   *
   */

  angular.module('mapas', ['leaflet-directive', 'ui.bootstrap.modal', 'ModuleMapasUtil', 'ModuleEventos', 'pascalprecht.translate', 'ModuleConvertersUtil', 'VTabelaCellFilter', 'ProntuarioLinkModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ToggleLayerMarkersCtrl = function () {
    function ToggleLayerMarkersCtrl(MapLayerVisibility, Authenticator, MapasUtil, $scope) {
      var _this = this;

      _classCallCheck(this, ToggleLayerMarkersCtrl);

      this.mapLayerConstant = MapLayerVisibility;
      this.authenticator = Authenticator;
      this.mapasUtil = MapasUtil;
      this.scope = $scope;

      this.user = null;
      this.options = [{
        name: this.mapLayerConstant.PONTO_REFERENCIA,
        label: 'ce.common.permanencia.pontoReferencia',
        shouldShow: true
      }, {
        name: this.mapLayerConstant.CERCA_ELETRONICA,
        label: 'ce.common.permanencia.cercaEletronica',
        shouldShow: true
      }];
      this.scope.$on('layerVisibilityHasChanged', function (event, entityType, shouldShow) {
        _this.updateCheckboxValue(entityType, shouldShow);
      });
    }

    _createClass(ToggleLayerMarkersCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          _this2.user = user;
          _this2.populateOptionsWithUserPreferences();
        });
      }
    }, {
      key: 'onSelectOption',
      value: function onSelectOption(optionName, optionvalue) {
        this.savePreferencesInLocalStorage();
        this.mapasUtil.notifyLayersVisibilityChange(optionName, optionvalue);
      }
    }, {
      key: 'populateOptionsWithUserPreferences',
      value: function populateOptionsWithUserPreferences() {
        var _this3 = this;

        var preferencesLocalStorage = this.loadPreferencesFromLocalStorage();
        if (preferencesLocalStorage) {
          preferencesLocalStorage.forEach(function (preference) {
            _this3.updateCheckboxValue(preference.name, preference.shouldShow);
          });
        }
      }
    }, {
      key: 'updateCheckboxValue',
      value: function updateCheckboxValue(entityType, newValue) {
        var option = this.options.find(function (checkbox) {
          return checkbox.name === entityType;
        });
        option.shouldShow = newValue;
      }
    }, {
      key: 'loadPreferencesFromLocalStorage',
      value: function loadPreferencesFromLocalStorage() {
        return this.mapasUtil.getLayersVisibilityLocalStorage(this.user.id);
      }
    }, {
      key: 'savePreferencesInLocalStorage',
      value: function savePreferencesInLocalStorage() {
        var toPreference = this.options.map(function (_ref) {
          var name = _ref.name,
              shouldShow = _ref.shouldShow;
          return { name: name, shouldShow: shouldShow };
        });
        this.mapasUtil.setLayersVisibilityLocalStorage(this.user.id, toPreference);
      }
    }]);

    return ToggleLayerMarkersCtrl;
  }();

  angular.module('mapas').component('toggleLayerMarkers', {
    templateUrl: 'mapas/toggle-layer-markers/toggle-layer-markers-component.tpl.html',
    controller: ToggleLayerMarkersCtrl
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('mapas').constant('MapLayerVisibility', {
    PONTO_REFERENCIA: 'ponto-referencia',
    CERCA_ELETRONICA: 'cerca-eletronica'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L */
(function () {
  'use strict';

  var CAMADA_PARAM = 'camada';

  var MapLayerSwitcherCtrl = function () {
    function MapLayerSwitcherCtrl(Restangular, UrlService, $window, $timeout, MapasUtil, $rootScope) {
      var _defaultOptions;

      _classCallCheck(this, MapLayerSwitcherCtrl);

      this.restangular = Restangular;
      this.urlService = UrlService;
      this.window = $window;
      this.timeout = $timeout;
      this.mapasUtil = MapasUtil;
      this.rootScope = $rootScope;
      this.layerIds = {
        ESTRADAS: 'ESTRADAS',
        SATELITE: 'SATELITE',
        ESTRADAS_DIA: 'ESTRADAS_DIA',
        ESTRADAS_NOITE: 'ESTRADAS_NOITE'
      };
      this.defaultOptions = (_defaultOptions = {}, _defineProperty(_defaultOptions, this.layerIds.ESTRADAS, {
        label: 'ce.utils.mapa.estradas',
        value: this.layerIds.ESTRADAS,
        iconClass: 'fa fa-road'
      }), _defineProperty(_defaultOptions, this.layerIds.SATELITE, {
        label: 'ce.utils.mapa.satelite',
        value: this.layerIds.SATELITE,
        iconClass: 'fa fa-globe'
      }), _defaultOptions);
    }

    _createClass(MapLayerSwitcherCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.shouldSetUrlParam = angular.isUndefined(this.shouldSetUrlParam) ? true : this.shouldSetUrlParam;
        this.availableOptions = this.getAvailableOptions();
        this.selectedOption = this.getLastSelectedOption();
        this.fetchLayerData();

        this.tilesConfigListener = this.rootScope.$on('tilesConfigUpdated', function (event, data) {
          _this.layersData[_this.layerIds.ESTRADAS] = data.newConfig;
          _this.onSelectOption();
        });
      }
    }, {
      key: '$onDestroy',
      value: function $onDestroy() {
        if (this.urlExpirationTimeout) {
          this.timeout.cancel(this.urlExpirationTimeout);
        }
        if (this.tilesConfigListener) {
          this.tilesConfigListener();
        }
      }
    }, {
      key: 'getLastSelectedOption',
      value: function getLastSelectedOption() {
        return this.availableOptions[this.urlService.getQueryString(CAMADA_PARAM)] || this.availableOptions[this.window.localStorage.getItem(CAMADA_PARAM)] || Object.values(this.availableOptions)[0];
      }
    }, {
      key: 'getAvailableOptions',
      value: function getAvailableOptions() {
        if (this.useNightAndDayOptions) {
          var _ref;

          return _ref = {}, _defineProperty(_ref, this.layerIds.ESTRADAS_DIA, {
            label: 'ce.utils.mapa.estradasDia',
            value: this.layerIds.ESTRADAS_DIA,
            iconClass: 'fa fa-road'
          }), _defineProperty(_ref, this.layerIds.ESTRADAS_NOITE, {
            label: 'ce.utils.mapa.estradasNoite',
            value: this.layerIds.ESTRADAS_NOITE,
            iconClass: 'fa fa-moon-o'
          }), _defineProperty(_ref, this.layerIds.SATELITE, this.defaultOptions.SATELITE), _ref;
        }
        return this.defaultOptions;
      }
    }, {
      key: 'fetchLayerData',
      value: function fetchLayerData() {
        var _layersData;

        this.layersData = (_layersData = {}, _defineProperty(_layersData, this.layerIds.SATELITE, this.mapasUtil.tiles.trimbleMaps), _defineProperty(_layersData, this.layerIds.ESTRADAS, this.mapasUtil.tiles.veltec), _layersData);
        this.onSelectOption();
      }
    }, {
      key: 'onSelectOption',
      value: function onSelectOption() {
        this.onLayerSwitch({ layerWrapper: this.getLayerWrapper(this.selectedOption.value) });
        if (this.shouldSetUrlParam) {
          this.urlService.setQueryString(CAMADA_PARAM, this.selectedOption.value);
        }
        this.window.localStorage.setItem(CAMADA_PARAM, this.selectedOption.value);
      }
    }, {
      key: 'getLayerWrapper',
      value: function getLayerWrapper(layerId) {
        var _this2 = this;

        if (layerId === this.defaultOptions.ESTRADAS.value || layerId === this.defaultOptions.SATELITE.value) {
          return {
            getLayerConfig: function getLayerConfig() {
              return _this2.layersData[_this2.selectedOption.value];
            },
            getLayerObject: function getLayerObject() {
              return L.tileLayer(_this2.layersData[_this2.selectedOption.value].url, {
                attribution: _this2.layersData[_this2.selectedOption.value].options.attribution,
                subdomains: _this2.layersData[_this2.selectedOption.value].options.subdomains,
                options: _this2.layersData[_this2.selectedOption.value]
              });
            }
          };
        } else if (this.useNightAndDayOptions) {
          return {
            getLayerConfig: function getLayerConfig() {
              return Object.assign({ colorFilter: layerId === _this2.layerIds.ESTRADAS_NOITE ? ['inv:100%', 'bri:60%', 'gray:50%', 'hue:175deg'] : [] }, _this2.layersData[_this2.layerIds.ESTRADAS]);
            },
            getLayerObject: function getLayerObject() {
              return L.tileLayer.colorFilter(_this2.layersData[_this2.layerIds.ESTRADAS].url, {
                filter: layerId === _this2.layerIds.ESTRADAS_NOITE ? ['inv:100%', 'bri:60%', 'gray:50%', 'hue:175deg'] : [],
                attribution: _this2.layersData[_this2.layerIds.ESTRADAS].options.attribution,
                subdomains: _this2.layersData[_this2.layerIds.ESTRADAS].options.subdomains,
                options: _this2.layersData[_this2.layerIds.ESTRADAS]
              });
            }
          };
        }
      }
    }]);

    return MapLayerSwitcherCtrl;
  }();

  angular.module('mapas').component('mapLayerSwitcher', {
    templateUrl: 'mapas/map-layer-switcher/map-layer-switcher-component.tpl.html',
    controller: MapLayerSwitcherCtrl,
    bindings: {
      onLayerSwitch: '&',
      useNightAndDayOptions: '<',
      shouldSetUrlParam: '<?'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name seguranca
   * @description
   *
   */

  angular.module('segurancaModule', ['ui.router', 'FeatureFlagModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('segurancaModule').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.insights', {
      url: '/seguranca',
      views: {
        'content@': {
          templateUrl: 'insights/seguranca/seguranca.tpl.html',
          controller: 'SegurancaCtrl',
          controllerAs: 'seguranca'
        }
      },
      data: {
        hideTitulo: true,
        roles: [['PREDICAO_ACIDENTE_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var SegurancaCtrl = function () {
    function SegurancaCtrl(FeatureFlag, Authenticator, ServiceVfiltro, FactoryVfiltro) {
      var _this = this;

      _classCallCheck(this, SegurancaCtrl);

      this.featureFlag = FeatureFlag;
      this.authenticator = Authenticator;

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.initPredicaoAcidenteComponent();
      });
    }

    _createClass(SegurancaCtrl, [{
      key: 'initPredicaoAcidenteComponent',
      value: function initPredicaoAcidenteComponent() {
        var _this2 = this;

        if (this.featureFlag.MENU_INSIGHTS) {
          /* eslint-disable */
          var componentView = document.querySelector('#vfwc-predicao-acidentes-view');
          if (componentView) {
            this.authenticator.getUser().then(function (user) {
              var predicaoAcidentesElement = document.createElement('vfwc-external-predicao-acidentes');
              predicaoAcidentesElement.user = user;
              predicaoAcidentesElement.showHarshEventsRiskRegion = _this2.featureFlag.SHOW_HARSH_EVENTS_RISK_REGION;
              /* eslint-enable */
              componentView.appendChild(predicaoAcidentesElement);
            });
          }
        }
      }
    }]);

    return SegurancaCtrl;
  }();

  angular.module('segurancaModule').controller('SegurancaCtrl', SegurancaCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores.UtilizacaoVeiculo', ['ui.router', 'chartModule', 'angularMoment', 'chartModule', 'indicadores', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'pascalprecht.translate']).factory('UtilizacaoVeiculo', function (Restangular) {
    return Restangular.service('boletim/utilizacao-veiculo');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.utilizacaoVeiculo', {
      url: '/utilizacao-veiculo?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'indicadores/utilizacao-veiculo/utilizacao-veiculo.tpl.html',
          controller: 'UtilizacaoVeiculoCtrl',
          controllerAs: 'utilizacaoVeiculo'
        }
      },
      data: {
        titulo: 'ce.indicadores.ociosidadeFrota.titulo',
        role: 'OCIOSIDADE_FROTA_VISUALIZAR'
      }
    });
  }

  angular.module('indicadores.UtilizacaoVeiculo').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var UtilizacaoVeiculoCtrl = function () {
    function UtilizacaoVeiculoCtrl(UtilizacaoVeiculo, moment, ColumnChart, $window, IndicadoresService, PieChart, ServiceVfiltro, FactoryVfiltro, Keys, URLConducaoEconomica, $translate) {
      var _this = this;

      _classCallCheck(this, UtilizacaoVeiculoCtrl);

      this.service = UtilizacaoVeiculo;
      this.moment = moment;
      this.window = $window;
      this.indicadoresService = IndicadoresService;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.URLConducaoEconomica = URLConducaoEconomica;
      this.translate = $translate;

      this.desligadosCard = null;
      this.ate10KmCard = null;
      this.maisDe10KmCard = null;

      this.pieChart = PieChart.get();
      this.pieChart.setClickEvent(this.clickBinding().onClickPie);
      this.columnChart = ColumnChart.get();
      this.columnChart.setClickEvent(this.clickBinding().onClickColumn);
      this.columnChart.options.colors = ['rgb(204,38,54)', 'rgb(255,154,0)', 'rgb(139,188,33)'];

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'fat_conducao.dia',
        key: this.keys.dateTime.name,
        dateLimit: 180,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        key: this.keys.uo.name,
        ignoreQuery: true
      }, {
        key: this.keys.uoParceira.name,
        name: 'fat_conducao.uo_veiculo_id'
      }])).then(function (filtro) {
        _this.loadData(ServiceVfiltro.getFiltroBackendAntigo(filtro));
      });
    }

    _createClass(UtilizacaoVeiculoCtrl, [{
      key: 'loadData',
      value: function loadData(filtro) {
        var _this2 = this;

        this.service.one().get({ filtros: filtro }).then(function (data) {
          _this2.columnChart.setData(data.columnChart);
          _this2.listaUos = data.columnChart.opcoes.uos;
          _this2.setInvisibleSerie(_this2.columnChart.series[2]);
          _this2.pieChart.setData(data.pieChart);
          _this2.desligadosCard = data.desligadosCard;
          _this2.ate10KmCard = data.ate10KmCard;
          _this2.maisDe10KmCard = data.maisDe10KmCard;
        });
      }
    }, {
      key: 'setInvisibleSerie',
      value: function setInvisibleSerie(serie) {
        serie.visible = false;
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this,
            nameTranslated = this.translate.instant('ce.indicadores.ociosidadeFrota.charts.mais10kmPercorridos');

        return {
          onClickColumn: function onClickColumn() {
            var _this3 = this;

            var uoId = self.listaUos.find(function (c) {
              return c.nome === _this3.category;
            }).id,
                uos = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).defaultValues,
                uoParceira = null;

            if (!uos.find(function (f) {
              return f.id === uoId;
            })) {
              uoParceira = uoId;
              uoId = self.serviceVfiltro.filtroCompleto.find(function (item) {
                return item.key === self.keys.uo.name;
              }).value.id;
            }

            self.goToRanking(this.series.name.includes(nameTranslated), uoId, uoParceira);
          },
          onClickPie: function onClickPie() {
            var uoId = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).value.id,
                uoParceira = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uoParceira.name;
            });

            uoParceira = uoParceira.value ? uoParceira.value.id : null;

            self.goToRanking(this.name.includes(nameTranslated), uoId, uoParceira);
          }
        };
      }
    }, {
      key: 'goToRanking',
      value: function goToRanking(sort, uoId, uoParceira) {
        var _this4 = this;

        var periodo = this.serviceVfiltro.filtroCompleto.find(function (item) {
          return item.key === _this4.keys.dateTime.name;
        }).value,
            filtros = this.indicadoresService.getFiltrosParaRanking([periodo.startDate, periodo.endDate], uoId, uoParceira, 'distanciaPercorrida', sort);

        this.window.location.href = this.URLConducaoEconomica + '?' + filtros;
      }
    }]);

    return UtilizacaoVeiculoCtrl;
  }();

  angular.module('indicadores.UtilizacaoVeiculo').controller('UtilizacaoVeiculoCtrl', UtilizacaoVeiculoCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores.powerBi', ['ui.router', 'powerbi', 'restangular', 'FactoryVfiltroModule', 'ServiceVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.indicadorPowerBi', {
      url: '/bi?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'indicadores/power-bi/power-bi.tpl.html',
          controller: 'PowerBiCtrl',
          controllerAs: 'powerBi'
        }
      },
      data: {
        titulo: 'Indicadores de BI',
        role: 'INDICADOR_POWER_BI_VISUALIZAR',
        hideTitulo: true
      }
    });
  }

  angular.module('indicadores.powerBi').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PowerBiCtrl = function () {
    function PowerBiCtrl(FactoryVfiltro, ServiceVfiltro, Restangular) {
      _classCallCheck(this, PowerBiCtrl);

      this.restangular = Restangular;
      this.response = {};

      ServiceVfiltro.init(FactoryVfiltro.get([]));
      this.getReport();
    }

    _createClass(PowerBiCtrl, [{
      key: 'getReport',
      value: function getReport() {
        var _this = this;

        this.restangular.one('powerbi/reports/VFLEETS_ALERTAS').get().then(function (config) {
          _this.response.accessToken = config.embedToken;
          _this.response.embedUrl = config.embedUrl;
          _this.response.id = config.id;
          _this.response.name = '';
          _this.response.type = 'report';
          _this.response.webUrl = 'https://app.powerbi.com/reports/' + config.id;
          _this.response.permissions = 0;
          _this.response.pageView = 'fitToWidth';
          _this.response.tokenType = 1;
          _this.response.settings = {
            localeSettings: {
              language: 'pt-br'
            },
            filterPaneEnabled: true,
            navContentPaneEnabled: true
          };
        });
      }
    }]);

    return PowerBiCtrl;
  }();

  angular.module('indicadores.powerBi').controller('PowerBiCtrl', PowerBiCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores.DirecaoSegura', ['restangular', 'angularMoment', 'chartModule', 'confluenceID', 'indicadores', 'uoModule', 'onboarding', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'pascalprecht.translate']).factory('DirecaoSegura', function (Restangular) {
    return Restangular.service('boletim/painel-direcao-segura');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.direcaoSegura', {
      url: '/direcao-segura?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'indicadores/direcao-segura/direcao-segura.tpl.html',
          controller: 'DirecaoSeguraCtrl',
          controllerAs: 'direcaoSegura'
        }
      },
      data: {
        titulo: 'ce.indicadores.direcaoSegura.titulo',
        role: 'DIRECAO_SEGURA_VISUALIZAR'
      }
    });
  }

  angular.module('indicadores.DirecaoSegura').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores.DirecaoSegura').constant('MockDirecaoSegura', {
    comparativoChart: {
      categorias: ['Período Anterior: 24/04/2016 a 31/04/2016', 'Período Atual: 01/05/2016 a 07/05/2016'],
      series: [{
        name: 'Acelerações Bruscas',
        data: [2, 3],
        type: 'EVENTOS'
      }, {
        name: 'Banguelas',
        data: [9, 11],
        type: 'EVENTOS'
      }, {
        name: 'Curvas Bruscas',
        data: [8, 8],
        type: 'EVENTOS'
      }, {
        name: 'Excessos Velocidade',
        data: [9, 11],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Até 20%',
        data: [8, 5],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Acima de 30%',
        data: [9, 11],
        type: 'EVENTOS'
      }, {
        name: 'Freadas Bruscas',
        data: [8, 5],
        type: 'EVENTOS'
      }, {
        name: 'Média Quantidade Veiculos',
        data: [5, 6],
        type: 'VEICULOS_QTD'
      }],
      opcoes: {
        periodos: [['2016-04-24', '2016-04-31'], ['2016-05-01', '2016-05-07']]
      }
    },
    periodoChart: {
      categorias: ['01/05/2016', '02/05/2016', '03/05/2016', '04/05/2016', '05/05/2016', '06/05/2016', '07/05/2016'],
      series: [{
        name: 'Acelerações Bruscas',
        data: [6, 0, 2, 1, 3, 3, 5],
        type: 'EVENTOS'
      }, {
        name: 'Banguelas',
        data: [1, 2, 1, 1, 3, 2, 4],
        type: 'EVENTOS'
      }, {
        name: 'Curvas Bruscas',
        data: [11, 8, 3, 5, 1, 4, 3],
        type: 'EVENTOS'
      }, {
        name: 'Excessos Velocidade',
        data: [2, 9, 3, 3, 2, 1, 4],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Até 20%',
        data: [5, 3, 4, 7, 2, 5, 4],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Acima de 30%',
        data: [2, 2, 3, 2, 1, 5, 4],
        type: 'EVENTOS'
      }, {
        name: 'Freadas Bruscas',
        data: [16, 8, 9, 9, 10, 15, 9],
        type: 'EVENTOS'
      }, {
        name: 'Média Quantidade Veiculos',
        data: [1, 2, 3, 10, 9, 6, 5],
        type: 'VEICULOS_QTD'
      }],
      opcoes: {
        periodos: [['2016-05-01T00:00:00-03:00', '2016-05-01T23:59:59-03:00'], ['2016-05-02T00:00:00-03:00', '2016-05-02T23:59:59-03:00'], ['2016-05-03T00:00:00-03:00', '2016-05-03T23:59:59-03:00'], ['2016-05-04T00:00:00-03:00', '2016-05-04T23:59:59-03:00'], ['2016-05-05T00:00:00-03:00', '2016-05-05T23:59:59-03:00'], ['2016-05-06T00:00:00-03:00', '2016-05-06T23:59:59-03:00'], ['2016-05-07T00:00:00-03:00', '2016-05-07T23:59:59-03:00']]
      }
    },
    footer: [{
      descricao: 'Acelerações Bruscas',
      percentualEntrePeriodos: -12,
      mediaVeiculoPeriodoAnterior: 3.9,
      mediaVeiculoPeriodoAtual: 8.2
    }, {
      descricao: 'Freadas Bruscas',
      percentualEntrePeriodos: 19,
      mediaVeiculoPeriodoAnterior: 3,
      mediaVeiculoPeriodoAtual: 5
    }, {
      descricao: 'Curvas Bruscas',
      percentualEntrePeriodos: 0,
      mediaVeiculoPeriodoAnterior: 1,
      mediaVeiculoPeriodoAtual: 4
    }, {
      descricao: 'Excessos Velocidade',
      percentualEntrePeriodos: 15,
      mediaVeiculoPeriodoAnterior: 6,
      mediaVeiculoPeriodoAtual: 2
    }, {
      descricao: 'Banguelas',
      percentualEntrePeriodos: -25,
      mediaVeiculoPeriodoAnterior: 2,
      mediaVeiculoPeriodoAtual: 3
    }],
    uoChart: {
      categorias: ['PR', 'CO', 'MGES', 'NE', 'NO', 'PRSPI', 'RJ', 'RSSC', 'SPC'],
      series: [{
        name: 'Acelerações Bruscas',
        atual: [5, 3, 4, 7, 2, 5, 4, 8, 9],
        anterior: [6, 3, 4, 7, 2, 5, 4, 8, 3],
        type: 'EVENTOS'
      }, {
        name: 'Banguelas',
        atual: [2, 2, 3, 2, 1, 5, 4, 8, 2],
        anterior: [2, 2, 3, 2, 1, 5, 4, 8, 2],
        type: 'EVENTOS'
      }, {
        name: 'Curvas Bruscas',
        atual: [3, 4, 4, 2, 5, 5, 4, 8, 2],
        anterior: [5, 3, 4, 7, 2, 5, 4, 8, 9],
        type: 'EVENTOS'
      }, {
        name: 'Excessos Velocidade',
        atual: [2, 9, 3, 3, 2, 1, 4, 6, 10],
        anterior: [5, 3, 4, 7, 2, 5, 4, 8, 9],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Até 20%',
        atual: [1, 0, 2, 1, 3, 3, 5, 4, 3],
        anterior: [2, 2, 3, 2, 1, 5, 4, 8, 2],
        type: 'EVENTOS'
      }, {
        name: 'Excessos de Velocidade Acima de 30%',
        atual: [1, 2, 1, 1, 3, 2, 4, 2, 3],
        anterior: [5, 3, 4, 7, 2, 5, 4, 8, 9],
        type: 'EVENTOS'
      }, {
        name: 'Freadas Bruscas',
        atual: [11, 8, 3, 5, 1, 4, 3, 7, 9],
        anterior: [5, 3, 4, 7, 2, 5, 4, 8, 9],
        type: 'EVENTOS'
      }, {
        name: 'Média Quantidade Veiculos',
        atual: [18, 8, 9, 9, 12, 15, 9, 10, 8],
        anterior: [16, 8, 9, 9, 10, 15, 9, 9, 8],
        type: 'VEICULOS_QTD'
      }],
      opcoes: {
        periodos: [['2016-05-01T00:00:00-03:00', '2016-05-01T23:59:59-03:00'], ['2016-05-02T00:00:00-03:00', '2016-05-02T23:59:59-03:00'], ['2016-05-03T00:00:00-03:00', '2016-05-03T23:59:59-03:00'], ['2016-05-04T00:00:00-03:00', '2016-05-04T23:59:59-03:00'], ['2016-05-05T00:00:00-03:00', '2016-05-05T23:59:59-03:00'], ['2016-05-06T00:00:00-03:00', '2016-05-06T23:59:59-03:00'], ['2016-05-06T00:00:00-03:00', '2016-05-06T23:59:59-03:00'], ['2016-05-06T00:00:00-03:00', '2016-05-06T23:59:59-03:00'], ['2016-05-07T00:00:00-03:00', '2016-05-07T23:59:59-03:00']],
        uos: [{ uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }, { uoId: 1 }]
      }
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DirecaoSeguraCtrl = function () {
    function DirecaoSeguraCtrl(DirecaoSegura, moment, ColumnChart, $window, IDDirecaoSegura, URLDirecaoSegura, IndicadoresService, Uos, Onboarding, MockDirecaoSegura, FactoryVfiltro, ServiceVfiltro, Keys, ObjetosVfiltroService, $translate) {
      var _this = this;

      _classCallCheck(this, DirecaoSeguraCtrl);

      this.service = DirecaoSegura;
      this.moment = moment;
      this.window = $window;
      this.onboarding = Onboarding;
      this.mockDirecaoSegura = MockDirecaoSegura;
      this.URLDirecaoSegura = URLDirecaoSegura;
      this.indicadoresService = IndicadoresService;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.translate = $translate;

      this.comparativoChart = ColumnChart.get(2);
      this.tituloComparativoChart = this.translate.instant('ce.indicadores.common.charts.comparativoChart.titulo');
      this.comparativoChart.setTitleText(this.tituloComparativoChart);
      this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
      this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.comparativoChart.setClickEvent(this.clickBinding().onClickColumn);
      this.comparativoChart.withComparativeGradient();

      this.periodoChart = ColumnChart.get(2);
      this.tituloPeriodoChart = this.translate.instant('ce.indicadores.direcaoSegura.charts.periodoChart.titulo');
      this.periodoChart.setTitleText(this.tituloPeriodoChart);
      this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
      this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.periodoChart.setClickEvent(this.clickBinding().onClickColumn);

      this.uoChart = ColumnChart.get(2);
      this.tituloUoChart = this.translate.instant('ce.indicadores.direcaoSegura.charts.uoChart.titulo');
      this.uoChart.setTitleText(this.tituloUoChart);
      this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
      this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.uoChart.setClickEvent(this.clickBinding().onClickColumnUO);

      this.isDemo = this.onboarding.startOnboarding(IDDirecaoSegura);
      Uos.isDemo = this.isDemo;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'fat_conducao.dia',
        key: this.keys.dateTime.name,
        dateLimit: 180,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        key: this.keys.uo.name
      }, {
        name: 'fat_conducao.uo_veiculo_id',
        key: this.keys.uoParceira.name
      }])).then(function (filtro) {
        _this.loadData(ServiceVfiltro.getFiltroBackendAntigo(filtro), ServiceVfiltro.getFiltroBackendNovo(filtro));
      });
    }

    _createClass(DirecaoSeguraCtrl, [{
      key: 'loadData',
      value: function loadData(filtro, filtroNovo) {
        var _this2 = this;

        if (this.isDemo) {
          this.setInfoGrafico(this.mockDirecaoSegura);
        } else {
          var inicio = this.moment(filtroNovo.inicio).format('YYYY-MM-DD'),
              fim = this.moment(filtroNovo.fim).format('YYYY-MM-DD');
          this.service.one().get({ filtros: filtro, inicio: inicio, fim: fim }).then(function (data) {
            return _this2.setInfoGrafico(data);
          });
        }
      }
    }, {
      key: 'setInfoGrafico',
      value: function setInfoGrafico(data) {
        this.comparativoChart.setData(data.comparativoChart);
        this.comparativoChart.disableLegend();
        this.periodoChart.setData(data.periodoChart);
        this.footer = data.footer;

        var series = data.uoChart.series.map(function (serie) {
          return { name: serie.name, data: serie.atual, compareData: serie.anterior, type: serie.type };
        });
        this.uoChart.setData({
          categorias: data.uoChart.categorias,
          series: series,
          opcoes: data.uoChart.opcoes
        });
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this;

        return {
          onClickColumn: function onClickColumn() {
            var evento = this.series.name,
                chart = self.getChart(this.series.chart.title.textStr),
                periodo = this.series.stackKey === 'columnanterior' ? self.comparativoChart.columnSeries.opcoes.periodos[0] : chart.columnSeries.opcoes.periodos[this.index],
                uoId = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).value.id,
                uoParceira = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uoParceira.name;
            }),
                filtros = self.indicadoresService.getFiltrosParaRanking(periodo, uoId, uoParceira.value && uoParceira.value.id, evento);
            self.window.location.href = self.URLDirecaoSegura + '?' + (self.isDemo ? 'demo' : '') + '&' + filtros;
          },
          onClickColumnUO: function onClickColumnUO() {
            var evento = this.series.name,
                chart = self.getChart(this.series.chart.title.textStr),
                periodo = this.series.stackKey === 'columnanterior' ? self.comparativoChart.columnSeries.opcoes.periodos[0] : chart.columnSeries.opcoes.periodos[this.index],
                uoChart = chart.columnSeries.opcoes.uos && chart.columnSeries.opcoes.uos[this.index],
                uoPai = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).value.id,
                listaUos = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).defaultValues,
                uoParceira = !listaUos.some(function (x) {
              return x.id === uoChart.uoId;
            }) && uoChart.uoId,
                filtros = self.indicadoresService.getFiltrosParaRanking(periodo, !uoParceira ? uoChart.uoId : uoPai, uoParceira, evento);
            self.window.location.href = self.URLDirecaoSegura + '?' + (self.isDemo ? 'demo' : '') + '&' + filtros;
          }
        };
      }
    }, {
      key: 'getChart',
      value: function getChart(chartLabel) {
        switch (chartLabel) {
          case 'Eventos por Período':
            return this.periodoChart;
          case 'Comparativo entre Períodos':
            return this.comparativoChart;
          case 'Eventos por Unidade Organizacional':
            return this.uoChart;
          default:
            return undefined;
        }
      }
    }, {
      key: 'traduzLabelsCharts',
      value: function traduzLabelsCharts() {
        this.tituloComparativoChart = this.translate.instant('ce.indicadores.common.charts.comparativoChart.titulo');
        this.comparativoChart.setTitleText(this.tituloComparativoChart);
        this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
        this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
        this.tituloPeriodoChart = this.translate.instant('ce.indicadores.direcaoSegura.charts.periodoChart.titulo');
        this.periodoChart.setTitleText(this.tituloPeriodoChart);
        this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
        this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
        this.tituloUoChart = this.translate.instant('ce.indicadores.direcaoSegura.charts.uoChart.titulo');
        this.uoChart.setTitleText(this.tituloUoChart);
        this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.direcaoSegura.charts.yEventos'), 0);
        this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      }
    }]);

    return DirecaoSeguraCtrl;
  }();

  angular.module('indicadores.DirecaoSegura').controller('DirecaoSeguraCtrl', DirecaoSeguraCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores.ConducaoEconomica', ['restangular', 'angularMoment', 'chartModule', 'confluenceID', 'indicadores', 'ConstantModule', 'FactoryVfiltroModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule', 'ObjetosVfiltroModule', 'pascalprecht.translate']).filter('ceilAndRemoveDecimals', function () {
    return function (input) {
      var number;

      if (!angular.isNumber(input) && !angular.isString(input)) {
        return input;
      }

      number = parseFloat(input);

      number = Math.ceil(number);

      return number.toString();
    };
  }).factory('ConducaoEconomica', function (Restangular) {
    return Restangular.service('boletim/painel-conducao-economica');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.conducaoEconomica', {
      url: '/conducao-economica?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'indicadores/conducao-economica/conducao-economica.tpl.html',
          controller: 'ConducaoEconomicaCtrl',
          controllerAs: 'conducaoEconomica'
        }
      },
      data: {
        titulo: 'ce.indicadores.conducaoEconomica.titulo',
        role: 'CONDUCAO_ECONOMICA_VISUALIZAR'
      }
    });
  }

  angular.module('indicadores.ConducaoEconomica').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global _ */

  var ConducaoEconomicaCtrl = function () {
    function ConducaoEconomicaCtrl(ConducaoEconomica, moment, ColumnChart, $window, URLConducaoEconomica, GoogleTagManagerUtils, IndicadoresService, ServiceVfiltro, FactoryVfiltro, Keys, ObjetosVfiltroService, $translate) {
      var _this = this;

      _classCallCheck(this, ConducaoEconomicaCtrl);

      this.service = ConducaoEconomica;
      this.moment = moment;
      this.window = $window;
      this.URLConducaoEconomica = URLConducaoEconomica;
      this.indicadoresService = IndicadoresService;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.translate = $translate;
      this.colors = ['rgb(204,38,54)', 'rgb(103,144,171)', 'rgb(242,153,74)', '#c07d0e'];
      this.googleTagManagerUtils = GoogleTagManagerUtils;

      this.comparativoChart = ColumnChart.get(2, this.colors);
      this.tituloComparativoChart = this.translate.instant('ce.indicadores.common.charts.comparativoChart.titulo');
      this.comparativoChart.setTitleText(this.tituloComparativoChart);
      this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
      this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.comparativoChart.setClickEvent(this.clickBinding().onClickColumn);
      this.comparativoChart.withComparativeGradient();
      this.comparativoChart.setDateTooltip();

      this.periodoChart = ColumnChart.get(2, this.colors);
      this.tituloPeriodoChart = this.translate.instant('ce.indicadores.conducaoEconomica.charts.periodoChart.titulo');
      this.periodoChart.setTitleText(this.tituloPeriodoChart);
      this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
      this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.periodoChart.setClickEvent(this.clickBinding().onClickColumn);
      this.periodoChart.setDateTooltip();

      this.uoChart = ColumnChart.get(2, this.colors);
      this.tituloUoChart = this.translate.instant('ce.indicadores.conducaoEconomica.charts.uoChart.titulo');
      this.uoChart.setTitleText(this.tituloUoChart);
      this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
      this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      this.uoChart.setClickEvent(this.clickBinding().onClickColumnUO);
      this.uoChart.setDateTooltip();

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'fat_conducao.dia',
        key: this.keys.dateTime.name,
        dateLimit: 180,
        defaultValues: {
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        key: this.keys.uo.name
      }, {
        name: 'fat_conducao.uo_veiculo_id',
        key: this.keys.uoParceira.name
      }])).then(function (filtro) {
        _this.loadData(ServiceVfiltro.getFiltroBackendAntigo(filtro));
      });
    }

    _createClass(ConducaoEconomicaCtrl, [{
      key: 'loadData',
      value: function loadData(filtro) {
        var _this2 = this;

        this.service.one().get({ filtros: filtro }).then(function (data) {
          return _this2.setInfoGrafico(data);
        });
      }
    }, {
      key: 'sortUoChart',
      value: function sortUoChart(eventosAtuaisTotal) {
        return function (a, b) {
          if (eventosAtuaisTotal[a] > eventosAtuaisTotal[b]) {
            return -1;
          } else if (eventosAtuaisTotal[b] > eventosAtuaisTotal[a]) {
            return 1;
          }
          return 0;
        };
      }
    }, {
      key: 'reorderUoChart',
      value: function reorderUoChart(uoChart) {
        var uoChartSorted = _.cloneDeep(uoChart),
            uoChartOld = _.cloneDeep(uoChart),
            eventosAtuaisConjunto = [],
            eventosAtuaisTotal = void 0,
            indicesReordenados = void 0;

        uoChartOld.series = uoChartOld.series.filter(function (serie) {
          return serie.type !== 'VEICULOS_QTD';
        });
        uoChartOld.series.forEach(function (evento) {
          eventosAtuaisConjunto.push(evento.atual);
        });

        eventosAtuaisTotal = eventosAtuaisConjunto.reduce(function (soma, eventos) {
          return eventos.map(function (valor, i) {
            return soma[i] + valor;
          });
        });
        indicesReordenados = _.range(eventosAtuaisTotal.length).sort(this.sortUoChart(eventosAtuaisTotal));

        indicesReordenados.map(function (elementoOrdenado, index) {
          uoChartSorted.categorias[index] = uoChart.categorias[elementoOrdenado];
          uoChartSorted.opcoes.periodos[index] = uoChart.opcoes.periodos[elementoOrdenado];
          if (angular.isDefined(uoChart.opcoes.uos)) {
            uoChartSorted.opcoes.uos[index] = uoChart.opcoes.uos[elementoOrdenado];
          }
          uoChartSorted.series.map(function (evento, eventoIndex) {
            evento.atual[index] = uoChart.series[eventoIndex].atual[elementoOrdenado];
            evento.anterior[index] = uoChart.series[eventoIndex].anterior[elementoOrdenado];
          });
        });
        return uoChartSorted;
      }
    }, {
      key: 'setInfoGrafico',
      value: function setInfoGrafico(data) {
        this.comparativoChart.setData(data.comparativoChart, true);
        this.comparativoChart.disableLegend();
        this.periodoChart.setData(data.periodoChart, true);
        this.footer = data.footer;

        data.uoChart = this.reorderUoChart(data.uoChart);
        var series = data.uoChart.series.map(function (serie) {
          return { name: serie.name, data: serie.atual, compareData: serie.anterior, type: serie.type };
        });
        this.uoChart.setData({
          categorias: data.uoChart.categorias,
          series: series,
          opcoes: data.uoChart.opcoes
        }, true);
      }
    }, {
      key: 'clickBinding',
      value: function clickBinding() {
        var self = this;

        return {
          onClickColumn: function onClickColumn() {
            self.sendClickGTM();
            var evento = this.series.name,
                chart = self.getChart(this.series.chart.title.textStr),
                periodo = this.series.stackKey === 'columnanterior' ? self.comparativoChart.columnSeries.opcoes.periodos[0] : chart.columnSeries.opcoes.periodos[this.index],
                uoId = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).value.id,
                uoParceira = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uoParceira.name;
            }),
                filtros = self.indicadoresService.getFiltrosParaRanking(periodo, uoId, uoParceira.value && uoParceira.value.id, evento);
            self.window.location.href = self.URLConducaoEconomica + '?' + filtros;
          },
          onClickColumnUO: function onClickColumnUO() {
            self.sendClickGTM();
            var evento = this.series.name,
                chart = self.getChart(this.series.chart.title.textStr),
                periodo = this.series.stackKey === 'columnanterior' ? self.comparativoChart.columnSeries.opcoes.periodos[0] : chart.columnSeries.opcoes.periodos[this.index],
                uoChart = chart.columnSeries.opcoes.uos && chart.columnSeries.opcoes.uos[this.index],
                uoPai = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).value.id,
                listaUos = self.serviceVfiltro.filtroCompleto.find(function (item) {
              return item.key === self.keys.uo.name;
            }).defaultValues,
                uoParceira = !listaUos.some(function (x) {
              return x.id === uoChart.uoId;
            }) && uoChart.uoId,
                filtros = self.indicadoresService.getFiltrosParaRanking(periodo, !uoParceira ? uoChart.uoId : uoPai, uoParceira, evento);
            self.window.location.href = self.URLConducaoEconomica + '?' + filtros;
          }
        };
      }
    }, {
      key: 'getChart',
      value: function getChart(chartLabel) {
        switch (chartLabel) {
          case this.tituloPeriodoChart:
            return this.periodoChart;
          case this.tituloComparativoChart:
            return this.comparativoChart;
          case this.tituloUoChart:
            return this.uoChart;
          default:
            return undefined;
        }
      }
    }, {
      key: 'traduzLabelsCharts',
      value: function traduzLabelsCharts() {
        this.tituloComparativoChart = this.translate.instant('ce.indicadores.common.charts.comparativoChart.titulo');
        this.comparativoChart.setTitleText(this.tituloComparativoChart);
        this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
        this.comparativoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
        this.tituloPeriodoChart = this.translate.instant('ce.indicadores.conducaoEconomica.charts.periodoChart.titulo');
        this.periodoChart.setTitleText(this.tituloPeriodoChart);
        this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
        this.periodoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
        this.tituloUoChart = this.translate.instant('ce.indicadores.conducaoEconomica.charts.uoChart.titulo');
        this.uoChart.setTitleText(this.tituloUoChart);
        this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.conducaoEconomica.charts.yHoras'), 0);
        this.uoChart.setYAxisTitle(this.translate.instant('ce.indicadores.common.charts.yVeiculosMonitorados'), 1);
      }
    }, {
      key: 'sendClickGTM',
      value: function sendClickGTM() {
        this.googleTagManagerUtils.sendEventClickGTM('indicadores_ce_ir_para_ranking_conducao', this.serviceVfiltro.factoryVfiltro.user);
      }
    }]);

    return ConducaoEconomicaCtrl;
  }();

  angular.module('indicadores.ConducaoEconomica').controller('ConducaoEconomicaCtrl', ConducaoEconomicaCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FIELDS = ['id', 'uoId', 'vehicleId', 'cameras', 'dateTime', 'latitude', 'longitude', 'bucket', 'bucketRegion', 'label'];

  var VisaoCamerasService = function () {
    function VisaoCamerasService(HttpServiceV3g, $httpParamSerializer, AGRUPAMENTO_EQUIPAMENTO) {
      _classCallCheck(this, VisaoCamerasService);

      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
      this.Agrupamento = AGRUPAMENTO_EQUIPAMENTO;
    }

    _createClass(VisaoCamerasService, [{
      key: 'hasVideo',
      value: function hasVideo(veiculoId) {
        var params = this.httpParamSerializer({
          veiculoId: veiculoId,
          hasVideoComputadorBordo: true
        });

        return this.httpService.get('/veiculo/v2/veiculos?' + params).then(function (responseVeiculos) {
          return Boolean(responseVeiculos.data.numberOfElements);
        });
      }
    }, {
      key: 'getSnapshots',
      value: function getSnapshots(veiculoId, datetime, currentPage, labels) {
        var params = this.httpParamSerializer({
          fields: FIELDS.join(),
          begin: datetime.startDate,
          end: datetime.endDate,
          vehiclesId: veiculoId,
          labels: labels,
          page: currentPage,
          size: 10
        });

        return this.httpService.get('/video/snapshots/pageable?' + params);
      }
    }, {
      key: 'getLabels',
      value: function getLabels(datetime, veiculoId) {
        var params = this.httpParamSerializer({
          begin: datetime.startDate,
          end: datetime.endDate,
          vehicleId: veiculoId
        });

        return this.httpService.get('/video/snapshots/labels?' + params);
      }
    }]);

    return VisaoCamerasService;
  }();

  angular.module('historicoTimeline').service('VisaoCamerasService', VisaoCamerasService);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var VisaoCamerasCtrl = function () {
    function VisaoCamerasCtrl($translate, FeatureHubConfigKeys, FeaturehubJsSdk) {
      _classCallCheck(this, VisaoCamerasCtrl);

      this.translate = $translate;
      this.indice = undefined;
      this.indicesDisponiveis = [];
      this.labelsEvents = this.labelsFilterEvents();
      this.camerasEvidence = null;
      this.cameraSelected = null;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.featurehubJsSdk = FeaturehubJsSdk;
    }

    _createClass(VisaoCamerasCtrl, [{
      key: '$onChanges',
      value: function $onChanges() {
        if (this.snapshots && this.snapshots.length) {
          this.setIndicesDisponiveis();
          this.getCamerasEvidence();
          this.getAlertNoSnapshots();
        }
      }
    }, {
      key: 'labelsFilterEvents',
      value: function labelsFilterEvents() {
        var _this = this;

        return {
          onSelectionChanged: function onSelectionChanged() {
            _this.labelEvents();
          }
        };
      }
    }, {
      key: 'setIndicesDisponiveis',
      value: function setIndicesDisponiveis() {
        this.indicesDisponiveis = [].concat(_toConsumableArray(new Set(this.snapshots.reduce(function (acc, next) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(next.cameras.map(function (cam) {
            return cam.indice;
          })));
        }, [])))).sort();

        this.indice = angular.isDefined(this.indice) ? this.indice : this.indicesDisponiveis.indexOf(this.indicesDisponiveis[0]);
      }
    }, {
      key: 'changeIndiceCamera',
      value: function changeIndiceCamera(value, cameraSelected) {
        this.indice = value;
        this.cameraSelected = cameraSelected;
      }
    }, {
      key: 'verNoMapa',
      value: function verNoMapa(posicao) {
        this.onVerNoMapa({ posicao: posicao });
      }
    }, {
      key: 'changePage',
      value: function changePage(page) {
        this.handleChangePage({ page: page });
        angular.element('#snapshots').scrollTop(0);
      }
    }, {
      key: 'getCamerasEvidence',
      value: function getCamerasEvidence() {
        var isOnlyNoLabelActived = this.labelsActived.length === 1 && this.labelsActived[0].id === 'NO_LABEL',
            labelsActivedId = new Set(this.labelsActived.map(function (label) {
          return label.id;
        })),
            labelMap = new Map();

        if (!this.snapshots || this.snapshots.length === 0 || this.labelsActived.length === 0 || isOnlyNoLabelActived) {
          return null;
        }

        this.snapshots.forEach(function (snapshot) {
          (snapshot.cameraLabels || []).forEach(function (cameraLabel) {
            var commonLabels = cameraLabel.labels.filter(function (label) {
              return labelsActivedId.has(label);
            });
            commonLabels.forEach(function (label) {
              if (!labelMap.has(label)) {
                labelMap.set(label, new Set());
              }
              labelMap.get(label).add(cameraLabel.index);
            });
          });
        });

        this.camerasEvidence = Array.from(labelMap.entries()).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              label = _ref2[0],
              indexesSet = _ref2[1];

          return {
            label: label,
            indexes: Array.from(indexesSet)
          };
        });
      }
    }, {
      key: 'getAlertNoSnapshots',
      value: function getAlertNoSnapshots() {
        var hasNoIndexes = this.indicesDisponiveis.length === 0,
            hasNoLabels = !this.labelsActived || this.labelsActived.length === 0,
            alertNoImagesCondition = !this.snapshots || this.snapshots.length === 0 && hasNoIndexes && hasNoLabels,
            noImagesPeriod = this.translate.instant('ce.mapa.common.visaoCameras.naoExistemImagensPeriodo'),
            noFilterSelected = this.translate.instant('ce.mapa.common.visaoCameras.cameraNoFilterSelected');

        return alertNoImagesCondition ? noImagesPeriod : noFilterSelected;
      }
    }]);

    return VisaoCamerasCtrl;
  }();

  angular.module('historicoTimeline').component('visaoCameras', {
    controller: VisaoCamerasCtrl,
    templateUrl: 'historico-timeline/visao-cameras/visao-cameras.tpl.html',
    bindings: {
      snapshots: '<',
      labels: '<',
      labelsActived: '=',
      labelEvents: '&',
      onVerNoMapa: '&',
      navigationSetting: '<',
      handleChangePage: '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  function botaoUploadDirective() {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element.bind('click', function (e) {
          angular.element(e.target).siblings('#upload').trigger('click');
        });
      }
    };
  }

  angular.module('conducaoEconomica').directive('botaoUpload', botaoUploadDirective);
})();
'use strict';

(function () {
  'use strict';

  angular.module('duo-routes.cadastro-rotas', ['ui.router', 'ui.bootstrap', 'blockUI', 'restangular', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'safetyModule', 'ngSanitize']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FormDuoRoutesCtrl = function () {
    function FormDuoRoutesCtrl(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $stateParams, $state) {
      _classCallCheck(this, FormDuoRoutesCtrl);

      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.stateParams = $stateParams;
      this.blockUI = blockUI;
      this.state = $state;

      this.duoRouteUUID = this.stateParams.duoRouteUUID;
      this.user = null;

      this.initialize();
    }

    _createClass(FormDuoRoutesCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this2 = this;

        return this.authenticator.getUser().then(function (user) {
          _this2.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this3 = this;

        var appName = 'safetyApp',
            componentName = './DuoRouteFormPageRoute',
            componentId = 'safety-duo-route-form',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this3.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goBackToList',
      value: function goBackToList() {
        this.state.go('root.duo-routes-cadastro');
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        var props = {
          user: this.user,
          duoRouteUUID: this.duoRouteUUID,
          goBackToList: function goBackToList() {
            return _this4.goBackToList();
          }
        };

        if (this.stateParams.importFromVehicle) {
          props.importFromVehicle = this.stateParams.importFromVehicle;
        }
        if (this.stateParams.importStartDateTime) {
          props.importStartDateTime = this.stateParams.importStartDateTime;
        }
        if (this.stateParams.importEndDateTime) {
          props.importEndDateTime = this.stateParams.importEndDateTime;
        }

        return props;
      }
    }]);

    return FormDuoRoutesCtrl;
  }();

  angular.module('duo-routes.cadastro-rotas').controller('FormDuoRoutesCtrl', FormDuoRoutesCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('duo-routes.cadastro-rotas').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.duo-routes-cadastro', {
      url: '/duo-routes/cadastro?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'duo-routes/cadastro/cadastro-duo-routes.tpl.html',
          controller: 'CadastroDuoRoutesCtrl',
          controllerAs: 'cadastroDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.cadastroRotas.titulo',
        hideTitulo: true,
        roles: [['ROTA_VISUALIZAR']]
      }
    });

    $stateProvider.state('root.duo-routes-cadastro.form', {
      url: '/form/:duoRouteUUID?importFromVehicle&importStartDateTime&importEndDateTime',
      views: {
        'content@': {
          templateUrl: 'duo-routes/cadastro/form-duo-routes.tpl.html',
          controller: 'FormDuoRoutesCtrl',
          controllerAs: 'FormDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.cadastroRotas.titulo',
        hideTitulo: true,
        roles: [['ROTA_EDITAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CadastroDuoRoutesCtrl = function () {
    function CadastroDuoRoutesCtrl(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state) {
      _classCallCheck(this, CadastroDuoRoutesCtrl);

      this.keys = Keys;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    _createClass(CadastroDuoRoutesCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }])).then(function (filtro) {
          _this2.filtro = filtro;
        });
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this3 = this;

        return this.authenticator.getUser().then(function (user) {
          _this3.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this4 = this;

        var appName = 'safetyApp',
            componentName = './DuoRouteListPageRoute',
            componentId = 'safety-duo-route-list',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this4.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goToRouteForm',
      value: function goToRouteForm(duoRouteUUID) {
        this.state.go('root.duo-routes-cadastro.form', {
          duoRouteUUID: duoRouteUUID
        });
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this5 = this;

        return {
          user: this.user,
          filter: {
            ouId: this.filtro.find(function (f) {
              return f.key === _this5.keys.uo.name;
            }).value.id
          },
          goToRouteForm: function goToRouteForm(duoRouteUUID) {
            return _this5.goToRouteForm(duoRouteUUID);
          }
        };
      }
    }]);

    return CadastroDuoRoutesCtrl;
  }();

  angular.module('duo-routes.cadastro-rotas').controller('CadastroDuoRoutesCtrl', CadastroDuoRoutesCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('duo-routes.atribuicao-rotas', ['ui.router', 'ui.bootstrap', 'angularMoment', 'blockUI', 'restangular', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'safetyModule', 'ngSanitize']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FormAssignmentDuoRoutesCtrl = function () {
    function FormAssignmentDuoRoutesCtrl(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $state) {
      _classCallCheck(this, FormAssignmentDuoRoutesCtrl);

      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.blockUI = blockUI;
      this.state = $state;

      this.user = null;

      this.initialize();
    }

    _createClass(FormAssignmentDuoRoutesCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this2 = this;

        return this.authenticator.getUser().then(function (user) {
          _this2.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this3 = this;

        var appName = 'safetyApp',
            componentName = './DuoRouteAssignmentFormPage',
            componentId = 'safety-duo-route-assignment-form',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this3.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goBackToList',
      value: function goBackToList() {
        this.state.go('root.duo-routes-atribuicao');
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        return {
          user: this.user,
          goBackToList: function goBackToList() {
            return _this4.goBackToList();
          }
        };
      }
    }]);

    return FormAssignmentDuoRoutesCtrl;
  }();

  angular.module('duo-routes.atribuicao-rotas').controller('FormAssignmentDuoRoutesCtrl', FormAssignmentDuoRoutesCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DetailsAssignmentDuoRoutesCtrl = function () {
    function DetailsAssignmentDuoRoutesCtrl(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $state, $stateParams) {
      _classCallCheck(this, DetailsAssignmentDuoRoutesCtrl);

      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.user = null;
      this.assignmentUUID = this.stateParams.UUID;

      this.initialize();
    }

    _createClass(DetailsAssignmentDuoRoutesCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this2 = this;

        return this.authenticator.getUser().then(function (user) {
          _this2.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this3 = this;

        var appName = 'safetyApp',
            componentName = './DuoRouteAssignmentDetailsPageRoute',
            componentId = 'safety-duo-route-assignment-details',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this3.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goBackToList',
      value: function goBackToList() {
        this.state.go('root.duo-routes-atribuicao');
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        return {
          user: this.user,
          assignmentUUID: this.assignmentUUID,
          goBackToList: function goBackToList() {
            return _this4.goBackToList();
          }
        };
      }
    }]);

    return DetailsAssignmentDuoRoutesCtrl;
  }();

  angular.module('duo-routes.atribuicao-rotas').controller('DetailsAssignmentDuoRoutesCtrl', DetailsAssignmentDuoRoutesCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('duo-routes.atribuicao-rotas').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.duo-routes-atribuicao', {
      url: '/duo-routes/atribuicao?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/atribuicao-duo-routes.tpl.html',
          controller: 'AtribuicaoDuoRoutesCtrl',
          controllerAs: 'atribuicaoDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_VISUALIZAR']]
      }
    });

    $stateProvider.state('root.duo-routes-atribuicao.form', {
      url: '/form',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/form-assignment-duo-routes.tpl.html',
          controller: 'FormAssignmentDuoRoutesCtrl',
          controllerAs: 'FormAssignmentDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_EDITAR']]
      }
    });

    $stateProvider.state('root.duo-routes-atribuicao.details', {
      url: '/details/:UUID',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/details-assignment-duo-routes.tpl.html',
          controller: 'DetailsAssignmentDuoRoutesCtrl',
          controllerAs: 'DetailsAssignmentDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_VISUALIZAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var AtribuicaoDuoRoutesCtrl = function () {
    function AtribuicaoDuoRoutesCtrl(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, $window, blockUI, moment, $state, FeaturehubJsSdk) {
      _classCallCheck(this, AtribuicaoDuoRoutesCtrl);

      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.window = $window;
      this.blockUI = blockUI;
      this.state = $state;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    _createClass(AtribuicaoDuoRoutesCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          key: this.keys.dateTime.name,
          time: true,
          maxDate: this.moment().endOf('day').format(),
          defaultValues: {
            hoje: {
              active: true
            },
            ontem: {
              active: true
            }
          }
        }, {
          name: 'veiculosId',
          key: this.keys.veiculos.name,
          ignoreValidation: true
        }])).then(function (filtro) {
          _this2.filtro = filtro;
        });
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this3 = this;

        return this.authenticator.getUser().then(function (user) {
          _this3.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this4 = this;

        var appName = 'safetyApp',
            componentName = './DuoRouteAssignmentListPageRoute',
            componentId = 'safety-duo-route-assignment-list',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this4.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goToRouteAssignmentForm',
      value: function goToRouteAssignmentForm() {
        this.state.go('root.duo-routes-atribuicao.form');
      }
    }, {
      key: 'goToVehicle',
      value: function goToVehicle(vehicleId) {
        var _this5 = this;

        var uoId = this.filtro.find(function (f) {
          return f.key === _this5.keys.uo.name;
        }).value.id;
        var link = 'mapas-grid?vfiltro=uo:' + uoId + ';veiculos:' + vehicleId;

        this.window.open(link, '_blank');
      }
    }, {
      key: 'goToAssignmentExecutionDetails',
      value: function goToAssignmentExecutionDetails(assignmentUUID) {
        if (!this.featurehubJsSdk.isFeatureEnabled('LADRX-336-assignment-details')) {
          return;
        }
        this.state.go('root.duo-routes-atribuicao.details', { UUID: assignmentUUID });
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this6 = this;

        var filteredVehicles = this.filtro.find(function (f) {
          return f.key === _this6.keys.veiculos.name;
        });
        return {
          user: this.user,
          filter: {
            ouId: this.filtro.find(function (f) {
              return f.key === _this6.keys.uo.name;
            }).value.id,
            startDate: this.filtro.find(function (f) {
              return f.key === _this6.keys.dateTime.name;
            }).value.startDate,
            endDate: this.filtro.find(function (f) {
              return f.key === _this6.keys.dateTime.name;
            }).value.endDate,
            vehicleIds: filteredVehicles ? filteredVehicles.values.map(function (v) {
              return v.id;
            }) : []
          },
          goToRouteAssignmentForm: function goToRouteAssignmentForm() {
            return _this6.goToRouteAssignmentForm();
          },
          goToVehicle: function goToVehicle(id) {
            return _this6.goToVehicle(id);
          },
          goToAssignmentExecutionDetails: function goToAssignmentExecutionDetails(assignmentUUID) {
            return _this6.goToAssignmentExecutionDetails(assignmentUUID);
          }
        };
      }
    }]);

    return AtribuicaoDuoRoutesCtrl;
  }();

  angular.module('duo-routes.atribuicao-rotas').controller('AtribuicaoDuoRoutesCtrl', AtribuicaoDuoRoutesCtrl);
})();
'use strict';

(function () {
  'use strict';

  function v3gTableLimitDirective(v3gTableLimitService) {
    return {
      restrict: 'EA',
      templateUrl: 'directives/v3g-table-limit/v3g-table-limit.tpl.html',
      link: function link(scope) {
        scope.v3gTableLimitService = v3gTableLimitService;
        scope.options = {
          10: '10',
          20: '20',
          50: '50'
        };
        scope.stItemsByPage = v3gTableLimitService.stItemsByPage;

        scope.changeValue = function () {
          v3gTableLimitService.salvarLimite(scope.stItemsByPage);
        };

        scope.$watch('v3gTableLimitService.stItemsByPage', function (newValue) {
          if (scope.stItemsByPage !== newValue) {
            scope.stItemsByPage = newValue;
          }
        });
      }
    };
  }

  angular.module('smart-table').directive('v3gTableLimitDirective', v3gTableLimitDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var v3gTableLimitService = function () {
    function v3gTableLimitService($window) {
      _classCallCheck(this, v3gTableLimitService);

      this.window = $window;
      this.stItemsByPage = 10;
      this.user = null;
    }

    _createClass(v3gTableLimitService, [{
      key: 'init',
      value: function init(user) {
        this.user = user;
        var local = angular.fromJson(this.window.localStorage.getItem('table-limit-' + this.user.id));

        if (local) {
          this.stItemsByPage = local;
        } else {
          this.salvarLimite(10);
        }

        return {
          number: this.stItemsByPage
        };
      }
    }, {
      key: 'salvarLimite',
      value: function salvarLimite(e) {
        this.stItemsByPage = e;
        this.window.localStorage.setItem('table-limit-' + this.user.id, this.stItemsByPage);
      }
    }]);

    return v3gTableLimitService;
  }();

  angular.module('smart-table').service('v3gTableLimitService', v3gTableLimitService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('VImageCrop', ['ngImgCrop', 'alert-message']);
})();
'use strict';

(function () {
  'use strict';

  function V3gImageCrop() {
    return {
      templateUrl: 'directives/v3g-image-crop/v3g-image-crop.tpl.html',
      restrict: 'E',
      controller: 'v3gImageCropCtrl',
      controllerAs: 'v3gImageCropCtrl',
      scope: {
        maxSize: '=?',
        required: '=?',
        onChangeFile: '=',
        onCrop: '='
      }
    };
  }

  angular.module('VImageCrop').directive('v3gImageCrop', V3gImageCrop);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FileReader, atob, Blob */

  var v3gImageCropCtrl = function () {
    function v3gImageCropCtrl($scope, MB_IN_BYTES, AlertMessage) {
      _classCallCheck(this, v3gImageCropCtrl);

      this.scope = $scope;
      this.alertMessage = AlertMessage;
      this.required = $scope.required || true;
      this.maxSize = $scope.maxSize || 5 * MB_IN_BYTES;
      this.MB_IN_BYTES = MB_IN_BYTES;
      this.TIPOS_EXTENSAO_IMAGE = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];

      this.fotoOriginal = null;
      this.fotoFinal = null;
    }

    _createClass(v3gImageCropCtrl, [{
      key: 'handleChangeImage',
      value: function handleChangeImage(el) {
        var _this = this;

        var file = el.files[0],
            extension = file.name.split('.').slice(-1)[0],
            reader = new FileReader();

        if (this.isValidImage(extension)) {
          reader.onload = this.onLoadFileReader();
          reader.readAsDataURL(file);
          this.scope.onChangeFile(file);
        } else {
          this.scope.$apply(function () {
            _this.alertMessage.create({
              type: 'error',
              message: 'A extensão do arquivo deve ser JPG, JPEG, PNG, GIF ou BMP.',
              appendTo: '.alert-file'
            });
            angular.element('#imagem').val('');
          });
        }
      }
    }, {
      key: 'onLoadFileReader',
      value: function onLoadFileReader() {
        var _this2 = this;

        return function (evt) {
          _this2.scope.$apply(function () {
            _this2.fotoOriginal = evt.target.result;
            _this2.fotoFinal = evt.target.result;
          });
        };
      }
    }, {
      key: 'dataURItoBlob',
      value: function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]),
            mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0],
            ab = new ArrayBuffer(byteString.length),
            ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      }
    }, {
      key: 'onCrop',
      value: function onCrop() {
        if (this.fotoFinal !== null) {
          this.scope.onCrop(this.dataURItoBlob(this.fotoFinal));
        }
      }
    }, {
      key: 'maxSizeLabel',
      value: function maxSizeLabel() {
        return this.maxSize / this.MB_IN_BYTES + 'MB';
      }
    }, {
      key: 'isValidImage',
      value: function isValidImage(type) {
        return this.TIPOS_EXTENSAO_IMAGE.find(function (tipo) {
          return type.includes(tipo);
        });
      }
    }]);

    return v3gImageCropCtrl;
  }();

  angular.module('VImageCrop').constant('MB_IN_BYTES', 1000000).controller('v3gImageCropCtrl', v3gImageCropCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var NAO_CADASTRADO = -1;

  var VUiSelectCtrl = function () {
    function VUiSelectCtrl() {
      _classCallCheck(this, VUiSelectCtrl);
    }

    _createClass(VUiSelectCtrl, [{
      key: 'checkEscapeKey',
      value: function checkEscapeKey(evento) {
        if (evento.keyCode === 27) {
          this.model = '';
        }
      }
    }, {
      key: 'onSelectedElement',
      value: function onSelectedElement(select) {
        this.onSelection({ elemento: select });
      }
    }, {
      key: 'itemCadastrado',
      value: function itemCadastrado(element) {
        return element.id !== NAO_CADASTRADO;
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults($select) {
        var search = $select.search,
            list = angular.copy($select.items),
            userInputItem = {};
        list = list.filter(function (item) {
          return item.id !== NAO_CADASTRADO;
        });

        userInputItem = {
          id: NAO_CADASTRADO,
          nome: search
        };

        if (!search) {
          userInputItem.nome = userInputItem.nome;
          $select.items = [userInputItem].concat(list);
        }
      }
    }]);

    return VUiSelectCtrl;
  }();

  angular.module('vUiSelectModule', []).component('vUiSelect', {
    controller: VUiSelectCtrl,
    templateUrl: 'directives/v-ui-select/v-ui-select.tpl.html',
    bindings: {
      name: '@',
      placeholder: '@',
      info: '@',
      model: '=',
      elements: '=',
      onSelection: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var UoSelectInputCtrl = function () {
    function UoSelectInputCtrl(Uos, UoArvoreNivel, Authenticator, $scope) {
      _classCallCheck(this, UoSelectInputCtrl);

      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.authenticator = Authenticator;
      this.uos = [];
      this.uoUser = null;
      this.scope = $scope;
    }

    _createClass(UoSelectInputCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          _this.carregarUos(user.uo.id);
          _this.uoUser = user.uo.id;
        });
      }
    }, {
      key: 'bindModelSelect',
      value: function bindModelSelect() {
        if (this.model && this.uos) {
          this.model = this.findUoById(this.model.id);
        }
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos(uoId) {
        var _this2 = this;

        this.uoService.getFilhas(uoId).then(function (data) {
          _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
          if (_this2.model) {
            _this2.model = _this2.findUoById(_this2.model.id);
          } else if (_this2.defaultUserUo) {
            _this2.model = _this2.findUoById(_this2.uoUser);
          }
        });
      }
    }, {
      key: 'findUoById',
      value: function findUoById(uoId) {
        return this.uos.find(function (uo) {
          return uo.id === uoId;
        });
      }
    }, {
      key: 'onSelect',
      value: function onSelect(uo) {
        this.onSelectUo({ uo: uo });
      }
    }]);

    return UoSelectInputCtrl;
  }();

  angular.module('uoSelectInputModule', ['uoModule', 'uoArvoreNivelModule', 'v3gAuthenticatorModule']).component('uoSelectInput', {
    controller: UoSelectInputCtrl,
    templateUrl: 'directives/uo-select-input/uo-select-input-component.tpl.html',
    bindings: {
      model: '=',
      required: '=',
      name: '@',
      disabled: '<',
      defaultUserUo: '<',
      onSelectUo: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var TagIgnoreCtrl = function () {
    function TagIgnoreCtrl($translate, moment, MeasurementUnitConverterService, Authenticator, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, TagIgnoreCtrl);

      this.translate = $translate;
      this.moment = moment;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.featureFlagLAINT42 = FeaturehubJsSdk.isFeatureEnabled('LAINT42_tag_ignore');
      this.name = '';
      this.date = '';
      this.dateTimeFormat = '';
      Authenticator.getUser().then(function (user) {
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateFormat(user.measurementUnits.dateTimeFormat).toUpperCase() + ' HH:mm:ss';
        _this.handleInitValues();
      });
    }

    _createClass(TagIgnoreCtrl, [{
      key: 'handleInitValues',
      value: function handleInitValues() {
        if (this.alert) {
          var alert = angular.isString(this.alert) ? angular.fromJson(this.alert) : this.alert;
          this.name = alert.labelInfo.labeledByName;
          this.date = alert.labelInfo.labeledAt;
        } else if (this.event) {
          var event = angular.isString(this.event) ? angular.fromJson(this.event) : this.event;
          this.name = event.labeledByName;
          this.date = event.datetimeCreated;
        }
      }
    }, {
      key: 'handleTooltipMessage',
      value: function handleTooltipMessage() {
        this.handleInitValues();
        return this.translate.instant('ce.enum.eventosTooltips.tagIgnoreAlert', {
          name: this.name,
          date: this.moment(this.date).format(this.dateTimeFormat)
        });
      }
    }]);

    return TagIgnoreCtrl;
  }();

  angular.module('TagIgnoreModule', []).controller('TagIgnoreCtrl', TagIgnoreCtrl).component('tagIgnore', {
    templateUrl: 'directives/tag-ignore/tag-ignore.tpl.html',
    controller: TagIgnoreCtrl,
    bindings: {
      alert: '<',
      event: '<',
      size: '@',
      position: '@'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var SnapshotLinkCtrl = function () {
    function SnapshotLinkCtrl(Authenticator, ServiceVfiltro, $window, UrlConfigService, HttpServiceV3g, $httpParamSerializer, FeatureOuService, CadastroVeiculoService, $attrs) {
      _classCallCheck(this, SnapshotLinkCtrl);

      this.authenticator = Authenticator;
      this.seePhotoLinkElement = null;
      this.window = $window;
      this.urlConfigService = UrlConfigService;
      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
      this.featureOuService = FeatureOuService;
      this.cadastroVeiculoService = CadastroVeiculoService;
      this.attrs = $attrs;

      this.uoId = angular.fromJson(this.window.localStorage.getItem('vfiltro-' + ServiceVfiltro.factoryVfiltro.user.id)).uo;
    }

    _createClass(SnapshotLinkCtrl, [{
      key: '$postLink',
      value: function $postLink() {
        this.seePhotoLinkElement = document.createElement('vfleets-see-photo'); // eslint-disable-line
        this.buildSeePhotoLinkElement();
      }
    }, {
      key: '$onChanges',
      value: function $onChanges(changes) {
        if (!this.seePhotoLinkElement) {
          return;
        }
        if (changes.uoWithRecFacial) {
          this.seePhotoLinkElement.uoWithRecFacial = !!this.uoWithRecFacial;
        }
        if (changes.isNa) {
          this.seePhotoLinkElement.isNa = !!this.isNa;
        }
      }

      /**
       * Necessário a utilização do $doCheck pois a div do template não era encontrado
       * na DOM na inicialização do component, fazendo com que o querySelector viesse
       * sempre null. Por isso foi criado condicionais para que depois que se encontre
       * uma vez o elemento na DOM não precisar mais buscar, para evitar o excesso de processamento
       * devido ao $doCheck que ocorre a cada modificação existente.
       */

    }, {
      key: '$doCheck',
      value: function $doCheck() {
        var seePhotoLinkContainer = document.querySelector('#' + this.prefixContainer + '-' + (this.alertId ? this.alertId : this.idSnapshot)); // eslint-disable-line
        if (seePhotoLinkContainer && this.seePhotoLinkElement && seePhotoLinkContainer.innerHTML === '') {
          seePhotoLinkContainer.appendChild(this.seePhotoLinkElement);
        }
      }
    }, {
      key: 'buildViewParams',
      value: function buildViewParams() {
        var params = {
          s3key: this.s3key,
          uoVeiculo: this.uoVeiculo
        };
        if (this.isFilled(this.bucket)) {
          params.bucket = this.bucket;
        }
        if (this.isFilled(this.bucketRegion)) {
          params.bucketRegion = this.bucketRegion;
        }
        return params;
      }
    }, {
      key: 'isFilled',
      value: function isFilled(value) {
        return !!value && value !== 'undefined' && value !== 'null';
      }
    }, {
      key: 'buildSeePhotoLinkElement',
      value: function buildSeePhotoLinkElement() {
        var _this = this;

        var params = this.httpParamSerializer(this.buildViewParams());
        this.seePhotoLinkElement.isWithVigenciaManual = this.showOptionVigenciaManual();
        this.seePhotoLinkElement.hasPermissionEditMotorista = this.hasPermissionEditMotorista();
        this.seePhotoLinkElement.imageUrl = '/motorista/reconhecimento-facial/v2/view?' + params;
        this.seePhotoLinkElement.snapshotId = this.idSnapshot;
        this.seePhotoLinkElement.hasPermissionViewVideo = this.hasPermissionViewVideo();
        this.seePhotoLinkElement.ignitionsVehicle = this.buildIgnitionsVehicle();
        this.seePhotoLinkElement.vigenciaAtual = this.vigenciaAtual ? this.vigenciaAtual : this.buildVigenciaPopUp();
        this.seePhotoLinkElement.uoId = this.uoId;
        this.seePhotoLinkElement.customButtonText = this.textButton;
        this.seePhotoLinkElement.isAlert = !!this.alertId;
        if (this.attrs && 'isNa' in this.attrs) {
          this.seePhotoLinkElement.isNa = !!this.isNa;
        } else {
          this.seePhotoLinkElement.isNa = false;
          this.featureOuService.getVehicleTableConfig(this.uoId).then(function (isNaUo) {
            _this.seePhotoLinkElement.isNa = isNaUo;
          }).catch(function () {});
        }
        if (this.attrs && 'uoWithRecFacial' in this.attrs) {
          this.seePhotoLinkElement.uoWithRecFacial = !!this.uoWithRecFacial;
        } else {
          this.seePhotoLinkElement.uoWithRecFacial = false;
          this.cadastroVeiculoService.hasRecFacial(this.uoId, null).then(function (uoWithRecFacial) {
            _this.seePhotoLinkElement.uoWithRecFacial = uoWithRecFacial;
          }).catch(function () {});
        }
        this.seePhotoLinkElement.addEventListener('vigenciaManualCadastrada', function (e) {
          if (e.detail.reload) {
            if (_this.isHistoricoDetalhado) {
              _this.window.location.reload();
            } else {
              _this.onCloseDialog();
            }
          }
        });
      }
    }, {
      key: 'buildVigenciaPopUp',
      value: function buildVigenciaPopUp() {
        return angular.fromJson(this.vigenciaAtualPopup);
      }
    }, {
      key: 'showOptionVigenciaManual',
      value: function showOptionVigenciaManual() {
        return this.podeAbrirVigenciaManual;
      }
    }, {
      key: 'buildIgnitionsVehicle',
      value: function buildIgnitionsVehicle() {
        return {
          veiculoId: this.idVeiculo,
          dateIgnitionOn: this.dateIgnitionOn,
          dateIgnitionOff: this.dateIgnitionOff
        };
      }
    }, {
      key: 'getUrl',
      value: function getUrl() {
        return this.urlConfigService.getApiGatewayUrl() + '/motorista/reconhecimento-facial/view/' + this.idSnapshot + '?datetimeReferencia=' + this.dateIgnitionOn;
      }
    }, {
      key: 'hasPermissionViewVideo',
      value: function hasPermissionViewVideo() {
        return this.authenticator.hasRole('VIDEO_VISUALIZAR');
      }
    }, {
      key: 'hasPermissionEditMotorista',
      value: function hasPermissionEditMotorista() {
        return this.authenticator.hasRole('MOTORISTA_EDITAR');
      }
    }]);

    return SnapshotLinkCtrl;
  }();

  angular.module('videoPlayer').controller('SnapshotLinkCtrl', SnapshotLinkCtrl).component('snapshotLink', {
    template: '<div id=\'{{$ctrl.prefixContainer}}-{{$ctrl.alertId ? $ctrl.alertId : $ctrl.idSnapshot}}\'></div>',
    controller: 'SnapshotLinkCtrl',
    bindings: {
      idSnapshot: '@',
      s3key: '@',
      bucket: '@',
      bucketRegion: '@',
      prefixContainer: '@',
      dateIgnitionOn: '@',
      dateIgnitionOff: '@',
      podeAbrirVigenciaManual: '<',
      vigenciaAtual: '<',
      vigenciaAtualPopup: '@',
      idVeiculo: '@',
      uoVeiculo: '@',
      textButton: '@',
      alertId: '@',
      uoWithRecFacial: '<',
      isNa: '<',
      onCloseDialog: '&'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var SelectUoCtrl = function () {
    function SelectUoCtrl(Uos, UoArvoreNivel, Authenticator) {
      var _this = this;

      _classCallCheck(this, SelectUoCtrl);

      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.authenticator = Authenticator;
      this.uos = [];
      this.authenticator.getUser().then(function (user) {
        _this.carregarUos(user.uo.id);
      });
    }

    _createClass(SelectUoCtrl, [{
      key: 'carregarUos',
      value: function carregarUos(uoId) {
        var _this2 = this;

        this.uoService.getFilhas(uoId).then(function (data) {
          _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }]);

    return SelectUoCtrl;
  }();

  angular.module('conducaoEconomica').component('selectUo', {
    controller: SelectUoCtrl,
    templateUrl: 'directives/select-uo/select-uo.tpl.html',
    bindings: {
      model: '=',
      selectRequired: '=',
      selectName: '@',
      selectDisabled: '<'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('reprodRotasModule', []);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ReprodRotasService = function () {
    function ReprodRotasService(EventosEnum, AlertMessage, $translate) {
      _classCallCheck(this, ReprodRotasService);

      this.createdReprodRotas = false;
      this.showReprodRotas = false;
      this.agrupamentos = null;
      this.eventosEnum = EventosEnum;
      this.translate = $translate;
      this.alertMessage = AlertMessage;
    }

    _createClass(ReprodRotasService, [{
      key: 'criaPosicoesUnicas',
      value: function criaPosicoesUnicas(posicoes) {
        return posicoes.reduce(function (acc, posicao) {
          if (acc.length === 0 || posicao.latitude !== acc[acc.length - 1].latitude || posicao.longitude !== acc[acc.length - 1].longitude) {
            acc.push(posicao);
          }
          return acc;
        }, []);
      }
    }, {
      key: 'setAgrupamentos',
      value: function setAgrupamentos(agrupamentos) {
        this.agrupamentos = agrupamentos;
      }
    }, {
      key: 'hasSomeEventoMovimento',
      value: function hasSomeEventoMovimento() {
        var _this = this;

        if (this.agrupamentos) {
          return this.agrupamentos.some(function (agrupamento) {
            return agrupamento.evento === _this.translate.instant(_this.eventosEnum.MOVIMENTO);
          });
        }
        return false;
      }
    }, {
      key: 'createReprodRotas',
      value: function createReprodRotas() {
        if (!this.hasSomeEventoMovimento()) {
          this.alertMessage.create({
            type: 'warning',
            message: this.translate.instant('ce.mapa.common.modal.reprodRotas.rotaNaoPossuiMovimento'),
            appendTo: '.alerta-aqui'
          });
        } else {
          this.createdReprodRotas = true;
          this.showReprodRotas = true;
        }
      }
    }, {
      key: 'toggleReprodRotas',
      value: function toggleReprodRotas() {
        this.showReprodRotas = !this.showReprodRotas;
      }
    }]);

    return ReprodRotasService;
  }();

  angular.module('reprodRotasModule').service('ReprodRotasService', ReprodRotasService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L */
(function () {
  'use strict';

  var ReprodRotasCtrl = function () {
    function ReprodRotasCtrl($interval, ReprodRotasService, EventosEnum, $translate) {
      _classCallCheck(this, ReprodRotasCtrl);

      this.pathGroup = new L.FeatureGroup();
      this.intervalService = $interval;
      this.reprodRotasService = ReprodRotasService;
      this.eventosEnum = EventosEnum;
      this.translate = $translate;

      this.checkedPos = [];
      this.lastCheckPoint = 0;
      this.lastPosTime = null;
      this.routeFinished = false;
      this.showSpeed = false;

      this.pos = [];
      this.playbackRoute = null;
      this.isPlaying = false;
      this.model = {
        speed: 1,
        pulaParada: false
      };
      this.speedInput = {
        min: 0.1,
        max: 10,
        step: 0.1
      };

      this.intervalReproducao = null;
      this.dataTimeReproduction = 0;
    }

    _createClass(ReprodRotasCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.pos = this.reprodRotasService.criaPosicoesUnicas(this.posicoes);
        this.initEvents();
        this.initReprodRoute();
        this.initControls();
      }
    }, {
      key: '$onDestroy',
      value: function $onDestroy() {
        this.intervalService.cancel(this.intervalReproducao);
      }
    }, {
      key: 'initEvents',
      value: function initEvents() {
        var elementReprodRotas = L.DomUtil.get('reprod-rotas');
        L.DomEvent.disableClickPropagation(elementReprodRotas);
        L.DomEvent.disableScrollPropagation(elementReprodRotas);
      }
    }, {
      key: 'initReprodRoute',
      value: function initReprodRoute() {
        var playbackObj = {
          type: 'Feature',
          geometry: {
            type: 'MultiPoint',
            coordinates: this.pos.map(function (p) {
              return [p.longitude, p.latitude];
            })
          },
          properties: {
            time: this.pos.map(function (p) {
              return new Date(p.data).getTime();
            })
          }
        },
            icon = L.icon({
          iconUrl: '/images/veiculo-reprod-rotas.png',
          iconSize: [20, 20],
          iconAnchor: [10, 10]
        }),
            playbackOptions = {
          maxInterpolationTime: 1440 * 60 * 1000,
          tickLen: 15000,
          speed: this.model.speed * 50,
          orientIcons: false,
          marker: function marker() {
            return {
              icon: icon,
              zIndexOffset: 99999
            };
          }
        };

        this.playbackRoute = new L.Playback(this.map, playbackObj, null, playbackOptions);
        this.geraOffsetEventoParado();
      }
    }, {
      key: 'geraOffsetEventoParado',
      value: function geraOffsetEventoParado() {
        var _this = this;

        this.offsets = this.agrupamentos.filter(function (agrupamento) {
          return agrupamento.evento === _this.translate.instant(_this.eventosEnum.PARADO);
        }).map(function (agrupamento) {
          return {
            inicio: new Date(agrupamento.inicio).getTime(),
            fim: new Date(agrupamento.fim).getTime()
          };
        });
      }
    }, {
      key: 'getIntervalReproducao',
      value: function getIntervalReproducao() {
        var _this2 = this;

        var interval = this.intervalService(function () {
          var currentTime = _this2.playbackRoute.getTime();
          if (_this2.model.pulaParada) {
            _this2.pulaEventoParado(currentTime);
          }
          _this2.model.slider = currentTime;
          _this2.setCurrentTime(currentTime);
          _this2.centralizaNavegacao();
          _this2.verificaFinalRota();
        }, 250);
        return interval;
      }
    }, {
      key: 'setCurrentTime',
      value: function setCurrentTime(currentTime) {
        var endTime = this.playbackRoute.getEndTime();
        this.dataTimeReproduction = currentTime > endTime ? endTime : currentTime;
      }
    }, {
      key: 'verificaFinalRota',
      value: function verificaFinalRota() {
        if (this.isAtEndRoute()) {
          this.pause();
          this.routeFinished = true;
        } else {
          this.lastPosTime = this.playbackRoute.getTime();
        }
      }
    }, {
      key: 'pulaEventoParado',
      value: function pulaEventoParado(currentTime) {
        var offsetCurrentPos = this.offsets.find(function (offset) {
          return currentTime >= offset.inicio && currentTime <= offset.fim;
        });
        if (offsetCurrentPos) {
          this.playbackRoute.setCursor(offsetCurrentPos.fim);
        }
      }
    }, {
      key: 'getCurrentLatLng',
      value: function getCurrentLatLng() {
        return this.playbackRoute._trackController._tracks[0].tick(this.playbackRoute.getTime()); //eslint-disable-line
      }
    }, {
      key: 'centralizaNavegacao',
      value: function centralizaNavegacao() {
        var latLng = this.getCurrentLatLng();
        latLng = L.latLng(latLng[1], latLng[0]);
        if (!this.map.getBounds().contains(latLng)) {
          this.map.setView(latLng, this.map.getZoom());
        }
      }
    }, {
      key: 'initControls',
      value: function initControls() {
        this.sliderInput = {
          min: this.playbackRoute.getStartTime(),
          max: this.playbackRoute.getEndTime(),
          step: this.playbackRoute.getTickLen(),
          value: this.playbackRoute.getTime()
        };
        this.dataTimeReproduction = this.playbackRoute.getStartTime();
      }
    }, {
      key: 'playPause',
      value: function playPause() {
        if (this.playbackRoute.isPlaying()) {
          this.pause();
        } else {
          this.play();
        }
      }
    }, {
      key: 'play',
      value: function play() {
        if (this.routeFinished) {
          this.playbackRoute.setCursor(this.playbackRoute.getStartTime());
          this.routeFinished = false;
        }
        this.intervalReproducao = this.getIntervalReproducao();
        this.playbackRoute.start();
        this.isPlaying = true;
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.intervalService.cancel(this.intervalReproducao);
        this.playbackRoute.stop();
        this.isPlaying = false;
      }
    }, {
      key: 'setSpeed',
      value: function setSpeed() {
        var velocidade = Number(this.model.speed) * 50;
        this.playbackRoute.setSpeed(velocidade);
      }
    }, {
      key: 'isAtEndRoute',
      value: function isAtEndRoute() {
        var currentTime = this.playbackRoute.getTime();
        return this.lastPosTime === currentTime && currentTime >= this.playbackRoute.getEndTime() - this.playbackRoute.getTickLen();
      }
    }, {
      key: 'setSlider',
      value: function setSlider() {
        this.playbackRoute.setCursor(this.model.slider);
        this.dataTimeReproduction = this.playbackRoute.getTime();
        if (!this.isAtEndRoute()) {
          this.routeFinished = false;
        }
      }
    }, {
      key: 'toggleSpeed',
      value: function toggleSpeed() {
        this.showSpeed = !this.showSpeed;
      }
    }, {
      key: 'closeSpeed',
      value: function closeSpeed() {
        this.showSpeed = false;
      }
    }]);

    return ReprodRotasCtrl;
  }();

  angular.module('mapControlModule').component('reprodRotas', {
    controller: ReprodRotasCtrl,
    templateUrl: 'directives/reprod-rotas/reprod-rotas.tpl.html',
    bindings: {
      posicoes: '=',
      agrupamentos: '=',
      map: '='
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('mousewheelDirectiveModule', []);
})();
'use strict';

(function () {
  'use strict';

  function onMousewheelDirective() {
    return {
      restrict: 'A',
      scope: {
        onMousewheel: '&'
      },
      link: function link(scope, element) {
        element.bind('mousewheel', function (e) {
          scope.$applyAsync(scope.onMousewheel(e));
        });
      }
    };
  }

  angular.module('mousewheelDirectiveModule').directive('onMousewheel', onMousewheelDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global L */
(function () {
  'use strict';

  var MotoristaLinkCtrl = function () {
    function MotoristaLinkCtrl(Authenticator, ProntuarioLinkService, ServiceVfiltro, Keys) {
      var _this = this;

      _classCallCheck(this, MotoristaLinkCtrl);

      this.prontuarioLinkService = ProntuarioLinkService;
      this.element = null;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.authenticator = Authenticator;
      this.authenticator.getUser().then(function (user) {
        _this.enableHiperlink = _this.prontuarioLinkService.hasRoleToViewProntuario(user);
      });
    }

    _createClass(MotoristaLinkCtrl, [{
      key: 'getLinkProntuarioMotorista',
      value: function getLinkProntuarioMotorista() {
        var _this2 = this;

        if (!this.motoristaId || !this.hasPermission) {
          return null;
        }
        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this2.keys.uo.name;
        }).value.id;
        return this.prontuarioLinkService.goToLinkProntuarioSinceFirstDayOfMonth(uoId, this.motoristaId);
      }
    }]);

    return MotoristaLinkCtrl;
  }();

  angular.module('motoristaLinkModule', ['ProntuarioLinkModule', 'ServiceVfiltroModule']).controller('MotoristaLinkCtrl', MotoristaLinkCtrl).component('motoristaLink', {
    templateUrl: 'directives/motorista-link/motorista-link.tpl.html',
    controller: MotoristaLinkCtrl,
    bindings: {
      motorista: '=',
      motoristaId: '=',
      hasPermission: '=',
      index: '='
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  // Mantêm estados entre Ponto de Referência e Area de Controle

  var MapControlService = function MapControlService() {
    _classCallCheck(this, MapControlService);

    this.isDrawingCercaEletronica = false;
    this.isDrawingPontoRef = false;
  };

  angular.module('mapControlModule').service('MapControlService', MapControlService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var PontosReferenciaMenu = function () {
    function PontosReferenciaMenu(ReprodRotasService, $rootScope, Authenticator, $window, MapasUtil, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, PontosReferenciaMenu);

      this.menustate = 'closed';
      this.menu = 'closed';
      this.drawerBusca = false;
      this.drawerAdvisor = false;
      this.tabelaPontosProximos = false;
      this.buttons = [];
      this.buttonsPrincipal = null;
      this.idMapa = '';
      this.reprodRotasService = ReprodRotasService;
      this.rootScope = $rootScope;
      this.authenticator = Authenticator;
      this.window = $window;
      this.mapasUtilService = MapasUtil;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.rootScope.$on('toggle-drawer', function () {
        return _this.toggleDrawer();
      });
    }

    _createClass(PontosReferenciaMenu, [{
      key: 'menuOpen',
      value: function menuOpen() {
        this.menustate = 'open';
        this.menu = 'open';
      }
    }, {
      key: 'menuClose',
      value: function menuClose() {
        this.menustate = 'closed';
        this.menu = 'closed';
      }
    }, {
      key: 'isDrawerOpen',
      value: function isDrawerOpen() {
        return this.drawerAdvisor || this.drawerBusca;
      }
    }, {
      key: 'drawerOpen',
      value: function drawerOpen() {
        this.drawerBusca = true;
      }
    }, {
      key: 'drawerAdvisorOpen',
      value: function drawerAdvisorOpen() {
        this.drawerAdvisor = true;
        this.rootScope.$broadcast('openAdvisorList');
      }
    }, {
      key: 'drawerClose',
      value: function drawerClose() {
        this.drawerBusca = false;
      }
    }, {
      key: 'drawerAdvisorClose',
      value: function drawerAdvisorClose() {
        this.drawerAdvisor = false;
      }
    }, {
      key: 'toggleSnackbarSugestion',
      value: function toggleSnackbarSugestion() {
        /* eslint-disable */
        var snackbarElement = document.querySelector('vfwc-snackbar-sugestao-rotograma'); /* eslint-enable */
        if (snackbarElement) {
          if (this.drawerAdvisor) {
            snackbarElement.style.display = 'inherit';
          } else {
            snackbarElement.style.display = 'none';
          }
        }
      }
    }, {
      key: 'tabelaPontosProximosOpen',
      value: function tabelaPontosProximosOpen() {
        this.tabelaPontosProximos = true;
      }
    }, {
      key: 'tabelaPontosProximosClose',
      value: function tabelaPontosProximosClose() {
        this.tabelaPontosProximos = false;
      }
    }, {
      key: 'toggleDrawer',
      value: function toggleDrawer() {
        if (!this.canOpenDrawer()) {
          return;
        }
        if (this.tipoFAB !== 'adicionar-pontos-proximos') {
          if (this.drawerBusca) {
            this.setFABActive('default');
          } else {
            this.activateMapLayers();
            this.setFABActive('pesquisar');
          }
        } else {
          this.togglePesquisa(!this.drawerBusca);
        }
      }
    }, {
      key: 'setFABDefault',
      value: function setFABDefault() {
        this.limpaClassePesquisa();
        this.menuClose();
        this.drawerClose();
        this.setFABActive('default');
      }
    }, {
      key: 'setFABActive',
      value: function setFABActive(type) {
        if (type === 'reproducao-rotas') {
          this.reprodRotasService.createReprodRotas();
        }
        this.togglePesquisa(type === 'pesquisar');
        this.tipoFAB = type;
      }
    }, {
      key: 'togglePesquisa',
      value: function togglePesquisa(fun) {
        var mapa = angular.element('#' + this.idMapa);
        mapa.removeClass('drawer-open');
        this.drawerAdvisorClose();

        if (fun) {
          mapa.addClass('drawer-open');
          this.drawerOpen();
          this.menuClose();
        } else {
          mapa.removeClass('drawer-open');
          this.drawerClose();
        }
      }
    }, {
      key: 'clickAdvisorButton',
      value: function clickAdvisorButton() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          _this2.mapasUtilService.activateAllMapLayers(user.id);
          var jaVisualizouBoasVindas = _this2.window.localStorage.getItem('boas-vindas-advisor-' + user.id);
          if (jaVisualizouBoasVindas) {
            _this2.toggleAdvisor();
          } else {
            _this2.createBoasVindasAdvisor();
          }
        });
      }
    }, {
      key: 'createBoasVindasAdvisor',
      value: function createBoasVindasAdvisor() {
        /* eslint-disable */
        var body = document.querySelector('body'),
            boasVindasElement = document.createElement('vfwc-open-dialog-boas-vindas-sugestao');
        /* eslint-enable */
        body.append(boasVindasElement);
        this.setOnCloseBoasVindas(boasVindasElement);
      }
    }, {
      key: 'setOnCloseBoasVindas',
      value: function setOnCloseBoasVindas(element) {
        var _this3 = this;

        element.addEventListener('onClose', function (event) {
          if (event.detail && event.detail.onCloseBoasVindasAdvisor) {
            _this3.toggleAdvisor();
            _this3.setModalBoasVindasInLocalStorage();
          }
        });
      }
    }, {
      key: 'setModalBoasVindasInLocalStorage',
      value: function setModalBoasVindasInLocalStorage() {
        var _this4 = this;

        this.authenticator.getUser().then(function (user) {
          _this4.window.localStorage.setItem('boas-vindas-advisor-' + user.id, true);
        });
      }
    }, {
      key: 'toggleAdvisor',
      value: function toggleAdvisor() {
        if (!this.canOpenDrawer()) {
          return;
        }
        var mapa = angular.element('#' + this.idMapa);
        this.drawerClose();

        if (!this.drawerAdvisor) {
          // map width control
          mapa.addClass('drawer-open');
          this.drawerAdvisorOpen();
          this.menuClose();
        } else {
          mapa.removeClass('drawer-open');
          this.drawerAdvisorClose();
        }
        this.toggleSnackbarSugestion();
      }
    }, {
      key: 'setMenu',
      value: function setMenu(buttons) {
        var buttonsPrincipal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { active: 'fa fa-plus', resting: 'fa fa-plus' };

        this.buttonsPrincipal = buttonsPrincipal;
        this.buttons = buttons;
      }
    }, {
      key: 'limpaClassePesquisa',
      value: function limpaClassePesquisa() {
        angular.element('.lista-resultado-pesquisa').removeClass('ativo');
      }
    }, {
      key: 'fecharDrawer',
      value: function fecharDrawer() {
        this.drawerClose();
        this.setFABDefault();
      }
    }, {
      key: 'verificaMenuDefaultOuPesquisa',
      value: function verificaMenuDefaultOuPesquisa() {
        return this.tipoFAB === 'default' || this.tipoFAB === 'pesquisar' || this.tipoFAB === 'reproducao-rotas';
      }
    }, {
      key: 'canOpenDrawer',
      value: function canOpenDrawer() {
        return !this.isEditModeOn();
      }
    }, {
      key: 'isEditModeOn',
      value: function isEditModeOn() {
        if (!this.featurehubJsSdk.isFeatureEnabled('TTLADAAS208')) {
          return false;
        }

        var editModeFabTypes = ['adicionar-cerca-eletronica', 'editar-cerca-eletronica', 'excluir-cerca-eletronica'];

        return editModeFabTypes.includes(this.tipoFAB);
      }
    }, {
      key: 'verificaMenuDefaultOuPesquisaOuAdicionarPontoProximo',
      value: function verificaMenuDefaultOuPesquisaOuAdicionarPontoProximo() {
        return this.verificaMenuDefaultOuPesquisa() || this.tipoFAB === 'adicionar-pontos-proximos';
      }
    }, {
      key: 'activateMapLayers',
      value: function activateMapLayers() {
        var _this5 = this;

        this.authenticator.getUser().then(function (user) {
          _this5.mapasUtilService.activateAllMapLayers(user.id);
        });
      }
    }]);

    return PontosReferenciaMenu;
  }();

  angular.module('mapControlModule').service('PontosReferenciaMenu', PontosReferenciaMenu);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  function mapControlDirective() {
    return {
      templateUrl: 'directives/map-control/map-control-directive.tpl.html',
      controller: 'MapControlDirectiveCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {
        idPonto: '=',
        idMapa: '=',
        pontosProximos: '=',
        onInit: '&'
      }
    };
  }

  var MapControlDirectiveCtrl = function () {
    function MapControlDirectiveCtrl($scope, $window, $q, $uibModal, moment, leafletData, Authenticator, AlertMessage, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, CategoriaPontosReferencia, PontosReferenciaFiltro, PontosProximos, CercaEletronicaMapService, CercaEletronicaService, $translate, BuscaPorRegiaoMapService, AdvisorRotogramasService, FeatureFlag, Onboarding, IDBuscaPorRegiao, $location, MapasUtil, MapLayerVisibility) {
      var _this = this;

      _classCallCheck(this, MapControlDirectiveCtrl);

      this.scope = $scope;
      this.window = $window;
      this.q = $q;
      this.modalService = $uibModal;
      this.moment = moment;
      this.translate = $translate;
      this.featureFlag = FeatureFlag;
      this.onboarding = Onboarding;
      this.idBuscaPorRegiao = IDBuscaPorRegiao;
      this.mapasUtil = MapasUtil;
      this.mapLayerConstant = MapLayerVisibility;

      this.leafletData = leafletData;
      this.authenticator = Authenticator;
      this.alertMessage = AlertMessage;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.cercaEletronicaMapService = CercaEletronicaMapService;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.cercaEletronicaService = CercaEletronicaService;
      this.pontosCategoriaReferenciaService = CategoriaPontosReferencia;
      this.pontosReferenciaFiltroService = PontosReferenciaFiltro;
      this.pontosProximosService = PontosProximos;
      this.buscaPorRegiaoMapService = BuscaPorRegiaoMapService;
      this.advisorRotogramasService = AdvisorRotogramasService;
      this.location = $location;
      this.isDemo = this.location.search().demo;
      this.advisorRotogramasService.isDemo = this.isDemo;
      this.user = null;

      this.hasRoleUpdateAdvisorSuggestion = false;
      this.suggestions = [];

      this.initPermissions();
      this.pontosReferenciaMenuService.idMapa = this.scope.idMapa;
      this.scope.$on('initPontoReferencia', function (e, mapa) {
        var historico = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        _this.pontosProximosService.init(historico);
        _this.init(mapa);
      });
      this.scope.$on('layerVisibilityHasChanged', function (e, entityType, shouldShow) {
        if (_this.mapLayerConstant.PONTO_REFERENCIA === entityType && _this.pontosReferenciaService.roleVisualizar) {
          _this.refreshPontosDeReferencia(shouldShow);
        }
        if (_this.mapLayerConstant.CERCA_ELETRONICA === entityType && _this.cercaEletronicaService.roleVisualizar) {
          _this.refreshCercasEletronicas(shouldShow);
        }
      });
      this.alertaZoomCercaEletronica = 'ce.mapa.common.mapControlDirective.alertaZoomCercaEletronica';
      this.alertaZoomPontoReferencia = 'ce.mapa.common.mapControlDirective.alertaZoomPontoReferencia';
      if (this.scope.onInit) {
        this.scope.onInit();
      }
    }

    _createClass(MapControlDirectiveCtrl, [{
      key: 'initPermissions',
      value: function initPermissions() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          _this2.user = user;
          _this2.pontosReferenciaService.roleCadastrar = user.permissoesSolucao.includes('PONTO_REFERENCIA_EDITAR');
          _this2.pontosReferenciaService.roleCadastrarRotograma = user.permissoesSolucao.includes('ROTOGRAMA_EDITAR');
          _this2.pontosReferenciaService.roleVisualizar = user.permissoesSolucao.includes('PONTO_REFERENCIA_VISUALIZAR');
          _this2.pontosReferenciaService.roleVisualizarRotograma = user.permissoesSolucao.includes('ROTOGRAMA_VISUALIZAR');
          _this2.cercaEletronicaService.roleCadastrar = user.permissoesSolucao.includes('CERCA_ELETRONICA_EDITAR');
          _this2.cercaEletronicaService.roleVisualizar = user.permissoesSolucao.includes('CERCA_ELETRONICA_VISUALIZAR');
          _this2.pontosReferenciaService.user = user.plain();
          _this2.hasRoleUpdateAdvisorSuggestion = user.permissoesSolucao.includes('ROTOGRAMA_EDITAR') && user.permissoesSolucao.includes('ADVISOR_ROTOGRAMA_EDITAR');
        });
      }
    }, {
      key: 'init',
      value: function init(mapa) {
        if (this.pontosReferenciaService.roleVisualizar) {
          this.pontosReferenciaMapService.setVariaveis();

          this.pontosReferenciaMapService.setMap(mapa);
          this.pontosReferenciaMenuService.setFABDefault();
          this.pontosReferenciaMenuService.tabelaPontosProximosClose();

          if (this.pontosReferenciaService.roleCadastrar) {
            this.pontosReferenciaMapService.iniciaEventos();
          }

          this.pontosReferenciaMapService.eventoGeral();
          if (this.shouldRenderMarkers(this.mapLayerConstant.PONTO_REFERENCIA)) {
            this.loadPontosDeReferencia();
          }
        }

        if (this.cercaEletronicaService.roleVisualizar) {
          this.cercaEletronicaMapService.setMap(mapa);
          this.pontosReferenciaMenuService.setFABDefault();
          this.pontosReferenciaMenuService.tabelaPontosProximosClose();

          if (this.cercaEletronicaService.roleCadastrar) {
            this.cercaEletronicaMapService.iniciaEventosEdicao();
          }
          this.cercaEletronicaMapService.iniciaEventosVisualizacao();

          if (this.shouldRenderMarkers(this.mapLayerConstant.CERCA_ELETRONICA)) {
            this.loadCercasEletronica();
          }
        }

        if (this.hasRoleUpdateAdvisorSuggestion) {
          this.loadRotogramaSuggestions();
        }

        this.buscaPorRegiaoMapService.setMap(mapa);
        if (this.isDemo) {
          this.onboarding.startOnboarding(this.idBuscaPorRegiao);
        }
      }
    }, {
      key: 'refreshPontosDeReferencia',
      value: function refreshPontosDeReferencia(shouldShow) {
        if (shouldShow) {
          this.loadPontosDeReferencia();
        } else {
          this.pontosReferenciaMapService.clearMarkers();
        }
      }
    }, {
      key: 'loadPontosDeReferencia',
      value: function loadPontosDeReferencia() {
        var _this3 = this;

        this.q.all([this.pontosReferenciaService.getListPontoReferencia(), this.pontosCategoriaReferenciaService.getListCategoriasPontoReferencia()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              pontoReferencia = _ref2[0],
              categorias = _ref2[1];

          return _this3.pontosReferenciaMapService.setPontosReferencia(pontoReferencia.data, categorias, _this3.scope.idPonto);
        }).catch(function () {
          _this3.alertMessage.create({
            type: 'error',
            message: _this3.translate.instant('ce.mapa.common.mapControlDirective.erroCarregarPontos'),
            appendTo: '.alerta-aqui-ponto'
          });
        });
      }
    }, {
      key: 'loadRotogramaSuggestions',
      value: function loadRotogramaSuggestions() {
        var _this4 = this;

        this.advisorRotogramasService.getMany().then(function (res) {
          _this4.suggestions = res.data;
          if (_this4.suggestions.length > 0) {
            _this4.loadRotogramaToast();
          }
        });
      }
    }, {
      key: 'loadRotogramaToast',
      value: function loadRotogramaToast() {
        var _this5 = this;

        this.authenticator.getUser().then(function (user) {
          var userUltimoAcesso = _this5.window.localStorage.getItem('toast-advisor');
          if (!userUltimoAcesso || userUltimoAcesso !== user.ultimoAcesso) {
            _this5.createToastElement();
          }
        });
      }
    }, {
      key: 'createToastElement',
      value: function createToastElement() {
        /* eslint-disable */
        if (!document.querySelector('vfwc-toast-arrow')) {
          var toastContainer = document.querySelector('#toast-advisor'),
              toastElement = document.createElement('vfwc-toast-arrow');
          /* eslint-enable */
          toastElement.text = this.translate.instant('ce.mapa.common.modal.toastAdvisor.msg', { x: this.suggestions.length });
          toastContainer.appendChild(toastElement);
          this.setOnCloseToastAdvisor(toastElement);
        }
      }
    }, {
      key: 'setOnCloseToastAdvisor',
      value: function setOnCloseToastAdvisor(toastElement) {
        var _this6 = this;

        toastElement.addEventListener('onClose', function (event) {
          if (event.detail && event.detail.toastClosed) {
            _this6.setToastAdvisorInLocalStorage();
          }
        });
      }
    }, {
      key: 'setToastAdvisorInLocalStorage',
      value: function setToastAdvisorInLocalStorage() {
        var _this7 = this;

        this.authenticator.getUser().then(function (user) {
          _this7.window.localStorage.setItem('toast-advisor', user.ultimoAcesso);
        });
      }
    }, {
      key: 'refreshCercasEletronicas',
      value: function refreshCercasEletronicas(shouldShow) {
        if (shouldShow) {
          this.loadCercasEletronica();
        } else {
          this.cercaEletronicaMapService.clearMarkers();
        }
      }
    }, {
      key: 'loadCercasEletronica',
      value: function loadCercasEletronica() {
        var _this8 = this;

        this.cercaEletronicaService.getListCercaEletronica().then(function (responseCercasEletronicas) {
          _this8.cercaEletronicaMapService.setCercasEletronicas(responseCercasEletronicas.data);
        }).catch(function () {
          _this8.alertMessage.create({
            type: 'error',
            message: _this8.translate.instant('ce.mapa.common.mapControlDirective.erroCarregarCercas'),
            appendTo: '.alerta-aqui-ponto'
          });
        });
      }
    }, {
      key: 'limparFiltro',
      value: function limparFiltro() {
        this.pontosReferenciaFiltroService.limparFiltro();
        this.pontosReferenciaMapService.recarregaPontos();
        this.cercaEletronicaMapService.mostrarCercasBoundsAtual();
      }
    }, {
      key: 'activeDrawerStyle',
      value: function activeDrawerStyle() {
        return this.pontosReferenciaMenuService.drawerBusca || this.pontosReferenciaMenuService.drawerAdvisor ? 'active' : '';
      }
    }, {
      key: 'shouldRenderMarkers',
      value: function shouldRenderMarkers(entity) {
        var preferences = this.mapasUtil.getLayersVisibilityLocalStorage(this.user.id);
        if (preferences) {
          return !preferences.some(function (l) {
            return l.name === entity && l.shouldShow === false;
          });
        }
        return true;
      }
    }]);

    return MapControlDirectiveCtrl;
  }();

  angular.module('mapControlModule').controller('MapControlDirectiveCtrl', MapControlDirectiveCtrl).directive('mapControl', mapControlDirective);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DatepickerCtrl = function DatepickerCtrl() {
    _classCallCheck(this, DatepickerCtrl);
  };

  angular.module('conducaoEconomica').component('datepicker', {
    controller: DatepickerCtrl,
    templateUrl: 'directives/datepicker/datepicker.tpl.html',
    bindings: {
      options: '=',
      model: '=',
      name: '@',
      disabled: '=',
      required: '<'
    }
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var CustomPopupCtrl = function () {
    function CustomPopupCtrl($window, GoogleTagManagerUtils, ServiceVfiltro, $translate) {
      _classCallCheck(this, CustomPopupCtrl);

      this.window = $window;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.routeDetailsCollapsed = false;
    }

    _createClass(CustomPopupCtrl, [{
      key: 'isValid',
      value: function isValid(row) {
        return row.type === 'route-progress' ? Boolean(row.routeProgress) : row.infos.some(function (item) {
          return item.value;
        });
      }
    }, {
      key: 'toggleRouteDetails',
      value: function toggleRouteDetails() {
        this.routeDetailsCollapsed = !this.routeDetailsCollapsed;
      }
    }, {
      key: 'getMobileSize',
      value: function getMobileSize(size) {
        return size > 6 ? 12 : 6;
      }
    }, {
      key: 'onClickTratarOcorrencia',
      value: function onClickTratarOcorrencia(ocorrenciaId) {
        this.sendClickGTM();
        this.setOcorrenciaIdInLocalStorage(ocorrenciaId);
      }
    }, {
      key: 'sendClickGTM',
      value: function sendClickGTM() {
        this.googleTagManagerUtils.sendEventClickGTM('localizacao_frota_ir_para_ocorrencias', this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'setOcorrenciaIdInLocalStorage',
      value: function setOcorrenciaIdInLocalStorage(ocorrenciaId) {
        this.window.localStorage.setItem('localizacao-frota-go-to-quadro-ocorrencias-ocorrenciaId', ocorrenciaId);
      }
    }, {
      key: 'onItemClick',
      value: function onItemClick(item) {
        if (item.onClick && item.onClick.type === 'openVehicleHealthEvidences') {
          this.openVehicleHealthEvidencesDialog(item.onClick);
        }
      }
    }, {
      key: 'openVehicleHealthEvidencesDialog',
      value: function openVehicleHealthEvidencesDialog(_ref) {
        var veiculoPosicao = _ref.veiculoPosicao,
            initialTab = _ref.initialTab,
            canDisplayLivestream = _ref.canDisplayLivestream;

        /* eslint-disable */
        var elementContainer = document.querySelector('#dialog-vehicle-health');
        var dialogOpener = document.createElement('vfwc-open-dialog-vehicle-health-evidences');
        /* eslint-enable */

        dialogOpener.usuario = this.serviceVfiltro.factoryVfiltro.user;
        dialogOpener.veiculo = veiculoPosicao;
        dialogOpener.hasLivestreamPermission = canDisplayLivestream;
        dialogOpener.initialTab = initialTab;

        elementContainer.appendChild(dialogOpener);
      }
    }, {
      key: 'getGpsText',
      value: function getGpsText() {
        return this.infos.lastValidGps ? this.translate.instant('ce.mapa.localizacaoDaFrota.ultimaValida', { date: this.infos.lastValidGps }) : this.translate.instant('ce.mapa.common.customPopup.localizacaoBaixaPrecisao');
      }
    }]);

    return CustomPopupCtrl;
  }();

  angular.module('v3gCustomPopupModule', ['enumModule', 'ServiceVfiltroModule']).component('customPopup', {
    controller: CustomPopupCtrl,
    templateUrl: 'directives/custom-popup/custom-popup.tpl.html',
    bindings: {
      infos: '='
    }
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('biReport', ['safetyModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('biReport').config(function ($stateProvider) {
    return $stateProvider.state('root.biReport', {
      url: '/bi-report?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/bi-report/bi-report.tpl.html',
          controller: 'BIReportCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.configuracao.biReport.title',
        tituloDescricao: '',
        role: 'ADMIN_VELTEC'
      }
    });
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BIReportCtrl = function () {
    function BIReportCtrl(Keys, ServiceVfiltro, FactoryVfiltro, Authenticator, safetyService) {
      var _this = this;

      _classCallCheck(this, BIReportCtrl);

      this.authenticator = Authenticator;
      this.serviceVfiltro = ServiceVfiltro;
      this.safetyService = safetyService;

      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: Keys.uo.name
      }])).then(function (filtro) {
        _this.vfiltroBackend = _this.serviceVfiltro.getFiltroBackendNovo(filtro);

        _this.safetyService.initialize().then(function () {
          return _this.loadSafety();
        });
      });
    }

    _createClass(BIReportCtrl, [{
      key: 'loadSafety',
      value: function loadSafety() {
        var _this2 = this;

        this.authenticator.getUser().then(function (user) {
          var appName = 'safetyApp',
              componentPath = './BIReport',
              componentId = 'safety-bi-report',
              props = {
            user: user,
            uoId: _this2.vfiltroBackend.uo_permissao
          };

          _this2.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        });
      }
    }]);

    return BIReportCtrl;
  }();

  angular.module('biReport').controller('BIReportCtrl', BIReportCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('vehicleSettings', ['ui.router', 'FeatureFlagModule', 'pascalprecht.translate', 'ServiceVfiltroModule', 'ObjetosVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'UrlModule', 'safetyModule', 'modalInfoConfirmModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('vehicleSettings').config(function ($stateProvider) {
    return $stateProvider.state('root.vehicleSettings', {
      url: '/vehicle-settings?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/vehicle-settings/vehicle-settings.tpl.html',
          controller: 'VehicleSettingsCtrl'
        }
      },
      data: {
        titulo: 'ce.configuracao.vehicleSettings.title',
        tituloDescricao: '',
        roles: [['VEHICLE_SETTINGS_VIEW']],
        hideTitulo: true
      }
    }).state('root.vehicleSettingsProfile', {
      url: '/vehicle-settings/profile/:profileId?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/vehicle-settings/vehicle-settings-profile.tpl.html',
          controller: 'VehicleSettingsProfileCtrl'
        }
      },
      data: {
        titulo: 'ce.configuracao.vehicleSettings.title',
        tituloDescricao: '',
        roles: [['VEHICLE_SETTINGS_VIEW']],
        hideTitulo: true
      }
    });
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-var */
(function () {
  'use strict';

  var UNSAVED_MODAL_PREFIX = 'ce.configuracao.vehicleSettings.unsavedChangesModal';

  var VehicleSettingsProfileCtrl = function () {
    function VehicleSettingsProfileCtrl($scope, $rootScope, $location, $window, $safetyService, Authenticator, Keys, ServiceVfiltro, FactoryVfiltro, $state, $stateParams, ModalInfoConfirmService, $translate) {
      var _this = this;

      _classCallCheck(this, VehicleSettingsProfileCtrl);

      this.scope = $scope;
      this.rootScope = $rootScope;
      this.location = $location;
      this.window = $window;
      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.state = $state;
      this.stateParams = $stateParams;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.translate = $translate;
      this.user = {};
      this.isDirty = false;
      this.allowLeave = false;

      this.registerUnsavedChangesGuard();

      this.authenticator.getUser().then(function (user) {
        _this.user = user;

        ServiceVfiltro.init(FactoryVfiltro.get([{
          key: _this.keys.uo.name
        }])).then(function (filtro) {
          _this.filtro = filtro;
          _this.initializePage(_this.serviceVfiltro.getFiltroBackendNovo(_this.filtro));
        });
      });
    }

    // The React editor holds an unsaved draft in its own store and reports its dirty state through the
    // onDirtyChange prop. We must guard on BOTH ui-router events because, under ui-router 0.2.x, they cover
    // different navigation triggers:
    //   - $stateChangeStart fires before a $state.go / ui-sref transition (menu links) — the only point at which
    //     we can stop it, because the state transitions before the URL updates.
    //   - $locationChangeStart fires before the URL commits on a browser/mouse back button — $stateChangeStart is
    //     too late there because the URL has already changed.
    // Preventing one stops the other from firing for the same navigation, so there is no double prompt.
    // Navigations the editor itself triggers (onBack) are pre-authorized via allowLeave.


    _createClass(VehicleSettingsProfileCtrl, [{
      key: 'registerUnsavedChangesGuard',
      value: function registerUnsavedChangesGuard() {
        var _this2 = this;

        var unregisterState = this.rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
          if (!_this2.shouldGuard() || _this2.isSameProfile(toState, toParams, fromState, fromParams)) {
            return;
          }
          event.preventDefault();
          _this2.confirmUnsavedChanges(function () {
            return _this2.state.go(toState.name, toParams);
          });
        });

        var unregisterLocation = this.rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
          if (!_this2.shouldGuard() || _this2.isSamePath(newUrl, oldUrl)) {
            return;
          }
          event.preventDefault();
          _this2.confirmUnsavedChanges(function () {
            var target = new _this2.window.URL(newUrl);
            _this2.location.url(target.pathname + target.search + target.hash);
          });
        });

        this.scope.$on('$destroy', function () {
          unregisterState();
          unregisterLocation();
        });
      }
    }, {
      key: 'shouldGuard',
      value: function shouldGuard() {
        return this.isDirty && !this.allowLeave;
      }
    }, {
      key: 'isSameProfile',
      value: function isSameProfile(toState, toParams, fromState, fromParams) {
        return Boolean(fromState) && toState.name === fromState.name && Boolean(toParams) && Boolean(fromParams) && toParams.profileId === fromParams.profileId;
      }
    }, {
      key: 'isSamePath',
      value: function isSamePath(newUrl, oldUrl) {
        try {
          return new this.window.URL(newUrl).pathname === new this.window.URL(oldUrl).pathname;
        } catch (e) {
          return false;
        }
      }
    }, {
      key: 'openUnsavedConfirm',
      value: function openUnsavedConfirm() {
        return this.modalInfoConfirmService.confirmModal({
          title: this.translate.instant(UNSAVED_MODAL_PREFIX + '.title'),
          conteudo: this.translate.instant(UNSAVED_MODAL_PREFIX + '.description'),
          btnPrimario: this.translate.instant(UNSAVED_MODAL_PREFIX + '.discardLabel'),
          btnSecundario: this.translate.instant(UNSAVED_MODAL_PREFIX + '.deployFirstLabel'),
          headerColor: 'vehicle-settings-unsaved-header',
          typeButton: 'btn-danger'
        });
      }
    }, {
      key: 'confirmUnsavedChanges',
      value: function confirmUnsavedChanges(onDiscard) {
        var _this3 = this;

        this.openUnsavedConfirm().then(function () {
          _this3.isDirty = false;
          _this3.allowLeave = true;
          onDiscard();
        }).catch(function () {});
      }
    }, {
      key: 'initializePage',
      value: function initializePage(filter) {
        var _this4 = this;

        this.safetyService.initialize().then(function () {
          return _this4.loadPage(filter);
        });
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter) {
        var _this5 = this;

        var appName = 'safetyApp',
            componentPath = './VehicleSettingsProfileEditor',
            componentId = 'safety-app-vehicle-settings-profile',
            props = {
          user: this.user,
          uoId: filter.uo_permissao,
          profileId: this.stateParams.profileId,
          onBack: function onBack() {
            _this5.allowLeave = true;
            _this5.state.go('root.vehicleSettings');
          },
          onDirtyChange: function onDirtyChange(isDirty) {
            _this5.isDirty = isDirty;
          }
        };
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }]);

    return VehicleSettingsProfileCtrl;
  }();

  VehicleSettingsProfileCtrl.$inject = ['$scope', '$rootScope', '$location', '$window', 'safetyService', 'Authenticator', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$state', '$stateParams', 'ModalInfoConfirmService', '$translate'];
  angular.module('vehicleSettings').controller('VehicleSettingsProfileCtrl', VehicleSettingsProfileCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-var */
(function () {
  'use strict';

  var VehicleSettingsCtrl = function () {
    function VehicleSettingsCtrl($safetyService, Authenticator, FeaturehubJsSdk, FeatureHubConfigKeys, Keys, ServiceVfiltro, FactoryVfiltro, $state) {
      var _this = this;

      _classCallCheck(this, VehicleSettingsCtrl);

      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.state = $state;
      this.user = {};
      this.isFeatureFlagVehicleSettingsPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VEHICLE_SETTINGS_PAGE);

      this.authenticator.getUser().then(function (user) {
        _this.user = user;

        ServiceVfiltro.init(FactoryVfiltro.get([{
          key: _this.keys.uo.name
        }])).then(function (filtro) {
          _this.filtro = filtro;
          _this.initializePage(_this.serviceVfiltro.getFiltroBackendNovo(_this.filtro));
        });
      });
    }

    _createClass(VehicleSettingsCtrl, [{
      key: 'initializePage',
      value: function initializePage(filter) {
        var _this2 = this;

        this.safetyService.initialize().then(function () {
          return _this2.loadPage(filter);
        });
      }
    }, {
      key: 'goToProfile',
      value: function goToProfile(profileId) {
        this.state.go('root.vehicleSettingsProfile', { profileId: profileId });
      }
    }, {
      key: 'loadPage',
      value: function loadPage(filter) {
        var _this3 = this;

        var appName = 'safetyApp',
            componentPath = './VehicleSettingsPage',
            componentId = 'safety-app-vehicle-settings',
            props = {
          user: this.user,
          filter: filter,
          goToProfile: function goToProfile(profileId) {
            return _this3.goToProfile(profileId);
          }
        };

        if (this.isFeatureFlagVehicleSettingsPageEnabled) {
          this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        }
      }
    }]);

    return VehicleSettingsCtrl;
  }();

  VehicleSettingsCtrl.$inject = ['safetyService', 'Authenticator', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$state'];
  angular.module('vehicleSettings').controller('VehicleSettingsCtrl', VehicleSettingsCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('configVdrivers', ['SubpaginasVdrivers', 'ModalVdrivers', 'ui.router']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfigVdriversService = function () {
    function ConfigVdriversService($q, $uibModal, Restangular, AlertMessage) {
      _classCallCheck(this, ConfigVdriversService);

      this.q = $q;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;

      this.umMinutoEmSegundos = 60;
      this.uoId = 0;
      this.tipo = '';
      this.roleCadastrar = true;
      this.tipoSubpagina = {
        VIGENCIA: 'vigencia',
        SAFEDRIVE: 'safedrive',
        APLICATIVO: 'aplicativo',
        CHECKLIST: 'checklist'
      };
      this.model = {
        configuracoes: [],
        configuracoesBackup: [],
        checklist: [],
        checklistBackup: [],
        checklistAtivos: [],
        checklistInativos: [],
        textChecklist: ''
      };
      this.mapLabel = {
        aplicativo: {
          manterTelaAtiva: {
            titulo: 'Manter tela ativa',
            valueDefault: true
          },
          evitarFechamentoApp: {
            titulo: 'Evitar fechamento do aplicativo',
            valueDefault: true
          }
        },
        vigencia: {
          habilitarVigencia: {
            titulo: 'Habilitar <strong>uso</strong> de Vigência',
            valueDefault: true
          },
          fecharVigenciaPorIgnicaoOff: {
            titulo: 'Habilitar <strong>fechamento</strong> Automático de Vigência por ignição <i>off</i>',
            valueDefault: true
          },
          habilitarVigenciaAutomatica: {
            titulo: 'Habilitar <strong>identificação</strong> Automática da Vigência',
            valueDefault: true
          },
          tempoVerificacao: {
            titulo: 'Tempo de verificação para identificação de veículos',
            mask: 'min',
            valueDefault: 120
          },
          velocidadeMinima: {
            titulo: 'Velocidade mínima',
            subtitulo: 'Para iniciar monitoramento do motorista',
            mask: 'km/h',
            valueDefault: 15
          },
          distanciaMinima: {
            titulo: 'Distância máxima',
            subtitulo: 'Medida usada para iniciar uma vigência',
            mask: 'm',
            valueDefault: 150
          },
          tempoMaximoIgnicao: {
            titulo: 'Limite de tempo para considerar Início de Vigência via ignição',
            mask: 'min',
            valueDefault: 7200
          },
          tempoVeiculoParado: {
            titulo: 'Limite de tempo parado para cancelar monitoramento',
            mask: 'min',
            valueDefault: 900
          },
          tempoMaximoEntreVigencias: {
            titulo: 'Tempo para unificar vigência',
            mask: 'min',
            valueDefault: 900
          }
        },
        safedrive: {
          habilitarResumo: {
            titulo: 'Habilitar <i>Dashboard SafeDrive</i>',
            valueDefault: true
          },
          atualizarEventosVigencia: {
            titulo: 'Tempo de atualização de Eventos para <i>Dashboard SafeDrive</i>',
            mask: 'min',
            valueDefault: 120
          }
        },
        checklist: {
          habilitarChecklist: {
            titulo: 'Habilitar checklist do veículo',
            valueDefault: true
          }
        }
      };
    }

    _createClass(ConfigVdriversService, [{
      key: 'getTipo',
      value: function getTipo(tipo) {
        switch (tipo) {
          case this.tipoSubpagina.VIGENCIA:
            return this.tipoSubpagina.VIGENCIA;
          case this.tipoSubpagina.SAFEDRIVE:
            return this.tipoSubpagina.SAFEDRIVE;
          case this.tipoSubpagina.CHECKLIST:
            return this.tipoSubpagina.CHECKLIST;
          default:
            return this.tipoSubpagina.APLICATIVO;
        }
      }
    }, {
      key: 'carregarConfigUo',
      value: function carregarConfigUo(uoId, tipo) {
        var _this = this;

        this.uoId = uoId;
        this.tipo = tipo;
        this.model = {
          configuracoes: [],
          configuracoesBackup: [],
          checklist: [],
          checklistBackup: [],
          checklistAtivos: [],
          checklistInativos: [],
          textChecklist: ''
        };

        var getters = [this.restangular.one('/mobile/config/uo/' + uoId + '/vdrivers').get()];

        if (this.tipo === this.tipoSubpagina.CHECKLIST) {
          var fields = ['item.id', 'item.nome', 'item.uoId', 'item.status'];
          getters.push(this.restangular.one('/veiculo/checklist/ativo/' + uoId + '?fields=' + fields.toString()).get());
        }

        this.q.all(getters).then(function (data) {
          return _this.preecheVariaveis(data);
        }).catch(function () {
          _this.alertMessage.create({
            type: 'error',
            message: 'Ocorreu um erro ao carregar as configurações',
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'preecheVariaveis',
      value: function preecheVariaveis(data) {
        var _this2 = this;

        var configVdrivers = data[0],
            configChecklist = data[1];

        this.model.id = configVdrivers.id;
        this.model.uoId = configVdrivers.uoId;
        this.vdriverConfig = angular.copy(configVdrivers.vdriverConfig);
        this.model.configuracoes = this.buildConfig(configVdrivers.vdriverConfig, this.mapLabel[this.tipo]);
        this.model.configuracoesBackup = angular.copy(this.model.configuracoes);

        if (configChecklist) {
          this.model.checklist = configChecklist.itens;
          this.model.checklistBackup = angular.copy(configChecklist.itens);
          this.model.checklist.forEach(function (item) {
            return item.status ? _this2.model.checklistAtivos.push(item) : _this2.model.checklistInativos.push(item);
          });
        }
      }
    }, {
      key: 'buildConfig',
      value: function buildConfig(config, configDefault) {
        var _this3 = this;

        Object.keys(config).forEach(function (tipo) {
          if (configDefault[tipo]) {
            var value = config[tipo];
            if (configDefault[tipo].mask === 'min') {
              value /= _this3.umMinutoEmSegundos;
            }
            configDefault[tipo].value = value;
          }
        });
        return configDefault;
      }
    }, {
      key: 'salvar',
      value: function salvar(form) {
        var _this4 = this;

        Object.keys(this.vdriverConfig).forEach(function (item) {
          if (_this4.model.configuracoes[item]) {
            var value = _this4.model.configuracoes[item].value;
            if (_this4.model.configuracoes[item].mask === 'min') {
              value *= _this4.umMinutoEmSegundos;
            }
            _this4.vdriverConfig[item] = value;
          }
        });

        var config = {
          id: this.model.id,
          uoId: this.uoId,
          vdriverConfig: this.vdriverConfig
        },
            checklist = this.model.checklistAtivos.map(function (item) {
          return {
            id: item.id || null,
            uoId: _this4.uoId,
            nome: item.nome,
            status: item.status
          };
        });

        var setters = [this.restangular.all('/mobile/config/vdrivers')[this.model.uoId === 1 ? 'post' : 'customPUT'](config)];

        if (this.model.configuracoes.habilitarChecklist && this.model.configuracoes.habilitarChecklist.value && this.tipo === this.tipoSubpagina.CHECKLIST) {
          setters.push(this.restangular.all('/veiculo/checklist').post(checklist));
        }

        this.q.all(setters).then(function (data) {
          _this4.model.configuracoesBackup = angular.copy(_this4.model.configuracoes);

          if (data[1]) {
            _this4.model.checklistAtivos = data[1].map(function (item) {
              return angular.extend(item, { status: true });
            });
            _this4.model.checklistBackup = angular.copy(_this4.model.checklistAtivos.concat(_this4.model.checklistInativos));
          }

          if (form) {
            form.$setPristine();
          }
          _this4.alertMessage.create({
            type: 'success',
            message: 'Salvo com sucesso',
            appendTo: '.alerta-aqui'
          });
        }).catch(function () {
          _this4.alertMessage.create({
            type: 'error',
            message: 'Ocorreu um erro ao salvar as configurações',
            appendTo: '.alerta-aqui'
          });
        });

        this.model.uoId = this.uoId;
      }
    }, {
      key: 'resetarValores',
      value: function resetarValores() {
        var _this5 = this;

        Object.keys(this.model.configuracoes).forEach(function (item) {
          var value = _this5.model.configuracoes[item].valueDefault;
          if (_this5.model.configuracoes[item].mask === 'min') {
            value /= _this5.umMinutoEmSegundos;
          }
          _this5.model.configuracoes[item].value = value;
        });
        this.salvar();
      }
    }, {
      key: 'descartarAlteracoes',
      value: function descartarAlteracoes() {
        var _this6 = this;

        this.model.configuracoes = angular.copy(this.model.configuracoesBackup);
        this.model.checklist = angular.copy(this.model.checklistBackup);
        this.model.checklistAtivos = [];
        this.model.checklistInativos = [];
        this.model.checklist.forEach(function (item) {
          return item.status ? _this6.model.checklistAtivos.push(item) : _this6.model.checklistInativos.push(item);
        });
      }
    }, {
      key: 'abrirModal',
      value: function abrirModal() {
        var _this7 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'configuracoes/vdrivers/modal/reset/reset-vdrivers.tpl.html',
          controller: 'ModalResetVdriversCtrl',
          controllerAs: '$ctrl'
        }).result.then(function () {
          _this7.resetarValores();
        });
      }
    }, {
      key: 'changeStatus',
      value: function changeStatus(i, tipo) {
        if (i.status !== tipo) {
          if (tipo) {
            this.model.checklistInativos.push(i);
            this.model.checklistAtivos = this.model.checklistAtivos.filter(function (x) {
              return x !== i;
            });
          } else {
            this.model.checklistAtivos.push(i);
            this.model.checklistInativos = this.model.checklistInativos.filter(function (x) {
              return x !== i;
            });
          }
        }
      }
    }, {
      key: 'inserirChecklist',
      value: function inserirChecklist() {
        var _this8 = this;

        if (this.model.textChecklist && !this.model.checklist.find(function (item) {
          return item.nome && item.nome.toLowerCase() === _this8.model.textChecklist.toLowerCase();
        })) {
          var item = {
            id: null,
            nome: this.model.textChecklist,
            uoId: this.uoId,
            status: true
          };
          this.model.checklist.push(item);
          this.model.checklistAtivos.push(item);
          this.model.textChecklist = '';
        } else {
          this.erroForm = true;
        }
      }
    }, {
      key: 'removeItem',
      value: function removeItem(item) {
        this.model.checklist = this.model.checklist.filter(function (x) {
          return x !== item;
        });
        this.model.checklistAtivos = this.model.checklistAtivos.filter(function (x) {
          return x !== item;
        });
      }
    }, {
      key: 'invalidChecklist',
      value: function invalidChecklist() {
        return this.model.configuracoes.habilitarChecklist && this.model.configuracoes.habilitarChecklist.value && (this.model.checklistAtivos.length === 0 || !!this.model.checklistAtivos.find(function (item) {
          return !item.nome;
        }));
      }
    }, {
      key: 'validateChecklistInput',
      value: function validateChecklistInput(item, nome) {
        if (!item) {
          return 'Esse campo não pode ser vazio.';
        } else if (item !== nome && this.model.checklistAtivos.find(function (i) {
          return i.nome.toLowerCase() === item.toLowerCase();
        })) {
          return 'Esse item já está cadastrado.';
        } else if (item.length > 80) {
          return 'São permitidos até 80 caracteres.';
        }
        return true;
      }
    }]);

    return ConfigVdriversService;
  }();

  angular.module('configVdrivers').service('ConfigVdriversService', ConfigVdriversService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('configVdrivers').config(function ($stateProvider) {
    return $stateProvider.state('root.configVdrivers', {
      url: '/configuracoes-vdrivers/:tipoSubpagina?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/vdrivers/configuracoes-vdrivers.tpl.html',
          controller: 'ConfigVdriversCtrl',
          controllerAs: 'configVdriversCtrl'
        }
      },
      data: {
        titulo: 'Configurações do Vdrivers',
        tituloDescricao: '',
        role: 'CONFIG_VDRIVERS_VISUALIZAR'
      }
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfigVdriversCtrl = function ConfigVdriversCtrl($stateParams, ConfigVdriversService, Keys, ServiceVfiltro, FactoryVfiltro) {
    var _this = this;

    _classCallCheck(this, ConfigVdriversCtrl);

    this.service = ConfigVdriversService;

    this.tipo = this.service.getTipo($stateParams.tipoSubpagina && $stateParams.tipoSubpagina.toLowerCase());

    ServiceVfiltro.init(FactoryVfiltro.get([{
      key: Keys.uo.name
    }])).then(function (filtro) {
      _this.service.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_VDRIVERS_EDITAR');
      var uoId = filtro.find(function (x) {
        return x.key === Keys.uo.name;
      }).value.id;
      _this.service.carregarConfigUo(uoId, _this.tipo);
    });
  };

  angular.module('configVdrivers').controller('ConfigVdriversCtrl', ConfigVdriversCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('configEventos', ['ui.router', 'ModuleMapasUtil', 'ModalEventos', 'SubpaginasEventos', 'enumModule', 'v3gAuthenticatorModule', 'SolucoesModule', 'FeatureFlagModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('configEventos').config(function ($stateProvider) {
    return $stateProvider.state('root.configEventos', {
      url: '/configuracoes-eventos/:tipoSubpagina?vfiltro=&hideTitle=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/eventos/configuracoes-eventos.tpl.html',
          controller: 'ConfigEventosCtrl',
          controllerAs: 'configEventosCtrl'
        }
      },
      data: {
        titulo: 'ce.configuracao.eventos.titulo',
        tituloDescricao: '',
        role: ['CONFIGURACAO_ALERTA_VISUALIZAR', 'CONFIG_OCORRENCIA_VISUALIZAR', 'CONFIG_PESO_EVENTO_VISUALIZAR', 'CONFIG_DESCARTE_VISUALIZAR', 'ONE_PAGE_VISUALIZAR', 'CONFIG_SAUDE_DO_EQUIPAMENTO_VISUALIZAR']
      }
    });
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/log */
(function () {
  'use strict';

  var ConfigEventosCtrl = function () {
    function ConfigEventosCtrl($stateParams, Authenticator, SolucoesEnum, FeatureFlag, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, tmhDynamicLocale) {
      _classCallCheck(this, ConfigEventosCtrl);

      this.authenticator = Authenticator;
      this.solucoesEnum = SolucoesEnum;
      this.hasPermissionOcorrenciaSolucao = false;
      this.hasPermissaoConfigPesoEventosSolucao = false;
      this.hasPermissaoConfigDescarteEventosSolucao = false;
      this.hasPermissaoConfigTurno = false;
      this.hasPermissionConfigAlerta = false;
      this.FeatureOuService = FeatureOuService;
      this.shouldDisplayWorkShift = false;
      this.tmhDynamicLocale = tmhDynamicLocale;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.tipoSubpagina = {
        TIPOS: 'tipos',
        TURNOS: 'turnos',
        OCORRENCIAS: 'ocorrencias',
        PESOS: 'pesos',
        DESCARTE: 'descarte',
        DEVICE_HEALTH_CONFIGURATION: 'device-health-configuration',
        DRIVER_PRIVACY: 'driver-privacy',
        USO_INDEVIDO_VEICULO: 'uso-indevido-veiculo'
      };
      this.idiomaMap = {
        'EN_US': 'en-us',
        'PT_BR': 'pt-br',
        'ES_ES': 'es-es',
        'EN_GB': 'en-gb',
        'DE_DE': 'de-de',
        'FR_FR': 'fr-fr',
        'IT_IT': 'it-it',
        'NL_NL': 'nl-nl',
        'PL_PL': 'pl-pl'
      };
      this.isLoading = true;
      this.featureFlag = FeatureFlag;
      this.flagEnableDeviceHealthConfiguration = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS);
      this.flagEnableDriverPrivacy = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_DRIVER_PRIVACY);
      this.flagEnableUsoIndevidoVeiculo = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.CONFIG_ALERTA_USO_INDEVIDO_VEICULO);
      this.tipo = this.getTipo($stateParams.tipoSubpagina && $stateParams.tipoSubpagina.toLowerCase());
      this.hideTitle = $stateParams.hideTitle;
      this.setUserParams();
    }

    _createClass(ConfigEventosCtrl, [{
      key: 'setUserParams',
      value: function setUserParams() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          _this.hasPermissionConfigAlerta = user.permissoesSolucao.includes('CONFIGURACAO_ALERTA_VISUALIZAR');
          _this.hasPermissionOcorrencia = user.permissoesSolucao.includes('CONFIG_OCORRENCIA_VISUALIZAR');
          _this.hasPermissionOcorrenciaSolucao = user.permissoesSolucao.indexOf('CONFIG_OCORRENCIA_VISUALIZAR') !== -1;
          _this.hasPermissaoConfigPesoEventosSolucao = user.permissoesSolucao.indexOf('CONFIG_PESO_EVENTO_VISUALIZAR') !== -1;
          _this.hasPermissaoConfigDescarteEventosSolucao = user.permissoesSolucao.indexOf('CONFIG_DESCARTE_VISUALIZAR') !== -1;
          _this.hasPermissaoConfigTurno = user.permissoesSolucao.includes('ONE_PAGE_VISUALIZAR') || user.permissoesSolucao.includes('CONFIG_OCORRENCIA_VISUALIZAR');
          _this.hasPermissaoConfigDeviceHealthConfiguration = user.permissoesSolucao.includes('CONFIG_SAUDE_DO_EQUIPAMENTO_VISUALIZAR') && _this.flagEnableDeviceHealthConfiguration;
          _this.hasPermissaoDriverPrivacy = _this.flagEnableDriverPrivacy && user.isNa === true;
          _this.hasPermissaoConfigAlertaUsoIndevidoVeiculo = _this.flagEnableUsoIndevidoVeiculo && _this.hasPermissionConfigAlerta;
          var locale = _this.idiomaMap[user.idioma] || 'pt-br';
          _this.tmhDynamicLocale.set(locale);
          _this.getEventsConfig(user.uo.id).finally(function () {
            _this.isLoading = false;
          });
        });
      }
    }, {
      key: 'getTipo',
      value: function getTipo(tipo) {
        switch (tipo) {
          case this.tipoSubpagina.TURNOS:
            return this.tipoSubpagina.TURNOS;
          case this.tipoSubpagina.PESOS:
            return this.tipoSubpagina.PESOS;
          case this.tipoSubpagina.OCORRENCIAS:
            return this.tipoSubpagina.OCORRENCIAS;
          case this.tipoSubpagina.DESCARTE:
            return this.tipoSubpagina.DESCARTE;
          case this.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION:
            return this.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION;
          case this.tipoSubpagina.DRIVER_PRIVACY:
            return this.tipoSubpagina.DRIVER_PRIVACY;
          case this.tipoSubpagina.USO_INDEVIDO_VEICULO:
            return this.tipoSubpagina.USO_INDEVIDO_VEICULO;
          default:
            return this.tipoSubpagina.TIPOS;
        }
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(userUoId) {
        var _this2 = this;

        return this.FeatureOuService.getEventsConfig(userUoId).then(function (eventNaConfig) {
          _this2.shouldDisplayWorkShift = eventNaConfig;
        }).catch(function (error) {
          console.error('Error loading featureOu config: ', error);
        });
      }
    }]);

    return ConfigEventosCtrl;
  }();

  angular.module('configEventos').controller('ConfigEventosCtrl', ConfigEventosCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.configNotificacao', {
      url: '/configuracao-notificacao?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'configuracoes/config-notificacao/config-notificacao.tpl.html',
          controller: 'ConfigNotificacaoCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.configuracao.eventos.itensConfiguraveis.ocorrencias.btnGerenciarNotificacoes.descricao',
        role: 'CONFIG_OCORRENCIA_VISUALIZAR'
      }
    });
  }

  angular.module('configEventos').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var ConfigNotificacaoCtrl = function () {
    function ConfigNotificacaoCtrl($state, Authenticator, FactoryVfiltro, Keys, ServiceVfiltro, FeatureFlag) {
      var _this = this;

      _classCallCheck(this, ConfigNotificacaoCtrl);

      this.authenticator = Authenticator;
      this.state = $state;
      this.keys = Keys;
      this.configNotificacaoElement = null;
      this.serviceVfiltro = ServiceVfiltro;
      this.featureFlag = FeatureFlag;

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (filtro) {
        if (_this.featureFlag.CONFIG_NOTIFICACAO_OCORRENCIA) {
          _this.uoId = filtro.find(function (x) {
            return x.key === _this.keys.uo.name;
          }).value.id;
          _this.init();
        }
      });
    }

    _createClass(ConfigNotificacaoCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        /*eslint-disable */
        var configNotificacaoContainer = document.querySelector('#container-notificacao');

        this.authenticator.getUser().then(function (user) {
          _this2.user = user;
          _this2.user.uoId = user.uo.id;
          var configNotificacaoElement = document.createElement('vfwc-config-notificacao');
          configNotificacaoElement.usuario = _this2.user;
          configNotificacaoElement.uoId = _this2.uoId;
          configNotificacaoContainer.appendChild(configNotificacaoElement);

          configNotificacaoElement.addEventListener('voltar', function () {
            _this2.state.go('root.configEventos', { tipoSubpagina: 'ocorrencias' });
          });
        });
      }
    }]);

    return ConfigNotificacaoCtrl;
  }();

  angular.module('configEventos').controller('ConfigNotificacaoCtrl', ConfigNotificacaoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var fields = ['id', 'placa', 'prefixo', 'uo.nome', 'uo.id', 'grupo.nome', 'tipo', 'modelo', 'marca', 'ano', 'hodometro', 'status', 'timezone', 'chassi', 'horimetro', 'tipoPermissao', 'intervaloManutencao', 'margemAlertaManutencao', 'hodometroProximoAlertaManutencao', 'intervaloManutencaoHorimetro', 'margemAlertaManutencaoHorimetro', 'horimetroProximoAlertaManutencao', 'situacaoVeiculo.id', 'situacaoVeiculo.nome', 'dataRetorno', 'vigenciaProgramada', 'ultimoSyncTtc', 'ultimoSyncVfleets', 'tipoVeiculo.id', 'tipoVeiculo.nome', 'tipoVeiculo.nameEn', 'tipoVeiculo.nameEs', 'tipoVeiculo.nameDe', 'tipoVeiculo.nameFr', 'tipoVeiculo.nameIt', 'tipoVeiculo.nameNl', 'tipoVeiculo.namePl', 'ultimoSyncVfleets', 'province.id', 'province.name', 'color', 'fuelType', 'modulo.id_fornecedor', 'modulo.computador_bordo_id', 'modulo.device_model_id', 'modulo2.id_fornecedor', 'modulo2.computador_bordo_id', 'modulo2.device_model_id', 'modulo3.id_fornecedor', 'modulo3.computador_bordo_id', 'modulo3.device_model_id'],
      BUNDLE_FIELDS = ['modulo.id', 'modulo2.id', 'solucao.id'],
      VEICULO_URL = 'veiculo/v2/veiculos';

  var CadastroVeiculoService = function () {
    function CadastroVeiculoService(Restangular, EQUIPAMENTO) {
      _classCallCheck(this, CadastroVeiculoService);

      this.restangular = Restangular;
      this.equipamentosSensorAcionado = [EQUIPAMENTO.ACIONAMENTO_ELETRONICO, EQUIPAMENTO.ACIONAMENTO_PNEUMATICO, EQUIPAMENTO.SENSOR_HIDRAULICO, EQUIPAMENTO.SENSOR_HIDRAULICO_HR36, EQUIPAMENTO.SENSOR_HIDRAULICO_PV, EQUIPAMENTO.SENSOR_HIDRAULICO_PV_NEO, EQUIPAMENTO.SENSOR_HIDRAULICO_HR48, EQUIPAMENTO.SENSOR_HIDRAULICO_HR24, EQUIPAMENTO.SENSOR_HIDRAULICO_EPP36, EQUIPAMENTO.SENSOR_HIDRAULICO_PNEUMATICO_PARA_VIDEO];
    }

    _createClass(CadastroVeiculoService, [{
      key: 'getByUo',
      value: function getByUo(uoId, uoDonaId, veiculoId, status) {
        var params = {
          uoPermissao: uoId,
          uoId: uoDonaId,
          veiculoId: veiculoId,
          size: 100000,
          fields: fields
        };

        if (status) {
          params.status = status;
        }

        return this.restangular.one(VEICULO_URL).get(params);
      }
    }, {
      key: 'hasRecFacial',
      value: function hasRecFacial(uoId, solucaoId) {
        var params = {
          uoWithRecFacial: true,
          uoPermissao: uoId,
          size: 1
        };
        if (solucaoId) {
          params.solucaoId = solucaoId;
        }
        return this.restangular.one(VEICULO_URL).get(params).then(function (responseVeiculos) {
          return Boolean(responseVeiculos.numberOfElements);
        });
      }
    }, {
      key: 'hasSensor',
      value: function hasSensor(uoId) {
        return this.restangular.one(VEICULO_URL).get({
          uoPermissao: uoId,
          equipamento: this.equipamentosSensorAcionado,
          size: 1
        }).then(function (responseVeiculos) {
          return Boolean(responseVeiculos.numberOfElements);
        });
      }
    }, {
      key: 'hasBundle',
      value: function hasBundle(uoId, bundles, premiumTelemetry) {
        return this.restangular.one(VEICULO_URL).get({
          fields: BUNDLE_FIELDS,
          uoPermissao: uoId,
          bundles: bundles,
          premiumTelemetry: premiumTelemetry,
          size: 1
        }).then(function (responseVeiculos) {
          return Boolean(responseVeiculos.numberOfElements);
        });
      }
    }, {
      key: 'getQrCode',
      value: function getQrCode(params) {
        return this.restangular.all(VEICULO_URL + '/qrcode').post(params);
      }
    }]);

    return CadastroVeiculoService;
  }();

  angular.module('cadastros.veiculo').service('CadastroVeiculoService', CadastroVeiculoService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.veiculo').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.veiculo', {
      url: '/veiculo?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'cadastros/veiculo/veiculo.tpl.html',
          controller: 'VeiculoCtrl',
          controllerAs: 'veiculoCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.veiculos.titulo',
        tituloDescricao: '',
        role: 'VEICULO_VISUALIZAR'
      }
    }).state('root.veiculo.qrcode', {
      url: '/qrcode',
      views: {
        'content@': {
          templateUrl: 'cadastros/veiculo/qrcode/qrcode-veiculo.tpl.html',
          controller: 'QrcodeVeiculoCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'QR Code Veículo',
        tituloDescricao: '',
        role: 'VEICULO_EDITAR'
      }
    });
  }
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var HORA_EM_SEGUNDOS = 3600,
      KM_EM_METROS = 1000,
      STATUS_TODOS = 'TODOS',
      DEVICE_MODEL_BY_ON_BOARD_COMPUTER = {
    8: 'M1',
    11: 'M1',
    12: 'M1',
    13: 'M1N',
    15: 'C6 Lite',
    17: 'Dashcam',
    18: 'M1N 2.0'
  },
      MITAC_VIDEO_DEVICE_MODEL_BY_ID = {
    'd1834db5-d87a-443c-8d63-57185d26ed44': 'K265',
    '0fad13f5-1c13-4dd0-b44f-e1a6f98f5c00': 'K165',
    'db57ce72-2a8a-4c0e-a3e5-e50c3527200a': 'K245C',
    '7a2700c4-9f12-4ee9-9eb8-7c1ad71f5d8d': 'K145c'
  };

  /* global _ */

  var VeiculoCtrl = function () {
    function VeiculoCtrl(Restangular, moment, $uibModal, $filter, AlertMessage, CadastroVeiculoService, HttpServiceV3g, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, VtabelaFactory, TipoPermissaoEnum, ModalInfoConfirmService, $q, $scope, $translate, FeatureFlag, $state, $window, Authenticator, MeasurementUnitConverterService, FeatureOuService, ConvertersService, safetyService, VmovComputadorBordo, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, VeiculoCtrl);

      this.vmovComputadorBordo = VmovComputadorBordo;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.httpService = HttpServiceV3g;
      this.veiculoService = CadastroVeiculoService;
      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.FeatureOuService = FeatureOuService;
      this.restangular = Restangular;
      this.moment = moment;
      this.modalService = $uibModal;
      this.featureFlag = FeatureFlag;
      this.filter = $filter;
      this.alertMessage = AlertMessage;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.vtabelaFactory = VtabelaFactory;
      this.tipoPermissaoEnum = TipoPermissaoEnum;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.ConvertersService = ConvertersService;
      this.q = $q;
      this.scope = $scope;
      this.translate = $translate;
      this.semPermissaoEditar = this.translate.instant('ce.cadastro.veiculos.colunas.semPermissaoEditar');
      this.cliqueEditar = this.translate.instant('ce.cadastro.veiculos.colunas.cliqueEditar');
      this.semEquipamentoVideo = this.translate.instant('ce.cadastro.veiculos.colunas.semEquipamentoVideo');
      this.tooltipIntervaloManutencao = this.translate.instant('ce.cadastro.veiculos.colunas.intervaloManutencao.headerTooltip');
      this.sucessoPt1 = this.translate.instant('ce.cadastro.veiculos.modalManutencao.sucessoPt1');
      this.cadastrada = this.translate.instant('ce.cadastro.veiculos.modalManutencao.cadastrada');
      this.removida = this.translate.instant('ce.cadastro.veiculos.modalManutencao.removida');
      this.sucessoPt2 = this.translate.instant('ce.cadastro.veiculos.modalManutencao.sucessoPt2');
      this.tooltipDisabledMenu = this.translate.instant('ce.cadastro.veiculos.colunas.conducao.disableTooltip');
      this.state = $state;
      this.window = $window;
      this.veiculos = [];
      this.vtabela = null;
      this.relatorio = null;
      this.currentPage = 0;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.relatorioSafe = null;
      this.isFirstLoad = true;
      this.hasSensor = false;
      this.safetyService = safetyService;
      this.safetyService.initialize();
      this.shouldDisplayMoreOptions = false;

      this.beforeEdit = null;

      this.mapStatusI18N = {
        'EM TESTE': this.translate.instant('ce.enum.statusVeiculo.emTeste'),
        INATIVO: this.translate.instant('ce.enum.statusVeiculo.inativo'),
        'INSTALACAO PENDENTE': this.translate.instant('ce.enum.statusVeiculo.instalacaoPendente'),
        LIBERADO: this.translate.instant('ce.enum.statusVeiculo.liberado'),
        REMOVIDO: this.translate.instant('ce.enum.statusVeiculo.removido'),
        SUSPENSO: this.translate.instant('ce.enum.statusVeiculo.suspenso')
      };

      this.mapSituacaoI18N = {
        'Fora de Operação': this.translate.instant('ce.enum.situacaoVeiculo.foraOperacao'),
        Sinistrado: this.translate.instant('ce.enum.situacaoVeiculo.sinistrado'),
        'Em manutenção': this.translate.instant('ce.enum.situacaoVeiculo.emManutencao'),
        'Em operação': this.translate.instant('ce.enum.situacaoVeiculo.emOperacao'),
        'Parado no pátio': this.translate.instant('ce.enum.situacaoVeiculo.paradoPatio'),
        Reserva: this.translate.instant('ce.enum.situacaoVeiculo.reserva'),
        'Manutenção mecânica': this.translate.instant('ce.enum.situacaoVeiculo.manutencaoMecanica'),
        'Processo de cancelamento': this.translate.instant('ce.enum.situacaoVeiculo.processoCancelamento'),
        'Processo de troca por outro veículo': this.translate.instant('ce.enum.situacaoVeiculo.processoTrocaOutroVeiulo'),
        'Processo de Transferência de operador Logístico': this.translate.instant('ce.enum.situacaoVeiculo.processoTransferenciaOperador'),
        'Em rota': this.translate.instant('ce.enum.situacaoVeiculo.emRota'),
        'Em processo de cancelamento': this.translate.instant('ce.enum.situacaoVeiculo.emProcessoCancelamento'),
        'Rodando sem sinal - Aguardando retorno da operação': this.translate.instant('ce.enum.situacaoVeiculo.rodandoSemSinal')
      };

      this.authenticator.getUser().then(function (user) {
        _this.user = user;
        _this.uoId = user ? user.uo.id : null;
        _this.userPreferredDateFormat = user.measurementUnits.dateTimeFormat;
        _this.distanceUnitFormat = user.measurementUnits.distanceMeasurement;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormat(_this.userPreferredDateFormat);
        _this.dateFormat = _this.measurementUnitConverterService.getDateFormat(_this.userPreferredDateFormat).toUpperCase();
        _this.idioma = user.idioma;
        _this.FeatureOuService.getVehicleTableConfig(user.uo.id).then(function (isTTCUser) {
          _this.isTTCUser = isTTCUser;
          _this.shouldDisplayMoreOptions = !isTTCUser;
          ServiceVfiltro.init(FactoryVfiltro.get([{
            key: _this.keys.uo.name
          }, {
            key: _this.keys.uoParceira.name,
            size: 6
          }, {
            key: _this.keys.veiculo.name,
            size: 6
          }, {
            key: _this.keys.vehicleStatus.name,
            size: 6
          }])).then(function () {
            _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VEICULO_EDITAR');
            _this.roleVigenciaProgramadaVisualizar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIGENCIA_PROGRAMADA_VISUALIZAR');
            _this.restangular.one('configuracao/configuracoes/' + _this.serviceVfiltro.factoryVfiltro.user.uo.id + '/alerta').get().then(function (alertas) {
              _this.permissaoManutencaoProgramada = alertas.configuracoes.manutencaoProgramada.ativo;
            });
            _this.deveExibirColunaEditarVeiculo = _this.isTTCUser && _this.roleCadastrar;
            _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'cadastroVeiculo', _this.getTableVersion());
            _this.consultar();
          });
        });
      });

      this.scope.$on('vehicleRegistered', function () {
        _this.reloadVehicleTable();
      });

      this.scope.$on('vehicleEdited', function () {
        _this.reloadVehicleTable();
      });
    }

    _createClass(VeiculoCtrl, [{
      key: 'getMaisOpcoesMsg',
      value: function getMaisOpcoesMsg() {
        if (!this.vtabela || !this.vtabela.rowsSelected || this.vtabela.rowsSelected.length === 0) {
          return this.translate.instant('ce.cadastro.veiculos.menuOpcoes.msg');
        }
        if (this.getEditableRowsSelected().length === 0) {
          return this.semPermissaoEditar;
        }
        return null;
      }
    }, {
      key: 'onSaveRowVtabela',
      value: function onSaveRowVtabela(rowEntity) {
        var promise = null;
        if (rowEntity.hodometro !== this.beforeEdit.hodometro) {
          promise = this.confirmarAlteracaoHodometro(rowEntity.hodometro, this.beforeEdit.hodometro, rowEntity);
        } else if (rowEntity.prefixo !== this.beforeEdit.prefixo) {
          promise = this.confirmarAlteracaoPrefixo(rowEntity);
        }

        if (promise !== null) {
          this.vtabela.gridApi.rowEdit.setSavePromise(rowEntity, promise);
        }
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        var showNaOnlyColumns = this.isTTCUser;
        var objVtabela = {
          exporterCsvFilename: this.translate.instant('ce.cadastro.veiculos.csvFileName') + '.csv',
          appScopeProvider: this,
          enableCellEdit: true,
          rowEditWaitInterval: 1,
          saveRow: function saveRow(rowEntity) {
            _this2.onSaveRowVtabela(rowEntity);
          },
          beginCellEdit: function beginCellEdit(rowEntity) {
            _this2.beforeEdit = angular.copy(rowEntity);
          },
          columnDefs: [{
            name: 'placa',
            displayName: 'ce.cadastro.veiculos.colunas.placa',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false,
            enableCellEdit: false,
            pinnedLeft: true,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-placa-{{row.entity.id}}">\n                <i\n                  ng-if="!grid.appScope.podeEditarVeiculo(row.entity)"\n                  class="fa fa-minus-circle"\n                  uib-tooltip=\'{{ grid.appScope.semPermissaoEditar }}\'>\n                </i>\n                <span ng-class=\'{"no-icon": grid.appScope.podeEditarVeiculo(row.entity)}\'>\n                  {{row.entity.placa}}\n                </span>\n              </div>'
          }, {
            name: 'prefixo',
            displayName: 'ce.cadastro.veiculos.colunas.prefixo',
            type: 'string',
            filterCellFiltered: true,
            cellTemplate: '\n                <div class="editable-double-click ui-grid-cell-contents-container" data-testid="cell-prefixo-{{row.entity.id}}"\n                  title="{{ grid.appScope.podeEditarVeiculo(row.entity) ? grid.appScope.cliqueEditar : grid.appScope.semPermissaoEditar }}">\n                  <div class=\'ui-grid-cell-contents\'>\n                    <span class=\'span-ui-grid-cell-contents\'>\n                      {{ row.entity.prefixo }}\n                    </span>\n                  </div>\n                </div>\n              ',
            cellEditableCondition: function cellEditableCondition($scope) {
              return _this2.podeEditarVeiculo($scope.row.entity);
            },
            editableCellTemplate: '\n              <div class="editable-double-click ui-grid-cell-contents-container">\n                <div class=\'ui-grid-cell-contents\'>\n                  <form name="edit-prefixo">\n                    <input type="text" ui-grid-editor ng-model="row.entity.prefixo" maxlength="20">\n                  </form>\n                </div>\n              </div>'
          }, {
            name: 'uoNome',
            displayName: 'ce.cadastro.veiculos.colunas.uoNome',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-uoNome-{{row.entity.id}}">{{row.entity.uoNome}}</div>'
          }, {
            name: 'equipamentoVideo',
            displayName: 'ce.cadastro.veiculos.colunas.equipamentoVideo',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            visible: this.showVideoEquipmentColumns(),
            enableHiding: this.showVideoEquipmentColumns(),
            cellTemplate: '\n                <div class="ui-grid-cell-contents" data-testid="cell-equipamentoVideo-{{row.entity.id}}">\n                  <a ng-if="row.entity.dvrEquipamentoVideo"\n                    ui-sref="root.devices({ dvr: row.entity.dvrEquipamentoVideo })">\n                    {{ row.entity.equipamentoVideo }}\n                  </a>\n                  <span ng-if="!row.entity.dvrEquipamentoVideo" class="text-muted">\n                    {{ row.entity.equipamentoVideo }}\n                  </span>\n                </div>'
          }, {
            name: 'modeloEquipamentoVideo',
            displayName: 'ce.cadastro.veiculos.colunas.modeloEquipamentoVideo',
            cellFilter: 'withLabelToUndefined:\'-\'',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            visible: this.showVideoEquipmentColumns(),
            enableHiding: this.showVideoEquipmentColumns(),
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-modeloEquipamentoVideo-{{row.entity.id}}">{{row.entity.modeloEquipamentoVideo | withLabelToUndefined:\'-\'}}</div>'
          }, {
            name: 'vin',
            displayName: 'ce.cadastro.veiculos.colunas.vin',
            cellClass: 'text-left',
            cellFilter: 'withLabelToUndefined:\'-\'',
            type: 'string',
            visible: this.isTTCUser,
            enableHiding: true,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-vin-{{row.entity.id}}">{{row.entity.vin}}</div>'
          }, {
            name: 'grupo',
            displayName: 'ce.cadastro.veiculos.colunas.grupo',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-grupo-{{row.entity.id}}">{{row.entity.grupo}}</div>'
          }, {
            name: 'tipo',
            displayName: 'ce.cadastro.veiculos.colunas.tipo',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-tipo-{{row.entity.id}}">{{row.entity.tipo}}</div>'
          }, {
            name: 'situacao',
            displayName: 'ce.cadastro.veiculos.colunas.situacao',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-situacao-{{row.entity.id}}">{{row.entity.situacao}}</div>'
          }, {
            name: 'dataRetorno',
            displayName: 'ce.cadastro.veiculos.colunas.dataRetorno.colLabel',
            type: 'date',
            cellFilter: 'date:\'dd/MM/yyyy\'',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellClass: 'text-center',
            cellTemplate: '\n                <div class=\'ui-grid-cell-contents\' data-testid="cell-dataRetorno-{{row.entity.id}}" ng-if="row.entity.dataRetorno">\n                  <span class="icone-esquerda">{{row.entity.dataRetorno}}</span>\n                  <i\n                    class="fa fa-wrench text-blue"\n                    uib-tooltip="{{ \'ce.cadastro.veiculos.colunas.dataRetorno.iconTooltip\' | translate }}">\n                  </i>\n                </div>\n                <div class=\'ui-grid-cell-contents\' ng-if="!row.entity.dataRetorno">-</div>\n              '
          }, {
            name: 'marca',
            displayName: 'ce.cadastro.veiculos.colunas.marca',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-marca-{{row.entity.id}}">{{row.entity.marca}}</div>'
          }, {
            name: 'modelo',
            displayName: 'ce.cadastro.veiculos.colunas.modelo',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-modelo-{{row.entity.id}}">{{row.entity.modelo}}</div>'
          }, {
            name: 'ano',
            displayName: 'ce.cadastro.veiculos.colunas.ano',
            cellClass: 'text-right',
            type: 'number',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellFilter: 'withLabelToUndefined:\'-\'',
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-ano-{{row.entity.id}}">{{row.entity.ano}}</div>'
          }, {
            name: 'hodometro',
            displayName: 'ce.cadastro.veiculos.colunas.hodometro',
            filterCellFiltered: true,
            cellTemplate: '\n                <div class="editable-double-click ui-grid-cell-contents-container" data-testid="cell-hodometro-{{row.entity.id}}"\n                  title="{{ grid.appScope.podeEditarVeiculo(row.entity) ? grid.appScope.cliqueEditar : grid.appScope.semPermissaoEditar }}">\n                  <div class=\'ui-grid-cell-contents\'>\n                    <span ng-class=\'{"no-icon": grid.appScope.podeEditarVeiculo(row.entity)}\'>\n                      {{row.entity.hodometro | number:1}}\n                    </span>\n                  </div>\n                </div>\n              ',
            cellEditableCondition: function cellEditableCondition($scope) {
              return _this2.podeEditarVeiculo($scope.row.entity);
            },
            editableCellTemplate: '\n                <div class="editable-double-click ui-grid-cell-contents-container">\n                  <div class=\'ui-grid-cell-contents\'>\n                    <form name="edit-hodometro">\n                      <input type="text" ui-grid-editor ng-model="row.entity.hodometro" ui-hide-group-sep min=0 ui-number-mask=1>\n                    </form>\n                  </div>\n                </div>'
          }, {
            name: 'status',
            displayName: 'ce.cadastro.veiculos.colunas.status',
            type: 'string',
            filterCellFiltered: true,
            enableCellEdit: false,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-status-{{row.entity.id}}">{{row.entity.status}}</div>'
          }, {
            name: 'timezone',
            displayName: 'ce.cadastro.veiculos.colunas.timezone',
            cellClass: 'text-left',
            cellFilter: 'withLabelToUndefined:\'-\'',
            type: 'string',
            visible: this.isTTCUser,
            enableHiding: true,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-timezone-{{row.entity.id}}">{{row.entity.timezone}}</div>'
          }, {
            name: 'intervaloManutencao',
            displayName: 'ce.cadastro.veiculos.colunas.intervaloManutencao.colLabel',
            cellClass: 'text-right',
            headerCellClass: 'icon-info-tooltip',
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerTooltip: this.tooltipIntervaloManutencao,
            type: 'number',
            enableCellEdit: false,
            visible: !showNaOnlyColumns,
            enableHiding: !showNaOnlyColumns,
            cellTemplate: '<div class="ui-grid-cell-contents" data-testid="cell-intervaloManutencao-{{row.entity.id}}">{{row.entity.intervaloManutencao}}</div>'
          }]
        };

        if (this.hasSensor) {
          this.intervaloManutencaoHorimetro = this.translate.instant('ce.cadastro.veiculos.colunas.intervaloManutencaoHorimetro.colLabel');
          this.tooltipManutencaoHorimetro = this.translate.instant('ce.cadastro.veiculos.colunas.intervaloManutencaoHorimetro.headerTooltip');
          objVtabela.columnDefs.push({
            name: 'intervaloManutencaoHorimetro',
            displayName: this.intervaloManutencaoHorimetro,
            cellClass: 'text-right',
            headerCellClass: 'icon-info-tooltip',
            cellFilter: 'withLabelToUndefined:\'-\'',
            headerTooltip: this.tooltipManutencaoHorimetro,
            type: 'number',
            enableCellEdit: false,
            visible: !showNaOnlyColumns,
            enableHiding: !showNaOnlyColumns
          });
        }

        if (this.roleVigenciaProgramadaVisualizar && this.featureFlag.VIGENCIA_PROGRAMADA) {
          objVtabela.columnDefs.push({
            name: 'conducaoInicio',
            displayName: 'ce.cadastro.veiculos.colunas.conducao.colLabelInicio',
            type: 'date',
            cellFilter: 'date:\'dd/MM/yyyy\'',
            filterCellFiltered: true,
            cellClass: 'text-center',
            visible: false,
            enableHiding: !showNaOnlyColumns,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' ng-if="row.entity.conducaoInicio">\n                <span uib-tooltip=\'{{ grid.appScope.getTooltipMsg(row.entity.conducao) }}\'>\n                  {{ row.entity.conducaoInicio }}\n                </span>\n              </div>\n              <div class=\'ui-grid-cell-contents\' ng-if="!row.entity.conducaoInicio"></div>\n            '
          }, {
            name: 'conducaoFim',
            displayName: 'ce.cadastro.veiculos.colunas.conducao.colLabelFim',
            type: 'date',
            cellFilter: 'date:\'dd/MM/yyyy\'',
            filterCellFiltered: true,
            cellClass: 'text-center',
            visible: false,
            enableHiding: !showNaOnlyColumns,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' ng-if="row.entity.conducaoFim">\n                <span uib-tooltip=\'{{ grid.appScope.getTooltipMsg(row.entity.conducao) }}\'>\n                  {{ row.entity.conducaoFim }}\n                </span>\n              </div>\n              <div class=\'ui-grid-cell-contents\' ng-if="!row.entity.conducaoFim"></div>\n            '
          });
        }

        if (this.isFeatureFlagEditVehicleEnabled()) {
          objVtabela.columnDefs.push({
            name: 'editarVeiculo',
            displayName: 'ce.cadastro.veiculos.colunas.editarVeiculo.colLabel',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            visible: this.deveExibirColunaEditarVeiculo,
            headerCellTemplate: '\n                <span\n                  class="fa fa-info-circle info-editar-icon"\n                  uib-tooltip="{{ \'ce.cadastro.veiculos.colunas.editarVeiculo.colLabel\' | translate }}"\n                  tooltip-placement="top-right">\n                </span>',
            exporterSuppressExport: true,
            width: 55,
            cellTemplate: '\n            <div ng-if="grid.appScope.podeEditarVeiculo(row.entity)"\n              ng-controller="VehicleEditCtrl as VehicleEditCtrl">\n              <a ng-click="VehicleEditCtrl.handleEditVehicleButtonClick(row.entity, grid.appScope.idioma)"\n                class="fa fa-pencil" ng-class="\'icone\'"\n                uib-tooltip="{{ \'ce.cadastro.veiculos.colunas.editarVeiculo.tooltipEnabled\' | translate }}"\n              ></a>\n            </div>\n            <div ng-if="!grid.appScope.podeEditarVeiculo(row.entity)">\n                <i\n                  class="fa fa-pencil" ng-class="\'icone-disabled\'"\n                  uib-tooltip="{{ \'ce.cadastro.veiculos.colunas.editarVeiculo.tooltipDisabled\' | translate }}">\n                </i>\n            </div>'
          });
        }

        objVtabela.columnDefs.push({
          name: 'veiculoSync',
          displayName: '',
          enableFiltering: false,
          enableSorting: false,
          pinnedRight: true,
          enableColumnResizing: false,
          enableHiding: false,
          visible: this.isTTCUser,
          headerCellTemplate: '\n          <span\n            class="fa trimble-cloud-connected info-motorista-sync-icon"\n            data-testid="vehicle-sync-icon"\n          </span>',
          exporterSuppressExport: true,
          width: 55,
          cellTemplate: '\n          <a ng-if="row.entity.dateSync"\n          uib-tooltip="{{ \'ce.cadastro.veiculos.colunas.ultimoUpdateTooltip\' | translate: { lastSyncUpdate: row.entity.dateSync } }}"\n          tooltip-placement="top-right"\n          tooltip-class="custom-tooltip"\n          data-testid="vehicle-sync-icon-{{row.entity.placa}}"\n          class="fa trimble-cloud-connected icone"></a>'
        });

        return objVtabela;
      }
    }, {
      key: 'handleOdometerConversion',
      value: function handleOdometerConversion(odometerValue) {
        if (this.distanceUnitFormat === 'MILES') {
          return this.ConvertersService.handleKmToMiles(odometerValue);
        }
        return odometerValue;
      }
    }, {
      key: 'getTooltipMsg',
      value: function getTooltipMsg(conducao) {
        return this.translate.instant('ce.cadastro.veiculos.colunas.conducao.headerTooltip', { dataInicio: conducao.inicio, dataFim: conducao.fim });
      }
    }, {
      key: 'getTableVersion',
      value: function getTableVersion() {
        var produto = this.isTTCUser ? 'na' : 'latam',
            video = this.showVideoEquipmentColumns() ? 'video' : 'novideo';

        return 'v2-' + produto + '-' + video;
      }
    }, {
      key: 'showVideoEquipmentColumns',
      value: function showVideoEquipmentColumns() {
        return Boolean(this.isTTCUser) && Boolean(this.featurehubJsSdk) && this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VEHICLE_VIDEO_EQUIPMENT_COLUMNS);
      }
    }, {
      key: 'isFeatureFlagEditVehicleEnabled',
      value: function isFeatureFlagEditVehicleEnabled() {
        var feature = featurehubJsSdk.isFeatureEnabled('STFM_726_ALLOW_EDIT_VEHICLE');
        return feature;
      }
    }, {
      key: 'podeEditarVeiculo',
      value: function podeEditarVeiculo(entity) {
        return this.roleCadastrar && this.tipoPermissaoEnum.podeEditar(entity.tipoPermissao);
      }
    }, {
      key: 'getTipoVeiculo',
      value: function getTipoVeiculo(tipoVeiculo) {
        if (angular.isUndefined(tipoVeiculo)) {
          return undefined;
        }

        switch (this.idioma) {
          case 'EN_US':
            return tipoVeiculo.nameEn;
          case 'ES_ES':
            return tipoVeiculo.nameEs;
          case 'EN_GB':
            return tipoVeiculo.nameEn;
          case 'DE_DE':
            return tipoVeiculo.nameDe;
          case 'FR_FR':
            return tipoVeiculo.nameFr;
          case 'IT_IT':
            return tipoVeiculo.nameIt;
          case 'NL_NL':
            return tipoVeiculo.nameNl;
          case 'PL_PL':
            return tipoVeiculo.namePl;
          default:
            return tipoVeiculo.nome;
        }
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        var latestSyncDateWithTtc = null;
        if (item.ultimoSyncTtc || item.ultimoSyncVfleets) {
          var ultimo_sync_ttc = item.ultimoSyncTtc ? new Date(item.ultimoSyncTtc).getTime() : 0;
          var ultimo_sync_vfleets = item.ultimoSyncVfleets ? new Date(item.ultimoSyncVfleets).getTime() : 0;
          latestSyncDateWithTtc = new Date(Math.max(ultimo_sync_ttc, ultimo_sync_vfleets));
        }
        return {
          id: item.id,
          prefixo: item.prefixo,
          placa: item.placa ? item.placa : '-',
          uo: item.uo,
          uoNome: item.uo ? item.uo.nome : '-',
          uoId: item.uo ? item.uo.id : null,
          dvrEquipamentoVideo: this.getEquipamentoVideo(item),
          equipamentoVideo: this.getEquipamentoVideoLabel(item),
          modeloEquipamentoVideo: this.getModeloEquipamentoVideo(item),
          grupo: item.grupo && item.grupo.nome ? item.grupo.nome : '-',
          tipo: this.getTipoVeiculo(item.tipoVeiculo),
          situacao: item.situacaoVeiculo && item.situacaoVeiculo.nome ? this.getSituacao18n(item.situacaoVeiculo.nome) : '-',
          situacaoEnum: item.situacaoVeiculo && item.situacaoVeiculo.nome ? item.situacaoVeiculo.nome : '-',
          marca: item.marca,
          modelo: item.modelo,
          hodometro: this.handleOdometerConversion(item.hodometro),
          horimetro: item.horimetro,
          ano: item.ano,
          status: this.getStatusi18n(item.status),
          statusEnum: item.status,
          timezone: item.timezone,
          vin: item.chassi,
          hodometroProximoAlertaManutencao: this.valueOrNull(item.manutencaoProgramada, 'hodometroProximoAlertaManutencao'),
          intervaloManutencao: this.valueOrNull(item.manutencaoProgramada, 'intervaloManutencao'),
          margemAlertaManutencao: this.valueOrNull(item.manutencaoProgramada, 'margemAlertaManutencao'),
          horimetroProximoAlertaManutencao: this.valueOrNull(item.manutencaoProgramada, 'horimetroProximoAlertaManutencao'),
          intervaloManutencaoHorimetro: this.valueOrNull(item.manutencaoProgramada, 'intervaloManutencaoHorimetro'),
          margemAlertaManutencaoHorimetro: this.valueOrNull(item.manutencaoProgramada, 'margemAlertaManutencaoHorimetro'),
          tipoPermissao: item.tipoPermissao,
          tipoEntidade: item.tipoEntidade,
          dataRetorno: item.dataRetorno ? this.moment(item.dataRetorno).format(this.dateFormat).toString() : item.dataRetorno,
          conducaoInicio: item.vigenciaProgramada ? this.moment(item.vigenciaProgramada.inicio).format(this.dateFormat).toString() : null,
          conducaoFim: item.vigenciaProgramada ? this.moment(item.vigenciaProgramada.fim).format(this.dateFormat).toString() : null,
          conducao: item.vigenciaProgramada,
          dateSync: this.filter('date')(latestSyncDateWithTtc, this.dateTimeFormat),
          province: item.province,
          provinceId: item.province ? item.province.id : '',
          provinceName: item.province ? item.province.name : '',
          vehicleType: item.tipoVeiculo,
          vehicleTypeId: item.tipoVeiculo ? item.tipoVeiculo.id : '',
          vehicleTypeName: item.tipoVeiculo ? item.tipoVeiculo.nome : '',
          color: item.color,
          fuelType: item.fuelType
        };
      }
    }, {
      key: 'getVideoModule',
      value: function getVideoModule(item) {
        var _this3 = this;

        return [item.modulo, item.modulo2, item.modulo3].find(function (modulo) {
          return modulo && _this3.isVideoModule(modulo);
        });
      }
    }, {
      key: 'isVideoModule',
      value: function isVideoModule(modulo) {
        return this.vmovComputadorBordo.devices.includes(modulo.computadorBordoId) || MITAC_VIDEO_DEVICE_MODEL_BY_ID.hasOwnProperty(modulo.deviceModelId);
      }
    }, {
      key: 'getVideoModuleModel',
      value: function getVideoModuleModel(videoModule) {
        return MITAC_VIDEO_DEVICE_MODEL_BY_ID[videoModule.deviceModelId] || DEVICE_MODEL_BY_ON_BOARD_COMPUTER[videoModule.computadorBordoId] || null;
      }
    }, {
      key: 'getEquipamentoVideo',
      value: function getEquipamentoVideo(item) {
        var videoModule = this.getVideoModule(item);
        return videoModule ? videoModule.idFornecedor : item.dvrEquipamentoVideo || null;
      }
    }, {
      key: 'getEquipamentoVideoLabel',
      value: function getEquipamentoVideoLabel(item) {
        return this.getEquipamentoVideo(item) || this.semEquipamentoVideo;
      }
    }, {
      key: 'getModeloEquipamentoVideo',
      value: function getModeloEquipamentoVideo(item) {
        var videoModule = this.getVideoModule(item);
        return videoModule ? this.getVideoModuleModel(videoModule) : item.modeloEquipamentoVideo || null;
      }
    }, {
      key: 'valueOrNull',
      value: function valueOrNull(obj, atributo) {
        return obj ? obj[atributo] || null : null;
      }
    }, {
      key: 'vDataToVeiculo',
      value: function vDataToVeiculo(list) {
        var _this4 = this;

        if (angular.isArray(list)) {
          return list.map(function (i) {
            return _this4.itemToVeiculo(i);
          });
        }
        return this.itemToVeiculo(list);
      }
    }, {
      key: 'itemToVeiculo',
      value: function itemToVeiculo(item) {
        return {
          id: item.id,
          prefixo: item.prefixo,
          dvrEquipamentoVideo: item.dvrEquipamentoVideo,
          modeloEquipamentoVideo: item.modeloEquipamentoVideo,
          placa: item.placa,
          marca: item.marca,
          modelo: item.modelo,
          hodometro: this.handleOdometerConversion(item.hodometro),
          horimetro: item.horimetro,
          ano: item.ano,
          grupo: {
            nome: item.grupo
          },
          situacaoVeiculo: {
            nome: item.situacaoEnum
          },
          tipo: item.tipo,
          status: item.statusEnum,
          timezone: item.timezone,
          vin: item.chassi,
          manutencaoProgramada: {
            hodometroProximoAlertaManutencao: item.hodometroProximoAlertaManutencao,
            intervaloManutencao: item.intervaloManutencao,
            margemAlertaManutencao: item.margemAlertaManutencao,
            horimetroProximoAlertaManutencao: item.horimetroProximoAlertaManutencao,
            intervaloManutencaoHorimetro: item.intervaloManutencaoHorimetro,
            margemAlertaManutencaoHorimetro: item.margemAlertaManutencaoHorimetro
          },
          uo: {
            id: item.uoId,
            nome: item.uoNome
          },
          tipoPermissao: item.tipoPermissao,
          tipoEntidade: item.tipoEntidade,
          dataRetorno: item.dataRetorno ? this.moment(item.dataRetorno).format('DD/MM/YYYY').toString() : item.dataRetorno
        };
      }
    }, {
      key: 'getStatusFiltro',
      value: function getStatusFiltro() {
        var _this5 = this;

        var filtroStatus = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this5.keys.vehicleStatus.name;
        });

        if (!filtroStatus || !filtroStatus.values || filtroStatus.values.length === 0) {
          return null;
        }

        if (filtroStatus.values.some(function (x) {
          return x.id === STATUS_TODOS;
        })) {
          return null;
        }

        return filtroStatus.values.map(function (x) {
          return x.id;
        }).join(',');
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        var _this6 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this6.keys.uo.name;
        }).value.id,
            uoParceira = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this6.keys.uoParceira.name;
        }),
            status = this.getStatusFiltro(),
            urlBase = '/veiculo/v2/veiculos/csv?uoPermissao=' + uoId + '&uoId=' + (uoParceira ? uoParceira.value.id : '');
        return status ? urlBase + '&status=' + encodeURIComponent(status) : urlBase;
      }
    }, {
      key: 'isVeiculoEditavel',
      value: function isVeiculoEditavel() {
        return this.vtabela && this.vtabela.rowsSelected.length === 1 && this.tipoPermissaoEnum.podeEditar(this.vtabela.rowsSelected[0].tipoPermissao) && this.roleCadastrar;
      }
    }, {
      key: 'openConfigConducao',
      value: function openConfigConducao(veiculos) {
        if (veiculos.length === 1) {
          /* eslint-disable */
          var elementContainer = document.querySelector('#dialogConfigConducao'),
              dialogConfigConducao = document.createElement('vfwc-dialog-conducao-programada');
          /* eslint-enable */

          dialogConfigConducao.user = this.serviceVfiltro.factoryVfiltro.user;
          dialogConfigConducao.veiculo = veiculos[0];
          elementContainer.appendChild(dialogConfigConducao);
          this.onConfigSalva(dialogConfigConducao);
        }
      }
    }, {
      key: 'onConfigSalva',
      value: function onConfigSalva(element) {
        var _this7 = this;

        element.addEventListener('successConducaoProgramada', function () {
          _this7.reloadVehicleTable();
        });
      }
    }, {
      key: 'reloadVehicleTable',
      value: function reloadVehicleTable() {
        this.consultar();
        this.vtabela.rowsSelected = [];
      }
    }, {
      key: 'isVeiculoEditavelComIntervaloDeManutencao',
      value: function isVeiculoEditavelComIntervaloDeManutencao() {
        return !this.isTTCUser && this.isVeiculoEditavel() && this.vtabela.rowsSelected[0].intervaloManutencao;
      }
    }, {
      key: 'isVeiculoEditavelComIntervaloDeManutencaoHorimetro',
      value: function isVeiculoEditavelComIntervaloDeManutencaoHorimetro() {
        return !this.isTTCUser && this.isVeiculoEditavel() && this.vtabela.rowsSelected[0].intervaloManutencaoHorimetro;
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this8 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this8.keys.uo.name;
        }).value.id,
            uoParceira = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this8.keys.uoParceira.name;
        }),
            filtroVeiculo = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this8.keys.veiculo.name;
        }),
            veiculoId = filtroVeiculo && filtroVeiculo.value && filtroVeiculo.value.id;

        this.q.all([this.veiculoService.getByUo(uoId, uoParceira ? uoParceira.value.id : '', veiculoId, this.getStatusFiltro()), this.veiculoService.hasSensor(uoId)]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              resVeiculos = _ref2[0],
              resHasSensor = _ref2[1];

          _this8.veiculos = resVeiculos.plain().content;
          _this8.hasSensor = resHasSensor;
          _this8.carregarRelatorio();
        });
      }
    }, {
      key: 'carregarRelatorio',
      value: function carregarRelatorio() {
        var _this9 = this;

        this.relatorio = this.filter('orderBy')(this.isFirstLoad ? this.veiculos.map(function (v) {
          v.hodometro = angular.isDefined(v.hodometro) ? parseFloat((v.hodometro / KM_EM_METROS).toFixed(1)) : 0;
          v.horimetro = angular.isDefined(v.horimetro) ? parseFloat((v.horimetro / HORA_EM_SEGUNDOS).toFixed(1)) : 0;
          if (v.manutencaoProgramada) {
            v.manutencaoProgramada.intervaloManutencao /= KM_EM_METROS;
            v.manutencaoProgramada.margemAlertaManutencao = v.manutencaoProgramada.margemAlertaManutencao ? v.manutencaoProgramada.margemAlertaManutencao / KM_EM_METROS : null;
            v.manutencaoProgramada.intervaloManutencaoHorimetro /= HORA_EM_SEGUNDOS;
            v.manutencaoProgramada.margemAlertaManutencaoHorimetro = v.manutencaoProgramada.margemAlertaManutencaoHorimetro ? v.manutencaoProgramada.margemAlertaManutencaoHorimetro / HORA_EM_SEGUNDOS : null;
          }
          return v;
        }) : this.veiculos, 'placa');

        this.relatorioSafe = [].concat(this.relatorio);
        this.vtabela.setData(this.relatorioSafe.map(function (i) {
          return _this9.getItemVtabela(i);
        }));
      }
    }, {
      key: 'abrirQrCode',
      value: function abrirQrCode(veiculos) {
        var veiculosId = veiculos.map(function (v) {
          return v.id;
        }),
            qrcodePageUrl = this.state.href('root.veiculo.qrcode');

        this.window.localStorage.setItem('qrcode-veiculos-params', angular.toJson({ veiculosId: veiculosId }));
        this.window.open(qrcodePageUrl, '_blank');
      }
    }, {
      key: 'cancelarAlteracaoVeiculo',
      value: function cancelarAlteracaoVeiculo() {
        var _this10 = this;

        this.vtabela.grid.data.filter(function (x) {
          return x.id === _this10.beforeEdit.id;
        }).forEach(function (x) {
          angular.merge(x, _this10.beforeEdit);
        });

        this.beforeEdit = null;
      }
    }, {
      key: 'editarGrupoVeiculosModal',
      value: function editarGrupoVeiculosModal(veiculosSelecionadosEditaveis) {
        var _this11 = this;

        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/veiculo/editar-grupo/editar-grupo.tpl.html',
          controller: 'EditarGrupoCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            veiculos: function veiculos() {
              return veiculosSelecionadosEditaveis;
            }
          }
        }).result.then(function (data) {
          _this11.alertMessage.create({
            type: 'success',
            message: data.message,
            appendTo: '.alerta-aqui'
          });
          _this11.replaceGruposGrid(data.edition);
        }).catch(function (data) {
          if (data && data.message) {
            _this11.alertMessage.create({
              type: 'error',
              message: data.message,
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'desvincularGrupoVeic',
      value: function desvincularGrupoVeic(veiculosSelecionadosComGrupo) {
        var _this12 = this;

        var configs = {
          title: this.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.title'),
          btnSecundario: this.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.btnSecundario'),
          btnPrimario: this.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.btnPrimario'),
          conteudo: veiculosSelecionadosComGrupo.length === 1 ? this.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.msgConfirmacao') : this.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.msgConfirmacaoMaisDeUm')
        };

        this.modalInfoConfirmService.confirmModal(configs).then(function () {
          _this12.efetivaDesvinculo(veiculosSelecionadosComGrupo);
        });
      }
    }, {
      key: 'efetivaDesvinculo',
      value: function efetivaDesvinculo(veiculos) {
        var _this13 = this;

        var veiculosIds = veiculos.map(function (veiculo) {
          return veiculo.id;
        });

        this.httpService.post('/veiculo/v2/veiculos/batch', {
          veiculoIds: veiculosIds,
          patch: {
            grupoId: null
          }
        }).success(function () {
          _this13.alertMessage.create({
            type: 'success',
            message: veiculosIds.length === 1 ? _this13.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.efetivaDesvinculo.sucesso') : _this13.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.efetivaDesvinculo.sucessoMaisDeUm'),
            appendTo: '.alerta-aqui'
          });
          _this13.replaceGruposGrid({
            veiculosIds: veiculosIds,
            grupo: {
              nome: '-'
            }
          });
        }).error(function () {
          _this13.alertMessage.create({
            type: 'danger',
            message: veiculosIds.length === 1 ? _this13.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.efetivaDesvinculo.erro') : _this13.translate.instant('ce.cadastro.veiculos.desvincularGrupoVeic.efetivaDesvinculo.erroMaisDeUm'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'replaceGruposGrid',
      value: function replaceGruposGrid(edition) {
        var _this14 = this;

        edition.veiculosIds.forEach(function (veiculoId) {
          var veiculoConsulta = _this14.veiculos.find(function (veic) {
            return veic.id === veiculoId;
          });
          if (angular.isDefined(veiculoConsulta.grupo)) {
            veiculoConsulta.grupo.nome = edition.grupo.nome;
          } else {
            veiculoConsulta.grupo = {
              nome: edition.grupo.nome
            };
          }
          _this14.atualizaVeiculoVtabela(veiculoConsulta);
        });
        this.isFirstLoad = false;
      }
    }, {
      key: 'confirmarAlteracaoHodometro',
      value: function confirmarAlteracaoHodometro(novoValorHodometro, hodometroOriginal, rowEntity) {
        var _this15 = this;

        this.hodometroOriginal = hodometroOriginal;
        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/veiculo/hodometro-confirmacao.tpl.html',
          controller: 'HodometroConfirmacaoCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            novoValorHodometro: novoValorHodometro,
            placa: function placa() {
              return rowEntity.placa;
            }
          }
        }).result.then(function () {
          _this15.salvarHodometro(_this15.vDataToVeiculo(rowEntity));
        }, function () {
          _this15.cancelarAlteracaoVeiculo();
        });
      }
    }, {
      key: 'confirmarAlteracaoPrefixo',
      value: function confirmarAlteracaoPrefixo(rowEntity) {
        var _this16 = this;

        return this.modalInfoConfirmService.confirmModal({
          title: '' + this.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.title'),
          conteudo: this.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.conteudoPt1') + ' ' + rowEntity.placa + ' ' + this.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.conteudoPt2') + ' <strong>' + rowEntity.prefixo + '</strong>?',
          btnSecundario: '' + this.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.btnSecundario'),
          btnPrimario: '' + this.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.btnPrimario'),
          headerColor: 'bg-light-blue',
          typeButton: 'btn-primary'
        }).then(function () {
          return _this16.salvarPrefixo(_this16.vDataToVeiculo(rowEntity));
        }).catch(function () {
          return _this16.cancelarAlteracaoVeiculo();
        });
      }
    }, {
      key: 'salvarPrefixo',
      value: function salvarPrefixo(veiculo) {
        var _this17 = this;

        this.httpService.patch('/veiculo/v2/veiculos/' + veiculo.id, {
          prefixo: veiculo.prefixo
        }).success(function () {
          _this17.atualizaVeiculoVtabela(veiculo);
          return _this17.alertMessage.create({
            type: 'success',
            message: _this17.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.salvarPrefixo.sucesso'),
            appendTo: '.alerta-aqui'
          });
        }).error(function () {
          _this17.cancelarAlteracaoVeiculo();
          return _this17.alertMessage.create({
            type: 'error',
            message: _this17.translate.instant('ce.cadastro.veiculos.alteracaoPrefixo.salvarPrefixo.erro'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'salvarHodometro',
      value: function salvarHodometro(veiculo) {
        var _this18 = this;

        this.restangular.all('veiculo/historico-hodometro').post({
          datahora: this.moment(),
          veiculo: { id: veiculo.id },
          uo: { id: veiculo.uo.id },
          hodometroPainel: veiculo.hodometro * 1000
        }).then(function () {
          _this18.hodometroOriginal = '';
          _this18.atualizaVeiculoVtabela(veiculo);
          return _this18.alertMessage.create({
            type: 'success',
            message: _this18.translate.instant('ce.cadastro.veiculos.alteracaoHodometro.salvarHodometro.sucesso'),
            appendTo: '.alerta-aqui'
          });
        }).catch(function () {
          veiculo.hodometro = _this18.hodometroOriginal;
          _this18.cancelarAlteracaoVeiculo();
          return _this18.alertMessage.create({
            type: 'error',
            message: _this18.translate.instant('ce.cadastro.veiculos.alteracaoHodometro.salvarHodometro.erro'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'atualizaVeiculoVtabela',
      value: function atualizaVeiculoVtabela(novoVeiculo) {
        var _this19 = this;

        if (this.vtabela) {
          this.vtabela.grid.data.filter(function (row) {
            return row.id === novoVeiculo.id;
          }).map(function (row) {
            angular.merge(row, _this19.getItemVtabela(novoVeiculo));
          });
        }
      }
    }, {
      key: 'alertaManutencao',
      value: function alertaManutencao(_veiculos) {
        var _this20 = this;

        var removeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/veiculo/alerta-manutencao/alerta-manutencao' + (removeType ? '-remove' : '') + '.tpl.html',
          controller: 'AlertaManutencaoCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            veiculos: function veiculos() {
              return removeType ? _this20.removeManutencaoEspecificaVeiculo(_veiculos, removeType) : _veiculos;
            },
            permissaoManutencaoProgramada: function permissaoManutencaoProgramada() {
              return _this20.permissaoManutencaoProgramada;
            },
            tipoRemocao: function tipoRemocao() {
              return removeType;
            }
          }
        }).result.then(function (values) {
          return _this20.rebuildVeiculos(values, removeType);
        }).catch(function (erro) {
          if (erro && erro.msg) {
            _this20.alertMessage.create({
              type: 'error',
              message: erro.msg,
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'removeManutencaoEspecificaVeiculo',
      value: function removeManutencaoEspecificaVeiculo(veiculos, removeType) {
        veiculos = angular.isArray(veiculos) ? veiculos : [veiculos];

        if (removeType === 'hodometro') {
          return veiculos.map(function (veiculoSelecionado) {
            veiculoSelecionado.manutencaoProgramada.hodometroProximoAlertaManutencao = 0;
            veiculoSelecionado.manutencaoProgramada.intervaloManutencao = 0;
            veiculoSelecionado.manutencaoProgramada.margemAlertaManutencao = 0;

            return veiculoSelecionado;
          });
        }

        return veiculos.map(function (veiculoSelecionado) {
          veiculoSelecionado.manutencaoProgramada.horimetroProximoAlertaManutencao = 0;
          veiculoSelecionado.manutencaoProgramada.intervaloManutencaoHorimetro = 0;
          veiculoSelecionado.manutencaoProgramada.margemAlertaManutencaoHorimetro = 0;

          return veiculoSelecionado;
        });
      }
    }, {
      key: 'abrirModalDefinirSituacao',
      value: function abrirModalDefinirSituacao(_veiculos2) {
        var _this21 = this;

        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/veiculo/situacao/situacao-veiculo.tpl.html',
          controller: 'SituacaoVeiculoCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            veiculos: function veiculos() {
              return _veiculos2;
            }
          }
        }).result.then(function (result) {
          _this21.updateSituacaoVeiculos(result.situacao, result.dataRetorno, _veiculos2);
          _this21.alertMessage.create({
            type: 'success',
            message: _this21.translate.instant('ce.cadastro.veiculos.modalSituacao.sucesso'),
            appendTo: '.alerta-aqui'
          });
        }).catch(function (erro) {
          if (erro && erro.msg) {
            _this21.alertMessage.create({
              type: 'error',
              message: erro.msg,
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'updateSituacaoVeiculos',
      value: function updateSituacaoVeiculos(situacaoVeiculo, dataRetorno, veiculosAtualizados) {
        var _this22 = this;

        var veiculoIds = veiculosAtualizados.map(function (v) {
          return v.id;
        });
        this.veiculos.filter(function (x) {
          return _.contains(veiculoIds, x.id);
        }).forEach(function (x) {
          x.situacaoVeiculo = situacaoVeiculo;
          x.dataRetorno = dataRetorno;
          _this22.atualizaVeiculoVtabela(x);
          return x;
        });
      }
    }, {
      key: 'rebuildVeiculos',
      value: function rebuildVeiculos(values, remove) {
        var _this23 = this;

        if (values && values.length > 0) {
          values.forEach(function (value) {
            var itemTabela = _this23.vtabela.grid.data.find(function (x) {
              return x.id === value.veiculoId;
            });
            if (itemTabela) {
              angular.merge(itemTabela, {
                intervaloManutencao: !isNaN(value.intervaloManutencao) ? value.intervaloManutencao : null,
                margemAlertaManutencao: value.margemAlertaManutencao || null,
                hodometroProximoAlertaManutencao: value.hodometroProximoAlertaManutencao || null,
                intervaloManutencaoHorimetro: !isNaN(value.intervaloManutencaoHorimetro) ? value.intervaloManutencaoHorimetro : null,
                margemAlertaManutencaoHorimetro: value.margemAlertaManutencaoHorimetro || null,
                horimetroProximoAlertaManutencao: value.horimetroProximoAlertaManutencao || null
              });
            }
          });
          this.alertMessage.create({
            type: 'success',
            message: this.sucessoPt1 + ' ' + (remove ? this.removida : this.cadastrada) + ' ' + this.sucessoPt2,
            appendTo: '.alerta-aqui'
          });
        }
      }
    }, {
      key: 'getSelecionadosComGrupo',
      value: function getSelecionadosComGrupo() {
        var _this24 = this;

        if (!this.vtabela || !this.vtabela.rowsSelected) {
          return [];
        }
        return this.vtabela.rowsSelected.filter(function (veic) {
          return _this24.tipoPermissaoEnum.podeEditar(veic.tipoPermissao) && veic.grupo !== '-';
        });
      }
    }, {
      key: 'getEditableRowsSelected',
      value: function getEditableRowsSelected() {
        var _this25 = this;

        if (!this.vtabela || !this.vtabela.rowsSelected) {
          return [];
        }
        return this.vtabela.rowsSelected.filter(function (i) {
          return _this25.tipoPermissaoEnum.podeEditar(i.tipoPermissao);
        });
      }
    }, {
      key: 'getStatusi18n',
      value: function getStatusi18n(status) {
        return this.mapStatusI18N[status];
      }
    }, {
      key: 'getSituacao18n',
      value: function getSituacao18n(status) {
        return this.mapSituacaoI18N[status];
      }
    }]);

    return VeiculoCtrl;
  }();

  var HodometroConfirmacaoCtrl = function () {
    function HodometroConfirmacaoCtrl($uibModalInstance, novoValorHodometro, placa) {
      _classCallCheck(this, HodometroConfirmacaoCtrl);

      this.modalInstance = $uibModalInstance;
      this.hodometro = novoValorHodometro;
      this.placa = placa;
    }

    _createClass(HodometroConfirmacaoCtrl, [{
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return HodometroConfirmacaoCtrl;
  }();

  angular.module('cadastros.veiculo').controller('VeiculoCtrl', VeiculoCtrl).controller('HodometroConfirmacaoCtrl', HodometroConfirmacaoCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.pontoReferencia').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.pontoReferencia', {
      url: '/ponto-referencia',
      views: {
        'content@': {
          templateUrl: 'cadastros/ponto-referencia/ponto-referencia.tpl.html',
          controller: 'PontoReferenciaCtrl',
          controllerAs: 'pontoReferenciaCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.pontosReferencia.titulo',
        tituloDescricao: '',
        role: 'PONTO_REFERENCIA_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
(function () {
  'use strict';

  var PontoReferencia = function () {
    function PontoReferencia($httpParamSerializer, $uibModal, AlertMessage, PontosReferencia, CategoriaPontosReferencia, v3gTableLimitService, ValidateUtil, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, VtabelaFactory, uiGridConstants, TipoPermissaoEnum, $translate, Authenticator, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, PontoReferencia);

      this.httpParamSerializer = $httpParamSerializer;
      this.alertMessage = AlertMessage;
      this.pontosReferenciaService = PontosReferencia;
      this.pontosCategoriaReferenciaService = CategoriaPontosReferencia;
      this.v3gTableLimitService = v3gTableLimitService;
      this.validateUtil = ValidateUtil;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.modalService = $uibModal;
      this.tipoPermissaoEnum = TipoPermissaoEnum;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.isIntegrationCodeLandmarkEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_INTEGRATION_CODE_LANDMARK);
      this.FIELDS_PONTOS_REFERENCIA = ['id', 'nome', 'categoriaNome', 'uo.nome', 'localizacao', 'logradouro', 'lat', 'lng', 'raio', 'obs', 'hasRotograma', 'tempoPermanenciaMinimo', 'tipoPermissao', 'codigoIntegracao'];
      this.USUARIOS_IMPORTACAO = {
        'ana_padua@trimble.com': true,
        'daniel_silva@trimble.com': true,
        'gabriel_giovani@trimble.com': true,
        'gustavo_paiva@trimble.com': true,
        'jean_camillo@trimble.com': true,
        'joao_barroso@trimble.com': true,
        'jose_neto@trimble.com': true,
        'leandro_soares@trimble.com': true,
        'marcos_nakamura@trimble.com': true,
        'rafael_arabori@trimble.com': true,
        'renan_rodrigues@trimble.com': true
      };
      this.usuarioLogado = null;
      this.authenticator.getUser().then(function (user) {
        _this.usuarioLogado = user.login;
        _this.uoId = user ? user.uo.id : null;
      });

      this.vtabela = null;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.roleVisualizarMapa = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('LOCALIZACAO_ATUAL_VISUALIZAR');
        _this.roleVisualizarPonto = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PONTO_REFERENCIA_VISUALIZAR');
        _this.roleEditarPontoReferencia = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PONTO_REFERENCIA_EDITAR');
        _this.roleEditarPermanenciaPonto = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('PERMANENCIA_PONTO_REFERENCIA_EDITAR');
        _this.carregarPontosReferencia();
      });
    }

    _createClass(PontoReferencia, [{
      key: 'getMaisOpcoesMsg',
      value: function getMaisOpcoesMsg() {
        if (!this.roleEditarPontoReferencia) {
          return this.translate.instant('ce.cadastro.pontosReferencia.msgSemPermissao');
        }

        if (!this.getEditableRowsSelected().length) {
          return this.translate.instant('ce.cadastro.pontosReferencia.msgSelecionePontoPermissao');
        }

        return null;
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var exporterBaseName = this.translate.instant('ce.cadastro.pontosReferencia.exporter');
        var objVtabela = {
          exporterPdfFilename: exporterBaseName + '.pdf',
          exporterCsvFilename: exporterBaseName + '.csv',
          exporterExcelFilename: exporterBaseName + '.xlsx',
          appScopeProvider: this,
          columnDefs: [{
            name: 'id',
            displayName: 'Id',
            type: 'string',
            enableHiding: Boolean(this.USUARIOS_IMPORTACAO[this.usuarioLogado]),
            visible: false
          }, {
            name: 'nome',
            displayName: 'ce.cadastro.pontosReferencia.colunas.nome',
            type: 'string',
            pinnedLeft: true,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents">\n                <i\n                  ng-if="!grid.appScope.tipoPermissaoEnum.podeEditar(row.entity.tipoPermissao)"\n                  class="fa fa-minus-circle"\n                  uib-tooltip="{{ \'ce.cadastro.pontosReferencia.tooltipSemPermissao\' | translate }}">\n                </i>\n                <span ng-class=\'{"no-icon": grid.appScope.tipoPermissaoEnum.podeEditar(row.entity.tipoPermissao)}\'>\n                  {{row.entity.nome}}\n                </span>\n              </div>'
          }, {
            name: 'categoriaNome',
            displayName: 'ce.cadastro.pontosReferencia.colunas.categoria',
            type: 'string',
            cellFilter: 'withLabelToUndefined:\'-\'',
            enableHiding: false,
            pinnedLeft: true
          }, {
            name: 'uoNome',
            displayName: 'ce.cadastro.pontosReferencia.colunas.uo',
            type: 'string',
            enableHiding: false
          }, {
            name: 'localizacao',
            displayName: 'ce.cadastro.pontosReferencia.colunas.localizacao',
            type: 'string'
          }, {
            name: 'logradouro',
            displayName: 'ce.cadastro.pontosReferencia.colunas.logradouro',
            type: 'string',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{row.entity.logradouro}}">\n                <a ng-href=\'{{(row.entity.link)}}\' target=\'_blank\' ng-if=\'grid.appScope.roleVisualizarMapa && grid.appScope.roleVisualizarPonto\'>\n                  {{ grid.appScope.filtroLogradouro(row.entity.logradouro)}}\n                </a>\n                <span ng-if=\'!grid.appScope.roleVisualizarMapa && !grid.appScope.roleVisualizarPonto\'> {{row.entity.logradouro}} </span>\n                <span ng-if=\'!grid.appScope.roleVisualizarMapa && grid.appScope.roleVisualizarPonto\'> {{row.entity.logradouro}} </span>\n              </div>\n              '
          }, {
            name: 'raio',
            displayName: 'ce.cadastro.pontosReferencia.colunas.raio',
            type: 'number',
            cellClass: 'text-center',
            headerCellClass: 'text-center'
          }, {
            name: 'coordenada',
            displayName: 'ce.cadastro.pontosReferencia.colunas.coordenada',
            type: 'string',
            cellClass: 'text-center',
            headerCellClass: 'text-center'
          }, {
            name: 'observacao',
            displayName: 'ce.cadastro.pontosReferencia.colunas.observacao',
            type: 'string'
          }, {
            name: 'hasRotograma',
            displayName: 'ce.cadastro.pontosReferencia.colunas.rotograma.displayName',
            type: 'string',
            enableFiltering: false,
            enableColumnResizing: false,
            width: 100,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents text-center\'>\n                <span\n                  ng-if=\'row.entity.hasRotograma\' class=\'fa fa-check\'\n                  title="{{ \'ce.cadastro.pontosReferencia.colunas.rotograma.content\' | translate }}"/>\n              </div>\n              '
          }, {
            name: 'tempoPermanenciaMinimo',
            displayName: 'ce.cadastro.pontosReferencia.colunas.tempoPermanencia',
            filterCellFiltered: true,
            cellFilter: 'humanizedOrUndefinedWithLabel:\'-\'',
            cellClass: 'text-center'
          }, {
            name: 'codigoIntegracao',
            displayName: 'ce.cadastro.pontosReferencia.colunas.codigoIntegracao',
            type: 'string',
            enableHiding: this.isIntegrationCodeLandmarkEnabled,
            visible: false
          }]
        };

        return objVtabela;
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/ponto-referencia/v2/pontos-referencia/csv';
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.id,
          nome: item.nome,
          latitude: item.lat,
          longitude: item.lng,
          raio: item.raio,
          uoNome: item.uo.nome,
          localizacao: item.localizacao,
          logradouro: item.logradouro,
          observacao: item.obs,
          categoriaNome: item.categoriaNome,
          coordenada: item.lat.toString().replace('.', ',') + ', ' + item.lng.toString().replace('.', ','),
          link: '/mapas-grid?ponto=' + item.id + '&forceRenderLayer=true',
          hasRotograma: item.hasRotograma,
          tempoPermanenciaMinimo: item.tempoPermanenciaMinimo,
          tipoPermissao: item.tipoPermissao,
          codigoIntegracao: item.codigoIntegracao
        };
      }
    }, {
      key: 'carregarPontosReferencia',
      value: function carregarPontosReferencia() {
        var _this2 = this;

        this.pontosReferenciaService.getPontosReferenciaV2({
          fields: this.FIELDS_PONTOS_REFERENCIA.toString()
        }).then(function (data) {
          _this2.vtabela = _this2.vtabelaFactory.get(_this2.initVtabela(), _this2.serviceVfiltro.factoryVfiltro.user, 'cadastroPontos', 'v2');
          _this2.vtabela.setData(data.map(function (i) {
            return _this2.getItemVtabela(i);
          }));
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.cadastro.pontosReferencia.errorMessage'),
            appendTo: '.alerta-aqui-ponto'
          });
        });
      }
    }, {
      key: 'abrirTempoPermanenciaConfig',
      value: function abrirTempoPermanenciaConfig(_pontos) {
        var _this3 = this;

        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/ponto-referencia/tempo-permanencia/tempo-permanencia' + (remove ? '-remove' : '') + '.tpl.html',
          controller: 'TempoPermanenciaCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            pontos: function pontos() {
              return _pontos;
            }
          }
        }).result.then(function (values) {
          return _this3.rebuildPontos(values.data, remove);
        }).catch(function (erro) {
          if (erro && erro.msg) {
            _this3.alertMessage.create({
              type: 'error',
              message: erro.msg,
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'rebuildPontos',
      value: function rebuildPontos(pontosAtualizados, remove) {
        var _this4 = this;

        if (pontosAtualizados.length > 0) {
          pontosAtualizados.forEach(function (p) {
            var itemTabela = _this4.vtabela.grid.data.find(function (x) {
              return x.id === p.id;
            });
            if (itemTabela) {
              angular.merge(itemTabela, {
                tempoPermanenciaMinimo: p.tempoPermanenciaMinimo
              });
            }
          });
          this.alertMessage.create({
            type: 'success',
            message: this.translate.instant('ce.cadastro.pontosReferencia.successMessage', {
              msg: remove ? this.translate.instant('ce.cadastro.pontosReferencia.removida') : this.translate.instant('ce.cadastro.pontosReferencia.cadastrada')
            }),
            appendTo: '.alerta-aqui'
          });
        }
      }
    }, {
      key: 'filtroLogradouro',
      value: function filtroLogradouro(logradouro) {
        return !this.validateUtil.temLogradouro(logradouro) ? this.translate.instant('ce.cadastro.pontosReferencia.verNoMapa') : logradouro;
      }
    }, {
      key: 'getEditableRowsSelected',
      value: function getEditableRowsSelected() {
        var _this5 = this;

        if (!this.vtabela || !this.vtabela.rowsSelected) {
          return [];
        }
        return this.vtabela.rowsSelected.filter(function (i) {
          return _this5.tipoPermissaoEnum.podeEditar(i.tipoPermissao);
        });
      }
    }, {
      key: 'podeExibirOpcoes',
      value: function podeExibirOpcoes() {
        return this.getEditableRowsSelected().length > 0 && this.roleEditarPermanenciaPonto;
      }
    }, {
      key: 'podeExibirOpcoesImportacao',
      value: function podeExibirOpcoesImportacao() {
        return Boolean(this.USUARIOS_IMPORTACAO[this.usuarioLogado]);
      }
    }, {
      key: 'abrirModalImportacao',
      value: function abrirModalImportacao(pontos) {
        /* eslint-disable */
        var botaoImportar = document.querySelector('#abrirModal'),
            abrirModal = document.createElement('vfwc-abrir-importacao-ponto-modal'); /* eslint-enable */
        abrirModal.uoIdUsuario = this.uoId;
        abrirModal.pontos = pontos;
        botaoImportar.appendChild(abrirModal);
      }
    }, {
      key: 'abrirCodigoIntegracaoCadastro',
      value: function abrirCodigoIntegracaoCadastro(_pontos2) {
        var _this6 = this;

        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/ponto-referencia/codigo-integracao/codigo-integracao' + (remove ? '-remove' : '') + '.tpl.html',
          controller: 'CodigoIntegracaoCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            pontos: function pontos() {
              return _pontos2;
            }
          }
        }).result.then(function (values) {
          return _this6.rebuildPontosCodigoIntegracao(values.data, remove);
        }).catch(function (erro) {
          if (erro && erro.msg) {
            _this6.alertMessage.create({
              type: 'error',
              message: erro.msg,
              appendTo: '.alerta-aqui'
            });
          }
        });
      }
    }, {
      key: 'rebuildPontosCodigoIntegracao',
      value: function rebuildPontosCodigoIntegracao(pontosAtualizados, remove) {
        var _this7 = this;

        if (pontosAtualizados.length > 0) {
          pontosAtualizados.forEach(function (p) {
            var itemTabela = _this7.vtabela.grid.data.find(function (x) {
              return x.id === p.id;
            });
            if (itemTabela) {
              angular.merge(itemTabela, {
                codigoIntegracao: p.codigoIntegracao
              });
            }
          });
          this.alertMessage.create({
            type: 'success',
            message: this.translate.instant('ce.cadastro.pontosReferencia.successCodigoIntegracaoMessage', {
              msg: remove ? this.translate.instant('ce.cadastro.pontosReferencia.removido') : this.translate.instant('ce.cadastro.pontosReferencia.cadastrado')
            }),
            appendTo: '.alerta-aqui'
          });
        }
      }
    }]);

    return PontoReferencia;
  }();

  angular.module('cadastros.pontoReferencia').controller('PontoReferenciaCtrl', PontoReferencia);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MotoristaService = function () {
    function MotoristaService(Restangular) {
      _classCallCheck(this, MotoristaService);

      this.restangular = Restangular;
    }

    _createClass(MotoristaService, [{
      key: 'getMotoristasSemFoto',
      value: function getMotoristasSemFoto(userUoId) {
        return this.restangular.all('/motorista/v2/motoristas?fields=id,fotos&uoIds=' + userUoId).getList();
      }
    }, {
      key: 'getQRCode',
      value: function getQRCode(motoristaUoId, motoristaId) {
        return this.restangular.one('/motorista/motoristas/' + motoristaUoId + '/qrcode/' + motoristaId + '/base64').get();
      }
    }]);

    return MotoristaService;
  }();

  angular.module('motoristaModule').service('MotoristaService', MotoristaService);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.motorista
   * @description
   *
   */

  angular.module('cadastros.motorista', ['ui.router', 'ng-mfb', 'restangular', 'alert-message', 'httpServiceV3gModule', 'motoristaModule', 'middlewareModule', 'angularMoment', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'enumModule', 'VtabelaModule', 'v3gAuthenticatorModule', 'pascalprecht.translate', 'FeatureFlagModule', 'urlConfigModule', 'cadastros.motorista.filters']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.motorista').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.motorista', {
      url: '/motorista?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'cadastros/motorista/motorista.tpl.html',
          controller: 'MotoristaCtrl',
          controllerAs: 'motoristaCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.motoristas.titulo',
        tituloDescricao: '',
        roles: [['MOTORISTA_MENU_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.motorista.filters', []).filter('hexa', function () {
    return function (codigo, isHexa) {
      return isHexa && codigo ? Number(codigo).toString(16).toUpperCase() : codigo;
    };
  }).filter('dec', function () {
    return function (codigo, isHexa) {
      return isHexa && codigo ? parseInt(codigo, 16) : codigo;
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document, Intl */
(function () {
  'use strict';

  var MotoristaCtrl = function () {
    function MotoristaCtrl(HttpServiceV3g, $uibModal, $filter, AlertMessage, Motoristas, MiddlewareService, moment, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, GoogleTagManagerUtils, $state, VtabelaFactory, uiGridConstants, TipoPermissaoEnum, Authenticator, $translate, FeatureFlag, UrlConfigService, CadastroVeiculoService, SolucoesEnum, MeasurementUnitConverterService, FeatureOuService, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, MotoristaCtrl);

      this.httpService = HttpServiceV3g;
      this.modalService = $uibModal;
      this.filter = $filter;
      this.alertMessage = AlertMessage;
      this.motoristaService = Motoristas;
      this.middlewareService = MiddlewareService;
      this.moment = moment;
      this.keys = Keys;
      this.tipoPermissaoEnum = TipoPermissaoEnum;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.authenticator = Authenticator;
      this.translate = $translate;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureFlag = FeatureFlag;
      this.state = $state;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.urlConfigService = UrlConfigService;
      this.cadastroVeiculoService = CadastroVeiculoService;
      this.solucoesEnum = SolucoesEnum;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.uiGridConstants = uiGridConstants;
      this.vtabelaFactory = VtabelaFactory;
      this.vtabela = null;
      this.files = [];
      this.relatorio = null;
      this.currentPage = 0;
      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.relatorioSafe = null;
      this.ativos = this.translate.instant('ce.cadastro.motoristas.tabela.coluna.status.ativos');
      this.ativoUpperCase = this.translate.instant('ce.cadastro.motoristas.tabela.coluna.status.ativoUpperCase');
      this.inativos = this.translate.instant('ce.cadastro.motoristas.tabela.coluna.status.inativos');
      this.inativoUpperCase = this.translate.instant('ce.cadastro.motoristas.tabela.coluna.status.inativoUpperCase');
      this.documentoStatus = {
        VENCIDO: { label: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.documentoStatus.vencido'), class: 'text-red' },
        PROXIMO_DO_VENCIMENTO: {
          label: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.documentoStatus.proximoDoVencimento'),
          class: 'text-yellow' },
        EM_DIA: { label: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.documentoStatus.emDia'), class: 'text-black' }
      };
      this.possuiFoto = {
        LABEL: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.possuiFoto.label'),
        SIM: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.possuiFoto.sim'),
        NAO: this.translate.instant('ce.cadastro.motoristas.tabela.coluna.possuiFoto.nao')
      };
      this.user = null;
      this.uoWithRecFacial = false;
      this.tooltipApenas1Motorista = this.translate.instant('ce.cadastro.motoristas.botao.maisOpcoes.selecioneApenas1');
      this.displayName = 'ce.cadastro.motoristas.tabela.coluna.apelido';
      this.featureOuService = FeatureOuService;
      this.isGenerateCsvPhotosLinkEnabled = this.featurehubJsSdk.isFeatureEnabled('TTLAINT1555_driver_link');
      this.removeMoreOptions = false;

      this.authenticator.getUser().then(function (user) {
        _this.uoId = user ? user.uo.id : null;
        _this.userPerfilId = user ? user.perfil.id : null;
        _this.user = user;
        _this.isAdminVeltec = user.perfil.id === 1;
        _this.isTTC = user.dataOrigin === 'TTC';
        _this.dateFormat = user.measurementUnits.dateTimeFormat;
        _this.isNaUser = _this.user.isNa;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormat(_this.dateFormat);
        _this.getEventNaConfig(_this.uoId).then(function () {
          _this.featureOuService.getVehicleRegistrationConfig(_this.uoId).then(function (vehicleRegistration) {
            _this.removeMoreOptions = vehicleRegistration;
            _this.displayName = vehicleRegistration ? 'ce.cadastro.motoristas.tabela.coluna.driverId' : 'ce.cadastro.motoristas.tabela.coluna.apelido';
            ServiceVfiltro.init(FactoryVfiltro.get([{
              key: _this.keys.uo.name
            }, {
              key: _this.keys.uoParceira.name
            }])).then(function () {
              _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('MOTORISTA_EDITAR');
              _this.consultar();
              _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'cadastroMotorista', 'v1');
            });
          }).catch(function (error) {
            _this.log.error('Error loading featureOu config: ', error);
          });
        });
      });
    }

    _createClass(MotoristaCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var _this2 = this;

        return {
          appScopeProvider: this,
          exporterFieldCallback: function exporterFieldCallback(grid, row, col, input) {
            if (col.name === 'ativo') {
              if (input) {
                return 'Ativo';
              }
              return 'Inativo';
            }
            if (col.name === 'vencimentoCnh') {
              return _this2.moment(input).format('DD/MM/YYYY');
            }
            return input;
          },
          columnDefs: [{
            name: 'nome',
            displayName: 'ce.cadastro.motoristas.tabela.coluna.nome',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true,
            headerCellFilter: 'translate',
            type: 'string',
            cellTemplate: '\n            <div class="ui-grid-cell-contents">\n              <i ng-if="row.entity.permissao.tipo === \'V\'"\n                class="fa fa-minus-circle permissao-icon"\n                uib-tooltip="{{ \'ce.cadastro.motoristas.tabela.coluna.tooltipColunaNome\' | translate }}">\n              </i>\n              <motorista-link\n                motorista="row.entity.nome"\n                motorista-id="row.entity.id"\n                has-permission="true"\n                index="$index">\n              </motorista-link>\n            </div>'
          }, {
            name: 'apelido',
            displayName: this.displayName,
            type: 'string'
          }, { name: 'cpf', displayName: 'ce.cadastro.motoristas.tabela.coluna.cpf', type: 'number', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, { name: 'documentoIdentificador', displayName: 'motorista.documentoIdentificador', type: 'string', cellClass: 'text-center', headerCellClass: 'text-center' }, { name: 'uoNome', displayName: 'ce.cadastro.motoristas.tabela.coluna.uo', type: 'string', enableHiding: false }, { name: 'departamento', displayName: 'ce.cadastro.motoristas.tabela.coluna.departamento', type: 'string', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, {
            name: 'telefone',
            displayName: 'ce.cadastro.motoristas.tabela.coluna.telefoneMotorista',
            type: 'number',
            cellFilter: 'brPhoneNumber',
            visible: !this.eventNaConfig
          }, { name: 'codigo', displayName: 'ce.cadastro.motoristas.tabela.coluna.codigo', type: 'number', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, { name: 'ibutton', displayName: 'ce.cadastro.motoristas.tabela.coluna.iButton', type: 'string', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, { name: 'tag', displayName: 'ce.cadastro.motoristas.tabela.coluna.rfid', type: 'number', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, { name: 'formato', displayName: 'ce.cadastro.motoristas.tabela.coluna.formato', type: 'number', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, {
            name: 'statusDocumento',
            displayName: 'ce.cadastro.motoristas.tabela.coluna.documentosDoMotorista',
            enableSorting: true,
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents status-documento {{ row.entity.statusDocumentoStyle }}\'>\n              <a ng-click=\'grid.appScope.redirectToDocumentos(row.entity.motoristaRow.id)\' class="{{ row.entity.statusDocumentoStyle }}"\n              title="{{ row.entity.statusDocumento }}">\n                {{ row.entity.statusDocumento }}\n              </a>\n            </div>',
            visible: this.featureFlag.DOCUMENTOS_MOTORISTA && !this.eventNaConfig
          }, { name: 'email', displayName: 'ce.cadastro.motoristas.tabela.coluna.email', visible: !this.eventNaConfig, type: 'string' }, { name: 'pis', displayName: 'ce.cadastro.motoristas.tabela.coluna.pis', type: 'number', cellClass: 'text-center', headerCellClass: 'text-center', visible: !this.eventNaConfig, enableHiding: !this.eventNaConfig }, { name: 'cnh', displayName: 'ce.cadastro.motoristas.tabela.coluna.cnh', type: 'number', cellClass: 'text-center', visible: !this.eventNaConfig, headerCellClass: 'text-center' }, {
            name: 'vencimentoCnh',
            displayName: 'ce.cadastro.motoristas.tabela.coluna.vencimentoCnh',
            type: 'date',
            cellFilter: 'date:\'dd/MM/yyyy\'',
            filterCellFiltered: true,
            visible: !this.eventNaConfig
          }, {
            name: 'ativo',
            displayName: 'ce.cadastro.motoristas.tabela.coluna.status.label',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: true, label: this.ativos }, { value: false, label: this.inativos }]
            },
            type: 'boolean',
            cellTemplate: '\n            <div\n              class="ui-grid-cell-contents text-center">\n              {{ grid.appScope.getStatus(row.entity.ativo) }}\n            </div>'
          }, {
            name: 'possuiFoto',
            displayName: this.possuiFoto.LABEL,
            type: 'boolean',
            cellClass: 'text-center',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.EXACT,
              selectOptions: [{ value: true, label: this.possuiFoto.SIM }, { value: false, label: this.possuiFoto.NAO }]
            },
            visible: false,
            cellTemplate: '\n            <div>\n              {{ grid.appScope.getLabelPossuiFoto(row.entity.possuiFoto) }}\n            </div>'
          }, {
            name: 'editarCadastro',
            displayName: '',
            headerCellTemplate: '\n            <span\n              class="fa fa-info-circle info-editar-icon"\n              uib-tooltip="{{ \'ce.cadastro.motoristas.tabela.coluna.tooltip\' | translate }}"\n              tooltip-placement="top-right">\n            </span>',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 55,
            cellTemplate: '\n            <a ng-if="row.entity.permissaoEditar && grid.appScope.uosReplicadores.length === 0"\n            id="motorista-id-{{row.entity.motoristaRow.id}}"\n            ng-click=\'grid.appScope.modalEditar(row.entity.motoristaRow)\'\n            class="fa fa-pencil" ng-class="grid.appScope.showWarnPencil(row.entity.motoristaRow) ? \'icone-warn\' : \'icone\'"\n            uib-tooltip="{{ grid.appScope.getTooltipEditMotorista(row.entity.motoristaRow) }}"></a>'
          }, {
            name: 'cadastroDocumentos',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 55,
            cellTemplate: '\n            <a ng-if="row.entity.ativo"\n            uib-tooltip="{{ \'ce.cadastro.motoristas.tabela.coluna.documentosTooltip\' | translate }}"\n            ng-click=\'grid.appScope.redirectToDocumentos(row.entity.motoristaRow.id)\'\n            class="fa fa-file-text icone"></a>',
            visible: this.featureFlag.DOCUMENTOS_MOTORISTA && this.roleCadastrar
          }, {
            name: 'motoristaSync',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            visible: this.isTTC,
            headerCellTemplate: '\n            <span\n              class="fa trimble-cloud-connected info-motorista-sync-icon"\n            </span>',
            exporterSuppressExport: true,
            width: 55,
            cellTemplate: '\n            <a ng-if="row.entity.dateSync"\n            uib-tooltip="{{ \'ce.cadastro.motoristas.tabela.coluna.ultimoUpdateTooltip\' | translate: { lastSyncUpdate: row.entity.dateSync } }}"\n            tooltip-placement="top-right"\n            tooltip-class="custom-tooltip"\n            class="fa trimble-cloud-connected icone"></a>'
          }]
        };
      }
    }, {
      key: 'insertQuandoFeatureAtiva',
      value: function insertQuandoFeatureAtiva(condition, element) {
        return condition ? [element] : [];
      }
    }, {
      key: 'getTooltipEditMotorista',
      value: function getTooltipEditMotorista(motorista) {
        return this.showWarnPencil(motorista) ? this.translate.instant('ce.cadastro.motoristas.tabela.coluna.editarCadastroTooltip') : '';
      }
    }, {
      key: 'showWarnPencil',
      value: function showWarnPencil(motorista) {
        return this.uoWithRecFacial && !motorista.allRequiredImagesValidated;
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this3 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this3.keys.uo.name;
        }).value.id,
            uoParceira = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this3.keys.uoParceira.name;
        }),
            solucaoId = this.featureFlag.SOLUCAO_REC_FACIAL ? this.solucoesEnum.RECONHECIMENTO_FACIAL : null;
        this.cadastroVeiculoService.hasRecFacial(uoId, solucaoId).then(function (uoHasRecFacial) {
          return _this3.uoWithRecFacial = uoHasRecFacial;
        });
        this.motoristaService.getTodosByUo(uoId, uoParceira ? uoParceira.value.id : '').then(function (motoristas) {
          _this3.motoristas = motoristas;
          _this3.getMotoristaUoReplicador();
        }).catch(function () {
          return _this3.vtabela.setError();
        });
      }
    }, {
      key: 'getStatus',
      value: function getStatus(ativo) {
        return ativo ? this.ativoUpperCase : this.inativoUpperCase;
      }
    }, {
      key: 'getMotoristaUoReplicador',
      value: function getMotoristaUoReplicador() {
        var _this4 = this;

        var uosMotoristas = [].concat(_toConsumableArray(new Set(this.motoristas.map(function (motorista) {
          return motorista.uo.id;
        })))).join();
        this.middlewareService.getUosComIntegracaoMotoristas(uosMotoristas).then(function (uosReplicadores) {
          _this4.uosReplicadores = uosReplicadores;
          _this4.configurarBotaoCadastroMotorista();
          _this4.setDataVtabela();
          _this4.uosCadastraveis = _this4.uosSemReplicador();
        }).catch(function () {
          return _this4.vtabela.setError();
        });
      }
    }, {
      key: 'setDataVtabela',
      value: function setDataVtabela() {
        var _this5 = this;

        this.vtabela.setData(this.motoristas.map(function (item) {
          return _this5.getItemVtabela(item);
        }));
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        item.telefone = item.telefone ? item.telefone.replace(/\D/g, '') : null;
        return {
          id: item.id,
          permissao: item.permissao,
          nome: item.nome,
          departamento: item.departamento && item.departamento.nome,
          ibutton: item.ibutton,
          email: item.email,
          uo: item.uo,
          uoNome: item.uo.nome,
          cpf: item.cpf,
          documentoIdentificador: item.documentoIdentificador,
          tag: this.filter('hexa')(item.tag, item.tagHexadecimal),
          formato: Number(item.tagHexadecimal),
          codigo: item.codigo,
          pis: item.pis,
          cnh: item.cnh,
          vencimentoCnh: item.vencimentoCnh,
          ativo: item.ativo,
          permissaoEditar: this.isMotoristaEditavel(item.uo.id, item.permissao.tipo),
          motoristaRow: item,
          telefone: item.telefone,
          apelido: item.apelido,
          statusDocumento: item.statusDocumento && this.documentoStatus[item.statusDocumento].label,
          statusDocumentoStyle: item.statusDocumento && this.documentoStatus[item.statusDocumento].class,
          possuiFoto: this.hasFotoCadastro(item.fotos),
          dateSync: this.filter('date')(item.datetimeTtcSync, this.dateTimeFormat)
        };
      }
    }, {
      key: 'hasFotoCadastro',
      value: function hasFotoCadastro(fotos) {
        return Boolean(fotos && fotos.find(function (foto) {
          return foto.fotoCadastro && !foto.excluido && !foto.pretoBranco;
        }));
      }
    }, {
      key: 'getLabelPossuiFoto',
      value: function getLabelPossuiFoto(hasFoto) {
        return hasFoto ? this.possuiFoto.SIM : this.possuiFoto.NAO;
      }
    }, {
      key: 'isMotoristaEditavel',
      value: function isMotoristaEditavel(uoId, permissao) {
        return !this.uosReplicadores.includes(uoId) && this.roleCadastrar && this.tipoPermissaoEnum.podeEditar(permissao);
      }
    }, {
      key: 'rowsAreValid',
      value: function rowsAreValid() {
        return this.motoristasEditaveis(true).length + this.motoristasEditaveis(false).length + this.motoristasComEmail().length > 0;
      }
    }, {
      key: 'activeDrivers',
      value: function activeDrivers() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.vtabela.rowsSelected;
        var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        return list.filter(function (m) {
          return m.permissao.tipo !== 'V' && m.ativo === active;
        });
      }
    }, {
      key: 'motoristasEditaveis',
      value: function motoristasEditaveis(ativo) {
        if (this.vtabela) {
          var lista = this.vtabela.rowsSelected.length === 0 ? this.vtabela.grid.data : this.vtabela.rowsSelected;
          return this.activeDrivers(lista, ativo);
        }
        return [];
      }
    }, {
      key: 'motoristasComEmail',
      value: function motoristasComEmail() {
        if (this.vtabela) {
          var lista = this.vtabela.rowsSelected.length === 0 ? this.vtabela.grid.data : this.vtabela.rowsSelected;
          return lista.filter(function (m) {
            return m.email;
          });
        }
        return [];
      }
    }, {
      key: 'handleCanGenerateLink',
      value: function handleCanGenerateLink() {
        return this.roleCadastrar && this.activeDrivers(this.vtabela.rowsSelected, true).length > 0;
      }
    }, {
      key: 'handleGenerateLink',
      value: function handleGenerateLink(_motoristas) {
        var _this6 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/motorista/motorista-link.tpl.html',
          controller: 'MotoristaLinkConfirmationCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristas: function motoristas() {
              return _motoristas;
            },
            httpService: function httpService() {
              return _this6.httpService;
            },
            uo: function uo() {
              return _this6.serviceVfiltro.filtroTopbar.find(function (x) {
                return x.key === _this6.keys.uo.name;
              }).value.id;
            }
          }
        });
      }
    }, {
      key: 'uosSemReplicador',
      value: function uosSemReplicador() {
        var _this7 = this;

        return this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this7.keys.uo.name;
        }).defaultValues.filter(function (x) {
          return !_this7.uosReplicadores.includes(x.id);
        });
      }
    }, {
      key: 'modalEditar',
      value: function modalEditar(motorista) {
        /* eslint-disable */
        var botaoEditar = document.querySelector('#motorista-id-' + motorista.id),
            abrirModal = document.createElement('vfwc-abrir-editar-motorista'); /* eslint-enable */
        abrirModal.uoId = this.uoId;
        abrirModal.motorista = motorista;
        abrirModal.userPerfilId = this.userPerfilId;
        abrirModal.uoWithRecFacial = this.uoWithRecFacial;
        abrirModal.isNa = this.isNaUser;
        botaoEditar.innerHTML = '';
        botaoEditar.appendChild(abrirModal);
        this.onMotoristaSalvo(abrirModal);
      }
    }, {
      key: 'replaceValue',
      value: function replaceValue(motoristaEdited) {
        var motorista = this.motoristas.find(function (item) {
          return motoristaEdited.id === item.id;
        });
        Object.keys(motoristaEdited).forEach(function (key) {
          return motorista[key] = motoristaEdited[key];
        });
        this.setDataVtabela();
      }
    }, {
      key: 'ativarInativar',
      value: function ativarInativar(motorista) {
        if (motorista.ativo) {
          this.ativar([motorista]);
        } else {
          this.inativar([motorista]);
        }
      }
    }, {
      key: 'confirmacaoAtivar',
      value: function confirmacaoAtivar(_motoristas2) {
        var _this8 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/motorista/motorista-confirmacao.tpl.html',
          controller: 'MotoristaConfirmacaoCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristas: function motoristas() {
              return _motoristas2;
            },
            motoristaCtrl: function motoristaCtrl() {
              return _this8;
            },
            ativando: function ativando() {
              return true;
            }
          }
        });
      }
    }, {
      key: 'ativar',
      value: function ativar(motoristas) {
        var _this9 = this;

        this.motoristaService.ativar(motoristas.map(function (m) {
          return m.id;
        })).then(function (result) {
          if (!result.success) {
            _this9.alertMessage.create({
              type: 'warning',
              message: _this9.translate.instant('ce.cadastro.motoristas.modal.confirmacao.erroAoAtivarMotoristas'),
              appendTo: '.alerta-aqui-motorista'
            });
          }
          motoristas.forEach(function (m, index) {
            m.ativo = result.data[index].ativo;
          });
        });
      }
    }, {
      key: 'confirmacaoInativar',
      value: function confirmacaoInativar(_motoristas3) {
        var _this10 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/motorista/motorista-confirmacao.tpl.html',
          controller: 'MotoristaConfirmacaoCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristas: function motoristas() {
              return _motoristas3;
            },
            motoristaCtrl: function motoristaCtrl() {
              return _this10;
            },
            ativando: function ativando() {
              return false;
            }
          }
        });
      }
    }, {
      key: 'inativar',
      value: function inativar(motoristas) {
        var _this11 = this;

        this.motoristaService.inativar(motoristas.map(function (m) {
          return m.id;
        })).then(function (result) {
          if (!result.success) {
            _this11.alertMessage.create({
              type: 'warning',
              message: _this11.translate.instant('ce.cadastro.motoristas.modal.confirmacao.erroAoInativarMotoristas'),
              appendTo: '.alerta-aqui-motorista'
            });
          }
          motoristas.forEach(function (m, index) {
            m.ativo = result.data[index].ativo;
          });
        });
      }
    }, {
      key: 'abrirQrCode',
      value: function abrirQrCode(_motorista) {
        var _this12 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/motorista/motorista-qrmodal.tpl.html',
          controller: 'ModalQrCtrl',
          controllerAs: '$ctrl',
          size: 'md',
          resolve: {
            motorista: function motorista() {
              return _motorista;
            },
            motoristaCtrl: function motoristaCtrl() {
              return _this12;
            }
          }
        });
      }
    }, {
      key: 'enviarEmails',
      value: function enviarEmails(_motoristas4) {
        var _this13 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/motorista/motorista-emailmultiplomodal.tpl.html',
          controller: 'ModalEmailMultiploCtrl',
          controllerAs: '$ctrl',
          size: 'email',
          resolve: {
            motoristas: function motoristas() {
              return _motoristas4;
            },
            httpService: function httpService() {
              return _this13.httpService;
            },
            uo: function uo() {
              return _this13.serviceVfiltro.filtroTopbar.find(function (x) {
                return x.key === _this13.keys.uo.name;
              }).value.id;
            },
            motoristaCtrl: function motoristaCtrl() {
              return _this13;
            }
          }
        });
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        var _this14 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this14.keys.uo.name;
        }).value.id;
        var uoParceira = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this14.keys.uoParceira.name;
        });

        if (uoParceira) {
          uoParceira = uoParceira.value.id;
        }

        return '/motorista/motoristas/' + uoId + '/csv?uoDona=' + (uoParceira ? uoParceira : '') + '&timezone=' + this.currentTimezone;
      }
    }, {
      key: 'selecionouMotoristaInativo',
      value: function selecionouMotoristaInativo() {
        var selecionouMotoristaInativo = this.vtabela.rowsSelected.length === 1 && !this.vtabela.rowsSelected[0].ativo;
        return selecionouMotoristaInativo || this.vtabela.rowsSelected.length === 0;
      }
    }, {
      key: 'hasMotoristasComEmail',
      value: function hasMotoristasComEmail() {
        return this.motoristasComEmail().length > 0;
      }
    }, {
      key: 'configurarBotaoCadastroMotorista',
      value: function configurarBotaoCadastroMotorista() {
        /* eslint-disable */
        var btnCadastrarMotorista = document.querySelector('vfwc-btn-cadastro-motorista');
        if (this.roleCadastrar && !this.uosReplicadores.length && !btnCadastrarMotorista) {
          var elementContainer = document.querySelector('#botaoCadastrarMotorista'),
              btnCadastrarMotoristaElement = document.createElement('vfwc-btn-cadastro-motorista');
          /* eslint-enable */

          btnCadastrarMotoristaElement.uoId = Number(this.uoId);
          btnCadastrarMotoristaElement.uoWithRecFacial = this.uoWithRecFacial;
          btnCadastrarMotoristaElement.isNa = this.isNaUser;
          elementContainer.appendChild(btnCadastrarMotoristaElement);
          this.onMotoristaSalvo(btnCadastrarMotoristaElement);
        }
      }
    }, {
      key: 'onMotoristaSalvo',
      value: function onMotoristaSalvo(element) {
        var _this15 = this;

        element.addEventListener('emiteSucesso', function (event) {
          if (event.detail && event.detail.salvoComSucesso) {
            _this15.consultar();
          }
        });
      }
    }, {
      key: 'redirectToDocumentos',
      value: function redirectToDocumentos(motoristaId) {
        var _this16 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this16.keys.uo.name;
        }).value.id;
        this.sendClickGTM();
        this.state.go('root.documentos', {
          vfiltro: 'motoristas:' + motoristaId + ';uo:' + uoId,
          podeEditar: this.roleCadastrar && this.uosReplicadores.length === 0
        });
      }
    }, {
      key: 'disableAtivarInativar',
      value: function disableAtivarInativar(length) {
        return (length > 1 || length === 0) && !this.isAdminVeltec;
      }
    }, {
      key: 'sendClickGTM',
      value: function sendClickGTM() {
        if (this.user) {
          this.googleTagManagerUtils.sendEventClickGTM('motorista_ver_documento', this.user);
        }
      }
    }, {
      key: 'getEventNaConfig',
      value: function getEventNaConfig(uoId) {
        var _this17 = this;

        return this.featureOuService.getEventsConfig(uoId).then(function (eventNaConfig) {
          _this17.eventNaConfig = eventNaConfig;
        });
      }
    }]);

    return MotoristaCtrl;
  }();

  var MotoristaConfirmacao = function () {
    function MotoristaConfirmacao($uibModalInstance, motoristas, motoristaCtrl, ativando) {
      _classCallCheck(this, MotoristaConfirmacao);

      this.motoristas = motoristas;
      this.modalInstance = $uibModalInstance;
      this.motoristaCtrl = motoristaCtrl;
      this.ativando = ativando;
    }

    _createClass(MotoristaConfirmacao, [{
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'mostrarTexto',
      value: function mostrarTexto() {
        return this.ativando ? 'ce.cadastro.motoristas.modal.confirmacao.msgAtivar' : 'ce.cadastro.motoristas.modal.confirmacao.msgInativar';
      }
    }, {
      key: 'getTitle',
      value: function getTitle() {
        return this.ativando ? 'ce.cadastro.motoristas.modal.confirmacao.tituloAtivando' : 'ce.cadastro.motoristas.modal.confirmacao.tituloInativando';
      }
    }, {
      key: 'confirmacaoAtivar',
      value: function confirmacaoAtivar() {
        this.motoristaCtrl.ativar(this.motoristas);
        this.ok();
      }
    }, {
      key: 'confirmacaoInativar',
      value: function confirmacaoInativar() {
        this.motoristaCtrl.inativar(this.motoristas);
        this.ok();
      }
    }]);

    return MotoristaConfirmacao;
  }();

  var MotoristaQRCode = function () {
    function MotoristaQRCode($uibModalInstance, motorista, motoristaCtrl, UrlConfigService, MotoristaService) {
      _classCallCheck(this, MotoristaQRCode);

      this.motorista = motorista;
      this.modalInstance = $uibModalInstance;
      this.motoristaCtrl = motoristaCtrl;
      this.urlConfigService = UrlConfigService;
      this.motoristaService = MotoristaService;

      this.qrCodeImage = null;
      this.init();
    }

    _createClass(MotoristaQRCode, [{
      key: 'init',
      value: function init() {
        var _this18 = this;

        this.motoristaService.getQRCode(this.motorista.uo.id, this.motorista.id).then(function (result) {
          _this18.qrCodeImage = 'data:image/png;base64,' + result.qrCodeBase64;
        });
      }
    }, {
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'download',
      value: function download() {
        var anchor = angular.element('<a/>');
        anchor.attr({
          href: this.qrCodeImage,
          target: '_blank',
          download: 'qrcode-uo-' + this.motorista.uo.id + '-motorista-' + this.motorista.id + '.png'
        })[0].click();
      }
    }]);

    return MotoristaQRCode;
  }();

  var MotoristaEmailMultiplo = function () {
    function MotoristaEmailMultiplo($uibModalInstance, motoristas, httpService, uo, motoristaCtrl) {
      _classCallCheck(this, MotoristaEmailMultiplo);

      this.motoristas = motoristas;
      this.modalInstance = $uibModalInstance;
      this.httpService = httpService;
      this.enviando = false;
      this.uo = uo;
      this.result = false;
      this.motoristaCtrl = motoristaCtrl;
    }

    _createClass(MotoristaEmailMultiplo, [{
      key: 'ok',
      value: function ok() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'enviarEmails',
      value: function enviarEmails() {
        var _this19 = this;

        this.enviando = true;
        this.httpService.post('/motorista/motoristas/' + this.uo + '/email', this.motoristas.map(function (m) {
          return m.id;
        })).success(function (data) {
          _this19.result = data;
          _this19.result.message = 'ce.cadastro.motoristas.modal.email.emailsEstaoSendoEnviados';
          _this19.enviando = false;
        }).error(function (data) {
          _this19.result = data;
          _this19.result.message = 'ce.cadastro.motoristas.modal.email.erroAoEnviarEmails';
          _this19.enviando = false;
        });
      }
    }]);

    return MotoristaEmailMultiplo;
  }();

  var MotoristaLinkConfirmation = function () {
    function MotoristaLinkConfirmation($uibModalInstance, motoristas, httpService, uo) {
      _classCallCheck(this, MotoristaLinkConfirmation);

      this.motoristas = motoristas;
      this.modalInstance = $uibModalInstance;
      this.httpService = httpService;
      this.isLoading = false;
      this.uo = uo;
    }

    _createClass(MotoristaLinkConfirmation, [{
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }, {
      key: 'generateLink',
      value: function generateLink() {
        var _this20 = this;

        this.isLoading = true;
        this.httpService.post('/motorista/v3/motoristas/driver-photos/csv', this.motoristas.map(function (m) {
          return m.id;
        }), { responseType: 'blob' }).then(function (result) {
          var contentDispositionHeader = result.headers('content-disposition'),
              fileName = contentDispositionHeader ? contentDispositionHeader.split('filename=')[1] : undefined,
              anchor = angular.element('<a/>');
          anchor.attr({
            href: window.URL.createObjectURL(result.data), //eslint-disable-line
            target: '_blank',
            download: fileName ? fileName : 'export.csv'
          })[0].click();
          _this20.isLoading = false;
          _this20.modalInstance.close();
        }).catch(function () {
          _this20.isLoading = false;
          _this20.modalInstance.dismiss();
        });
      }
    }]);

    return MotoristaLinkConfirmation;
  }();

  /**
   * @ngdoc object
   * @name cadastros.motorista.controller:MotoristaCtrl
   *
   * @description
   *
   */


  angular.module('cadastros.motorista').controller('MotoristaCtrl', MotoristaCtrl).controller('ModalQrCtrl', MotoristaQRCode).controller('ModalEmailMultiploCtrl', MotoristaEmailMultiplo).controller('MotoristaConfirmacaoCtrl', MotoristaConfirmacao).controller('MotoristaLinkConfirmationCtrl', MotoristaLinkConfirmation);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.macro
   * @description
   *
   */

  angular.module('cadastros.macro', ['ui.router', 'ui.bootstrap', 'blockUI', 'restangular', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'safetyModule', 'ngSanitize']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.macro').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.macro', {
      url: '/macro?vfiltro&tabIndex',
      views: {
        'content@': {
          templateUrl: 'cadastros/macro/macro.tpl.html',
          controller: 'MacroCtrl',
          controllerAs: 'MacroCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.macro.title',
        hideTitulo: true,
        roles: [['MACRO_VISUALIZAR']]
      }
    });

    $stateProvider.state('root.macro.form', {
      url: '/form/:macroGroupUUID?',
      views: {
        'content@': {
          templateUrl: 'cadastros/macro/form-macro.tpl.html',
          controller: 'FormMacroCtrl',
          controllerAs: 'FormMacroCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.macro.title',
        hideTitulo: true,
        roles: [['MACRO_EDITAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MacroCtrl = function () {
    function MacroCtrl(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, $stateParams) {
      _classCallCheck(this, MacroCtrl);

      this.keys = Keys;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.filtro = null;
      this.user = null;
      this.tabIndex = this.getValidatedTabIndex();

      this.initialize();
    }

    _createClass(MacroCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }])).then(function (filtro) {
          _this2.filtro = filtro;
        });
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this3 = this;

        return this.authenticator.getUser().then(function (user) {
          _this3.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this4 = this;

        var appName = 'safetyApp',
            componentName = './MacroPageRoute',
            componentId = 'safety-macro-page',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this4.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goToMacroGroupForm',
      value: function goToMacroGroupForm(macroGroupUUID) {
        this.state.go('root.macro.form', {
          macroGroupUUID: macroGroupUUID
        });
      }
    }, {
      key: 'getValidatedTabIndex',
      value: function getValidatedTabIndex() {
        var tabIndex = Number(this.stateParams.tabIndex);

        if (tabIndex === 0 || tabIndex === 1) {
          return tabIndex;
        }

        return 0;
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this5 = this;

        return {
          user: this.user,
          filter: {
            ouId: this.filtro.find(function (f) {
              return f.key === _this5.keys.uo.name;
            }).value.id
          },
          tabIndex: this.tabIndex,
          goToMacroGroupForm: function goToMacroGroupForm(macroGroupUUID) {
            return _this5.goToMacroGroupForm(macroGroupUUID);
          }
        };
      }
    }]);

    return MacroCtrl;
  }();

  angular.module('cadastros.macro').controller('MacroCtrl', MacroCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var FormMacroCtrl = function () {
    function FormMacroCtrl(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $stateParams, $state) {
      _classCallCheck(this, FormMacroCtrl);

      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.stateParams = $stateParams;
      this.blockUI = blockUI;
      this.state = $state;

      this.macroGroupUUID = this.stateParams.macroGroupUUID;
      this.user = null;

      this.initialize();
    }

    _createClass(FormMacroCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this2 = this;

        return this.authenticator.getUser().then(function (user) {
          _this2.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this3 = this;

        var appName = 'safetyApp',
            componentName = './MacroGroupFormPageRoute',
            componentId = 'safety-macro-group-form',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this3.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'goBackToList',
      value: function goBackToList(tabIndex) {
        this.state.go('root.macro', {
          tabIndex: tabIndex
        });
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this4 = this;

        return {
          user: this.user,
          macroGroupUUID: this.macroGroupUUID,
          goBackToList: function goBackToList(tabIndex) {
            return _this4.goBackToList(tabIndex);
          }
        };
      }
    }]);

    return FormMacroCtrl;
  }();

  angular.module('cadastros.macro').controller('FormMacroCtrl', FormMacroCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.grupoVeic', {
      url: '/grupoVeic?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'cadastros/grupo-veic/grupo-veic.tpl.html',
          controller: 'GrupoVeicCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.grupoDeVeiculos.titulo',
        role: 'GRUPO_VEICULO_VISUALIZAR'
      }
    });
  }

  angular.module('cadastros.grupoVeic').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var GrupoVeicCtrl = function () {
    function GrupoVeicCtrl(GrupoVeic, $httpParamSerializer, ServiceVfiltro, ObjetosVfiltroService, ModalInfoConfirmService, FactoryVfiltro, Keys, VtabelaFactory, $uibModal, Restangular, AlertMessage, TipoPermissaoEnum, HttpServiceV3g, $sanitize) {
      var _this = this;

      _classCallCheck(this, GrupoVeicCtrl);

      this.$sanitize = $sanitize;
      this.grupoVeicService = GrupoVeic;
      this.serviceVfiltro = ServiceVfiltro;
      this.tipoPermissaoEnum = TipoPermissaoEnum;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.vtabelaFactory = VtabelaFactory;
      this.httpParamSerializer = $httpParamSerializer;
      this.modalService = $uibModal;
      this.httpService = HttpServiceV3g;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.modalInfoConfirmService = ModalInfoConfirmService;

      this.grupos = [];
      this.vtabela = null;
      this.FIELDS_GRUPO_VEIC = ['id', 'nome', 'observacoes', 'quantidadeVeiculosTotal', 'tipoPermissao', 'uo.id', 'uo.nome'];

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.user = _this.serviceVfiltro.factoryVfiltro.user;
        _this.hasRoleEditarGrupo = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('GRUPO_VEICULO_EDITAR');
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'grupoVeic', 'v1');
        _this.consultar();
      });
    }

    _createClass(GrupoVeicCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          appScopeProvider: this,
          enableRowSelection: false,
          enableGridMenu: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableSelectAll: false,
          exportsCsv: false,
          columnDefs: [{
            name: 'nome',
            displayName: 'ce.cadastro.grupoDeVeiculos.colunas.nome',
            type: 'string',
            pinnedLeft: true,
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'observacoes',
            displayName: 'ce.cadastro.grupoDeVeiculos.colunas.observacoes',
            enableHiding: false,
            filterCellFiltered: true,
            cellFilter: 'withLabelToUndefined:\'-\''
          }, {
            name: 'veicTotal',
            displayName: 'ce.cadastro.grupoDeVeiculos.colunas.veicTotal',
            type: 'number',
            cellClass: 'text-center',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'uoNome',
            displayName: 'ce.cadastro.grupoDeVeiculos.colunas.uoNome',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'editar',
            displayName: '',
            enableFiltering: false,
            enableSorting: false,
            pinnedRight: true,
            enableColumnResizing: false,
            enableHiding: false,
            exporterSuppressExport: true,
            width: 70,
            visible: this.hasRoleEditarGrupo,
            cellTemplate: '\n                <div class="ui-grid-cell-contents vtabela-icone-detalhado">\n                  <a class=\'grupo-editar\'\n                  ng-if=\'grid.appScope.hasRoleEditarGrupo &&\n                  grid.appScope.tipoPermissaoEnum.podeEditar(row.entity.item.tipoPermissao)\'\n                  ng-click=\'grid.appScope.modalForm(row.entity.item)\'>\n                    <span class="fa fa-pencil" aria-hidden=\'true\'></span>\n                  </a>\n                </div>'
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'modalForm',
      value: function modalForm(row) {
        var _this2 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'cadastros/grupo-veic/grupo-veic-formmodal/grupo-veic-formmodal.tpl.html',
          controller: 'GrupoVeicFormCtrl',
          controllerAs: '$ctrl',
          size: 'custom-size',
          resolve: {
            grupoRow: function grupoRow() {
              return row;
            }
          }
        }).result.then(function (data) {
          var sanitizedMessage = _this2.$sanitize(data.message);
          _this2.alertMessage.create({
            type: 'success',
            message: sanitizedMessage,
            appendTo: '.alerta-aqui'
          });

          if (data.idDeleted) {
            _this2.removeGrupoVtabela(data.idDeleted);
          } else if (angular.isDefined(data.grupoSubmit)) {
            _this2.updateGridRow(data.grupoSubmit, row);
          } else {
            _this2.consultar();
          }
        });
      }
    }, {
      key: 'removeGrupoVtabela',
      value: function removeGrupoVtabela(grupoId) {
        this.grupos = this.grupos.filter(function (grupo) {
          return grupo.id !== grupoId;
        });
        this.setInfoTable();
      }
    }, {
      key: 'updateGridRow',
      value: function updateGridRow(grupoEdited, row) {
        var grupoUpdate = this.grupos.find(function (grupo) {
          return grupo.id === row.id;
        });
        grupoUpdate.nome = grupoEdited.nome;
        grupoUpdate.observacoes = grupoEdited.observacoes;
        this.setInfoTable();
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.id,
          nome: item.nome,
          observacoes: item.observacoes,
          tipoPermissao: item.tipoPermissao,
          veicTotal: this.undefinedToZero(item.quantidadeVeiculosTotal),
          uoNome: item.uo && item.uo.nome,
          link: this.linkCadastroVeiculoPorGrupo(item.id),
          item: item
        };
      }
    }, {
      key: 'undefinedToZero',
      value: function undefinedToZero(value) {
        return angular.isUndefined(value) ? 0 : value;
      }
    }, {
      key: 'linkCadastroVeiculoPorGrupo',
      value: function linkCadastroVeiculoPorGrupo(idGrupo) {
        return '/veiculo/vfiltro=grupo:' + idGrupo;
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this3 = this;

        this.grupoVeicService.one().get(this.getParams()).then(function (data) {
          _this3.grupos = data;
          _this3.setInfoTable();
        }).catch(function () {
          return _this3.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable() {
        var _this4 = this;

        this.vtabela.setData(this.grupos.map(function (i) {
          return _this4.getItemVtabela(i);
        }));
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        var params = this.serviceVfiltro.getFiltroBackendNovo(this.filtro);
        params.fields = this.FIELDS_GRUPO_VEIC.join();
        return params;
      }
    }]);

    return GrupoVeicCtrl;
  }();

  angular.module('cadastros.grupoVeic').controller('GrupoVeicCtrl', GrupoVeicCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.devices
   * @description
   *
   */

  angular.module('cadastros.devices', ['ui.router', 'restangular', 'angularMoment', 'alert-message', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'VtabelaModule', 'pascalprecht.translate', 'modalInfoConfirmModule', 'FeatureFlagModule', 'relatorios', 'FeatureOuModule', 'UrlModule']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('cadastros.devices').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.devices', {
      url: '/devices?vdevices=&dvr=',
      views: {
        'content@': {
          templateUrl: 'cadastros/devices/devices.tpl.html',
          controller: 'DevicesCtrl'
        }
      },
      data: {
        titulo: 'devices.title',
        roles: [['MODULO_VISUALIZAR']]
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminProfile = {
  TRIMBLE_ADMIN: 1,
  ADMIN: 2,
  BI_ADMIN: 1216
};

var DevicesCtrl = function () {
  function DevicesCtrl($safetyService, $window, Authenticator, FeatureOuService, $state, UrlService, FeaturehubJsSdk, FeatureHubConfigKeys) {
    _classCallCheck(this, DevicesCtrl);

    this.window = $window;
    this.safetyService = $safetyService;
    this.authenticator = Authenticator;
    this.FeatureOuService = FeatureOuService;
    this.featurehubJsSdk = FeaturehubJsSdk;
    this.featureHubConfigKeys = FeatureHubConfigKeys;
    this.state = $state;
    this.urlService = UrlService;
    this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
    this.isFeatureHideTitleEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ORION_HIDE_TITLE);
    if (this.isFeatureHideTitleEnabled && this.queryParams.hideTitle === 'true') {
      this.hideTitle = true;
    } else {
      this.hideTitle = false;
    }
    this.initializePage();
  }

  _createClass(DevicesCtrl, [{
    key: 'initializePage',
    value: function initializePage() {
      var _this = this;

      this.safetyService.initialize().then(function () {
        return _this.loadPage();
      }).catch(function (error) {
        return _this.log.error('Initialization failed:', error);
      });
    }
  }, {
    key: 'loadPage',
    value: function loadPage() {
      var _this2 = this;

      var isAdmin = false,
          userProps = [];
      this.authenticator.getUser().then(function (user) {
        _this2.FeatureOuService.getDeviceScreenConfig(user.uo.id).then(function (eventNaConfig) {
          if (!eventNaConfig) {
            _this2.state.go('root.unauthorized');
          }
        }).catch(function (error) {
          _this2.log.error('Error loading featureOu config: ', error);
        });
        if (user.perfil && user.perfil.id) {
          isAdmin = [AdminProfile.TRIMBLE_ADMIN, AdminProfile.ADMIN, AdminProfile.BI_ADMIN].includes(user.perfil.id);
        }
        userProps = user;
        var appName = 'safetyApp',
            componentPath = './DevicePageRoute',
            componentId = 'safety-app',
            props = {
          isAdmin: isAdmin,
          user: userProps,
          hideTitle: _this2.hideTitle,
          dvrNumber: _this2.state.params.dvr
        };
        return _this2.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      });
    }
  }]);

  return DevicesCtrl;
}();

DevicesCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', '$state', 'UrlService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys'];
angular.module('cadastros.devices').controller('DevicesCtrl', DevicesCtrl);
'use strict';

(function () {
  'use strict';

  angular.module('vflashModule', ['flash']).factory('VFlash', function (Flash) {
    var vflash = Flash;

    vflash.filterError = function (name) {
      return Flash.create('error', 'O filtro ' + name + ' \xE9 obrigat\xF3rio.');
    };

    vflash.filterWarn = function () {
      Flash.create('warning', 'Nenhum resultado encontrado para os filtros informados.');
    };

    return vflash;
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global moment */

  var ValidateUtil = function () {
    function ValidateUtil() {
      _classCallCheck(this, ValidateUtil);
    }

    _createClass(ValidateUtil, [{
      key: 'temLogradouro',
      value: function temLogradouro(logradouro) {
        return !!logradouro && logradouro.trim() !== '-' && logradouro.trim().length > 0;
      }
    }, {
      key: 'isNotDataFutura',
      value: function isNotDataFutura(inputScope) {
        return function () {
          var dataInput = moment(inputScope.$viewValue, 'DD/MM/YYYY', true);
          if (dataInput.isValid()) {
            var dataValidation = dataInput.isBefore(moment().startOf('day'));
            return dataValidation;
          }
          return true;
        };
      }
    }]);

    return ValidateUtil;
  }();

  angular.module('validateUtilModule', []).service('ValidateUtil', ValidateUtil);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ObjetosVfiltro = function () {
    function ObjetosVfiltro(UrlService, ServiceVfiltro, Keys) {
      _classCallCheck(this, ObjetosVfiltro);

      this.urlService = UrlService;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;

      this.tableStateDefault = {
        sort: {
          predicate: '',
          reverse: ''
        }
      };
    }

    _createClass(ObjetosVfiltro, [{
      key: 'getVfiltroTableState',
      value: function getVfiltroTableState(table, exclude) {
        var vfiltro = this.urlService.getObjectVfiltro(this.serviceVfiltro.filtroTopbar.filter(function (item) {
          return item.key !== exclude;
        })),
            tablestate = this.getTableState(table);
        if (tablestate) {
          return 'tablestate=' + tablestate + '&vfiltro=' + vfiltro;
        }
        return 'vfiltro=' + vfiltro;
      }
    }, {
      key: 'getTableState',
      value: function getTableState(table) {
        var tableState = {
          predicate: table.sort && table.sort.predicate,
          reverse: table.sort && table.sort.reverse
        };
        return angular.isFunction(table.sort.predicate) ? null : this.urlService.getObjectVfiltroUrl(tableState);
      }
    }, {
      key: 'setTableStateUrl',
      value: function setTableStateUrl(tablestate, replace) {
        var objTableState = this.getTableState(tablestate);
        if (objTableState) {
          this.urlService.setQueryString('tablestate', objTableState, replace);
        }
      }
    }, {
      key: 'getTableStateUrl',
      value: function getTableStateUrl() {
        var tablestate = this.urlService.getVfiltroUrl('tablestate');
        if (tablestate) {
          return {
            sort: {
              predicate: tablestate.predicate || '',
              reverse: angular.fromJson(tablestate.reverse) || ''
            }
          };
        }
        return angular.copy(this.tableStateDefault);
      }
    }]);

    return ObjetosVfiltro;
  }();

  angular.module('ObjetosVfiltroModule', ['UrlModule', 'ServiceVfiltroModule', 'ConstantVfiltroModule']).service('ObjetosVfiltroService', ObjetosVfiltro);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MILES_CONSTANT = 1.60934,
      MILES_CONSTANT_MINUS_ONE = 0.60934;

  var MeasurementUnitConverterService = function () {
    function MeasurementUnitConverterService() {
      _classCallCheck(this, MeasurementUnitConverterService);
    }

    _createClass(MeasurementUnitConverterService, [{
      key: 'getDateTimeFormat',
      value: function getDateTimeFormat(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy HH:mm:ss' : 'MM/dd/yy HH:mm:ss';
      }
    }, {
      key: 'getDateFormat',
      value: function getDateFormat(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
      }
    }, {
      key: 'getDateTimeFormatYearWithTwo',
      value: function getDateTimeFormatYearWithTwo(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy' : 'MM/dd/yy';
      }
    }, {
      key: 'getDistanceUnit',
      value: function getDistanceUnit(distanceMeasurement) {
        return distanceMeasurement === 'KM' ? 'Km' : 'mi';
      }
    }, {
      key: 'getSpeedUnit',
      value: function getSpeedUnit(speedMeasurement) {
        return speedMeasurement === 'KM' ? 'Km/h' : 'mph';
      }
    }, {
      key: 'getFuelUnit',
      value: function getFuelUnit(fuelMeasurement) {
        return fuelMeasurement === 'LITERS' ? 'L' : 'gal';
      }
    }, {
      key: 'getFuelEfficiencyUnit',
      value: function getFuelEfficiencyUnit(fuelMeasurement) {
        return fuelMeasurement === 'LITERS' ? 'Km/L' : 'mpg';
      }
    }, {
      key: 'getEnergyEfficiencyUnit',
      value: function getEnergyEfficiencyUnit(fuelMeasurement) {
        return fuelMeasurement === 'LITERS' ? 'Km/kWh' : 'mi/kWh';
      }
    }, {
      key: 'convertSpeedFromMphToKmh',
      value: function convertSpeedFromMphToKmh(speed) {
        if (speed === null || angular.isUndefined(speed) || isNaN(speed)) {
          throw new Error('Invalid value for kmh');
        }
        if (speed === 0) return 0;
        return Math.ceil(speed * MILES_CONSTANT + MILES_CONSTANT_MINUS_ONE);
      }
    }, {
      key: 'convertSpeedFromKmhToMph',
      value: function convertSpeedFromKmhToMph(speed) {
        if (speed === null || angular.isUndefined(speed) || isNaN(speed)) {
          throw new Error('Invalid speed value');
        }
        if (speed === 0) return 0;
        return Math.floor(speed / MILES_CONSTANT);
      }
    }]);

    return MeasurementUnitConverterService;
  }();

  angular.module('ModuleMeasurementUnitConverter', []).service('MeasurementUnitConverterService', MeasurementUnitConverterService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  angular.module('ModuleMapasUtil', ['ModuleEventos', 'pascalprecht.translate', 'mapas']);

  var SOUTH_AMERICA_MAP_CENTER_DEFAULT = { lat: -23.3045, lng: -51.1696, zoom: 4 },
      NORTH_AMERICA_MAP_CENTER_DEFAULT = { lat: 39.8283, lng: -98.5795, zoom: 4 },
      NORTH_AMERICA_TIMEZONES = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Toronto', 'America/Vancouver', 'America/Winnipeg', 'America/Halifax', 'America/St_Johns', 'America/Phoenix', 'America/Anchorage', 'America/Adak', 'America/Juneau', 'America/Indiana/Indianapolis', 'America/Detroit', 'America/Boise', 'America/Sitka', 'America/Metlakatla'],
      TILE_SERVER_CONFIG = {
    TILES_URL: 'https://ptiles-{s}.vfleets.com.br/tiles/{z}/{x}/{y}.png',
    UPDATE_WHEN_IDLE: true,
    UPDATE_WHEN_ZOOMING: false,
    KEEP_BUFFER: 2
  },
      TILE_SERVER_ALIASES = ['ptiles-1.vfleets.com.br', 'ptiles-2.vfleets.com.br', 'ptiles-3.vfleets.com.br', 'ptiles-4.vfleets.com.br'],
      QA_TILE_SERVER_CONFIG = {
    TILES_URL: 'https://ptiles-{s}.ttl.dev.br/tiles/{z}/{x}/{y}.png',
    UPDATE_WHEN_IDLE: true,
    UPDATE_WHEN_ZOOMING: false,
    KEEP_BUFFER: 2
  },
      QA_TILE_SERVER_ALIASES = ['ptiles-1.ttl.dev.br', 'ptiles-2.ttl.dev.br', 'ptiles-3.ttl.dev.br', 'ptiles-4.ttl.dev.br'];
  /* global _ , Intl */

  var MapasUtil = function () {
    function MapasUtil(Eventos, $translate, $window, $rootScope, MapLayerVisibility, FeaturehubJsSdk, FeatureHubConfigKeys, Authenticator) {
      _classCallCheck(this, MapasUtil);

      this.translate = $translate;
      this.eventos = Eventos;
      this.window = $window;
      this.rootScope = $rootScope;
      this.mapLayerVisibility = MapLayerVisibility;
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.authenticator = Authenticator;

      // Use QA servers when feature flag is enabled, otherwise use production
      var useQAServers = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.QA_MAP_SERVER);
      this.tileServerConfig = useQAServers ? QA_TILE_SERVER_CONFIG : TILE_SERVER_CONFIG;
      this.tileServerAliases = useQAServers ? QA_TILE_SERVER_ALIASES : TILE_SERVER_ALIASES;
      this.currentUoId = null;
      this.oldTiles = {
        name: 'Mapa',
        url: 'https://tiles-{s}.vfleets.com.br/tile/{z}/{x}/{y}.png',
        type: 'xyz',
        options: {
          subdomains: ['1', '2', '3', '4'],
          attribution: '&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors'
        }
      };
      this.newTiles = this.buildDynamicTilesConfig();
      this.tiles = {
        veltec: this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.USE_NEW_TILES_SOURCE) ? this.newTiles : this.oldTiles,
        trimbleMaps: {
          name: 'Satellite',
          url: 'https://contentsvc-sat-{s}.alk.com/ContentService.svc/xml/SatImageTile?authToken=300E18BCE5EEA04A8BA48B936949B413|2023-05-23T00:00:00.000Z&proj=EPSG:900913&provider=DigitalGlobe&width=256&z={z}&x={x}&y={y}',
          type: 'xyz',
          options: {
            subdomains: ['a', 'b', 'c', 'd'],
            attribution: '© Trimble Inc. | © OpenMapTiles © OpenStreetMap contributors | <a href="https://maps.alk.com/Account/MapDataDisclaimer">Imagery © Digital Globe</a> contributors'
          }
        }
      };
      this.defaults = {
        zoomControlPosition: 'topright',
        minZoom: 3
      };
      this.eventosOperacionaisPermiteExibicao = this.translate.instant(this.eventos.PARADO_LIGADO.descricao);
      this.layersVisibilityLocalStorage = 'map-layers-visibility';
      this.validGpsTimeWindowFlag = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_INVALID_GPS_MAPS);
      this.VALID_GPS_TIME_WINDOW_SECONDS = 15;
    }

    _createClass(MapasUtil, [{
      key: 'init',
      value: function init() {
        this.authenticateWithTileServer();
        this.setupTokenRefreshListener();
      }
    }, {
      key: 'authenticateWithTileServer',
      value: function authenticateWithTileServer() {
        var _this = this;

        if (!this.authenticator || !angular.isFunction(this.authenticator.getUser)) {
          return;
        }
        this.authenticator.getUser().then(function () {
          if (!_this.authenticator.keycloak || !_this.authenticator.keycloak.token) {
            return;
          }
          if (!_this.window.fetch) {
            return;
          }
          var token = _this.authenticator.keycloak.token,
              authPromises = _this.tileServerAliases.map(function (alias) {
            return _this.window.fetch('https://' + alias + '/auth', {
              method: 'POST',
              headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
              },
              credentials: 'include'
            });
          });

          Promise.all(authPromises);
        });
      }
    }, {
      key: 'setupTokenRefreshListener',
      value: function setupTokenRefreshListener() {
        var _this2 = this;

        if (!this.authenticator || !this.authenticator.keycloak) {
          return;
        }
        var keycloak = this.authenticator.keycloak;
        keycloak.onAuthRefreshSuccess = function () {
          _this2.authenticateWithTileServer();
        };
      }
    }, {
      key: 'getIconByZoom',
      value: function getIconByZoom(zoom, posicao) {
        var qtdOcorrenciasNovasVeiculo = posicao.ocorrenciasNovasDoVeiculo ? posicao.ocorrenciasNovasDoVeiculo.length : 0;
        if (zoom > 13) {
          return this.getIcon(posicao, 'v3g-icon-25x', [27, 35], [5, -20], qtdOcorrenciasNovasVeiculo);
        }
        if (zoom > 12) {
          return this.getIcon(posicao, 'fa-2x', [25, 25], [0, -10], qtdOcorrenciasNovasVeiculo);
        }
        if (zoom > 10) {
          return this.getIcon(posicao, 'fa-lg', [15, 15], [0, -10], qtdOcorrenciasNovasVeiculo);
        }
        return this.getIconLonge();
      }
    }, {
      key: 'getVeiculoLabel',
      value: function getVeiculoLabel(placa, prefixo, emMovimento, invalidGps) {
        var statusVeiculoCssClass = void 0,
            invalidGpsCssClass = void 0;

        statusVeiculoCssClass = emMovimento ? 'div-text-placa-movimento' : 'div-text-placa-parado';
        invalidGpsCssClass = invalidGps ? 'bg-invalid-gps' : '';

        if (Boolean(prefixo)) {
          return '<div class=\'' + statusVeiculoCssClass + ' ' + invalidGpsCssClass + '\'>\n            <span>' + prefixo + '-</span>\n            <span>' + placa + '</span>\n          </div>';
        } else if (Boolean(placa)) {
          return '<div class=\'' + statusVeiculoCssClass + ' ' + invalidGpsCssClass + '\'>\n            <span>' + placa + '</span>\n          </div>';
        }
        return '';
      }
    }, {
      key: 'getIcon',
      value: function getIcon(posicao, size, iconAnchor, popupAnchor, qtdOcorrenciasNovasVeiculo) {
        var emMovimento = posicao.status !== this.translate.instant('ce.enum.eventos.parado'),
            invalidGps = posicao.statusGps === false;
        return {
          type: 'div',
          html: '<div class=\'icon-container\'>\n                <span class="v3g-icon fa-stack ' + size + '">\n                  <div class="fa-stack-2x\n                  ' + (emMovimento ? 'trimble-vehicle-directional' : 'trimble-vehicle-directional stopped') + '\n                  ' + (invalidGps ? 'icon-invalid-gps' : '') + '"\n                  style="' + this.getCssRotate(posicao.dir, emMovimento) + ';"></div>\n                  <i class="v3g-icon trimble-vehicle fa-stack-2x ' + (emMovimento ? 'text-primary' : '') + '\n                  ' + (invalidGps ? 'text-invalid-gps' : '') + '"\'></i>\n                  ' + this.getLabelQtdOcorrenciasNovasDoVeiculo(qtdOcorrenciasNovasVeiculo) + '\n                </span>\n                ' + this.getVeiculoLabel(posicao.placa, posicao.prefixo, emMovimento, invalidGps) + '\n              </div>',
          iconAnchor: iconAnchor,
          popupAnchor: popupAnchor
        };
      }
    }, {
      key: 'getLabelQtdOcorrenciasNovasDoVeiculo',
      value: function getLabelQtdOcorrenciasNovasDoVeiculo(qtdOcorrenciasNovasVeiculo) {
        return '<div class="quantity-container ' + (qtdOcorrenciasNovasVeiculo > 0 ? '' : 'no-display') + '" >\n                <span>' + qtdOcorrenciasNovasVeiculo + '</span>\n              </div>';
      }
    }, {
      key: 'getCssRotate',
      value: function getCssRotate(direcao, emMovimento) {
        if (!emMovimento) {
          return '';
        }
        return '\n        -webkit-transform: rotate(' + direcao + 'deg);\n        -ms-transform: rotate(' + direcao + 'deg);\n        transform: rotate(' + direcao + 'deg);\n      ';
      }
    }, {
      key: 'getIconPosicao',
      value: function getIconPosicao() {
        return '<img src=\'images/icons-map/marker-pin-blue.png\' class="img-icon"/>';
      }
    }, {
      key: 'setVelocidadeExcessiva',
      value: function setVelocidadeExcessiva(e) {
        if (e.evento === this.translate.instant(this.eventos.EXCESSO_VELOCIDADE.tipo)) {
          var limiar = this.getLimiarComoNumero(e.limiar),
              velocidade = Number(e.velocidade),
              excesso = limiar === 0 ? 0 : Math.round(velocidade / limiar * 100 - 100);
          if (excesso <= 20 && excesso !== 0) {
            e.evento = this.translate.instant(this.eventos.EXCESSO_VELOCIDADE1.tipo);
          } else if (excesso > 30) {
            e.evento = this.translate.instant(this.eventos.EXCESSO_VELOCIDADE3.tipo);
          } else {
            e.evento = this.translate.instant(this.eventos.EXCESSO_VELOCIDADE2.tipo);
          }
        }

        return e;
      }
    }, {
      key: 'mapParadoExcessivamente',
      value: function mapParadoExcessivamente(e) {
        if (e.evento === this.translate.instant(this.eventos.PARADO.tipo)) {
          if (e.duracao > 3600) {
            e.evento = this.translate.instant(this.eventos.PARADO_EX_4.tipo);
          } else if (e.duracao > 1800) {
            e.evento = this.translate.instant(this.eventos.PARADO_EX_3.tipo);
          } else if (e.duracao > 300) {
            e.evento = this.translate.instant(this.eventos.PARADO_EX_2.tipo);
          } else {
            e.evento = this.translate.instant(this.eventos.PARADO_EX_1.tipo);
          }
        }

        return e;
      }
    }, {
      key: 'handleUndefinedEvent',
      value: function handleUndefinedEvent(event) {
        if (angular.isUndefined(event.evento)) {
          if (event.tipoPosicao === 'STATUS_PARADO_MOTOR_LIGADO') {
            event.evento = this.translate.instant(this.eventos.RPM.tipo);
          } else {
            event.evento = this.translate.instant('ce.enum.common.desconhecido');
          }
        }

        return event;
      }
    }, {
      key: 'mapCurvaBrusca',
      value: function mapCurvaBrusca(e) {
        if (angular.isUndefined(e.evento)) {
          return e;
        }

        var curvaBrusca = this.translate.instant(this.eventos.CURVA_BRUSCA.tipo);
        if (e.evento === curvaBrusca) {
          e.evento = curvaBrusca;
        } else if (e.evento.indexOf(this.translate.instant('ce.enum.eventos.curva')) !== -1 && e.evento.indexOf(this.translate.instant('ce.enum.common.esquerda')) !== -1) {
          e.evento = this.translate.instant(this.eventos.CURVA_BRUSCA_ESQUERDA.tipo);
          e.intensidade = angular.isDefined(e.intensidade) ? e.intensidade.replace('-', '') : null;
        } else if (e.evento.indexOf(this.translate.instant('ce.enum.eventos.curva')) !== -1 && e.evento.indexOf(this.translate.instant('ce.enum.common.direita')) !== -1) {
          e.evento = this.translate.instant(this.eventos.CURVA_BRUSCA_DIREITA.tipo);
        }

        return e;
      }
    }, {
      key: 'setDescida',
      value: function setDescida(e, faixasDescida) {
        var eventoDescida = this.translate.instant(this.eventos.DESCIDA.tipo);
        if (e.evento === eventoDescida && angular.isDefined(faixasDescida)) {
          var segundosFreioPressionado = e.miscInfo.segundosFreioPressionado;
          if (segundosFreioPressionado <= faixasDescida.segundosFaixa1) {
            e.evento = this.translate.instant(this.eventos.DESCIDA_FAIXA1.tipo);
          } else if (segundosFreioPressionado <= faixasDescida.segundosFaixa2) {
            e.evento = this.translate.instant(this.eventos.DESCIDA_FAIXA2.tipo);
          } else {
            e.evento = this.translate.instant(this.eventos.DESCIDA_FAIXA3.tipo);
          }
        }
        return e;
      }
    }, {
      key: 'getCenter',
      value: function getCenter() {
        var eventos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (eventos.length > 0) {
          return {
            lat: eventos[0].latitude,
            lng: eventos[0].longitude,
            zoom: 12
          };
        }
        return this.getMapCenterByTimezone(this.currentTimezone);
      }
    }, {
      key: 'getMapCenterByTimezone',
      value: function getMapCenterByTimezone(timezone) {
        if (NORTH_AMERICA_TIMEZONES.includes(timezone)) {
          return NORTH_AMERICA_MAP_CENTER_DEFAULT;
        }
        return SOUTH_AMERICA_MAP_CENTER_DEFAULT;
      }
    }, {
      key: 'getLimiarComoNumero',
      value: function getLimiarComoNumero(limiar) {
        var arrayPalavras = limiar.split(' ');
        return Number(arrayPalavras[1]);
      }
    }, {
      key: 'flatPosicoes',
      value: function flatPosicoes(posicoes) {
        return posicoes.reduce(function (acc, posicao) {
          acc.push(posicao);

          if (angular.isDefined(posicao.posicoes)) {
            posicao.posicoes.forEach(function (p) {
              return acc.push(p);
            });
          }

          if (angular.isDefined(posicao.fim)) {
            acc.push(posicao.fim);
          }

          return acc;
        }, []);
      }
    }, {
      key: 'ajustaEvento',
      value: function ajustaEvento(p, index, ultimaValida, ultimaInvalida, faixasDescida) {
        this.handleUndefinedEvent(p);
        this.setVelocidadeExcessiva(p);
        this.mapParadoExcessivamente(p);
        this.mapCurvaBrusca(p);
        this.setDescida(p, faixasDescida);

        var evento = this.eventos.getEvento(p.evento);
        p.descricao = angular.isDefined(evento) ? evento.descricao : p.evento;
        p.index = index;

        if (this.isValidPosition(p)) {
          if (angular.isArray(p.posicoes) && p.posicoes.length > 0) {
            ultimaValida = p.posicoes[p.posicoes.length - 1];
          } else {
            ultimaValida = p;
          }
          p.temCoordenada = true;
          if (ultimaInvalida && !ultimaInvalida.temCoordenada && this.isWithinTimeWindowValidGps(ultimaInvalida, p)) {
            ultimaInvalida.temCoordenada = true;
            ultimaInvalida.latitude = p.latitude;
            ultimaInvalida.longitude = p.longitude;
            ultimaInvalida.logradouro = p.logradouro;
            ultimaInvalida.cidade = p.cidade;
            ultimaInvalida.uf = p.uf;
            ultimaInvalida.posicaoFoiAjustada = true;
          }
        } else if (ultimaValida && this.isWithinTimeWindowValidGps(p, ultimaValida)) {
          p.latitude = ultimaValida.latitude;
          p.longitude = ultimaValida.longitude;
          p.logradouro = ultimaValida.logradouro;
          p.cidade = ultimaValida.cidade;
          p.uf = ultimaValida.uf;
          p.temCoordenada = true;
          p.posicaoFoiAjustada = true;
        } else {
          ultimaInvalida = p;
          p.temCoordenada = false;
        }

        return {
          posicao: p,
          ultimaValida: ultimaValida,
          ultimaInvalida: ultimaInvalida
        };
      }
    }, {
      key: 'isValidPosition',
      value: function isValidPosition(position) {
        return position.gps !== 'Inválido' && position.latitude !== 0.0 && position.longitude !== 0.0;
      }
    }, {
      key: 'isWithinTimeWindowValidGps',
      value: function isWithinTimeWindowValidGps(invalidPosition, lastValidPosition) {
        if (!this.validGpsTimeWindowFlag) {
          return true;
        }
        var invalidPositionDate = new Date(invalidPosition.data),
            validPositionDate = new Date(lastValidPosition.data),
            diff = Math.abs(validPositionDate.getTime() - invalidPositionDate.getTime());
        return diff <= this.VALID_GPS_TIME_WINDOW_SECONDS * 1000;
      }
    }, {
      key: 'ajustarEventos',
      value: function ajustarEventos(posicoes, faixasDescida) {
        var _this3 = this;

        var ultimaValida = void 0,
            ultimaInvalida = void 0;
        return _.chain(posicoes).map(function (p, index) {
          var ajustado = _this3.ajustaEvento(p, index, ultimaValida, ultimaInvalida, faixasDescida);

          ultimaInvalida = ajustado.ultimaInvalida;
          ultimaValida = ajustado.ultimaValida;
          return ajustado.posicao;
        }).value();
      }
    }, {
      key: 'marcarPosicoesInvalidasNoInicio',
      value: function marcarPosicoesInvalidasNoInicio(posicoes) {
        var jaTeveValida = false;
        posicoes.forEach(function (p) {
          if (p.temCoordenada || jaTeveValida) {
            jaTeveValida = true;
            p.valida = true;
          } else {
            p.valida = false;
          }
        });
      }
    }, {
      key: 'posicoesFiltradas',
      value: function posicoesFiltradas(posicoes) {
        var _this4 = this;

        return posicoes.filter(function (p) {
          var eventoAnaliseOperacionalExibivel = _.contains(_this4.eventosOperacionaisPermiteExibicao, p.evento) && p.valida;
          return p.valida && p.tipoPosicao !== 'ANAL_OPERACIONAL' || eventoAnaliseOperacionalExibivel;
        });
      }
    }, {
      key: 'getLayersVisibilityLocalStorage',
      value: function getLayersVisibilityLocalStorage(userId) {
        var preferences = this.window.localStorage.getItem(this.layersVisibilityLocalStorage + '-' + userId);
        return preferences && angular.fromJson(preferences);
      }
    }, {
      key: 'setLayersVisibilityLocalStorage',
      value: function setLayersVisibilityLocalStorage(userId, preferences) {
        var preferencesJson = angular.toJson(preferences);
        this.window.localStorage.setItem(this.layersVisibilityLocalStorage + '-' + userId, preferencesJson);
      }
    }, {
      key: 'activateAllMapLayers',
      value: function activateAllMapLayers(userId) {
        var _this5 = this;

        var visibilityPreferences = this.getLayersVisibilityLocalStorage(userId);
        if (visibilityPreferences) {
          visibilityPreferences.forEach(function (layer) {
            if (!layer.shouldShow) {
              layer.shouldShow = true;
              _this5.notifyLayersVisibilityChange(layer.name, true);
            }
          });
          this.setLayersVisibilityLocalStorage(userId, visibilityPreferences);
        }
      }
    }, {
      key: 'notifyLayersVisibilityChange',
      value: function notifyLayersVisibilityChange(entity, shouldShow) {
        this.rootScope.$broadcast('layerVisibilityHasChanged', entity, shouldShow);
      }
    }, {
      key: 'buildDynamicTilesConfig',
      value: function buildDynamicTilesConfig() {
        var defaultUrl = this.tileServerConfig.TILES_URL + '?uoId=default';
        return this.createTilesConfig(defaultUrl);
      }
    }, {
      key: 'createTilesConfig',
      value: function createTilesConfig(url) {
        var tileSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

        return {
          name: 'Mapa',
          url: url,
          type: 'xyz',
          options: {
            subdomains: ['1', '2', '3', '4'],
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            tileSize: tileSize,
            maxZoom: 18,
            zoomOffset: -1,
            updateWhenIdle: true,
            updateWhenZooming: false,
            keepBuffer: 2,
            updateInterval: 200
          }
        };
      }
    }, {
      key: 'setCurrentUoId',
      value: function setCurrentUoId(uoId) {
        this.currentUoId = uoId;
        this.updateTilesWithUoId(uoId);
      }
    }, {
      key: 'updateTilesWithUoId',
      value: function updateTilesWithUoId(uoId) {
        this.newTiles = this.getTilesForUoId(uoId);
        if (this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.USE_NEW_TILES_SOURCE)) {
          this.tiles.veltec = this.newTiles;
        }
        this.rootScope.$broadcast('tilesConfigUpdated', {
          newConfig: this.newTiles,
          uoId: uoId || 'default'
        });
      }
    }, {
      key: 'getTilesForUoId',
      value: function getTilesForUoId(uoId) {
        var uoIdParam = uoId || 'default',
            separator = this.tileServerConfig.TILES_URL.includes('?') ? '&' : '?',
            urlWithUoId = '' + this.tileServerConfig.TILES_URL + separator + 'uoId=' + uoIdParam;

        return this.createTilesConfig(urlWithUoId);
      }
    }]);

    return MapasUtil;
  }();

  angular.module('ModuleMapasUtil').service('MapasUtil', MapasUtil);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  angular.module('ModuleEventos', ['pascalprecht.translate']);

  var EventosService = function () {
    function EventosService($translate, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, EventosService);

      this.translate = $translate;
      this.featureHub = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;

      this.LOCALIZACAO = 'ce.enum.eventos.localizacao';
      this.EXCESSO_VELOCIDADE = {
        tipo: 'ce.enum.common.excessoVelocidade',
        icone: 'icon trimble-speeding',
        cor: 'yellow',
        descricao: 'ce.enum.common.excessoVelocidade',
        alerta: 'EXCESSO_VELOCIDADE',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.EXCESSO_VELOCIDADE1 = {
        tipo: 'ce.enum.eventos.excessoVelocidade1',
        icone: 'icon trimble-speeding',
        cor: 'yellow',
        descricao: 'ce.enum.common.excessoVelocidade',
        alerta: 'EXCESSO_VELOCIDADE',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.EXCESSO_VELOCIDADE2 = {
        tipo: 'ce.enum.eventos.excessoVelocidade2',
        icone: 'icon trimble-speeding',
        cor: 'lred',
        descricao: 'ce.enum.common.excessoVelocidade',
        alerta: 'EXCESSO_VELOCIDADE',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.EXCESSO_VELOCIDADE3 = {
        tipo: 'ce.enum.eventos.excessoVelocidade3',
        icone: 'icon trimble-speeding',
        cor: 'red',
        descricao: 'ce.enum.common.excessoVelocidade',
        alerta: 'EXCESSO_VELOCIDADE',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.EXCESSO_VELOCIDADE_VIA = {
        tipo: 'ce.enum.common.excessoVelocidadePorVia',
        icone: 'icon trimble-speeding-highway',
        cor: 'red',
        descricao: 'ce.enum.common.excessoVelocidadePorVia',
        alerta: 'EXCESSO_VELOCIDADE_POR_VIA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.IGNICAO_LIGADA = {
        tipo: 'ce.enum.eventos.ignicaoLigada',
        icone: 'fa-key',
        cor: 'green',
        descricao: 'ce.enum.eventos.ignicaoLigada',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.RFID = {
        tipo: 'ce.enum.eventos.rfidUpperCase',
        icone: 'fa-tag',
        cor: 'blue',
        descricao: 'ce.enum.eventos.eventoDeRfid',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.ABERTURA_VIGENCIA = {
        tipo: 'ce.enum.eventos.aberturaDeVigencia',
        icone: 'icon trimble-rfid',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.aberturaDeVigencia',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FECHAMENTO_VIGENCIA = {
        tipo: 'ce.enum.eventos.fechamentoDeVigencia',
        icone: 'icon trimble-rfid',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.fechamentoDeVigencia',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.IGNICAO_DESLIGADA = {
        tipo: 'ce.enum.eventos.ignicaoDesligada',
        icone: 'fa-key',
        cor: 'red',
        descricao: 'ce.enum.eventos.ignicaoDesligada',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PONTO_REFERENCIA = {
        tipo: 'ce.enum.eventos.pontoDeReferencia',
        icone: 'fa-home',
        cor: 'maroon',
        descricao: 'ce.enum.eventos.pontoDeReferencia',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.INICIO_JORNADA = {
        tipo: 'ce.enum.eventos.inicioJornadaUnderscore',
        icone: 'fa-asterisk',
        cor: 'blue',
        descricao: 'ce.enum.eventos.inicioDeJornada',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.INICIO_JORNADA_AJUDANTE = {
        tipo: 'ce.enum.eventos.inicioJornadaAjudanteUnderscore',
        icone: 'fa-asterisk',
        cor: 'blue',
        descricao: 'ce.enum.eventos.inicioDeJornadaDeAjudante',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.EM_JORNADA = {
        tipo: 'ce.enum.eventos.paradoUpperCase',
        icone: 'fa-minus-circle',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.emJornada',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DIRECAO = {
        tipo: 'ce.enum.eventos.direcaoUpperCase',
        icone: 'fa-road',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.direcao',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.REFEICAO = {
        tipo: 'ce.enum.eventos.refeicaoUpperCase',
        icone: 'fa-cutlery',
        cor: 'green',
        descricao: 'ce.enum.eventos.refeicao',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCANSO = {
        tipo: 'ce.enum.eventos.descansoUpperCase',
        icone: 'fa-coffee',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.descanso',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.ESPERA = {
        tipo: 'ce.enum.eventos.esperaUpperCase',
        icone: 'fa-clock-o',
        cor: 'maroon',
        descricao: 'ce.enum.eventos.espera',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.ENTREGA = {
        tipo: 'ce.enum.eventos.entregaUpperCase',
        icone: 'fa-archive',
        cor: 'blue',
        descricao: 'ce.enum.eventos.entrega',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.RESERVA = {
        tipo: 'ce.enum.eventos.reservaUpperCase',
        icone: 'fa-retweet',
        cor: 'green',
        descricao: 'ce.enum.eventos.reserva',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FIM_JORNADA = {
        tipo: 'ce.enum.eventos.fimJornadaUnderscore',
        icone: 'fa-power-off',
        cor: 'maroon',
        descricao: 'ce.enum.eventos.fimDeJornada',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FIM_JORNADA_AJUDANTE = {
        tipo: 'ce.enum.eventos.fimJornadaAjudanteUnderscore',
        icone: 'fa-power-off',
        cor: 'maroon',
        descricao: 'ce.enum.eventos.fimDeJornadaDeAjudante',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.BANGUELA = {
        tipo: 'ce.enum.common.banguela',
        icone: 'icon trimble-coasting',
        cor: 'yellow',
        descricao: 'ce.enum.common.banguela',
        alerta: 'BANGUELA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.RPM = {
        tipo: 'ce.enum.common.rpmExcessivo',
        icone: 'icon trimble-rpm',
        cor: 'yellow',
        descricao: 'ce.enum.common.rpmExcessivo',
        alerta: 'EXCESSO_RPM',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MOTOR_OCIOSO = {
        tipo: 'ce.enum.eventos.motorOcioso',
        icone: 'icone-motor',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.motorOcioso',
        alerta: 'PARADO_LIGADO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.ACELERACAO_BRUSCA = {
        tipo: 'ce.enum.common.aceleracaoBrusca',
        icone: 'icon trimble-harsh-acceleration',
        cor: 'yellow',
        descricao: 'ce.enum.common.aceleracaoBrusca',
        alerta: 'ACELERACAO_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FRENAGEM_BRUSCA = {
        tipo: 'ce.enum.common.frenagemBrusca',
        icone: 'icon trimble-harsh-braking',
        cor: 'yellow',
        descricao: 'ce.enum.common.frenagemBrusca',
        alerta: 'FREADA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FRENAGEM_BRUSCA_COM_PEDAL = {
        tipo: 'ce.enum.common.frenagemBruscaComPedal',
        icone: 'icon trimble-harsh-braking',
        cor: 'yellow',
        descricao: 'ce.enum.common.frenagemBruscaComPedal',
        alerta: 'FREADA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FRENAGEM_BRUSCA_SEM_PEDAL = {
        tipo: 'ce.enum.common.frenagemBruscaSemPedal',
        icone: 'icon trimble-harsh-braking',
        cor: 'yellow',
        descricao: 'ce.enum.common.frenagemBruscaSemPedal',
        alerta: 'FREADA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.TREPIDACAO = {
        tipo: 'ce.enum.common.trepidacao',
        icone: 'icon trimble-trepidation',
        cor: 'yellow',
        descricao: 'ce.enum.common.trepidacao',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CURVA_BRUSCA = {
        tipo: 'ce.enum.common.curvaBrusca',
        icone: 'icon trimble-sharp-turn',
        cor: 'yellow',
        descricao: 'ce.enum.common.curvaBrusca',
        alerta: 'CURVA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CURVA_BRUSCA_ESQUERDA = {
        tipo: 'ce.enum.eventos.curvaBruscaEsquerda',
        icone: 'icon trimble-sharp-turn',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.curvaBruscaEsquerda',
        alerta: 'CURVA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CURVA_BRUSCA_DIREITA = {
        tipo: 'ce.enum.eventos.curvaBruscaDireita',
        icone: 'icon trimble-sharp-turn',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.curvaBruscaDireita',
        alerta: 'CURVA_BRUSCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MOVIMENTO = {
        tipo: 'ce.enum.eventos.movimento',
        icone: 'fa-map-marker',
        cor: '',
        descricao: 'ce.enum.eventos.movimento',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO = {
        tipo: 'ce.enum.eventos.parado',
        icone: 'icone-parado',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.parado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO_EX_1 = {
        tipo: 'ce.enum.eventos.paradoExc1',
        icone: 'icone-parado',
        cor: 'green',
        descricao: 'ce.enum.eventos.parado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO_EX_2 = {
        tipo: 'ce.enum.eventos.paradoExc2',
        icone: 'icone-parado',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.parado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO_EX_3 = {
        tipo: 'ce.enum.eventos.paradoExc3',
        icone: 'icone-parado',
        cor: 'lred',
        descricao: 'ce.enum.eventos.parado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO_EX_4 = {
        tipo: 'ce.enum.eventos.paradoExc4',
        icone: 'icone-parado',
        cor: 'red',
        descricao: 'ce.enum.eventos.parado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.REMOCAO_EQUIPAMENTO = {
        tipo: 'ce.enum.common.remocaoEquipamento',
        icone: 'icon trimble-power-off',
        cor: 'red',
        descricao: 'ce.enum.common.remocaoEquipamento',
        alerta: 'REMOCAO_EQUIPAMENTO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CONEXAO_EQUIPAMENTO = {
        tipo: 'ce.enum.eventos.conexaoEquipamento',
        icone: 'icon trimble-power-on',
        cor: 'green',
        descricao: 'ce.enum.eventos.conexaoEquipamento',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.POSSIVEL_COLISAO = {
        tipo: 'ce.enum.common.possivelColisao',
        icone: 'icon trimble-collision',
        cor: 'red',
        descricao: 'ce.enum.common.possivelColisao',
        alerta: 'POSSIVEL_COLISAO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DIAGNOSTICO_OBD = {
        tipo: 'ce.enum.eventos.diagnosticoObd',
        icone: 'fa-wrench',
        cor: 'dark-gray',
        descricao: 'ce.enum.eventos.diagnosticoObd',
        alerta: 'DIAGNOSTICO_OBD',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DIAGNOSTICO_CAN = {
        tipo: 'ce.enum.eventos.diagnosticoCan',
        icone: 'fa-wrench',
        cor: 'dark-gray',
        descricao: 'ce.enum.eventos.diagnosticoCan',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PARADO_LIGADO = {
        tipo: 'ce.enum.common.paradoLigado',
        icone: 'trimble-idling',
        cor: 'yellow',
        descricao: 'ce.enum.common.paradoLigado',
        alerta: 'PARADO_LIGADO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.VEICULO_SEM_VIGENCIA = {
        tipo: 'ce.enum.common.semIdentificacaoMotorista',
        icone: 'icon trimble-rfid',
        cor: 'yellow',
        descricao: 'ce.enum.common.semIdentificacaoMotorista',
        alerta: 'VEICULO_SEM_VIGENCIA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.VEICULO_SEM_SINAL = {
        tipo: 'ce.enum.common.semSinal',
        icone: 'icon trimble-connection-off',
        cor: 'red',
        descricao: 'ce.enum.common.semSinal',
        alerta: 'VEICULO_SEM_SINAL',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.SENSOR_ACIONADO = {
        tipo: 'ce.enum.eventos.sensorAcionado',
        icone: 'trimble-sensor-on',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.sensorAcionado',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MANUTENCAO_PROGRAMADA = {
        tipo: 'ce.enum.common.manutencaoProgramada',
        icone: 'trimble-maintenance',
        cor: 'pink',
        descricao: 'ce.enum.common.manutencaoProgramada',
        alerta: 'MANUTENCAO_PROGRAMADA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DISTANCIA_PERIGOSA = {
        tipo: 'ce.enum.common.distanciaPerigosa',
        icone: 'trimble-distance-warning',
        cor: 'red',
        descricao: 'ce.enum.common.distanciaPerigosa',
        alerta: 'DISTANCIA_PERIGOSA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DISTRACAO_MOTORISTA = {
        tipo: 'ce.enum.common.distracao',
        icone: 'trimble-distraction',
        cor: 'red',
        descricao: 'ce.enum.common.distracao',
        alerta: 'DISTRACAO_MOTORISTA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FADIGA_MOTORISTA = {
        tipo: 'ce.enum.common.fadiga',
        icone: 'trimble-fatique',
        cor: 'red',
        descricao: 'ce.enum.common.fadiga',
        alerta: 'FADIGA_MOTORISTA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MANUSEIO_CELULAR = {
        tipo: 'ce.enum.common.usoDeCelular',
        icone: 'trimble-cell-phone-usage',
        cor: 'red',
        descricao: 'ce.enum.common.usoDeCelular',
        alerta: 'MANUSEIO_CELULAR',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PREVISAO_COLISAO = {
        tipo: 'ce.enum.common.quaseColisao',
        icone: 'trimble-collision-warning',
        cor: 'red',
        descricao: 'ce.enum.common.quaseColisao',
        alerta: 'PREVISAO_COLISAO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.USO_CIGARRO = {
        tipo: 'ce.enum.common.usoDeCigarro',
        icone: 'trimble-smoking',
        cor: 'red',
        descricao: 'ce.enum.common.usoDeCigarro',
        alerta: 'USO_CIGARRO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.GPS_INVALIDO = {
        tipo: 'ce.enum.eventos.gpsInvalido',
        icone: 'trimble-gps-off',
        cor: 'red',
        descricao: 'ce.enum.eventos.gpsInvalido',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MOTORISTA_AUSENTE = {
        tipo: 'ce.enum.common.semMotorista',
        icone: 'trimble-no-driver',
        cor: 'red',
        descricao: 'ce.enum.common.semMotorista',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CAMERA_OBSTRUIDA = {
        tipo: 'ce.enum.common.cameraObstruida',
        icone: 'trimble-obstructed-camera',
        cor: 'red',
        descricao: 'ce.enum.common.cameraObstruida',
        alerta: 'CAMERA_OBSTRUIDA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CAMERA_DISCONNECTION_DRIVER = {
        tipo: 'ce.enum.eventos.cameraDisconnectionDriver',
        icone: 'trimble-disconnected-camera',
        cor: 'red',
        descricao: 'ce.enum.eventos.cameraDisconnectionDriver',
        alerta: 'CAMERA_DISCONNECTION_DRIVER',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CAMERA_DISCONNECTION_ROAD = {
        tipo: 'ce.enum.eventos.cameraDisconnectionRoad',
        icone: 'trimble-disconnected-camera',
        cor: 'red',
        descricao: 'ce.enum.eventos.cameraDisconnectionRoad',
        alerta: 'CAMERA_DISCONNECTION_ROAD',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CAMERA_DISCONNECTION_AUDIT = {
        tipo: 'ce.enum.eventos.cameraDisconnectionAudit',
        icone: 'trimble-disconnected-camera',
        cor: 'red',
        descricao: 'ce.enum.eventos.cameraDisconnectionAudit',
        alerta: 'CAMERA_DISCONNECTION_AUDIT',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PERMANENCIA_PONTO = {
        tipo: 'ce.enum.common.permanenciaPontoReferencia',
        icone: 'trimble-duration-stay',
        cor: 'yellow',
        descricao: 'ce.enum.common.permanenciaPontoReferencia',
        alerta: 'PERMANENCIA_PONTO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.SEM_CINTO = {
        tipo: 'ce.enum.common.semCinto',
        icone: 'trimble-no-seatbelt',
        cor: 'yellow',
        descricao: 'ce.enum.common.semCinto',
        alerta: 'SEM_CINTO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.RFID_NAO_CADASTRADO = {
        tipo: 'ce.enum.common.rfidNaoCadastradoLowerCase',
        icone: 'trimble-rfid-alert',
        cor: 'yellow',
        descricao: 'ce.enum.common.rfidNaoCadastrado',
        alerta: 'RFID_NAO_CADASTRADO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.MANUTENCAO_PROGRAMADA_HORIMETRO = {
        tipo: 'ce.enum.common.manutencaoProgramadaHorimetro',
        icone: 'trimble-maintenance-hour-meter',
        cor: 'pink',
        descricao: 'ce.enum.common.manutencaoProgramadaHorimetro',
        alerta: 'MANUTENCAO_PROGRAMADA_HORIMETRO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PANICO = {
        tipo: 'ce.enum.common.botaoPane',
        icone: 'fa fa-exclamation-circle',
        cor: 'red',
        descricao: 'ce.enum.common.botaoPane',
        alerta: 'PANICO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.PERMANENCIA_CERCA = {
        tipo: 'Permanência em Cerca Eletrônica',
        icone: 'trimble-duration-stay-area',
        cor: 'yellow',
        descricao: 'Permanência em Cerca Eletrônica',
        alerta: 'PERMANENCIA_CERCA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CONVERSAO_ILEGAL = {
        tipo: 'ce.enum.common.conversaoSemSinalizacao',
        icone: 'trimble-lane-departure-unindicated',
        cor: 'yellow',
        descricao: 'ce.enum.common.conversaoSemSinalizacao',
        alerta: 'CONVERSAO_ILEGAL',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.AVISO_LIGADO = {
        tipo: 'ce.enum.common.botaoAviso',
        icone: 'fa fa-exclamation-triangle',
        cor: 'yellow',
        descricao: 'ce.enum.common.botaoAviso',
        alerta: 'AVISO_LIGADO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA = {
        tipo: 'ce.enum.common.descida',
        icone: 'material outlined_flag',
        cor: 'blue',
        descricao: 'ce.enum.common.descida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA1 = {
        tipo: 'ce.enum.eventos.descidaFaixa1',
        icone: 'material outlined_flag',
        cor: 'blue',
        descricao: 'ce.enum.common.inicioDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA2 = {
        tipo: 'ce.enum.eventos.descidaFaixa2',
        icone: 'material outlined_flag',
        cor: 'blue',
        descricao: 'ce.enum.common.inicioDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA3 = {
        tipo: 'ce.enum.eventos.descidaFaixa3',
        icone: 'material outlined_flag',
        cor: 'blue',
        descricao: 'ce.enum.common.inicioDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA1_FIM = {
        tipo: 'ce.enum.eventos.descidaFaixa1fim',
        icone: 'material sports_score',
        cor: 'purple',
        descricao: 'ce.enum.common.fimDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA2_FIM = {
        tipo: 'ce.enum.eventos.descidaFaixa2fim',
        icone: 'material sports_score',
        cor: 'purple',
        descricao: 'ce.enum.common.fimDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.DESCIDA_FAIXA3_FIM = {
        tipo: 'ce.enum.eventos.descidaFaixa3fim',
        icone: 'material sports_score',
        cor: 'purple',
        descricao: 'ce.enum.common.fimDescida',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.SEM_CONE = {
        tipo: 'ce.enum.eventos.semCone',
        icone: 'trimble-cone',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.semCone',
        alerta: 'SEM_CONE',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.SEM_OCULOS = {
        tipo: 'ce.enum.eventos.SemOculos',
        icone: 'trimble-sem-oculos',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.SemOculos',
        alerta: 'SEM_OCULOS',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.SEM_LUVAS = {
        tipo: 'ce.enum.eventos.SemLuvas',
        icone: 'trimble-luva',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.SemLuvas',
        alerta: 'SEM_LUVAS',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.BOCEJO = {
        tipo: 'ce.enum.eventos.bocejo',
        icone: 'trimble-yawning',
        cor: 'red',
        descricao: 'ce.enum.eventos.bocejo',
        alerta: 'BOCEJO',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.ULTRAPASSAGEM_ILEGAL = {
        tipo: 'ce.enum.eventos.ultrapassagemIlegal',
        icone: 'trimble-ultrapassagem-ilegal',
        cor: 'red',
        descricao: 'ce.enum.eventos.ultrapassagemIlegal',
        alerta: 'ULTRAPASSAGEM_ILEGAL',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.CARONA = {
        tipo: 'ce.enum.eventos.carona',
        icone: 'trimble-carona',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.carona',
        alerta: 'CARONA',
        isEnabled: function isEnabled() {
          return true;
        }
      };
      this.FOLLOWING_DISTANCE = {
        tipo: 'ce.enum.eventos.followingDistance',
        icone: 'trimble-unit-selector1',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.followingDistance',
        alerta: 'FOLLOWING_DISTANCE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.followingDistance && configuracoesEventos.followingDistance.enabled === false);
        }
      };
      this.COLLISION_MITIGATION = {
        tipo: 'ce.enum.eventos.collisionMitigation',
        icone: 'trimble-collision-warning',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.collisionMitigation',
        alerta: 'COLLISION_MITIGATION',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.collisionMitigation && configuracoesEventos.collisionMitigation.enabled === false);
        }
      };
      this.FCW_BRAKE_EXT_ACC_DEM = {
        tipo: 'ce.enum.eventos.fcwBrakeExtAccDem',
        icone: 'trimble-truck-warning-delay1',
        tooltip: 'ce.enum.eventosTooltips.fcwBrakeExtAccDem',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.fcwBrakeExtAccDem',
        alerta: 'FCW_BRAKE_EXT_ACC_DEM',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.fcwBrakeExtAccDem && configuracoesEventos.fcwBrakeExtAccDem.enabled === false);
        }
      };
      this.HAPTIC_WARNING = {
        tipo: 'ce.enum.eventos.hapticWarning',
        icone: 'trimble-traffic-cone_outline',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.hapticWarning',
        alerta: 'HAPTIC_WARNING',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.hapticWarning && configuracoesEventos.hapticWarning.enabled === false);
        }
      };
      this.ROP_BRAKE = {
        tipo: 'ce.enum.eventos.ropBrake',
        icone: 'trimble-between_outline',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.ropBrake',
        alerta: 'ROP_BRAKE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.ropBrake && configuracoesEventos.ropBrake.enabled === false);
        }
      };

      this.ROP_ENGINE = {
        tipo: 'ce.enum.eventos.ropEngine',
        icone: 'trimble-between_outline',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.ropEngine',
        alerta: 'ROP_ENGINE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.ropEngine && configuracoesEventos.ropEngine.enabled === false);
        }
      };

      this.YC_BRAKE = {
        tipo: 'ce.enum.eventos.ycBrake',
        icone: 'trimble-advanced-instructions_outline',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.ycBrake',
        alerta: 'YC_BRAKE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.ycBrake && configuracoesEventos.ycBrake.enabled === false);
        }
      };

      this.YC_ENGINE = {
        tipo: 'ce.enum.eventos.ycEngine',
        icone: 'trimble-advanced-instructions_outline',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.ycEngine',
        alerta: 'YC_ENGINE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.ycEngine && configuracoesEventos.ycEngine.enabled === false);
        }
      };

      this.FCW = {
        tipo: 'ce.enum.eventos.fcw',
        icone: 'trimble-truck-warning-delay1',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.fcw',
        alerta: 'FCW',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.fcw && configuracoesEventos.fcw.enabled === false);
        }
      };

      this.UNAUTHORIZED_VEHICLE_USE = {
        tipo: 'ce.enum.eventos.unauthorizedVehicleUse',
        icone: 'trimble-car-crash',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.unauthorizedVehicleUse',
        alerta: 'UNAUTHORIZED_VEHICLE_USE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.unauthorizedVehicleUse && configuracoesEventos.unauthorizedVehicleUse.enabled === false);
        }
      };

      this.MANUSEIO_OBJETO = {
        tipo: 'ce.enum.eventos.manuseioObjeto',
        icone: 'trimble-handling-object',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.manuseioObjeto',
        alerta: 'MANUSEIO_OBJETO',
        isEnabled: function isEnabled(configuracoesEventos) {
          return _this.featureHub.isFeatureEnabled(_this.featureHubConfigKeys.MANUSEIO_OBJETO_FRONTEND) && configuracoesEventos && configuracoesEventos.manuseioObjeto && configuracoesEventos.manuseioObjeto.enabled;
        }
      };

      this.ROLLING_STOP = {
        tipo: 'ce.enum.eventos.rollingStop',
        icone: 'trimble-rolling-stop',
        cor: 'white',
        descricao: 'ce.enum.eventos.rollingStop',
        alerta: 'ROLLING_STOP',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.rollingStop && configuracoesEventos.rollingStop.enabled === false);
        }
      };

      this.NO_STOP = {
        tipo: 'ce.enum.eventos.noStop',
        icone: 'trimble-no-stop',
        cor: 'white',
        descricao: 'ce.enum.eventos.noStop',
        alerta: 'NO_STOP',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.noStop && configuracoesEventos.noStop.enabled === false);
        }
      };

      this.ROUTE_DEVIATION = {
        tipo: 'ce.enum.eventos.routeDeviation',
        icone: 'trimble-route-deviation',
        cor: 'yellow',
        descricao: 'ce.enum.eventos.routeDeviation',
        alerta: 'ROUTE_DEVIATION',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.routeDeviation && configuracoesEventos.routeDeviation.enabled === false);
        }
      };

      this.SEM_CASQUETE = {
        tipo: 'ce.enum.eventos.semCasquete',
        icone: 'trimble-hard-helmet',
        cor: 'red',
        descricao: 'ce.enum.eventos.semCasquete',
        alerta: 'SEM_CASQUETE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return !(configuracoesEventos && configuracoesEventos.semCasquete && configuracoesEventos.semCasquete.enabled === false);
        }
      };

      this.MANUAL_EVENT_HARDWARE = {
        tipo: 'ce.enum.eventos.manualEventHardware',
        icone: 'trimble-manual-event-hardware',
        cor: 'red',
        descricao: 'ce.enum.eventos.manualEventHardware',
        alerta: 'MANUAL_EVENT_HARDWARE',
        isEnabled: function isEnabled(configuracoesEventos) {
          return _this.featureHub.isFeatureEnabled(_this.featureHubConfigKeys.MANUAL_EVENT_HARDWARE) && !(configuracoesEventos && configuracoesEventos.manualEventHardware && configuracoesEventos.manualEventHardware.enabled === false);
        }
      };

      this.eventos = this.translateEvents([this.EXCESSO_VELOCIDADE, this.EXCESSO_VELOCIDADE1, this.EXCESSO_VELOCIDADE2, this.EXCESSO_VELOCIDADE3, this.EXCESSO_VELOCIDADE_VIA, this.RFID, this.IGNICAO_LIGADA, this.IGNICAO_DESLIGADA, this.PONTO_REFERENCIA, this.INICIO_JORNADA, this.INICIO_JORNADA_AJUDANTE, this.EM_JORNADA, this.DIRECAO, this.REFEICAO, this.DESCANSO, this.ESPERA, this.ENTREGA, this.RESERVA, this.FIM_JORNADA, this.FIM_JORNADA_AJUDANTE, this.BANGUELA, this.RPM, this.MOTOR_OCIOSO, this.ACELERACAO_BRUSCA, this.FRENAGEM_BRUSCA, this.FRENAGEM_BRUSCA_COM_PEDAL, this.FRENAGEM_BRUSCA_SEM_PEDAL, this.TREPIDACAO, this.CURVA_BRUSCA, this.CURVA_BRUSCA_ESQUERDA, this.CURVA_BRUSCA_DIREITA, this.MOVIMENTO, this.PARADO, this.PARADO_EX_1, this.PARADO_EX_2, this.PARADO_EX_3, this.PARADO_EX_4, this.REMOCAO_EQUIPAMENTO, this.CONEXAO_EQUIPAMENTO, this.POSSIVEL_COLISAO, this.DIAGNOSTICO_OBD, this.DIAGNOSTICO_CAN, this.PARADO_LIGADO, this.VEICULO_SEM_VIGENCIA, this.VEICULO_SEM_SINAL, this.ABERTURA_VIGENCIA, this.FECHAMENTO_VIGENCIA, this.SENSOR_ACIONADO, this.MANUTENCAO_PROGRAMADA, this.DISTANCIA_PERIGOSA, this.DISTRACAO_MOTORISTA, this.FADIGA_MOTORISTA, this.MANUSEIO_CELULAR, this.PREVISAO_COLISAO, this.USO_CIGARRO, this.GPS_INVALIDO, this.MOTORISTA_AUSENTE, this.CAMERA_OBSTRUIDA, this.CAMERA_DISCONNECTION_DRIVER, this.CAMERA_DISCONNECTION_ROAD, this.CAMERA_DISCONNECTION_AUDIT, this.PERMANENCIA_PONTO, this.SEM_CINTO, this.RFID_NAO_CADASTRADO, this.MANUTENCAO_PROGRAMADA_HORIMETRO, this.PANICO, this.PERMANENCIA_CERCA, this.CONVERSAO_ILEGAL, this.AVISO_LIGADO, this.DESCIDA, this.DESCIDA_FAIXA1, this.DESCIDA_FAIXA2, this.DESCIDA_FAIXA3, this.DESCIDA_FAIXA1_FIM, this.DESCIDA_FAIXA2_FIM, this.DESCIDA_FAIXA3_FIM, this.SEM_CONE, this.SEM_OCULOS, this.SEM_LUVAS, this.BOCEJO, this.ULTRAPASSAGEM_ILEGAL, this.CARONA, this.FOLLOWING_DISTANCE, this.ROP_BRAKE, this.ROP_ENGINE, this.YC_BRAKE, this.YC_ENGINE, this.COLLISION_MITIGATION, this.FCW_BRAKE_EXT_ACC_DEM, this.HAPTIC_WARNING, this.FCW, this.UNAUTHORIZED_VEHICLE_USE, this.MANUSEIO_OBJETO, this.ROLLING_STOP, this.NO_STOP, this.ROUTE_DEVIATION, this.SEM_CASQUETE, this.MANUAL_EVENT_HARDWARE]);
    }

    _createClass(EventosService, [{
      key: 'translateEvents',
      value: function translateEvents(eventos) {
        var _this2 = this;

        return eventos.map(function (event) {
          return {
            tipo: _this2.translate.instant(event.tipo),
            icone: event.icone,
            cor: event.cor,
            descricao: _this2.translate.instant(event.descricao),
            alerta: event.alerta,
            isEnabled: event.isEnabled
          };
        });
      }
    }, {
      key: 'isLocalizacao',
      value: function isLocalizacao(evento) {
        return evento === this.translate.instant(this.LOCALIZACAO) || evento === this.translate.instant(this.MOVIMENTO.tipo);
      }
    }, {
      key: 'isAlerta',
      value: function isAlerta(evento) {
        return !this.isLocalizacao(evento) && !this.isIgnicao(evento) && !this.isPontoDeReferencia(evento) && !this.isRfid(evento);
      }
    }, {
      key: 'isRfid',
      value: function isRfid(evento) {
        return evento === this.translate.instant(this.RFID.tipo);
      }
    }, {
      key: 'isIgnicaoLigada',
      value: function isIgnicaoLigada(evento) {
        return evento === this.translate.instant(this.IGNICAO_LIGADA.tipo);
      }
    }, {
      key: 'isIgnicaoDesligada',
      value: function isIgnicaoDesligada(evento) {
        return evento === this.translate.instant(this.IGNICAO_DESLIGADA.tipo);
      }
    }, {
      key: 'isIgnicao',
      value: function isIgnicao(evento) {
        var ignicao = this.translate.instant('ce.enum.eventos.ignicao');
        return evento.indexOf(ignicao) > -1;
      }
    }, {
      key: 'isDiagnosticoObd',
      value: function isDiagnosticoObd(evento) {
        var diagnosticoObd = this.translate.instant('ce.enum.eventos.diagnosticoObd');
        return evento.indexOf(diagnosticoObd) > -1;
      }
    }, {
      key: 'isExcessoVelocidade',
      value: function isExcessoVelocidade(evento) {
        return evento === this.EXCESSO_VELOCIDADE.tipo || evento === this.translate.instant(this.EXCESSO_VELOCIDADE1.tipo) || evento === this.translate.instant(this.EXCESSO_VELOCIDADE2.tipo) || evento === this.translate.instant(this.EXCESSO_VELOCIDADE3.tipo);
      }
    }, {
      key: 'isCurvaBrusca',
      value: function isCurvaBrusca(evento) {
        if (angular.isString(evento)) {
          var eventoUpperCase = evento.toUpperCase();
          return eventoUpperCase === this.translate.instant(this.CURVA_BRUSCA.tipo).toUpperCase() || eventoUpperCase === this.translate.instant(this.CURVA_BRUSCA_DIREITA.tipo).toUpperCase() || eventoUpperCase === this.translate.instant(this.CURVA_BRUSCA_ESQUERDA.tipo).toUpperCase();
        }
        return false;
      }
    }, {
      key: 'isFrenagemBrusca',
      value: function isFrenagemBrusca(evento) {
        if (angular.isString(evento)) {
          var eventoUpperCase = evento.toUpperCase();
          return eventoUpperCase === this.translate.instant(this.FRENAGEM_BRUSCA.tipo).toUpperCase();
        }
      }
    }, {
      key: 'getTipoFrenagem',
      value: function getTipoFrenagem(acionamentoPedal) {
        switch (acionamentoPedal) {
          case true:
            return this.translate.instant(this.FRENAGEM_BRUSCA_COM_PEDAL.tipo);
          case false:
            return this.translate.instant(this.FRENAGEM_BRUSCA_SEM_PEDAL.tipo);
          default:
            return this.translate.instant(this.FRENAGEM_BRUSCA.tipo);
        }
      }
    }, {
      key: 'isPontoDeReferencia',
      value: function isPontoDeReferencia(evento) {
        return evento === this.translate.instant(this.PONTO_REFERENCIA.tipo);
      }
    }, {
      key: 'getEvento',
      value: function getEvento(tipo) {
        return this.eventos.filter(function (evento) {
          return evento.tipo === tipo;
        })[0];
      }
    }, {
      key: 'getByAlerta',
      value: function getByAlerta(alertaId) {
        return this.eventos.find(function (evento) {
          return !!evento.alerta && evento.alerta === alertaId;
        });
      }
    }]);

    return EventosService;
  }();

  angular.module('ModuleEventos').service('Eventos', EventosService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CustomGridster = function () {
    function CustomGridster($window) {
      _classCallCheck(this, CustomGridster);

      this.window = $window;
      this.resizable = {
        enabled: false
      };
      this.draggable = {
        enabled: false
      };
    }

    _createClass(CustomGridster, [{
      key: 'setStatusGridster',
      value: function setStatusGridster(item) {
        this.resizable.enabled = item;
        this.draggable.enabled = item;
      }
    }, {
      key: 'getOptions',
      value: function getOptions(rowHeight) {
        return {
          minRows: 1,
          maxRows: 200,
          columns: 12,
          rowHeight: rowHeight,
          margins: [15, 15],
          mobileBreakPoint: 800,
          resizable: this.resizable,
          draggable: this.draggable,
          swapping: true
        };
      }
    }, {
      key: 'getLocalStorage',
      value: function getLocalStorage(name) {
        return angular.fromJson(this.window.localStorage.getItem(name));
      }
    }, {
      key: 'setLocalStorage',
      value: function setLocalStorage(name, item) {
        this.window.localStorage.setItem(name, angular.toJson(item));
      }
    }, {
      key: 'removeLocalStorage',
      value: function removeLocalStorage(name) {
        this.window.localStorage.removeItem(name);
      }
    }]);

    return CustomGridster;
  }();

  angular.module('customGridsterModule', ['gridster']).service('CustomGridster', CustomGridster);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ModuleConvertersUtil', []).service('ConvertersService', function () {
    var KM_TO_MILE_CONVERSION = 0.621371,
        MILES_DECIMAL_CONSTANT = 0.609,
        MILE_TO_KM_CONVERSION = 1 / KM_TO_MILE_CONVERSION,
        truncateMiles = function truncateMiles(miles) {
      return Math.floor(miles);
    },
        roundUpKilometers = function roundUpKilometers(kilometers) {
      return Math.ceil(kilometers);
    },
        parseKm = function parseKm(km) {
      if (km === null || angular.isUndefined(km)) {
        return null;
      }
      var parsedKm = angular.isString(km) ? parseFloat(km) : km;
      return Number.isNaN(parsedKm) ? null : parsedKm;
    };

    this.handleKmToMiles = function (km) {
      var parsedKm = parseKm(km);
      return parsedKm === null ? km : truncateMiles(parsedKm * KM_TO_MILE_CONVERSION);
    };

    this.handleKmToMilesWithDecimal = function (km, decimalCases) {
      var parsedKm = parseKm(km);
      return parsedKm === null ? km : Number((parsedKm * KM_TO_MILE_CONVERSION).toFixed(decimalCases));
    };

    this.handleMilesToKm = function (mile) {
      if (mile === null || angular.isUndefined(mile)) {
        return mile;
      }

      var parsedMile = angular.isString(mile) ? parseFloat(mile) : mile;

      if (Number.isNaN(parsedMile)) {
        return mile;
      }

      return roundUpKilometers(parsedMile * MILE_TO_KM_CONVERSION + MILES_DECIMAL_CONSTANT);
    };
  }).filter('formatSpeedMeasure', function () {
    return function (speed, userSpeedMeasurement) {
      if (userSpeedMeasurement === 'MILES') {
        return speed + ' mph';
      }
      return speed + ' KM/H';
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable */
(function () {
  'use strict';

  var PlanosSolucoesCtrl = function () {
    function PlanosSolucoesCtrl(Authenticator, FeatureOuService, $state, $window, ServiceVfiltro, FactoryVfiltro) {
      var _this = this;

      _classCallCheck(this, PlanosSolucoesCtrl);

      this.auth = Authenticator;
      this.FeatureOuService = FeatureOuService;
      this.window = $window;
      this.state = $state;
      this.shouldRedirectToUnauthorizedNAPage = false;
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.init();
      });
    }

    _createClass(PlanosSolucoesCtrl, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.auth.getUser().then(function (user) {
          _this2.window.localStorage.removeItem('vfiltro-' + user.id);
          var contratacaoPlanos = angular.element('vfwc-contratacao-planos')[0];
          if (contratacaoPlanos) {
            contratacaoPlanos.solucaoIds = user.plain().solucoes.map(function (solucao) {
              return solucao.solucaoId;
            });
            contratacaoPlanos.uoId = user.plain().uo.id;
          }
          _this2.getEventsConfig(user.plain().uo.id);
        });
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(userUoId) {
        var _this3 = this;

        this.FeatureOuService.getEventsConfig(userUoId).then(function (eventNaConfig) {
          _this3.shouldRedirectToUnauthorizedNAPage = eventNaConfig;
          if (_this3.shouldRedirectToUnauthorizedNAPage) {
            _this3.state.go('root.unauthorized');
          }
        }).catch(function (error) {
          console.error('Error loading featureOu config: ', error);
        });
      }
    }]);

    return PlanosSolucoesCtrl;
  }();

  PlanosSolucoesCtrl.$inject = ['Authenticator', 'FeatureOuService', '$state', '$window', 'ServiceVfiltro', 'FactoryVfiltro'];

  angular.module('planosSolucoesModule', ['ui.router', 'v3gAuthenticatorModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule']).controller('PlanosSolucoesCtrl', PlanosSolucoesCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.unauthorized', {
      url: '/unauthorized',
      views: {
        'content@': {
          templateUrl: 'unauthorized-na-user/unauthorized-na-user.tpl.html',
          controller: 'UnauthorizedCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        hideTitulo: true
      }
    });
  }

  angular.module('planosSolucoesModule').config(pageConfig);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var UnauthorizedCtrl = function UnauthorizedCtrl() {
    _classCallCheck(this, UnauthorizedCtrl);
  };

  angular.module('planosSolucoesModule').controller('UnauthorizedCtrl', UnauthorizedCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('usuarioModule').factory('UsuariosVfleets', function (Restangular) {
    var service = Restangular.service('auth/usuario');
    service.getUsuariosDaUo = function () {
      return Restangular.all('auth/usuario/uo').withHttpConfig({ cache: true }).getList();
    };
    service.getUsuarios = function (params) {
      return Restangular.all('auth/usuarios').getList(params);
    };
    service.getUsuariosAtribuiveis = function (veiculoIds) {
      return Restangular.all('alerta/usuarios/atribuiveis').getList({
        veiculoIds: veiculoIds.join()
      });
    };
    return service;
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('UoHelperModule', ['enumModule']).factory('UoHelperService', UoHelperService);

  function UoHelperService(RootUoEnum) {
    var service = {
      isRoot: isRoot,
      isDirectChildOfRoot: isDirectChildOfRoot
    };

    return service;

    function isRoot(uoId) {
      return RootUoEnum.getIds().includes(Number(uoId));
    }

    function isDirectChildOfRoot(uo) {
      return isRoot(uo && uo.uoPai && uo.uoPai.id);
    }
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('FeatureOuModule', ['alert-message']).factory('FeatureOuService', ['Restangular', 'AlertMessage', '$q', '$window', FeatureOuService]);

  function FeatureOuService(Restangular, AlertMessage, $q, $window) {
    var inMemoryPromiseCache = {};
    var LOCAL_STORAGE_KEY = 'featureOuConfig';
    var CACHE_EXPIRATION_MS = 60 * 60 * 1000;

    var service = {
      getFeatureOuConfig: getFeatureOuConfig,
      getDecoratedVideoPlayerConfig: getDecoratedVideoPlayerConfig,
      getDeviceScreenConfig: getDeviceScreenConfig,
      getEventsConfig: getEventsConfig,
      getVehicleRegistrationConfig: getVehicleRegistrationConfig,
      getVehicleTableConfig: getVehicleTableConfig,
      getLastVisitedPageReload: getLastVisitedPageReload,
      getTrimbleLogo: getTrimbleLogo,
      getProductName: getProductName,
      getWhatsNewConfig: getWhatsNewConfig,
      handleError: handleError,
      clearCache: clearCache
    };

    return service;

    function getFeatureOuConfig(ouId) {
      if (!ouId) {
        return $q.reject(new Error('FeatureOuService: ouId cannot be null or undefined.'));
      }

      if (inMemoryPromiseCache[ouId]) {
        return inMemoryPromiseCache[ouId];
      }

      var cachedData = getFromLocalStorage(ouId);
      if (cachedData) {
        var resolvedPromise = $q.resolve(cachedData);
        inMemoryPromiseCache[ouId] = resolvedPromise;
        return resolvedPromise;
      }

      var requestPromise = Restangular.one('configuracao/configuracoes/' + ouId + '/feature-ou').get().then(function (featureOu) {
        var configData = featureOu.plain();
        saveToLocalStorage(ouId, configData);
        return configData;
      }).catch(function (error) {
        delete inMemoryPromiseCache[ouId];
        return handleError(error);
      });

      inMemoryPromiseCache[ouId] = requestPromise;

      return requestPromise;
    }

    function saveToLocalStorage(ouId, data) {
      try {
        var allConfigs = angular.fromJson($window.localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
        allConfigs[ouId] = {
          timestamp: new Date().getTime(),
          data: data
        };
        $window.localStorage.setItem(LOCAL_STORAGE_KEY, angular.toJson(allConfigs));
      } catch (e) {
        console.error('FeatureOuService: Failed to save localStorage.', e);
      }
    }

    function isCacheItemValid(item) {
      if (!item || !item.timestamp) {
        return false;
      }
      var now = new Date().getTime();
      return now - item.timestamp <= CACHE_EXPIRATION_MS;
    }

    function getFromLocalStorage(ouId) {
      try {
        var allConfigs = angular.fromJson($window.localStorage.getItem(LOCAL_STORAGE_KEY));
        var item = allConfigs ? allConfigs[ouId] : null;

        if (isCacheItemValid(item)) {
          return item.data;
        }

        if (allConfigs && allConfigs[ouId]) {
          delete allConfigs[ouId];
          $window.localStorage.setItem(LOCAL_STORAGE_KEY, angular.toJson(allConfigs));
        }

        return null;
      } catch (e) {
        console.error('FeatureOuService: Failed to read from localStorage.', e);
        return null;
      }
    }

    function getDecoratedVideoPlayerConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.decoratedVideoPlayer;
      });
    }

    function getDeviceScreenConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.deviceScreen;
      });
    }

    function getEventsConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.events;
      });
    }

    function getVehicleRegistrationConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.vehicleRegistration;
      });
    }

    function getVehicleTableConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.vehicleTable;
      });
    }

    function getLastVisitedPageReload(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.lastVisitedPageReload;
      });
    }

    function getTrimbleLogo(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.trimbleLogo;
      });
    }

    function getProductName(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.vi20ProductName;
      });
    }

    function getWhatsNewConfig(ouId) {
      return getFeatureOuConfig(ouId).then(function (featureOu) {
        return featureOu.whatsNew;
      });
    }

    function handleError(error) {
      AlertMessage.create({
        type: 'error',
        message: 'An error occurred while loading the settings: ' + error.data.message,
        appendTo: '.alerta-aqui-geral'
      });
      return $q.reject(error);
    }

    function clearCache() {
      inMemoryPromiseCache = {};
      try {
        $window.localStorage.removeItem(LOCAL_STORAGE_KEY);
      } catch (e) {
        console.error('FeatureOuService: Failed to clean up localStorage.', e);
      }
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var DecoratedVideoPlayerService = function () {
    function DecoratedVideoPlayerService(safetyService, $document, $rootScope, $window) {
      _classCallCheck(this, DecoratedVideoPlayerService);

      this.safetyService = safetyService;
      this.document = $document[0];
      this.window = $window;
      this.coachingStatus = 'UNDECIDED';
      this.rootScope = $rootScope;
      this.addCloseListener();
      this.addCoachRequiredListener();
      this.addCommentListener();
    }

    _createClass(DecoratedVideoPlayerService, [{
      key: 'addCommentListener',
      value: function addCommentListener() {
        var _this = this;

        this.window.addEventListener('commentSavedEvent', function (event) {
          if (event && event.detail) {
            var _event$detail = event.detail,
                vehicleId = _event$detail.vehicleId,
                datahora = _event$detail.datahora,
                comment = _event$detail.comment;

            _this.rootScope.$applyAsync(function () {
              _this.rootScope.$emit('commentSavedEvent', { vehicleId: vehicleId, datahora: datahora, comment: comment });
            });
          }
        });
      }
    }, {
      key: 'addCoachRequiredListener',
      value: function addCoachRequiredListener() {
        var _this2 = this;

        this.window.addEventListener('coachRequiredEvent', function (event) {
          if (event && event.detail) {
            _this2.coachingStatus = event.detail.coachingStatus;
            _this2.rootScope.$applyAsync(function () {
              _this2.rootScope.$emit('coachRequiredUpdated', _this2.coachingStatus);
            });
          }
        });
      }
    }, {
      key: 'addCloseListener',
      value: function addCloseListener() {
        var _this3 = this;

        this.rootScope.$on('closeDecoratedVideoPlayer', function () {
          _this3.safetyService.unmountReactComponent('decoratedVideoPlayerModalContainer');
          _this3.rootScope.$emit('updateDecoratedVideoPlayer');
        });
      }
    }, {
      key: 'loadDecoratedVideoPlayer',
      value: function loadDecoratedVideoPlayer(props) {
        var _this4 = this;

        var isSeparatedVideoScreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var appName = 'safetyApp',
            componentPath = './VideoPlayerModal',
            componentId = 'decoratedVideoPlayerModalContainer';

        if (this.document.getElementById(componentId)) {
          this.safetyService.unmountReactComponent(componentId);
        }

        if (!isSeparatedVideoScreen) {
          props.onCloseDecoratedVideoPlayer = function () {
            _this4.rootScope.$apply(function () {
              _this4.rootScope.$emit('closeDecoratedVideoPlayer');
              _this4.window.parent.postMessage({ event: 'closeDecoratedVideoPlayer' });
              if (_this4.coachingStatus === 'COACHING_REQUIRED' || _this4.coachingStatus === 'NO_COACHING_REQUIRED' || _this4.coachingStatus === 'UNDECIDED' || _this4.coachingStatus === 'DISMISSED' || _this4.coachingStatus === 'COMPLETED') {
                _this4.rootScope.$emit('updateTable', {
                  vehicleId: props.vehicleId,
                  datahora: props.datahora,
                  coachingStatus: _this4.coachingStatus
                });
              }
            });
          };
        }

        this.safetyService.loadReactComponent(appName, componentPath, componentId, props).catch(function (error) {
          return console.error('Error loading Decorated Video Player:', error);
        });
      }
    }]);

    return DecoratedVideoPlayerService;
  }();

  DecoratedVideoPlayerService.$inject = ['safetyService', '$document', '$rootScope', '$window'];

  angular.module('videoPlayer').service('DecoratedVideoPlayerService', DecoratedVideoPlayerService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('reportwrongspeedviaModule', ['pascalprecht.translate']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ReportWrongSpeedViaService = function () {
    function ReportWrongSpeedViaService($httpParamSerializer, $translate, URL_GOOGLE_FORMS, FORM_FIELD_NOME, FORM_FIELD_EMAIL, FORM_FIELD_COORDENADAS, UO_IDS_PERMITIDAS) {
      _classCallCheck(this, ReportWrongSpeedViaService);

      this.httpParamSerializer = $httpParamSerializer;
      this.translate = $translate;

      this.URL_GOOGLE_FORMS = URL_GOOGLE_FORMS;
      this.FORM_FIELD_NOME = FORM_FIELD_NOME;
      this.FORM_FIELD_EMAIL = FORM_FIELD_EMAIL;
      this.FORM_FIELD_COORDENADAS = FORM_FIELD_COORDENADAS;
      this.UO_IDS_PERMITIDAS = UO_IDS_PERMITIDAS;
    }

    _createClass(ReportWrongSpeedViaService, [{
      key: 'getLinkToFormHtml',
      value: function getLinkToFormHtml(usuario, latitude, longitude) {
        if (usuario && this.UO_IDS_PERMITIDAS.includes(usuario.uo.id)) {
          var _httpParamSerializer;

          var params = this.httpParamSerializer((_httpParamSerializer = {}, _defineProperty(_httpParamSerializer, this.FORM_FIELD_NOME, usuario.nome), _defineProperty(_httpParamSerializer, this.FORM_FIELD_EMAIL, usuario.login), _defineProperty(_httpParamSerializer, this.FORM_FIELD_COORDENADAS, latitude + ', ' + longitude), _httpParamSerializer));

          return '<a href="' + this.URL_GOOGLE_FORMS + '?' + params + '"' + (' target="_blank"><i class="trimble-wrong-speed"></i> ' + this.translate.instant('ce.mapa.common.modal.popupService.reportarVelocidadeIncorreta') + '</a><br/>');
        }
        return '';
      }
    }]);

    return ReportWrongSpeedViaService;
  }();

  angular.module('reportwrongspeedviaModule').service('ReportWrongSpeedViaService', ReportWrongSpeedViaService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('reportwrongspeedviaModule').constant('URL_GOOGLE_FORMS', 'https://docs.google.com/forms/d/e/1FAIpQLSeiK6r2qgaDmOR87d8keO6kmQOce_xaDECOZQPG9uKqkWI1eg/viewform').constant('FORM_FIELD_NOME', 'entry.1172079207').constant('FORM_FIELD_EMAIL', 'entry.1373458914').constant('FORM_FIELD_COORDENADAS', 'entry.1196063270').constant('UO_IDS_PERMITIDAS', [5373, 3854]);
})();
'use strict';

(function () {
  'use strict';

  angular.module('resumoPeriodoModule', ['enumModule', 'pascalprecht.translate', 'ModuleEventos', 'ServiceVfiltroModule', 'ConstantModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  function resumoPeriodo() {
    return {
      templateUrl: 'relatorios/resumo-periodo.tpl.html',
      controller: 'ResumoPeriodoCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {
        titulo: '=',
        subtitulo: '=',
        duracao: '=',
        distancia: '=',
        consumoCombustivel: '=',
        mediaConsumo: '=',
        consumoEletrico: '=',
        mediaConsumoEletrico: '=',
        logradouroInicio: '=',
        logradouroFim: '=',
        conducoes: '=',
        tempoPorFaixaRpm: '=',
        onClickEvento: '=',
        onClickPosicao: '=',
        faixasDescida: '=',
        diferencaAltitude: '='
      }
    };
  }

  var ResumoPeriodoCtrl = function () {
    function ResumoPeriodoCtrl($scope, EventosEnum, $sce, $translate, Eventos, ServiceVfiltro, GoogleTagManagerUtils, $rootScope, MeasurementUnitConverterService, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, ResumoPeriodoCtrl);

      this.scope = $scope;
      this.eventosEnum = EventosEnum;
      this.translate = $translate;
      this.sce = $sce;
      this.eventos = Eventos;
      this.serviceVfiltro = ServiceVfiltro;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.enableTooltipTitulo = false;
      this.enableTooltipSubtitulo = false;
      this.eventoSelecionado = '';
      this.eventoTipoSelecionado = '';
      this.trusted = {};
      this.events = [];
      this.feature462 = FeaturehubJsSdk.isFeatureEnabled('LAINT46_bdx_page');
      this.featRollingStop = FeaturehubJsSdk.isFeatureEnabled('PSVI453_ROLLING_STOP');
      this.featRouteDeviation = FeaturehubJsSdk.isFeatureEnabled('LADRX661_ROUTE_DEVIATION');
      this.hasIgnoredEvents = false;

      this.buildEvents();
      this.eventosContendoCurva = this.translate.instant(this.eventosEnum.CURVA);
      this.descidaFaixa1 = this.translate.instant(this.eventos.DESCIDA_FAIXA1.tipo);
      this.descidaFaixa2 = this.translate.instant(this.eventos.DESCIDA_FAIXA2.tipo);
      this.scope.$watch('conducoes', function (conducoes) {
        _this.agruparEventosDasConducoes(conducoes);
        _this.agruparDescidasDasConducoes(conducoes);
      });
      this.rootScope = $rootScope;
      this.measurementUnitConverterService = MeasurementUnitConverterService;

      this.distanceUnit = this.measurementUnitConverterService.getDistanceUnit(this.rootScope.usuario.measurementUnits.distanceMeasurement);
      this.fuelUnit = this.measurementUnitConverterService.getFuelUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.fuelEfficiency = this.measurementUnitConverterService.getFuelEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
      this.energyUnit = 'kWh';
      this.energyEfficiency = this.measurementUnitConverterService.getEnergyEfficiencyUnit(this.rootScope.usuario.measurementUnits.fuelMeasurement);
    }

    _createClass(ResumoPeriodoCtrl, [{
      key: 'buildEvents',
      value: function buildEvents() {
        var _events,
            _this2 = this;

        this.events = (_events = {}, _defineProperty(_events, this.getTranslation(this.eventosEnum.EXCESSO_VELOCIDADE), this.buildEvent('trimble-speeding', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ACELERACAO_BRUSCA), this.buildEvent('trimble-harsh-acceleration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.FRENAGEM_BRUSCA), this.buildEvent('trimble-harsh-braking')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CURVA_BRUSCA), this.buildEvent('trimble-sharp-turn')), _defineProperty(_events, this.getTranslation(this.eventosEnum.BANGUELA), this.buildEvent('trimble-coasting', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.PARADO_LIGADO), this.buildEvent('trimble-idling', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.RPM_EXCESSIVO), this.buildEvent('trimble-rpm', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.EXCESSO_VELOCIDADE_VIA), this.buildEvent('trimble-speeding', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SENSOR_ACIONADO), this.buildEvent('trimble-sensor-on', 'duration')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CAMERA_OBSTRUIDA), this.buildEvent('trimble-obstructed-camera')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CAMERA_DISCONNECTION_DRIVER), this.buildEvent('trimble-disconnected-camera')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CAMERA_DISCONNECTION_ROAD), this.buildEvent('trimble-disconnected-camera')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CAMERA_DISCONNECTION_AUDIT), this.buildEvent('trimble-disconnected-camera')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SEM_CINTO), this.buildEvent('trimble-no-seatbelt')), _defineProperty(_events, this.getTranslation(this.eventosEnum.BOCEJO), this.buildEvent('trimble-yawning')), _defineProperty(_events, this.getTranslation(this.eventosEnum.MOTORISTA_AUSENTE), this.buildEvent('trimble-no-driver')), _defineProperty(_events, this.getTranslation(this.eventosEnum.USO_CIGARRO), this.buildEvent('trimble-smoking')), _defineProperty(_events, this.getTranslation(this.eventosEnum.DISTRACAO_MOTORISTA), this.buildEvent('trimble-distraction')), _defineProperty(_events, this.getTranslation(this.eventosEnum.FADIGA_MOTORISTA), this.buildEvent('trimble-fatique')), _defineProperty(_events, this.getTranslation(this.eventosEnum.MANUSEIO_CELULAR), this.buildEvent('trimble-cell-phone-usage')), _defineProperty(_events, this.getTranslation(this.eventosEnum.DISTANCIA_PERIGOSA), this.buildEvent('trimble-distance-warning')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ULTRAPASSAGEM_ILEGAL), this.buildEvent('trimble-ultrapassagem-ilegal')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SEM_CONE), this.buildEvent('trimble-cone')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SEM_OCULOS), this.buildEvent('trimble-sem-oculos')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SEM_LUVAS), this.buildEvent('trimble-luva')), _defineProperty(_events, this.getTranslation(this.eventosEnum.CARONA), this.buildEvent('trimble-carona')), _defineProperty(_events, this.getTranslation(this.eventosEnum.FOLLOWING_DISTANCE), this.buildEvent('trimble-unit-selector1')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ROP_ENGINE), this.buildEvent('trimble-between_outline')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ROP_BRAKE), this.buildEvent('trimble-between_outline')), _defineProperty(_events, this.getTranslation(this.eventosEnum.YC_ENGINE), this.buildEvent('trimble-advanced-instructions_outline')), _defineProperty(_events, this.getTranslation(this.eventosEnum.YC_BRAKE), this.buildEvent('trimble-advanced-instructions_outline')), _defineProperty(_events, this.getTranslation(this.eventosEnum.COLLISION_MITIGATION), this.buildEvent('trimble-collision-warning1')), _defineProperty(_events, this.getTranslation(this.eventosEnum.HAPTIC_WARNING), this.buildEvent('trimble-traffic-cone_outline')), _defineProperty(_events, this.getTranslation(this.eventosEnum.FCW_BRAKE_EXT_ACC_DEM), this.buildEvent('trimble-truck-warning-delay_outline-1')), _defineProperty(_events, this.getTranslation(this.eventosEnum.FCW), this.buildEvent('trimble-truck-warning-delay_outline-1')), _defineProperty(_events, this.getTranslation(this.eventosEnum.UNAUTHORIZED_VEHICLE_USE), this.buildEvent('trimble-car-crash')), _defineProperty(_events, this.getTranslation(this.eventosEnum.MANUSEIO_OBJETO), this.buildEvent('trimble-handling-object')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ROLLING_STOP), this.buildEvent('trimble-rolling-stop')), _defineProperty(_events, this.getTranslation(this.eventosEnum.NO_STOP), this.buildEvent('trimble-no-stop')), _defineProperty(_events, this.getTranslation(this.eventosEnum.SEM_CASQUETE), this.buildEvent('trimble-hard-helmet')), _defineProperty(_events, this.getTranslation(this.eventosEnum.ROUTE_DEVIATION), this.buildEvent('trimble-route-deviation')), _events);
        this.eventsWithDatePosition = [this.eventosEnum.FRENAGEM_BRUSCA, this.eventosEnum.CURVA_BRUSCA, this.eventosEnum.ACELERACAO_BRUSCA, this.eventosEnum.CAMERA_OBSTRUIDA, this.eventosEnum.CAMERA_DISCONNECTION_DRIVER, this.eventosEnum.CAMERA_DISCONNECTION_ROAD, this.eventosEnum.CAMERA_DISCONNECTION_AUDIT, this.eventosEnum.SEM_CINTO, this.eventosEnum.BOCEJO, this.eventosEnum.MOTORISTA_AUSENTE, this.eventosEnum.USO_CIGARRO, this.eventosEnum.DISTRACAO_MOTORISTA, this.eventosEnum.FADIGA_MOTORISTA, this.eventosEnum.MANUSEIO_CELULAR, this.eventosEnum.DISTANCIA_PERIGOSA, this.eventosEnum.ULTRAPASSAGEM_ILEGAL, this.eventosEnum.SEM_CONE, this.eventosEnum.SEM_OCULOS, this.eventosEnum.SEM_LUVAS, this.eventosEnum.CARONA, this.eventosEnum.FOLLOWING_DISTANCE, this.eventosEnum.ROP_ENGINE, this.eventosEnum.ROP_BRAKE, this.eventosEnum.YC_ENGINE, this.eventosEnum.YC_BRAKE, this.eventosEnum.COLLISION_MITIGATION, this.eventosEnum.HAPTIC_WARNING, this.eventosEnum.FCW_BRAKE_EXT_ACC_DEM, this.eventosEnum.FCW, this.eventosEnum.UNAUTHORIZED_VEHICLE_USE, this.eventosEnum.MANUSEIO_OBJETO, this.eventosEnum.ROLLING_STOP, this.eventosEnum.NO_STOP, this.eventosEnum.SEM_CASQUETE, this.eventosEnum.ROUTE_DEVIATION];

        if (!this.featRollingStop) {
          delete this.events[this.getTranslation(this.eventosEnum.ROLLING_STOP)];
          delete this.events[this.getTranslation(this.eventosEnum.NO_STOP)];
          this.eventsWithDatePosition = this.eventsWithDatePosition.filter(function (evento) {
            return evento !== _this2.eventosEnum.ROLLING_STOP && evento !== _this2.eventosEnum.NO_STOP;
          });
        }

        if (!this.featRouteDeviation) {
          delete this.events[this.getTranslation(this.eventosEnum.ROUTE_DEVIATION)];
          this.eventsWithDatePosition = this.eventsWithDatePosition.filter(function (evento) {
            return evento !== _this2.eventosEnum.ROUTE_DEVIATION;
          });
        }
      }
    }, {
      key: 'getTranslation',
      value: function getTranslation(name) {
        return this.translate.instant(name).toUpperCase();
      }
    }, {
      key: 'buildEvent',
      value: function buildEvent(icon) {
        var valueType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'quantity';

        return {
          icon: icon,
          valueType: valueType
        };
      }
    }, {
      key: 'getTipoAlerta',
      value: function getTipoAlerta(alerta) {
        var evento = this.eventos.getEvento(alerta);
        return evento ? evento.alerta : '';
      }
    }, {
      key: 'agruparEventosDasConducoes',
      value: function agruparEventosDasConducoes(conducoes) {
        var _this3 = this;

        if (!conducoes) {
          return;
        }
        this.eventosAgrupados = _.groupBy(_.flatten(conducoes.map(function (conducao) {
          return conducao.posicoes;
        })), function (p) {
          return p.descricao.includes(_this3.eventosContendoCurva) ? _this3.translate.instant(_this3.eventosEnum.CURVA_BRUSCA) : p.descricao;
        });
        this.eventosAgrupados = Object.keys(this.eventosAgrupados).map(function (key) {
          var posicoes = _this3.eventosAgrupados[key].reduce(function (acc, posicao) {
            if (posicao.tagIgnoreEvent) {
              _this3.hasIgnoredEvents = true;
              acc[1].push(posicao);
            } else {
              acc[0].push(posicao);
            }
            return acc;
          }, [[], []]);

          return {
            nome: key,
            duracao: (posicoes[0] || []).map(function (posicao) {
              return posicao.duracao;
            }).reduce(function (acumulado, atual) {
              return acumulado + atual;
            }, 0),
            duracaoIgnorada: (posicoes[1] || []).map(function (posicao) {
              return posicao.duracao;
            }).reduce(function (acumulado, atual) {
              return acumulado + atual;
            }, 0),
            posicoes: posicoes[0],
            posicoesIgnoradas: posicoes[1]
          };
        }).filter(function (agrupamento) {
          return (agrupamento.posicoes.length > 0 || agrupamento.posicoesIgnoradas.length > 0) && _this3.getEventByName(agrupamento.nome);
        });
      }
    }, {
      key: 'getEventByName',
      value: function getEventByName(name) {
        return this.events[name.toUpperCase()];
      }
    }, {
      key: 'agruparDescidasDasConducoes',
      value: function agruparDescidasDasConducoes(conducoes) {
        var _this4 = this;

        if (!conducoes) {
          return;
        }
        this.descidasAgrupadas = _.groupBy(_.flatten(conducoes.map(function (conducao) {
          return conducao.posicoes;
        })).filter(function (p) {
          return p.descricao.includes(_this4.translate.instant(_this4.eventosEnum.DESCIDA));
        }), function (p) {
          return p.evento;
        });
        this.descidasAgrupadas = Object.keys(this.descidasAgrupadas).map(function (key) {
          var posicoes = _this4.descidasAgrupadas[key].reduce(function (acc, posicao) {
            if (posicao.tagIgnoreEvent) {
              _this4.hasIgnoredEvents = true;
              acc[1].push(posicao);
            } else {
              acc[0].push(posicao);
            }
            return acc;
          }, [[], []]);

          return {
            nome: key,
            duracao: _this4.descidasAgrupadas[key].map(function (posicao) {
              return posicao.miscInfo.segundosFreioPressionado;
            }).reduce(function (acumulado, atual) {
              return acumulado + atual;
            }),
            posicoes: posicoes[0],
            posicoesIgnoradas: posicoes[1]
          };
        }).sort(function (a, b) {
          return a.nome.localeCompare(b.nome);
        }).filter(function (agrupamento) {
          return agrupamento.posicoes.length > 0 || agrupamento.posicoesIgnoradas.length > 0;
        });
      }
    }, {
      key: 'getTextoFaixaDescida',
      value: function getTextoFaixaDescida(nome) {
        if (nome === this.descidaFaixa1) {
          return this.translate.instant('ce.resumoPeriodo.faixa', { x: 1 });
        } else if (nome === this.descidaFaixa2) {
          return this.translate.instant('ce.resumoPeriodo.faixa', { x: 2 });
        }
        return this.translate.instant('ce.resumoPeriodo.faixa', { x: 3 });
      }
    }, {
      key: 'getTextoTempoFaixaDescida',
      value: function getTextoTempoFaixaDescida(nome) {
        if (nome === this.descidaFaixa1) {
          return this.translate.instant('ce.resumoPeriodo.ateXseg', { x: this.scope.faixasDescida.segundosFaixa1 });
        } else if (nome === this.descidaFaixa2) {
          return this.translate.instant('ce.resumoPeriodo.ateXseg', { x: this.scope.faixasDescida.segundosFaixa2 });
        }
        return this.translate.instant('ce.resumoPeriodo.maiorXseg', { x: this.scope.faixasDescida.segundosFaixa2 });
      }
    }, {
      key: 'isAnyOfTheseEvents',
      value: function isAnyOfTheseEvents(agrupamentoNome, events) {
        var _this5 = this;

        return events.map(function (event) {
          return _this5.translate.instant(event);
        }).includes(agrupamentoNome);
      }
    }, {
      key: 'tituloCustomizado',
      value: function tituloCustomizado(reticencias) {
        if (!angular.isArray(this.scope.titulo)) {
          return this.scope.titulo;
        }

        var titulo = _.uniq(this.scope.titulo);

        if (titulo.length > 1) {
          if (reticencias) {
            return titulo[0] + '...';
          }
          this.enableTooltipTitulo = true;
          return titulo.slice(1).join(', ');
        }
        this.enableTooltipTitulo = false;
        return titulo[0];
      }
    }, {
      key: 'subtituloCustomizado',
      value: function subtituloCustomizado(reticencias) {
        if (!angular.isArray(this.scope.subtitulo)) {
          return this.scope.subtitulo;
        }

        var subtitulo = _.uniq(this.scope.subtitulo);

        if (subtitulo.length > 1) {
          if (reticencias) {
            return subtitulo[0] + '...';
          }
          this.enableTooltipSubtitulo = true;
          return subtitulo.slice(1).join(', ');
        }
        this.enableTooltipSubtitulo = false;
        return subtitulo[0];
      }
    }, {
      key: 'montaHorarioViagem',
      value: function montaHorarioViagem() {
        if (angular.isDefined(this.scope.inicio) && angular.isDefined(this.scope.fim)) {
          return this.scope.inicio + ' - ' + this.scope.fim;
        }
      }
    }, {
      key: 'getPopoverContent',
      value: function getPopoverContent() {
        var link = 'http://suporte.onps.com/',
            content = this.translate.instant('ce.resumoPeriodo.popOverContent', { linkPortalVeltec: link });
        return this.trusted[content] || (this.trusted[content] = this.sce.trustAsHtml(content));
      }
    }, {
      key: 'onClick',
      value: function onClick(agrupamento, tipo) {
        if (this.eventoSelecionado === agrupamento.nome && this.eventoTipoSelecionado === tipo) {
          this.eventoSelecionado = '';
          this.eventoTipoSelecionado = '';
        } else {
          this.eventoSelecionado = agrupamento.nome;
          this.eventoTipoSelecionado = tipo;
        }
        this.scope.onClickEvento(this.eventoSelecionado);
      }
    }, {
      key: 'formatarVelocidadeMaximaBanguela',
      value: function formatarVelocidadeMaximaBanguela(intensidade) {
        if (angular.isString(intensidade) && intensidade.length > 0) {
          return intensidade.match(/\d+/).toString();
        }
        return '';
      }
    }, {
      key: 'formatarVelocidadeMinimaBanguela',
      value: function formatarVelocidadeMinimaBanguela(intensidade) {
        if (angular.isString(intensidade) && intensidade.length > 0) {
          return intensidade.match(/\d+(?=\,)/).toString();
        }
        return '';
      }
    }, {
      key: 'hasConsumo',
      value: function hasConsumo() {
        return angular.isDefined(this.scope.mediaConsumo);
      }
    }, {
      key: 'deveExibirFaixasRpm',
      value: function deveExibirFaixasRpm() {
        return _.some(this.scope.tempoPorFaixaRpm, Boolean);
      }
    }, {
      key: 'onVideoClick',
      value: function onVideoClick() {
        this.googleTagManagerUtils.sendEventClickGTM('bdv_bdm_detalhes_reproduzir_video_vfleets', this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'handleCheckEventsPosicoes',
      value: function handleCheckEventsPosicoes(tipo) {
        return this.eventosAgrupados.some(function (agrupamento) {
          return agrupamento[tipo].length > 0;
        });
      }
    }]);

    return ResumoPeriodoCtrl;
  }();

  angular.module('resumoPeriodoModule').controller('ResumoPeriodoCtrl', ResumoPeriodoCtrl).directive('resumoPeriodo', resumoPeriodo);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios
   * @description
   *
   */

  angular.module('relatorios', ['ui.router', 'relatorios.rankingEconomy', 'relatorios.rankingSafety', 'relatorios.bdm', 'relatorios.bdv', 'relatorios.bds', 'relatorios.analiseOp', 'relatorios.historicoSolicitacao', 'relatorios.velocidadeRpm', 'relatorios.abastecimento', 'relatorios.deviceHealth', 'relatorios.coaching', 'relatorios.riskIntelligence', 'relatorios.permanencia', 'relatorios.historicoComando', 'relatorios.ocorrencia', 'relatorios.ocorrenciaDetalhes', 'relatorios.saudeFrota', 'relatorios.videoLibrary', 'relatorios.videoLibrary.solicitacaoVideos', 'relatorios.videoLibrary.playback', 'relatorios.identificacoes', 'core-ce.constants', 'onboarding', 'angular-intro', 'confluenceID']).constant('semMotorista', 'Sem Identificação').constant('EQUIPAMENTO', {
    ACIONAMENTO_ELETRONICO: 198,
    ACIONAMENTO_PNEUMATICO: 199,
    SENSOR_HIDRAULICO: 391,
    SENSOR_HIDRAULICO_HR36: 537,
    SENSOR_HIDRAULICO_PV: 541,
    SENSOR_HIDRAULICO_PV_NEO: 612,
    SENSOR_HIDRAULICO_HR48: 538,
    SENSOR_HIDRAULICO_HR24: 539,
    SENSOR_HIDRAULICO_EPP36: 540,
    SENSOR_HIDRAULICO_PNEUMATICO_PARA_VIDEO: 7743
  }).constant('AGRUPAMENTO_EQUIPAMENTO', {
    VSAFE: 'VSAFE',
    VTALKS: 'VTALKS',
    VMOV: 'VMOV'
  }).constant('sortAlertasIndicadores', {
    aceleracoesBruscas: 'aceleracoes',
    banguelas: 'banguelas',
    curvasBruscas: 'curvas',
    exVelocidadeFaixa1: 'excessosVelocidade',
    exVelocidadeFaixa2: 'excessosVelocidade',
    exVelocidadeFaixa3: 'excessosVelocidade',
    frenagensBruscas: 'frenagens',
    motorOcioso: 'motorOcioso',
    rpmExcessivo: 'rpmExcessivos'
  }).factory('sorters', function (maxChar, semMotorista) {
    return {
      formatMotoristaNome: function formatMotoristaNome(row) {
        return row.motorista === semMotorista ? maxChar : row.motorista;
      }
    };
  }).filter('filterMot', function (semMotorista) {
    return function (motoristaNome) {
      return motoristaNome === '' ? semMotorista : motoristaNome;
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  /* global Intl */
  'use strict';

  var FIELDS_OCORR = ['id', 'uoId', 'dataHora', 'status', 'alertasGerados', 'veiculoId', 'veiculo.id', 'veiculo.placa', 'veiculo.prefixo', 'veiculo.grupo.id', 'veiculo.grupo.nome', 'veiculo.uo.nome', 'veiculo.uo.id', 'motorista.id', 'motorista.nome', 'motorista.uo.id', 'motorista.uoId', 'motorista.uo.nome', 'motorista.departamentoId', 'motorista.departamento.id', 'motorista.departamento.nome', 'usuarioIdAtribuido', 'usuario.id', 'usuario.login'],
      FIELDS_HIST = ['statusAnterior', 'statusNovo', 'comentario', 'dataHora', 'id', 'usuarioIdAtribuidoNovo', 'usuarioIdAtribuidoAnterior', 'usuario.id', 'usuario.login'];

  var Ocorrencias = function () {
    function Ocorrencias(HttpServiceV3g, $q, $httpParamSerializer, moment, OcorrenciasEnum, FormatVfiltro) {
      _classCallCheck(this, Ocorrencias);

      this.q = $q;
      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.formatVfiltro = FormatVfiltro;
      this.ocorrenciasEnum = OcorrenciasEnum;
    }

    _createClass(Ocorrencias, [{
      key: 'getOcorrenciasNova',
      value: function getOcorrenciasNova(vfiltro) {
        var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FIELDS_OCORR;

        var params = this.httpParamSerializer({
          fields: fields.join(),
          inicio: this.moment().subtract(12, 'hours').format(),
          fim: this.moment().format(),
          status: this.ocorrenciasEnum.NOVA.id,
          uoId: vfiltro.uoId
        });

        return this.httpService.get('/alerta/ocorrencias?' + params);
      }
    }, {
      key: 'getOcorrenciasNovaLocFrota',
      value: function getOcorrenciasNovaLocFrota(vfiltro) {
        var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FIELDS_OCORR;

        var params = this.httpParamSerializer({
          fields: fields.join(),
          uoId: vfiltro.uoId
        });

        return this.httpService.get('/alerta/ocorrencias/novas/veiculos-permitidos?' + params);
      }
    }, {
      key: 'getOcorrenciasTratativa',
      value: function getOcorrenciasTratativa(vfiltro) {
        var params = this.httpParamSerializer({
          fields: FIELDS_OCORR.join(),
          status: this.ocorrenciasEnum.EM_TRATATIVA.id,
          uoId: vfiltro.uoId
        });

        return this.httpService.get('/alerta/ocorrencias?' + params);
      }
    }, {
      key: 'getOcorrenciasResolvida',
      value: function getOcorrenciasResolvida(vfiltro) {
        var params = this.httpParamSerializer({
          fields: FIELDS_OCORR.join(),
          inicioFinalizacao: this.moment().startOf('day').format(),
          fimFinalizacao: this.moment().format(),
          status: this.ocorrenciasEnum.RESOLVIDA.id,
          uoId: vfiltro.uoId
        });

        return this.httpService.get('/alerta/ocorrencias?' + params);
      }
    }, {
      key: 'getOcorrenciaById',
      value: function getOcorrenciaById(idOcorrencia, dataHora) {
        var params = this.httpParamSerializer({
          fields: FIELDS_OCORR.join(),
          inicio: dataHora,
          fim: dataHora,
          id: idOcorrencia
        });

        return this.httpService.get('/alerta/ocorrencias?' + params);
      }
    }, {
      key: 'getQuadroOcorrencias',
      value: function getQuadroOcorrencias(vfiltro) {
        var currentTimezone = this.getTimezone(),
            params = this.httpParamSerializer({
          fields: FIELDS_OCORR.join(),
          timezone: currentTimezone,
          uoId: vfiltro.uoId
        });

        return this.httpService.get('/alerta/ocorrencias/quadro?' + params);
      }
    }, {
      key: 'getTimezone',
      value: function getTimezone() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    }, {
      key: 'getParamsHistDetalhado',
      value: function getParamsHistDetalhado(ocorrencia) {
        var iniciosAlertas = [],
            finaisAlertas = [],
            dataInicio = void 0,
            dataFinal = void 0;

        ocorrencia.alertasGerados.forEach(function (alerta) {
          iniciosAlertas.push(new Date(alerta.dataHoraPrimeiroAlerta).getTime());
          finaisAlertas.push(new Date(alerta.dataHoraUltimoAlerta).getTime());
        });

        dataInicio = this.moment(Math.min.apply(Math, iniciosAlertas)).subtract(1, 'hour').format(this.formatVfiltro);

        dataFinal = this.moment(Math.max.apply(Math, finaisAlertas)).add(1, 'hour').format(this.formatVfiltro);

        return 'vfiltro=dateTime:' + dataInicio + ',' + dataFinal + ';veiculo:' + ocorrencia.veiculo.id;
      }
    }, {
      key: 'getUsers',
      value: function getUsers(veiculoIdOcorrencia) {
        return this.httpService.get('/alerta/usuarios/atribuiveis?veiculoIds=' + veiculoIdOcorrencia);
      }
    }, {
      key: 'getHistorico',
      value: function getHistorico(ocorr, timezone) {
        return this.httpService.get('/alerta/ocorrencias/' + ocorr.id + '/historicos?dataHora=' + ocorr.dataHora + '&timezone=' + timezone + '&fields=' + FIELDS_HIST.join());
      }
    }, {
      key: 'getConfigsByUo',
      value: function getConfigsByUo(uoId) {
        return this.httpService.get('/configuracao/configuracoes/' + uoId + '/ocorrencia');
      }
    }, {
      key: 'getEventPriorityConfigsByUo',
      value: function getEventPriorityConfigsByUo(uoId) {
        var FIELDS = ['uoId', 'tipo', 'presentationPriority'];
        return this.httpService.get('/configuracao/configuracoes/' + uoId + '/ocorrencia/with-fields?fields=' + FIELDS);
      }
    }]);

    return Ocorrencias;
  }();

  angular.module('quadroOcorrencias').service('Ocorrencias', Ocorrencias);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.quadroOcorrencias', {
      url: '/tempo-real/ocorrencias?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'quadro-ocorrencias/quadro-ocorrencias.tpl.html',
          controller: 'QuadroOcorrenciasCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.quadroDeOcorrencias.titulo',
        role: ['OCORRENCIA_VISUALIZAR']
      }
    });
  }

  angular.module('quadroOcorrencias').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global _, document */

  var QuadroOcorrenciasCtrl = function () {
    function QuadroOcorrenciasCtrl(Authenticator, Ocorrencias, $uibModal, $interval, ServiceVfiltro, AlertMessage, AlertasEnum, ObjetosVfiltroService, FactoryVfiltro, FeatureFlag, Keys, OcorrenciasEnum, $scope, $translate, $window, $document, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, QuadroOcorrenciasCtrl);

      this.modalService = $uibModal;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.keys = Keys;
      this.ocorrenciasEnum = OcorrenciasEnum;
      this.intervalService = $interval;
      this.ocorrenciasService = Ocorrencias;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.scope = $scope;
      this.intervaloConsulta = 60000;
      this.initMsg();
      this.featureFlag = FeatureFlag;
      this.hasConfigHistoricoAlerta = false;
      this.eventsOrder = [];
      this.cardsOrderOptions = [{
        key: 'mostRecent',
        label: 'ce.tempoReal.quadroDeOcorrencias.orderOptions.mostRecent'
      }, {
        key: 'recurrent',
        label: 'ce.tempoReal.quadroDeOcorrencias.orderOptions.recurrent'
      }, {
        key: 'mostEvents',
        label: 'ce.tempoReal.quadroDeOcorrencias.orderOptions.mostEvents'
      }, {
        key: 'assignedToMe',
        label: 'ce.tempoReal.quadroDeOcorrencias.orderOptions.assignedToMe'
      }];
      this.cardsOrder = 'mostRecent';

      this.entreEmContatoI18N = $translate.instant('ce.tempoReal.quadroDeOcorrencias.entreEmContato');
      this.erroRealizarTratativa = $translate.instant('ce.tempoReal.quadroDeOcorrencias.erroRealizarTratativa');
      this.naoPossuiPermissaoOcorrencia = $translate.instant('ce.tempoReal.quadroDeOcorrencias.naoPossuiPermissaoOcorrencia');
      this.ocorrencias = [];
      this.usuario = null;
      this.window = $window;
      this.document = $document[0];
      this.translate = $translate;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.occurrencePollingPauseEnabled = this.featurehubJsSdk.isFeatureEnabled('LAVID990_occurrence_polling_pause');

      if (this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.RISK_INTELLIGENCE_LINK)) {
        this.appendAcessarNovoQuadroLink();
      }

      Authenticator.getUser().then(function (user) {
        _this.usuario = user;
        _this.hasConfigHistoricoAlerta = user.permissoes.includes('HISTORICO_ALERTA_VISUALIZAR');
        _this.userLanguage = user.idioma;
      });

      ServiceVfiltro.init(FactoryVfiltro.get([{
        name: 'uoId',
        key: this.keys.uo.name,
        size: 12
      }, {
        name: 'veiculos',
        key: this.keys.veiculos.name,
        ignoreValidation: true,
        size: 12
      }, {
        key: this.keys.usuario.name,
        size: 6
      }, {
        key: this.keys.nivel.name,
        size: 6
      }, {
        key: this.keys.tipos.name,
        size: 12
      }])).then(function (vfiltro) {
        _this.vfiltro = vfiltro;
        _this.uoId = vfiltro.find(function (x) {
          return x.key === _this.keys.uo.name;
        }).value.id;
        var cardsOrderLocalstorage = _this.window.localStorage.getItem('safety-focus-cards-order-' + _this.usuario.id);

        _this.cardsOrder = cardsOrderLocalstorage ? cardsOrderLocalstorage : _this.cardsOrder;

        _this.startOcorrencias();
        if (_this.featureFlag.SHOW_EVENT_DIALOG) {
          _this.showOpenDialogEventPriority();
          _this.getEventPriorityConfigs();
        }
        _this.permissaoEditarOcorrencia = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('OCORRENCIA_EDITAR');
      }).catch(function () {
        _this.serviceVfiltro.openFiltroDetalhado = false;
      });
    }

    _createClass(QuadroOcorrenciasCtrl, [{
      key: 'appendAcessarNovoQuadroLink',
      value: function appendAcessarNovoQuadroLink() {
        /* eslint-disable */
        var pageTitle = document.querySelector('#page-title');
        if (!pageTitle) {
          return;
        }

        var link = document.createElement('a'),
            icon = document.createElement('i'); /* eslint-enable */

        link.id = 'occurrences-board-intelligent-btn';
        link.className = 'acessar-novo-quadro-link';
        link.href = '/qi';
        link.textContent = this.translate.instant('ce.tempoReal.quadroDeOcorrencias.acessarNovoQuadro');
        icon.className = 'fa fa-arrow-right';
        link.appendChild(icon);

        pageTitle.appendChild(link);

        this.scope.$on('$destroy', function () {
          link.remove();
        });
      }
    }, {
      key: 'getEventPriorityConfigs',
      value: function getEventPriorityConfigs() {
        var _this2 = this;

        this.ocorrenciasService.getEventPriorityConfigsByUo(this.uoId).then(function (response) {
          var eventsOrderLocalstorage = _this2.window.localStorage.getItem('event-priority-' + _this2.uoId);

          if (response.data.some(function (i) {
            return i.presentationPriority;
          })) {
            _this2.eventsOrderByUo = response.data.sort(function (a, b) {
              return (a.presentationPriority || response.data.length) - (b.presentationPriority || response.data.length);
            }).map(function (event) {
              return event.tipo;
            });
          } else {
            var list = _this2.getAlertasFiltrados();
            _this2.eventsOrderByUo = list.sort(function (a, b) {
              return (a.eventOrder || list.length) - (b.eventOrder || list.length);
            }).map(function (alerta) {
              return alerta.id;
            });
          }

          _this2.eventsOrder = eventsOrderLocalstorage ? eventsOrderLocalstorage.split(',') : _this2.eventsOrderByUo;
        });
      }
    }, {
      key: 'getAlertasFiltrados',
      value: function getAlertasFiltrados() {
        return this.alertasEnum.getTipos().filter(function (alerta) {
          return alerta.id !== 'EXCESSO_VELOCIDADE' && alerta.id !== 'EXCESSO_VELOCIDADE_20' && alerta.id !== 'EXCESSO_VELOCIDADE_30' && alerta.id !== 'EXCESSO_VELOCIDADE_ACIMA_30' && alerta.id !== 'EXCESSO_VELOCIDADE_POR_VIA' && alerta.id !== 'DIAGNOSTICO_OBD' && alerta.id !== 'VEICULO_SEM_SINAL' && alerta.id !== 'RFID_NAO_CADASTRADO' && alerta.id !== 'SEM_IDENTIFICACAO_DE_MOTORISTA' && alerta.id !== 'GENERIC' && alerta.id !== 'SEM_EPI' && alerta.id !== 'STABILITY_CONTROL';
        });
      }
    }, {
      key: 'startOcorrencias',
      value: function startOcorrencias() {
        var _this3 = this;

        if (!this.occurrencePollingPauseEnabled) {
          this.consultar();

          var interval = this.intervalService(function () {
            _this3.consultar();
          }, this.intervaloConsulta);

          this.scope.$on('$destroy', function () {
            _this3.intervalService.cancel(interval);
          });

          return;
        }

        this.iniciarPollingOcorrencias();

        this.onVisibilityChange = function () {
          if (_this3.document.hidden) {
            _this3.pararPollingOcorrencias();
          } else {
            _this3.iniciarPollingOcorrencias();
          }
        };

        this.document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.scope.$on('$destroy', function () {
          _this3.pararPollingOcorrencias();
          _this3.document.removeEventListener('visibilitychange', _this3.onVisibilityChange);
        });
      }
    }, {
      key: 'iniciarPollingOcorrencias',
      value: function iniciarPollingOcorrencias() {
        var _this4 = this;

        if (this.ocorrenciasInterval) {
          return;
        }

        this.consultar();

        this.ocorrenciasInterval = this.intervalService(function () {
          _this4.consultar();
        }, this.intervaloConsulta);
      }
    }, {
      key: 'pararPollingOcorrencias',
      value: function pararPollingOcorrencias() {
        if (this.ocorrenciasInterval) {
          this.intervalService.cancel(this.ocorrenciasInterval);
          this.ocorrenciasInterval = null;
        }
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this5 = this;

        var vfiltroParams = this.serviceVfiltro.getFiltroBackendNovo(this.vfiltro);
        var veiculosFiltered = this.vfiltro.find(function (f) {
          return f.key === 'veiculos';
        }),
            usuarioIdFiltro = vfiltroParams.usuario,
            tiposFiltered = this.vfiltro.find(function (f) {
          return f.key === 'tipos';
        }),
            nivelFiltro = vfiltroParams.nivel,
            veiculoIdsFiltro = veiculosFiltered ? veiculosFiltered.values.map(function (veiculo) {
          return veiculo.id;
        }) : veiculosFiltered,
            tiposFiltro = tiposFiltered ? tiposFiltered.values.map(function (tipo) {
          return tipo.id;
        }) : tiposFiltered;

        this.setFiltroUsuarioVeiculos(usuarioIdFiltro, veiculoIdsFiltro, tiposFiltro, nivelFiltro);

        this.ocorrenciasService.getQuadroOcorrencias(vfiltroParams).then(function (response) {
          if (response && response.data) {
            var allOcurrences = response.data.NOVA.concat(response.data.EM_TRATATIVA, response.data.RESOLVIDA);
            _this5.ocorrenciasByMotorista = _this5.getOcorrenciasByMotorista(allOcurrences);
            _this5.handleOcurrenceResponse(response.data);
          }
        }).catch(function () {
          _this5.setMsgErrorRequest();
        });
      }
    }, {
      key: 'handleOcurrenceResponse',
      value: function handleOcurrenceResponse(response) {
        var ocorrenciasNova = response.NOVA,
            ocorrenciasTratativa = response.EM_TRATATIVA,
            ocorrenciasResolvida = response.RESOLVIDA;

        this.ocorrenciasNova = this.getOcorrenciasSortedAndFiltered(ocorrenciasNova);
        this.ocorrenciasTratativa = this.getOcorrenciasSortedAndFiltered(ocorrenciasTratativa);
        this.ocorrenciasResolvida = this.getOcorrenciasSortedAndFiltered(ocorrenciasResolvida);

        this.ocorrencias = this.ocorrenciasNova.concat(this.ocorrenciasTratativa, this.ocorrenciasResolvida);

        if (!this.ocorrencias.length) {
          this.getConfigs();
        } else {
          this.initOcorrencias(false);
          this.initMsg();
          this.verifyOcorrenciaInLocalStorage();
        }
        this.errorRequest = false;
      }
    }, {
      key: 'setFiltroUsuarioVeiculos',
      value: function setFiltroUsuarioVeiculos(usuarioId, veiculoIds, tiposFiltro, nivelFiltro) {
        var _this6 = this;

        this.filtroUsuarioVeiculos = function (ocorrencia) {
          var hasUsuario = angular.isUndefined(usuarioId) || ocorrencia.usuarioIdAtribuido === usuarioId,
              hasVeiculo = angular.isUndefined(veiculoIds) || veiculoIds.some(function (veiculoId) {
            return veiculoId === ocorrencia.veiculoId;
          }),
              hasTipos = angular.isUndefined(tiposFiltro) || _this6.handleTiposFiltro(ocorrencia, tiposFiltro, nivelFiltro);
          return hasUsuario && hasVeiculo && hasTipos;
        };
      }
    }, {
      key: 'handleTiposFiltro',
      value: function handleTiposFiltro(ocorrencia, tiposFiltro, nivelFiltro) {
        return tiposFiltro.some(function (tipo) {
          var isExcessoVelocidade = tipo === 'EXCESSO_VELOCIDADE',
              hasNivel = angular.isDefined(nivelFiltro),
              isExcessoVelocidadePorVia = tipo === 'EXCESSO_VELOCIDADE_POR_VIA';

          return ocorrencia.alertasGerados.some(function (alerta) {
            if (isExcessoVelocidadePorVia) {
              return hasNivel ? alerta.tipo === 'EXCESSO_VELOCIDADE_POR_VIA' + nivelFiltro : alerta.tipo.includes('EXCESSO_VELOCIDADE_POR_VIA');
            }
            if (isExcessoVelocidade && !isExcessoVelocidadePorVia) {
              return hasNivel ? alerta.tipo === 'EXCESSO_VELOCIDADE_' + nivelFiltro : alerta.tipo.startsWith('EXCESSO_VELOCIDADE') && !alerta.tipo.includes('POR_VIA');
            }
            if (isExcessoVelocidade && isExcessoVelocidadePorVia) {
              return hasNivel ? alerta.tipo === 'EXCESSO_VELOCIDADE_' + nivelFiltro : alerta.tipo.includes('EXCESSO_VELOCIDADE');
            }
            return alerta.tipo === tipo;
          });
        });
      }
    }, {
      key: 'getConfigs',
      value: function getConfigs() {
        var _this7 = this;

        this.ocorrenciasService.getConfigsByUo(this.uoId).then(function (res) {
          if (!res.data.length) {
            _this7.setMsgSemConfig();
          } else {
            _this7.setMsgSemOcorrencia();
          }
        }).catch(function () {
          _this7.setMsgErrorRequest();
        });
      }
    }, {
      key: 'initMsg',
      value: function initMsg() {
        this.errorRequest = false;
        this.loaded = false;
        this.hasConfigs = true;
      }
    }, {
      key: 'verifyOcorrenciaInLocalStorage',
      value: function verifyOcorrenciaInLocalStorage() {
        var ocorrenciaId = this.window.localStorage.getItem('localizacao-frota-go-to-quadro-ocorrencias-ocorrenciaId');
        if (ocorrenciaId) {
          var ocorrenciaNovaMaisRecente = this.ocorrenciasNova.find(function (ocorrencia) {
            return ocorrencia.id === Number(ocorrenciaId);
          });
          this.openDetalhes(ocorrenciaNovaMaisRecente);
          this.window.localStorage.removeItem('localizacao-frota-go-to-quadro-ocorrencias-ocorrenciaId');
        }
      }
    }, {
      key: 'setMsgSemConfig',
      value: function setMsgSemConfig() {
        this.errorRequest = false;
        this.loaded = false;
        this.hasConfigs = false;
      }
    }, {
      key: 'setMsgSemOcorrencia',
      value: function setMsgSemOcorrencia() {
        this.errorRequest = false;
        this.loaded = true;
        this.hasConfigs = true;
      }
    }, {
      key: 'setMsgErrorRequest',
      value: function setMsgErrorRequest() {
        this.errorRequest = true;
        this.loaded = false;
        this.hasConfigs = true;
      }
    }, {
      key: 'initOcorrencias',
      value: function initOcorrencias(isUpdate) {
        if (isUpdate) {
          this.ocorrencias = this.getOcorrenciasSortedAndFiltered(this.ocorrencias);
        }
        this.ocorrenciasByStatus = this.getOcorrenciasByStatus(isUpdate);

        this.createStatusEmpty();
      }
    }, {
      key: 'createStatusEmpty',
      value: function createStatusEmpty() {
        var _this8 = this;

        this.ocorrenciasEnum.getKeys().forEach(function (statusKey) {
          if (angular.isUndefined(_this8.ocorrenciasByStatus[statusKey])) {
            _this8.ocorrenciasByStatus[statusKey] = [];
          }
        });
      }
    }, {
      key: 'getOcorrenciasSortedAndFiltered',
      value: function getOcorrenciasSortedAndFiltered(ocorrencias) {
        var _this9 = this;

        ocorrencias.sort(function (a, b) {
          return new Date(b.dataHora).getTime() - new Date(a.dataHora).getTime();
        }).forEach(function (ocorrencia) {
          ocorrencia.isRecorrente = _this9.isRecorrente(ocorrencia);
          ocorrencia.sortableQty = ocorrencia.alertasGerados.reduce(function (acc, alerta) {
            return acc + alerta.quantidade;
          }, 0);
        });

        var sorted = this.sortCards(ocorrencias, this.cardsOrder);

        return sorted.filter(this.filtroUsuarioVeiculos);
      }
    }, {
      key: 'sortCards',
      value: function sortCards(ocorrencias, type) {
        var _this10 = this;

        switch (type) {
          case 'mostRecent':
            return ocorrencias;
          case 'recurrent':
            return ocorrencias.sort(function (a, b) {
              return b.isRecorrente - a.isRecorrente;
            });
          case 'mostEvents':
            return ocorrencias.sort(function (a, b) {
              return b.sortableQty - a.sortableQty;
            });
          case 'assignedToMe':
            if (this.usuario.id) {
              return ocorrencias.sort(function (a, b) {
                if (a.usuarioIdAtribuido !== b.usuarioIdAtribuido) {
                  if (a.usuarioIdAtribuido === _this10.usuario.id) {
                    return -1;
                  } else if (b.usuarioIdAtribuido === _this10.usuario.id) {
                    return 1;
                  }
                }
              });
            }
            return ocorrencias;
          default:
            return ocorrencias;
        }
      }
    }, {
      key: 'onChangeCardsOrder',
      value: function onChangeCardsOrder() {
        this.window.localStorage.setItem('safety-focus-cards-order-' + this.usuario.id, this.cardsOrder);
        this.handleOcurrenceResponse(this.ocorrenciasByStatus);
      }
    }, {
      key: 'getOcorrenciasByMotorista',
      value: function getOcorrenciasByMotorista(occurrences) {
        return _.groupBy(occurrences && occurrences.sort(function (a, b) {
          return new Date(b.dataHora).getTime() - new Date(a.dataHora).getTime();
        }), function (ocorrencia) {
          return ocorrencia.motorista && ocorrencia.motorista.id;
        });
      }
    }, {
      key: 'getOcorrenciaById',
      value: function getOcorrenciaById(id) {
        return this.ocorrencias.find(function (ocorrencia) {
          return ocorrencia.id === id;
        });
      }
    }, {
      key: 'getOcorrenciasByStatus',
      value: function getOcorrenciasByStatus(isUpdate) {
        if (isUpdate) {
          return _.groupBy(this.ocorrencias, function (ocorrencia) {
            return ocorrencia.status;
          });
        }
        return {
          NOVA: this.ocorrenciasNova,
          EM_TRATATIVA: this.ocorrenciasTratativa,
          RESOLVIDA: this.ocorrenciasResolvida
        };
      }
    }, {
      key: 'isRecorrente',
      value: function isRecorrente(ocorrencia) {
        if (ocorrencia.motorista) {
          var idMotorista = ocorrencia.motorista.id,
              lastIndex = this.ocorrenciasByMotorista[idMotorista].length - 1;
          return this.ocorrenciasByMotorista[idMotorista][lastIndex].id !== ocorrencia.id;
        }
        return false;
      }
    }, {
      key: 'generateIdTrackBy',
      value: function generateIdTrackBy(ocorrencia) {
        return ocorrencia.id + ',' + ocorrencia.usuarioIdAtribuido + ',' + ocorrencia.alertasGerados.length + ',' + ocorrencia.alertasGerados.map(function (alerta) {
          return alerta.quantidade;
        }) + ',' + this.eventsOrder.join(',');
      }
    }, {
      key: 'updateOcorrencia',
      value: function updateOcorrencia(idOcorrencia, novoStatus, usuarioAtribuido) {
        var ocorrenciaUpdated = this.getOcorrenciaById(idOcorrencia);
        ocorrenciaUpdated.status = novoStatus;
        if (usuarioAtribuido) {
          ocorrenciaUpdated.usuarioIdAtribuido = usuarioAtribuido.id;
          ocorrenciaUpdated.usuarioAtribuido = usuarioAtribuido;
        }
        this.initOcorrencias(true);
      }
    }, {
      key: 'showOpenDialogEventPriority',
      value: function showOpenDialogEventPriority() {
        /* eslint-disable */
        var abrirModal = document.querySelector('#openDialogEventPriority'),
            modal = document.createElement('vfwc-open-dialog-event-priority'); /* eslint-enable */
        modal.uoId = this.uoId;
        modal.userLanguage = this.userLanguage;
        abrirModal.appendChild(modal);
        this.onEventPriority(modal);
      }
    }, {
      key: 'onEventPriority',
      value: function onEventPriority(element) {
        var _this11 = this;

        element.addEventListener('eventPriorityEmitter', function (event) {
          _this11.eventsOrder = event.detail && event.detail.length ? event.detail : _this11.eventsOrderByUo;
          _this11.consultar();
        });
      }
    }, {
      key: 'openDetalhes',
      value: function openDetalhes(ocorrencia) {
        if (!this.hasConfigHistoricoAlerta) {
          return this.errorPermissionAlert();
        }
        var ocorrenciasByMotorista = [];
        if (ocorrencia.motorista) {
          ocorrenciasByMotorista = this.ocorrenciasByMotorista[ocorrencia.motorista.id];
        }
        /* eslint-disable */
        var abrirModal = document.querySelector('#abrirModal'),
            modal = document.createElement('vfwc-abrir-ocorrencia-dialog'); /* eslint-enable */
        modal.ocorrenciaId = ocorrencia.id;
        modal.ocorrenciaDatahora = ocorrencia.dataHora;
        modal.veiculoIdOcorrencia = ocorrencia.veiculo.id;
        modal.ocorrenciasMotorista = ocorrenciasByMotorista;
        modal.usuario = this.usuario;
        modal.ouId = this.uoId;
        abrirModal.appendChild(modal);
        this.onOcorrenciaAtualizada(modal);
      }
    }, {
      key: 'errorPermissionAlert',
      value: function errorPermissionAlert() {
        /* eslint-disable */
        var openAlert = document.querySelector('#openAlert');
        var oldAlert = openAlert.querySelector('vfwc-toast-alert-generic');
        if (oldAlert) {
          openAlert.removeChild(oldAlert);
        }
        var alert = document.createElement('vfwc-toast-alert-generic');
        alert.text = this.naoPossuiPermissaoOcorrencia;
        openAlert.append(alert);
      }
    }, {
      key: 'onOcorrenciaAtualizada',
      value: function onOcorrenciaAtualizada(element) {
        var _this12 = this;

        element.addEventListener('emiteAlteracaoOcorrencia', function (event) {
          if (event.detail && event.detail.ocorrencia) {
            var ocorrencia = event.detail.ocorrencia;
            _this12.updateOcorrencia(ocorrencia.id, ocorrencia.status, ocorrencia.usuarioAtribuido);
          }
          if (event.detail && event.detail.ocorrenciaAnexo) {
            var _ocorrencia = event.detail.ocorrenciaAnexo;
            _this12.openDetalhes(_ocorrencia);
          }
        });

        element.addEventListener('hasAlertsPurgedEmitter', function (event) {
          if (event.detail) {
            _this12.consultar();
          }
        });
      }
    }, {
      key: 'emiteErro',
      value: function emiteErro() {
        this.error = true;
        this.alertMessage.create({
          type: 'error',
          message: this.erroRealizarTratativa,
          appendTo: '.alerta-aqui'
        });
      }
    }]);

    return QuadroOcorrenciasCtrl;
  }();

  angular.module('quadroOcorrencias').controller('QuadroOcorrenciasCtrl', QuadroOcorrenciasCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ProntuarioLink = function () {
    function ProntuarioLink(FeaturehubJsSdk, moment, FeatureHubConfigKeys, Authenticator, SolucoesEnum) {
      _classCallCheck(this, ProntuarioLink);

      this.featurehubJsSdk = FeaturehubJsSdk;
      this.moment = moment;
      this.authenticator = Authenticator;
      this.vFiltroStartDateFormat = 'YYYY.MM.DD.00.00.00.ZZ';
      this.vFiltroEndDateFormat = 'YYYY.MM.DD.23.59.59.ZZ';
      this.solucoesEnum = SolucoesEnum;
    }

    _createClass(ProntuarioLink, [{
      key: 'handleProntuarioLink',
      value: function handleProntuarioLink(defaultValue) {
        var date = new Date(),
            month = 'month';

        date.setDate(date.getDate() - 1);

        switch (defaultValue) {
          case 'ontem':
            return this.moment(date).format(this.vFiltroStartDateFormat) + ',' + this.moment(date).format(this.vFiltroEndDateFormat) + ',personalizado';

          case 'mesAtual':
            return this.moment().format(this.vFiltroStartDateFormat.replace('DD', '01')) + ',' + this.moment(date).format(this.vFiltroEndDateFormat) + ',personalizado';

          case 'ultimoMes':
            return this.moment().subtract(1, month).startOf(month).format(this.vFiltroStartDateFormat) + ',' + this.moment().subtract(1, month).endOf(month).format(this.vFiltroEndDateFormat) + ',monthly';

          case 'ultimos3Meses':
            return this.moment().subtract(3, month).startOf(month).format(this.vFiltroStartDateFormat) + ',' + this.moment().subtract(1, month).endOf(month).format(this.vFiltroEndDateFormat) + ',monthly';

          case 'ultimos6Meses':
            return this.moment().subtract(6, month).startOf(month).format(this.vFiltroStartDateFormat) + ',' + this.moment().subtract(1, month).endOf(month).format(this.vFiltroEndDateFormat) + ',monthly';

          default:
            return defaultValue;
        }
      }
    }, {
      key: 'goToLinkProntuarioSinceFirstDayOfMonth',
      value: function goToLinkProntuarioSinceFirstDayOfMonth(uoId, motoristaId) {
        if (motoristaId === null) {
          return '';
        }
        if (uoId === null) {
          return '';
        }

        var date = new Date();
        date.setDate(date.getDate() - 1);
        var dateStart = new Date(date.getFullYear(), date.getMonth(), 1);

        return 'prontuario?vfiltro=uo:' + uoId + ';dateTime:' + this.moment(dateStart).format(this.vFiltroStartDateFormat) + ',' + this.moment(date).format(this.vFiltroEndDateFormat) + ',personalizado;motorista:' + motoristaId;
      }
    }, {
      key: 'hasRoleToViewProntuario',
      value: function hasRoleToViewProntuario(user) {
        return this.authenticator.hasRole('PRONTUARIO_MOTORISTA_VISUALIZAR') && this.solucoesEnum.hasProntuarioSolucoes(user.solucoes) && user.permissoesSolucao.includes('DADOS_SENSIVEIS_VISUALIZAR') && (user.permissoesSolucao.includes('PRONTUARIO_MOTORISTA_VISUALIZAR') || user.permissoesSolucao.includes('RANKING_GERAL_VISUALIZAR'));
      }
    }]);

    return ProntuarioLink;
  }();

  angular.module('ProntuarioLinkModule', ['FeatureFlagModule', 'SolucoesModule']).service('ProntuarioLinkService', ProntuarioLink);
})();
'use strict';

(function () {
  'use strict';

  angular.module('ProntuarioV2Module', ['ui.router', 'ui.bootstrap', 'restangular', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'safetyModule', 'v3gAuthenticatorModule']).factory('ProntuarioV2', function (Restangular) {
    return Restangular.service('boletim/ranking/pontuacao-motoristas/mensal');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.prontuarioV2', {
      url: '/prontuario?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'prontuario-v2/prontuario.tpl.html',
          controller: 'ProntuarioV2Ctrl',
          controllerAs: 'prontuario'
        }
      },
      data: {
        titulo: 'ce.ranking.motoristas.prontuario.titulo',
        hideTitulo: true,
        roles: [['RANKING_GERAL_VISUALIZAR', 'PRONTUARIO_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }

  angular.module('ProntuarioV2Module').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ProntuarioV2Ctrl = function () {
    function ProntuarioV2Ctrl($uibModal, $location, Keys, Authenticator, ServiceVfiltro, FactoryVfiltro, safetyService, SolucoesEnum, FeatureFlag, $translate, FeaturehubJsSdk) {
      _classCallCheck(this, ProntuarioV2Ctrl);

      this.keys = Keys;
      this.authenticator = Authenticator;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.safetyService = safetyService;
      this.featureFlag = FeatureFlag;
      this.solucoesEnum = SolucoesEnum;
      this.modalService = $uibModal;
      this.translate = $translate;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.solucaoId = this.featureFlag.SOLUCAO_REC_FACIAL ? this.solucoesEnum.RECONHECIMENTO_FACIAL : null;

      var search = $location.search();
      this.currentTab = search && search.tab ? search.tab : 'indicators';

      this.consultar();
    }

    _createClass(ProntuarioV2Ctrl, [{
      key: 'consultar',
      value: function consultar() {
        var _this = this;

        this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          key: this.keys.dateTime.name,
          dateLimit: 30,
          format: 'YYYY-MM-DD',
          labelSegmentPersonalizado: this.translate.instant('v3gwc.vfiltro.tempo.daily'),
          defaultValues: {
            monthly: {
              active: true,
              dateLimit: 365
            }
          }
        }, {
          name: 'motorista',
          key: this.keys.motorista.name,
          required: true,
          onlyActive: false
        }])).then(function (filtro) {
          _this.isMonthly = filtro.find(function (f) {
            return f.key === _this.keys.dateTime.name;
          }).value.tipo === 'monthly';
          _this.vfiltroBackend = _this.serviceVfiltro.getFiltroBackendNovo(filtro);
          _this.authenticator.getUser().then(function (user) {
            _this.loadReact(user);
          });
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact(user) {
        var _this2 = this;

        var appName = 'safetyApp',
            componentPath = './Prontuario',
            componentId = 'safety-driver-record',
            props = {
          currentTab: this.currentTab,
          driverId: this.vfiltroBackend.motorista,
          endDate: this.vfiltroBackend.fim,
          handleOpenModalUpload: this.handleOpenModalUpload.bind(this),
          isMonthly: this.isMonthly,
          solucaoRecFacialId: this.solucaoId,
          startDate: this.vfiltroBackend.inicio,
          uoId: this.vfiltroBackend.uoId,
          user: user
        };

        this.safetyService.initialize().then(function () {
          return _this2.safetyService.loadReactComponent(appName, componentPath, componentId, props);
        });
      }
    }, {
      key: 'handleOpenModalUpload',
      value: function handleOpenModalUpload(event) {
        var _this3 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'prontuario/modal/upload/upload-prontuario.tpl.html',
          controller: 'UploadProntuarioCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristaId: function motoristaId() {
              return _this3.vfiltroBackend.motorista;
            },
            arquivo: function arquivo() {
              return event.detail;
            },
            user: function user() {
              return _this3.serviceVfiltro.factoryVfiltro.user;
            }
          }
        }).result.then(function () {
          /*eslint-disable */
          var ev = new Event('reload-infracoes-prontuario');
          document.dispatchEvent(ev);
          /*eslint-enable */
        });
      }
    }, {
      key: 'handleGoToOldProntuario',
      value: function handleGoToOldProntuario() {
        return '/prontuario-antigo';
      }
    }]);

    return ProntuarioV2Ctrl;
  }();

  angular.module('ProntuarioV2Module').controller('ProntuarioV2Ctrl', ProntuarioV2Ctrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.prontuario', {
      url: '/prontuario-antigo?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'prontuario/prontuario.tpl.html',
          controller: 'ProntuarioCtrl',
          controllerAs: 'prontuario'
        }
      },
      data: {
        titulo: 'ce.ranking.motoristas.prontuario.titulo',
        hideTitulo: true,
        roles: [['RANKING_GERAL_VISUALIZAR', 'PRONTUARIO_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
      }
    });
  }

  angular.module('ProntuarioModule').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global document, Event */

  var ProntuarioCtrl = function () {
    function ProntuarioCtrl($uibModal, moment, Keys, ServiceVfiltro, FactoryVfiltro) {
      _classCallCheck(this, ProntuarioCtrl);

      this.modalService = $uibModal;
      this.moment = moment;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;

      this.consultar();
    }

    _createClass(ProntuarioCtrl, [{
      key: 'consultar',
      value: function consultar() {
        var _this = this;

        this.serviceVfiltro.init(this.factoryVfiltro.get([{
          key: this.keys.dateTime.name,
          showSegmentPersonalizado: false,
          format: 'YYYY-MM-DD',
          defaultValues: this.getDefaultValuesFiltro()
        }, {
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          name: 'motorista',
          key: this.keys.motorista.name,
          required: true,
          onlyActive: false
        }])).then(function (filtro) {
          _this.vfiltroBackend = _this.serviceVfiltro.getFiltroBackendNovo(filtro);
          _this.setupProntuarioTassi(_this.vfiltroBackend);
          _this.isAdminVeltec = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ADMIN_VELTEC');
        });
      }
    }, {
      key: 'setupProntuarioTassi',
      value: function setupProntuarioTassi(filtro) {
        /*eslint-disable */
        var prontuarioDivElement = document.querySelector('#prontuario-tassi'),
            prontuarioElement = document.createElement('vfwc-prontuario-motorista');
        prontuarioElement.uoId = filtro.uoId;
        prontuarioElement.inicio = filtro.inicio;
        prontuarioElement.fim = filtro.fim;
        prontuarioElement.motoristaId = filtro.motorista;
        prontuarioElement.usuario = this.serviceVfiltro.factoryVfiltro.user;
        /*eslint-enable */

        prontuarioDivElement.appendChild(prontuarioElement);
        this.onAbrirModalEditarInfracao(prontuarioElement);
      }
    }, {
      key: 'onAbrirModalEditarInfracao',
      value: function onAbrirModalEditarInfracao(element) {
        var _this2 = this;

        element.addEventListener('abrirModalImportarInfracoes', function (event) {
          _this2.openModalUpload(event.detail);
        });
      }
    }, {
      key: 'getDefaultValuesFiltro',
      value: function getDefaultValuesFiltro() {
        return {
          mesAtual: {
            active: this.geCurrentDay() !== 1
          },
          ultimoMes: {
            active: true
          },
          ultimos3Meses: {
            active: true
          },
          ultimos6Meses: {
            active: true
          }
        };
      }
    }, {
      key: 'geCurrentDay',
      value: function geCurrentDay() {
        return this.moment().date();
      }
    }, {
      key: 'openModalUpload',
      value: function openModalUpload() {
        var _this3 = this;

        var _arquivo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        this.modalService.open({
          animation: true,
          templateUrl: 'prontuario/modal/upload/upload-prontuario.tpl.html',
          controller: 'UploadProntuarioCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristaId: function motoristaId() {
              return _this3.vfiltroBackend.motorista;
            },
            arquivo: function arquivo() {
              return _arquivo;
            },
            user: function user() {
              return _this3.serviceVfiltro.factoryVfiltro.user;
            }
          }
        }).result.then(function () {
          /*eslint-disable */
          var ev = new Event('reload-infracoes-prontuario');
          document.dispatchEvent(ev);
          /*eslint-enable */
        });
      }
    }, {
      key: 'handleGoToNewProntuario',
      value: function handleGoToNewProntuario() {
        return '/prontuario';
      }
    }]);

    return ProntuarioCtrl;
  }();

  angular.module('ProntuarioModule').controller('ProntuarioCtrl', ProntuarioCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('productivity-report', ['ui.router', 'ui.bootstrap', 'blockUI', 'angularMoment', 'restangular', 'httpServiceV3gModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ObjetosVfiltroModule', 'safetyModule', 'ngSanitize']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('productivity-report').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.productivity-report', {
      url: '/productivity-report?vfiltro&tabIndex',
      views: {
        'content@': {
          templateUrl: 'productivity-report/productivity-report.tpl.html',
          controller: 'ProductivityReportCtrl',
          controllerAs: 'productivityReportCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.productivityReport.menuLabel',
        hideTitulo: true,
        roles: ['MACRO_VISUALIZAR', 'ROTA_VISUALIZAR']
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ProductivityReportCtrl = function () {
    function ProductivityReportCtrl(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, moment, $stateParams) {
      _classCallCheck(this, ProductivityReportCtrl);

      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.filtro = null;
      this.user = null;
      this.tabIndex = this.getValidatedTabIndex();

      this.initialize();
    }

    _createClass(ProductivityReportCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          key: this.keys.dateTime.name,
          time: true,
          maxDate: this.moment().endOf('day').format(),
          defaultValues: {
            hoje: {
              active: true
            },
            ontem: {
              active: true
            }
          }
        }, {
          name: 'veiculosId',
          key: this.keys.veiculos.name,
          ignoreValidation: true
        }])).then(function (filtro) {
          _this2.filtro = filtro;
        });
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this3 = this;

        return this.authenticator.getUser().then(function (user) {
          _this3.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this4 = this;

        var appName = 'safetyApp',
            componentName = './ProductivityReportPageRoute',
            componentId = 'safety-productivity-report',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this4.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'getValidatedTabIndex',
      value: function getValidatedTabIndex() {
        var tabIndex = Number(this.stateParams.tabIndex);

        if (tabIndex === 0 || tabIndex === 1 || tabIndex === 2) {
          return tabIndex;
        }

        return 0;
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this5 = this;

        var filteredVehicles = this.filtro.find(function (f) {
          return f.key === _this5.keys.veiculos.name;
        });

        return {
          user: this.user,
          filter: {
            ouId: this.filtro.find(function (f) {
              return f.key === _this5.keys.uo.name;
            }).value.id,
            startDate: this.filtro.find(function (f) {
              return f.key === _this5.keys.dateTime.name;
            }).value.startDate,
            endDate: this.filtro.find(function (f) {
              return f.key === _this5.keys.dateTime.name;
            }).value.endDate,
            vehicleIds: filteredVehicles ? filteredVehicles.values.map(function (v) {
              return v.id;
            }) : []
          },
          tabIndex: this.tabIndex
        };
      }
    }]);

    return ProductivityReportCtrl;
  }();

  angular.module('productivity-report').controller('ProductivityReportCtrl', ProductivityReportCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('productivity-indicators', ['ui.router']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('productivity-indicators').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.productivity-indicators', {
      url: '/productivity-indicators?vfiltro',
      views: {
        'content@': {
          templateUrl: 'productivity-indicators/productivity-indicators.tpl.html',
          controller: 'ProductivityIndicatorsCtrl',
          controllerAs: 'productivityIndicatorsCtrl'
        }
      },
      data: {
        titulo: 'ce.indicadores.productivityIndicators.menuLabel',
        hideTitulo: true,
        role: 'ROTA_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ProductivityIndicatorsCtrl = function () {
    function ProductivityIndicatorsCtrl(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, moment) {
      _classCallCheck(this, ProductivityIndicatorsCtrl);

      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    _createClass(ProductivityIndicatorsCtrl, [{
      key: 'initialize',
      value: function initialize() {
        var _this = this;

        this.blockUI.start();
        return this.initFilter().then(function () {
          return _this.loadUser();
        }).then(function () {
          return _this.loadReact();
        }).finally(function () {
          _this.blockUI.reset();
          _this.blockUI.stop();
        });
      }
    }, {
      key: 'initFilter',
      value: function initFilter() {
        var _this2 = this;

        return this.serviceVfiltro.init(this.factoryVfiltro.get([{
          name: 'uoId',
          key: this.keys.uo.name
        }, {
          key: this.keys.dateTime.name,
          time: false,
          required: true,
          dateLimit: 30,
          maxDate: this.moment().subtract(1, 'days').endOf('day').format(),
          defaultValues: {
            ultimos7dias: {
              active: true
            },
            ultimos30dias: {
              active: true
            }
          }
        }, {
          name: 'duoRoutes',
          key: this.keys.duoRoutes.name,
          ignoreValidation: true
        }])).then(function (filtro) {
          _this2.filtro = filtro;
        });
      }
    }, {
      key: 'loadUser',
      value: function loadUser() {
        var _this3 = this;

        return this.authenticator.getUser().then(function (user) {
          _this3.user = user;
        });
      }
    }, {
      key: 'loadReact',
      value: function loadReact() {
        var _this4 = this;

        var appName = 'safetyApp',
            componentName = './ProductivityIndicatorsPageRoute',
            componentId = 'safety-productivity-indicators',
            props = this.getReactProps();

        return this.safetyService.initialize().then(function () {
          return _this4.safetyService.loadReactComponent(appName, componentName, componentId, props);
        });
      }
    }, {
      key: 'getReactProps',
      value: function getReactProps() {
        var _this5 = this;

        var filteredRoutes = this.filtro.find(function (f) {
          return f.key === _this5.keys.duoRoutes.name;
        }),
            routeUUIDs = filteredRoutes ? filteredRoutes.values.map(function (r) {
          return r.id;
        }) : [],
            ouId = this.filtro.find(function (f) {
          return f.key === _this5.keys.uo.name;
        }).value.id,
            date = this.filtro.find(function (f) {
          return f.key === _this5.keys.dateTime.name;
        }).value,
            startDate = date.startDate,
            endDate = date.endDate;

        return {
          user: this.user,
          filter: {
            ouId: ouId,
            startDate: startDate,
            endDate: endDate,
            routeUUIDs: routeUUIDs
          }
        };
      }
    }]);

    return ProductivityIndicatorsCtrl;
  }();

  angular.module('productivity-indicators').controller('ProductivityIndicatorsCtrl', ProductivityIndicatorsCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PlanosSolucoesNovoUsuarioCtrl = function () {
    function PlanosSolucoesNovoUsuarioCtrl($state, $window, $timeout) {
      _classCallCheck(this, PlanosSolucoesNovoUsuarioCtrl);

      this.state = $state;
      this.window = $window;
      this.timeout = $timeout;
      this.shouldDisplayUnauthorizedPage = false;
      this.init();
    }

    _createClass(PlanosSolucoesNovoUsuarioCtrl, [{
      key: 'init',
      value: function init() {
        var browserLanguage = this.window.navigator.language || this.window.navigator.userLanguage;
        if (browserLanguage.startsWith('en')) {
          this.handleRedirectionFromTFM();
        } else {
          this.handleNormalRedirectionFlow();
        }
      }
    }, {
      key: 'handleRedirectionFromTFM',
      value: function handleRedirectionFromTFM() {
        this.shouldDisplayUnauthorizedPage = true;
      }
    }, {
      key: 'handleNormalRedirectionFlow',
      value: function handleNormalRedirectionFlow() {
        this.timeout(function () {
          var contratacaoPlanos = angular.element('vfwc-contratacao-planos')[0];
          if (contratacaoPlanos) {
            contratacaoPlanos.solucaoIds = [];
            contratacaoPlanos.uoId = 1;
            contratacaoPlanos.linkContatoFixo = 'https://veltec.atlassian.net/servicedesk/customer/portal/6/group/20/create/362';
          }
        }, 0);
      }
    }]);

    return PlanosSolucoesNovoUsuarioCtrl;
  }();

  PlanosSolucoesNovoUsuarioCtrl.$inject = ['$state', '$window', '$timeout'];

  angular.module('planosSolucoesNovoUsuarioModule', ['ui.router']).controller('PlanosSolucoesNovoUsuarioCtrl', PlanosSolucoesNovoUsuarioCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('unprotected.planos-solucoes-novo-usuario', {
      url: '/planos-solucoes-novo-usuario',
      views: {
        'guest@': {
          templateUrl: 'planos-solucoes-usuario-novo/planos-solucoes.tpl.html',
          controller: 'PlanosSolucoesNovoUsuarioCtrl',
          controllerAs: 'ctrl'
        }
      }
    });
  }

  angular.module('planosSolucoesNovoUsuarioModule').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.planos', {
      url: '/planos-solucoes',
      views: {
        'content@': {
          templateUrl: 'planos-solucoes/planos-solucoes.tpl.html',
          controller: 'PlanosSolucoesCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        hideTitulo: true
      }
    });
  }

  angular.module('planosSolucoesModule').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  function OnePageSortDirective($window) {
    return {
      require: '^stTable',
      link: function link(scope, element, attr, ctrl) {
        var orderBy = angular.fromJson(attr.orderby);
        if (orderBy && orderBy.predicate) {
          ctrl.sortBy(orderBy.predicate, orderBy.reverse);
        }

        scope.$watch(function () {
          return ctrl.tableState();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            var local = angular.fromJson($window.localStorage.getItem(attr.nameLocalstorage));
            local.alertas.map(function (x) {
              if (x.tipo === attr.onePageSortDirective) {
                x.sort = newValue.sort;
              }
              return x;
            });
            $window.localStorage.setItem(attr.nameLocalstorage, angular.toJson(local));
          }
        }, true);
      }
    };
  }

  angular.module('onePageModule').directive('onePageSortDirective', OnePageSortDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var OnePageService = function () {
    function OnePageService($timeout, StatusVeiculo, StatusVeiculoPassivelManutencao, Restangular) {
      _classCallCheck(this, OnePageService);

      this.timeout = $timeout;
      this.statusVeiculoService = StatusVeiculo;
      this.statusVeiculoPassivelManutencaoService = StatusVeiculoPassivelManutencao;
      this.restangular = Restangular;
      this.callbacksStatusVeiculo = [];
      this.callbacksStatusVeiculoPassivelManutencao = [];
      this.callbacksAlertaTurno = [];
      this.alertaTurnoErrorHandlers = [];
      this.paramStatusVeiculo = null;
      this.paramAlertaTurno = null;
      this.alertaTurno = null;
      this.alertaTipo = '';
      this.alertaSelecionado = {};
      this.exibirAlertaTurnos = true;
    }

    _createClass(OnePageService, [{
      key: 'onUpdateStatusVeiculoPassivelManutencao',
      value: function onUpdateStatusVeiculoPassivelManutencao(callback, name) {
        if (this.callbacksStatusVeiculoPassivelManutencao.filter(function (e) {
          return e.name === name;
        }).length === 0) {
          this.callbacksStatusVeiculoPassivelManutencao.push({ callback: callback, name: name });
        }
      }
    }, {
      key: 'checkStatusVeiculoPassivelManutencao',
      value: function checkStatusVeiculoPassivelManutencao(param) {
        var _this = this;

        this.paramStatusVeiculo = param;
        return this.statusVeiculoPassivelManutencaoService.getStatusVeiculos(param.uoId).then(function (data) {
          _this.updateStatusVeiculoPassivelManutencao(data.plain());
        }, function () {
          _this.updateStatusVeiculoPassivelManutencao(0);
        });
      }
    }, {
      key: 'updateStatusVeiculoPassivelManutencao',
      value: function updateStatusVeiculoPassivelManutencao(data) {
        var _this2 = this;

        if (data !== 0) {
          this.listaCacheadaPassivelManutencao = data;
        }
        this.callbacksStatusVeiculoPassivelManutencao.forEach(function (cb) {
          cb.callback(_this2.listaCacheadaPassivelManutencao);
        });
        this.timerPassivelManutencao = this.timeout(function () {
          return _this2.checkStatusVeiculoPassivelManutencao(_this2.paramStatusVeiculo);
        }, 60000);
      }
    }, {
      key: 'onUpdateStatusVeiculo',
      value: function onUpdateStatusVeiculo(callback, name) {
        if (this.callbacksStatusVeiculo.filter(function (e) {
          return e.name === name;
        }).length === 0) {
          this.callbacksStatusVeiculo.push({ callback: callback, name: name });
        }
      }
    }, {
      key: 'checkStatusVeiculo',
      value: function checkStatusVeiculo(param) {
        var _this3 = this;

        this.paramStatusVeiculo = param;
        return this.statusVeiculoService.one().get(this.paramStatusVeiculo).then(function (data) {
          _this3.updateStatusVeiculo(data.plain());
        }, function () {
          _this3.updateStatusVeiculo(0);
        });
      }
    }, {
      key: 'updateStatusVeiculo',
      value: function updateStatusVeiculo(data) {
        var _this4 = this;

        if (data !== 0) {
          this.listaCacheada = data;
        }
        this.callbacksStatusVeiculo.forEach(function (cb) {
          cb.callback(_this4.listaCacheada);
        });
        this.timer = this.timeout(function () {
          return _this4.checkStatusVeiculo(_this4.paramStatusVeiculo);
        }, 60000);
      }
    }, {
      key: 'removeTimer',
      value: function removeTimer() {
        this.timeout.cancel(this.timer);
        this.timeout.cancel(this.timerAlertaTurno);
        this.timeout.cancel(this.timerPassivelManutencao);
      }
    }, {
      key: 'removeUpdateStatusVeiculo',
      value: function removeUpdateStatusVeiculo() {
        this.callbacksStatusVeiculo = [];
      }
    }, {
      key: 'removeUpdateAlertaTurno',
      value: function removeUpdateAlertaTurno() {
        this.callbacksAlertaTurno = [];
        this.alertaTurnoErrorHandlers = [];
      }
    }, {
      key: 'removeUpdateStatusVeiculoPassivelManutencao',
      value: function removeUpdateStatusVeiculoPassivelManutencao() {
        this.callbacksStatusVeiculoPassivelManutencao = [];
      }
    }, {
      key: 'onUpdateAlertaTurno',
      value: function onUpdateAlertaTurno(callback, name) {
        if (this.callbacksAlertaTurno.filter(function (e) {
          return e.name === name;
        }).length === 0) {
          this.callbacksAlertaTurno.push({ callback: callback, name: name });
        }
      }
    }, {
      key: 'onUpdateAlertaTurnoError',
      value: function onUpdateAlertaTurnoError(callback, name) {
        if (this.alertaTurnoErrorHandlers.filter(function (e) {
          return e.name === name;
        }).length === 0) {
          this.alertaTurnoErrorHandlers.push({ callback: callback, name: name });
          this.timeout.cancel(this.timerAlertaTurno);
          this.checkAlertaTurno(this.paramAlertaTurno);
        }
      }
    }, {
      key: 'checkAlertaTurno',
      value: function checkAlertaTurno(param) {
        var _this5 = this;

        this.paramAlertaTurno = param;
        return this.restangular.one('alerta/one-page/' + this.paramAlertaTurno.uoId).get().then(function (data) {
          var dataPlain = data.plain();
          if (dataPlain && dataPlain.turnos.length > 0) {
            _this5.exibirAlertaTurnos = true;
          } else {
            _this5.exibirAlertaTurnos = false;
          }
          _this5.updateAlertaTurno(dataPlain);
        }, function (error) {
          _this5.alertaTurnoErrorHandlers.forEach(function (cb) {
            return cb.callback(error);
          });
          _this5.exibirAlertaTurnos = true;
          _this5.updateAlertaTurno(0);
        });
      }
    }, {
      key: 'updateAlertaTurno',
      value: function updateAlertaTurno(data) {
        var _this6 = this;

        if (data !== 0) {
          this.listaCacheadaAlertaTurno = data;
        }
        this.callbacksAlertaTurno.forEach(function (cb) {
          cb.callback(_this6.listaCacheadaAlertaTurno);
        });
        this.timerAlertaTurno = this.timeout(function () {
          return _this6.checkAlertaTurno(_this6.paramAlertaTurno);
        }, 60000);
      }
    }, {
      key: 'getAlertaTurno',
      value: function getAlertaTurno(tipo) {
        if (this.alertaTipo !== tipo || this.alertaTurno.length === 1) {
          var alerta = this.alertaTurno.filter(function (x) {
            return x.key === tipo;
          })[0];

          this.alertaTipo = tipo;
          this.alertaSelecionado = alerta;
        }
        return this.alertaSelecionado;
      }
    }]);

    return OnePageService;
  }();

  angular.module('onePageModule').service('OnePageService', OnePageService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('onePageModule').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.onePage', {
      url: '/tempo-real?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'one-page/one-page.tpl.html',
          controller: 'OnePageCtrl',
          controllerAs: 'onePage'
        }
      },
      data: {
        titulo: 'ce.tempoReal.statusFrota.titulo',
        roles: ['ONE_PAGE_VISUALIZAR']
      }
    });
  }
})();
'use strict';

(function () {
  'use strict';

  function OnePageHighlightDirective($timeout, OnePageService) {
    return {
      scope: {
        tipoAlerta: '=',
        newValue: '=',
        oldValue: '='
      },
      link: function link(scope, element, attr) {
        if (scope.newValue !== scope.oldValue) {
          var obj = OnePageService.alertaTurno.filter(function (x) {
            return x.key === attr.onePageHighlightDirective;
          });
          if (obj.length > 0) {
            obj[0][scope.tipoAlerta] = scope.newValue;
          }
          angular.element(element[0]).addClass('highlight-turno');
          $timeout(function () {
            return angular.element(element[0]).removeClass('highlight-turno');
          }, 1500);
        }
      }
    };
  }

  angular.module('onePageModule').directive('onePageHighlightDirective', OnePageHighlightDirective);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var OnePageCtrl = function () {
    function OnePageCtrl($scope, $window, $uibModal, OnePageService, CustomGridster, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, $translate) {
      var _this = this;

      _classCallCheck(this, OnePageCtrl);

      this.scope = $scope;
      this.window = $window;
      this.translate = $translate;
      this.modalService = $uibModal;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.onePageService = OnePageService;
      this.customGridster = CustomGridster;

      this.edicaoGridster = false;
      this.versaoLocalstorage = 'v5';
      this.colors = ['rgb(244, 150, 59)', 'rgb(72, 60, 70)', 'rgb(60, 110, 113)', 'rgb(136,84,196)', 'rgb(112,174,110)', 'rgb(139,188,33)', 'rgb(255,108,58)', 'rgb(49,139,255)', 'rgb(204,38,54)', '#F2994A', '#92a323', 'rgb(255, 203, 63)', 'rgb(255, 73, 121)', '#6790AB', '#FF94C2', '#880E4F', '#F80C0C', '#133c7c', '#5f680b', '#0b685a', '#9183ad', '#d7f704', '#627a5f', '#510e0b', '#bf1ea1', '#7b5b91', '#ea52c4', '#5eea52', '#dff704'];

      this.scope.$on('$destroy', function () {
        _this.onePageService.removeTimer();
      });

      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function () {
        _this.init();
      });
    }

    _createClass(OnePageCtrl, [{
      key: 'init',
      value: function init() {
        this.user = this.serviceVfiltro.factoryVfiltro.user;
        var graficoCard = angular.fromJson(this.window.localStorage.getItem('grafico-card-' + this.user.id)) || true,
            edicaoGridster = angular.fromJson(this.window.localStorage.getItem('edicao-gridster-' + this.user.id));
        if (graficoCard !== null) {
          this.grafico = graficoCard;
        } else {
          this.window.localStorage.setItem('grafico-card-' + this.user.id, this.grafico);
        }
        if (edicaoGridster !== null) {
          this.edicaoGridster = edicaoGridster;
          this.customGridster.setStatusGridster(edicaoGridster);
        } else {
          this.window.localStorage.setItem('edicao-gridster-' + this.user.id, this.edicaoGridster);
        }
        this.loadOnePageService();
      }
    }, {
      key: 'loadOnePageService',
      value: function loadOnePageService() {
        this.onePageService.removeTimer();
        this.onePageService.checkStatusVeiculo(this.getParams());
        this.onePageService.checkStatusVeiculoPassivelManutencao(this.getParams());
        this.onePageService.checkAlertaTurno(this.getParams());
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return {
          uoId: this.getParamValue(this.keys.uo.name)
        };
      }
    }, {
      key: 'getParamValue',
      value: function getParamValue(name) {
        var param = this.serviceVfiltro.filtroTopbar.find(function (p) {
          return p.key === name;
        });
        if (param) {
          return param.value.id;
        }
        return undefined;
      }
    }, {
      key: 'graficoCard',
      value: function graficoCard(item) {
        this.grafico = item;
        this.window.localStorage.setItem('grafico-card-' + this.user.id, this.grafico);
      }
    }, {
      key: 'statusGridster',
      value: function statusGridster() {
        this.edicaoGridster = !this.edicaoGridster;
        this.customGridster.setStatusGridster(this.edicaoGridster);
        this.window.localStorage.setItem('edicao-gridster-' + this.user.id, this.edicaoGridster);
      }
    }, {
      key: 'getPosicaoGrafico',
      value: function getPosicaoGrafico(name, defaultValue) {
        var item = this.customGridster.getLocalStorage(name);
        if (item && item.versao && item.versao === this.versaoLocalstorage) {
          return item;
        }
        this.customGridster.setLocalStorage(name, defaultValue);
        return defaultValue;
      }
    }, {
      key: 'setPosicaoLocalStorage',
      value: function setPosicaoLocalStorage(obj) {
        var _this2 = this;

        this.scope.$watch(function () {
          return obj;
        }, function (i) {
          var item = _this2.customGridster.getLocalStorage(i.name);
          if (item) {
            item.sizeX = i.sizeX;
            item.sizeY = i.sizeY;
            item.minSizeX = i.minSizeX;
            item.maxSizeX = i.maxSizeX;
            item.minSizeY = i.minSizeY;
            item.maxSizeY = i.maxSizeY;
            item.row = i.row;
            item.col = i.col;
            item.versao = i.versao;
            _this2.customGridster.setLocalStorage(i.name, item);
          }
        }, true);
      }
    }, {
      key: 'setPosicaoLocalStorageAlertas',
      value: function setPosicaoLocalStorageAlertas(obj, name) {
        var _this3 = this;

        return this.scope.$watch(function () {
          return obj;
        }, function (i) {
          var item = _this3.customGridster.getLocalStorage(name);
          if (item) {
            var alertas = item.alertas.map(function (x) {
              if (x.tipo === i.tipo) {
                return {
                  row: i.row,
                  col: i.col,
                  sizeX: i.sizeX,
                  sizeY: i.sizeY,
                  minSizeY: i.minSizeY,
                  maxSizeY: i.maxSizeY,
                  minSizeX: i.minSizeX,
                  maxSizeX: i.maxSizeX,
                  tipo: i.tipo,
                  sort: i.sort
                };
              }
              return x;
            });
            _this3.customGridster.setLocalStorage(name, { name: name, alertas: alertas, versao: _this3.versaoLocalstorage });
          }
        }, true);
      }
    }, {
      key: 'voltarPadrao',
      value: function voltarPadrao() {
        var _this4 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'one-page/one-page-padrao.tpl.html',
          controller: 'ModalOnePageCtrl',
          controllerAs: '$ctrl'
        }).result.then(function () {
          _.forIn(_this4.window.localStorage, function (value, key) {
            if (key.indexOf('c-alertaTurno-' + _this4.user.id) !== -1) {
              _this4.customGridster.removeLocalStorage(key);
            }
          });
          _this4.customGridster.removeLocalStorage('c-paradoMovimento-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('c-semsinal-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('g-alerta-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('g-alertaTurno-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('g-paradoMovimento-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('g-semsinal-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('edicao-gridster-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('grafico-card-' + _this4.user.id);
          _this4.customGridster.removeLocalStorage('collapse-alertas-' + _this4.user.id);
          _this4.window.location.href = '/tempo-real';
        });
      }
    }, {
      key: 'isEdicaoGridster',
      value: function isEdicaoGridster() {
        return this.edicaoGridster ? this.translate.instant('ce.tempoReal.statusFrota.common.desabilitarEdicao') : this.translate.instant('ce.tempoReal.statusFrota.common.habilitarEdicao');
      }
    }]);

    return OnePageCtrl;
  }();

  var ModalOnePage = function ModalOnePage($uibModalInstance) {
    _classCallCheck(this, ModalOnePage);

    this.modalInstance = $uibModalInstance;
  };

  /**
   * @ngdoc object
   * @name onePage.controller:OnePageCtrl
   *
   * @description
   *
   */


  angular.module('onePageModule').controller('ModalOnePageCtrl', ModalOnePage).controller('OnePageCtrl', OnePageCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global _ */

  var AlertaVeiculoService = function () {
    function AlertaVeiculoService(HttpServiceV3g, $timeout, moment, AlertaVeiculoConfig, AlertasEnum, $translate) {
      var _this = this;

      _classCallCheck(this, AlertaVeiculoService);

      this.http = HttpServiceV3g;
      this.timeout = $timeout;
      this.moment = moment;
      this.config = AlertaVeiculoConfig;
      this.callbacksPorTipo = [];
      this.callbacksPorTipoErrorHandler = [];
      this.translate = $translate;
      this.alertaMapPtBr = AlertasEnum.getTipos().reduce(function (acc, atual) {
        acc[atual.id] = {
          key: atual.id,
          texto: _this.translate.instant(atual.descricao),
          icone: atual.icone,
          ordem: atual.ordem,
          chartColor: atual.chartColor
        };
        return acc;
      }, {});
    }

    _createClass(AlertaVeiculoService, [{
      key: 'onUpdateAlertaPorTipo',
      value: function onUpdateAlertaPorTipo(callback, id) {
        if (this.callbacksPorTipo.filter(function (e) {
          return e.id === id;
        }).length === 0) {
          this.callbacksPorTipo.push({ callback: callback, id: id });
        }
      }
    }, {
      key: 'onUpdateAlertaPorTipoError',
      value: function onUpdateAlertaPorTipoError(callback, id) {
        if (this.callbacksPorTipoErrorHandler.filter(function (e) {
          return e.id === id;
        }).length === 0) {
          this.callbacksPorTipoErrorHandler.push({ callback: callback, id: id });
          if (this.errorcheckAlertaPorTipo) {
            this.checkAlertaPorTipo();
          }
        }
      }
    }, {
      key: 'checkAlertaPorTipo',
      value: function checkAlertaPorTipo() {
        var _this2 = this;

        return this.http.get(this.getUrlAlertaPorTipo()).then(function (response) {
          _this2.updateAlertaPorTipo(_this2.mapearPtBr(response.data));
        }, function (error) {
          _this2.errorcheckAlertaPorTipo = error;
          _this2.callbacksPorTipoErrorHandler.forEach(function (cb) {
            return cb.callback(error);
          });
          _this2.timeoutPorTipo = _this2.timeout(function () {
            return _this2.checkAlertaPorTipo();
          }, 10000);
        });
      }
    }, {
      key: 'updateAlertaPorTipo',
      value: function updateAlertaPorTipo(data) {
        var _this3 = this;

        if (data && data !== 0) {
          this.listaCacheada = data;
        }
        this.callbacksPorTipo.forEach(function (cb) {
          return cb.callback(data);
        });
        this.timeoutPorTipo = this.timeout(function () {
          return _this3.checkAlertaPorTipo();
        }, 10000);
      }
    }, {
      key: 'removeCallbackPorTipo',
      value: function removeCallbackPorTipo(id) {
        this.callbacksPorTipo = this.callbacksPorTipo.filter(function (x) {
          return x.id !== id;
        });
      }
    }, {
      key: 'getUrlAlertaPorTipo',
      value: function getUrlAlertaPorTipo() {
        return this.config.url + '/quantidade/' + this.config.uoId + '/tipo?dia=' + this.moment().format('YYYY-MM-DD');
      }
    }, {
      key: 'mapearPtBr',
      value: function mapearPtBr(listaBackEnd) {
        var _this4 = this;

        return _(listaBackEnd).map(function (value, tipo) {
          var _alertaMapPtBr$tipo = _this4.alertaMapPtBr[tipo],
              key = _alertaMapPtBr$tipo.key,
              texto = _alertaMapPtBr$tipo.texto,
              icone = _alertaMapPtBr$tipo.icone,
              ordem = _alertaMapPtBr$tipo.ordem,
              chartColor = _alertaMapPtBr$tipo.chartColor;

          return { key: key, texto: texto, quantidade: value, icone: icone, ordem: ordem, chartColor: chartColor };
        }).sortBy('ordem').value();
      }
    }, {
      key: 'stop',
      value: function stop() {
        this.timeout.cancel(this.timeoutPorTipo);
      }
    }, {
      key: 'setUoId',
      value: function setUoId(uoId) {
        this.config.uoId = uoId;
      }
    }]);

    return AlertaVeiculoService;
  }();

  angular.module('onePageModule').service('AlertaVeiculoService', AlertaVeiculoService).value('AlertaVeiculoConfig', {
    url: '/alerta',
    uoId: -1
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable no-underscore-dangle */
(function () {
  'use strict';

  var Onboarding = function () {
    function Onboarding($q, HttpServiceV3g, $window, $location, $document, $rootScope, Restangular, ngIntroService, IDBuscaPorRegiao, $timeout) {
      _classCallCheck(this, Onboarding);

      this.q = $q;
      this.http = HttpServiceV3g;
      this.window = $window;
      this.location = $location;
      this.document = $document;
      this.rootScope = $rootScope;
      this.restangular = Restangular;
      this.isTutorialBuscaRegiao = false;
      this.ngIntroService = ngIntroService;
      this.timeout = $timeout;
      this.idBuscaPorRegiao = IDBuscaPorRegiao;
      this.steps = null;
      this.stepsLengthTotal = 0;
    }

    _createClass(Onboarding, [{
      key: 'getListOnboarding',
      value: function getListOnboarding(id) {
        return this.restangular.one('/wiki/' + id + '/child?expand=page.body.view,page.metadata.labels').get();
      }
    }, {
      key: 'buildObjectOnboarding',
      value: function buildObjectOnboarding(lista) {
        return {
          steps: lista,
          exitOnOverlayClick: false,
          nextLabel: '<button type="button" style="background: #005F9E; width: 92px; height: 28px; color: white; font-weight: bold; border: 0;">PRÓXIMO</button>',
          prevLabel: '<i class="fa fa-chevron-left"></i>',
          skipLabel: 'Sair',
          doneLabel: 'Sair',
          showStepNumbers: false,
          hidePrev: this.isTutorialBuscaRegiao,
          showBullets: !this.isTutorialBuscaRegiao,
          disableInteraction: true,
          keyboardNavigation: false
        };
      }
    }, {
      key: 'startOnboarding',
      value: function startOnboarding(id) {
        var _this = this;

        this.isTutorialBuscaRegiao = id === this.idBuscaPorRegiao;
        if (this.location.search().demo) {
          this.getListOnboarding(id).then(function (data) {
            _this.ngIntroService.clear();
            _this.steps = data.page.results.map(function (x) {
              return {
                intro: x.body.view.value,
                element: isNaN(Number(x.title)) ? x.title : undefined,
                position: x.metadata.labels.results[0] ? x.metadata.labels.results[0].name : undefined,
                stepIndex: data.page.results.indexOf(x) + 1
              };
            });
            _this.stepsLengthTotal = _this.steps.length;
            _this.ngIntroService.clear();
            _this.ngIntroService.setOptions(_this.buildObjectOnboarding(_this.steps));

            _this.ngIntroService.onExit(function () {
              if (!_this.isTutorialBuscaRegiao) {
                _this.window.location.href = '/direcao-segura?vfiltro=limpar-vfiltro:true';
              }
            });

            _this.ngIntroService.onChange(function (element) {
              _this.controlarFiltroHeader(element);
            });

            _this.ngIntroService.onAfterChange(function (element) {
              if (_this.isTutorialBuscaRegiao && _this.ngIntroService.intro._currentStep !== 0) {
                _this.emitEvent();
              }

              var ele = angular.element(element);
              _this.controlarSortTable(ele);
              _this.controlarColunaVeiculo(ele);
            });

            _this.timeout(function () {
              _this.ngIntroService.start();
              if (_this.isTutorialBuscaRegiao) {
                angular.element('.introjs-fixParent').removeClass('introjs-fixParent');
                _this.adjustButtonsForBuscaRegiao();
              }
            }, 1000);
          });
          return true;
        }
        return false;
      }
    }, {
      key: 'adjustButtonsForBuscaRegiao',
      value: function adjustButtonsForBuscaRegiao() {
        var _this2 = this;

        /*eslint-disable*/
        var introModal = document.querySelector('.introjs-tooltip'),
            prevButton = document.querySelector('.introjs-prevbutton'),
            nextButton = document.querySelector('.introjs-nextbutton'),
            exitButton = document.querySelector('.introjs-skipbutton'),
            doneButton = document.querySelector('.introjs-donebutton'),
            tooltipbuttons = document.querySelector('.introjs-tooltipbuttons'),
            introTexto = document.querySelector('.introjs-tooltiptext'),
            cookiesBar = document.querySelector('#cookies-bar'),
            progresso = document.createElement('p'),
            progressoTexto = document.createTextNode(this.steps[0].stepIndex + '/' + this.stepsLengthTotal),
            closeButton = document.createElement('button'),
            closeTexto = document.createTextNode('×');
        /*eslint-enable*/

        if (prevButton && nextButton && exitButton && tooltipbuttons && introTexto) {
          prevButton.style.display = 'none';
          exitButton.style.display = 'none';
          nextButton.style.padding = '0px';
        }

        if (introModal && introTexto) {
          introTexto.style.display = 'inline-block';
          introTexto.style.width = '95%';
          introTexto.firstChild.style.marginTop = '0';
          closeButton.className = 'btn-close';
          closeButton.onclick = function () {
            _this2.ngIntroService.onExit(function () {
              _this2.window.close();
            });
            _this2.ngIntroService.exit();
          };
          closeButton.appendChild(closeTexto);
          introModal.insertBefore(closeButton, introModal.firstChild.nextSibling);
        }

        if (doneButton) {
          doneButton.style.padding = '0px';
          doneButton.innerHTML = '<button type="button" class="finalizar-button">FINALIZAR</button>';
        }

        if (tooltipbuttons) {
          progresso.style.display = 'inline-block';
          progresso.style.marginRight = '60%';
          progresso.appendChild(progressoTexto);
          tooltipbuttons.insertBefore(progresso, tooltipbuttons.firstChild);
        }

        if (cookiesBar) {
          cookiesBar.style.display = 'none';
        }
      }
    }, {
      key: 'emitEvent',
      value: function emitEvent() {
        var _this3 = this;

        switch (this.steps[0].stepIndex) {
          case 1:
            this.rootScope.$broadcast('toggle-drawer');
            this.resetOnboarding();
            break;
          case 2:
            this.rootScope.$broadcast('clica-busca-regiao');
            this.resetOnboarding();
            break;
          case 3:
            this.rootScope.$broadcast('desenha-area');
            this.resetOnboarding();
            break;
          case 4:
            this.rootScope.$broadcast('data-busca-regiao');
            this.resetOnboarding();
            break;
          case 5:
            this.rootScope.$broadcast('busca-por-regiao');
            this.resetOnboarding();
            break;
          case 6:
            this.rootScope.$broadcast('buscar-veiculo');
            this.resetOnboarding();
            this.ngIntroService.onExit(function () {
              _this3.window.localStorage.setItem('tutorial-busca-regiao', false);
              _this3.window.close();
            });
            break;
          default:
            break;
        }
      }
    }, {
      key: 'resetOnboarding',
      value: function resetOnboarding() {
        var _this4 = this;

        this.ngIntroService.exit();
        this.timeout(function () {
          _this4.steps.shift();
          var remainingSteps = _this4.steps;
          _this4.ngIntroService.setOptions(_this4.buildObjectOnboarding(remainingSteps));
          _this4.ngIntroService.start();
          angular.element('.introjs-fixParent').removeClass('introjs-fixParent');
          _this4.adjustButtonsForBuscaRegiao();
        }, 500);
      }
    }, {
      key: 'controlarFiltroHeader',
      value: function controlarFiltroHeader(element) {
        if (element.id === 'vfiltro') {
          angular.element('body').css('overflow-y', 'hidden');
        } else {
          angular.element('body').css('overflow-y', 'auto');
        }
      }
    }, {
      key: 'controlarSortTable',
      value: function controlarSortTable(element) {
        if (element.hasClass('st-sort-descent') || element.hasClass('td-detalhes')) {
          var elementTable = angular.element('.table-responsive'),
              offsetElement = element.offset().left,
              paddingIntro = element.hasClass('last-item') ? -8 : 15,
              paddingElemento = 8,
              distanciaScroll = offsetElement - elementTable.width() + paddingIntro;
          var distanciaIntro = offsetElement - paddingElemento;

          if (distanciaScroll > 0) {
            distanciaIntro = offsetElement - distanciaScroll - paddingElemento;
            elementTable.animate({ scrollLeft: distanciaScroll });
          }

          angular.element('.introjs-helperLayer').css('left', distanciaIntro + 'px');
          angular.element('.introjs-tooltipReferenceLayer').css('left', distanciaIntro + 'px');
        }
      }
    }, {
      key: 'controlarColunaVeiculo',
      value: function controlarColunaVeiculo(element) {
        if (element.hasClass('column-veiculos')) {
          angular.element('.table-responsive').animate({ scrollLeft: 0 });
        }
      }
    }]);

    return Onboarding;
  }();

  angular.module('onboarding', ['ui.router', 'angular-intro', 'httpServiceV3gModule', 'restangular', 'confluenceID']).service('Onboarding', Onboarding);
})();
'use strict';

(function () {
  'use strict';

  angular.module('mapasGrid').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.mapasGrid', {
      url: '/mapas-grid?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'mapas-grid/mapas-grid.tpl.html',
          controller: 'MapasGridCtrl',
          controllerAs: 'mapasGrid'
        }
      },
      data: {
        titulo: 'ce.mapa.localizacaoDaFrota.titulo',
        hideTitulo: true,
        role: 'LOCALIZACAO_ATUAL_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-var */

(function () {
  'use strict';
  /* global L, Intl, _, document */

  var MapasGridCtrl = function () {
    function MapasGridCtrl($scope, $filter, $interval, $location, $rootScope, $sce, $state, MapasUtil, GoogleTagManagerUtils, moment, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, StatusVeiculo, blockUI, VtabelaFactory, uiGridConstants, VpopupService, leafletData, $uibModal, AlertMessage, $httpParamSerializer, VeiculoStatusEnum, $translate, PontosReferenciaMenu, Ocorrencias, $window, Uos, $q, MockGetStatusVeiculo, UrlConfigService, Authenticator, LanguagesEnum, ConvertersService, FeaturehubJsSdk, FeatureHubConfigKeys, FeatureOuService, PermanenciaRealtime, UrlService, UoHelperService) {
      var _this = this;

      _classCallCheck(this, MapasGridCtrl);

      this.httpParamSerializer = $httpParamSerializer;
      this.sce = $sce;
      this.scope = $scope;
      this.filter = $filter;
      this.location = $location;
      this.rootScope = $rootScope;
      this.intervalService = $interval;
      this.state = $state;
      this.moment = moment;
      this.mapasUtil = MapasUtil;
      this.mapasUtil.init();
      this.leafletData = leafletData;
      this.statusVeiculoService = StatusVeiculo;
      this.permanenciaRealtime = PermanenciaRealtime;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.blockUI = blockUI;
      this.vtabelaFactory = VtabelaFactory;
      this.uiGridConstants = uiGridConstants;
      this.vpopupService = VpopupService;
      this.modalService = $uibModal;
      this.alertMessage = AlertMessage;
      this.veiculoStatusEnum = VeiculoStatusEnum;
      this.translate = $translate;
      this.pontosReferenciaMenu = PontosReferenciaMenu;

      this.flagExceededPermanencia = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_EXCEEDED_PERMANENCIA_REALTIME);
      this.flagCafezinho = FeaturehubJsSdk.isFeatureEnabled('LAINT42_cafezinho_screen');
      this.flagUseMainSemaphoreStatus = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DEVICE_HEALTH_TELEMATICS_TABLE);
      this.flagRouteProgressCard = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROUTE_PROGRESS_CARD);
      this.exibicao = true;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.q = $q;
      this.mockStatusVeiculo = MockGetStatusVeiculo;
      this.urlConfigService = UrlConfigService;
      this.authenticator = Authenticator;
      this.languagesEnum = LanguagesEnum;
      this.convertersService = ConvertersService;
      this.vtabela = null;
      this.showLoad = true;
      this.map = null;
      this.trusted = {};
      this.limitVeiculosEnvioComando = 100;
      this.fraseErro = this.translate.instant('ce.mapa.localizacaoDaFrota.fraseErro') + '\n         <a href="http://suporte.onps.com/" target="_blank">\n          ' + this.translate.instant('ce.mapa.localizacaoDaFrota.fraseErroLink') + '\n         </a>';
      this.fraseTooltip = this.translate.instant('ce.mapa.localizacaoDaFrota.fraseTooltip') + ' <strong>' + this.translate.instant('ce.mapa.localizacaoDaFrota.movimento') + '.</strong>';
      this.tooltipDisabledMenuComando = this.translate.instant('ce.mapa.localizacaoDaFrota.disableTooltipMenuComando', { qtd: this.limitVeiculosEnvioComando });
      this.statusVeiculos = null;
      this.statusVeiculosTable = null;
      this.filtroPontoReferencia = null;
      this.markersCluster = null;
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.ocorrenciaService = Ocorrencias;
      this.possuiOcorrencia = {
        LABEL: this.translate.instant('ce.mapa.localizacaoDaFrota.colunas.ocorrencias'),
        SIM: this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.sim'),
        NAO: this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.nao')
      };
      this.duoSimNao = {
        SIM: this.translate.instant('ce.mapa.localizacaoDaFrota.duo.sim'),
        NAO: this.translate.instant('ce.mapa.localizacaoDaFrota.duo.nao')
      };
      this.semaphoreVideo = {
        LABEL: this.translate.instant('ce.mapa.localizacaoDaFrota.colunas.saudeDoVeiculo'),
        RELEASED: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.labels.liberado'),
        REQUIRES_ATTENTION: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.labels.requerAtencao'),
        EVALUATE_URGENTLY: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.labels.avaliarUrgente'),
        INDETERMINATE: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.labels.indeterminado')
      };
      this.semaphoreVideoTooltip = {
        CONNECTION: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.tooltipInfos.conexao'),
        BEHAVIOR_EVENT: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.tooltipInfos.eventoComportamento'),
        VIDEO: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.tooltipInfos.video'),
        PHOTOS: this.translate.instant('ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.tooltipInfos.fotos'),
        SDCARD: 'SD Card'
      };
      this.FIELDS_OCORR_LOC_FROTA = ['id', 'veiculoId', 'dataHora'];
      this.LIVESTREAM_OPTIONS = {
        NA: 'NOT_APPLICABLE',
        VMOV_ONLINE: 'VMOV_ONLINE',
        VMOV_OFFLINE: 'VMOV_OFFLINE'
      };
      this.window = $window;
      this.isDemo = this.location.search().demo;
      Uos.isDemo = this.isDemo;
      this.exibicao = !this.isDemo;
      this.showVideoSemaphoreStatus = true;
      this.verifyMapLayers();

      this.isPopupOpen = false;

      this.leafletData.unresolveMap('mapaPrincipal');
      this.setMapConfig();
      this.setMapEvents();
      this.FeatureOuService = FeatureOuService;
      this.leafletData.getMap('mapaPrincipal').then(function (map) {
        ServiceVfiltro.init(FactoryVfiltro.get([{
          name: 'uoId',
          key: _this.keys.uo.name
        }, {
          name: 'uoParceiraId',
          key: _this.keys.uoParceira.name,
          size: 6
        }, {
          name: 'veiculosId',
          key: _this.keys.veiculos.name,
          onlyStatus: ['LIBERADO', 'EM TESTE'],
          size: 6
        }])).then(function (vfiltro) {
          _this.vfiltro = vfiltro;
          _this.map = map;
          _this.uoId = _this.serviceVfiltro.factoryVfiltro.filtroUrl.uo;
          _this.mapasUtil.setCurrentUoId(_this.uoId);
          _this.permissaoComandoEditar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('COMANDO_EDITAR');
          _this.permissaoComandoVisualizar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('COMANDO_VISUALIZAR');
          _this.permissaoOcorrenciasVisualizar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('OCORRENCIA_VISUALIZAR');
          _this.permissaoLivestreamVisualizar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('VPLAYER_LIVESTREAM_VISUALIZAR');
          _this.scope.$broadcast('initPontoReferencia', map);

          _this.setMomentLocale();

          _this.authenticator.getUser().then(function (user) {
            _this.user = user;
            _this.FeatureOuService.getVehicleTableConfig(user.uo.id).then(function (isNaUser) {
              _this.isNaUser = isNaUser;
              _this.showVideoSemaphoreStatus = !_this.isNaUser;
              _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'mapasGrid', 'v5');

              _this.init();
            });
          });

          _this.scope.$on('onRegisterApi', function () {
            _this.stateVtabelaControl();
            _this.scope.selectAllVtabela = _this.vtabela.gridApi.grid.selection.selectAll;
          });
        }).catch(function () {
          _this.leafletData.unresolveMap('mapaPrincipal');
        });
      });

      this.scope.$on('$destroy', function () {
        _this.leafletData.unresolveMap('mapaPrincipal');
      });
      this.rootScope.$on('openAdvisorList', function () {
        _this.exibicao = false;
      });

      this.authenticator.getUser().then(function (user) {
        _this.userMeasurementUnits = user.measurementUnits;
      });
      this.ONE_MINUTE = 60000;
      this.exceededPermanenciasByVehicle = {};

      this.urlService = UrlService;
      this.uoHelperService = UoHelperService;
      this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
      this.showMenu = this.queryParams.showMenu === 'false' ? false : true;
    }

    _createClass(MapasGridCtrl, [{
      key: 'toggleShowGrid',
      value: function toggleShowGrid() {
        this.exibicao = !this.exibicao;
      }
    }, {
      key: 'init',
      value: function init() {
        var idPontoUrl = this.location.search().ponto;
        if (idPontoUrl) {
          this.filtroPontoReferencia = idPontoUrl;
        }
        this.getPermanenciasByPermission();
        if (!this.isRootUser(this.serviceVfiltro.factoryVfiltro.user)) {
          this.loadStatusVeiculo();
        }
      }
    }, {
      key: 'getClusterPointSize',
      value: function getClusterPointSize(numeroDeElementos) {
        if (numeroDeElementos < 10) {
          return 45;
        }
        if (numeroDeElementos < 100) {
          return 50;
        }
        return 55;
      }
    }, {
      key: 'getClusterLabelSize',
      value: function getClusterLabelSize(numeroDeElementos) {
        if (numeroDeElementos < 10) {
          return 'small';
        }
        if (numeroDeElementos < 100) {
          return 'medium';
        }
        return 'large';
      }
    }, {
      key: 'temStatus',
      value: function temStatus() {
        for (var i = 0; i < this.statusVeiculosTable.length; i++) {
          if (angular.isDefined(this.statusVeiculosTable[i].status)) {
            return true;
          }
        }
        return false;
      }
    }, {
      key: 'setMapConfig',
      value: function setMapConfig() {
        this.tiles = this.mapasUtil.tiles.veltec;
        this.defaults = this.mapasUtil.defaults;
        this.center = this.mapasUtil.getMapCenterByTimezone(this.currentTimezone);
        this.markers = {};
        this.geoJson = {};
      }
    }, {
      key: 'setMapEvents',
      value: function setMapEvents() {
        angular.extend(this.scope, {
          events: {
            map: {
              enable: ['click', 'resize'],
              logic: 'emit'
            },
            markers: {
              enable: ['click'],
              logic: 'emit'
            }
          }
        });
      }
    }, {
      key: 'loadStatusVeiculo',
      value: function loadStatusVeiculo(timer) {
        var _this2 = this;

        if (this.showLoad) {
          this.blockUI.start();
        }
        this.getStatusVeiculo().then(function (data) {
          var itens = data.map(function (item) {
            return _this2.enrichStatusVeiculo(item);
          });
          if (_this2.showLoad) {
            _this2.blockUI.stop();
          }
          _this2.statusVeiculosTable = itens;
          _this2.statusVeiculos = [].concat(itens);
          if ((_this2.showLoad || !timer) && !_this2.isDemo) {
            _this2.setCenter();
            _this2.setTimer();
            _this2.showLoad = false;
          }
          if (_this2.permissaoOcorrenciasVisualizar && !_this2.isDemo) {
            _this2.ocorrenciaService.getOcorrenciasNovaLocFrota(_this2.serviceVfiltro.getFiltroBackendNovo(_this2.vfiltro), _this2.FIELDS_OCORR_LOC_FROTA).then(function (ocorrenciasNovas) {
              _this2.addOcorrenciaNovaPropertiesToTableItem(itens, ocorrenciasNovas.data);
              _this2.setInfoTable(itens);
              _this2.markers = {};
              _this2.setMarkers();
            });
          } else {
            _this2.setInfoTable(itens);
            _this2.markers = {};
            _this2.setMarkers();
          }
        }).catch(function (error) {
          if (_this2.flagCafezinho) {
            if (error && error.status === 500) {
              _this2.state.go('unprotected.errorPage', {
                lastPage: _this2.window.location.pathname
              });
            }
          } else {
            _this2.state.go('unprotected.errorPage', {
              lastPage: _this2.window.location.pathname
            });
          }
        });
      }
    }, {
      key: 'enrichStatusVeiculo',
      value: function enrichStatusVeiculo(item) {
        if (!this.isNa()) {
          if (this.flagUseMainSemaphoreStatus && item.videoVitalSigns) {
            item.videoVitalSigns.videoSemaphoreStatus = item.videoVitalSigns.mainSemaphoreStatus;
          }
          item.exceededPermanencia = this.getIsExceededPermanencia(item.vei);
        }
        return angular.extend(item, { pontoRefProx: this.setPontoReferencia(item.pontoProximo) });
      }
    }, {
      key: 'refreshOpenPopup',
      value: function refreshOpenPopup() {
        var _this3 = this;

        var openPopup = this.openPopup;
        if (!openPopup) {
          return;
        }
        this.getStatusVeiculo().then(function (data) {
          var isPopupStillOpen = _this3.openPopup === openPopup;
          var latestStatusOfVehicle = data.find(function (item) {
            return item.vei === openPopup.vei;
          });
          if (isPopupStillOpen && latestStatusOfVehicle) {
            var _openPopup$posicao = openPopup.posicao,
                ocorrenciasNovasDoVeiculo = _openPopup$posicao.ocorrenciasNovasDoVeiculo,
                veiculoHasOcorrenciaNova = _openPopup$posicao.veiculoHasOcorrenciaNova,
                veiculoOcorrenciaNovaMaisRecente = _openPopup$posicao.veiculoOcorrenciaNovaMaisRecente;

            openPopup.posicao = angular.extend(_this3.enrichStatusVeiculo(latestStatusOfVehicle), {
              ocorrenciasNovasDoVeiculo: ocorrenciasNovasDoVeiculo, veiculoHasOcorrenciaNova: veiculoHasOcorrenciaNova, veiculoOcorrenciaNovaMaisRecente: veiculoOcorrenciaNovaMaisRecente
            });
            _this3.vpopupService.refreshVeiculoElement(openPopup.element, openPopup.posicao);
          }
        }).catch(angular.noop);
      }
    }, {
      key: 'getStatusVeiculo',
      value: function getStatusVeiculo() {
        var _this4 = this;

        if (this.isDemo) {
          return this.q(function (resolve) {
            return resolve(_this4.mockStatusVeiculo);
          });
        }
        var params = _.cloneDeep(this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar));
        params.forcaObjetoReduzido = false;
        params.isTelemetryEnabled = !this.isNa();
        params.includeVideoVitalSigns = this.showVideoSemaphoreStatus;
        return this.statusVeiculoService.one().get(params);
      }
    }, {
      key: 'addOcorrenciaNovaPropertiesToTableItem',
      value: function addOcorrenciaNovaPropertiesToTableItem(data, ocorrenciasNovas) {
        var _this5 = this;

        data.forEach(function (tableItem) {
          tableItem.ocorrenciasNovasDoVeiculo = ocorrenciasNovas.filter(function (ocorrencia) {
            return ocorrencia.veiculoId === tableItem.vei;
          });
          tableItem.veiculoHasOcorrenciaNova = _this5.veiculoHasOcorrenciaNova(tableItem.ocorrenciasNovasDoVeiculo, tableItem.vei);
          tableItem.veiculoOcorrenciaNovaMaisRecente = _this5.getVeiculoOcorrenciaNovaMaisRecente(tableItem.ocorrenciasNovasDoVeiculo);
        });
      }
    }, {
      key: 'getVeiculoOcorrenciaNovaMaisRecente',
      value: function getVeiculoOcorrenciaNovaMaisRecente(ocorrenciasNovasDoVeiculo) {
        if (ocorrenciasNovasDoVeiculo.length > 1) {
          var ocorrenciaNovaMaisRecente = ocorrenciasNovasDoVeiculo.reduce(function (acc, atual) {
            return new Date(acc.dataHora) > new Date(atual.dataHora) ? acc : atual;
          });
          return ocorrenciaNovaMaisRecente;
        }
        return ocorrenciasNovasDoVeiculo[0];
      }
    }, {
      key: 'veiculoHasOcorrenciaNova',
      value: function veiculoHasOcorrenciaNova(ocorrenciasNovasDoVeiculo, veiculoId) {
        return ocorrenciasNovasDoVeiculo.some(function (ocorrenciaNova) {
          return ocorrenciaNova.veiculoId === veiculoId;
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this6 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this6.getItemVtabela(i);
        }));
      }
    }, {
      key: 'stateVtabelaControl',
      value: function stateVtabelaControl() {
        var _this7 = this;

        this.vtabela.gridApi.core.on.rowsRendered(null, function () {
          _this7.selecionaRows();
          _this7.setSelectAll();
        });

        this.vtabela.gridApi.selection.on.rowFocusChanged(null, function () {
          _this7.getSelectAll();
        });

        this.vtabela.gridApi.selection.on.rowSelectionChangedBatch(null, function () {
          _this7.getSelectAll();
        });

        this.vtabela.gridApi.selection.on.rowSelectionChanged(null, function () {
          _this7.getSelectAll();
        });
      }
    }, {
      key: 'selecionaRows',
      value: function selecionaRows() {
        var _this8 = this;

        this.vtabela.gridApi.grid.rows.map(function (row) {
          if (_this8.vtabela.rowsSelected.map(function (rowSelect) {
            return rowSelect.veiculoId;
          }).includes(row.entity.veiculoId)) {
            row.setSelected(true);
          }
        });
      }
    }, {
      key: 'getSelectAll',
      value: function getSelectAll() {
        this.vtabela.lastSelectAll = angular.copy(this.vtabela.gridApi.grid.selection.selectAll);
      }
    }, {
      key: 'navegaHistComando',
      value: function navegaHistComando(veiculoIds) {
        this.location.url('/relatorios/historico-comando?vfiltro=dateTime:hoje;uo:' + this.uoId + ';veiculos:' + veiculoIds);
      }
    }, {
      key: 'goHistComandos',
      value: function goHistComandos() {
        if (this.vtabela.rowsSelected.length <= 100) {
          var veiculoIds = this.vtabela.rowsSelected.map(function (row) {
            return row.veiculoId;
          }).join();
          this.navegaHistComando(veiculoIds);
        } else {
          this.openModalMaxSelected();
        }
      }
    }, {
      key: 'openModalMaxSelected',
      value: function openModalMaxSelected() {
        var _this9 = this;

        this.modalService.open({
          animation: true,
          templateUrl: 'mapas-grid/modal-select/modal-select.tpl.html',
          windowTopClass: 'modal-localizacao-frota',
          controller: 'ModalSelectCtrl',
          controllerAs: '$ctrl'
        }).result.then(function () {
          var veiculoIds = _this9.vtabela.rowsSelected.slice(0, 100).map(function (row) {
            return row.veiculoId;
          }).join();
          _this9.navegaHistComando(veiculoIds);
        });
      }
    }, {
      key: 'setSelectAll',
      value: function setSelectAll() {
        this.vtabela.gridApi.grid.selection.selectAll = angular.copy(this.vtabela.lastSelectAll);
      }
    }, {
      key: 'handleSpeedCellFormater',
      value: function handleSpeedCellFormater(value) {
        var distanceUnit = this.userMeasurementUnits.distanceMeasurement;

        if (distanceUnit === 'MILES') {
          var convertedValue = this.convertersService.handleKmToMiles(value);
          return convertedValue + ' mph';
        }
        return value + ' Km/h';
      }
    }, {
      key: 'handleOdometerLabel',
      value: function handleOdometerLabel() {
        var distanceUnit = this.userMeasurementUnits.distanceMeasurement;

        return 'decimalWithLabel:' + (distanceUnit === 'MILES' ? '\'mi\'' : '\'Km\'');
      }
    }, {
      key: 'handledateTimeCellFormater',
      value: function handledateTimeCellFormater() {
        var dateTimeFormat = this.userMeasurementUnits.dateTimeFormat;

        return 'date:\'' + (dateTimeFormat === 'AMERICAN' ? 'MM/dd/yyyy HH:mm:ss' : 'dd/MM/yyyy HH:mm:ss') + '\'';
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          appScopeProvider: this,
          exportsCsv: true,
          columnDefs: [{
            name: 'vehicleId',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.vehicleId',
            filterCellFiltered: true,
            enableHiding: true,
            visible: false
          }, {
            name: 'uoNome',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.uo',
            type: 'string',
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'grupoNome',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.grupoDeVeiculo',
            type: 'string',
            visible: !this.isNaUser,
            filterCellFiltered: true
          }, {
            name: 'motNome',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.motorista',
            type: 'string',
            cellFilter: 'withLabelToUndefined:\'ce.common.motorista.semIdentificacao\' | translate | splitComposedLabels:true',
            filterCellFiltered: true,
            headerCellFilter: 'translate',
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents\'>\n                    <motorista-link\n                      motorista-id=\'row.entity.motId\'\n                      motorista=\'row.entity.motNome\'\n                      has-permission=\'row.entity.hasPermissionDriver\'\n                      index=\'$index\'>\n                    </motorista-link>\n                  </div>\n                '
          }, {
            name: 'veiculo',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.veiculo',
            enableHiding: false,
            filterCellFiltered: true,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title="{{row.entity.veiculo}}">\n                <a class="cell-veiculo" ng-click=\'grid.appScope.setFocus(row.entity.veiculoId)\'>\n                  {{row.entity.veiculo}}\n                </a>\n                <span ng-if=\'!grid.appScope.roleVisualizarBdv || !row.entity.veiculos || !row.entity.linkBdv\'> {{row.entity.veiculos}} </span>\n              </div>\n              '
          }, {
            name: 'status',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.status',
            cellClass: 'text-center',
            filterCellFiltered: true,
            width: 115,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\'>\n                <span title="{{ row.entity.status | translate }}" class="icone-esquerda">\n                  {{ row.entity.status | translate }}\n                </span>\n                <span\n                  class="fa fa-info-circle text-blue margin-right-info"\n                  ng-if=\'grid.appScope.verificaMovimentoVelocidadeZero(row.entity)\'\n                  uib-tooltip-html="grid.appScope.setPopoverContent(grid.appScope.fraseTooltip)"\n                  tooltip-placement="top">\n                </span>\n                <span\n                  class="fa fa-wrench text-blue"\n                  ng-if="grid.appScope.isInTest(row.entity)"\n                  uib-tooltip-html=\'grid.appScope.setPopoverContent("' + this.translate.instant('ce.mapa.localizacaoDaFrota.veiculoEmManuntencao') + '")\'\n                  tooltip-placement="top">\n                </span>\n              </div>\n              '
          }, {
            name: 'vel',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.velocidade',
            cellTemplate: '\n                <div class="ui-grid-cell-contents">\n                  {{grid.appScope.handleSpeedCellFormater(row.entity.vel)}}\n                </div>\n              ',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'hodo',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.hodometro',
            cellClass: 'text-center',
            cellFilter: this.handleOdometerLabel(),
            filterCellFiltered: true,
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\'>\n                <span title="{{row.entity.hodo | ' + this.handleOdometerLabel() + ' }}" class="icone-esquerda">{{row.entity.hodo | ' + this.handleOdometerLabel() + ' }}</span>\n                <span\n                  class="fa fa-info-circle text-blue"\n                  ng-if=\'grid.appScope.isRedeSat(row.entity)\'\n                  uib-tooltip-html=\'grid.appScope.setPopoverContent("' + this.translate.instant('ce.mapa.localizacaoDaFrota.tooltipHodometro') + '")\'\n                  tooltip-placement="top">\n                </span>\n              </div>\n              '
          }, {
            name: 'data',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.dataHora',
            cellFilter: this.handledateTimeCellFormater(),
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'bloqueioPartida',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.bloqueio',
            cellClass: 'text-center',
            visible: !this.isNaUser,
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: true, label: this.translate.instant('ce.mapa.localizacaoDaFrota.bloqueado') }, { value: false, label: this.translate.instant('ce.mapa.localizacaoDaFrota.desbloqueado') }]
            },
            width: 100,
            cellTemplate: '\n              <div class="ui-grid-cell-contents">\n                <span\n                  class="fv trimble-locked red icon-bloqueio"\n                  title="{{ \'ce.mapa.localizacaoDaFrota.bloqueado\' | translate }}"\n                  ng-if=\'row.entity.bloqueioPartida\'>\n                </span>\n                <span\n                 class="fv trimble-unlocked green icon-bloqueio"\n                 title="{{ \'ce.mapa.localizacaoDaFrota.desbloqueado\' | translate }}"\n                 ng-if=\'row.entity.bloqueioPartida === false\'>\n                </span>\n                <span ng-if=\'row.entity.bloqueioPartida === undefined\'>\n                  {{ \'ce.mapa.localizacaoDaFrota.undefined\' | translate }}\n                </span>\n              </div>\n              '
          }, {
            name: 'gsmSearch',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.gsm',
            cellClass: 'text-center',
            type: 'string',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: 'ON', label: this.translate.instant('ce.mapa.common.gsmOnline') }, { value: 'OFF', label: this.translate.instant('ce.mapa.common.gsmOffline') }, { value: 'SAT', label: this.translate.instant('ce.mapa.common.gsmSatelital') }]
            },
            width: 100,
            cellTemplate: '\n              <div class="ui-grid-cell-contents">\n                <span class="{{grid.appScope.getRede(row.entity).style}}"\n                  aria-hidden=\'true\'\n                  title=\'{{ grid.appScope.setPopoverContent(grid.appScope.getRede(row.entity).label) | translate }}\'>\n                </span>\n              </div>\n              '
          }, {
            name: 'statusGps',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.precisao',
            cellClass: 'text-center',
            type: 'boolean',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: true, label: this.translate.instant('ce.mapa.localizacaoDaFrota.gpsAltaPrecisao') }, { value: false, label: this.translate.instant('ce.mapa.localizacaoDaFrota.gpsBaixaPrecisao') }]
            },
            width: 100,
            cellTemplate: '\n              <div class="ui-grid-cell-contents">\n                <span\n                  ng-if=\'!row.entity.statusGps\'\n                  class="fv trimble-help v3g-text-alt-red circulo-precisao-red"\n                  aria-hidden=\'true\'\n                  uib-popover-html="grid.appScope.setPopoverContent(grid.appScope.fraseErro)"\n                  popover-title="{{ \'ce.mapa.localizacaoDaFrota.gpsBaixaPrecisao\' | translate }}"\n                  popover-trigger="\'focus\'"\n                  popover-placement="top"\n                  tabindex="0"\n                  title="{{ \'ce.mapa.localizacaoDaFrota.gpsBaixaPrecisao\' | translate }}">\n                </span>\n                <span\n                  ng-if=\'row.entity.statusGps\'\n                  class="circulo-precisao-blue"\n                  title="{{ \'ce.mapa.localizacaoDaFrota.gpsAltaPrecisao\' | translate }}">\n                </span>\n              </div>\n              '
          }, {
            name: 'videoSemaphoreStatus',
            field: 'videoSemaphoreStatus.id',
            displayName: this.semaphoreVideo.LABEL,
            type: 'string',
            cellClass: 'text-left',
            filterCellFiltered: true,
            visible: this.showVideoSemaphoreStatus,
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: 'RELEASED', label: this.semaphoreVideo.RELEASED }, { value: 'REQUIRES_ATTENTION', label: this.semaphoreVideo.REQUIRES_ATTENTION }, { value: 'EVALUATE_URGENTLY', label: this.semaphoreVideo.EVALUATE_URGENTLY }, { value: 'INDETERMINATE', label: this.semaphoreVideo.INDETERMINATE }]
            },
            width: 160,
            cellTemplate: '\n              <div class="ui-grid-cell-contents vehicle-health-field">\n                <span\n                  class="underline"\n                  ng-if="row.entity.videoSemaphoreStatus.id !== \'INDETERMINATE\'"\n                  uib-tooltip-html=\'grid.appScope.getVideoEventsTooltip(row.entity.videoVitalSignsEvents, row.entity.hasPremiumTelemetry)\'\n                  tooltip-class="tooltip-health-vehicle"\n                  tooltip-placement="right"\n                  >\n                  <div>\n                    <p>\n                      <span class="{{row.entity.videoSemaphoreStatus.style}}"></span>\n                      <a ng-click=\'grid.appScope.setFocus(row.entity.veiculoId, true)\'>\n                        {{row.entity.videoSemaphoreStatus.label}}\n                      </a>\n                    </p>\n                  </div>\n                </span>\n                <span class="stream-text-color" ng-if="row.entity.videoSemaphoreStatus.id === \'INDETERMINATE\'">\n                  <div>\n                    <span class="{{row.entity.videoSemaphoreStatus.style}}"></span>\n                    {{row.entity.videoSemaphoreStatus.label}}\n                  </div>\n                </span>\n              </div>\n              '
          }, {
            name: 'logra',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.logradouro',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'local',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.localizacao',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'pontoRefProx',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.pontoDeRef',
            cellClass: 'text-center',
            filterCellFiltered: true,
            visible: !this.isNaUser
          }, {
            name: 'exceededPermanencia',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.exceededPermanencia',
            cellClass: 'text-center',
            filterCellFiltered: true,
            headerCellFilter: 'translate',
            visible: this.flagExceededPermanencia && !this.isNa()
          }, {
            name: 'latLng',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.latLong',
            filterCellFiltered: true,
            visible: false
          }, {
            name: 'motApel',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.apelido',
            filterCellFiltered: true,
            visible: !this.isNaUser
          }, {
            name: 'motTel',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.telefoneMotorista',
            filterCellFiltered: true,
            visible: !this.isNaUser
          }] };

        if (this.permissaoOcorrenciasVisualizar) {
          var colunaOcorrencia = {
            name: 'possuiOcorrencia',
            displayName: this.possuiOcorrencia.LABEL,
            type: 'boolean',
            cellClass: 'text-center',
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.EXACT,
              selectOptions: [{ value: true, label: this.possuiOcorrencia.SIM }, { value: false, label: this.possuiOcorrencia.NAO }]
            },
            cellTemplate: '\n              <span\n                ng-if=\'row.entity.possuiOcorrencia\'\n                class="vertical-correction underline">\n                <div>\n                  <a ng-click=\'grid.appScope.goToQuadroOcorrenciasWithLocalStorageSet(row.entity.veiculoOcorrenciaNovaMaisRecente.id)\'>\n                    ' + this.possuiOcorrencia.SIM + '\n                  </a>\n                </div>\n              </span>\n              <span\n                ng-if=\'!row.entity.possuiOcorrencia\'\n                class="vertical-correction">\n                <div>' + this.possuiOcorrencia.NAO + '</div>\n              </span>\n              '
          },
              indiceSituacaoVeiculo = 13;
          objVtabela.columnDefs.splice(indiceSituacaoVeiculo, 0, colunaOcorrencia);
        }

        if (this.permissaoLivestreamVisualizar) {
          var colunaLivestream = {
            name: 'livestream',
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.cameraAoVivo',
            type: 'string',
            cellClass: 'text-left',
            filterCellFiltered: true,
            filter: {
              type: this.uiGridConstants.filter.SELECT,
              condition: this.uiGridConstants.filter.STARTS_WITH,
              selectOptions: [{ value: this.LIVESTREAM_OPTIONS.VMOV_ONLINE, label: this.translate.instant('ce.mapa.localizacaoDaFrota.livestream.aoVivo') }, { value: this.LIVESTREAM_OPTIONS.VMOV_OFFLINE, label: this.translate.instant('ce.mapa.localizacaoDaFrota.livestream.offline') }, { value: this.LIVESTREAM_OPTIONS.NA, label: this.translate.instant('ce.mapa.localizacaoDaFrota.undefined') }]
            },
            width: 125,
            cellTemplate: '\n              <div class="ui-grid-cell-contents">\n                <span ng-if=\'row.entity.livestream === grid.appScope.LIVESTREAM_OPTIONS.NA\'\n                  class=\'stream-text-color\'>\n                  <span class="dot-stream"></span> {{ \'ce.mapa.localizacaoDaFrota.undefined\' | translate }}\n                </span>\n                <span\n                  ng-if=\'row.entity.livestream === grid.appScope.LIVESTREAM_OPTIONS.VMOV_OFFLINE\'\n                  class=\'stream-text-color\'\n                  title="{{ row.entity.vmovDate | date:\'dd/MM/yyyy HH:mm:ss\' }}"\n                >\n                  <span class="dot-stream"></span> {{ grid.appScope.getLastOnlineText(row.entity.vmovDate) }}\n                </span>\n                <span\n                  ng-if=\'row.entity.livestream === grid.appScope.LIVESTREAM_OPTIONS.VMOV_ONLINE && !row.entity.hasPremiumTelemetry\'\n                  class="underline"\n                >\n                  <div>\n                    <a ng-click=\'grid.appScope.openDialogVehicleHealth(row.entity.posicao, 2)\'>\n                      <span class="dot-stream online"></span> {{ \'ce.mapa.common.vpopupService.assistirTempoReal\' | translate }}\n                    </a>\n                  </div>\n                </span>\n              </div>\n              '
          },
              indiceStatusGps = 12;
          objVtabela.columnDefs.splice(indiceStatusGps, 0, colunaLivestream);
        }

        if (this.flagRouteProgressCard) {
          var _objVtabela$columnDef;

          (_objVtabela$columnDef = objVtabela.columnDefs).push.apply(_objVtabela$columnDef, _toConsumableArray(this.getDuoColumnDefs()));
        }

        return objVtabela;
      }
    }, {
      key: 'getDuoColumnDefs',
      value: function getDuoColumnDefs() {
        var _this10 = this;

        var textColumn = function textColumn(name) {
          return {
            name: name,
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.' + name,
            cellClass: 'text-center',
            filterCellFiltered: true
          };
        };
        var yesNoColumn = function yesNoColumn(name) {
          return {
            name: name,
            displayName: 'ce.mapa.localizacaoDaFrota.colunas.' + name,
            type: 'boolean',
            cellClass: 'text-center',
            filter: {
              type: _this10.uiGridConstants.filter.SELECT,
              condition: _this10.uiGridConstants.filter.EXACT,
              selectOptions: [{ value: true, label: _this10.duoSimNao.SIM }, { value: false, label: _this10.duoSimNao.NAO }]
            },
            cellTemplate: '\n          <div class="ui-grid-cell-contents text-center">\n            <span ng-if="row.entity.' + name + ' === true">' + _this10.duoSimNao.SIM + '</span>\n            <span ng-if="row.entity.' + name + ' === false">' + _this10.duoSimNao.NAO + '</span>\n          </div>\n        '
          };
        };

        return [textColumn('macroAtiva'), textColumn('rota'), yesNoColumn('atrasoRota'), yesNoColumn('desvioRota'), {
          name: 'tempoExecucaoRota',
          displayName: 'ce.mapa.localizacaoDaFrota.colunas.tempoExecucaoRota',
          type: 'number',
          cellClass: 'text-center',
          cellFilter: 'secondsToHHmm:\'\'',
          sortWithUndefinedValues: true,
          filterCellFiltered: true
        }];
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        var params = this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar);
        if (this.flagUseMainSemaphoreStatus) {
          params.isNa = this.isNa();
        }
        return params;
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        return '/sensor/status-veiculo/csv?' + this.httpParamSerializer(angular.extend(this.getParams(), { timezone: this.currentTimezone }));
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        var duo = item.duo || {};
        var duoMacro = duo.macro || {};
        var duoRoute = duo.route || {};
        var videoSemaphoreStatusConfig = this.getVideoSemaphoreStatusConfig(item.videoVitalSigns);
        if (item.videoVitalSigns) {
          item.videoVitalSigns.videoSemaphoreStatusConfig = videoSemaphoreStatusConfig;
        }

        return {
          vehicleId: item.vei,
          uoNome: item.uoNome,
          grupoNome: item.grupoNome,
          motId: item.motoristaId,
          motNome: item.motNome,
          motApel: item.motApel,
          motTel: item.motTel,
          veiculo: this.buildVeiculo(item.prefixo, item.placa),
          veiculoId: item.vei,
          status: this.getVeiculoStatusi18n(item.status),
          vel: item.vel,
          hodo: item.hodo,
          data: item.data,
          bloqueioPartida: item.bloqueioPartida,
          gsm: item.gsm,
          gsmSearch: this.getRede(item).id,
          statusGps: item.statusGps,
          logra: item.logra,
          local: item.local,
          pontoRefProx: item.pontoRefProx,
          exceededPermanencia: this.getIsExceededPermanencia(item.vei),
          placa: item.placa,
          meio: item.meio,
          situacaoVeiculo: item.situacaoVeiculo,
          latLng: item.lat + ', ' + item.lng,
          possuiOcorrencia: item.veiculoHasOcorrenciaNova,
          veiculoOcorrenciaNovaMaisRecente: item.veiculoOcorrenciaNovaMaisRecente,
          livestream: this.getLivestream(item),
          vmovDate: item.vmovDate,
          posicao: item.hasStream && item.vmovOnline ? item : null,
          videoSemaphoreStatus: videoSemaphoreStatusConfig,
          videoVitalSignsEvents: item.videoVitalSigns,
          hasPremiumTelemetry: item.hasPremiumTelemetry,
          hasPermissionDriver: item.hasPermissaoMotorista,
          macroAtiva: duoMacro.name,
          rota: duoRoute.name,
          atrasoRota: duoRoute.late,
          desvioRota: duoRoute.onDeviation,
          tempoExecucaoRota: duoRoute.executionTime
        };
      }
    }, {
      key: 'tooltipMsg',
      value: function tooltipMsg() {
        if (this.permissaoComandoEditar || this.permissaoComandoVisualizar) {
          return this.translate.instant('ce.mapa.localizacaoDaFrota.maisOpcoesTooltip');
        }
        return this.translate.instant('ce.mapa.localizacaoDaFrota.semPermissaoVeiculo');
      }
    }, {
      key: 'isMenuHabilitado',
      value: function isMenuHabilitado() {
        return (this.permissaoComandoEditar || this.permissaoComandoVisualizar) && this.vtabela.rowsSelected.length;
      }
    }, {
      key: 'modalEnviarComando',
      value: function modalEnviarComando() {
        var _this11 = this;

        var _veiculoIds = this.vtabela.rowsSelected.map(function (row) {
          return row.veiculoId;
        });
        if (_veiculoIds.length <= this.limitVeiculosEnvioComando) {
          this.modalService.open({
            animation: true,
            templateUrl: 'mapas-grid/envio-comando/envio-comando.tpl.html',
            controller: 'EnviarComandoCtrl',
            controllerAs: '$ctrl',
            windowTopClass: 'modal-localizacao-frota',
            resolve: {
              veiculoIds: function veiculoIds() {
                return _veiculoIds;
              }
            }
          }).result.then(function (data) {
            var alert = {
              message: data.msg,
              appendTo: '.alerta-aqui'
            };
            alert.type = data.hasAfetados ? 'success' : 'warning';
            _this11.alertMessage.create(alert);
          });
        }
      }
    }, {
      key: 'podeEnviarComando',
      value: function podeEnviarComando() {
        return this.vtabela.rowsSelected.length <= this.limitVeiculosEnvioComando;
      }
    }, {
      key: 'buildVeiculo',
      value: function buildVeiculo(prefixo, placa) {
        if (angular.isDefined(prefixo) && angular.isDefined(placa)) {
          return prefixo + ' - ' + placa;
        }
        return placa;
      }
    }, {
      key: 'setTimer',
      value: function setTimer() {
        var _this12 = this;

        if (angular.isDefined(this.rootScope.timerMapa)) {
          this.intervalService.cancel(this.rootScope.timerMapa);
        }
        this.rootScope.timerMapa = this.intervalService(function () {
          if (_this12.isPopupOpen) {
            _this12.refreshOpenPopup();
          } else {
            _this12.getPermanenciasByPermission();
            _this12.loadStatusVeiculo(true);
          }
        }, this.ONE_MINUTE);
      }
    }, {
      key: 'setMarkers',
      value: function setMarkers() {
        var _this13 = this;

        if (!this.markersCluster) {
          this.markersCluster = L.markerClusterGroup({
            spiderfyDistanceMultiplier: 3,
            iconCreateFunction: function iconCreateFunction(cluster) {
              var childCount = cluster.getChildCount(),
                  size = _this13.getClusterPointSize(childCount),
                  qtdTotalOcorrenciasNovasAgrupamento = 0;

              if (_this13.permissaoOcorrenciasVisualizar) {
                var clusterChildren = cluster.getAllChildMarkers();
                clusterChildren.forEach(function (clusterChild) {
                  qtdTotalOcorrenciasNovasAgrupamento += clusterChild.options.posicao.ocorrenciasNovasDoVeiculo.length;
                });
              }

              return new L.DivIcon({
                html: '<div>\n                      <span>' + childCount + '</span>\n                      <span class="quantity-container ' + (qtdTotalOcorrenciasNovasAgrupamento > 0 ? '' : 'no-display') + '">' + qtdTotalOcorrenciasNovasAgrupamento + '</span>\n                    </div>',
                className: 'marker-cluster marker-cluster-' + _this13.getClusterLabelSize(childCount),
                iconSize: new L.Point(size, size) });
            }
          });
        }
        this.markersCluster.clearLayers();
        this.statusVeiculos.forEach(function (posicao) {
          var markerVeic = L.marker([posicao.lat, posicao.lng], {
            icon: L.divIcon(_this13.mapasUtil.getIconByZoom(11, posicao)),
            posicao: posicao,
            vei: posicao.vei });
          _this13.markersCluster.addLayer(markerVeic);
          _this13.onClickBindPopup(markerVeic);
        });
        if (!this.map.hasLayer(this.markersCluster)) {
          this.map.addLayer(this.markersCluster);
        }
      }
    }, {
      key: 'onClickBindPopup',
      value: function onClickBindPopup(markerVeic) {
        var _this14 = this;

        markerVeic.on('click', function (marker) {
          if (angular.isUndefined(marker.target.getPopup())) {
            var posicao = markerVeic.options.posicao;
            var element = _this14.vpopupService.getVeiculoElement(posicao);
            marker.target.bindPopup(element, { className: 'vpopup' });
            marker.target.openPopup();
            _this14.isPopupOpen = true;
            _this14.openPopup = { element: element, vei: posicao.vei, posicao: posicao };

            marker.target.on('popupclose', function () {
              _this14.isPopupOpen = false;
              _this14.openPopup = undefined;
            });
          }
        });
      }
    }, {
      key: 'getVeiculoLayer',
      value: function getVeiculoLayer(vei) {
        var veiculo = void 0;
        this.markersCluster.getLayers().forEach(function (veiculoLayer) {
          if (veiculoLayer.options.vei === vei) {
            veiculo = veiculoLayer;
          }
        });
        return veiculo;
      }
    }, {
      key: 'setCenter',
      value: function setCenter() {
        if (this.statusVeiculos.length === 1 && this.filtroPontoReferencia === null) {
          this.center = {
            lat: this.statusVeiculos[0].lat,
            lng: this.statusVeiculos[0].lng,
            zoom: 12
          };
        }
      }
    }, {
      key: 'setFocus',
      value: function setFocus(veiculoId, shouldOpenSemaphoreModal) {
        var _this15 = this;

        this.exibicao = false;
        this.statusVeiculos.filter(function (s) {
          return s.vei === veiculoId;
        }).map(function (s) {
          var layerVeiculo = _this15.getVeiculoLayer(s.vei);
          _this15.markersCluster.zoomToShowLayer(layerVeiculo, function () {
            if (angular.isUndefined(layerVeiculo.getPopup())) {
              layerVeiculo.bindPopup(_this15.vpopupService.getVeiculoElement(layerVeiculo.options.posicao), { className: 'vpopup' });
            }

            layerVeiculo.openPopup(layerVeiculo);

            if (shouldOpenSemaphoreModal) {
              _this15.openDialogVehicleHealth(layerVeiculo.options.posicao, 0);
            }
          });
        });
      }
    }, {
      key: 'goToQuadroOcorrenciasWithLocalStorageSet',
      value: function goToQuadroOcorrenciasWithLocalStorageSet(ocorrenciaId) {
        this.googleTagManagerUtils.sendEventClickGTM('localizacao_frota_ir_para_ocorrencia', this.serviceVfiltro.factoryVfiltro.user);
        this.window.localStorage.setItem('localizacao-frota-go-to-quadro-ocorrencias-ocorrenciaId', ocorrenciaId);
        this.window.open('/tempo-real/ocorrencias?vfiltro=uo:' + this.uoId, '_blank');
      }
    }, {
      key: 'isRootUser',
      value: function isRootUser(usuario) {
        return this.uoHelperService.isRoot(usuario.uo.id);
      }
    }, {
      key: 'getRede',
      value: function getRede(row) {
        if (row.meio === 'SAT' && row.gsm) {
          return {
            style: 'trimble-sattelite v3g-text-blue',
            label: 'ce.mapa.common.gsmSatelital',
            id: 'SAT'
          };
        } else if (row.gsm) {
          return {
            style: 'trimble-connection-bar text-green',
            label: 'ce.mapa.common.gsmOnline',
            id: 'ON'
          };
        }
        return {
          style: 'trimble-connection-off v3g-text-alt-red',
          label: 'ce.mapa.common.gsmOffline',
          id: 'OFF'
        };
      }
    }, {
      key: 'getVideoSemaphoreStatusConfig',
      value: function getVideoSemaphoreStatusConfig(videoVitalSigns) {
        var status = videoVitalSigns ? videoVitalSigns.videoSemaphoreStatus : 'INDETERMINATE';
        switch (status) {
          case 'RELEASED':
            return {
              style: 'dot-stream online',
              label: this.semaphoreVideo.RELEASED,
              id: 'RELEASED'
            };
          case 'REQUIRES_ATTENTION':
            return {
              style: 'dot-stream warning',
              label: this.semaphoreVideo.REQUIRES_ATTENTION,
              id: 'REQUIRES_ATTENTION'
            };
          case 'EVALUATE_URGENTLY':
            return {
              style: 'dot-stream urgent',
              label: this.semaphoreVideo.EVALUATE_URGENTLY,
              id: 'EVALUATE_URGENTLY'
            };
          default:
            return {
              style: 'dot-stream',
              label: this.translate.instant('ce.mapa.localizacaoDaFrota.undefined'),
              id: 'INDETERMINATE'
            };
        }
      }
    }, {
      key: 'getVideoEventsTooltip',
      value: function getVideoEventsTooltip(videoEvents, hasPremiumTelemetry) {
        var _this16 = this;

        var _semaphoreVideoToolti = this.semaphoreVideoTooltip,
            CONNECTION = _semaphoreVideoToolti.CONNECTION,
            BEHAVIOR_EVENT = _semaphoreVideoToolti.BEHAVIOR_EVENT,
            VIDEO = _semaphoreVideoToolti.VIDEO,
            PHOTOS = _semaphoreVideoToolti.PHOTOS,
            SDCARD = _semaphoreVideoToolti.SDCARD,
            getFormattedLastOnline = function getFormattedLastOnline(event) {
          return event ? _this16.getLastOnlineText(event) : '-';
        },
            tooltip = '\n        <div id="vehicle-health-tooltip" class="saude-veiculo-tooltip">\n          <p>' + CONNECTION + ': ' + getFormattedLastOnline(videoEvents.lastConnection) + '</p>\n          <p>' + BEHAVIOR_EVENT + ': ' + getFormattedLastOnline(videoEvents.lastBehaviorEvent) + '</p>\n          ' + (hasPremiumTelemetry ? '' : '<p>' + VIDEO + ': ' + getFormattedLastOnline(videoEvents.lastVideo) + '</p>') + '\n          <p>' + PHOTOS + ': ' + getFormattedLastOnline(videoEvents.lastPhoto) + '</p>\n          <p>' + SDCARD + ': ' + (this.vpopupService.getStorageHealth(videoEvents.storageHealth) || '-') + '</p>\n        </div>\n      ';

        return tooltip;
      }
    }, {
      key: 'isRedeSat',
      value: function isRedeSat(row) {
        return row.meio === 'SAT' && row.gsm;
      }
    }, {
      key: 'isInTest',
      value: function isInTest(row) {
        return row.situacaoVeiculo === 'EM TESTE';
      }
    }, {
      key: 'setPontoReferencia',
      value: function setPontoReferencia(obj) {
        var texto = '';
        if (angular.isDefined(obj)) {
          if (obj.distancia === 0) {
            texto += 'em ' + obj.pontoReferencia.nome;
          } else {
            texto += obj.distancia + 'm de ' + obj.pontoReferencia.nome;
          }
        }
        return texto;
      }
    }, {
      key: 'setPopoverContent',
      value: function setPopoverContent(item) {
        return this.trusted[item] || (this.trusted[item] = this.sce.trustAsHtml(item));
      }
    }, {
      key: 'verificaMovimentoVelocidadeZero',
      value: function verificaMovimentoVelocidadeZero(item) {
        return item.status === 'Movimento' && item.vel === 0;
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }, {
      key: 'getVeiculoStatusi18n',
      value: function getVeiculoStatusi18n(status) {
        if (!status) {
          return '';
        }
        var statusi18n = this.veiculoStatusEnum.getStatusById(status.toUpperCase());
        return statusi18n ? statusi18n.descricao : '';
      }
    }, {
      key: 'verifyMapLayers',
      value: function verifyMapLayers() {
        var _this17 = this;

        if (this.location.search().forceRenderLayer) {
          this.authenticator.getUser().then(function (user) {
            _this17.mapasUtil.activateAllMapLayers(user.id);
          });
        }
      }
    }, {
      key: 'getLivestream',
      value: function getLivestream(item) {
        if (!item.hasStream) {
          return this.LIVESTREAM_OPTIONS.NA;
        }
        return item.vmovOnline ? this.LIVESTREAM_OPTIONS.VMOV_ONLINE : this.LIVESTREAM_OPTIONS.VMOV_OFFLINE;
      }
    }, {
      key: 'setMomentLocale',
      value: function setMomentLocale() {
        var _this18 = this;

        this.moment.locale('pt-br');
        this.authenticator.getUser().then(function (user) {
          var momentLang = _this18.languagesEnum.getLanguage(user.idioma).moment;
          _this18.moment.locale(momentLang);
        });
      }
    }, {
      key: 'getLastOnlineText',
      value: function getLastOnlineText(date) {
        return this.moment(date).fromNow();
      }
    }, {
      key: 'openDialogVehicleHealth',
      value: function openDialogVehicleHealth(posicao, initialTab) {
        if (posicao) {
          /* eslint-disable */
          var elementContainer = document.querySelector('#dialog-vehicle-health');
          var dialogOpener = document.createElement('vfwc-open-dialog-vehicle-health-evidences');
          /* eslint-enable */

          dialogOpener.usuario = this.serviceVfiltro.factoryVfiltro.user;
          dialogOpener.veiculo = posicao;
          dialogOpener.hasLivestreamPermission = this.permissaoLivestreamVisualizar && posicao.hasStream;
          dialogOpener.initialTab = initialTab || 0;

          elementContainer.appendChild(dialogOpener);
        }
        return '';
      }
    }, {
      key: 'isNa',
      value: function isNa() {
        return this.user && this.user.isNa;
      }
    }, {
      key: 'getPermanenciasByPermission',
      value: function getPermanenciasByPermission() {
        var _this19 = this;

        if (this.flagExceededPermanencia && !this.isNa()) {
          this.permanenciaRealtime.one().get().then(function (data) {
            _this19.exceededPermanenciasByVehicle = data.reduce(function (permanenciasByVehicle, permanencia) {
              permanenciasByVehicle[permanencia.vehicleId] = permanenciasByVehicle[permanencia.vehicleId] || permanencia.isExceeded;
              return permanenciasByVehicle;
            }, {});
          });
        }
      }
    }, {
      key: 'getIsExceededPermanencia',
      value: function getIsExceededPermanencia(vehicleId) {
        var isExceeded = this.exceededPermanenciasByVehicle[vehicleId];
        if (isExceeded) {
          return this.translate.instant('ce.mapa.localizacaoDaFrota.permanenciaExcedidaLabel.sim');
        } else if (isExceeded === false) {
          return this.translate.instant('ce.mapa.localizacaoDaFrota.permanenciaExcedidaLabel.nao');
        }
      }
    }]);

    return MapasGridCtrl;
  }();

  /**
   * @ngdoc object
   * @name mapasGrid.controller:MapasGridCtrl
   *
   * @description
   *
   */


  angular.module('mapasGrid').controller('MapasGridCtrl', MapasGridCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var tooltipInfosTextPrefix = 'ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.tooltipInfos',
      storageHealthTextPrefix = 'ce.mapa.localizacaoDaFrota.saudeDoVeiculoColumnInfo.sdCardStatus';

  var VpopupService = function () {
    function VpopupService($compile, $filter, $rootScope, ConvertersService, UrlService, ServiceVfiltro, Keys, moment, VeiculoStatusEnum, $translate, Authenticator, MeasurementUnitConverterService, SaudeVeiculoStatusToColorMap, FeaturehubJsSdk, ProntuarioLinkService, FeatureHubConfigKeys) {
      _classCallCheck(this, VpopupService);

      this.filter = $filter;
      this.compile = $compile;
      this.rootScope = $rootScope;
      this.veiculoStatusEnum = VeiculoStatusEnum;
      this.translate = $translate;
      this.convertersService = ConvertersService;
      this.urlService = UrlService;
      this.keys = Keys;
      this.moment = moment;
      this.serviceVfiltro = ServiceVfiltro;
      this.prontuarioLinkService = ProntuarioLinkService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.popupScopes = new WeakMap();

      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.saudeVeiculoStatusToColorMap = SaudeVeiculoStatusToColorMap;

      this.initUserMeasureSettings();
    }

    _createClass(VpopupService, [{
      key: 'initUserMeasureSettings',
      value: function initUserMeasureSettings() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          _this.measurementUnits = user.measurementUnits;
          _this.distanceMeasurement = _this.measurementUnits.distanceMeasurement;
          _this.dateFormat = _this.measurementUnits.dateTimeFormat;
          _this.speedUnit = _this.measurementUnitConverterService.getSpeedUnit(_this.distanceMeasurement);
          _this.distanceUnit = _this.measurementUnitConverterService.getDistanceUnit(_this.distanceMeasurement);
          _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormat(_this.dateFormat);
        });
      }
    }, {
      key: 'getVeiculoElement',
      value: function getVeiculoElement(posicao) {
        var scope = this.rootScope.$new(true);
        scope.eventoinfo = this.getVeiculoPopup(posicao);
        scope.onClosePopup = this.onClosePopup;
        var element = this.compile('<custom-popup infos=\'eventoinfo\'"></custom-popup>')(scope)[0];
        this.popupScopes.set(element, scope);
        return element;
      }
    }, {
      key: 'refreshVeiculoElement',
      value: function refreshVeiculoElement(element, posicao) {
        var scope = this.popupScopes.get(element);
        if (scope) {
          scope.eventoinfo = this.getVeiculoPopup(posicao);
        }
      }
    }, {
      key: 'geraClass',
      value: function geraClass(item, value) {
        switch (item) {
          case 'BLOQUEIO':
            return value ? 'text-danger' : 'text-success';
          case 'STATUS':
            return value === 'Movimento' ? 'label-primary' : 'label-danger';
          case 'GSM':
            return value ? 'text-success' : 'text-danger';
          default:
        }
      }
    }, {
      key: 'getBateria',
      value: function getBateria(fontAlimentacao) {
        switch (fontAlimentacao) {
          case 'PRINCIPAL':
            return this.translate.instant('ce.mapa.common.vpopupService.fonteAlimentacao.principal');
          case 'BACKUP':
            return this.translate.instant('ce.mapa.common.vpopupService.fonteAlimentacao.backup');
          case 'SEM_ALIMENTACAO':
            return this.translate.instant('ce.mapa.common.vpopupService.fonteAlimentacao.descarregada');
          default:
        }
      }
    }, {
      key: 'getPontoRef',
      value: function getPontoRef(ponto) {
        if (angular.isDefined(ponto)) {
          var pontoValue = ponto.pontoReferencia.nome;
          if (ponto.distancia) {
            pontoValue = ponto.distancia + ' ' + this.translate.instant('ce.mapa.common.vpopupService.unidadeDistanciaDe') + ' ' + pontoValue;
          }
          return pontoValue;
        }
      }
    }, {
      key: 'getBloqueio',
      value: function getBloqueio(bloqueio) {
        if (angular.isDefined(bloqueio)) {
          return bloqueio ? this.translate.instant('ce.mapa.common.vpopupService.bloqueado') : this.translate.instant('ce.mapa.common.vpopupService.desbloqueado');
        }
      }
    }, {
      key: 'getLogradouro',
      value: function getLogradouro(posicao) {
        if (posicao.logra) {
          return posicao.logra + ', ' + posicao.local;
        }
        return undefined;
      }
    }, {
      key: 'getLinkCadastroVeiculo',
      value: function getLinkCadastroVeiculo(veiculoId) {
        var _this2 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this2.keys.uo.name;
        }).value.id;
        return '/veiculo?vfiltro=' + this.keys.uo.name + ':' + uoId + ';veiculo:' + veiculoId;
      }
    }, {
      key: 'getLinkAnaliseMovimento',
      value: function getLinkAnaliseMovimento(veiculoId) {
        var _this3 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this3.keys.uo.name;
        }).value.id;
        return '/relatorios/movimento-veiculo?vfiltro=' + this.keys.dateTime.name + ';' + this.keys.uo.name + ':' + uoId + ';veiculo:' + veiculoId;
      }
    }, {
      key: 'getLinkProntuarioMotorista',
      value: function getLinkProntuarioMotorista(posicao) {
        var _this4 = this;

        if (!posicao.hasPermissaoMotorista) {
          return null;
        }
        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this4.keys.uo.name;
        }).value.id;
        return '/prontuario?vfiltro=' + this.keys.uo.name + ':' + uoId + ';' + this.keys.dateTime.name + ':' + this.prontuarioLinkService.handleProntuarioLink('ontem') + ';' + this.keys.motorista.name + ':' + posicao.motoristaId;
      }
    }, {
      key: 'getQuadroOcorrenciasLink',
      value: function getQuadroOcorrenciasLink() {
        var _this5 = this;

        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this5.keys.uo.name;
        }).value.id;
        return '/tempo-real/ocorrencias?vfiltro=uo:' + uoId;
      }
    }, {
      key: 'getLabelNovaOcorrencia',
      value: function getLabelNovaOcorrencia(qtdNovasOcorrencias) {
        return qtdNovasOcorrencias > 1 ? '' + this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.novas') : '' + this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.nova');
      }
    }, {
      key: 'getVeiculoPopup',
      value: function getVeiculoPopup(posicao) {
        var veiculoPopup = {
          title: {
            text: posicao.prefixo + ' - ' + posicao.placa,
            linkRedirecionar: this.getLinkCadastroVeiculo(posicao.vei)
          },
          subTitle: posicao.uoNome,
          linkMaps: this.getGoogleMapsLink(posicao.lat, posicao.lng),
          linkStreetView: this.getStreetViewLink(posicao.lat, posicao.lng),
          linkTimeline: this.getLinkHistoricoTimeline(posicao.vei, posicao.data),
          permissaoTimeline: this.permissaoHistoricoTimeline(),
          alerta: posicao.statusGps,
          data: this.filter('date')(posicao.data, this.dateTimeFormat),
          lastValidGps: this.getLastValidGpsDate(posicao),
          rows: [{
            icon: 'fa-user',
            infos: [{
              label: this.translate.instant('ce.mapa.common.vpopupService.motorista'),
              value: posicao.motNome,
              linkRedirecionar: this.getLinkProntuarioMotorista(posicao),
              size: 9
            }, posicao.motDocIdentificador ? {
              label: this.translate.instant('ce.mapa.common.vpopupService.documentoIdentificador'),
              value: posicao.motDocIdentificador,
              size: 3
            } : {
              label: this.translate.instant('ce.mapa.common.vpopupService.cpf'),
              value: posicao.motCpf,
              size: 3
            }]
          }, {
            icon: 'trimble-vehicle',
            infos: [{
              label: this.translate.instant('ce.mapa.common.vpopupService.status'),
              value: this.filter('translate')(this.getVeiculoStatusi18n(posicao.status)),
              linkRedirecionar: this.getLinkAnaliseMovimento(posicao.vei),
              class: 'text-uppercase label ' + this.geraClass('STATUS', posicao.status),
              size: 5
            }, {
              label: this.translate.instant('ce.mapa.common.vpopupService.velocidade'),
              value: this.filter('withLabel')(this.distanceMeasurement === 'KM' ? posicao.vel : this.convertersService.handleKmToMiles(posicao.vel), this.speedUnit),
              size: 3
            }, {
              label: this.translate.instant('ce.mapa.common.vpopupService.hodometro'),
              value: this.filter('decimalWithLabel')(posicao.hodo, this.distanceUnit),
              size: 4
            }]
          }, {
            icon: 'fa-podcast ',
            infos: [{
              label: this.translate.instant('ce.mapa.common.vpopupService.bloqueio'),
              class: 'text-uppercase ' + this.geraClass('BLOQUEIO', posicao.bloqueioPartida),
              value: this.getBloqueio(posicao.bloqueioPartida),
              size: 5
            }, {
              label: this.translate.instant('ce.mapa.common.vpopupService.gsm'),
              class: 'text-uppercase ' + this.geraClass('GSM', posicao.gsm),
              value: this.getRede(posicao.meio, posicao.gsm),
              size: 3
            }, {
              label: this.translate.instant('ce.mapa.common.vpopupService.bateria'),
              value: this.getBateria(posicao.fontAliment),
              size: 4
            }]
          }, {
            icon: 'fa-map-marker',
            noBorder: true,
            infos: [{
              label: this.translate.instant('ce.mapa.common.vpopupService.logradouro'),
              value: this.getLogradouro(posicao),
              size: 12
            }]
          }, {
            infos: [{
              label: this.translate.instant('ce.mapa.common.vpopupService.pontoDeReferencia'),
              value: this.getPontoRef(posicao.pontoProximo),
              size: 5
            }, {
              label: this.translate.instant('ce.mapa.localizacaoDaFrota.permanenciaExcedidaLabel.popup'),
              value: posicao.exceededPermanencia,
              class: 'text-uppercase',
              size: 7
            }]
          }]
        };
        if (posicao.veiculoHasOcorrenciaNova) {
          veiculoPopup.rows.splice(1, 0, {
            icon: 'fa-exclamation-triangle red-icon',
            infos: [{
              label: this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.labelVeiculo'),
              value: this.getLabelNovaOcorrencia(posicao.ocorrenciasNovasDoVeiculo.length),
              qtdNovasOcorrencias: posicao.ocorrenciasNovasDoVeiculo.length,
              linkRedirecionar: this.getQuadroOcorrenciasLink(),
              veiculoHasOcorrenciaNova: posicao.veiculoHasOcorrenciaNova,
              ocorrenciaId: posicao.veiculoOcorrenciaNovaMaisRecente.id,
              class: 'text-uppercase label custom-label',
              size: 9
            }, {
              label: this.translate.instant('ce.mapa.localizacaoDaFrota.ocorrencia.geradaEm'),
              value: this.moment(posicao.veiculoOcorrenciaNovaMaisRecente.dataHora).format('HH:mm:ss'),
              size: 3
            }]
          });
        }

        if (this.permissaoLivestream()) {
          var rowIndex = posicao.veiculoHasOcorrenciaNova ? 3 : 2;
          veiculoPopup.rows[rowIndex].infos.splice(3, 0, {
            label: this.translate.instant('ce.mapa.common.vpopupService.videoTempoReal'),
            class: 'text-uppercase clickable-value',
            value: this.getTempoReal(posicao.hasStream, posicao.vmovOnline),
            size: 6,
            onClick: this.canDisplayLivestream(posicao) && {
              type: 'openVehicleHealthEvidences',
              initialTab: 2,
              canDisplayLivestream: this.canDisplayLivestream(posicao),
              veiculoPosicao: posicao
            } || undefined
          });
        }

        var videoVitalSigns = posicao.videoVitalSigns;
        if (videoVitalSigns) {
          var rowOrder = posicao.veiculoHasOcorrenciaNova ? 4 : 3;
          if (posicao.hasPremiumTelemetry) {
            veiculoPopup.rows.splice(rowOrder, 0, {
              icon: videoVitalSigns.videoSemaphoreStatusConfig && videoVitalSigns.videoSemaphoreStatusConfig.style,
              infos: [{
                label: this.translate.instant(tooltipInfosTextPrefix + '.eventoComportamento'),
                value: videoVitalSigns.lastBehaviorEvent ? this.moment(videoVitalSigns.lastBehaviorEvent).fromNow() : '-',
                class: this.getSemaphoreItemColorClass(videoVitalSigns.statusBehaviorEvent),
                size: 5
              }, {
                label: this.translate.instant(tooltipInfosTextPrefix + '.fotos'),
                value: videoVitalSigns.lastPhoto ? this.moment(videoVitalSigns.lastPhoto).fromNow() : '-',
                class: this.saudeVeiculoStatusToColorMap.default,
                size: 3,
                onClick: {
                  type: 'openVehicleHealthEvidences',
                  initialTab: 0,
                  canDisplayLivestream: this.canDisplayLivestream(posicao),
                  veiculoPosicao: posicao
                }
              }, {
                label: 'SD CARD',
                value: this.getStorageHealth(videoVitalSigns.storageHealth),
                class: this.getSemaphoreItemColorClass(videoVitalSigns.storageHealth),
                size: 4
              }]
            });
          } else {
            veiculoPopup.rows.splice(rowOrder, 0, {
              icon: videoVitalSigns.videoSemaphoreStatusConfig && videoVitalSigns.videoSemaphoreStatusConfig.style,
              infos: [{
                label: this.translate.instant(tooltipInfosTextPrefix + '.eventoComportamento'),
                value: videoVitalSigns.lastBehaviorEvent ? this.moment(videoVitalSigns.lastBehaviorEvent).fromNow() : '-',
                class: this.getSemaphoreItemColorClass(videoVitalSigns.statusBehaviorEvent),
                size: 5
              }, {
                label: this.translate.instant(tooltipInfosTextPrefix + '.fotos'),
                value: videoVitalSigns.lastPhoto ? this.moment(videoVitalSigns.lastPhoto).fromNow() : '-',
                class: this.saudeVeiculoStatusToColorMap.default,
                size: 3,
                onClick: {
                  type: 'openVehicleHealthEvidences',
                  initialTab: 0,
                  canDisplayLivestream: this.canDisplayLivestream(posicao),
                  veiculoPosicao: posicao
                }
              }, {
                label: 'SD CARD',
                value: this.getStorageHealth(videoVitalSigns.storageHealth),
                class: this.getSemaphoreItemColorClass(videoVitalSigns.storageHealth),
                size: 4
              }, {
                label: this.translate.instant(tooltipInfosTextPrefix + '.video'),
                value: videoVitalSigns.lastVideo ? this.moment(videoVitalSigns.lastVideo).fromNow() : '-',
                class: this.saudeVeiculoStatusToColorMap.default,
                size: 5,
                onClick: {
                  type: 'openVehicleHealthEvidences',
                  initialTab: 1,
                  canDisplayLivestream: this.canDisplayLivestream(posicao),
                  veiculoPosicao: posicao
                }
              }]
            });
          }
        }
        this.addDuoRows(veiculoPopup, posicao);
        return veiculoPopup;
      }
    }, {
      key: 'addDuoRows',
      value: function addDuoRows(veiculoPopup, posicao) {
        var _veiculoPopup$rows;

        var duo = posicao.duo;
        var hasDuoData = Boolean(duo);
        var isRouteProgressCardEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ROUTE_PROGRESS_CARD);
        if (!hasDuoData || !isRouteProgressCardEnabled) {
          return;
        }
        var duoRows = [this.getMacroRow(duo.macro), this.getRouteProgressRow(duo)].filter(function (row) {
          return row;
        });
        var statusRowIndex = posicao.veiculoHasOcorrenciaNova ? 2 : 1;
        var firstDuoRowIndex = statusRowIndex + 1;
        (_veiculoPopup$rows = veiculoPopup.rows).splice.apply(_veiculoPopup$rows, [firstDuoRowIndex, 0].concat(_toConsumableArray(duoRows)));
      }
    }, {
      key: 'getMacroRow',
      value: function getMacroRow(macro) {
        if (!macro) {
          return undefined;
        }
        var elapsedSeconds = macro.startedAt && Math.max(0, this.moment().diff(this.moment(macro.startedAt), 'seconds'));
        var hasStartedAt = Boolean(macro.startedAt);
        return {
          infos: [{
            label: this.translate.instant('ce.mapa.common.vpopupService.macroAtiva'),
            value: macro.name,
            size: 8
          }, {
            label: this.translate.instant('ce.mapa.common.vpopupService.tempoExecucaoMacro'),
            value: hasStartedAt ? this.secondsToHHmm(elapsedSeconds) : undefined,
            size: 4
          }]
        };
      }
    }, {
      key: 'getRouteProgressRow',
      value: function getRouteProgressRow(duo) {
        var route = duo.route;
        if (!route) {
          return undefined;
        }
        var progressPercentage = Math.min(100, Math.max(0, Number(route.progress) || 0));
        var hasExceededTime = route.exceededTime > 0;
        return {
          type: 'route-progress',
          icon: 'fa-road',
          routeProgress: {
            name: route.name,
            late: route.late,
            onDeviation: route.onDeviation,
            progress: progressPercentage,
            eta: route.eta ? this.filter('date')(route.eta, 'HH:mm') : '-',
            estimatedTime: this.secondsToHHmm(route.estimatedTime),
            executionTime: this.secondsToHHmm(route.executionTime),
            exceededMinutes: hasExceededTime ? Math.ceil(route.exceededTime / 60) : null,
            lastUpdate: duo.lastUpdate ? this.filter('date')(duo.lastUpdate, this.dateTimeFormat) : '-'
          }
        };
      }
    }, {
      key: 'secondsToHHmm',
      value: function secondsToHHmm(seconds) {
        return this.filter('secondsToHHmm')(seconds);
      }
    }, {
      key: 'getLastValidGpsDate',
      value: function getLastValidGpsDate(posicao) {
        return posicao.lastValidGps ? this.filter('date')(posicao.lastValidGps, this.dateTimeFormat) : null;
      }
    }, {
      key: 'permissaoHistoricoTimeline',
      value: function permissaoHistoricoTimeline() {
        return this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('HISTORICO_DETALHADO_VISUALIZAR');
      }
    }, {
      key: 'permissaoLivestream',
      value: function permissaoLivestream() {
        return this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VPLAYER_LIVESTREAM_VISUALIZAR');
      }
    }, {
      key: 'canDisplayLivestream',
      value: function canDisplayLivestream(posicao) {
        return this.permissaoLivestream() && posicao.hasStream;
      }
    }, {
      key: 'getLinkHistoricoTimeline',
      value: function getLinkHistoricoTimeline(veiculoId, datatime) {
        if (this.permissaoHistoricoTimeline()) {
          return '/historico-timeline?vfiltro=' + this.getFiltroHistoricoTimeline(veiculoId, datatime);
        }
      }
    }, {
      key: 'getFiltroHistoricoTimeline',
      value: function getFiltroHistoricoTimeline(veiculoId, datatime) {
        var _this6 = this;

        var eventoIsoDate = new Date(datatime).toISOString();
        var vfiltro = angular.copy(this.serviceVfiltro.filtroTopbar).filter(function (x) {
          return x.key !== _this6.keys.veiculos.name;
        });
        vfiltro.unshift({
          key: this.keys.dateTime.name,
          value: {
            startDate: this.moment(datatime).startOf('day'),
            endDate: datatime,
            tipo: 'personalizado'
          }
        });
        vfiltro.push({
          key: this.keys.veiculo.name,
          value: { id: veiculoId }
        });
        return this.urlService.getObjectVfiltro(vfiltro) + '&date=' + eventoIsoDate + '&ultimo=true';
      }
    }, {
      key: 'getGoogleMapsLink',
      value: function getGoogleMapsLink(latitude, longitude) {
        return 'https://www.google.com/maps/@' + latitude + ',' + longitude + ',16z/data=!5m1!1e1';
      }
    }, {
      key: 'getStreetViewLink',
      value: function getStreetViewLink(latitude, longitude) {
        return 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + latitude + ',' + longitude;
      }
    }, {
      key: 'getRede',
      value: function getRede(meio, gsm) {
        if (meio === 'SAT' && gsm) {
          return this.translate.instant('ce.mapa.common.gsmSatelital');
        } else if (gsm) {
          return this.translate.instant('ce.mapa.common.gsmOnline');
        }
        return this.translate.instant('ce.mapa.common.gsmOffline');
      }
    }, {
      key: 'getVeiculoStatusi18n',
      value: function getVeiculoStatusi18n(status) {
        if (!status) {
          return '';
        }
        var statusi18n = this.veiculoStatusEnum.getStatusById(status.toUpperCase());
        return statusi18n ? statusi18n.descricao : '';
      }
    }, {
      key: 'getTempoReal',
      value: function getTempoReal(hasStream, vmovOnline) {
        if (hasStream && vmovOnline) {
          return this.translate.instant('ce.mapa.common.vpopupService.assistirTempoReal');
        }
        return '';
      }
    }, {
      key: 'getSemaphoreItemColorClass',
      value: function getSemaphoreItemColorClass(status) {
        if (status in this.saudeVeiculoStatusToColorMap.byStatus) {
          return this.saudeVeiculoStatusToColorMap.byStatus[status];
        }

        return this.saudeVeiculoStatusToColorMap.default;
      }
    }, {
      key: 'getStorageHealth',
      value: function getStorageHealth(storageHealth) {
        if (storageHealth === 'HEALTHY') {
          return this.translate.instant(storageHealthTextPrefix + '.funcionando');
        } else if (storageHealth === 'NOT_HEALTHY') {
          return this.translate.instant(storageHealthTextPrefix + '.comProblema');
        }
        return 'N/A';
      }
    }]);

    return VpopupService;
  }();

  angular.module('mapas').service('VpopupService', VpopupService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MAX_ZINDEX = 9999999;

  /* global OverlappingMarkerSpiderfier */

  var SpiderfierService = function () {
    function SpiderfierService() {
      _classCallCheck(this, SpiderfierService);
    }

    _createClass(SpiderfierService, [{
      key: 'createSpiderfier',
      value: function createSpiderfier(map) {
        var oms = new OverlappingMarkerSpiderfier(map);

        oms.addListener('click', function (event) {
          return event.setZIndexOffset(MAX_ZINDEX);
        });

        return oms;
      }
    }]);

    return SpiderfierService;
  }();

  angular.module('mapas').service('SpiderfierService', SpiderfierService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var BEFORE_COLON = new RegExp('(.+?' + ':'.replace(/[^\w\s]/g, '\\$&') + ')');

  var PopupService = function () {
    function PopupService($filter, Eventos, $translate, MeasurementUnitConverterService, ConvertersService, Authenticator) {
      var _this = this;

      _classCallCheck(this, PopupService);

      this.filter = $filter;
      this.Eventos = Eventos;
      this.authenticator = Authenticator;
      this.translate = $translate;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.convertersService = ConvertersService;
      this.limitLabel = this.translate.instant('ce.mapa.historicoDetalhado.limiteLabel');

      this.authenticator.getUser().then(function (user) {
        _this.usuario = user;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormatYearWithTwo(_this.usuario.measurementUnits.dateTimeFormat);
        _this.speedUnit = _this.measurementUnitConverterService.getSpeedUnit(_this.usuario.measurementUnits.speedMeasurement);
      });
    }

    _createClass(PopupService, [{
      key: 'build',
      value: function build(posicao) {
        if (posicao.evento && posicao.evento.includes(this.translate.instant(this.Eventos.DESCIDA.tipo))) {
          return this.getGps(posicao.gps) + this.getData(posicao, this.dateTimeFormat + ' HH:mm:ss') + this.getEvento(posicao) + this.getGoogleMapsLink(posicao.latitude, posicao.longitude) + this.getStreetViewLink(posicao.latitude, posicao.longitude) + this.getPontoRef(posicao);
        }
        return this.getGps(posicao.gps) + this.getData(posicao, this.dateTimeFormat + ' HH:mm:ss') + this.getDuracao(posicao.duracao) + this.getMotorista(posicao.motorista) + this.getEvento(posicao) + this.getIdentificacaoMotorista(posicao.identificacaoMotorista) + this.getVelocidade(posicao) + this.getDistancia(posicao.distancia) + this.getLimiar(posicao.limiar, posicao.pontoReferencia) + this.getIntensidade(posicao) + this.getChuva(posicao) + this.getVeiculo(posicao) + this.getObd(posicao) + this.getCan(posicao) + this.getUo(posicao) + this.getSnapshotLink(posicao) + this.getGoogleMapsLink(posicao.latitude, posicao.longitude) + this.getStreetViewLink(posicao.latitude, posicao.longitude) + this.getPontoRef(posicao) + this.getEventoTic(posicao.meio);
      }
    }, {
      key: 'getSnapshotLink',
      value: function getSnapshotLink(posicao) {
        var ignOn = posicao.data || '',
            ignOff = posicao.snapshotDataIgnicaoOff || '',
            hasVigencia = !!posicao.vigencia,
            isEventoAbertura = posicao.intensidade === 'Abertura de vigência',
            isEventoIgnOn = posicao.tipoPosicao === 'IGNICAO_LIGADA',
            isVigenciaRFID = hasVigencia && posicao.vigencia.origem === 'RFID',
            vigenciaNotRfidNotAbertura = hasVigencia && !isVigenciaRFID && !isEventoAbertura,
            tagVerFoto = !hasVigencia || isVigenciaRFID ? 'historico_detalhado_ver_foto' : undefined,
            tagEdicaoVigencia = hasVigencia && !isVigenciaRFID && isEventoAbertura ? 'historico_detalhado_editar_vigencia' : undefined,
            hasSnapshotNotVigencia = !!posicao.snapshotId && !hasVigencia && !isEventoIgnOn,
            clickGtm = this.getLinkGtm(tagVerFoto, tagEdicaoVigencia);

        if (!posicao.snapshotId || isVigenciaRFID && isEventoAbertura || vigenciaNotRfidNotAbertura || hasSnapshotNotVigencia) {
          return '';
        }

        return '<snapshot-link id-snapshot="' + posicao.snapshotId + '" date-ignition-on="' + ignOn + '" date-ignition-off="' + ignOff + '" pode-abrir-vigencia-manual="' + posicao.podeAbrirVigenciaManual + '" vigencia-atual-popup=\'' + this.buildVigenciaPopUpJson(posicao.vigencia) + '\' id-veiculo="' + posicao.veiculo.id + '" uo-veiculo="' + posicao.veiculo.uo.id + '" s3key="' + posicao.s3Key + '" bucket="' + (posicao.snapshotBucket || '') + '" bucket-region="' + (posicao.snapshotBucketRegion || '') + '" prefix-container="popup-container" uo-with-rec-facial="historicoTimeline.uoWithRecFacial" is-na="historicoTimeline.isNa" ng-click="' + clickGtm + '"></snapshot-link><br/>';
      }
    }, {
      key: 'getLinkGtm',
      value: function getLinkGtm(tagVerFoto, tagEdicaoVigencia) {
        if (!tagVerFoto && !tagEdicaoVigencia) {
          return '';
        }

        return 'historicoTimeline.sendClickGTM(\'' + (tagVerFoto ? tagVerFoto : tagEdicaoVigencia) + '\')';
      }
    }, {
      key: 'buildVigenciaPopUpJson',
      value: function buildVigenciaPopUpJson(vigencia) {
        if (angular.isDefined(vigencia) && vigencia !== null) {
          var vigenciaObjeto = {
            inicio: vigencia.inicio,
            fim: vigencia.fim,
            motoristaCpf: vigencia.motoristaCpf,
            motoristaId: vigencia.motoristaId,
            motoristaNome: vigencia.motoristaNome,
            origem: vigencia.origem,
            uoId: vigencia.uoId,
            uuid: vigencia.uuid,
            veiculoId: vigencia.veiculoId
          };
          return angular.toJson(vigenciaObjeto);
        }
        return null;
      }
    }, {
      key: 'getPontoRef',
      value: function getPontoRef(posicao) {
        if (angular.isUndefined(posicao.pontoProximo)) {
          return '';
        }

        var distancia = '',
            pontoRef = this.translate.instant('ce.mapa.common.modal.popupService.pontoRef');
        if (posicao.pontoProximo.distancia !== 0) {
          distancia = '</strong>' + posicao.pontoProximo.distancia + 'm de <strong>';
        }
        return '<br/><br/><i class="fa fa-map-marker"></i> <strong>' + pontoRef + ' ' + distancia + posicao.pontoProximo.pontoReferencia.nome + '</strong><br/>';
      }
    }, {
      key: 'getCan',
      value: function getCan(posicao) {
        if (posicao.descricao !== this.translate.instant('ce.enum.eventos.diagnosticoCan')) {
          return '';
        }

        return '<strong>' + this.translate.instant('ce.mapa.common.modal.popupService.codigoCan') + '</strong> ' + posicao.intensidade + '\n        <br/>\n        <br/>\n        ' + this.translate.instant('ce.mapa.common.modal.popupService.esseCodigoFalha') + '\n        <br/>\n        ' + this.translate.instant('ce.mapa.common.modal.popupService.paraSaberMaisSimples') + '\n        <br/>\n        <br/>';
      }
    }, {
      key: 'getUo',
      value: function getUo(posicao) {
        if (posicao.veiculo && posicao.veiculo.uo && posicao.veiculo.uo.nome) {
          return '<strong data-testid="popup-uo">' + this.translate.instant('ce.mapa.common.modal.popupService.uo') + '</strong> ' + posicao.veiculo.uo.nome + '<br/>';
        }
        return '';
      }
    }, {
      key: 'getObd',
      value: function getObd(posicao) {
        if (posicao.descricao !== this.translate.instant('ce.enum.eventos.diagnosticoObd')) {
          return '';
        }

        var obd = '';
        if (!!posicao.miscInfo && !!posicao.miscInfo.obdDesc) {
          obd = '<br/>' + posicao.miscInfo.obdDesc + '<br/>';
        }

        return '<strong>' + this.translate.instant('ce.mapa.common.modal.popupService.codigoObd') + '</strong> ' + posicao.intensidade + '\n        <a href="#" id="obd-mostrar-detalhes-' + posicao.index + '">(' + this.translate.instant('ce.mapa.common.modal.popupService.maisInformacoes') + ')</a>\n        <br/>\n        <div id="obd-detalhes-' + posicao.index + '">\n        ' + obd + '\n        <br />\n        ' + this.translate.instant('ce.mapa.common.modal.popupService.esseCodigoFalha') + '\n        <br/>\n        ' + this.translate.instant('ce.mapa.common.modal.popupService.paraSaberMaisClicando') + '\n        <a href="http://dtcsearch.com/' + posicao.intensidade + '" target="_blank">' + this.translate.instant('ce.mapa.common.modal.popupService.aqui') + '</a>\n        </div>\n        <br/>';
      }
    }, {
      key: 'getVeiculo',
      value: function getVeiculo(posicao) {
        if (angular.isUndefined(posicao.prefixo) && angular.isUndefined(posicao.placa)) {
          return '';
        }

        var veiculo = this.filter('prefixoPlaca')(posicao);
        return '<strong data-testid="popup-placa">' + this.translate.instant('ce.mapa.common.modal.popupService.veiculo') + ' </strong> ' + veiculo + ' <br/>';
      }
    }, {
      key: 'getChuva',
      value: function getChuva(posicao) {
        if (!!posicao.miscInfo && !!posicao.miscInfo.sensorChuva) {
          return '<strong>' + this.translate.instant('ce.mapa.common.modal.popupService.chovendo') + ' </strong> ' + this.translate.instant('ce.mapa.common.modal.popupService.sim') + ' <br/>';
        }

        return '';
      }
    }, {
      key: 'getLimiar',
      value: function getLimiar(limiar, pontoReferencia) {
        var ponto = '';
        if (angular.isUndefined(limiar) || limiar === '-') {
          return '';
        }

        if (pontoReferencia && pontoReferencia.id) {
          ponto = '<a href="#" id="popup-ponto-referencia-' + pontoReferencia.id + '" focus-ponto-referencia-directive="' + pontoReferencia.id + '">(' + this.translate.instant('ce.mapa.common.modal.popupService.rotograma') + ')</a>';
        }

        if (this.usuario.measurementUnits.speedMeasurement === 'MILES' && limiar && limiar.includes('Km/h/s')) {
          var limiarEmKm = parseFloat(limiar.replace('Km/h/s', '').replace('Limite: ', ''));
          limiar = this.limitLabel + ' ' + this.convertersService.handleKmToMiles(limiarEmKm) + ' mph/s';
        } else if (this.usuario.measurementUnits.speedMeasurement === 'MILES' && limiar && limiar.includes('Km/h')) {
          var _limiarEmKm = parseFloat(limiar.replace('Km/h', '').replace('Limite: ', ''));
          limiar = this.limitLabel + ' ' + this.convertersService.handleKmToMiles(_limiarEmKm) + ' mph';
        }

        if (this.usuario.measurementUnits.dateTimeFormat === 'AMERICAN' && limiar && limiar.includes('RPM')) {
          limiar = limiar.replace('Limite: ', this.limitLabel);
        }

        return limiar.replace(BEFORE_COLON, '<strong>$1</strong>') + ' ' + ponto + '<br/>';
      }
    }, {
      key: 'getIntensidade',
      value: function getIntensidade(posicao) {
        var _this2 = this;

        var isStringValida = function isStringValida(s) {
          return angular.isString(s) && s !== '-' && s !== '';
        },
            isEventoValido = function isEventoValido(evento) {
          return evento === _this2.Eventos.FRENAGEM_BRUSCA.tipo || evento === _this2.Eventos.ACELERACAO_BRUSCA.tipo || _this2.Eventos.isCurvaBrusca(evento) || evento === _this2.Eventos.RPM.tipo;
        };

        if (this.usuario.measurementUnits.speedMeasurement === 'MILES' && posicao.intensidade && posicao.intensidade.includes('Km/h/s')) {
          var intensidadeEmKm = parseFloat(posicao.intensidade.replace('Km/h/s', ''));
          posicao.intensidade = this.convertersService.handleKmToMiles(intensidadeEmKm) + ' mph';
        }

        if (isStringValida(posicao.intensidade) && isEventoValido(posicao.evento)) {
          return '<strong data-testid="popup-intensidade">' + this.translate.instant('ce.mapa.common.modal.popupService.excesso') + '</strong> ' + posicao.intensidade.replace(BEFORE_COLON, '<strong>$1</strong>') + ' <br/>';
        }
        return '';
      }
    }, {
      key: 'getDistancia',
      value: function getDistancia(distancia) {
        if (distancia) {
          var km = this.filter('km')(distancia);
          return '<strong data-testid="popup-distancia">' + this.translate.instant('ce.mapa.common.modal.popupService.distancia') + '</strong> ' + km + ' <br/>';
        }
        return '';
      }
    }, {
      key: 'getVelocidade',
      value: function getVelocidade(posicao) {
        if (angular.isUndefined(posicao.velocidade)) {
          return '';
        }

        var isExcesso = posicao.descricao && !posicao.descricao.indexOf(this.translate.instant('ce.enum.common.excessoVelocidade')),
            isEventoDeVelocidadeInicio = posicao.descricao && (!posicao.descricao.indexOf(this.translate.instant('ce.enum.common.curvaBrusca')) || !posicao.descricao.indexOf(this.translate.instant('ce.enum.common.aceleracaoBrusca')) || !posicao.descricao.indexOf(this.translate.instant('ce.enum.common.frenagemBrusca')));
        var descricao = void 0;

        if (isExcesso) {
          descricao = '<strong data-testid="popup-velocidade">' + this.translate.instant('ce.mapa.common.modal.popupService.velMaxima') + '</strong>';
        } else if (isEventoDeVelocidadeInicio) {
          descricao = '<strong data-testid="popup-velocidade">' + this.translate.instant('ce.mapa.common.modal.popupService.velInicio') + '</strong>';
        } else {
          descricao = '<strong data-testid="popup-velocidade">' + this.translate.instant('ce.mapa.common.modal.popupService.velocidade') + '</strong>';
        }

        if (this.usuario.measurementUnits.speedMeasurement === 'MILES' && !posicao.velocidadeConvertida) {
          posicao.velocidade = this.convertersService.handleKmToMiles(posicao.velocidade);
          posicao.velocidadeConvertida = true;
        }

        return descricao + ' ' + posicao.velocidade + ' ' + this.speedUnit + '  <br/>';
      }
    }, {
      key: 'getEvento',
      value: function getEvento(posicao) {
        var alertTag = posicao.tagIgnoreEvent ? '<tag-ignore event=\'' + angular.toJson(posicao.tagIgnoreEvent) + '\' size="inherit" position="right"></tag-ignore>' : '';
        switch (posicao.acionamentoFreioServico) {
          case true:
            return '<div class="popup-evento"><strong data-testid="popup-evento">' + this.translate.instant('ce.mapa.common.modal.popupService.evento') + '</strong> ' + this.translate.instant('ce.enum.common.frenagemBruscaComPedal') + alertTag + '</div>';
          case false:
            return '<div class="popup-evento"><strong data-testid="popup-evento">' + this.translate.instant('ce.mapa.common.modal.popupService.evento') + '</strong> ' + this.translate.instant('ce.enum.common.frenagemBruscaSemPedal') + alertTag + '</div>';
          default:
            return posicao.descricao ? '<div class="popup-evento"><strong data-testid="popup-evento">' + this.translate.instant('ce.mapa.common.modal.popupService.evento') + '</strong> ' + posicao.descricao + alertTag + '</div>' : '';
        }
      }
    }, {
      key: 'getMotorista',
      value: function getMotorista(motorista) {
        if (angular.isString(motorista)) {
          return '<strong data-testid="popup-motorista">' + this.translate.instant('ce.mapa.common.modal.popupService.motorista') + '</strong> ' + motorista + ' <br/>';
        }
        if (angular.isObject(motorista) && motorista.nome) {
          return '<strong data-testid="popup-motorista">' + this.translate.instant('ce.mapa.common.modal.popupService.motorista') + '</strong> ' + motorista.nome + ' <br/>';
        }
        return '';
      }
    }, {
      key: 'getDuracao',
      value: function getDuracao(duracao) {
        if (duracao) {
          return '<strong data-testid="popup-duracao">' + this.translate.instant('ce.mapa.common.modal.popupService.duracao') + '</strong> ' + this.filter('humanizedDuration')(duracao) + ' <br/>';
        }
        return '';
      }
    }, {
      key: 'getGps',
      value: function getGps(gps) {
        if (gps !== 'Inválido') {
          return '';
        }
        return '<div class="text-center"><i class="fa fa-exclamation-triangle v3g-text-alt-red"></i></div>' + ('<strong data-testid="popup-gps">' + this.translate.instant('ce.mapa.common.modal.popupService.atencaoLocalizacao') + '<br/><br/>');
      }
    }, {
      key: 'getIdentificacaoMotorista',
      value: function getIdentificacaoMotorista(identificacaoMotorista) {
        if (identificacaoMotorista) {
          return '<strong data-testid="popup-identificacao-motorista">' + this.translate.instant('ce.mapa.common.modal.popupService.identificacao') + '</strong> ' + identificacaoMotorista + '<br/>';
        }
        return '';
      }
    }, {
      key: 'getData',
      value: function getData(posicao, dateTimeFormat) {
        if (posicao.data) {
          var prefixo = posicao.duracao ? '<strong data-testid="popup-inicio">' + this.translate.instant('ce.mapa.common.modal.popupService.inicio') + '</strong>' : '<strong data-testid="popup-data">' + this.translate.instant('ce.mapa.common.modal.popupService.dataHora') + '</strong>',
              data = this.filter('date')(posicao.data, dateTimeFormat);
          return prefixo + ' ' + data + ' <br/>';
        }
        return '';
      }
    }, {
      key: 'getGoogleMapsLink',
      value: function getGoogleMapsLink(latitude, longitude) {
        return '<a data-testid="google-maps-link" href="https://www.google.com/maps/@' + latitude + ',' + longitude + ',16z/data=!5m1!1e1"' + (' target="_blank"><i class="trimble-traffic"></i> ' + this.translate.instant('ce.mapa.common.modal.popupService.trafegoTempoReal') + '</a><br/>');
      }
    }, {
      key: 'getStreetViewLink',
      value: function getStreetViewLink(latitude, longitude) {
        return '<a data-testid="street-view-link" href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + latitude + ',' + longitude + '"' + (' target="_blank"><i class="fa fa-street-view"></i> ' + this.translate.instant('ce.mapa.common.modal.popupService.explorarVisaoLocal') + '</a><br/>');
      }
    }, {
      key: 'getEventoTic',
      value: function getEventoTic(meio) {
        if (meio === 'GTP') {
          return '<div class="evento-tic popup-tic">' + '<div class="icon-tic">' + '<span class="material-icons">hub</span>' + '</div>' + '<div>' + ('<small class="texto-tic">' + this.translate.instant('ce.mapa.historicoDetalhado.eventoTic') + '</small>') + '</div>' + '</div>';
        }
        return '';
      }
    }]);

    return PopupService;
  }();

  angular.module('mapas').service('PopupService', PopupService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ICON_ANCHOR_DEFAULT = [15, 40],
      POPUP_ANCHOR_DEFAULT = [0, -40],
      MAX_ZINDEX = 9999999,
      MIN_ZINDEX = 0;

  /* global L, document, _ */

  var MarkerService = function () {
    function MarkerService(Eventos, PopupService, $translate, FeaturehubJsSdk) {
      _classCallCheck(this, MarkerService);

      this.eventos = Eventos;
      this.popupService = PopupService;
      this.lastActiveItem = null;
      this.translate = $translate;
      this.hasAlertTag = false;
      this.feature462 = FeaturehubJsSdk.isFeatureEnabled('LAINT46_bdx_page');
    }

    _createClass(MarkerService, [{
      key: 'buildMarkers',
      value: function buildMarkers(trechos, filtro, prefix, idElementoPai, hasAlertTag) {
        var _this = this;

        this.hasAlertTag = hasAlertTag;
        return _.chain(trechos).map(function (posicoes) {
          return _this.filtraEventos(posicoes, filtro);
        }).map(function (posicoes) {
          return posicoes.map(function (p, index) {
            var tipo = p.evento;
            if (index === 0 && tipo === null) {
              tipo = 'Início';
            }
            if (index === posicoes.length - 1 && tipo === null) {
              tipo = 'Fim';
            }
            return p.temCoordenada ? _this.buildMarker(p, tipo, index, prefix, idElementoPai) : false;
          });
        }).flatten();
      }
    }, {
      key: 'buildMarkersAssociadosAsPosicoes',
      value: function buildMarkersAssociadosAsPosicoes(posicoes, filtro, prefix) {
        var _this2 = this;

        var dateTimeFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'HH:mm:ss';

        this.hasAlertTag = this.feature462;
        return this.filtraEventos(posicoes, filtro).map(function (posicao, i) {
          var tipo = posicao.evento;
          if (i === 0) {
            tipo = 'Início';
          } else if (i === posicoes.length - 1) {
            tipo = 'Fim';
          }
          return [posicao, posicao.temCoordenada ? _this2.buildMarker(posicao, tipo, i, prefix, null, dateTimeFormat) : null];
        }).reduce(function (acc, atual) {
          return acc.set(atual[0], atual[1]);
        }, new Map());
      }
    }, {
      key: 'filtraEventos',
      value: function filtraEventos(posicoes, filtro) {
        var _this3 = this;

        return posicoes.filter(function (p, index) {
          var isPrimeira = index === 0,
              isUltima = index === posicoes.length - 1,
              semFiltro = !filtro,
              filtroUpperCase = filtro.toUpperCase(),
              descidaFaixa1 = _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA1.tipo).toUpperCase(),
              descidaFaixa2 = _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA2.tipo).toUpperCase(),
              descidaFaixa3 = _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA3.tipo).toUpperCase(),
              isDescidaFaixa1 = filtroUpperCase === descidaFaixa1,
              isDescidaFaixa2 = filtroUpperCase === descidaFaixa2,
              isDescidaFaixa3 = filtroUpperCase === descidaFaixa3;

          return isPrimeira || isUltima || semFiltro || filtroUpperCase === _this3.translate.instant(_this3.eventos.EXCESSO_VELOCIDADE.tipo).toUpperCase() && _this3.eventos.isExcessoVelocidade(p.evento) || filtroUpperCase === _this3.translate.instant(_this3.eventos.CURVA_BRUSCA.tipo).toUpperCase() && _this3.eventos.isCurvaBrusca(p.evento) || isDescidaFaixa1 && p.evento === _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA1_FIM.tipo) || isDescidaFaixa2 && p.evento === _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA2_FIM.tipo) || isDescidaFaixa3 && p.evento === _this3.translate.instant(_this3.eventos.DESCIDA_FAIXA3_FIM.tipo) || filtroUpperCase === p.evento.toUpperCase();
        });
      }
    }, {
      key: 'buildMarker',
      value: function buildMarker(posicao, tipo, index, prefix, idElementoPai, dateTimeFormat) {
        var _this4 = this;

        return L.marker([posicao.latitude, posicao.longitude], {
          evento: tipo,
          index: index,
          icon: L.divIcon({
            iconSize: [0, 0],
            html: this.getMarkerIcon(posicao.icon, tipo, this.hasAlertTag && (posicao.tagIgnoreEvent || posicao.tagIgnoreAlert)),
            iconAnchor: [15, 40],
            popupAnchor: [1, -35]
          })
        }).bindPopup(dateTimeFormat ? this.popupService.build(posicao, dateTimeFormat) : this.popupService.build(posicao)).on('popupopen', function (event) {
          _this4.onMarkerPopup(true, event, prefix + index, idElementoPai);
          angular.element('#obd-detalhes-' + index).hide();
          angular.element('#obd-mostrar-detalhes-' + index).click(function (evt) {
            angular.element('#obd-mostrar-detalhes-' + index).hide();
            angular.element('#obd-detalhes-' + index).show();
            evt.preventDefault();
          });
        }).on('popupclose', function (event) {
          _this4.onMarkerPopup(false, event, prefix + index, idElementoPai);
          angular.element('#obd-mostrar-detalhes-' + index).show();
        });
      }
    }, {
      key: 'onMarkerPopup',
      value: function onMarkerPopup(open, event, idElemento, idElementoPai) {
        event.target.setZIndexOffset(open ? MAX_ZINDEX : MIN_ZINDEX);
        /*eslint-disable */
        var element = document.getElementById(idElemento); // jshint ignore:line
        /*eslint-enable */
        if (element) {
          if (idElementoPai) {
            /*eslint-disable */
            var container = document.getElementById(idElementoPai),
                // jshint ignore:line
            elements = container.getElementsByClassName('active'); // jshint ignore:line
            /*eslint-enable */
            while (elements[0]) {
              elements[0].classList.remove('active');
            }
          }

          if (this.lastActiveItem) {
            this.lastActiveItem.classList.remove('active');
          }

          if (open) {
            this.lastActiveItem = element;
            element.scrollIntoView();
            element.classList.add('active');
          }
        }
      }
    }, {
      key: 'handleUseDefaultColor',
      value: function handleUseDefaultColor(useDefaultColor, defaultColor) {
        return useDefaultColor ? 'dark-gray' : defaultColor;
      }
    }, {
      key: 'getMarkerIcon',
      value: function getMarkerIcon(icon, tipo, useDefaultColor) {
        if (icon) {
          return {
            iconUrl: icon,
            iconAnchor: ICON_ANCHOR_DEFAULT,
            popupAnchor: POPUP_ANCHOR_DEFAULT
          };
        }

        if (this.eventos.isLocalizacao(tipo)) {
          return '';
        }
        if (tipo === 'Início' || tipo === 'Fim') {
          return this.getIconEvento(this.handleUseDefaultColor(useDefaultColor, 'blue'), 'fa-bus');
        }

        var evento = this.eventos.getEvento(tipo);
        if (angular.isDefined(evento)) {
          return this.getIconEvento(this.handleUseDefaultColor(useDefaultColor, evento.cor), evento.icone);
        }

        return this.getIconEvento(this.handleUseDefaultColor(useDefaultColor, 'yellow'), 'fa-exclamation-triangle');
      }
    }, {
      key: 'getIconEvento',
      value: function getIconEvento(cor, icone) {
        if (icone.includes('material')) {
          var matIcon = icone.replace('material ', '');
          return '<img src=\'images/icons-map/marker-' + cor + '.png\' class="img-icon"/>\n        <span class=\'circle-icon material-icons-map-marker bg-' + cor + '\'>' + matIcon + '</span>';
        }
        return '<img src=\'images/icons-map/marker-' + cor + '.png\' class="img-icon"/>\n        <span class=\'fa ' + icone + ' bg-' + cor + ' circle-icon\'></span>';
      }
    }]);

    return MarkerService;
  }();

  angular.module('mapas').service('MarkerService', MarkerService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('mapas').factory('$mapas', function ($uibModal) {
    return {
      open: function open(_posicao) {
        return $uibModal.open({
          templateUrl: 'mapas/mapa.tpl.html',
          controller: 'MapasCtrl',
          controllerAs: 'mapas',
          size: 'lg',
          resolve: {
            posicao: function posicao() {
              return _posicao;
            },
            latitude: function latitude() {
              return _posicao.latitude;
            },
            longitude: function longitude() {
              return _posicao.longitude;
            }
          }
        });
      }
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MapaCtrl = function () {
    function MapaCtrl(latitude, longitude, posicao, MapasUtil, $modalInstance) {
      _classCallCheck(this, MapaCtrl);

      this.posicao = posicao;
      this.mapasUtil = MapasUtil;
      this.tiles = MapasUtil.tiles;
      this.mapasUtil.init();
      this.modalInstance = $modalInstance;
      this.center = {
        lat: latitude,
        lng: longitude,
        zoom: 15
      };
      this.markers = {
        mainMarker: {
          lat: latitude,
          lng: longitude,
          focus: true,
          draggable: false
        }
      };
    }

    _createClass(MapaCtrl, [{
      key: 'closeModal',
      value: function closeModal() {
        this.modalInstance.dismiss('cancel');
      }
    }]);

    return MapaCtrl;
  }();

  angular.module('mapas').controller('MapasCtrl', MapaCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
  * @name mapasGrid
  * @description
  *
  */

  angular.module('mapaCalor', ['ui.router', 'restangular', 'ModuleMapasUtil', 'angularMoment', 'alert-message', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'ConstantVfiltroModule', 'leaflet-directive', 'v3gAuthenticatorModule', 'AlertasModule', 'pascalprecht.translate']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('mapaCalor').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.mapaCalor', {
      url: '/mapa-de-calor/:mes?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'mapa-calor/mapa-calor.tpl.html',
          controller: 'MapaCalorCtrl',
          controllerAs: 'mapaCalor'
        }
      },
      data: {
        titulo: 'ce.mapa.mapaDeCalor.titulo',
        hideTitulo: true,
        role: 'MAPA_DE_CALOR_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global _, L */

  var MapaCalorCtrl = function () {
    function MapaCalorCtrl($stateParams, $window, MapasUtil, Restangular, moment, AlertMessage, ServiceVfiltro, FactoryVfiltro, Keys, leafletData, $scope, CONFIG, Authenticator, AlertasEnum, $translate) {
      var _this = this;

      _classCallCheck(this, MapaCalorCtrl);

      this.stateParams = $stateParams;
      this.window = $window;
      this.scope = $scope;
      this.mapasUtil = MapasUtil;
      this.mapasUtil.init();
      this.restangular = Restangular;
      this.moment = moment;
      this.alertMessage = AlertMessage;
      this.serviceVfiltro = ServiceVfiltro;
      this.keys = Keys;
      this.leafletData = leafletData;
      this.factoryVfiltro = FactoryVfiltro;
      this.authenticator = Authenticator;
      this.alertasEnum = AlertasEnum;
      this.translate = $translate;

      this.whichClicked = 'ABSOLUTO';
      this.DBCLICK_ZOOM = 15;
      this.MIN_LONGITUDE = -34;
      this.MIN_ZOOM_FOR_CIRCLES = 12;
      this.VISIBLE_REGIONS = null;
      this.COLORS = ['#07f', '#fa0', '#f02'];
      this.CONFIG = CONFIG;
      this.regionsArray = [];
      this.ranking = [];
      this.unidadeMedida = null;

      this.mainMarker = null;
      this.map = null;
      this.heatLayerGroup = L.featureGroup();
      this.heatMapContent = [];

      this.mesFocus = 0;
      this.listaMes = [];
      this.constDia = '-01';

      this.leafletData.unresolveMap('leafletCalor');
      this.setMapConfig();
      this.leafletData.getMap('leafletCalor').then(function (map) {
        _this.map = map;
        _this.baseLayer = L.tileLayer.colorFilter(_this.mapasUtil.tiles.veltec.url, Object.assign({}, _this.mapasUtil.tiles.veltec.options, { filter: [] }));
        _this.map.addLayer(_this.baseLayer);
        L.control.scale().addTo(_this.map);
        _this.mainMarker = L.marker([31.5965265, 130.5569595], {
          icon: L.divIcon({
            html: _this.mapasUtil.getIconPosicao(),
            iconSize: [0, 0],
            shadowSize: [14, 20],
            shadowAnchor: [4, 19],
            iconAnchor: [15, 40],
            popupAnchor: [1, -35]
          })
        }).addTo(_this.map);

        _this.authenticator.getUser().then(function (u) {
          if (u.uo && u.uo.id) {
            _this.mapasUtil.setCurrentUoId(u.uo.id);
          }
          _this.initFiltro(u);
        });
      });

      this.scope.$on('$destroy', function () {
        _this.leafletData.unresolveMap('leafletCalor');
      });
    }

    _createClass(MapaCalorCtrl, [{
      key: 'getTiposAlertaHeatmap',
      value: function getTiposAlertaHeatmap() {
        var _this2 = this;

        var tiposHeatmap = Object.keys(this.CONFIG);
        var tiposAlertas = this.alertasEnum.getTipos().filter(function (tipoAlerta) {
          return _.include(tiposHeatmap, tipoAlerta.id);
        }).map(function (tipoAlerta) {
          return { id: tipoAlerta.id, label: _this2.translate.instant(tipoAlerta.descricao) };
        });
        tiposAlertas.push({ id: 'TREPIDACAO', label: this.translate.instant('ce.enum.common.trepidacao') });
        return tiposAlertas;
      }
    }, {
      key: 'initFiltro',
      value: function initFiltro(usuario) {
        var _this3 = this;

        this.serviceVfiltro.init(this.factoryVfiltro.get([{
          key: this.keys.uo.name,
          disabled: true,
          fixedId: usuario.uo.id,
          type: 'filtro-fixed',
          info: this.translate.instant('ce.mapa.mapaDeCalor.naoEhpermitidoTrocarUo')
        }, {
          key: this.keys.tipo.name,
          required: true,
          hasNivel: false,
          defaultValues: this.getTiposAlertaHeatmap()
        }])).then(function (vfiltro) {
          _this3.tipoEvento = vfiltro.find(function (x) {
            return x.key === _this3.keys.tipo.name;
          }).value.id;
          _this3.unidadeMedida = _this3.CONFIG[_this3.tipoEvento].UNIDADE;
          _this3.carregaMeses(_this3.stateParams.mes, _this3.serviceVfiltro.factoryVfiltro.user);
        }).catch(function () {
          _this3.serviceVfiltro.openFiltroDetalhado = true;
          _this3.leafletData.unresolveMap('leafletCalor');
        });
      }
    }, {
      key: 'carregaMeses',
      value: function carregaMeses(mesState, user) {
        var _this4 = this;

        this.user = user;
        this.restangular.one('/analisedados/mapa-de-calor/' + this.CONFIG[this.tipoEvento].ID + '/' + this.user.uo.id).get().then(function (data) {
          if (data.meses.length > 0) {
            _this4.listaMes = data.meses;
            if (mesState && data.meses.filter(function (x) {
              return x === mesState;
            })) {
              _this4.mesFocus = data.meses.filter(function (x) {
                return x === mesState;
              })[0];
            } else {
              _this4.mesFocus = data.meses[data.meses.length - 1];
            }
            return _this4.carregaCards();
          }
          _this4.alertMessage.create({
            type: 'warning',
            message: _this4.translate.instant('ce.mapa.mapaDeCalor.dadosInexistentesParaUo'),
            appendTo: '.alerta-aqui'
          });
        }).catch(function () {
          _this4.alertMessage.create({
            type: 'error',
            message: _this4.translate.instant('ce.mapa.mapaDeCalor.erroAoCarregarMapaDeCalor'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'carregaCards',
      value: function carregaCards() {
        var _this5 = this;

        return this.restangular.one('/analisedados/mapa-de-calor/' + this.CONFIG[this.tipoEvento].ID + '/' + this.user.uo.id + '/' + this.mesFocus).get().then(function (data) {
          var finalData = _this5.dataProcessing(data);
          if (finalData.length > 0) {
            _this5.heatMapContent = finalData;
            _this5.createCircles();
            _this5.paintCircles();
            _this5.updateMapOnMove();
            _this5.updateHeatmap();
            _this5.map.on('moveend', _this5.updateMapOnMove.bind(_this5));
            _this5.map.on('click', function () {
              return _this5.mainMarker.setLatLng([31.5965265, 130.5569595]);
            });
          }
        }).catch(function () {
          _this5.alertMessage.create({
            type: 'error',
            message: _this5.translate.instant('ce.mapa.mapaDeCalor.erroAoCarregarMapaDeCalor'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'dataProcessing',
      value: function dataProcessing(data) {
        var _this6 = this;

        var classifier = function classifier(value, flagValue) {
          var cls = 2;
          if (value < _this6.CONFIG[_this6.tipoEvento][flagValue][1]) {
            cls = 1;
          }
          if (value < _this6.CONFIG[_this6.tipoEvento][flagValue][0]) {
            cls = 0;
          }
          return cls;
        };

        return data.map(function (cluster) {
          var mainValue = { PERCENTUAL: [], ABSOLUTO: [] },
              granularClass = { PERCENTUAL: [], ABSOLUTO: [] };

          for (var i = 0; i < cluster.vei.length; i++) {
            var percentual = void 0;
            if (cluster.lim[i] > 0) {
              percentual = Math.round(cluster.exc[i] * 100 / cluster.lim[i] - 100);
            } else {
              percentual = 0;
            }

            mainValue.PERCENTUAL.push(percentual);
            // Arredonda para no máximo 2 casas no valor absoluto.
            mainValue.ABSOLUTO.push(Math.round(cluster.exc[i] * 100) / 100);
            granularClass.PERCENTUAL.push(classifier(percentual, 'PERCENTUAL'));
            granularClass.ABSOLUTO.push(classifier(cluster.exc[i], 'ABSOLUTO'));
          }

          cluster.mainValue = mainValue;
          cluster.granularClass = granularClass;
          cluster.regionClass = {
            PERCENTUAL: classifier(Math.max.apply(Math, _toConsumableArray(cluster.mainValue.PERCENTUAL)), 'PERCENTUAL'),
            ABSOLUTO: classifier(Math.max.apply(Math, _toConsumableArray(cluster.mainValue.ABSOLUTO)), 'ABSOLUTO')
          };
          return cluster;
        }).filter(function (cluster) {
          return cluster.lon < _this6.MIN_LONGITUDE;
        });
      }
    }, {
      key: 'updateHeatmap',
      value: function updateHeatmap() {
        var _this7 = this;

        if (this.map.hasLayer(this.heatLayerGroup)) {
          this.map.removeLayer(this.heatLayerGroup);
          this.heatLayerGroup = L.featureGroup();
        }

        var heats = [
        // blues
        { grad: { 0.6: '#001AFF', 0.8: '#00B3FF', 1: '#AAFFFF' }, data: [] },
        // oranges
        { grad: { 0.2: '#ff4400', 0.6: '#FF8800', 1: '#FFFF00' }, data: [] },
        // reds
        { grad: { 0.2: '#FF0000', 0.9: '#FF0011', 1: '#FF3355' }, data: [] }];

        this.heatMapContent.forEach(function (reg) {
          heats[reg.regionClass[_this7.whichClicked]].data.push([reg.lat[0], reg.lon[0], 1]);
        });

        heats.forEach(function (heat) {
          _this7.heatLayerGroup.addLayer(L.heatLayer(heat.data, {
            radius: 3,
            blur: 3,
            maxZoom: 0,
            zIndex: 2,
            gradient: heat.grad
          }), { interactive: false });
        });

        this.map.addLayer(this.heatLayerGroup);
      }
    }, {
      key: 'updateMapOnMove',
      value: function updateMapOnMove() {
        this.updateVisibleRegions();
        this.showCirclesInsideBounds();
        this.updateCards();
        this.freeVisibleRegions();
      }
    }, {
      key: 'updateVisibleRegions',
      value: function updateVisibleRegions() {
        var mapBounds = this.map.getBounds();
        this.VISIBLE_REGIONS = this.regionsArray.filter(function (reg) {
          return mapBounds.contains(reg.getLatLng());
        });
      }
    }, {
      key: 'freeVisibleRegions',
      value: function freeVisibleRegions() {
        this.VISIBLE_REGIONS = null;
      }
    }, {
      key: 'showCirclesInsideBounds',
      value: function showCirclesInsideBounds() {
        var _this8 = this;

        if (this.map.getZoom() > this.MIN_ZOOM_FOR_CIRCLES) {
          this.VISIBLE_REGIONS.forEach(function (e) {
            return e.addTo(_this8.map);
          });
        } else {
          this.VISIBLE_REGIONS.forEach(function (e) {
            return _this8.map.removeLayer(e);
          });
        }
      }
    }, {
      key: 'updateCards',
      value: function updateCards() {
        var newRanking = [];
        this.VISIBLE_REGIONS.forEach(function (e) {
          var incident = e.options.data;
          for (var i = 0; i < incident.vei.length; i++) {
            newRanking.push({
              lat: incident.lat[0],
              lon: incident.lon[0],
              dtt: incident.dtt[i],
              exc: incident.exc[i],
              lim: incident.lim[i],
              pfx: incident.pfx[i],
              plc: incident.plc[i],
              vei: incident.vei[i],
              mainValue: {
                PERCENTUAL: incident.mainValue.PERCENTUAL[i],
                ABSOLUTO: incident.mainValue.ABSOLUTO[i]
              },
              granularClass: {
                PERCENTUAL: incident.granularClass.PERCENTUAL[i],
                ABSOLUTO: incident.granularClass.ABSOLUTO[i]
              }
            });
          }
        });

        this.ranking = newRanking.sort(this.sortCards(this.whichClicked)).slice(0, 10);
      }
    }, {
      key: 'setMapConfig',
      value: function setMapConfig() {
        this.defaults = {
          zoomControlPosition: 'topleft',
          minZoom: 3
        };
        this.center = this.mapasUtil.getCenter();
      }
    }, {
      key: 'toggleValueFlag',
      value: function toggleValueFlag(newFlagValue) {
        if (newFlagValue !== this.whichClicked) {
          this.whichClicked = newFlagValue;

          this.paintCircles();
          this.updateHeatmap();
          this.updateMapOnMove();
        }
      }
    }, {
      key: 'getMesExtenso',
      value: function getMesExtenso(mes) {
        return this.moment(mes + this.constDia).locale(this.translate.use()).format('MMM');
      }
    }, {
      key: 'sortCards',
      value: function sortCards(type) {
        return function (a, b) {
          if (a.mainValue[type] < b.mainValue[type]) {
            return 1;
          } else if (a.mainValue[type] > b.mainValue[type]) {
            return -1;
          }
          return 0;
        };
      }
    }, {
      key: 'refresh',
      value: function refresh(anoMes) {
        var filtroAtual = this.serviceVfiltro.filtroTopbar.map(function (filtro) {
          return filtro.key + ':' + filtro.value.id;
        }).join(';');
        this.window.location = '/mapa-de-calor/' + anoMes + '?vfiltro=' + filtroAtual;
      }
    }, {
      key: 'getVeiculoDescricao',
      value: function getVeiculoDescricao(item) {
        return '' + (item.pfx ? item.pfx + ' - ' : '') + item.plc;
      }
    }, {
      key: 'zoom',
      value: function zoom() {
        this.map.setZoom(this.DBCLICK_ZOOM, { animate: false });
      }
    }, {
      key: 'pan',
      value: function pan(item) {
        this.map.panTo([item.lat, item.lon]);
        this.mainMarker.setLatLng([item.lat, item.lon]);
      }
    }, {
      key: 'getStyleCardContainer',
      value: function getStyleCardContainer(item, tipo) {
        return {
          color: this.COLORS[item.granularClass[tipo]]
        };
      }
    }, {
      key: 'getStyleLine',
      value: function getStyleLine(item) {
        var maxValue = this.CONFIG[this.tipoEvento].ABSOLUTO[2],
            lineSize = this.whichClicked === 'ABSOLUTO' ? item.mainValue.ABSOLUTO / maxValue * 100 : item.mainValue.PERCENTUAL;
        return {
          'border-bottom': '2px solid ' + this.COLORS[item.granularClass[this.whichClicked]],
          width: lineSize + '%',
          'min-width': '3%',
          'max-width': '100%'
        };
      }
    }, {
      key: 'createCircles',
      value: function createCircles() {
        var _this9 = this;

        this.heatMapContent.forEach(function (region) {
          var circleStyle = {
            color: '#000',
            weight: 1,
            opacity: 0.9,
            fillOpacity: 0.6,
            data: region
          };

          _this9.regionsArray.push(L.circle(L.latLng(Number(region.lat), Number(region.lon)), 60, circleStyle).on('click', _this9.regionClick.bind(_this9)));
        });
      }
    }, {
      key: 'regionClick',
      value: function regionClick(event) {
        this.window.location = this.getLinkHistoricoDetalhado(event.target.options.data);
      }
    }, {
      key: 'getLinkHistoricoDetalhado',
      value: function getLinkHistoricoDetalhado(item) {
        var dataInfrator = this.moment(item.dtt, 'YYYY-MM-DD HH:mm:ss.ZZ'),
            eventoIsoDate = new Date(item.dtt).toISOString(),
            dataInicio = this.moment(dataInfrator).startOf('day').format('YYYY.MM.DD.HH.mm.ss.ZZ'),
            dataFim = dataInfrator.format('YYYY.MM.DD.HH.mm.ss.ZZ');

        return '/historico-timeline?vfiltro=dateTime:' + dataInicio + ',' + dataFim + ';uo:' + this.user.uo.id + ';veiculo:' + item.vei + '&date=' + eventoIsoDate + '&ultimo=true';
      }
    }, {
      key: 'paintCircles',
      value: function paintCircles() {
        var _this10 = this;

        this.regionsArray.forEach(function (region) {
          region.setStyle({
            color: _this10.COLORS[region.options.data.regionClass[_this10.whichClicked]]
          });
        });
      }
    }, {
      key: 'getUnidadeMedida',
      value: function getUnidadeMedida() {
        return this.unidadeMedida;
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        var newBaseLayer = layerWrapper.getLayerObject();
        this.map.addLayer(newBaseLayer);
        this.map.removeLayer(this.baseLayer);
        this.baseLayer = newBaseLayer;
      }
    }]);

    return MapaCalorCtrl;
  }();

  /**
   * @ngdoc object
   * @name mapaCalor.controller:MapaCalorCtrl
   *
   * @description
   *
   */


  angular.module('mapaCalor').controller('MapaCalorCtrl', MapaCalorCtrl).constant('CONFIG', {
    EXCESSO_VELOCIDADE: {
      ID: 'SPEED_LIMIT_V3',
      ABSOLUTO: [60, 90, 120],
      UNIDADE: 'km/h',
      PERCENTUAL: [33, 66]
    },
    EXCESSO_VELOCIDADE_POR_VIA: {
      ID: 'SPEED_LIMIT_VIA',
      ABSOLUTO: [60, 90, 120],
      UNIDADE: 'km/h',
      PERCENTUAL: [33, 66]
    },
    EXCESSO_RPM: {
      ID: 'EXCESSO_RPM',
      ABSOLUTO: [2500, 3000, 4500],
      UNIDADE: 'RPM',
      PERCENTUAL: [33, 66]
    },
    CURVA_BRUSCA: {
      ID: 'CURVA_BRUSCA',
      ABSOLUTO: [0.8, 1.2, 1.5],
      UNIDADE: 'G',
      PERCENTUAL: [33, 66]
    },
    TREPIDACAO: {
      ID: 'TREPIDACAO',
      ABSOLUTO: [1, 2, 3],
      UNIDADE: 'G',
      PERCENTUAL: []
    },
    ACELERACAO_BRUSCA: {
      ID: 'ACELERACAO_BRUSCA',
      ABSOLUTO: [20, 40, 50],
      UNIDADE: 'km/h/s',
      PERCENTUAL: [33, 66]
    },
    FREADA_BRUSCA: {
      ID: 'FREADA_BRUSCA',
      ABSOLUTO: [20, 40, 50],
      UNIDADE: 'km/h/s',
      PERCENTUAL: [33, 66]
    },
    BANGUELA: {
      ID: 'BANGUELA',
      ABSOLUTO: [15, 17, 120],
      UNIDADE: 's',
      PERCENTUAL: [0, 0]
    },
    POSSIVEL_COLISAO: {
      ID: 'POSSIVEL_COLISAO',
      ABSOLUTO: [40, 90, 120],
      UNIDADE: 'km/h',
      PERCENTUAL: [0, 0]
    },
    FADIGA_MOTORISTA: {
      ID: 'FADIGA',
      ABSOLUTO: [40, 90, 120],
      UNIDADE: 'km/h',
      PERCENTUAL: [0, 0]
    }
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name insights
   * @description
   *
   */

  angular.module('insightsModule', ['segurancaModule']);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
  * @name mapasGrid
  * @description
  *
  */

  angular.module('informativoModule', ['informativoKeysModule', 'ui.router', 'restangular', 'ui.router', 'v3gAuthenticatorModule', 'FeatureOuModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.informativo', {
      url: '/informativo',
      params: {
        informativoKey: null,
        uoId: null
      },
      views: {
        'content@': {
          templateUrl: 'informativo/informativo.tpl.html',
          controller: 'InformativoCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        hideTitulo: true
      }
    });
  }

  angular.module('informativoModule').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable */
(function () {
  'use strict';

  var INFORMATIVO_KEY = 'informativo-key',
      PAGE_INFORMATIVO_DEFAULT = 'INDICADORES_DIRECAO_SEGURA';

  var InformativoCtrl = function () {
    function InformativoCtrl($stateParams, Authenticator, $rootScope, $window, FeatureOuService, $state, ServiceVfiltro, FactoryVfiltro) {
      var _this = this;

      _classCallCheck(this, InformativoCtrl);

      this.window = $window;
      this.stateParams = $stateParams;
      this.rootScope = $rootScope;
      this.FeatureOuService = FeatureOuService;
      this.state = $state;
      this.shouldRedirectToUnauthorizedNAPage = false;
      this.isLoadingDependencies = true;
      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        Authenticator.getUser().then(function (user) {
          _this.window.localStorage.removeItem('vfiltro-' + user.id);
          _this.user = user;
          _this.getEventsConfig(user.uo.id).then(function () {
            if (!_this.shouldRedirectToUnauthorizedNAPage) {
              _this.init();
            }
            _this.isLoadingDependencies = false;
          }).catch(function (error) {
            _this.log.error('Error loading featureOu config: ', error);
            _this.isLoadingDependencies = false;
          });
        });
      });
    }

    _createClass(InformativoCtrl, [{
      key: 'init',
      value: function init() {
        var informativoElement = this.getElement();
        if (informativoElement) {
          if (!this.stateParams.informativoKey) {
            informativoElement.informativoKey = this.getPageKeyInformativo();
            informativoElement.uoId = this.rootScope.usuario.uo.id;
          } else {
            informativoElement.informativoKey = this.stateParams.informativoKey;
            informativoElement.uoId = this.stateParams.uoId;
          }
          informativoElement.noPadding = false;

          this.setPageKeyInformativo(informativoElement.informativoKey);
        }
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(userUoId) {
        var _this2 = this;

        return this.FeatureOuService.getEventsConfig(userUoId).then(function (eventNAConfig) {
          _this2.shouldRedirectToUnauthorizedNAPage = eventNAConfig;
          if (_this2.shouldRedirectToUnauthorizedNAPage) {
            _this2.state.go('root.unauthorized');
          }
        });
      }
    }, {
      key: 'getElement',
      value: function getElement() {
        return angular.element(document.getElementById('informativo-box'))[0];
      }
    }, {
      key: 'getPageKeyInformativo',
      value: function getPageKeyInformativo() {
        var keyInformativo = this.window.localStorage.getItem(INFORMATIVO_KEY + '-' + this.rootScope.usuario.id);
        return keyInformativo || PAGE_INFORMATIVO_DEFAULT;
      }
    }, {
      key: 'setPageKeyInformativo',
      value: function setPageKeyInformativo(pageKey) {
        this.window.localStorage.setItem(INFORMATIVO_KEY + '-' + this.rootScope.usuario.id, pageKey);
      }
    }]);

    return InformativoCtrl;
  }();

  InformativoCtrl.$inject = ['$stateParams', 'Authenticator', '$rootScope', '$window', 'FeatureOuService', '$state', 'ServiceVfiltro', 'FactoryVfiltro'];

  angular.module('informativoModule').controller('InformativoCtrl', InformativoCtrl);
})();
/* eslint-enable */
'use strict';

(function () {
  'use strict';

  angular.module('informativoKeysModule', ['ui.router', 'v3gAuthenticatorModule']).constant('InformativoKeys', {
    'root.conducaoEconomica': [{ key: 'INDICADORES_CONDUCAO_ECONOMICA' }],
    'root.direcaoSegura': [{ key: 'INDICADORES_DIRECAO_SEGURA' }],
    'root.utilizacaoVeiculo': [{ key: 'INDICADORES_OCIOSIDADE_FROTA' }],
    'root.quadroOcorrencias': [{ key: 'QUADRO_OCORRENCIAS' }],
    'root.bdm': [{ key: 'BOLETIM_DIARIO_MOTORISTA' }],
    'root.bdmDetalhes': [{ key: 'BOLETIM_DIARIO_MOTORISTA' }],
    'root.bdv': [{ key: 'BOLETIM_DIARIO_VEICULO' }],
    'root.bdvDetalhes': [{ key: 'BOLETIM_DIARIO_VEICULO' }],
    'root.bdvChecklist': [{ key: 'BOLETIM_DIARIO_VEICULO' }],
    'root.bds': [{ key: 'BOLETIM_SERVICO' }],
    'root.bdsDetalhes': [{ key: 'BOLETIM_SERVICO' }],
    'root.analiseOp': [{ key: 'ANALISE_MOVIMENTO_VEICULO' }],
    'root.abastecimento': [{ key: 'ANALISE_ABASTECIMENTO' }],
    'root.velocidadeRpm': [{ key: 'ANALISE_VELOCIDADE_RPM' }],
    'root.permanencia': [{ key: 'ANALISE_PERMANENCIA_PONTO' }],
    'root.ocorrencia': [{ key: 'QUADRO_OCORRENCIAS' }],
    'root.ocorrenciaDetalhes': [{ key: 'QUADRO_OCORRENCIAS' }],
    'root.rankingEconomy': [{ key: 'RANKING_CONDUCAO_ECONOMICA' }],
    'root.rankingSafety': [{ key: 'RANKING_DIRECAO_SEGURA' }],
    'root.indicadorPowerBi': [{ key: 'INDICADORES_BI' }],
    'root.pontoReferencia': [{ key: 'PONTOS_REFERENCIA' }],
    'root.mapaCalor': [{ key: 'MAPA_CALOR' }],
    'root.onePage': [{ key: 'STATUS_FROTA' }],
    'root.rankingInfracoes': [{ key: 'INFRACOES_TEMPO_REAL' }],
    'root.rankingPontos': [{ key: 'RANKING_MOTORISTA' }],
    'root.prontuario': [{ key: 'RANKING_MOTORISTA' }],
    'root.configVdrivers': [{ key: 'CONFIGURACOES_VDRIVERS' }],
    'root.identificacoes': [{ key: 'CONFIGURACOES_VDRIVERS' }]
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('indicadores', ['indicadores.ConducaoEconomica', 'indicadores.DirecaoSegura', 'indicadores.UtilizacaoVeiculo', 'indicadores.powerBi', 'ui.router', 'core-ce.constants', 'onboarding', 'angular-intro', 'confluenceID', 'angularMoment', 'UrlModule', 'ObjetosVfiltroModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var IndicadoresService = function () {
    function IndicadoresService(moment, UrlService, ObjetosVfiltroService, SortAlertas) {
      _classCallCheck(this, IndicadoresService);

      this.moment = moment;
      this.urlService = UrlService;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.SortAlertas = SortAlertas;
    }

    _createClass(IndicadoresService, [{
      key: 'getFiltrosParaRanking',
      value: function getFiltrosParaRanking(periodo, uoPai, uoParceira, evento) {
        var reverse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        var filtro = {
          dateTime: [this.moment(periodo[0]).format('YYYY.MM.DD.HH.mm.00.ZZ'), this.moment(periodo[1]).format('YYYY.MM.DD.HH.mm.59.ZZ')],
          uo: uoPai,
          uoParceira: uoParceira
        },
            tableState = {
          sort: {
            predicate: this.SortAlertas[evento] || evento,
            reverse: reverse
          },
          search: '',
          pagination: {
            start: 0,
            totalItemCount: 0,
            number: 10,
            numberOfPages: 1
          }
        };

        return 'vfiltro=' + this.urlService.getObjectVfiltroUrl(filtro) + '&tablestate=' + this.objetosVfiltroService.getTableState(tableState);
      }
    }]);

    return IndicadoresService;
  }();

  angular.module('indicadores').service('IndicadoresService', IndicadoresService);
})();
'use strict';

/* eslint-disable quote-props */
(function () {
  'use strict';

  angular.module('indicadores').constant('URLDirecaoSegura', '/relatorios/ranking/safety').constant('URLConducaoEconomica', '/relatorios/ranking/economy').constant('SortAlertas', {
    'Acelerações Bruscas': 'aceleracoesBruscas',
    'Banguelas': 'banguelas',
    'Trepidações': '',
    'Curvas Bruscas': 'curvasBruscas',
    'Excessos Velocidade': '',
    'Excessos de Velocidade Até 20%': 'exVelocidadeFaixa1',
    'Excessos de Velocidade de 21% até 30%': 'exVelocidadeFaixa2',
    'Excessos de Velocidade Acima de 30%': 'exVelocidadeFaixa3',
    'Frenagens Bruscas': 'frenagensBruscas',
    'Parado Ligado': 'motorOcioso',
    'RPM Excessivo': 'rpmExcessivo',
    'Sensor Acionado': 'tempoSensorDesengate'
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name home
   * @description
   *
   */

  angular.module('home', ['ui.router']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.home', {
      url: '/home',
      views: {
        'content@': {
          templateUrl: 'home/home.tpl.html',
          controller: 'HomeCtrl',
          controllerAs: 'home'
        }
      },
      data: {
        titulo: 'Home'
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var HomeCtrl = function HomeCtrl() {
    _classCallCheck(this, HomeCtrl);

    this.ctrlName = 'HomeCtrl';
  };

  /**
   * @ngdoc object
   * @name home.controller:HomeCtrl
   *
   * @description
   *
   */


  angular.module('home').controller('HomeCtrl', HomeCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.historicoTimeline', {
      url: '/historico-timeline?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'historico-timeline/historico-timeline.tpl.html',
          controller: 'HistoricoTimelineCtrl',
          controllerAs: 'historicoTimeline'
        }
      },
      data: {
        titulo: 'ce.mapa.historicoDetalhado.titulo',
        hideTitulo: true,
        role: 'HISTORICO_DETALHADO_VISUALIZAR'
      }
    });
  }

  angular.module('historicoTimeline').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  function historicoTimelineDirective() {
    return {
      scope: {
        item: '=',
        historicoTimeline: '='
      },
      restrict: 'E',
      templateUrl: 'historico-timeline/historico-timeline-directive.tpl.html'
    };
  }

  angular.module('historicoTimeline').directive('historicoTimelineDirective', historicoTimelineDirective);
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ICON_ANCHOR_DEFAULT = [15, 40],
      POPUP_ANCHOR_DEFAULT = [0, -40],
      MAP_ZOOM = 25;

  /* global _, L, window */

  var HistoricoTimelineCtrl = function () {
    function HistoricoTimelineCtrl($scope, $httpParamSerializer, $filter, $compile, $timeout, $location, FeatureFlag, GoogleTagManagerUtils, HistoricoVeiculo, Eventos, MapasUtil, moment, AlertMessage, leafletData, SpiderfierService, MarkerService, EventosEnum, AuditingEventsEnum, Keys, ServiceVfiltro, FactoryVfiltro, ObjetosVfiltroService, AGRUPAMENTOS_VALIDOS, ReprodRotasService, $translate, VisaoCamerasService, UrlConfigService, Authenticator, HttpServiceV3g, MeasurementUnitConverterService, FeaturehubJsSdk, FeatureHubConfigKeys, $state, $window, FeatureOuService, CadastroVeiculoService) {
      var _this = this;

      _classCallCheck(this, HistoricoTimelineCtrl);

      this.scope = $scope;
      this.filter = $filter;
      this.compile = $compile;
      this.timeout = $timeout;
      this.location = $location;
      this.httpParamSerializer = $httpParamSerializer;
      this.moment = moment;
      this.eventos = Eventos;
      this.leafletData = leafletData;
      this.alertMessage = AlertMessage;
      this.mapasUtilService = MapasUtil;
      this.mapasUtilService.init();
      this.markerService = MarkerService;
      this.spiderfierService = SpiderfierService;
      this.historicoVeiculoService = HistoricoVeiculo;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.eventosEnum = EventosEnum;
      this.auditingEventsEnum = AuditingEventsEnum;
      this.translate = $translate;
      this.reprodRotasService = ReprodRotasService;
      this.visaoCamerasService = VisaoCamerasService;
      this.featureFlag = FeatureFlag;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.urlConfigService = UrlConfigService;
      this.authenticator = Authenticator;
      this.httpServiceV3g = HttpServiceV3g;
      this.featureOuService = FeatureOuService;
      this.cadastroVeiculoService = CadastroVeiculoService;
      this.uoWithRecFacial = false;
      this.isNa = false;
      this.map = null;
      this.markersGroup = new L.FeatureGroup();
      this.pathGroup = new L.FeatureGroup();
      this.historicoInicial = [];
      this.historicoCompleto = [];
      this.historico = [];
      this.historicoMarkers = [];
      this.eventoHistAlerta = '';
      this.eventoData = '';
      this.posicaoItem = null;
      this.tiles = MapasUtil.tiles.veltec;
      this.defaults = MapasUtil.defaults;
      this.geoJson = {};
      this.mapMarkers = [];
      this.mapCenter = MapasUtil.getCenter();
      this.markerSelecionado = null;
      this.deveFocarUltimoCard = false;
      this.ativarDelay = false;
      this.eventosDesativadosPorPadrao = [this.translate.instant(EventosEnum.PONTO_REFERENCIA)];
      this.filtroEventos = [];
      this.eventosAtivos = [];
      this.filtroEventosEvents = this.filtroEventosEventHandler();
      this.agrupamentosValidos = AGRUPAMENTOS_VALIDOS.map(function (event) {
        return _this.translate.instant(event);
      });
      this.posicoesReprodRotas = null;
      this.mostraVisaoCameras = false;
      this.markerSnapshot = null;
      this.snapshots = null;
      this.labels = null;
      this.labelsActived = [];
      this.veiculoId = null;
      this.dataReferencia = null;
      this.navigationSetting = null;
      this.featureFlagLAINT356 = FeaturehubJsSdk.isFeatureEnabled('LAINT356_event_tag');
      this.alertTagCheckbox = true;
      this.leafletData.unresolveMap('historico-map');
      this.setMapEvents();
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator.getUser().then(function (user) {
        _this.usuario = user;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormatYearWithTwo(_this.usuario.measurementUnits.dateTimeFormat);
        _this.speedUnit = _this.measurementUnitConverterService.getSpeedUnit(_this.usuario.measurementUnits.speedMeasurement);
        if (_this.usuario.uo && _this.usuario.uo.id) {
          _this.mapasUtilService.setCurrentUoId(_this.usuario.uo.id);
        }
      });
      this.invalidGpsFilterEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_INVALID_GPS_MAPS);
      this.fraseTooltip = this.translate.instant('ce.mapa.historicoDetalhado.fraseTooltip');
      this.frasePossivelColisaoTooltip = this.translate.instant('ce.mapa.historicoDetalhado.frasePossivelColisaoTooltip');
      this.fraseAcionamentoSemPedalFreio = this.translate.instant('ce.mapa.historicoDetalhado.acionamentoPedalTooltip');
      this.unknownDriver = this.translate.instant('ce.tempoReal.infracoes.common.mensagem.motoristaNaoIdentificado');
      this.invalidPositionTooltip = this.translate.instant('ce.mapa.localizacaoDaFrota.localizacaoInvalida');
      this.INVALID_GPS = 'Inválido';
      this.RED_COLOR = '#DD4B39';
      this.state = $state;
      this.window = $window;
      this.roleRotaEditar = this.authenticator.hasRole('ROTA_EDITAR');

      this.verifyMapLayers();
      this.leafletData.getMap('historico-map').then(function (map) {
        ServiceVfiltro.init(FactoryVfiltro.get([{
          name: 'sensor_data.datetime',
          key: _this.keys.dateTime.name,
          time: true,
          maxDate: _this.moment().endOf('day').format(),
          dateLimit: 1,
          defaultValues: {
            hoje: {
              active: true
            },
            ontem: {
              active: true
            }
          }
        }, {
          key: _this.keys.uo.name,
          size: 6
        }, {
          key: _this.keys.uoParceira.name,
          size: 6
        }, {
          name: 'sensor_data.vei_id',
          key: _this.keys.veiculo.name,
          ignoreValidation: true,
          required: true,
          size: 6
        }])).then(function (filtros) {
          _this.veiculoId = filtros.find(function (filtro) {
            return filtro.key === _this.keys.veiculo.name;
          }).value.id;
          _this.dataReferencia = filtros.find(function (filtro) {
            return filtro.key === _this.keys.dateTime.name;
          }).value;
          _this.ouId = filtros.find(function (filtro) {
            return filtro.key === _this.keys.uo.name;
          }).value.id;
          _this.resolveUoWithRecFacial(_this.ouId);
          _this.resolveIsNa(_this.ouId);

          _this.map = map;
          _this.init();
        }).catch(function () {
          _this.location.replace();
          _this.leafletData.unresolveMap('historico-map');
          _this.serviceVfiltro.openFiltroDetalhado = true;
        });
      });
      this.scope.$on('$destroy', function () {
        _this.leafletData.unresolveMap('historico-map');
      });
    }

    _createClass(HistoricoTimelineCtrl, [{
      key: 'init',
      value: function init() {
        var querystring = this.location.search(),
            ultimo = querystring.ultimo,
            evento = querystring.evento,
            date = querystring.date;
        if (ultimo) {
          this.ativarDelay = true;
          this.deveFocarUltimoCard = ultimo;
        }
        if (evento) {
          this.eventoHistAlerta = evento;
        }
        if (date) {
          this.eventoData = date;
        }

        this.consultar();
        this.location.search('evento', null);
        this.reprodRotasService.showReprodRotas = false;
      }
    }, {
      key: 'resolveUoWithRecFacial',
      value: function resolveUoWithRecFacial(uoId) {
        var _this2 = this;

        this.uoWithRecFacial = false;
        this.cadastroVeiculoService.hasRecFacial(uoId, null).then(function (uoWithRecFacial) {
          _this2.uoWithRecFacial = uoWithRecFacial;
        }).catch(function () {});
      }
    }, {
      key: 'resolveIsNa',
      value: function resolveIsNa(uoId) {
        var _this3 = this;

        this.isNa = false;
        this.featureOuService.getVehicleTableConfig(uoId).then(function (isNa) {
          _this3.isNa = isNa;
        }).catch(function () {});
      }
    }, {
      key: 'getTipoAlerta',
      value: function getTipoAlerta(alerta) {
        var evento = this.eventos.getEvento(alerta);
        return evento ? evento.alerta : '';
      }
    }, {
      key: 'getSnapshots',
      value: function getSnapshots() {
        var _this4 = this;

        var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        var labelsSelectedId = this.labelsActived.map(function (label) {
          return label.id;
        });

        if (labelsSelectedId.length === 0) {
          this.snapshots = [];
          return Promise.resolve([]);
        }

        return this.visaoCamerasService.getSnapshots(this.veiculoId, this.dataReferencia, currentPage, labelsSelectedId).then(function (res) {
          _this4.navigationSetting = {
            totalPages: res.data.totalPages,
            page: res.data.number,
            first: res.data.first,
            last: res.data.last
          };
          var snapshots = res.data.content;
          snapshots.forEach(function (snapshot) {
            var nearstPosition = _this4.findClosestPosition(snapshot.dateTime);
            if (angular.isDefined(nearstPosition)) {
              snapshot.latitude = nearstPosition.latitude;
              snapshot.longitude = nearstPosition.longitude;
            }
          });
          _this4.snapshots = snapshots;
          return _this4.snapshots;
        }).catch(function () {
          _this4.alertMessage.create({
            type: 'error',
            message: _this4.translate.instant('ce.mapa.historicoDetalhado.getSnapshotsErrorMessage'),
            appendTo: '.alerta-aqui'
          });
          return [];
        });
      }
    }, {
      key: 'getLabels',
      value: function getLabels() {
        var _this5 = this;

        if (this.mostraVisaoCameras && this.labels === null) {
          return this.visaoCamerasService.getLabels(this.dataReferencia, this.veiculoId).then(function (response) {
            if (response && response.data.length > 0) {
              _this5.labels = _this5.handleFormatLabels(response.data);
              _this5.labelsActived = angular.copy(_this5.labels);
            }

            _this5.loadSnapshots();
          });
        }
      }
    }, {
      key: 'handleFormatLabels',
      value: function handleFormatLabels(labels) {
        var _this6 = this;

        return labels.map(function (label) {
          return {
            id: label,
            label: _this6.translate.instant(_this6.auditingEventsEnum.getDescriptionById(label))
          };
        });
      }
    }, {
      key: 'handleChangePage',
      value: function handleChangePage(page) {
        this.getSnapshots(page);
      }
    }, {
      key: 'filtroEventosEventHandler',
      value: function filtroEventosEventHandler() {
        var _this7 = this;

        return {
          onSelectionChanged: function onSelectionChanged() {
            _this7.applyData();
          }
        };
      }
    }, {
      key: 'filterLabelsEvent',
      value: function filterLabelsEvent() {
        this.getSnapshots(0);
      }
    }, {
      key: 'setMapEvents',
      value: function setMapEvents() {
        angular.extend(this.scope, {
          events: {
            map: {
              enable: ['click'],
              logic: 'emit'
            },
            markers: {
              enable: ['click'],
              logic: 'emit'
            }
          }
        });
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this8 = this;

        this.historicoVeiculoService.one().get(this.getParams()).then(function (data) {
          _this8.serviceVfiltro.openFiltroDetalhado = false;
          _this8.historicoInicial = data.plain();
          _this8.scope.$broadcast('initPontoReferencia', _this8.map, _this8.historicoInicial);
          if (_this8.historicoInicial.length > 0) {
            try {
              _this8.applyFiltros();
              _this8.applyData();
            } catch (error) {
              _this8.alertMessage.create({
                type: 'error',
                message: _this8.translate.instant('ce.mapa.historicoDetalhado.consultarErrorMessage'),
                appendTo: '.alerta-aqui'
              });
            }
          } else {
            _this8.alertMessage.create({
              type: 'warning',
              message: _this8.translate.instant('v3gwc.vtabela.emptyMessage'),
              appendTo: '.alerta-aqui'
            });
            _this8.reprodRotasService.setAgrupamentos(null);
          }

          _this8.setMostraVisaoCameras();
        }).catch(function (erro) {
          if (erro.status === 500) {
            _this8.serviceVfiltro.openFiltroDetalhado = true;
          }
        });
      }
    }, {
      key: 'setMostraVisaoCameras',
      value: function setMostraVisaoCameras() {
        var _this9 = this;

        if (this.featureFlag.SNAPSHOTS_HIST_DETALHADO && this.authenticator.hasRole('VIDEO_VISUALIZAR')) {
          this.visaoCamerasService.hasVideo(this.veiculoId).then(function (hasVideo) {
            _this9.mostraVisaoCameras = hasVideo;
          });
        }
      }
    }, {
      key: 'loadSnapshots',
      value: function loadSnapshots() {
        if (this.snapshots === null) {
          this.getSnapshots(0);
        }
      }
    }, {
      key: 'findClosestPosition',
      value: function findClosestPosition(dateTime) {
        var jsDatetime = { jsDate: new Date(dateTime) },
            timeSearching = jsDatetime.jsDate.getTime(),
            indexPosition = _.sortedIndex(this.posicoesReprodRotas, jsDatetime, function (obj) {
          return obj.jsDate;
        }),
            previousPosition = this.posicoesReprodRotas[indexPosition - 1];
        if (indexPosition >= this.posicoesReprodRotas.length) {
          return previousPosition;
        }

        if (!previousPosition) {
          return this.posicoesReprodRotas[indexPosition];
        }

        var timeFound = this.posicoesReprodRotas[indexPosition].jsDate.getTime(),
            diffPrevious = Math.abs(previousPosition.jsDate.getTime() - timeSearching),
            diffCurrent = Math.abs(timeFound - timeSearching);
        if (diffPrevious < diffCurrent) {
          return previousPosition;
        }
        return this.posicoesReprodRotas[indexPosition];
      }
    }, {
      key: 'applyFiltros',
      value: function applyFiltros() {
        var _this10 = this;

        this.filtroEventos = [];

        this.historicoInicial.forEach(function (item) {
          item.historicos.forEach(function (hist) {
            return _this10.verificarFiltroEventos(hist);
          });
        });

        this.eventosAtivos = this.getEventosAtivos();
        var posicoes = this.posicoesToPath(this.mapasUtilService.ajustarEventos(this.converterArvoreEmLista(angular.copy(this.historicoInicial))));
        this.setPath(posicoes);
        this.posicoesReprodRotas = posicoes;
      }
    }, {
      key: 'verificarFiltroEventos',
      value: function verificarFiltroEventos(historico) {
        var _this11 = this;

        if (this.filtroEventos.findIndex(function (i) {
          return i.id === historico.evento;
        }) === -1) {
          if (this.isFrenagemBruscaInformacaoPedal(historico)) {
            this.filtroEventos.push(this.insertTipoFrenagemBruscaFiltroEventos(historico));
          }
          this.filtroEventos.push({ id: historico.evento, label: historico.evento });
        } else if (this.isFrenagemBruscaInformacaoPedal(historico) && this.filtroEventos.findIndex(function (i) {
          return i.id === _this11.verificarPedalFreio(historico.acionamentoFreioServico);
        }) === -1) {
          this.filtroEventos.push(this.insertTipoFrenagemBruscaFiltroEventos(historico));
        }
      }
    }, {
      key: 'insertTipoFrenagemBruscaFiltroEventos',
      value: function insertTipoFrenagemBruscaFiltroEventos(historico) {
        var tipoFrenagem = this.verificarPedalFreio(historico.acionamentoFreioServico);
        return {
          id: tipoFrenagem,
          label: tipoFrenagem
        };
      }
    }, {
      key: 'isFrenagemBruscaInformacaoPedal',
      value: function isFrenagemBruscaInformacaoPedal(historico) {
        if (typeof historico.acionamentoFreioServico !== 'undefined') {
          return this.eventos.isFrenagemBrusca(historico.evento);
        }
      }
    }, {
      key: 'verificarPedalFreio',
      value: function verificarPedalFreio(acionamentoPedal) {
        return this.eventos.getTipoFrenagem(acionamentoPedal);
      }
    }, {
      key: 'getEventosAtivos',
      value: function getEventosAtivos() {
        var _this12 = this;

        var evento = this.eventos.getByAlerta(this.location.search().tipoEvento),
            tipoEvento = evento ? evento.tipo : null;

        return this.filtroEventos.filter(function (item) {
          return (!tipoEvento || item.id === tipoEvento) && _this12.eventosDesativadosPorPadrao.indexOf(item.label) === -1;
        });
      }
    }, {
      key: 'analisarExibicaoEvento',
      value: function analisarExibicaoEvento(historico, eventosExibidos) {
        var eventosExibir = eventosExibidos.map(function (item) {
          return item.id;
        });
        if (this.isFrenagemBruscaInformacaoPedal(historico)) {
          if (eventosExibir.indexOf(this.verificarPedalFreio(historico.acionamentoFreioServico)) !== -1) {
            return true;
          }
        } else if (eventosExibir.indexOf(historico.evento) !== -1) {
          return true;
        }
        return false;
      }
    }, {
      key: 'applyData',
      value: function applyData() {
        var _this13 = this;

        var data = void 0,
            historicoInicial = _.cloneDeep(this.historicoInicial);

        historicoInicial.forEach(function (item) {
          item.historicos = item.historicos.map(function (hist) {
            return angular.extend(hist, { exibirEvento: _this13.analisarExibicaoEvento(hist, _this13.eventosAtivos) });
          });
        });

        data = this.eventosAtivos.length === 0 ? historicoInicial.filter(function (hist) {
          return hist.historicos.length > 0;
        }) : historicoInicial;

        this.reprodRotasService.setAgrupamentos(data);
        this.historicoCompleto = data;
        this.hasSomeEventoMovimento = this.reprodRotasService.hasSomeEventoMovimento();
        this.historico = this.mapasUtilService.ajustarEventos(this.converterArvoreEmLista(data));
        this.historicoMarkers = this.mapasUtilService.ajustarEventos(this.converterArvoreEmListaCom1ParadoPorGrupo(data));
        this.insertMarkers();

        if (data.length === 0) {
          this.alertMessage.create({
            type: 'warning',
            message: this.translate.instant('v3gwc.vtabela.emptyMessage'),
            appendTo: '.alerta-aqui'
          });
        }
      }
    }, {
      key: 'exibeReproducaoRotas',
      value: function exibeReproducaoRotas() {
        return this.posicoesReprodRotas && this.historicoCompleto && this.reprodRotasService.createdReprodRotas && this.hasSomeEventoMovimento;
      }
    }, {
      key: 'mostrarDuracao',
      value: function mostrarDuracao(posicao) {
        return posicao.duracao > 0 ? ' (' + this.filter('humanizedDuration')(posicao.duracao) + ')' : '';
      }
    }, {
      key: 'getUltimasPosicoes',
      value: function getUltimasPosicoes(posicoes) {
        return posicoes.map(function (p, index) {
          var isUltima = index === posicoes.length - 1,
              temPosicaoAgrupada = angular.isArray(p.posicoes) && p.posicoes.length > 0;
          return isUltima && temPosicaoAgrupada ? p.posicoes[p.posicoes.length - 1] : p;
        });
      }
    }, {
      key: 'insertMarkers',
      value: function insertMarkers() {
        var _this14 = this;

        var oms = this.spiderfierService.createSpiderfier(this.map);
        var posicoes = this.getUltimasPosicoes(this.historicoMarkers);

        this.closeMarker();
        this.markersGroup.clearLayers();
        this.mapMarkers = this.markerService.buildMarkers([posicoes], '', 'historico-', 'timeline', this.alertTagCheckbox && this.featureFlagLAINT356).value();
        this.mapMarkers.forEach(function (m) {
          return _this14.insertMarkersMap(m, oms);
        });

        if (!this.map.hasLayer(this.markersGroup)) {
          this.map.addLayer(this.markersGroup);
        }

        if (this.markersGroup.getBounds().isValid()) {
          this.focusHistorico();
        }

        this.setValueHistoricoAlerta();
        this.setEventoStatusVeiculo();
        this.setEventoHistoricoAlerta();
      }
    }, {
      key: 'focusHistorico',
      value: function focusHistorico() {
        this.map.fitBounds(this.markersGroup.getBounds(), { padding: [100, 100] });
      }
    }, {
      key: 'insertMarkersMap',
      value: function insertMarkersMap(item, oms) {
        if (item && this.handleShowEventWithAlertTag(this.historicoMarkers[item.options.index])) {
          item.setPopupContent(this.compile('<div>' + item.getPopup().getContent() + '</div>')(this.scope)[0]);
          this.markersGroup.addLayer(item);
          if (!this.eventos.isLocalizacao(item.options.evento)) {
            oms.addMarker(item);
          }
        }
      }
    }, {
      key: 'setValueHistoricoAlerta',
      value: function setValueHistoricoAlerta() {
        var _this15 = this;

        if (this.eventoHistAlerta && this.eventoData) {
          this.posicaoItem = this.historico.filter(function (item) {
            return new Date(_this15.eventoData).getTime() === new Date(item.data).getTime();
          });

          this.ativarDelay = true;
        }
      }
    }, {
      key: 'setEventoHistoricoAlerta',
      value: function setEventoHistoricoAlerta() {
        if (this.posicaoItem !== null) {
          if (this.posicaoItem.length > 0) {
            var posicao = null;

            if (this.eventoHistAlerta.indexOf('Diagnóstico') === -1) {
              var evento = this.eventos.getByAlerta(this.eventoHistAlerta),
                  tipoEvento = evento ? evento.tipo : evento,
                  posicaoEvento = tipoEvento ? this.posicaoItem.find(function (m) {
                return m.evento === tipoEvento;
              }) : null;
              posicao = posicaoEvento ? posicaoEvento : this.posicaoItem[0];
            } else {
              var posicaoDiagnostico = this.posicaoItem.find(function (m) {
                return m.evento.indexOf('Diagnóstico') !== -1;
              });
              posicao = posicaoDiagnostico ? posicaoDiagnostico : this.posicaoItem[0];
            }
            this.setFocusItem(posicao);
          } else {
            this.alertMessage.create({
              type: 'error',
              message: this.translate.instant('ce.mapa.historicoDetalhado.historicoAlertaEventoErrorMessage'),
              appendTo: '.alerta-aqui'
            });
          }
        }
      }
    }, {
      key: 'setFocusItem',
      value: function setFocusItem(posicao) {
        if (angular.isDefined(this.historico.filter(function (m) {
          return m === posicao;
        })[0])) {
          this.historico.filter(function (m) {
            return m === posicao;
          })[0].ativo = true;
        }
        this.setFocusMap(posicao);
      }
    }, {
      key: 'setEventoStatusVeiculo',
      value: function setEventoStatusVeiculo() {
        var _this16 = this;

        if (this.deveFocarUltimoCard) {
          var posicao = this.historicoMarkers.find(function (evento) {
            return evento.data === _this16.eventoData;
          });
          this.setFocusItem(posicao);
          this.deveFocarUltimoCard = false;
        }
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return {
          filtros: this.serviceVfiltro.filtroTopbar && this.serviceVfiltro.filtroTopbar.length > 0 ? this.serviceVfiltro.getFiltroBackendAntigo(this.serviceVfiltro.filtroTopbar, [this.keys.uo.name, this.keys.uoParceira.name]) : '',
          orderBy: 'datetime',
          orderDirection: 'ASC',
          limit: 2000,
          offset: 0
        };
      }
    }, {
      key: 'posicoesToPath',
      value: function posicoesToPath(posicoes) {
        return _.chain(this.mapasUtilService.flatPosicoes(posicoes)).map(function (p) {
          p.jsDate = new Date(p.data);
          return p;
        }).sortBy(function (p) {
          return p.data;
        }).value();
      }
    }, {
      key: 'setPath',
      value: function setPath(posicoes) {
        var _this17 = this;

        this.pathGroup.clearLayers();
        var validPositions = posicoes.filter(function (p) {
          return _this17.isValidPosition(p);
        });
        var coordinatesToDraw = [];
        if (this.invalidGpsFilterEnabled) {
          coordinatesToDraw = this.getValidPositionSegments(posicoes);
          this.setPathInvalidGaps(posicoes);
        } else {
          coordinatesToDraw = validPositions.map(function (p) {
            return [p.latitude, p.longitude];
          });
        }
        this.drawLinesForVehicleMovement(coordinatesToDraw);
        this.setPathEventos(validPositions);
      }
    }, {
      key: 'getValidPositionSegments',
      value: function getValidPositionSegments(posicoes) {
        var segmentoAtual = [];
        var segmentosDeRota = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = posicoes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            if (this.isValidPosition(p)) {
              segmentoAtual.push([p.latitude, p.longitude]);
            } else if (segmentoAtual.length > 0) {
              segmentosDeRota.push(segmentoAtual);
              segmentoAtual = [];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (segmentoAtual.length > 0) {
          segmentosDeRota.push(segmentoAtual);
        }
        return segmentosDeRota;
      }
    }, {
      key: 'drawLinesForVehicleMovement',
      value: function drawLinesForVehicleMovement(segmentosDeRota) {
        var routeLines = L.polyline(segmentosDeRota, {
          color: '#3388FF',
          opacity: 0.75,
          weight: 3
        });
        L.polylineDecorator(routeLines, {
          patterns: [{
            offset: 0,
            repeat: 300,
            symbol: L.Symbol.arrowHead({
              pixelSize: 12,
              pathOptions: { fillOpacity: 0.75, color: '#0033FF', weight: 0 }
            })
          }]
        }).addTo(this.pathGroup);
        this.pathGroup.addLayer(routeLines);
        if (!this.map.hasLayer(this.pathGroup)) {
          this.map.addLayer(this.pathGroup);
        }
      }
    }, {
      key: 'converterArvoreEmLista',
      value: function converterArvoreEmLista(posicoes) {
        var _this18 = this;

        return _(posicoes).map(function (p) {
          p.movimentos = p.historicos.filter(function (h) {
            return h.evento === _this18.translate.instant('ce.enum.eventos.movimento') || h.evento === _this18.translate.instant('ce.enum.eventos.parado');
          });
          return p.historicos;
        }).flatten().value();
      }
    }, {
      key: 'isPossivelColisao',
      value: function isPossivelColisao(item) {
        return item.descricao === this.translate.instant('ce.enum.common.possivelColisao');
      }
    }, {
      key: 'converterArvoreEmListaCom1ParadoPorGrupo',
      value: function converterArvoreEmListaCom1ParadoPorGrupo(posicoes) {
        var parado = this.translate.instant('ce.enum.eventos.parado');
        return _(posicoes).map(function (p) {
          var encontrouUmParado = false;
          return p.historicos.reduce(function (acc, pos) {
            if (!encontrouUmParado || acc.length === 0) {
              acc.push(pos);
              if (pos.descricao === parado) {
                encontrouUmParado = true;
              }
            } else if (pos.descricao !== parado) {
              acc.push(pos);
            }
            return acc;
          }, []);
        }).flatten().value();
      }
    }, {
      key: 'setPathEventos',
      value: function setPathEventos(posicoes, e) {
        var _this19 = this;

        posicoes.filter(function (p) {
          return _this19.isEvento(p, e);
        }).map(function (p) {
          var coord = [[p.latitude, p.longitude]],
              routeEventsLines = null;
          if (angular.isDefined(p.fim) && p.fim !== null) {
            if (p.fim.latitude !== 0 && p.fim.longitude !== 0) {
              coord = coord.concat(_this19.getPosicoesDentroDoPeriodoDoEvento(p, posicoes));
              coord.push([p.fim.latitude, p.fim.longitude]);
            }
          }
          routeEventsLines = L.polyline(coord, {
            color: 'red',
            weight: 3
          }).bindTooltip(_this19.translate.instant('ce.mapa.historicoDetalhado.eventRouteTooltip'), {
            sticky: true,
            direction: 'top'
          });
          _this19.pathGroup.addLayer(routeEventsLines);
        });
        if (!this.map.hasLayer(this.pathGroup)) {
          this.map.addLayer(this.pathGroup);
        }
      }
    }, {
      key: 'setPathInvalidGaps',
      value: function setPathInvalidGaps(allPositions) {
        var _this20 = this;

        var gapSegments = [];
        var lastValidLatLng = null,
            inGap = false;

        allPositions.forEach(function (p) {
          if (_this20.isValidPosition(p)) {
            var currentLatLng = [p.latitude, p.longitude];
            if (inGap && lastValidLatLng) {
              gapSegments.push([lastValidLatLng, currentLatLng]);
              inGap = false;
            }
            lastValidLatLng = currentLatLng;
          } else {
            inGap = true;
          }
        });
        if (gapSegments.length > 0) {
          this.drawInvalidPositionLines(gapSegments);
        }
      }
    }, {
      key: 'drawInvalidPositionLines',
      value: function drawInvalidPositionLines(gapSegments) {
        var routeLines = L.polyline(gapSegments, {
          color: this.RED_COLOR,
          opacity: 0.75,
          weight: 3,
          dashArray: '8,8'
        }).bindTooltip(this.translate.instant('ce.mapa.historicoDetalhado.invalidGpsRouteTooltip'), {
          sticky: true,
          direction: 'top'
        });
        this.pathGroup.addLayer(routeLines);
        if (!this.map.hasLayer(this.pathGroup)) {
          this.map.addLayer(this.pathGroup);
        }
      }
    }, {
      key: 'isValidPosition',
      value: function isValidPosition(position) {
        return position.gps !== this.INVALID_GPS && position.latitude !== 0 && position.longitude !== 0;
      }
    }, {
      key: 'getPosicoesDentroDoPeriodoDoEvento',
      value: function getPosicoesDentroDoPeriodoDoEvento(posicao, posicoes) {
        var _this21 = this;

        return posicoes.filter(function (p) {
          return _this21.isDentroDoPeriodo(p, posicao);
        }).map(function (p) {
          return [p.latitude, p.longitude];
        });
      }
    }, {
      key: 'isDentroDoPeriodo',
      value: function isDentroDoPeriodo(posicao, posicaoPeriodo) {
        return new Date(posicaoPeriodo.data) < new Date(posicao.data) && new Date(posicaoPeriodo.fim.data) > new Date(posicao.data);
      }
    }, {
      key: 'isEvento',
      value: function isEvento(p, e) {
        return e === null ? true : angular.isDefined(p.fim) && p.tipo === e;
      }
    }, {
      key: 'setFocusMap',
      value: function setFocusMap(posicao) {
        var _this22 = this;

        if (this.markerSelecionado !== null) {
          if (this.eventos.isLocalizacao(this.markerSelecionado.options.evento)) {
            this.markerSelecionado.setIcon(L.divIcon({
              html: this.mapasUtilService.getIconPosicao(),
              popupAnchor: [-2, -32],
              iconAnchor: [15, 40]
            }));
          }
          this.closeMarker();
        }

        this.markerSelecionado = this.mapMarkers[posicao.index];
        this.timeout(function () {
          return _this22.markerSelecionado.openPopup();
        }, this.ativarDelay ? 850 : 0);
        this.ativarDelay = false;
        if (this.eventos.isLocalizacao(this.markerSelecionado.options.evento)) {
          this.markerSelecionado.setIcon(L.divIcon({
            html: this.mapasUtilService.getIconPosicao(),
            popupAnchor: [-2, -32],
            iconAnchor: [15, 40]
          }));
        }

        var start = [posicao.latitude, posicao.longitude],
            last = this.getFimPosicao(posicao),
            end = [last.latitude, last.longitude];

        if (this.isCoordinatesEqual(start, end)) {
          this.map.fitBounds([start, end], { padding: [100, 100] });
        } else {
          this.map.setView(start, MAP_ZOOM);
        }
      }
    }, {
      key: 'getFimPosicao',
      value: function getFimPosicao(posicao) {
        var _this23 = this;

        if (angular.isDefined(posicao.fim) && angular.isObject(posicao.fim)) {
          return posicao.fim;
        }

        if (angular.isDefined(posicao.posicoes) && posicao.posicoes.length > 0) {
          var posicoes = posicao.posicoes.filter(function (p) {
            return _this23.isValidPosition(p);
          });
          if (posicoes.length > 0) {
            return posicoes[posicoes.length - 1];
          }
        }

        return posicao;
      }
    }, {
      key: 'getIcon',
      value: function getIcon(historico) {
        var evento = this.eventos.getEvento(historico.evento),
            alertTag = (historico.tagIgnoreEvent || historico.historicos && historico.historicos.length === 1 && historico.historicos[0].tagIgnoreEvent) && this.featureFlagLAINT356 ? ' disabled-icon' : '',
            removeEfeito = historico.historicos && this.verificaSeTemEventos(historico.historicos) && !this.verificaEventoDiferenteDefault(historico.evento) ? '' : 'remove-efeito';

        if (angular.isDefined(evento)) {
          return 'fa ' + evento.icone + ' bg-' + evento.cor + ' ' + removeEfeito + alertTag;
        }
        return 'fa fa-exclamation-triangle bg-yellow ' + removeEfeito + alertTag;
      }
    }, {
      key: 'urlCsv',
      value: function urlCsv() {
        return '/sensor/relatorio/historico-veiculo/csv?' + this.httpParamSerializer(this.getParams());
      }
    }, {
      key: 'downloadCsv',
      value: function downloadCsv() {
        this.httpServiceV3g.get(this.urlCsv(), { responseType: 'blob' }).then(function (result) {
          var contentDispositionHeader = result.headers('content-disposition'),
              fileName = contentDispositionHeader ? contentDispositionHeader.split('filename=')[1] : undefined,
              anchor = angular.element('<a/>');
          anchor.attr({
            href: window.URL.createObjectURL(result.data), //eslint-disable-line
            target: '_blank',
            download: fileName ? fileName : 'export.csv'
          })[0].click();
        });
      }
    }, {
      key: 'verificaMovimentoVelocidadeZero',
      value: function verificaMovimentoVelocidadeZero(item) {
        return item.evento === this.translate.instant('ce.enum.eventos.movimento') && item.velocidade === 0;
      }
    }, {
      key: 'getInfoEvento',
      value: function getInfoEvento(posicao) {
        if (posicao.evento === this.translate.instant(this.eventos.BANGUELA.tipo)) {
          var _posicao$intensidade$ = posicao.intensidade.match(/\d+/g),
              _posicao$intensidade$2 = _slicedToArray(_posicao$intensidade$, 3),
              velocidadeInicial = _posicao$intensidade$2[0],
              velocidadeFinal = _posicao$intensidade$2[1],
              duracao = _posicao$intensidade$2[2];

          return 'Vel.: ' + velocidadeInicial + 'km/h -> ' + velocidadeFinal + 'km/h, Dura\xE7\xE3o: ' + this.filter('humanizedDuration')(duracao);
        } else if (posicao.evento === this.translate.instant('ce.enum.eventos.aberturaDeVigencia') || posicao.evento === this.translate.instant('ce.enum.eventos.fechamentoDeVigencia')) {
          return posicao.evento;
        } else if (this.eventos.isExcessoVelocidade(posicao.evento)) {
          return this.translate.instant('ce.mapa.historicoDetalhado.limiteLabel') + ' ' + this.getRoundedSpeed(posicao.limiarSemLabel);
        }
        return posicao.intensidade;
      }
    }, {
      key: 'getRoundedSpeed',
      value: function getRoundedSpeed(stringSpeed) {
        if (!stringSpeed) {
          return '-';
        }
        var speed = void 0,
            unit = void 0;
        if (stringSpeed.includes(' ')) {
          var _stringSpeed$split = stringSpeed.split(' ');

          var _stringSpeed$split2 = _slicedToArray(_stringSpeed$split, 2);

          speed = _stringSpeed$split2[0];
          unit = _stringSpeed$split2[1];
        } else {
          var _stringSpeed$split$fi = stringSpeed.split(/(\d+)/).filter(Boolean);
          // speed should be a number
          // regex to split numeric from non-numeric characters


          var _stringSpeed$split$fi2 = _slicedToArray(_stringSpeed$split$fi, 2);

          speed = _stringSpeed$split$fi2[0];
          unit = _stringSpeed$split$fi2[1];
        }
        return '' + Math.round(parseFloat(speed)) + unit;
      }
    }, {
      key: 'deveMostrar',
      value: function deveMostrar(item) {
        return this.eventos.isExcessoVelocidade(item.evento) ? item.limiar.length > 1 : item.intensidade.length > 1;
      }
    }, {
      key: 'closeMarker',
      value: function closeMarker() {
        if (this.markerSelecionado !== null) {
          this.markerSelecionado.closePopup();
          this.markerSelecionado = null;
        }
      }
    }, {
      key: 'temLocalizacao',
      value: function temLocalizacao(evento) {
        return (evento.gps !== this.INVALID_GPS || this.ignoreInvalidPosition(evento)) && !!evento.latitude && !!evento.longitude;
      }
    }, {
      key: 'ignoreInvalidPosition',
      value: function ignoreInvalidPosition(posicao) {
        return !this.invalidGpsFilterEnabled || posicao.posicaoFoiAjustada;
      }
    }, {
      key: 'setMarkerAgrupamento',
      value: function setMarkerAgrupamento(posicao, index) {
        var posicaoAjustado = this.mapasUtilService.ajustaEvento(angular.copy(posicao), index);
        posicaoAjustado.posicao.data = posicaoAjustado.posicao.inicio;
        if (angular.isDefined(posicaoAjustado.posicao.veiculo)) {
          posicaoAjustado.posicao.prefixo = posicaoAjustado.posicao.veiculo.prefixo;
          posicaoAjustado.posicao.placa = posicaoAjustado.posicao.veiculo.placa;
        }
        return this.setMarker(posicaoAjustado.posicao, index);
      }
    }, {
      key: 'setMarker',
      value: function setMarker(posicao, index) {
        this.closeMarker();
        var inicio = [posicao.latitude, posicao.longitude],
            ultima = this.getFimPosicao(posicao),
            fim = [ultima.latitude, ultima.longitude];

        this.createMarker(posicao, index);

        this.setMarkerOnMap();
        this.map.fitBounds([inicio, fim], { padding: [100, 100] });
      }
    }, {
      key: 'createMarker',
      value: function createMarker(posicao, index) {
        this.markerSelecionado = this.markerService.buildMarker(posicao, posicao.evento, index, 'historico-', 'timeline');

        this.markerSelecionado.setIcon(L.divIcon({
          html: this.mapasUtilService.getIconPosicao(),
          popupAnchor: [-2, -32],
          iconAnchor: [15, 40]
        }));
      }
    }, {
      key: 'setMarkerOnMap',
      value: function setMarkerOnMap() {
        var _this24 = this;

        if (this.markerSelecionado !== null) {
          this.markersGroup.addLayer(this.markerSelecionado);
          this.markerSelecionado.openPopup();
          this.markerSelecionado.on('popupclose', function () {
            if (_this24.markerSelecionado !== null) {
              _this24.markersGroup.removeLayer(_this24.markerSelecionado);
              _this24.map.removeLayer(_this24.markerSelecionado);
            }
          });
        }
      }
    }, {
      key: 'setPontoReferencia',
      value: function setPontoReferencia(obj) {
        var pontoRef = '';
        if (angular.isDefined(obj.pontoProximo)) {
          if (obj.pontoProximo.distancia === 0) {
            pontoRef += '<strong>' + obj.pontoProximo.pontoReferencia.nome + '</strong>';
          } else {
            pontoRef += obj.pontoProximo.distancia + 'm de <strong>' + obj.pontoProximo.pontoReferencia.nome + '</strong>';
          }
          pontoRef += ' - ';
        }
        pontoRef += obj.logradouro ? obj.logradouro : '';
        pontoRef += obj.logradouro && obj.cidade ? ', ' : '';
        pontoRef += obj.cidade ? obj.cidade : '';
        return pontoRef;
      }
    }, {
      key: 'verificaEventoDefault',
      value: function verificaEventoDefault(item) {
        return item.historicos.length === 1 && this.verificaEventoDiferenteDefault(item.evento);
      }
    }, {
      key: 'verificaSeTemEventos',
      value: function verificaSeTemEventos(item) {
        return this.retornaEventosFiltrados(item) > 0;
      }
    }, {
      key: 'retornaEventosFiltrados',
      value: function retornaEventosFiltrados(item) {
        var _this25 = this;

        return item.filter(function (x) {
          return x.exibirEvento && _this25.verificaEventoDiferenteDefault(x.descricao);
        }).length;
      }
    }, {
      key: 'handleCheckAlertTag',
      value: function handleCheckAlertTag(item) {
        if (!this.alertTagCheckbox && item.tagIgnoreEvent && this.featureFlagLAINT356) {
          return false;
        }
        return true;
      }
    }, {
      key: 'handleShowEventWithAlertTag',
      value: function handleShowEventWithAlertTag(item) {
        if (item.exibirEvento) {
          return this.handleCheckAlertTag(item);
        }
        return false;
      }
    }, {
      key: 'verificaEventoDiferenteDefault',
      value: function verificaEventoDiferenteDefault(item) {
        return !this.agrupamentosValidos.find(function (itemValido) {
          return itemValido === item;
        });
      }
    }, {
      key: 'onLayerSwitch',
      value: function onLayerSwitch(layerWrapper) {
        this.tiles = layerWrapper.getLayerConfig();
      }
    }, {
      key: 'deveMostrarChovendo',
      value: function deveMostrarChovendo(item) {
        return Boolean(item.miscInfo && item.miscInfo.sensorChuva);
      }
    }, {
      key: 'resizeDropdown',
      value: function resizeDropdown() {
        var _this26 = this;

        this.timeout(function () {
          return _this26.scope.$applyAsync();
        }, 100);
      }
    }, {
      key: 'onVerNoMapaSnapshot',
      value: function onVerNoMapaSnapshot(posicao) {
        this.setMarkerSnapshot(posicao.latitude, posicao.longitude, posicao.horario);
      }
    }, {
      key: 'showHistorico',
      value: function showHistorico() {
        this.removeMarkerSnapshot();
        this.focusHistorico();
      }
    }, {
      key: 'removeMarkerSnapshot',
      value: function removeMarkerSnapshot() {
        if (this.markerSnapshot) {
          this.map.removeLayer(this.markerSnapshot);
        }
      }
    }, {
      key: 'setMarkerSnapshot',
      value: function setMarkerSnapshot(latitude, longitude) {
        var datetime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '10:15:55';

        this.removeMarkerSnapshot();

        this.markerSnapshot = L.marker([latitude, longitude], {
          evento: 'snapshot',
          icon: L.divIcon({
            iconSize: [0, 0],
            html: '\n              <img src=\'images/icons-map/marker-yellow.png\' class="img-icon"/>\n              <span class=\'fa fa-camera bg-yellow circle-icon\'></span>\n            ',
            iconAnchor: ICON_ANCHOR_DEFAULT,
            popupAnchor: POPUP_ANCHOR_DEFAULT
          })
        }).bindPopup('\n        <p><strong>Snapshot</strong></p>\n        <strong>Hor\xE1rio: </strong>' + datetime + '\n      ');

        this.map.addLayer(this.markerSnapshot);
        this.map.setView(L.latLng(latitude, longitude), 17);
        this.markerSnapshot.openPopup();
      }
    }, {
      key: 'sendClickGTM',
      value: function sendClickGTM(eventName) {
        this.googleTagManagerUtils.sendEventClickGTM(eventName, this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'onClickCameras',
      value: function onClickCameras() {
        this.googleTagManagerUtils.sendEventClickGTM('historico_detalhado_cameras', this.serviceVfiltro.factoryVfiltro.user);
        this.getLabels();
      }
    }, {
      key: 'onVideoClick',
      value: function onVideoClick() {
        this.googleTagManagerUtils.sendEventClickGTM('historico_detalhado_reproduzir_video_vfleets', this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'verifyMapLayers',
      value: function verifyMapLayers() {
        var _this27 = this;

        if (this.location.search().forceRenderLayer) {
          this.authenticator.getUser().then(function (user) {
            _this27.mapasUtilService.activateAllMapLayers(user.id);
          });
        }
      }
    }, {
      key: 'isAberturaVigencia',
      value: function isAberturaVigencia(historico) {
        return !!historico.snapshotId && !!historico.vigencia && historico.intensidade === 'Abertura de vigência' && historico.vigencia.origem !== 'RFID';
      }
    }, {
      key: 'hasSnapshotNotIgnition',
      value: function hasSnapshotNotIgnition(historico) {
        return !!historico.snapshotId && historico.tipoPosicao !== 'IGNICAO_LIGADA';
      }
    }, {
      key: 'hasSnapshotNotVigencia',
      value: function hasSnapshotNotVigencia(historico) {
        return !!historico.snapshotId && historico.intensidade !== 'Abertura de vigência';
      }
    }, {
      key: 'hasSnapshotIgnition',
      value: function hasSnapshotIgnition(historico) {
        return !!historico.snapshotId && historico.tipoPosicao === 'IGNICAO_LIGADA';
      }
    }, {
      key: 'isCoordinatesEqual',
      value: function isCoordinatesEqual(start, end) {
        return start && end ? start.toString() === end.toString() : false;
      }
    }, {
      key: 'getEventTooltip',
      value: function getEventTooltip(item) {
        var eventName = this.getTipoAlerta(item.descricao);
        return eventName && this.eventos[eventName] && angular.isDefined(this.eventos[eventName].tooltip) ? this.translate.instant(this.eventos[eventName].tooltip) : null;
      }
    }, {
      key: 'isEventTooltip',
      value: function isEventTooltip(item) {
        var eventName = this.getTipoAlerta(item.descricao);
        return eventName && this.eventos[eventName] && angular.isDefined(this.eventos[eventName].tooltip) ? this.eventos[eventName].tooltip : false;
      }
    }, {
      key: 'getSnapshotId',
      value: function getSnapshotId(historico) {
        return historico.snapshotId && historico.tipoPosicao !== 'IGNICAO_LIGADA' && historico.intensidade !== 'Abertura de vigência' ? historico.snapshotId : historico.eventSnapshotId;
      }
    }, {
      key: 'registerRoute',
      value: function registerRoute() {
        var url = this.state.href('root.duo-routes-cadastro.form', {
          importFromVehicle: this.veiculoId,
          importStartDateTime: this.dataReferencia.startDate,
          importEndDateTime: this.dataReferencia.endDate
        });

        this.window.open(url, '_blank');
      }
    }]);

    return HistoricoTimelineCtrl;
  }();

  /**
   * @ngdoc object
   * @name historico-timeline:HistoricoTimelineCtrl
   *
   * @description
   *
   */


  angular.module('historicoTimeline').constant('AGRUPAMENTOS_VALIDOS', ['ce.enum.eventos.movimento', 'ce.enum.eventos.parado', 'ce.enum.eventos.gpsInvalido']).controller('HistoricoTimelineCtrl', HistoricoTimelineCtrl);
})();
'use strict';

/* eslint-disable */

/**
 * Diretiva de terceiros, parcialmente modificada
 * TODO: caso for utilizar em outro lugar, tornar global e genérico
 */

/* global document, event */
(function (angular) {
  'use strict';

  var directiveModule = angular.module('historico-timeline-dropdown-multiselect', []);

  directiveModule.directive('dmDropdownStaticInclude', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
      var template = attrs.dmDropdownStaticInclude,
          contents = element.html(template).contents();
      $compile(contents)(scope);
    };
  }]);

  directiveModule.directive('historicoTimelineDropdownMultiselect', ['$filter', '$document', '$translate', function ($filter, $document, $translate) {
    return {
      restrict: 'AE',
      scope: {
        selectedModel: '=',
        options: '=',
        extraSettings: '=',
        events: '=',
        searchFilter: '=?',
        translationTexts: '=',
        groupBy: '@',
        disabled: '=',
        buttonText: '@?'
      },

      template: function template(element, attrs) {
        var checkboxes = !!attrs.checkboxes,
            groups = !!attrs.groupBy,
            template = void 0;

        template = '<div class="multiselect-parent btn-group dropdown-multiselect" ng-class="{open: open}">';
        template += '<button ng-disabled="disabled" type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()" data-testid="historico-timeline-filtro-eventos-dropdown-button">{{getButtonText()}}&nbsp;<span class="caret"></span></button>';
        template += '<ul class="dropdown-menu dropdown-menu-form" ng-if="open" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\', overflow: \'auto\' }" >';
        template += '<li ng-if="settings.showCheckAll && settings.selectionLimit !== 1" ><a ng-keydown="keyDownLink($event)" data-ng-click="selectAll()" tabindex="-1" id="selectAll" data-testid="historico-timeline-filtro-eventos-checkall-button"><span class="glyphicon glyphicon-ok" ng-if="options.length === selectedModel.length"></span>  {{ texts.checkAll | translate }}</a></li>';
        template += '<li ng-if="settings.showUncheckAll && settings.selectionLimit !== 1" ><a ng-keydown="keyDownLink($event)" data-ng-click="deselectAll()" tabindex="-1" id="uncheckAll" data-testid="historico-timeline-filtro-eventos-uncheckall-button"><span class="glyphicon glyphicon-ok" ng-if="selectedModel.length === 0"></span>  {{ texts.uncheckAll | translate }}</a></li>';
        template += '<li ng-if="settings.selectByGroups || settings.showCheckAll" class="divider"></li>';
        template += '<li ng-repeat="currentGroup in settings.selectByGroups track by $index" ng-click="selectCurrentGroup(currentGroup)"><a ng-class="{\'dropdown-selected-group\': selectedGroup === currentGroup}" tabindex="-1">{{ ::texts.selectGroup | translate }} {{::getGroupLabel(currentGroup)}}</a></li>';
        template += '<li ng-if="settings.selectByGroups && settings.showEnableSearchButton" class="divider"></li>';
        template += '<li ng-if="settings.showEnableSearchButton && settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click="toggleSearch($event);" tabindex="-1">{{texts.disableSearch}}</a></li>';
        template += '<li ng-if="settings.showEnableSearchButton && !settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click="toggleSearch($event);" tabindex="-1">{{texts.enableSearch}}</a></li>';
        template += '<li ng-if="settings.showEnableSearchButton" class="divider"></li>';
        template += '<li ng-if="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control searchField" ng-keydown="keyDownSearchDefault($event); keyDownSearch($event, input.searchFilter);" ng-style="{width: \'100%\'}" ng-model="input.searchFilter" placeholder="{{ texts.searchPlaceholder | translate }}" data-testid="historico-timeline-filtro-eventos-search"/></li>';
        template += '<li ng-if="settings.enableSearch" class="divider"></li>';

        if (groups) {
          template += '<li ng-repeat-start="option in orderedItems | filter:getFilter(input.searchFilter)" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupLabel(getPropertyForObject(option, settings.groupBy)) }}</li>';
          template += '<li ng-class="{\'active\': isChecked(getPropertyForObject(option,settings.idProp)) && settings.styleActive}" ng-repeat-end role="presentation">';
        } else {
          template += '<li ng-class="{\'active\': isChecked(getPropertyForObject(option,settings.idProp)) && settings.styleActive}" role="presentation" ng-repeat="option in options | filter:getFilter(input.searchFilter)">';
        }

        template += '<a ng-keydown="option.disabled || keyDownLink($event)" role="menuitem" class="option" tabindex="-1" ng-click="option.disabled || setSelectedItem(getPropertyForObject(option,settings.idProp), false, true)" ng-disabled="option.disabled" data-testid="historico-timeline-filtro-eventos-check-event-{{getPropertyForObject(option,settings.idProp)}}">';

        if (checkboxes) {
          template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> <span dm-dropdown-static-include="{{settings.template}}"></div></label></span></a>';
        } else {
          template += '<span data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(getPropertyForObject(option,settings.idProp))}"> </span> <span dm-dropdown-static-include="{{settings.template}}"></span></a>';
        }

        template += '</li>';

        template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
        template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{ texts.selectionCount | translate }}</a></li>';

        template += '</ul>';
        template += '</div>';

        return template;
      },

      link: function link($scope, $element, $attrs) {
        var $dropdownTrigger = $element.children()[0];

        $scope.toggleDropdown = function () {
          if ($scope.open) {
            $scope.close();
          } else {
            $scope.open = true;
          }
          if ($scope.settings.keyboardControls) {
            if ($scope.open) {
              if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                setTimeout(function () {
                  angular.element($element)[0].querySelector('.searchField').focus();
                }, 0);
              } else {
                focusFirstOption();
              }
            }
          }
          if ($scope.settings.enableSearch) {
            if ($scope.open) {
              setTimeout(function () {
                angular.element($element)[0].querySelector('.searchField').focus();
              }, 0);
            }
          }
        };

        $scope.checkboxClick = function ($event, id) {
          $scope.setSelectedItem(id, false, true);
          $event.stopImmediatePropagation();
        };

        $scope.externalEvents = {
          onItemSelect: angular.noop,
          onItemDeselect: angular.noop,
          onSelectAll: angular.noop,
          onDeselectAll: angular.noop,
          onInitDone: angular.noop,
          onMaxSelectionReached: angular.noop,
          onSelectionChanged: angular.noop,
          onClose: angular.noop
        };

        $scope.settings = {
          dynamicTitle: true,
          scrollable: false,
          scrollableHeight: '300px',
          closeOnBlur: true,
          displayProp: 'label',
          idProp: 'id',
          externalIdProp: 'id',
          enableSearch: true,
          selectionLimit: 0,
          showCheckAll: true,
          showUncheckAll: true,
          showEnableSearchButton: false,
          closeOnSelect: false,
          buttonClasses: 'btn btn-default',
          closeOnDeselect: false,
          groupBy: $attrs.groupBy || undefined,
          groupByTextProvider: null,
          smartButtonMaxItems: 5,
          smartButtonTextConverter: angular.noop,
          styleActive: false,
          keyboardControls: false,
          template: '{{getPropertyForObject(option, settings.displayProp)}}',
          searchField: '$',
          showAllSelectedText: false
        };

        $scope.texts = {
          checkAll: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.checkAll',
          uncheckAll: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.uncheckAll',
          selectionCount: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.selectionCount',
          selectionOf: '/',
          searchPlaceholder: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.searchPlaceholder',
          buttonDefaultText: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.buttonDefaultText',
          dynamicButtonTextSuffix: 'ce.mapa.historicoDetalhado.dynamicButtonTextSuffix',
          disableSearch: 'Desatilet busca',
          enableSearch: 'Atilet busca',
          selectGroup: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.selectGroup',
          allSelectedText: 'ce.mapa.historicoDetalhado.dropdownMultiselectDirective.allSelectedText'
        };

        $scope.input = {
          searchFilter: $scope.searchFilter || ''
        };

        if (angular.isDefined($scope.settings.groupBy)) {
          $scope.$watch('options', function (newValue) {
            if (angular.isDefined(newValue)) {
              $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
            }
          });
        }

        $scope.$watch('selectedModel', function (newValue) {
          $scope.singleSelection = !Array.isArray(newValue);
        });

        $scope.close = function () {
          $scope.open = false;
          $scope.externalEvents.onClose();
        };

        $scope.selectCurrentGroup = function (currentGroup) {
          $scope.selectedModel.splice(0, $scope.selectedModel.length);
          if ($scope.orderedItems) {
            $scope.orderedItems.forEach(function (item) {
              if (item[$scope.groupBy] === currentGroup) {
                $scope.setSelectedItem($scope.getPropertyForObject(item, $scope.settings.idProp), false, false);
              }
            });
          }
          $scope.externalEvents.onSelectionChanged();
        };

        angular.extend($scope.settings, $scope.extraSettings || []);
        angular.extend($scope.externalEvents, $scope.events || []);
        angular.extend($scope.texts, $scope.translationTexts);

        $scope.singleSelection = $scope.settings.selectionLimit === 1;

        function getFindObj(id) {
          var findObj = {};

          if ($scope.settings.externalIdProp === '') {
            findObj[$scope.settings.idProp] = id;
          } else {
            findObj[$scope.settings.externalIdProp] = id;
          }

          return findObj;
        }

        function clearObject(object) {
          for (var prop in object) {
            delete object[prop];
          }
        }

        if ($scope.singleSelection) {
          if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
            clearObject($scope.selectedModel);
          }
        }

        if ($scope.settings.closeOnBlur) {
          $document.on('click', function (e) {
            if ($scope.open) {
              var target = e.target.parentElement,
                  parentFound = false;

              while (angular.isDefined(target) && target !== null && !parentFound) {
                if (!!target.className.split && contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                  if (target === $dropdownTrigger) {
                    parentFound = true;
                  }
                }
                target = target.parentElement;
              }

              if (!parentFound) {
                $scope.$apply(function () {
                  $scope.close();
                });
              }
            }
          });
        }

        $scope.getGroupLabel = function (groupValue) {
          if ($scope.settings.groupByTextProvider !== null) {
            return $scope.settings.groupByTextProvider(groupValue);
          }

          return groupValue;
        };

        function textWidth(text) {
          var $btn = $element.find('button'),
              canvas = document.createElement('canvas'),
              ctx = canvas.getContext('2d');

          ctx.font = $btn.css('font-size') + $btn.css('font-family');
          ctx.originalFont = $btn.css('font-size') + $btn.css('font-family');
          ctx.fillStyle = '#000000';

          return ctx.measureText(text).width;
        }

        $scope.getButtonText = function () {
          var defaultText = $translate.instant($scope.buttonText || $scope.texts.buttonDefaultText);

          if ($scope.settings.dynamicTitle && $scope.selectedModel && ($scope.selectedModel.length > 0 || angular.isObject($scope.selectedModel) && Object.keys($scope.selectedModel).length > 0)) {
            var totalSelected = void 0;

            if ($scope.singleSelection) {
              totalSelected = $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) ? 1 : 0;
            } else {
              totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
            }

            if ($scope.settings.smartButtonMaxItems > 0) {
              var paddingWidth = 12 * 2,
                  borderWidth = 2,
                  dropdownIconWidth = 8,
                  widthLimit = $element[0].offsetWidth - paddingWidth - borderWidth - dropdownIconWidth,
                  itemsText = [];

              angular.forEach($scope.options, function (optionItem) {
                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                  var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp),
                      converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                  itemsText.push(converterResponse ? converterResponse : displayText);
                }
              });

              var result = itemsText.join(', '),
                  index = result.length - 1;

              if ($element[0].offsetWidth === 0) {
                return result;
              }

              while (textWidth(result) > widthLimit && index > 0) {
                if (itemsText[itemsText.length - 1] !== '...') {
                  itemsText.push('...');
                  result = result + '... (' + (totalSelected === $scope.options.length ? $translate.instant($scope.texts.allSelectedText) : totalSelected) + ')';
                }
                result = result.slice(0, index) + result.slice(index + 1);
                index--;
              }

              return result;
            } else {
              if (totalSelected === 0) {
                return defaultText;
              }

              if ($scope.settings.showAllSelectedText && totalSelected === $scope.options.length) {
                return $translate.instant($scope.texts.allSelectedText);
              }

              return totalSelected + ' ' + $translate.instant($scope.texts.dynamicButtonTextSuffix);
            }
          } else {
            return defaultText;
          }
        };

        $scope.getPropertyForObject = function (object, property) {
          if (angular.isDefined(object) && object.hasOwnProperty(property)) {
            return object[property];
          }

          return undefined;
        };

        $scope.selectAll = function () {
          var searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter)),
              totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;

          if (searchResult.length === totalSelected) {
            $scope.deselectAll();
          } else {
            $scope.deselectAll(true);
            $scope.externalEvents.onSelectAll();

            angular.forEach(searchResult, function (value) {
              $scope.setSelectedItem(value[$scope.settings.idProp], true, false);
            });
            $scope.externalEvents.onSelectionChanged();
            $scope.selectedGroup = null;
          }
        };

        $scope.deselectAll = function (dontSendEvent) {
          dontSendEvent = dontSendEvent || false;

          if (!dontSendEvent) {
            $scope.externalEvents.onDeselectAll();
          }

          if ($scope.singleSelection) {
            clearObject($scope.selectedModel);
          } else {
            $scope.selectedModel.splice(0, $scope.selectedModel.length);
          }
          if (!dontSendEvent) {
            $scope.externalEvents.onSelectionChanged();
          }
          $scope.selectedGroup = null;
        };

        $scope.setSelectedItem = function (id, dontRemove, fireSelectionChange) {
          var findObj = getFindObj(id),
              finalObj = null;

          if ($scope.settings.externalIdProp === '') {
            finalObj = find($scope.options, findObj);
          } else {
            finalObj = findObj;
          }

          if ($scope.singleSelection) {
            clearObject($scope.selectedModel);
            angular.extend($scope.selectedModel, finalObj);
            if (fireSelectionChange) {
              $scope.externalEvents.onItemSelect(finalObj);
            }
            if ($scope.settings.closeOnSelect || $scope.settings.closeOnDeselect) {
              $scope.close();
            }
          } else {
            dontRemove = dontRemove || false;

            var exists = findIndex($scope.selectedModel, findObj) !== -1;

            if (!dontRemove && exists) {
              $scope.selectedModel.splice(findIndex($scope.selectedModel, findObj), 1);
              $scope.externalEvents.onItemDeselect(findObj);
              if ($scope.settings.closeOnDeselect) {
                $scope.close();
              }
            } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
              $scope.selectedModel.push(finalObj);
              if (fireSelectionChange) {
                $scope.externalEvents.onItemSelect(finalObj);
              }
              if ($scope.settings.closeOnSelect) {
                $scope.close();
              }
              if ($scope.settings.selectionLimit > 0 && $scope.selectedModel.length === $scope.settings.selectionLimit) {
                $scope.externalEvents.onMaxSelectionReached();
              }
            }
          }
          if (fireSelectionChange) {
            $scope.externalEvents.onSelectionChanged();
          }
          $scope.selectedGroup = null;
        };

        $scope.isChecked = function (id) {
          if ($scope.singleSelection) {
            if ($scope.settings.externalIdProp === '') {
              return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
            }
            return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.externalIdProp]) && $scope.selectedModel[$scope.settings.externalIdProp] === getFindObj(id)[$scope.settings.externalIdProp];
          }

          return findIndex($scope.selectedModel, getFindObj(id)) !== -1;
        };

        $scope.externalEvents.onInitDone();

        $scope.keyDownLink = function (event) {
          var sourceScope = angular.element(event.target).scope(),
              nextOption = void 0,
              parent = event.target.parentNode;

          if (!$scope.settings.keyboardControls) {
            return;
          }
          if (event.keyCode === 13 || event.keyCode === 32) {
            // enter
            event.preventDefault();
            if (!!sourceScope.option) {
              $scope.setSelectedItem($scope.getPropertyForObject(sourceScope.option, $scope.settings.idProp), false, true);
            } else if (event.target.id === 'deselectAll') {
              $scope.deselectAll();
            } else if (event.target.id === 'selectAll') {
              $scope.selectAll();
            }
          } else if (event.keyCode === 38) {
            // up arrow
            event.preventDefault();
            if (!!parent.previousElementSibling) {
              nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
            }
            while (!nextOption && !!parent) {
              parent = parent.previousElementSibling;
              if (!!parent) {
                nextOption = parent.querySelector('a') || parent.querySelector('input');
              }
            }
            if (!!nextOption) {
              nextOption.focus();
            }
          } else if (event.keyCode === 40) {
            // down arrow
            event.preventDefault();
            if (!!parent.nextElementSibling) {
              nextOption = parent.nextElementSibling.querySelector('a') || parent.nextElementSibling.querySelector('input');
            }
            while (!nextOption && !!parent) {
              parent = parent.nextElementSibling;
              if (!!parent) {
                nextOption = parent.querySelector('a') || parent.querySelector('input');
              }
            }
            if (!!nextOption) {
              nextOption.focus();
            }
          } else if (event.keyCode === 27) {
            event.preventDefault();
            $scope.toggleDropdown();
          }
        };

        $scope.keyDownSearchDefault = function (event) {
          var parent = event.target.parentNode.parentNode,
              nextOption = void 0;

          if (!$scope.settings.keyboardControls) {
            return;
          }

          if (event.keyCode === 9 || event.keyCode === 40) {
            // tab
            event.preventDefault();
            focusFirstOption();
          } else if (event.keyCode === 38) {
            event.preventDefault();
            if (!!parent.previousElementSibling) {
              nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
            }
            while (!nextOption && !!parent) {
              parent = parent.previousElementSibling;
              if (!!parent) {
                nextOption = parent.querySelector('a') || parent.querySelector('input');
              }
            }
            if (!!nextOption) {
              nextOption.focus();
            }
          } else if (event.keyCode === 27) {
            event.preventDefault();
            $scope.toggleDropdown();
          }
        };

        $scope.keyDownSearch = function (event, searchFilter) {
          var searchResult = void 0;

          if (!$scope.settings.keyboardControls) {
            return;
          }

          if (event.keyCode === 13) {
            if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
              searchResult = $filter('filter')($scope.options, $scope.getFilter(searchFilter));
              if (searchResult.length === 1) {
                $scope.setSelectedItem($scope.getPropertyForObject(searchResult[0], $scope.settings.idProp), false, true);
              }
            } else if ($scope.settings.enableSearch) {
              $scope.selectAll();
            }
          }
        };

        $scope.getFilter = function (searchFilter) {
          var filter = {};
          filter[$scope.settings.searchField] = searchFilter;
          return filter;
        };

        $scope.toggleSearch = function ($event) {
          if ($event) {
            $event.stopPropagation();
          }
          $scope.settings.enableSearch = !$scope.settings.enableSearch;
          if (!$scope.settings.enableSearch) {
            $scope.input.searchFilter = '';
          }
        };

        $scope.keyDownToggleSearch = function () {
          if (!$scope.settings.keyboardControls) {
            return;
          }
          if (event.keyCode === 13) {
            $scope.toggleSearch();
            if ($scope.settings.enableSearch) {
              setTimeout(function () {
                angular.element($element)[0].querySelector('.searchField').focus();
              }, 0);
            } else {
              focusFirstOption();
            }
          }
        };

        function focusFirstOption() {
          setTimeout(function () {
            var elementToFocus = angular.element($element)[0].querySelector('.option');
            if (angular.isDefined(elementToFocus) && elementToFocus !== null) {
              elementToFocus.focus();
            }
          }, 0);
        }
      }
    };
  }]);

  function contains(collection, target) {
    var containsTarget = false;
    collection.some(function (object) {
      if (object === target) {
        containsTarget = true;
        return true;
      }
    });
    return containsTarget;
  }

  function find(collection, properties) {
    var target = void 0;

    collection.some(function (object) {
      var hasAllSameProperties = true;
      Object.keys(properties).forEach(function (key) {
        if (object[key] !== properties[key]) {
          hasAllSameProperties = false;
        }
      });
      if (hasAllSameProperties) {
        target = object;
        return true;
      }
    });

    return target;
  }

  function findIndex(collection, properties) {
    var index = -1,
        counter = -1;

    collection.some(function (object) {
      var hasAllSameProperties = true;
      counter += 1;
      Object.keys(properties).forEach(function (key) {
        if (object[key] !== properties[key]) {
          hasAllSameProperties = false;
        }
      });
      if (hasAllSameProperties) {
        index = counter;
        return true;
      }
    });

    return index;
  }
})(angular);
/* eslint-enbled */
'use strict';

(function () {
  'use strict';

  angular.module('requisicaoVideo', ['AlertasModule', 'angularMoment', 'restangular', 'alert-message', 'pascalprecht.translate', 'ServiceVfiltroModule', 'ConstantModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ModalRequisicaoVideoCtrl = function () {
    function ModalRequisicaoVideoCtrl(AlertasEnum, moment, Restangular, AlertMessage, $translate, ServiceVfiltro, GoogleTagManagerUtils, Authenticator, MeasurementUnitConverterService, FeatureHubConfigKeys, FeaturehubJsSdk) {
      var _this = this;

      _classCallCheck(this, ModalRequisicaoVideoCtrl);

      this.alertasEnum = AlertasEnum;
      this.moment = moment;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.translate = $translate;
      this.serviceVfiltro = ServiceVfiltro;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator = Authenticator;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.user = null;

      this.authenticator.getUser().then(function (user) {
        _this.user = user;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateFormat(user.measurementUnits.dateTimeFormat);
      });
    }

    _createClass(ModalRequisicaoVideoCtrl, [{
      key: '$onInit',
      value: function $onInit() {
        this.alerta = this.resolve.alerta;

        if (this.alerta && this.alerta.user) {
          this.user = this.alerta.user;
        }

        this.isSnapshotRequest = !!this.resolve.isSnapshotRequest;
        this.tipoAlerta = this.alertasEnum.getAlerta(this.alerta.tipo);
        this.inicioVideo = this.moment(this.alerta.datahora).subtract(5, 'seconds').toISOString();
        this.fimVideo = this.moment(this.alerta.datahora).add(10, 'seconds').toISOString();
        this.snapshotCameras = [];
        this.buildSnapshotCameras();

        if (this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_6_CAMERAS)) {
          this.cameras = ['CAMERA_1', 'CAMERA_2', 'CAMERA_3', 'CAMERA_4', 'CAMERA_5', 'CAMERA_6'];
        } else {
          this.cameras = ['CAMERA_1', 'CAMERA_2', 'CAMERA_3', 'CAMERA_4', 'CAMERA_5'];
        }
      }
    }, {
      key: 'getIconBackgroundColor',
      value: function getIconBackgroundColor() {
        return 'bg-' + this.tipoAlerta.cor;
      }
    }, {
      key: 'qualificaAlerta',
      value: function qualificaAlerta(tipoAlerta, nivel) {
        if (nivel) {
          return tipoAlerta + '_' + nivel;
        }
        return tipoAlerta;
      }
    }, {
      key: 'request',
      value: function request() {
        if (this.isSnapshotRequest) {
          this.requestSnapshot();
        } else {
          this.requisitarVideo();
        }
      }
    }, {
      key: 'requisitarVideo',
      value: function requisitarVideo() {
        var _this2 = this;

        this.sendEventToGTM();
        this.restangular.all('video/videos').withHttpConfig({ transformResponse: angular.identity }).post({
          idVeiculo: this.alerta.veiculo.id,
          inicioVideo: this.inicioVideo,
          fimVideo: this.fimVideo,
          descricao: this.translate.instant(this.tipoAlerta.descricao),
          dataHoraEvento: this.alerta.datahora,
          tipoEvento: this.qualificaAlerta(this.tipoAlerta.id, this.alerta.nivel),
          cameras: this.cameras
        }).then(function (videoId) {
          if (_this2.resolve.onRequestCompleted && angular.isFunction(_this2.resolve.onRequestCompleted)) {
            _this2.resolve.onRequestCompleted();
          }
          _this2.close({ $value: videoId });
        }).catch(function () {
          _this2.alertMessage.create({
            type: 'error',
            message: _this2.translate.instant('ce.analise.alertas.requisicaoVideo.errorMsg'),
            appendTo: '.alerta-aqui-requisicao-video'
          });
        });
      }
    }, {
      key: 'requestSnapshot',
      value: function requestSnapshot() {
        var _this3 = this;

        this.restangular.all('video/snapshots').post({
          uoId: this.alerta.uoId,
          veiculoId: this.alerta.veiculo.id,
          dateTime: this.alerta.datahora,
          type: 'TELEMETRY_EVENT',
          cameras: this.snapshotCameras
        }).then(function (response) {
          _this3.close({
            $value: {
              snapshotId: response.id
            }
          });
        }).catch(function () {
          _this3.alertMessage.create({
            type: 'error',
            message: _this3.translate.instant('ce.analise.alertas.requisicaoVideo.errorMsg'),
            appendTo: '.alerta-aqui-requisicao-video'
          });
        });
      }
    }, {
      key: 'sendEventToGTM',
      value: function sendEventToGTM() {
        this.googleTagManagerUtils.sendEventClickGTM('analise_alertas_solicitar_video', this.serviceVfiltro.factoryVfiltro.user || this.user);
      }
    }, {
      key: 'buildSnapshotCameras',
      value: function buildSnapshotCameras() {
        for (var i = 0; i < 5; i++) {
          this.snapshotCameras.push({
            indice: i
          });
        }
      }
    }]);

    return ModalRequisicaoVideoCtrl;
  }();

  angular.module('requisicaoVideo').component('modalRequisicaoVideo', {
    controller: ModalRequisicaoVideoCtrl,
    templateUrl: 'historico-alerta/modal-requisicao-video.tpl.html',
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    }
  });
})();
'use strict';

(function () {
  'use strict';

  function paginacaoAlerta() {
    return {
      scope: {
        navigationSetting: '=',
        setpage: '='
      },
      templateUrl: 'historico-alerta/historico-paginacao-directive.tpl.html',
      link: function link(scope) {
        scope.pagina = function pagina(i) {
          var paginasTotais = Math.min(5, scope.navigationSetting.numberOfPages);

          if (scope.navigationSetting.currentPage <= Math.floor(paginasTotais / 2)) {
            return i + 1;
          } else if (scope.navigationSetting.currentPage + Math.floor(paginasTotais / 2) > scope.navigationSetting.numberOfPages) {
            return scope.navigationSetting.numberOfPages - (paginasTotais - 1) + i;
          }
          return scope.navigationSetting.currentPage + i - Math.floor(paginasTotais / 2);
        };

        scope.isFirst = function isFirst() {
          return scope.navigationSetting.currentPage === 1;
        };

        scope.isLast = function isLast() {
          return scope.navigationSetting.currentPage === scope.navigationSetting.numberOfPages;
        };

        scope.lastRegistroPagina = function lastRegistroPagina() {
          return Math.min(scope.navigationSetting.start + scope.navigationSetting.number || 10, scope.navigationSetting.total);
        };
      }
    };
  }

  angular.module('historicoAlertaPaginacao', []).directive('paginacaoAlerta', paginacaoAlerta);
})();
'use strict';

(function () {
  'use strict';

  angular.module('historicoAlerta', ['ui.router', 'ui.bootstrap', 'ngSanitize', 'restangular', 'historicoAlertaPaginacao', 'validateUtilModule', 'requisicaoVideo', 'statusVideo', 'videoPlayer', 'pascalprecht.translate', 'usuarioModule', 'angularMoment', 'smart-table', 'VtabelaModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'UrlModule', 'ObjetosVfiltroModule', 'AlertasModule', 'pascalprecht.translate', 'urlConfigModule', 'ConstantModule', 'uoModule', 'TagIgnoreModule']).factory('RelatorioAlerta', function (Restangular) {
    var service = Restangular.service('alerta/relatorio');
    service.get = function (uoId, params) {
      return Restangular.service('alerta/relatorio/uo/' + uoId).one().get(params);
    };

    return service;
  }).factory('AlertsTag', function (Restangular) {
    var service = Restangular.service('alerta/tags');
    service.get = function (ouId) {
      return Restangular.service('alerta/tags').one().get({
        ouId: ouId,
        active: true,
        visible: true,
        fields: ['id', 'name', 'ouId', 'ignoreIndicator'].join(',')
      });
    };

    return service;
  }).factory('TiposAlerta', function (Restangular) {
    return Restangular.service('alerta/tipos');
  }).factory('Alertas', function (Restangular) {
    return Restangular.service('alerta/alertas');
  }).factory('HistoricoAlerta', function (Restangular) {
    return Restangular.service('alerta/historico-alertas');
  });
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.historicoAlerta', {
      url: '/historico-alerta?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'historico-alerta/historico-alerta.tpl.html',
          controller: 'HistoricoAlertaCtrl',
          controllerAs: 'historicoAlerta'
        }
      },
      data: {
        titulo: 'ce.analise.alertas.titulo',
        role: 'HISTORICO_ALERTA_VISUALIZAR'
      }
    });
  }

  angular.module('historicoAlerta').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, Intl, document */

  var HistoricoAlertaCtrl = function () {
    function HistoricoAlertaCtrl($uibModal, $rootScope, $window, $httpParamSerializer, $sce, ConvertersService, $q, RelatorioAlerta, moment, v3gTableLimitService, ValidateUtil, VtabelaFactory, Keys, ServiceVfiltro, FactoryVfiltro, UrlService, ObjetosVfiltroService, Authenticator, $filter, AlertasEnum, StatusVideo, MultiVideoService, $translate, GoogleTagManagerUtils, Uos, MeasurementUnitConverterService, FeaturehubJsSdk, FeatureHubConfigKeys, $document, safetyService, DecoratedVideoPlayerService, FeatureOuService, CurrentViewStateService, SpeedingBucketService, CadastroVeiculoService) {
      var _this = this;

      _classCallCheck(this, HistoricoAlertaCtrl);

      this.uibModal = $uibModal;
      this.$q = $q;
      this.rootScope = $rootScope;
      this.window = $window;
      this.convertersService = ConvertersService;
      this.httpParamSerializer = $httpParamSerializer;
      this.sce = $sce;
      this.relatorioAlertaService = RelatorioAlerta;
      this.moment = moment;
      this.v3gTableLimitService = v3gTableLimitService;
      this.validateUtil = ValidateUtil;
      this.vtabelaFactory = VtabelaFactory;
      this.multiVideoService = MultiVideoService;
      this.uoService = Uos;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.authenticator = Authenticator;
      this.uoIdUsuarioLogado = null;
      this.isIntegrationSupplierFlagEnable = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_INTEGRATION_SUPPLIER_ENABLE);
      this.isTagFilterFeatureEnabled = FeaturehubJsSdk.isFeatureEnabled('LAINT49_tag_filter');
      this.is7DaysFeatureEnabled = FeaturehubJsSdk.isFeatureEnabled('PSVI223_last_7_days');
      this.isDecoratedModalWithoutVideoEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DECORATED_MODAL_WITHOUT_VIDEO);
      this.isAiAnalysisColumnEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_AI_ANALYSIS_COLUMN);
      this.isEventsCardViewLatamEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.EVENTS_CARD_VIEW_LATAM);
      this.isFilterEventByDriverEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FILTER_EVENT_BY_DRIVER);
      this.isCoachingNonNaEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.COACHING_NON_NA);
      this.isDecoratedVideoPlayerEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DECORATED_VIDEO_PLAYER);
      this.multiVideoPlayerModal = null;
      this.speedingBucketService = SpeedingBucketService;
      this.speedingLevels = null;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.safetyService = safetyService;
      this.decoratedVideoPlayerService = DecoratedVideoPlayerService;
      this.featureOuService = FeatureOuService;
      this.cadastroVeiculoService = CadastroVeiculoService;
      this.uoWithRecFacial = false;
      this.isNa = false;
      this.currentViewStateService = CurrentViewStateService;
      this.urlService = UrlService;
      this.objetosVfiltroService = ObjetosVfiltroService;
      this.filter = $filter;
      this.alertasEnum = AlertasEnum;
      this.alertasExpurgo = AlertasEnum.getTiposExpurgo();
      this.statusVideo = StatusVideo;
      this.translate = $translate;
      this.labelSemMotorista = this.translate.instant('ce.analise.alertas.colunas.motorista.semIdentificacao');
      this.tooltipNaoAplica = this.translate.instant('ce.analise.alertas.colunas.excessoTooltipNaoAplica');
      this.tooltipDias = this.translate.instant('ce.analise.alertas.colunas.excessoTooltipDias');
      this.semVideo = this.translate.instant('ce.analise.alertas.colunas.video.semVideo');
      this.semFoto = this.translate.instant('ce.analise.alertas.colunas.video.semFoto');
      this.solicitarVideo = this.translate.instant('ce.analise.alertas.colunas.video.solicitarVideo');
      this.solicitarImagem = this.translate.instant('ce.analise.alertas.colunas.video.solicitarImagem');
      this.processando = this.translate.instant('ce.analise.alertas.colunas.video.processando');
      this.videoNaoDisponivel = this.translate.instant('ce.analise.alertas.colunas.video.tooltipNaoDisponivel');
      this.semSinal = this.translate.instant('ce.enum.common.semSinal');
      this.abonarEvento = this.translate.instant('ce.analise.alertas.colunas.abonarEvento');
      this.cliqueParaVer = this.translate.instant('ce.analise.alertas.detalhes.cliqueParaVerTooltip');
      this.alertaSemVideo = this.translate.instant('notificacoes.solicitacaoDownload.tooltipNoVideo');
      this.currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.user = null;

      this.tableState = this.objetosVfiltroService.getTableStateUrl();
      this.vtabela = null;
      this.exportsPdf = false;
      this.exibirCampoExcesso = true;
      this.exibirCampoDuracao = true;
      this.exibirCampoAbono = false;
      this.trusted = {};
      this.tooltipSemSinal = {};
      this.options = {
        10: '10',
        20: '20',
        50: '50'
      };
      this.status = {
        NOVO: { label: this.translate.instant('ce.analise.alertas.status.novo'), cor: 'bg-green' },
        RESOLVIDO: { label: this.translate.instant('ce.analise.alertas.status.resolvido'), cor: 'bg-blue' },
        ATRIBUIDO: { label: this.translate.instant('ce.analise.alertas.status.atribuido'), cor: 'bg-orange' }
      };
      this.nivel = {
        BAIXO: { label: this.translate.instant('ce.analise.alertas.nivel.baixo'), cor: 'bg-blue' },
        MEDIO: { label: this.translate.instant('ce.analise.alertas.nivel.medio'), cor: 'bg-yellow' },
        ALTO: { label: this.translate.instant('ce.analise.alertas.nivel.alto'), cor: 'bg-red' }
      };
      this.trusted = {};
      this.stItemsByPage = 10;
      this.dataPreprocessada = this.moment('2017-10-01T00:00:00-0300');
      this.maxCsvSize = 40000;

      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator.getUser().then(function (user) {
        _this.user = user;
        _this.uoIdUsuarioLogado = user ? user.uo.id : null;
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormat(user.measurementUnits.dateTimeFormat);
        _this.speedMeasurement = user.measurementUnits.speedMeasurement;
        _this.getEventsConfig(user.uo.id).then(function () {
          _this.speedingBucketService.getFormattedSpeedingLevels(user.uo.id).then(function (speedingLevels) {
            _this.speedingLevels = speedingLevels;

            var defaultValues = {
              hoje: { active: true },
              ontem: { active: true }
            };

            var dateLimit = 1;

            if (_this.is7DaysFeatureEnabled) {
              defaultValues.ultimos7dias = { active: true };
              dateLimit = 7;
            }

            ServiceVfiltro.init(FactoryVfiltro.get([{
              key: _this.keys.dateTime.name,
              dateLimit: dateLimit,
              time: true,
              maxDate: _this.moment().endOf('day').format(),
              defaultValues: defaultValues
            }, {
              key: _this.keys.uo.name,
              size: 12
            }, {
              name: 'uoParceira',
              key: _this.keys.uoParceira.name,
              size: 6
            }, {
              name: 'veiculo',
              key: _this.keys.veiculo.name,
              size: 6
            }].concat(_toConsumableArray(!_this.eventNAConfig ? [{
              key: _this.keys.status.name,
              size: 6
            }] : []), [{
              key: _this.keys.nivel.name,
              size: 6
            }, {
              key: _this.keys.tipos.name,
              size: 12
            }], _toConsumableArray(!_this.eventNAConfig ? [{
              key: _this.keys.usuario.name,
              size: 6
            }] : []), [{
              key: _this.keys.feedbackVideo.name,
              size: 6
            }], _toConsumableArray(_this.isFilterEventByDriverEnabled ? [{
              name: 'motoristaId',
              key: _this.keys.motorista.name,
              onlyActive: false,
              order: _this.keys.feedbackVideo.order + 0.5,
              size: 6
            }] : []), _toConsumableArray(!_this.eventNAConfig ? [{
              key: _this.keys.eventoTic.name,
              size: 6
            }] : []), _toConsumableArray(_this.isTagFilterFeatureEnabled ? [{
              key: _this.keys.tags.name,
              size: 12
            }] : []), [{
              key: _this.keys.statusVideos.name,
              size: 12
            }], _toConsumableArray(_this.eventNAConfig ? [{
              key: _this.keys.coaching.name,
              size: 12
            }] : [])))).then(function (filtro) {
              var statusVideosFiltro = _this.serviceVfiltro.factoryVfiltro.filtroCompleto.find(function (f) {
                return f.key === _this.keys.statusVideos.name;
              });
              if (statusVideosFiltro) {
                statusVideosFiltro.defaultValues = statusVideosFiltro.defaultValues.filter(function (v) {
                  return v.id !== 'ERRO';
                });
              }
              _this.loadView();
              _this.ouId = filtro.find(function (x) {
                return x.key === _this.keys.uo.name;
              }).value.id;
              _this.resolveUoWithRecFacial(_this.ouId);
              _this.resolveIsNa(_this.ouId);
              _this.isAdminVeltec = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ADMIN_VELTEC');
              _this.roleAbonoEditar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ABONO_EDITAR');
              _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('HISTORICO_ALERTA_EDITAR');
              _this.roleHistoricoDetalhado = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('HISTORICO_DETALHADO_VISUALIZAR');
              _this.roleVisualizarVideo = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIDEO_VISUALIZAR');
              _this.roleSolicitarVideo = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('VIDEO_EDITAR');
              _this.exibirCampoAbono = _this.roleAbonoEditar;
              _this.iniciaTabelaConsulta();
            });
          });
        });
      });
      this.currentView = this.currentViewStateService.getCurrentView();
      this.isThumbnailsViewButtonEnabled = this.currentViewStateService.isThumbnailsViewButtonEnabled;
      this.document = $document[0];

      // Called by the thumbnail view with its alert DTO. Picks the same player as the table's event-viewer-link.
      this.openVideoPlayer = function (alert) {
        return _this.shouldDisplayDecoratedVideoPlayer().then(function (shouldDisplayDecorated) {
          var playerData = {
            idVideo: alert.videoId,
            snapshotId: alert.snapshotId,
            datahora: alert.datahora,
            latitude: alert.latitude,
            longitude: alert.longitude,
            vehicleId: alert.vehicleId,
            vehiclePrefix: alert.vehiclePrefix,
            vehiclePlate: alert.vehiclePlate,
            driverName: alert.driverName,
            tipoEvento: alert.tipoEvento,
            threshold: alert.threshold,
            eventDuration: alert.eventDuration,
            actualValue: alert.actualValue,
            eventLevel: alert.eventLevel,
            statusVideo: alert.statusVideo
          };

          if (!shouldDisplayDecorated) {
            return _this.openMultiVideoPlayer(playerData);
          }

          return _this.decoratedVideoPlayerService.loadDecoratedVideoPlayer(Object.assign({}, playerData, {
            coordinates: alert.coordinates,
            user: _this.user
          }));
        });
      };

      this.openVideoPlayerWithoutVideo = function (alert) {
        var vehicleId = alert.veiculo ? alert.veiculo.id : alert.vehicleId,
            liveRow = _this.vtabela && _this.vtabela.grid && vehicleId && alert.datahora ? _this.vtabela.grid.data.find(function (row) {
          return String(row.veiculo.id).trim() === String(vehicleId).trim() && String(row.datahora).trim() === String(alert.datahora).trim();
        }) : null,
            props = {
          snapshotId: alert.snapshotId,
          datahora: alert.datahora,
          latitude: alert.latitude,
          longitude: alert.longitude,
          vehicleId: vehicleId,
          vehiclePrefix: alert.prefixo,
          vehiclePlate: alert.placa,
          driverName: alert.motorista,
          tipoEvento: alert.tipo,
          threshold: alert.limiar,
          eventDuration: alert.duracao,
          actualValue: alert.excesso,
          eventLevel: alert.nivel,
          alertaId: alert.id,
          user: _this.user,
          coordinates: alert.coordinates,
          requestVideo: function requestVideo(onRequestCompleted) {
            return _this.abrirModalRequisicaoVideo(liveRow || alert, onRequestCompleted);
          },
          requestVideoPermission: _this.roleSolicitarVideo,
          statusVideo: liveRow ? liveRow.statusVideo : alert.statusVideo
        };
        return _this.decoratedVideoPlayerService.loadDecoratedVideoPlayer(props);
      };

      this.onUpdateVideo();
      if (this.window.addEventListener) {
        var registeredWindow = this.window,
            onVideoRequested = function onVideoRequested(event) {
          var _event$detail = event.detail,
              vehicleId = _event$detail.vehicleId,
              datahora = _event$detail.datahora,
              statusVideo = _event$detail.statusVideo,
              videoId = _event$detail.videoId,
              linha = _this.vtabela && _this.vtabela.grid && vehicleId && datahora ? _this.vtabela.grid.data.find(function (row) {
            return String(row.veiculo.id).trim() === String(vehicleId).trim() && String(row.datahora).trim() === String(datahora).trim();
          }) : null;

          if (linha) {
            linha.statusVideo = statusVideo;
            if (videoId && !linha.videoId) {
              linha.videoId = videoId;
            }
            if (_this.vtabela.grid.api && _this.vtabela.grid.api.core) {
              _this.vtabela.grid.api.core.refreshRows([linha]);
              _this.vtabela.grid.api.core.notifyDataChange('all');
            }
          }
        };
        registeredWindow.addEventListener('videoRequestedEvent', onVideoRequested);
        this.rootScope.$on('$destroy', function () {
          registeredWindow.removeEventListener('videoRequestedEvent', onVideoRequested);
        });
      }
      this.rootScope.$on('updateTable', function (event, data) {
        if (data && data.vehicleId && data.datahora) {
          var linhaIndex = _this.vtabela.grid.data.findIndex(function (row) {
            var rowVehicleId = String(row.veiculo.id).trim(),
                rowDatahora = String(row.datahora).trim(),
                dataVehicleId = String(data.vehicleId).trim(),
                dataDatahora = String(data.datahora).trim();
            return rowVehicleId === dataVehicleId && rowDatahora === dataDatahora;
          });

          if (linhaIndex !== -1) {
            var linha = _this.vtabela.grid.data[linhaIndex];
            if (typeof data.coachingStatus !== 'undefined') {
              linha.coachingStatus = data.coachingStatus;
            }
            if (_this.vtabela.grid.api && _this.vtabela.grid.api.core) {
              _this.vtabela.grid.api.core.refreshRows([linha]);
              _this.vtabela.grid.api.core.notifyDataChange('all');
            } else {
              setTimeout(function () {
                if (_this.vtabela.grid.api && _this.vtabela.grid.api.core) {
                  _this.vtabela.grid.api.core.refreshRows([linha]);
                  _this.vtabela.grid.api.core.notifyDataChange('all');
                } else {
                  console.error('API do grid ainda não está disponível após tentativa de inicialização.');
                }
              }, 500);
            }
          } else {
            console.warn('Nenhuma linha encontrada para o ve\xEDculo com ID: ' + data.vehicleId);
          }
        } else {
          console.warn('Dados inválidos recebidos no evento "updateVehicleTable".');
        }
      });
      this.rootScope.$on('commentSavedEvent', function (event, data) {
        if (data && data.vehicleId && data.datahora) {
          var linhaIndex = _this.vtabela.grid.data.findIndex(function (row) {
            var rowVehicleId = String(row.veiculo.id).trim(),
                dataVehicleId = String(data.vehicleId).trim(),
                rowDatahora = String(row.datahora).trim(),
                dataHora = String(data.datahora).trim();
            return rowVehicleId === dataVehicleId && rowDatahora === dataHora;
          });
          if (linhaIndex !== -1) {
            var linha = _this.vtabela.grid.data[linhaIndex];
            linha.comentarios = (linha.comentarios || 0) + 1;
            if (_this.vtabela.grid.api && _this.vtabela.grid.api.core) {
              _this.vtabela.grid.api.core.refreshRows([linha]);
              _this.vtabela.grid.api.core.notifyDataChange('all');
            } else {
              setTimeout(function () {
                if (_this.vtabela.grid.api && _this.vtabela.grid.api.core) {
                  _this.vtabela.grid.api.core.refreshRows([linha]);
                  _this.vtabela.grid.api.core.notifyDataChange('all');
                } else {
                  console.error('API do grid ainda não está disponível após tentativa de inicialização (comentário).');
                }
              }, 500);
            }
          } else {
            console.warn('Linha para comentário não encontrada!');
          }
        }
      });
    }

    _createClass(HistoricoAlertaCtrl, [{
      key: 'iniciaTabelaConsulta',
      value: function iniciaTabelaConsulta() {
        this.vtabela = this.vtabelaFactory.get(this.initVtabela(), this.serviceVfiltro.factoryVfiltro.user, 'historicoAlerta', this.isIntegrationSupplierFlagEnable ? 'v6' : 'v5');
        this.consultar();
      }
    }, {
      key: 'getMaisOpcoesMsg',
      value: function getMaisOpcoesMsg() {
        if (this.vtabela.rowsSelected.length === 0) {
          return this.translate.instant('ce.analise.alertas.opcoes.msg');
        }
      }
    }, {
      key: 'onUpdateVideo',
      value: function onUpdateVideo() {
        var _this2 = this;

        this.multiVideoService.sharedScope.$on('update-video', function (_, video) {
          var alertasComVideoASerAtualizado = _this2.vtabela.grid.data.filter(function (alerta) {
            return alerta.videoId === video.id;
          });
          alertasComVideoASerAtualizado.forEach(function (alerta) {
            alerta.statusVideo = video.state;
            alerta.usuarioEmailAssistiuVideo = video.userLogin;
            if (angular.isUndefined(alerta.feedback) && angular.isDefined(video.feedbackAnswer)) {
              alerta.feedback = Boolean(video.feedbackAnswer);
              alerta.usuarioFeedbackEmail = video.userLogin;
            }
          });
        });
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var _this3 = this;

        var shouldRequestThumbnails = this.eventNAConfig || this.isEventsCardViewLatamEnabled;
        return {
          virtualizationThreshold: 150,
          columnVirtualizationThreshold: 99,
          enableVtabelaExport: false,
          enableFiltering: false,
          useExternalPagination: true,
          useExternalSorting: true,
          paginationCurrentPage: 1,
          appScopeProvider: this,
          getPage: function getPage(limit, offset, orderBy, orderDirection) {
            var uo = _this3.serviceVfiltro.filtroTopbar.find(function (x) {
              return x.key === _this3.keys.uo.name;
            }).value.id;
            return _this3.relatorioAlertaService.get(uo, _this3.getParams(limit, offset, orderBy, orderDirection, shouldRequestThumbnails)).then(function (dat) {
              _this3.vtabela.grid.totalItems = dat.total;
              _this3.vtabela.setData(dat.list.map(function (item) {
                return _this3.getItemVtabela(item);
              }));
              _this3.vtabela.rowsSelected = [];
              if (_this3.currentViewStateService.isThumbnailsViewButtonEnabled) {
                _this3.initiateThumbnailViewGrid();
              }
            });
          },
          exporterPdfFilename: 'Histórico de Alertas PDF.pdf',
          exporterCsvFilename: 'Histórico de Alertas CSV.csv',
          exporterExcelFilename: 'Histórico de Alertas XLSX.xlsx',
          columnDefs: [{
            name: 'expurgo',
            displayName: 'ce.analise.alertas.colunas.abono',
            pinnedLeft: false,
            enableHiding: this.exibirCampoAbono,
            enableColumnResizing: false,
            width: 30,
            enableSorting: false,
            visible: false,
            headerCellClass: 'abono-header data-testid=alert-vtabela-header-abono',
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents\'>\n              <span ng-if=\'grid.appScope.exibirCampoAbono && row.entity.temPermissaoVeiculo && grid.appScope.verificaSeTipoExpurgo(row.entity.tipo)\' data-testid=alert-vtabela-abono-{{row.entity.placa}}>\n                <a\n                  uib-tooltip="{{ grid.appScope.abonarEvento }}"\n                  class="btn-solicitar-video-foto"\n                  ng-click=\'grid.appScope.abrirModalAbonarEvento(row.entity)\'\n                  id="abrirModalAbono">\n                  <span class="material-icons icone-abonar-evento">\n                    delete_outline\n                  </span>\n                </a>\n              </span>\n            </div>'
          }, {
            name: 'placa',
            displayName: 'ce.analise.alertas.colunas.placa',
            pinnedLeft: true,
            enableHiding: false,
            enableColumnResizing: false,
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-header-placa',
            cellClass: 'data-testid=alert-vtabela-placa-cell'
          }, {
            name: 'prefixo',
            displayName: 'ce.analise.alertas.colunas.prefixo',
            enableHiding: false,
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-header-prefixo',
            cellClass: 'data-testid=alert-vtabela-prefixo-cell'
          }, {
            name: 'grupo',
            displayName: 'ce.analise.alertas.colunas.grupo',
            visible: !this.eventNAConfig,
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-header-grupo',
            cellClass: 'data-testid=alert-vtabela-grupo-cell'
          }, {
            name: 'motorista',
            displayName: 'ce.analise.alertas.colunas.motorista.motoristaLabel',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-motorista-header',
            cellClass: 'data-testid=alert-vtabela-motorista-cell',
            cellTemplate: this.getMotoristaCellTemplate()
          }, {
            name: 'uo',
            displayName: 'ce.analise.alertas.colunas.uo',
            enableHiding: false,
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-uo-header',
            cellClass: 'data-testid=alert-vtabela-uo-cell'
          }, {
            name: 'tipo',
            displayName: 'ce.analise.alertas.colunas.tipo',
            enableHiding: false,
            headerCellClass: 'data-testid=alert-vtabela-tipo-header',
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents cell-tipo\' title={{grid.appScope.getDescricao(row.entity.tipo)}}>\n              <a\n                class=\'action-link text-ellipse\'\n                ng-if=\'grid.appScope.hasLinkPortalPassivelManutencao(row.entity)\'\n                uib-popover-html="grid.appScope.setPopoverContentVeiculoSemSinal(row.entity)"\n                popover-title="{{ grid.appScope.semSinal }}"\n                popover-trigger="\'focus\'"\n                popover-placement="top"\n                tabindex="0"\n                data-testid=alert-vtabela-tipo-{{row.entity.placa}} >\n                {{ grid.appScope.getDescricao(row.entity.tipo) }}\n              </a>\n              <span class=\'text-ellipse\' ng-if=\'!grid.appScope.hasLinkPortalPassivelManutencao(row.entity)\' data-testid=alert-vtabela-tipo-{{row.entity.placa}}>\n                {{ grid.appScope.getDescricao(row.entity.tipo) }}\n              </span>\n              <div class=\'div-icone\'\n              ng-if=\'grid.appScope.verificaSeGTP(row.entity.meio)\'>\n                <span class="material-icons icone-tic"\n                uib-tooltip="{{ \'ce.analise.alertas.colunas.alertaGTP\' | translate }}"\n                tooltip-placement="top">\n                hub\n                </span>\n              </div>\n              <span class="material-icons info-icon"\n                ng-if=\'grid.appScope.isEventTooltip(row.entity.tipo)\'\n                uib-tooltip="{{ grid.appScope.getEventTooltip(row.entity.tipo) | translate }}"\n                tooltip-placement="top">\n                info\n              </span>\n              <tag-ignore alert="row.entity.tagIgnoreAlert" size="small" position="top"></tag-ignore>\n            </div>'
          }, {
            name: 'tag',
            visible: !this.eventNAConfig,
            displayName: 'ce.analise.alertas.colunas.tag',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-tag-header',
            cellClass: 'data-testid=alert-vtabela-tag-cell'
          }, {
            name: 'limiar',
            displayName: 'ce.analise.alertas.colunas.limiar',
            enableSorting: false,
            headerCellClass: 'text-center data-testid=alert-vtabela-limiar-header',
            cellClass: 'text-center data-testid=alert-vtabela-limiar-cell'
          }, {
            name: 'excesso',
            displayName: 'ce.analise.alertas.colunas.excesso',
            enableSorting: !!this.serviceVfiltro.factoryVfiltro.filtroUrl.tipos,
            cellClass: 'text-center',
            headerCellClass: 'text-center data-testid=alert-vtabela-excesso-header',
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents text-center\'>\n              <div ng-if="row.entity.excesso === \'0.00 G\'\n                || row.entity.excesso === \'0 Km/h/s\'\n                || row.entity.excesso === \'0 Km/h\'"\n                uib-tooltip=\'{{ grid.appScope.toolTipNaoAplica }}\' tooltip-placement=\'left\'> N/A </div>\n              <div ng-if="row.entity.excesso !== \'0.00 G\'\n                && row.entity.excesso !== \'0 Km/h/s\'\n                && row.entity.excesso !== \'0 Km/h\'">\n                <span class=\'badge text-center\'\n                  ng-if="row.entity.tipo === \'VEICULO_SEM_SINAL\'"\n                  tooltip-placement=\'left\'\n                  uib-tooltip=\'{{ grid.appScope.tooltipDias }}\'\n                  ng-class=\'grid.appScope.nivel[row.entity.nivel].cor\'\n                  data-testid=alert-vtabela-excesso-{{row.entity.placa}}>\n                  {{ row.entity.excesso }}\n                </span>\n                <span class=\'badge\'\n                  role="button"\n                  ng-class=\'grid.appScope.nivel[row.entity.nivel].cor\'\n                  ng-if="row.entity.tipo === \'DIAGNOSTICO_OBD\'"\n                  uib-popover-html="grid.appScope.setPopoverContent(\n                    row.entity.excesso,\n                    row.entity.miscInfo.obdDesc,\n                    row.entity.miscInfo.origem === \'OBD\')"\n                  popover-title="{{row.entity.excesso}}"\n                  popover-trigger="\'focus\'"\n                  popover-placement="right"\n                  tabindex="0"\n                  data-testid=alert-vtabela-excesso-{{row.entity.placa}}>\n                  {{ row.entity.excesso }}\n                </span>\n                <span class=\'badge\'\n                  ng-class=\'grid.appScope.nivel[row.entity.nivel].cor\'\n                  ng-if="row.entity.tipo !== \'DIAGNOSTICO_OBD\' && row.entity.tipo !== \'VEICULO_SEM_SINAL\'"\n                  uib-tooltip="{{grid.appScope.getTooltipMsgExcesso(row)}}" tooltip-placement="left"\n                  data-testid=alert-vtabela-excesso-{{row.entity.placa}}>\n                  {{ row.entity.excesso }}\n                </span>\n              </div>\n            </div>'
          }, {
            name: 'duracao',
            displayName: 'ce.analise.alertas.colunas.duracao',
            cellTooltip: false,
            headerCellClass: 'data-testid=alert-vtabela-duracao-header',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents text-center\' ng-if="row.entity.duracao === 0" title="{{ grid.appScope.tooltipNaoAplica }}">\n                <div ng-if="row.entity.duracao === 0" data-testid=alert-vtabela-duracao-{{row.entity.placa}}> N/A </div>\n              </div>\n              <div class=\'ui-grid-cell-contents text-center\' ng-if="row.entity.duracao > 0" title="{{row.entity.duracao | humanizedDuration: true}}">\n                <div ng-if="row.entity.duracao > 0" data-testid=alert-vtabela-duracao-{{row.entity.placa}}> {{ row.entity.duracao | humanizedDuration: true }} </div>\n              </div>\n            '
          }, {
            name: 'aiAnalysisResultTranslated',
            displayName: 'ce.analise.alertas.colunas.aiAnalysis',
            visible: this.isAiAnalysisColumnEnabled,
            enableHiding: this.isAiAnalysisColumnEnabled,
            enableSorting: false,
            headerCellClass: 'data-testid=alerts-ai-analysis-result-header',
            cellClass: 'text-center',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents text-center\' data-testid=alerts-ai-analysis-result-{{row.entity.placa}}>\n                <span>{{ row.entity.aiAnalysisResultTranslated || \'-\' }}</span>\n              </div>\n            '
          }, {
            name: 'pontoReferencia',
            visible: !this.eventNAConfig,
            displayName: 'ce.analise.alertas.colunas.pontoReferencia',
            headerCellClass: 'data-testid=alert-vtabela-pontoReferencia-header',
            cellClass: 'data-testid=alert-vtabela-pontoReferencia-cell',
            enableSorting: false
          }, {
            name: 'categoria',
            visible: !this.eventNAConfig,
            displayName: 'ce.analise.alertas.colunas.categoria',
            headerCellClass: 'data-testid=alert-vtabela-categoria-header',
            cellClass: 'data-testid=alert-vtabela-categoria-cell',
            enableSorting: false
          }, {
            name: 'cercaEletronica',
            visible: !this.eventNAConfig,
            displayName: 'ce.analise.alertas.colunas.cercaEletronica',
            headerCellClass: 'data-testid=alert-vtabela-cercaEletronica-header',
            cellClass: 'data-testid=alert-vtabela-cercaEletronica-cell',
            enableSorting: false
          }, {
            name: 'logradouro',
            displayName: 'ce.analise.alertas.colunas.logradouro',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-logradouro-header',
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents\' title="{{ row.entity.logradouro ? row.entity.logradouro : \'-\'}}" data-testid=alert-vtabela-logradouro-{{row.entity.placa}}>\n              <a ng-href=\'{{grid.appScope.goToHistoricoTimeline(row.entity)}}\' target=\'_blank\' ng-if=\'grid.appScope.exibeInfoLogradouro(row.entity)\'>\n                {{ row.entity.logradouro ? row.entity.logradouro : \'-\'}}\n              </a>\n              <span ng-if=\'row.entity.logradouro === undefined\'> - </span>\n            </div>'
          }, {
            name: 'localizacao',
            displayName: 'ce.analise.alertas.colunas.localizacao',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-localizacao-header',
            cellClass: 'data-testid=alert-vtabela-localizacao-cell',
            width: '5%'
          }, {
            name: 'datahora',
            displayName: 'ce.analise.alertas.colunas.dataHora',
            type: 'date',
            headerCellClass: 'data-testid=alert-vtabela-datahora-header',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\' title=\'{{grid.appScope.getDataHora(row.entity)}}\'\n              data-testid=alert-vtabela-datahora-{{row.entity.placa}}>\n                {{grid.appScope.getDataHora(row.entity)}}\n              </div>\n            '
          }, {
            name: 'status',
            displayName: 'ce.analise.alertas.colunas.status',
            width: '5%',
            enableSorting: true,
            headerCellClass: 'data-testid=alert-vtabela-status-header',
            cellTemplate: '\n            <div class=\'ui-grid-cell-contents\'>\n              <span class=\'badge {{grid.appScope.status[row.entity.status].cor}}\'>\n                {{ grid.appScope.status[row.entity.status].label }}\n              </span>\n              <span class=\'fa-stack fa-1x historicoAlerta-icon-calendar text-primary\' ng-if=\'row.entity.comentarios > 0 && grid.appScope.roleCadastrar\'>\n                <i class=\'fa fa-comment fa-stack-1x\'></i>\n                <span class=\'fa-stack-1x calendar-text\' data-testid=alert-vtabela-status-{{row.entity.placa}}>\n                  {{ row.entity.comentarios }}\n                </span>\n              </span>\n            </div>'
          }, {
            name: 'atribuido',
            displayName: 'ce.analise.alertas.colunas.atribuido',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-atribuido-header',
            cellClass: 'data-testid=alert-vtabela-atribuido-cell'
          }, {
            name: 'usuarioEmailAssistiuVideo',
            displayName: 'ce.analise.alertas.colunas.usuarioEmailAssistiuVideo',
            headerCellClass: 'data-testid=alert-vtabela-usuarioEmailAssistiuVideo-header',
            cellClass: 'data-testid=alert-vtabela-usuarioEmailAssistiuVideo-cell',
            enableSorting: false
          }, {
            name: 'anexos',
            displayName: 'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.colunas.anexos',
            headerCellClass: 'data-testid=alert-vtabela-anexos-header',
            cellTemplate: '\n              <div class="ui-grid-cell-contents" data-testid=alert-vtabela-status-{{row.entity.placa}}>\n                <div ng-if=\'row.entity.anexos != null\' class=\'anexo-div\'>\n                  <span class="material-icons icon-anexo">\n                    attach_file\n                  </span>\n                  <span>\n                  <a\n                  uib-tooltip="{{ grid.appScope.cliqueParaVer }}"\n                  class="btn-solicitar-video-foto"\n                  ng-click=\'grid.appScope.abrirModalAnexos(row.entity)\'\n                  id="abrirModalAnexo">\n                  {{ \'ce.tempoReal.quadroDeOcorrencias.historicoOcorrencia.possuiAnexos\' | translate }}\n                  </span>\n                </div>\n              </div>'
          }, {
            name: 'integrationSupplier',
            enableHiding: !this.eventNAConfig,
            visible: false,
            displayName: 'ce.analise.alertas.colunas.integrationSupplier',
            headerCellClass: 'data-testid=alert-vtabela-integrationSupplier-header',
            cellClass: 'data-testid=alert-vtabela-integrationSupplier-cell'
          }, {
            name: 'feedback',
            displayName: 'ce.analise.alertas.colunas.feedbackVideo',
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-feedback-header',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents text-center\' data-testid=alert-vtabela-status-{{row.entity.placa}}>\n                <i ng-if=\'!row.entity.isEventoVsafe\'>{{ \'v3gwc.vfiltro.constantes.feedbackVideo.naoSeAplica\' | translate }}</i>\n                <i ng-if=\'row.entity.isEventoVsafe && row.entity.feedback\' class=\'trimble-icon trimble-thumbs-up\' uib-tooltip=\'{{ row.entity.usuarioFeedbackEmail }}\'></i>\n                <i ng-if=\'row.entity.isEventoVsafe && row.entity.feedback === false\' class=\'trimble-icon trimble-thumbs-down\' uib-tooltip=\'{{ row.entity.usuarioFeedbackEmail }}\'></i>\n              </div>\n            '
          }, {
            name: 'coachingStatus',
            displayName: 'Coaching',
            visible: this.eventNAConfig,
            enableColumnResizing: true,
            enableHiding: this.eventNAConfig,
            enableSorting: true,
            headerCellClass: 'data-testid=alert-vtabela-coaching-header',
            cellClass: 'data-testid=alert-vtabela-coaching-cell',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\'>\n                {{ grid.appScope.getCoachingRequired(row.entity) }}\n              </div>\n            '
          }, {
            name: 'automation',
            displayName: 'Automation',
            visible: this.eventNAConfig,
            enableColumnResizing: true,
            enableHiding: this.eventNAConfig,
            enableSorting: false,
            headerCellClass: 'data-testid=alert-vtabela-automation-header',
            cellClass: 'data-testid=alert-vtabela-automation-cell',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents\'>\n                {{ grid.appScope.getAutomation(row.entity) }}\n              </div>\n            '
          }, {
            name: 'video',
            displayName: 'ce.analise.alertas.colunas.video.colLabel',
            enableSorting: false,
            exporterSuppressExport: true,
            enableColumnResizing: false,
            enableCellEdit: false,
            pinnedRight: true,
            width: 60,
            headerCellTemplate: '\n              <div tabindex="0" class="ui-grid-cell-contents ui-grid-header-cell-primary-focus" col-index="renderIndex" title="">\n                <span class="ui-grid-header-cell-label">\n                  <i class=\'fa fa-info-circle\' data-testid=alert-vtabela-video-header\n                    uib-tooltip=\' {{ grid.appScope.videoNaoDisponivel }}\'\n                    tooltip-placement=\'top-right\'></i>\n                </span>\n              </div>\n            ',
            cellTemplate: '\n              <div class=\'ui-grid-cell-contents text-left\'>\n                <span ng-if=\'row.entity.videoId || row.entity.statusVideo || row.entity.snapshotId\' class="icone-status-video-foto" data-testid=alert-vtabela-video-play-{{row.entity.placa}}>\n                  <event-viewer-link\n                    class="historico-alerta-video-play-button"\n                    ng-if="grid.appScope.isVideoPlayer(row.entity) || grid.appScope.isPhotoReady(row.entity)"\n                    id-video="{{row.entity.videoId}}"\n                    snapshot-id="{{row.entity.snapshotId}}"\n                    datahora="{{row.entity.datahora}}"\n                    latitude="{{row.entity.coordinates.latitude}}"\n                    longitude="{{row.entity.coordinates.longitude}}"\n                    vehicle-id="{{row.entity.veiculo.id}}"\n                    vehicle-prefix="{{row.entity.prefixo}}"\n                    vehicle-plate="{{row.entity.veiculo.placa}}"\n                    driver-name="row.entity.motorista"\n                    tipo-evento="{{row.entity.tipo}}"\n                    threshold="{{row.entity.limiar}}"\n                    event-duration="{{row.entity.duracao}}"\n                    actual-value="{{row.entity.excesso}}"\n                    event-level="{{row.entity.nivel}}"\n                    coordinates="{{row.entity.coordinates}}"\n                    status-video="row.entity.statusVideo"\n                    hide-text="true"\n                    is-assistido="grid.appScope.isVideoAssistido(row.entity.statusVideo)"\n                    show-tooltip="true"\n                    ng-click=\'grid.appScope.onVideoClick()\'>\n                  </event-viewer-link>\n                </span>\n                <span ng-if=\'grid.appScope.isDecoratedModalWithoutVideoEnabled && (grid.appScope.isRequestVideo(row.entity) || grid.appScope.isPendingVideo(row.entity) || grid.appScope.isPendingPhoto(row.entity))\' class="icone-status-video-foto">\n                  <a\n                    class="btn-solicitar-video-foto"\n                    ng-if=\'row.entity.isVmov && grid.appScope.canOpenEventWithoutVideo()\'\n                    ng-click=\'grid.appScope.openVideoPlayerWithoutVideo(row.entity)\'\n                    uib-tooltip="{{ grid.appScope.alertaSemVideo }}">\n                    <i class="fa fa-eye margin-right-5"></i>\n                  </a>\n                </span>\n                <span ng-if=\'grid.appScope.isPendingVideo(row.entity) || grid.appScope.isPendingPhoto(row.entity)\' class="icone-status-video-foto" data-testid=alert-vtabela-video-pending-{{row.entity.placa}}>\n                  <i class=\'fa fa-clock-o requisicao-pendente\'\n                    uib-tooltip=\'{{ grid.appScope.processando }}\'>\n                  </i>\n                </span>\n                <span ng-if=\'grid.appScope.isRequestVideo(row.entity)\' class="icone-status-video-foto" data-testid=alert-vtabela-video-solicitar-{{row.entity.placa}}>\n                  <a\n                    uib-tooltip="{{ grid.appScope.solicitarVideo }}"\n                    class="btn-solicitar-video-foto"\n                    ng-if=\'row.entity.isVmov && !grid.appScope.isVideoProcessando(row.entity.statusVideo)\'\n                    ng-click=\'grid.appScope.abrirModalRequisicaoVideo(row.entity)\'>\n                    <i class="fa fa-plus"></i>\n                  </a>\n                </span>\n                <span ng-if=\'grid.appScope.isRequestSnapshot(row.entity)\' class="icone-status-video-foto">\n                  <a\n                    uib-tooltip="{{ grid.appScope.solicitarImagem }}"\n                    class="btn-solicitar-video-foto"\n                    ng-click=\'grid.appScope.openRequestSnapshotPopup(row.entity)\'>\n                    <i class="fa fa-plus"></i>\n                  </a>\n                </span>\n                <span\n                  class="sem-video-icone"\n                  ng-if="grid.appScope.isUnavailableVideo(row.entity)">\n                  <i class="trimble-no-video" uib-tooltip="{{ grid.appScope.semVideo }}"></i>\n                </span>\n                <span\n                  class="material-symbols-filled no-photo-icon"\n                  ng-if="grid.appScope.isUnavailablePhoto(row.entity)"\n                  uib-tooltip="{{ grid.appScope.semFoto }}">\n                    no_photography\n                </span>\n              </div>\n            '
          }]
        };
      }
    }, {
      key: 'shouldShowSeePhotoDialog',
      value: function shouldShowSeePhotoDialog(row) {
        return row.identificacao && row.identificacao.podeAbrirVigenciaManual;
      }
    }, {
      key: 'resolveUoWithRecFacial',
      value: function resolveUoWithRecFacial(uoId) {
        var _this4 = this;

        this.uoWithRecFacial = false;
        this.cadastroVeiculoService.hasRecFacial(uoId, null).then(function (uoWithRecFacial) {
          _this4.uoWithRecFacial = uoWithRecFacial;
        }).catch(function () {});
      }
    }, {
      key: 'resolveIsNa',
      value: function resolveIsNa(uoId) {
        var _this5 = this;

        this.isNa = false;
        this.featureOuService.getVehicleTableConfig(uoId).then(function (isNa) {
          _this5.isNa = isNa;
        }).catch(function () {});
      }
    }, {
      key: 'isPendingVideo',
      value: function isPendingVideo(alerta) {
        return alerta.videoId && this.roleVisualizarVideo && this.isVideoProcessando(alerta.statusVideo);
      }
    }, {
      key: 'isPendingPhoto',
      value: function isPendingPhoto(alerta) {
        return !alerta.videoId && alerta.snapshotId && this.isSnapshotStatusPending(alerta.statusSnapshot);
      }
    }, {
      key: 'isRequestVideo',
      value: function isRequestVideo(alerta) {
        return !alerta.hasPremiumTelemetry && !alerta.videoId && !alerta.snapshotId && this.roleSolicitarVideo;
      }
    }, {
      key: 'isRequestSnapshot',
      value: function isRequestSnapshot(alerta) {
        return alerta.hasPremiumTelemetry && !alerta.videoId && !alerta.snapshotId;
      }
    }, {
      key: 'isUnavailableVideo',
      value: function isUnavailableVideo(alerta) {
        return !alerta.hasPremiumTelemetry && this.roleVisualizarVideo && alerta.isVmov && this.isVideoIndisponivel(alerta.statusVideo);
      }
    }, {
      key: 'isUnavailablePhoto',
      value: function isUnavailablePhoto(alerta) {
        return alerta.snapshotId && this.isPhotoStatusUnavailable(alerta.statusSnapshot);
      }
    }, {
      key: 'isVideoProcessando',
      value: function isVideoProcessando(status) {
        return status === 'CADASTRADO' || status === 'BAIXANDO' || status === 'CONVERTENDO' || status === 'PENDENTE';
      }
    }, {
      key: 'isSnapshotStatusPending',
      value: function isSnapshotStatusPending(status) {
        return status === 'PENDING' || status === 'REQUESTED' || status === 'CONVERTING';
      }
    }, {
      key: 'isVideoPlayer',
      value: function isVideoPlayer(alerta) {
        return this.isVideoDisponivel(alerta.statusVideo) && !alerta.snapshotId;
      }
    }, {
      key: 'isVideoDisponivel',
      value: function isVideoDisponivel(status) {
        return status === 'ASSISTIDO' || status === 'CONCLUIDO';
      }
    }, {
      key: 'isPhotoReady',
      value: function isPhotoReady(alerta) {
        return alerta.statusSnapshot === 'DONE' && alerta.snapshotId;
      }
    }, {
      key: 'isVideoIndisponivel',
      value: function isVideoIndisponivel(status) {
        return status === 'DESCONHECIDO' || status === 'ERRO' || status === 'INDISPONIVEL';
      }
    }, {
      key: 'isPhotoStatusUnavailable',
      value: function isPhotoStatusUnavailable(status) {
        return status === 'ERROR' || status === 'UNAVAILABLE';
      }
    }, {
      key: 'isVideoAssistido',
      value: function isVideoAssistido(status) {
        return status === 'ASSISTIDO';
      }
    }, {
      key: 'abrirModalRequisicaoVideo',
      value: function abrirModalRequisicaoVideo(_alerta, _onRequestCompleted) {
        var _this6 = this;

        return this.uibModal.open({
          component: 'modalRequisicaoVideo',
          backdrop: 'static',
          resolve: {
            alerta: function alerta() {
              return _alerta;
            },
            onRequestCompleted: function onRequestCompleted() {
              return _onRequestCompleted;
            }
          }
        }).result.then(function (videoId) {
          _alerta.statusVideo = 'CADASTRADO';
          _alerta.videoId = videoId;
          var vehicleId = _alerta.veiculo ? _alerta.veiculo.id : _alerta.vehicleId;
          if (vehicleId && _alerta.datahora) {
            _this6.window.dispatchEvent(new _this6.window.CustomEvent('videoRequestedEvent', {
              detail: {
                statusVideo: 'PENDENTE',
                vehicleId: vehicleId,
                datahora: _alerta.datahora,
                videoId: videoId
              }
            }));
          }
          return videoId;
        });
      }
    }, {
      key: 'openRequestSnapshotPopup',
      value: function openRequestSnapshotPopup(_alerta2) {
        return this.uibModal.open({
          component: 'modalRequisicaoVideo',
          backdrop: 'static',
          resolve: {
            alerta: function alerta() {
              return _alerta2;
            },
            isSnapshotRequest: function isSnapshotRequest() {
              return true;
            }
          }
        }).result.then(function (result) {
          _alerta2.snapshotId = result.snapshotId;
          _alerta2.statusSnapshot = 'PENDING';
        });
      }
    }, {
      key: 'onVideoClick',
      value: function onVideoClick() {
        this.googleTagManagerUtils.sendEventClickGTM('analise_alertas_reproduzir_video', this.serviceVfiltro.factoryVfiltro.user);
      }
    }, {
      key: 'setPopoverContent',
      value: function setPopoverContent(codigo, content, obd) {
        return this.trusted[codigo] || (this.trusted[codigo] = this.sce.trustAsHtml((angular.isDefined(content) && content !== null ? content + '<br/>' : '') + this.translate.instant('ce.analise.alertas.codigoDeFalhaPt1') + (obd ? this.translate.instant('ce.analise.alertas.codigoDeFalhaPt2') : '.')));
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        this.callServiceForPageContent();
      }
    }, {
      key: 'getTooltipMsgExcesso',
      value: function getTooltipMsgExcesso(row) {
        var tipo = this.alertasEnum.getAlerta(row.entity.tipo),
            isSpeedingEvent = tipo.id === 'EXCESSO_VELOCIDADE_POR_VIA' || tipo.id === 'EXCESSO_VELOCIDADE';

        if (isSpeedingEvent) {
          var customLabel = this.getCustomSpeedingLabel(row);
          if (customLabel) {
            return customLabel;
          }
        }

        return isSpeedingEvent ? this.nivel[row.entity.nivel].label : row.entity.excesso;
      }
    }, {
      key: 'getCustomSpeedingLabel',
      value: function getCustomSpeedingLabel(row) {
        if (!this.speedingLevels) {
          return null;
        }

        var nivel = row.entity.nivel;

        if (this.speedingLevels.useBuckets && this.speedingLevels[nivel] && this.speedingLevels[nivel].levelLabel) {
          return this.speedingLevels[nivel].levelLabel;
        }

        return null;
      }
    }, {
      key: 'callServiceForPageContent',
      value: function callServiceForPageContent() {
        this.vtabela.pageSize = this.vtabela.pageSize ? this.vtabela.pageSize : 50;
        this.vtabela.vtabelaLocalstorage.pageSize = this.pageSize;
        var offset = (Number(this.vtabela.currentPage || 1) - 1) * this.vtabela.pageSize;

        this.vtabela.setVtabelaUrl();
        this.vtabela.grid.getPage(this.vtabela.pageSize, offset, 'datahora', this.vtabela.sortDirection ? this.vtabela.sortDirection : 'desc');
      }
    }, {
      key: 'convertSpeedMeasurement',
      value: function convertSpeedMeasurement(limiar) {
        var convertibleUnits = ['Km/h/s', 'Km/h', 'Km'],
            unit = convertibleUnits.find(function (u) {
          return limiar.includes(u);
        }),
            value = parseFloat(limiar.replace(unit, '').trim()),
            unitConversionMap = {
          'Km/h': { converter: 'handleKmToMiles', newUnit: 'mph' },
          'Km/h/s': { converter: 'handleKmToMiles', newUnit: 'mph/s' },
          Km: { converter: 'handleKmToMiles', newUnit: 'mi', round: true }
        };

        if (!unit || this.speedMeasurement !== 'MILES') {
          return limiar;
        }

        if (isNaN(value)) {
          return limiar;
        }

        if (unitConversionMap.hasOwnProperty(unit)) {
          var _unitConversionMap$un = unitConversionMap[unit],
              converter = _unitConversionMap$un.converter,
              newUnit = _unitConversionMap$un.newUnit,
              _unitConversionMap$un2 = _unitConversionMap$un.round,
              round = _unitConversionMap$un2 === undefined ? false : _unitConversionMap$un2;

          var convertedValue = this.convertersService[converter](value, !round);
          if (round) {
            convertedValue = Math.ceil(convertedValue);
          }
          return convertedValue + ' ' + newUnit;
        }
        return limiar;
      }
    }, {
      key: 'getCoachingRequired',
      value: function getCoachingRequired(item) {
        if (item.coachingStatus === 'COACHING_REQUIRED') {
          return this.translate.instant('v3gwc.vfiltro.constantes.coaching.required');
        } else if (item.coachingStatus === 'NO_COACHING_REQUIRED') {
          return this.translate.instant('v3gwc.vfiltro.constantes.coaching.notRequired');
        } else if (item.coachingStatus === 'COMPLETED') {
          return this.translate.instant('v3gwc.vfiltro.constantes.coaching.completed');
        }
        return this.translate.instant('v3gwc.vfiltro.constantes.coaching.unreviewed');
      }
    }, {
      key: 'getAutomation',
      value: function getAutomation(item) {
        if (typeof item.automatedCoaching !== 'boolean') {
          return '-';
        }
        return item.automatedCoaching ? 'Yes' : 'No';
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          id: item.id,
          uuid: item.uuid,
          prefixo: item.veiculo.prefixo,
          placa: item.veiculo.placa,
          grupo: item.veiculo.grupo ? item.veiculo.grupo.nome : '-',
          motorista: item.motorista ? item.motorista : null,
          motoristaId: item.motoristaId,
          hasPermissionDriver: item.hasPermissionDriver,
          uo: item.uoNome,
          uoId: item.uo,
          tipo: item.tipo,
          limiar: this.convertSpeedMeasurement(item.limiar),
          excesso: this.convertSpeedMeasurement(item.excesso),
          nivel: item.nivel ? item.nivel : '',
          duracao: item.duracao,
          aiAnalysisResultTranslated: item.aiAnalysisResultTranslated || '-',
          logradouro: item.logradouro,
          localizacao: item.localizacao,
          datahora: item.data,
          veiculo: {
            id: item.veiculo.id,
            placa: item.veiculo.placa
          },
          status: item.status,
          atribuido: item.usuarioAtribuido && item.usuarioAtribuido.login ? item.usuarioAtribuido.login : '',
          tag: item.tag,
          tagIgnoreAlert: item.tagIgnoreAlert,
          usuarioAtribuido: item.usuarioAtribuido,
          comentarios: item.qtdComentarios,
          videoId: item.videoId,
          statusVideo: item.statusVideo,
          miscInfo: item.miscInfo,
          pontoReferencia: item.pontoReferencia && item.pontoReferencia.nome ? item.pontoReferencia.nome : '',
          categoria: item.pontoReferencia && item.categoriaPontoReferencia ? item.categoriaPontoReferencia.nome : '',
          cercaEletronica: item.cercaEletronica && item.cercaEletronica.nome ? item.cercaEletronica.nome : '',
          computadorDeBordo1: item.computadorDeBordo1,
          computadorDeBordo2: item.computadorDeBordo2,
          isVmov: item.isVmov,
          usuarioEmailAssistiuVideo: item.usuarioEmailAssistiuVideo,
          temPermissaoVeiculo: item.temPermissaoVeiculo,
          feedback: item.feedback,
          meio: item.meio,
          usuarioFeedbackEmail: item.usuarioFeedbackEmail,
          isEventoVsafe: item.isEventoVsafe,
          mensagemOVUUID: item.mensagemOVUUID,
          anexos: item.anexos,
          snapshotId: item.snapshotId,
          coordinates: { latitude: item.latitude, longitude: item.longitude },
          identificacao: item.identificacao,
          hasPremiumTelemetry: item.hasPremiumTelemetry,
          statusSnapshot: item.statusSnapshot,
          thumbnailUrls: item.thumbnails,
          coachingStatus: item.coachingStatus,
          automatedCoaching: item.automatedCoaching,
          integrationSupplier: item.integrationSupplier
        };
      }
    }, {
      key: 'isSortAscent',
      value: function isSortAscent(columnName) {
        return this.tableState.sort.predicate === columnName && !this.tableState.sort.reverse;
      }
    }, {
      key: 'isSortDescent',
      value: function isSortDescent(columnName) {
        return this.tableState.sort.predicate === columnName && this.tableState.sort.reverse;
      }
    }, {
      key: 'deveMostrarBotaoCsv',
      value: function deveMostrarBotaoCsv() {
        var inicioFiltro = this.moment(this.getParams().inicio);
        return inicioFiltro.isSame(this.dataPreprocessada) || inicioFiltro.isAfter(this.dataPreprocessada);
      }
    }, {
      key: 'replaceStatusVideos',
      value: function replaceStatusVideos(filtro) {
        var _this7 = this;

        if (angular.isDefined(filtro.statusVideos)) {
          var statusVideoLabels = new Set(filtro.statusVideos.split(','));
          if (statusVideoLabels.size === 3) {
            delete filtro.statusVideos;
          } else {
            filtro.statusVideos = [].concat(_toConsumableArray(statusVideoLabels)).map(function (label) {
              return _this7.statusVideo.getByAgrupador(label);
            }).join(',');
            if (statusVideoLabels.has('SEM_VIDEO')) {
              filtro.notStatusVideos = _.flatten(this.statusVideo.getAgrupadores().filter(function (agrupador) {
                return !statusVideoLabels.has(agrupador);
              }).map(function (agrupador) {
                return _this7.statusVideo.getByAgrupador(agrupador);
              })).join(',');
            }
          }
        }
        return filtro;
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var orderBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'datahora';
        var orderDirection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'desc';
        var includeThumbnails = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var filtro = this.serviceVfiltro.getFiltroBackendNovo(this.serviceVfiltro.filtroTopbar, 'uo');
        filtro = this.replaceStatusVideos(filtro);
        return angular.extend(filtro, {
          limit: limit,
          offset: offset,
          orderBy: orderBy,
          orderDirection: orderDirection,
          includeThumbnails: includeThumbnails
        });
      }
    }, {
      key: 'getUrlCsv',
      value: function getUrlCsv() {
        var _this8 = this;

        var params = this.getParams();
        params.limit = this.maxCsvSize;
        params.offset = null;
        params.timezone = this.currentTimezone;
        var uoId = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this8.keys.uo.name;
        }).value.id;
        return '/alerta/relatorio/csv/' + uoId + '?' + this.httpParamSerializer(params);
      }
    }, {
      key: 'openDetalhesModal',
      value: function openDetalhesModal(_alertas, _status) {
        var _this9 = this;

        if (_status) {
          _status = this.translate.instant(_status);
        }
        this.uibModal.open({
          templateUrl: 'historico-alerta/detalhes-alerta.html',
          controller: 'DetalhesAlertaCtrl as detalhesAlertaModal',
          resolve: {
            alertas: function alertas() {
              return _alertas;
            },
            status: function status() {
              return _status;
            },
            descricaoStatus: function descricaoStatus() {
              return _this9.status;
            },
            ouId: this.ouId
          }
        }).result.finally(function () {
          return _this9.consultar();
        });
      }
    }, {
      key: 'getUrlHistoricoTimeline',
      value: function getUrlHistoricoTimeline(item) {
        var _this10 = this;

        var uo = this.serviceVfiltro.filtroTopbar.find(function (x) {
          return x.key === _this10.keys.uo.name;
        }).value.id,
            vfiltroToHistoricoDetalhado = [{
          key: this.keys.uo.name,
          value: {
            id: uo
          }
        }, {
          key: this.keys.dateTime.name,
          value: {
            startDate: this.moment(item.datahora).subtract(1, 'h'),
            endDate: this.moment(item.datahora).add(1, 'h'),
            tipo: 'personalizado'
          }
        }, {
          key: this.keys.veiculo.name,
          value: {
            id: item.veiculo.id
          }
        }];
        return this.httpParamSerializer({
          vfiltro: this.urlService.getObjectVfiltro(vfiltroToHistoricoDetalhado),
          evento: item.tipo,
          date: item.datahora
        });
      }
    }, {
      key: 'goToHistoricoTimeline',
      value: function goToHistoricoTimeline(item) {
        return '/historico-timeline?' + this.getUrlHistoricoTimeline(item);
      }
    }, {
      key: 'hasLinkPortalPassivelManutencao',
      value: function hasLinkPortalPassivelManutencao(row) {
        return row.tipo === 'VEICULO_SEM_SINAL' && !!row.miscInfo.linkPortal;
      }
    }, {
      key: 'setPopoverContentVeiculoSemSinal',
      value: function setPopoverContentVeiculoSemSinal(row) {
        var link = '<a href="' + row.miscInfo.linkPortal + '" target="_blank">' + this.translate.instant('ce.analise.alertas.portal') + '</a>';
        var stringAlerta = this.translate.instant('ce.analise.alertas.veiculoSemSinalPt1') + ' ' + link;
        return this.tooltipSemSinal[stringAlerta] || (this.tooltipSemSinal[stringAlerta] = this.sce.trustAsHtml(stringAlerta));
      }
    }, {
      key: 'exibeInfoLogradouro',
      value: function exibeInfoLogradouro(row) {
        return row.tipo !== 'VEICULO_SEM_SINAL';
      }
    }, {
      key: 'getDataHora',
      value: function getDataHora(row) {
        if (row.tipo === 'VEICULO_SEM_SINAL') {
          return '-';
        }
        return this.filter('date')(row.datahora, this.dateTimeFormat);
      }
    }, {
      key: 'getDescricao',
      value: function getDescricao(tipoAlerta) {
        var alerta = this.alertasEnum.getAlerta(tipoAlerta);
        return angular.isDefined(alerta) ? this.translate.instant(alerta.descricao) : '-';
      }
    }, {
      key: 'getEventTooltip',
      value: function getEventTooltip(tipoAlerta) {
        var alerta = this.alertasEnum.getAlerta(tipoAlerta);
        return angular.isDefined(alerta) && angular.isDefined(alerta.tooltip) ? this.translate.instant(alerta.tooltip) : null;
      }
    }, {
      key: 'isEventTooltip',
      value: function isEventTooltip(tipoAlerta) {
        if (this.alertasEnum.getAlerta(tipoAlerta) && this.alertasEnum.getAlerta(tipoAlerta).tooltip) {
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: 'abrirModalAnexos',
      value: function abrirModalAnexos(row) {
        /* eslint-disable */
        var botaoVerAnexos = document.querySelector('#abrirModalAnexo'),
            modal = document.createElement('vfwc-external-abrir-dialog-anexos'); /* eslint-enable */
        modal.anexos = row.anexos;
        modal.relatorioAlertaItem = {
          uoId: this.uoIdUsuarioLogado ? this.uoIdUsuarioLogado : row.uoId,
          uoNome: row.uo,
          motorista: row.motorista,
          tipo: {
            id: row.tipo,
            descricao: this.getDescricao(row.tipo)
          }
        };
        modal.isAlertas = true;
        botaoVerAnexos.appendChild(modal);
      }
    }, {
      key: 'abrirModalAbonarEvento',
      value: function abrirModalAbonarEvento(alerta) {
        /* eslint-disable */
        var botaoImportar = document.querySelector('#abrirModalAbono'),
            abrirModal = document.createElement('vfwc-abrir-dialog-abono'); /* eslint-enable */
        abrirModal.user = this.user;
        abrirModal.isFromAlertAnalysis = true;
        abrirModal.uo = {
          nome: alerta.uo,
          uoId: alerta.uoId
        };
        abrirModal.alerta = {
          tipo: {
            id: alerta.tipo,
            descricao: this.getDescricao(alerta.tipo)
          },
          duracao: alerta.duracao ? alerta.duracao : null,
          datahora: alerta.datahora,
          veiculo: alerta.veiculo,
          uo: alerta.uoId,
          mensagemOVUUID: alerta.mensagemOVUUID
        };
        botaoImportar.appendChild(abrirModal);
      }
    }, {
      key: 'verificaSeTipoExpurgo',
      value: function verificaSeTipoExpurgo(tipoAlerta) {
        return this.alertasExpurgo.some(function (alerta) {
          return alerta.id === tipoAlerta;
        });
      }
    }, {
      key: 'verificaSeGTP',
      value: function verificaSeGTP(meio) {
        return meio === 'GTP';
      }
    }, {
      key: 'getMotoristaCellTemplate',
      value: function getMotoristaCellTemplate() {
        return '\n        <div class=\'ui-grid-cell-contents\'>\n          <div\n            id="see-photo-dialog-no-identification"\n            ng-if="!row.entity.motorista && grid.appScope.shouldShowSeePhotoDialog(row.entity)">\n            <snapshot-link\n              id-snapshot="{{row.entity.identificacao.snapshotId}}"\n              date-ignition-on="{{row.entity.identificacao.datahora}}"\n              date-ignition-off="{{row.entity.identificacao.datetimeIgnitionOff}}"\n              pode-abrir-vigencia-manual="row.entity.identificacao.podeAbrirVigenciaManual"\n              id-veiculo="{{row.entity.identificacao.veiculoId}}"\n              uo-veiculo="{{row.entity.uoId}}"\n              s3key="{{row.entity.identificacao.s3Key}}"\n              bucket="{{row.entity.identificacao.bucket}}"\n              bucket-region="{{row.entity.identificacao.bucketRegion}}"\n              prefix-container="alert-report-container"\n              text-button="ce.analise.alertas.colunas.motorista.semIdentificacao"\n              alert-id="{{row.entity.id}}"\n              uo-with-rec-facial="grid.appScope.uoWithRecFacial"\n              is-na="grid.appScope.isNa"\n              on-close-dialog="grid.appScope.consultar()">\n            </snapshot-link>\n          </div>\n          <div\n            id="with-driver"\n            ng-if="!grid.appScope.shouldShowSeePhotoDialog(row.entity)">\n            <motorista-link\n              motorista="row.entity.motorista"\n              motorista-id="row.entity.motoristaId"\n              has-permission="row.entity.hasPermissionDriver"\n              index="$index">\n            </motorista-link>\n          </div>\n        </div>\n      ';
      }
    }, {
      key: 'getEventsConfig',
      value: function getEventsConfig(uoId) {
        var _this11 = this;

        return this.featureOuService.getEventsConfig(uoId).then(function (eventNAConfig) {
          _this11.eventNAConfig = eventNAConfig;
        });
      }
    }, {
      key: 'shouldDisplayDecoratedVideoPlayer',
      value: function shouldDisplayDecoratedVideoPlayer() {
        if (!this.isDecoratedVideoPlayerEnabled || !this.user) {
          return this.$q.resolve(false);
        }

        return this.$q.when(this.featureOuService.getDecoratedVideoPlayerConfig(this.user.uo.id)).then(function (decoratedVideoPlayer) {
          return Boolean(decoratedVideoPlayer);
        }).catch(function () {
          return false;
        });
      }

      // A single click on a thumbnail can call openVideoPlayer more than once, so extra calls are ignored until the
      // modal is rendered. The legacy player closes by removing its element, so the modal's closed promise never resolves.

    }, {
      key: 'openMultiVideoPlayer',
      value: function openMultiVideoPlayer(playerData) {
        var _this12 = this;

        if (this.multiVideoPlayerModal) {
          return this.multiVideoPlayerModal;
        }

        this.multiVideoPlayerModal = this.uibModal.open({
          component: 'multiVideoPlayer',
          windowTopClass: 'player-container',
          backdrop: false,
          resolve: {
            idVideo: function idVideo() {
              return playerData.idVideo;
            },
            snapshotId: function snapshotId() {
              return playerData.snapshotId;
            },
            datahora: function datahora() {
              return playerData.datahora;
            },
            tipoEvento: function tipoEvento() {
              return playerData.tipoEvento;
            },
            latitude: function latitude() {
              return playerData.latitude;
            },
            longitude: function longitude() {
              return playerData.longitude;
            },
            vehicleId: function vehicleId() {
              return playerData.vehicleId;
            },
            vehiclePrefix: function vehiclePrefix() {
              return playerData.vehiclePrefix;
            },
            vehiclePlate: function vehiclePlate() {
              return playerData.vehiclePlate;
            },
            driverName: function driverName() {
              return playerData.driverName;
            },
            threshold: function threshold() {
              return playerData.threshold;
            },
            eventDuration: function eventDuration() {
              return playerData.eventDuration;
            },
            actualValue: function actualValue() {
              return playerData.actualValue;
            },
            eventLevel: function eventLevel() {
              return playerData.eventLevel;
            },
            statusVideo: function statusVideo() {
              return playerData.statusVideo;
            }
          }
        });
        this.multiVideoPlayerModal.rendered.finally(function () {
          _this12.multiVideoPlayerModal = null;
        });

        return this.multiVideoPlayerModal;
      }

      // Opening an event without video is how the user marks it for coaching, so non-NA OUs
      // get it only through CPD_759_COACHING_NON_NA, the same flag that shows the Coaching tab.

    }, {
      key: 'canOpenEventWithoutVideo',
      value: function canOpenEventWithoutVideo() {
        return Boolean(this.eventNAConfig || this.isCoachingNonNaEnabled);
      }
    }, {
      key: 'toggleView',
      value: function toggleView(view) {
        this.currentView = view;
        this.window.localStorage.setItem('currentView', view);
        this.currentViewStateService.setCurrentView(view);
        this.renderView();
      }
    }, {
      key: 'renderView',
      value: function renderView() {
        this.tableContainer = this.document.getElementById('historico-alerta');
        this.videoContainer = this.document.getElementById('thumbnailGrid');
        this.tableButton = this.document.querySelector('.btn-table');
        this.gridButton = this.document.querySelector('.btn-grid');

        if (this.tableContainer && this.videoContainer && this.tableButton && this.gridButton) {
          if (this.currentView === 'table') {
            this.tableContainer.style.display = 'block';
            this.videoContainer.style.display = 'none';
            this.tableButton.classList.add('active');
            this.gridButton.classList.remove('active');
          } else {
            this.videoContainer.style.display = 'block';
            this.tableButton.classList.remove('active');
            this.gridButton.classList.add('active');
          }
        }
      }
    }, {
      key: 'loadView',
      value: function loadView() {
        var shouldAllowGridView = (this.eventNAConfig || this.isEventsCardViewLatamEnabled) && this.isThumbnailsViewButtonEnabled,
            savedView = this.window.localStorage.getItem('currentView');
        if (savedView && shouldAllowGridView) {
          this.currentView = savedView;
        }
      }
    }, {
      key: 'initiateThumbnailViewGrid',
      value: function initiateThumbnailViewGrid() {
        var _this13 = this;

        var alertsDTO = this.vtabela.grid.data.map(function (alert) {
          return {
            id: alert.id,
            videoId: alert.videoId,
            snapshotId: alert.snapshotId,
            datahora: alert.datahora,
            latitude: alert.coordinates.latitude,
            longitude: alert.coordinates.longitude,
            vehicleId: alert.veiculo.id,
            vehiclePrefix: alert.prefixo,
            vehiclePlate: alert.veiculo.placa,
            driverName: alert.motorista,
            tipoEvento: alert.tipo,
            threshold: alert.limiar,
            eventDuration: alert.duracao,
            actualValue: alert.excesso,
            eventLevel: alert.nivel,
            statusVideo: alert.statusVideo,
            isPremiumTelemetryEnabled: alert.hasPremiumTelemetry,
            statusSnapshot: alert.statusSnapshot,
            veiculo: alert.veiculo,
            tipo: alert.tipo,
            thumbnailUrls: alert.thumbnailUrls,
            coordinates: alert.coordinates,
            requestVideo: function requestVideo(onRequestCompleted) {
              return _this13.abrirModalRequisicaoVideo(alert, onRequestCompleted);
            },
            requestSnapshot: function requestSnapshot() {
              return _this13.openRequestSnapshotPopup(alert);
            }
          };
        }),
            props = {
          alerts: alertsDTO,
          user: this.serviceVfiltro.factoryVfiltro.user,
          openVideoPlayer: this.openVideoPlayer.bind(this),
          requestVideoPermission: this.roleSolicitarVideo,
          totalNumberOfAlerts: this.vtabela.grid.totalItems,
          openVideoPlayerWithoutVideo: function openVideoPlayerWithoutVideo(alert) {
            _this13.openVideoPlayerWithoutVideo(alert);
          }
        },
            appName = 'safetyApp',
            componentPath = './AlertsThumbnailView',
            componentId = 'thumbnailGrid';

        this.safetyService.initialize().then(function () {
          return _this13.safetyService.loadReactComponent(appName, componentPath, componentId, props).then(function () {
            return _this13.renderView();
          });
        });
      }
    }]);

    return HistoricoAlertaCtrl;
  }();

  angular.module('historicoAlerta').controller('HistoricoAlertaCtrl', HistoricoAlertaCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FormData, Blob, document, MutationObserver */

  var DetalhesAlertaCtrl = function () {
    function DetalhesAlertaCtrl($q, $timeout, $uibModalInstance, alertas, status, ouId, AlertMessage, FeaturehubJsSdk, descricaoStatus, HistoricoAlerta, Alertas, AlertsTag, UsuariosVfleets, Restangular, $translate) {
      var _statusMap;

      _classCallCheck(this, DetalhesAlertaCtrl);

      this.q = $q;
      this.timeout = $timeout;
      this.modalInstance = $uibModalInstance;
      this.alertMessage = AlertMessage;
      this.historicoService = HistoricoAlerta;
      this.descricaoStatus = descricaoStatus;
      this.alertasService = Alertas;
      this.alertsTagService = AlertsTag;
      this.alertTag = null;
      this.alertsTag = [];
      this.ouId = ouId;
      this.usuarioService = UsuariosVfleets;
      this.alertas = alertas;
      this.status = angular.isDefined(status) ? status : null;
      this.historico = [];
      this.comentario = '';
      this.usuario = null;
      this.usuarios = [];
      this.alerta = {};
      this.anexos = [];
      this.shouldSendAttachmentProntuario = false;
      this.restangular = Restangular;
      this.translate = $translate;
      this.stringPara = this.translate.instant('ce.analise.alertas.detalhes.para');
      /*eslint-disable */
      this.statusMap = (_statusMap = {}, _defineProperty(_statusMap, this.translate.instant('ce.analise.alertas.detalhes.atribuido'), 'ATRIBUIDO'), _defineProperty(_statusMap, this.translate.instant('ce.analise.alertas.detalhes.resolvido'), 'RESOLVIDO'), _statusMap);
      /*eslint-enable */
      this.statusLista = Object.keys(this.statusMap);
      this.loadHistorico();
      this.loadUsuarios();
      this.loadAttachmentSquare();
      this.loadAlertsTag();
      this.REFUSED = 0;
      this.ACCEPT = 1;
    }

    _createClass(DetalhesAlertaCtrl, [{
      key: 'loadHistorico',
      value: function loadHistorico() {
        var _this = this;

        if (this.alertas.length === 1) {
          this.historicoService.one(this.alertas[0].id).get({ datahora: this.alertas[0].datahora }).then(function (data) {
            _this.historico = data;
          });
        }
      }
    }, {
      key: 'loadUsuarios',
      value: function loadUsuarios() {
        var _this2 = this;

        this.usuarioService.getUsuariosAtribuiveis(this.alertas.map(function (v) {
          return v.veiculo.id;
        })).then(function (data) {
          return _this2.usuarios = _this2.sortUsuariosByLogin(data);
        });
      }
    }, {
      key: 'loadAlertsTag',
      value: function loadAlertsTag() {
        var _this3 = this;

        this.alertsTagService.get(this.ouId).then(function (data) {
          return _this3.alertsTag = _this3.sortTagsByName(data);
        });
      }
    }, {
      key: 'sortUsuariosByLogin',
      value: function sortUsuariosByLogin(list) {
        if (angular.isArray(list)) {
          return list.sort(function (a, b) {
            return a.login.localeCompare(b.login);
          });
        }
      }
    }, {
      key: 'sortTagsByName',
      value: function sortTagsByName(list) {
        if (angular.isArray(list)) {
          return list.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          }).map(function (tag) {
            return {
              id: tag.id,
              name: '' + tag.name + (!tag.isOuOwner ? ' *' : ''),
              ignoreIndicator: tag.ignoreIndicator || false
            };
          });
        }
      }
    }, {
      key: 'tratativaAlertaRequest',
      value: function tratativaAlertaRequest() {
        var _this4 = this;

        var veiculoId = this.alertas[0].veiculo.id,
            params = {
          inicio: this.alertas[0].datahora,
          fim: this.alertas[this.alertas.length - 1].datahora,
          ouIdTagFilter: this.ouId,
          shouldSendAnexoProntuario: this.shouldSendAttachmentProntuario ? this.ACCEPT : this.REFUSED
        },
            formData = this.buildFormData();
        return this.restangular.all('alerta/alertas/' + veiculoId + '/tratativa-alertas').withHttpConfig({ transformRequest: angular.identity }).customPOST(formData, undefined, params, { 'Content-Type': undefined }).catch(function () {
          _this4.alertMessage.create({
            type: 'error',
            message: _this4.translate.instant('ce.ranking.motoristas.prontuario.modal.erroSalvar'),
            appendTo: '.alerta-aqui'
          });
        });
      }
    }, {
      key: 'buildFormData',
      value: function buildFormData() {
        var alertaIds = this.alertas.map(function (alerta) {
          return alerta.id;
        }),
            motoristasId = this.alertas.map(function (alerta) {
          return alerta.motoristaId;
        });
        var formData = new FormData(),
            response = {
          alertasIds: alertaIds,
          motoristasIds: motoristasId,
          status: this.status !== null ? this.statusMap[this.status] : null,
          comentario: this.comentario,
          usuarioAtribuido: this.usuario
        };
        if (this.anexos.length > 0) {
          this.anexos.forEach(function (file) {
            return formData.append('file', file.file);
          });
        }
        if (this.alertTag && this.alertTag.id) {
          response.tagId = this.alertTag.id;
          response.ignoreIndicator = this.alertTag.ignoreIndicator;
        }
        formData.append('content', new Blob([angular.toJson(response)], { type: 'application/json' }));
        return formData;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this5 = this;

        if (this.validar()) {
          if (this.shouldOpenModalConfirmProntuario()) {
            this.loadModalConfirmProntuario().then(function () {
              _this5.tratativaAlertaRequest().then(function () {
                _this5.fechar();
              });
            }).catch(function () {});
          } else {
            this.tratativaAlertaRequest().then(function () {
              _this5.fechar();
            });
          }
        }
      }
    }, {
      key: 'validar',
      value: function validar() {
        if (this.comentario === '' && this.status === null && this.anexos.length === 0 && this.alertTag === null) {
          this.exibirAlerta('warning', 'ce.analise.alertas.detalhes.validarAlteracao');
          return false;
        }
        if (this.status === this.translate.instant('ce.analise.alertas.detalhes.atribuido') && this.usuario === null) {
          this.exibirAlerta('warning', 'ce.analise.alertas.detalhes.validarUsuario');
          return false;
        }
        return true;
      }
    }, {
      key: 'isDisabled',
      value: function isDisabled() {
        var veiculoIds = this.alertas.map(function (alerta) {
          return alerta.veiculo.id;
        });
        return this.hasVeiculosDiferentes(veiculoIds);
      }
    }, {
      key: 'hasVeiculosDiferentes',
      value: function hasVeiculosDiferentes(veiculoIds) {
        return veiculoIds.some(function (id) {
          return id !== veiculoIds[0];
        });
      }
    }, {
      key: 'loadAttachmentSquare',
      value: function loadAttachmentSquare() {
        var _this6 = this;

        this.timeout(function () {
          _this6.waitForAttachmentElement('#attachmentSquare');
        }, 0);
      }
    }, {
      key: 'waitForAttachmentElement',
      value: function waitForAttachmentElement(selector) {
        var _this7 = this;

        /* eslint-disable */
        var observer = new MutationObserver(function (mutations) {
          var attachmentElementContainer = document.querySelector(selector);
          if (mutations.length > 0) {
            observer.disconnect();
            var attachmentSquareElement = document.createElement('vfwc-external-button-attachment-square');
            attachmentSquareElement.isDisabled = _this7.isDisabled();
            attachmentElementContainer.appendChild(attachmentSquareElement);
            _this7.onFileAttached(attachmentSquareElement);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }, {
      key: 'loadModalConfirmProntuario',
      value: function loadModalConfirmProntuario() {
        var _this8 = this;

        return new Promise(function (resolve, reject) {
          /* eslint-disable */
          var confirmProntuarioElementContainer = document.querySelector('#modalConfirmProntuario');
          var confirmProntuarioElement = document.createElement('vfwc-external-confirm-dialog-anexo-alerta-prontuario');
          confirmProntuarioElement.motoristas = _this8.alertas.filter(function (alerta) {
            return alerta.motoristaId;
          }).map(function (alerta) {
            return alerta.motorista;
          });
          confirmProntuarioElementContainer.appendChild(confirmProntuarioElement);
          _this8.onConfirmProntuario(confirmProntuarioElement, resolve, reject);
        });
      }
    }, {
      key: 'onConfirmProntuario',
      value: function onConfirmProntuario(element, resolve, reject) {
        var _this9 = this;

        element.addEventListener('userAnswerEvent', function (event) {
          if (event.detail) {
            switch (event.detail.shouldSendProntuario) {
              case _this9.ACCEPT:
                _this9.shouldSendAttachmentProntuario = true;
                break;
              case _this9.REFUSED:
                _this9.shouldSendAttachmentProntuario = false;
                break;
              default:
                reject();
            }
          }
          resolve();
        });
      }
    }, {
      key: 'onFileAttached',
      value: function onFileAttached(element) {
        var _this10 = this;

        element.addEventListener('fileAttachedEvent', function (event) {
          if (event.detail && event.detail.fileAttached) {
            _this10.anexos = event.detail.attached;
          } else {
            _this10.anexos = [];
          }
        });
      }
    }, {
      key: 'shouldOpenModalConfirmProntuario',
      value: function shouldOpenModalConfirmProntuario() {
        var hasMotoristas = this.alertas.some(function (alerta) {
          return alerta.motoristaId;
        }),
            hasFilesAttached = this.anexos.length > 0;
        return hasMotoristas && hasFilesAttached;
      }
    }, {
      key: 'fechar',
      value: function fechar() {
        this.modalInstance.dismiss('cancel');
      }
    }, {
      key: 'exibirAlerta',
      value: function exibirAlerta(type, msg) {
        this.alerta = {
          show: true,
          type: type,
          msg: this.translate.instant(msg)
        };
      }
    }]);

    return DetalhesAlertaCtrl;
  }();

  angular.module('historicoAlerta').controller('DetalhesAlertaCtrl', DetalhesAlertaCtrl);
})();
'use strict';

angular.module('historicoAlerta').service('CurrentViewStateService', function (FeaturehubJsSdk, FeatureHubConfigKeys) {
  var isThumbnailsViewButtonEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.FEATURE_THUMBNAILS_BUTTON) || FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.EVENTS_CARD_VIEW_LATAM);
  var currentView = isThumbnailsViewButtonEnabled ? 'grid' : 'table';

  return {
    getCurrentView: function getCurrentView() {
      return currentView;
    },
    setCurrentView: function setCurrentView(view) {
      currentView = view;
    },
    isThumbnailsViewButtonEnabled: isThumbnailsViewButtonEnabled
  };
});
'use strict';

(function () {
  'use strict';

  angular.module('gestaoOcorrencia', ['ui.router', 'powerbi', 'restangular', 'FactoryVfiltroModule', 'ServiceVfiltroModule']);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('root.gestaoOcorrencias', {
      url: '/tempo-real/gestao-ocorrencias',
      views: {
        'content@': {
          templateUrl: 'gestao-ocorrencia/gestao-ocorrencia.tpl.html',
          controller: 'GestaoOcorrenciasCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.gestaoOcorrencia.titulo',
        role: ['OCORRENCIA_VISUALIZAR']
      }
    });
  }

  angular.module('gestaoOcorrencia').config(pageConfig);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';
  /* global _, document */

  var GestaoOcorrenciasCtrl = function () {
    function GestaoOcorrenciasCtrl(ServiceVfiltro, FactoryVfiltro, Restangular) {
      _classCallCheck(this, GestaoOcorrenciasCtrl);

      this.restangular = Restangular;
      this.response = {};

      ServiceVfiltro.init(FactoryVfiltro.get([]));
      this.getReport();
    }

    _createClass(GestaoOcorrenciasCtrl, [{
      key: 'getReport',
      value: function getReport() {
        var _this = this;

        this.restangular.one('powerbi/reports/GESTAO_OCORRENCIA').get().then(function (config) {
          _this.response.accessToken = config.embedToken;
          _this.response.embedUrl = config.embedUrl;
          _this.response.id = config.id;
          _this.response.name = '';
          _this.response.type = 'report';
          _this.response.webUrl = 'https://app.powerbi.com/reports/' + config.id;
          _this.response.permissions = 0;
          _this.response.pageView = 'fitToWidth';
          _this.response.tokenType = 1;
          _this.response.settings = {
            localeSettings: {
              language: 'pt-br'
            },
            filterPaneEnabled: true,
            navContentPaneEnabled: true
          };
        });
      }
    }]);

    return GestaoOcorrenciasCtrl;
  }();

  angular.module('gestaoOcorrencia').controller('GestaoOcorrenciasCtrl', GestaoOcorrenciasCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('unprotected.errorPage', {
      url: '/error',
      params: {
        lastPage: null
      },
      views: {
        'guest@': {
          templateUrl: 'components/error-page/error-page.tpl.html',
          controller: 'ErrorPageCtrl',
          controllerAs: 'ctrl'
        }
      }
    });
  }

  angular.module('errorPageModule').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('duo-routes', ['ui.router', 'duo-routes.cadastro-rotas', 'duo-routes.atribuicao-rotas']);
})();
'use strict';

(function () {
  'use strict';

  function v3gTableState(v3gTableStateLinkFunction) {
    return {
      require: 'stTable',
      scope: {
        v3gTableState: '=',
        onSort: '='
      },
      link: v3gTableStateLinkFunction
    };
  }

  angular.module('smart-table').directive('v3gTableState', v3gTableState).factory('v3gTableStateLinkFunction', function () {
    return {
      pre: function pre(scope, element, attrs, ctrl) {
        var sortBy = ctrl.sortBy;
        if (scope.onSort) {
          ctrl.sortBy = function (predicate, reverse) {
            sortBy.apply(ctrl, [predicate, reverse]);
            scope.onSort.apply(scope, [ctrl.tableState(), ctrl]);
          };
        }
        scope.v3gTableState(ctrl.tableState(), ctrl);
      }
    };
  });
})();
'use strict';

(function () {
  'use strict';

  /* eslint-disable */

  function v3gPagination(stConfig) {
    return {
      restrict: 'EA',
      require: '^stTable',
      scope: {
        stItemsByPage: '=?',
        stDisplayedPages: '=?',
        stPageChange: '&?',
        stSelectPage: '='
      },
      templateUrl: function templateUrl(element, attrs) {
        if (attrs.stTemplate) {
          return attrs.stTemplate;
        }
        return stConfig.pagination.template;
      },
      link: function link(scope, element, attrs, ctrl) {

        scope.stItemsByPage = scope.stItemsByPage ? +scope.stItemsByPage : stConfig.pagination.itemsByPage;
        scope.stDisplayedPages = scope.stDisplayedPages ? +scope.stDisplayedPages : stConfig.pagination.displayedPages;

        scope.currentPage = 1;
        scope.pages = [];

        function redraw() {
          var paginationState = ctrl.tableState().pagination;
          var start = 1;
          var end;
          var i;
          var prevPage = scope.currentPage;
          scope.totalItemCount = paginationState.totalItemCount;
          scope.currentPage = Math.floor(paginationState.start / paginationState.number) + 1;

          start = Math.max(start, scope.currentPage - Math.abs(Math.floor(scope.stDisplayedPages / 2)));
          end = start + scope.stDisplayedPages;

          if (end > paginationState.numberOfPages) {
            end = paginationState.numberOfPages + 1;
            start = Math.max(1, end - scope.stDisplayedPages);
          }

          scope.pages = [];
          scope.numPages = paginationState.numberOfPages;

          for (i = start; i < end; i++) {
            scope.pages.push(i);
          }

          if (prevPage !== scope.currentPage && angular.isDefined(scope.stPageChange)) {
            scope.stPageChange({ newPage: scope.currentPage });
          }
        }

        //table state --> view
        scope.$watch(function () {
          return ctrl.tableState().pagination;
        }, redraw, true);

        //scope --> table state  (--> view)
        scope.$watch('stItemsByPage', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.selectPage(1);
          }
        });

        scope.$watch('stDisplayedPages', redraw);

        scope.$watch('stSelectPage', function (page) {
          if (page > 0) {
            scope.selectPage(page);
          }
        });

        //view -> table state
        scope.selectPage = function (page) {
          if (page > 0 && page <= scope.numPages) {
            ctrl.slice((page - 1) * scope.stItemsByPage, scope.stItemsByPage);
          }
        };

        if (!ctrl.tableState().pagination.number) {
          ctrl.slice(0, scope.stItemsByPage);
        }
      }
    };
  }

  angular.module('smart-table').directive('v3gPagination', ['stConfig', v3gPagination]);
})();
'use strict';

(function () {
  'use strict';

  angular.module('enumModule', []);
})();
'use strict';

(function () {
  'use strict';

  var status = {
    MOVIMENTO: {
      id: 'MOVIMENTO',
      descricao: 'ce.enum.veiculoStatus.movimento'
    },
    PARADO: {
      id: 'PARADO',
      descricao: 'ce.enum.veiculoStatus.parado'
    }
  },
      funcoes = {
    getStatusById: function getStatusById(id) {
      return status[id];
    }
  };

  angular.module('enumModule').constant('VeiculoStatusEnum', Object.assign({}, status, funcoes));
})();
'use strict';

(function () {
  'use strict';

  var tipoPermissao = {
    EDITAR: 'E',
    VISUALIZAR: 'V',
    podeEditar: function podeEditar(item) {
      return item === tipoPermissao.EDITAR;
    },
    podeVisualizar: function podeVisualizar(item) {
      return item === tipoPermissao.VISUALIZAR || tipoPermissao.podeEditar(item);
    }
  };

  angular.module('enumModule').constant('TipoPermissaoEnum', tipoPermissao);
})();
'use strict';

(function () {
  'use strict';

  /* global _ */

  var comVideoStatus = ['CONCLUIDO', 'ASSISTIDO'],
      processandoStatus = ['CADASTRADO', 'BAIXANDO', 'CONVERTENDO', 'PENDENTE'],
      semVideoStatus = ['INDISPONIVEL', 'ERRO'],
      COM_VIDEO_ID = 'COM_VIDEO',
      PROCESSANDO_ID = 'PROCESSANDO',
      SEM_VIDEO_ID = 'SEM_VIDEO',
      statusVideo = {
    getAgrupadores: function getAgrupadores() {
      return [COM_VIDEO_ID, PROCESSANDO_ID, SEM_VIDEO_ID];
    },
    getByAgrupador: function getByAgrupador(agrupador) {
      switch (agrupador) {
        case COM_VIDEO_ID:
          return comVideoStatus;
        case PROCESSANDO_ID:
          return processandoStatus;
        case SEM_VIDEO_ID:
          return semVideoStatus;
        default:
          return undefined;
      }
    },
    getAll: function getAll() {
      return _.flatten([comVideoStatus, processandoStatus, semVideoStatus]);
    }
  };

  angular.module('statusVideo', []).constant('StatusVideo', statusVideo);
})();
'use strict';

(function () {
  'use strict';

  var now = new Date(),
      lastTenMinutes = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() - 10, now.getSeconds()),
      lastOneHour = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() - 1, now.getMinutes(), now.getSeconds()),
      lastTwoDays = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2, now.getHours(), now.getMinutes(), now.getSeconds()),
      inMinutes = function inMinutes(minutes) {
    return new Date(now.getTime() + minutes * 60000).toISOString();
  },
      getStatusVeiculoMock = [{
    prefixo: 'V1',
    placa: 'QBO5620',
    situacaoVeiculo: 'LIBERADO',
    status: 'Movimento',
    statusGps: true,
    gsm: false,
    meio: 'GSM',
    vei: 1,
    uoId: 957,
    uoNome: 'VELTEC S/A',
    grupoNome: 'Veículos leves',
    lng: -55.431427,
    lat: -10.819852,
    data: '2018-09-18T17:34:42Z',
    logra: 'MT-320',
    local: 'Colíder - Mato Grosso',
    vel: 57,
    hodo: 69677015,
    dir: 121,
    motNome: 'Antônio Nunes',
    motoristaId: 132,
    motApel: 'Tônin',
    motTel: '+55 (43) 9898-5050',
    motCpf: '01669107167',
    bloqueioPartida: true,
    videoVitalSigns: {
      cameras: 13,
      lastConnection: lastOneHour.toISOString(),
      lastBehaviorEvent: lastTenMinutes.toISOString(),
      lastVideo: lastTwoDays.toISOString(),
      lastPhoto: lastTenMinutes.toISOString(),
      statusConnection: 'RELEASED',
      statusBehaviorEvent: 'RELEASED',
      statusVideo: 'RELEASED',
      statusPhoto: 'RELEASED',
      videoSemaphoreStatus: 'RELEASED',
      storageHealth: 'HEALTHY'
    },
    duo: {
      online: true,
      lastUpdate: inMinutes(0),
      macro: { name: 'Início de Descarga', startedAt: inMinutes(-90) },
      route: {
        name: 'Rota teste', progress: 40.7, late: false, onDeviation: false,
        eta: inMinutes(45), estimatedTime: 4500, executionTime: 2700, exceededTime: 0
      }
    }
  }, {
    data: '2021-04-20T20:14:25Z',
    dir: 0,
    fontAliment: 'PRINCIPAL',
    grupoNome: 'DEOVAN',
    gsm: false,
    hodo: 213555625,
    lat: -23.322643,
    lng: -51.192665,
    local: 'Londrina - Paraná',
    logra: 'Rodovia Celso Garcia Cid',
    meio: 'VMOV',
    motApel: 'Bart',
    motCpf: '60428016944',
    motNome: 'Bartholomeu',
    motTel: '',
    motoristaId: 77990,
    obs: '',
    placa: 'VVV1010',
    prefixo: 'VSAFE 4.0',
    situacaoVeiculo: 'LIBERADO',
    status: 'Parado',
    statusGps: false,
    uoId: 2351,
    uoNome: 'GRUPO NAKAMURA',
    vei: 90561,
    vel: 0,
    videoVitalSigns: {
      cameras: 2,
      lastConnection: lastTwoDays.toISOString(),
      lastBehaviorEvent: lastTenMinutes.toISOString(),
      lastVideo: lastTenMinutes.toISOString(),
      lastPhoto: lastTenMinutes.toISOString(),
      statusConnection: 'REQUIRES_ATTENTION',
      statusBehaviorEvent: 'RELEASED',
      statusVideo: 'RELEASED',
      statusPhoto: 'RELEASED',
      videoSemaphoreStatus: 'REQUIRES_ATTENTION',
      storageHealth: 'HEALTHY'
    },
    duo: {
      online: true,
      lastUpdate: inMinutes(-1),
      macro: { name: 'Carregando cliente', startedAt: inMinutes(-130) },
      route: {
        name: 'Fazenda Paineiras - IDA', progress: 82.4, late: true, onDeviation: true,
        eta: inMinutes(12), estimatedTime: 4500, executionTime: 5100, exceededTime: 600
      }
    }
  }, {
    data: '2021-04-20T20:14:25Z',
    dir: 0,
    fontAliment: 'PRINCIPAL',
    grupoNome: 'DEOVAN',
    gsm: false,
    hodo: 213555625,
    lat: -23.322643,
    lng: -51.192665,
    local: 'Londrina - Paraná',
    logra: 'Rodovia Celso Garcia Cid',
    meio: 'VMOV',
    motApel: 'Bart',
    motCpf: '60428016944',
    motNome: 'Bartholomeu',
    motTel: '',
    motoristaId: 77990,
    obs: '',
    placa: 'VVV2020',
    prefixo: 'VSAFE',
    situacaoVeiculo: 'LIBERADO',
    status: 'Parado',
    statusGps: false,
    uoId: 2351,
    uoNome: 'GRUPO NAKAMURA',
    vei: 90561,
    vel: 0,
    videoVitalSigns: {
      cameras: 8,
      lastConnection: lastOneHour.toISOString(),
      lastBehaviorEvent: lastTenMinutes.toISOString(),
      lastVideo: lastTwoDays.toISOString(),
      lastPhoto: lastTenMinutes.toISOString(),
      statusConnection: 'REQUIRES_ATTENTION',
      statusBehaviorEvent: 'RELEASED',
      statusVideo: 'EVALUATE_URGENTLY',
      statusPhoto: 'RELEASED',
      videoSemaphoreStatus: 'EVALUATE_URGENTLY',
      storageHealth: 'HEALTHY'
    },
    duo: {
      online: true,
      lastUpdate: inMinutes(-1),
      macro: { name: 'Macro 10a', startedAt: inMinutes(-25) }
    }
  }, {
    data: '2021-04-20T21:14:25Z',
    dir: 0,
    fontAliment: 'PRINCIPAL',
    grupoNome: 'TESTE-PAULO',
    gsm: false,
    hodo: 213555625,
    lat: -23.322643,
    lng: -51.192665,
    local: 'Londrina - Paraná',
    logra: 'Rodovia Celso Garcia Cid',
    meio: 'VMOV',
    motApel: 'Bart',
    motCpf: '60428016944',
    motNome: 'Bartholomeu',
    motTel: '',
    motoristaId: 77990,
    obs: '',
    placa: 'PFR0001',
    prefixo: 'VSAFE',
    situacaoVeiculo: 'LIBERADO',
    status: 'Parado',
    statusGps: false,
    uoId: 2351,
    uoNome: 'GRUPO NAKAMURA',
    vei: 90561,
    vel: 0,
    videoVitalSigns: {
      cameras: 8,
      lastVideo: lastTwoDays.toISOString(),
      lastPhoto: lastTenMinutes.toISOString(),
      statusVideo: 'EVALUATE_URGENTLY',
      statusPhoto: 'RELEASED',
      videoSemaphoreStatus: 'EVALUATE_URGENTLY',
      storageHealth: 'HEALTHY'
    }
  }, {
    data: '2021-04-20T20:14:25Z',
    dir: 0,
    fontAliment: 'PRINCIPAL',
    grupoNome: 'DEOVAN',
    gsm: false,
    hodo: 213555625,
    lat: -23.322643,
    lng: -51.192665,
    local: 'Londrina - Paraná',
    logra: 'Rodovia Celso Garcia Cid',
    meio: 'VMOV',
    motApel: 'Bart',
    motCpf: '60428016944',
    motNome: 'Bartholomeu',
    motTel: '',
    motoristaId: 77990,
    obs: '',
    placa: 'VVV3020',
    prefixo: 'VSAFE',
    situacaoVeiculo: 'LIBERADO',
    status: 'Parado',
    statusGps: false,
    uoId: 2351,
    uoNome: 'GRUPO NAKAMURA',
    vei: 90561,
    vel: 0,
    duo: {
      online: true,
      lastUpdate: inMinutes(-2),
      route: { name: 'TO DO THE L', progress: 0, onDeviation: true, eta: inMinutes(4320), executionTime: 700 }
    }
  }];

  angular.module('enumModule').constant('MockGetStatusVeiculo', getStatusVeiculoMock);
})();
'use strict';

(function () {
  'use strict';

  var saudeVeiculoStatusToColorMap = {
    byStatus: {
      RELEASED: 'text-success',
      REQUIRES_ATTENTION: 'modus-text-warning',
      EVALUATE_URGENTLY: 'text-danger',
      HEALTHY: 'text-success',
      NOT_HEALTHY: 'text-danger'
    },
    default: 'modus-text-blue'
  };

  angular.module('enumModule').constant('SaudeVeiculoStatusToColorMap', saudeVeiculoStatusToColorMap);
})();
'use strict';

(function () {
  'use strict';

  // ROOT is the absolute root and currently also answers as the Latam regional root.
  // The region roots below are all direct children of ROOT.

  var roots = {
    ROOT: { id: 1, uuid: '00000000-0000-0000-0000-000000000001' },
    NA: { id: 1000000000, uuid: '00000000-0000-0000-0000-000000000002' },
    EU: { id: 1000000001, uuid: '00000000-0000-0000-0000-000000000003' },
    LATAM: { id: 1000000002, uuid: '00000000-0000-0000-0000-000000000004' }
  },
      funcoes = {
    getIds: function getIds() {
      return Object.keys(roots).map(function (key) {
        return roots[key].id;
      });
    }
  };

  angular.module('enumModule').constant('RootUoEnum', Object.assign({}, roots, funcoes));
})();
'use strict';

(function () {
  'use strict';

  /* global _ */

  var status = {
    NOVA: {
      id: 'NOVA',
      nivel: 0,
      descricao: 'ce.enum.ocorrencia.nova.descricao',
      title: 'ce.enum.ocorrencia.nova.titulo'
    },
    EM_TRATATIVA: {
      id: 'EM_TRATATIVA',
      nivel: 1,
      descricao: 'ce.enum.ocorrencia.emTratativa.descricao',
      title: 'ce.enum.ocorrencia.emTratativa.titulo'
    },
    RESOLVIDA: {
      id: 'RESOLVIDA',
      nivel: 2,
      descricao: 'ce.enum.ocorrencia.resolvida.descricao',
      title: 'ce.enum.ocorrencia.resolvida.titulo'
    }
  },
      funcoes = {
    getStatusById: function getStatusById(id) {
      return status[id];
    },
    getStatusObject: function getStatusObject() {
      return status;
    },
    getStatus: function getStatus() {
      return _.values(status);
    },
    getKeys: function getKeys() {
      return Object.keys(status);
    }
  };

  angular.module('enumModule').constant('OcorrenciasEnum', Object.assign({}, status, funcoes));
})();
'use strict';

(function () {
  'use strict';

  var languages = {
    PT_BR: {
      underline: 'PT_BR',
      hyphen: 'PT-BR',
      moment: 'pt-br'
    },
    EN_US: {
      underline: 'EN_US',
      hyphen: 'EN-US',
      moment: 'en-us'
    },
    ES_ES: {
      underline: 'ES_ES',
      hyphen: 'ES-ES',
      moment: 'es'
    },
    EN_GB: {
      underline: 'EN_GB',
      hyphen: 'EN-GB',
      moment: 'en-gb'
    },
    DE_DE: {
      underline: 'DE_DE',
      hyphen: 'DE-DE',
      moment: 'de'
    },
    FR_FR: {
      underline: 'FR_FR',
      hyphen: 'FR-FR',
      moment: 'fr'
    },
    IT_IT: {
      underline: 'IT_IT',
      hyphen: 'IT-IT',
      moment: 'it'
    },
    NL_NL: {
      underline: 'NL_NL',
      hyphen: 'NL-NL',
      moment: 'nl'
    },
    PL_PL: {
      underline: 'PL_PL',
      hyphen: 'PL-PL',
      moment: 'pl'
    }
  },
      funcoes = {
    getLanguage: function getLanguage(id) {
      return languages[id];
    },
    getLanguagesObject: function getLanguagesObject() {
      return languages;
    },
    getKeys: function getKeys() {
      return Object.keys(languages);
    }
  };

  angular.module('enumModule').constant('LanguagesEnum', Object.assign({}, languages, funcoes));
})();
'use strict';

(function () {
  'use strict';

  /* global featurehubJsSdk */

  angular.module('FeatureFlagModule', []).factory('FeaturehubJsSdk', function () {
    return featurehubJsSdk;
  });
})();
'use strict';

(function () {
  'use strict';

  var ATIVO = true,
      INATIVO = false;

  angular.module('FeatureFlagModule').constant('FeatureFlag', {
    /**
     * Ativa ou inativa verificação de soluções.
     * @type {boolean}
     */
    SOLUCOES: ATIVO,
    SOLUCOES_AVISO: INATIVO,
    CONFIG_NOTIFICACAO_OCORRENCIA: ATIVO,
    SNAPSHOTS_HIST_DETALHADO: ATIVO,
    DOCUMENTOS_MOTORISTA: ATIVO,
    SNACKBAR_PRODUCT_VALIDATION: INATIVO,
    ADVISOR: ATIVO,
    TUTORIAL_BUSCA_REGIAO: INATIVO,
    DIALOG_PONTO_REESTRUTURADO: ATIVO,
    VIGENCIA_PROGRAMADA: ATIVO,
    MENU_INSIGHTS: ATIVO,
    SOLUCAO_REC_FACIAL: ATIVO,
    EXPORTAR_PDF_HISTORICO_OCORRENCIAS: ATIVO,
    SHOW_EVENT_DIALOG: ATIVO,
    SHOW_HARSH_EVENTS_RISK_REGION: ATIVO,
    SHOW_ULTRAPASSAGEM_ILEGAL: ATIVO
  }).constant('FeatureHubConfigKeys', {
    ENABLE_6_CAMERAS: 'TTLAV1145_videos_with_6_cameras',
    ENABLE_FEAT_ROLE_PRONTUARIO_VISUALIZAR: 'TTLAINT1512_role_PRONTUARIO_MOTORISTA_VISUALIZAR',
    FEATURE_VSAFE_BOLETIM: 'TTLATEL1853_vsafe_boletim',
    FEATURE_INTEGRATION_SUPPLIER_ENABLE: 'TTLAINT1738_add_column_data_integrator_to_alerts_board',
    DECORATED_VIDEO_PLAYER: 'STFM_974_DISPLAY_DECORATED_VIDEO_PLAYER_V3',
    DEVICE_HEALTH_PAGE: 'STFM-1371-DeviceHealth',
    DEVICE_HEALTH_TELEMATICS_TABLE: 'LAINT18_telematics_table',
    ENABLE_INTEGRATION_CODE_LANDMARK: 'TTLATEL1891_integration_code_landmark',
    COLLAPSIBLE_TABLES: 'STFM1206_collapsible_tables',
    FEATURE_THUMBNAILS_BUTTON: 'STFM1263_thumbnails_buttons',
    SEPARATE_STABILITY_CONTROL: 'STFM-1217_separate_stability_control',
    ENABLE_RETENTION_PERIOD_NA: 'STFM1332_retention_period_configuration',
    ENABLE_RETENTION_PERIOD_LATAM: 'LAVID-996_retention_period_configuration',
    FIX_UI_BEHAVIOR: 'STFM1392_fix_ui_behavior',
    ENABLE_DRIVER_LINK: 'TTLAINT1555_driver_link',
    ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS: 'STFM-1380_device_health_notification_configuration',
    ENABLE_EXCEEDED_PERMANENCIA_REALTIME: 'LATEL390_EXCEEDED_PERMANENCIA_REALTIME',
    ORION_HIDE_TITLE: 'PVPH44_hide_title',
    COACHING_PAGE: 'PVS_187_COACHING_PAGE_NAVIGATION',
    USE_NEW_TILES_SOURCE: 'LAINT_692_NEW_TILES_SOURCE',
    ENABLE_DRIVER_PRIVACY: 'PVS-334_driver_privacy',
    DECORATED_MODAL_WITHOUT_VIDEO: 'PVS_109_DECORATED_MODAL_WITHOUT_VIDEO',
    ENABLE_FEAT_DOWNLOAD_PDF_ANALISE_MOVIMENTO_VEICULO: 'LATEL_631_download_pdf_analise_movimento_veiculo',
    FEATURE_INVALID_GPS_MAPS: 'TTLATEL633_invalid_gps_maps',
    VIDEO_PLAYBACK_REQUEST: 'PSVI328_video_playback_request',
    CONFIG_ALERTA_USO_INDEVIDO_VEICULO: 'LATEL-1022_configuracao_alerta_uso_indevido_veiculo',
    QA_MAP_SERVER: 'LAINT_817_qa_map_server',
    ENABLE_AI_ANALYSIS_COLUMN: 'LAVID-701_alerts_ai_analysis_column',
    VEHICLE_SETTINGS_PAGE: 'PSVI586_vehicle_settings_page',
    GESTAO_OCORRENCIA_FLAG: 'LAVID-794_gestao_ocorrencia',
    EVENTS_CARD_VIEW_LATAM: 'PSVI732_thumbnails_view_latam',
    RISK_INTELLIGENCE_LINK: 'LAVID-759_risk_intelligence_link',
    MANUSEIO_OBJETO_FRONTEND: 'LAVID-842_manuseio_objeto_frontend',
    BOLETIM_MOTORISTA_RELATORIO_AGENDADO: 'INNOVATION_DAY_BDM',
    VFLEETS2_MENU_ITEM: 'IDAY-0001_vfleets2_menu_item',
    ROLLING_STOP: 'PSVI453_ROLLING_STOP',
    VEHICLE_VIDEO_EQUIPMENT_COLUMNS: 'PSVI697_vehicle_video_equipment_columns',
    ROUTE_DEVIATION: 'LADRX661_ROUTE_DEVIATION',
    FILTER_EVENT_BY_DRIVER: 'PSVI_140_FILTER_EVENT_BY_DRIVER',
    AUTOMATED_COACHING: 'CPD_393_enable_automated_coaching',
    ENABLE_COACHING_PORTAL: 'enable_coaching_portal',
    COACHING_NON_NA: 'CPD_759_COACHING_NON_NA',
    HIDE_VIDEO_HISTORY_MENU: 'PSVI_657_hide_video_history_menu',
    ROUTE_PROGRESS_CARD: 'LADRX698_ROUTE_PROGRESS_CARD',
    MANUAL_EVENT_HARDWARE: 'PSVI908_MANUAL_EVENT_HARDWARE'
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('enumModule').constant('EventosEnum', {
    EXCESSO_VELOCIDADE: 'ce.enum.common.excessoVelocidade',
    EXCESSO_VELOCIDADE_VIA: 'ce.enum.common.excessoVelocidadePorVia',
    PARADO_LIGADO: 'ce.enum.common.paradoLigado',
    RPM_EXCESSIVO: 'ce.enum.common.rpmExcessivo',
    BANGUELA: 'ce.enum.common.banguela',
    CURVA_BRUSCA: 'ce.enum.common.curvaBrusca',
    ACELERACAO_BRUSCA: 'ce.enum.common.aceleracaoBrusca',
    FRENAGEM_BRUSCA: 'ce.enum.common.frenagemBrusca',
    FREADA_BRUSCA_COM_ACIONAMENTO_PEDAL: 'ce.enum.common.frenagemBruscaComPedal',
    FREADA_BRUSCA_SEM_ACIONAMENTO_PEDAL: 'ce.enum.common.frenagemBruscaSemPedal',
    POSSIVEL_COLISAO: 'ce.enum.common.possivelColisao',
    CURVA: 'ce.enum.eventos.curva',
    ACELERACAO: 'ce.enum.eventos.aceleracao',
    FREADA: 'ce.enum.eventos.freada',
    TREPIDACAO: 'ce.enum.common.trepidacao',
    VEICULO_SEM_VIGENCIA: 'ce.enum.common.semVigencia',
    PONTO_REFERENCIA: 'ce.enum.eventos.pontoDeReferencia',
    LOCALIZACAO: 'ce.enum.eventos.localizacao',
    ANALISE_OPERACIONAL: 'ce.enum.eventos.analiseOperacional',
    JORNADA: 'ce.enum.eventos.jornada',
    RFID: 'ce.enum.eventos.rfidUpperCase',
    CONEXAO_EQUIPAMENTO: 'ce.enum.eventos.conexaoEquipamento',
    REMOCAO_EQUIPAMENTO: 'ce.enum.common.remocaoEquipamento',
    DIAGNOSTICO_ODB: 'ce.enum.eventos.diagnosticoObd',
    DIAGNOSTICO_CAN: 'ce.enum.eventos.diagnosticoCan',
    STATUS: 'ce.enum.eventos.status',
    MOVIMENTO: 'ce.enum.eventos.movimento',
    PARADO: 'ce.enum.eventos.parado',
    SENSOR_ACIONADO: 'ce.enum.eventos.sensorAcionado',
    MANUTENCAO_PROGRAMADA: 'ce.enum.common.manutencaoProgramada',
    DISTANCIA_PERIGOSA: 'ce.enum.common.distanciaPerigosa',
    DISTRACAO_MOTORISTA: 'ce.enum.common.distracao',
    FADIGA_MOTORISTA: 'ce.enum.common.fadiga',
    MANUSEIO_CELULAR: 'ce.enum.common.usoDeCelular',
    PREVISAO_COLISAO: 'ce.enum.common.quaseColisao',
    USO_CIGARRO: 'ce.enum.common.usoDeCigarro',
    CAMERA_OBSTRUIDA: 'ce.enum.common.cameraObstruida',
    CAMERA_DISCONNECTION_DRIVER: 'ce.enum.eventos.cameraDisconnectionDriver',
    CAMERA_DISCONNECTION_ROAD: 'ce.enum.eventos.cameraDisconnectionRoad',
    CAMERA_DISCONNECTION_AUDIT: 'ce.enum.eventos.cameraDisconnectionAudit',
    PERMANENCIA_PONTO: 'ce.enum.common.permanenciaPontoReferencia',
    MANUTENCAO_PROGRAMADA_HORIMETRO: 'ce.enum.common.manutencaoProgramadaHorimetro',
    DESCIDA: 'ce.enum.common.descida',
    DESCIDA_FAIXA1: 'ce.enum.eventos.descidaFaixa1',
    DESCIDA_FAIXA2: 'ce.enum.eventos.descidaFaixa2',
    DESCIDA_FAIXA3: 'ce.enum.eventos.descidaFaixa3',
    SEM_CONE: 'ce.enum.eventos.semCone',
    SEM_OCULOS: 'ce.enum.eventos.SemOculos',
    SEM_LUVAS: 'ce.enum.eventos.SemLuvas',
    SEM_EPI: 'ce.enum.eventos.semEPI',
    BOCEJO: 'ce.enum.eventos.bocejo',
    ULTRAPASSAGEM_ILEGAL: 'ce.enum.eventos.ultrapassagemIlegal',
    CARONA: 'ce.enum.eventos.carona',
    SEM_CINTO: 'ce.enum.common.semCinto',
    MOTORISTA_AUSENTE: 'ce.enum.common.semMotorista',
    FOLLOWING_DISTANCE: 'ce.enum.eventos.followingDistance',
    ROP_ENGINE: 'ce.enum.eventos.ropEngine',
    ROP_BRAKE: 'ce.enum.eventos.ropBrake',
    YC_ENGINE: 'ce.enum.eventos.ycEngine',
    YC_BRAKE: 'ce.enum.eventos.ycBrake',
    COLLISION_MITIGATION: 'ce.enum.eventos.collisionMitigation',
    HAPTIC_WARNING: 'ce.enum.eventos.hapticWarning',
    FCW_BRAKE_EXT_ACC_DEM: 'ce.enum.eventos.fcwBrakeExtAccDem',
    FCW: 'ce.enum.eventos.fcw',
    UNAUTHORIZED_VEHICLE_USE: 'ce.enum.eventos.unauthorizedVehicleUse',
    MANUSEIO_OBJETO: 'ce.enum.eventos.manuseioObjeto',
    ROLLING_STOP: 'ce.enum.eventos.rollingStop',
    NO_STOP: 'ce.enum.eventos.noStop',
    SEM_CASQUETE: 'ce.enum.eventos.semCasquete',
    ROUTE_DEVIATION: 'ce.enum.eventos.routeDeviation',
    MANUAL_EVENT_HARDWARE: 'ce.enum.eventos.manualEventHardware'
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('confluenceID', []).constant('IDDirecaoSegura', 115409915).constant('IDRankingSafety', 115409940).constant('IDBDV', 115378154).constant('IDBDVDetalhes', 127926344).constant('IDBDM', 127501023).constant('IDBDMDetalhes', 129105986).constant('IDBuscaPorRegiao', 1849917446);
})();
'use strict';

(function () {
  'use strict';

  var tipos = {
    CONFORME: { id: 'CONFORME', label: 'ce.enum.checklist.conforme', class: 'text-success' },
    NAO_CONFORME: { id: 'NAO_CONFORME', label: 'ce.enum.checklist.naoConforme', class: 'text-danger' },
    NAO_APLICA: { id: 'NAO_APLICA', label: 'ce.enum.checklist.naoSeAplica', class: '' }
  },
      func = {
    getTipoChecklist: function getTipoChecklist(tipo) {
      return tipos[tipo] || { id: '', label: '', class: '' };
    }
  };
  angular.module('ChecklistEnum', []).constant('ChecklistEnum', Object.assign({}, tipos, func));
})();
'use strict';

(function () {
  'use strict';

  var getListBuscaRegiaoResult = {
    data: [{
      veiculoId: 999,
      placa: 'ABC1234',
      prefixo: 'ABC 1234',
      datahora: new Date().toISOString(),
      latitude: -23.31531166,
      longitude: -51.15512166
    }, {
      veiculoId: 888,
      placa: 'DEF5678',
      prefixo: 'DEF 5678',
      datahora: new Date().toISOString(),
      latitude: -23.31531166,
      longitude: -51.15512166
    }]
  };

  angular.module('enumModule').constant('MockGetListBuscaRegiao', getListBuscaRegiaoResult);
})();
'use strict';

(function () {
  'use strict';

  angular.module('core-ce.constants', []).constant('maxChar', '\u4000');
})();
'use strict';

(function () {
    'use strict';

    var getManyAdvisorResult = [{
        velocidades: {
            caminhao: [{ angulo: 35, velocidade: 65 }],
            onibus: [{ angulo: 35, velocidade: 50 }]
        },
        uuid: 'a80f20d4-c548-4287-96ac-f20d338698cb',
        velocidadeInformativa: { caminhao: 50, onibus: 40 },
        velocidadeInterna: { caminhao: 50, onibus: 40 },
        uoId: 151,
        lat: -23.2688573,
        lng: -51.1751573,
        raio: 300,
        eventos: { curva: 10, freada: 20 },
        status: 'pendente',
        logradouro: 'Rua Joao Cunha, Londrina, Paraná'
    }, {
        velocidades: {
            caminhao: [{ angulo: 35, velocidade: 65 }],
            onibus: [{ angulo: 35, velocidade: 50 }]
        },
        uuid: 'abd01840-36b9-44dd-9bef-d6e3d50844bd',
        velocidadeInformativa: { caminhao: 40, onibus: 30 },
        velocidadeInterna: { caminhao: 40, onibus: 30 },
        uoId: 151,
        lat: 52.5,
        lng: 66.7,
        raio: 300,
        eventos: { curva: 98, freada: 47 },
        status: 'pendente',
        logradouro: 'Rua Jose Alves, Ibiporã, Paraná'
    }, {
        velocidades: {
            caminhao: [{ angulo: 35, velocidade: 65 }],
            onibus: [{ angulo: 35, velocidade: 50 }]
        },
        uuid: 'abd01840-36b9-44dd-9bef-d6e3d50844bd',
        velocidadeInformativa: { caminhao: 40, onibus: 30 },
        velocidadeInterna: { caminhao: 40, onibus: 30 },
        uoId: 151,
        lat: 52.5,
        lng: 66.7,
        raio: 300,
        eventos: { curva: 98, freada: 47 },
        status: 'pendente',
        logradouro: 'Rua Jose Alves, Ibiporã, Paraná'
    }, {
        velocidades: {
            caminhao: [{ angulo: 35, velocidade: 65 }],
            onibus: [{ angulo: 35, velocidade: 50 }]
        },
        uuid: 'abd01840-36b9-44dd-9bef-d6e3d50844bd',
        velocidadeInformativa: { caminhao: 40, onibus: 30 },
        velocidadeInterna: { caminhao: 40, onibus: 30 },
        uoId: 151,
        lat: 52.5,
        lng: 66.7,
        raio: 300,
        eventos: { curva: 98, freada: 47 },
        status: 'pendente',
        logradouro: 'Rua Jose Alves, Ibiporã, Paraná'
    }];

    angular.module('enumModule').constant('MockGetManyAdvisors', getManyAdvisorResult);
})();
'use strict';

(function () {
  'use strict';

  angular.module('configuracoesEvento', ['restangular']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfiguracoesEvento = function () {
    function ConfiguracoesEvento(Restangular) {
      _classCallCheck(this, ConfiguracoesEvento);

      this.restangular = Restangular;
    }

    _createClass(ConfiguracoesEvento, [{
      key: 'getConfiguracoes',
      value: function getConfiguracoes(uoId) {
        return this.restangular.one('/sensor/uos/' + uoId + '/configuracoes/evento').get();
      }
    }]);

    return ConfiguracoesEvento;
  }();

  angular.module('configuracoesEvento').service('ConfiguracoesEvento', ConfiguracoesEvento);
})();
'use strict';

(function () {
  'use strict';

  /* global $, moment */

  $.AdminLTE.options.enableBSToppltip = false;
  $.AdminLTE.options.navbarMenuSlimscroll = false;
  // Set moment to serialize dates to json
  /*eslint-disable */
  Date.prototype.toJSON = function () {
    return moment(this).format();
  };
  /*eslint-enable */

  angular.module('conducaoEconomica').config(config);

  function config(stConfig, blockUIConfig, growlProvider, $httpProvider, $locationProvider) {
    stConfig.pagination.template = 'template/pagination-template.html';
    blockUIConfig.message = '...';

    function ignorarModalCarregando(blockConfig) {
      if (blockConfig.url.match(/ponto-referencia/) || blockConfig.url.match(/status-veiculo/) || blockConfig.url.match(/alerta\/quantidade/) || blockConfig.url.match(/alerta\/one-page/) || blockConfig.url.match(/alerta\/ranking-infracoes/) || blockConfig.url.match(/configuracao\/configuracoes\/[0-9]*\/alerta/) || blockConfig.url.match(/alerta\/notificacoes\/[0-9]*/) || blockConfig.url.match(/.*duo-routes.*/) || blockConfig.url.match(/.*macro.*/)) {
        return false;
      }
      return '...';
    }
    blockUIConfig.requestFilter = ignorarModalCarregando;

    growlProvider.globalTimeToLive(3000);
    growlProvider.globalPosition('bottom-right');

    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common.Accept = 'application/json';

    $locationProvider.html5Mode(true);
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('chartModule', ['highcharts-ng']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var SingleColumnChart = function () {
    function SingleColumnChart(CommonChart, $timeout, $rootScope) {
      _classCallCheck(this, SingleColumnChart);

      this.commonChartService = CommonChart;
      this.timeout = $timeout;
      this.scope = $rootScope;
      this.title = this.commonChartService.getTitle();
      this.subtitle = this.commonChartService.getSubtitle();
      this.xAxis = this.commonChartService.getXAxis();
      this.yAxis = this.commonChartService.getYAxis(false, false);
      this.options = this.getOptions();
      this.series = null;
      this.animation = false;
      this.erroSemData = true;
    }

    _createClass(SingleColumnChart, [{
      key: 'getOptions',
      value: function getOptions() {
        var _this = this;

        return {
          chart: {
            events: {
              load: function load() {
                _this.timeout(function () {
                  return _this.scope.$broadcast('highchartsng.reflow');
                }, 100);
              }
            },
            type: 'column'
          },
          colors: ['rgb(244, 150, 59)', 'rgb(72, 60, 70)', 'rgb(60, 110, 113)', 'rgb(136,84,196)', 'rgb(112,174,110)', 'rgb(139,188,33)', 'rgb(255,108,58)', 'rgb(49,139,255)', 'rgb(204,38,54)', '#F2994A', 'rgb(136,84,196)', 'rgb(255,203,63)', 'rgb(255,73,121)', '#6790AB', '#FF94C2', '#880E4F', '#C62828', '#424242', '#9E9E9E'],
          exporting: {
            enabled: false
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              grouping: false,
              animation: true
            },
            series: {
              data: [],
              point: { events: {} },
              events: {
                click: this.commonChartService.filterAllSeries,
                legendItemClick: this.commonChartService.filterAllSeries
              }
            }
          },
          credits: { enabled: false },
          legend: {
            itemStyle: {
              font: '9pt "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              color: 'black'
            }
          },
          tooltip: {
            shared: false
          }
        };
      }
    }, {
      key: 'setCustomTooltip',
      value: function setCustomTooltip() {
        this.options.tooltip.formatter = function () {
          return '<span style="color: ' + this.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y + '</b>';
        };
      }
    }, {
      key: 'setAnimation',
      value: function setAnimation() {
        if (this.animation) {
          this.options.plotOptions.column.animation = false;
        } else {
          this.options.plotOptions.column.animation = true;
          this.animation = true;
        }
      }
    }, {
      key: 'setData',
      value: function setData(data) {
        if (data.series) {
          this.xAxis.categories = data.categorias;
          this.series = this.mapSingleSeries(data.series);
          this.setAnimation();
        }
      }
    }, {
      key: 'setClickEvent',
      value: function setClickEvent(onClickColumn) {
        this.options.plotOptions.series.point.events.click = onClickColumn;
        this.options.plotOptions.series.events.click = function () {};
      }
    }, {
      key: 'setLegendItemClickEvent',
      value: function setLegendItemClickEvent(onLegendItemClick) {
        this.options.plotOptions.series.events.legendItemClick = onLegendItemClick;
      }
    }, {
      key: 'setTitleText',
      value: function setTitleText(chartTitle) {
        this.title.text = chartTitle;
      }
    }, {
      key: 'setYAxisTitle',
      value: function setYAxisTitle(yAxisTitle, axisIndex) {
        if (angular.isArray(this.yAxis)) {
          if (axisIndex) {
            this.yAxis[axisIndex].title.text = yAxisTitle;
          } else {
            this.yAxis[0].title.text = yAxisTitle;
          }
        } else {
          this.yAxis.title.text = yAxisTitle;
        }
      }
    }, {
      key: 'mapSingleSeries',
      value: function mapSingleSeries(series) {
        var _this2 = this;

        return _.chain(series).map(function (serie, index) {
          return {
            name: serie.name,
            data: _this2.preencheDados(serie.data, index, series.length),
            visible: angular.isUndefined(serie.visible) || serie.visible,
            color: serie.color || _this2.options.colors[serie.indexColor],
            key: serie.key
          };
        }).flatten().value();
      }
    }, {
      key: 'preencheDados',
      value: function preencheDados(valor, index, qntItem) {
        var data = [];
        for (var i = 0; i < qntItem; i++) {
          if (i === index) {
            data.push(valor);
          } else {
            data.push(null);
          }
        }
        return data;
      }
    }, {
      key: 'removeTitleCategories',
      value: function removeTitleCategories() {
        this.xAxis.labels = {
          enabled: false
        };
      }
    }, {
      key: 'disableLegend',
      value: function disableLegend() {
        this.options.legend.enabled = false;
      }
    }]);

    return SingleColumnChart;
  }();

  angular.module('chartModule').service('SingleColumnChart', function (CommonChart, $timeout, $rootScope) {
    return { get: function get() {
        return new SingleColumnChart(CommonChart, $timeout, $rootScope);
      } };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PieChart = function () {
    function PieChart(CommonChart) {
      _classCallCheck(this, PieChart);

      this.commonChartService = CommonChart;
      this.title = this.commonChartService.getTitle();
      this.subtitle = this.commonChartService.getSubtitle();
      this.xAxis = this.commonChartService.getXAxis();
      this.yAxis = this.commonChartService.getYAxis(false, true);
      this.options = this.getOptions();
      this.series = null;
    }

    _createClass(PieChart, [{
      key: 'getOptions',
      value: function getOptions() {
        return {
          chart: { renderTo: 'container', type: 'pie' },
          colors: ['rgb(204,38,54)', 'rgb(255,154,0)', 'rgb(139,188,33)', 'rgb(49,139,255)', 'rgb(136,84,196)', 'rgb(255,203,63)', 'rgb(255,73,121)', 'rgb(255,108,58)', 'rgb(8,204,180)', 'rgb(83,119,0)', 'rgb(255,63,0)', 'rgb(79,73,255)', 'rgb(209,153,12)'],
          plotOptions: {
            column: {},
            line: {},
            pie: {
              borderColor: '#FFFFFF',
              borderWidth: 1,
              innerSize: '60%'
            },
            series: { point: { events: {} }, events: {} }
          },
          credits: { enabled: false },
          legend: {
            itemStyle: {
              font: '9pt "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              color: 'black'
            }
          }
        };
      }
    }, {
      key: 'setData',
      value: function setData(data) {
        this.xAxis.categories = data.categorias;
        this.series = [{
          data: data.map(function (d) {
            return [d.name, d.total];
          }),
          size: '90%',
          innerSize: '60%',
          showInLegend: true,
          dataLabels: {
            enabled: false
          }
        }];

        this.options.tooltip = { pointFormat: '<b>{point.y}</b>' };
      }
    }, {
      key: 'setTitleText',
      value: function setTitleText(chartTitle) {
        this.title.text = chartTitle;
      }
    }, {
      key: 'setYAxisTitle',
      value: function setYAxisTitle(yAxisTitle) {
        this.yAxis.title.text = yAxisTitle;
      }
    }, {
      key: 'setClickEvent',
      value: function setClickEvent(onClick) {
        this.options.plotOptions.series.point.events.click = onClick;
        this.options.plotOptions.series.events.click = function () {};
      }
    }]);

    return PieChart;
  }();

  angular.module('chartModule').service('PieChart', function (CommonChart) {
    return { get: function get() {
        return new PieChart(CommonChart);
      } };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var HalfPieChart = function () {
    function HalfPieChart(CommonChart, $timeout, $rootScope, $translate) {
      _classCallCheck(this, HalfPieChart);

      this.commonChartService = CommonChart;
      this.timeout = $timeout;
      this.scope = $rootScope;
      this.translate = $translate;
      this.title = this.commonChartService.getTitle();
      this.subtitle = this.commonChartService.getSubtitle();
      this.xAxis = this.commonChartService.getXAxis();
      this.yAxis = this.commonChartService.getYAxis(false, false);
      this.options = this.getOptions();
      this.series = null;
      this.animation = false;
      this.erroSemData = true;
    }

    _createClass(HalfPieChart, [{
      key: 'getOptions',
      value: function getOptions() {
        var _this = this;

        return {
          chart: {
            events: {
              load: function load() {
                _this.timeout(function () {
                  return _this.scope.$broadcast('highchartsng.reflow');
                }, 100);
              }
            },
            type: 'pie'
          },
          exporting: {
            enabled: false
          },
          colors: ['rgb(139,188,33)', 'rgb(130,130,130)'],
          plotOptions: {
            pie: {
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '85%'],
              animation: true,
              size: '150%',
              dataLabels: {
                enabled: true,
                distance: -40,
                style: {
                  fontWeight: 'bold',
                  color: 'black'
                },
                formatter: function formatter() {
                  return this.percentage.toFixed(2) + '%';
                }
              }
            },
            series: {
              type: 'pie',
              innerSize: '50%',
              point: { events: {} },
              events: {}
            }
          },
          credits: { enabled: false },
          legend: {
            itemStyle: {
              font: '9pt "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              color: 'black'
            }
          },
          tooltip: {
            shared: false
          }
        };
      }
    }, {
      key: 'setAnimation',
      value: function setAnimation() {
        if (this.animation) {
          this.options.plotOptions.pie.animation = false;
        } else {
          this.options.plotOptions.pie.animation = true;
          this.animation = true;
        }
      }
    }, {
      key: 'setData',
      value: function setData(data) {
        if (data.series) {
          this.xAxis.categories = data.categorias;
          this.series = [{
            name: this.translate.instant('ce.tempoReal.statusFrota.charts.common.veiculos'),
            data: data.series.map(function (d) {
              return [d.name, d.y, d.ids];
            }),
            showInLegend: true
          }];
          this.setAnimation();
        }
      }
    }, {
      key: 'setClickEvent',
      value: function setClickEvent(onClickColumn) {
        this.options.plotOptions.series.point.events.click = onClickColumn;
        this.options.plotOptions.series.events.click = function () {};
      }
    }, {
      key: 'setTitleText',
      value: function setTitleText(chartTitle) {
        this.title.text = chartTitle;
      }
    }, {
      key: 'setYAxisTitle',
      value: function setYAxisTitle(yAxisTitle) {
        this.yAxis.title.text = yAxisTitle;
      }
    }, {
      key: 'removeTitleCategories',
      value: function removeTitleCategories() {
        this.xAxis.labels = {
          enabled: false
        };
      }
    }]);

    return HalfPieChart;
  }();

  angular.module('chartModule').service('HalfPieChart', function (CommonChart, $timeout, $rootScope, $translate) {
    return { get: function get() {
        return new HalfPieChart(CommonChart, $timeout, $rootScope, $translate);
      } };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global Highcharts */

  var DrilldownChart = function () {
    function DrilldownChart(yAxis, CommonChart, $timeout, $rootScope, $translate) {
      _classCallCheck(this, DrilldownChart);

      this.commonChartService = CommonChart;
      this.timeout = $timeout;
      this.scope = $rootScope;
      this.translate = $translate;
      this.title = this.commonChartService.getTitle();
      this.subtitle = this.commonChartService.getSubtitle();
      this.options = this.getOptions();
      this.series = null;
      this.yAxis = {
        title: {
          text: this.translate.instant('ce.tempoReal.statusFrota.charts.common.quantidadeDeEventos')
        }
      };
      this.xAxis = {
        type: 'category',
        categories: [],
        plotBands: []
      };

      this.animation = false;
      this.erroSemData = true;
      this.isDrillDown = false;
      Highcharts.Tick.prototype.drillable = function () {};
    }

    _createClass(DrilldownChart, [{
      key: 'getOptions',
      value: function getOptions() {
        var _this = this;

        return {
          chart: {
            type: 'column',
            events: {
              load: function load() {
                _this.timeout(function () {
                  return _this.scope.$broadcast('highchartsng.reflow');
                }, 100);
              },
              drilldown: function drilldown(e) {
                e.target.xAxis[0].categories = e.seriesOptions.data.map(function (x) {
                  return x.name;
                });
                e.target.xAxis[0].removePlotBand('turno-atual');
                _this.isDrillDown = true;
              },
              drillup: function drillup(e) {
                e.target.xAxis[0].categories = e.target.options.xAxis[0].categories;
                e.target.xAxis[0].addPlotBand(_this.plotOptions);
                _this.isDrillDown = false;
              }
            }
          },
          lang: {
            drillUpText: '< ' + this.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.voltar')
          },
          plotOptions: {
            series: {
              point: { events: {} },
              dataLabels: {
                enabled: false
              },
              stacking: 'normal',
              events: {
                legendItemClick: this.commonChartService.filterAllSeries
              }
            }
          },
          credits: { enabled: false },
          legend: {
            enabled: true,
            itemStyle: {
              font: '9pt "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              color: 'black'
            }
          },
          drilldown: {
            drillUpButton: {
              relativeTo: 'spacingBox',
              position: {
                y: 0,
                x: -30
              }
            },
            series: []
          }
        };
      }
    }, {
      key: 'setAnimation',
      value: function setAnimation() {
        if (this.animation) {
          this.options.plotOptions.series.animation = false;
        } else {
          this.options.plotOptions.series.animation = true;
          this.animation = true;
        }
      }
    }, {
      key: 'setData',
      value: function setData(data) {
        this.xAxis.categories = [];
        this.xAxis.plotBands = [];
        this.series = [];
        this.options.drilldown.series = [];

        if (data && data.series.length > 0) {
          this.erroSemData = false;

          for (var i = 1; i <= data.series[0].data.length; i++) {
            if (data.turnoAtual === i) {
              var from = angular.copy(i),
                  to = angular.copy(i);
              this.xAxis.categories.push('<strong>\n                ' + this.translate.instant('ce.tempoReal.statusFrota.charts.common.resolvidosTotal') + '\n              </strong>\n              <br />\n              <strong>\n                ' + this.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.turno') + ' ' + i + '\n              </strong>');
              this.plotOptions = {
                color: '#f0f0f0',
                from: from - 1.5,
                to: to - 0.5,
                id: 'turno-atual'
              };
              this.xAxis.plotBands.push(this.plotOptions);
            } else {
              this.xAxis.categories.push(this.translate.instant('ce.tempoReal.statusFrota.charts.common.resolvidosTotal') + '\n              <br />\n              ' + this.translate.instant('ce.tempoReal.statusFrota.charts.alertaSeguranca.turno') + ' ' + i);
            }
          }
          this.series = data.series;
          this.options.drilldown.series = data.drilldown;

          this.setAnimation();
        } else {
          this.erroSemData = true;
        }
      }
    }, {
      key: 'setClickEvent',
      value: function setClickEvent(onClickColumn) {
        this.options.plotOptions.series.point.events.click = onClickColumn;
        this.options.plotOptions.series.events.click = function () {};
      }
    }]);

    return DrilldownChart;
  }();

  angular.module('chartModule').service('DrilldownChart', function (CommonChart, $timeout, $rootScope, $translate) {
    return { get: function get(yAxis) {
        return new DrilldownChart(yAxis, CommonChart, $timeout, $rootScope, $translate);
      } };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _, Highcharts */

  var CommonChart = function () {
    function CommonChart() {
      _classCallCheck(this, CommonChart);
    }

    _createClass(CommonChart, [{
      key: 'getYAxis',
      value: function getYAxis(yAxis, allowDecimals) {
        var ret = void 0;
        if (!yAxis) {
          ret = {
            allowDecimals: allowDecimals,
            min: 0,
            title: { text: '' },
            labels: this.labelFormat()
          };
        } else {
          var axis = [];
          for (var i = 0; i < yAxis; i++) {
            axis.push({
              allowDecimals: allowDecimals,
              min: 0,
              title: { text: '' },
              labels: this.labelFormat(),
              opposite: i > 0
            });
          }
          ret = axis;
        }
        return ret;
      }
    }, {
      key: 'getXAxis',
      value: function getXAxis() {
        return {
          stackLabels: {
            style: { color: 'black' },
            enabled: true
          },
          categories: []
        };
      }
    }, {
      key: 'getSubtitle',
      value: function getSubtitle() {
        return {
          align: 'left',
          style: {
            color: '#333',
            font: '12px "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif'
          }
        };
      }
    }, {
      key: 'getTitle',
      value: function getTitle() {
        return {
          text: '',
          align: 'left',
          style: {
            color: '#333',
            font: '18px "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif'
          }
        };
      }
    }, {
      key: 'getGradientColors',
      value: function getGradientColors(colors) {
        var re = /(rgb)\(([0-9]+),+([0-9]+),+([0-9]+)/,
            subst = 'rgba($2,$3,$4,0.5';
        return colors.map(function (x) {
          return x.replace(re, subst);
        });
      }
    }, {
      key: 'labelFormat',
      value: function labelFormat() {
        return {
          formatter: function formatter() {
            return this.value.toLocaleString('pt-BR');
          }
        };
      }
    }, {
      key: 'filterAllSeries',
      value: function filterAllSeries() {
        var _this = this;

        var visibleSeries = [],
            wasVisible = this.visible;

        _.chain(Highcharts.charts).filter(function (chart) {
          return angular.isDefined(chart);
        }).filter(function (chart) {
          return chart.options.chart.type !== 'pie';
        }).forEach(function (chart) {
          var showThis = false;

          chart.series.forEach(function (serie) {
            if (serie.visible) {
              visibleSeries.push(serie.name);
            }

            if (wasVisible) {
              if (serie.name !== _this.name) {
                if (serie.visible) {
                  serie.hide();
                }
              }
            } else if (serie.name === _this.name) {
              showThis = true;
            }
          });

          if (showThis) {
            _.chain(chart.series).filter(function (serie) {
              return serie.name === _this.name;
            }).forEach(function (serie) {
              return serie.show();
            });
          }
        });

        var uniqueSeries = _.unique(visibleSeries).length;

        if (wasVisible && (uniqueSeries === 1 || uniqueSeries === 0)) {
          _.chain(Highcharts.charts).filter(function (chart) {
            return angular.isDefined(chart);
          }).map(function (chart) {
            return chart.series;
          }).flatten().filter(function (serie) {
            return serie.name !== _this.name;
          }).forEach(function (serie) {
            return serie.show();
          });
        }

        return false;
      }
    }]);

    return CommonChart;
  }();

  angular.module('chartModule').service('CommonChart', CommonChart);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var ColumnChart = function () {
    function ColumnChart(yAxis, colors, CommonChart, moment, $filter) {
      _classCallCheck(this, ColumnChart);

      this.commonChartService = CommonChart;
      this.moment = moment;
      this.filter = $filter;
      this.title = this.commonChartService.getTitle();
      this.subtitle = this.commonChartService.getSubtitle();
      this.xAxis = this.commonChartService.getXAxis();
      this.yAxis = this.commonChartService.getYAxis(yAxis, false);
      this.colors = colors || ['rgb(49,139,255)', 'rgb(204,38,54)', 'rgb(139,188,33)', 'rgb(136,84,196)', 'rgb(255,203,63)', 'rgb(255,73,121)', 'rgb(255,108,58)', 'rgb(8,204,180)', 'rgb(83,119,0)', 'rgb(255,63,0)', 'rgb(79,73,255)', 'rgb(209,153,12)'];
      this.gradientColors = this.commonChartService.getGradientColors(this.colors);
      this.options = this.getOptions();
      this.series = null;
      this.columnSeries = null;
    }

    _createClass(ColumnChart, [{
      key: 'getOptions',
      value: function getOptions() {
        return {
          chart: { type: 'column' },
          colors: this.colors,
          plotOptions: {
            column: {
              stacking: 'normal',
              grouping: false
            },
            series: {
              point: { events: {} },
              events: {
                click: this.commonChartService.filterAllSeries,
                legendItemClick: this.commonChartService.filterAllSeries
              },
              tooltip: {
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>'
              }
            }
          },
          credits: { enabled: false },
          legend: {
            itemStyle: {
              font: '9pt "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              color: 'black'
            }
          }
        };
      }
    }, {
      key: 'setDateTooltip',
      value: function setDateTooltip() {
        var self = this;
        this.options.plotOptions.series.tooltip.pointFormatter = function () {
          var valor = this.y;
          if (this.series.options.dataDefault) {
            var data = this.series.options.dataDefault[this.index];
            valor = self.filter('humanizedDuration')(angular.isNumber(data) ? data : data.y, true);
          }
          return '<span style="color:' + this.color + '">\u25CF</span> ' + this.series.name + ': <b>' + valor + '</b><br/>';
        };
      }
    }, {
      key: 'setData',
      value: function setData(data, tipoDate) {
        this.xAxis.categories = data.categorias;
        this.columnSeries = data;

        if (data.series) {
          if (data.series[0].compareData) {
            this.series = this.mapComparativeSeries(data.series, tipoDate);
          } else {
            this.series = this.mapSingleSeries(data.series, tipoDate);
          }
          this.options.tooltip = { shared: false };
        }
      }
    }, {
      key: 'mapSeries',
      value: function mapSeries(data) {
        return data.map(function (item) {
          if (angular.isNumber(item)) {
            return item / 3600;
          }
          var i = item.y;
          item.y = i / 3600;
          return item;
        });
      }
    }, {
      key: 'mapSingleSeries',
      value: function mapSingleSeries(series, tipoDate) {
        var _this = this;

        return _.chain(series).map(function (serie, index) {
          var ret = void 0;
          if (serie.type === 'VEICULOS_QTD') {
            ret = {
              data: serie.data,
              name: serie.name,
              color: 'rgb(100, 100, 100)',
              type: 'spline',
              yAxis: 1,
              zIndex: -1,
              lineWidth: 0.6,
              marker: {
                enabled: true,
                radius: 2.5,
                symbol: 'circle'
              }
            };
          } else {
            if (_this.comparativeGradient) {
              var dataDefault = serie.data;
              if (tipoDate) {
                serie.data = _this.mapSeries(serie.data);
              }
              serie.data[0] = { y: angular.isNumber(serie.data[0]) ? serie.data[0] : serie.data[0].y, color: _this.gradientColors[index] };
              serie.data[1] = { y: angular.isNumber(serie.data[1]) ? serie.data[1] : serie.data[1].y, color: _this.options.colors[index] };
              return {
                name: serie.name,
                data: serie.data,
                dataDefault: dataDefault
              };
            }
            ret = {
              name: serie.name,
              data: tipoDate ? _this.mapSeries(serie.data) : serie.data,
              color: _this.options.colors[index],
              dataDefault: serie.data
            };
          }
          return ret;
        }).flatten().value();
      }
    }, {
      key: 'mapComparativeSeries',
      value: function mapComparativeSeries(series, tipoDate) {
        var _this2 = this;

        return _.chain(series).map(function (serie, index) {
          var ret = void 0;
          if (serie.type === 'VEICULOS_QTD') {
            ret = [{
              linkedTo: serie.name,
              name: serie.name,
              data: serie.compareData,
              stack: 'anteriorz',
              color: 'rgb(180,180,180)',
              pointPadding: 0.2,
              pointPlacement: -0.1,
              type: 'spline',
              yAxis: 1,
              zIndex: -1,
              lineWidth: 0.6,
              marker: {
                enabled: true,
                radius: 2.5,
                symbol: 'circle'
              }
            }, {
              linkedTo: null,
              name: serie.name,
              data: serie.data,
              stack: 'atualz',
              color: 'rgb(100, 100, 100)',
              pointPadding: 0.2,
              pointPlacement: 0.1,
              lineWidth: 0.6,
              type: 'spline',
              zIndex: -1,
              yAxis: 1,
              marker: {
                enabled: true,
                radius: 2.5,
                symbol: 'circle'
              }
            }];
          } else {
            ret = [{
              linkedTo: serie.name,
              name: serie.name,
              data: tipoDate ? _this2.mapSeries(serie.compareData) : serie.compareData,
              stack: 'anterior',
              color: _this2.gradientColors[index],
              pointPadding: 0.2,
              pointPlacement: -0.1,
              dataDefault: serie.compareData
            }, {
              linkedTo: null,
              name: serie.name,
              data: tipoDate ? _this2.mapSeries(serie.data) : serie.data,
              stack: 'atual',
              color: _this2.options.colors[index],
              pointPadding: 0.2,
              pointPlacement: 0.1,
              dataDefault: serie.data
            }];
          }
          return ret;
        }).flatten().sortBy('stack').value();
      }
    }, {
      key: 'setClickEvent',
      value: function setClickEvent(onClickColumn) {
        this.options.plotOptions.series.point.events.click = onClickColumn;
        this.options.plotOptions.series.events.click = function () {};
      }
    }, {
      key: 'withComparativeGradient',
      value: function withComparativeGradient() {
        this.comparativeGradient = true;
      }
    }, {
      key: 'disableLegend',
      value: function disableLegend() {
        this.options.legend.enabled = false;
      }
    }, {
      key: 'setTitleText',
      value: function setTitleText(chartTitle) {
        this.title.text = chartTitle;
      }
    }, {
      key: 'setYAxisTitle',
      value: function setYAxisTitle(yAxisTitle, axisIndex) {
        if (angular.isArray(this.yAxis)) {
          if (axisIndex) {
            this.yAxis[axisIndex].title.text = yAxisTitle;
          } else {
            this.yAxis[0].title.text = yAxisTitle;
          }
        } else {
          this.yAxis.title.text = yAxisTitle;
        }
      }
    }]);

    return ColumnChart;
  }();

  angular.module('chartModule').service('ColumnChart', function (CommonChart, moment, $filter) {
    return { get: function get(yAxis, colors) {
        return new ColumnChart(yAxis, colors, CommonChart, moment, $filter);
      } };
  });
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros
   * @description
   *
   */

  angular.module('cadastros', ['ui.router', 'cadastros.veiculo', 'cadastros.grupoVeic', 'cadastros.motorista', 'cadastros.devices', 'cadastros.pontoReferencia', 'cadastros.motorista.documentos', 'cadastros.macro']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global document */
/* eslint-disable angular/json-functions */
(function () {
  'use strict';

  var StateUrlService = function () {
    function StateUrlService($location, $window, $rootScope, $timeout, Authenticator, $state, $document, ModalInfoConfirmService, InformativoKeys, FeatureFlag, MotoristaService, SolucoesEnum, GoogleTagManagerUtils, FeatureOuService, CadastroVeiculoService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      _classCallCheck(this, StateUrlService);

      this.location = $location;
      this.window = $window;
      this.rootScope = $rootScope;
      this.authenticator = Authenticator;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.state = $state;
      this.timeout = $timeout;
      this.document = $document;
      this.FeatureOuService = FeatureOuService;
      this.modalInfoService = ModalInfoConfirmService;
      this.veiculoService = CadastroVeiculoService;
      this.FeaturehubJsSdk = FeaturehubJsSdk;
      this.FeatureHubConfigKeys = FeatureHubConfigKeys;

      this.PAGINAS_REQUIRED_INTELLIGENCE = ['root.indicadorPowerBi', 'root.quadroOcorrencias', 'root.onePage', 'root.rankingInfracoes', 'root.rankingPontos', 'root.mapaCalor', 'root.configEventos', 'root.configVdrivers'];
      this.SUBPAGES_NO_REQUIRED_INTELLIGENCE = ['', 'turnos', 'tipos'];
      this.PRODUCT_VALIDATION_SNACKBAR_PAGES = ['root.historicoTimeline', 'root.mapasGrid', 'root.historicoAlerta'];
      this.SCOPE_WITH_SUBPAGES = 'root.configEventos';
      this.informativoKeys = InformativoKeys;
      this.featureFlag = FeatureFlag;
      this.motoristaService = MotoristaService;
      this.solucoesEnum = SolucoesEnum;
      this.lastPage = '';
      this.flagBundle = null;
    }

    _createClass(StateUrlService, [{
      key: 'initInterceptInformativo',
      value: function initInterceptInformativo() {
        if (this.featureFlag.SOLUCOES) {
          this.rootScope.$on('$stateChangeStart', this.interceptParaInformativo.bind(this));
        }
      }
    }, {
      key: 'interceptParaInformativo',
      value: function interceptParaInformativo(event, toState) {
        var _this = this;

        if (this.lastPage === toState.name || this.isNoSolutionRequiredPage(toState.name)) {
          this.lastPage = toState.name;
          return;
        }
        this.lastPage = toState.name;

        this.authenticator.getUser().then(function (user) {
          if (!_this.hasRolePermission(toState, user)) {
            _this.checkAlternativeAccess(toState.data).then(function (hasPermission) {
              if (!hasPermission) {
                event.preventDefault();
                _this.sendToInformativo(toState);
              }
            });
          }
        });
      }
    }, {
      key: 'isNoSolutionRequiredPage',
      value: function isNoSolutionRequiredPage(page) {
        return ['root.informativo', 'root.planos', 'unprotected.errorPage'].includes(page);
      }
    }, {
      key: 'hasRolePermission',
      value: function hasRolePermission(toState, user) {
        return toState.data && (toState.data.roles || toState.data.role) && this.checkPermissaoSolucaoUsuario(user, toState.data.roles ? toState.data.roles : toState.data.role);
      }
    }, {
      key: 'checkPermissaoSolucaoUsuario',
      value: function checkPermissaoSolucaoUsuario(user, stateAllowedRoles) {
        var _this2 = this;

        var usuarioRolesSolucao = user.permissoesSolucao;
        if (angular.isString(stateAllowedRoles)) {
          return usuarioRolesSolucao.indexOf(stateAllowedRoles) !== -1;
        }
        if (angular.isArray(stateAllowedRoles)) {
          return stateAllowedRoles.some(function (allowedRole) {
            return _this2.checkPermissaoRole(allowedRole, usuarioRolesSolucao);
          });
        }

        return false;
      }
    }, {
      key: 'checkAlternativeAccess',
      value: function checkAlternativeAccess(stateData) {
        var bundles = stateData && stateData.accessByBundle ? stateData.accessByBundle : [],
            premiumTelemetry = stateData && stateData.accessByPremiumTelemetry ? stateData.accessByPremiumTelemetry : false;

        if (bundles.length > 0 || premiumTelemetry) {
          return this.verifyBundles(this.rootScope.usuario.uo.id, bundles, premiumTelemetry);
        }
        return Promise.resolve(false);
      }
    }, {
      key: 'verifyBundles',
      value: function verifyBundles(uoId, bundles, premiumTelemetry) {
        return this.veiculoService.hasBundle(uoId, bundles, premiumTelemetry).then(function (response) {
          return response;
        }).catch(function () {
          return false;
        });
      }
    }, {
      key: 'sendToInformativo',
      value: function sendToInformativo(toState) {
        var informativoState = this.informativoKeys[toState.name];
        if (informativoState) {
          this.state.go('root.informativo', {
            informativoKey: informativoState[0].key,
            uoId: this.rootScope.usuario.uo.id
          });
        } else {
          this.state.go('root.planos');
        }
      }
    }, {
      key: 'checkPermissaoRole',
      value: function checkPermissaoRole(role, permissoes) {
        var _this3 = this;

        if (angular.isString(role)) {
          return permissoes.indexOf(role) !== -1;
        }
        // must have all roles of this when it's an array
        return role.filter(function (roleVal) {
          return _this3.checkPermissaoRole(roleVal, permissoes);
        }).length === role.length;
      }
    }, {
      key: 'onPageChange',
      value: function onPageChange() {
        var _this4 = this;

        this.authenticator.getUser().then(function (user) {
          _this4.rootScope.$on('$viewContentLoaded', function () {
            var keyLastPage = 'lastPage-' + user.id,
                urlState = _this4.location.url();
            if (urlState !== '/informativo') {
              _this4.window.localStorage.setItem(keyLastPage, urlState);
            }
          });
        });
      }
    }, {
      key: 'getSanitizedPathName',
      value: function getSanitizedPathName() {
        var pathname = this.document[0].location.pathname;

        return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
      }
    }, {
      key: 'isValidPathname',
      value: function isValidPathname(pathname) {
        return pathname && !pathname.includes('/state=');
      }
    }, {
      key: 'getLastVisitedPageReloadReloadNaConfig',
      value: function getLastVisitedPageReloadReloadNaConfig(userUoId) {
        var _this5 = this;

        return this.FeatureOuService.getLastVisitedPageReload(userUoId).then(function (lastVisitedPageReload) {
          _this5.isTTCUser = lastVisitedPageReload;
          return lastVisitedPageReload;
        }).catch(function (error) {
          _this5.log.error('Error loading featureOu config: ', error);
          return false;
        });
      }
    }, {
      key: 'setLastUrl',
      value: function setLastUrl() {
        var _this6 = this;

        this.authenticator.getUser().then(function (user) {
          var id = user.id,
              uo = user.uo,
              lastPage = _this6.window.localStorage.getItem('lastPage-' + id);

          _this6.getLastVisitedPageReloadReloadNaConfig(uo.id).then(function () {
            var pageDefault = _this6.setDefaultPage(user),
                url = _this6.constructUrl(pageDefault, lastPage);
            _this6.location.url(url);
          });
        });
      }
    }, {
      key: 'constructUrl',
      value: function constructUrl(pageDefault, lastPage) {
        if (this.isTTCUser) {
          var pathname = this.getSanitizedPathName();
          return pageDefault || (this.isValidPathname(pathname) ? pathname : lastPage);
        }
        return lastPage || pageDefault;
      }
    }, {
      key: 'setDefaultPage',
      value: function setDefaultPage(user) {
        if (this.isTTCUser) {
          return '/mapas-grid';
        }
        if (this.featureFlag.MENU_INSIGHTS && user.permissoesSolucao.includes('PREDICAO_ACIDENTE_VISUALIZAR') && user.permissoes.includes('PREDICAO_ACIDENTE_VISUALIZAR') && user.permissoes.includes('DADOS_SENSIVEIS_VISUALIZAR') && user.permissoes.includes('ADMIN_VELTEC')) {
          return '/seguranca';
        }
        var defaultPage = '/direcao-segura';
        if (!user.permissoes.includes('DIRECAO_SEGURA_VISUALIZAR')) {
          defaultPage = user.permissoes.includes('LOCALIZACAO_ATUAL_VISUALIZAR') ? '/mapas-grid' : '/relatorios/bdv';
        }
        return defaultPage;
      }
    }, {
      key: 'onPageLoad',
      value: function onPageLoad() {
        var _this7 = this;

        var currentState = this.state.current.name,
            subPagina = this.state.params.tipoSubpagina,
            scopeWithSubPages = currentState === this.SCOPE_WITH_SUBPAGES,
            subPaginaSemRestricao = scopeWithSubPages && this.SUBPAGES_NO_REQUIRED_INTELLIGENCE.includes(subPagina);

        this.authenticator.getUser().then(function (user) {
          var urlState = _this7.location.url();
          if (!_this7.state.previous || _this7.state.current.name !== _this7.state.previous.name) {
            _this7.googleTagManagerUtils.sendEventClickGTM('page_view', user, { page: urlState });
          }
          if (_this7.featureFlag.SOLUCOES_AVISO && _this7.PAGINAS_REQUIRED_INTELLIGENCE.includes(currentState) && !subPaginaSemRestricao) {
            if (!user.solucoes || !_this7.solucoesEnum.hasIntelligence(user.solucoes)) {
              _this7.openModalBloqueio();
            }
          }
        });
      }
    }, {
      key: 'onProductValidationSnackbarLoad',
      value: function onProductValidationSnackbarLoad() {
        var _this8 = this;

        if (this.featureFlag.SNACKBAR_PRODUCT_VALIDATION) {
          var currentState = this.state.current.name;

          if (this.PRODUCT_VALIDATION_SNACKBAR_PAGES.includes(currentState) && this.authenticator.hasRole('MOTORISTA_EDITAR')) {
            this.authenticator.getUser().then(function (user) {
              /* eslint-disable */
              var usuario = user.plain(),
                  isSnackBarInfoInLocalStorage = _this8.window.localStorage.getItem('snackbar-' + usuario.id, 'true');

              if (!isSnackBarInfoInLocalStorage) {
                _this8.appendSnackbarToVFleetsBody(usuario);
              }
            });
          } else {
            var snackbarRef = document.querySelector('.product-validation-snackbar');
            /* eslint-enable */
            if (snackbarRef) {
              snackbarRef.remove();
            }
          }
        }
      }
    }, {
      key: 'appendSnackbarToVFleetsBody',
      value: function appendSnackbarToVFleetsBody(usuario) {
        var _this9 = this;

        /* eslint-disable */
        var snackbarAtual = document.querySelector('body').querySelector('vfwc-product-validation-snackbar');
        if (snackbarAtual) {
          snackbarAtual.remove();
        } else {
          this.motoristaService.getMotoristasSemFoto(usuario.uo.id).then(function (motoristas) {
            var motoristasSemFotoResponse = motoristas.filter(function (motorista) {
              return _this9.hasFotoCadastro(motorista.fotos);
            });

            var elementContainer = document.querySelector('body'),
                snackBarElement = document.createElement('vfwc-product-validation-snackbar'),
                userUOHasMotoristaSemFoto = motoristasSemFotoResponse.length > 0;
            /* eslint-enable */

            if (userUOHasMotoristaSemFoto && snackBarElement) {
              snackBarElement.addEventListener('onIrParaCadastroMotorista', function () {
                _this9.state.go('root.motorista');
              });

              snackBarElement.usuarioId = usuario.id;
              elementContainer.appendChild(snackBarElement);
            }
          });
        }
      }
    }, {
      key: 'hasFotoCadastro',
      value: function hasFotoCadastro(fotos) {
        return Boolean(fotos && fotos.find(function (foto) {
          return foto.fotoCadastro && !foto.excluido && !foto.pretoBranco;
        }));
      }
    }, {
      key: 'openModalBloqueio',
      value: function openModalBloqueio() {
        var _this10 = this;

        this.timeout(function () {
          _this10.modalInfoService.confirmSingleModal({
            title: 'Atualize seu plano comercial para manter esta funcionalidade!',
            btnPrimario: 'Ver Planos',
            conteudo: 'Em breve esta funcionalidade integrar\xE1 o m\xF3dulo <strong>Intelligence</strong>. Para continuar com acesso\n          a esse e outros recursos, entre em contato com o seu <strong>consultor comercial</strong> ou nos contate pelo Portal PS.',
            headerColor: 'bg-green modal-bloqueio-paginas',
            typeButton: 'btn-success'
          }, function () {
            return _this10.window.open('/planos-solucoes', '_blank');
          });
        }, 1000);
      }
    }]);

    return StateUrlService;
  }();

  angular.module('stateUrlModule', ['ui.router', 'v3gAuthenticatorModule', 'modalInfoConfirmModule', 'informativoKeysModule', 'FeatureFlagModule', 'motoristaModule', 'SolucoesModule']).service('StateUrlService', StateUrlService);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global $, document */

  var HeaderCtrl = function () {
    function HeaderCtrl(Uos, $timeout, FeatureFlag, SolucoesEnum, Authenticator, $window, FeaturehubJsSdk, FeatureHubConfigKeys, FeatureOuService) {
      var _this = this;

      _classCallCheck(this, HeaderCtrl);

      this.sistema = 'core-conducaoeconomica';
      this.featureFlag = FeatureFlag;
      this.solucoesEnum = SolucoesEnum;
      this.authenticator = Authenticator;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.featureOuService = FeatureOuService;
      this.window = $window;
      this.showMenu = true;
      if (this.window.parent) {
        this.window.parent.postMessage({ origin: 'vfleets', type: 'loaded' }, '*');
      }

      this.uo = {
        id: -1,
        nome: 'Carregando UOs...'
      };
      Uos.getFilhas().then(function (data) {
        return angular.extend(_this.uo, data.plain());
      });

      $timeout(function () {
        $.AdminLTE.tree('.sidebar');
      });
      this.isGestaoOcorrenciaEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.GESTAO_OCORRENCIA_FLAG);

      this.authenticator.getUser().then(function (user) {
        var localStrgBuscaRegiao = _this.window.localStorage.getItem('tutorial-busca-regiao');
        if (user.permissoes.includes('VPLAYER_DOWNLOAD_VISUALIZAR')) {
          _this.notificationVideoDownload(user);
        }
        _this.featureOuService.getWhatsNewConfig(user.uo && user.uo.id).then(function (whatsNew) {
          _this.showVersion = !!whatsNew;
          _this.showModalTutorialBuscaRegiao = (localStrgBuscaRegiao === null || localStrgBuscaRegiao < new Date()) && !!whatsNew && _this.featureFlag.TUTORIAL_BUSCA_REGIAO;
        }).catch(function () {
          _this.showVersion = false;
          _this.showModalTutorialBuscaRegiao = false;
        });
        _this.initHeader(user.isNa);
      });
    }

    _createClass(HeaderCtrl, [{
      key: 'initHeader',
      value: function initHeader(isNa) {
        var isCoachingPortalEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_COACHING_PORTAL),
            deviceHealthMenu = isNa ? { label: 'ce.tempoReal.deviceHealth.menuLabel', state: 'root.device-health', role: 'SAUDE_DO_EQUIPAMENTO' } : { label: 'ce.tempoReal.vehicleHealth.menuLabel', state: 'root.vehicle-health', role: 'SAUDE_DO_EQUIPAMENTO' },
            coachingMenu = !isCoachingPortalEnabled && this.featurehubJsSdk.isFeatureEnabled('PVS_187_COACHING_PAGE_NAVIGATION') && isNa && { label: 'ce.tempoReal.coaching.menuLabel', state: 'root.coaching', role: 'COACHING_PAGE_VISUALIZAR' },
            psCoachMenu = isCoachingPortalEnabled && {
          label: 'ce.psCoach.menuLabel', icon: 'fa-graduation-cap', roles: ['COACHING_PAGE_VISUALIZAR'],
          submenu: [{ label: 'ce.psCoach.coachingDashboard.menuLabel', state: 'root.coachingPortal', role: 'COACHING_PAGE_VISUALIZAR' }]
        };
        this.menu = [{
          label: 'ce.indicadores.menuLabel', icon: 'fa-bar-chart', roles: ['CONDUCAO_ECONOMICA_VISUALIZAR', 'DIRECAO_SEGURA_VISUALIZAR', 'OCIOSIDADE_FROTA_VISUALIZAR', 'INDICADOR_POWER_BI_VISUALIZAR', 'ROTA_VISUALIZAR'],
          submenu: [{ label: 'ce.indicadores.conducaoEconomica.menuLabel', state: 'root.conducaoEconomica', role: 'CONDUCAO_ECONOMICA_VISUALIZAR' }, { label: 'ce.indicadores.direcaoSegura.menuLabel', state: 'root.direcaoSegura', role: 'DIRECAO_SEGURA_VISUALIZAR' }, { label: 'ce.indicadores.ociosidadeFrota.menuLabel', state: 'root.utilizacaoVeiculo', role: 'OCIOSIDADE_FROTA_VISUALIZAR' }, !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX_297_productivity_indicators') && { label: 'ce.indicadores.productivityIndicators.menuLabel', state: 'root.productivity-indicators', role: 'ROTA_VISUALIZAR' }, { label: 'BI', state: 'root.indicadorPowerBi', role: 'INDICADOR_POWER_BI_VISUALIZAR' }].filter(Boolean)
        }, {
          label: 'ce.tempoReal.menuLabel', icon: 'trimble-icon trimble-real-time', roles: ['OCORRENCIA_VISUALIZAR', 'ONE_PAGE_VISUALIZAR', 'RANKING_INFRACOES_VISUALIZAR', 'SAUDE_DO_EQUIPAMENTO', 'MACRO_VISUALIZAR', 'ROTA_VISUALIZAR', coachingMenu && 'COACHING_PAGE_VISUALIZAR'].filter(Boolean),
          submenu: [{ label: 'ce.tempoReal.quadroDeOcorrencias.menuLabel', state: 'root.quadroOcorrencias', role: 'OCORRENCIA_VISUALIZAR' }, this.isGestaoOcorrenciaEnabled && !isNa && { label: 'ce.tempoReal.gestaoOcorrencia.menuLabel', state: 'root.gestaoOcorrencias', role: 'OCORRENCIA_VISUALIZAR' }, { label: 'ce.tempoReal.statusFrota.menuLabel', state: 'root.onePage', role: 'ONE_PAGE_VISUALIZAR' }, this.featurehubJsSdk.isFeatureEnabled('STFM-1371-DeviceHealth') && deviceHealthMenu, coachingMenu, { label: 'ce.tempoReal.infracoes.menuLabel', state: 'root.rankingInfracoes', role: 'RANKING_INFRACOES_VISUALIZAR' }, !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX-251_productivity') && {
            label: 'ce.tempoReal.productivityReport.menuLabel', state: 'root.productivity-report', roles: ['MACRO_VISUALIZAR', 'ROTA_VISUALIZAR']
          }].filter(Boolean)
        }, {
          label: 'ce.ranking.menuLabel', icon: 'fa-sort-amount-desc', roles: ['RANKING_GERAL_VISUALIZAR', 'RANKING_ECONOMIA_VISUALIZAR', 'RANKING_SEGURANCA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR'],
          submenu: [{ label: 'ce.ranking.pontos.menuLabel', state: 'root.rankingPontos', roles: [['RANKING_GERAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']] }, { label: 'ce.ranking.conducaoEconomica.menuLabel', state: 'root.rankingEconomy', role: 'RANKING_ECONOMIA_VISUALIZAR' }, { label: 'ce.ranking.direcaoSegura.menuLabel', state: 'root.rankingSafety', role: 'RANKING_SEGURANCA_VISUALIZAR' }]
        }, {
          label: 'ce.boletim.menuLabel', icon: 'fa-list-alt', roles: ['BOLETIM_MOTORISTA_VISUALIZAR', 'BOLETIM_VEICULO_VISUALIZAR', 'BOLETIM_SERVICO_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR'],
          submenu: [{
            label: 'ce.boletim.diarioMotorista.menuLabel',
            state: 'root.bdm',
            roles: [['BOLETIM_MOTORISTA_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
          }, { label: 'ce.boletim.diarioVeiculo.menuLabel', state: 'root.bdv', role: 'BOLETIM_VEICULO_VISUALIZAR' }, { label: 'ce.boletim.abastecimento.menuLabel', state: 'root.abastecimento', role: 'HISTORICO_ABASTECIMENTO_VISUALIZAR' }, { label: 'ce.boletim.servicos.menuLabel', state: 'root.bds', role: 'BOLETIM_SERVICO_VISUALIZAR' }]
        }, psCoachMenu, {
          label: 'ce.analise.menuLabel',
          icon: 'fa-line-chart',
          roles: ['HISTORICO_CONSOLIDADO_VISUALIZAR', 'HISTORICO_ALERTA_VISUALIZAR', 'PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR', 'PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR', 'ANALISE_VELOCIDADE_RPM_PARABRISA_VISUALIZAR', 'SAUDE_FROTA_VISUALIZAR', 'MOTORISTA_MENU_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR', 'VPLAYER_REQMANUAL_VISUALIZAR'],
          submenu: [!isNa && { label: 'ce.analise.movimentoVeiculo.menuLabel', state: 'root.analiseOp', role: 'HISTORICO_CONSOLIDADO_VISUALIZAR' }, { label: 'ce.analise.permanencia.menuLabel', state: 'root.permanencia', roles: ['PERMANENCIA_PONTO_REFERENCIA_VISUALIZAR', 'PERMANENCIA_CERCA_ELETRONICA_VISUALIZAR'] }, { label: 'ce.analise.alertas.menuLabel', state: 'root.historicoAlerta', role: 'HISTORICO_ALERTA_VISUALIZAR' }, {
            label: 'ce.analise.solicitacoesAgendadas.menuLabel',
            state: 'root.historicoSolicitacao',
            roles: ['SOLICITACAO_AGENDADA_VISUALIZAR']
          }, { label: 'ce.analise.velocidadeXrpm.menuLabel', state: 'root.velocidadeRpm', role: 'ANALISE_VELOCIDADE_RPM_PARABRISA_VISUALIZAR' }, { label: 'ce.analise.saudeDaFrota.menuLabel', state: 'root.saudeFrota', role: 'SAUDE_FROTA_VISUALIZAR' }, {
            label: 'ce.analise.identificacoes.menuLabel',
            state: 'root.identificacoes',
            roles: [['IDENTIFICACOES_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
          }].filter(Boolean)
        }, {
          label: 'ce.mapa.menuLabel', icon: 'fa-map', roles: ['LOCALIZACAO_ATUAL_VISUALIZAR', 'HISTORICO_DETALHADO_VISUALIZAR'],
          submenu: [{ label: 'ce.mapa.localizacaoDaFrota.menuLabel', state: 'root.mapasGrid', role: 'LOCALIZACAO_ATUAL_VISUALIZAR' }, { label: 'ce.mapa.historicoDetalhado.menuLabel', state: 'root.historicoTimeline', role: 'HISTORICO_DETALHADO_VISUALIZAR' }, { label: 'ce.mapa.mapaDeCalor.menuLabel', state: 'root.mapaCalor', role: 'MAPA_DE_CALOR_VISUALIZAR' }]
        }, {
          label: 'ce.cadastro.menuLabel', icon: 'fa-pencil-square-o', roles: ['MOTORISTA_MENU_VISUALIZAR', 'VEICULO_VISUALIZAR', 'PONTO_REFERENCIA_VISUALIZAR', 'MACRO_VISUALIZAR'],
          submenu: [{ label: 'ce.cadastro.motoristas.menuLabel', state: 'root.motorista', roles: [['MOTORISTA_MENU_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']] }, { label: 'ce.cadastro.veiculos.menuLabel', state: 'root.veiculo', role: 'VEICULO_VISUALIZAR' }, { label: 'ce.cadastro.grupoDeVeiculos.menuLabel', state: 'root.grupoVeic', role: 'GRUPO_VEICULO_VISUALIZAR' }, { label: 'ce.cadastro.pontosReferencia.menuLabel', state: 'root.pontoReferencia', role: 'PONTO_REFERENCIA_VISUALIZAR' }, !isNa && this.featurehubJsSdk.isFeatureEnabled('LADRX-205_cadastro-macros') && { label: 'ce.cadastro.macro.title', state: 'root.macro', role: 'MACRO_VISUALIZAR' }].filter(Boolean)
        }, {
          label: 'ce.configuracao.menuLabel', icon: 'fa-cog', roles: ['CONFIGURACAO_ALERTA_VISUALIZAR', 'CONFIG_VDRIVERS_VISUALIZAR', 'VEHICLE_SETTINGS_VIEW'],
          submenu: [{ label: 'ce.configuracao.eventos.menuLabel', state: 'root.configEventos', role: 'CONFIGURACAO_ALERTA_VISUALIZAR' }, { label: 'ce.configuracao.biReport.menu', state: 'root.biReport', role: 'ADMIN_VELTEC' }, { label: 'Vdrivers', state: 'root.configVdrivers', role: 'CONFIG_VDRIVERS_VISUALIZAR' }, isNa && this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VEHICLE_SETTINGS_PAGE) && { label: 'ce.configuracao.vehicleSettings.menuLabel', state: 'root.vehicleSettings', role: 'VEHICLE_SETTINGS_VIEW' }].filter(Boolean)
        }].filter(Boolean);

        this.addDuoRoutesMenu();
        this.addVideoLibrary();
        this.addMenuInsights(isCoachingPortalEnabled);
        this.addVfleets2Menu();
      }
    }, {
      key: 'addVfleets2Menu',
      value: function addVfleets2Menu() {
        if (this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.VFLEETS2_MENU_ITEM)) {
          this.menu.push({
            label: 'Vfleets 2.0',
            icon: 'material-icons launch',
            submenu: [{ label: 'Vfleets 2.0', state: 'root.vfleets2' }]
          });
        }
      }
    }, {
      key: 'addVideoLibrary',
      value: function addVideoLibrary() {
        var _this2 = this;

        var indiceSubmenuVideoLibrary = 4,
            isVideoHistoryHidden = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.HIDE_VIDEO_HISTORY_MENU);
        this.authenticator.getUser().then(function (user) {
          var menuAnalise = _this2.menu.find(function (item) {
            return item.label === 'ce.analise.menuLabel';
          });
          if (user.permissoes.indexOf('VPLAYER_REQMANUAL_VISUALIZAR') !== -1 && !isVideoHistoryHidden) {
            menuAnalise.submenu.splice(indiceSubmenuVideoLibrary, 0, {
              label: 'ce.analise.videoLibrary.menuLabel',
              state: 'root.videoLibrary.solicitacaoVideos',
              roles: [['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
            });
          }

          if (user.permissoes.indexOf('VIDEO_PLAYBACK') !== -1 || user.permissoes.indexOf('VPLAYER_REQMANUAL_VISUALIZAR') !== -1) {
            menuAnalise.submenu.splice(indiceSubmenuVideoLibrary, 0, {
              label: 'ce.analise.videoPlayback.menuLabel',
              state: 'root.playback',
              roles: ['VIDEO_PLAYBACK', ['VPLAYER_REQMANUAL_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']]
            });
          }
        });
      }
    }, {
      key: 'addMenuInsights',
      value: function addMenuInsights(isCoachingPortalEnabled) {
        var _this3 = this;

        this.authenticator.getUser().then(function (user) {
          if (_this3.featureFlag.MENU_INSIGHTS) {
            if (user.permissoesSolucao.indexOf('PREDICAO_ACIDENTE_VISUALIZAR') !== -1) {
              var indiceMenuInsights = isCoachingPortalEnabled ? _this3.menu.findIndex(function (item) {
                return item.label === 'ce.configuracao.menuLabel';
              }) : 8;
              _this3.menu.splice(indiceMenuInsights, 0, {
                label: 'Insights', icon: 'trimble-icon trimble-ps-logo', roles: ['PREDICAO_ACIDENTE_VISUALIZAR'],
                submenu: [{ label: 'ce.insights.seguranca.menuLabel', state: 'root.insights', roles: [['PREDICAO_ACIDENTE_VISUALIZAR', 'DADOS_SENSIVEIS_VISUALIZAR']] }]
              });
            }
          }
        });
      }
    }, {
      key: 'addDuoRoutesMenu',
      value: function addDuoRoutesMenu() {
        var _this4 = this;

        this.authenticator.getUser().then(function (user) {
          if (user.isNa) {
            return;
          }

          var cadastroMenuIndex = _this4.menu.findIndex(function (item) {
            return item.label === 'ce.cadastro.menuLabel';
          });
          _this4.menu.splice(cadastroMenuIndex, 0, {
            label: 'ce.duoRoutes.menuLabel',
            icon: 'material-icons route',
            roles: ['ROTA_VISUALIZAR', 'ATRIBUICAO_ROTA_VISUALIZAR'],
            submenu: [{ label: 'ce.duoRoutes.cadastroRotas.menuLabel', state: 'root.duo-routes-cadastro', role: 'ROTA_VISUALIZAR' }, { label: 'ce.duoRoutes.atribuicao.menuLabel', state: 'root.duo-routes-atribuicao', role: 'ATRIBUICAO_ROTA_VISUALIZAR' }].filter(Boolean)
          });
        });
      }
    }, {
      key: 'notificationVideoDownload',
      value: function notificationVideoDownload(user) {
        /* eslint-disable */
        var notificationVideoDownloadElement = document.querySelector('#notification-video-download'),
            vfwcNotificationVideoDownloadElement = document.createElement('vfwc-notification-video-download'); /* eslint-enable */
        vfwcNotificationVideoDownloadElement.user = user;
        notificationVideoDownloadElement.appendChild(vfwcNotificationVideoDownloadElement);
      }
    }]);

    return HeaderCtrl;
  }();

  angular.module('headerModule', ['FeatureFlagModule', 'uoModule', 'SolucoesModule', 'v3gAuthenticatorModule']).controller('HeaderCtrl', HeaderCtrl);
})();
'use strict';

/* global localStorage, window */
/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('conducaoEconomica').value('routeOnAuthFail', 'root.direcaoSegura').config(config);

  function config($urlRouterProvider, $stateProvider, $httpProvider) {
    $urlRouterProvider.otherwise(function ($injector) {
      var stateUrlService = $injector.get('StateUrlService');
      stateUrlService.setLastUrl();
    });

    $stateProvider.state('root', {
      url: '',
      abstract: true,
      views: {
        header: {
          templateUrl: 'header.tpl.html',
          controller: 'HeaderCtrl',
          controllerAs: 'headerCtrl'
        }
      },
      data: {
        titulo: '',
        tituloDescricao: ''
      },
      resolve: {
        auth: function auth(Authenticator, UrlConfigService, FeaturehubJsSdk, UoHelperService) {
          return Authenticator.getUser().then(function (usuario) {
            if (usuario && usuario.uo && UoHelperService.isRoot(usuario.uo.id)) {
              /* eslint-disable */
              window.location.href = UrlConfigService.getPermissoesUrl();
              /* eslint-enable */
            }
            return addFeatureHubConfigAttributes(FeaturehubJsSdk, usuario).then(function () {
              return usuario;
            });
          });
        },
        translateReady: ['$translate', function ($translate) {
          return $translate.onReady();
        }]
      }
    }).state('unprotected', {
      abstract: true,
      views: {
        header: {
          template: '<div data-ui-view="guest@" class="view-content"></div>'
        }
      },
      resolve: {
        auth: function auth(Authenticator) {
          return Authenticator.init();
        }
      }
    }).state('root.vfleets2', {
      url: '/redirect-vfleets2',
      onEnter: function onEnter($window) {
        $window.location.href = '/v2/home';
      }
    }).state('root.coachingPortal', {
      url: '/redirect-coaching-portal',
      onEnter: function onEnter($window) {
        $window.location.href = '/v2/coaching';
      }
    });

    $httpProvider.interceptors.push(['$q', 'Flash', '$window', '$injector', '$rootScope', function ($q, Flash, $window, $injector, $rootScope) {
      return {
        responseError: function responseError(rejection) {
          var authenticator = $injector.get('Authenticator'),
              user = $rootScope.usuario,
              featurehubJsSdk = $injector.get('FeaturehubJsSdk');
          if (rejection.status === 401) {
            if (user) {
              var keysLocalStorage = Object.keys(angular.fromJson(angular.toJson(localStorage))),
                  userPreferencesThatHasUo = ['vfiltro-' + user.id, 'lastPage-' + user.id, 'filtro-ponto-referencia-' + user.id];
              keysLocalStorage.forEach(function (key) {
                if (userPreferencesThatHasUo.includes(key)) {
                  localStorage.removeItem(key);
                }
              });
            }
            localStorage.removeItem('vfleets-oauth2-authorization');

            authenticator.init();
          } else if (rejection.status === 403) {
            if (featurehubJsSdk.isFeatureEnabled('LAINT42_cafezinho_screen') && localStorage.getItem('vfleets-oauth2-authorization')) {
              authenticator.hadleUpdateToken();
            }
            Flash.create('danger', 'Erro! Usuário sem permissão para acessar este recurso.');
          } else if (rejection.status === 404) {
            if (rejection.config.url.endsWith('/usuario') && !$window.location.pathname.includes('planos-solucoes-novo-usuario')) {
              $window.location.href = '/planos-solucoes-novo-usuario';
            } else {
              Flash.create('danger', 'Erro! Serviço não encontrado.');
            }
          } else {
            Flash.create('danger', 'Erro ao requisitar o servidor.');
          }
          return $q.reject(rejection);
        }
      };
    }]);
  }

  function addFeatureHubConfigAttributes(FeaturehubJsSdk, usuario) {
    if (!usuario) {
      return Promise.resolve();
    }

    var userId = usuario.id,
        uoId = usuario.uo && usuario.uo.id,
        email = usuario.email,
        role = usuario.perfil && usuario.perfil.nome;

    localStorage.setItem('userId', userId);
    localStorage.setItem('uo', uoId);

    return FeaturehubJsSdk.setUserKey(userId).then(function () {
      return FeaturehubJsSdk.setAttributeValue('uo', uoId);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('uoId', uoId);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('email', email);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('role', role);
    });
  }
})();